// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2343d39e%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ff5c75%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ff5c75%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%234B4B5A%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/Templates-banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/users/chat.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/plugin/multiple-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/unicons.eot?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/unicons.woff2?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/unicons.woff?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/unicons.ttf?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/unicons.svg?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/bootstrap-icons.woff2?856008caa5eb66df68595e734e59580d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/bootstrap-icons.woff?856008caa5eb66df68595e734e59580d", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___, { hash: "#unicons" });
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Shreyu - Responsive Bootstrap 5 Admin Dashboard
Author: CoderThemes
Version: 2.0.0
Website: https://coderthemes.com/
Contact: support@coderthemes.com
File: Custom Bootstrap Css File
*/
/*!
 * Bootstrap v5.1.3 (https://getbootstrap.com/)
 * Copyright 2011-2021 The Bootstrap Authors
 * Copyright 2011-2021 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --bs-blue: #5369f8;
  --bs-indigo: #564ab1;
  --bs-purple: #6f42c1;
  --bs-pink: #e83e8c;
  --bs-red: #ff5c75;
  --bs-orange: #f77e53;
  --bs-yellow: #ffbe0b;
  --bs-green: #43d39e;
  --bs-teal: #1ce1ac;
  --bs-cyan: #25c2e3;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #f6f6f7;
  --bs-gray-300: #e2e7f1;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #4B4B5A;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #5369f8;
  --bs-secondary: #6c757d;
  --bs-success: #43d39e;
  --bs-info: #25c2e3;
  --bs-warning: #ffbe0b;
  --bs-danger: #ff5c75;
  --bs-light: #f8f9fa;
  --bs-dark: #343a40;
  --bs-primary-rgb: 83, 105, 248;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 67, 211, 158;
  --bs-info-rgb: 37, 194, 227;
  --bs-warning-rgb: 255, 190, 11;
  --bs-danger-rgb: 255, 92, 117;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 52, 58, 64;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-body-color-rgb: 75, 75, 90;
  --bs-body-bg-rgb: 243, 244, 247;
  --bs-font-sans-serif: "Noto Sans", "Noto Sans Fallback", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: Noto Sans, Noto Sans Fallback, sans-serif;
  --bs-body-font-size: 0.875rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #4B4B5A;
  --bs-body-bg: #f3f4f7;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1.5rem 0;
  color: rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);
  background-color: currentColor;
  border: 0;
  opacity: 1;
}

hr:not([size]) {
  height: 1px;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  font-weight: 500;
  line-height: 1.1;
}

h1, .h1 {
  font-size: calc(1.35rem + 1.2vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.25rem;
  }
}

h2, .h2 {
  font-size: calc(1.3125rem + 0.75vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.875rem;
  }
}

h3, .h3 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.5rem;
  }
}

h4, .h4 {
  font-size: 1.125rem;
}

h5, .h5 {
  font-size: 0.9375rem;
}

h6, .h6 {
  font-size: 0.9rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.75rem;
}

mark, .mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #5369f8;
  text-decoration: none;
}
a:hover {
  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);
  text-decoration: none;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr /* rtl:ignore */;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend {
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.09375rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-1 {
  font-weight: 300;
  line-height: 1.1;
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-2 {
  font-weight: 300;
  line-height: 1.1;
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-3 {
  font-weight: 300;
  line-height: 1.1;
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-4 {
  font-weight: 300;
  line-height: 1.1;
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-5 {
  font-weight: 300;
  line-height: 1.1;
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.display-6 {
  font-weight: 300;
  line-height: 1.1;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 6px;
}

.initialism {
  font-size: 0.75rem;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1.5rem;
  font-size: 1.09375rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1.5rem;
  margin-bottom: 1.5rem;
  font-size: 0.75rem;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f3f4f7;
  border: 1px solid #e2e7f1;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.75rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.75rem;
  color: #6c757d;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: var(--bs-gutter-x, 12px);
  padding-left: var(--bs-gutter-x, 12px);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.row {
  --bs-gutter-x: 24px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.375rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.375rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.75rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.75rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1.5rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1.5rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 2.25rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 2.25rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 4.5rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 4.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 4.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.375rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.375rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 4.5rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 4.5rem;
  }
}
.table {
  --bs-table-bg: transparent;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #4B4B5A;
  --bs-table-striped-bg: #f8f9fa;
  --bs-table-active-color: #4B4B5A;
  --bs-table-active-bg: #f8f9fa;
  --bs-table-hover-color: #4B4B5A;
  --bs-table-hover-bg: #f8f9fa;
  width: 100%;
  margin-bottom: 1.5rem;
  color: #4B4B5A;
  vertical-align: top;
  border-color: #e2e7f1;
}
.table > :not(caption) > * > * {
  padding: 0.85rem 0.85rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}
.table > :not(:first-child) {
  border-top: 2px solid #e2e7f1;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: rgb(86.5098039216%, 88.2352941176%, 99.4509803922%);
  --bs-table-striped-bg: #343a40;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #343a40;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #343a40;
  --bs-table-hover-color: #fff;
  color: #343a40;
  border-color: rgb(79.8980392157%, 81.6862745098%, 92.0156862745%);
}

.table-secondary {
  --bs-table-bg: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  --bs-table-striped-bg: #343a40;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #343a40;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #343a40;
  --bs-table-hover-color: #fff;
  color: #343a40;
  border-color: rgb(81.662745098%, 82.5333333333%, 83.3333333333%);
}

.table-success {
  --bs-table-bg: rgb(85.2549019608%, 96.5490196078%, 92.3921568627%);
  --bs-table-striped-bg: #343a40;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #343a40;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #343a40;
  --bs-table-hover-color: #fff;
  color: #343a40;
  border-color: rgb(78.768627451%, 89.168627451%, 85.662745098%);
}

.table-info {
  --bs-table-bg: rgb(82.9019607843%, 95.2156862745%, 97.8039215686%);
  --bs-table-striped-bg: #343a40;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #343a40;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #343a40;
  --bs-table-hover-color: #fff;
  color: #343a40;
  border-color: rgb(76.6509803922%, 87.968627451%, 90.5333333333%);
}

.table-warning {
  --bs-table-bg: rgb(100%, 94.9019607843%, 80.862745098%);
  --bs-table-striped-bg: #343a40;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #343a40;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #343a40;
  --bs-table-hover-color: #fff;
  color: #343a40;
  border-color: rgb(92.0392156863%, 87.6862745098%, 75.2862745098%);
}

.table-danger {
  --bs-table-bg: rgb(100%, 87.2156862745%, 89.1764705882%);
  --bs-table-striped-bg: #343a40;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #343a40;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #343a40;
  --bs-table-hover-color: #fff;
  color: #343a40;
  border-color: rgb(92.0392156863%, 80.768627451%, 82.768627451%);
}

.table-light {
  --bs-table-bg: #f8f9fa;
  --bs-table-striped-bg: #343a40;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #343a40;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #343a40;
  --bs-table-hover-color: #fff;
  color: #343a40;
  border-color: rgb(89.568627451%, 90.1568627451%, 90.7450980392%);
}

.table-dark {
  --bs-table-bg: #343a40;
  --bs-table-striped-bg: white;
  --bs-table-striped-color: #343a40;
  --bs-table-active-bg: white;
  --bs-table-active-color: #343a40;
  --bs-table-hover-bg: white;
  --bs-table-hover-color: #343a40;
  color: #fff;
  border-color: rgb(28.3529411765%, 30.4705882353%, 32.5882352941%);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.45rem + 1px);
  padding-bottom: calc(0.45rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.09375rem;
}

.col-form-label-sm {
  padding-top: calc(0.28rem + 1px);
  padding-bottom: calc(0.28rem + 1px);
  font-size: 0.7875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #6c757d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4B4B5A;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #4B4B5A;
  background-color: #fff;
  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
  outline: 0;
  box-shadow: none;
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #fff;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.45rem 0.9rem;
  margin: -0.45rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: #4B4B5A;
  background-color: #f6f6f7;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(91.6470588235%, 91.6470588235%, 92.0196078431%);
}
.form-control::-webkit-file-upload-button {
  padding: 0.45rem 0.9rem;
  margin: -0.45rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: #4B4B5A;
  background-color: #f6f6f7;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: rgb(91.6470588235%, 91.6470588235%, 92.0196078431%);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.45rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #4B4B5A;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
  padding: 0.28rem 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}
.form-control-sm::file-selector-button {
  padding: 0.28rem 0.8rem;
  margin: -0.28rem -0.8rem;
  margin-inline-end: 0.8rem;
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.28rem 0.8rem;
  margin: -0.28rem -0.8rem;
  margin-inline-end: 0.8rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.9rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.56rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: auto;
  padding: 0.45rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.45rem 2.7rem 0.45rem 0.9rem;
  -moz-padding-start: calc(0.9rem - 3px);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4B4B5A;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 14px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select {
  appearance: none;
}
.form-select:focus {
  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
  outline: 0;
  box-shadow: none;
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.9rem;
  background-image: none;
}
.form-select:disabled {
  color: #6c757d;
  background-color: #f6f6f7;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #4B4B5A;
}

.form-select-sm {
  padding-top: 0.28rem;
  padding-bottom: 0.28rem;
  padding-left: 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}

.form-check {
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.5rem;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5rem;
}

.form-check-input {
  width: 1rem;
  height: 1rem;
  margin-top: 0.25rem;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  appearance: none;
  color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);
}
.form-check-input:checked {
  background-color: #5369f8;
  border-color: #5369f8;
}
.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #5369f8;
  border-color: #5369f8;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%2869.3889648883%, 73.137254902%, 76.8855449156%%29'/%3e%3c/svg%3e");
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f3f4f7, none;
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f3f4f7, none;
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #5369f8;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb {
  appearance: none;
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(79.7647058824%, 82.3529411765%, 99.1764705882%);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e2e7f1;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #5369f8;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb {
  appearance: none;
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(79.7647058824%, 82.3529411765%, 99.1764705882%);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e2e7f1;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.9rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control {
  padding: 1rem 0.9rem;
}
.form-floating > .form-control::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 3;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4B4B5A;
  text-align: center;
  white-space: nowrap;
  background-color: #f6f6f7;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.28rem 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #43d39e;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(67, 211, 158, 0.9);
  border-radius: 0.2rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #43d39e;
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #43d39e;
  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #43d39e;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.95rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #43d39e;
  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.25);
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #43d39e;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #43d39e;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #43d39e;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 1;
}
.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,
.was-validated .input-group .form-select:valid:focus,
.input-group .form-select.is-valid:focus {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #ff5c75;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.8rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(255, 92, 117, 0.9);
  border-radius: 0.2rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #ff5c75;
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #ff5c75;
  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #ff5c75;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.95rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #ff5c75;
  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.25);
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #ff5c75;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #ff5c75;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ff5c75;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 2;
}
.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,
.was-validated .input-group .form-select:invalid:focus,
.input-group .form-select.is-invalid:focus {
  z-index: 3;
}

.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #4B4B5A;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #4B4B5A;
}
.btn-check:focus + .btn, .btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
}

.btn-primary {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(27.6666666667%, 35%, 82.6666666667%);
  border-color: rgb(26.0392156863%, 32.9411764706%, 77.8039215686%);
}
.btn-check:focus + .btn-primary, .btn-primary:focus {
  color: #fff;
  background-color: rgb(27.6666666667%, 35%, 82.6666666667%);
  border-color: rgb(26.0392156863%, 32.9411764706%, 77.8039215686%);
  box-shadow: 0 0 0 0 rgba(42.6666666667%, 50%, 97.6666666667%, 0.5);
}
.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(26.0392156863%, 32.9411764706%, 77.8039215686%);
  border-color: rgb(24.4117647059%, 30.8823529412%, 72.9411764706%);
}
.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(42.6666666667%, 50%, 97.6666666667%, 0.5);
}
.btn-primary:disabled, .btn-primary.disabled {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(36%, 39%, 41.6666666667%);
  border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
}
.btn-check:focus + .btn-secondary, .btn-secondary:focus {
  color: #fff;
  background-color: rgb(36%, 39%, 41.6666666667%);
  border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);
}
.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);
  border-color: rgb(31.7647058824%, 34.4117647059%, 36.7647058824%);
}
.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);
}
.btn-secondary:disabled, .btn-secondary.disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-success {
  color: #fff;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(22.3333333333%, 70.3333333333%, 52.6666666667%);
  border-color: rgb(21.0196078431%, 66.1960784314%, 49.568627451%);
}
.btn-check:focus + .btn-success, .btn-success:focus {
  color: #fff;
  background-color: rgb(22.3333333333%, 70.3333333333%, 52.6666666667%);
  border-color: rgb(21.0196078431%, 66.1960784314%, 49.568627451%);
  box-shadow: 0 0 0 0 rgba(37.3333333333%, 85.3333333333%, 67.6666666667%, 0.5);
}
.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(21.0196078431%, 66.1960784314%, 49.568627451%);
  border-color: rgb(19.7058823529%, 62.0588235294%, 46.4705882353%);
}
.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(37.3333333333%, 85.3333333333%, 67.6666666667%, 0.5);
}
.btn-success:disabled, .btn-success.disabled {
  color: #fff;
  background-color: #43d39e;
  border-color: #43d39e;
}

.btn-info {
  color: #fff;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-info:hover {
  color: #fff;
  background-color: rgb(12.3333333333%, 64.6666666667%, 75.6666666667%);
  border-color: rgb(11.6078431373%, 60.862745098%, 71.2156862745%);
}
.btn-check:focus + .btn-info, .btn-info:focus {
  color: #fff;
  background-color: rgb(12.3333333333%, 64.6666666667%, 75.6666666667%);
  border-color: rgb(11.6078431373%, 60.862745098%, 71.2156862745%);
  box-shadow: 0 0 0 0 rgba(27.3333333333%, 79.6666666667%, 90.6666666667%, 0.5);
}
.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.6078431373%, 60.862745098%, 71.2156862745%);
  border-color: rgb(10.8823529412%, 57.0588235294%, 66.7647058824%);
}
.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(27.3333333333%, 79.6666666667%, 90.6666666667%, 0.5);
}
.btn-info:disabled, .btn-info.disabled {
  color: #fff;
  background-color: #25c2e3;
  border-color: #25c2e3;
}

.btn-warning {
  color: #343a40;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-warning:hover {
  color: #343a40;
  background-color: rgb(100%, 78.3333333333%, 18.6666666667%);
  border-color: rgb(100%, 77.0588235294%, 13.8823529412%);
}
.btn-check:focus + .btn-warning, .btn-warning:focus {
  color: #343a40;
  background-color: rgb(100%, 78.3333333333%, 18.6666666667%);
  border-color: rgb(100%, 77.0588235294%, 13.8823529412%);
  box-shadow: 0 0 0 0 rgba(88.0588235294%, 66.7450980392%, 7.431372549%, 0.5);
}
.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {
  color: #343a40;
  background-color: rgb(100%, 79.6078431373%, 23.4509803922%);
  border-color: rgb(100%, 77.0588235294%, 13.8823529412%);
}
.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(88.0588235294%, 66.7450980392%, 7.431372549%, 0.5);
}
.btn-warning:disabled, .btn-warning.disabled {
  color: #343a40;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}

.btn-danger {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(85%, 30.6666666667%, 39%);
  border-color: rgb(80%, 28.862745098%, 36.7058823529%);
}
.btn-check:focus + .btn-danger, .btn-danger:focus {
  color: #fff;
  background-color: rgb(85%, 30.6666666667%, 39%);
  border-color: rgb(80%, 28.862745098%, 36.7058823529%);
  box-shadow: 0 0 0 0 rgba(100%, 45.6666666667%, 54%, 0.5);
}
.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(80%, 28.862745098%, 36.7058823529%);
  border-color: rgb(75%, 27.0588235294%, 34.4117647059%);
}
.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(100%, 45.6666666667%, 54%, 0.5);
}
.btn-danger:disabled, .btn-danger.disabled {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}

.btn-light {
  color: #343a40;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:hover {
  color: #343a40;
  background-color: rgb(97.6666666667%, 98%, 98.3333333333%);
  border-color: rgb(97.5294117647%, 97.8823529412%, 98.2352941176%);
}
.btn-check:focus + .btn-light, .btn-light:focus {
  color: #343a40;
  background-color: rgb(97.6666666667%, 98%, 98.3333333333%);
  border-color: rgb(97.5294117647%, 97.8823529412%, 98.2352941176%);
  box-shadow: 0 0 0 0 rgba(85.7254901961%, 86.4117647059%, 87.0980392157%, 0.5);
}
.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {
  color: #343a40;
  background-color: rgb(97.8039215686%, 98.1176470588%, 98.431372549%);
  border-color: rgb(97.5294117647%, 97.8823529412%, 98.2352941176%);
}
.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(85.7254901961%, 86.4117647059%, 87.0980392157%, 0.5);
}
.btn-light:disabled, .btn-light.disabled {
  color: #343a40;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(17.3333333333%, 19.3333333333%, 21.3333333333%);
  border-color: rgb(16.3137254902%, 18.1960784314%, 20.0784313725%);
}
.btn-check:focus + .btn-dark, .btn-dark:focus {
  color: #fff;
  background-color: rgb(17.3333333333%, 19.3333333333%, 21.3333333333%);
  border-color: rgb(16.3137254902%, 18.1960784314%, 20.0784313725%);
  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}
.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(16.3137254902%, 18.1960784314%, 20.0784313725%);
  border-color: rgb(15.2941176471%, 17.0588235294%, 18.8235294118%);
}
.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);
}
.btn-dark:disabled, .btn-dark.disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-outline-primary {
  color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);
}
.btn-outline-primary:disabled, .btn-outline-primary.disabled {
  color: #5369f8;
  background-color: transparent;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  color: #6c757d;
  background-color: transparent;
}

.btn-outline-success {
  color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);
}
.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {
  color: #fff;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);
}
.btn-outline-success:disabled, .btn-outline-success.disabled {
  color: #43d39e;
  background-color: transparent;
}

.btn-outline-info {
  color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);
}
.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {
  color: #fff;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);
}
.btn-outline-info:disabled, .btn-outline-info.disabled {
  color: #25c2e3;
  background-color: transparent;
}

.btn-outline-warning {
  color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:hover {
  color: #343a40;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);
}
.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {
  color: #343a40;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);
}
.btn-outline-warning:disabled, .btn-outline-warning.disabled {
  color: #ffbe0b;
  background-color: transparent;
}

.btn-outline-danger {
  color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);
}
.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);
}
.btn-outline-danger:disabled, .btn-outline-danger.disabled {
  color: #ff5c75;
  background-color: transparent;
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #343a40;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {
  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);
}
.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {
  color: #343a40;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);
}
.btn-outline-light:disabled, .btn-outline-light.disabled {
  color: #f8f9fa;
  background-color: transparent;
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark:disabled, .btn-outline-dark.disabled {
  color: #343a40;
  background-color: transparent;
}

.btn-link {
  font-weight: 400;
  color: #5369f8;
  text-decoration: none;
}
.btn-link:hover {
  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);
  text-decoration: none;
}
.btn-link:focus {
  text-decoration: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.09375rem;
  border-radius: 0.25rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.28rem 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.25rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 10rem;
  padding: 0.25rem 0;
  margin: 0;
  font-size: 0.875rem;
  color: #4B4B5A;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
  border-radius: 0.25rem;
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: 0.125rem;
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.75rem 0;
  overflow: hidden;
  border-top: 1px solid #e2e7f1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.375rem 1.2rem;
  clear: both;
  font-weight: 400;
  color: #4B4B5A;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(26.4705882353%, 26.4705882353%, 31.7647058824%);
  background-color: #f8f9fa;
}
.dropdown-item.active, .dropdown-item:active {
  color: #343a40;
  text-decoration: none;
  background-color: #f8f9fa;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.25rem 1.2rem;
  margin-bottom: 0;
  font-size: 0.7875rem;
  color: inherit;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.375rem 1.2rem;
  color: #4B4B5A;
}

.dropdown-menu-dark {
  color: #e2e7f1;
  background-color: #343a40;
  border-color: rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
}
.dropdown-menu-dark .dropdown-item {
  color: #e2e7f1;
}
.dropdown-menu-dark .dropdown-item:hover, .dropdown-menu-dark .dropdown-item:focus {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
}
.dropdown-menu-dark .dropdown-item.active, .dropdown-menu-dark .dropdown-item:active {
  color: #343a40;
  background-color: #f8f9fa;
}
.dropdown-menu-dark .dropdown-item.disabled, .dropdown-menu-dark .dropdown-item:disabled {
  color: #adb5bd;
}
.dropdown-menu-dark .dropdown-divider {
  border-color: #e2e7f1;
}
.dropdown-menu-dark .dropdown-item-text {
  color: #e2e7f1;
}
.dropdown-menu-dark .dropdown-header {
  color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.6rem;
  padding-left: 0.6rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #5369f8;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 0px solid #e2e7f1;
}
.nav-tabs .nav-link {
  margin-bottom: -0px;
  background: none;
  border: 0px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #f6f6f7 #f6f6f7 #e2e7f1;
  isolation: isolate;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #4B4B5A;
  background-color: #fff;
  border-color: #e2e7f1 #e2e7f1 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -0px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #5369f8;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.75rem;
  padding-right: 1.5rem;
  padding-bottom: 0.75rem;
  padding-left: 1.5rem;
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: 0.3359375rem;
  padding-bottom: 0.3359375rem;
  margin-right: 1rem;
  font-size: 1.09375rem;
  white-space: nowrap;
}
.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.09375rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }
  .navbar-expand-sm .offcanvas-top,
  .navbar-expand-sm .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }
  .navbar-expand-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }
  .navbar-expand-md .offcanvas-top,
  .navbar-expand-md .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }
  .navbar-expand-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }
  .navbar-expand-lg .offcanvas-top,
  .navbar-expand-lg .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }
  .navbar-expand-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }
  .navbar-expand-xl .offcanvas-top,
  .navbar-expand-xl .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }
  .navbar-expand-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: inherit;
    bottom: 0;
    z-index: 1000;
    flex-grow: 1;
    visibility: visible !important;
    background-color: transparent;
    border-right: 0;
    border-left: 0;
    transition: none;
    transform: none;
  }
  .navbar-expand-xxl .offcanvas-top,
  .navbar-expand-xxl .offcanvas-bottom {
    height: auto;
    border-top: 0;
    border-bottom: 0;
  }
  .navbar-expand-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas {
  position: inherit;
  bottom: 0;
  z-index: 1000;
  flex-grow: 1;
  visibility: visible !important;
  background-color: transparent;
  border-right: 0;
  border-left: 0;
  transition: none;
  transform: none;
}
.navbar-expand .offcanvas-top,
.navbar-expand .offcanvas-bottom {
  height: auto;
  border-top: 0;
  border-bottom: 0;
}
.navbar-expand .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-light .navbar-brand {
  color: #5369f8;
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: #5369f8;
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: #5369f8;
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.55);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: #5369f8;
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.55);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #e2e7f1;
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 1rem 1.25rem;
  margin-bottom: 0;
  background-color: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);
  border-bottom: 1px solid #e2e7f1;
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 1rem 1.25rem;
  background-color: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);
  border-top: 1px solid #e2e7f1;
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -1rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-group > .card {
  margin-bottom: 12px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 0.875rem;
  color: #4B4B5A;
  text-align: left;
  background-color: #f3f4f7;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: rgb(29.2941176471%, 37.0588235294%, 87.5294117647%);
  background-color: rgb(93.2549019608%, 94.1176470588%, 99.7254901961%);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}
.accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2829.2941176471%, 37.0588235294%, 87.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  transform: rotate(-180deg);
}
.accordion-button::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  background-color: #f3f4f7;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.accordion-item:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.accordion-body {
  padding: 1rem 1.25rem;
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 1.005rem 0;
  margin-bottom: 1rem;
  list-style: none;
  background-color: transparent;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #adb5bd;
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: #343a40;
  background-color: #fff;
  border: 1px solid #e2e7f1;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: #343a40;
  background-color: #f6f6f7;
  border-color: #e2e7f1;
}
.page-link:focus {
  z-index: 3;
  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);
  background-color: #f6f6f7;
  outline: 0;
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #e2e7f1;
}

.page-link {
  padding: 0.5rem 0.75rem;
}

.page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.09375rem;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3.75rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.9375rem 1.25rem;
}

.alert-primary {
  color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);
  background-color: rgb(86.5098039216%, 88.2352941176%, 99.4509803922%);
  border-color: rgb(81.1137254902%, 83.5294117647%, 99.231372549%);
}
.alert-primary .alert-link {
  color: rgb(15.6235294118%, 19.7647058824%, 46.6823529412%);
}

.alert-secondary {
  color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
  border-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);
}
.alert-secondary .alert-link {
  color: rgb(20.3294117647%, 22.0235294118%, 23.5294117647%);
}

.alert-success {
  color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);
  background-color: rgb(85.2549019608%, 96.5490196078%, 92.3921568627%);
  border-color: rgb(79.3568627451%, 95.168627451%, 89.3490196078%);
}
.alert-success .alert-link {
  color: rgb(12.6117647059%, 39.7176470588%, 29.7411764706%);
}

.alert-info {
  color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);
  background-color: rgb(82.9019607843%, 95.2156862745%, 97.8039215686%);
  border-color: rgb(76.062745098%, 93.3019607843%, 96.9254901961%);
}
.alert-info .alert-link {
  color: rgb(6.9647058824%, 36.5176470588%, 42.7294117647%);
}

.alert-warning {
  color: rgb(60%, 44.7058823529%, 2.5882352941%);
  background-color: rgb(100%, 94.9019607843%, 80.862745098%);
  border-color: rgb(100%, 92.862745098%, 73.2078431373%);
}
.alert-warning .alert-link {
  color: rgb(48%, 35.7647058824%, 2.0705882353%);
}

.alert-danger {
  color: rgb(60%, 21.6470588235%, 27.5294117647%);
  background-color: rgb(100%, 87.2156862745%, 89.1764705882%);
  border-color: rgb(100%, 82.1019607843%, 84.8470588235%);
}
.alert-danger .alert-link {
  color: rgb(48%, 17.3176470588%, 22.0235294118%);
}

.alert-light {
  color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);
  background-color: rgb(99.4509803922%, 99.5294117647%, 99.6078431373%);
  border-color: rgb(99.231372549%, 99.3411764706%, 99.4509803922%);
}
.alert-light .alert-link {
  color: rgb(46.6823529412%, 46.8705882353%, 47.0588235294%);
}

.alert-dark {
  color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);
  background-color: rgb(84.0784313725%, 84.5490196078%, 85.0196078431%);
  border-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);
}
.alert-dark .alert-link {
  color: rgb(9.7882352941%, 10.9176470588%, 12.0470588235%);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.75rem;
  }
}
.progress {
  display: flex;
  height: 0.75rem;
  overflow: hidden;
  font-size: 0.65625rem;
  background-color: rgb(96.0460556316%, 96.7277701778%, 98.0911992704%);
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #5369f8;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.75rem 0.75rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > li::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: #4B4B5A;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #4B4B5A;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #4B4B5A;
  background-color: #f6f6f7;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  color: #212529;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);
  background-color: rgb(86.5098039216%, 88.2352941176%, 99.4509803922%);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);
  background-color: rgb(77.8588235294%, 79.4117647059%, 89.5058823529%);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);
  border-color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);
}

.list-group-item-secondary {
  color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
  background-color: rgb(79.6235294118%, 80.2588235294%, 80.8235294118%);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
  border-color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);
}

.list-group-item-success {
  color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);
  background-color: rgb(85.2549019608%, 96.5490196078%, 92.3921568627%);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);
  background-color: rgb(76.7294117647%, 86.8941176471%, 83.1529411765%);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);
  border-color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);
}

.list-group-item-info {
  color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);
  background-color: rgb(82.9019607843%, 95.2156862745%, 97.8039215686%);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);
  background-color: rgb(74.6117647059%, 85.6941176471%, 88.0235294118%);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);
  border-color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);
}

.list-group-item-warning {
  color: rgb(60%, 44.7058823529%, 2.5882352941%);
  background-color: rgb(100%, 94.9019607843%, 80.862745098%);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(60%, 44.7058823529%, 2.5882352941%);
  background-color: rgb(90%, 85.4117647059%, 72.7764705882%);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(60%, 44.7058823529%, 2.5882352941%);
  border-color: rgb(60%, 44.7058823529%, 2.5882352941%);
}

.list-group-item-danger {
  color: rgb(60%, 21.6470588235%, 27.5294117647%);
  background-color: rgb(100%, 87.2156862745%, 89.1764705882%);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(60%, 21.6470588235%, 27.5294117647%);
  background-color: rgb(90%, 78.4941176471%, 80.2588235294%);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(60%, 21.6470588235%, 27.5294117647%);
  border-color: rgb(60%, 21.6470588235%, 27.5294117647%);
}

.list-group-item-light {
  color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);
  background-color: rgb(99.4509803922%, 99.5294117647%, 99.6078431373%);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);
  background-color: rgb(89.5058823529%, 89.5764705882%, 89.6470588235%);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);
  border-color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);
}

.list-group-item-dark {
  color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);
  background-color: rgb(84.0784313725%, 84.5490196078%, 85.0196078431%);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);
  background-color: rgb(75.6705882353%, 76.0941176471%, 76.5176470588%);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);
  border-color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_11___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  width: 350px;
  max-width: 100%;
  font-size: 0.875rem;
  pointer-events: auto;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: 12px;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.toast-header .btn-close {
  margin-right: -0.375rem;
  margin-left: 0.75rem;
}

.toast-body {
  padding: 0.75rem;
  word-wrap: break-word;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid transparent;
  border-radius: 0.2rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: #212529;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 0 solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
}
.modal-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 0 solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);
  border-bottom-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.modal-footer > * {
  margin: 0.25rem;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
}
.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  margin: 0;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.4rem 0.8rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.2rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0 /* rtl:ignore */;
  z-index: 1070;
  display: block;
  max-width: 276px;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.7875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e2e7f1;
  border-radius: 0.25rem;
}
.popover .popover-arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #e2e7f1;
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #e2e7f1;
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #e2e7f1;
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f8f9fa;
}

.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #e2e7f1;
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.7rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e2e7f1;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.7rem 0.8rem;
  color: #4B4B5A;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: 1045;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  visibility: hidden;
  background-color: #fff;
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #212529;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.offcanvas-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin-top: -0.5rem;
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: 1rem 1rem;
  overflow-y: auto;
}

.offcanvas-start {
  top: 0;
  left: 0;
  width: 400px;
  border-right: 0 solid transparent;
  transform: translateX(-100%);
}

.offcanvas-end {
  top: 0;
  right: 0;
  width: 400px;
  border-left: 0 solid transparent;
  transform: translateX(100%);
}

.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-bottom: 0 solid transparent;
  transform: translateY(-100%);
}

.offcanvas-bottom {
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-top: 0 solid transparent;
  transform: translateY(100%);
}

.offcanvas.show {
  transform: none;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentColor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.link-primary {
  color: #5369f8;
}
.link-primary:hover, .link-primary:focus {
  color: rgb(27.6666666667%, 35%, 82.6666666667%);
}

.link-secondary {
  color: #6c757d;
}
.link-secondary:hover, .link-secondary:focus {
  color: rgb(36%, 39%, 41.6666666667%);
}

.link-success {
  color: #43d39e;
}
.link-success:hover, .link-success:focus {
  color: rgb(22.3333333333%, 70.3333333333%, 52.6666666667%);
}

.link-info {
  color: #25c2e3;
}
.link-info:hover, .link-info:focus {
  color: rgb(12.3333333333%, 64.6666666667%, 75.6666666667%);
}

.link-warning {
  color: #ffbe0b;
}
.link-warning:hover, .link-warning:focus {
  color: rgb(100%, 78.3333333333%, 18.6666666667%);
}

.link-danger {
  color: #ff5c75;
}
.link-danger:hover, .link-danger:focus {
  color: rgb(85%, 30.6666666667%, 39%);
}

.link-light {
  color: #f8f9fa;
}
.link-light:hover, .link-light:focus {
  color: rgb(97.6666666667%, 98%, 98.3333333333%);
}

.link-dark {
  color: #343a40;
}
.link-dark:hover, .link-dark:focus {
  color: rgb(17.3333333333%, 19.3333333333%, 21.3333333333%);
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentColor;
  opacity: 1;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #5369f8 !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #43d39e !important;
}

.border-info {
  border-color: #25c2e3 !important;
}

.border-warning {
  border-color: #ffbe0b !important;
}

.border-danger {
  border-color: #ff5c75 !important;
}

.border-light {
  border-color: #f8f9fa !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-white {
  border-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.375rem !important;
}

.gap-2 {
  gap: 0.75rem !important;
}

.gap-3 {
  gap: 1.5rem !important;
}

.gap-4 {
  gap: 2.25rem !important;
}

.gap-5 {
  gap: 4.5rem !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.375rem !important;
}

.m-2 {
  margin: 0.75rem !important;
}

.m-3 {
  margin: 1.5rem !important;
}

.m-4 {
  margin: 2.25rem !important;
}

.m-5 {
  margin: 4.5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.375rem !important;
  margin-left: 0.375rem !important;
}

.mx-2 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-3 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-4 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-5 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.375rem !important;
  margin-bottom: 0.375rem !important;
}

.my-2 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-3 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-4 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-5 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.375rem !important;
}

.mt-2 {
  margin-top: 0.75rem !important;
}

.mt-3 {
  margin-top: 1.5rem !important;
}

.mt-4 {
  margin-top: 2.25rem !important;
}

.mt-5 {
  margin-top: 4.5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.375rem !important;
}

.me-2 {
  margin-right: 0.75rem !important;
}

.me-3 {
  margin-right: 1.5rem !important;
}

.me-4 {
  margin-right: 2.25rem !important;
}

.me-5 {
  margin-right: 4.5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.375rem !important;
}

.mb-2 {
  margin-bottom: 0.75rem !important;
}

.mb-3 {
  margin-bottom: 1.5rem !important;
}

.mb-4 {
  margin-bottom: 2.25rem !important;
}

.mb-5 {
  margin-bottom: 4.5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.375rem !important;
}

.ms-2 {
  margin-left: 0.75rem !important;
}

.ms-3 {
  margin-left: 1.5rem !important;
}

.ms-4 {
  margin-left: 2.25rem !important;
}

.ms-5 {
  margin-left: 4.5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.375rem !important;
}

.m-n2 {
  margin: -0.75rem !important;
}

.m-n3 {
  margin: -1.5rem !important;
}

.m-n4 {
  margin: -2.25rem !important;
}

.m-n5 {
  margin: -4.5rem !important;
}

.mx-n1 {
  margin-right: -0.375rem !important;
  margin-left: -0.375rem !important;
}

.mx-n2 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n3 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n4 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n5 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.my-n1 {
  margin-top: -0.375rem !important;
  margin-bottom: -0.375rem !important;
}

.my-n2 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n3 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n4 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n5 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.mt-n1 {
  margin-top: -0.375rem !important;
}

.mt-n2 {
  margin-top: -0.75rem !important;
}

.mt-n3 {
  margin-top: -1.5rem !important;
}

.mt-n4 {
  margin-top: -2.25rem !important;
}

.mt-n5 {
  margin-top: -4.5rem !important;
}

.me-n1 {
  margin-right: -0.375rem !important;
}

.me-n2 {
  margin-right: -0.75rem !important;
}

.me-n3 {
  margin-right: -1.5rem !important;
}

.me-n4 {
  margin-right: -2.25rem !important;
}

.me-n5 {
  margin-right: -4.5rem !important;
}

.mb-n1 {
  margin-bottom: -0.375rem !important;
}

.mb-n2 {
  margin-bottom: -0.75rem !important;
}

.mb-n3 {
  margin-bottom: -1.5rem !important;
}

.mb-n4 {
  margin-bottom: -2.25rem !important;
}

.mb-n5 {
  margin-bottom: -4.5rem !important;
}

.ms-n1 {
  margin-left: -0.375rem !important;
}

.ms-n2 {
  margin-left: -0.75rem !important;
}

.ms-n3 {
  margin-left: -1.5rem !important;
}

.ms-n4 {
  margin-left: -2.25rem !important;
}

.ms-n5 {
  margin-left: -4.5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.375rem !important;
}

.p-2 {
  padding: 0.75rem !important;
}

.p-3 {
  padding: 1.5rem !important;
}

.p-4 {
  padding: 2.25rem !important;
}

.p-5 {
  padding: 4.5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.375rem !important;
  padding-left: 0.375rem !important;
}

.px-2 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-3 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-4 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-5 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}

.py-2 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-3 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-4 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-5 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.375rem !important;
}

.pt-2 {
  padding-top: 0.75rem !important;
}

.pt-3 {
  padding-top: 1.5rem !important;
}

.pt-4 {
  padding-top: 2.25rem !important;
}

.pt-5 {
  padding-top: 4.5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.375rem !important;
}

.pe-2 {
  padding-right: 0.75rem !important;
}

.pe-3 {
  padding-right: 1.5rem !important;
}

.pe-4 {
  padding-right: 2.25rem !important;
}

.pe-5 {
  padding-right: 4.5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.375rem !important;
}

.pb-2 {
  padding-bottom: 0.75rem !important;
}

.pb-3 {
  padding-bottom: 1.5rem !important;
}

.pb-4 {
  padding-bottom: 2.25rem !important;
}

.pb-5 {
  padding-bottom: 4.5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.375rem !important;
}

.ps-2 {
  padding-left: 0.75rem !important;
}

.ps-3 {
  padding-left: 1.5rem !important;
}

.ps-4 {
  padding-left: 2.25rem !important;
}

.ps-5 {
  padding-left: 4.5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2 {
  font-size: calc(1.3125rem + 0.75vw) !important;
}

.fs-3 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-4 {
  font-size: 1.125rem !important;
}

.fs-5 {
  font-size: 0.9375rem !important;
}

.fs-6 {
  font-size: 0.9rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.5 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 1.5 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: #6c757d !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.2rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-end {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-start {
  border-bottom-left-radius: 0.25rem !important;
  border-top-left-radius: 0.25rem !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.375rem !important;
  }
  .gap-sm-2 {
    gap: 0.75rem !important;
  }
  .gap-sm-3 {
    gap: 1.5rem !important;
  }
  .gap-sm-4 {
    gap: 2.25rem !important;
  }
  .gap-sm-5 {
    gap: 4.5rem !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.375rem !important;
  }
  .m-sm-2 {
    margin: 0.75rem !important;
  }
  .m-sm-3 {
    margin: 1.5rem !important;
  }
  .m-sm-4 {
    margin: 2.25rem !important;
  }
  .m-sm-5 {
    margin: 4.5rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-sm-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-sm-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-sm-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-sm-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-sm-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.375rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.75rem !important;
  }
  .mt-sm-3 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-4 {
    margin-top: 2.25rem !important;
  }
  .mt-sm-5 {
    margin-top: 4.5rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.375rem !important;
  }
  .me-sm-2 {
    margin-right: 0.75rem !important;
  }
  .me-sm-3 {
    margin-right: 1.5rem !important;
  }
  .me-sm-4 {
    margin-right: 2.25rem !important;
  }
  .me-sm-5 {
    margin-right: 4.5rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.375rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.75rem !important;
  }
  .ms-sm-3 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-4 {
    margin-left: 2.25rem !important;
  }
  .ms-sm-5 {
    margin-left: 4.5rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.375rem !important;
  }
  .m-sm-n2 {
    margin: -0.75rem !important;
  }
  .m-sm-n3 {
    margin: -1.5rem !important;
  }
  .m-sm-n4 {
    margin: -2.25rem !important;
  }
  .m-sm-n5 {
    margin: -4.5rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-sm-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-sm-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-sm-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-sm-n5 {
    margin-top: -4.5rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.375rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.75rem !important;
  }
  .me-sm-n3 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n4 {
    margin-right: -2.25rem !important;
  }
  .me-sm-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-sm-n5 {
    margin-left: -4.5rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.375rem !important;
  }
  .p-sm-2 {
    padding: 0.75rem !important;
  }
  .p-sm-3 {
    padding: 1.5rem !important;
  }
  .p-sm-4 {
    padding: 2.25rem !important;
  }
  .p-sm-5 {
    padding: 4.5rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-sm-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-sm-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-sm-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-sm-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-sm-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-sm-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.375rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.75rem !important;
  }
  .pt-sm-3 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-4 {
    padding-top: 2.25rem !important;
  }
  .pt-sm-5 {
    padding-top: 4.5rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.375rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.75rem !important;
  }
  .pe-sm-3 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-4 {
    padding-right: 2.25rem !important;
  }
  .pe-sm-5 {
    padding-right: 4.5rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.375rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.75rem !important;
  }
  .ps-sm-3 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-4 {
    padding-left: 2.25rem !important;
  }
  .ps-sm-5 {
    padding-left: 4.5rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.375rem !important;
  }
  .gap-md-2 {
    gap: 0.75rem !important;
  }
  .gap-md-3 {
    gap: 1.5rem !important;
  }
  .gap-md-4 {
    gap: 2.25rem !important;
  }
  .gap-md-5 {
    gap: 4.5rem !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.375rem !important;
  }
  .m-md-2 {
    margin: 0.75rem !important;
  }
  .m-md-3 {
    margin: 1.5rem !important;
  }
  .m-md-4 {
    margin: 2.25rem !important;
  }
  .m-md-5 {
    margin: 4.5rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-md-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-md-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-md-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-md-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-md-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-md-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.375rem !important;
  }
  .mt-md-2 {
    margin-top: 0.75rem !important;
  }
  .mt-md-3 {
    margin-top: 1.5rem !important;
  }
  .mt-md-4 {
    margin-top: 2.25rem !important;
  }
  .mt-md-5 {
    margin-top: 4.5rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.375rem !important;
  }
  .me-md-2 {
    margin-right: 0.75rem !important;
  }
  .me-md-3 {
    margin-right: 1.5rem !important;
  }
  .me-md-4 {
    margin-right: 2.25rem !important;
  }
  .me-md-5 {
    margin-right: 4.5rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-md-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.375rem !important;
  }
  .ms-md-2 {
    margin-left: 0.75rem !important;
  }
  .ms-md-3 {
    margin-left: 1.5rem !important;
  }
  .ms-md-4 {
    margin-left: 2.25rem !important;
  }
  .ms-md-5 {
    margin-left: 4.5rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.375rem !important;
  }
  .m-md-n2 {
    margin: -0.75rem !important;
  }
  .m-md-n3 {
    margin: -1.5rem !important;
  }
  .m-md-n4 {
    margin: -2.25rem !important;
  }
  .m-md-n5 {
    margin: -4.5rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-md-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-md-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-md-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-md-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-md-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-md-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-md-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-md-n5 {
    margin-top: -4.5rem !important;
  }
  .me-md-n1 {
    margin-right: -0.375rem !important;
  }
  .me-md-n2 {
    margin-right: -0.75rem !important;
  }
  .me-md-n3 {
    margin-right: -1.5rem !important;
  }
  .me-md-n4 {
    margin-right: -2.25rem !important;
  }
  .me-md-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-md-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-md-n5 {
    margin-left: -4.5rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.375rem !important;
  }
  .p-md-2 {
    padding: 0.75rem !important;
  }
  .p-md-3 {
    padding: 1.5rem !important;
  }
  .p-md-4 {
    padding: 2.25rem !important;
  }
  .p-md-5 {
    padding: 4.5rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-md-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-md-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-md-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-md-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-md-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-md-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.375rem !important;
  }
  .pt-md-2 {
    padding-top: 0.75rem !important;
  }
  .pt-md-3 {
    padding-top: 1.5rem !important;
  }
  .pt-md-4 {
    padding-top: 2.25rem !important;
  }
  .pt-md-5 {
    padding-top: 4.5rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.375rem !important;
  }
  .pe-md-2 {
    padding-right: 0.75rem !important;
  }
  .pe-md-3 {
    padding-right: 1.5rem !important;
  }
  .pe-md-4 {
    padding-right: 2.25rem !important;
  }
  .pe-md-5 {
    padding-right: 4.5rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-md-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.375rem !important;
  }
  .ps-md-2 {
    padding-left: 0.75rem !important;
  }
  .ps-md-3 {
    padding-left: 1.5rem !important;
  }
  .ps-md-4 {
    padding-left: 2.25rem !important;
  }
  .ps-md-5 {
    padding-left: 4.5rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.375rem !important;
  }
  .gap-lg-2 {
    gap: 0.75rem !important;
  }
  .gap-lg-3 {
    gap: 1.5rem !important;
  }
  .gap-lg-4 {
    gap: 2.25rem !important;
  }
  .gap-lg-5 {
    gap: 4.5rem !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.375rem !important;
  }
  .m-lg-2 {
    margin: 0.75rem !important;
  }
  .m-lg-3 {
    margin: 1.5rem !important;
  }
  .m-lg-4 {
    margin: 2.25rem !important;
  }
  .m-lg-5 {
    margin: 4.5rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-lg-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-lg-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-lg-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-lg-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-lg-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.375rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.75rem !important;
  }
  .mt-lg-3 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-4 {
    margin-top: 2.25rem !important;
  }
  .mt-lg-5 {
    margin-top: 4.5rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.375rem !important;
  }
  .me-lg-2 {
    margin-right: 0.75rem !important;
  }
  .me-lg-3 {
    margin-right: 1.5rem !important;
  }
  .me-lg-4 {
    margin-right: 2.25rem !important;
  }
  .me-lg-5 {
    margin-right: 4.5rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.375rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.75rem !important;
  }
  .ms-lg-3 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-4 {
    margin-left: 2.25rem !important;
  }
  .ms-lg-5 {
    margin-left: 4.5rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.375rem !important;
  }
  .m-lg-n2 {
    margin: -0.75rem !important;
  }
  .m-lg-n3 {
    margin: -1.5rem !important;
  }
  .m-lg-n4 {
    margin: -2.25rem !important;
  }
  .m-lg-n5 {
    margin: -4.5rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-lg-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-lg-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-lg-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-lg-n5 {
    margin-top: -4.5rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.375rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.75rem !important;
  }
  .me-lg-n3 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n4 {
    margin-right: -2.25rem !important;
  }
  .me-lg-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-lg-n5 {
    margin-left: -4.5rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.375rem !important;
  }
  .p-lg-2 {
    padding: 0.75rem !important;
  }
  .p-lg-3 {
    padding: 1.5rem !important;
  }
  .p-lg-4 {
    padding: 2.25rem !important;
  }
  .p-lg-5 {
    padding: 4.5rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-lg-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-lg-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-lg-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-lg-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-lg-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-lg-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.375rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.75rem !important;
  }
  .pt-lg-3 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-4 {
    padding-top: 2.25rem !important;
  }
  .pt-lg-5 {
    padding-top: 4.5rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.375rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.75rem !important;
  }
  .pe-lg-3 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-4 {
    padding-right: 2.25rem !important;
  }
  .pe-lg-5 {
    padding-right: 4.5rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.375rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.75rem !important;
  }
  .ps-lg-3 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-4 {
    padding-left: 2.25rem !important;
  }
  .ps-lg-5 {
    padding-left: 4.5rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.375rem !important;
  }
  .gap-xl-2 {
    gap: 0.75rem !important;
  }
  .gap-xl-3 {
    gap: 1.5rem !important;
  }
  .gap-xl-4 {
    gap: 2.25rem !important;
  }
  .gap-xl-5 {
    gap: 4.5rem !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.375rem !important;
  }
  .m-xl-2 {
    margin: 0.75rem !important;
  }
  .m-xl-3 {
    margin: 1.5rem !important;
  }
  .m-xl-4 {
    margin: 2.25rem !important;
  }
  .m-xl-5 {
    margin: 4.5rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.375rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.75rem !important;
  }
  .mt-xl-3 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-4 {
    margin-top: 2.25rem !important;
  }
  .mt-xl-5 {
    margin-top: 4.5rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.375rem !important;
  }
  .me-xl-2 {
    margin-right: 0.75rem !important;
  }
  .me-xl-3 {
    margin-right: 1.5rem !important;
  }
  .me-xl-4 {
    margin-right: 2.25rem !important;
  }
  .me-xl-5 {
    margin-right: 4.5rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.375rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.75rem !important;
  }
  .ms-xl-3 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-4 {
    margin-left: 2.25rem !important;
  }
  .ms-xl-5 {
    margin-left: 4.5rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.375rem !important;
  }
  .m-xl-n2 {
    margin: -0.75rem !important;
  }
  .m-xl-n3 {
    margin: -1.5rem !important;
  }
  .m-xl-n4 {
    margin: -2.25rem !important;
  }
  .m-xl-n5 {
    margin: -4.5rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xl-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xl-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xl-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-xl-n5 {
    margin-top: -4.5rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.375rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.75rem !important;
  }
  .me-xl-n3 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n4 {
    margin-right: -2.25rem !important;
  }
  .me-xl-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-xl-n5 {
    margin-left: -4.5rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.375rem !important;
  }
  .p-xl-2 {
    padding: 0.75rem !important;
  }
  .p-xl-3 {
    padding: 1.5rem !important;
  }
  .p-xl-4 {
    padding: 2.25rem !important;
  }
  .p-xl-5 {
    padding: 4.5rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.375rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.75rem !important;
  }
  .pt-xl-3 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-4 {
    padding-top: 2.25rem !important;
  }
  .pt-xl-5 {
    padding-top: 4.5rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.375rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.75rem !important;
  }
  .pe-xl-3 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-4 {
    padding-right: 2.25rem !important;
  }
  .pe-xl-5 {
    padding-right: 4.5rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.375rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.75rem !important;
  }
  .ps-xl-3 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-4 {
    padding-left: 2.25rem !important;
  }
  .ps-xl-5 {
    padding-left: 4.5rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.375rem !important;
  }
  .gap-xxl-2 {
    gap: 0.75rem !important;
  }
  .gap-xxl-3 {
    gap: 1.5rem !important;
  }
  .gap-xxl-4 {
    gap: 2.25rem !important;
  }
  .gap-xxl-5 {
    gap: 4.5rem !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.375rem !important;
  }
  .m-xxl-2 {
    margin: 0.75rem !important;
  }
  .m-xxl-3 {
    margin: 1.5rem !important;
  }
  .m-xxl-4 {
    margin: 2.25rem !important;
  }
  .m-xxl-5 {
    margin: 4.5rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.375rem !important;
    margin-left: 0.375rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-4 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xxl-5 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.375rem !important;
    margin-bottom: 0.375rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xxl-3 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-4 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xxl-5 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.375rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.75rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-4 {
    margin-top: 2.25rem !important;
  }
  .mt-xxl-5 {
    margin-top: 4.5rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.375rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.75rem !important;
  }
  .me-xxl-3 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-4 {
    margin-right: 2.25rem !important;
  }
  .me-xxl-5 {
    margin-right: 4.5rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.375rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.375rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.75rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-4 {
    margin-left: 2.25rem !important;
  }
  .ms-xxl-5 {
    margin-left: 4.5rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.375rem !important;
  }
  .m-xxl-n2 {
    margin: -0.75rem !important;
  }
  .m-xxl-n3 {
    margin: -1.5rem !important;
  }
  .m-xxl-n4 {
    margin: -2.25rem !important;
  }
  .m-xxl-n5 {
    margin: -4.5rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.375rem !important;
    margin-left: -0.375rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.375rem !important;
    margin-bottom: -0.375rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n4 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xxl-n5 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.375rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.75rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -2.25rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -4.5rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.375rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.75rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n4 {
    margin-right: -2.25rem !important;
  }
  .me-xxl-n5 {
    margin-right: -4.5rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -4.5rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.375rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.75rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -2.25rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -4.5rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.375rem !important;
  }
  .p-xxl-2 {
    padding: 0.75rem !important;
  }
  .p-xxl-3 {
    padding: 1.5rem !important;
  }
  .p-xxl-4 {
    padding: 2.25rem !important;
  }
  .p-xxl-5 {
    padding: 4.5rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.375rem !important;
    padding-left: 0.375rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xxl-3 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-4 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xxl-5 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xxl-3 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-4 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xxl-5 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.375rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.75rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-4 {
    padding-top: 2.25rem !important;
  }
  .pt-xxl-5 {
    padding-top: 4.5rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.375rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.75rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-4 {
    padding-right: 2.25rem !important;
  }
  .pe-xxl-5 {
    padding-right: 4.5rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 4.5rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.375rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.75rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-4 {
    padding-left: 2.25rem !important;
  }
  .ps-xxl-5 {
    padding-left: 4.5rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.25rem !important;
  }
  .fs-2 {
    font-size: 1.875rem !important;
  }
  .fs-3 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
.custom-accordionwitharrow .card + .card {
  margin-top: 0.5rem;
}
.custom-accordionwitharrow .card .card-header {
  background-color: transparent;
}
.custom-accordionwitharrow .accordion-arrow {
  font-size: 1.2rem;
  margin-top: -5px;
}
.custom-accordionwitharrow a.collapsed i.accordion-arrow:before {
  content: "\\e831";
}

.custom-accordion .card {
  overflow: visible;
  border-color: transparent !important;
  border-left: 2px dashed #e2e7f1 !important;
  box-shadow: none;
  padding-left: 24px;
  margin-left: 10px;
}
.custom-accordion .card .card-header {
  border-radius: 7px !important;
}
.custom-accordion .card .card-header:before {
  content: "";
  position: absolute;
  left: 5px;
  top: 22px;
  width: 25px;
  height: 2px;
  background: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);
}
.custom-accordion .card .icon {
  position: absolute;
  left: -18px;
  top: -2px;
  background-color: #fff;
  border-radius: 50%;
  margin-right: 1px;
}

.badge-soft-primary {
  color: #5369f8;
  background-color: rgba(83, 105, 248, 0.18);
  box-shadow: none;
}

.badge-soft-secondary {
  color: #6c757d;
  background-color: rgba(108, 117, 125, 0.18);
  box-shadow: none;
}

.badge-soft-success {
  color: #43d39e;
  background-color: rgba(67, 211, 158, 0.18);
  box-shadow: none;
}

.badge-soft-info {
  color: #25c2e3;
  background-color: rgba(37, 194, 227, 0.18);
  box-shadow: none;
}

.badge-soft-warning {
  color: #ffbe0b;
  background-color: rgba(255, 190, 11, 0.18);
  box-shadow: none;
}

.badge-soft-danger {
  color: #ff5c75;
  background-color: rgba(255, 92, 117, 0.18);
  box-shadow: none;
}

.badge-soft-light {
  color: #f8f9fa;
  background-color: rgba(248, 249, 250, 0.18);
  box-shadow: none;
}

.badge-soft-dark {
  color: #343a40;
  background-color: rgba(52, 58, 64, 0.18);
  box-shadow: none;
}

.badge-outline-primary {
  color: #5369f8;
  border: 1px solid #5369f8;
  background-color: transparent;
  box-shadow: none;
}

.badge-outline-secondary {
  color: #6c757d;
  border: 1px solid #6c757d;
  background-color: transparent;
  box-shadow: none;
}

.badge-outline-success {
  color: #43d39e;
  border: 1px solid #43d39e;
  background-color: transparent;
  box-shadow: none;
}

.badge-outline-info {
  color: #25c2e3;
  border: 1px solid #25c2e3;
  background-color: transparent;
  box-shadow: none;
}

.badge-outline-warning {
  color: #ffbe0b;
  border: 1px solid #ffbe0b;
  background-color: transparent;
  box-shadow: none;
}

.badge-outline-danger {
  color: #ff5c75;
  border: 1px solid #ff5c75;
  background-color: transparent;
  box-shadow: none;
}

.badge-outline-light {
  color: #f8f9fa;
  border: 1px solid #f8f9fa;
  background-color: transparent;
  box-shadow: none;
}

.badge-outline-dark {
  color: #343a40;
  border: 1px solid #343a40;
  background-color: transparent;
  box-shadow: none;
}

.bg-soft-primary {
  background-color: rgba(83, 105, 248, 0.25) !important;
}

.bg-soft-secondary {
  background-color: rgba(108, 117, 125, 0.25) !important;
}

.bg-soft-success {
  background-color: rgba(67, 211, 158, 0.25) !important;
}

.bg-soft-info {
  background-color: rgba(37, 194, 227, 0.25) !important;
}

.bg-soft-warning {
  background-color: rgba(255, 190, 11, 0.25) !important;
}

.bg-soft-danger {
  background-color: rgba(255, 92, 117, 0.25) !important;
}

.bg-soft-light {
  background-color: rgba(248, 249, 250, 0.25) !important;
}

.bg-soft-dark {
  background-color: rgba(52, 58, 64, 0.25) !important;
}

.bg-ghost {
  opacity: 0.4;
}

.breadcrumb-item > a {
  color: #4B4B5A;
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "unicons";
}

.btn {
  color: #fff;
}
.btn:focus {
  box-shadow: none;
}
.btn .icon svg {
  width: 1rem;
  height: 1rem;
  margin-left: 0.1rem;
  margin-top: -2px;
}

.btn-light, .btn-white {
  color: #212529;
}

.btn-white {
  border-color: #e2e7f1;
}
.btn-white:hover, .btn-white:focus {
  background-color: #e2e7f1;
  border-color: #ced4da;
}

.btn-link {
  font-weight: 400;
  color: #5369f8;
  background-color: transparent;
}
.btn-link:hover {
  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);
  text-decoration: none;
  background-color: transparent;
  border-color: transparent;
}
.btn-link:focus {
  text-decoration: none;
  border-color: transparent;
  box-shadow: none;
}
.btn-link:disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-xs {
  padding: 0.2rem 0.6rem;
  font-size: 0.75rem;
  border-radius: 0.15rem;
}

.btn-soft-primary {
  background-color: rgba(83, 105, 248, 0.15);
  color: #5369f8;
  border-color: rgba(83, 105, 248, 0.15);
}
.btn-soft-primary:focus {
  box-shadow: none;
}
.btn-soft-primary:hover, .btn-soft-primary:focus {
  background-color: rgba(83, 105, 248, 0.2);
  color: #5369f8;
}

.btn-soft-secondary {
  background-color: rgba(108, 117, 125, 0.15);
  color: #6c757d;
  border-color: rgba(108, 117, 125, 0.15);
}
.btn-soft-secondary:focus {
  box-shadow: none;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus {
  background-color: rgba(108, 117, 125, 0.2);
  color: #6c757d;
}

.btn-soft-success {
  background-color: rgba(67, 211, 158, 0.15);
  color: #43d39e;
  border-color: rgba(67, 211, 158, 0.15);
}
.btn-soft-success:focus {
  box-shadow: none;
}
.btn-soft-success:hover, .btn-soft-success:focus {
  background-color: rgba(67, 211, 158, 0.2);
  color: #43d39e;
}

.btn-soft-info {
  background-color: rgba(37, 194, 227, 0.15);
  color: #25c2e3;
  border-color: rgba(37, 194, 227, 0.15);
}
.btn-soft-info:focus {
  box-shadow: none;
}
.btn-soft-info:hover, .btn-soft-info:focus {
  background-color: rgba(37, 194, 227, 0.2);
  color: #25c2e3;
}

.btn-soft-warning {
  background-color: rgba(255, 190, 11, 0.15);
  color: #ffbe0b;
  border-color: rgba(255, 190, 11, 0.15);
}
.btn-soft-warning:focus {
  box-shadow: none;
}
.btn-soft-warning:hover, .btn-soft-warning:focus {
  background-color: rgba(255, 190, 11, 0.2);
  color: #ffbe0b;
}

.btn-soft-danger {
  background-color: rgba(255, 92, 117, 0.15);
  color: #ff5c75;
  border-color: rgba(255, 92, 117, 0.15);
}
.btn-soft-danger:focus {
  box-shadow: none;
}
.btn-soft-danger:hover, .btn-soft-danger:focus {
  background-color: rgba(255, 92, 117, 0.2);
  color: #ff5c75;
}

.btn-soft-light {
  background-color: rgba(248, 249, 250, 0.15);
  color: #f8f9fa;
  border-color: rgba(248, 249, 250, 0.15);
}
.btn-soft-light:focus {
  box-shadow: none;
}
.btn-soft-light:hover, .btn-soft-light:focus {
  background-color: rgba(248, 249, 250, 0.2);
  color: #f8f9fa;
}

.btn-soft-dark {
  background-color: rgba(52, 58, 64, 0.15);
  color: #343a40;
  border-color: rgba(52, 58, 64, 0.15);
}
.btn-soft-dark:focus {
  box-shadow: none;
}
.btn-soft-dark:hover, .btn-soft-dark:focus {
  background-color: rgba(52, 58, 64, 0.2);
  color: #343a40;
}

.btn-outline-primary {
  color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);
}
.btn-outline-primary:disabled, .btn-outline-primary.disabled {
  color: #5369f8;
  background-color: transparent;
}
.btn-outline-primary:focus {
  box-shadow: none;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:focus {
  box-shadow: none;
}

.btn-outline-success {
  color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);
}
.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {
  color: #fff;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);
}
.btn-outline-success:disabled, .btn-outline-success.disabled {
  color: #43d39e;
  background-color: transparent;
}
.btn-outline-success:focus {
  box-shadow: none;
}

.btn-outline-info {
  color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);
}
.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {
  color: #fff;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);
}
.btn-outline-info:disabled, .btn-outline-info.disabled {
  color: #25c2e3;
  background-color: transparent;
}
.btn-outline-info:focus {
  box-shadow: none;
}

.btn-outline-warning {
  color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:hover {
  color: #343a40;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);
}
.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {
  color: #343a40;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);
}
.btn-outline-warning:disabled, .btn-outline-warning.disabled {
  color: #ffbe0b;
  background-color: transparent;
}
.btn-outline-warning:focus {
  box-shadow: none;
}

.btn-outline-danger {
  color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);
}
.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);
}
.btn-outline-danger:disabled, .btn-outline-danger.disabled {
  color: #ff5c75;
  background-color: transparent;
}
.btn-outline-danger:focus {
  box-shadow: none;
}

.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #343a40;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {
  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);
}
.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {
  color: #343a40;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);
}
.btn-outline-light:disabled, .btn-outline-light.disabled {
  color: #f8f9fa;
  background-color: transparent;
}
.btn-outline-light:focus {
  box-shadow: none;
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark:disabled, .btn-outline-dark.disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:focus {
  box-shadow: none;
}

.card {
  margin-bottom: 24px;
}

.card-link + .card-link {
  /*rtl:ignore*/
  margin-left: 1.25rem;
  /*rtl:ignore*/
  margin-right: 0;
}

.card-drop {
  font-size: 20px;
  line-height: 0;
  color: inherit;
}

.card-widgets {
  float: right;
  height: 16px;
}
.card-widgets > a {
  color: inherit;
  font-size: 18px;
  display: inline-block;
  line-height: 1;
}
.card-widgets > a.collapsed i:before {
  content: "\\f0415";
}

.card-title,
.card-header {
  margin-top: 0;
}

.card-disabled {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 0.25rem;
  background: rgba(255, 255, 255, 0.8);
  cursor: progress;
}
.card-disabled .card-portlets-loader {
  background-color: #3e4852;
  animation: rotatebox 1.2s infinite ease-in-out;
  height: 30px;
  width: 30px;
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 3px;
  margin-left: -12px;
  margin-top: -12px;
}

@keyframes rotatebox {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}
.card-box {
  background-color: #fff;
  padding: 1.25rem;
  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075);
  margin-bottom: 24px;
  border-radius: 0.25rem;
}

.header-title {
  font-size: 15px;
  margin: 0 0 7px 0;
  font-weight: 600;
  text-transform: uppercase;
}

.sub-header {
  font-size: 0.875rem;
  margin-bottom: 24px;
  color: #6c757d;
}

.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  font-size: 0.875rem;
  top: 100%;
}
.dropdown-menu.show {
  top: 100% !important;
}
.dropdown-menu i {
  display: inline-block;
}

.dropdown-menu-end {
  right: 0 !important;
  left: auto !important;
}

.dropdown-menu[data-popper-placement^=right],
.dropdown-menu[data-popper-placement^=top],
.dropdown-menu[data-popper-placement^=left] {
  top: auto !important;
  animation: none !important;
}

@keyframes DropDownSlide {
  100% {
    transform: translateY(0);
  }
  0% {
    transform: translateY(-10px);
  }
}
@media (min-width: 600px) {
  .dropdown-lg {
    width: 320px;
  }
}
.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  display: block;
  border: 1px solid transparent;
  color: #4B4B5A;
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  background-color: #f8f9fa;
}

@media (min-width: 992px) {
  .dropdown-mega-menu-xl {
    width: 40rem;
  }
  .dropdown-mega-menu-lg {
    width: 26rem;
  }
}
.form-control::placeholder {
  color: rgb(63.0941176471%, 66.0117647059%, 68.9294117647%);
}

.form-control-light {
  background-color: #f3f7f9 !important;
  border-color: #f3f7f9 !important;
}

input.form-control[type=color],
input.form-control[type=range] {
  min-height: 39px;
}

.custom-select.is-invalid:focus, .form-control.is-invalid:focus, .custom-select:invalid:focus, .form-control:invalid:focus,
.custom-select.is-valid:focus, .form-control.is-valid:focus, .custom-select:valid:focus, .form-control:valid:focus {
  box-shadow: none !important;
}

.comment-area-box .form-control {
  border-color: #e2e7f1;
  border-radius: 0.25rem 0.25rem 0 0;
}
.comment-area-box .comment-area-btn {
  background-color: #f8f9fa;
  padding: 10px;
  border: 1px solid #e2e7f1;
  border-top: none;
  border-radius: 0 0 0.25rem 0.25rem;
}

.search-bar .form-control {
  padding-left: 40px;
  padding-right: 20px;
  border-radius: 30px;
}
.search-bar span {
  position: absolute;
  z-index: 10;
  font-size: 16px;
  line-height: calc(1.5em + 0.9rem + 2px);
  left: 13px;
  top: -2px;
  color: #6c757d;
}

.password-eye:before {
  font-family: feather !important;
  content: "\\e86a";
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  vertical-align: middle;
  line-height: 1.2;
  font-size: 16px;
}

.show-password .password-eye:before {
  content: "\\e86e";
}

.modal-title {
  margin-top: 0;
}

.modal-full-width {
  width: 95%;
  max-width: none;
}

.modal-top {
  margin: 0 auto;
}

.modal-right {
  position: absolute;
  right: 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  height: 100%;
  margin: 0;
  background-color: #fff;
  align-content: center;
  transform: translate(25%, 0) !important;
}
.modal-right button.close {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1;
}

.modal.show .modal-right {
  transform: translate(0, 0) !important;
}

.modal-bottom {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  height: 100%;
  margin: 0 auto;
  align-content: center;
}

.modal-colored-header {
  color: #fff;
  border-radius: 0;
}
.modal-colored-header .close {
  color: #fff !important;
}

.nav-tabs {
  border-bottom: 2px solid rgba(108, 117, 125, 0.2);
}
.nav-tabs .nav-item {
  margin-bottom: -2px;
}
.nav-tabs .nav-link {
  cursor: pointer;
  outline: none;
}
.nav-tabs li a {
  border-color: transparent !important;
  padding: 0.625rem 1.25rem;
}
.nav-tabs li a.active {
  border-bottom: 2px solid #5369f8 !important;
}

.nav-tabs > li > a, .nav-pills > li > a {
  color: #4B4B5A;
  font-weight: 700;
}

.nav-pills {
  background: #f3f4f7;
  border-radius: 0.25rem;
  padding: 6px 2px;
}
.nav-pills .nav-link {
  background-color: transparent;
  color: #4B4B5A;
  outline: none;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #4B4B5A;
  background-color: #fff;
  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075);
}

.navtab-bg li > a {
  background-color: #e2e7f1;
}

.tab-content {
  padding: 20px 0 0 0;
}

@media only screen and (max-width: 991px) {
  .hederSection {
    justify-content: center !important;
  }
}
.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px;
  border: none;
}

.popover-header {
  margin-top: 0;
}

.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 15px;
}

/* Progressbar Vertical */
.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-md {
  width: 8px;
}
.progress-vertical.progress-sm {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-md {
  width: 8px;
}
.progress-vertical-bottom.progress-sm {
  width: 5px;
}

body {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
body.loading {
  visibility: hidden;
  opacity: 0;
}

label {
  font-weight: 700;
}

button:focus {
  outline: none;
}

.row > * {
  position: relative;
}

a:focus {
  outline: none;
}

th {
  font-weight: 700;
}

.table-centered td, .table-centered th {
  vertical-align: middle !important;
}

.table-nowrap th, .table-nowrap td {
  white-space: nowrap;
}

.table .table-user img {
  height: 30px;
  width: 30px;
}

.action-icon {
  color: #6c757d;
  font-size: 1.2rem;
  display: inline-block;
  padding: 0 3px;
}
.action-icon:hover {
  color: #4B4B5A;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 10px 0;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  color: #343a40;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-17 {
  font-size: 17px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-19 {
  font-size: 19px !important;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.fw-medium {
  font-weight: 500;
}

.fw-semibold {
  font-weight: 600;
}

.text-unline-dashed {
  border-bottom: #ced4da 1px dashed !important;
  padding-bottom: 1px;
}

/*
Template Name: Shreyu - Responsive Bootstrap 5 Admin Dashboard
Author: CoderThemes
Version: 2.0.0
Website: https://coderthemes.com/
Contact: support@coderthemes.com
File: Main Css File
*/
iframe#webpack-dev-server-client-overlay {
  display: none !important;
}

html {
  position: relative;
  min-height: 100%;
}

body {
  overflow-x: hidden;
}

#wrapper {
  height: 100%;
  overflow: hidden;
  width: 100%;
}

.content-page {
  margin-left: 250px;
  overflow: hidden;
  padding: 0 15px 65px 15px;
  min-height: 80vh;
  margin-top: 70px;
}

.left-side-menu {
  width: 250px;
  background: linear-gradient(180deg, #020b18 0%, #031024 45%, #051329 100%) !important;
  border-right: 1px solid #0a1f3d !important;
  bottom: 0;
  padding: 0 0 30px 0;
  position: fixed;
  transition: all 0.1s ease-out;
  top: 70px;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);
  z-index: 1000;
}
.left-side-menu .simplebar-scrollbar:before {
  background: rgba(255, 255, 255, 0.15);
}

.sidebar-inner-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sidebar-mobile-brand {
  padding: 12px 14px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 8px;
}
.sidebar-mobile-brand .sidebar-brand-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none !important;
}
.sidebar-mobile-brand .sidebar-brand-mascot {
  height: 44px;
  width: auto;
  object-fit: contain;
}
.sidebar-mobile-brand .sidebar-brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}
.sidebar-mobile-brand .sidebar-brand-title {
  font-weight: 800;
  font-size: 17px;
  color: #0b3558;
}
.sidebar-mobile-brand .sidebar-brand-subtitle {
  font-weight: 700;
  font-size: 10px;
  color: #0284c7;
}

.sidebar-portal-badge-wrap {
  padding: 16px 14px 8px 14px;
}

.sidebar-portal-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(14, 38, 77, 0.75);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 9999px;
  padding: 4px 12px;
}
.sidebar-portal-badge .sidebar-badge-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #22c55e;
  box-shadow: 0 0 8px #22c55e;
  flex-shrink: 0;
}
.sidebar-portal-badge .sidebar-badge-text {
  color: #60a5fa;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
}

.sidebar-entity-card {
  margin: 4px 14px 16px 14px;
  padding: 10px 12px;
  background: #081a36;
  border: 1px solid rgba(59, 130, 246, 0.22);
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.sidebar-entity-card .sidebar-entity-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #0d2850;
  border: 1px solid rgba(59, 130, 246, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #60a5fa;
  flex-shrink: 0;
}
.sidebar-entity-card .sidebar-entity-icon svg {
  width: 18px;
  height: 18px;
}
.sidebar-entity-card .sidebar-entity-info {
  overflow: hidden;
  flex: 1 1;
  min-width: 0;
}
.sidebar-entity-card .sidebar-entity-name {
  color: #ffffff;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}
.sidebar-entity-card .sidebar-entity-code {
  color: #64748b;
  font-size: 10.5px;
  font-weight: 500;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#sidebar-menu > ul.side-menu {
  list-style: none;
  padding: 0 12px 24px 12px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
#sidebar-menu > ul.side-menu > li.side-nav-item {
  position: relative;
  list-style: none;
  border: none !important;
  background: transparent !important;
  margin: 0;
  padding: 0;
  border-radius: 12px;
}
#sidebar-menu > ul.side-menu > li.side-nav-item > a,
#sidebar-menu > ul.side-menu > li.side-nav-item > .side-sub-nav-link {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 8px 12px !important;
  border-radius: 12px !important;
  color: #94a3b8 !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  background: transparent !important;
  border: none !important;
}
#sidebar-menu > ul.side-menu > li.side-nav-item > a:hover,
#sidebar-menu > ul.side-menu > li.side-nav-item > .side-sub-nav-link:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #ffffff !important;
}
#sidebar-menu > ul.side-menu > li.side-nav-item > a:hover .menu-icon-box,
#sidebar-menu > ul.side-menu > li.side-nav-item > .side-sub-nav-link:hover .menu-icon-box {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.18) !important;
  color: #ffffff !important;
}
#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active,
#sidebar-menu > ul.side-menu > li.side-nav-item > a.active {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 18px -2px rgba(37, 99, 235, 0.5) !important;
}
#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a .active-indicator-pill, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active .active-indicator-pill,
#sidebar-menu > ul.side-menu > li.side-nav-item > a.active .active-indicator-pill {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4.5px;
  height: 24px;
  background: #ffffff;
  border-radius: 0 4px 4px 0;
  z-index: 2;
}
#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a .menu-icon-box, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active .menu-icon-box,
#sidebar-menu > ul.side-menu > li.side-nav-item > a.active .menu-icon-box {
  background: rgba(255, 255, 255, 0.22) !important;
  border-color: rgba(255, 255, 255, 0.35) !important;
  color: #ffffff !important;
}
#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a .menu-icon-box svg, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active .menu-icon-box svg,
#sidebar-menu > ul.side-menu > li.side-nav-item > a.active .menu-icon-box svg {
  color: #ffffff !important;
  stroke: #ffffff !important;
}
#sidebar-menu > ul.side-menu > li.side-nav-item ul {
  padding-left: 20px;
  list-style: none;
}
#sidebar-menu .badge {
  margin-top: 2px;
}
#sidebar-menu .menu-title {
  padding: 14px 14px 6px;
  letter-spacing: 0.08em;
  pointer-events: none;
  cursor: default;
  font-size: 0.65rem;
  text-transform: uppercase;
  color: #475569;
  font-weight: 700;
}

.menu-icon-box {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  transition: all 0.2s ease;
}
.menu-icon-box svg {
  width: 17px;
  height: 17px;
  stroke-width: 2;
  fill: none !important;
}

.menu-item-text {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13.5px;
  font-weight: inherit;
}

.nav-second-level {
  padding: 4px 0 6px 36px;
  list-style: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.nav-second-level li a {
  padding: 6px 10px !important;
  color: #94a3b8 !important;
  display: block;
  position: relative;
  transition: all 0.2s;
  font-size: 13px !important;
  border-radius: 8px !important;
}
.nav-second-level li a:focus, .nav-second-level li a:hover {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.05) !important;
}
.nav-second-level li.active > a, .nav-second-level li.menuitem-active > a {
  color: #60a5fa !important;
  background: rgba(37, 99, 235, 0.15) !important;
  font-weight: 600 !important;
}

.menu-arrow {
  transition: transform 0.15s;
  display: inline-block;
  font-family: "unicons";
  text-rendering: auto;
  font-size: 1rem;
  transform: translate(0, 0);
}
.menu-arrow::before {
  content: "\\e82f";
}

[dir=rtl] .menu-arrow::before {
  content: "\\e82e";
}

li > a[aria-expanded=true] > span.menu-arrow {
  transform: rotate(90deg);
}
li.menuitem-active > a:not(.collapsed) > span.menu-arrow {
  transform: rotate(90deg);
}

body[data-sidebar-size=condensed] .logo-box {
  width: 70px !important;
  text-align: center;
}
@media (max-width: 991.98px) {
  body[data-sidebar-size=condensed] .logo-box {
    padding-left: 0 !important;
  }
}
body[data-sidebar-size=condensed] .logo span.logo-lg {
  display: none;
}
body[data-sidebar-size=condensed] .logo span.logo-sm {
  display: block;
}
body[data-sidebar-size=condensed] .left-side-menu {
  position: absolute;
  padding-top: 0;
  width: 70px !important;
  z-index: 5;
}
body[data-sidebar-size=condensed] .left-side-menu .simplebar-mask,
body[data-sidebar-size=condensed] .left-side-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
body[data-sidebar-size=condensed] .left-side-menu .simplebar-scrollbar {
  display: none !important;
}
body[data-sidebar-size=condensed] .left-side-menu .simplebar-offset {
  bottom: 0 !important;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .menu-title,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .menu-arrow,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .label,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .badge,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .collapse.in {
  display: none !important;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .nav.collapse {
  height: inherit !important;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li {
  position: relative;
  white-space: nowrap;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a {
  padding: 15px 20px;
  min-height: 54px;
  transition: none;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a:hover, body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a:active, body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a:focus {
  color: #5369f8;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a i {
  font-size: 1.3rem;
  margin-right: 20px;
  margin-left: 5px;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a svg {
  width: 18px;
  height: 18px;
  margin-left: 6px;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a span {
  display: none;
  padding-left: 25px;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > a {
  position: relative;
  width: calc(190px + 70px);
  color: #5369f8;
  background-color: #f8f9fa;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > a span {
  display: inline;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover a.open :after,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover a.active :after {
  display: none;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing {
  display: block !important;
  height: auto !important;
  transition: none !important;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul {
  display: block !important;
  left: 70px;
  position: absolute;
  width: 190px;
  box-shadow: 3px 5px 10px 0 rgba(154, 161, 171, 0.2);
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul ul,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul ul {
  box-shadow: 3px 5px 10px 0 rgba(154, 161, 171, 0.2);
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul a,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul a {
  box-shadow: none;
  padding: 8px 20px;
  position: relative;
  width: 190px;
  z-index: 6;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul a:hover,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul a:hover {
  color: #5369f8;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul .collapsing {
  display: block !important;
  height: auto !important;
  transition: none !important;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul {
  padding: 5px 0;
  z-index: 9999;
  display: none;
  background-color: #ffffff;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapse,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapsing {
  display: block !important;
  height: auto !important;
  transition: none !important;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapse > ul,
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapsing > ul {
  display: block;
  left: 190px;
  margin-top: -36px;
  position: absolute;
  width: 190px;
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li > a span.pull-right {
  position: absolute;
  right: 20px;
  top: 12px;
  transform: rotate(270deg);
}
body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li.active a {
  color: #5369f8;
}
body[data-sidebar-size=condensed] .content-page {
  margin-left: 70px !important;
}
@media (min-width: 992px) {
  body[data-sidebar-size=condensed] .footer {
    left: 70px !important;
  }
}
body[data-sidebar-size=condensed] .user-box {
  display: none !important;
}

@media (min-width: 768px) {
  body[data-sidebar-size=condensed]:not([data-layout=compact]) {
    min-height: 1750px;
  }
  body.authentication-bg {
    min-height: auto !important;
  }
}
@media (max-width: 575.98px) {
  .pro-user-name {
    display: none;
  }
}
@media (max-width: 991.98px) {
  body {
    overflow-x: hidden;
    padding-bottom: 80px;
  }
  .left-side-menu {
    display: none;
    z-index: 10 !important;
  }
  .sidebar-enable .left-side-menu {
    display: block;
  }
  .content-page,
  body[data-sidebar-size=condensed] .content-page {
    margin-left: 0 !important;
    padding: 0 10px;
  }
  .footer {
    left: 0 !important;
  }
}
/* =============
  Small Menu
============= */
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .logo-box {
  width: 160px !important;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu {
  width: 160px !important;
  text-align: center;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul > li > a > i {
  display: block;
  font-size: 18px;
  line-height: 24px;
  width: 100%;
  margin: 0;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul > li > a svg {
  display: block;
  margin: 0 auto 5px auto;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul ul {
  padding-left: 0;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul ul a {
  padding: 10px 20px;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu .menu-arrow,
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu .badge {
  display: none !important;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu + .content-page {
  margin-left: 160px;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu + .content-page .footer {
  left: 160px;
}
body[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu .menu-title {
  background-color: #f8f9fa;
}

body[data-sidebar-color=dark] .logo-box {
  background-color: #ffffff !important;
  border-right: 1px solid #e2e8f0 !important;
}
body[data-sidebar-color=dark] .left-side-menu {
  background: linear-gradient(180deg, #020b18 0%, #031024 45%, #051329 100%) !important;
  border-right-color: #0a1f3d !important;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);
}
body[data-sidebar-color=dark][data-sidebar-size=condensed] #wrapper .left-side-menu #sidebar-menu > ul > li:hover > a {
  background-color: #323742;
  box-shadow: none;
}
body[data-sidebar-color=dark][data-sidebar-size=condensed] #wrapper .left-side-menu #sidebar-menu .menuitem-active .active {
  color: #5369f8;
}
body[data-sidebar-color=dark][data-sidebar-size=compact] #wrapper .left-side-menu .menu-title {
  background-color: rgba(255, 255, 255, 0.03);
}

.user-box {
  display: none;
}

.user-pro-dropdown {
  padding: 15px 5px !important;
  width: 90%;
  margin-left: 5%;
  margin-top: 10px;
}
.user-pro-dropdown .dropdown-item {
  border-radius: 3px;
}

body[data-layout-mode=detached] .logo-box {
  background-color: transparent !important;
}
@media (min-width: 992px) {
  body[data-layout-mode=detached] .navbar-custom .container-fluid, body[data-layout-mode=detached] .navbar-custom .container-sm, body[data-layout-mode=detached] .navbar-custom .container-md, body[data-layout-mode=detached] .navbar-custom .container-lg, body[data-layout-mode=detached] .navbar-custom .container-xl, body[data-layout-mode=detached] .navbar-custom .container-xxl {
    max-width: 95%;
  }
  body[data-layout-mode=detached] #wrapper {
    max-width: 95%;
    margin: 0 auto;
  }
  body[data-layout-mode=detached] .left-side-menu {
    margin-top: 30px;
    margin-bottom: 30px;
    border-radius: 5px;
    border: 1px solid #e2e7f1;
  }
  body[data-layout-mode=detached] .content-page {
    padding-bottom: 30px;
  }
  body[data-layout-mode=detached] .logo-box {
    background-color: transparent;
    background-image: none;
  }
}

body[data-sidebar-showuser=true] .user-box {
  display: block;
}

.logo {
  display: block;
}
.logo span.logo-lg {
  display: block;
}
.logo span.logo-sm {
  display: none;
}
.logo .logo-lg-text-dark {
  color: #343a40;
  font-weight: 700;
  font-size: 22px;
  text-transform: uppercase;
}
.logo .logo-lg-text-light {
  color: #fff;
  font-weight: 700;
  font-size: 22px;
  text-transform: uppercase;
}

/* Default height for the logo */
.logo Img {
  height: 80px;
}

/* Media query for smaller screens */
@media screen and (max-width: 768px) {
  .logo Img {
    height: 60px; /* Adjust the height for smaller screens */
  }
}
/* Media query for even smaller screens */
@media screen and (max-width: 576px) {
  .logo Img {
    height: 40px; /* Adjust the height for even smaller screens */
  }
}
@media screen and (max-width: 376px) {
  .logo Img {
    height: 35px; /* Adjust the height for even smaller screens */
  }
}
.logo-box {
  height: 70px;
  width: 250px;
  float: left;
  transition: all 0.1s ease-out;
  padding: 0 14px;
  background: #ffffff !important;
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1002;
}
.logo-box .sidebar-brand-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none !important;
  width: 100%;
  overflow: hidden;
}
.logo-box .sidebar-brand-mascot {
  height: 50px;
  width: auto;
  max-width: 50px;
  object-fit: contain;
  flex-shrink: 0;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
}
.logo-box .sidebar-brand-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.15;
  overflow: hidden;
}
.logo-box .sidebar-brand-title {
  font-weight: 800;
  font-size: 18px;
  color: #0b3558;
  letter-spacing: -0.2px;
  white-space: nowrap;
}
.logo-box .sidebar-brand-subtitle {
  font-weight: 700;
  font-size: 10.5px;
  color: #0284c7;
  letter-spacing: 0px;
  white-space: nowrap;
}
.logo-box .sidebar-brand-icon-only {
  display: none;
}
.logo-box .sidebar-brand-combo-img {
  height: 58px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}

body[data-sidebar-size=condensed] .logo-box .sidebar-brand-combo {
  display: none !important;
}
body[data-sidebar-size=condensed] .logo-box .sidebar-brand-icon-only {
  display: block !important;
}

.topbar-district-contact {
  height: 70px;
  gap: 8px;
  padding: 0 12px;
  line-height: 1.15;
}
.topbar-district-contact__icon {
  color: #60a5fa;
}
.topbar-district-contact__icon-link {
  color: inherit;
  cursor: pointer;
}
.topbar-district-contact__text {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  overflow: hidden;
}
.topbar-district-contact__designation {
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.55);
}
.topbar-district-contact__detail {
  font-size: 0.8rem;
  font-weight: 600;
  color: #ffffff;
  text-decoration: none;
}
.topbar-district-contact__detail:hover {
  text-decoration: underline;
}
.topbar-district-contact__detail a {
  color: inherit;
  text-decoration: none;
}
.topbar-district-contact__detail a:hover {
  text-decoration: underline;
}
.topbar-district-contact--mobile {
  gap: 6px;
  padding: 0 8px;
  max-width: 50vw;
}
.topbar-district-contact--mobile .topbar-district-contact__designation {
  font-size: 0.55rem;
}
.topbar-district-contact--mobile .topbar-district-contact__detail {
  font-size: 0.72rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 991.98px) {
  .topbar-district-contact--mobile {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
  }
}
body[data-topbar-color=light] .topbar-district-contact__icon {
  color: #f77707;
}
body[data-topbar-color=light] .topbar-district-contact__designation {
  color: rgba(0, 0, 0, 0.5);
}
body[data-topbar-color=light] .topbar-district-contact__detail {
  color: #1e293b;
}

.navbar-custom {
  background-color: #323742;
  padding: 0 10px 0 0;
  position: fixed;
  left: 0;
  right: 0;
  height: 70px;
  border-bottom: 1px solid #323742;
  z-index: 1001;
}
.navbar-custom .topnav-menu > li {
  float: left;
}
.navbar-custom .topnav-menu .nav-link {
  padding: 0 12px;
  color: rgba(255, 255, 255, 0.6);
  min-width: 32px;
  display: block;
  line-height: 70px;
  text-align: center;
  max-height: 70px;
}
.navbar-custom .topnav-menu .nav-link svg {
  height: 20px;
  width: 20px;
  color: rgba(255, 255, 255, 0.6);
  fill: rgba(255, 255, 255, 0.12);
}
.navbar-custom .topnav-menu .nav-link:hover svg, .navbar-custom .topnav-menu .nav-link:focus svg, .navbar-custom .topnav-menu .nav-link:active svg {
  color: #5369f8;
  fill: rgba(83, 105, 248, 0.1);
}
.navbar-custom .container-fluid, .navbar-custom .container-sm, .navbar-custom .container-md, .navbar-custom .container-lg, .navbar-custom .container-xl, .navbar-custom .container-xxl {
  padding: 0;
}
.navbar-custom {
  /* Search */
}
.navbar-custom .app-search {
  height: 70px;
  display: grid;
  width: 180px;
  margin-right: 20px;
  align-items: center;
}
.navbar-custom .app-search .react-select__placeholder,
.navbar-custom .app-search input::placeholder {
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.3);
  margin: 0;
}
.navbar-custom .app-search .react-select__menu {
  overflow: hidden;
  width: 320px !important;
  margin-top: 0;
}
.navbar-custom .app-search .react-select__input,
.navbar-custom .app-search .react-select__value-container {
  color: #fff !important;
  padding: 0;
}
.navbar-custom .app-search .form-control,
.navbar-custom .app-search .react-select__control {
  border: none;
  height: 38px;
  padding-left: 20px;
  padding-right: 0;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: none;
}
.navbar-custom .app-search .input-group-text {
  margin-left: 0 !important;
  z-index: 4;
}
.navbar-custom .app-search .btn {
  border-color: transparent;
  color: rgba(255, 255, 255, 0.3);
  border-radius: 0 30px 30px 0;
  box-shadow: none !important;
}
.navbar-custom .button-menu-mobile {
  border: none;
  color: #fff;
  display: inline-block;
  height: 70px;
  line-height: 70px;
  width: 60px;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}
.navbar-custom .button-menu-mobile.disable-btn {
  display: none;
}

/* Notification */
.noti-scroll {
  max-height: 230px;
}

.notification-list {
  margin-left: 0;
}
.notification-list .noti-title {
  background-color: transparent;
  padding: 15px 20px;
}
.notification-list .noti-icon-badge {
  display: inline-block;
  position: absolute;
  top: 14px;
  right: 8px;
}
.notification-list .notify-item {
  padding: 12px 20px;
}
.notification-list .notify-item .notify-icon {
  float: left;
  height: 36px;
  width: 36px;
  line-height: 36px;
  text-align: center;
  margin-right: 10px;
  border-radius: 50%;
  color: #fff;
}
.notification-list .notify-item .notify-details {
  margin-bottom: 5px;
  overflow: hidden;
  margin-left: 45px;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #343a40;
}
.notification-list .notify-item .notify-details b {
  font-weight: 500;
}
.notification-list .notify-item .notify-details small, .notification-list .notify-item .notify-details .small {
  display: block;
}
.notification-list .notify-item .notify-details span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.notification-list .notify-item .user-msg {
  margin-left: 45px;
  white-space: normal;
  line-height: 16px;
}
.notification-list .profile-dropdown .notify-item {
  padding: 7px 20px;
}

.noti-icon {
  font-size: 21px;
  vertical-align: middle;
}

.profile-dropdown {
  min-width: 170px !important;
}
.profile-dropdown i {
  vertical-align: middle;
  margin-right: 5px;
}

.nav-user {
  padding: 0 12px !important;
}
.nav-user img {
  height: 32px;
  width: 32px;
}

@media (max-width: 991.98px) {
  .logo-box {
    width: 70px !important;
    padding-right: 0 !important;
    border-bottom: 1px solid #e2e7f1;
  }
  .logo-box .logo-lg {
    display: none !important;
  }
  .logo-box .logo-sm {
    display: block !important;
  }
  .logo-box {
    display: none !important;
  }
}
@media (max-width: 600px) {
  .navbar-custom .dropdown {
    position: static;
  }
  .navbar-custom .dropdown .dropdown-menu {
    left: 10px !important;
    right: 10px !important;
  }
}
body[data-topbar-color=light] .navbar-custom {
  background-color: #ffffff !important;
  border-bottom: 1px solid #e2e7f1;
}
body[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link {
  color: #343a40;
}
body[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link svg {
  color: #343a40;
  fill: rgba(52, 58, 64, 0.12);
}
body[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link:hover svg, body[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link:focus svg, body[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link:active svg {
  color: #5369f8;
  fill: rgba(83, 105, 248, 0.1);
}
body[data-topbar-color=light] .navbar-custom .button-menu-mobile {
  color: #343a40;
}
body[data-topbar-color=light] .navbar-custom {
  /* Search */
}
body[data-topbar-color=light] .navbar-custom .app-search .react-select__placeholder,
body[data-topbar-color=light] .navbar-custom .app-search input::placeholder {
  color: #adb5bd !important;
}
body[data-topbar-color=light] .navbar-custom .app-search .react-select__input,
body[data-topbar-color=light] .navbar-custom .app-search .react-select__value-container {
  color: #343a40 !important;
  padding: 0;
}
body[data-topbar-color=light] .navbar-custom .app-search .form-control,
body[data-topbar-color=light] .navbar-custom .app-search .react-select__control {
  color: #343a40 !important;
  background-color: #f6f6f7;
  border-color: #f6f6f7;
}
body[data-topbar-color=light] .navbar-custom .app-search .btn {
  background-color: #f6f6f7;
  color: #ced4da;
}
body[data-topbar-color=light] .logo-box {
  background: #ffffff;
  border-right: 1px solid #e2e7f1;
}
body[data-topbar-color=light] .logo-dark {
  display: block;
}
body[data-topbar-color=light] .logo-light {
  display: none;
}

@media (max-width: 991.98px) {
  body[data-layout-mode=horizontal] .navbar-toggle {
    border: 0;
    position: relative;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
  body[data-layout-mode=horizontal] .navbar-toggle .lines {
    width: 25px;
    display: block;
    position: relative;
    height: 16px;
    transition: all 0.5s ease;
    margin-top: calc(54px * 0.5);
  }
  body[data-layout-mode=horizontal] .navbar-toggle span {
    height: 2px;
    width: 100%;
    background-color: #4B4B5A;
    display: block;
    margin-bottom: 5px;
    transition: transform 0.5s ease;
  }
  body[data-layout-mode=horizontal] .navbar-toggle.open span {
    position: absolute;
  }
  body[data-layout-mode=horizontal] .navbar-toggle.open span:first-child {
    top: 7px;
    transform: rotate(45deg);
  }
  body[data-layout-mode=horizontal] .navbar-toggle.open span:nth-child(2) {
    visibility: hidden;
  }
  body[data-layout-mode=horizontal] .navbar-toggle.open span:last-child {
    width: 100%;
    top: 7px;
    transform: rotate(-45deg);
  }
}
body[data-layout-mode=horizontal] .button-menu-mobile {
  display: none;
}
body[data-layout-mode=horizontal] .logo-box {
  width: auto;
  padding-right: 50px;
  background-color: transparent;
  padding-left: 0;
  border: none !important;
}
@media (max-width: 1366px) {
  body[data-layout-mode=horizontal] .logo-box {
    padding-left: 20px;
  }
}

@media (max-width: 360px) {
  .navbar-custom .topnav-menu .nav-link {
    padding: 0 12px;
  }
  .navbar-custom .button-menu-mobile {
    width: 45px;
  }
}
body[data-layout-mode=two-column] .logo-box {
  display: none;
}

.page-title-box {
  align-items: center;
  justify-content: space-between;
  display: flex;
  margin: 0 -27px 0;
  padding: 20px 27px;
}
.page-title-box .page-title {
  font-size: 1.05rem;
  margin: 0;
}
.page-title-box .breadcrumb {
  padding: 0;
}

@media (max-width: 639px) {
  .page-title-box {
    display: block;
  }
  .page-title-box .page-title {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .page-title-box .page-title-right {
    display: block;
    padding-top: 5px;
  }
}
.footer {
  bottom: 0;
  padding: 19px 15px 20px;
  position: absolute;
  right: 0;
  color: #6c757d;
  left: 250px;
  border-top: 1px solid #e2e7f1;
}
.footer .footer-links a {
  color: #6c757d;
  margin-left: 1.5rem;
  transition: all 0.4s;
}
.footer .footer-links a:hover {
  color: #212529;
}
.footer .footer-links a:first-of-type {
  margin-left: 0;
}

.footer-alt {
  left: 0 !important;
  text-align: center;
  background-color: transparent;
}

@media (max-width: 575.98px) {
  .footer {
    left: 0 !important;
    text-align: center;
  }
}
body[data-layout-mode=horizontal] .footer {
  left: 0 !important;
}
body[data-layout-mode=horizontal][data-layout-width=boxed] .footer {
  max-width: 1300px !important;
}

@media (min-width: 992px) {
  body[data-layout-mode=detached] .footer {
    position: inherit;
    margin: 0 10px;
  }
}

.right-bar {
  background-color: #ffffff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 260px;
  z-index: 9999;
  float: right !important;
  right: -270px;
  top: 0;
  bottom: 0;
}
.right-bar .rightbar-title {
  background-color: #5369f8;
  padding: 27px 25px;
  color: #fff;
}
.right-bar .right-bar-toggle {
  background-color: rgb(26.6680189317%, 29.7450980392%, 32.8221771467%);
  height: 24px;
  width: 24px;
  line-height: 27px;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-top: -4px;
}
.right-bar .right-bar-toggle:hover {
  background-color: rgb(29.3576741041%, 32.7450980392%, 36.1325219743%);
}
.right-bar .user-box {
  padding: 25px;
  text-align: center;
}
.right-bar .user-box .user-img {
  position: relative;
  height: 64px;
  width: 64px;
  margin: 0 auto 15px auto;
}
.right-bar .user-box .user-img .user-edit {
  position: absolute;
  right: -5px;
  bottom: 0px;
  height: 24px;
  width: 24px;
  background-color: #fff;
  line-height: 24px;
  border-radius: 50%;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}
.right-bar .user-box h5, .right-bar .user-box .h5 {
  margin-bottom: 2px;
}
.right-bar .user-box h5 a, .right-bar .user-box .h5 a {
  color: #343a40;
}
.right-bar .notification-item .media {
  padding: 0.75rem 1rem;
}
.right-bar .notification-item .media:hover {
  background-color: #f8f9fa;
}
.right-bar .notification-item .user-status {
  position: absolute;
  right: 0px;
  bottom: -4px;
  font-size: 10px;
}
.right-bar .notification-item .user-status.online {
  color: #43d39e;
}
.right-bar .notification-item .user-status.away {
  color: #ffbe0b;
}
.right-bar .notification-item .user-status.busy {
  color: #ff5c75;
}

.rightbar-overlay {
  background-color: rgba(52, 58, 64, 0.2);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all 0.2s ease-out;
}

.right-bar-enabled .right-bar {
  right: 0;
}
.right-bar-enabled .rightbar-overlay {
  display: block;
}

@media (max-width: 575.98px) {
  .right-bar {
    overflow: auto;
  }
  .right-bar .slimscroll-menu {
    height: auto !important;
  }
}
body[data-layout-width=boxed] #wrapper {
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}
body[data-layout-width=boxed] .navbar-custom {
  max-width: 1300px;
  margin: 0 auto;
}
body[data-layout-width=boxed] .footer {
  margin: 0 auto;
  max-width: calc(1300px - 250px);
}
body[data-layout-width=boxed][data-sidebar-size=condensed] .footer {
  max-width: calc(1300px - 70px);
}
body[data-layout-width=boxed][data-sidebar-size=compact] .footer {
  max-width: calc(1300px - 160px);
}

@media (min-width: 768px) {
  body[data-layout-width=boxed][data-sidebar-size=condensed] .content-page {
    min-height: calc(1750px - 70px);
  }
}
@media (min-width: 1200px) {
  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) {
    padding-bottom: 0;
  }
  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) #wrapper {
    display: flex;
  }
  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .navbar-custom,
  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .topnav {
    position: absolute;
  }
  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .left-side-menu {
    position: relative;
    min-width: 250px;
    max-width: 250px;
    padding: 20px 0 calc(70px + 20px);
  }
  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .content-page {
    margin-left: 0;
    width: 100%;
    padding-bottom: 60px;
  }
}
@media (min-width: 1200px) {
  body[data-layout-mode=horizontal] .container-fluid, body[data-layout-mode=horizontal] .container-sm, body[data-layout-mode=horizontal] .container-md, body[data-layout-mode=horizontal] .container-lg, body[data-layout-mode=horizontal] .container-xl, body[data-layout-mode=horizontal] .container-xxl {
    max-width: 90%;
  }
  body[data-layout-mode=horizontal] .navbar-custom {
    padding: 0 24px;
  }
}
body[data-layout-mode=horizontal] .content-page {
  margin-left: 0 !important;
}

.topnav {
  background: #ffffff;
  border-bottom: 1px solid #e2e7f1;
  margin-top: 70px;
  padding: 0 calc(24px * 0.5);
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
}
.topnav .topnav-menu {
  margin: 0;
  padding: 0;
}
.topnav .navbar-nav .nav-link {
  font-size: 0.95rem;
  position: relative;
  line-height: 22px;
  padding: calc(33px * 0.5) 1.1rem;
  color: #6e7488;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
}
.topnav .navbar-nav .nav-link i {
  font-size: 15px;
  display: inline-block;
}
.topnav .navbar-nav .nav-link svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: -4px 5px 0 0;
  color: #6e7488;
  fill: rgba(110, 116, 136, 0.12);
}
.topnav .navbar-nav .nav-link:focus, .topnav .navbar-nav .nav-link:hover {
  color: #5369f8;
  background-color: transparent;
}
.topnav .navbar-nav .nav-item .dropdown.active > a.dropdown-toggle {
  color: #5369f8;
}
.topnav .navbar-nav .nav-item.active > a {
  color: #5369f8;
}
.topnav .navbar-nav .nav-item.active > a svg {
  color: #5369f8;
  fill: rgba(83, 105, 248, 0.12);
}

@media (min-width: 992px) {
  .topnav {
    height: 55px;
  }
  .topnav .navbar-nav .nav-item:first-of-type .nav-link {
    padding-left: 0;
  }
  .topnav .dropdown-item {
    padding: 0.5rem 1.25rem;
    min-width: 180px;
    margin: 0 0.3rem;
    width: auto;
  }
  .topnav .dropdown-item.active {
    background-color: transparent;
    color: #5369f8;
  }
  .topnav .dropdown.mega-dropdown .mega-dropdown-menu {
    left: 0px;
    right: auto;
  }
  .topnav .dropdown .dropdown-menu {
    padding: 0.3rem 0;
    margin-top: 0;
    border-radius: 0 0 0.25rem 0.25rem;
  }
  .topnav .dropdown .dropdown-menu .arrow-down::after {
    right: 20px;
    transform: rotate(-135deg) translateY(-50%);
    position: absolute;
  }
  .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {
    position: absolute;
    top: 0 !important;
    left: 100%;
    display: none;
  }
  .topnav .dropdown:hover > .nav-link {
    color: #5369f8;
  }
  .topnav .dropdown:hover > .nav-link svg {
    color: #5369f8;
    fill: rgba(83, 105, 248, 0.12);
  }
  .topnav .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-item {
    color: #5369f8;
  }
  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {
    display: block;
  }
  .navbar-toggle {
    display: none;
  }
  body[data-layout-mode=horizontal] .content-page {
    padding: 55px 12px 65px 12px;
  }
}
.arrow-down {
  display: inline-block;
}
.arrow-down:after {
  border-color: initial;
  border-style: solid;
  border-width: 0 0 1px 1px;
  content: "";
  height: 0.4em;
  display: inline-block;
  right: 5px;
  top: 50%;
  margin-left: 10px;
  transform: rotate(-45deg) translateY(-50%);
  transform-origin: top;
  transition: all 0.3s ease-out;
  width: 0.4em;
}

@media (max-width: 1199.98px) {
  .topnav-menu .navbar-nav li:last-of-type .dropdown .dropdown-menu {
    right: 100%;
    left: auto;
  }
}
@media (max-width: 991.98px) {
  .topnav {
    max-height: 360px;
    overflow-y: auto;
    padding: 0;
  }
  .topnav .navbar-nav .nav-link {
    padding: 0.75rem 1.1rem;
  }
  .topnav .dropdown .dropdown-menu {
    background-color: transparent;
    border: none;
    box-shadow: none;
    padding-left: 15px;
  }
  .topnav .dropdown .dropdown-item {
    position: relative;
    background-color: transparent;
  }
  .topnav .dropdown .dropdown-item.active, .topnav .dropdown .dropdown-item:active {
    color: #5369f8;
  }
  .topnav .arrow-down::after {
    right: 15px;
    position: absolute;
  }
}
body[data-layout-mode=horizontal][data-layout-width=boxed] .topnav {
  max-width: 1300px;
  margin: 70px auto 0;
}

body[data-layout-mode=horizontal] .logo-box {
  background-color: transparent !important;
}

body[data-layout-mode=two-column] .left-side-menu {
  width: calc(70px + 220px);
  background-color: transparent;
  box-shadow: none;
}
body[data-layout-mode=two-column] .sidebar-icon-menu {
  position: fixed;
  width: 70px;
  z-index: 500;
  top: 0;
  bottom: 0;
  padding-bottom: 20px;
  background-color: #5369f8;
}
body[data-layout-mode=two-column] .sidebar-icon-menu .logo {
  display: block;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}
body[data-layout-mode=two-column] .sidebar-icon-menu .nav {
  background-color: transparent;
  margin: 24px auto;
}
body[data-layout-mode=two-column] .sidebar-icon-menu .nav .nav-link {
  text-align: center;
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin: 12px auto;
  padding: 0px;
  border-radius: 4px;
}
body[data-layout-mode=two-column] .sidebar-icon-menu .nav .nav-link.active {
  background-color: rgba(255, 255, 255, 0.12);
}
body[data-layout-mode=two-column] .sidebar-icon-menu .nav .nav-link svg {
  color: #fff;
  fill: rgba(255, 255, 255, 0.12);
  height: 22px;
  width: 22px;
}
body[data-layout-mode=two-column] .sidebar-main-menu {
  display: block;
  position: fixed;
  width: 220px;
  background-color: #ffffff;
  top: 70px;
  bottom: 0;
  left: 70px;
  padding: 30px 5px;
  border-right: 1px solid #e2e7f1;
  transition: all 0.1s ease-out;
}
body[data-layout-mode=two-column] .sidebar-main-menu .sidebar-menu-body {
  padding: 20px;
}
body[data-layout-mode=two-column] .sidebar-main-menu .menu-title {
  color: #adb5bd !important;
  margin: 0;
  padding: 10px 20px;
  letter-spacing: 0.05em;
  font-size: 0.7rem;
  text-transform: uppercase;
  font-weight: 600;
}
body[data-layout-mode=two-column] .sidebar-main-menu .nav > .nav-item > .nav-link {
  color: #4b4b5a;
  font-size: 0.95rem;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
}
body[data-layout-mode=two-column] .sidebar-main-menu .nav > .nav-item .menu-arrow {
  right: 10px;
}
body[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link {
  position: relative;
  color: #4b4b5a;
  padding: 6px 15px;
  border-radius: 3px;
  margin: 3px 5px;
}
body[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link.active {
  color: #5369f8;
}
body[data-layout-mode=two-column] .sidebar-main-menu .nav .menuitem-active > a.nav-link {
  color: #5369f8;
  background-color: rgba(83, 105, 248, 0.07);
}
body[data-layout-mode=two-column] .sidebar-main-menu .nav .menuitem-active a.active {
  color: #5369f8;
}
body[data-layout-mode=two-column] .sidebar-main-menu #sidebar-menu .menu-arrow {
  top: 7px;
}
body[data-layout-mode=two-column] .sidebar-main-menu .nav-second-level {
  padding-left: 15px;
  list-style: none;
}
@media (min-width: 992px) {
  body[data-layout-mode=two-column] .navbar-custom {
    left: 70px !important;
    padding-left: 0px;
  }
  body[data-layout-mode=two-column] .navbar-custom .logo-box {
    width: 220px;
  }
  body[data-layout-mode=two-column] .navbar-custom .logo-box .logo-sm {
    display: none;
  }
  body[data-layout-mode=two-column][data-sidebar-size=condensed] .logo-box {
    width: 0 !important;
  }
}
body[data-layout-mode=two-column][data-sidebar-color=light] .logo-box {
  background-color: #ffffff;
}
@media (min-width: 992px) {
  body[data-layout-mode=two-column] .content-page {
    margin-left: calc(70px + 220px);
  }
  body[data-layout-mode=two-column] .footer {
    left: calc(70px + 220px);
  }
  body[data-layout-mode=two-column][data-sidebar-size=condensed] .sidebar-main-menu {
    display: none;
  }
}
body[data-layout-mode=two-column] .twocolumn-menu-item {
  display: none;
}
body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu {
  background-color: #323742;
}
body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav > .nav-item > .nav-link {
  color: #9097a7;
}
body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .nav-link.active {
  color: #c8cddc;
}
body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .menuitem-active > a.nav-link {
  color: #5369f8;
  background-color: rgba(83, 105, 248, 0.07);
}
body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .menuitem-active a.active {
  color: #5369f8;
}
body[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav > .nav-item > .nav-link, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav > .nav-item > .nav-link {
  color: rgba(255, 255, 255, 0.7);
}
body[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav .nav-link.active, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav .nav-link.active {
  color: rgba(255, 255, 255, 0.9);
}
body[data-layout-mode=two-column][data-layout-width=boxed] .navbar-custom {
  max-width: calc(1300px - 70px);
}
body[data-layout-mode=two-column][data-layout-width=boxed] .sidebar-main-menu {
  position: absolute;
  top: 0;
}
body[data-layout-mode=two-column][data-layout-width=boxed]:not([data-sidebar-size=condensed]) .footer {
  max-width: calc(1300px - calc(70px + 220px));
}

.avatar-xs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-sm {
  height: 2.25rem;
  width: 2.25rem;
}

.avatar {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 3.5rem;
  width: 3.5rem;
}

.avatar-lg {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-xl {
  height: 6rem;
  width: 6rem;
}

.avatar-xxl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
}
.avatar-group .avatar-group-item {
  margin: 0 0 10px -12px;
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 50%;
}

.checkbox label {
  display: inline-block;
  padding-left: 8px;
  position: relative;
  font-weight: 500;
  margin-bottom: 0;
}
.checkbox label::before {
  background-color: #e2e7f1;
  border-radius: 3px;
  border: 2px solid #e2e7f1;
  content: "";
  display: inline-block;
  height: 18px;
  left: 0;
  margin-left: -18px;
  position: absolute;
  transition: 0.3s ease-in-out;
  width: 18px;
  outline: none !important;
  top: 2px;
}
.checkbox label::after {
  color: #4B4B5A;
  display: inline-block;
  font-size: 11px;
  height: 18px;
  left: 0;
  margin-left: -18px;
  padding-left: 3px;
  padding-top: 2px;
  position: absolute;
  top: 0;
  width: 18px;
}
.checkbox input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.checkbox input[type=checkbox]:disabled + label {
  opacity: 0.65;
}
.checkbox input[type=checkbox]:focus + label::before {
  outline-offset: -2px;
  outline: none;
}
.checkbox input[type=checkbox]:checked + label::after {
  content: "";
  position: absolute;
  top: 6px;
  left: 7px;
  display: table;
  width: 4px;
  height: 8px;
  border: 2px solid #4B4B5A;
  border-top-width: 0;
  border-left-width: 0;
  transform: rotate(45deg);
}
.checkbox input[type=checkbox]:disabled + label::before {
  background-color: #f8f9fa;
  cursor: not-allowed;
}

.checkbox.checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox.checkbox-inline {
  margin-top: 0;
}

.checkbox.checkbox-single input {
  height: 18px;
  width: 18px;
  position: absolute;
}
.checkbox.checkbox-single label {
  height: 18px;
  width: 18px;
}
.checkbox.checkbox-single label:before {
  margin-left: 0;
}
.checkbox.checkbox-single label:after {
  margin-left: 0;
}

.checkbox-primary input[type=checkbox]:checked + label::before {
  background-color: #5369f8;
  border-color: #5369f8;
}
.checkbox-primary input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-secondary input[type=checkbox]:checked + label::before {
  background-color: #6c757d;
  border-color: #6c757d;
}
.checkbox-secondary input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-success input[type=checkbox]:checked + label::before {
  background-color: #43d39e;
  border-color: #43d39e;
}
.checkbox-success input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-info input[type=checkbox]:checked + label::before {
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.checkbox-info input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-warning input[type=checkbox]:checked + label::before {
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.checkbox-warning input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-danger input[type=checkbox]:checked + label::before {
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.checkbox-danger input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-light input[type=checkbox]:checked + label::before {
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.checkbox-light input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-dark input[type=checkbox]:checked + label::before {
  background-color: #343a40;
  border-color: #343a40;
}
.checkbox-dark input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.radio label {
  display: inline-block;
  padding-left: 8px;
  position: relative;
  font-weight: 500;
  margin-bottom: 0;
}
.radio label::before {
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #6c757d;
  content: "";
  display: inline-block;
  height: 18px;
  left: 0;
  margin-left: -18px;
  position: absolute;
  transition: border 0.5s ease-in-out;
  width: 18px;
  outline: none !important;
}
.radio label::after {
  background-color: #4B4B5A;
  border-radius: 50%;
  content: " ";
  display: inline-block;
  height: 10px;
  left: 6px;
  margin-left: -20px;
  position: absolute;
  top: 4px;
  transform: scale(0, 0);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  width: 10px;
}
.radio input[type=radio] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.radio input[type=radio]:disabled + label {
  opacity: 0.65;
}
.radio input[type=radio]:focus + label::before {
  outline-offset: -2px;
  outline: 5px auto -webkit-focus-ring-color;
  outline: thin dotted;
}
.radio input[type=radio]:checked + label::after {
  transform: scale(1, 1);
}
.radio input[type=radio]:disabled + label::before {
  cursor: not-allowed;
}

.radio.radio-inline {
  margin-top: 0;
}

.radio.radio-single label {
  height: 17px;
}

.radio-primary input[type=radio] + label::after {
  background-color: #5369f8;
}
.radio-primary input[type=radio]:checked + label::before {
  border-color: #5369f8;
}
.radio-primary input[type=radio]:checked + label::after {
  background-color: #5369f8;
}

.radio-secondary input[type=radio] + label::after {
  background-color: #6c757d;
}
.radio-secondary input[type=radio]:checked + label::before {
  border-color: #6c757d;
}
.radio-secondary input[type=radio]:checked + label::after {
  background-color: #6c757d;
}

.radio-success input[type=radio] + label::after {
  background-color: #43d39e;
}
.radio-success input[type=radio]:checked + label::before {
  border-color: #43d39e;
}
.radio-success input[type=radio]:checked + label::after {
  background-color: #43d39e;
}

.radio-info input[type=radio] + label::after {
  background-color: #25c2e3;
}
.radio-info input[type=radio]:checked + label::before {
  border-color: #25c2e3;
}
.radio-info input[type=radio]:checked + label::after {
  background-color: #25c2e3;
}

.radio-warning input[type=radio] + label::after {
  background-color: #ffbe0b;
}
.radio-warning input[type=radio]:checked + label::before {
  border-color: #ffbe0b;
}
.radio-warning input[type=radio]:checked + label::after {
  background-color: #ffbe0b;
}

.radio-danger input[type=radio] + label::after {
  background-color: #ff5c75;
}
.radio-danger input[type=radio]:checked + label::before {
  border-color: #ff5c75;
}
.radio-danger input[type=radio]:checked + label::after {
  background-color: #ff5c75;
}

.radio-light input[type=radio] + label::after {
  background-color: #f8f9fa;
}
.radio-light input[type=radio]:checked + label::before {
  border-color: #f8f9fa;
}
.radio-light input[type=radio]:checked + label::after {
  background-color: #f8f9fa;
}

.radio-dark input[type=radio] + label::after {
  background-color: #343a40;
}
.radio-dark input[type=radio]:checked + label::before {
  border-color: #343a40;
}
.radio-dark input[type=radio]:checked + label::after {
  background-color: #343a40;
}

.width-xs {
  min-width: 80px;
}

.width-sm {
  min-width: 100px;
}

.width-md {
  min-width: 120px;
}

.width-lg {
  min-width: 140px;
}

.width-xl {
  min-width: 160px;
}

.font-family-primary {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
}

.font-family-secondary {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
}

.sp-line-1,
.sp-line-2,
.sp-line-3,
.sp-line-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.sp-line-1 {
  -webkit-line-clamp: 1;
}

.sp-line-2 {
  -webkit-line-clamp: 2;
}

.sp-line-3 {
  -webkit-line-clamp: 3;
}

.sp-line-4 {
  -webkit-line-clamp: 4;
}

.icon-dual {
  color: #6c757d;
  fill: rgba(108, 117, 125, 0.12);
}

.icon-dual-primary {
  color: #5369f8;
  fill: rgba(83, 105, 248, 0.16);
}

.icon-dual-secondary {
  color: #6c757d;
  fill: rgba(108, 117, 125, 0.16);
}

.icon-dual-success {
  color: #43d39e;
  fill: rgba(67, 211, 158, 0.16);
}

.icon-dual-info {
  color: #25c2e3;
  fill: rgba(37, 194, 227, 0.16);
}

.icon-dual-warning {
  color: #ffbe0b;
  fill: rgba(255, 190, 11, 0.16);
}

.icon-dual-danger {
  color: #ff5c75;
  fill: rgba(255, 92, 117, 0.16);
}

.icon-dual-light {
  color: #f8f9fa;
  fill: rgba(248, 249, 250, 0.16);
}

.icon-dual-dark {
  color: #343a40;
  fill: rgba(52, 58, 64, 0.16);
}

.icon-xs {
  height: 16px;
  width: 16px;
}

.icon-sm {
  height: 24px;
  width: 24px;
}

.icon-md {
  height: 32px;
  width: 32px;
}

.icon-lg {
  height: 40px;
  width: 40px;
}

.icon-xl {
  height: 48px;
  width: 48px;
}

.icon-xxl {
  height: 60px;
  width: 60px;
}

.item-hovered:hover {
  background-color: #f8f9fa;
}

.cursor-pointer {
  cursor: pointer;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 2px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
}

.widget-flat {
  position: relative;
  overflow: hidden;
}
.widget-flat i.widget-icon {
  font-size: 36px;
}

/* Chat widget */
.conversation-list {
  list-style: none;
  height: 332px;
  padding: 0 7px;
  outline: none;
}
.conversation-list li {
  margin-bottom: 24px;
}
.conversation-list .chat-avatar {
  float: left;
  text-align: center;
  width: 38px;
}
.conversation-list .chat-avatar img {
  border-radius: 100%;
  width: 100%;
}
.conversation-list .chat-avatar i {
  font-size: 12px;
  font-style: normal;
}
.conversation-list .ctext-wrap {
  background: rgb(94.0462263118%, 94.8077555044%, 99.7576952569%);
  color: #5369f8;
  border-radius: 0.25rem;
  display: inline-block;
  padding: 4px 12px;
  position: relative;
}
.conversation-list .ctext-wrap i {
  display: block;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  position: relative;
}
.conversation-list .ctext-wrap p {
  margin: 0;
  padding-top: 3px;
}
.conversation-list .ctext-wrap:after {
  right: 98%;
  top: 0;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-top-color: rgb(94.0462263118%, 94.8077555044%, 99.7576952569%);
  border-width: 6px;
  margin-left: -1px;
  border-right-color: rgb(94.0462263118%, 94.8077555044%, 99.7576952569%);
}
.conversation-list .conversation-text {
  float: left;
  font-size: 12px;
  margin-left: 12px;
  width: 70%;
}
.conversation-list .odd .chat-avatar {
  float: right !important;
}
.conversation-list .odd .conversation-text {
  float: right !important;
  margin-right: 12px;
  text-align: right;
  width: 70% !important;
}
.conversation-list .odd .ctext-wrap {
  background-color: #e2e7f1;
  color: #4B4B5A;
}
.conversation-list .odd .ctext-wrap:after {
  border-color: transparent;
  border-left-color: #e2e7f1;
  border-top-color: #e2e7f1;
  left: 99% !important;
}

/* profile / users */
.profile-widget {
  position: relative;
}
.profile-widget .card-action {
  position: absolute;
  right: 7px;
  top: 12px;
  z-index: 100;
}
.profile-widget .card-img-top {
  max-height: 220px;
}
.profile-widget .profile-info {
  margin-top: -2.7rem;
}

.calendar-widget .flatpickr-calendar {
  box-shadow: none;
  border: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;
}

.activity-widget .activity-list {
  border-bottom: 1px solid #f6f6f7;
  padding: 12px 0px;
}
.activity-widget .activity-list:last-child {
  border: none;
}

@media print {
  .left-side-menu,
  .right-bar,
  .page-title-box,
  .navbar-custom,
  .footer {
    display: none;
  }
  .card-body,
  .content-page,
  .right-bar,
  .content,
  body {
    padding: 0;
    margin: 0;
  }
  .card {
    border: none;
  }
}
#preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 9999;
}

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

.spinner {
  margin: 0 auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 5px solid #e2e7f1;
  border-right: 5px solid #e2e7f1;
  border-bottom: 5px solid #e2e7f1;
  border-left: 5px solid #5369f8;
  transform: translateZ(0);
  animation: SpinnerAnimation 1.1s infinite linear;
}

.spinner,
.spinner:after {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

@keyframes SpinnerAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
body.authentication-bg {
  background-size: cover;
  background-repeat: no-repeat;
  padding-bottom: 0;
}

.authentication-form .form-group .input-group-text {
  background-color: transparent;
}
.authentication-form .form-group .input-group-text svg {
  height: 20px;
  width: 20px;
}

.icon-fb {
  color: #3c5a98;
}

.icon-google {
  color: #e94134;
}

.auth-page-sidebar {
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  position: relative;
}
.auth-page-sidebar .overlay {
  flex: 1 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
}
.auth-page-sidebar .auth-user-testimonial {
  text-align: center;
  color: #fff;
  position: absolute;
  margin: 0 auto;
  padding: 0 1.75rem;
  bottom: 3rem;
  left: 0;
  right: 0;
}

.auth-logo .logo-light {
  display: none !important;
}
.auth-logo .logo-dark {
  display: block !important;
}

.logout-checkmark {
  width: 90px;
  margin: 0 auto;
  padding: 20px 0;
}
.logout-checkmark .path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
  animation: dash 2s ease-in-out;
}
.logout-checkmark .spin {
  animation: spin 2s;
  transform-origin: 50% 50%;
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes text {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.mashaal-brand {
  display: inline-flex;
  align-items: flex-start;
  gap: 12px;
  text-decoration: none;
  margin-bottom: 20px;
}
.mashaal-brand__mascot {
  width: 56px;
  height: auto;
}
.mashaal-brand__combo {
  height: 68px;
  width: auto;
}
.mashaal-brand__text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  text-align: left;
}
.mashaal-brand__title {
  font-weight: 800;
  font-size: 1.25rem;
  color: #101828;
}
.mashaal-brand__subtitle {
  font-weight: 700;
  font-size: 0.8rem;
  color: #101828;
}
.mashaal-brand--on-dark .mashaal-brand__title,
.mashaal-brand--on-dark .mashaal-brand__subtitle {
  color: #ffffff;
}

.school-login-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  background: #ffffff;
}
.school-login-page__back {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.9);
  color: #101828;
  font-weight: 600;
  font-size: 0.85rem;
  text-decoration: none;
  padding: 8px 14px;
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.12);
  transition: background 0.15s ease;
}
.school-login-page__back:hover {
  background: #ffffff;
  color: #14335e;
}
.school-login-page__back i {
  font-size: 0.95rem;
}
.school-login-page__photo {
  display: none;
  background-size: cover;
  background-position: center;
  opacity: 0.55;
}
.school-login-page__form-wrap {
  flex: 1 1 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
}
.school-login-page__form {
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.school-login-page__title {
  font-weight: 700;
  font-size: 1.5rem;
  color: #101828;
  margin-bottom: 6px;
}
.school-login-page__subtitle {
  color: #667085;
  font-size: 0.9rem;
  margin-bottom: 24px;
}
.school-login-page__forgot {
  color: #dc2626;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
}
.school-login-page__forgot:hover {
  text-decoration: underline;
}
.school-login-page__submit {
  background: linear-gradient(90deg, #b91c3c 0%, #1e3a8a 100%);
  border: none;
  font-weight: 700;
  padding: 10px 0;
  border-radius: 8px;
}
.school-login-page__submit:hover, .school-login-page__submit:focus, .school-login-page__submit:active {
  background: linear-gradient(90deg, #a01834 0%, #17307a 100%) !important;
  border: none !important;
}
.school-login-page .school-login-form {
  width: 100%;
  text-align: left;
}
@media (min-width: 768px) {
  .school-login-page__photo {
    display: block;
    flex: 1 1 50%;
    min-height: 100vh;
  }
  .school-login-page__form-wrap {
    flex: 1 1 50%;
  }
}
@media (min-width: 992px) {
  .school-login-page__photo {
    flex-basis: 55%;
  }
  .school-login-page__form-wrap {
    flex-basis: 45%;
  }
}

.button-list {
  margin-left: -8px;
  margin-bottom: -12px;
}
.button-list .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.grid-structure .grid-container {
  background-color: #f8f9fa;
  margin-bottom: 10px;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 10px 20px;
}

.icons-list-demo div.col-sm-6 {
  cursor: pointer;
  line-height: 45px;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}
.icons-list-demo div.col-sm-6 p {
  margin-bottom: 0;
  line-height: inherit;
}
.icons-list-demo i {
  text-align: center;
  vertical-align: middle;
  font-size: 22px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  margin-right: 12px;
  color: #6c757d;
  border-radius: 3px;
  display: inline-block;
  transition: all 0.2s;
}
.icons-list-demo .col-md-4 {
  border-radius: 3px;
  background-clip: padding-box;
  margin-bottom: 10px;
}
.icons-list-demo .col-md-4:hover, .icons-list-demo .col-md-4:hover i {
  color: #5369f8;
}

.icons-list .icon-item {
  padding: 15px 0;
  color: #6c757d;
}
.icons-list .icon-item svg {
  margin-right: 10px;
}
.icons-list .icon-item span {
  line-height: 30px;
  display: inline-block;
  vertical-align: middle;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.text-error {
  color: #5369f8;
  text-shadow: rgba(83, 105, 248, 0.3) 5px 1px, rgba(83, 105, 248, 0.2) 10px 3px;
  font-size: 84px;
  line-height: 90px;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
}

.error-text-box {
  font-size: 10rem;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  min-height: 200px;
}
.error-text-box .text {
  fill: none;
  stroke-width: 6;
  stroke-linejoin: round;
  stroke-dasharray: 30 100;
  stroke-dashoffset: 0;
  animation: stroke 9s infinite linear;
}
.error-text-box .text:nth-child(5n+1) {
  stroke: #ff5c75;
  animation-delay: -1.2s;
}
.error-text-box .text:nth-child(5n+2) {
  stroke: #ffbe0b;
  animation-delay: -2.4s;
}
.error-text-box .text:nth-child(5n+3) {
  stroke: #5369f8;
  animation-delay: -3.6s;
}
.error-text-box .text:nth-child(5n+4) {
  stroke: #25c2e3;
  animation-delay: -4.8s;
}
.error-text-box .text:nth-child(5n+5) {
  stroke: #43d39e;
  animation-delay: -6s;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: -400;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .error-text-box .text {
    fill: #ff5c75;
    stroke: #ff5c75;
    stroke-width: 6;
    stroke-dasharray: 0 0;
    stroke-dashoffset: 0;
    animation: none;
  }
}
.email-container {
  background-color: #fff;
}
.email-container .inbox-leftbar {
  padding: 1.25rem;
  width: 250px;
  float: left;
  padding-bottom: 184px;
  margin-bottom: -184px;
}
.email-container .inbox-rightbar {
  margin-left: 250px;
  border-left: 5px solid #f3f4f7;
  padding: 0 0 1.5rem 25px;
}

.message-list {
  display: block;
  padding-left: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 48px;
  line-height: 48px;
  cursor: default;
  transition-duration: 0.3s;
  background: #fff;
  margin-bottom: 1px;
  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075);
}
.message-list li a {
  color: #4B4B5A;
}
.message-list li:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 320px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 10px 0 20px;
}
.message-list li .col-mail-1 .star-toggle {
  color: #adb5bd;
  margin-left: 10px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 100px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
  line-height: 50px;
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 320px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 100px;
  padding-left: 10px;
}
.message-list li.active,
.message-list li.mail-selected {
  background: #f8f9fa;
  transition-duration: 0.05s;
}
.message-list li.active,
.message-list li.active:hover {
  box-shadow: inset 3px 0 0 #25c2e3;
}
.message-list li.unread a {
  color: rgb(15.9093982421%, 17.7450980392%, 19.5807978364%);
}
.message-list .checkbox-wrapper-mail {
  cursor: pointer;
  height: 20px;
  width: 20px;
  position: relative;
  display: inline-block;
  box-shadow: inset 0 0 0 2px #ced4da;
  border-radius: 3px;
}
.message-list .checkbox-wrapper-mail input {
  opacity: 0;
  cursor: pointer;
}
.message-list .checkbox-wrapper-mail input:checked ~ label {
  opacity: 1;
}
.message-list .checkbox-wrapper-mail label {
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  cursor: pointer;
  background: #6c757d;
  opacity: 0;
  margin-bottom: 0 !important;
  transition-duration: 0.05s;
}
.message-list .checkbox-wrapper-mail label:active {
  background: #87949b;
}

.mail-list a {
  color: #4B4B5A;
  padding: 7px 10px;
  display: block;
}

.reply-box {
  border: 2px solid #f8f9fa;
}

@media (max-width: 648px) {
  .email-container .inbox-leftbar {
    width: 100%;
    float: none;
    margin-bottom: 21px;
    padding-bottom: 1.25rem;
  }
  .email-container .inbox-rightbar {
    margin-left: 0;
    border: 0;
    padding-left: 0;
  }
}
@media (max-width: 520px) {
  .inbox-rightbar > .btn-group {
    margin-bottom: 10px;
  }
  .message-list li .col-mail-1 {
    width: 150px;
  }
  .message-list li .col-mail-1 .title {
    left: 80px;
  }
  .message-list li .col-mail-2 {
    left: 160px;
  }
  .message-list li .col-mail-2 .date {
    text-align: right;
    padding-right: 10px;
    padding-left: 20px;
  }
}
.chatbox {
  position: fixed;
  right: 35px;
  bottom: 10px;
  width: 300px;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 99;
}
.chatbox .chat-input .form-control {
  padding-right: 60px;
}
.chatbox .chat-link {
  position: absolute;
  right: 4px;
  top: 10px;
}

.card-pricing {
  position: relative;
}
.card-pricing .card-pricing-plan-name {
  padding-bottom: 20px;
}
.card-pricing .card-pricing-icon {
  font-size: 22px;
  background-color: rgba(83, 105, 248, 0.1);
  height: 60px;
  display: inline-block;
  width: 60px;
  line-height: 62px;
  border-radius: 50%;
}
.card-pricing .card-pricing-price {
  padding: 30px 0 0;
}
.card-pricing .card-pricing-price span {
  font-size: 40%;
  color: #6c757d;
  letter-spacing: 2px;
  text-transform: uppercase;
}
.card-pricing .card-pricing-features {
  color: #6c757d;
  list-style: none;
  margin: 0;
  padding: 20px 0 0 0;
}
.card-pricing .card-pricing-features li {
  padding: 10px;
}

.card-pricing-recommended {
  background-color: #5369f8;
  color: #fff;
}
.card-pricing-recommended .card-pricing-icon {
  background-color: rgba(255, 255, 255, 0.1);
}
.card-pricing-recommended .card-pricing-features, .card-pricing-recommended .card-pricing-price span {
  color: rgba(255, 255, 255, 0.7);
}

.post-user-comment-box {
  background-color: #f8f9fa;
  margin: 0 -0.75rem;
  padding: 1rem;
  margin-top: 20px;
}

.board {
  display: block;
  white-space: nowrap;
  overflow-x: auto;
}

.tasks {
  display: inline-block;
  width: 22rem;
  padding: 0 1rem 1rem 1rem;
  vertical-align: top;
  margin-bottom: 24px;
  background-color: #fff;
  border-radius: 0.2rem;
}
.tasks.tasks:not(:last-child) {
  margin-right: 1.25rem;
}
.tasks .card {
  white-space: normal;
  margin-top: 1rem;
}
.tasks .task-header {
  background-color: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);
  padding: 1rem;
  margin: 0 -1rem;
  border-radius: 0.2rem;
}

.task-list-items {
  min-height: 100px;
  position: relative;
}
.task-list-items .card {
  cursor: pointer;
}
.task-list-items:before {
  content: "No Tasks";
  position: absolute;
  line-height: 110px;
  width: 100%;
  text-align: center;
  font-weight: 600;
}

.task-modal-content .form-control-light {
  background-color: rgb(99.1176470588%, 99.1176470588%, 99.2156862745%) !important;
  border-color: rgb(99.1176470588%, 99.1176470588%, 99.2156862745%) !important;
}

.gantt-task-details {
  min-width: 220px;
}

.task-search .search-input {
  padding-left: 32px;
  z-index: 10;
}
.task-search .icon-search {
  z-index: 11;
  position: absolute;
  left: 10px;
  top: 10px;
}

/************** Horizontal timeline **************/
.left-timeline .events {
  border-left: 3px solid #e2e7f1;
  padding-left: 35px;
}
.left-timeline .events .event-list {
  position: relative;
}
.left-timeline .events .event-list::before {
  content: "";
  position: absolute;
  left: -45px;
  top: 6px;
  height: 18px;
  width: 18px;
  background-color: #5369f8;
  border-radius: 50%;
  border: 5px solid #fff;
  z-index: 9;
}
.left-timeline .events .event-list::after {
  content: "";
  position: absolute;
  left: -38px;
  top: 14px;
  height: 3px;
  width: 30px;
  background-color: #e2e7f1;
}
.left-timeline .album img {
  height: 36px;
  width: auto;
  border-radius: 4px;
}

.timeline {
  margin-bottom: 50px;
  position: relative;
}
.timeline:before {
  background-color: #e2e7f1;
  bottom: 0;
  content: "";
  left: 50%;
  position: absolute;
  top: 30px;
  width: 2px;
  z-index: 0;
}
.timeline .time-show {
  margin-bottom: 30px;
  margin-top: 30px;
  position: relative;
  text-align: center;
}
.timeline .timeline-box {
  display: block;
  position: relative;
  padding: 20px;
}
.timeline .timeline-album {
  margin-top: 12px;
}
.timeline .timeline-album a {
  display: inline-block;
  margin-right: 5px;
}
.timeline .timeline-album img {
  height: 36px;
  width: auto;
  border-radius: 3px;
}

@media (min-width: 768px) {
  .timeline .time-show {
    right: 69px;
  }
  .timeline .timeline-box {
    margin-left: 15px;
  }
  .timeline .timeline-icon {
    background: #5369f8;
    border-radius: 50%;
    display: block;
    height: 20px;
    left: -24px;
    margin-top: -10px;
    position: absolute;
    text-align: center;
    top: 15%;
    width: 20px;
    border: 5px solid #fff;
    z-index: 9;
  }
  .timeline .timeline-icon:before {
    content: "";
    position: absolute;
    height: 3px;
    width: 19px;
    background-color: #e2e7f1;
    left: 15px;
    top: 3px;
  }
  .timeline .timeline-desk {
    display: table-cell;
    vertical-align: top;
    width: 50%;
  }
  .timeline-item {
    display: flex;
  }
  .timeline-item:before {
    content: "";
    display: block;
    width: 50%;
  }
  .timeline-item.timeline-item-left:after {
    content: "";
    display: block;
    width: 50%;
  }
  .timeline-item.timeline-item-left .timeline-desk .album {
    float: right;
    margin-top: 20px;
  }
  .timeline-item.timeline-item-left .timeline-desk .album a {
    float: right;
    margin-left: 5px;
  }
  .timeline-item.timeline-item-left .timeline-icon {
    left: auto;
    right: -26px;
  }
  .timeline-item.timeline-item-left .timeline-icon:before {
    left: auto;
    right: 15px;
  }
  .timeline-item.timeline-item-left:before {
    display: none;
  }
  .timeline-item.timeline-item-left .timeline-box {
    margin-right: 15px;
    margin-left: 0;
    text-align: right;
  }
}
@media (max-width: 575.98px) {
  .timeline .time-show {
    position: relative;
  }
  .timeline .event-date {
    float: left !important;
    margin-right: 1.5rem;
    margin-left: 0 !important;
  }
  .timeline .timeline-icon {
    display: none;
  }
}
section.bg-body {
  background-color: #ffffff !important;
}

.navbar.nav-sticky {
  background-color: #fff;
}

.section-eyebrow {
  display: block;
  width: 100%;
  text-align: center;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 1.5px;
  color: #f0611b;
  margin: 0 auto 10px;
  text-transform: uppercase;
}

.section-title {
  display: block;
  width: 100%;
  text-align: center;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-weight: 800;
  font-size: 2.4rem;
  color: #101828;
  margin: 0 auto 12px;
  line-height: 1.2;
}
@media (max-width: 576px) {
  .section-title {
    font-size: 1.6rem;
  }
}

.section-subtitle,
.section-description {
  display: block;
  width: 100%;
  max-width: 720px;
  text-align: center;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-weight: 400;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #475467;
  margin: 0 auto 40px;
}
@media (max-width: 576px) {
  .section-subtitle,
  .section-description {
    font-size: 0.88rem;
    margin-bottom: 28px;
  }
}

.visionaries-header,
.sports-categories-header {
  max-width: 720px;
  margin: 0 auto 40px;
  text-align: center;
}

.hero-banner {
  position: relative;
  overflow: hidden;
  height: 420px;
}
.hero-banner .carousel,
.hero-banner .carousel-inner,
.hero-banner .carousel-item {
  height: 100%;
}
.hero-banner__slide {
  height: 100%;
  background-size: cover;
  background-position: center;
}
.hero-banner__slide-img {
  display: none;
}
.hero-banner__overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(100deg, rgba(80, 15, 15, 0.88) 0%, rgba(90, 20, 20, 0.7) 30%, rgba(20, 51, 94, 0.35) 60%, rgba(20, 51, 94, 0.1) 100%);
  pointer-events: none;
}
.hero-banner__content {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  padding: 24px 20px;
  max-width: 640px;
}
.hero-banner__title {
  color: #ffffff;
  font-weight: 800;
  font-size: 1.5rem;
  line-height: 1.25;
  margin-bottom: 10px;
}
.hero-banner__copy {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  margin-bottom: 10px;
}
.hero-banner__stats {
  font-weight: 700;
  font-size: 0.78rem;
  color: #ffd399;
  margin-bottom: 16px;
}
.hero-banner__cta {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  color: #14335e;
  font-weight: 700;
  font-size: 0.8rem;
  text-decoration: none;
  padding: 10px 18px;
  border-radius: 10px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.hero-banner__cta:hover {
  color: #14335e;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}
@media (min-width: 768px) {
  .hero-banner {
    height: 480px;
  }
  .hero-banner__content {
    padding: 40px 48px;
  }
  .hero-banner__title {
    font-size: 2.2rem;
  }
  .hero-banner__copy {
    font-size: 0.95rem;
    margin-bottom: 14px;
  }
  .hero-banner__stats {
    font-size: 0.9rem;
    margin-bottom: 22px;
  }
  .hero-banner__cta {
    font-size: 0.9rem;
    padding: 12px 22px;
  }
}
@media (min-width: 1200px) {
  .hero-banner {
    height: 560px;
  }
  .hero-banner__title {
    font-size: 2.6rem;
  }
}

.notice-marquee {
  display: flex;
  align-items: stretch;
  background: #fff4ea;
  border-bottom: 1px solid #f3d9bd;
}
.notice-marquee__label {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #14335e;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
  padding: 10px 18px;
}
.notice-marquee__label i {
  font-size: 1rem;
  color: #ff8a3d;
}
.notice-marquee__link {
  display: inline-flex;
  text-decoration: none;
  color: inherit;
}
.notice-marquee__item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 40px;
  color: #7a2e10;
  font-weight: 600;
  font-size: 0.85rem;
  white-space: nowrap;
}
.notice-marquee__badge {
  flex-shrink: 0;
  background: #f0611b;
  color: #ffffff;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 4px;
}
@media (max-width: 576px) {
  .notice-marquee__label {
    padding: 8px 12px;
    font-size: 0.78rem;
  }
  .notice-marquee__item {
    font-size: 0.78rem;
    margin-right: 28px;
  }
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: rgba(181, 182, 199, 0.1);
  animation: animate 25s linear infinite;
  bottom: -150px;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0);
    opacity: 1;
    border-radius: 0;
  }
  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}
.fs-44 {
  font-size: 44px;
}

.animate {
  transform: scale(1);
  transition: 0.3s ease-in-out;
}

.animate:hover {
  transform: scale(1.1);
}

.gov-topbar {
  background: linear-gradient(to right, #9e3b32, #14335e);
  padding: 6px 0;
  font-size: 0.85rem;
  color: #ffffff;
}
.gov-topbar .gov-topbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 400;
}
.gov-topbar .gov-topbar-left .gov-hindi {
  font-weight: 600;
}
.gov-topbar .gov-topbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gov-topbar .gov-topbar-right a,
.gov-topbar .gov-topbar-right .gov-lang,
.gov-topbar .gov-topbar-right .gov-accessibility-btn {
  color: #ffffff;
  text-decoration: none;
  white-space: nowrap;
}
.gov-topbar .gov-topbar-right a:hover,
.gov-topbar .gov-topbar-right .gov-lang:hover,
.gov-topbar .gov-topbar-right .gov-accessibility-btn:hover {
  color: #f0f0f0;
  text-decoration: underline;
}
.gov-topbar .gov-topbar-right .gov-accessibility-btn {
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  cursor: pointer;
}
.gov-topbar .gov-topbar-right .gov-divider {
  color: rgba(255, 255, 255, 0.6);
}
.gov-topbar .gov-topbar-right .gov-lang {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}
@media (max-width: 576px) {
  .gov-topbar {
    font-size: 0.7rem;
    padding: 5px 0;
    text-align: center;
  }
  .gov-topbar > .container-fluid, .gov-topbar > .container-sm, .gov-topbar > .container-md, .gov-topbar > .container-lg, .gov-topbar > .container-xl, .gov-topbar > .container-xxl {
    flex-direction: column;
    row-gap: 4px;
  }
  .gov-topbar .gov-topbar-left,
  .gov-topbar .gov-topbar-right {
    justify-content: center;
    width: 100%;
  }
}

.main-navbar {
  background: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}
@media (max-width: 576px) {
  .main-navbar > .container-fluid, .main-navbar > .container-sm, .main-navbar > .container-md, .main-navbar > .container-lg, .main-navbar > .container-xl, .main-navbar > .container-xxl {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
.main-navbar .navbar-brand-logo {
  height: 68px;
  width: auto;
}
@media (max-width: 576px) {
  .main-navbar .navbar-brand-logo {
    height: 50px;
  }
}
.main-navbar .navbar-brand-mashaal {
  gap: 12px;
}
.main-navbar .navbar-brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.main-navbar .navbar-brand-text__title {
  font-weight: 800;
  font-size: 1.5rem;
  color: #101828;
}
.main-navbar .navbar-brand-text__subtitle {
  font-weight: 700;
  font-size: 0.95rem;
  color: #101828;
}
@media (max-width: 576px) {
  .main-navbar .navbar-brand-text__title {
    font-size: 1.1rem;
  }
  .main-navbar .navbar-brand-text__subtitle {
    font-size: 0.72rem;
  }
}
.main-navbar .main-nav-link {
  color: #1a1a1a !important;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.2px;
  padding: 0.5rem 0.9rem !important;
  text-transform: uppercase;
}
.main-navbar .main-nav-link:hover, .main-navbar .main-nav-link:focus {
  color: #14335e !important;
}
.main-navbar .main-nav-link.active {
  color: #14335e !important;
  position: relative;
}
.main-navbar .main-nav-link.active::after {
  content: "";
  position: absolute;
  left: 0.9rem;
  right: 0.9rem;
  bottom: 0.15rem;
  height: 2px;
  background: #f0611b;
  border-radius: 1px;
}
.main-navbar .main-nav-dropdown-toggle {
  color: #1a1a1a;
  font-weight: 600;
  font-size: 0.95rem;
  background: none;
  border: none;
  padding: 0.5rem 0.9rem;
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
}
.main-navbar .main-nav-dropdown-toggle:hover, .main-navbar .main-nav-dropdown-toggle:focus {
  color: #14335e;
}
.main-navbar .main-nav-dropdown-toggle::after {
  display: none;
}
.main-navbar .main-nav-dropdown-toggle--download {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 0.4rem 0.9rem;
  gap: 8px;
}
.main-navbar .main-nav-dropdown-toggle__icon {
  font-size: 1rem;
  color: #f0611b;
}
.main-navbar .main-nav-dropdown-toggle__caret {
  font-size: 1.1rem;
  margin-left: 2px;
  transition: transform 0.15s ease;
}
.main-navbar .main-nav-dropdown-toggle.show .main-navbar .main-nav-dropdown-toggle__caret {
  transform: rotate(180deg);
}
.main-navbar .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}
.main-navbar .dropdown-menu .dropdown-item i {
  color: #14335e;
  font-size: 0.95rem;
}
.main-navbar .navbar-toggler {
  border: none;
  box-shadow: none !important;
  color: #14335e;
}
@media (max-width: 991.98px) {
  .main-navbar .main-nav-link,
  .main-navbar .main-nav-dropdown-toggle {
    padding: 0.6rem 0 !important;
  }
  .main-navbar .main-nav-link.active::after {
    left: 0;
    right: 0;
  }
}

.visionaries-section {
  padding: 60px 0;
}
.visionaries-section .visionaries-header {
  margin-bottom: 40px;
}
.visionaries-section .visionaries-eyebrow {
  display: block;
  color: #14335e;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 1px;
  margin-bottom: 8px;
}
.visionaries-section .visionaries-title {
  font-weight: 800;
  font-size: 2rem;
  color: #101828;
  margin-bottom: 0;
}
.visionaries-section .visionary-card {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
}
.visionaries-section .visionary-card__photo {
  width: 100%;
  height: 260px;
  background-image: linear-gradient(to bottom, #ffffff 0%, #ffffff 45%, var(--visionary-band-color) 45%, var(--visionary-band-color) 100%);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.visionaries-section .visionary-card__photo img {
  max-width: 78%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}
.visionaries-section .visionary-card__info {
  padding: 18px 16px 22px;
  text-align: center;
  background: #ffffff;
}
.visionaries-section .visionary-card__info h3, .visionaries-section .visionary-card__info .h3 {
  font-weight: 700;
  font-size: 1.05rem;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #e8720c;
  margin-bottom: 6px;
}
.visionaries-section .visionary-card__info p {
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: #1f2937;
  margin-bottom: 0;
}
.visionaries-section .visionary-card--peach {
  --visionary-band-color: #fbe3cf;
}
.visionaries-section .visionary-card--blue {
  --visionary-band-color: #dbeafe;
}
.visionaries-section .visionary-card--pink {
  --visionary-band-color: #f6def0;
}
@media (max-width: 991.98px) {
  .visionaries-section .visionary-card__photo {
    height: 230px;
  }
}
@media (max-width: 576px) {
  .visionaries-section {
    padding: 40px 0;
  }
  .visionaries-section .visionaries-title {
    font-size: 1.5rem;
  }
  .visionaries-section .visionary-card {
    max-width: 280px;
  }
  .visionaries-section .visionary-card__photo {
    height: 210px;
  }
  .visionaries-section .visionary-card__info {
    padding: 14px 14px 18px;
  }
  .visionaries-section .visionary-card__info h3, .visionaries-section .visionary-card__info .h3 {
    font-size: 0.95rem;
  }
  .visionaries-section .visionary-card__info p {
    font-size: 0.75rem;
  }
}

.battery-videos-section {
  padding: 60px 0;
}
.battery-videos-section .battery-video-card {
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.08);
}
.battery-videos-section .battery-video-card__player {
  position: absolute;
  inset: 0;
}
.battery-videos-section .battery-video-card__player video,
.battery-videos-section .battery-video-card__player iframe,
.battery-videos-section .battery-video-card__player > div {
  border-radius: 12px;
}
.battery-videos-section .battery-video-card__play {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(20, 51, 90, 0.85);
  color: #ffffff;
  font-size: 1.4rem;
  transition: transform 0.2s ease, background 0.2s ease;
}
.battery-videos-section .battery-video-card__play i {
  margin-left: 3px;
}
.battery-videos-section .battery-video-card:hover .battery-video-card__play {
  background: #e8720c;
  transform: scale(1.08);
}
.battery-videos-section .battery-video-card__label {
  margin: 10px 0 0;
  text-align: center;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1f2937;
}
@media (max-width: 576px) {
  .battery-videos-section {
    padding: 40px 0;
  }
  .battery-videos-section .visionaries-title {
    font-size: 1.5rem;
  }
}

.mashaal-scheme-section {
  padding: 40px 0;
  scroll-margin-top: 140px;
}
@media (max-width: 576px) {
  .mashaal-scheme-section {
    scroll-margin-top: 100px;
  }
}
.mashaal-scheme-section .mashaal-scheme-image {
  border-radius: 20px;
  overflow: hidden;
}
.mashaal-scheme-section .mashaal-scheme-image img {
  display: block;
  width: 100%;
  height: auto;
}
.mashaal-scheme-section .mashaal-scheme-panel {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  background: #0e1f45;
  padding: 36px 24px;
}
@media (min-width: 768px) {
  .mashaal-scheme-section .mashaal-scheme-panel {
    padding: 48px 56px;
  }
}
.mashaal-scheme-section .mashaal-scheme-intro {
  max-width: 780px;
  margin: 0 auto 34px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.mashaal-scheme-section .mashaal-scheme-tag {
  display: inline-block;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 2px;
  color: #ffffff;
  margin-bottom: 12px;
}
.mashaal-scheme-section .mashaal-scheme-heading {
  color: #ffffff;
  font-weight: 800;
  font-size: 2.2rem;
  line-height: 1.15;
  margin-bottom: 14px;
}
.mashaal-scheme-section .mashaal-scheme-heading span {
  color: #ff8a3d;
}
.mashaal-scheme-section .mashaal-scheme-copy {
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.95rem;
  line-height: 1.65;
  margin-bottom: 0;
}
.mashaal-scheme-section .mashaal-scheme-components {
  min-width: 0;
  text-align: center;
}
.mashaal-scheme-section .mashaal-pathway-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #ffffff;
  font-weight: 700;
  font-size: 1.15rem;
  margin-bottom: 30px;
}
.mashaal-scheme-section .mashaal-pathway-title span {
  display: block;
  width: 40px;
  height: 1px;
  background: rgba(255, 138, 61, 0.6);
}
.mashaal-scheme-section .mashaal-pathway {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway {
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    gap: 90px;
  }
}
.mashaal-scheme-section .mashaal-pathway__chain {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__chain {
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    gap: 0;
  }
}
.mashaal-scheme-section .mashaal-pathway__link {
  position: relative;
  text-align: center;
  width: 100%;
  max-width: 260px;
  padding: 20px 18px;
  border-radius: 14px;
  background: linear-gradient(180deg, #1c3b7a 0%, #16305f 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link {
    width: 176px;
    min-height: 240px;
    max-width: none;
    padding: 24px 20px 20px 34px;
    border: none;
    border-radius: 0;
    clip-path: polygon(0 0, calc(100% - 26px) 0, 100% 50%, calc(100% - 26px) 100%, 0 100%, 26px 50%);
    margin-left: -26px;
  }
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link--first {
    padding-left: 20px;
    clip-path: polygon(0 0, calc(100% - 26px) 0, 100% 50%, calc(100% - 26px) 100%, 0 100%);
    margin-left: 0;
    border-radius: 16px 0 0 16px;
  }
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link--last {
    padding-right: 20px;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 26px 50%);
  }
}
.mashaal-scheme-section .mashaal-pathway__link h4, .mashaal-scheme-section .mashaal-pathway__link .h4 {
  color: #ffffff;
  font-weight: 700;
  font-size: 0.85rem;
  margin: 3px 0 12px;
}
.mashaal-scheme-section .mashaal-pathway__link p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.72rem;
  line-height: 1.4;
  margin-bottom: 0;
}
.mashaal-scheme-section .mashaal-pathway__link--1 {
  background: linear-gradient(180deg, #2563eb 0%, #14335e 100%);
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link--1 {
    z-index: 4;
  }
}
.mashaal-scheme-section .mashaal-pathway__link--2 {
  background: linear-gradient(180deg, rgb(34.4117647059%, 38.6274509804%, 71.7647058824%) 0%, rgb(24.9019607843%, 21.3725490196%, 28.8235294118%) 100%);
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link--2 {
    z-index: 3;
  }
}
.mashaal-scheme-section .mashaal-pathway__link--3 {
  background: linear-gradient(180deg, rgb(54.3137254902%, 38.431372549%, 51.3725490196%) 0%, #6b3a35 100%);
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link--3 {
    z-index: 2;
  }
}
.mashaal-scheme-section .mashaal-pathway__link--4 {
  background: linear-gradient(180deg, rgb(74.2156862745%, 38.2352941176%, 30.9803921569%) 0%, rgb(59.0196078431%, 24.1176470588%, 12.7450980392%) 100%);
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link--4 {
    z-index: 1;
  }
}
.mashaal-scheme-section .mashaal-pathway__link--5 {
  background: linear-gradient(180deg, #f0611b 0%, #c2410c 100%);
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__link--5 {
    z-index: 0;
  }
}
.mashaal-scheme-section .mashaal-pathway__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 1.25rem;
  margin: 0 auto 12px;
}
.mashaal-scheme-section .mashaal-pathway__index {
  display: block;
  color: #ff8a3d;
  font-weight: 800;
  font-size: 0.68rem;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  margin-bottom: 4px;
}
.mashaal-scheme-section .mashaal-pathway__arrow {
  display: none;
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    right: -13px;
    transform: translateY(-50%);
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #ff8a3d;
    color: #0a1a3d;
    font-size: 0.9rem;
    z-index: 10;
    box-shadow: 0 0 0 4px #0e1f45;
  }
}
.mashaal-scheme-section .mashaal-pathway__branches {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  max-width: 280px;
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__branches {
    max-width: 240px;
  }
}
.mashaal-scheme-section .mashaal-pathway__branch-trunk {
  display: none;
}
@media (min-width: 992px) {
  .mashaal-scheme-section .mashaal-pathway__branch-trunk {
    display: block;
    position: absolute;
    top: 0;
    left: -90px;
    width: 90px;
    height: 100%;
    pointer-events: none;
  }
  .mashaal-scheme-section .mashaal-pathway__branch-trunk::before, .mashaal-scheme-section .mashaal-pathway__branch-trunk::after {
    content: "";
    position: absolute;
    left: 0;
    width: 55px;
    height: 55px;
    border: 3px solid #f0611b;
    border-right: none;
  }
  .mashaal-scheme-section .mashaal-pathway__branch-trunk::before {
    top: 50%;
    border-bottom: none;
    border-radius: 14px 0 0 0;
    transform: translateY(-100%);
  }
  .mashaal-scheme-section .mashaal-pathway__branch-trunk::after {
    bottom: 50%;
    border-top: none;
    border-radius: 0 0 0 14px;
    transform: translateY(100%);
  }
}
.mashaal-scheme-section .mashaal-pathway__branch-card {
  position: relative;
  text-align: center;
  padding: 18px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 138, 61, 0.4);
}
.mashaal-scheme-section .mashaal-pathway__branch-card h4, .mashaal-scheme-section .mashaal-pathway__branch-card .h4 {
  color: #ffffff;
  font-weight: 700;
  font-size: 0.9rem;
  margin: 4px 0 10px;
}
.mashaal-scheme-section .mashaal-pathway__branch-card p {
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.76rem;
  line-height: 1.5;
  margin-bottom: 0;
}
.mashaal-scheme-section .mashaal-pathway__branch-card .mashaal-pathway__icon {
  background: rgba(240, 97, 27, 0.2);
  color: #ff8a3d;
}
.mashaal-scheme-section .mashaal-pathway-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: rgba(255, 255, 255, 0.55);
  font-weight: 600;
  font-size: 0.78rem;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin: 10px 0 0;
}
.mashaal-scheme-section .mashaal-pathway-footer span {
  display: block;
  width: 40px;
  height: 1px;
  background: rgba(255, 255, 255, 0.25);
}
@media (max-width: 576px) {
  .mashaal-scheme-section {
    padding: 30px 0;
  }
  .mashaal-scheme-section .mashaal-scheme-panel {
    border-radius: 14px;
  }
  .mashaal-scheme-section .mashaal-scheme-heading {
    font-size: 1.8rem;
  }
  .mashaal-scheme-section .mashaal-scheme-copy {
    font-size: 0.88rem;
  }
}

.associations-section {
  padding: 60px 0;
}
.associations-section .associations-header {
  max-width: 720px;
  margin: 0 auto 44px;
}
.associations-section .associations-eyebrow {
  display: block;
  color: #f0611b;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 1px;
  margin-bottom: 10px;
}
.associations-section .associations-title {
  font-weight: 800;
  font-size: 2.4rem;
  color: #101828;
  margin-bottom: 14px;
}
.associations-section .associations-subtitle {
  color: #667085;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 0;
}
.associations-section .associations-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 48px;
}
.associations-section .associations-grid__item {
  flex: 0 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90px;
}
.associations-section .associations-grid__item img {
  max-height: 90px;
  max-width: 200px;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: grayscale(15%);
  transition: filter 0.2s ease, transform 0.2s ease;
}
.associations-section .associations-grid__item img:hover {
  filter: grayscale(0%);
  transform: scale(1.04);
}
@media (max-width: 576px) {
  .associations-section {
    padding: 40px 0;
  }
  .associations-section .associations-title {
    font-size: 1.6rem;
  }
  .associations-section .associations-subtitle {
    font-size: 0.9rem;
  }
  .associations-section .associations-grid {
    gap: 28px;
  }
  .associations-section .associations-grid__item {
    height: 60px;
  }
  .associations-section .associations-grid__item img {
    max-height: 60px;
    max-width: 140px;
  }
}

.our-journey-section {
  padding: 60px 0;
}
.our-journey-section .our-journey-panel {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.06);
  padding: 40px 36px;
}
.our-journey-section .our-journey-header {
  max-width: 640px;
  margin: 0 auto 32px;
}
.our-journey-section .our-journey-eyebrow {
  display: block;
  color: #f0611b;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 1px;
  margin-bottom: 10px;
}
.our-journey-section .our-journey-title {
  font-weight: 800;
  font-size: 2.4rem;
  color: #101828;
  margin-bottom: 10px;
}
.our-journey-section .our-journey-subtitle {
  color: #667085;
  font-size: 0.95rem;
  margin-bottom: 0;
}
.our-journey-section .our-journey-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-bottom: 18px;
}
.our-journey-section .journey-card {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  padding: 20px 22px;
  background: var(--journey-tint);
  border: 1px solid var(--journey-border);
}
.our-journey-section .journey-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: var(--journey-accent);
  font-size: 1.2rem;
  margin-bottom: 14px;
}
.our-journey-section .journey-card__icon--footer {
  background: rgba(255, 255, 255, 0.7);
  color: #6d28d9;
}
.our-journey-section .journey-card__value {
  font-weight: 800;
  font-size: 1.6rem;
  color: var(--journey-accent);
  line-height: 1.2;
}
.our-journey-section .journey-card__label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #344054;
  margin-top: 4px;
}
.our-journey-section .journey-card::after {
  content: "";
  position: absolute;
  left: 22px;
  bottom: 14px;
  width: 26px;
  height: 3px;
  border-radius: 2px;
  background: var(--journey-accent);
}
.our-journey-section .journey-card--blue {
  --journey-tint: #eff6ff;
  --journey-border: #dbeafe;
  --journey-accent: #2563eb;
}
.our-journey-section .journey-card--green {
  --journey-tint: #ecfdf5;
  --journey-border: #d1fae5;
  --journey-accent: #059669;
}
.our-journey-section .journey-card--purple {
  --journey-tint: #f5f3ff;
  --journey-border: #ede9fe;
  --journey-accent: #7c3aed;
}
.our-journey-section .journey-card--amber {
  --journey-tint: #fffbeb;
  --journey-border: #fef3c7;
  --journey-accent: #d97706;
}
.our-journey-section .journey-card--red {
  --journey-tint: #fef2f2;
  --journey-border: #fee2e2;
  --journey-accent: #dc2626;
}
.our-journey-section .journey-card--teal {
  --journey-tint: #f0fdfa;
  --journey-border: #ccfbf1;
  --journey-accent: #0d9488;
}
.our-journey-section .our-journey-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  background: linear-gradient(90deg, #f5f3ff 0%, #ede9fe 100%);
  border: 1px solid #ede9fe;
  border-radius: 14px;
  padding: 22px 26px;
}
.our-journey-section .our-journey-footer__stat {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1 1 200px;
}
.our-journey-section .our-journey-footer__message {
  flex: 1 1 260px;
  text-align: center;
}
.our-journey-section .our-journey-footer__message h4, .our-journey-section .our-journey-footer__message .h4 {
  font-weight: 700;
  font-size: 1rem;
  color: #101828;
  margin-bottom: 4px;
}
.our-journey-section .our-journey-footer__message p {
  font-size: 0.85rem;
  color: #667085;
  margin-bottom: 0;
}
.our-journey-section .our-journey-footer__trend {
  flex: 0 0 auto;
  font-size: 2rem;
  color: #7c3aed;
  opacity: 0.6;
}
@media (max-width: 991.98px) {
  .our-journey-section .our-journey-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 576px) {
  .our-journey-section {
    padding: 40px 0;
  }
  .our-journey-section .our-journey-panel {
    padding: 26px 18px;
    border-radius: 16px;
  }
  .our-journey-section .our-journey-title {
    font-size: 1.5rem;
  }
  .our-journey-section .our-journey-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .our-journey-section .our-journey-footer {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
  .our-journey-section .our-journey-footer__message {
    text-align: left;
  }
  .our-journey-section .our-journey-footer__trend {
    display: none;
  }
}

.sports-categories-section {
  padding: 50px 0;
}

.sports-categories {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 14px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.sports-group {
  flex: 1 1;
  min-width: 150px;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.08);
  background: #ffffff;
}
.sports-group--athletics {
  flex: 2.3 2.3;
  min-width: 400px;
}
.sports-group--cycling {
  flex: 1 1;
  min-width: 200px;
}
.sports-group__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  color: #ffffff;
  font-weight: 800;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.sports-group__header i {
  font-size: 1.1rem;
}
.sports-group__events {
  display: flex;
  flex-wrap: nowrap;
  height: 100%;
}
.sports-group--athletics .sports-group__header {
  background: #14335e;
}
.sports-group--cycling .sports-group__header {
  background: #14532d;
}
.sports-group--kabaddi .sports-group__header {
  background: #c2410c;
}
.sports-group--football .sports-group__header {
  background: #166534;
}
.sports-group--volleyball .sports-group__header {
  background: #5b21b6;
}
.sports-group--athletics .sports-event {
  background: #eaf1fb;
  border-color: #d3e2f5;
}
.sports-group--cycling .sports-event {
  background: #eaf6ee;
  border-color: #d3ecdc;
}
.sports-group--kabaddi .sports-event {
  background: #fdeee3;
  border-color: #fad9c1;
}
.sports-group--football .sports-event {
  background: #eaf6ee;
  border-color: #d3ecdc;
}
.sports-group--volleyball .sports-event {
  background: #f1eafb;
  border-color: #ded0f5;
}

.sports-event {
  flex: 1 1;
  min-width: 78px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 12px 6px 14px;
  border-right: 1px solid;
}
.sports-event:last-child {
  border-right: none;
}
.sports-event__label {
  font-weight: 700;
  font-size: 0.72rem;
  color: #101828;
  min-height: 32px;
}
.sports-event__age {
  display: block;
  font-weight: 600;
  font-size: 0.66rem;
  color: #475467;
}
.sports-event__icon {
  font-size: 1.8rem;
  color: inherit;
  margin: 10px 0;
  line-height: 1;
}
.sports-event__divider {
  display: block;
  width: 70%;
  border-top: 1px dashed #98a2b3;
  margin-bottom: 8px;
}
.sports-event__gender-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 1.1rem;
  margin-bottom: 4px;
}
.sports-event__gender-icons .icofont-male {
  color: #1d4ed8;
}
.sports-event__gender-icons .icofont-female {
  color: #db2777;
}
.sports-event__gender-label {
  font-weight: 600;
  font-size: 0.75rem;
  color: #344054;
}

.sports-group--athletics .sports-event__icon {
  color: #14335e;
}

.sports-group--cycling .sports-event__icon {
  color: #14532d;
}

.sports-group--kabaddi .sports-event__icon {
  color: #c2410c;
}

.sports-group--football .sports-event__icon {
  color: #166534;
}

.sports-group--volleyball .sports-event__icon {
  color: #5b21b6;
}

@media (min-width: 992px) {
  .sports-categories {
    overflow-x: visible;
  }
  .sports-group {
    min-width: 0;
  }
  .sports-group--athletics {
    min-width: 0;
  }
  .sports-group--cycling {
    min-width: 0;
  }
  .sports-group__header {
    padding: 14px 12px;
    font-size: 1rem;
  }
  .sports-group__header i {
    font-size: 1.3rem;
  }
  .sports-event {
    min-width: 0;
    padding: 16px 10px 18px;
  }
  .sports-event__label {
    font-size: 0.85rem;
    min-height: 40px;
  }
  .sports-event__age {
    font-size: 0.78rem;
  }
  .sports-event__icon {
    font-size: 2.6rem;
    margin: 14px 0;
  }
}
/* ==========================================================================
   Mashaal Modern Responsive Footer
   ========================================================================== */
.mashaal-footer {
  background-color: #0b1325;
  padding: 48px 0 24px 0;
  color: #cbd5e1;
  position: relative;
  z-index: 10;
}
.mashaal-footer__widgets {
  row-gap: 24px;
  align-items: flex-start;
}
.mashaal-footer__col--brand {
  display: flex;
  flex-direction: column;
}
@media (min-width: 992px) {
  .mashaal-footer__col--links {
    padding-left: 2rem;
  }
}
@media (min-width: 992px) {
  .mashaal-footer__col--helpdesk {
    padding-left: 1rem;
  }
}
.mashaal-footer__brand-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.mashaal-footer__mascot {
  height: 84px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
}
.mashaal-footer__brand-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.mashaal-footer__brand-title {
  color: #ffffff;
  font-size: 1.32rem;
  font-weight: 800;
  line-height: 1.15;
  margin: 0 0 3px 0;
  letter-spacing: -0.2px;
}
.mashaal-footer__brand-subtitle {
  color: #ffffff;
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  opacity: 0.95;
}
.mashaal-footer__brand-desc {
  color: #94a3b8;
  font-size: 0.85rem;
  line-height: 1.55;
  margin: 0;
  max-width: 320px;
}
.mashaal-footer__title {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  letter-spacing: 0.2px;
}
.mashaal-footer__list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.mashaal-footer__item {
  margin-bottom: 8px;
  font-size: 0.85rem;
  line-height: 1.45;
}
.mashaal-footer__item:last-child {
  margin-bottom: 0;
}
.mashaal-footer__item--info {
  margin-top: 10px;
  margin-bottom: 2px;
}
.mashaal-footer__text {
  color: #94a3b8;
  display: inline-block;
}
.mashaal-footer__link {
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.2s ease;
  display: inline-block;
}
.mashaal-footer__link:hover {
  color: #ff8a3d;
}
.mashaal-footer__helpdesk-link {
  color: #ffffff;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.2s ease;
}
.mashaal-footer__helpdesk-link:hover {
  color: #ff8a3d;
}
.mashaal-footer__divider {
  height: 1px;
  width: 100%;
  background: linear-gradient(90deg, #1e40af 0%, #2563eb 20%, #3b82f6 50%, #2563eb 80%, #1e40af 100%);
  box-shadow: 0 0 10px rgba(37, 99, 235, 0.6), 0 0 3px rgba(59, 130, 246, 0.9);
  margin: 36px 0 20px 0;
}
.mashaal-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.82rem;
  color: #94a3b8;
}
.mashaal-footer__copyright {
  margin: 0;
  color: #94a3b8;
  font-size: 0.82rem;
}
.mashaal-footer__privacy {
  color: #94a3b8;
  font-size: 0.82rem;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: color 0.2s ease;
}
.mashaal-footer__privacy:hover {
  color: #ffffff;
}

@media (max-width: 767.98px) {
  .mashaal-footer {
    padding: 36px 0 24px 0;
  }
  .mashaal-footer__col--brand {
    margin-bottom: 8px;
  }
  .mashaal-footer__brand-desc {
    max-width: 100%;
  }
  .mashaal-footer__divider {
    margin: 28px 0 18px 0;
  }
  .mashaal-footer__bottom {
    flex-direction: column;
    text-align: center;
    gap: 6px;
    justify-content: center;
  }
  .mashaal-footer__copyright {
    text-align: center;
  }
  .mashaal-footer__privacy {
    text-align: center;
  }
}
.crc-list-page {
  background: #f2f4f7;
  padding: 32px 0 60px;
  min-height: 60vh;
}

.crc-list-header {
  margin-bottom: 20px;
}
.crc-list-header h5, .crc-list-header .h5 {
  font-weight: 700;
  font-size: 1.15rem;
  color: #101828;
  margin-bottom: 2px;
}
.crc-list-header p {
  color: #667085;
  font-size: 0.9rem;
  margin-bottom: 0;
}

.crc-list-filters {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);
  padding: 16px;
  margin-bottom: 20px;
  align-items: center;
}
.crc-list-filters .crc-list-select__control {
  min-height: 38px;
  border-color: #ced4da;
  border-radius: 0.375rem;
}
.crc-list-filters .crc-list-select__control--is-focused {
  border-color: #86b7fe !important;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
}
.crc-list-filters .crc-list-select__menu {
  z-index: 5;
}

.crc-list-error {
  background: #fef3f2;
  color: #b42318;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 0.85rem;
  margin-bottom: 16px;
}

.crc-list-table-wrap {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);
  overflow-x: auto;
}

.crc-list-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}
.crc-list-table th,
.crc-list-table td {
  padding: 12px 16px;
  text-align: left;
  white-space: nowrap;
}
.crc-list-table thead th {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #667085;
  border-bottom: 1px solid #eaecf0;
}
.crc-list-table tbody tr {
  border-bottom: 1px solid #f2f4f7;
}
.crc-list-table tbody tr:last-child {
  border-bottom: none;
}
.crc-list-table__empty {
  text-align: center;
  color: #667085;
  padding: 32px 16px;
  white-space: normal;
}

.crc-list-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
}
.crc-list-pagination__meta {
  color: #667085;
  font-size: 0.85rem;
}
.crc-list-pagination__controls {
  display: flex;
  align-items: center;
  gap: 10px;
}
.crc-list-pagination__page {
  color: #101828;
  font-size: 0.85rem;
  font-weight: 600;
}
.crc-list-pagination button {
  border: 1px solid #d0d5dd;
  background: #ffffff;
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 0.85rem;
  color: #101828;
}
.crc-list-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.crc-list-pagination button:not(:disabled):hover {
  background: #f2f4f7;
}

@media (max-width: 768px) {
  .crc-list-filters {
    grid-template-columns: 1fr;
  }
  .crc-list-pagination {
    flex-direction: column;
    align-items: stretch;
  }
  .crc-list-pagination__controls {
    justify-content: space-between;
  }
}
.coordinator-trainer-page {
  background: #f4f6fa;
  padding: 30px 0 60px;
  min-height: 75vh;
}

.coordinator-trainer-hero {
  background: linear-gradient(135deg, #0f2b4c 0%, #173f6e 100%);
  border-radius: 16px;
  padding: 24px 28px;
  color: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 43, 76, 0.16);
}
.coordinator-trainer-hero .badge-official {
  background: #f0611b;
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.coordinator-trainer-hero .badge-ref-date {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 20px;
  backdrop-filter: blur(4px);
}
.coordinator-trainer-hero .coordinator-trainer-title {
  font-size: 1.55rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 6px;
  letter-spacing: -0.01em;
}
.coordinator-trainer-hero .coordinator-trainer-subtitle {
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.82);
  margin-bottom: 0;
  max-width: 600px;
}

.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills {
  background: #ffffff;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid #eaecf0;
  display: inline-flex;
  gap: 6px;
  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.04);
}
.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn {
  border-radius: 8px;
  padding: 10px 22px;
  font-weight: 700;
  font-size: 0.92rem;
  color: #475467;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}
.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn i {
  font-size: 1.15rem;
}
.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn:hover {
  color: #14335e;
  background: #f8fafc;
}
.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn.active {
  background: #14335e !important;
  color: #ffffff !important;
  box-shadow: 0 3px 8px rgba(20, 51, 94, 0.25);
}

.coordinator-content-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #eaecf0;
}
.coordinator-content-card .empty-state-icon-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #f0f4fa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coordinator-content-card .empty-state-icon-circle i {
  font-size: 2.2rem;
  color: #14335e;
}

@media (max-width: 575.98px) {
  .coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills {
    width: 100%;
    flex-direction: column;
  }
  .coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn {
    width: 100%;
    justify-content: center;
  }
}
.tab-count-badge {
  background: rgba(20, 51, 94, 0.12);
  color: #14335e;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 12px;
}

.coordinator-tab-btn.active .tab-count-badge {
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

.coordinator-search-card {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #eaecf0;
}
.coordinator-search-card .search-label {
  font-size: 0.84rem;
  margin-bottom: 6px;
  color: #344054;
}
.coordinator-search-card .search-select,
.coordinator-search-card .search-input-control {
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  font-size: 0.88rem;
  height: 40px;
}
.coordinator-search-card .search-select:focus,
.coordinator-search-card .search-input-control:focus {
  border-color: #14335e;
  box-shadow: 0 0 0 3px rgba(20, 51, 94, 0.12) !important;
}
.coordinator-search-card .btn-coordinator-search {
  background: #14335e;
  border-color: #14335e;
  height: 40px;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}
.coordinator-search-card .btn-coordinator-search:hover {
  background: #0f2747;
  border-color: #0f2747;
  transform: translateY(-1px);
}
.coordinator-search-card .btn-coordinator-reset {
  height: 40px;
  border-radius: 8px;
  font-size: 0.9rem;
}
.coordinator-search-card .results-count-text {
  font-size: 0.86rem;
}
.coordinator-search-card .results-count-text strong {
  color: #101828;
}
.coordinator-search-card .active-filter-indicator {
  font-size: 0.84rem;
  color: #14335e;
  background: #eff4fb;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #d6e4f7;
}

.coordinator-table-card {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #eaecf0;
  overflow: hidden;
}

.coordinator-main-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
  margin-bottom: 0;
}
.coordinator-main-table thead th {
  background: #f8fafc;
  color: #344054;
  font-weight: 700;
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 13px 16px;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
  vertical-align: middle;
}
.coordinator-main-table thead th.th-sr-no {
  width: 70px;
}
.coordinator-main-table thead th.th-districts {
  min-width: 200px;
}
.coordinator-main-table thead th.th-person {
  min-width: 200px;
}
.coordinator-main-table thead th.th-mobile {
  min-width: 170px;
}
.coordinator-main-table thead th.th-action {
  width: 110px;
}
.coordinator-main-table tbody tr.coordinator-row {
  border-bottom: 1px solid #f2f4f7;
  transition: background-color 0.15s ease;
}
.coordinator-main-table tbody tr.coordinator-row:last-child {
  border-bottom: none;
}
.coordinator-main-table tbody tr.coordinator-row:hover {
  background-color: #f8faff;
}
.coordinator-main-table tbody tr.coordinator-row td {
  padding: 13px 16px;
  vertical-align: middle;
}
.coordinator-main-table tbody tr.coordinator-row .sr-no-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f0f4fa;
  color: #14335e;
  font-weight: 700;
  font-size: 0.8rem;
}
.coordinator-main-table tbody tr.coordinator-row .district-tag {
  display: inline-flex;
  align-items: center;
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.82rem;
  font-weight: 600;
}
.coordinator-main-table tbody tr.coordinator-row .district-tag i {
  font-size: 0.85rem;
  color: #22c55e;
}
.coordinator-main-table tbody tr.coordinator-row .person-avatar-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #eff6ff;
  color: #1d4ed8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
}
.coordinator-main-table tbody tr.coordinator-row .person-avatar-circle--trainer {
  background: #fef3c7;
  color: #b45309;
}
.coordinator-main-table tbody tr.coordinator-row .person-name {
  font-weight: 700;
  color: #101828;
  font-size: 0.9rem;
}
.coordinator-main-table tbody tr.coordinator-row .mobile-link {
  display: inline-flex;
  align-items: center;
  color: #14335e;
  font-weight: 600;
  font-size: 0.88rem;
  text-decoration: none;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.15s ease;
}
.coordinator-main-table tbody tr.coordinator-row .mobile-link i {
  color: #f0611b;
  font-size: 0.95rem;
}
.coordinator-main-table tbody tr.coordinator-row .mobile-link:hover {
  background: #f0f4fa;
  color: #f0611b;
}
.coordinator-main-table tbody tr.coordinator-row .btn-call-now {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 4px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}
.coordinator-main-table tbody tr.coordinator-row .btn-call-now i {
  font-size: 0.85rem;
}
.coordinator-main-table tbody tr.coordinator-row .btn-call-now:hover {
  background: #16a34a;
  color: #ffffff;
  border-color: #16a34a;
  transform: translateY(-1px);
}
.coordinator-main-table tbody tr.coordinator-row .btn-whatsapp-now {
  background: #25d366;
  color: #ffffff;
  border: 1px solid #22c55e;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 4px 10px;
  border-radius: 6px;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.coordinator-main-table tbody tr.coordinator-row .btn-whatsapp-now i {
  font-size: 0.95rem;
}
.coordinator-main-table tbody tr.coordinator-row .btn-whatsapp-now:hover {
  background: #1da851;
  color: #ffffff;
  border-color: #1da851;
  transform: translateY(-1px);
}
.coordinator-main-table .table-no-results {
  padding: 40px 20px;
}
.coordinator-main-table .table-no-results .empty-icon {
  font-size: 2.8rem;
}

.coordinator-footer-note {
  font-size: 0.85rem;
  line-height: 1.5;
}

.file-search .search-input {
  background-color: #f8f9fa;
  padding-left: 40px;
}
.file-search .icon-search {
  z-index: 9;
  position: absolute;
}

@media (max-width: 768px) {
  .recent-data {
    margin-left: 0px !important;
    padding: 0px !important;
  }
}
/* Search */
.chat-search {
  height: 70px;
  display: table;
  width: 100%;
}
.chat-search .chat-search-box {
  display: table-cell;
  vertical-align: middle;
  position: relative;
}
.chat-search .form-control {
  padding: 0;
  box-shadow: none;
  background-color: #f1f3fa !important;
  border-color: #f1f3fa !important;
}
.chat-search .form-control::placeholder {
  color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%);
}
.chat-search .btn {
  box-shadow: none !important;
  background-color: #f1f3fa;
  color: #6c757d;
}

.user-status {
  position: absolute;
  height: 11px;
  width: 11px;
  background-color: #ced4da;
  border: 2.5px solid #fff;
  border-radius: 50%;
  bottom: 0;
  left: 35px;
}

.video-call {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 450px;
  position: relative;
}
.video-call .video-call-head img {
  height: 4rem;
  width: 4rem;
}
.video-call .video-call-action {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  padding: 60px 0 16px;
  background: linear-gradient(to top, #000 0, rgba(0, 0, 0, 0) 90%);
}

.voice-call {
  height: 450px;
  position: relative;
}
.voice-call .voice-call-head img {
  width: 6rem;
  height: 6rem;
}
.voice-call .voice-call-action {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
}

.conversation-list {
  list-style: none;
  padding: 0 15px;
  outline: none;
}
.conversation-list li {
  margin-bottom: 20px;
}
.conversation-list li .conversation-actions {
  display: none;
}
.conversation-list li:hover .conversation-actions {
  display: block;
}
.conversation-list .ctext-wrap {
  background: #f1f3fa;
  color: #6c757d;
  border-radius: 3px;
  display: inline-block;
  padding: 7px 12px;
  position: relative;
}
.conversation-list .ctext-wrap i {
  display: block;
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  position: relative;
}
.conversation-list .ctext-wrap p {
  margin: 0;
  padding: 0;
}
.conversation-list .ctext-wrap:after {
  left: -11px;
  top: 0;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-width: 6px;
  margin-right: -1px;
}
.conversation-list .conversation-text {
  float: left;
  font-size: 13px;
  margin-left: 12px;
  width: 80%;
}
.conversation-list .odd .conversation-text {
  float: right !important;
  text-align: right !important;
  width: 70% !important;
}
.conversation-list .odd .ctext-wrap {
  background-color: #fef5e4;
  color: #4B4B5A;
}
.conversation-list .odd .ctext-wrap:after {
  border-color: transparent;
  right: -10px;
  left: auto;
}

.dash-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}
.dash-stats-grid .dash-stat-tile .card {
  height: 100%;
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif !important;
  font-weight: 700;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip-title,
.apexcharts-tooltip-text,
.apexcharts-legend-text {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif !important;
}

.apexcharts-legend-series {
  font-weight: 700;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: #f9f9fd;
}

.apexcharts-legend-text {
  color: #6c757d !important;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif !important;
  fill: #6c757d;
  font-weight: 700;
}

.apexcharts-point-annotations text,
.apexcharts-xaxis-annotations text,
.apexcharts-yaxis-annotations text {
  fill: #6c757d;
}

.apexcharts-radar-series polygon {
  fill: transparent;
  stroke: #e2e7f1;
}
.apexcharts-radar-series line {
  stroke: #e2e7f1;
}

.apexcharts-plot-series .apexcharts-datalabel {
  fill: #fff !important;
}

.apexcharts-datalabels-group text {
  fill: #6c757d !important;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif !important;
}

.scatter-images-chart .apexcharts-legend {
  overflow: hidden !important;
  min-height: 17px;
}
.scatter-images-chart .apexcharts-legend-marker {
  background: none !important;
  margin-right: 7px !important;
}
.scatter-images-chart .apexcharts-legend-series {
  align-items: flex-start !important;
}

.apexcharts-pie-series path {
  stroke: transparent !important;
}

.apexcharts-track path {
  stroke: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);
}

.apexcharts-xaxis line {
  stroke: #ced4da !important;
}

.apex-charts .apexcharts-title-text {
  fill: #343a40;
}
.apex-charts .apexcharts-subtitle-text {
  fill: rgb(61.0588235294%, 63.8823529412%, 66.7058823529%);
  font-weight: 400;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-view-container .table-bordered th,
.fc-view-container .table-bordered td, .fc-view-harness .table-bordered th,
.fc-view-harness .table-bordered td {
  border: 1px solid #e2e7f1;
}
.fc-view-container .fc-popover, .fc-view-harness .fc-popover {
  z-index: 1000 !important;
  background-color: #f8f9fa;
}

.fc-view {
  margin-top: 30px !important;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-toolbar {
  margin: 10px 0 5px 0 !important;
}
.fc-toolbar h2, .fc-toolbar .h2 {
  font-size: 1.25rem !important;
  line-height: 1.875rem !important;
  text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
  font-weight: 500;
}

th.fc-day-header, th.fc-col-header-cell {
  padding: 0.5rem 0 !important;
}

.fc-day {
  background: transparent;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}

.fc th.fc-widget-header {
  background: #e2e7f1;
  font-size: 13px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 500;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #e2e7f1;
}
.fc-unthemed td.fc-today,
.fc-unthemed .fc-divider {
  background: #e2e7f1;
}

.fc-button {
  background: #e2e7f1;
  border: none;
  color: #4B4B5A;
  text-transform: capitalize;
  box-shadow: none;
  border-radius: 3px;
  margin: 0 3px;
  padding: 6px 12px;
  height: auto;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 1rem;
}

.fc-state-hover,
.fc-state-highlight,
.fc-cell-overlay {
  background: #e2e7f1;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #5369f8;
  color: #fff;
  text-shadow: none;
}

.fc-unthemed .fc-today {
  background: #fff;
}

.fc-event {
  border-radius: 2px !important;
  border: none !important;
  cursor: move;
  font-size: 0.8125rem !important;
  margin: 5px 7px;
  padding: 5px 5px !important;
  text-align: center;
}

.external-event {
  cursor: move;
  margin: 10px 0;
  padding: 8px 10px;
  color: #fff;
  border-radius: 4px;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
}
.fc-basic-view td.fc-day-number {
  padding-right: 8px;
}
.fc-basic-view .fc-content {
  color: #fff;
}

.fc-time-grid-event .fc-content {
  color: #fff;
}

.fc-content-skeleton .fc-day-top .fc-day-number {
  float: right;
  height: 20px;
  width: 20px;
  text-align: center;
  line-height: 20px;
  background-color: #f8f9fa;
  border-radius: 50%;
  margin: 5px;
  font-size: 11px;
}

@media (max-width: 767.98px) {
  .fc-toolbar {
    display: block !important;
  }
  .fc-toolbar .fc-left,
  .fc-toolbar .fc-right,
  .fc-toolbar .fc-center {
    text-align: left;
    float: none;
    display: block;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc-today-button {
    display: none;
  }
}
.fc-toolbar .btn {
  padding: 0.28rem 0.8rem;
  font-size: 0.7875rem;
  border-radius: 0.25rem;
}

.fc-list-item-title,
.fc-list-item-time {
  color: #fff;
}

[dir=rtl] .fc-toolbar .btn-group .btn:first-child {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-radius: 0.25rem;
}
[dir=rtl] .fc-toolbar .btn-group .btn:last-child {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-radius: 0.25rem;
}

.fc-list-table .fc-list-day th, .fc-list-table .fc-list-day td, .fc-list-table .fc-list-event th, .fc-list-table .fc-list-event td {
  padding: 0.85rem 0.85rem !important;
}
.fc-list-table .fc-list-day th, .fc-list-table .fc-list-day td {
  background: transparent !important;
}
.fc-list-table .fc-list-event:hover td, .fc-list-table .fc-list-event:hover th {
  background-color: inherit !important;
}
.fc-list-table .fc-list-event td, .fc-list-table .fc-list-event th {
  color: #fff !important;
}

.fc-daygrid-event {
  color: #fff !important;
}

.sp-container {
  background-color: #fff;
  z-index: 9;
}
.sp-container button {
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: 0.2rem;
  font-weight: 400;
  color: #343a40;
}
.sp-container button.sp-palette-toggle {
  background-color: #f8f9fa;
}
.sp-container button.sp-choose {
  background-color: #43d39e;
  margin-left: 5px;
  margin-right: 0;
}

.sp-palette-container {
  border-right: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);
}

.sp-input {
  background-color: #fff;
  border-color: #ced4da !important;
  color: #4B4B5A;
}
.sp-input:focus {
  outline: none;
}

[dir=rtl] .sp-alpha {
  direction: ltr;
}
[dir=rtl] .sp-original-input-container .sp-add-on {
  border: none;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}
[dir=rtl] input.spectrum.with-add-on {
  border: 1px solid #ced4da;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.sp-original-input-container .sp-add-on {
  border: none !important;
}

.jqstooltip {
  box-sizing: content-box;
  width: auto !important;
  height: auto !important;
  background-color: #fff !important;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  padding: 5px 10px !important;
  border-radius: 3px;
  border-color: #fff !important;
}

.jqsfield {
  color: #000 !important;
  font-size: 12px !important;
  line-height: 18px !important;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif !important;
  font-weight: 700 !important;
}

.dataTables_wrapper.container-fluid, .dataTables_wrapper.container-sm, .dataTables_wrapper.container-md, .dataTables_wrapper.container-lg, .dataTables_wrapper.container-xl, .dataTables_wrapper.container-xxl {
  padding: 0;
}

table.dataTable {
  border-collapse: collapse !important;
  margin-bottom: 15px !important;
}
table.dataTable tbody > tr.selected,
table.dataTable tbody > tr > .selected {
  background-color: #5369f8;
}
table.dataTable tbody > tr.selected td,
table.dataTable tbody > tr > .selected td {
  border-color: #5369f8;
}
table.dataTable tbody td:focus {
  outline: none !important;
}
table.dataTable tbody th.focus, table.dataTable tbody td.focus {
  outline: 2px solid #5369f8 !important;
  outline-offset: -1px;
  color: #5369f8;
  background-color: rgba(83, 105, 248, 0.15);
}
table.dataTable thead .sorting::before,
table.dataTable thead .sorting_asc::before,
table.dataTable thead .sorting_desc::before,
table.dataTable thead .sorting_asc_disabled::before,
table.dataTable thead .sorting_desc_disabled::before {
  right: 1em;
  left: auto;
  content: "↑";
}
table.dataTable thead .sorting::after,
table.dataTable thead .sorting_asc::after,
table.dataTable thead .sorting_desc::after,
table.dataTable thead .sorting_asc_disabled::after,
table.dataTable thead .sorting_desc_disabled::after {
  right: 0.5em;
  left: auto;
  content: "↓";
}
table.dataTable thead > tr > th.sorting, table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc {
  padding-right: 30px;
  padding-left: 0.85rem;
}

.dataTables_info {
  font-weight: 600;
}

table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  background-color: #43d39e;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  background-color: #ff5c75;
}

div.dt-button-info {
  background-color: #5369f8;
  border: none;
  color: #fff;
  box-shadow: none;
  border-radius: 3px;
  text-align: center;
  z-index: 21;
}
div.dt-button-info h2, div.dt-button-info .h2 {
  border-bottom: none;
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

@media (max-width: 575.98px) {
  li.paginate_button.previous, li.paginate_button.next {
    display: inline-block;
    font-size: 1.5rem;
  }
  li.paginate_button {
    display: none;
  }
  .dataTables_paginate ul {
    text-align: center;
    display: block;
    margin: 1.5rem 0 0 !important;
  }
  div.dt-buttons {
    display: inline-table;
    margin-bottom: 1.5rem;
  }
}
.activate-select .sorting_1 {
  background-color: #f8f9fa;
}

.dataTables_filter {
  text-align: right;
}
.dataTables_filter input {
  margin-left: 0.5em;
  margin-right: 0 !important;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -8px;
  position: absolute;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
  border-bottom-color: rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: #6c757d;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: 0px;
  border-bottom-color: #fff;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -8px;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-bottom: none;
  border-top-color: #6c757d;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: 0px;
  border-top-color: #fff;
}

.react-datepicker-wrapper {
  display: block;
}

.react-datepicker {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-size: 0.875rem;
  background-color: #fff;
  color: #6c757d;
  border: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
  border-radius: 0.3rem;
  display: inline-block;
  position: relative;
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}
.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}
.react-datepicker--time-only .react-datepicker__time {
  border-radius: 0.3rem;
}
.react-datepicker--time-only .react-datepicker__time-box {
  border-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 1;
}
.react-datepicker-popper[data-placement^=bottom] {
  padding-top: 10px;
}
.react-datepicker-popper[data-placement^=top] {
  padding-bottom: 10px;
}
.react-datepicker-popper[data-placement^=right] {
  padding-left: 8px;
}
.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}
.react-datepicker-popper[data-placement^=left] {
  padding-right: 8px;
}
.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  padding-top: 8px;
  position: relative;
}
.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
  color: #6c757d;
  font-weight: bold;
  font-size: 0.875rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  line-height: 2rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 10px;
  width: 0;
  padding: 0;
  border: 0.45rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
}
.react-datepicker__navigation--previous {
  left: 10px;
  border-right-color: #6c757d;
}
.react-datepicker__navigation--previous:hover {
  border-right-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);
  cursor: default;
}
.react-datepicker__navigation--next {
  right: 10px;
  border-left-color: #6c757d;
}
.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 80px;
}
.react-datepicker__navigation--next:hover {
  border-left-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);
  cursor: default;
}
.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #6c757d;
}
.react-datepicker__navigation--years-previous:hover {
  border-top-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #6c757d;
}
.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}
.react-datepicker__month .react-datepicker__month-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__input-time-container {
  clear: both;
  width: 100%;
  float: left;
  margin: 5px 0 10px 15px;
  text-align: left;
}
.react-datepicker__input-time-container .react-datepicker-time__caption {
  display: inline-block;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: inline-block;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  display: inline-block;
  margin-left: 10px;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: 85px;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {
  -moz-appearance: textfield;
}
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
  margin-left: 5px;
  display: inline-block;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
  width: 100px;
}
.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -72px;
  top: 0;
}
.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: #fff;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 100px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + 2rem * 0.5);
  overflow-y: scroll;
  padding-right: 0px;
  padding-left: 0px;
  width: 100%;
  box-sizing: content-box;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 30px;
  padding: 5px 10px;
  outline: none !important;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #fff;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #5369f8;
  color: white;
  font-weight: bold;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #5369f8;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #6c757d;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #6c757d;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.3rem;
  background-color: #fff;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #6c757d;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range {
  border-radius: 0.3rem;
  background-color: #5369f8;
  color: #fff;
}
.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover {
  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);
}
.react-datepicker__month--disabled {
  color: #6c757d;
  pointer-events: none;
}
.react-datepicker__month--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__day,
.react-datepicker__month-text {
  cursor: pointer;
}
.react-datepicker__day:hover,
.react-datepicker__month-text:hover {
  border-radius: 0.3rem;
  background-color: #5369f8;
  color: #fff !important;
}
.react-datepicker__day--today,
.react-datepicker__month-text--today {
  font-weight: bold;
}
.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted {
  border-radius: 0.3rem;
  background-color: #5369f8;
  color: #fff;
}
.react-datepicker__day--highlighted:hover,
.react-datepicker__month-text--highlighted:hover {
  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);
}
.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1 {
  color: magenta;
}
.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2 {
  color: green;
}
.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range {
  border-radius: 0.3rem;
  background-color: #5369f8;
  color: #fff;
}
.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover {
  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);
}
.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected {
  border-radius: 0.3rem;
  background-color: rgb(51.7668967028%, 57.9362471245%, 98.0370248658%);
  color: #fff;
}
.react-datepicker__day--keyboard-selected:hover,
.react-datepicker__month-text--keyboard-selected:hover {
  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range) {
  background-color: rgba(83, 105, 248, 0.5);
}
.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range) {
  background-color: #fff;
  color: #6c757d;
}
.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled {
  cursor: default;
  color: #6c757d;
}
.react-datepicker__day--disabled:hover,
.react-datepicker__month-text--disabled:hover {
  background-color: transparent;
}

.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover {
  background-color: #5369f8;
}
.react-datepicker__month-text:hover {
  background-color: #fff;
}

.react-datepicker__input-container {
  position: relative;
  display: block;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
}
.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #6c757d;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.45rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #fff;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
}
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}
.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #6c757d;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  vertical-align: middle;
  position: absolute;
  height: 16px;
  width: 16px;
  top: 25%;
  right: 7px;
}
.react-datepicker__close-icon::after {
  background-color: #5369f8;
  border-radius: 50%;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  content: "×";
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 1;
  margin: -8px auto 0;
  padding: 2px;
  position: absolute;
  right: 0px;
  text-align: center;
}

.react-datepicker__today-button {
  background: #fff;
  border-top: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}
.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}
@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.575rem;
}
.react-datepicker__portal .react-datepicker__navigation {
  border: 0.81rem solid transparent;
}
.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #6c757d;
}
.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);
  cursor: default;
}
.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #6c757d;
}
.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);
}
.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);
  cursor: default;
}

.react-datepicker__day:focus {
  outline: none !important;
}

.calendar-widget > div {
  width: 100%;
}
.calendar-widget .react-datepicker {
  width: 100%;
}
.calendar-widget .react-datepicker .react-datepicker__month-container {
  width: 100%;
}
.calendar-widget .react-datepicker .react-datepicker__month-container .react-datepicker__current-month {
  font-size: 1.1rem;
}
.calendar-widget .react-datepicker .react-datepicker__month-container .react-datepicker__day-names,
.calendar-widget .react-datepicker .react-datepicker__month-container .react-datepicker__week {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 52px;
}

.sw-main {
  box-shadow: none;
  border: 1px solid rgb(85.9297765618%, 88.3556771546%, 93.2074783402%);
}
.sw-main .sw-toolbar {
  background: transparent;
  padding: 10px;
}
.sw-main .step-content {
  background-color: transparent !important;
  text-align: left;
}

.sw-theme-default .step-content {
  background-color: transparent;
}
.sw-theme-default > ul.step-anchor > li > a {
  color: #6c757d;
}
.sw-theme-default > ul.step-anchor > li > a:hover {
  color: #6c757d;
}
.sw-theme-default > ul.step-anchor > li > a:after {
  background: #5369f8;
}
.sw-theme-default > ul.step-anchor > li.active > a {
  color: #5369f8 !important;
}
.sw-theme-default > ul.step-anchor > li.done > a {
  color: #6c757d !important;
}
.sw-theme-default > ul.step-anchor > li.done > a:after {
  background: #43d39e;
}

.sw-theme-arrows > ul.step-anchor {
  background: #e2e7f1;
  border-bottom-color: #e2e7f1;
}
.sw-theme-arrows > ul.step-anchor > li a {
  padding: 10px 0 10px 45px;
}
.sw-theme-arrows > ul.step-anchor > li a:hover {
  padding: 10px 0 10px 45px;
  isolation: inherit;
}
.sw-theme-arrows > ul.step-anchor > li:first-child a {
  padding-left: 15px;
}
.sw-theme-arrows > ul.step-anchor > li > a, .sw-theme-arrows > ul.step-anchor > li > a:hover {
  background: #e2e7f1;
  color: #6c757d;
}
.sw-theme-arrows > ul.step-anchor > li > a::after {
  border-left-color: #e2e7f1 !important;
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  border-left: 30px solid transparent;
  border-right: 0;
  position: absolute;
  top: 50%;
  margin-top: -50px;
  left: 100%;
  z-index: 2;
}
.sw-theme-arrows > ul.step-anchor > li > a::before {
  border-left-color: #e2e7f1 !important;
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  border-left: 30px solid transparent;
  border-right: 0;
  position: absolute;
  top: 50%;
  margin-top: -50px;
  margin-left: 1px;
  left: 100%;
  z-index: 1;
}
.sw-theme-arrows > ul.step-anchor > li.active > a {
  background: #5369f8 !important;
  border-color: #5369f8 !important;
  isolation: inherit;
}
.sw-theme-arrows > ul.step-anchor > li.active > a:after {
  border-left-color: #5369f8 !important;
  border-right: 0 !important;
}
.sw-theme-arrows > ul.step-anchor > li.done > a {
  background: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;
  border-color: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;
  color: #5369f8 !important;
}
.sw-theme-arrows > ul.step-anchor > li.done > a:after {
  border-left-color: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;
  border-right: 0 !important;
}
.sw-theme-arrows > ul.step-anchor > li.done > a::before {
  border-left-color: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;
  border-right: 0 !important;
}

.sw-theme-circles > ul.step-anchor {
  margin-top: 30px;
  background-color: transparent;
}
.sw-theme-circles > ul.step-anchor:before {
  background-color: #e2e7f1;
}
.sw-theme-circles > ul.step-anchor > li {
  margin-left: 40px;
  margin-right: 0;
}
.sw-theme-circles > ul.step-anchor > li > a {
  font-size: 14px;
  width: 40px;
  height: 40px;
  padding: 12px 0;
  background-color: #e2e7f1;
  border-color: #f6f6f7 !important;
  box-shadow: none !important;
}
.sw-theme-circles > ul.step-anchor > li > a:hover {
  background-color: #e2e7f1;
}
.sw-theme-circles > ul.step-anchor > li > a small, .sw-theme-circles > ul.step-anchor > li > a .small {
  bottom: -20px;
  width: 100%;
}
.sw-theme-circles > ul.step-anchor > li > a, .sw-theme-circles > ul.step-anchor > li > a:hover {
  color: #6c757d;
}
.sw-theme-circles > ul.step-anchor > li > a small, .sw-theme-circles > ul.step-anchor > li > a .small, .sw-theme-circles > ul.step-anchor > li > a:hover small {
  color: #6c757d;
}
.sw-theme-circles > ul.step-anchor > li.active > a {
  background: #5369f8 !important;
  border-color: #5369f8 !important;
  color: #fff !important;
}
.sw-theme-circles > ul.step-anchor > li.active > a > small, .sw-theme-circles > ul.step-anchor > li.active > a > .small {
  color: #5369f8;
}
.sw-theme-circles > ul.step-anchor > li.done > a {
  background: #43d39e !important;
  border-color: #43d39e !important;
  color: #fff !important;
}
.sw-theme-circles > ul.step-anchor > li.done > a > small, .sw-theme-circles > ul.step-anchor > li.done > a > .small {
  color: #43d39e;
}

.sw-theme-dots > ul.step-anchor {
  background-color: transparent;
}
.sw-theme-dots > ul.step-anchor:before {
  background-color: #e2e7f1;
}
.sw-theme-dots > ul.step-anchor > li > a:before {
  bottom: -6px;
  background: #e2e7f1;
}
.sw-theme-dots > ul.step-anchor > li > a:after {
  left: 44%;
  bottom: -8px;
  background: #ced4da;
}
.sw-theme-dots > ul.step-anchor > li > a, .sw-theme-dots > ul.step-anchor > li > a:hover, .sw-theme-dots > ul.step-anchor > li > a:focus {
  color: #6c757d;
}
.sw-theme-dots > ul.step-anchor > li.active > a {
  color: #5369f8;
}
.sw-theme-dots > ul.step-anchor > li.active > a:after {
  background: #5369f8;
}
.sw-theme-dots > ul.step-anchor > li.done > a {
  color: #43d39e;
}
.sw-theme-dots > ul.step-anchor > li.done > a:after {
  background: #43d39e;
}

[dir=rtl] .sw-theme-dots > ul.step-anchor > li > a:after {
  left: 40%;
}

@media (max-width: 768px) {
  .sw-main > ul.step-anchor > li {
    display: block;
    width: 100%;
  }
  .sw-theme-arrows > ul.step-anchor > li a {
    padding: 10px 15px;
  }
  .sw-theme-circles > ul.step-anchor {
    margin-bottom: 10px;
  }
  .sw-theme-circles > ul.step-anchor::before {
    width: 0px;
  }
  .sw-theme-circles > ul.step-anchor > li {
    margin-bottom: 10px;
  }
  .sw-theme-circles > ul.step-anchor > li > a > small, .sw-theme-circles > ul.step-anchor > li > a > .small {
    bottom: 14px;
    left: 76px;
  }
  .sw-theme-dots > ul.step-anchor::before {
    left: 10px;
    right: 0;
    margin-right: 10px;
    margin-left: 0px;
  }
  .sw-theme-dots > ul.step-anchor > li {
    margin: 0 20px;
  }
  .sw-theme-dots > ul.step-anchor > li > a {
    text-align: left;
  }
  .sw-theme-dots > ul.step-anchor > li > a::before {
    left: -23px;
    margin-right: 10px;
    margin-left: 0px;
  }
  .sw-theme-dots > ul.step-anchor > li > a::after {
    top: -36px;
    left: -35px !important;
    margin-right: 10px;
    margin-left: 0px;
  }
}
.select2-container {
  width: 100% !important;
}
.select2-container .select2-selection--single {
  border: 1px solid #ced4da;
  height: calc(1.5em + 0.9rem + 2px);
  background-color: #fff;
  outline: none;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 12px;
  color: #4B4B5A;
  text-align: left;
}
.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  right: 3px;
  left: auto;
}
.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: #adb5bd transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}
.select2-container input::placeholder {
  color: #adb5bd;
}

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent #adb5bd transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-results__option {
  padding: 6px 12px;
  text-align: left;
}

.select2-dropdown {
  border: 0 solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  background-color: #fff;
}

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: white;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  outline: none;
  border: 1px solid #ced4da;
  background-color: #fff;
  color: #4B4B5A;
  text-align: left;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #5369f8;
}
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: white;
  color: #343a40;
}
.select2-container--default .select2-results__option[aria-selected=true]:hover {
  background-color: #5369f8;
  color: #fff;
}

.select2-container .select2-selection--multiple {
  min-height: calc(1.5em + 0.9rem + 2px);
  border: 1px solid #ced4da !important;
  background-color: #fff;
  display: flex;
}
.select2-container .select2-selection--multiple .select2-selection__choice__display {
  /*rtl:ignore*/
  padding-left: 0px;
}
.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 1px 10px;
  float: left;
  margin-bottom: 0;
}
.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: #4B4B5A;
}
.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: #5369f8;
  border: none;
  color: #fff;
  border-radius: 3px;
  float: left;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff;
  margin-right: 2px;
  /*rtl:ignore*/
  margin-left: 0px;
  /*rtl:ignore*/
  border-right: none;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove:hover {
  color: #fff;
  background-color: #5369f8;
}
.select2-container .select2-search--inline {
  float: left;
}
.select2-container .select2-search--inline .select2-search__field {
  margin-top: 7px;
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  outline: none;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto;
  /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 5px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

.ms-container {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat 50% 50%;
  width: auto;
  max-width: 370px;
}
.ms-container .ms-list {
  box-shadow: none;
  border: 1px solid #ced4da;
}
.ms-container .ms-list.ms-focus {
  box-shadow: none;
  border: 1px solid rgb(69.3889648883%, 73.137254902%, 76.8855449156%);
}
.ms-container .ms-selectable {
  background-color: #fff;
}
.ms-container .ms-selectable li.ms-elem-selectable {
  border: none;
  padding: 5px 10px;
  color: #6c757d;
}
.ms-container .ms-selectable li.ms-hover {
  background-color: #5369f8;
  color: #fff;
}
.ms-container .ms-selection {
  background-color: #fff;
}
.ms-container .ms-selection li.ms-elem-selection {
  border: none;
  padding: 5px 10px;
  color: #6c757d;
}
.ms-container .ms-selection li.ms-hover {
  background-color: #5369f8;
  color: #fff;
}

.ms-selectable {
  box-shadow: none;
  outline: none !important;
}

.ms-optgroup-label {
  font-weight: 500;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  color: #343a40 !important;
  font-size: 13px;
  padding-left: 5px !important;
}

.bootstrap-touchspin .btn .input-group-text {
  padding: 0;
  border: none;
  background-color: transparent;
  color: inherit;
}

.parsley-errors-list {
  margin: 0;
  padding: 0;
}
.parsley-errors-list > li {
  list-style: none;
  color: #ff5c75;
  margin-top: 10px;
  padding: 4px 7px 4px 28px;
  position: relative;
  display: inline-block;
  background-color: rgba(255, 92, 117, 0.2);
  border-radius: 7px;
}
.parsley-errors-list > li:before {
  content: "\\ebee";
  font-family: "unicons";
  position: absolute;
  left: 8px;
  top: 4px;
}
.parsley-errors-list > li:after {
  content: "";
  border: 8px solid transparent;
  border-bottom-color: rgba(255, 92, 117, 0.2);
  position: absolute;
  left: 14px;
  top: -16px;
}

.parsley-error {
  border-color: #ff5c75;
}

.parsley-success {
  border-color: #43d39e;
}

.ql-container {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.ql-container.ql-snow {
  border-color: #ced4da;
}

.ql-bubble {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.ql-toolbar {
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif !important;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.ql-toolbar span {
  outline: none !important;
  color: #4B4B5A;
}
.ql-toolbar span:hover {
  color: #5369f8 !important;
}
.ql-toolbar.ql-snow {
  border-color: #ced4da;
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: transparent;
}
.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
  margin-left: 0;
}

.ql-snow .ql-stroke,
.ql-snow .ql-script,
.ql-snow .ql-strike svg {
  stroke: #4B4B5A;
}
.ql-snow .ql-fill {
  fill: #4B4B5A;
}

.ql-snow .ql-picker-options {
  background-color: #fff;
  border-color: rgb(93.7549019608%, 94.6470588235%, 95.5392156863%) !important;
}

.ql-editor {
  text-align: left;
}

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  left: auto;
  top: 50%;
  width: 18px;
}

.ql-editor ol li:not(.ql-direction-rtl), .ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
  padding-right: 0;
}
.ql-editor li:not(.ql-direction-rtl):before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}

.ql-editor ol, .ql-editor ul {
  padding-left: 1.5em;
  padding-right: 0;
}

.rdw-editor-wrapper {
  border-color: #ced4da !important;
}
.rdw-editor-wrapper .rdw-editor-toolbar {
  background: transparent !important;
  border-bottom: 1px solid #ced4da !important;
  border: none;
}
.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper {
  background: #fff !important;
  border-color: transparent !important;
}
.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper.rdw-option-active {
  box-shadow: none !important;
}
.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper img {
  fill: #343a40 !important;
}
.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper .rdw-dropdownoption-active {
  background: #f8f9fa !important;
}
.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper {
  background: transparent !important;
}
.rdw-editor-wrapper .rdw-editor-main {
  border-color: #ced4da !important;
}

.EasyMDEContainer .CodeMirror {
  background: #fff !important;
  border-color: #ced4da !important;
}
.EasyMDEContainer .editor-toolbar {
  border-color: #ced4da !important;
}
.EasyMDEContainer .editor-toolbar i.separator {
  border-color: #ced4da !important;
}
.EasyMDEContainer .editor-toolbar button {
  color: #343a40 !important;
}
.EasyMDEContainer .editor-toolbar button:hover {
  background: rgb(88.8549019608%, 90.7764705882%, 94.6196078431%) !important;
  border-color: transparent !important;
}
.EasyMDEContainer .CodeMirror-lines .CodeMirror-cursors .CodeMirror-cursor {
  border-color: #343a40;
}
.EasyMDEContainer .CodeMirror-lines .CodeMirror-code .CodeMirror-line {
  color: #343a40;
}
.EasyMDEContainer .CodeMirror-lines .CodeMirror-code .CodeMirror-line .cm-null {
  background: transparent !important;
  color: #4B4B5A !important;
}

.react-select > div {
  border: 1px solid #ced4da;
  background-color: #fff !important;
}
.react-select > div:hover {
  border: 1px solid #ced4da;
}

.react-select__control--is-focused {
  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%) !important;
  box-shadow: none !important;
}

.react-select__indicator-separator {
  display: none !important;
}

.react-select__input-container {
  margin-left: 0 !important;
}

.react-select__dropdown-indicator {
  color: #6c757d !important;
}

.react-select__menu {
  background-color: #fff !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  border: none !important;
  border-radius: 0.25rem !important;
  z-index: 1000 !important;
}

.react-select__menu-list {
  border: 0 solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%) !important;
  border-radius: 0.25rem !important;
}

.react-select__single-value {
  color: #6c757d !important;
}

.react-select__multi-value {
  background-color: rgba(83, 105, 248, 0.2) !important;
  color: #5369f8 !important;
}
.react-select__multi-value .react-select__multi-value__label {
  color: #5369f8;
}
.react-select__multi-value .react-select__multi-value__remove:hover {
  background-color: rgba(83, 105, 248, 0.2);
  color: #5369f8;
}

.rbt-token {
  background-color: rgba(83, 105, 248, 0.2) !important;
  color: #5369f8 !important;
}
.rbt-token .rbt-token-remove-button {
  background-color: transparent;
  border: none;
}
.rbt-token .rbt-token-remove-button .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.rbt-input-multi.focus {
  box-shadow: none !important;
  background-color: #fff !important;
  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%) !important;
}

.react-select-container .react-select__value-container--has-value .react-select__single-value {
  color: #4B4B5A !important;
}
.react-select-container .react-select__menu-list {
  max-height: 252px;
}
.react-select-container .react-select__option {
  padding: 0.375rem 1.2rem;
  color: #4B4B5A;
  background-color: transparent !important;
}
.react-select-container .react-select__option:hover {
  color: #fff !important;
  background-color: #5369f8 !important;
}
.react-select-container .react-select__option--is-selected {
  color: #343a40 !important;
}

.app-search .react-select__menu-list .react-select__option {
  padding: 0.375rem 1.2rem;
  color: #4B4B5A;
  background-color: transparent;
}
.app-search .react-select__menu-list .react-select__option:hover {
  color: #343a40;
  background-color: #f8f9fa;
}
.app-search .react-select__menu-list .react-select__option--is-selected {
  background-color: #f8f9fa;
}
.app-search .react-select__menu-list .react-select__option--is-selected .dropdown-item {
  color: #343a40 !important;
}
.app-search .react-select__menu-list .react-select__option--is-disabled:hover {
  background-color: transparent !important;
}
.app-search .react-select__value-container--has-value .react-select__single-value i, .app-search .react-select__value-container--has-value .react-select__single-value img, .app-search .react-select__value-container--has-value .react-select__single-value .user-subinfo {
  display: none !important;
}
.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item {
  color: rgba(255, 255, 255, 0.6) !important;
}
.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item .drop-username {
  color: rgba(255, 255, 255, 0.6) !important;
}
.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item:hover {
  color: #4B4B5A;
  background-color: transparent;
}
.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item, .app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item .drop-username {
  width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

body[data-topbar-color=light] .app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item, body[data-topbar-color=light] .app-search .react-select__value-container--has-value .react-select__single-value .drop-username {
  color: #343a40 !important;
}

.react-table th, .react-table td {
  white-space: nowrap;
}
.react-table th {
  padding-left: 0.85rem;
  padding-right: 30px;
}
.react-table .sortable {
  position: relative;
  cursor: pointer;
}
.react-table .sortable:before {
  position: absolute;
  right: 1rem;
  left: auto;
  content: "↑";
  font-family: "Material Design Icons";
  font-size: 1rem;
  top: 12px;
  opacity: 0.3;
}
.react-table .sortable:after {
  position: absolute;
  right: 0.5em;
  left: auto;
  content: "↓";
  font-family: "Material Design Icons";
  top: 12px;
  opacity: 0.3;
  font-size: 1rem;
}
.react-table .sortable.sorting_asc:before {
  opacity: 1;
}
.react-table .sortable.sorting_desc:after {
  opacity: 1;
}
@media (max-width: 991.98px) {
  .react-table li.paginate_button.previous, .react-table li.paginate_button.next {
    display: inline-block;
    font-size: 1.5rem;
  }
}

.flatpickr-calendar {
  background: #fff;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);
}
.flatpickr-calendar.arrowTop:before {
  border-bottom-color: white;
}
.flatpickr-calendar.arrowTop:after {
  border-bottom-color: #fff;
}
.flatpickr-calendar.arrowBottom:before, .flatpickr-calendar.arrowBottom:after {
  border-top-color: #fff;
}

.flatpickr-current-month {
  font-size: 110%;
}

.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background: #5369f8 !important;
  border-color: #5369f8;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #5369f8;
}

.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus {
  background: #fff;
  color: #343a40;
}

.flatpickr-months .flatpickr-month {
  height: 36px;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month,
.flatpickr-months .flatpickr-month {
  color: #adb5bd;
  fill: #adb5bd;
}

.flatpickr-weekdays {
  background-color: #f8f9fa;
}

span.flatpickr-weekday,
.flatpickr-day,
.flatpickr-current-month input.cur-year[disabled],
.flatpickr-current-month input.cur-year[disabled]:hover,
.flatpickr-time input,
.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  color: #4B4B5A;
  fill: #4B4B5A;
}

.flatpickr-day.disabled, .flatpickr-day.disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {
  color: #6c757d;
}
.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {
  background: #f8f9fa;
  border-color: #f8f9fa;
}

.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {
  border-top: 1px solid white;
}

.numInputWrapper:hover,
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background-color: transparent;
  color: #343a40;
}

.flatpickr-day.inRange {
  box-shadow: -5px 0 0 #f8f9fa, 5px 0 0 #f8f9fa;
}

.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {
  color: #6c757d;
}

.dropzone {
  border: 2px dashed #ced4da;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
  min-height: 150px;
  padding: 20px;
  min-height: 150px;
}
.dropzone > div:focus {
  outline: none;
}
.dropzone .dz-message {
  text-align: center;
  margin: 2rem 0;
  outline: none;
}
.dropzone.dz-started .dz-message {
  display: none;
}
@keyframes passing-through {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  30%, 70% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(-40px);
  }
}
@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  30% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  10% {
    transform: scale(1.1);
  }
  20% {
    transform: scale(1);
  }
}
.dropzone, .dropzone * {
  box-sizing: border-box;
}

.dropzone.dz-clickable {
  cursor: pointer;
}

.dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {
  cursor: pointer;
}

.dropzone.dz-started .dz-message {
  display: none;
}

.dropzone.dz-drag-hover {
  border-style: solid;
}

.dropzone.dz-drag-hover .dz-message {
  opacity: 0.5;
}

.dropzone .dz-message {
  text-align: center;
  margin: 2em 0;
}

.dropzone .dz-message .dz-button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}

.dropzone .dz-preview {
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin: 16px;
  min-height: 100px;
}

.dropzone .dz-preview:hover {
  z-index: 1000;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-file-preview .dz-image {
  border-radius: 20px;
  background: #999;
  background: linear-gradient(to bottom, #eee, #ddd);
}

.dropzone .dz-preview.dz-file-preview .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-image-preview .dz-details {
  transition: opacity 0.2s linear;
}

.dropzone .dz-preview .dz-remove {
  font-size: 14px;
  text-align: center;
  display: block;
  cursor: pointer;
  border: none;
}

.dropzone .dz-preview .dz-remove:hover {
  text-decoration: underline;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview .dz-details {
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 13px;
  min-width: 100%;
  max-width: 100%;
  padding: 2em 1em;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  line-height: 150%;
}

.dropzone .dz-preview .dz-details .dz-size {
  margin-bottom: 1em;
  font-size: 16px;
}

.dropzone .dz-preview .dz-details .dz-filename {
  white-space: nowrap;
}

.dropzone .dz-preview .dz-details .dz-filename:hover span {
  border: 1px solid rgba(200, 200, 200, 0.8);
  background-color: rgba(255, 255, 255, 0.8);
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
  border: 1px solid transparent;
}

.dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {
  background-color: rgba(255, 255, 255, 0.4);
  padding: 0 0.4em;
  border-radius: 3px;
}

.dropzone .dz-preview:hover .dz-image img {
  transform: scale(1.05, 1.05);
  filter: blur(8px);
}

.dropzone .dz-preview .dz-image {
  border-radius: 20px;
  overflow: hidden;
  width: 120px;
  height: 120px;
  position: relative;
  display: block;
  z-index: 10;
  background-color: #f8f9fa;
}

.dropzone .dz-preview .dz-image img {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.dropzone .dz-preview.dz-success .dz-success-mark {
  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview.dz-error .dz-error-mark {
  opacity: 1;
  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {
  pointer-events: none;
  opacity: 0;
  z-index: 500;
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  margin-left: -27px;
  margin-top: -27px;
}

.dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {
  display: block;
  width: 54px;
  height: 54px;
}

.dropzone .dz-preview.dz-processing .dz-progress {
  opacity: 1;
  transition: all 0.2s linear;
}

.dropzone .dz-preview.dz-complete .dz-progress {
  opacity: 0;
  transition: opacity 0.4s ease-in;
}

.dropzone .dz-preview:not(.dz-processing) .dz-progress {
  animation: pulse 6s ease infinite;
}

.dropzone .dz-preview .dz-progress {
  opacity: 1;
  z-index: 1000;
  pointer-events: none;
  position: absolute;
  height: 16px;
  left: 50%;
  top: 50%;
  margin-top: -8px;
  width: 80px;
  margin-left: -40px;
  background: rgba(255, 255, 255, 0.9);
  -webkit-transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.dropzone .dz-preview .dz-progress .dz-upload {
  background: #333;
  background: linear-gradient(to bottom, #666, #444);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  transition: width 300ms ease-in-out;
}

.dropzone .dz-preview.dz-error .dz-error-message {
  display: block;
}

.dropzone .dz-preview.dz-error:hover .dz-error-message {
  opacity: 1;
  pointer-events: auto;
}

.dropzone .dz-preview .dz-error-message {
  pointer-events: none;
  z-index: 1000;
  position: absolute;
  display: block;
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
  font-size: 13px;
  top: 130px;
  left: -10px;
  width: 140px;
  background: #be2626;
  background: linear-gradient(to bottom, #be2626, #a92222);
  padding: 0.5em 1.2em;
  color: white;
}

.dropzone .dz-preview .dz-error-message:after {
  content: "";
  position: absolute;
  top: -6px;
  left: 64px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #be2626;
}

.dz-preview .dz-remove .btn {
  background-color: rgba(173, 181, 189, 0.85);
  color: #fff;
  border-radius: 50%;
  font-size: 10px;
  padding: 0;
  height: 24px;
  width: 24px;
  line-height: 22px;
  position: absolute;
  top: -7px;
  right: -5px;
  z-index: 999;
  opacity: 0;
  transition: 0.2s ease-in-out;
}
.dz-preview:hover .dz-remove .btn {
  opacity: 1;
}

.gmaps,
.gmaps-panaroma {
  height: 300px;
  background: #f8f9fa;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #5369f8;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}
.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #5369f8;
}
.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #5369f8;
}

.jvectormap-label {
  border: none;
  background: #343a40;
  color: color-yiq(#343a40);
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-size: 0.875rem;
  padding: 5px 8px;
}

svg {
  touch-action: none;
}

image, text, .jvm-zoomin, .jvm-zoomout {
  -webkit-user-select: none;
          user-select: none;
}

.jvm-container {
  touch-action: none;
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

.jvm-tooltip {
  border-radius: 3px;
  background-color: #343a40;
  font-family: "Noto Sans", "Noto Sans Fallback", sans-serif;
  font-size: 0.875rem;
  box-shadow: 1px 2px 12px rgba(0, 0, 0, 0.2);
  padding: 5px 8px;
  white-space: nowrap;
  position: absolute;
  display: none;
  color: #f8f9fa;
  border: none;
}

.jvm-zoom-btn {
  border-radius: 3px;
  background-color: #292929;
  padding: 3px;
  box-sizing: border-box;
  position: absolute;
  line-height: 10px;
  cursor: pointer;
  color: #FFF;
  height: 15px;
  width: 15px;
  left: 10px;
}
.jvm-zoom-btn.jvm-zoomout {
  top: 30px;
}
.jvm-zoom-btn.jvm-zoomin {
  top: 10px;
}

.jvm-series-container {
  right: 15px;
  position: absolute;
}
.jvm-series-container.jvm-series-h {
  bottom: 15px;
}
.jvm-series-container.jvm-series-v {
  top: 15px;
}
.jvm-series-container .jvm-legend {
  background-color: #FFF;
  border: 1px solid #e5e7eb;
  margin-left: 0.75rem;
  border-radius: 0.25rem;
  border-color: #e5e7eb;
  padding: 0.6rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  float: left;
}
.jvm-series-container .jvm-legend .jvm-legend-title {
  line-height: 1;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 0.5rem;
  margin-bottom: 0.575rem;
  text-align: left;
}
.jvm-series-container .jvm-legend .jvm-legend-inner {
  overflow: hidden;
}
.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick {
  overflow: hidden;
  min-width: 40px;
}
.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick:not(:first-child) {
  margin-top: 0.575rem;
}
.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick .jvm-legend-tick-sample {
  border-radius: 4px;
  margin-right: 0.65rem;
  height: 16px;
  width: 16px;
  float: left;
}
.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick .jvm-legend-tick-text {
  font-size: 12px;
  text-align: center;
  float: left;
}

.jvm-line[animation=true] {
  animation: jvm-line-animation 10s linear forwards infinite;
}
@keyframes jvm-line-animation {
  from {
    stroke-dashoffset: 250;
  }
}

/*
Template Name: Shreyu - Responsive 5 Admin Dashboard
Author: CoderThemes
Version: 2.0.0
Email: support@coderthemes.com
File: Icons Css File
*/
@font-face {
  font-family: "unicons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */
/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */
/*
@media screen and (-webkit-min-device-pixel-ratio:0) {
  @font-face {
    font-family: 'unicons';
    src: url('../fonts/unicons.svg?2256574#unicons') format('svg');
  }
}
*/
.uil {
  line-height: inherit;
}

[class^=uil-]:before, [class*=" uil-"]:before {
  font-family: "unicons";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  text-align: center;
  /* opacity: .8; */
  /* For safety - reset parent styles, that can break glyph codes*/
  font-variant: normal;
  text-transform: none;
  /* fix buttons height, for twitter bootstrap */
  line-height: 1em;
  vertical-align: middle;
  /* Animation center compensation - margins should be symmetric */
  /* remove if not needed */
  /* you can be more comfortable with increased icons size */
  font-size: 120%;
  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
}

.uil-0-plus:before {
  content: "\\e800";
} /* '' */
.uil-10-plus:before {
  content: "\\e801";
} /* '' */
.uil-12-plus:before {
  content: "\\e802";
} /* '' */
.uil-13-plus:before {
  content: "\\e803";
} /* '' */
.uil-16-plus:before {
  content: "\\e804";
} /* '' */
.uil-17-plus:before {
  content: "\\e805";
} /* '' */
.uil-18-plus:before {
  content: "\\e806";
} /* '' */
.uil-21-plus:before {
  content: "\\e807";
} /* '' */
.uil-3-plus:before {
  content: "\\e808";
} /* '' */
.uil-500px:before {
  content: "\\e809";
} /* '' */
.uil-6-plus:before {
  content: "\\e80a";
} /* '' */
.uil-abacus:before {
  content: "\\e80b";
} /* '' */
.uil-accessible-icon-alt:before {
  content: "\\e80c";
} /* '' */
.uil-adjust-alt:before {
  content: "\\e80d";
} /* '' */
.uil-adjust-circle:before {
  content: "\\e80e";
} /* '' */
.uil-adjust-half:before {
  content: "\\e80f";
} /* '' */
.uil-adjust:before {
  content: "\\e810";
} /* '' */
.uil-adobe-alt:before {
  content: "\\e811";
} /* '' */
.uil-adobe:before {
  content: "\\e812";
} /* '' */
.uil-airplay:before {
  content: "\\e813";
} /* '' */
.uil-align-alt:before {
  content: "\\e814";
} /* '' */
.uil-align-center-alt:before {
  content: "\\e815";
} /* '' */
.uil-align-center-h:before {
  content: "\\e816";
} /* '' */
.uil-align-center-justify:before {
  content: "\\e817";
} /* '' */
.uil-align-center-v:before {
  content: "\\e818";
} /* '' */
.uil-align-center:before {
  content: "\\e819";
} /* '' */
.uil-align-justify:before {
  content: "\\e81a";
} /* '' */
.uil-align-left-justify:before {
  content: "\\e81b";
} /* '' */
.uil-align-left:before {
  content: "\\e81c";
} /* '' */
.uil-align-letter-right:before {
  content: "\\e81d";
} /* '' */
.uil-align-right-justify:before {
  content: "\\e81e";
} /* '' */
.uil-align-right:before {
  content: "\\e81f";
} /* '' */
.uil-align:before {
  content: "\\e820";
} /* '' */
.uil-amazon:before {
  content: "\\e821";
} /* '' */
.uil-ambulance:before {
  content: "\\e822";
} /* '' */
.uil-analysis:before {
  content: "\\e823";
} /* '' */
.uil-analytics:before {
  content: "\\e824";
} /* '' */
.uil-anchor:before {
  content: "\\e825";
} /* '' */
.uil-android-alt:before {
  content: "\\e826";
} /* '' */
.uil-android-phone-slash:before {
  content: "\\e827";
} /* '' */
.uil-android:before {
  content: "\\e828";
} /* '' */
.uil-angle-double-down:before {
  content: "\\e829";
} /* '' */
.uil-angle-double-left:before {
  content: "\\e82a";
} /* '' */
.uil-angle-double-right:before {
  content: "\\e82b";
} /* '' */
.uil-angle-double-up:before {
  content: "\\e82c";
} /* '' */
.uil-angle-down:before {
  content: "\\e82d";
} /* '' */
.uil-angle-left:before {
  content: "\\e82e";
} /* '' */
.uil-angle-right-b:before {
  content: "\\e82f";
} /* '' */
.uil-angle-right:before {
  content: "\\e830";
} /* '' */
.uil-angle-up:before {
  content: "\\e831";
} /* '' */
.uil-angry:before {
  content: "\\e832";
} /* '' */
.uil-ankh:before {
  content: "\\e833";
} /* '' */
.uil-annoyed-alt:before {
  content: "\\e834";
} /* '' */
.uil-annoyed:before {
  content: "\\e835";
} /* '' */
.uil-apple-alt:before {
  content: "\\e836";
} /* '' */
.uil-apple:before {
  content: "\\e837";
} /* '' */
.uil-apps:before {
  content: "\\e838";
} /* '' */
.uil-archive-alt:before {
  content: "\\e839";
} /* '' */
.uil-archive:before {
  content: "\\e83a";
} /* '' */
.uil-archway:before {
  content: "\\e83b";
} /* '' */
.uil-arrow-break:before {
  content: "\\e83c";
} /* '' */
.uil-arrow-circle-down:before {
  content: "\\e83d";
} /* '' */
.uil-arrow-circle-left:before {
  content: "\\e83e";
} /* '' */
.uil-arrow-circle-right:before {
  content: "\\e83f";
} /* '' */
.uil-arrow-circle-up:before {
  content: "\\e840";
} /* '' */
.uil-arrow-compress-h:before {
  content: "\\e841";
} /* '' */
.uil-arrow-down-left:before {
  content: "\\e842";
} /* '' */
.uil-arrow-down-right:before {
  content: "\\e843";
} /* '' */
.uil-arrow-down:before {
  content: "\\e844";
} /* '' */
.uil-arrow-from-right:before {
  content: "\\e845";
} /* '' */
.uil-arrow-from-top:before {
  content: "\\e846";
} /* '' */
.uil-arrow-growth:before {
  content: "\\e847";
} /* '' */
.uil-arrow-left:before {
  content: "\\e848";
} /* '' */
.uil-arrow-random:before {
  content: "\\e849";
} /* '' */
.uil-arrow-resize-diagonal:before {
  content: "\\e84a";
} /* '' */
.uil-arrow-right:before {
  content: "\\e84b";
} /* '' */
.uil-arrow-to-bottom:before {
  content: "\\e84c";
} /* '' */
.uil-arrow-to-right:before {
  content: "\\e84d";
} /* '' */
.uil-arrow-up-left:before {
  content: "\\e84e";
} /* '' */
.uil-arrow-up-right:before {
  content: "\\e84f";
} /* '' */
.uil-arrow-up:before {
  content: "\\e850";
} /* '' */
.uil-arrows-h-alt:before {
  content: "\\e851";
} /* '' */
.uil-arrows-h:before {
  content: "\\e852";
} /* '' */
.uil-arrows-left-down:before {
  content: "\\e853";
} /* '' */
.uil-arrows-maximize:before {
  content: "\\e854";
} /* '' */
.uil-arrows-merge:before {
  content: "\\e855";
} /* '' */
.uil-arrows-resize-h:before {
  content: "\\e856";
} /* '' */
.uil-arrows-resize-v:before {
  content: "\\e857";
} /* '' */
.uil-arrows-resize:before {
  content: "\\e858";
} /* '' */
.uil-arrows-right-down:before {
  content: "\\e859";
} /* '' */
.uil-arrows-shrink-h:before {
  content: "\\e85a";
} /* '' */
.uil-arrows-shrink-v:before {
  content: "\\e85b";
} /* '' */
.uil-arrows-up-right:before {
  content: "\\e85c";
} /* '' */
.uil-arrows-v-alt:before {
  content: "\\e85d";
} /* '' */
.uil-arrows-v:before {
  content: "\\e85e";
} /* '' */
.uil-assistive-listening-systems:before {
  content: "\\e85f";
} /* '' */
.uil-asterisk:before {
  content: "\\e860";
} /* '' */
.uil-at:before {
  content: "\\e861";
} /* '' */
.uil-atm-card:before {
  content: "\\e862";
} /* '' */
.uil-atom:before {
  content: "\\e863";
} /* '' */
.uil-auto-flash:before {
  content: "\\e864";
} /* '' */
.uil-award-alt:before {
  content: "\\e865";
} /* '' */
.uil-award:before {
  content: "\\e866";
} /* '' */
.uil-baby-carriage:before {
  content: "\\e867";
} /* '' */
.uil-backpack:before {
  content: "\\e868";
} /* '' */
.uil-backspace:before {
  content: "\\e869";
} /* '' */
.uil-backward:before {
  content: "\\e86a";
} /* '' */
.uil-bag-alt:before {
  content: "\\e86b";
} /* '' */
.uil-bag-slash:before {
  content: "\\e86c";
} /* '' */
.uil-bag:before {
  content: "\\e86d";
} /* '' */
.uil-balance-scale:before {
  content: "\\e86e";
} /* '' */
.uil-ball:before {
  content: "\\e86f";
} /* '' */
.uil-ban:before {
  content: "\\e870";
} /* '' */
.uil-bars:before {
  content: "\\e871";
} /* '' */
.uil-baseball-ball:before {
  content: "\\e872";
} /* '' */
.uil-basketball-hoop:before {
  content: "\\e873";
} /* '' */
.uil-basketball:before {
  content: "\\e874";
} /* '' */
.uil-bath:before {
  content: "\\e875";
} /* '' */
.uil-battery-bolt:before {
  content: "\\e876";
} /* '' */
.uil-battery-empty:before {
  content: "\\e877";
} /* '' */
.uil-bed-double:before {
  content: "\\e878";
} /* '' */
.uil-bed:before {
  content: "\\e879";
} /* '' */
.uil-behance-alt:before {
  content: "\\e87a";
} /* '' */
.uil-behance:before {
  content: "\\e87b";
} /* '' */
.uil-bell-school:before {
  content: "\\e87c";
} /* '' */
.uil-bell-slash:before {
  content: "\\e87d";
} /* '' */
.uil-bell:before {
  content: "\\e87e";
} /* '' */
.uil-bill:before {
  content: "\\e87f";
} /* '' */
.uil-bitcoin-alt:before {
  content: "\\e880";
} /* '' */
.uil-bitcoin-bold:before {
  content: "\\e881";
} /* '' */
.uil-bitcoin-circle:before {
  content: "\\e882";
} /* '' */
.uil-bitcoin:before {
  content: "\\e883";
} /* '' */
.uil-black-berry:before {
  content: "\\e884";
} /* '' */
.uil-blogger-alt:before {
  content: "\\e885";
} /* '' */
.uil-blogger:before {
  content: "\\e886";
} /* '' */
.uil-bluetooth-b:before {
  content: "\\e887";
} /* '' */
.uil-bold:before {
  content: "\\e888";
} /* '' */
.uil-bolt-alt:before {
  content: "\\e889";
} /* '' */
.uil-bolt-slash:before {
  content: "\\e88a";
} /* '' */
.uil-bolt:before {
  content: "\\e88b";
} /* '' */
.uil-book-alt:before {
  content: "\\e88c";
} /* '' */
.uil-book-medical:before {
  content: "\\e88d";
} /* '' */
.uil-book-open:before {
  content: "\\e88e";
} /* '' */
.uil-book-reader:before {
  content: "\\e88f";
} /* '' */
.uil-book:before {
  content: "\\e890";
} /* '' */
.uil-bookmark-full:before {
  content: "\\e891";
} /* '' */
.uil-bookmark:before {
  content: "\\e892";
} /* '' */
.uil-books:before {
  content: "\\e893";
} /* '' */
.uil-boombox:before {
  content: "\\e894";
} /* '' */
.uil-border-alt:before {
  content: "\\e895";
} /* '' */
.uil-border-bottom:before {
  content: "\\e896";
} /* '' */
.uil-border-clear:before {
  content: "\\e897";
} /* '' */
.uil-border-horizontal:before {
  content: "\\e898";
} /* '' */
.uil-border-inner:before {
  content: "\\e899";
} /* '' */
.uil-border-left:before {
  content: "\\e89a";
} /* '' */
.uil-border-out:before {
  content: "\\e89b";
} /* '' */
.uil-border-right:before {
  content: "\\e89c";
} /* '' */
.uil-border-top:before {
  content: "\\e89d";
} /* '' */
.uil-border-vertical:before {
  content: "\\e89e";
} /* '' */
.uil-bowling-ball:before {
  content: "\\e89f";
} /* '' */
.uil-box:before {
  content: "\\e8a0";
} /* '' */
.uil-briefcase-alt:before {
  content: "\\e8a1";
} /* '' */
.uil-briefcase:before {
  content: "\\e8a2";
} /* '' */
.uil-bright:before {
  content: "\\e8a3";
} /* '' */
.uil-brightness-empty:before {
  content: "\\e8a4";
} /* '' */
.uil-brightness-half:before {
  content: "\\e8a5";
} /* '' */
.uil-brightness-low:before {
  content: "\\e8a6";
} /* '' */
.uil-brightness-minus:before {
  content: "\\e8a7";
} /* '' */
.uil-brightness-plus:before {
  content: "\\e8a8";
} /* '' */
.uil-brightness:before {
  content: "\\e8a9";
} /* '' */
.uil-bring-bottom:before {
  content: "\\e8aa";
} /* '' */
.uil-bring-front:before {
  content: "\\e8ab";
} /* '' */
.uil-brush-alt:before {
  content: "\\e8ac";
} /* '' */
.uil-bug:before {
  content: "\\e8ad";
} /* '' */
.uil-building:before {
  content: "\\e8ae";
} /* '' */
.uil-bullseye:before {
  content: "\\e8af";
} /* '' */
.uil-bus-alt:before {
  content: "\\e8b0";
} /* '' */
.uil-bus-school:before {
  content: "\\e8b1";
} /* '' */
.uil-bus:before {
  content: "\\e8b2";
} /* '' */
.uil-calcualtor:before {
  content: "\\e8b3";
} /* '' */
.uil-calculator-alt:before {
  content: "\\e8b4";
} /* '' */
.uil-calculator:before {
  content: "\\e8b5";
} /* '' */
.uil-calendar-alt:before {
  content: "\\e8b6";
} /* '' */
.uil-calendar-slash:before {
  content: "\\e8b7";
} /* '' */
.uil-calender:before {
  content: "\\e8b8";
} /* '' */
.uil-calling:before {
  content: "\\e8b9";
} /* '' */
.uil-camera-change:before {
  content: "\\e8ba";
} /* '' */
.uil-camera-plus:before {
  content: "\\e8bb";
} /* '' */
.uil-camera-slash:before {
  content: "\\e8bc";
} /* '' */
.uil-camera:before {
  content: "\\e8bd";
} /* '' */
.uil-cancel:before {
  content: "\\e8be";
} /* '' */
.uil-capsule:before {
  content: "\\e8bf";
} /* '' */
.uil-capture:before {
  content: "\\e8c0";
} /* '' */
.uil-car-sideview:before {
  content: "\\e8c1";
} /* '' */
.uil-car-slash:before {
  content: "\\e8c2";
} /* '' */
.uil-car-wash:before {
  content: "\\e8c3";
} /* '' */
.uil-car:before {
  content: "\\e8c4";
} /* '' */
.uil-card-atm:before {
  content: "\\e8c5";
} /* '' */
.uil-caret-right:before {
  content: "\\e8c6";
} /* '' */
.uil-cart:before {
  content: "\\e8c7";
} /* '' */
.uil-cell:before {
  content: "\\e8c8";
} /* '' */
.uil-celsius:before {
  content: "\\e8c9";
} /* '' */
.uil-chart-bar-alt:before {
  content: "\\e8ca";
} /* '' */
.uil-chart-bar:before {
  content: "\\e8cb";
} /* '' */
.uil-chart-down:before {
  content: "\\e8cc";
} /* '' */
.uil-chart-growth-alt:before {
  content: "\\e8cd";
} /* '' */
.uil-chart-growth:before {
  content: "\\e8ce";
} /* '' */
.uil-chart-line:before {
  content: "\\e8cf";
} /* '' */
.uil-chart-pie-alt:before {
  content: "\\e8d0";
} /* '' */
.uil-chart-pie:before {
  content: "\\e8d1";
} /* '' */
.uil-chart:before {
  content: "\\e8d2";
} /* '' */
.uil-chat-bubble-user:before {
  content: "\\e8d3";
} /* '' */
.uil-chat-info:before {
  content: "\\e8d4";
} /* '' */
.uil-chat:before {
  content: "\\e8d5";
} /* '' */
.uil-check-circle:before {
  content: "\\e8d6";
} /* '' */
.uil-check-square:before {
  content: "\\e8d7";
} /* '' */
.uil-check:before {
  content: "\\e8d8";
} /* '' */
.uil-circle-layer:before {
  content: "\\e8d9";
} /* '' */
.uil-circle:before {
  content: "\\e8da";
} /* '' */
.uil-circuit:before {
  content: "\\e8db";
} /* '' */
.uil-clapper-board:before {
  content: "\\e8dc";
} /* '' */
.uil-clipboard-alt:before {
  content: "\\e8dd";
} /* '' */
.uil-clipboard-blank:before {
  content: "\\e8de";
} /* '' */
.uil-clipboard-notes:before {
  content: "\\e8df";
} /* '' */
.uil-clipboard:before {
  content: "\\e8e0";
} /* '' */
.uil-clock-eight:before {
  content: "\\e8e1";
} /* '' */
.uil-clock-five:before {
  content: "\\e8e2";
} /* '' */
.uil-clock-nine:before {
  content: "\\e8e3";
} /* '' */
.uil-clock-seven:before {
  content: "\\e8e4";
} /* '' */
.uil-clock-ten:before {
  content: "\\e8e5";
} /* '' */
.uil-clock-three:before {
  content: "\\e8e6";
} /* '' */
.uil-clock-two:before {
  content: "\\e8e7";
} /* '' */
.uil-clock:before {
  content: "\\e8e8";
} /* '' */
.uil-closed-captioning:before {
  content: "\\e8e9";
} /* '' */
.uil-cloud-block:before {
  content: "\\e8ea";
} /* '' */
.uil-cloud-bookmark:before {
  content: "\\e8eb";
} /* '' */
.uil-cloud-check:before {
  content: "\\e8ec";
} /* '' */
.uil-cloud-computing:before {
  content: "\\e8ed";
} /* '' */
.uil-cloud-data-connection:before {
  content: "\\e8ee";
} /* '' */
.uil-cloud-database-tree:before {
  content: "\\e8ef";
} /* '' */
.uil-cloud-download:before {
  content: "\\e8f0";
} /* '' */
.uil-cloud-drizzle:before {
  content: "\\e8f1";
} /* '' */
.uil-cloud-exclamation:before {
  content: "\\e8f2";
} /* '' */
.uil-cloud-hail:before {
  content: "\\e8f3";
} /* '' */
.uil-cloud-heart:before {
  content: "\\e8f4";
} /* '' */
.uil-cloud-info:before {
  content: "\\e8f5";
} /* '' */
.uil-cloud-lock:before {
  content: "\\e8f6";
} /* '' */
.uil-cloud-meatball:before {
  content: "\\e8f7";
} /* '' */
.uil-cloud-moon-hail:before {
  content: "\\e8f8";
} /* '' */
.uil-cloud-moon-meatball:before {
  content: "\\e8f9";
} /* '' */
.uil-cloud-moon-rain:before {
  content: "\\e8fa";
} /* '' */
.uil-cloud-moon-showers:before {
  content: "\\e8fb";
} /* '' */
.uil-cloud-moon:before {
  content: "\\e8fc";
} /* '' */
.uil-cloud-question:before {
  content: "\\e8fd";
} /* '' */
.uil-cloud-rain-sun:before {
  content: "\\e8fe";
} /* '' */
.uil-cloud-rain:before {
  content: "\\e8ff";
} /* '' */
.uil-cloud-redo:before {
  content: "\\e900";
} /* '' */
.uil-cloud-set:before {
  content: "\\e901";
} /* '' */
.uil-cloud-share:before {
  content: "\\e902";
} /* '' */
.uil-cloud-shield:before {
  content: "\\e903";
} /* '' */
.uil-cloud-showers-alt:before {
  content: "\\e904";
} /* '' */
.uil-cloud-showers-heavy:before {
  content: "\\e905";
} /* '' */
.uil-cloud-showers:before {
  content: "\\e906";
} /* '' */
.uil-cloud-slash:before {
  content: "\\e907";
} /* '' */
.uil-cloud-sun-hail:before {
  content: "\\e908";
} /* '' */
.uil-cloud-sun-meatball:before {
  content: "\\e909";
} /* '' */
.uil-cloud-sun-rain-alt:before {
  content: "\\e90a";
} /* '' */
.uil-cloud-sun-rain:before {
  content: "\\e90b";
} /* '' */
.uil-cloud-sun-tear:before {
  content: "\\e90c";
} /* '' */
.uil-cloud-sun:before {
  content: "\\e90d";
} /* '' */
.uil-cloud-times:before {
  content: "\\e90e";
} /* '' */
.uil-cloud-unlock:before {
  content: "\\e90f";
} /* '' */
.uil-cloud-upload:before {
  content: "\\e910";
} /* '' */
.uil-cloud-wifi:before {
  content: "\\e911";
} /* '' */
.uil-cloud-wind:before {
  content: "\\e912";
} /* '' */
.uil-cloud:before {
  content: "\\e913";
} /* '' */
.uil-clouds:before {
  content: "\\e914";
} /* '' */
.uil-club:before {
  content: "\\e915";
} /* '' */
.uil-code:before {
  content: "\\e916";
} /* '' */
.uil-coffee:before {
  content: "\\e917";
} /* '' */
.uil-cog:before {
  content: "\\e918";
} /* '' */
.uil-coins:before {
  content: "\\e919";
} /* '' */
.uil-columns:before {
  content: "\\e91a";
} /* '' */
.uil-comment-alt-block:before {
  content: "\\e91b";
} /* '' */
.uil-comment-alt-chart-lines:before {
  content: "\\e91c";
} /* '' */
.uil-comment-alt-check:before {
  content: "\\e91d";
} /* '' */
.uil-comment-alt-dots:before {
  content: "\\e91e";
} /* '' */
.uil-comment-alt-download:before {
  content: "\\e91f";
} /* '' */
.uil-comment-alt-edit:before {
  content: "\\e920";
} /* '' */
.uil-comment-alt-exclamation:before {
  content: "\\e921";
} /* '' */
.uil-comment-alt-heart:before {
  content: "\\e922";
} /* '' */
.uil-comment-alt-image:before {
  content: "\\e923";
} /* '' */
.uil-comment-alt-info:before {
  content: "\\e924";
} /* '' */
.uil-comment-alt-lines:before {
  content: "\\e925";
} /* '' */
.uil-comment-alt-lock:before {
  content: "\\e926";
} /* '' */
.uil-comment-alt-medical:before {
  content: "\\e927";
} /* '' */
.uil-comment-alt-message:before {
  content: "\\e928";
} /* '' */
.uil-comment-alt-notes:before {
  content: "\\e929";
} /* '' */
.uil-comment-alt-plus:before {
  content: "\\e92a";
} /* '' */
.uil-comment-alt-question:before {
  content: "\\e92b";
} /* '' */
.uil-comment-alt-redo:before {
  content: "\\e92c";
} /* '' */
.uil-comment-alt-search:before {
  content: "\\e92d";
} /* '' */
.uil-comment-alt-share:before {
  content: "\\e92e";
} /* '' */
.uil-comment-alt-shield:before {
  content: "\\e92f";
} /* '' */
.uil-comment-alt-slash:before {
  content: "\\e930";
} /* '' */
.uil-comment-alt-upload:before {
  content: "\\e931";
} /* '' */
.uil-comment-alt-verify:before {
  content: "\\e932";
} /* '' */
.uil-comment-alt:before {
  content: "\\e933";
} /* '' */
.uil-comment-block:before {
  content: "\\e934";
} /* '' */
.uil-comment-chart-line:before {
  content: "\\e935";
} /* '' */
.uil-comment-check:before {
  content: "\\e936";
} /* '' */
.uil-comment-dots:before {
  content: "\\e937";
} /* '' */
.uil-comment-download:before {
  content: "\\e938";
} /* '' */
.uil-comment-edit:before {
  content: "\\e939";
} /* '' */
.uil-comment-exclamation:before {
  content: "\\e93a";
} /* '' */
.uil-comment-heart:before {
  content: "\\e93b";
} /* '' */
.uil-comment-image:before {
  content: "\\e93c";
} /* '' */
.uil-comment-info-alt:before {
  content: "\\e93d";
} /* '' */
.uil-comment-info:before {
  content: "\\e93e";
} /* '' */
.uil-comment-lines:before {
  content: "\\e93f";
} /* '' */
.uil-comment-lock:before {
  content: "\\e940";
} /* '' */
.uil-comment-medical:before {
  content: "\\e941";
} /* '' */
.uil-comment-message:before {
  content: "\\e942";
} /* '' */
.uil-comment-notes:before {
  content: "\\e943";
} /* '' */
.uil-comment-plus:before {
  content: "\\e944";
} /* '' */
.uil-comment-question:before {
  content: "\\e945";
} /* '' */
.uil-comment-redo:before {
  content: "\\e946";
} /* '' */
.uil-comment-search:before {
  content: "\\e947";
} /* '' */
.uil-comment-share:before {
  content: "\\e948";
} /* '' */
.uil-comment-shield:before {
  content: "\\e949";
} /* '' */
.uil-comment-slash:before {
  content: "\\e94a";
} /* '' */
.uil-comment-upload:before {
  content: "\\e94b";
} /* '' */
.uil-comment-verify:before {
  content: "\\e94c";
} /* '' */
.uil-comment:before {
  content: "\\e94d";
} /* '' */
.uil-comments-alt:before {
  content: "\\e94e";
} /* '' */
.uil-comments:before {
  content: "\\e94f";
} /* '' */
.uil-commnet-alt-slash:before {
  content: "\\e950";
} /* '' */
.uil-compact-disc:before {
  content: "\\e951";
} /* '' */
.uil-compass:before {
  content: "\\e952";
} /* '' */
.uil-compress-alt-left:before {
  content: "\\e953";
} /* '' */
.uil-compress-alt:before {
  content: "\\e954";
} /* '' */
.uil-compress-arrows:before {
  content: "\\e955";
} /* '' */
.uil-compress-lines:before {
  content: "\\e956";
} /* '' */
.uil-compress-point:before {
  content: "\\e957";
} /* '' */
.uil-compress-v:before {
  content: "\\e958";
} /* '' */
.uil-compress:before {
  content: "\\e959";
} /* '' */
.uil-computer-mouse:before {
  content: "\\e95a";
} /* '' */
.uil-confused:before {
  content: "\\e95b";
} /* '' */
.uil-constructor:before {
  content: "\\e95c";
} /* '' */
.uil-copy-alt:before {
  content: "\\e95d";
} /* '' */
.uil-copy-landscape:before {
  content: "\\e95e";
} /* '' */
.uil-copy:before {
  content: "\\e95f";
} /* '' */
.uil-copyright:before {
  content: "\\e960";
} /* '' */
.uil-corner-down-left:before {
  content: "\\e961";
} /* '' */
.uil-corner-down-right-alt:before {
  content: "\\e962";
} /* '' */
.uil-corner-down-right:before {
  content: "\\e963";
} /* '' */
.uil-corner-left-down:before {
  content: "\\e964";
} /* '' */
.uil-corner-right-down:before {
  content: "\\e965";
} /* '' */
.uil-corner-up-left-alt:before {
  content: "\\e966";
} /* '' */
.uil-corner-up-left:before {
  content: "\\e967";
} /* '' */
.uil-corner-up-right-alt:before {
  content: "\\e968";
} /* '' */
.uil-corner-up-right:before {
  content: "\\e969";
} /* '' */
.uil-creative-commons-pd-alt:before {
  content: "\\e96a";
} /* '' */
.uil-creative-commons-pd:before {
  content: "\\e96b";
} /* '' */
.uil-crockery:before {
  content: "\\e96c";
} /* '' */
.uil-crop-alt-rotate-left:before {
  content: "\\e96d";
} /* '' */
.uil-crop-alt-rotate-right:before {
  content: "\\e96e";
} /* '' */
.uil-crop-alt:before {
  content: "\\e96f";
} /* '' */
.uil-crosshair-alt:before {
  content: "\\e970";
} /* '' */
.uil-crosshair:before {
  content: "\\e971";
} /* '' */
.uil-crosshairs:before {
  content: "\\e972";
} /* '' */
.uil-cube:before {
  content: "\\e973";
} /* '' */
.uil-dashboard:before {
  content: "\\e974";
} /* '' */
.uil-data-sharing:before {
  content: "\\e975";
} /* '' */
.uil-database-alt:before {
  content: "\\e976";
} /* '' */
.uil-database:before {
  content: "\\e977";
} /* '' */
.uil-desert:before {
  content: "\\e978";
} /* '' */
.uil-desktop-alt-slash:before {
  content: "\\e979";
} /* '' */
.uil-desktop-alt:before {
  content: "\\e97a";
} /* '' */
.uil-desktop-cloud-alt:before {
  content: "\\e97b";
} /* '' */
.uil-desktop-slash:before {
  content: "\\e97c";
} /* '' */
.uil-desktop:before {
  content: "\\e97d";
} /* '' */
.uil-dialpad-alt:before {
  content: "\\e97e";
} /* '' */
.uil-dialpad:before {
  content: "\\e97f";
} /* '' */
.uil-diamond:before {
  content: "\\e980";
} /* '' */
.uil-diary-alt:before {
  content: "\\e981";
} /* '' */
.uil-diary:before {
  content: "\\e982";
} /* '' */
.uil-dice-five:before {
  content: "\\e983";
} /* '' */
.uil-dice-four:before {
  content: "\\e984";
} /* '' */
.uil-dice-one:before {
  content: "\\e985";
} /* '' */
.uil-dice-six:before {
  content: "\\e986";
} /* '' */
.uil-dice-three:before {
  content: "\\e987";
} /* '' */
.uil-dice-two:before {
  content: "\\e988";
} /* '' */
.uil-direction:before {
  content: "\\e989";
} /* '' */
.uil-directions:before {
  content: "\\e98a";
} /* '' */
.uil-dizzy-meh:before {
  content: "\\e98b";
} /* '' */
.uil-dna:before {
  content: "\\e98c";
} /* '' */
.uil-document-layout-center:before {
  content: "\\e98d";
} /* '' */
.uil-document-layout-left:before {
  content: "\\e98e";
} /* '' */
.uil-document-layout-right:before {
  content: "\\e98f";
} /* '' */
.uil-document:before {
  content: "\\e990";
} /* '' */
.uil-dollar-alt:before {
  content: "\\e991";
} /* '' */
.uil-dollar-sign-alt:before {
  content: "\\e992";
} /* '' */
.uil-dollar-sign:before {
  content: "\\e993";
} /* '' */
.uil-down-arrow:before {
  content: "\\e994";
} /* '' */
.uil-download-alt:before {
  content: "\\e995";
} /* '' */
.uil-dribbble:before {
  content: "\\e996";
} /* '' */
.uil-drill:before {
  content: "\\e997";
} /* '' */
.uil-dropbox:before {
  content: "\\e998";
} /* '' */
.uil-dumbbell:before {
  content: "\\e999";
} /* '' */
.uil-ear:before {
  content: "\\e99a";
} /* '' */
.uil-edit-alt:before {
  content: "\\e99b";
} /* '' */
.uil-edit:before {
  content: "\\e99c";
} /* '' */
.uil-ellipsis-h:before {
  content: "\\e99d";
} /* '' */
.uil-ellipsis-v:before {
  content: "\\e99e";
} /* '' */
.uil-emoji:before {
  content: "\\e99f";
} /* '' */
.uil-enter:before {
  content: "\\e9a0";
} /* '' */
.uil-entry:before {
  content: "\\e9a1";
} /* '' */
.uil-envelope-add:before {
  content: "\\e9a2";
} /* '' */
.uil-envelope-alt:before {
  content: "\\e9a3";
} /* '' */
.uil-envelope-block:before {
  content: "\\e9a4";
} /* '' */
.uil-envelope-bookmark:before {
  content: "\\e9a5";
} /* '' */
.uil-envelope-check:before {
  content: "\\e9a6";
} /* '' */
.uil-envelope-download-alt:before {
  content: "\\e9a7";
} /* '' */
.uil-envelope-download:before {
  content: "\\e9a8";
} /* '' */
.uil-envelope-edit:before {
  content: "\\e9a9";
} /* '' */
.uil-envelope-exclamation:before {
  content: "\\e9aa";
} /* '' */
.uil-envelope-heart:before {
  content: "\\e9ab";
} /* '' */
.uil-envelope-info:before {
  content: "\\e9ac";
} /* '' */
.uil-envelope-lock:before {
  content: "\\e9ad";
} /* '' */
.uil-envelope-minus:before {
  content: "\\e9ae";
} /* '' */
.uil-envelope-open:before {
  content: "\\e9af";
} /* '' */
.uil-envelope-question:before {
  content: "\\e9b0";
} /* '' */
.uil-envelope-receive:before {
  content: "\\e9b1";
} /* '' */
.uil-envelope-redo:before {
  content: "\\e9b2";
} /* '' */
.uil-envelope-search:before {
  content: "\\e9b3";
} /* '' */
.uil-envelope-send:before {
  content: "\\e9b4";
} /* '' */
.uil-envelope-share:before {
  content: "\\e9b5";
} /* '' */
.uil-envelope-shield:before {
  content: "\\e9b6";
} /* '' */
.uil-envelope-star:before {
  content: "\\e9b7";
} /* '' */
.uil-envelope-times:before {
  content: "\\e9b8";
} /* '' */
.uil-envelope-upload-alt:before {
  content: "\\e9b9";
} /* '' */
.uil-envelope-upload:before {
  content: "\\e9ba";
} /* '' */
.uil-envelope:before {
  content: "\\e9bb";
} /* '' */
.uil-envelopes:before {
  content: "\\e9bc";
} /* '' */
.uil-equal-circle:before {
  content: "\\e9bd";
} /* '' */
.uil-euro-circle:before {
  content: "\\e9be";
} /* '' */
.uil-euro:before {
  content: "\\e9bf";
} /* '' */
.uil-exchange-alt:before {
  content: "\\e9c0";
} /* '' */
.uil-exchange:before {
  content: "\\e9c1";
} /* '' */
.uil-exclamation-circle:before {
  content: "\\e9c2";
} /* '' */
.uil-exclamation-octagon:before {
  content: "\\e9c3";
} /* '' */
.uil-exclamation-triangle:before {
  content: "\\e9c4";
} /* '' */
.uil-exclude:before {
  content: "\\e9c5";
} /* '' */
.uil-exit:before {
  content: "\\e9c6";
} /* '' */
.uil-expand-alt:before {
  content: "\\e9c7";
} /* '' */
.uil-expand-arrows-alt:before {
  content: "\\e9c8";
} /* '' */
.uil-expand-arrows:before {
  content: "\\e9c9";
} /* '' */
.uil-expand-from-corner:before {
  content: "\\e9ca";
} /* '' */
.uil-expand-left:before {
  content: "\\e9cb";
} /* '' */
.uil-expand-right:before {
  content: "\\e9cc";
} /* '' */
.uil-export:before {
  content: "\\e9cd";
} /* '' */
.uil-exposure-alt:before {
  content: "\\e9ce";
} /* '' */
.uil-exposure-increase:before {
  content: "\\e9cf";
} /* '' */
.uil-external-link-alt:before {
  content: "\\e9d0";
} /* '' */
.uil-eye-slash:before {
  content: "\\e9d1";
} /* '' */
.uil-eye:before {
  content: "\\e9d2";
} /* '' */
.uil-facebook-f:before {
  content: "\\e9d3";
} /* '' */
.uil-facebook-messenger-alt:before {
  content: "\\e9d4";
} /* '' */
.uil-facebook-messenger:before {
  content: "\\e9d5";
} /* '' */
.uil-facebook:before {
  content: "\\e9d6";
} /* '' */
.uil-fahrenheit:before {
  content: "\\e9d7";
} /* '' */
.uil-fast-mail-alt:before {
  content: "\\e9d8";
} /* '' */
.uil-fast-mail:before {
  content: "\\e9d9";
} /* '' */
.uil-favorite:before {
  content: "\\e9da";
} /* '' */
.uil-feedback:before {
  content: "\\e9db";
} /* '' */
.uil-file-alt:before {
  content: "\\e9dc";
} /* '' */
.uil-file-blank:before {
  content: "\\e9dd";
} /* '' */
.uil-file-block-alt:before {
  content: "\\e9de";
} /* '' */
.uil-file-bookmark-alt:before {
  content: "\\e9df";
} /* '' */
.uil-file-check-alt:before {
  content: "\\e9e0";
} /* '' */
.uil-file-check:before {
  content: "\\e9e1";
} /* '' */
.uil-file-contract-dollar:before {
  content: "\\e9e2";
} /* '' */
.uil-file-copy-alt:before {
  content: "\\e9e3";
} /* '' */
.uil-file-download-alt:before {
  content: "\\e9e4";
} /* '' */
.uil-file-download:before {
  content: "\\e9e5";
} /* '' */
.uil-file-edit-alt:before {
  content: "\\e9e6";
} /* '' */
.uil-file-exclamation-alt:before {
  content: "\\e9e7";
} /* '' */
.uil-file-exclamation:before {
  content: "\\e9e8";
} /* '' */
.uil-file-heart:before {
  content: "\\e9e9";
} /* '' */
.uil-file-info-alt:before {
  content: "\\e9ea";
} /* '' */
.uil-file-landscape-alt:before {
  content: "\\e9eb";
} /* '' */
.uil-file-landscape:before {
  content: "\\e9ec";
} /* '' */
.uil-file-lanscape-slash:before {
  content: "\\e9ed";
} /* '' */
.uil-file-lock-alt:before {
  content: "\\e9ee";
} /* '' */
.uil-file-medical-alt:before {
  content: "\\e9ef";
} /* '' */
.uil-file-medical:before {
  content: "\\e9f0";
} /* '' */
.uil-file-minus-alt:before {
  content: "\\e9f1";
} /* '' */
.uil-file-minus:before {
  content: "\\e9f2";
} /* '' */
.uil-file-network:before {
  content: "\\e9f3";
} /* '' */
.uil-file-plus-alt:before {
  content: "\\e9f4";
} /* '' */
.uil-file-plus:before {
  content: "\\e9f5";
} /* '' */
.uil-file-question-alt:before {
  content: "\\e9f6";
} /* '' */
.uil-file-question:before {
  content: "\\e9f7";
} /* '' */
.uil-file-redo-alt:before {
  content: "\\e9f8";
} /* '' */
.uil-file-search-alt:before {
  content: "\\e9f9";
} /* '' */
.uil-file-share-alt:before {
  content: "\\e9fa";
} /* '' */
.uil-file-shield-alt:before {
  content: "\\e9fb";
} /* '' */
.uil-file-slash:before {
  content: "\\e9fc";
} /* '' */
.uil-file-times-alt:before {
  content: "\\e9fd";
} /* '' */
.uil-file-times:before {
  content: "\\e9fe";
} /* '' */
.uil-file-upload-alt:before {
  content: "\\e9ff";
} /* '' */
.uil-file-upload:before {
  content: "\\ea00";
} /* '' */
.uil-file:before {
  content: "\\ea01";
} /* '' */
.uil-files-landscapes-alt:before {
  content: "\\ea02";
} /* '' */
.uil-files-landscapes:before {
  content: "\\ea03";
} /* '' */
.uil-film:before {
  content: "\\ea04";
} /* '' */
.uil-filter-slash:before {
  content: "\\ea05";
} /* '' */
.uil-filter:before {
  content: "\\ea06";
} /* '' */
.uil-fire:before {
  content: "\\ea07";
} /* '' */
.uil-flask-potion:before {
  content: "\\ea08";
} /* '' */
.uil-flask:before {
  content: "\\ea09";
} /* '' */
.uil-flip-h-alt:before {
  content: "\\ea0a";
} /* '' */
.uil-flip-h:before {
  content: "\\ea0b";
} /* '' */
.uil-flip-v-alt:before {
  content: "\\ea0c";
} /* '' */
.uil-flip-v:before {
  content: "\\ea0d";
} /* '' */
.uil-flower:before {
  content: "\\ea0e";
} /* '' */
.uil-focus-add:before {
  content: "\\ea0f";
} /* '' */
.uil-focus-target:before {
  content: "\\ea10";
} /* '' */
.uil-focus:before {
  content: "\\ea11";
} /* '' */
.uil-folder-check:before {
  content: "\\ea12";
} /* '' */
.uil-folder-download:before {
  content: "\\ea13";
} /* '' */
.uil-folder-exclamation:before {
  content: "\\ea14";
} /* '' */
.uil-folder-heart:before {
  content: "\\ea15";
} /* '' */
.uil-folder-info:before {
  content: "\\ea16";
} /* '' */
.uil-folder-lock:before {
  content: "\\ea17";
} /* '' */
.uil-folder-medical:before {
  content: "\\ea18";
} /* '' */
.uil-folder-minus:before {
  content: "\\ea19";
} /* '' */
.uil-folder-network:before {
  content: "\\ea1a";
} /* '' */
.uil-folder-plus:before {
  content: "\\ea1b";
} /* '' */
.uil-folder-question:before {
  content: "\\ea1c";
} /* '' */
.uil-folder-slash:before {
  content: "\\ea1d";
} /* '' */
.uil-folder-times:before {
  content: "\\ea1e";
} /* '' */
.uil-folder-upload:before {
  content: "\\ea1f";
} /* '' */
.uil-folder:before {
  content: "\\ea20";
} /* '' */
.uil-food:before {
  content: "\\ea21";
} /* '' */
.uil-football-american:before {
  content: "\\ea22";
} /* '' */
.uil-football-ball:before {
  content: "\\ea23";
} /* '' */
.uil-football:before {
  content: "\\ea24";
} /* '' */
.uil-forecastcloud-moon-tear:before {
  content: "\\ea25";
} /* '' */
.uil-forwaded-call:before {
  content: "\\ea26";
} /* '' */
.uil-forward:before {
  content: "\\ea27";
} /* '' */
.uil-frown:before {
  content: "\\ea28";
} /* '' */
.uil-game-structure:before {
  content: "\\ea29";
} /* '' */
.uil-game:before {
  content: "\\ea2a";
} /* '' */
.uil-gift:before {
  content: "\\ea2b";
} /* '' */
.uil-github-alt:before {
  content: "\\ea2c";
} /* '' */
.uil-github:before {
  content: "\\ea2d";
} /* '' */
.uil-glass-martini-alt-slash:before {
  content: "\\ea2e";
} /* '' */
.uil-glass-martini-alt:before {
  content: "\\ea2f";
} /* '' */
.uil-glass-martini:before {
  content: "\\ea30";
} /* '' */
.uil-glass-tea:before {
  content: "\\ea31";
} /* '' */
.uil-glass:before {
  content: "\\ea32";
} /* '' */
.uil-globe:before {
  content: "\\ea33";
} /* '' */
.uil-gold:before {
  content: "\\ea34";
} /* '' */
.uil-google-drive-alt:before {
  content: "\\ea35";
} /* '' */
.uil-google-drive:before {
  content: "\\ea36";
} /* '' */
.uil-google-hangouts-alt:before {
  content: "\\ea37";
} /* '' */
.uil-google-hangouts:before {
  content: "\\ea38";
} /* '' */
.uil-google-play:before {
  content: "\\ea39";
} /* '' */
.uil-google:before {
  content: "\\ea3a";
} /* '' */
.uil-graduation-hat:before {
  content: "\\ea3b";
} /* '' */
.uil-graph-bar:before {
  content: "\\ea3c";
} /* '' */
.uil-grid:before {
  content: "\\ea3d";
} /* '' */
.uil-grids:before {
  content: "\\ea3e";
} /* '' */
.uil-grin-tongue-wink-alt:before {
  content: "\\ea3f";
} /* '' */
.uil-grin-tongue-wink:before {
  content: "\\ea40";
} /* '' */
.uil-grin:before {
  content: "\\ea41";
} /* '' */
.uil-grip-horizontal-line:before {
  content: "\\ea42";
} /* '' */
.uil-hdd:before {
  content: "\\ea43";
} /* '' */
.uil-headphones-alt:before {
  content: "\\ea44";
} /* '' */
.uil-headphones:before {
  content: "\\ea45";
} /* '' */
.uil-heart-alt:before {
  content: "\\ea46";
} /* '' */
.uil-heart-medical:before {
  content: "\\ea47";
} /* '' */
.uil-heart-rate:before {
  content: "\\ea48";
} /* '' */
.uil-heart-sign:before {
  content: "\\ea49";
} /* '' */
.uil-heart:before {
  content: "\\ea4a";
} /* '' */
.uil-heartbeat:before {
  content: "\\ea4b";
} /* '' */
.uil-history-alt:before {
  content: "\\ea4c";
} /* '' */
.uil-history:before {
  content: "\\ea4d";
} /* '' */
.uil-home-alt:before {
  content: "\\ea4e";
} /* '' */
.uil-home:before {
  content: "\\ea4f";
} /* '' */
.uil-horizontal-align-center:before {
  content: "\\ea50";
} /* '' */
.uil-horizontal-align-left:before {
  content: "\\ea51";
} /* '' */
.uil-horizontal-align-right:before {
  content: "\\ea52";
} /* '' */
.uil-horizontal-distribution-center:before {
  content: "\\ea53";
} /* '' */
.uil-horizontal-distribution-left:before {
  content: "\\ea54";
} /* '' */
.uil-horizontal-distribution-right:before {
  content: "\\ea55";
} /* '' */
.uil-hourglass:before {
  content: "\\ea56";
} /* '' */
.uil-html3-alt:before {
  content: "\\ea57";
} /* '' */
.uil-html3:before {
  content: "\\ea58";
} /* '' */
.uil-hunting:before {
  content: "\\ea59";
} /* '' */
.uil-image-alt-slash:before {
  content: "\\ea5a";
} /* '' */
.uil-image-block:before {
  content: "\\ea5b";
} /* '' */
.uil-image-broken:before {
  content: "\\ea5c";
} /* '' */
.uil-image-check:before {
  content: "\\ea5d";
} /* '' */
.uil-image-download:before {
  content: "\\ea5e";
} /* '' */
.uil-image-edit:before {
  content: "\\ea5f";
} /* '' */
.uil-image-lock:before {
  content: "\\ea60";
} /* '' */
.uil-image-minus:before {
  content: "\\ea61";
} /* '' */
.uil-image-plus:before {
  content: "\\ea62";
} /* '' */
.uil-image-question:before {
  content: "\\ea63";
} /* '' */
.uil-image-redo:before {
  content: "\\ea64";
} /* '' */
.uil-image-resize-landscape:before {
  content: "\\ea65";
} /* '' */
.uil-image-resize-square:before {
  content: "\\ea66";
} /* '' */
.uil-image-search:before {
  content: "\\ea67";
} /* '' */
.uil-image-share:before {
  content: "\\ea68";
} /* '' */
.uil-image-shield:before {
  content: "\\ea69";
} /* '' */
.uil-image-slash:before {
  content: "\\ea6a";
} /* '' */
.uil-image-times:before {
  content: "\\ea6b";
} /* '' */
.uil-image-upload:before {
  content: "\\ea6c";
} /* '' */
.uil-image-v:before {
  content: "\\ea6d";
} /* '' */
.uil-image:before {
  content: "\\ea6e";
} /* '' */
.uil-images:before {
  content: "\\ea6f";
} /* '' */
.uil-import:before {
  content: "\\ea70";
} /* '' */
.uil-incoming-call:before {
  content: "\\ea71";
} /* '' */
.uil-info-circle:before {
  content: "\\ea72";
} /* '' */
.uil-instagram-alt:before {
  content: "\\ea73";
} /* '' */
.uil-instagram:before {
  content: "\\ea74";
} /* '' */
.uil-intercom-alt:before {
  content: "\\ea75";
} /* '' */
.uil-intercom:before {
  content: "\\ea76";
} /* '' */
.uil-invoice:before {
  content: "\\ea77";
} /* '' */
.uil-italic:before {
  content: "\\ea78";
} /* '' */
.uil-jackhammer:before {
  content: "\\ea79";
} /* '' */
.uil-java-script:before {
  content: "\\ea7a";
} /* '' */
.uil-kayak:before {
  content: "\\ea7b";
} /* '' */
.uil-key-skeleton-alt:before {
  content: "\\ea7c";
} /* '' */
.uil-key-skeleton:before {
  content: "\\ea7d";
} /* '' */
.uil-keyboard-alt:before {
  content: "\\ea7e";
} /* '' */
.uil-keyboard-hide:before {
  content: "\\ea7f";
} /* '' */
.uil-keyboard-show:before {
  content: "\\ea80";
} /* '' */
.uil-keyboard:before {
  content: "\\ea81";
} /* '' */
.uil-keyhole-circle:before {
  content: "\\ea82";
} /* '' */
.uil-keyhole-square-full:before {
  content: "\\ea83";
} /* '' */
.uil-keyhole-square:before {
  content: "\\ea84";
} /* '' */
.uil-kid:before {
  content: "\\ea85";
} /* '' */
.uil-label-alt:before {
  content: "\\ea86";
} /* '' */
.uil-label:before {
  content: "\\ea87";
} /* '' */
.uil-lamp:before {
  content: "\\ea88";
} /* '' */
.uil-laptop-cloud:before {
  content: "\\ea89";
} /* '' */
.uil-laptop:before {
  content: "\\ea8a";
} /* '' */
.uil-laughing:before {
  content: "\\ea8b";
} /* '' */
.uil-layer-group-slash:before {
  content: "\\ea8c";
} /* '' */
.uil-layer-group:before {
  content: "\\ea8d";
} /* '' */
.uil-layers-alt:before {
  content: "\\ea8e";
} /* '' */
.uil-layers-slash:before {
  content: "\\ea8f";
} /* '' */
.uil-layers:before {
  content: "\\ea90";
} /* '' */
.uil-left-arrow-from-left:before {
  content: "\\ea91";
} /* '' */
.uil-left-arrow-to-left:before {
  content: "\\ea92";
} /* '' */
.uil-left-indent-alt:before {
  content: "\\ea93";
} /* '' */
.uil-left-indent:before {
  content: "\\ea94";
} /* '' */
.uil-left-to-right-text-direction:before {
  content: "\\ea95";
} /* '' */
.uil-life-ring:before {
  content: "\\ea96";
} /* '' */
.uil-lightbulb-alt:before {
  content: "\\ea97";
} /* '' */
.uil-lightbulb:before {
  content: "\\ea98";
} /* '' */
.uil-line-alt:before {
  content: "\\ea99";
} /* '' */
.uil-line-spacing:before {
  content: "\\ea9a";
} /* '' */
.uil-line:before {
  content: "\\ea9b";
} /* '' */
.uil-link-alt:before {
  content: "\\ea9c";
} /* '' */
.uil-link-broken:before {
  content: "\\ea9d";
} /* '' */
.uil-link-h:before {
  content: "\\ea9e";
} /* '' */
.uil-link:before {
  content: "\\ea9f";
} /* '' */
.uil-linkedin-alt:before {
  content: "\\eaa0";
} /* '' */
.uil-linkedin:before {
  content: "\\eaa1";
} /* '' */
.uil-list-ui-alt:before {
  content: "\\eaa2";
} /* '' */
.uil-list-ul:before {
  content: "\\eaa3";
} /* '' */
.uil-location-arrow-alt:before {
  content: "\\eaa4";
} /* '' */
.uil-location-arrow:before {
  content: "\\eaa5";
} /* '' */
.uil-location-pin-alt:before {
  content: "\\eaa6";
} /* '' */
.uil-location-point:before {
  content: "\\eaa7";
} /* '' */
.uil-location:before {
  content: "\\eaa8";
} /* '' */
.uil-lock-access:before {
  content: "\\eaa9";
} /* '' */
.uil-lock-alt:before {
  content: "\\eaaa";
} /* '' */
.uil-lock-open-alt:before {
  content: "\\eaab";
} /* '' */
.uil-lock-slash:before {
  content: "\\eaac";
} /* '' */
.uil-lock:before {
  content: "\\eaad";
} /* '' */
.uil-mailbox-alt:before {
  content: "\\eaae";
} /* '' */
.uil-mailbox:before {
  content: "\\eaaf";
} /* '' */
.uil-map-marker-alt:before {
  content: "\\eab0";
} /* '' */
.uil-map-marker-edit:before {
  content: "\\eab1";
} /* '' */
.uil-map-marker-info:before {
  content: "\\eab2";
} /* '' */
.uil-map-marker-minus:before {
  content: "\\eab3";
} /* '' */
.uil-map-marker-plus:before {
  content: "\\eab4";
} /* '' */
.uil-map-marker-question:before {
  content: "\\eab5";
} /* '' */
.uil-map-marker-shield:before {
  content: "\\eab6";
} /* '' */
.uil-map-marker-slash:before {
  content: "\\eab7";
} /* '' */
.uil-map-marker:before {
  content: "\\eab8";
} /* '' */
.uil-map-pin-alt:before {
  content: "\\eab9";
} /* '' */
.uil-map-pin:before {
  content: "\\eaba";
} /* '' */
.uil-map:before {
  content: "\\eabb";
} /* '' */
.uil-mars:before {
  content: "\\eabc";
} /* '' */
.uil-master-card:before {
  content: "\\eabd";
} /* '' */
.uil-maximize-left:before {
  content: "\\eabe";
} /* '' */
.uil-medal:before {
  content: "\\eabf";
} /* '' */
.uil-medical-drip:before {
  content: "\\eac0";
} /* '' */
.uil-medical-square-full:before {
  content: "\\eac1";
} /* '' */
.uil-medical-square:before {
  content: "\\eac2";
} /* '' */
.uil-medical:before {
  content: "\\eac3";
} /* '' */
.uil-medium-m:before {
  content: "\\eac4";
} /* '' */
.uil-medkit:before {
  content: "\\eac5";
} /* '' */
.uil-meeting-board:before {
  content: "\\eac6";
} /* '' */
.uil-megaphone:before {
  content: "\\eac7";
} /* '' */
.uil-meh-alt:before {
  content: "\\eac8";
} /* '' */
.uil-meh-closed-eye:before {
  content: "\\eac9";
} /* '' */
.uil-meh:before {
  content: "\\eaca";
} /* '' */
.uil-message:before {
  content: "\\eacb";
} /* '' */
.uil-metro:before {
  content: "\\eacc";
} /* '' */
.uil-microphone-slash:before {
  content: "\\eacd";
} /* '' */
.uil-microphone:before {
  content: "\\eace";
} /* '' */
.uil-minus-circle:before {
  content: "\\eacf";
} /* '' */
.uil-minus-path:before {
  content: "\\ead0";
} /* '' */
.uil-minus-square-full:before {
  content: "\\ead1";
} /* '' */
.uil-minus-square:before {
  content: "\\ead2";
} /* '' */
.uil-minus:before {
  content: "\\ead3";
} /* '' */
.uil-missed-call:before {
  content: "\\ead4";
} /* '' */
.uil-mobey-bill-slash:before {
  content: "\\ead5";
} /* '' */
.uil-mobile-android-alt:before {
  content: "\\ead6";
} /* '' */
.uil-mobile-android:before {
  content: "\\ead7";
} /* '' */
.uil-mobile-vibrate:before {
  content: "\\ead8";
} /* '' */
.uil-modem:before {
  content: "\\ead9";
} /* '' */
.uil-money-bill-stack:before {
  content: "\\eada";
} /* '' */
.uil-money-bill:before {
  content: "\\eadb";
} /* '' */
.uil-money-insert:before {
  content: "\\eadc";
} /* '' */
.uil-money-stack:before {
  content: "\\eadd";
} /* '' */
.uil-money-withdraw:before {
  content: "\\eade";
} /* '' */
.uil-money-withdrawal:before {
  content: "\\eadf";
} /* '' */
.uil-moneybag-alt:before {
  content: "\\eae0";
} /* '' */
.uil-moneybag:before {
  content: "\\eae1";
} /* '' */
.uil-monitor-heart-rate:before {
  content: "\\eae2";
} /* '' */
.uil-monitor:before {
  content: "\\eae3";
} /* '' */
.uil-moon-eclipse:before {
  content: "\\eae4";
} /* '' */
.uil-moon:before {
  content: "\\eae5";
} /* '' */
.uil-moonset:before {
  content: "\\eae6";
} /* '' */
.uil-mountains-sun:before {
  content: "\\eae7";
} /* '' */
.uil-mountains:before {
  content: "\\eae8";
} /* '' */
.uil-mouse-alt:before {
  content: "\\eae9";
} /* '' */
.uil-mouse:before {
  content: "\\eaea";
} /* '' */
.uil-multiply:before {
  content: "\\eaeb";
} /* '' */
.uil-music-note:before {
  content: "\\eaec";
} /* '' */
.uil-music-tune-slash:before {
  content: "\\eaed";
} /* '' */
.uil-music:before {
  content: "\\eaee";
} /* '' */
.uil-n-a:before {
  content: "\\eaef";
} /* '' */
.uil-navigator:before {
  content: "\\eaf0";
} /* '' */
.uil-nerd:before {
  content: "\\eaf1";
} /* '' */
.uil-newspaper:before {
  content: "\\eaf2";
} /* '' */
.uil-ninja:before {
  content: "\\eaf3";
} /* '' */
.uil-no-entry:before {
  content: "\\eaf4";
} /* '' */
.uil-notebooks:before {
  content: "\\eaf5";
} /* '' */
.uil-notes:before {
  content: "\\eaf6";
} /* '' */
.uil-object-group:before {
  content: "\\eaf7";
} /* '' */
.uil-object-ungroup:before {
  content: "\\eaf8";
} /* '' */
.uil-octagon:before {
  content: "\\eaf9";
} /* '' */
.uil-opera-alt:before {
  content: "\\eafa";
} /* '' */
.uil-opera:before {
  content: "\\eafb";
} /* '' */
.uil-outgoing-call:before {
  content: "\\eafc";
} /* '' */
.uil-package:before {
  content: "\\eafd";
} /* '' */
.uil-padlock:before {
  content: "\\eafe";
} /* '' */
.uil-paint-tool:before {
  content: "\\eaff";
} /* '' */
.uil-palette:before {
  content: "\\eb00";
} /* '' */
.uil-panorama-h-alt:before {
  content: "\\eb01";
} /* '' */
.uil-panorama-h:before {
  content: "\\eb02";
} /* '' */
.uil-panorama-v:before {
  content: "\\eb03";
} /* '' */
.uil-paperclip:before {
  content: "\\eb04";
} /* '' */
.uil-paragraph:before {
  content: "\\eb05";
} /* '' */
.uil-parcel:before {
  content: "\\eb06";
} /* '' */
.uil-parking-square:before {
  content: "\\eb07";
} /* '' */
.uil-pathfinder-unite:before {
  content: "\\eb08";
} /* '' */
.uil-pathfinder:before {
  content: "\\eb09";
} /* '' */
.uil-pause-circle:before {
  content: "\\eb0a";
} /* '' */
.uil-pause:before {
  content: "\\eb0b";
} /* '' */
.uil-paypal:before {
  content: "\\eb0c";
} /* '' */
.uil-pen:before {
  content: "\\eb0d";
} /* '' */
.uil-pentagon:before {
  content: "\\eb0e";
} /* '' */
.uil-percentage:before {
  content: "\\eb0f";
} /* '' */
.uil-phone-alt:before {
  content: "\\eb10";
} /* '' */
.uil-phone-pause:before {
  content: "\\eb11";
} /* '' */
.uil-phone-slash:before {
  content: "\\eb12";
} /* '' */
.uil-phone-times:before {
  content: "\\eb13";
} /* '' */
.uil-phone-volume:before {
  content: "\\eb14";
} /* '' */
.uil-phone:before {
  content: "\\eb15";
} /* '' */
.uil-picture:before {
  content: "\\eb16";
} /* '' */
.uil-plane-arrival:before {
  content: "\\eb17";
} /* '' */
.uil-plane-departure:before {
  content: "\\eb18";
} /* '' */
.uil-plane-fly:before {
  content: "\\eb19";
} /* '' */
.uil-plane:before {
  content: "\\eb1a";
} /* '' */
.uil-play-circle:before {
  content: "\\eb1b";
} /* '' */
.uil-play:before {
  content: "\\eb1c";
} /* '' */
.uil-plug:before {
  content: "\\eb1d";
} /* '' */
.uil-plus-circle:before {
  content: "\\eb1e";
} /* '' */
.uil-plus-square:before {
  content: "\\eb1f";
} /* '' */
.uil-plus:before {
  content: "\\eb20";
} /* '' */
.uil-podium:before {
  content: "\\eb21";
} /* '' */
.uil-polygon:before {
  content: "\\eb22";
} /* '' */
.uil-post-stamp:before {
  content: "\\eb23";
} /* '' */
.uil-postcard:before {
  content: "\\eb24";
} /* '' */
.uil-pound-circle:before {
  content: "\\eb25";
} /* '' */
.uil-pound:before {
  content: "\\eb26";
} /* '' */
.uil-power:before {
  content: "\\eb27";
} /* '' */
.uil-prescription-bottle:before {
  content: "\\eb28";
} /* '' */
.uil-presentation-check:before {
  content: "\\eb29";
} /* '' */
.uil-presentation-edit:before {
  content: "\\eb2a";
} /* '' */
.uil-presentation-line:before {
  content: "\\eb2b";
} /* '' */
.uil-presentation-lines-alt:before {
  content: "\\eb2c";
} /* '' */
.uil-presentation-minus:before {
  content: "\\eb2d";
} /* '' */
.uil-presentation-play:before {
  content: "\\eb2e";
} /* '' */
.uil-presentation-plus:before {
  content: "\\eb2f";
} /* '' */
.uil-presentation-times:before {
  content: "\\eb30";
} /* '' */
.uil-presentation:before {
  content: "\\eb31";
} /* '' */
.uil-previous:before {
  content: "\\eb32";
} /* '' */
.uil-pricetag-alt:before {
  content: "\\eb33";
} /* '' */
.uil-print-slash:before {
  content: "\\eb34";
} /* '' */
.uil-print:before {
  content: "\\eb35";
} /* '' */
.uil-process:before {
  content: "\\eb36";
} /* '' */
.uil-processor:before {
  content: "\\eb37";
} /* '' */
.uil-pump:before {
  content: "\\eb38";
} /* '' */
.uil-puzzle-piece:before {
  content: "\\eb39";
} /* '' */
.uil-question-circle:before {
  content: "\\eb3a";
} /* '' */
.uil-raddit-alien-alt:before {
  content: "\\eb3b";
} /* '' */
.uil-rainbow:before {
  content: "\\eb3c";
} /* '' */
.uil-raindrops-alt:before {
  content: "\\eb3d";
} /* '' */
.uil-raindrops:before {
  content: "\\eb3e";
} /* '' */
.uil-react:before {
  content: "\\eb3f";
} /* '' */
.uil-receipt-alt:before {
  content: "\\eb40";
} /* '' */
.uil-receipt:before {
  content: "\\eb41";
} /* '' */
.uil-record-audio:before {
  content: "\\eb42";
} /* '' */
.uil-reddit-alien-alt:before {
  content: "\\eb43";
} /* '' */
.uil-redo:before {
  content: "\\eb44";
} /* '' */
.uil-refresh:before {
  content: "\\eb45";
} /* '' */
.uil-registered:before {
  content: "\\eb46";
} /* '' */
.uil-repeat:before {
  content: "\\eb47";
} /* '' */
.uil-restaurant:before {
  content: "\\eb48";
} /* '' */
.uil-right-indent-alt:before {
  content: "\\eb49";
} /* '' */
.uil-right-to-left-text-direction:before {
  content: "\\eb4a";
} /* '' */
.uil-robot:before {
  content: "\\eb4b";
} /* '' */
.uil-rope-way:before {
  content: "\\eb4c";
} /* '' */
.uil-rotate-360:before {
  content: "\\eb4d";
} /* '' */
.uil-rss-alt:before {
  content: "\\eb4e";
} /* '' */
.uil-rss-interface:before {
  content: "\\eb4f";
} /* '' */
.uil-rss:before {
  content: "\\eb50";
} /* '' */
.uil-ruler-combined:before {
  content: "\\eb51";
} /* '' */
.uil-ruler:before {
  content: "\\eb52";
} /* '' */
.uil-sad-cry:before {
  content: "\\eb53";
} /* '' */
.uil-sad-crying:before {
  content: "\\eb54";
} /* '' */
.uil-sad-dizzy:before {
  content: "\\eb55";
} /* '' */
.uil-sad-squint:before {
  content: "\\eb56";
} /* '' */
.uil-sad:before {
  content: "\\eb57";
} /* '' */
.uil-scaling-left:before {
  content: "\\eb58";
} /* '' */
.uil-scaling-right:before {
  content: "\\eb59";
} /* '' */
.uil-scenery:before {
  content: "\\eb5a";
} /* '' */
.uil-schedule:before {
  content: "\\eb5b";
} /* '' */
.uil-science:before {
  content: "\\eb5c";
} /* '' */
.uil-screw:before {
  content: "\\eb5d";
} /* '' */
.uil-scroll-h:before {
  content: "\\eb5e";
} /* '' */
.uil-scroll:before {
  content: "\\eb5f";
} /* '' */
.uil-search-alt:before {
  content: "\\eb60";
} /* '' */
.uil-search-minus:before {
  content: "\\eb61";
} /* '' */
.uil-search-plus:before {
  content: "\\eb62";
} /* '' */
.uil-search:before {
  content: "\\eb63";
} /* '' */
.uil-selfie:before {
  content: "\\eb64";
} /* '' */
.uil-server-alt:before {
  content: "\\eb65";
} /* '' */
.uil-server-connection:before {
  content: "\\eb66";
} /* '' */
.uil-server-network-alt:before {
  content: "\\eb67";
} /* '' */
.uil-server-network:before {
  content: "\\eb68";
} /* '' */
.uil-server:before {
  content: "\\eb69";
} /* '' */
.uil-servers:before {
  content: "\\eb6a";
} /* '' */
.uil-servicemark:before {
  content: "\\eb6b";
} /* '' */
.uil-share-alt:before {
  content: "\\eb6c";
} /* '' */
.uil-shield-check:before {
  content: "\\eb6d";
} /* '' */
.uil-shield-exclamation:before {
  content: "\\eb6e";
} /* '' */
.uil-shield-question:before {
  content: "\\eb6f";
} /* '' */
.uil-shield-slash:before {
  content: "\\eb70";
} /* '' */
.uil-shield:before {
  content: "\\eb71";
} /* '' */
.uil-ship:before {
  content: "\\eb72";
} /* '' */
.uil-shop:before {
  content: "\\eb73";
} /* '' */
.uil-shopping-basket:before {
  content: "\\eb74";
} /* '' */
.uil-shopping-cart-alt:before {
  content: "\\eb75";
} /* '' */
.uil-shopping-trolley:before {
  content: "\\eb76";
} /* '' */
.uil-shovel:before {
  content: "\\eb77";
} /* '' */
.uil-shrink:before {
  content: "\\eb78";
} /* '' */
.uil-shuffle:before {
  content: "\\eb79";
} /* '' */
.uil-shutter-alt:before {
  content: "\\eb7a";
} /* '' */
.uil-shutter:before {
  content: "\\eb7b";
} /* '' */
.uil-sick:before {
  content: "\\eb7c";
} /* '' */
.uil-sigma:before {
  content: "\\eb7d";
} /* '' */
.uil-sign-alt:before {
  content: "\\eb7e";
} /* '' */
.uil-sign-in-alt:before {
  content: "\\eb7f";
} /* '' */
.uil-sign-left:before {
  content: "\\eb80";
} /* '' */
.uil-sign-out-alt:before {
  content: "\\eb81";
} /* '' */
.uil-sign-right:before {
  content: "\\eb82";
} /* '' */
.uil-signal-alt-3:before {
  content: "\\eb83";
} /* '' */
.uil-signal-alt:before {
  content: "\\eb84";
} /* '' */
.uil-signal:before {
  content: "\\eb85";
} /* '' */
.uil-silence:before {
  content: "\\eb86";
} /* '' */
.uil-silent-squint:before {
  content: "\\eb87";
} /* '' */
.uil-sim-card:before {
  content: "\\eb88";
} /* '' */
.uil-sitemap:before {
  content: "\\eb89";
} /* '' */
.uil-skip-forward-alt:before {
  content: "\\eb8a";
} /* '' */
.uil-skip-forward-circle:before {
  content: "\\eb8b";
} /* '' */
.uil-skip-forward:before {
  content: "\\eb8c";
} /* '' */
.uil-skype-alt:before {
  content: "\\eb8d";
} /* '' */
.uil-skype:before {
  content: "\\eb8e";
} /* '' */
.uil-slack-alt:before {
  content: "\\eb8f";
} /* '' */
.uil-slack:before {
  content: "\\eb90";
} /* '' */
.uil-sliders-v-alt:before {
  content: "\\eb91";
} /* '' */
.uil-sliders-v:before {
  content: "\\eb92";
} /* '' */
.uil-smile-beam:before {
  content: "\\eb93";
} /* '' */
.uil-smile-dizzy:before {
  content: "\\eb94";
} /* '' */
.uil-smile-squint-wink-alt:before {
  content: "\\eb95";
} /* '' */
.uil-smile-squint-wink:before {
  content: "\\eb96";
} /* '' */
.uil-smile-wink-alt:before {
  content: "\\eb97";
} /* '' */
.uil-smile-wink:before {
  content: "\\eb98";
} /* '' */
.uil-smile:before {
  content: "\\eb99";
} /* '' */
.uil-snapchat-alt:before {
  content: "\\eb9a";
} /* '' */
.uil-snapchat-ghost:before {
  content: "\\eb9b";
} /* '' */
.uil-snapchat-square:before {
  content: "\\eb9c";
} /* '' */
.uil-snow-flake:before {
  content: "\\eb9d";
} /* '' */
.uil-snowflake-alt:before {
  content: "\\eb9e";
} /* '' */
.uil-snowflake:before {
  content: "\\eb9f";
} /* '' */
.uil-sort-amount-down:before {
  content: "\\eba0";
} /* '' */
.uil-sort-amount-up:before {
  content: "\\eba1";
} /* '' */
.uil-sort:before {
  content: "\\eba2";
} /* '' */
.uil-sorting:before {
  content: "\\eba3";
} /* '' */
.uil-space-key:before {
  content: "\\eba4";
} /* '' */
.uil-spade:before {
  content: "\\eba5";
} /* '' */
.uil-sperms:before {
  content: "\\eba6";
} /* '' */
.uil-spin:before {
  content: "\\eba7";
} /* '' */
.uil-sport:before {
  content: "\\eba8";
} /* '' */
.uil-square-full:before {
  content: "\\eba9";
} /* '' */
.uil-square-shape:before {
  content: "\\ebaa";
} /* '' */
.uil-square:before {
  content: "\\ebab";
} /* '' */
.uil-squint:before {
  content: "\\ebac";
} /* '' */
.uil-star-half-alt:before {
  content: "\\ebad";
} /* '' */
.uil-star:before {
  content: "\\ebae";
} /* '' */
.uil-step-backward-alt:before {
  content: "\\ebaf";
} /* '' */
.uil-step-backward-circle:before {
  content: "\\ebb0";
} /* '' */
.uil-step-backward:before {
  content: "\\ebb1";
} /* '' */
.uil-step-forward:before {
  content: "\\ebb2";
} /* '' */
.uil-stop-circle:before {
  content: "\\ebb3";
} /* '' */
.uil-stopwatch-slash:before {
  content: "\\ebb4";
} /* '' */
.uil-stopwatch:before {
  content: "\\ebb5";
} /* '' */
.uil-store-alt:before {
  content: "\\ebb6";
} /* '' */
.uil-store:before {
  content: "\\ebb7";
} /* '' */
.uil-streering:before {
  content: "\\ebb8";
} /* '' */
.uil-stretcher:before {
  content: "\\ebb9";
} /* '' */
.uil-subject:before {
  content: "\\ebba";
} /* '' */
.uil-subway-alt:before {
  content: "\\ebbb";
} /* '' */
.uil-subway:before {
  content: "\\ebbc";
} /* '' */
.uil-suitcase-alt:before {
  content: "\\ebbd";
} /* '' */
.uil-suitcase:before {
  content: "\\ebbe";
} /* '' */
.uil-sun:before {
  content: "\\ebbf";
} /* '' */
.uil-sunset:before {
  content: "\\ebc0";
} /* '' */
.uil-surprise:before {
  content: "\\ebc1";
} /* '' */
.uil-swatchbook:before {
  content: "\\ebc2";
} /* '' */
.uil-swiggy:before {
  content: "\\ebc3";
} /* '' */
.uil-swimmer:before {
  content: "\\ebc4";
} /* '' */
.uil-symbol:before {
  content: "\\ebc5";
} /* '' */
.uil-sync-exclamation:before {
  content: "\\ebc6";
} /* '' */
.uil-sync-slash:before {
  content: "\\ebc7";
} /* '' */
.uil-sync:before {
  content: "\\ebc8";
} /* '' */
.uil-syringe:before {
  content: "\\ebc9";
} /* '' */
.uil-table:before {
  content: "\\ebca";
} /* '' */
.uil-tablet:before {
  content: "\\ebcb";
} /* '' */
.uil-tablets:before {
  content: "\\ebcc";
} /* '' */
.uil-tachometer-fast:before {
  content: "\\ebcd";
} /* '' */
.uil-tag-alt:before {
  content: "\\ebce";
} /* '' */
.uil-tag:before {
  content: "\\ebcf";
} /* '' */
.uil-tape:before {
  content: "\\ebd0";
} /* '' */
.uil-taxi:before {
  content: "\\ebd1";
} /* '' */
.uil-tear:before {
  content: "\\ebd2";
} /* '' */
.uil-technology:before {
  content: "\\ebd3";
} /* '' */
.uil-telegram-alt:before {
  content: "\\ebd4";
} /* '' */
.uil-telegram:before {
  content: "\\ebd5";
} /* '' */
.uil-telescope:before {
  content: "\\ebd6";
} /* '' */
.uil-temperature-empty:before {
  content: "\\ebd7";
} /* '' */
.uil-temperature-half:before {
  content: "\\ebd8";
} /* '' */
.uil-temperature-minus:before {
  content: "\\ebd9";
} /* '' */
.uil-temperature-plus:before {
  content: "\\ebda";
} /* '' */
.uil-temperature-quarter:before {
  content: "\\ebdb";
} /* '' */
.uil-temperature-three-quarter:before {
  content: "\\ebdc";
} /* '' */
.uil-temperature:before {
  content: "\\ebdd";
} /* '' */
.uil-text-fields:before {
  content: "\\ebde";
} /* '' */
.uil-text-size:before {
  content: "\\ebdf";
} /* '' */
.uil-text-strike-through:before {
  content: "\\ebe0";
} /* '' */
.uil-text:before {
  content: "\\ebe1";
} /* '' */
.uil-th-large:before {
  content: "\\ebe2";
} /* '' */
.uil-th-slash:before {
  content: "\\ebe3";
} /* '' */
.uil-th:before {
  content: "\\ebe4";
} /* '' */
.uil-thermometer:before {
  content: "\\ebe5";
} /* '' */
.uil-thumbs-down:before {
  content: "\\ebe6";
} /* '' */
.uil-thumbs-up:before {
  content: "\\ebe7";
} /* '' */
.uil-thunderstorm-moon:before {
  content: "\\ebe8";
} /* '' */
.uil-thunderstorm-sun:before {
  content: "\\ebe9";
} /* '' */
.uil-thunderstorm:before {
  content: "\\ebea";
} /* '' */
.uil-ticket:before {
  content: "\\ebeb";
} /* '' */
.uil-times-circle:before {
  content: "\\ebec";
} /* '' */
.uil-times-square:before {
  content: "\\ebed";
} /* '' */
.uil-times:before {
  content: "\\ebee";
} /* '' */
.uil-toggle-off:before {
  content: "\\ebef";
} /* '' */
.uil-toggle-on:before {
  content: "\\ebf0";
} /* '' */
.uil-top-arrow-from-top:before {
  content: "\\ebf1";
} /* '' */
.uil-top-arrow-to-top:before {
  content: "\\ebf2";
} /* '' */
.uil-tornado:before {
  content: "\\ebf3";
} /* '' */
.uil-trademark-circle:before {
  content: "\\ebf4";
} /* '' */
.uil-trademark:before {
  content: "\\ebf5";
} /* '' */
.uil-traffic-barrier:before {
  content: "\\ebf6";
} /* '' */
.uil-trash-alt:before {
  content: "\\ebf7";
} /* '' */
.uil-trash:before {
  content: "\\ebf8";
} /* '' */
.uil-trees:before {
  content: "\\ebf9";
} /* '' */
.uil-triangle:before {
  content: "\\ebfa";
} /* '' */
.uil-trophy:before {
  content: "\\ebfb";
} /* '' */
.uil-trowel:before {
  content: "\\ebfc";
} /* '' */
.uil-truck-case:before {
  content: "\\ebfd";
} /* '' */
.uil-truck-loading:before {
  content: "\\ebfe";
} /* '' */
.uil-truck:before {
  content: "\\ebff";
} /* '' */
.uil-tumblr-alt:before {
  content: "\\ec00";
} /* '' */
.uil-tumblr-square:before {
  content: "\\ec01";
} /* '' */
.uil-tumblr:before {
  content: "\\ec02";
} /* '' */
.uil-tv-retro-slash:before {
  content: "\\ec03";
} /* '' */
.uil-tv-retro:before {
  content: "\\ec04";
} /* '' */
.uil-twitter-alt:before {
  content: "\\ec05";
} /* '' */
.uil-twitter:before {
  content: "\\ec06";
} /* '' */
.uil-umbrella:before {
  content: "\\ec07";
} /* '' */
.uil-unamused:before {
  content: "\\ec08";
} /* '' */
.uil-underline:before {
  content: "\\ec09";
} /* '' */
.uil-university:before {
  content: "\\ec0a";
} /* '' */
.uil-unlock-alt:before {
  content: "\\ec0b";
} /* '' */
.uil-unlock:before {
  content: "\\ec0c";
} /* '' */
.uil-upload-alt:before {
  content: "\\ec0d";
} /* '' */
.uil-upload:before {
  content: "\\ec0e";
} /* '' */
.uil-usd-circle:before {
  content: "\\ec0f";
} /* '' */
.uil-usd-square:before {
  content: "\\ec10";
} /* '' */
.uil-user-check:before {
  content: "\\ec11";
} /* '' */
.uil-user-circle:before {
  content: "\\ec12";
} /* '' */
.uil-user-exclamation:before {
  content: "\\ec13";
} /* '' */
.uil-user-hard-hat:before {
  content: "\\ec14";
} /* '' */
.uil-user-minus:before {
  content: "\\ec15";
} /* '' */
.uil-user-plus:before {
  content: "\\ec16";
} /* '' */
.uil-user-square:before {
  content: "\\ec17";
} /* '' */
.uil-user-times:before {
  content: "\\ec18";
} /* '' */
.uil-user:before {
  content: "\\ec19";
} /* '' */
.uil-users-alt:before {
  content: "\\ec1a";
} /* '' */
.uil-utensils-alt:before {
  content: "\\ec1b";
} /* '' */
.uil-utensils:before {
  content: "\\ec1c";
} /* '' */
.uil-vector-square-alt:before {
  content: "\\ec1d";
} /* '' */
.uil-vector-square:before {
  content: "\\ec1e";
} /* '' */
.uil-venus:before {
  content: "\\ec1f";
} /* '' */
.uil-vertical-align-bottom:before {
  content: "\\ec20";
} /* '' */
.uil-vertical-align-center:before {
  content: "\\ec21";
} /* '' */
.uil-vertical-align-top:before {
  content: "\\ec22";
} /* '' */
.uil-vertical-distribute-bottom:before {
  content: "\\ec23";
} /* '' */
.uil-vertical-distribution-center:before {
  content: "\\ec24";
} /* '' */
.uil-vertical-distribution-top:before {
  content: "\\ec25";
} /* '' */
.uil-video-slash:before {
  content: "\\ec26";
} /* '' */
.uil-video:before {
  content: "\\ec27";
} /* '' */
.uil-visual-studio:before {
  content: "\\ec28";
} /* '' */
.uil-vk-alt:before {
  content: "\\ec29";
} /* '' */
.uil-vk:before {
  content: "\\ec2a";
} /* '' */
.uil-voicemail-rectangle:before {
  content: "\\ec2b";
} /* '' */
.uil-voicemail:before {
  content: "\\ec2c";
} /* '' */
.uil-volleyball:before {
  content: "\\ec2d";
} /* '' */
.uil-volume-down:before {
  content: "\\ec2e";
} /* '' */
.uil-volume-mute:before {
  content: "\\ec2f";
} /* '' */
.uil-volume-off:before {
  content: "\\ec30";
} /* '' */
.uil-volume-up:before {
  content: "\\ec31";
} /* '' */
.uil-volume:before {
  content: "\\ec32";
} /* '' */
.uil-vuejs-alt:before {
  content: "\\ec33";
} /* '' */
.uil-vuejs:before {
  content: "\\ec34";
} /* '' */
.uil-wall:before {
  content: "\\ec35";
} /* '' */
.uil-wallet:before {
  content: "\\ec36";
} /* '' */
.uil-watch-alt:before {
  content: "\\ec37";
} /* '' */
.uil-watch:before {
  content: "\\ec38";
} /* '' */
.uil-water-drop-slash:before {
  content: "\\ec39";
} /* '' */
.uil-water-glass:before {
  content: "\\ec3a";
} /* '' */
.uil-water:before {
  content: "\\ec3b";
} /* '' */
.uil-web-grid-alt:before {
  content: "\\ec3c";
} /* '' */
.uil-web-grid:before {
  content: "\\ec3d";
} /* '' */
.uil-web-section-alt:before {
  content: "\\ec3e";
} /* '' */
.uil-web-section:before {
  content: "\\ec3f";
} /* '' */
.uil-webcam:before {
  content: "\\ec40";
} /* '' */
.uil-weight:before {
  content: "\\ec41";
} /* '' */
.uil-whatsapp:before {
  content: "\\ec42";
} /* '' */
.uil-wheel-barrow:before {
  content: "\\ec43";
} /* '' */
.uil-wheelchair-alt:before {
  content: "\\ec44";
} /* '' */
.uil-wheelchair:before {
  content: "\\ec45";
} /* '' */
.uil-wifi-router:before {
  content: "\\ec46";
} /* '' */
.uil-wifi-slash:before {
  content: "\\ec47";
} /* '' */
.uil-wifi:before {
  content: "\\ec48";
} /* '' */
.uil-wind-moon:before {
  content: "\\ec49";
} /* '' */
.uil-wind-sun:before {
  content: "\\ec4a";
} /* '' */
.uil-wind:before {
  content: "\\ec4b";
} /* '' */
.uil-window-grid:before {
  content: "\\ec4c";
} /* '' */
.uil-window-maximize:before {
  content: "\\ec4d";
} /* '' */
.uil-window-restore:before {
  content: "\\ec4e";
} /* '' */
.uil-window-section:before {
  content: "\\ec4f";
} /* '' */
.uil-window:before {
  content: "\\ec50";
} /* '' */
.uil-windsock:before {
  content: "\\ec51";
} /* '' */
.uil-wrap-text:before {
  content: "\\ec52";
} /* '' */
.uil-wrench:before {
  content: "\\ec53";
} /* '' */
.uil-yellow:before {
  content: "\\ec54";
} /* '' */
.uil-yen-circle:before {
  content: "\\ec55";
} /* '' */
.uil-yen:before {
  content: "\\ec56";
} /* '' */
.uil-yin-yang:before {
  content: "\\ec57";
} /* '' */
.uil-youtube-alt:before {
  content: "\\ec58";
} /* '' */
.uil-youtube:before {
  content: "\\ec59";
} /* '' */
@font-face {
  font-family: "bootstrap-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff");
}
[class^=bi-]::before,
[class*=" bi-"]::before {
  display: inline-block;
  font-family: bootstrap-icons !important;
  font-style: normal;
  font-weight: normal !important;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: -0.125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bi-alarm-fill::before {
  content: "\\f101";
}

.bi-alarm::before {
  content: "\\f102";
}

.bi-align-bottom::before {
  content: "\\f103";
}

.bi-align-center::before {
  content: "\\f104";
}

.bi-align-end::before {
  content: "\\f105";
}

.bi-align-middle::before {
  content: "\\f106";
}

.bi-align-start::before {
  content: "\\f107";
}

.bi-align-top::before {
  content: "\\f108";
}

.bi-alt::before {
  content: "\\f109";
}

.bi-app-indicator::before {
  content: "\\f10a";
}

.bi-app::before {
  content: "\\f10b";
}

.bi-archive-fill::before {
  content: "\\f10c";
}

.bi-archive::before {
  content: "\\f10d";
}

.bi-arrow-90deg-down::before {
  content: "\\f10e";
}

.bi-arrow-90deg-left::before {
  content: "\\f10f";
}

.bi-arrow-90deg-right::before {
  content: "\\f110";
}

.bi-arrow-90deg-up::before {
  content: "\\f111";
}

.bi-arrow-bar-down::before {
  content: "\\f112";
}

.bi-arrow-bar-left::before {
  content: "\\f113";
}

.bi-arrow-bar-right::before {
  content: "\\f114";
}

.bi-arrow-bar-up::before {
  content: "\\f115";
}

.bi-arrow-clockwise::before {
  content: "\\f116";
}

.bi-arrow-counterclockwise::before {
  content: "\\f117";
}

.bi-arrow-down-circle-fill::before {
  content: "\\f118";
}

.bi-arrow-down-circle::before {
  content: "\\f119";
}

.bi-arrow-down-left-circle-fill::before {
  content: "\\f11a";
}

.bi-arrow-down-left-circle::before {
  content: "\\f11b";
}

.bi-arrow-down-left-square-fill::before {
  content: "\\f11c";
}

.bi-arrow-down-left-square::before {
  content: "\\f11d";
}

.bi-arrow-down-left::before {
  content: "\\f11e";
}

.bi-arrow-down-right-circle-fill::before {
  content: "\\f11f";
}

.bi-arrow-down-right-circle::before {
  content: "\\f120";
}

.bi-arrow-down-right-square-fill::before {
  content: "\\f121";
}

.bi-arrow-down-right-square::before {
  content: "\\f122";
}

.bi-arrow-down-right::before {
  content: "\\f123";
}

.bi-arrow-down-short::before {
  content: "\\f124";
}

.bi-arrow-down-square-fill::before {
  content: "\\f125";
}

.bi-arrow-down-square::before {
  content: "\\f126";
}

.bi-arrow-down-up::before {
  content: "\\f127";
}

.bi-arrow-down::before {
  content: "\\f128";
}

.bi-arrow-left-circle-fill::before {
  content: "\\f129";
}

.bi-arrow-left-circle::before {
  content: "\\f12a";
}

.bi-arrow-left-right::before {
  content: "\\f12b";
}

.bi-arrow-left-short::before {
  content: "\\f12c";
}

.bi-arrow-left-square-fill::before {
  content: "\\f12d";
}

.bi-arrow-left-square::before {
  content: "\\f12e";
}

.bi-arrow-left::before {
  content: "\\f12f";
}

.bi-arrow-repeat::before {
  content: "\\f130";
}

.bi-arrow-return-left::before {
  content: "\\f131";
}

.bi-arrow-return-right::before {
  content: "\\f132";
}

.bi-arrow-right-circle-fill::before {
  content: "\\f133";
}

.bi-arrow-right-circle::before {
  content: "\\f134";
}

.bi-arrow-right-short::before {
  content: "\\f135";
}

.bi-arrow-right-square-fill::before {
  content: "\\f136";
}

.bi-arrow-right-square::before {
  content: "\\f137";
}

.bi-arrow-right::before {
  content: "\\f138";
}

.bi-arrow-up-circle-fill::before {
  content: "\\f139";
}

.bi-arrow-up-circle::before {
  content: "\\f13a";
}

.bi-arrow-up-left-circle-fill::before {
  content: "\\f13b";
}

.bi-arrow-up-left-circle::before {
  content: "\\f13c";
}

.bi-arrow-up-left-square-fill::before {
  content: "\\f13d";
}

.bi-arrow-up-left-square::before {
  content: "\\f13e";
}

.bi-arrow-up-left::before {
  content: "\\f13f";
}

.bi-arrow-up-right-circle-fill::before {
  content: "\\f140";
}

.bi-arrow-up-right-circle::before {
  content: "\\f141";
}

.bi-arrow-up-right-square-fill::before {
  content: "\\f142";
}

.bi-arrow-up-right-square::before {
  content: "\\f143";
}

.bi-arrow-up-right::before {
  content: "\\f144";
}

.bi-arrow-up-short::before {
  content: "\\f145";
}

.bi-arrow-up-square-fill::before {
  content: "\\f146";
}

.bi-arrow-up-square::before {
  content: "\\f147";
}

.bi-arrow-up::before {
  content: "\\f148";
}

.bi-arrows-angle-contract::before {
  content: "\\f149";
}

.bi-arrows-angle-expand::before {
  content: "\\f14a";
}

.bi-arrows-collapse::before {
  content: "\\f14b";
}

.bi-arrows-expand::before {
  content: "\\f14c";
}

.bi-arrows-fullscreen::before {
  content: "\\f14d";
}

.bi-arrows-move::before {
  content: "\\f14e";
}

.bi-aspect-ratio-fill::before {
  content: "\\f14f";
}

.bi-aspect-ratio::before {
  content: "\\f150";
}

.bi-asterisk::before {
  content: "\\f151";
}

.bi-at::before {
  content: "\\f152";
}

.bi-award-fill::before {
  content: "\\f153";
}

.bi-award::before {
  content: "\\f154";
}

.bi-back::before {
  content: "\\f155";
}

.bi-backspace-fill::before {
  content: "\\f156";
}

.bi-backspace-reverse-fill::before {
  content: "\\f157";
}

.bi-backspace-reverse::before {
  content: "\\f158";
}

.bi-backspace::before {
  content: "\\f159";
}

.bi-badge-3d-fill::before {
  content: "\\f15a";
}

.bi-badge-3d::before {
  content: "\\f15b";
}

.bi-badge-4k-fill::before {
  content: "\\f15c";
}

.bi-badge-4k::before {
  content: "\\f15d";
}

.bi-badge-8k-fill::before {
  content: "\\f15e";
}

.bi-badge-8k::before {
  content: "\\f15f";
}

.bi-badge-ad-fill::before {
  content: "\\f160";
}

.bi-badge-ad::before {
  content: "\\f161";
}

.bi-badge-ar-fill::before {
  content: "\\f162";
}

.bi-badge-ar::before {
  content: "\\f163";
}

.bi-badge-cc-fill::before {
  content: "\\f164";
}

.bi-badge-cc::before {
  content: "\\f165";
}

.bi-badge-hd-fill::before {
  content: "\\f166";
}

.bi-badge-hd::before {
  content: "\\f167";
}

.bi-badge-tm-fill::before {
  content: "\\f168";
}

.bi-badge-tm::before {
  content: "\\f169";
}

.bi-badge-vo-fill::before {
  content: "\\f16a";
}

.bi-badge-vo::before {
  content: "\\f16b";
}

.bi-badge-vr-fill::before {
  content: "\\f16c";
}

.bi-badge-vr::before {
  content: "\\f16d";
}

.bi-badge-wc-fill::before {
  content: "\\f16e";
}

.bi-badge-wc::before {
  content: "\\f16f";
}

.bi-bag-check-fill::before {
  content: "\\f170";
}

.bi-bag-check::before {
  content: "\\f171";
}

.bi-bag-dash-fill::before {
  content: "\\f172";
}

.bi-bag-dash::before {
  content: "\\f173";
}

.bi-bag-fill::before {
  content: "\\f174";
}

.bi-bag-plus-fill::before {
  content: "\\f175";
}

.bi-bag-plus::before {
  content: "\\f176";
}

.bi-bag-x-fill::before {
  content: "\\f177";
}

.bi-bag-x::before {
  content: "\\f178";
}

.bi-bag::before {
  content: "\\f179";
}

.bi-bar-chart-fill::before {
  content: "\\f17a";
}

.bi-bar-chart-line-fill::before {
  content: "\\f17b";
}

.bi-bar-chart-line::before {
  content: "\\f17c";
}

.bi-bar-chart-steps::before {
  content: "\\f17d";
}

.bi-bar-chart::before {
  content: "\\f17e";
}

.bi-basket-fill::before {
  content: "\\f17f";
}

.bi-basket::before {
  content: "\\f180";
}

.bi-basket2-fill::before {
  content: "\\f181";
}

.bi-basket2::before {
  content: "\\f182";
}

.bi-basket3-fill::before {
  content: "\\f183";
}

.bi-basket3::before {
  content: "\\f184";
}

.bi-battery-charging::before {
  content: "\\f185";
}

.bi-battery-full::before {
  content: "\\f186";
}

.bi-battery-half::before {
  content: "\\f187";
}

.bi-battery::before {
  content: "\\f188";
}

.bi-bell-fill::before {
  content: "\\f189";
}

.bi-bell::before {
  content: "\\f18a";
}

.bi-bezier::before {
  content: "\\f18b";
}

.bi-bezier2::before {
  content: "\\f18c";
}

.bi-bicycle::before {
  content: "\\f18d";
}

.bi-binoculars-fill::before {
  content: "\\f18e";
}

.bi-binoculars::before {
  content: "\\f18f";
}

.bi-blockquote-left::before {
  content: "\\f190";
}

.bi-blockquote-right::before {
  content: "\\f191";
}

.bi-book-fill::before {
  content: "\\f192";
}

.bi-book-half::before {
  content: "\\f193";
}

.bi-book::before {
  content: "\\f194";
}

.bi-bookmark-check-fill::before {
  content: "\\f195";
}

.bi-bookmark-check::before {
  content: "\\f196";
}

.bi-bookmark-dash-fill::before {
  content: "\\f197";
}

.bi-bookmark-dash::before {
  content: "\\f198";
}

.bi-bookmark-fill::before {
  content: "\\f199";
}

.bi-bookmark-heart-fill::before {
  content: "\\f19a";
}

.bi-bookmark-heart::before {
  content: "\\f19b";
}

.bi-bookmark-plus-fill::before {
  content: "\\f19c";
}

.bi-bookmark-plus::before {
  content: "\\f19d";
}

.bi-bookmark-star-fill::before {
  content: "\\f19e";
}

.bi-bookmark-star::before {
  content: "\\f19f";
}

.bi-bookmark-x-fill::before {
  content: "\\f1a0";
}

.bi-bookmark-x::before {
  content: "\\f1a1";
}

.bi-bookmark::before {
  content: "\\f1a2";
}

.bi-bookmarks-fill::before {
  content: "\\f1a3";
}

.bi-bookmarks::before {
  content: "\\f1a4";
}

.bi-bookshelf::before {
  content: "\\f1a5";
}

.bi-bootstrap-fill::before {
  content: "\\f1a6";
}

.bi-bootstrap-reboot::before {
  content: "\\f1a7";
}

.bi-bootstrap::before {
  content: "\\f1a8";
}

.bi-border-all::before {
  content: "\\f1a9";
}

.bi-border-bottom::before {
  content: "\\f1aa";
}

.bi-border-center::before {
  content: "\\f1ab";
}

.bi-border-inner::before {
  content: "\\f1ac";
}

.bi-border-left::before {
  content: "\\f1ad";
}

.bi-border-middle::before {
  content: "\\f1ae";
}

.bi-border-outer::before {
  content: "\\f1af";
}

.bi-border-right::before {
  content: "\\f1b0";
}

.bi-border-style::before {
  content: "\\f1b1";
}

.bi-border-top::before {
  content: "\\f1b2";
}

.bi-border-width::before {
  content: "\\f1b3";
}

.bi-border::before {
  content: "\\f1b4";
}

.bi-bounding-box-circles::before {
  content: "\\f1b5";
}

.bi-bounding-box::before {
  content: "\\f1b6";
}

.bi-box-arrow-down-left::before {
  content: "\\f1b7";
}

.bi-box-arrow-down-right::before {
  content: "\\f1b8";
}

.bi-box-arrow-down::before {
  content: "\\f1b9";
}

.bi-box-arrow-in-down-left::before {
  content: "\\f1ba";
}

.bi-box-arrow-in-down-right::before {
  content: "\\f1bb";
}

.bi-box-arrow-in-down::before {
  content: "\\f1bc";
}

.bi-box-arrow-in-left::before {
  content: "\\f1bd";
}

.bi-box-arrow-in-right::before {
  content: "\\f1be";
}

.bi-box-arrow-in-up-left::before {
  content: "\\f1bf";
}

.bi-box-arrow-in-up-right::before {
  content: "\\f1c0";
}

.bi-box-arrow-in-up::before {
  content: "\\f1c1";
}

.bi-box-arrow-left::before {
  content: "\\f1c2";
}

.bi-box-arrow-right::before {
  content: "\\f1c3";
}

.bi-box-arrow-up-left::before {
  content: "\\f1c4";
}

.bi-box-arrow-up-right::before {
  content: "\\f1c5";
}

.bi-box-arrow-up::before {
  content: "\\f1c6";
}

.bi-box-seam::before {
  content: "\\f1c7";
}

.bi-box::before {
  content: "\\f1c8";
}

.bi-braces::before {
  content: "\\f1c9";
}

.bi-bricks::before {
  content: "\\f1ca";
}

.bi-briefcase-fill::before {
  content: "\\f1cb";
}

.bi-briefcase::before {
  content: "\\f1cc";
}

.bi-brightness-alt-high-fill::before {
  content: "\\f1cd";
}

.bi-brightness-alt-high::before {
  content: "\\f1ce";
}

.bi-brightness-alt-low-fill::before {
  content: "\\f1cf";
}

.bi-brightness-alt-low::before {
  content: "\\f1d0";
}

.bi-brightness-high-fill::before {
  content: "\\f1d1";
}

.bi-brightness-high::before {
  content: "\\f1d2";
}

.bi-brightness-low-fill::before {
  content: "\\f1d3";
}

.bi-brightness-low::before {
  content: "\\f1d4";
}

.bi-broadcast-pin::before {
  content: "\\f1d5";
}

.bi-broadcast::before {
  content: "\\f1d6";
}

.bi-brush-fill::before {
  content: "\\f1d7";
}

.bi-brush::before {
  content: "\\f1d8";
}

.bi-bucket-fill::before {
  content: "\\f1d9";
}

.bi-bucket::before {
  content: "\\f1da";
}

.bi-bug-fill::before {
  content: "\\f1db";
}

.bi-bug::before {
  content: "\\f1dc";
}

.bi-building::before {
  content: "\\f1dd";
}

.bi-bullseye::before {
  content: "\\f1de";
}

.bi-calculator-fill::before {
  content: "\\f1df";
}

.bi-calculator::before {
  content: "\\f1e0";
}

.bi-calendar-check-fill::before {
  content: "\\f1e1";
}

.bi-calendar-check::before {
  content: "\\f1e2";
}

.bi-calendar-date-fill::before {
  content: "\\f1e3";
}

.bi-calendar-date::before {
  content: "\\f1e4";
}

.bi-calendar-day-fill::before {
  content: "\\f1e5";
}

.bi-calendar-day::before {
  content: "\\f1e6";
}

.bi-calendar-event-fill::before {
  content: "\\f1e7";
}

.bi-calendar-event::before {
  content: "\\f1e8";
}

.bi-calendar-fill::before {
  content: "\\f1e9";
}

.bi-calendar-minus-fill::before {
  content: "\\f1ea";
}

.bi-calendar-minus::before {
  content: "\\f1eb";
}

.bi-calendar-month-fill::before {
  content: "\\f1ec";
}

.bi-calendar-month::before {
  content: "\\f1ed";
}

.bi-calendar-plus-fill::before {
  content: "\\f1ee";
}

.bi-calendar-plus::before {
  content: "\\f1ef";
}

.bi-calendar-range-fill::before {
  content: "\\f1f0";
}

.bi-calendar-range::before {
  content: "\\f1f1";
}

.bi-calendar-week-fill::before {
  content: "\\f1f2";
}

.bi-calendar-week::before {
  content: "\\f1f3";
}

.bi-calendar-x-fill::before {
  content: "\\f1f4";
}

.bi-calendar-x::before {
  content: "\\f1f5";
}

.bi-calendar::before {
  content: "\\f1f6";
}

.bi-calendar2-check-fill::before {
  content: "\\f1f7";
}

.bi-calendar2-check::before {
  content: "\\f1f8";
}

.bi-calendar2-date-fill::before {
  content: "\\f1f9";
}

.bi-calendar2-date::before {
  content: "\\f1fa";
}

.bi-calendar2-day-fill::before {
  content: "\\f1fb";
}

.bi-calendar2-day::before {
  content: "\\f1fc";
}

.bi-calendar2-event-fill::before {
  content: "\\f1fd";
}

.bi-calendar2-event::before {
  content: "\\f1fe";
}

.bi-calendar2-fill::before {
  content: "\\f1ff";
}

.bi-calendar2-minus-fill::before {
  content: "\\f200";
}

.bi-calendar2-minus::before {
  content: "\\f201";
}

.bi-calendar2-month-fill::before {
  content: "\\f202";
}

.bi-calendar2-month::before {
  content: "\\f203";
}

.bi-calendar2-plus-fill::before {
  content: "\\f204";
}

.bi-calendar2-plus::before {
  content: "\\f205";
}

.bi-calendar2-range-fill::before {
  content: "\\f206";
}

.bi-calendar2-range::before {
  content: "\\f207";
}

.bi-calendar2-week-fill::before {
  content: "\\f208";
}

.bi-calendar2-week::before {
  content: "\\f209";
}

.bi-calendar2-x-fill::before {
  content: "\\f20a";
}

.bi-calendar2-x::before {
  content: "\\f20b";
}

.bi-calendar2::before {
  content: "\\f20c";
}

.bi-calendar3-event-fill::before {
  content: "\\f20d";
}

.bi-calendar3-event::before {
  content: "\\f20e";
}

.bi-calendar3-fill::before {
  content: "\\f20f";
}

.bi-calendar3-range-fill::before {
  content: "\\f210";
}

.bi-calendar3-range::before {
  content: "\\f211";
}

.bi-calendar3-week-fill::before {
  content: "\\f212";
}

.bi-calendar3-week::before {
  content: "\\f213";
}

.bi-calendar3::before {
  content: "\\f214";
}

.bi-calendar4-event::before {
  content: "\\f215";
}

.bi-calendar4-range::before {
  content: "\\f216";
}

.bi-calendar4-week::before {
  content: "\\f217";
}

.bi-calendar4::before {
  content: "\\f218";
}

.bi-camera-fill::before {
  content: "\\f219";
}

.bi-camera-reels-fill::before {
  content: "\\f21a";
}

.bi-camera-reels::before {
  content: "\\f21b";
}

.bi-camera-video-fill::before {
  content: "\\f21c";
}

.bi-camera-video-off-fill::before {
  content: "\\f21d";
}

.bi-camera-video-off::before {
  content: "\\f21e";
}

.bi-camera-video::before {
  content: "\\f21f";
}

.bi-camera::before {
  content: "\\f220";
}

.bi-camera2::before {
  content: "\\f221";
}

.bi-capslock-fill::before {
  content: "\\f222";
}

.bi-capslock::before {
  content: "\\f223";
}

.bi-card-checklist::before {
  content: "\\f224";
}

.bi-card-heading::before {
  content: "\\f225";
}

.bi-card-image::before {
  content: "\\f226";
}

.bi-card-list::before {
  content: "\\f227";
}

.bi-card-text::before {
  content: "\\f228";
}

.bi-caret-down-fill::before {
  content: "\\f229";
}

.bi-caret-down-square-fill::before {
  content: "\\f22a";
}

.bi-caret-down-square::before {
  content: "\\f22b";
}

.bi-caret-down::before {
  content: "\\f22c";
}

.bi-caret-left-fill::before {
  content: "\\f22d";
}

.bi-caret-left-square-fill::before {
  content: "\\f22e";
}

.bi-caret-left-square::before {
  content: "\\f22f";
}

.bi-caret-left::before {
  content: "\\f230";
}

.bi-caret-right-fill::before {
  content: "\\f231";
}

.bi-caret-right-square-fill::before {
  content: "\\f232";
}

.bi-caret-right-square::before {
  content: "\\f233";
}

.bi-caret-right::before {
  content: "\\f234";
}

.bi-caret-up-fill::before {
  content: "\\f235";
}

.bi-caret-up-square-fill::before {
  content: "\\f236";
}

.bi-caret-up-square::before {
  content: "\\f237";
}

.bi-caret-up::before {
  content: "\\f238";
}

.bi-cart-check-fill::before {
  content: "\\f239";
}

.bi-cart-check::before {
  content: "\\f23a";
}

.bi-cart-dash-fill::before {
  content: "\\f23b";
}

.bi-cart-dash::before {
  content: "\\f23c";
}

.bi-cart-fill::before {
  content: "\\f23d";
}

.bi-cart-plus-fill::before {
  content: "\\f23e";
}

.bi-cart-plus::before {
  content: "\\f23f";
}

.bi-cart-x-fill::before {
  content: "\\f240";
}

.bi-cart-x::before {
  content: "\\f241";
}

.bi-cart::before {
  content: "\\f242";
}

.bi-cart2::before {
  content: "\\f243";
}

.bi-cart3::before {
  content: "\\f244";
}

.bi-cart4::before {
  content: "\\f245";
}

.bi-cash-stack::before {
  content: "\\f246";
}

.bi-cash::before {
  content: "\\f247";
}

.bi-cast::before {
  content: "\\f248";
}

.bi-chat-dots-fill::before {
  content: "\\f249";
}

.bi-chat-dots::before {
  content: "\\f24a";
}

.bi-chat-fill::before {
  content: "\\f24b";
}

.bi-chat-left-dots-fill::before {
  content: "\\f24c";
}

.bi-chat-left-dots::before {
  content: "\\f24d";
}

.bi-chat-left-fill::before {
  content: "\\f24e";
}

.bi-chat-left-quote-fill::before {
  content: "\\f24f";
}

.bi-chat-left-quote::before {
  content: "\\f250";
}

.bi-chat-left-text-fill::before {
  content: "\\f251";
}

.bi-chat-left-text::before {
  content: "\\f252";
}

.bi-chat-left::before {
  content: "\\f253";
}

.bi-chat-quote-fill::before {
  content: "\\f254";
}

.bi-chat-quote::before {
  content: "\\f255";
}

.bi-chat-right-dots-fill::before {
  content: "\\f256";
}

.bi-chat-right-dots::before {
  content: "\\f257";
}

.bi-chat-right-fill::before {
  content: "\\f258";
}

.bi-chat-right-quote-fill::before {
  content: "\\f259";
}

.bi-chat-right-quote::before {
  content: "\\f25a";
}

.bi-chat-right-text-fill::before {
  content: "\\f25b";
}

.bi-chat-right-text::before {
  content: "\\f25c";
}

.bi-chat-right::before {
  content: "\\f25d";
}

.bi-chat-square-dots-fill::before {
  content: "\\f25e";
}

.bi-chat-square-dots::before {
  content: "\\f25f";
}

.bi-chat-square-fill::before {
  content: "\\f260";
}

.bi-chat-square-quote-fill::before {
  content: "\\f261";
}

.bi-chat-square-quote::before {
  content: "\\f262";
}

.bi-chat-square-text-fill::before {
  content: "\\f263";
}

.bi-chat-square-text::before {
  content: "\\f264";
}

.bi-chat-square::before {
  content: "\\f265";
}

.bi-chat-text-fill::before {
  content: "\\f266";
}

.bi-chat-text::before {
  content: "\\f267";
}

.bi-chat::before {
  content: "\\f268";
}

.bi-check-all::before {
  content: "\\f269";
}

.bi-check-circle-fill::before {
  content: "\\f26a";
}

.bi-check-circle::before {
  content: "\\f26b";
}

.bi-check-square-fill::before {
  content: "\\f26c";
}

.bi-check-square::before {
  content: "\\f26d";
}

.bi-check::before {
  content: "\\f26e";
}

.bi-check2-all::before {
  content: "\\f26f";
}

.bi-check2-circle::before {
  content: "\\f270";
}

.bi-check2-square::before {
  content: "\\f271";
}

.bi-check2::before {
  content: "\\f272";
}

.bi-chevron-bar-contract::before {
  content: "\\f273";
}

.bi-chevron-bar-down::before {
  content: "\\f274";
}

.bi-chevron-bar-expand::before {
  content: "\\f275";
}

.bi-chevron-bar-left::before {
  content: "\\f276";
}

.bi-chevron-bar-right::before {
  content: "\\f277";
}

.bi-chevron-bar-up::before {
  content: "\\f278";
}

.bi-chevron-compact-down::before {
  content: "\\f279";
}

.bi-chevron-compact-left::before {
  content: "\\f27a";
}

.bi-chevron-compact-right::before {
  content: "\\f27b";
}

.bi-chevron-compact-up::before {
  content: "\\f27c";
}

.bi-chevron-contract::before {
  content: "\\f27d";
}

.bi-chevron-double-down::before {
  content: "\\f27e";
}

.bi-chevron-double-left::before {
  content: "\\f27f";
}

.bi-chevron-double-right::before {
  content: "\\f280";
}

.bi-chevron-double-up::before {
  content: "\\f281";
}

.bi-chevron-down::before {
  content: "\\f282";
}

.bi-chevron-expand::before {
  content: "\\f283";
}

.bi-chevron-left::before {
  content: "\\f284";
}

.bi-chevron-right::before {
  content: "\\f285";
}

.bi-chevron-up::before {
  content: "\\f286";
}

.bi-circle-fill::before {
  content: "\\f287";
}

.bi-circle-half::before {
  content: "\\f288";
}

.bi-circle-square::before {
  content: "\\f289";
}

.bi-circle::before {
  content: "\\f28a";
}

.bi-clipboard-check::before {
  content: "\\f28b";
}

.bi-clipboard-data::before {
  content: "\\f28c";
}

.bi-clipboard-minus::before {
  content: "\\f28d";
}

.bi-clipboard-plus::before {
  content: "\\f28e";
}

.bi-clipboard-x::before {
  content: "\\f28f";
}

.bi-clipboard::before {
  content: "\\f290";
}

.bi-clock-fill::before {
  content: "\\f291";
}

.bi-clock-history::before {
  content: "\\f292";
}

.bi-clock::before {
  content: "\\f293";
}

.bi-cloud-arrow-down-fill::before {
  content: "\\f294";
}

.bi-cloud-arrow-down::before {
  content: "\\f295";
}

.bi-cloud-arrow-up-fill::before {
  content: "\\f296";
}

.bi-cloud-arrow-up::before {
  content: "\\f297";
}

.bi-cloud-check-fill::before {
  content: "\\f298";
}

.bi-cloud-check::before {
  content: "\\f299";
}

.bi-cloud-download-fill::before {
  content: "\\f29a";
}

.bi-cloud-download::before {
  content: "\\f29b";
}

.bi-cloud-drizzle-fill::before {
  content: "\\f29c";
}

.bi-cloud-drizzle::before {
  content: "\\f29d";
}

.bi-cloud-fill::before {
  content: "\\f29e";
}

.bi-cloud-fog-fill::before {
  content: "\\f29f";
}

.bi-cloud-fog::before {
  content: "\\f2a0";
}

.bi-cloud-fog2-fill::before {
  content: "\\f2a1";
}

.bi-cloud-fog2::before {
  content: "\\f2a2";
}

.bi-cloud-hail-fill::before {
  content: "\\f2a3";
}

.bi-cloud-hail::before {
  content: "\\f2a4";
}

.bi-cloud-haze-1::before {
  content: "\\f2a5";
}

.bi-cloud-haze-fill::before {
  content: "\\f2a6";
}

.bi-cloud-haze::before {
  content: "\\f2a7";
}

.bi-cloud-haze2-fill::before {
  content: "\\f2a8";
}

.bi-cloud-lightning-fill::before {
  content: "\\f2a9";
}

.bi-cloud-lightning-rain-fill::before {
  content: "\\f2aa";
}

.bi-cloud-lightning-rain::before {
  content: "\\f2ab";
}

.bi-cloud-lightning::before {
  content: "\\f2ac";
}

.bi-cloud-minus-fill::before {
  content: "\\f2ad";
}

.bi-cloud-minus::before {
  content: "\\f2ae";
}

.bi-cloud-moon-fill::before {
  content: "\\f2af";
}

.bi-cloud-moon::before {
  content: "\\f2b0";
}

.bi-cloud-plus-fill::before {
  content: "\\f2b1";
}

.bi-cloud-plus::before {
  content: "\\f2b2";
}

.bi-cloud-rain-fill::before {
  content: "\\f2b3";
}

.bi-cloud-rain-heavy-fill::before {
  content: "\\f2b4";
}

.bi-cloud-rain-heavy::before {
  content: "\\f2b5";
}

.bi-cloud-rain::before {
  content: "\\f2b6";
}

.bi-cloud-slash-fill::before {
  content: "\\f2b7";
}

.bi-cloud-slash::before {
  content: "\\f2b8";
}

.bi-cloud-sleet-fill::before {
  content: "\\f2b9";
}

.bi-cloud-sleet::before {
  content: "\\f2ba";
}

.bi-cloud-snow-fill::before {
  content: "\\f2bb";
}

.bi-cloud-snow::before {
  content: "\\f2bc";
}

.bi-cloud-sun-fill::before {
  content: "\\f2bd";
}

.bi-cloud-sun::before {
  content: "\\f2be";
}

.bi-cloud-upload-fill::before {
  content: "\\f2bf";
}

.bi-cloud-upload::before {
  content: "\\f2c0";
}

.bi-cloud::before {
  content: "\\f2c1";
}

.bi-clouds-fill::before {
  content: "\\f2c2";
}

.bi-clouds::before {
  content: "\\f2c3";
}

.bi-cloudy-fill::before {
  content: "\\f2c4";
}

.bi-cloudy::before {
  content: "\\f2c5";
}

.bi-code-slash::before {
  content: "\\f2c6";
}

.bi-code-square::before {
  content: "\\f2c7";
}

.bi-code::before {
  content: "\\f2c8";
}

.bi-collection-fill::before {
  content: "\\f2c9";
}

.bi-collection-play-fill::before {
  content: "\\f2ca";
}

.bi-collection-play::before {
  content: "\\f2cb";
}

.bi-collection::before {
  content: "\\f2cc";
}

.bi-columns-gap::before {
  content: "\\f2cd";
}

.bi-columns::before {
  content: "\\f2ce";
}

.bi-command::before {
  content: "\\f2cf";
}

.bi-compass-fill::before {
  content: "\\f2d0";
}

.bi-compass::before {
  content: "\\f2d1";
}

.bi-cone-striped::before {
  content: "\\f2d2";
}

.bi-cone::before {
  content: "\\f2d3";
}

.bi-controller::before {
  content: "\\f2d4";
}

.bi-cpu-fill::before {
  content: "\\f2d5";
}

.bi-cpu::before {
  content: "\\f2d6";
}

.bi-credit-card-2-back-fill::before {
  content: "\\f2d7";
}

.bi-credit-card-2-back::before {
  content: "\\f2d8";
}

.bi-credit-card-2-front-fill::before {
  content: "\\f2d9";
}

.bi-credit-card-2-front::before {
  content: "\\f2da";
}

.bi-credit-card-fill::before {
  content: "\\f2db";
}

.bi-credit-card::before {
  content: "\\f2dc";
}

.bi-crop::before {
  content: "\\f2dd";
}

.bi-cup-fill::before {
  content: "\\f2de";
}

.bi-cup-straw::before {
  content: "\\f2df";
}

.bi-cup::before {
  content: "\\f2e0";
}

.bi-cursor-fill::before {
  content: "\\f2e1";
}

.bi-cursor-text::before {
  content: "\\f2e2";
}

.bi-cursor::before {
  content: "\\f2e3";
}

.bi-dash-circle-dotted::before {
  content: "\\f2e4";
}

.bi-dash-circle-fill::before {
  content: "\\f2e5";
}

.bi-dash-circle::before {
  content: "\\f2e6";
}

.bi-dash-square-dotted::before {
  content: "\\f2e7";
}

.bi-dash-square-fill::before {
  content: "\\f2e8";
}

.bi-dash-square::before {
  content: "\\f2e9";
}

.bi-dash::before {
  content: "\\f2ea";
}

.bi-diagram-2-fill::before {
  content: "\\f2eb";
}

.bi-diagram-2::before {
  content: "\\f2ec";
}

.bi-diagram-3-fill::before {
  content: "\\f2ed";
}

.bi-diagram-3::before {
  content: "\\f2ee";
}

.bi-diamond-fill::before {
  content: "\\f2ef";
}

.bi-diamond-half::before {
  content: "\\f2f0";
}

.bi-diamond::before {
  content: "\\f2f1";
}

.bi-dice-1-fill::before {
  content: "\\f2f2";
}

.bi-dice-1::before {
  content: "\\f2f3";
}

.bi-dice-2-fill::before {
  content: "\\f2f4";
}

.bi-dice-2::before {
  content: "\\f2f5";
}

.bi-dice-3-fill::before {
  content: "\\f2f6";
}

.bi-dice-3::before {
  content: "\\f2f7";
}

.bi-dice-4-fill::before {
  content: "\\f2f8";
}

.bi-dice-4::before {
  content: "\\f2f9";
}

.bi-dice-5-fill::before {
  content: "\\f2fa";
}

.bi-dice-5::before {
  content: "\\f2fb";
}

.bi-dice-6-fill::before {
  content: "\\f2fc";
}

.bi-dice-6::before {
  content: "\\f2fd";
}

.bi-disc-fill::before {
  content: "\\f2fe";
}

.bi-disc::before {
  content: "\\f2ff";
}

.bi-discord::before {
  content: "\\f300";
}

.bi-display-fill::before {
  content: "\\f301";
}

.bi-display::before {
  content: "\\f302";
}

.bi-distribute-horizontal::before {
  content: "\\f303";
}

.bi-distribute-vertical::before {
  content: "\\f304";
}

.bi-door-closed-fill::before {
  content: "\\f305";
}

.bi-door-closed::before {
  content: "\\f306";
}

.bi-door-open-fill::before {
  content: "\\f307";
}

.bi-door-open::before {
  content: "\\f308";
}

.bi-dot::before {
  content: "\\f309";
}

.bi-download::before {
  content: "\\f30a";
}

.bi-droplet-fill::before {
  content: "\\f30b";
}

.bi-droplet-half::before {
  content: "\\f30c";
}

.bi-droplet::before {
  content: "\\f30d";
}

.bi-earbuds::before {
  content: "\\f30e";
}

.bi-easel-fill::before {
  content: "\\f30f";
}

.bi-easel::before {
  content: "\\f310";
}

.bi-egg-fill::before {
  content: "\\f311";
}

.bi-egg-fried::before {
  content: "\\f312";
}

.bi-egg::before {
  content: "\\f313";
}

.bi-eject-fill::before {
  content: "\\f314";
}

.bi-eject::before {
  content: "\\f315";
}

.bi-emoji-angry-fill::before {
  content: "\\f316";
}

.bi-emoji-angry::before {
  content: "\\f317";
}

.bi-emoji-dizzy-fill::before {
  content: "\\f318";
}

.bi-emoji-dizzy::before {
  content: "\\f319";
}

.bi-emoji-expressionless-fill::before {
  content: "\\f31a";
}

.bi-emoji-expressionless::before {
  content: "\\f31b";
}

.bi-emoji-frown-fill::before {
  content: "\\f31c";
}

.bi-emoji-frown::before {
  content: "\\f31d";
}

.bi-emoji-heart-eyes-fill::before {
  content: "\\f31e";
}

.bi-emoji-heart-eyes::before {
  content: "\\f31f";
}

.bi-emoji-laughing-fill::before {
  content: "\\f320";
}

.bi-emoji-laughing::before {
  content: "\\f321";
}

.bi-emoji-neutral-fill::before {
  content: "\\f322";
}

.bi-emoji-neutral::before {
  content: "\\f323";
}

.bi-emoji-smile-fill::before {
  content: "\\f324";
}

.bi-emoji-smile-upside-down-fill::before {
  content: "\\f325";
}

.bi-emoji-smile-upside-down::before {
  content: "\\f326";
}

.bi-emoji-smile::before {
  content: "\\f327";
}

.bi-emoji-sunglasses-fill::before {
  content: "\\f328";
}

.bi-emoji-sunglasses::before {
  content: "\\f329";
}

.bi-emoji-wink-fill::before {
  content: "\\f32a";
}

.bi-emoji-wink::before {
  content: "\\f32b";
}

.bi-envelope-fill::before {
  content: "\\f32c";
}

.bi-envelope-open-fill::before {
  content: "\\f32d";
}

.bi-envelope-open::before {
  content: "\\f32e";
}

.bi-envelope::before {
  content: "\\f32f";
}

.bi-eraser-fill::before {
  content: "\\f330";
}

.bi-eraser::before {
  content: "\\f331";
}

.bi-exclamation-circle-fill::before {
  content: "\\f332";
}

.bi-exclamation-circle::before {
  content: "\\f333";
}

.bi-exclamation-diamond-fill::before {
  content: "\\f334";
}

.bi-exclamation-diamond::before {
  content: "\\f335";
}

.bi-exclamation-octagon-fill::before {
  content: "\\f336";
}

.bi-exclamation-octagon::before {
  content: "\\f337";
}

.bi-exclamation-square-fill::before {
  content: "\\f338";
}

.bi-exclamation-square::before {
  content: "\\f339";
}

.bi-exclamation-triangle-fill::before {
  content: "\\f33a";
}

.bi-exclamation-triangle::before {
  content: "\\f33b";
}

.bi-exclamation::before {
  content: "\\f33c";
}

.bi-exclude::before {
  content: "\\f33d";
}

.bi-eye-fill::before {
  content: "\\f33e";
}

.bi-eye-slash-fill::before {
  content: "\\f33f";
}

.bi-eye-slash::before {
  content: "\\f340";
}

.bi-eye::before {
  content: "\\f341";
}

.bi-eyedropper::before {
  content: "\\f342";
}

.bi-eyeglasses::before {
  content: "\\f343";
}

.bi-facebook::before {
  content: "\\f344";
}

.bi-file-arrow-down-fill::before {
  content: "\\f345";
}

.bi-file-arrow-down::before {
  content: "\\f346";
}

.bi-file-arrow-up-fill::before {
  content: "\\f347";
}

.bi-file-arrow-up::before {
  content: "\\f348";
}

.bi-file-bar-graph-fill::before {
  content: "\\f349";
}

.bi-file-bar-graph::before {
  content: "\\f34a";
}

.bi-file-binary-fill::before {
  content: "\\f34b";
}

.bi-file-binary::before {
  content: "\\f34c";
}

.bi-file-break-fill::before {
  content: "\\f34d";
}

.bi-file-break::before {
  content: "\\f34e";
}

.bi-file-check-fill::before {
  content: "\\f34f";
}

.bi-file-check::before {
  content: "\\f350";
}

.bi-file-code-fill::before {
  content: "\\f351";
}

.bi-file-code::before {
  content: "\\f352";
}

.bi-file-diff-fill::before {
  content: "\\f353";
}

.bi-file-diff::before {
  content: "\\f354";
}

.bi-file-earmark-arrow-down-fill::before {
  content: "\\f355";
}

.bi-file-earmark-arrow-down::before {
  content: "\\f356";
}

.bi-file-earmark-arrow-up-fill::before {
  content: "\\f357";
}

.bi-file-earmark-arrow-up::before {
  content: "\\f358";
}

.bi-file-earmark-bar-graph-fill::before {
  content: "\\f359";
}

.bi-file-earmark-bar-graph::before {
  content: "\\f35a";
}

.bi-file-earmark-binary-fill::before {
  content: "\\f35b";
}

.bi-file-earmark-binary::before {
  content: "\\f35c";
}

.bi-file-earmark-break-fill::before {
  content: "\\f35d";
}

.bi-file-earmark-break::before {
  content: "\\f35e";
}

.bi-file-earmark-check-fill::before {
  content: "\\f35f";
}

.bi-file-earmark-check::before {
  content: "\\f360";
}

.bi-file-earmark-code-fill::before {
  content: "\\f361";
}

.bi-file-earmark-code::before {
  content: "\\f362";
}

.bi-file-earmark-diff-fill::before {
  content: "\\f363";
}

.bi-file-earmark-diff::before {
  content: "\\f364";
}

.bi-file-earmark-easel-fill::before {
  content: "\\f365";
}

.bi-file-earmark-easel::before {
  content: "\\f366";
}

.bi-file-earmark-excel-fill::before {
  content: "\\f367";
}

.bi-file-earmark-excel::before {
  content: "\\f368";
}

.bi-file-earmark-fill::before {
  content: "\\f369";
}

.bi-file-earmark-font-fill::before {
  content: "\\f36a";
}

.bi-file-earmark-font::before {
  content: "\\f36b";
}

.bi-file-earmark-image-fill::before {
  content: "\\f36c";
}

.bi-file-earmark-image::before {
  content: "\\f36d";
}

.bi-file-earmark-lock-fill::before {
  content: "\\f36e";
}

.bi-file-earmark-lock::before {
  content: "\\f36f";
}

.bi-file-earmark-lock2-fill::before {
  content: "\\f370";
}

.bi-file-earmark-lock2::before {
  content: "\\f371";
}

.bi-file-earmark-medical-fill::before {
  content: "\\f372";
}

.bi-file-earmark-medical::before {
  content: "\\f373";
}

.bi-file-earmark-minus-fill::before {
  content: "\\f374";
}

.bi-file-earmark-minus::before {
  content: "\\f375";
}

.bi-file-earmark-music-fill::before {
  content: "\\f376";
}

.bi-file-earmark-music::before {
  content: "\\f377";
}

.bi-file-earmark-person-fill::before {
  content: "\\f378";
}

.bi-file-earmark-person::before {
  content: "\\f379";
}

.bi-file-earmark-play-fill::before {
  content: "\\f37a";
}

.bi-file-earmark-play::before {
  content: "\\f37b";
}

.bi-file-earmark-plus-fill::before {
  content: "\\f37c";
}

.bi-file-earmark-plus::before {
  content: "\\f37d";
}

.bi-file-earmark-post-fill::before {
  content: "\\f37e";
}

.bi-file-earmark-post::before {
  content: "\\f37f";
}

.bi-file-earmark-ppt-fill::before {
  content: "\\f380";
}

.bi-file-earmark-ppt::before {
  content: "\\f381";
}

.bi-file-earmark-richtext-fill::before {
  content: "\\f382";
}

.bi-file-earmark-richtext::before {
  content: "\\f383";
}

.bi-file-earmark-ruled-fill::before {
  content: "\\f384";
}

.bi-file-earmark-ruled::before {
  content: "\\f385";
}

.bi-file-earmark-slides-fill::before {
  content: "\\f386";
}

.bi-file-earmark-slides::before {
  content: "\\f387";
}

.bi-file-earmark-spreadsheet-fill::before {
  content: "\\f388";
}

.bi-file-earmark-spreadsheet::before {
  content: "\\f389";
}

.bi-file-earmark-text-fill::before {
  content: "\\f38a";
}

.bi-file-earmark-text::before {
  content: "\\f38b";
}

.bi-file-earmark-word-fill::before {
  content: "\\f38c";
}

.bi-file-earmark-word::before {
  content: "\\f38d";
}

.bi-file-earmark-x-fill::before {
  content: "\\f38e";
}

.bi-file-earmark-x::before {
  content: "\\f38f";
}

.bi-file-earmark-zip-fill::before {
  content: "\\f390";
}

.bi-file-earmark-zip::before {
  content: "\\f391";
}

.bi-file-earmark::before {
  content: "\\f392";
}

.bi-file-easel-fill::before {
  content: "\\f393";
}

.bi-file-easel::before {
  content: "\\f394";
}

.bi-file-excel-fill::before {
  content: "\\f395";
}

.bi-file-excel::before {
  content: "\\f396";
}

.bi-file-fill::before {
  content: "\\f397";
}

.bi-file-font-fill::before {
  content: "\\f398";
}

.bi-file-font::before {
  content: "\\f399";
}

.bi-file-image-fill::before {
  content: "\\f39a";
}

.bi-file-image::before {
  content: "\\f39b";
}

.bi-file-lock-fill::before {
  content: "\\f39c";
}

.bi-file-lock::before {
  content: "\\f39d";
}

.bi-file-lock2-fill::before {
  content: "\\f39e";
}

.bi-file-lock2::before {
  content: "\\f39f";
}

.bi-file-medical-fill::before {
  content: "\\f3a0";
}

.bi-file-medical::before {
  content: "\\f3a1";
}

.bi-file-minus-fill::before {
  content: "\\f3a2";
}

.bi-file-minus::before {
  content: "\\f3a3";
}

.bi-file-music-fill::before {
  content: "\\f3a4";
}

.bi-file-music::before {
  content: "\\f3a5";
}

.bi-file-person-fill::before {
  content: "\\f3a6";
}

.bi-file-person::before {
  content: "\\f3a7";
}

.bi-file-play-fill::before {
  content: "\\f3a8";
}

.bi-file-play::before {
  content: "\\f3a9";
}

.bi-file-plus-fill::before {
  content: "\\f3aa";
}

.bi-file-plus::before {
  content: "\\f3ab";
}

.bi-file-post-fill::before {
  content: "\\f3ac";
}

.bi-file-post::before {
  content: "\\f3ad";
}

.bi-file-ppt-fill::before {
  content: "\\f3ae";
}

.bi-file-ppt::before {
  content: "\\f3af";
}

.bi-file-richtext-fill::before {
  content: "\\f3b0";
}

.bi-file-richtext::before {
  content: "\\f3b1";
}

.bi-file-ruled-fill::before {
  content: "\\f3b2";
}

.bi-file-ruled::before {
  content: "\\f3b3";
}

.bi-file-slides-fill::before {
  content: "\\f3b4";
}

.bi-file-slides::before {
  content: "\\f3b5";
}

.bi-file-spreadsheet-fill::before {
  content: "\\f3b6";
}

.bi-file-spreadsheet::before {
  content: "\\f3b7";
}

.bi-file-text-fill::before {
  content: "\\f3b8";
}

.bi-file-text::before {
  content: "\\f3b9";
}

.bi-file-word-fill::before {
  content: "\\f3ba";
}

.bi-file-word::before {
  content: "\\f3bb";
}

.bi-file-x-fill::before {
  content: "\\f3bc";
}

.bi-file-x::before {
  content: "\\f3bd";
}

.bi-file-zip-fill::before {
  content: "\\f3be";
}

.bi-file-zip::before {
  content: "\\f3bf";
}

.bi-file::before {
  content: "\\f3c0";
}

.bi-files-alt::before {
  content: "\\f3c1";
}

.bi-files::before {
  content: "\\f3c2";
}

.bi-film::before {
  content: "\\f3c3";
}

.bi-filter-circle-fill::before {
  content: "\\f3c4";
}

.bi-filter-circle::before {
  content: "\\f3c5";
}

.bi-filter-left::before {
  content: "\\f3c6";
}

.bi-filter-right::before {
  content: "\\f3c7";
}

.bi-filter-square-fill::before {
  content: "\\f3c8";
}

.bi-filter-square::before {
  content: "\\f3c9";
}

.bi-filter::before {
  content: "\\f3ca";
}

.bi-flag-fill::before {
  content: "\\f3cb";
}

.bi-flag::before {
  content: "\\f3cc";
}

.bi-flower1::before {
  content: "\\f3cd";
}

.bi-flower2::before {
  content: "\\f3ce";
}

.bi-flower3::before {
  content: "\\f3cf";
}

.bi-folder-check::before {
  content: "\\f3d0";
}

.bi-folder-fill::before {
  content: "\\f3d1";
}

.bi-folder-minus::before {
  content: "\\f3d2";
}

.bi-folder-plus::before {
  content: "\\f3d3";
}

.bi-folder-symlink-fill::before {
  content: "\\f3d4";
}

.bi-folder-symlink::before {
  content: "\\f3d5";
}

.bi-folder-x::before {
  content: "\\f3d6";
}

.bi-folder::before {
  content: "\\f3d7";
}

.bi-folder2-open::before {
  content: "\\f3d8";
}

.bi-folder2::before {
  content: "\\f3d9";
}

.bi-fonts::before {
  content: "\\f3da";
}

.bi-forward-fill::before {
  content: "\\f3db";
}

.bi-forward::before {
  content: "\\f3dc";
}

.bi-front::before {
  content: "\\f3dd";
}

.bi-fullscreen-exit::before {
  content: "\\f3de";
}

.bi-fullscreen::before {
  content: "\\f3df";
}

.bi-funnel-fill::before {
  content: "\\f3e0";
}

.bi-funnel::before {
  content: "\\f3e1";
}

.bi-gear-fill::before {
  content: "\\f3e2";
}

.bi-gear-wide-connected::before {
  content: "\\f3e3";
}

.bi-gear-wide::before {
  content: "\\f3e4";
}

.bi-gear::before {
  content: "\\f3e5";
}

.bi-gem::before {
  content: "\\f3e6";
}

.bi-geo-alt-fill::before {
  content: "\\f3e7";
}

.bi-geo-alt::before {
  content: "\\f3e8";
}

.bi-geo-fill::before {
  content: "\\f3e9";
}

.bi-geo::before {
  content: "\\f3ea";
}

.bi-gift-fill::before {
  content: "\\f3eb";
}

.bi-gift::before {
  content: "\\f3ec";
}

.bi-github::before {
  content: "\\f3ed";
}

.bi-globe::before {
  content: "\\f3ee";
}

.bi-globe2::before {
  content: "\\f3ef";
}

.bi-google::before {
  content: "\\f3f0";
}

.bi-graph-down::before {
  content: "\\f3f1";
}

.bi-graph-up::before {
  content: "\\f3f2";
}

.bi-grid-1x2-fill::before {
  content: "\\f3f3";
}

.bi-grid-1x2::before {
  content: "\\f3f4";
}

.bi-grid-3x2-gap-fill::before {
  content: "\\f3f5";
}

.bi-grid-3x2-gap::before {
  content: "\\f3f6";
}

.bi-grid-3x2::before {
  content: "\\f3f7";
}

.bi-grid-3x3-gap-fill::before {
  content: "\\f3f8";
}

.bi-grid-3x3-gap::before {
  content: "\\f3f9";
}

.bi-grid-3x3::before {
  content: "\\f3fa";
}

.bi-grid-fill::before {
  content: "\\f3fb";
}

.bi-grid::before {
  content: "\\f3fc";
}

.bi-grip-horizontal::before {
  content: "\\f3fd";
}

.bi-grip-vertical::before {
  content: "\\f3fe";
}

.bi-hammer::before {
  content: "\\f3ff";
}

.bi-hand-index-fill::before {
  content: "\\f400";
}

.bi-hand-index-thumb-fill::before {
  content: "\\f401";
}

.bi-hand-index-thumb::before {
  content: "\\f402";
}

.bi-hand-index::before {
  content: "\\f403";
}

.bi-hand-thumbs-down-fill::before {
  content: "\\f404";
}

.bi-hand-thumbs-down::before {
  content: "\\f405";
}

.bi-hand-thumbs-up-fill::before {
  content: "\\f406";
}

.bi-hand-thumbs-up::before {
  content: "\\f407";
}

.bi-handbag-fill::before {
  content: "\\f408";
}

.bi-handbag::before {
  content: "\\f409";
}

.bi-hash::before {
  content: "\\f40a";
}

.bi-hdd-fill::before {
  content: "\\f40b";
}

.bi-hdd-network-fill::before {
  content: "\\f40c";
}

.bi-hdd-network::before {
  content: "\\f40d";
}

.bi-hdd-rack-fill::before {
  content: "\\f40e";
}

.bi-hdd-rack::before {
  content: "\\f40f";
}

.bi-hdd-stack-fill::before {
  content: "\\f410";
}

.bi-hdd-stack::before {
  content: "\\f411";
}

.bi-hdd::before {
  content: "\\f412";
}

.bi-headphones::before {
  content: "\\f413";
}

.bi-headset::before {
  content: "\\f414";
}

.bi-heart-fill::before {
  content: "\\f415";
}

.bi-heart-half::before {
  content: "\\f416";
}

.bi-heart::before {
  content: "\\f417";
}

.bi-heptagon-fill::before {
  content: "\\f418";
}

.bi-heptagon-half::before {
  content: "\\f419";
}

.bi-heptagon::before {
  content: "\\f41a";
}

.bi-hexagon-fill::before {
  content: "\\f41b";
}

.bi-hexagon-half::before {
  content: "\\f41c";
}

.bi-hexagon::before {
  content: "\\f41d";
}

.bi-hourglass-bottom::before {
  content: "\\f41e";
}

.bi-hourglass-split::before {
  content: "\\f41f";
}

.bi-hourglass-top::before {
  content: "\\f420";
}

.bi-hourglass::before {
  content: "\\f421";
}

.bi-house-door-fill::before {
  content: "\\f422";
}

.bi-house-door::before {
  content: "\\f423";
}

.bi-house-fill::before {
  content: "\\f424";
}

.bi-house::before {
  content: "\\f425";
}

.bi-hr::before {
  content: "\\f426";
}

.bi-hurricane::before {
  content: "\\f427";
}

.bi-image-alt::before {
  content: "\\f428";
}

.bi-image-fill::before {
  content: "\\f429";
}

.bi-image::before {
  content: "\\f42a";
}

.bi-images::before {
  content: "\\f42b";
}

.bi-inbox-fill::before {
  content: "\\f42c";
}

.bi-inbox::before {
  content: "\\f42d";
}

.bi-inboxes-fill::before {
  content: "\\f42e";
}

.bi-inboxes::before {
  content: "\\f42f";
}

.bi-info-circle-fill::before {
  content: "\\f430";
}

.bi-info-circle::before {
  content: "\\f431";
}

.bi-info-square-fill::before {
  content: "\\f432";
}

.bi-info-square::before {
  content: "\\f433";
}

.bi-info::before {
  content: "\\f434";
}

.bi-input-cursor-text::before {
  content: "\\f435";
}

.bi-input-cursor::before {
  content: "\\f436";
}

.bi-instagram::before {
  content: "\\f437";
}

.bi-intersect::before {
  content: "\\f438";
}

.bi-journal-album::before {
  content: "\\f439";
}

.bi-journal-arrow-down::before {
  content: "\\f43a";
}

.bi-journal-arrow-up::before {
  content: "\\f43b";
}

.bi-journal-bookmark-fill::before {
  content: "\\f43c";
}

.bi-journal-bookmark::before {
  content: "\\f43d";
}

.bi-journal-check::before {
  content: "\\f43e";
}

.bi-journal-code::before {
  content: "\\f43f";
}

.bi-journal-medical::before {
  content: "\\f440";
}

.bi-journal-minus::before {
  content: "\\f441";
}

.bi-journal-plus::before {
  content: "\\f442";
}

.bi-journal-richtext::before {
  content: "\\f443";
}

.bi-journal-text::before {
  content: "\\f444";
}

.bi-journal-x::before {
  content: "\\f445";
}

.bi-journal::before {
  content: "\\f446";
}

.bi-journals::before {
  content: "\\f447";
}

.bi-joystick::before {
  content: "\\f448";
}

.bi-justify-left::before {
  content: "\\f449";
}

.bi-justify-right::before {
  content: "\\f44a";
}

.bi-justify::before {
  content: "\\f44b";
}

.bi-kanban-fill::before {
  content: "\\f44c";
}

.bi-kanban::before {
  content: "\\f44d";
}

.bi-key-fill::before {
  content: "\\f44e";
}

.bi-key::before {
  content: "\\f44f";
}

.bi-keyboard-fill::before {
  content: "\\f450";
}

.bi-keyboard::before {
  content: "\\f451";
}

.bi-ladder::before {
  content: "\\f452";
}

.bi-lamp-fill::before {
  content: "\\f453";
}

.bi-lamp::before {
  content: "\\f454";
}

.bi-laptop-fill::before {
  content: "\\f455";
}

.bi-laptop::before {
  content: "\\f456";
}

.bi-layer-backward::before {
  content: "\\f457";
}

.bi-layer-forward::before {
  content: "\\f458";
}

.bi-layers-fill::before {
  content: "\\f459";
}

.bi-layers-half::before {
  content: "\\f45a";
}

.bi-layers::before {
  content: "\\f45b";
}

.bi-layout-sidebar-inset-reverse::before {
  content: "\\f45c";
}

.bi-layout-sidebar-inset::before {
  content: "\\f45d";
}

.bi-layout-sidebar-reverse::before {
  content: "\\f45e";
}

.bi-layout-sidebar::before {
  content: "\\f45f";
}

.bi-layout-split::before {
  content: "\\f460";
}

.bi-layout-text-sidebar-reverse::before {
  content: "\\f461";
}

.bi-layout-text-sidebar::before {
  content: "\\f462";
}

.bi-layout-text-window-reverse::before {
  content: "\\f463";
}

.bi-layout-text-window::before {
  content: "\\f464";
}

.bi-layout-three-columns::before {
  content: "\\f465";
}

.bi-layout-wtf::before {
  content: "\\f466";
}

.bi-life-preserver::before {
  content: "\\f467";
}

.bi-lightbulb-fill::before {
  content: "\\f468";
}

.bi-lightbulb-off-fill::before {
  content: "\\f469";
}

.bi-lightbulb-off::before {
  content: "\\f46a";
}

.bi-lightbulb::before {
  content: "\\f46b";
}

.bi-lightning-charge-fill::before {
  content: "\\f46c";
}

.bi-lightning-charge::before {
  content: "\\f46d";
}

.bi-lightning-fill::before {
  content: "\\f46e";
}

.bi-lightning::before {
  content: "\\f46f";
}

.bi-link-45deg::before {
  content: "\\f470";
}

.bi-link::before {
  content: "\\f471";
}

.bi-linkedin::before {
  content: "\\f472";
}

.bi-list-check::before {
  content: "\\f473";
}

.bi-list-nested::before {
  content: "\\f474";
}

.bi-list-ol::before {
  content: "\\f475";
}

.bi-list-stars::before {
  content: "\\f476";
}

.bi-list-task::before {
  content: "\\f477";
}

.bi-list-ul::before {
  content: "\\f478";
}

.bi-list::before {
  content: "\\f479";
}

.bi-lock-fill::before {
  content: "\\f47a";
}

.bi-lock::before {
  content: "\\f47b";
}

.bi-mailbox::before {
  content: "\\f47c";
}

.bi-mailbox2::before {
  content: "\\f47d";
}

.bi-map-fill::before {
  content: "\\f47e";
}

.bi-map::before {
  content: "\\f47f";
}

.bi-markdown-fill::before {
  content: "\\f480";
}

.bi-markdown::before {
  content: "\\f481";
}

.bi-mask::before {
  content: "\\f482";
}

.bi-megaphone-fill::before {
  content: "\\f483";
}

.bi-megaphone::before {
  content: "\\f484";
}

.bi-menu-app-fill::before {
  content: "\\f485";
}

.bi-menu-app::before {
  content: "\\f486";
}

.bi-menu-button-fill::before {
  content: "\\f487";
}

.bi-menu-button-wide-fill::before {
  content: "\\f488";
}

.bi-menu-button-wide::before {
  content: "\\f489";
}

.bi-menu-button::before {
  content: "\\f48a";
}

.bi-menu-down::before {
  content: "\\f48b";
}

.bi-menu-up::before {
  content: "\\f48c";
}

.bi-mic-fill::before {
  content: "\\f48d";
}

.bi-mic-mute-fill::before {
  content: "\\f48e";
}

.bi-mic-mute::before {
  content: "\\f48f";
}

.bi-mic::before {
  content: "\\f490";
}

.bi-minecart-loaded::before {
  content: "\\f491";
}

.bi-minecart::before {
  content: "\\f492";
}

.bi-moisture::before {
  content: "\\f493";
}

.bi-moon-fill::before {
  content: "\\f494";
}

.bi-moon-stars-fill::before {
  content: "\\f495";
}

.bi-moon-stars::before {
  content: "\\f496";
}

.bi-moon::before {
  content: "\\f497";
}

.bi-mouse-fill::before {
  content: "\\f498";
}

.bi-mouse::before {
  content: "\\f499";
}

.bi-mouse2-fill::before {
  content: "\\f49a";
}

.bi-mouse2::before {
  content: "\\f49b";
}

.bi-mouse3-fill::before {
  content: "\\f49c";
}

.bi-mouse3::before {
  content: "\\f49d";
}

.bi-music-note-beamed::before {
  content: "\\f49e";
}

.bi-music-note-list::before {
  content: "\\f49f";
}

.bi-music-note::before {
  content: "\\f4a0";
}

.bi-music-player-fill::before {
  content: "\\f4a1";
}

.bi-music-player::before {
  content: "\\f4a2";
}

.bi-newspaper::before {
  content: "\\f4a3";
}

.bi-node-minus-fill::before {
  content: "\\f4a4";
}

.bi-node-minus::before {
  content: "\\f4a5";
}

.bi-node-plus-fill::before {
  content: "\\f4a6";
}

.bi-node-plus::before {
  content: "\\f4a7";
}

.bi-nut-fill::before {
  content: "\\f4a8";
}

.bi-nut::before {
  content: "\\f4a9";
}

.bi-octagon-fill::before {
  content: "\\f4aa";
}

.bi-octagon-half::before {
  content: "\\f4ab";
}

.bi-octagon::before {
  content: "\\f4ac";
}

.bi-option::before {
  content: "\\f4ad";
}

.bi-outlet::before {
  content: "\\f4ae";
}

.bi-paint-bucket::before {
  content: "\\f4af";
}

.bi-palette-fill::before {
  content: "\\f4b0";
}

.bi-palette::before {
  content: "\\f4b1";
}

.bi-palette2::before {
  content: "\\f4b2";
}

.bi-paperclip::before {
  content: "\\f4b3";
}

.bi-paragraph::before {
  content: "\\f4b4";
}

.bi-patch-check-fill::before {
  content: "\\f4b5";
}

.bi-patch-check::before {
  content: "\\f4b6";
}

.bi-patch-exclamation-fill::before {
  content: "\\f4b7";
}

.bi-patch-exclamation::before {
  content: "\\f4b8";
}

.bi-patch-minus-fill::before {
  content: "\\f4b9";
}

.bi-patch-minus::before {
  content: "\\f4ba";
}

.bi-patch-plus-fill::before {
  content: "\\f4bb";
}

.bi-patch-plus::before {
  content: "\\f4bc";
}

.bi-patch-question-fill::before {
  content: "\\f4bd";
}

.bi-patch-question::before {
  content: "\\f4be";
}

.bi-pause-btn-fill::before {
  content: "\\f4bf";
}

.bi-pause-btn::before {
  content: "\\f4c0";
}

.bi-pause-circle-fill::before {
  content: "\\f4c1";
}

.bi-pause-circle::before {
  content: "\\f4c2";
}

.bi-pause-fill::before {
  content: "\\f4c3";
}

.bi-pause::before {
  content: "\\f4c4";
}

.bi-peace-fill::before {
  content: "\\f4c5";
}

.bi-peace::before {
  content: "\\f4c6";
}

.bi-pen-fill::before {
  content: "\\f4c7";
}

.bi-pen::before {
  content: "\\f4c8";
}

.bi-pencil-fill::before {
  content: "\\f4c9";
}

.bi-pencil-square::before {
  content: "\\f4ca";
}

.bi-pencil::before {
  content: "\\f4cb";
}

.bi-pentagon-fill::before {
  content: "\\f4cc";
}

.bi-pentagon-half::before {
  content: "\\f4cd";
}

.bi-pentagon::before {
  content: "\\f4ce";
}

.bi-people-fill::before {
  content: "\\f4cf";
}

.bi-people::before {
  content: "\\f4d0";
}

.bi-percent::before {
  content: "\\f4d1";
}

.bi-person-badge-fill::before {
  content: "\\f4d2";
}

.bi-person-badge::before {
  content: "\\f4d3";
}

.bi-person-bounding-box::before {
  content: "\\f4d4";
}

.bi-person-check-fill::before {
  content: "\\f4d5";
}

.bi-person-check::before {
  content: "\\f4d6";
}

.bi-person-circle::before {
  content: "\\f4d7";
}

.bi-person-dash-fill::before {
  content: "\\f4d8";
}

.bi-person-dash::before {
  content: "\\f4d9";
}

.bi-person-fill::before {
  content: "\\f4da";
}

.bi-person-lines-fill::before {
  content: "\\f4db";
}

.bi-person-plus-fill::before {
  content: "\\f4dc";
}

.bi-person-plus::before {
  content: "\\f4dd";
}

.bi-person-square::before {
  content: "\\f4de";
}

.bi-person-x-fill::before {
  content: "\\f4df";
}

.bi-person-x::before {
  content: "\\f4e0";
}

.bi-person::before {
  content: "\\f4e1";
}

.bi-phone-fill::before {
  content: "\\f4e2";
}

.bi-phone-landscape-fill::before {
  content: "\\f4e3";
}

.bi-phone-landscape::before {
  content: "\\f4e4";
}

.bi-phone-vibrate-fill::before {
  content: "\\f4e5";
}

.bi-phone-vibrate::before {
  content: "\\f4e6";
}

.bi-phone::before {
  content: "\\f4e7";
}

.bi-pie-chart-fill::before {
  content: "\\f4e8";
}

.bi-pie-chart::before {
  content: "\\f4e9";
}

.bi-pin-angle-fill::before {
  content: "\\f4ea";
}

.bi-pin-angle::before {
  content: "\\f4eb";
}

.bi-pin-fill::before {
  content: "\\f4ec";
}

.bi-pin::before {
  content: "\\f4ed";
}

.bi-pip-fill::before {
  content: "\\f4ee";
}

.bi-pip::before {
  content: "\\f4ef";
}

.bi-play-btn-fill::before {
  content: "\\f4f0";
}

.bi-play-btn::before {
  content: "\\f4f1";
}

.bi-play-circle-fill::before {
  content: "\\f4f2";
}

.bi-play-circle::before {
  content: "\\f4f3";
}

.bi-play-fill::before {
  content: "\\f4f4";
}

.bi-play::before {
  content: "\\f4f5";
}

.bi-plug-fill::before {
  content: "\\f4f6";
}

.bi-plug::before {
  content: "\\f4f7";
}

.bi-plus-circle-dotted::before {
  content: "\\f4f8";
}

.bi-plus-circle-fill::before {
  content: "\\f4f9";
}

.bi-plus-circle::before {
  content: "\\f4fa";
}

.bi-plus-square-dotted::before {
  content: "\\f4fb";
}

.bi-plus-square-fill::before {
  content: "\\f4fc";
}

.bi-plus-square::before {
  content: "\\f4fd";
}

.bi-plus::before {
  content: "\\f4fe";
}

.bi-power::before {
  content: "\\f4ff";
}

.bi-printer-fill::before {
  content: "\\f500";
}

.bi-printer::before {
  content: "\\f501";
}

.bi-puzzle-fill::before {
  content: "\\f502";
}

.bi-puzzle::before {
  content: "\\f503";
}

.bi-question-circle-fill::before {
  content: "\\f504";
}

.bi-question-circle::before {
  content: "\\f505";
}

.bi-question-diamond-fill::before {
  content: "\\f506";
}

.bi-question-diamond::before {
  content: "\\f507";
}

.bi-question-octagon-fill::before {
  content: "\\f508";
}

.bi-question-octagon::before {
  content: "\\f509";
}

.bi-question-square-fill::before {
  content: "\\f50a";
}

.bi-question-square::before {
  content: "\\f50b";
}

.bi-question::before {
  content: "\\f50c";
}

.bi-rainbow::before {
  content: "\\f50d";
}

.bi-receipt-cutoff::before {
  content: "\\f50e";
}

.bi-receipt::before {
  content: "\\f50f";
}

.bi-reception-0::before {
  content: "\\f510";
}

.bi-reception-1::before {
  content: "\\f511";
}

.bi-reception-2::before {
  content: "\\f512";
}

.bi-reception-3::before {
  content: "\\f513";
}

.bi-reception-4::before {
  content: "\\f514";
}

.bi-record-btn-fill::before {
  content: "\\f515";
}

.bi-record-btn::before {
  content: "\\f516";
}

.bi-record-circle-fill::before {
  content: "\\f517";
}

.bi-record-circle::before {
  content: "\\f518";
}

.bi-record-fill::before {
  content: "\\f519";
}

.bi-record::before {
  content: "\\f51a";
}

.bi-record2-fill::before {
  content: "\\f51b";
}

.bi-record2::before {
  content: "\\f51c";
}

.bi-reply-all-fill::before {
  content: "\\f51d";
}

.bi-reply-all::before {
  content: "\\f51e";
}

.bi-reply-fill::before {
  content: "\\f51f";
}

.bi-reply::before {
  content: "\\f520";
}

.bi-rss-fill::before {
  content: "\\f521";
}

.bi-rss::before {
  content: "\\f522";
}

.bi-rulers::before {
  content: "\\f523";
}

.bi-save-fill::before {
  content: "\\f524";
}

.bi-save::before {
  content: "\\f525";
}

.bi-save2-fill::before {
  content: "\\f526";
}

.bi-save2::before {
  content: "\\f527";
}

.bi-scissors::before {
  content: "\\f528";
}

.bi-screwdriver::before {
  content: "\\f529";
}

.bi-search::before {
  content: "\\f52a";
}

.bi-segmented-nav::before {
  content: "\\f52b";
}

.bi-server::before {
  content: "\\f52c";
}

.bi-share-fill::before {
  content: "\\f52d";
}

.bi-share::before {
  content: "\\f52e";
}

.bi-shield-check::before {
  content: "\\f52f";
}

.bi-shield-exclamation::before {
  content: "\\f530";
}

.bi-shield-fill-check::before {
  content: "\\f531";
}

.bi-shield-fill-exclamation::before {
  content: "\\f532";
}

.bi-shield-fill-minus::before {
  content: "\\f533";
}

.bi-shield-fill-plus::before {
  content: "\\f534";
}

.bi-shield-fill-x::before {
  content: "\\f535";
}

.bi-shield-fill::before {
  content: "\\f536";
}

.bi-shield-lock-fill::before {
  content: "\\f537";
}

.bi-shield-lock::before {
  content: "\\f538";
}

.bi-shield-minus::before {
  content: "\\f539";
}

.bi-shield-plus::before {
  content: "\\f53a";
}

.bi-shield-shaded::before {
  content: "\\f53b";
}

.bi-shield-slash-fill::before {
  content: "\\f53c";
}

.bi-shield-slash::before {
  content: "\\f53d";
}

.bi-shield-x::before {
  content: "\\f53e";
}

.bi-shield::before {
  content: "\\f53f";
}

.bi-shift-fill::before {
  content: "\\f540";
}

.bi-shift::before {
  content: "\\f541";
}

.bi-shop-window::before {
  content: "\\f542";
}

.bi-shop::before {
  content: "\\f543";
}

.bi-shuffle::before {
  content: "\\f544";
}

.bi-signpost-2-fill::before {
  content: "\\f545";
}

.bi-signpost-2::before {
  content: "\\f546";
}

.bi-signpost-fill::before {
  content: "\\f547";
}

.bi-signpost-split-fill::before {
  content: "\\f548";
}

.bi-signpost-split::before {
  content: "\\f549";
}

.bi-signpost::before {
  content: "\\f54a";
}

.bi-sim-fill::before {
  content: "\\f54b";
}

.bi-sim::before {
  content: "\\f54c";
}

.bi-skip-backward-btn-fill::before {
  content: "\\f54d";
}

.bi-skip-backward-btn::before {
  content: "\\f54e";
}

.bi-skip-backward-circle-fill::before {
  content: "\\f54f";
}

.bi-skip-backward-circle::before {
  content: "\\f550";
}

.bi-skip-backward-fill::before {
  content: "\\f551";
}

.bi-skip-backward::before {
  content: "\\f552";
}

.bi-skip-end-btn-fill::before {
  content: "\\f553";
}

.bi-skip-end-btn::before {
  content: "\\f554";
}

.bi-skip-end-circle-fill::before {
  content: "\\f555";
}

.bi-skip-end-circle::before {
  content: "\\f556";
}

.bi-skip-end-fill::before {
  content: "\\f557";
}

.bi-skip-end::before {
  content: "\\f558";
}

.bi-skip-forward-btn-fill::before {
  content: "\\f559";
}

.bi-skip-forward-btn::before {
  content: "\\f55a";
}

.bi-skip-forward-circle-fill::before {
  content: "\\f55b";
}

.bi-skip-forward-circle::before {
  content: "\\f55c";
}

.bi-skip-forward-fill::before {
  content: "\\f55d";
}

.bi-skip-forward::before {
  content: "\\f55e";
}

.bi-skip-start-btn-fill::before {
  content: "\\f55f";
}

.bi-skip-start-btn::before {
  content: "\\f560";
}

.bi-skip-start-circle-fill::before {
  content: "\\f561";
}

.bi-skip-start-circle::before {
  content: "\\f562";
}

.bi-skip-start-fill::before {
  content: "\\f563";
}

.bi-skip-start::before {
  content: "\\f564";
}

.bi-slack::before {
  content: "\\f565";
}

.bi-slash-circle-fill::before {
  content: "\\f566";
}

.bi-slash-circle::before {
  content: "\\f567";
}

.bi-slash-square-fill::before {
  content: "\\f568";
}

.bi-slash-square::before {
  content: "\\f569";
}

.bi-slash::before {
  content: "\\f56a";
}

.bi-sliders::before {
  content: "\\f56b";
}

.bi-smartwatch::before {
  content: "\\f56c";
}

.bi-snow::before {
  content: "\\f56d";
}

.bi-snow2::before {
  content: "\\f56e";
}

.bi-snow3::before {
  content: "\\f56f";
}

.bi-sort-alpha-down-alt::before {
  content: "\\f570";
}

.bi-sort-alpha-down::before {
  content: "\\f571";
}

.bi-sort-alpha-up-alt::before {
  content: "\\f572";
}

.bi-sort-alpha-up::before {
  content: "\\f573";
}

.bi-sort-down-alt::before {
  content: "\\f574";
}

.bi-sort-down::before {
  content: "\\f575";
}

.bi-sort-numeric-down-alt::before {
  content: "\\f576";
}

.bi-sort-numeric-down::before {
  content: "\\f577";
}

.bi-sort-numeric-up-alt::before {
  content: "\\f578";
}

.bi-sort-numeric-up::before {
  content: "\\f579";
}

.bi-sort-up-alt::before {
  content: "\\f57a";
}

.bi-sort-up::before {
  content: "\\f57b";
}

.bi-soundwave::before {
  content: "\\f57c";
}

.bi-speaker-fill::before {
  content: "\\f57d";
}

.bi-speaker::before {
  content: "\\f57e";
}

.bi-speedometer::before {
  content: "\\f57f";
}

.bi-speedometer2::before {
  content: "\\f580";
}

.bi-spellcheck::before {
  content: "\\f581";
}

.bi-square-fill::before {
  content: "\\f582";
}

.bi-square-half::before {
  content: "\\f583";
}

.bi-square::before {
  content: "\\f584";
}

.bi-stack::before {
  content: "\\f585";
}

.bi-star-fill::before {
  content: "\\f586";
}

.bi-star-half::before {
  content: "\\f587";
}

.bi-star::before {
  content: "\\f588";
}

.bi-stars::before {
  content: "\\f589";
}

.bi-stickies-fill::before {
  content: "\\f58a";
}

.bi-stickies::before {
  content: "\\f58b";
}

.bi-sticky-fill::before {
  content: "\\f58c";
}

.bi-sticky::before {
  content: "\\f58d";
}

.bi-stop-btn-fill::before {
  content: "\\f58e";
}

.bi-stop-btn::before {
  content: "\\f58f";
}

.bi-stop-circle-fill::before {
  content: "\\f590";
}

.bi-stop-circle::before {
  content: "\\f591";
}

.bi-stop-fill::before {
  content: "\\f592";
}

.bi-stop::before {
  content: "\\f593";
}

.bi-stoplights-fill::before {
  content: "\\f594";
}

.bi-stoplights::before {
  content: "\\f595";
}

.bi-stopwatch-fill::before {
  content: "\\f596";
}

.bi-stopwatch::before {
  content: "\\f597";
}

.bi-subtract::before {
  content: "\\f598";
}

.bi-suit-club-fill::before {
  content: "\\f599";
}

.bi-suit-club::before {
  content: "\\f59a";
}

.bi-suit-diamond-fill::before {
  content: "\\f59b";
}

.bi-suit-diamond::before {
  content: "\\f59c";
}

.bi-suit-heart-fill::before {
  content: "\\f59d";
}

.bi-suit-heart::before {
  content: "\\f59e";
}

.bi-suit-spade-fill::before {
  content: "\\f59f";
}

.bi-suit-spade::before {
  content: "\\f5a0";
}

.bi-sun-fill::before {
  content: "\\f5a1";
}

.bi-sun::before {
  content: "\\f5a2";
}

.bi-sunglasses::before {
  content: "\\f5a3";
}

.bi-sunrise-fill::before {
  content: "\\f5a4";
}

.bi-sunrise::before {
  content: "\\f5a5";
}

.bi-sunset-fill::before {
  content: "\\f5a6";
}

.bi-sunset::before {
  content: "\\f5a7";
}

.bi-symmetry-horizontal::before {
  content: "\\f5a8";
}

.bi-symmetry-vertical::before {
  content: "\\f5a9";
}

.bi-table::before {
  content: "\\f5aa";
}

.bi-tablet-fill::before {
  content: "\\f5ab";
}

.bi-tablet-landscape-fill::before {
  content: "\\f5ac";
}

.bi-tablet-landscape::before {
  content: "\\f5ad";
}

.bi-tablet::before {
  content: "\\f5ae";
}

.bi-tag-fill::before {
  content: "\\f5af";
}

.bi-tag::before {
  content: "\\f5b0";
}

.bi-tags-fill::before {
  content: "\\f5b1";
}

.bi-tags::before {
  content: "\\f5b2";
}

.bi-telegram::before {
  content: "\\f5b3";
}

.bi-telephone-fill::before {
  content: "\\f5b4";
}

.bi-telephone-forward-fill::before {
  content: "\\f5b5";
}

.bi-telephone-forward::before {
  content: "\\f5b6";
}

.bi-telephone-inbound-fill::before {
  content: "\\f5b7";
}

.bi-telephone-inbound::before {
  content: "\\f5b8";
}

.bi-telephone-minus-fill::before {
  content: "\\f5b9";
}

.bi-telephone-minus::before {
  content: "\\f5ba";
}

.bi-telephone-outbound-fill::before {
  content: "\\f5bb";
}

.bi-telephone-outbound::before {
  content: "\\f5bc";
}

.bi-telephone-plus-fill::before {
  content: "\\f5bd";
}

.bi-telephone-plus::before {
  content: "\\f5be";
}

.bi-telephone-x-fill::before {
  content: "\\f5bf";
}

.bi-telephone-x::before {
  content: "\\f5c0";
}

.bi-telephone::before {
  content: "\\f5c1";
}

.bi-terminal-fill::before {
  content: "\\f5c2";
}

.bi-terminal::before {
  content: "\\f5c3";
}

.bi-text-center::before {
  content: "\\f5c4";
}

.bi-text-indent-left::before {
  content: "\\f5c5";
}

.bi-text-indent-right::before {
  content: "\\f5c6";
}

.bi-text-left::before {
  content: "\\f5c7";
}

.bi-text-paragraph::before {
  content: "\\f5c8";
}

.bi-text-right::before {
  content: "\\f5c9";
}

.bi-textarea-resize::before {
  content: "\\f5ca";
}

.bi-textarea-t::before {
  content: "\\f5cb";
}

.bi-textarea::before {
  content: "\\f5cc";
}

.bi-thermometer-half::before {
  content: "\\f5cd";
}

.bi-thermometer-high::before {
  content: "\\f5ce";
}

.bi-thermometer-low::before {
  content: "\\f5cf";
}

.bi-thermometer-snow::before {
  content: "\\f5d0";
}

.bi-thermometer-sun::before {
  content: "\\f5d1";
}

.bi-thermometer::before {
  content: "\\f5d2";
}

.bi-three-dots-vertical::before {
  content: "\\f5d3";
}

.bi-three-dots::before {
  content: "\\f5d4";
}

.bi-toggle-off::before {
  content: "\\f5d5";
}

.bi-toggle-on::before {
  content: "\\f5d6";
}

.bi-toggle2-off::before {
  content: "\\f5d7";
}

.bi-toggle2-on::before {
  content: "\\f5d8";
}

.bi-toggles::before {
  content: "\\f5d9";
}

.bi-toggles2::before {
  content: "\\f5da";
}

.bi-tools::before {
  content: "\\f5db";
}

.bi-tornado::before {
  content: "\\f5dc";
}

.bi-trash-fill::before {
  content: "\\f5dd";
}

.bi-trash::before {
  content: "\\f5de";
}

.bi-trash2-fill::before {
  content: "\\f5df";
}

.bi-trash2::before {
  content: "\\f5e0";
}

.bi-tree-fill::before {
  content: "\\f5e1";
}

.bi-tree::before {
  content: "\\f5e2";
}

.bi-triangle-fill::before {
  content: "\\f5e3";
}

.bi-triangle-half::before {
  content: "\\f5e4";
}

.bi-triangle::before {
  content: "\\f5e5";
}

.bi-trophy-fill::before {
  content: "\\f5e6";
}

.bi-trophy::before {
  content: "\\f5e7";
}

.bi-tropical-storm::before {
  content: "\\f5e8";
}

.bi-truck-flatbed::before {
  content: "\\f5e9";
}

.bi-truck::before {
  content: "\\f5ea";
}

.bi-tsunami::before {
  content: "\\f5eb";
}

.bi-tv-fill::before {
  content: "\\f5ec";
}

.bi-tv::before {
  content: "\\f5ed";
}

.bi-twitch::before {
  content: "\\f5ee";
}

.bi-twitter::before {
  content: "\\f5ef";
}

.bi-type-bold::before {
  content: "\\f5f0";
}

.bi-type-h1::before {
  content: "\\f5f1";
}

.bi-type-h2::before {
  content: "\\f5f2";
}

.bi-type-h3::before {
  content: "\\f5f3";
}

.bi-type-italic::before {
  content: "\\f5f4";
}

.bi-type-strikethrough::before {
  content: "\\f5f5";
}

.bi-type-underline::before {
  content: "\\f5f6";
}

.bi-type::before {
  content: "\\f5f7";
}

.bi-ui-checks-grid::before {
  content: "\\f5f8";
}

.bi-ui-checks::before {
  content: "\\f5f9";
}

.bi-ui-radios-grid::before {
  content: "\\f5fa";
}

.bi-ui-radios::before {
  content: "\\f5fb";
}

.bi-umbrella-fill::before {
  content: "\\f5fc";
}

.bi-umbrella::before {
  content: "\\f5fd";
}

.bi-union::before {
  content: "\\f5fe";
}

.bi-unlock-fill::before {
  content: "\\f5ff";
}

.bi-unlock::before {
  content: "\\f600";
}

.bi-upc-scan::before {
  content: "\\f601";
}

.bi-upc::before {
  content: "\\f602";
}

.bi-upload::before {
  content: "\\f603";
}

.bi-vector-pen::before {
  content: "\\f604";
}

.bi-view-list::before {
  content: "\\f605";
}

.bi-view-stacked::before {
  content: "\\f606";
}

.bi-vinyl-fill::before {
  content: "\\f607";
}

.bi-vinyl::before {
  content: "\\f608";
}

.bi-voicemail::before {
  content: "\\f609";
}

.bi-volume-down-fill::before {
  content: "\\f60a";
}

.bi-volume-down::before {
  content: "\\f60b";
}

.bi-volume-mute-fill::before {
  content: "\\f60c";
}

.bi-volume-mute::before {
  content: "\\f60d";
}

.bi-volume-off-fill::before {
  content: "\\f60e";
}

.bi-volume-off::before {
  content: "\\f60f";
}

.bi-volume-up-fill::before {
  content: "\\f610";
}

.bi-volume-up::before {
  content: "\\f611";
}

.bi-vr::before {
  content: "\\f612";
}

.bi-wallet-fill::before {
  content: "\\f613";
}

.bi-wallet::before {
  content: "\\f614";
}

.bi-wallet2::before {
  content: "\\f615";
}

.bi-watch::before {
  content: "\\f616";
}

.bi-water::before {
  content: "\\f617";
}

.bi-whatsapp::before {
  content: "\\f618";
}

.bi-wifi-1::before {
  content: "\\f619";
}

.bi-wifi-2::before {
  content: "\\f61a";
}

.bi-wifi-off::before {
  content: "\\f61b";
}

.bi-wifi::before {
  content: "\\f61c";
}

.bi-wind::before {
  content: "\\f61d";
}

.bi-window-dock::before {
  content: "\\f61e";
}

.bi-window-sidebar::before {
  content: "\\f61f";
}

.bi-window::before {
  content: "\\f620";
}

.bi-wrench::before {
  content: "\\f621";
}

.bi-x-circle-fill::before {
  content: "\\f622";
}

.bi-x-circle::before {
  content: "\\f623";
}

.bi-x-diamond-fill::before {
  content: "\\f624";
}

.bi-x-diamond::before {
  content: "\\f625";
}

.bi-x-octagon-fill::before {
  content: "\\f626";
}

.bi-x-octagon::before {
  content: "\\f627";
}

.bi-x-square-fill::before {
  content: "\\f628";
}

.bi-x-square::before {
  content: "\\f629";
}

.bi-x::before {
  content: "\\f62a";
}

.bi-youtube::before {
  content: "\\f62b";
}

.bi-zoom-in::before {
  content: "\\f62c";
}

.bi-zoom-out::before {
  content: "\\f62d";
}

.bi-bank::before {
  content: "\\f62e";
}

.bi-bank2::before {
  content: "\\f62f";
}

.bi-bell-slash-fill::before {
  content: "\\f630";
}

.bi-bell-slash::before {
  content: "\\f631";
}

.bi-cash-coin::before {
  content: "\\f632";
}

.bi-check-lg::before {
  content: "\\f633";
}

.bi-coin::before {
  content: "\\f634";
}

.bi-currency-bitcoin::before {
  content: "\\f635";
}

.bi-currency-dollar::before {
  content: "\\f636";
}

.bi-currency-euro::before {
  content: "\\f637";
}

.bi-currency-exchange::before {
  content: "\\f638";
}

.bi-currency-pound::before {
  content: "\\f639";
}

.bi-currency-yen::before {
  content: "\\f63a";
}

.bi-dash-lg::before {
  content: "\\f63b";
}

.bi-exclamation-lg::before {
  content: "\\f63c";
}

.bi-file-earmark-pdf-fill::before {
  content: "\\f63d";
}

.bi-file-earmark-pdf::before {
  content: "\\f63e";
}

.bi-file-pdf-fill::before {
  content: "\\f63f";
}

.bi-file-pdf::before {
  content: "\\f640";
}

.bi-gender-ambiguous::before {
  content: "\\f641";
}

.bi-gender-female::before {
  content: "\\f642";
}

.bi-gender-male::before {
  content: "\\f643";
}

.bi-gender-trans::before {
  content: "\\f644";
}

.bi-headset-vr::before {
  content: "\\f645";
}

.bi-info-lg::before {
  content: "\\f646";
}

.bi-mastodon::before {
  content: "\\f647";
}

.bi-messenger::before {
  content: "\\f648";
}

.bi-piggy-bank-fill::before {
  content: "\\f649";
}

.bi-piggy-bank::before {
  content: "\\f64a";
}

.bi-pin-map-fill::before {
  content: "\\f64b";
}

.bi-pin-map::before {
  content: "\\f64c";
}

.bi-plus-lg::before {
  content: "\\f64d";
}

.bi-question-lg::before {
  content: "\\f64e";
}

.bi-recycle::before {
  content: "\\f64f";
}

.bi-reddit::before {
  content: "\\f650";
}

.bi-safe-fill::before {
  content: "\\f651";
}

.bi-safe2-fill::before {
  content: "\\f652";
}

.bi-safe2::before {
  content: "\\f653";
}

.bi-sd-card-fill::before {
  content: "\\f654";
}

.bi-sd-card::before {
  content: "\\f655";
}

.bi-skype::before {
  content: "\\f656";
}

.bi-slash-lg::before {
  content: "\\f657";
}

.bi-translate::before {
  content: "\\f658";
}

.bi-x-lg::before {
  content: "\\f659";
}

.bi-safe::before {
  content: "\\f65a";
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/Theme.scss","webpack://./src/assets/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./src/assets/scss/config/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/custom/components/_accordions.scss","webpack://./src/assets/scss/custom/components/_badge.scss","webpack://./src/assets/scss/custom/components/_backgrounds.scss","webpack://./src/assets/scss/custom/components/_breadcrumb.scss","webpack://./src/assets/scss/custom/components/_buttons.scss","webpack://./src/assets/scss/custom/components/_card.scss","webpack://./src/assets/scss/custom/components/_dropdown.scss","webpack://./src/assets/scss/custom/components/_forms.scss","webpack://./src/assets/scss/custom/components/_modal.scss","webpack://./src/assets/scss/custom/components/_nav.scss","webpack://./src/assets/scss/custom/components/_pagination.scss","webpack://./src/assets/scss/custom/components/_popover.scss","webpack://./src/assets/scss/custom/components/_progress.scss","webpack://./src/assets/scss/custom/components/_reboot.scss","webpack://./src/assets/scss/custom/components/_tables.scss","webpack://./src/assets/scss/custom/components/_type.scss","webpack://./src/assets/scss/app.scss","webpack://./src/assets/scss/custom/structure/_general.scss","webpack://./src/assets/scss/custom/structure/_left-menu.scss","webpack://./src/assets/scss/custom/structure/_topbar.scss","webpack://./src/assets/scss/custom/structure/_page-head.scss","webpack://./src/assets/scss/custom/structure/_footer.scss","webpack://./src/assets/scss/custom/structure/_right-sidebar.scss","webpack://./src/assets/scss/custom/structure/_layouts.scss","webpack://./src/assets/scss/custom/structure/_horizontal-nav.scss","webpack://./src/assets/scss/custom/structure/_two-column-menu.scss","webpack://./src/assets/scss/custom/components/_avatar.scss","webpack://./src/assets/scss/custom/components/_custom-checkbox.scss","webpack://./src/assets/scss/custom/components/_custom-radio.scss","webpack://./src/assets/scss/custom/components/_helper.scss","webpack://./src/assets/scss/custom/components/_social.scss","webpack://./src/assets/scss/custom/components/_widgets.scss","webpack://./src/assets/scss/custom/components/_print.scss","webpack://./src/assets/scss/custom/components/_preloader.scss","webpack://./src/assets/scss/custom/pages/_authentication.scss","webpack://./src/assets/scss/custom/pages/_components-demo.scss","webpack://./src/assets/scss/custom/pages/_error.scss","webpack://./src/assets/scss/custom/pages/_email.scss","webpack://./src/assets/scss/custom/pages/_pricing.scss","webpack://./src/assets/scss/custom/pages/_profile.scss","webpack://./src/assets/scss/custom/pages/_task.scss","webpack://./src/assets/scss/custom/pages/_timeline.scss","webpack://./src/assets/scss/custom/pages/_landing.scss","webpack://./src/assets/scss/custom/pages/_file-manager.scss","webpack://./src/assets/scss/custom/pages/_chat.scss","webpack://./src/assets/scss/custom/pages/_dashboard.scss","webpack://./src/assets/scss/custom/plugins/_apexcharts.scss","webpack://./src/assets/scss/custom/plugins/_calendar.scss","webpack://./src/assets/scss/custom/plugins/_colorpicker.scss","webpack://./src/assets/scss/custom/plugins/_sparkline-chart.scss","webpack://./src/assets/scss/custom/plugins/_datatable.scss","webpack://./src/assets/scss/custom/plugins/_datepicker.scss","webpack://./src/assets/scss/custom/plugins/_form-wizard.scss","webpack://./src/assets/scss/custom/plugins/_select2.scss","webpack://./src/assets/scss/custom/plugins/_simplebar.scss","webpack://./src/assets/scss/custom/plugins/_multiple-select.scss","webpack://./src/assets/scss/custom/plugins/_bootstrap-touchspin.scss","webpack://./src/assets/scss/custom/plugins/_parsley.scss","webpack://./src/assets/scss/custom/plugins/_quilljs-editor.scss","webpack://./src/assets/scss/custom/plugins/_react-select.scss","webpack://./src/assets/scss/custom/plugins/_react-table.scss","webpack://./src/assets/scss/custom/plugins/_flatpickr.scss","webpack://./src/assets/scss/custom/plugins/_dropzone.scss","webpack://./src/assets/scss/custom/plugins/_google-maps.scss","webpack://./src/assets/scss/custom/plugins/_vector-maps.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/custom/plugins/icons/_unicons.scss","webpack://./src/assets/scss/custom/plugins/icons/_bootstrap-icons.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CAAA;ACAA;;;;;EAAA;ACAA;EAQI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAGF,6BAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EAMA,mEAAA;EACA,yGAAA;EACA,yFAAA;EAQA,gEAAA;EACA,6BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;EAIA,qBAAA;AHkBF;;AIrDA;;;EAGE,sBAAA;AJwDF;;AIzCI;EANJ;IAOM,uBAAA;EJ6CJ;AACF;;AIhCA;EACE,SAAA;EACA,uCAAA;ECmPI,mCALI;ED5OR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AJmCF;;AIzBA;EACE,gBAAA;EACA,0DEksB4B;EFjsB5B,8BAAA;EACA,SAAA;EACA,UEisB4B;ANrqB9B;;AIzBA;EACE,WE0iB4B;AN9gB9B;;AIlBA;EACE,aAAA;EACA,qBE+YO;EF5YP,gBEuoB4B;EFtoB5B,gBEuoB4B;ANpnB9B;;AIfA;ECwMQ,gCAAA;ALrLR;AKmBI;EDtCJ;IC+MQ,kBAAA;ELxLN;AACF;;AInBA;ECmMQ,mCAAA;AL5KR;AKUI;EDjCJ;IC0MQ,mBAAA;EL/KN;AACF;;AIvBA;EC8LQ,iCAAA;ALnKR;AKCI;ED5BJ;ICqMQ,iBAAA;ELtKN;AACF;;AI3BA;ECqLM,mBALI;ALjJV;;AI1BA;ECgLM,oBALI;AL7IV;;AIzBA;EC2KM,iBALI;ALzIV;;AIlBA;EACE,aAAA;EACA,mBEob0B;AN/Z5B;;AIVA;;EAEE,iCAAA;EACA,YAAA;EACA,8BAAA;AJaF;;AIPA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJUF;;AIJA;;EAEE,kBAAA;AJOF;;AIJA;;;EAGE,aAAA;EACA,mBAAA;AJOF;;AIJA;;;;EAIE,gBAAA;AJOF;;AIJA;EACE,gBE0gB4B;ANngB9B;;AIFA;EACE,qBAAA;EACA,cAAA;AJKF;;AICA;EACE,gBAAA;AJEF;;AIMA;;EAEE,mBEmf4B;ANtf9B;;AIWA;EC4EM,kBALI;AL9EV;;AIcA;EACE,cE+iB4B;EF9iB5B,yBEsjB4B;ANjkB9B;;AIoBA;;EAEE,kBAAA;ECwDI,iBALI;EDjDR,cAAA;EACA,wBAAA;AJjBF;;AIoBA;EAAM,eAAA;AJhBN;;AIiBA;EAAM,WAAA;AJbN;;AIkBA;EACE,cElGQ;EFmGR,qBEoTwC;ANnU1C;AIiBE;EACE,yDEmTsC;EFlTtC,qBEmTsC;ANlU1C;;AIyBE;EAEE,cAAA;EACA,qBAAA;AJvBJ;;AI8BA;;;;EAIE,qCEga4B;EDlZxB,cALI;EDPR,+BAAA;EACA,2BAAA;AJ3BF;;AIkCA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ECAI,gBALI;EDOR,cEpKS;ANqIX;AIkCE;ECLI,kBALI;EDYN,cAAA;EACA,kBAAA;AJhCJ;;AIoCA;ECZM,gBALI;EDmBR,cExJQ;EFyJR,qBAAA;AJjCF;AIoCE;EACE,cAAA;AJlCJ;;AIsCA;EACE,sBAAA;ECxBI,gBALI;ED+BR,WErMS;EFsMT,yBE7LS;EChHP,qBAAA;AP2QJ;AIqCE;EACE,UAAA;EC/BE,cALI;EDsCN,gBE6X0B;ANha9B;;AI4CA;EACE,gBAAA;AJzCF;;AI+CA;;EAEE,sBAAA;AJ5CF;;AIoDA;EACE,oBAAA;EACA,yBAAA;AJjDF;;AIoDA;EACE,oBE2b4B;EF1b5B,uBE0b4B;EFzb5B,cExOS;EFyOT,gBAAA;AJjDF;;AIwDA;EAEE,mBAAA;EACA,gCAAA;AJtDF;;AIyDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AJtDF;;AI8DA;EACE,qBAAA;AJ3DF;;AIiEA;EAEE,gBAAA;AJ/DF;;AIuEA;EACE,UAAA;AJpEF;;AIyEA;;;;;EAKE,SAAA;EACA,oBAAA;EC9HI,kBALI;EDqIR,oBAAA;AJtEF;;AI0EA;;EAEE,oBAAA;AJvEF;;AI4EA;EACE,eAAA;AJzEF;;AI4EA;EAGE,iBAAA;AJ3EF;AI8EE;EACE,UAAA;AJ5EJ;;AImFA;EACE,aAAA;AJhFF;;AIwFA;;;;EAIE,0BAAA;AJrFF;AIwFI;;;;EACE,eAAA;AJnFN;;AI0FA;EACE,UAAA;EACA,kBAAA;AJvFF;;AI4FA;EACE,gBAAA;AJzFF;;AImGA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AJhGF;;AIwGA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBEgR4B;EDnetB,iCAAA;AL+GR;AKjRI;EDiXJ;ICxMQ,iBAAA;EL4GN;AACF;AI2FA;EAOE,oBAAA;AJ/FF;AIiGE;EACE,WAAA;AJ/FJ;;AIsGA;;;;;;;EAOE,UAAA;AJnGF;;AIsGA;EACE,YAAA;AJnGF;;AI4GA;EACE,oBAAA;EACA,6BAAA;AJzGF;;AIiHA;;;;;;;CAAA;AAWA;EACE,wBAAA;AJjHF;;AIsHA;EACE,UAAA;AJnHF;;AIyHA;EACE,aAAA;AJtHF;;AI4HA;EACE,aAAA;EACA,0BAAA;AJzHF;;AI8HA;EACE,qBAAA;AJ3HF;;AIgIA;EACE,SAAA;AJ7HF;;AIoIA;EACE,kBAAA;EACA,eAAA;AJjIF;;AIyIA;EACE,wBAAA;AJtIF;;AI8IA;EACE,wBAAA;AJ3IF;;AQxcA;EHyQM,qBALI;EGlQR,gBF0tB4B;AN/Q9B;;AQtcE;EHsQM,iCAAA;ALoMR;AKtWI;EGpGF;IH6QM,eAAA;ELiMN;AACF;AQ/cE;EAEE,gBF6sBkB;EE5sBlB,gBF8rB0B;AN9O9B;;AQndE;EHsQM,iCAAA;ALiNR;AKnXI;EGpGF;IH6QM,iBAAA;EL8MN;AACF;AQ5dE;EAEE,gBF6sBkB;EE5sBlB,gBF8rB0B;ANjO9B;;AQheE;EHsQM,iCAAA;AL8NR;AKhYI;EGpGF;IH6QM,eAAA;EL2NN;AACF;AQzeE;EAEE,gBF6sBkB;EE5sBlB,gBF8rB0B;ANpN9B;;AQ7eE;EHsQM,iCAAA;AL2OR;AK7YI;EGpGF;IH6QM,iBAAA;ELwON;AACF;AQtfE;EAEE,gBF6sBkB;EE5sBlB,gBF8rB0B;ANvM9B;;AQ1fE;EHsQM,iCAAA;ALwPR;AK1ZI;EGpGF;IH6QM,eAAA;ELqPN;AACF;AQngBE;EAEE,gBF6sBkB;EE5sBlB,gBF8rB0B;AN1L9B;;AQvgBE;EHsQM,iCAAA;ALqQR;AKvaI;EGpGF;IH6QM,iBAAA;ELkQN;AACF;AQhhBE;EAEE,gBF6sBkB;EE5sBlB,gBF8rB0B;AN7K9B;;AQ9fA;ECrDE,eAAA;EACA,gBAAA;ATujBF;;AQ9fA;EC1DE,eAAA;EACA,gBAAA;AT4jBF;;AQhgBA;EACE,qBAAA;ARmgBF;AQjgBE;EACE,iBFitB0B;AN9M9B;;AQzfA;EHsNM,kBALI;EG/MR,yBAAA;AR4fF;;AQxfA;EACE,qBFkZO;EDnMH,qBALI;ALkTV;AQzfE;EACE,gBAAA;AR2fJ;;AQvfA;EACE,mBAAA;EACA,qBFwYO;EDnMH,kBALI;EG9LR,cF8BS;AN4dX;AQxfE;EACE,aAAA;AR0fJ;;AUxlBA;ECIE,eAAA;EAGA,YAAA;AXslBF;;AUvlBA;EACE,gBJykDkC;EIxkDlC,yBJsf0B;EIrf1B,yBAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AX+lBF;;AUjlBA;EAEE,qBAAA;AVmlBF;;AUhlBA;EACE,sBAAA;EACA,cAAA;AVmlBF;;AUhlBA;EL+PM,kBALI;EKxPR,cJwFS;AN2fX;;AYrnBE;;;;;;;ECHA,WAAA;EACA,uCAAA;EACA,sCAAA;EACA,kBAAA;EACA,iBAAA;AbkoBF;;Ac1kBI;EF5CE;IACE,gBNmkBe;ENuDrB;AACF;AchlBI;EF5CE;IACE,gBNmkBe;EN4DrB;AACF;AcrlBI;EF5CE;IACE,gBNmkBe;ENiErB;AACF;Ac1lBI;EF5CE;IACE,iBNmkBe;ENsErB;AACF;Ac/lBI;EF5CE;IACE,iBNmkBe;EN2ErB;AACF;Ae9pBE;ECAA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhBgqBF;AepqBI;ECaF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhB0pBF;;AgB3mBM;EACE,SAAA;AhB8mBR;;AgB3mBM;EApCJ,cAAA;EACA,WAAA;AhBmpBF;;AgBroBE;EACE,cAAA;EACA,WAAA;AhBwoBJ;;AgB1oBE;EACE,cAAA;EACA,UAAA;AhB6oBJ;;AgB/oBE;EACE,cAAA;EACA,qBAAA;AhBkpBJ;;AgBppBE;EACE,cAAA;EACA,UAAA;AhBupBJ;;AgBzpBE;EACE,cAAA;EACA,UAAA;AhB4pBJ;;AgB9pBE;EACE,cAAA;EACA,qBAAA;AhBiqBJ;;AgBloBM;EAhDJ,cAAA;EACA,WAAA;AhBsrBF;;AgBjoBU;EAhEN,cAAA;EACA,kBAAA;AhBqsBJ;;AgBtoBU;EAhEN,cAAA;EACA,mBAAA;AhB0sBJ;;AgB3oBU;EAhEN,cAAA;EACA,UAAA;AhB+sBJ;;AgBhpBU;EAhEN,cAAA;EACA,mBAAA;AhBotBJ;;AgBrpBU;EAhEN,cAAA;EACA,mBAAA;AhBytBJ;;AgB1pBU;EAhEN,cAAA;EACA,UAAA;AhB8tBJ;;AgB/pBU;EAhEN,cAAA;EACA,mBAAA;AhBmuBJ;;AgBpqBU;EAhEN,cAAA;EACA,mBAAA;AhBwuBJ;;AgBzqBU;EAhEN,cAAA;EACA,UAAA;AhB6uBJ;;AgB9qBU;EAhEN,cAAA;EACA,mBAAA;AhBkvBJ;;AgBnrBU;EAhEN,cAAA;EACA,mBAAA;AhBuvBJ;;AgBxrBU;EAhEN,cAAA;EACA,WAAA;AhB4vBJ;;AgBrrBY;EAxDV,wBAAA;AhBivBF;;AgBzrBY;EAxDV,yBAAA;AhBqvBF;;AgB7rBY;EAxDV,gBAAA;AhByvBF;;AgBjsBY;EAxDV,yBAAA;AhB6vBF;;AgBrsBY;EAxDV,yBAAA;AhBiwBF;;AgBzsBY;EAxDV,gBAAA;AhBqwBF;;AgB7sBY;EAxDV,yBAAA;AhBywBF;;AgBjtBY;EAxDV,yBAAA;AhB6wBF;;AgBrtBY;EAxDV,gBAAA;AhBixBF;;AgBztBY;EAxDV,yBAAA;AhBqxBF;;AgB7tBY;EAxDV,yBAAA;AhByxBF;;AgBttBQ;;EAEE,gBAAA;AhBytBV;;AgBttBQ;;EAEE,gBAAA;AhBytBV;;AgBhuBQ;;EAEE,uBAAA;AhBmuBV;;AgBhuBQ;;EAEE,uBAAA;AhBmuBV;;AgB1uBQ;;EAEE,sBAAA;AhB6uBV;;AgB1uBQ;;EAEE,sBAAA;AhB6uBV;;AgBpvBQ;;EAEE,qBAAA;AhBuvBV;;AgBpvBQ;;EAEE,qBAAA;AhBuvBV;;AgB9vBQ;;EAEE,sBAAA;AhBiwBV;;AgB9vBQ;;EAEE,sBAAA;AhBiwBV;;AgBxwBQ;;EAEE,qBAAA;AhB2wBV;;AgBxwBQ;;EAEE,qBAAA;AhB2wBV;;Acr0BI;EEUE;IACE,SAAA;EhB+zBN;EgB5zBI;IApCJ,cAAA;IACA,WAAA;EhBm2BA;EgBr1BA;IACE,cAAA;IACA,WAAA;EhBu1BF;EgBz1BA;IACE,cAAA;IACA,UAAA;EhB21BF;EgB71BA;IACE,cAAA;IACA,qBAAA;EhB+1BF;EgBj2BA;IACE,cAAA;IACA,UAAA;EhBm2BF;EgBr2BA;IACE,cAAA;IACA,UAAA;EhBu2BF;EgBz2BA;IACE,cAAA;IACA,qBAAA;EhB22BF;EgB50BI;IAhDJ,cAAA;IACA,WAAA;EhB+3BA;EgB10BQ;IAhEN,cAAA;IACA,kBAAA;EhB64BF;EgB90BQ;IAhEN,cAAA;IACA,mBAAA;EhBi5BF;EgBl1BQ;IAhEN,cAAA;IACA,UAAA;EhBq5BF;EgBt1BQ;IAhEN,cAAA;IACA,mBAAA;EhBy5BF;EgB11BQ;IAhEN,cAAA;IACA,mBAAA;EhB65BF;EgB91BQ;IAhEN,cAAA;IACA,UAAA;EhBi6BF;EgBl2BQ;IAhEN,cAAA;IACA,mBAAA;EhBq6BF;EgBt2BQ;IAhEN,cAAA;IACA,mBAAA;EhBy6BF;EgB12BQ;IAhEN,cAAA;IACA,UAAA;EhB66BF;EgB92BQ;IAhEN,cAAA;IACA,mBAAA;EhBi7BF;EgBl3BQ;IAhEN,cAAA;IACA,mBAAA;EhBq7BF;EgBt3BQ;IAhEN,cAAA;IACA,WAAA;EhBy7BF;EgBl3BU;IAxDV,cAAA;EhB66BA;EgBr3BU;IAxDV,wBAAA;EhBg7BA;EgBx3BU;IAxDV,yBAAA;EhBm7BA;EgB33BU;IAxDV,gBAAA;EhBs7BA;EgB93BU;IAxDV,yBAAA;EhBy7BA;EgBj4BU;IAxDV,yBAAA;EhB47BA;EgBp4BU;IAxDV,gBAAA;EhB+7BA;EgBv4BU;IAxDV,yBAAA;EhBk8BA;EgB14BU;IAxDV,yBAAA;EhBq8BA;EgB74BU;IAxDV,gBAAA;EhBw8BA;EgBh5BU;IAxDV,yBAAA;EhB28BA;EgBn5BU;IAxDV,yBAAA;EhB88BA;EgB34BM;;IAEE,gBAAA;EhB64BR;EgB14BM;;IAEE,gBAAA;EhB44BR;EgBn5BM;;IAEE,uBAAA;EhBq5BR;EgBl5BM;;IAEE,uBAAA;EhBo5BR;EgB35BM;;IAEE,sBAAA;EhB65BR;EgB15BM;;IAEE,sBAAA;EhB45BR;EgBn6BM;;IAEE,qBAAA;EhBq6BR;EgBl6BM;;IAEE,qBAAA;EhBo6BR;EgB36BM;;IAEE,sBAAA;EhB66BR;EgB16BM;;IAEE,sBAAA;EhB46BR;EgBn7BM;;IAEE,qBAAA;EhBq7BR;EgBl7BM;;IAEE,qBAAA;EhBo7BR;AACF;Ac/+BI;EEUE;IACE,SAAA;EhBw+BN;EgBr+BI;IApCJ,cAAA;IACA,WAAA;EhB4gCA;EgB9/BA;IACE,cAAA;IACA,WAAA;EhBggCF;EgBlgCA;IACE,cAAA;IACA,UAAA;EhBogCF;EgBtgCA;IACE,cAAA;IACA,qBAAA;EhBwgCF;EgB1gCA;IACE,cAAA;IACA,UAAA;EhB4gCF;EgB9gCA;IACE,cAAA;IACA,UAAA;EhBghCF;EgBlhCA;IACE,cAAA;IACA,qBAAA;EhBohCF;EgBr/BI;IAhDJ,cAAA;IACA,WAAA;EhBwiCA;EgBn/BQ;IAhEN,cAAA;IACA,kBAAA;EhBsjCF;EgBv/BQ;IAhEN,cAAA;IACA,mBAAA;EhB0jCF;EgB3/BQ;IAhEN,cAAA;IACA,UAAA;EhB8jCF;EgB//BQ;IAhEN,cAAA;IACA,mBAAA;EhBkkCF;EgBngCQ;IAhEN,cAAA;IACA,mBAAA;EhBskCF;EgBvgCQ;IAhEN,cAAA;IACA,UAAA;EhB0kCF;EgB3gCQ;IAhEN,cAAA;IACA,mBAAA;EhB8kCF;EgB/gCQ;IAhEN,cAAA;IACA,mBAAA;EhBklCF;EgBnhCQ;IAhEN,cAAA;IACA,UAAA;EhBslCF;EgBvhCQ;IAhEN,cAAA;IACA,mBAAA;EhB0lCF;EgB3hCQ;IAhEN,cAAA;IACA,mBAAA;EhB8lCF;EgB/hCQ;IAhEN,cAAA;IACA,WAAA;EhBkmCF;EgB3hCU;IAxDV,cAAA;EhBslCA;EgB9hCU;IAxDV,wBAAA;EhBylCA;EgBjiCU;IAxDV,yBAAA;EhB4lCA;EgBpiCU;IAxDV,gBAAA;EhB+lCA;EgBviCU;IAxDV,yBAAA;EhBkmCA;EgB1iCU;IAxDV,yBAAA;EhBqmCA;EgB7iCU;IAxDV,gBAAA;EhBwmCA;EgBhjCU;IAxDV,yBAAA;EhB2mCA;EgBnjCU;IAxDV,yBAAA;EhB8mCA;EgBtjCU;IAxDV,gBAAA;EhBinCA;EgBzjCU;IAxDV,yBAAA;EhBonCA;EgB5jCU;IAxDV,yBAAA;EhBunCA;EgBpjCM;;IAEE,gBAAA;EhBsjCR;EgBnjCM;;IAEE,gBAAA;EhBqjCR;EgB5jCM;;IAEE,uBAAA;EhB8jCR;EgB3jCM;;IAEE,uBAAA;EhB6jCR;EgBpkCM;;IAEE,sBAAA;EhBskCR;EgBnkCM;;IAEE,sBAAA;EhBqkCR;EgB5kCM;;IAEE,qBAAA;EhB8kCR;EgB3kCM;;IAEE,qBAAA;EhB6kCR;EgBplCM;;IAEE,sBAAA;EhBslCR;EgBnlCM;;IAEE,sBAAA;EhBqlCR;EgB5lCM;;IAEE,qBAAA;EhB8lCR;EgB3lCM;;IAEE,qBAAA;EhB6lCR;AACF;AcxpCI;EEUE;IACE,SAAA;EhBipCN;EgB9oCI;IApCJ,cAAA;IACA,WAAA;EhBqrCA;EgBvqCA;IACE,cAAA;IACA,WAAA;EhByqCF;EgB3qCA;IACE,cAAA;IACA,UAAA;EhB6qCF;EgB/qCA;IACE,cAAA;IACA,qBAAA;EhBirCF;EgBnrCA;IACE,cAAA;IACA,UAAA;EhBqrCF;EgBvrCA;IACE,cAAA;IACA,UAAA;EhByrCF;EgB3rCA;IACE,cAAA;IACA,qBAAA;EhB6rCF;EgB9pCI;IAhDJ,cAAA;IACA,WAAA;EhBitCA;EgB5pCQ;IAhEN,cAAA;IACA,kBAAA;EhB+tCF;EgBhqCQ;IAhEN,cAAA;IACA,mBAAA;EhBmuCF;EgBpqCQ;IAhEN,cAAA;IACA,UAAA;EhBuuCF;EgBxqCQ;IAhEN,cAAA;IACA,mBAAA;EhB2uCF;EgB5qCQ;IAhEN,cAAA;IACA,mBAAA;EhB+uCF;EgBhrCQ;IAhEN,cAAA;IACA,UAAA;EhBmvCF;EgBprCQ;IAhEN,cAAA;IACA,mBAAA;EhBuvCF;EgBxrCQ;IAhEN,cAAA;IACA,mBAAA;EhB2vCF;EgB5rCQ;IAhEN,cAAA;IACA,UAAA;EhB+vCF;EgBhsCQ;IAhEN,cAAA;IACA,mBAAA;EhBmwCF;EgBpsCQ;IAhEN,cAAA;IACA,mBAAA;EhBuwCF;EgBxsCQ;IAhEN,cAAA;IACA,WAAA;EhB2wCF;EgBpsCU;IAxDV,cAAA;EhB+vCA;EgBvsCU;IAxDV,wBAAA;EhBkwCA;EgB1sCU;IAxDV,yBAAA;EhBqwCA;EgB7sCU;IAxDV,gBAAA;EhBwwCA;EgBhtCU;IAxDV,yBAAA;EhB2wCA;EgBntCU;IAxDV,yBAAA;EhB8wCA;EgBttCU;IAxDV,gBAAA;EhBixCA;EgBztCU;IAxDV,yBAAA;EhBoxCA;EgB5tCU;IAxDV,yBAAA;EhBuxCA;EgB/tCU;IAxDV,gBAAA;EhB0xCA;EgBluCU;IAxDV,yBAAA;EhB6xCA;EgBruCU;IAxDV,yBAAA;EhBgyCA;EgB7tCM;;IAEE,gBAAA;EhB+tCR;EgB5tCM;;IAEE,gBAAA;EhB8tCR;EgBruCM;;IAEE,uBAAA;EhBuuCR;EgBpuCM;;IAEE,uBAAA;EhBsuCR;EgB7uCM;;IAEE,sBAAA;EhB+uCR;EgB5uCM;;IAEE,sBAAA;EhB8uCR;EgBrvCM;;IAEE,qBAAA;EhBuvCR;EgBpvCM;;IAEE,qBAAA;EhBsvCR;EgB7vCM;;IAEE,sBAAA;EhB+vCR;EgB5vCM;;IAEE,sBAAA;EhB8vCR;EgBrwCM;;IAEE,qBAAA;EhBuwCR;EgBpwCM;;IAEE,qBAAA;EhBswCR;AACF;Acj0CI;EEUE;IACE,SAAA;EhB0zCN;EgBvzCI;IApCJ,cAAA;IACA,WAAA;EhB81CA;EgBh1CA;IACE,cAAA;IACA,WAAA;EhBk1CF;EgBp1CA;IACE,cAAA;IACA,UAAA;EhBs1CF;EgBx1CA;IACE,cAAA;IACA,qBAAA;EhB01CF;EgB51CA;IACE,cAAA;IACA,UAAA;EhB81CF;EgBh2CA;IACE,cAAA;IACA,UAAA;EhBk2CF;EgBp2CA;IACE,cAAA;IACA,qBAAA;EhBs2CF;EgBv0CI;IAhDJ,cAAA;IACA,WAAA;EhB03CA;EgBr0CQ;IAhEN,cAAA;IACA,kBAAA;EhBw4CF;EgBz0CQ;IAhEN,cAAA;IACA,mBAAA;EhB44CF;EgB70CQ;IAhEN,cAAA;IACA,UAAA;EhBg5CF;EgBj1CQ;IAhEN,cAAA;IACA,mBAAA;EhBo5CF;EgBr1CQ;IAhEN,cAAA;IACA,mBAAA;EhBw5CF;EgBz1CQ;IAhEN,cAAA;IACA,UAAA;EhB45CF;EgB71CQ;IAhEN,cAAA;IACA,mBAAA;EhBg6CF;EgBj2CQ;IAhEN,cAAA;IACA,mBAAA;EhBo6CF;EgBr2CQ;IAhEN,cAAA;IACA,UAAA;EhBw6CF;EgBz2CQ;IAhEN,cAAA;IACA,mBAAA;EhB46CF;EgB72CQ;IAhEN,cAAA;IACA,mBAAA;EhBg7CF;EgBj3CQ;IAhEN,cAAA;IACA,WAAA;EhBo7CF;EgB72CU;IAxDV,cAAA;EhBw6CA;EgBh3CU;IAxDV,wBAAA;EhB26CA;EgBn3CU;IAxDV,yBAAA;EhB86CA;EgBt3CU;IAxDV,gBAAA;EhBi7CA;EgBz3CU;IAxDV,yBAAA;EhBo7CA;EgB53CU;IAxDV,yBAAA;EhBu7CA;EgB/3CU;IAxDV,gBAAA;EhB07CA;EgBl4CU;IAxDV,yBAAA;EhB67CA;EgBr4CU;IAxDV,yBAAA;EhBg8CA;EgBx4CU;IAxDV,gBAAA;EhBm8CA;EgB34CU;IAxDV,yBAAA;EhBs8CA;EgB94CU;IAxDV,yBAAA;EhBy8CA;EgBt4CM;;IAEE,gBAAA;EhBw4CR;EgBr4CM;;IAEE,gBAAA;EhBu4CR;EgB94CM;;IAEE,uBAAA;EhBg5CR;EgB74CM;;IAEE,uBAAA;EhB+4CR;EgBt5CM;;IAEE,sBAAA;EhBw5CR;EgBr5CM;;IAEE,sBAAA;EhBu5CR;EgB95CM;;IAEE,qBAAA;EhBg6CR;EgB75CM;;IAEE,qBAAA;EhB+5CR;EgBt6CM;;IAEE,sBAAA;EhBw6CR;EgBr6CM;;IAEE,sBAAA;EhBu6CR;EgB96CM;;IAEE,qBAAA;EhBg7CR;EgB76CM;;IAEE,qBAAA;EhB+6CR;AACF;Ac1+CI;EEUE;IACE,SAAA;EhBm+CN;EgBh+CI;IApCJ,cAAA;IACA,WAAA;EhBugDA;EgBz/CA;IACE,cAAA;IACA,WAAA;EhB2/CF;EgB7/CA;IACE,cAAA;IACA,UAAA;EhB+/CF;EgBjgDA;IACE,cAAA;IACA,qBAAA;EhBmgDF;EgBrgDA;IACE,cAAA;IACA,UAAA;EhBugDF;EgBzgDA;IACE,cAAA;IACA,UAAA;EhB2gDF;EgB7gDA;IACE,cAAA;IACA,qBAAA;EhB+gDF;EgBh/CI;IAhDJ,cAAA;IACA,WAAA;EhBmiDA;EgB9+CQ;IAhEN,cAAA;IACA,kBAAA;EhBijDF;EgBl/CQ;IAhEN,cAAA;IACA,mBAAA;EhBqjDF;EgBt/CQ;IAhEN,cAAA;IACA,UAAA;EhByjDF;EgB1/CQ;IAhEN,cAAA;IACA,mBAAA;EhB6jDF;EgB9/CQ;IAhEN,cAAA;IACA,mBAAA;EhBikDF;EgBlgDQ;IAhEN,cAAA;IACA,UAAA;EhBqkDF;EgBtgDQ;IAhEN,cAAA;IACA,mBAAA;EhBykDF;EgB1gDQ;IAhEN,cAAA;IACA,mBAAA;EhB6kDF;EgB9gDQ;IAhEN,cAAA;IACA,UAAA;EhBilDF;EgBlhDQ;IAhEN,cAAA;IACA,mBAAA;EhBqlDF;EgBthDQ;IAhEN,cAAA;IACA,mBAAA;EhBylDF;EgB1hDQ;IAhEN,cAAA;IACA,WAAA;EhB6lDF;EgBthDU;IAxDV,cAAA;EhBilDA;EgBzhDU;IAxDV,wBAAA;EhBolDA;EgB5hDU;IAxDV,yBAAA;EhBulDA;EgB/hDU;IAxDV,gBAAA;EhB0lDA;EgBliDU;IAxDV,yBAAA;EhB6lDA;EgBriDU;IAxDV,yBAAA;EhBgmDA;EgBxiDU;IAxDV,gBAAA;EhBmmDA;EgB3iDU;IAxDV,yBAAA;EhBsmDA;EgB9iDU;IAxDV,yBAAA;EhBymDA;EgBjjDU;IAxDV,gBAAA;EhB4mDA;EgBpjDU;IAxDV,yBAAA;EhB+mDA;EgBvjDU;IAxDV,yBAAA;EhBknDA;EgB/iDM;;IAEE,gBAAA;EhBijDR;EgB9iDM;;IAEE,gBAAA;EhBgjDR;EgBvjDM;;IAEE,uBAAA;EhByjDR;EgBtjDM;;IAEE,uBAAA;EhBwjDR;EgB/jDM;;IAEE,sBAAA;EhBikDR;EgB9jDM;;IAEE,sBAAA;EhBgkDR;EgBvkDM;;IAEE,qBAAA;EhBykDR;EgBtkDM;;IAEE,qBAAA;EhBwkDR;EgB/kDM;;IAEE,sBAAA;EhBilDR;EgB9kDM;;IAEE,sBAAA;EhBglDR;EgBvlDM;;IAEE,qBAAA;EhBylDR;EgBtlDM;;IAEE,qBAAA;EhBwlDR;AACF;AiB9sDA;EACE,0BAAA;EACA,iCAAA;EACA,iCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,qBXydO;EWxdP,cXiHS;EWhHT,mBXqxB4B;EWpxB5B,qBX2GS;ANomDX;AiBxsDE;EACE,wBAAA;EACA,oCAAA;EACA,wBX2lB0B;EW1lB1B,wDAAA;AjB0sDJ;AiBvsDE;EACE,uBAAA;AjBysDJ;AiBtsDE;EACE,sBAAA;AjBwsDJ;AiBpsDE;EACE,6BAAA;AjBssDJ;;AiB7rDA;EACE,iBAAA;AjBgsDF;;AiBtrDE;EACE,sBAAA;AjByrDJ;;AiB1qDE;EACE,mBAAA;AjB6qDJ;AiB1qDI;EACE,mBAAA;AjB4qDN;;AiBrqDE;EACE,sBAAA;AjBwqDJ;AiBrqDE;EACE,mBAAA;AjBuqDJ;;AiB9pDE;EACE,gDAAA;EACA,oCAAA;AjBiqDJ;;AiBzpDA;EACE,+CAAA;EACA,mCAAA;AjB4pDF;;AiBppDE;EACE,8CAAA;EACA,kCAAA;AjBupDJ;;AkBnxDE;EAME,kEAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,cAbQ;EAcR,iEAAA;AlBgxDJ;;AkB/xDE;EAME,kEAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,cAbQ;EAcR,gEAAA;AlB4xDJ;;AkB3yDE;EAME,kEAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,cAbQ;EAcR,8DAAA;AlBwyDJ;;AkBvzDE;EAME,kEAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,cAbQ;EAcR,gEAAA;AlBozDJ;;AkBn0DE;EAME,uDAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,cAbQ;EAcR,iEAAA;AlBg0DJ;;AkB/0DE;EAME,wDAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,cAbQ;EAcR,+DAAA;AlB40DJ;;AkB31DE;EAME,sBAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,cAbQ;EAcR,gEAAA;AlBw1DJ;;AkBv2DE;EAME,sBAAA;EACA,4BAAA;EACA,iCAAA;EACA,2BAAA;EACA,gCAAA;EACA,0BAAA;EACA,+BAAA;EAEA,WAbQ;EAcR,iEAAA;AlBo2DJ;;AiBhuDI;EACE,gBAAA;EACA,iCAAA;AjBmuDN;;Ac9yDI;EGyEA;IACE,gBAAA;IACA,iCAAA;EjByuDJ;AACF;AcrzDI;EGyEA;IACE,gBAAA;IACA,iCAAA;EjB+uDJ;AACF;Ac3zDI;EGyEA;IACE,gBAAA;IACA,iCAAA;EjBqvDJ;AACF;Acj0DI;EGyEA;IACE,gBAAA;IACA,iCAAA;EjB2vDJ;AACF;Acv0DI;EGyEA;IACE,gBAAA;IACA,iCAAA;EjBiwDJ;AACF;AmBr5DA;EACE,qBb26BsC;AN4+BxC;;AmB94DA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;EdoRI,kBALI;Ec3QR,gBbmrB4B;AN4tC9B;;AmB34DA;EACE,+BAAA;EACA,kCAAA;Ed0QI,qBALI;AL0oDV;;AmB34DA;EACE,gCAAA;EACA,mCAAA;EdoQI,oBALI;ALgpDV;;AoB56DA;EACE,mBdm6BsC;EDnoBlC,kBALI;EevRR,cduHS;ANszDX;;AqBl7DA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EhB8RI,mBALI;EgBtRR,gBfwrB4B;EevrB5B,gBf6rB4B;Ee5rB5B,cfqHS;EepHT,sBf6GS;Ee5GT,4BAAA;EACA,yBAAA;EACA,gBAAA;EdGE,sBAAA;EeHE,wEDMJ;ArBg7DF;AsBl7DM;EDhBN;ICiBQ,gBAAA;EtBq7DN;AACF;AqBn7DE;EACE,gBAAA;ArBq7DJ;AqBn7DI;EACE,eAAA;ArBq7DN;AqBh7DE;EACE,cf+FO;Ee9FP,sBfuFO;EetFP,gEfi7BoC;Eeh7BpC,UAAA;EAKE,gBf86BkC;ANggCxC;AqBv6DE;EAEE,aAAA;ArBw6DJ;AqBp6DE;EACE,cfuEO;EerEP,UAAA;ArBq6DJ;AqB75DE;EAEE,sBfsDO;EenDP,UAAA;ArB45DJ;AqBx5DE;EACE,uBAAA;EACA,wBAAA;EACA,yBf6wB0B;Ee5wB1B,cfkDO;EiB7HT,yBjBwHS;Ee3CP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfkiB0B;EejiB1B,gBAAA;ECtEE,qIDuEF;ArB05DJ;AsB79DM;EDuDJ;ICtDM,gBAAA;EtBg+DN;AACF;AqB55DE;EACE,qEfkhC8B;AN44BlC;AqB35DE;EACE,uBAAA;EACA,wBAAA;EACA,yBf0vB0B;EezvB1B,cf+BO;EiB7HT,yBjBwHS;EexBP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4Bf+gB0B;Ee9gB1B,gBAAA;ECzFE,6ID0FF;EC1FE,qID0FF;ArB65DJ;AsBn/DM;ED0EJ;ICzEM,wBAAA;IAAA,gBAAA;EtBs/DN;AACF;AqB/5DE;EACE,qEf+/B8B;ANk6BlC;;AqBx5DA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBf4kB4B;Ee3kB5B,cfIS;EeHT,6BAAA;EACA,yBAAA;EACA,mBAAA;ArB25DF;AqBz5DE;EAEE,gBAAA;EACA,eAAA;ArB05DJ;;AqB/4DA;EACE,uCfm1BsC;Eel1BtC,uBAAA;EhBmJI,oBALI;EE7QN,qBAAA;APmhEJ;AqBh5DE;EACE,uBAAA;EACA,wBAAA;EACA,yBf8sB0B;ANosC9B;AqB/4DE;EACE,uBAAA;EACA,wBAAA;EACA,yBfwsB0B;ANysC9B;;AqB74DA;EACE,oCfi0BsC;Eeh0BtC,oBAAA;EhBgII,qBALI;EE7QN,qBAAA;APoiEJ;AqB94DE;EACE,oBAAA;EACA,qBAAA;EACA,uBf+rB0B;ANitC9B;AqB74DE;EACE,oBAAA;EACA,qBAAA;EACA,uBfyrB0B;ANstC9B;;AqBv4DE;EACE,sCfwyBoC;ANkmCxC;AqBv4DE;EACE,uCfqyBoC;ANomCxC;AqBt4DE;EACE,oCfkyBoC;ANsmCxC;;AqBn4DA;EACE,WfgyBsC;Ee/xBtC,YAAA;EACA,gBf+oB4B;ANuvC9B;AqBp4DE;EACE,eAAA;ArBs4DJ;AqBn4DE;EACE,aAAA;Ed/LA,sBAAA;APqkEJ;AqBl4DE;EACE,aAAA;EdpMA,sBAAA;APykEJ;;AwBvlEA;EACE,cAAA;EACA,WAAA;EACA,sCAAA;EAEA,sCAAA;EnB2RI,mBALI;EmBnRR,gBlBqrB4B;EkBprB5B,gBlB0rB4B;EkBzrB5B,clBkHS;EkBjHT,sBlB0GS;EkBzGT,yDAAA;EACA,4BAAA;EACA,wClBmiCkC;EkBliClC,0BlBmiCkC;EkBliClC,yBAAA;EjBFE,sBAAA;EeHE,wEEQJ;AxBulEF;AsB3lEM;EEfN;IFgBQ,gBAAA;EtB8lEN;AACF;AwB/mEA;EAoBE,gBAAA;AxB8lEF;AwB5lEE;EACE,gElBy7BoC;EkBx7BpC,UAAA;EAKE,gBlBoiC4B;ANsjClC;AwBtlEE;EAEE,qBlBmzB0B;EkBlzB1B,sBAAA;AxBulEJ;AwBplEE;EACE,clBmFO;EkBlFP,yBlB8EO;ANwgEX;AwBjlEE;EACE,kBAAA;EACA,0BAAA;AxBmlEJ;;AwB/kEA;EACE,oBlB4yB4B;EkB3yB5B,uBlB2yB4B;EkB1yB5B,oBlB2yB4B;EDlkBxB,oBALI;EE7QN,qBAAA;AP6nEJ;;AwB/kEA;EACE,mBlBwyB4B;EkBvyB5B,sBlBuyB4B;EkBtyB5B,kBlBuyB4B;EDtkBxB,qBALI;EE7QN,qBAAA;APqoEJ;;AyBppEA;EACE,cAAA;EACA,qBnBw+BwC;EmBv+BxC,oBnBw+BwC;EmBv+BxC,uBnBw+BwC;AN+qC1C;AyBrpEE;EACE,WAAA;EACA,oBAAA;AzBupEJ;;AyBnpEA;EACE,WnB49BwC;EmB39BxC,YnB29BwC;EmB19BxC,mBAAA;EACA,mBAAA;EACA,sBnBqGS;EmBpGT,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCnB+9BwC;EmB99BxC,gBAAA;EACA,mBAAA;AzBspEF;AyBnpEE;ElBXE,qBAAA;APiqEJ;AyBlpEE;EAEE,kBnBs9BsC;AN6rC1C;AyBhpEE;EACE,uBnB68BsC;ANqsC1C;AyB/oEE;EACE,gEnBy6BoC;EmBx6BpC,UAAA;EACA,4CnBszB4B;AN21ChC;AyB9oEE;EACE,yBnBsGM;EmBrGN,qBnBqGM;AN2iEV;AyB9oEI;EAII,yDAAA;AzB6oER;AyBzoEI;EAII,yDAAA;AzBwoER;AyBnoEE;EACE,yBnBiFM;EmBhFN,qBnBgFM;EmB3EJ,yDAAA;AzBioEN;AyB7nEE;EACE,oBAAA;EACA,YAAA;EACA,YnBq7BuC;AN0sC3C;AyBxnEI;EACE,YnB66BqC;AN6sC3C;;AyB5mEA;EACE,mBnBw6BgC;ANusClC;AyB7mEE;EACE,UnBo6B8B;EmBn6B9B,mBAAA;EACA,yDAAA;EACA,gCAAA;ElB9FA,kBAAA;EeHE,iDGmGF;AzB+mEJ;AsB9sEM;EGyFJ;IHxFM,gBAAA;EtBitEN;AACF;AyBlnEI;EACE,uMAAA;AzBonEN;AyBjnEI;EACE,iCnBm6B4B;EmB95B1B,yDAAA;AzB+mER;;AyBzmEA;EACE,qBAAA;EACA,kBnBs4BgC;ANsuClC;;AyBzmEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzB4mEF;AyBxmEI;EACE,oBAAA;EACA,YAAA;EACA,anBwvBwB;ANk3C9B;;A0BxvEA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A1B2vEF;A0BzvEE;EACE,UAAA;A1B2vEJ;A0BvvEI;EAA0B,mCpBilCa;ANyqC3C;A0BzvEI;EAA0B,mCpBglCa;AN4qC3C;A0BzvEE;EACE,SAAA;A1B2vEJ;A0BxvEE;EACE,WpBkkCuC;EoBjkCvC,YpBikCuC;EoBhkCvC,oBAAA;EHzBF,yBjBoJQ;EoBzHN,SpBikCuC;EC7kCvC,mBAAA;EeHE,oHIkBF;EJlBE,4GIkBF;A1ByvEJ;AsBvwEM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtB0wEN;AACF;A0BtwEE;EASE,gBAAA;A1BgwEJ;A0B9vEI;EHjCF,qEjBimCyC;ANisC3C;A0B5vEE;EACE,WpB2iC8B;EoB1iC9B,cpB2iC8B;EoB1iC9B,kBAAA;EACA,epB0iC8B;EoBziC9B,yBpB8EO;EoB7EP,yBAAA;EnB7BA,mBAAA;AP4xEJ;A0B1vEE;EACE,WpBuiCuC;EoBtiCvC,YpBsiCuC;EiBzlCzC,yBjBoJQ;EoB/FN,SpBuiCuC;EC7kCvC,mBAAA;EeHE,iHI4CF;EJ5CE,4GI4CF;A1B2vEJ;AsBnyEM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtBsyEN;AACF;A0BvwEE;EAQE,gBAAA;A1BkwEJ;A0BhwEI;EH3DF,qEjBimCyC;AN6tC3C;A0B9vEE;EACE,WpBihC8B;EoBhhC9B,cpBihC8B;EoBhhC9B,kBAAA;EACA,epBghC8B;EoB/gC9B,yBpBoDO;EoBnDP,yBAAA;EnBvDA,mBAAA;APwzEJ;A0B5vEE;EACE,oBAAA;A1B8vEJ;A0B5vEI;EACE,yBpB4CK;ANktEX;A0B3vEI;EACE,yBpBwCK;ANqtEX;;A2Bp1EA;EACE,kBAAA;A3Bu1EF;A2Br1EE;;EAEE,0BrB4mC8B;EqB3mC9B,iBrB4mC8B;AN2uClC;A2Bp1EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELDE,gEKEF;A3Bs1EJ;AsBp1EM;EKXJ;ILYM,gBAAA;EtBu1EN;AACF;A2Bv1EE;EACE,oBAAA;A3By1EJ;A2Bv1EI;EACE,kBAAA;A3By1EN;A2Bt1EI;EAEE,qBrBslC4B;EqBrlC5B,wBrBslC4B;ANiwClC;A2Bp1EI;EACE,qBrBilC4B;EqBhlC5B,wBrBilC4B;ANqwClC;A2Bl1EE;EACE,qBrB2kC8B;EqB1kC9B,wBrB2kC8B;ANywClC;A2B90EI;;;EACE,arBqkC4B;EqBpkC5B,8DrBqkC4B;AN6wClC;A2B70EI;EACE,arB8jC4B;EqB7jC5B,8DrB8jC4B;ANixClC;;A4Br4EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5Bw4EF;A4Bt4EE;;EAEE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5Bw4EJ;A4Bp4EE;;EAEE,UAAA;A5Bs4EJ;A4Bh4EE;EACE,kBAAA;EACA,UAAA;A5Bk4EJ;A4Bh4EI;EACE,UAAA;A5Bk4EN;;A4Bv3EA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EvBsPI,mBALI;EuB/OR,gBtBipB4B;EsBhpB5B,gBtBspB4B;EsBrpB5B,ctB8ES;EsB7ET,kBAAA;EACA,mBAAA;EACA,yBtBsES;EsBrET,yBAAA;ErBpCE,sBAAA;AP+5EJ;;A4Bj3EA;;;;EAIE,oBAAA;EvBgOI,qBALI;EE7QN,qBAAA;APw6EJ;;A4Bj3EA;;;;EAIE,uBAAA;EvBuNI,oBALI;EE7QN,qBAAA;APi7EJ;;A4Bj3EA;;EAEE,qBAAA;A5Bo3EF;;A4Bv2EI;;ErB/DA,0BAAA;EACA,6BAAA;AP26EJ;A4Bt2EI;;ErBtEA,0BAAA;EACA,6BAAA;APg7EJ;A4Bh2EE;EACE,iBAAA;ErBpEA,yBAAA;EACA,4BAAA;APu6EJ;;A6Bh8EE;EACE,aAAA;EACA,WAAA;EACA,mBvB44BoC;EDnoBlC,kBALI;EwBjQN,cvB6mCqB;ANq1CzB;;A6B/7EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ExB4PE,mBALI;EwBrPN,gBvB6pB0B;EuB5pB1B,WAvBc;EAwBd,yCAvBiB;EtBHjB,qBAAA;AP69EJ;;A6B97EI;;;;EAEE,cAAA;A7Bm8EN;;A6Bj/EI;EAoDE,qBvBklCmB;EuB/kCjB,mCvBk6BgC;EuBj6BhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A7B+7ER;A6B57EM;EACE,qBvBukCiB;EuBtkCjB,4CA/Ca;A7B6+ErB;;A6B9/EI;EAyEI,mCvBg5BgC;EuB/4BhC,gFAAA;A7By7ER;;A6BngFI;EAiFE,qBvBqjCmB;ANi4CzB;A6Bn7EQ;EAEE,sBvB+9B8B;EuB99B9B,kGAAA;EACA,6DAAA;EACA,yEAAA;A7Bo7EV;A6Bh7EM;EACE,qBvBwiCiB;EuBviCjB,4CA9Ea;A7BggFrB;;A6BjhFI;EAsGE,qBvBgiCmB;AN+4CzB;A6B76EM;EACE,yBvB6hCiB;ANk5CzB;A6B56EM;EACE,4CA5Fa;A7B0gFrB;A6B36EM;EACE,cvBqhCiB;ANw5CzB;;A6Bx6EI;EACE,kBAAA;A7B26EN;;A6BliFI;;;EA+HI,UAAA;A7By6ER;A6Br6EM;;;EACE,UAAA;A7By6ER;;A6B1hFE;EACE,aAAA;EACA,WAAA;EACA,mBvB44BoC;EDnoBlC,kBALI;EwBjQN,cvB6mCqB;AN+6CzB;;A6BzhFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ExB4PE,mBALI;EwBrPN,gBvB6pB0B;EuB5pB1B,WAvBc;EAwBd,yCAvBiB;EtBHjB,qBAAA;APujFJ;;A6BxhFI;;;;EAEE,cAAA;A7B6hFN;;A6B3kFI;EAoDE,qBvBklCmB;EuB/kCjB,mCvBk6BgC;EuBj6BhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A7ByhFR;A6BthFM;EACE,qBvBukCiB;EuBtkCjB,4CA/Ca;A7BukFrB;;A6BxlFI;EAyEI,mCvBg5BgC;EuB/4BhC,gFAAA;A7BmhFR;;A6B7lFI;EAiFE,qBvBqjCmB;AN29CzB;A6B7gFQ;EAEE,sBvB+9B8B;EuB99B9B,kGAAA;EACA,6DAAA;EACA,yEAAA;A7B8gFV;A6B1gFM;EACE,qBvBwiCiB;EuBviCjB,4CA9Ea;A7B0lFrB;;A6B3mFI;EAsGE,qBvBgiCmB;ANy+CzB;A6BvgFM;EACE,yBvB6hCiB;AN4+CzB;A6BtgFM;EACE,4CA5Fa;A7BomFrB;A6BrgFM;EACE,cvBqhCiB;ANk/CzB;;A6BlgFI;EACE,kBAAA;A7BqgFN;;A6B5nFI;;;EAiII,UAAA;A7BigFR;A6B//EM;;;EACE,UAAA;A7BmgFR;;A8BzoFA;EACE,qBAAA;EAEA,gBxB2rB4B;EwB1rB5B,gBxBgsB4B;EwB/rB5B,cxBwHS;EwBvHT,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;EC8GA,uBAAA;E1BsKI,mBALI;EE7QN,sBAAA;EeHE,qIQGJ;A9B2oFF;AsB1oFM;EQhBN;IRiBQ,gBAAA;EtB6oFN;AACF;A8B9oFE;EACE,cxB2GO;ANqiFX;A8B5oFE;EAEE,UAAA;EACA,4CxBu0B4B;ANs0DhC;A8B/nFE;EAGE,oBAAA;EACA,axB61B0B;ANkyD9B;;A8BnnFE;ECvCA,WAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;ANk/Ef;A+B3pFE;EACE,WAdY;ERRd,0DQMmB;EAkBjB,iEAjBa;A/B8qFjB;A+B1pFE;EAEE,WArBY;ERRd,0DQMmB;EAyBjB,iEAxBa;EA6BX,kEAAA;A/BupFN;A+BnpFE;EAKE,WAlCa;EAmCb,qEArCkB;EAwClB,iEAvCc;A/BsrFlB;A+B7oFI;EAKI,kEAAA;A/B2oFR;A+BtoFE;EAEE,WAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;AN0gFf;;A8BjpFE;ECvCA,WAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;ANghFf;A+BzrFE;EACE,WAdY;ERRd,+CQMmB;EAkBjB,iEAjBa;A/B4sFjB;A+BxrFE;EAEE,WArBY;ERRd,+CQMmB;EAyBjB,iEAxBa;EA6BX,uDAAA;A/BqrFN;A+BjrFE;EAKE,WAlCa;EAmCb,qEArCkB;EAwClB,iEAvCc;A/BotFlB;A+B3qFI;EAKI,uDAAA;A/ByqFR;A+BpqFE;EAEE,WAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;ANwiFf;;A8B/qFE;ECvCA,WAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;AN8iFf;A+BvtFE;EACE,WAdY;ERRd,qEQMmB;EAkBjB,gEAjBa;A/B0uFjB;A+BttFE;EAEE,WArBY;ERRd,qEQMmB;EAyBjB,gEAxBa;EA6BX,6EAAA;A/BmtFN;A+B/sFE;EAKE,WAlCa;EAmCb,oEArCkB;EAwClB,iEAvCc;A/BkvFlB;A+BzsFI;EAKI,6EAAA;A/BusFR;A+BlsFE;EAEE,WAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;ANskFf;;A8B7sFE;ECvCA,WAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;AN4kFf;A+BrvFE;EACE,WAdY;ERRd,qEQMmB;EAkBjB,gEAjBa;A/BwwFjB;A+BpvFE;EAEE,WArBY;ERRd,qEQMmB;EAyBjB,gEAxBa;EA6BX,6EAAA;A/BivFN;A+B7uFE;EAKE,WAlCa;EAmCb,oEArCkB;EAwClB,iEAvCc;A/BgxFlB;A+BvuFI;EAKI,6EAAA;A/BquFR;A+BhuFE;EAEE,WAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;ANomFf;;A8B3uFE;ECvCA,cAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;AN0mFf;A+BnxFE;EACE,cAdY;ERRd,2DQMmB;EAkBjB,uDAjBa;A/BsyFjB;A+BlxFE;EAEE,cArBY;ERRd,2DQMmB;EAyBjB,uDAxBa;EA6BX,2EAAA;A/B+wFN;A+B3wFE;EAKE,cAlCa;EAmCb,2DArCkB;EAwClB,uDAvCc;A/B8yFlB;A+BrwFI;EAKI,2EAAA;A/BmwFR;A+B9vFE;EAEE,cAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;ANkoFf;;A8BzwFE;ECvCA,WAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;ANwoFf;A+BjzFE;EACE,WAdY;ERRd,+CQMmB;EAkBjB,qDAjBa;A/Bo0FjB;A+BhzFE;EAEE,WArBY;ERRd,+CQMmB;EAyBjB,qDAxBa;EA6BX,wDAAA;A/B6yFN;A+BzyFE;EAKE,WAlCa;EAmCb,yDArCkB;EAwClB,sDAvCc;A/B40FlB;A+BnyFI;EAKI,wDAAA;A/BiyFR;A+B5xFE;EAEE,WAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;ANgqFf;;A8BvyFE;ECvCA,cAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;ANsqFf;A+B/0FE;EACE,cAdY;ERRd,0DQMmB;EAkBjB,iEAjBa;A/Bk2FjB;A+B90FE;EAEE,cArBY;ERRd,0DQMmB;EAyBjB,iEAxBa;EA6BX,6EAAA;A/B20FN;A+Bv0FE;EAKE,cAlCa;EAmCb,oEArCkB;EAwClB,iEAvCc;A/B02FlB;A+Bj0FI;EAKI,6EAAA;A/B+zFR;A+B1zFE;EAEE,cAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;AN8rFf;;A8Br0FE;ECvCA,WAXQ;ERLR,yBjB8La;EyB5Kb,qBzB4Ka;ANosFf;A+B72FE;EACE,WAdY;ERRd,qEQMmB;EAkBjB,iEAjBa;A/Bg4FjB;A+B52FE;EAEE,WArBY;ERRd,qEQMmB;EAyBjB,iEAxBa;EA6BX,6EAAA;A/By2FN;A+Br2FE;EAKE,WAlCa;EAmCb,qEArCkB;EAwClB,iEAvCc;A/Bw4FlB;A+B/1FI;EAKI,6EAAA;A/B61FR;A+Bx1FE;EAEE,WAjDe;EAkDf,yBzB8HW;EyB3HX,qBzB2HW;AN4tFf;;A8B71FE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;ANiuFf;A+B50FE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANsuFf;A+B30FE;EAEE,2CAAA;A/B40FJ;A+Bz0FE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;AN8uFf;A+Br0FI;EAKI,2CAAA;A/Bm0FR;A+B9zFE;EAEE,czB2EW;EyB1EX,6BAAA;A/B+zFJ;;A8Bt3FE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;AN0vFf;A+Br2FE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;AN+vFf;A+Bp2FE;EAEE,4CAAA;A/Bq2FJ;A+Bl2FE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANuwFf;A+B91FI;EAKI,4CAAA;A/B41FR;A+Bv1FE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bw1FJ;;A8B/4FE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;ANmxFf;A+B93FE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANwxFf;A+B73FE;EAEE,2CAAA;A/B83FJ;A+B33FE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANgyFf;A+Bv3FI;EAKI,2CAAA;A/Bq3FR;A+Bh3FE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bi3FJ;;A8Bx6FE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;AN4yFf;A+Bv5FE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANizFf;A+Bt5FE;EAEE,2CAAA;A/Bu5FJ;A+Bp5FE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANyzFf;A+Bh5FI;EAKI,2CAAA;A/B84FR;A+Bz4FE;EAEE,czB2EW;EyB1EX,6BAAA;A/B04FJ;;A8Bj8FE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;ANq0Ff;A+Bh7FE;EACE,cATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;AN00Ff;A+B/6FE;EAEE,2CAAA;A/Bg7FJ;A+B76FE;EAKE,cArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANk1Ff;A+Bz6FI;EAKI,2CAAA;A/Bu6FR;A+Bl6FE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bm6FJ;;A8B19FE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;AN81Ff;A+Bz8FE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANm2Ff;A+Bx8FE;EAEE,2CAAA;A/By8FJ;A+Bt8FE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;AN22Ff;A+Bl8FI;EAKI,2CAAA;A/Bg8FR;A+B37FE;EAEE,czB2EW;EyB1EX,6BAAA;A/B47FJ;;A8Bn/FE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;ANu3Ff;A+Bl+FE;EACE,cATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;AN43Ff;A+Bj+FE;EAEE,4CAAA;A/Bk+FJ;A+B/9FE;EAKE,cArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANo4Ff;A+B39FI;EAKI,4CAAA;A/By9FR;A+Bp9FE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bq9FJ;;A8B5gGE;ECmBA,czB8Ga;EyB7Gb,qBzB6Ga;ANg5Ff;A+B3/FE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANq5Ff;A+B1/FE;EAEE,yCAAA;A/B2/FJ;A+Bx/FE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;AN65Ff;A+Bp/FI;EAKI,yCAAA;A/Bk/FR;A+B7+FE;EAEE,czB2EW;EyB1EX,6BAAA;A/B8+FJ;;A8BzhGA;EACE,gBxBonB4B;EwBnnB5B,cxByEQ;EwBxER,qBxB+dwC;AN6jF1C;A8B1hGE;EACE,yDxB8dsC;EwB7dtC,qBxB8dsC;AN8jF1C;A8BzhGE;EACE,qBxB0dsC;ANikF1C;A8BxhGE;EAEE,cxBmCO;ANs/FX;;A8B9gGA;ECuBE,oBAAA;E1BsKI,qBALI;EE7QN,sBAAA;APymGJ;;A8BhhGA;ECmBE,uBAAA;E1BsKI,oBALI;EE7QN,sBAAA;AP+mGJ;;AgCloGA;EVgBM,gCUfJ;AhCqoGF;AsBlnGM;EUpBN;IVqBQ,gBAAA;EtBqnGN;AACF;AgCxoGE;EACE,UAAA;AhC0oGJ;;AgCpoGE;EACE,aAAA;AhCuoGJ;;AgCnoGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhCsoGF;AsBpoGM;EULN;IVMQ,gBAAA;EtBuoGN;AACF;AgCzoGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhC2oGJ;AsB9oGM;EUAJ;IVCM,gBAAA;EtBipGN;AACF;;AiCtqGA;;;;EAIE,kBAAA;AjCyqGF;;AiCtqGA;EACE,mBAAA;AjCyqGF;;AiClqGA;EACE,kBAAA;EACA,a3B4oCkC;E2B3oClC,aAAA;EACA,gB3BkuCkC;E2BjuClC,kBAAA;EACA,SAAA;E5B+QI,mBALI;E4BxQR,c3ByGS;E2BxGT,gBAAA;EACA,gBAAA;EACA,sB3B+FS;E2B9FT,4BAAA;EACA,mEAAA;E1BVE,sBAAA;APgrGJ;AiClqGE;EACE,SAAA;EACA,OAAA;EACA,oB3BqtCgC;AN+8DpC;;AiCxpGI;EACE,oBAAA;AjC2pGN;AiCzpGM;EACE,WAAA;EACA,OAAA;AjC2pGR;;AiCvpGI;EACE,kBAAA;AjC0pGN;AiCxpGM;EACE,QAAA;EACA,UAAA;AjC0pGR;;AczpGI;EmBfA;IACE,oBAAA;EjC4qGJ;EiC1qGI;IACE,WAAA;IACA,OAAA;EjC4qGN;EiCxqGE;IACE,kBAAA;EjC0qGJ;EiCxqGI;IACE,QAAA;IACA,UAAA;EjC0qGN;AACF;Ac1qGI;EmBfA;IACE,oBAAA;EjC4rGJ;EiC1rGI;IACE,WAAA;IACA,OAAA;EjC4rGN;EiCxrGE;IACE,kBAAA;EjC0rGJ;EiCxrGI;IACE,QAAA;IACA,UAAA;EjC0rGN;AACF;Ac1rGI;EmBfA;IACE,oBAAA;EjC4sGJ;EiC1sGI;IACE,WAAA;IACA,OAAA;EjC4sGN;EiCxsGE;IACE,kBAAA;EjC0sGJ;EiCxsGI;IACE,QAAA;IACA,UAAA;EjC0sGN;AACF;Ac1sGI;EmBfA;IACE,oBAAA;EjC4tGJ;EiC1tGI;IACE,WAAA;IACA,OAAA;EjC4tGN;EiCxtGE;IACE,kBAAA;EjC0tGJ;EiCxtGI;IACE,QAAA;IACA,UAAA;EjC0tGN;AACF;Ac1tGI;EmBfA;IACE,oBAAA;EjC4uGJ;EiC1uGI;IACE,WAAA;IACA,OAAA;EjC4uGN;EiCxuGE;IACE,kBAAA;EjC0uGJ;EiCxuGI;IACE,QAAA;IACA,UAAA;EjC0uGN;AACF;AiCjuGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uB3B6qCgC;ANsjEpC;AiC1tGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qB3B+pCgC;AN6jEpC;AiCvtGI;EACE,iBAAA;AjCytGN;;AiCntGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sB3B8oCgC;ANwkEpC;AiCjtGI;EACE,iBAAA;AjCmtGN;;AiC5sGA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AjC+sGF;;AiCzsGA;EACE,cAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,gB3B2jB4B;E2B1jB5B,c3BPS;E2BQT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;AjC2sGF;AiC7rGE;EAEE,0DCs/BgC;EX/oClC,yBjBuHS;ANiuGX;AiC1rGE;EAEE,c3BlCO;E2BmCP,qBAAA;EVjKF,yBjBuHS;ANsuGX;AiCxrGE;EAEE,c3B3CO;E2B4CP,oBAAA;EACA,6BAAA;AjCyrGJ;;AiCnrGA;EACE,cAAA;AjCsrGF;;AiClrGA;EACE,cAAA;EACA,uB3BwlCkC;E2BvlClC,gBAAA;E5B0GI,oBALI;E4BnGR,c3BolCkC;E2BnlClC,mBAAA;AjCqrGF;;AiCjrGA;EACE,cAAA;EACA,wBAAA;EACA,c3BpES;ANwvGX;;AiChrGA;EACE,c3B7ES;E2B8ET,yB3BzES;E2B0ET,iE3BijCkC;ANkoEpC;AiChrGE;EACE,c3BnFO;ANqwGX;AiChrGI;EAEE,W3B1FK;EiBtHT,2CjByxCkC;ANymEpC;AiC9qGI;EAEE,c3BxFK;EiB9HT,yBjBuHS;AN+wGX;AiC5qGI;EAEE,c3BjGK;AN8wGX;AiCzqGE;EACE,qB3BxGO;ANmxGX;AiCxqGE;EACE,c3B5GO;ANsxGX;AiCvqGE;EACE,c3B9GO;ANuxGX;;AmCr5GA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCw5GF;AmCt5GE;;EACE,kBAAA;EACA,cAAA;AnCy5GJ;AmCp5GE;;;;;;;;;;;;EAME,UAAA;AnC45GJ;;AmCv5GA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnC05GF;AmCx5GE;EACE,WAAA;AnC05GJ;;AmCp5GE;;EAEE,iBAAA;AnCu5GJ;AmCn5GE;;E5BRE,0BAAA;EACA,6BAAA;AP+5GJ;AmC/4GE;;;E5BHE,yBAAA;EACA,4BAAA;APu5GJ;;AmCl4GA;EACE,uBAAA;EACA,sBAAA;AnCq4GF;AmCn4GE;EAGE,cAAA;AnCm4GJ;AmCh4GE;EACE,eAAA;AnCk4GJ;;AmC93GA;EACE,qBAAA;EACA,oBAAA;AnCi4GF;;AmC93GA;EACE,sBAAA;EACA,qBAAA;AnCi4GF;;AmC72GA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnCg3GF;AmC92GE;;EAEE,WAAA;AnCg3GJ;AmC72GE;;EAEE,gBAAA;AnC+2GJ;AmC32GE;;E5BvFE,6BAAA;EACA,4BAAA;APs8GJ;AmC32GE;;E5B1GE,yBAAA;EACA,0BAAA;APy9GJ;;AoCj/GA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApCo/GF;;AoCj/GA;EACE,cAAA;EACA,oBAAA;EAGA,c9BsIQ;EgBxIJ,uGcIJ;ApCi/GF;AsBj/GM;EcPN;IdQQ,gBAAA;EtBo/GN;AACF;AoCp/GE;EAEE,yD9ByhBsC;AN49F1C;AoCh/GE;EACE,c9BkGO;E8BjGP,oBAAA;EACA,eAAA;ApCk/GJ;;AoC1+GA;EACE,gCAAA;ApC6+GF;AoC3+GE;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;E7BlBA,+BAAA;EACA,gCAAA;APggHJ;AoC5+GI;EAEE,qC9BsoC8B;E8BpoC9B,kBAAA;ApC4+GN;AoCz+GI;EACE,c9BuEK;E8BtEL,6BAAA;EACA,yBAAA;ApC2+GN;AoCv+GE;;EAEE,c9BgEO;E8B/DP,sB9BwDO;E8BvDP,kC9BynCgC;ANg3EpC;AoCt+GE;EAEE,gBAAA;E7B5CA,yBAAA;EACA,0BAAA;APohHJ;;AoC79GE;EACE,gBAAA;EACA,SAAA;E7BnEA,sBAAA;APoiHJ;AoC79GE;;EAEE,W9B8BO;EiBtHT,yBjBoJQ;ANo6GV;;AoCr9GE;;EAEE,cAAA;EACA,kBAAA;ApCw9GJ;;AoCn9GE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ApCs9GJ;;AoCh9GE;;EACE,WAAA;ApCo9GJ;;AoC18GE;EACE,aAAA;ApC68GJ;AoC38GE;EACE,cAAA;ApC68GJ;;AqCrkHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oB/BirCkC;E+BhrClC,qB/BidO;E+BhdP,uB/B+qCkC;E+B9qClC,oB/B+cO;ANynGT;AqClkHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArC0kHJ;AqCtjHA;EACE,yB/BwpCkC;E+BvpClC,4B/BupCkC;E+BtpClC,kB/BupCkC;ED56B9B,qBALI;EgCnOR,mBAAA;ArCujHF;AqC1iHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArC4iHF;AqC1iHE;EACE,gBAAA;EACA,eAAA;ArC4iHJ;AqCziHE;EACE,gBAAA;ArC2iHJ;;AqCliHA;EACE,mB/B4kCkC;E+B3kClC,sB/B2kCkC;AN09EpC;;AqCzhHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ArC0hHF;;AqCthHA;EACE,wBAAA;EhC6KI,qBALI;EgCtKR,cAAA;EACA,6BAAA;EACA,6BAAA;E9BzGE,sBAAA;EeHE,wCe8GJ;ArCyhHF;AsBnoHM;EemGN;IflGQ,gBAAA;EtBsoHN;AACF;AqC5hHE;EACE,qBAAA;ArC8hHJ;AqC3hHE;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;ArC6hHJ;;AqCvhHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArC0hHF;;AqCvhHA;EACE,yCAAA;EACA,gBAAA;ArC0hHF;;AcpnHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;ErCihHN;EqC/gHM;IACE,mBAAA;ErCihHR;EqC/gHQ;IACE,kBAAA;ErCihHV;EqC9gHQ;IACE,qB/BwhCwB;I+BvhCxB,oB/BuhCwB;ENy/ElC;EqC5gHM;IACE,iBAAA;ErC8gHR;EqC3gHM;IACE,wBAAA;IACA,gBAAA;ErC6gHR;EqC1gHM;IACE,aAAA;ErC4gHR;EqCzgHM;IACE,aAAA;ErC2gHR;EqCxgHM;IACE,iBAAA;IACA,SAAA;IACA,aAAA;IACA,YAAA;IACA,8BAAA;IACA,6BAAA;IACA,eAAA;IACA,cAAA;IfhMJ,gBeiMI;IACA,eAAA;ErC0gHR;EqCxgHM;;IAEE,YAAA;IACA,aAAA;IACA,gBAAA;ErC0gHR;EqCvgHM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCygHR;AACF;Ac1qHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;ErCskHN;EqCpkHM;IACE,mBAAA;ErCskHR;EqCpkHQ;IACE,kBAAA;ErCskHV;EqCnkHQ;IACE,qB/BwhCwB;I+BvhCxB,oB/BuhCwB;EN8iFlC;EqCjkHM;IACE,iBAAA;ErCmkHR;EqChkHM;IACE,wBAAA;IACA,gBAAA;ErCkkHR;EqC/jHM;IACE,aAAA;ErCikHR;EqC9jHM;IACE,aAAA;ErCgkHR;EqC7jHM;IACE,iBAAA;IACA,SAAA;IACA,aAAA;IACA,YAAA;IACA,8BAAA;IACA,6BAAA;IACA,eAAA;IACA,cAAA;IfhMJ,gBeiMI;IACA,eAAA;ErC+jHR;EqC7jHM;;IAEE,YAAA;IACA,aAAA;IACA,gBAAA;ErC+jHR;EqC5jHM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC8jHR;AACF;Ac/tHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;ErC2nHN;EqCznHM;IACE,mBAAA;ErC2nHR;EqCznHQ;IACE,kBAAA;ErC2nHV;EqCxnHQ;IACE,qB/BwhCwB;I+BvhCxB,oB/BuhCwB;ENmmFlC;EqCtnHM;IACE,iBAAA;ErCwnHR;EqCrnHM;IACE,wBAAA;IACA,gBAAA;ErCunHR;EqCpnHM;IACE,aAAA;ErCsnHR;EqCnnHM;IACE,aAAA;ErCqnHR;EqClnHM;IACE,iBAAA;IACA,SAAA;IACA,aAAA;IACA,YAAA;IACA,8BAAA;IACA,6BAAA;IACA,eAAA;IACA,cAAA;IfhMJ,gBeiMI;IACA,eAAA;ErConHR;EqClnHM;;IAEE,YAAA;IACA,aAAA;IACA,gBAAA;ErConHR;EqCjnHM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCmnHR;AACF;AcpxHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;ErCgrHN;EqC9qHM;IACE,mBAAA;ErCgrHR;EqC9qHQ;IACE,kBAAA;ErCgrHV;EqC7qHQ;IACE,qB/BwhCwB;I+BvhCxB,oB/BuhCwB;ENwpFlC;EqC3qHM;IACE,iBAAA;ErC6qHR;EqC1qHM;IACE,wBAAA;IACA,gBAAA;ErC4qHR;EqCzqHM;IACE,aAAA;ErC2qHR;EqCxqHM;IACE,aAAA;ErC0qHR;EqCvqHM;IACE,iBAAA;IACA,SAAA;IACA,aAAA;IACA,YAAA;IACA,8BAAA;IACA,6BAAA;IACA,eAAA;IACA,cAAA;IfhMJ,gBeiMI;IACA,eAAA;ErCyqHR;EqCvqHM;;IAEE,YAAA;IACA,aAAA;IACA,gBAAA;ErCyqHR;EqCtqHM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCwqHR;AACF;Acz0HI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;ErCquHN;EqCnuHM;IACE,mBAAA;ErCquHR;EqCnuHQ;IACE,kBAAA;ErCquHV;EqCluHQ;IACE,qB/BwhCwB;I+BvhCxB,oB/BuhCwB;EN6sFlC;EqChuHM;IACE,iBAAA;ErCkuHR;EqC/tHM;IACE,wBAAA;IACA,gBAAA;ErCiuHR;EqC9tHM;IACE,aAAA;ErCguHR;EqC7tHM;IACE,aAAA;ErC+tHR;EqC5tHM;IACE,iBAAA;IACA,SAAA;IACA,aAAA;IACA,YAAA;IACA,8BAAA;IACA,6BAAA;IACA,eAAA;IACA,cAAA;IfhMJ,gBeiMI;IACA,eAAA;ErC8tHR;EqC5tHM;;IAEE,YAAA;IACA,aAAA;IACA,gBAAA;ErC8tHR;EqC3tHM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC6tHR;AACF;AqCxxHI;EAEI,iBAAA;EACA,2BAAA;ArCyxHR;AqCvxHQ;EACE,mBAAA;ArCyxHV;AqCvxHU;EACE,kBAAA;ArCyxHZ;AqCtxHU;EACE,qB/BwhCwB;E+BvhCxB,oB/BuhCwB;ANiwFpC;AqCpxHQ;EACE,iBAAA;ArCsxHV;AqCnxHQ;EACE,wBAAA;EACA,gBAAA;ArCqxHV;AqClxHQ;EACE,aAAA;ArCoxHV;AqCjxHQ;EACE,aAAA;ArCmxHV;AqChxHQ;EACE,iBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;EfhMJ,gBeiMI;EACA,eAAA;ArCkxHV;AqChxHQ;;EAEE,YAAA;EACA,aAAA;EACA,gBAAA;ArCkxHV;AqC/wHQ;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArCixHV;;AqCnwHE;EACE,c/BtFM;AN41HV;AqCpwHI;EAEE,c/B1FI;AN+1HV;AqChwHI;EACE,0B/B2+B8B;ANuxFpC;AqChwHM;EAEE,yB/Bw+B4B;ANyxFpC;AqC9vHM;EACE,yB/Bs+B4B;AN0xFpC;AqC5vHI;;EAEE,c/B9GI;AN42HV;AqC1vHE;EACE,0B/Bw9BgC;E+Bv9BhC,gC/B49BgC;ANgyFpC;AqCzvHE;EACE,yDAAA;ArC2vHJ;AqCxvHE;EACE,0B/B+8BgC;AN2yFpC;AqCxvHI;;;EAGE,c/BjII;AN23HV;;AqCnvHE;EACE,W/BvKO;AN65HX;AqCpvHI;EAEE,W/B3KK;ANg6HX;AqChvHI;EACE,gC/Bi7B8B;ANi0FpC;AqChvHM;EAEE,gC/B86B4B;ANm0FpC;AqC9uHM;EACE,gC/B46B4B;ANo0FpC;AqC5uHI;;EAEE,W/B/LK;AN66HX;AqC1uHE;EACE,gC/B85BgC;E+B75BhC,sC/Bk6BgC;AN00FpC;AqCzuHE;EACE,yDAAA;ArC2uHJ;AqCxuHE;EACE,gC/Bq5BgC;ANq1FpC;AqCzuHI;;;EAGE,W/BjNK;AN47HX;;AsCljIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBhC+GS;EgC9GT,2BAAA;EACA,yBAAA;E/BME,sBAAA;AP+iIJ;AsCjjIE;EACE,eAAA;EACA,cAAA;AtCmjIJ;AsChjIE;EACE,mBAAA;EACA,sBAAA;AtCkjIJ;AsChjII;EACE,mBAAA;E/BCF,2CAAA;EACA,4CAAA;APkjIJ;AsChjII;EACE,sBAAA;E/BUF,+CAAA;EACA,8CAAA;APyiIJ;AsC7iIE;;EAEE,aAAA;AtC+iIJ;;AsC3iIA;EAGE,cAAA;EACA,wBAAA;AtC4iIF;;AsCxiIA;EACE,sBhCoyCkC;ANuwFpC;;AsCxiIA;EACE,qBAAA;EACA,gBAAA;AtC2iIF;;AsCxiIA;EACE,gBAAA;AtC2iIF;;AsCniIE;EACE,oBhCixCgC;ANqxFpC;;AsC9hIA;EACE,qBAAA;EACA,gBAAA;EAEA,oEhC8wCkC;EgC7wClC,gCAAA;AtCgiIF;AsC9hIE;E/BpEE,0DAAA;APqmIJ;;AsC5hIA;EACE,qBAAA;EAEA,oEhCmwCkC;EgClwClC,6BAAA;AtC8hIF;AsC5hIE;E/B/EE,0DAAA;AP8mIJ;;AsCrhIA;EACE,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;AtCwhIF;;AsC9gIA;EACE,uBAAA;EACA,sBAAA;AtCihIF;;AsC7gIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBhCiuCkC;ECp1ChC,kCAAA;APooIJ;;AsC7gIA;;;EAGE,WAAA;AtCghIF;;AsC7gIA;;E/BpHI,2CAAA;EACA,4CAAA;APsoIJ;;AsC9gIA;;E/B3GI,+CAAA;EACA,8CAAA;AP8nIJ;;AsCvgIE;EACE,mBhCqsCgC;ANq0FpC;Ac9mII;EwBgGJ;IAQI,aAAA;IACA,mBAAA;EtC0gIF;EsCvgIE;IAEE,SAAA;IACA,gBAAA;EtCwgIJ;EsCtgII;IACE,cAAA;IACA,cAAA;EtCwgIN;EsCngIM;I/BpJJ,0BAAA;IACA,6BAAA;EP0pIF;EsCpgIQ;;IAGE,0BAAA;EtCqgIV;EsCngIQ;;IAGE,6BAAA;EtCogIV;EsChgIM;I/BrJJ,yBAAA;IACA,4BAAA;EPwpIF;EsCjgIQ;;IAGE,yBAAA;EtCkgIV;EsChgIQ;;IAGE,4BAAA;EtCigIV;AACF;;AuC/sIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;ElC4RI,mBALI;EkCrRR,cjCsHS;EiCrHT,gBAAA;EACA,yBjCwf0B;EiCvf1B,SAAA;EhCKE,gBAAA;EgCHF,qBAAA;EjBAI,+JiBCJ;AvCktIF;AsB/sIM;EiBhBN;IjBiBQ,gBAAA;EtBktIN;AACF;AuCrtIE;EACE,0DjC42CsC;EiC32CtC,qEjC02CsC;EiCz2CtC,+CAAA;AvCutIJ;AuCrtII;EACE,+UAAA;EACA,0BjC+2CoC;ANw2F1C;AuCltIE;EACE,cAAA;EACA,cjCo2CsC;EiCn2CtC,ejCm2CsC;EiCl2CtC,iBAAA;EACA,WAAA;EACA,0DAAA;EACA,4BAAA;EACA,wBjC81CsC;EgBr3CpC,sCiBwBF;AvCotIJ;AsBxuIM;EiBWJ;IjBVM,gBAAA;EtB2uIN;AACF;AuCttIE;EACE,UAAA;AvCwtIJ;AuCrtIE;EACE,UAAA;EACA,gEjCo6BoC;EiCn6BpC,UAAA;EACA,4CjCizB4B;ANs6GhC;;AuCntIA;EACE,gBAAA;AvCstIF;;AuCntIA;EACE,yBjCyc0B;EiCxc1B,sCAAA;AvCstIF;AuCptIE;EhCnCE,+BAAA;EACA,gCAAA;AP0vIJ;AuCrtII;EhCtCA,2CAAA;EACA,4CAAA;AP8vIJ;AuCptIE;EACE,aAAA;AvCstIJ;AuCltIE;EhClCE,mCAAA;EACA,kCAAA;APuvIJ;AuCltIM;EhCtCF,+CAAA;EACA,8CAAA;AP2vIJ;AuCjtII;EhC3CA,mCAAA;EACA,kCAAA;AP+vIJ;;AuC/sIA;EACE,qBAAA;AvCktIF;;AuCzsIE;EACE,eAAA;AvC4sIJ;AuCzsIE;EACE,eAAA;EACA,cAAA;EhCxFA,gBAAA;APoyIJ;AuCzsII;EAAgB,aAAA;AvC4sIpB;AuC3sII;EAAe,gBAAA;AvC8sInB;AuC5sII;EhC9FA,gBAAA;AP6yIJ;;AwCh0IA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBlC2mDkC;EkCzmDlC,gBAAA;EACA,6BlCymDkC;EC7lDhC,sBAAA;APuzIJ;;AwC7zIE;EACE,oBlCgmDgC;ANguFpC;AwC9zII;EACE,WAAA;EACA,qBlC4lD8B;EkC3lD9B,clC4GK;EkC3GL,uFAAA;AxCg0IN;AwC5zIE;EACE,clCuGO;ANutIX;;AyCv1IA;EACE,aAAA;EhCGA,eAAA;EACA,gBAAA;ATw1IF;;AyCx1IA;EACE,kBAAA;EACA,cAAA;EACA,cnC0HS;EmCxHT,sBnCgHS;EmC/GT,yBAAA;EnBKI,qImBJJ;AzC01IF;AsBl1IM;EmBfN;InBgBQ,gBAAA;EtBq1IN;AACF;AyC71IE;EACE,UAAA;EACA,cnCkHO;EmChHP,yBnC0GO;EmCzGP,qBnC0GO;ANovIX;AyC31IE;EACE,UAAA;EACA,yDnCyhBsC;EmCxhBtC,yBnCmGO;EmClGP,UnC+xCgC;EmC9xChC,4CnCy0B4B;ANohHhC;;AyCx1IE;EACE,iBnCkxCgC;ANykGpC;AyCx1IE;EACE,UAAA;EACA,WnCoFO;EiBtHT,yBjBoJQ;EmChHN,qBnCgHM;AN0uIV;AyCv1IE;EACE,cnCoFO;EmCnFP,oBAAA;EACA,sBnC4EO;EmC3EP,qBnC8EO;AN2wIX;;A0Cp4IE;EACE,uBAAA;A1Cu4IJ;;A0Ch4IQ;EnCqCJ,+BAAA;EACA,kCAAA;AP+1IJ;A0C/3IQ;EnCiBJ,gCAAA;EACA,mCAAA;APi3IJ;;A0Cj5IE;EACE,uBAAA;ErCgSE,qBALI;AL0nIV;A0C94IQ;EnCqCJ,8BAAA;EACA,iCAAA;AP42IJ;A0C54IQ;EnCiBJ,+BAAA;EACA,kCAAA;AP83IJ;;A0C95IE;EACE,uBAAA;ErCgSE,oBALI;ALuoIV;A0C35IQ;EnCqCJ,8BAAA;EACA,iCAAA;APy3IJ;A0Cz5IQ;EnCiBJ,+BAAA;EACA,kCAAA;AP24IJ;;A2C16IA;EACE,qBAAA;EACA,qBAAA;EtC8RI,cALI;EsCvRR,gBrC0rB4B;EqCzrB5B,cAAA;EACA,WrC+GS;EqC9GT,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCKE,sBAAA;APy6IJ;A2Cz6IE;EACE,aAAA;A3C26IJ;;A2Ct6IA;EACE,kBAAA;EACA,SAAA;A3Cy6IF;;A4Ch8IA;EACE,kBAAA;EACA,wBAAA;EACA,mBtCqhD8B;EsCphD9B,6BAAA;ErCWE,qBAAA;APy7IJ;;A4C/7IA;EAEE,cAAA;A5Ci8IF;;A4C77IA;EACE,gBtC+qB4B;ANixH9B;;A4Cx7IA;EACE,sBtCsgD8B;ANq7FhC;A4Cx7IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,0BAAA;A5C07IJ;;A4C36IE;EClDA,0DD8Cc;ErB5Cd,qEqB0CmB;EC1CnB,gED2Ce;A5Cs7IjB;A6C/9IE;EACE,0DAAA;A7Ci+IJ;;A4Cp7IE;EClDA,0DD8Cc;ErB5Cd,qEqB0CmB;EC1CnB,iED2Ce;A5C+7IjB;A6Cx+IE;EACE,0DAAA;A7C0+IJ;;A4C77IE;EClDA,0DD8Cc;ErB5Cd,qEqB0CmB;EC1CnB,gED2Ce;A5Cw8IjB;A6Cj/IE;EACE,0DAAA;A7Cm/IJ;;A4Ct8IE;EClDA,yDD8Cc;ErB5Cd,qEqB0CmB;EC1CnB,gED2Ce;A5Ci9IjB;A6C1/IE;EACE,yDAAA;A7C4/IJ;;A4C/8IE;EClDA,8CD8Cc;ErB5Cd,0DqB0CmB;EC1CnB,sDD2Ce;A5C09IjB;A6CngJE;EACE,8CAAA;A7CqgJJ;;A4Cx9IE;EClDA,+CD8Cc;ErB5Cd,2DqB0CmB;EC1CnB,uDD2Ce;A5Cm+IjB;A6C5gJE;EACE,+CAAA;A7C8gJJ;;A4Cj+IE;EClDA,0DD8Cc;ErB5Cd,qEqB0CmB;EC1CnB,gED2Ce;A5C4+IjB;A6CrhJE;EACE,0DAAA;A7CuhJJ;;A4C1+IE;EClDA,0DD8Cc;ErB5Cd,qEqB0CmB;EC1CnB,gED2Ce;A5Cq/IjB;A6C9hJE;EACE,yDAAA;A7CgiJJ;;A8CniJE;EACE;IAAK,8BxCqiD2B;ENkgGlC;AACF;A8CniJA;EACE,aAAA;EACA,exC8hDkC;EwC7hDlC,gBAAA;EzCwRI,qBALI;EyCjRR,qExC6hDkC;ECzhDhC,sBAAA;APkiJJ;;A8CjiJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WxCiGS;EwChGT,kBAAA;EACA,mBAAA;EACA,yBxC4HQ;EgBxIJ,2BwBaJ;A9CoiJF;AsB7iJM;EwBAN;IxBCQ,gBAAA;EtBgjJN;AACF;;A8CtiJA;EvBYE,qMAAA;EuBVA,gCAAA;A9CyiJF;;A8CriJE;EACE,kDAAA;A9CwiJJ;A8CriJM;EAJJ;IAKM,eAAA;E9CwiJN;AACF;;A+ChlJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ExCSE,sBAAA;APykJJ;;A+C9kJA;EACE,qBAAA;EACA,sBAAA;A/CilJF;A+C/kJE;EAEE,oCAAA;EACA,0BAAA;A/CglJJ;;A+CtkJA;EACE,WAAA;EACA,czCgGS;EyC/FT,mBAAA;A/CykJF;A+CtkJE;EAEE,UAAA;EACA,czCyFO;EyCxFP,qBAAA;EACA,yBzCiFO;ANs/IX;A+CpkJE;EACE,czCmFO;EyClFP,yBzC6EO;ANy/IX;;A+C7jJA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,czCuES;EyCrET,sBzC4DS;EyC3DT,sCAAA;A/C+jJF;A+C7jJE;ExCrCE,+BAAA;EACA,gCAAA;APqmJJ;A+C7jJE;ExC3BE,mCAAA;EACA,kCAAA;AP2lJJ;A+C7jJE;EAEE,czCqDO;EyCpDP,oBAAA;EACA,sBzC6CO;ANihJX;A+C1jJE;EACE,UAAA;EACA,WzCuCO;EyCtCP,yBzCoEM;EyCnEN,qBzCmEM;ANy/IV;A+CzjJE;EACE,mBAAA;A/C2jJJ;A+CzjJI;EACE,gBAAA;EACA,qBzC0hBwB;ANiiI9B;;A+C7iJI;EACE,mBAAA;A/CgjJN;A+C7iJQ;ExCrCJ,kCAAA;EAZA,0BAAA;APkmJJ;A+C5iJQ;ExCtDJ,gCAAA;EAYA,4BAAA;AP0lJJ;A+C3iJQ;EACE,aAAA;A/C6iJV;A+C1iJQ;EACE,qBzCyfoB;EyCxfpB,oBAAA;A/C4iJV;A+C1iJU;EACE,iBAAA;EACA,sBzCofkB;ANwjI9B;;AchnJI;EiC4CA;IACE,mBAAA;E/CwkJJ;E+CrkJM;IxCrCJ,kCAAA;IAZA,0BAAA;EP0nJF;E+CpkJM;IxCtDJ,gCAAA;IAYA,4BAAA;EPknJF;E+CnkJM;IACE,aAAA;E/CqkJR;E+ClkJM;IACE,qBzCyfoB;IyCxfpB,oBAAA;E/CokJR;E+ClkJQ;IACE,iBAAA;IACA,sBzCofkB;ENglI5B;AACF;AczoJI;EiC4CA;IACE,mBAAA;E/CgmJJ;E+C7lJM;IxCrCJ,kCAAA;IAZA,0BAAA;EPkpJF;E+C5lJM;IxCtDJ,gCAAA;IAYA,4BAAA;EP0oJF;E+C3lJM;IACE,aAAA;E/C6lJR;E+C1lJM;IACE,qBzCyfoB;IyCxfpB,oBAAA;E/C4lJR;E+C1lJQ;IACE,iBAAA;IACA,sBzCofkB;ENwmI5B;AACF;AcjqJI;EiC4CA;IACE,mBAAA;E/CwnJJ;E+CrnJM;IxCrCJ,kCAAA;IAZA,0BAAA;EP0qJF;E+CpnJM;IxCtDJ,gCAAA;IAYA,4BAAA;EPkqJF;E+CnnJM;IACE,aAAA;E/CqnJR;E+ClnJM;IACE,qBzCyfoB;IyCxfpB,oBAAA;E/ConJR;E+ClnJQ;IACE,iBAAA;IACA,sBzCofkB;ENgoI5B;AACF;AczrJI;EiC4CA;IACE,mBAAA;E/CgpJJ;E+C7oJM;IxCrCJ,kCAAA;IAZA,0BAAA;EPksJF;E+C5oJM;IxCtDJ,gCAAA;IAYA,4BAAA;EP0rJF;E+C3oJM;IACE,aAAA;E/C6oJR;E+C1oJM;IACE,qBzCyfoB;IyCxfpB,oBAAA;E/C4oJR;E+C1oJQ;IACE,iBAAA;IACA,sBzCofkB;ENwpI5B;AACF;AcjtJI;EiC4CA;IACE,mBAAA;E/CwqJJ;E+CrqJM;IxCrCJ,kCAAA;IAZA,0BAAA;EP0tJF;E+CpqJM;IxCtDJ,gCAAA;IAYA,4BAAA;EPktJF;E+CnqJM;IACE,aAAA;E/CqqJR;E+ClqJM;IACE,qBzCyfoB;IyCxfpB,oBAAA;E/CoqJR;E+ClqJQ;IACE,iBAAA;IACA,sBzCofkB;ENgrI5B;AACF;A+CvpJA;ExC9HI,gBAAA;APwxJJ;A+CvpJE;EACE,qBAAA;A/CypJJ;A+CvpJI;EACE,sBAAA;A/CypJN;;AgD7yJE;EACE,0DDiKyB;EChKzB,qED+JsB;A/CipJ1B;AgD7yJM;EAEE,0DD2JqB;EC1JrB,qEAAA;AhD8yJR;AgD3yJM;EACE,W1C0GG;E0CzGH,qEDqJqB;ECpJrB,iEDoJqB;A/CypJ7B;;AgD3zJE;EACE,0DDiKyB;EChKzB,qED+JsB;A/C+pJ1B;AgD3zJM;EAEE,0DD2JqB;EC1JrB,qEAAA;AhD4zJR;AgDzzJM;EACE,W1C0GG;E0CzGH,qEDqJqB;ECpJrB,iEDoJqB;A/CuqJ7B;;AgDz0JE;EACE,0DDiKyB;EChKzB,qED+JsB;A/C6qJ1B;AgDz0JM;EAEE,0DD2JqB;EC1JrB,qEAAA;AhD00JR;AgDv0JM;EACE,W1C0GG;E0CzGH,qEDqJqB;ECpJrB,iEDoJqB;A/CqrJ7B;;AgDv1JE;EACE,yDDiKyB;EChKzB,qED+JsB;A/C2rJ1B;AgDv1JM;EAEE,yDD2JqB;EC1JrB,qEAAA;AhDw1JR;AgDr1JM;EACE,W1C0GG;E0CzGH,oEDqJqB;ECpJrB,gEDoJqB;A/CmsJ7B;;AgDr2JE;EACE,8CDiKyB;EChKzB,0DD+JsB;A/CysJ1B;AgDr2JM;EAEE,8CD2JqB;EC1JrB,0DAAA;AhDs2JR;AgDn2JM;EACE,W1C0GG;E0CzGH,yDDqJqB;ECpJrB,qDDoJqB;A/CitJ7B;;AgDn3JE;EACE,+CDiKyB;EChKzB,2DD+JsB;A/CutJ1B;AgDn3JM;EAEE,+CD2JqB;EC1JrB,0DAAA;AhDo3JR;AgDj3JM;EACE,W1C0GG;E0CzGH,0DDqJqB;ECpJrB,sDDoJqB;A/C+tJ7B;;AgDj4JE;EACE,0DDiKyB;EChKzB,qED+JsB;A/CquJ1B;AgDj4JM;EAEE,0DD2JqB;EC1JrB,qEAAA;AhDk4JR;AgD/3JM;EACE,W1C0GG;E0CzGH,qEDqJqB;ECpJrB,iEDoJqB;A/C6uJ7B;;AgD/4JE;EACE,0DDiKyB;EChKzB,qED+JsB;A/CmvJ1B;AgD/4JM;EAEE,0DD2JqB;EC1JrB,qEAAA;AhDg5JR;AgD74JM;EACE,W1C0GG;E0CzGH,qEDqJqB;ECpJrB,iEDoJqB;A/C2vJ7B;;AiD55JA;EACE,uBAAA;EACA,U3CwqD2B;E2CvqD3B,W3CuqD2B;E2CtqD3B,sBAAA;EACA,W3C0HS;E2CzHT,0FAAA;EACA,SAAA;E1COE,sBAAA;E0CLF,Y3CwqD2B;ANuvG7B;AiD55JE;EACE,W3CkHO;E2CjHP,qBAAA;EACA,a3CmqDyB;AN2vG7B;AiD35JE;EACE,UAAA;EACA,4C3C20B4B;E2C10B5B,U3C8pDyB;AN+vG7B;AiD15JE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,a3CwpDyB;ANmwG7B;;AiDv5JA;EACE,kD3CopD2B;ANswG7B;;AkDh8JA;EACE,Y5C28CkC;E4C18ClC,eAAA;E7CmSI,mBALI;E6C3RR,oBAAA;EACA,2C5C28CkC;E4C18ClC,4BAAA;EACA,oCAAA;EACA,gD5C48CkC;ECl8ChC,sBAAA;APy7JJ;AkDh8JE;EACE,UAAA;AlDk8JJ;AkD/7JE;EACE,aAAA;AlDi8JJ;;AkD77JA;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;AlDg8JF;AkD97JE;EACE,mB5ColBkB;AN42ItB;;AkD57JA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c5C6FS;E4C5FT,2C5Cq7CkC;E4Cp7ClC,4BAAA;EACA,4CAAA;E3CVE,2CAAA;EACA,4CAAA;AP08JJ;AkD97JE;EACE,uBAAA;EACA,oB5Ck6CgC;AN8hHpC;;AkD57JA;EACE,gB5C65CkC;E4C55ClC,qBAAA;AlD+7JF;;AmDz+JA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CypCkC;E6CxpClC,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnD0+JF;;AmDn+JA;EACE,kBAAA;EACA,WAAA;EACA,c7Co9CkC;E6Cl9ClC,oBAAA;AnDq+JF;AmDl+JE;E7BlBI,mC6BmBF;AnDo+JJ;AsBn/JM;E6BcJ;I7BbM,gBAAA;EtBs/JN;AACF;AmD1+JE;EAEE,8B7C0+CgC;ANigHpC;AmDz+JE;EACE,e7Cw+CgC;ANmgHpC;AmDv+JE;EACE,sB7Cq+CgC;ANogHpC;;AmDr+JA;EACE,yBAAA;AnDw+JF;AmDt+JE;EACE,gBAAA;EACA,gBAAA;AnDw+JJ;AmDr+JE;EACE,gBAAA;AnDu+JJ;;AmDn+JA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AnDs+JF;;AmDl+JA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB7C8CS;E6C7CT,4BAAA;EACA,2BAAA;E5C3DE,qBAAA;E4C+DF,UAAA;AnDi+JF;;AmD79JA;ECpFE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9C8pCkC;E8C7pClC,YAAA;EACA,aAAA;EACA,yB9C2HS;AN07JX;AoDljKE;EAAS,UAAA;ApDqjKX;AoDpjKE;EAAS,Y9Co/CyB;ANmkHpC;;AmDv+JA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,kB7Cs6CkC;E6Cr6ClC,0EAAA;E5CtEE,8BAAA;EACA,+BAAA;APijKJ;AmDz+JE;EACE,sBAAA;EACA,oCAAA;AnD2+JJ;;AmDt+JA;EACE,gBAAA;EACA,gB7C0lB4B;AN+4I9B;;AmDp+JA;EACE,kBAAA;EAGA,cAAA;EACA,a7Cq3CkC;ANgnHpC;;AmDj+JA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,uEAAA;E5CzFE,kCAAA;EACA,iCAAA;AP8jKJ;AmDh+JE;EACE,eAAA;AnDk+JJ;;Ac7iKI;EqCkFF;IACE,gB7Cw3CgC;I6Cv3ChC,oBAAA;EnD+9JF;EmD59JA;IACE,2BAAA;EnD89JF;EmD39JA;IACE,+BAAA;EnD69JF;EmDt9JA;IAAY,gB7Cu2CsB;ENknHlC;AACF;Ac7jKI;EqCuGF;;IAEE,gB7Cm2CgC;ENsnHlC;AACF;AcnkKI;EqC8GF;IAAY,iB7C+1CsB;EN0nHlC;AACF;AmDj9JI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnDm9JN;AmDj9JM;EACE,YAAA;EACA,SAAA;E5C3KJ,gBAAA;AP+nKJ;AmDh9JM;E5C/KF,gBAAA;APkoKJ;AmD/8JM;EACE,gBAAA;AnDi9JR;AmD98JM;E5CvLF,gBAAA;APwoKJ;;Ac/kKI;EqC0GA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDy+JJ;EmDv+JI;IACE,YAAA;IACA,SAAA;I5C3KJ,gBAAA;EPqpKF;EmDt+JI;I5C/KF,gBAAA;EPwpKF;EmDr+JI;IACE,gBAAA;EnDu+JN;EmDp+JI;I5CvLF,gBAAA;EP8pKF;AACF;ActmKI;EqC0GA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD+/JJ;EmD7/JI;IACE,YAAA;IACA,SAAA;I5C3KJ,gBAAA;EP2qKF;EmD5/JI;I5C/KF,gBAAA;EP8qKF;EmD3/JI;IACE,gBAAA;EnD6/JN;EmD1/JI;I5CvLF,gBAAA;EPorKF;AACF;Ac5nKI;EqC0GA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDqhKJ;EmDnhKI;IACE,YAAA;IACA,SAAA;I5C3KJ,gBAAA;EPisKF;EmDlhKI;I5C/KF,gBAAA;EPosKF;EmDjhKI;IACE,gBAAA;EnDmhKN;EmDhhKI;I5CvLF,gBAAA;EP0sKF;AACF;AclpKI;EqC0GA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD2iKJ;EmDziKI;IACE,YAAA;IACA,SAAA;I5C3KJ,gBAAA;EPutKF;EmDxiKI;I5C/KF,gBAAA;EP0tKF;EmDviKI;IACE,gBAAA;EnDyiKN;EmDtiKI;I5CvLF,gBAAA;EPguKF;AACF;AcxqKI;EqC0GA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDikKJ;EmD/jKI;IACE,YAAA;IACA,SAAA;I5C3KJ,gBAAA;EP6uKF;EmD9jKI;I5C/KF,gBAAA;EPgvKF;EmD7jKI;IACE,gBAAA;EnD+jKN;EmD5jKI;I5CvLF,gBAAA;EPsvKF;AACF;AqDzwKA;EACE,kBAAA;EACA,a/CmqCkC;E+ClqClC,cAAA;EACA,S/Cq5CkC;EgDz5ClC,0DhDkrB4B;EgDhrB5B,kBAAA;EACA,gBhD8rB4B;EgD7rB5B,gBhDmsB4B;EgDlsB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EjDsRI,mBALI;EgDrRR,qBAAA;EACA,UAAA;ArDqxKF;AqDnxKE;EAAS,Y/Cy4CyB;AN64HpC;AqDpxKE;EACE,kBAAA;EACA,cAAA;EACA,a/Cy4CgC;E+Cx4ChC,c/Cy4CgC;AN64HpC;AqDpxKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDsxKN;;AqDjxKA;EACE,iBAAA;ArDoxKF;AqDlxKE;EACE,SAAA;ArDoxKJ;AqDlxKI;EACE,SAAA;EACA,6BAAA;EACA,sB/C4FK;ANwrKX;;AqD/wKA;EACE,iBAAA;ArDkxKF;AqDhxKE;EACE,OAAA;EACA,a/C22CgC;E+C12ChC,c/Cy2CgC;ANy6HpC;AqDhxKI;EACE,WAAA;EACA,oCAAA;EACA,wB/C4EK;ANssKX;;AqD7wKA;EACE,iBAAA;ArDgxKF;AqD9wKE;EACE,MAAA;ArDgxKJ;AqD9wKI;EACE,YAAA;EACA,6BAAA;EACA,yB/C8DK;ANktKX;;AqD3wKA;EACE,iBAAA;ArD8wKF;AqD5wKE;EACE,QAAA;EACA,a/C60CgC;E+C50ChC,c/C20CgC;ANm8HpC;AqD5wKI;EACE,UAAA;EACA,oCAAA;EACA,uB/C8CK;ANguKX;;AqDzvKA;EACE,gB/CuyCkC;E+CtyClC,sBAAA;EACA,W/CYS;E+CXT,kBAAA;EACA,sB/CoBS;ECjHP,qBAAA;AP01KJ;;AuD72KA;EACE,kBAAA;EACA,MAAA;EACA,wBAAA;EACA,ajDiqCkC;EiDhqClC,cAAA;EACA,gBjD26CkC;EgDh7ClC,0DhDkrB4B;EgDhrB5B,kBAAA;EACA,gBhD8rB4B;EgD7rB5B,gBhDmsB4B;EgDlsB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EjDsRI,oBALI;EkDpRR,qBAAA;EACA,sBjD6GS;EiD5GT,4BAAA;EACA,yBAAA;EhDIE,sBAAA;APu3KJ;AuDv3KE;EACE,kBAAA;EACA,cAAA;EACA,WjD26CgC;EiD16ChC,cjD26CgC;AN88HpC;AuDv3KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AvDw3KN;;AuDl3KE;EACE,2BAAA;AvDq3KJ;AuDn3KI;EACE,SAAA;EACA,6BAAA;EACA,yBjD05C8B;AN29HpC;AuDl3KI;EACE,WjDwkBwB;EiDvkBxB,6BAAA;EACA,sBjDyEK;AN2yKX;;AuD92KE;EACE,yBAAA;EACA,ajDy4CgC;EiDx4ChC,YjDu4CgC;AN0+HpC;AuD/2KI;EACE,OAAA;EACA,oCAAA;EACA,2BjDs4C8B;AN2+HpC;AuD92KI;EACE,SjDojBwB;EiDnjBxB,oCAAA;EACA,wBjDqDK;AN2zKX;;AuD12KE;EACE,wBAAA;AvD62KJ;AuD32KI;EACE,MAAA;EACA,oCAAA;EACA,4BjDo3C8B;ANy/HpC;AuD12KI;EACE,QjDkiBwB;EiDjiBxB,oCAAA;EACA,yBjDmCK;ANy0KX;AuDv2KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WjDg2CgC;EiD/1ChC,oBAAA;EACA,WAAA;EACA,gCAAA;AvDy2KJ;;AuDp2KE;EACE,0BAAA;EACA,ajDu1CgC;EiDt1ChC,YjDq1CgC;ANkhIpC;AuDr2KI;EACE,QAAA;EACA,oCAAA;EACA,0BjDo1C8B;ANmhIpC;AuDp2KI;EACE,UjDkgBwB;EiDjgBxB,oCAAA;EACA,uBjDGK;ANm2KX;;AuDj1KA;EACE,sBAAA;EACA,gBAAA;ElDuJI,mBALI;EkD/IR,yBjDtBS;EiDuBT,gCAAA;EhDtHE,2CAAA;EACA,4CAAA;AP08KJ;AuDl1KE;EACE,aAAA;AvDo1KJ;;AuDh1KA;EACE,sBAAA;EACA,cjD3BS;AN82KX;;AwDl+KA;EACE,kBAAA;AxDq+KF;;AwDl+KA;EACE,mBAAA;AxDq+KF;;AwDl+KA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxDq+KF;AyD3/KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzD6/KJ;;AwDt+KA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;ElClBI,sCkCmBJ;AxDy+KF;AsBx/KM;EkCQN;IlCPQ,gBAAA;EtB2/KN;AACF;;AwD3+KA;;;EAGE,cAAA;AxD8+KF;;AwD3+KA,qBAAA;AACA;;EAEE,2BAAA;AxD8+KF;;AwD3+KA;;EAEE,4BAAA;AxD8+KF;;AwD3+KA,mBAAA;AAQE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxDu+KJ;AwDp+KE;;;EAGE,UAAA;EACA,UAAA;AxDs+KJ;AwDn+KE;;EAEE,UAAA;EACA,UAAA;ElC/DE,2BkCgEF;AxDq+KJ;AsBjiLM;EkCwDJ;;IlCvDM,gBAAA;EtBqiLN;AACF;;AwDl+KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlDyhDmC;EkDxhDnC,UAAA;EACA,WlDqBS;EkDpBT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlDohDmC;EgB7mD/B,8BkC0FJ;AxDo+KF;AsB1jLM;EkCqEN;;IlCpEQ,gBAAA;EtB8jLN;AACF;AwDv+KE;;;EAEE,WlDWO;EkDVP,qBAAA;EACA,UAAA;EACA,YlD4gDiC;AN89HrC;;AwDv+KA;EACE,OAAA;AxD0+KF;;AwDv+KA;EACE,QAAA;AxD0+KF;;AwDr+KA;;EAEE,qBAAA;EACA,WlD6gDmC;EkD5gDnC,YlD4gDmC;EkD3gDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AxDw+KF;;AwDr+KA;;;;;;;GAAA;AAQA;EACE,0DAAA;AxDw+KF;;AwDt+KA;EACE,0DAAA;AxDy+KF;;AwDj+KA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBlDq9CmC;EkDp9CnC,mBAAA;EACA,gBlDm9CmC;EkDl9CnC,gBAAA;AxDm+KF;AwDj+KE;EACE,uBAAA;EACA,cAAA;EACA,WlDk9CiC;EkDj9CjC,WlDk9CiC;EkDj9CjC,UAAA;EACA,iBlDk9CiC;EkDj9CjC,gBlDi9CiC;EkDh9CjC,mBAAA;EACA,eAAA;EACA,sBlD5DO;EkD6DP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YlDy8CiC;EgBrnD/B,6BkC6KF;AxDk+KJ;AsB3oLM;EkCwJJ;IlCvJM,gBAAA;EtB8oLN;AACF;AwDp+KE;EACE,UlDs8CiC;ANgiIrC;;AwD79KA;EACE,kBAAA;EACA,UAAA;EACA,elDg8CmC;EkD/7CnC,SAAA;EACA,oBlD67CmC;EkD57CnC,uBlD47CmC;EkD37CnC,WlDvFS;EkDwFT,kBAAA;AxDg+KF;;AwD19KE;;EAEE,gClD+7CiC;AN8hIrC;AwD19KE;EACE,sBlD1FO;ANsjLX;AwDz9KE;EACE,WlD9FO;ANyjLX;;A0DxrLA;EACE;IAAK,0CAAA;E1D4rLL;AACF;A0DzrLA;EACE,qBAAA;EACA,WpDopDwB;EoDnpDxB,YpDmpDwB;EoDlpDxB,wBpDopDwB;EoDnpDxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;A1D0rLF;;A0DvrLA;EACE,WpD+oDwB;EoD9oDxB,YpD8oDwB;EoD7oDxB,mBpD+oDwB;AN2iI1B;;A0DlrLA;EACE;IACE,mBAAA;E1DqrLF;E0DnrLA;IACE,UAAA;IACA,eAAA;E1DqrLF;AACF;A0DjrLA;EACE,qBAAA;EACA,WpDknDwB;EoDjnDxB,YpDinDwB;EoDhnDxB,wBpDknDwB;EoDjnDxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;A1DkrLF;;A0D/qLA;EACE,WpD6mDwB;EoD5mDxB,YpD4mDwB;ANskI1B;;A0D9qLE;EACE;;IAEE,wBAAA;E1DirLJ;AACF;A2DnvLA;EACE,eAAA;EACA,SAAA;EACA,arD+pCkC;EqD9pClC,aAAA;EACA,sBAAA;EACA,eAAA;EAEA,kBAAA;EACA,sBrDiHS;EqDhHT,4BAAA;EACA,UAAA;ErCKI,sCqCHJ;A3DmvLF;AsB5uLM;EqCpBN;IrCqBQ,gBAAA;EtB+uLN;AACF;;A2DrvLA;EPdE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9C4pCkC;E8C3pClC,YAAA;EACA,aAAA;EACA,yB9C2HS;AN4oLX;AoDpwLE;EAAS,UAAA;ApDuwLX;AoDtwLE;EAAS,Y9Co/CyB;ANqxIpC;;A2DjwLA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;A3DowLF;A2DlwLE;EACE,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;A3DowLJ;;A2DhwLA;EACE,gBAAA;EACA,gBrDoqB4B;AN+lK9B;;A2DhwLA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;A3DmwLF;;A2DhwLA;EACE,MAAA;EACA,OAAA;EACA,YrDmpDkC;EqDlpDlC,iCAAA;EACA,4BAAA;A3DmwLF;;A2DhwLA;EACE,MAAA;EACA,QAAA;EACA,YrD2oDkC;EqD1oDlC,gCAAA;EACA,2BAAA;A3DmwLF;;A2DhwLA;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,YrDmoDkC;EqDloDlC,gBAAA;EACA,kCAAA;EACA,4BAAA;A3DmwLF;;A2DhwLA;EACE,QAAA;EACA,OAAA;EACA,YrD0nDkC;EqDznDlC,gBAAA;EACA,+BAAA;EACA,2BAAA;A3DmwLF;;A2DhwLA;EACE,eAAA;A3DmwLF;;A4Dp1LA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YtD20CkC;AN4gJpC;A4Dr1LE;EACE,qBAAA;EACA,WAAA;A5Du1LJ;;A4Dl1LA;EACE,iBAAA;A5Dq1LF;;A4Dl1LA;EACE,iBAAA;A5Dq1LF;;A4Dl1LA;EACE,iBAAA;A5Dq1LF;;A4Dh1LE;EACE,mDAAA;A5Dm1LJ;;A4D/0LA;EACE;IACE,YtD8yCgC;ENoiJlC;AACF;A4D/0LA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A5Di1LF;;A4D90LA;EACE;IACE,uBAAA;E5Di1LF;AACF;AyDh4LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDk4LJ;;A6Dt4LE;EACE,cvDgMW;ANysLf;A6Dt4LM;EAEE,+CAAA;A7Du4LR;;A6D74LE;EACE,cvDgMW;ANgtLf;A6D74LM;EAEE,oCAAA;A7D84LR;;A6Dp5LE;EACE,cvDgMW;ANutLf;A6Dp5LM;EAEE,0DAAA;A7Dq5LR;;A6D35LE;EACE,cvDgMW;AN8tLf;A6D35LM;EAEE,0DAAA;A7D45LR;;A6Dl6LE;EACE,cvDgMW;ANquLf;A6Dl6LM;EAEE,gDAAA;A7Dm6LR;;A6Dz6LE;EACE,cvDgMW;AN4uLf;A6Dz6LM;EAEE,oCAAA;A7D06LR;;A6Dh7LE;EACE,cvDgMW;ANmvLf;A6Dh7LM;EAEE,+CAAA;A7Di7LR;;A6Dv7LE;EACE,cvDgMW;AN0vLf;A6Dv7LM;EAEE,0DAAA;A7Dw7LR;;A8D77LA;EACE,kBAAA;EACA,WAAA;A9Dg8LF;A8D97LE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A9Dg8LJ;A8D77LE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A9D+7LJ;;A8D17LE;EACE,uBAAA;A9D67LJ;;A8D97LE;EACE,sBAAA;A9Di8LJ;;A8Dl8LE;EACE,yBAAA;A9Dq8LJ;;A8Dt8LE;EACE,iCAAA;A9Dy8LJ;;A+D99LA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,azDypCkC;ANw0JpC;;A+D99LA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,azDipCkC;ANg1JpC;;A+Dz9LI;EACE,gBAAA;EACA,MAAA;EACA,azDqoC8B;ANu1JpC;;Acv7LI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDqoC8B;EN81JlC;AACF;Ac/7LI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDqoC8B;ENq2JlC;AACF;Act8LI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDqoC8B;EN42JlC;AACF;Ac78LI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDqoC8B;ENm3JlC;AACF;Acp9LI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDqoC8B;EN03JlC;AACF;AgEzhMA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AhE2hMF;;AgExhMA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AhE2hMF;;AiEniMA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AlEoiMF;;AmE/iME;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U7D0iBsC;E6DziBtC,WAAA;AnEkjMJ;;AoE1jMA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;ArE8jMF;;AsEpkMA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,UhEowB4B;ANm0K9B;;AuE9gMQ;EAOI,mCAAA;AvE2gMZ;;AuElhMQ;EAOI,8BAAA;AvE+gMZ;;AuEthMQ;EAOI,iCAAA;AvEmhMZ;;AuE1hMQ;EAOI,iCAAA;AvEuhMZ;;AuE9hMQ;EAOI,sCAAA;AvE2hMZ;;AuEliMQ;EAOI,mCAAA;AvE+hMZ;;AuEtiMQ;EAOI,sBAAA;AvEmiMZ;;AuE1iMQ;EAOI,uBAAA;AvEuiMZ;;AuE9iMQ;EAOI,sBAAA;AvE2iMZ;;AuEljMQ;EAOI,qBAAA;AvE+iMZ;;AuEtjMQ;EAOI,wBAAA;AvEmjMZ;;AuE1jMQ;EAOI,uBAAA;AvEujMZ;;AuE9jMQ;EAOI,wBAAA;AvE2jMZ;;AuElkMQ;EAOI,qBAAA;AvE+jMZ;;AuEtkMQ;EAOI,yBAAA;AvEmkMZ;;AuE1kMQ;EAOI,2BAAA;AvEukMZ;;AuE9kMQ;EAOI,4BAAA;AvE2kMZ;;AuEllMQ;EAOI,2BAAA;AvE+kMZ;;AuEtlMQ;EAOI,0BAAA;AvEmlMZ;;AuE1lMQ;EAOI,gCAAA;AvEulMZ;;AuE9lMQ;EAOI,yBAAA;AvE2lMZ;;AuElmMQ;EAOI,wBAAA;AvE+lMZ;;AuEtmMQ;EAOI,yBAAA;AvEmmMZ;;AuE1mMQ;EAOI,6BAAA;AvEumMZ;;AuE9mMQ;EAOI,8BAAA;AvE2mMZ;;AuElnMQ;EAOI,wBAAA;AvE+mMZ;;AuEtnMQ;EAOI,+BAAA;AvEmnMZ;;AuE1nMQ;EAOI,wBAAA;AvEunMZ;;AuE9nMQ;EAOI,wDAAA;AvE2nMZ;;AuEloMQ;EAOI,gEAAA;AvE+nMZ;;AuEtoMQ;EAOI,uDAAA;AvEmoMZ;;AuE1oMQ;EAOI,2BAAA;AvEuoMZ;;AuE9oMQ;EAOI,2BAAA;AvE2oMZ;;AuElpMQ;EAOI,6BAAA;AvE+oMZ;;AuEtpMQ;EAOI,6BAAA;AvEmpMZ;;AuE1pMQ;EAOI,0BAAA;AvEupMZ;;AuE9pMQ;EAOI,2BAAA;AvE2pMZ;;AuElqMQ;EAOI,iBAAA;AvE+pMZ;;AuEtqMQ;EAOI,mBAAA;AvEmqMZ;;AuE1qMQ;EAOI,oBAAA;AvEuqMZ;;AuE9qMQ;EAOI,oBAAA;AvE2qMZ;;AuElrMQ;EAOI,sBAAA;AvE+qMZ;;AuEtrMQ;EAOI,uBAAA;AvEmrMZ;;AuE1rMQ;EAOI,kBAAA;AvEurMZ;;AuE9rMQ;EAOI,oBAAA;AvE2rMZ;;AuElsMQ;EAOI,qBAAA;AvE+rMZ;;AuEtsMQ;EAOI,mBAAA;AvEmsMZ;;AuE1sMQ;EAOI,qBAAA;AvEusMZ;;AuE9sMQ;EAOI,sBAAA;AvE2sMZ;;AuEltMQ;EAOI,2CAAA;AvE+sMZ;;AuEttMQ;EAOI,sCAAA;AvEmtMZ;;AuE1tMQ;EAOI,sCAAA;AvEutMZ;;AuE9tMQ;EAOI,gFAAA;AvE2tMZ;;AuEluMQ;EAOI,oBAAA;AvE+tMZ;;AuEtuMQ;EAOI,oFAAA;AvEmuMZ;;AuE1uMQ;EAOI,wBAAA;AvEuuMZ;;AuE9uMQ;EAOI,sFAAA;AvE2uMZ;;AuElvMQ;EAOI,0BAAA;AvE+uMZ;;AuEtvMQ;EAOI,uFAAA;AvEmvMZ;;AuE1vMQ;EAOI,2BAAA;AvEuvMZ;;AuE9vMQ;EAOI,qFAAA;AvE2vMZ;;AuElwMQ;EAOI,yBAAA;AvE+vMZ;;AuEtwMQ;EAOI,gCAAA;AvEmwMZ;;AuE1wMQ;EAOI,gCAAA;AvEuwMZ;;AuE9wMQ;EAOI,gCAAA;AvE2wMZ;;AuElxMQ;EAOI,gCAAA;AvE+wMZ;;AuEtxMQ;EAOI,gCAAA;AvEmxMZ;;AuE1xMQ;EAOI,gCAAA;AvEuxMZ;;AuE9xMQ;EAOI,gCAAA;AvE2xMZ;;AuElyMQ;EAOI,gCAAA;AvE+xMZ;;AuEtyMQ;EAOI,6BAAA;AvEmyMZ;;AuE1yMQ;EAOI,4BAAA;AvEuyMZ;;AuE9yMQ;EAOI,4BAAA;AvE2yMZ;;AuElzMQ;EAOI,4BAAA;AvE+yMZ;;AuEtzMQ;EAOI,4BAAA;AvEmzMZ;;AuE1zMQ;EAOI,4BAAA;AvEuzMZ;;AuE9zMQ;EAOI,qBAAA;AvE2zMZ;;AuEl0MQ;EAOI,qBAAA;AvE+zMZ;;AuEt0MQ;EAOI,qBAAA;AvEm0MZ;;AuE10MQ;EAOI,sBAAA;AvEu0MZ;;AuE90MQ;EAOI,sBAAA;AvE20MZ;;AuEl1MQ;EAOI,0BAAA;AvE+0MZ;;AuEt1MQ;EAOI,uBAAA;AvEm1MZ;;AuE11MQ;EAOI,2BAAA;AvEu1MZ;;AuE91MQ;EAOI,sBAAA;AvE21MZ;;AuEl2MQ;EAOI,sBAAA;AvE+1MZ;;AuEt2MQ;EAOI,sBAAA;AvEm2MZ;;AuE12MQ;EAOI,uBAAA;AvEu2MZ;;AuE92MQ;EAOI,uBAAA;AvE22MZ;;AuEl3MQ;EAOI,2BAAA;AvE+2MZ;;AuEt3MQ;EAOI,wBAAA;AvEm3MZ;;AuE13MQ;EAOI,4BAAA;AvEu3MZ;;AuE93MQ;EAOI,yBAAA;AvE23MZ;;AuEl4MQ;EAOI,8BAAA;AvE+3MZ;;AuEt4MQ;EAOI,iCAAA;AvEm4MZ;;AuE14MQ;EAOI,sCAAA;AvEu4MZ;;AuE94MQ;EAOI,yCAAA;AvE24MZ;;AuEl5MQ;EAOI,uBAAA;AvE+4MZ;;AuEt5MQ;EAOI,uBAAA;AvEm5MZ;;AuE15MQ;EAOI,yBAAA;AvEu5MZ;;AuE95MQ;EAOI,yBAAA;AvE25MZ;;AuEl6MQ;EAOI,0BAAA;AvE+5MZ;;AuEt6MQ;EAOI,4BAAA;AvEm6MZ;;AuE16MQ;EAOI,kCAAA;AvEu6MZ;;AuE96MQ;EAOI,iBAAA;AvE26MZ;;AuEl7MQ;EAOI,wBAAA;AvE+6MZ;;AuEt7MQ;EAOI,uBAAA;AvEm7MZ;;AuE17MQ;EAOI,sBAAA;AvEu7MZ;;AuE97MQ;EAOI,uBAAA;AvE27MZ;;AuEl8MQ;EAOI,sBAAA;AvE+7MZ;;AuEt8MQ;EAOI,sCAAA;AvEm8MZ;;AuE18MQ;EAOI,oCAAA;AvEu8MZ;;AuE98MQ;EAOI,kCAAA;AvE28MZ;;AuEl9MQ;EAOI,yCAAA;AvE+8MZ;;AuEt9MQ;EAOI,wCAAA;AvEm9MZ;;AuE19MQ;EAOI,wCAAA;AvEu9MZ;;AuE99MQ;EAOI,kCAAA;AvE29MZ;;AuEl+MQ;EAOI,gCAAA;AvE+9MZ;;AuEt+MQ;EAOI,8BAAA;AvEm+MZ;;AuE1+MQ;EAOI,gCAAA;AvEu+MZ;;AuE9+MQ;EAOI,+BAAA;AvE2+MZ;;AuEl/MQ;EAOI,oCAAA;AvE++MZ;;AuEt/MQ;EAOI,kCAAA;AvEm/MZ;;AuE1/MQ;EAOI,gCAAA;AvEu/MZ;;AuE9/MQ;EAOI,uCAAA;AvE2/MZ;;AuElgNQ;EAOI,sCAAA;AvE+/MZ;;AuEtgNQ;EAOI,iCAAA;AvEmgNZ;;AuE1gNQ;EAOI,2BAAA;AvEugNZ;;AuE9gNQ;EAOI,iCAAA;AvE2gNZ;;AuElhNQ;EAOI,+BAAA;AvE+gNZ;;AuEthNQ;EAOI,6BAAA;AvEmhNZ;;AuE1hNQ;EAOI,+BAAA;AvEuhNZ;;AuE9hNQ;EAOI,8BAAA;AvE2hNZ;;AuEliNQ;EAOI,oBAAA;AvE+hNZ;;AuEtiNQ;EAOI,mBAAA;AvEmiNZ;;AuE1iNQ;EAOI,mBAAA;AvEuiNZ;;AuE9iNQ;EAOI,mBAAA;AvE2iNZ;;AuEljNQ;EAOI,mBAAA;AvE+iNZ;;AuEtjNQ;EAOI,mBAAA;AvEmjNZ;;AuE1jNQ;EAOI,mBAAA;AvEujNZ;;AuE9jNQ;EAOI,mBAAA;AvE2jNZ;;AuElkNQ;EAOI,oBAAA;AvE+jNZ;;AuEtkNQ;EAOI,2BAAA;AvEmkNZ;;AuE1kNQ;EAOI,0BAAA;AvEukNZ;;AuE9kNQ;EAOI,yBAAA;AvE2kNZ;;AuEllNQ;EAOI,0BAAA;AvE+kNZ;;AuEtlNQ;EAOI,yBAAA;AvEmlNZ;;AuE1lNQ;EAOI,uBAAA;AvEulNZ;;AuE9lNQ;EAOI,0BAAA;EAAA,yBAAA;AvE4lNZ;;AuEnmNQ;EAOI,iCAAA;EAAA,gCAAA;AvEimNZ;;AuExmNQ;EAOI,gCAAA;EAAA,+BAAA;AvEsmNZ;;AuE7mNQ;EAOI,+BAAA;EAAA,8BAAA;AvE2mNZ;;AuElnNQ;EAOI,gCAAA;EAAA,+BAAA;AvEgnNZ;;AuEvnNQ;EAOI,+BAAA;EAAA,8BAAA;AvEqnNZ;;AuE5nNQ;EAOI,6BAAA;EAAA,4BAAA;AvE0nNZ;;AuEjoNQ;EAOI,wBAAA;EAAA,2BAAA;AvE+nNZ;;AuEtoNQ;EAOI,+BAAA;EAAA,kCAAA;AvEooNZ;;AuE3oNQ;EAOI,8BAAA;EAAA,iCAAA;AvEyoNZ;;AuEhpNQ;EAOI,6BAAA;EAAA,gCAAA;AvE8oNZ;;AuErpNQ;EAOI,8BAAA;EAAA,iCAAA;AvEmpNZ;;AuE1pNQ;EAOI,6BAAA;EAAA,gCAAA;AvEwpNZ;;AuE/pNQ;EAOI,2BAAA;EAAA,8BAAA;AvE6pNZ;;AuEpqNQ;EAOI,wBAAA;AvEiqNZ;;AuExqNQ;EAOI,+BAAA;AvEqqNZ;;AuE5qNQ;EAOI,8BAAA;AvEyqNZ;;AuEhrNQ;EAOI,6BAAA;AvE6qNZ;;AuEprNQ;EAOI,8BAAA;AvEirNZ;;AuExrNQ;EAOI,6BAAA;AvEqrNZ;;AuE5rNQ;EAOI,2BAAA;AvEyrNZ;;AuEhsNQ;EAOI,0BAAA;AvE6rNZ;;AuEpsNQ;EAOI,iCAAA;AvEisNZ;;AuExsNQ;EAOI,gCAAA;AvEqsNZ;;AuE5sNQ;EAOI,+BAAA;AvEysNZ;;AuEhtNQ;EAOI,gCAAA;AvE6sNZ;;AuEptNQ;EAOI,+BAAA;AvEitNZ;;AuExtNQ;EAOI,6BAAA;AvEqtNZ;;AuE5tNQ;EAOI,2BAAA;AvEytNZ;;AuEhuNQ;EAOI,kCAAA;AvE6tNZ;;AuEpuNQ;EAOI,iCAAA;AvEiuNZ;;AuExuNQ;EAOI,gCAAA;AvEquNZ;;AuE5uNQ;EAOI,iCAAA;AvEyuNZ;;AuEhvNQ;EAOI,gCAAA;AvE6uNZ;;AuEpvNQ;EAOI,8BAAA;AvEivNZ;;AuExvNQ;EAOI,yBAAA;AvEqvNZ;;AuE5vNQ;EAOI,gCAAA;AvEyvNZ;;AuEhwNQ;EAOI,+BAAA;AvE6vNZ;;AuEpwNQ;EAOI,8BAAA;AvEiwNZ;;AuExwNQ;EAOI,+BAAA;AvEqwNZ;;AuE5wNQ;EAOI,8BAAA;AvEywNZ;;AuEhxNQ;EAOI,4BAAA;AvE6wNZ;;AuEpxNQ;EAOI,4BAAA;AvEixNZ;;AuExxNQ;EAOI,2BAAA;AvEqxNZ;;AuE5xNQ;EAOI,0BAAA;AvEyxNZ;;AuEhyNQ;EAOI,2BAAA;AvE6xNZ;;AuEpyNQ;EAOI,0BAAA;AvEiyNZ;;AuExyNQ;EAOI,kCAAA;EAAA,iCAAA;AvEsyNZ;;AuE7yNQ;EAOI,iCAAA;EAAA,gCAAA;AvE2yNZ;;AuElzNQ;EAOI,gCAAA;EAAA,+BAAA;AvEgzNZ;;AuEvzNQ;EAOI,iCAAA;EAAA,gCAAA;AvEqzNZ;;AuE5zNQ;EAOI,gCAAA;EAAA,+BAAA;AvE0zNZ;;AuEj0NQ;EAOI,gCAAA;EAAA,mCAAA;AvE+zNZ;;AuEt0NQ;EAOI,+BAAA;EAAA,kCAAA;AvEo0NZ;;AuE30NQ;EAOI,8BAAA;EAAA,iCAAA;AvEy0NZ;;AuEh1NQ;EAOI,+BAAA;EAAA,kCAAA;AvE80NZ;;AuEr1NQ;EAOI,8BAAA;EAAA,iCAAA;AvEm1NZ;;AuE11NQ;EAOI,gCAAA;AvEu1NZ;;AuE91NQ;EAOI,+BAAA;AvE21NZ;;AuEl2NQ;EAOI,8BAAA;AvE+1NZ;;AuEt2NQ;EAOI,+BAAA;AvEm2NZ;;AuE12NQ;EAOI,8BAAA;AvEu2NZ;;AuE92NQ;EAOI,kCAAA;AvE22NZ;;AuEl3NQ;EAOI,iCAAA;AvE+2NZ;;AuEt3NQ;EAOI,gCAAA;AvEm3NZ;;AuE13NQ;EAOI,iCAAA;AvEu3NZ;;AuE93NQ;EAOI,gCAAA;AvE23NZ;;AuEl4NQ;EAOI,mCAAA;AvE+3NZ;;AuEt4NQ;EAOI,kCAAA;AvEm4NZ;;AuE14NQ;EAOI,iCAAA;AvEu4NZ;;AuE94NQ;EAOI,kCAAA;AvE24NZ;;AuEl5NQ;EAOI,iCAAA;AvE+4NZ;;AuEt5NQ;EAOI,iCAAA;AvEm5NZ;;AuE15NQ;EAOI,gCAAA;AvEu5NZ;;AuE95NQ;EAOI,+BAAA;AvE25NZ;;AuEl6NQ;EAOI,gCAAA;AvE+5NZ;;AuEt6NQ;EAOI,+BAAA;AvEm6NZ;;AuE16NQ;EAOI,qBAAA;AvEu6NZ;;AuE96NQ;EAOI,4BAAA;AvE26NZ;;AuEl7NQ;EAOI,2BAAA;AvE+6NZ;;AuEt7NQ;EAOI,0BAAA;AvEm7NZ;;AuE17NQ;EAOI,2BAAA;AvEu7NZ;;AuE97NQ;EAOI,0BAAA;AvE27NZ;;AuEl8NQ;EAOI,2BAAA;EAAA,0BAAA;AvEg8NZ;;AuEv8NQ;EAOI,kCAAA;EAAA,iCAAA;AvEq8NZ;;AuE58NQ;EAOI,iCAAA;EAAA,gCAAA;AvE08NZ;;AuEj9NQ;EAOI,gCAAA;EAAA,+BAAA;AvE+8NZ;;AuEt9NQ;EAOI,iCAAA;EAAA,gCAAA;AvEo9NZ;;AuE39NQ;EAOI,gCAAA;EAAA,+BAAA;AvEy9NZ;;AuEh+NQ;EAOI,yBAAA;EAAA,4BAAA;AvE89NZ;;AuEr+NQ;EAOI,gCAAA;EAAA,mCAAA;AvEm+NZ;;AuE1+NQ;EAOI,+BAAA;EAAA,kCAAA;AvEw+NZ;;AuE/+NQ;EAOI,8BAAA;EAAA,iCAAA;AvE6+NZ;;AuEp/NQ;EAOI,+BAAA;EAAA,kCAAA;AvEk/NZ;;AuEz/NQ;EAOI,8BAAA;EAAA,iCAAA;AvEu/NZ;;AuE9/NQ;EAOI,yBAAA;AvE2/NZ;;AuElgOQ;EAOI,gCAAA;AvE+/NZ;;AuEtgOQ;EAOI,+BAAA;AvEmgOZ;;AuE1gOQ;EAOI,8BAAA;AvEugOZ;;AuE9gOQ;EAOI,+BAAA;AvE2gOZ;;AuElhOQ;EAOI,8BAAA;AvE+gOZ;;AuEthOQ;EAOI,2BAAA;AvEmhOZ;;AuE1hOQ;EAOI,kCAAA;AvEuhOZ;;AuE9hOQ;EAOI,iCAAA;AvE2hOZ;;AuEliOQ;EAOI,gCAAA;AvE+hOZ;;AuEtiOQ;EAOI,iCAAA;AvEmiOZ;;AuE1iOQ;EAOI,gCAAA;AvEuiOZ;;AuE9iOQ;EAOI,4BAAA;AvE2iOZ;;AuEljOQ;EAOI,mCAAA;AvE+iOZ;;AuEtjOQ;EAOI,kCAAA;AvEmjOZ;;AuE1jOQ;EAOI,iCAAA;AvEujOZ;;AuE9jOQ;EAOI,kCAAA;AvE2jOZ;;AuElkOQ;EAOI,iCAAA;AvE+jOZ;;AuEtkOQ;EAOI,0BAAA;AvEmkOZ;;AuE1kOQ;EAOI,iCAAA;AvEukOZ;;AuE9kOQ;EAOI,gCAAA;AvE2kOZ;;AuEllOQ;EAOI,+BAAA;AvE+kOZ;;AuEtlOQ;EAOI,gCAAA;AvEmlOZ;;AuE1lOQ;EAOI,+BAAA;AvEulOZ;;AuE9lOQ;EAOI,gDAAA;AvE2lOZ;;AuElmOQ;EAOI,2CAAA;AvE+lOZ;;AuEtmOQ;EAOI,8CAAA;AvEmmOZ;;AuE1mOQ;EAOI,4CAAA;AvEumOZ;;AuE9mOQ;EAOI,8BAAA;AvE2mOZ;;AuElnOQ;EAOI,+BAAA;AvE+mOZ;;AuEtnOQ;EAOI,4BAAA;AvEmnOZ;;AuE1nOQ;EAOI,6BAAA;AvEunOZ;;AuE9nOQ;EAOI,6BAAA;AvE2nOZ;;AuEloOQ;EAOI,2BAAA;AvE+nOZ;;AuEtoOQ;EAOI,+BAAA;AvEmoOZ;;AuE1oOQ;EAOI,2BAAA;AvEuoOZ;;AuE9oOQ;EAOI,2BAAA;AvE2oOZ;;AuElpOQ;EAOI,8BAAA;AvE+oOZ;;AuEtpOQ;EAOI,yBAAA;AvEmpOZ;;AuE1pOQ;EAOI,2BAAA;AvEupOZ;;AuE9pOQ;EAOI,2BAAA;AvE2pOZ;;AuElqOQ;EAOI,2BAAA;AvE+pOZ;;AuEtqOQ;EAOI,2BAAA;AvEmqOZ;;AuE1qOQ;EAOI,4BAAA;AvEuqOZ;;AuE9qOQ;EAOI,6BAAA;AvE2qOZ;;AuElrOQ;EAOI,gCAAA;AvE+qOZ;;AuEtrOQ;EAOI,qCAAA;AvEmrOZ;;AuE1rOQ;EAOI,wCAAA;AvEurOZ;;AuE9rOQ;EAOI,oCAAA;AvE2rOZ;;AuElsOQ;EAOI,oCAAA;AvE+rOZ;;AuEtsOQ;EAOI,qCAAA;AvEmsOZ;;AuE1sOQ;EAOI,8BAAA;AvEusOZ;;AuE9sOQ;EAOI,8BAAA;AvE2sOZ;;AuEhuOQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AvEitOZ;;AuEnsOQ,mBAAA;AArBA;EAIQ,oBAAA;EAGJ,qEAAA;AvEutOZ;;AuE9tOQ;EAIQ,oBAAA;EAGJ,uEAAA;AvE4tOZ;;AuEnuOQ;EAIQ,oBAAA;EAGJ,qEAAA;AvEiuOZ;;AuExuOQ;EAIQ,oBAAA;EAGJ,kEAAA;AvEsuOZ;;AuE7uOQ;EAIQ,oBAAA;EAGJ,qEAAA;AvE2uOZ;;AuElvOQ;EAIQ,oBAAA;EAGJ,oEAAA;AvEgvOZ;;AuEvvOQ;EAIQ,oBAAA;EAGJ,mEAAA;AvEqvOZ;;AuE5vOQ;EAIQ,oBAAA;EAGJ,kEAAA;AvE0vOZ;;AuEjwOQ;EAIQ,oBAAA;EAGJ,mEAAA;AvE+vOZ;;AuEtwOQ;EAIQ,oBAAA;EAGJ,mEAAA;AvEowOZ;;AuE3wOQ;EAIQ,oBAAA;EAGJ,wEAAA;AvEywOZ;;AuEhxOQ;EAIQ,oBAAA;EAGJ,yBAAA;AvE8wOZ;;AuErxOQ;EAIQ,oBAAA;EAGJ,oCAAA;AvEmxOZ;;AuE1xOQ;EAIQ,oBAAA;EAGJ,0CAAA;AvEwxOZ;;AuE/xOQ;EAIQ,oBAAA;EAGJ,yBAAA;AvE6xOZ;;AuE9yOQ;EACE,uBAAA;AvEizOV;;AuElzOQ;EACE,sBAAA;AvEqzOV;;AuEtzOQ;EACE,uBAAA;AvEyzOV;;AuE1zOQ;EACE,oBAAA;AvE6zOV;;AuEpzOQ;EAIQ,kBAAA;EAGJ,8EAAA;AvEkzOZ;;AuEzzOQ;EAIQ,kBAAA;EAGJ,gFAAA;AvEuzOZ;;AuE9zOQ;EAIQ,kBAAA;EAGJ,8EAAA;AvE4zOZ;;AuEn0OQ;EAIQ,kBAAA;EAGJ,2EAAA;AvEi0OZ;;AuEx0OQ;EAIQ,kBAAA;EAGJ,8EAAA;AvEs0OZ;;AuE70OQ;EAIQ,kBAAA;EAGJ,6EAAA;AvE20OZ;;AuEl1OQ;EAIQ,kBAAA;EAGJ,4EAAA;AvEg1OZ;;AuEv1OQ;EAIQ,kBAAA;EAGJ,2EAAA;AvEq1OZ;;AuE51OQ;EAIQ,kBAAA;EAGJ,4EAAA;AvE01OZ;;AuEj2OQ;EAIQ,kBAAA;EAGJ,4EAAA;AvE+1OZ;;AuEt2OQ;EAIQ,kBAAA;EAGJ,8EAAA;AvEo2OZ;;AuE32OQ;EAIQ,kBAAA;EAGJ,wCAAA;AvEy2OZ;;AuE13OQ;EACE,oBAAA;AvE63OV;;AuE93OQ;EACE,qBAAA;AvEi4OV;;AuEl4OQ;EACE,oBAAA;AvEq4OV;;AuEt4OQ;EACE,qBAAA;AvEy4OV;;AuE14OQ;EACE,kBAAA;AvE64OV;;AuEp4OQ;EAOI,+CAAA;AvEi4OZ;;AuEx4OQ;EAOI,mCAAA;UAAA,2BAAA;AvEq4OZ;;AuE54OQ;EAOI,oCAAA;UAAA,4BAAA;AvEy4OZ;;AuEh5OQ;EAOI,oCAAA;UAAA,4BAAA;AvE64OZ;;AuEp5OQ;EAOI,+BAAA;AvEi5OZ;;AuEx5OQ;EAOI,+BAAA;AvEq5OZ;;AuE55OQ;EAOI,iCAAA;AvEy5OZ;;AuEh6OQ;EAOI,2BAAA;AvE65OZ;;AuEp6OQ;EAOI,gCAAA;AvEi6OZ;;AuEx6OQ;EAOI,iCAAA;AvEq6OZ;;AuE56OQ;EAOI,gCAAA;AvEy6OZ;;AuEh7OQ;EAOI,6BAAA;AvE66OZ;;AuEp7OQ;EAOI,+BAAA;AvEi7OZ;;AuEx7OQ;EAOI,0CAAA;EAAA,2CAAA;AvEs7OZ;;AuE77OQ;EAOI,2CAAA;EAAA,8CAAA;AvE27OZ;;AuEl8OQ;EAOI,8CAAA;EAAA,6CAAA;AvEg8OZ;;AuEv8OQ;EAOI,6CAAA;EAAA,0CAAA;AvEq8OZ;;AuE58OQ;EAOI,8BAAA;AvEy8OZ;;AuEh9OQ;EAOI,6BAAA;AvE68OZ;;Acp9OI;EyDAI;IAOI,sBAAA;EvEk9OV;EuEz9OM;IAOI,uBAAA;EvEq9OV;EuE59OM;IAOI,sBAAA;EvEw9OV;EuE/9OM;IAOI,0BAAA;EvE29OV;EuEl+OM;IAOI,gCAAA;EvE89OV;EuEr+OM;IAOI,yBAAA;EvEi+OV;EuEx+OM;IAOI,wBAAA;EvEo+OV;EuE3+OM;IAOI,yBAAA;EvEu+OV;EuE9+OM;IAOI,6BAAA;EvE0+OV;EuEj/OM;IAOI,8BAAA;EvE6+OV;EuEp/OM;IAOI,wBAAA;EvEg/OV;EuEv/OM;IAOI,+BAAA;EvEm/OV;EuE1/OM;IAOI,wBAAA;EvEs/OV;EuE7/OM;IAOI,yBAAA;EvEy/OV;EuEhgPM;IAOI,8BAAA;EvE4/OV;EuEngPM;IAOI,iCAAA;EvE+/OV;EuEtgPM;IAOI,sCAAA;EvEkgPV;EuEzgPM;IAOI,yCAAA;EvEqgPV;EuE5gPM;IAOI,uBAAA;EvEwgPV;EuE/gPM;IAOI,uBAAA;EvE2gPV;EuElhPM;IAOI,yBAAA;EvE8gPV;EuErhPM;IAOI,yBAAA;EvEihPV;EuExhPM;IAOI,0BAAA;EvEohPV;EuE3hPM;IAOI,4BAAA;EvEuhPV;EuE9hPM;IAOI,kCAAA;EvE0hPV;EuEjiPM;IAOI,iBAAA;EvE6hPV;EuEpiPM;IAOI,wBAAA;EvEgiPV;EuEviPM;IAOI,uBAAA;EvEmiPV;EuE1iPM;IAOI,sBAAA;EvEsiPV;EuE7iPM;IAOI,uBAAA;EvEyiPV;EuEhjPM;IAOI,sBAAA;EvE4iPV;EuEnjPM;IAOI,sCAAA;EvE+iPV;EuEtjPM;IAOI,oCAAA;EvEkjPV;EuEzjPM;IAOI,kCAAA;EvEqjPV;EuE5jPM;IAOI,yCAAA;EvEwjPV;EuE/jPM;IAOI,wCAAA;EvE2jPV;EuElkPM;IAOI,wCAAA;EvE8jPV;EuErkPM;IAOI,kCAAA;EvEikPV;EuExkPM;IAOI,gCAAA;EvEokPV;EuE3kPM;IAOI,8BAAA;EvEukPV;EuE9kPM;IAOI,gCAAA;EvE0kPV;EuEjlPM;IAOI,+BAAA;EvE6kPV;EuEplPM;IAOI,oCAAA;EvEglPV;EuEvlPM;IAOI,kCAAA;EvEmlPV;EuE1lPM;IAOI,gCAAA;EvEslPV;EuE7lPM;IAOI,uCAAA;EvEylPV;EuEhmPM;IAOI,sCAAA;EvE4lPV;EuEnmPM;IAOI,iCAAA;EvE+lPV;EuEtmPM;IAOI,2BAAA;EvEkmPV;EuEzmPM;IAOI,iCAAA;EvEqmPV;EuE5mPM;IAOI,+BAAA;EvEwmPV;EuE/mPM;IAOI,6BAAA;EvE2mPV;EuElnPM;IAOI,+BAAA;EvE8mPV;EuErnPM;IAOI,8BAAA;EvEinPV;EuExnPM;IAOI,oBAAA;EvEonPV;EuE3nPM;IAOI,mBAAA;EvEunPV;EuE9nPM;IAOI,mBAAA;EvE0nPV;EuEjoPM;IAOI,mBAAA;EvE6nPV;EuEpoPM;IAOI,mBAAA;EvEgoPV;EuEvoPM;IAOI,mBAAA;EvEmoPV;EuE1oPM;IAOI,mBAAA;EvEsoPV;EuE7oPM;IAOI,mBAAA;EvEyoPV;EuEhpPM;IAOI,oBAAA;EvE4oPV;EuEnpPM;IAOI,2BAAA;EvE+oPV;EuEtpPM;IAOI,0BAAA;EvEkpPV;EuEzpPM;IAOI,yBAAA;EvEqpPV;EuE5pPM;IAOI,0BAAA;EvEwpPV;EuE/pPM;IAOI,yBAAA;EvE2pPV;EuElqPM;IAOI,uBAAA;EvE8pPV;EuErqPM;IAOI,0BAAA;IAAA,yBAAA;EvEkqPV;EuEzqPM;IAOI,iCAAA;IAAA,gCAAA;EvEsqPV;EuE7qPM;IAOI,gCAAA;IAAA,+BAAA;EvE0qPV;EuEjrPM;IAOI,+BAAA;IAAA,8BAAA;EvE8qPV;EuErrPM;IAOI,gCAAA;IAAA,+BAAA;EvEkrPV;EuEzrPM;IAOI,+BAAA;IAAA,8BAAA;EvEsrPV;EuE7rPM;IAOI,6BAAA;IAAA,4BAAA;EvE0rPV;EuEjsPM;IAOI,wBAAA;IAAA,2BAAA;EvE8rPV;EuErsPM;IAOI,+BAAA;IAAA,kCAAA;EvEksPV;EuEzsPM;IAOI,8BAAA;IAAA,iCAAA;EvEssPV;EuE7sPM;IAOI,6BAAA;IAAA,gCAAA;EvE0sPV;EuEjtPM;IAOI,8BAAA;IAAA,iCAAA;EvE8sPV;EuErtPM;IAOI,6BAAA;IAAA,gCAAA;EvEktPV;EuEztPM;IAOI,2BAAA;IAAA,8BAAA;EvEstPV;EuE7tPM;IAOI,wBAAA;EvEytPV;EuEhuPM;IAOI,+BAAA;EvE4tPV;EuEnuPM;IAOI,8BAAA;EvE+tPV;EuEtuPM;IAOI,6BAAA;EvEkuPV;EuEzuPM;IAOI,8BAAA;EvEquPV;EuE5uPM;IAOI,6BAAA;EvEwuPV;EuE/uPM;IAOI,2BAAA;EvE2uPV;EuElvPM;IAOI,0BAAA;EvE8uPV;EuErvPM;IAOI,iCAAA;EvEivPV;EuExvPM;IAOI,gCAAA;EvEovPV;EuE3vPM;IAOI,+BAAA;EvEuvPV;EuE9vPM;IAOI,gCAAA;EvE0vPV;EuEjwPM;IAOI,+BAAA;EvE6vPV;EuEpwPM;IAOI,6BAAA;EvEgwPV;EuEvwPM;IAOI,2BAAA;EvEmwPV;EuE1wPM;IAOI,kCAAA;EvEswPV;EuE7wPM;IAOI,iCAAA;EvEywPV;EuEhxPM;IAOI,gCAAA;EvE4wPV;EuEnxPM;IAOI,iCAAA;EvE+wPV;EuEtxPM;IAOI,gCAAA;EvEkxPV;EuEzxPM;IAOI,8BAAA;EvEqxPV;EuE5xPM;IAOI,yBAAA;EvEwxPV;EuE/xPM;IAOI,gCAAA;EvE2xPV;EuElyPM;IAOI,+BAAA;EvE8xPV;EuEryPM;IAOI,8BAAA;EvEiyPV;EuExyPM;IAOI,+BAAA;EvEoyPV;EuE3yPM;IAOI,8BAAA;EvEuyPV;EuE9yPM;IAOI,4BAAA;EvE0yPV;EuEjzPM;IAOI,4BAAA;EvE6yPV;EuEpzPM;IAOI,2BAAA;EvEgzPV;EuEvzPM;IAOI,0BAAA;EvEmzPV;EuE1zPM;IAOI,2BAAA;EvEszPV;EuE7zPM;IAOI,0BAAA;EvEyzPV;EuEh0PM;IAOI,kCAAA;IAAA,iCAAA;EvE6zPV;EuEp0PM;IAOI,iCAAA;IAAA,gCAAA;EvEi0PV;EuEx0PM;IAOI,gCAAA;IAAA,+BAAA;EvEq0PV;EuE50PM;IAOI,iCAAA;IAAA,gCAAA;EvEy0PV;EuEh1PM;IAOI,gCAAA;IAAA,+BAAA;EvE60PV;EuEp1PM;IAOI,gCAAA;IAAA,mCAAA;EvEi1PV;EuEx1PM;IAOI,+BAAA;IAAA,kCAAA;EvEq1PV;EuE51PM;IAOI,8BAAA;IAAA,iCAAA;EvEy1PV;EuEh2PM;IAOI,+BAAA;IAAA,kCAAA;EvE61PV;EuEp2PM;IAOI,8BAAA;IAAA,iCAAA;EvEi2PV;EuEx2PM;IAOI,gCAAA;EvEo2PV;EuE32PM;IAOI,+BAAA;EvEu2PV;EuE92PM;IAOI,8BAAA;EvE02PV;EuEj3PM;IAOI,+BAAA;EvE62PV;EuEp3PM;IAOI,8BAAA;EvEg3PV;EuEv3PM;IAOI,kCAAA;EvEm3PV;EuE13PM;IAOI,iCAAA;EvEs3PV;EuE73PM;IAOI,gCAAA;EvEy3PV;EuEh4PM;IAOI,iCAAA;EvE43PV;EuEn4PM;IAOI,gCAAA;EvE+3PV;EuEt4PM;IAOI,mCAAA;EvEk4PV;EuEz4PM;IAOI,kCAAA;EvEq4PV;EuE54PM;IAOI,iCAAA;EvEw4PV;EuE/4PM;IAOI,kCAAA;EvE24PV;EuEl5PM;IAOI,iCAAA;EvE84PV;EuEr5PM;IAOI,iCAAA;EvEi5PV;EuEx5PM;IAOI,gCAAA;EvEo5PV;EuE35PM;IAOI,+BAAA;EvEu5PV;EuE95PM;IAOI,gCAAA;EvE05PV;EuEj6PM;IAOI,+BAAA;EvE65PV;EuEp6PM;IAOI,qBAAA;EvEg6PV;EuEv6PM;IAOI,4BAAA;EvEm6PV;EuE16PM;IAOI,2BAAA;EvEs6PV;EuE76PM;IAOI,0BAAA;EvEy6PV;EuEh7PM;IAOI,2BAAA;EvE46PV;EuEn7PM;IAOI,0BAAA;EvE+6PV;EuEt7PM;IAOI,2BAAA;IAAA,0BAAA;EvEm7PV;EuE17PM;IAOI,kCAAA;IAAA,iCAAA;EvEu7PV;EuE97PM;IAOI,iCAAA;IAAA,gCAAA;EvE27PV;EuEl8PM;IAOI,gCAAA;IAAA,+BAAA;EvE+7PV;EuEt8PM;IAOI,iCAAA;IAAA,gCAAA;EvEm8PV;EuE18PM;IAOI,gCAAA;IAAA,+BAAA;EvEu8PV;EuE98PM;IAOI,yBAAA;IAAA,4BAAA;EvE28PV;EuEl9PM;IAOI,gCAAA;IAAA,mCAAA;EvE+8PV;EuEt9PM;IAOI,+BAAA;IAAA,kCAAA;EvEm9PV;EuE19PM;IAOI,8BAAA;IAAA,iCAAA;EvEu9PV;EuE99PM;IAOI,+BAAA;IAAA,kCAAA;EvE29PV;EuEl+PM;IAOI,8BAAA;IAAA,iCAAA;EvE+9PV;EuEt+PM;IAOI,yBAAA;EvEk+PV;EuEz+PM;IAOI,gCAAA;EvEq+PV;EuE5+PM;IAOI,+BAAA;EvEw+PV;EuE/+PM;IAOI,8BAAA;EvE2+PV;EuEl/PM;IAOI,+BAAA;EvE8+PV;EuEr/PM;IAOI,8BAAA;EvEi/PV;EuEx/PM;IAOI,2BAAA;EvEo/PV;EuE3/PM;IAOI,kCAAA;EvEu/PV;EuE9/PM;IAOI,iCAAA;EvE0/PV;EuEjgQM;IAOI,gCAAA;EvE6/PV;EuEpgQM;IAOI,iCAAA;EvEggQV;EuEvgQM;IAOI,gCAAA;EvEmgQV;EuE1gQM;IAOI,4BAAA;EvEsgQV;EuE7gQM;IAOI,mCAAA;EvEygQV;EuEhhQM;IAOI,kCAAA;EvE4gQV;EuEnhQM;IAOI,iCAAA;EvE+gQV;EuEthQM;IAOI,kCAAA;EvEkhQV;EuEzhQM;IAOI,iCAAA;EvEqhQV;EuE5hQM;IAOI,0BAAA;EvEwhQV;EuE/hQM;IAOI,iCAAA;EvE2hQV;EuEliQM;IAOI,gCAAA;EvE8hQV;EuEriQM;IAOI,+BAAA;EvEiiQV;EuExiQM;IAOI,gCAAA;EvEoiQV;EuE3iQM;IAOI,+BAAA;EvEuiQV;EuE9iQM;IAOI,2BAAA;EvE0iQV;EuEjjQM;IAOI,4BAAA;EvE6iQV;EuEpjQM;IAOI,6BAAA;EvEgjQV;AACF;AcxjQI;EyDAI;IAOI,sBAAA;EvEqjQV;EuE5jQM;IAOI,uBAAA;EvEwjQV;EuE/jQM;IAOI,sBAAA;EvE2jQV;EuElkQM;IAOI,0BAAA;EvE8jQV;EuErkQM;IAOI,gCAAA;EvEikQV;EuExkQM;IAOI,yBAAA;EvEokQV;EuE3kQM;IAOI,wBAAA;EvEukQV;EuE9kQM;IAOI,yBAAA;EvE0kQV;EuEjlQM;IAOI,6BAAA;EvE6kQV;EuEplQM;IAOI,8BAAA;EvEglQV;EuEvlQM;IAOI,wBAAA;EvEmlQV;EuE1lQM;IAOI,+BAAA;EvEslQV;EuE7lQM;IAOI,wBAAA;EvEylQV;EuEhmQM;IAOI,yBAAA;EvE4lQV;EuEnmQM;IAOI,8BAAA;EvE+lQV;EuEtmQM;IAOI,iCAAA;EvEkmQV;EuEzmQM;IAOI,sCAAA;EvEqmQV;EuE5mQM;IAOI,yCAAA;EvEwmQV;EuE/mQM;IAOI,uBAAA;EvE2mQV;EuElnQM;IAOI,uBAAA;EvE8mQV;EuErnQM;IAOI,yBAAA;EvEinQV;EuExnQM;IAOI,yBAAA;EvEonQV;EuE3nQM;IAOI,0BAAA;EvEunQV;EuE9nQM;IAOI,4BAAA;EvE0nQV;EuEjoQM;IAOI,kCAAA;EvE6nQV;EuEpoQM;IAOI,iBAAA;EvEgoQV;EuEvoQM;IAOI,wBAAA;EvEmoQV;EuE1oQM;IAOI,uBAAA;EvEsoQV;EuE7oQM;IAOI,sBAAA;EvEyoQV;EuEhpQM;IAOI,uBAAA;EvE4oQV;EuEnpQM;IAOI,sBAAA;EvE+oQV;EuEtpQM;IAOI,sCAAA;EvEkpQV;EuEzpQM;IAOI,oCAAA;EvEqpQV;EuE5pQM;IAOI,kCAAA;EvEwpQV;EuE/pQM;IAOI,yCAAA;EvE2pQV;EuElqQM;IAOI,wCAAA;EvE8pQV;EuErqQM;IAOI,wCAAA;EvEiqQV;EuExqQM;IAOI,kCAAA;EvEoqQV;EuE3qQM;IAOI,gCAAA;EvEuqQV;EuE9qQM;IAOI,8BAAA;EvE0qQV;EuEjrQM;IAOI,gCAAA;EvE6qQV;EuEprQM;IAOI,+BAAA;EvEgrQV;EuEvrQM;IAOI,oCAAA;EvEmrQV;EuE1rQM;IAOI,kCAAA;EvEsrQV;EuE7rQM;IAOI,gCAAA;EvEyrQV;EuEhsQM;IAOI,uCAAA;EvE4rQV;EuEnsQM;IAOI,sCAAA;EvE+rQV;EuEtsQM;IAOI,iCAAA;EvEksQV;EuEzsQM;IAOI,2BAAA;EvEqsQV;EuE5sQM;IAOI,iCAAA;EvEwsQV;EuE/sQM;IAOI,+BAAA;EvE2sQV;EuEltQM;IAOI,6BAAA;EvE8sQV;EuErtQM;IAOI,+BAAA;EvEitQV;EuExtQM;IAOI,8BAAA;EvEotQV;EuE3tQM;IAOI,oBAAA;EvEutQV;EuE9tQM;IAOI,mBAAA;EvE0tQV;EuEjuQM;IAOI,mBAAA;EvE6tQV;EuEpuQM;IAOI,mBAAA;EvEguQV;EuEvuQM;IAOI,mBAAA;EvEmuQV;EuE1uQM;IAOI,mBAAA;EvEsuQV;EuE7uQM;IAOI,mBAAA;EvEyuQV;EuEhvQM;IAOI,mBAAA;EvE4uQV;EuEnvQM;IAOI,oBAAA;EvE+uQV;EuEtvQM;IAOI,2BAAA;EvEkvQV;EuEzvQM;IAOI,0BAAA;EvEqvQV;EuE5vQM;IAOI,yBAAA;EvEwvQV;EuE/vQM;IAOI,0BAAA;EvE2vQV;EuElwQM;IAOI,yBAAA;EvE8vQV;EuErwQM;IAOI,uBAAA;EvEiwQV;EuExwQM;IAOI,0BAAA;IAAA,yBAAA;EvEqwQV;EuE5wQM;IAOI,iCAAA;IAAA,gCAAA;EvEywQV;EuEhxQM;IAOI,gCAAA;IAAA,+BAAA;EvE6wQV;EuEpxQM;IAOI,+BAAA;IAAA,8BAAA;EvEixQV;EuExxQM;IAOI,gCAAA;IAAA,+BAAA;EvEqxQV;EuE5xQM;IAOI,+BAAA;IAAA,8BAAA;EvEyxQV;EuEhyQM;IAOI,6BAAA;IAAA,4BAAA;EvE6xQV;EuEpyQM;IAOI,wBAAA;IAAA,2BAAA;EvEiyQV;EuExyQM;IAOI,+BAAA;IAAA,kCAAA;EvEqyQV;EuE5yQM;IAOI,8BAAA;IAAA,iCAAA;EvEyyQV;EuEhzQM;IAOI,6BAAA;IAAA,gCAAA;EvE6yQV;EuEpzQM;IAOI,8BAAA;IAAA,iCAAA;EvEizQV;EuExzQM;IAOI,6BAAA;IAAA,gCAAA;EvEqzQV;EuE5zQM;IAOI,2BAAA;IAAA,8BAAA;EvEyzQV;EuEh0QM;IAOI,wBAAA;EvE4zQV;EuEn0QM;IAOI,+BAAA;EvE+zQV;EuEt0QM;IAOI,8BAAA;EvEk0QV;EuEz0QM;IAOI,6BAAA;EvEq0QV;EuE50QM;IAOI,8BAAA;EvEw0QV;EuE/0QM;IAOI,6BAAA;EvE20QV;EuEl1QM;IAOI,2BAAA;EvE80QV;EuEr1QM;IAOI,0BAAA;EvEi1QV;EuEx1QM;IAOI,iCAAA;EvEo1QV;EuE31QM;IAOI,gCAAA;EvEu1QV;EuE91QM;IAOI,+BAAA;EvE01QV;EuEj2QM;IAOI,gCAAA;EvE61QV;EuEp2QM;IAOI,+BAAA;EvEg2QV;EuEv2QM;IAOI,6BAAA;EvEm2QV;EuE12QM;IAOI,2BAAA;EvEs2QV;EuE72QM;IAOI,kCAAA;EvEy2QV;EuEh3QM;IAOI,iCAAA;EvE42QV;EuEn3QM;IAOI,gCAAA;EvE+2QV;EuEt3QM;IAOI,iCAAA;EvEk3QV;EuEz3QM;IAOI,gCAAA;EvEq3QV;EuE53QM;IAOI,8BAAA;EvEw3QV;EuE/3QM;IAOI,yBAAA;EvE23QV;EuEl4QM;IAOI,gCAAA;EvE83QV;EuEr4QM;IAOI,+BAAA;EvEi4QV;EuEx4QM;IAOI,8BAAA;EvEo4QV;EuE34QM;IAOI,+BAAA;EvEu4QV;EuE94QM;IAOI,8BAAA;EvE04QV;EuEj5QM;IAOI,4BAAA;EvE64QV;EuEp5QM;IAOI,4BAAA;EvEg5QV;EuEv5QM;IAOI,2BAAA;EvEm5QV;EuE15QM;IAOI,0BAAA;EvEs5QV;EuE75QM;IAOI,2BAAA;EvEy5QV;EuEh6QM;IAOI,0BAAA;EvE45QV;EuEn6QM;IAOI,kCAAA;IAAA,iCAAA;EvEg6QV;EuEv6QM;IAOI,iCAAA;IAAA,gCAAA;EvEo6QV;EuE36QM;IAOI,gCAAA;IAAA,+BAAA;EvEw6QV;EuE/6QM;IAOI,iCAAA;IAAA,gCAAA;EvE46QV;EuEn7QM;IAOI,gCAAA;IAAA,+BAAA;EvEg7QV;EuEv7QM;IAOI,gCAAA;IAAA,mCAAA;EvEo7QV;EuE37QM;IAOI,+BAAA;IAAA,kCAAA;EvEw7QV;EuE/7QM;IAOI,8BAAA;IAAA,iCAAA;EvE47QV;EuEn8QM;IAOI,+BAAA;IAAA,kCAAA;EvEg8QV;EuEv8QM;IAOI,8BAAA;IAAA,iCAAA;EvEo8QV;EuE38QM;IAOI,gCAAA;EvEu8QV;EuE98QM;IAOI,+BAAA;EvE08QV;EuEj9QM;IAOI,8BAAA;EvE68QV;EuEp9QM;IAOI,+BAAA;EvEg9QV;EuEv9QM;IAOI,8BAAA;EvEm9QV;EuE19QM;IAOI,kCAAA;EvEs9QV;EuE79QM;IAOI,iCAAA;EvEy9QV;EuEh+QM;IAOI,gCAAA;EvE49QV;EuEn+QM;IAOI,iCAAA;EvE+9QV;EuEt+QM;IAOI,gCAAA;EvEk+QV;EuEz+QM;IAOI,mCAAA;EvEq+QV;EuE5+QM;IAOI,kCAAA;EvEw+QV;EuE/+QM;IAOI,iCAAA;EvE2+QV;EuEl/QM;IAOI,kCAAA;EvE8+QV;EuEr/QM;IAOI,iCAAA;EvEi/QV;EuEx/QM;IAOI,iCAAA;EvEo/QV;EuE3/QM;IAOI,gCAAA;EvEu/QV;EuE9/QM;IAOI,+BAAA;EvE0/QV;EuEjgRM;IAOI,gCAAA;EvE6/QV;EuEpgRM;IAOI,+BAAA;EvEggRV;EuEvgRM;IAOI,qBAAA;EvEmgRV;EuE1gRM;IAOI,4BAAA;EvEsgRV;EuE7gRM;IAOI,2BAAA;EvEygRV;EuEhhRM;IAOI,0BAAA;EvE4gRV;EuEnhRM;IAOI,2BAAA;EvE+gRV;EuEthRM;IAOI,0BAAA;EvEkhRV;EuEzhRM;IAOI,2BAAA;IAAA,0BAAA;EvEshRV;EuE7hRM;IAOI,kCAAA;IAAA,iCAAA;EvE0hRV;EuEjiRM;IAOI,iCAAA;IAAA,gCAAA;EvE8hRV;EuEriRM;IAOI,gCAAA;IAAA,+BAAA;EvEkiRV;EuEziRM;IAOI,iCAAA;IAAA,gCAAA;EvEsiRV;EuE7iRM;IAOI,gCAAA;IAAA,+BAAA;EvE0iRV;EuEjjRM;IAOI,yBAAA;IAAA,4BAAA;EvE8iRV;EuErjRM;IAOI,gCAAA;IAAA,mCAAA;EvEkjRV;EuEzjRM;IAOI,+BAAA;IAAA,kCAAA;EvEsjRV;EuE7jRM;IAOI,8BAAA;IAAA,iCAAA;EvE0jRV;EuEjkRM;IAOI,+BAAA;IAAA,kCAAA;EvE8jRV;EuErkRM;IAOI,8BAAA;IAAA,iCAAA;EvEkkRV;EuEzkRM;IAOI,yBAAA;EvEqkRV;EuE5kRM;IAOI,gCAAA;EvEwkRV;EuE/kRM;IAOI,+BAAA;EvE2kRV;EuEllRM;IAOI,8BAAA;EvE8kRV;EuErlRM;IAOI,+BAAA;EvEilRV;EuExlRM;IAOI,8BAAA;EvEolRV;EuE3lRM;IAOI,2BAAA;EvEulRV;EuE9lRM;IAOI,kCAAA;EvE0lRV;EuEjmRM;IAOI,iCAAA;EvE6lRV;EuEpmRM;IAOI,gCAAA;EvEgmRV;EuEvmRM;IAOI,iCAAA;EvEmmRV;EuE1mRM;IAOI,gCAAA;EvEsmRV;EuE7mRM;IAOI,4BAAA;EvEymRV;EuEhnRM;IAOI,mCAAA;EvE4mRV;EuEnnRM;IAOI,kCAAA;EvE+mRV;EuEtnRM;IAOI,iCAAA;EvEknRV;EuEznRM;IAOI,kCAAA;EvEqnRV;EuE5nRM;IAOI,iCAAA;EvEwnRV;EuE/nRM;IAOI,0BAAA;EvE2nRV;EuEloRM;IAOI,iCAAA;EvE8nRV;EuEroRM;IAOI,gCAAA;EvEioRV;EuExoRM;IAOI,+BAAA;EvEooRV;EuE3oRM;IAOI,gCAAA;EvEuoRV;EuE9oRM;IAOI,+BAAA;EvE0oRV;EuEjpRM;IAOI,2BAAA;EvE6oRV;EuEppRM;IAOI,4BAAA;EvEgpRV;EuEvpRM;IAOI,6BAAA;EvEmpRV;AACF;Ac3pRI;EyDAI;IAOI,sBAAA;EvEwpRV;EuE/pRM;IAOI,uBAAA;EvE2pRV;EuElqRM;IAOI,sBAAA;EvE8pRV;EuErqRM;IAOI,0BAAA;EvEiqRV;EuExqRM;IAOI,gCAAA;EvEoqRV;EuE3qRM;IAOI,yBAAA;EvEuqRV;EuE9qRM;IAOI,wBAAA;EvE0qRV;EuEjrRM;IAOI,yBAAA;EvE6qRV;EuEprRM;IAOI,6BAAA;EvEgrRV;EuEvrRM;IAOI,8BAAA;EvEmrRV;EuE1rRM;IAOI,wBAAA;EvEsrRV;EuE7rRM;IAOI,+BAAA;EvEyrRV;EuEhsRM;IAOI,wBAAA;EvE4rRV;EuEnsRM;IAOI,yBAAA;EvE+rRV;EuEtsRM;IAOI,8BAAA;EvEksRV;EuEzsRM;IAOI,iCAAA;EvEqsRV;EuE5sRM;IAOI,sCAAA;EvEwsRV;EuE/sRM;IAOI,yCAAA;EvE2sRV;EuEltRM;IAOI,uBAAA;EvE8sRV;EuErtRM;IAOI,uBAAA;EvEitRV;EuExtRM;IAOI,yBAAA;EvEotRV;EuE3tRM;IAOI,yBAAA;EvEutRV;EuE9tRM;IAOI,0BAAA;EvE0tRV;EuEjuRM;IAOI,4BAAA;EvE6tRV;EuEpuRM;IAOI,kCAAA;EvEguRV;EuEvuRM;IAOI,iBAAA;EvEmuRV;EuE1uRM;IAOI,wBAAA;EvEsuRV;EuE7uRM;IAOI,uBAAA;EvEyuRV;EuEhvRM;IAOI,sBAAA;EvE4uRV;EuEnvRM;IAOI,uBAAA;EvE+uRV;EuEtvRM;IAOI,sBAAA;EvEkvRV;EuEzvRM;IAOI,sCAAA;EvEqvRV;EuE5vRM;IAOI,oCAAA;EvEwvRV;EuE/vRM;IAOI,kCAAA;EvE2vRV;EuElwRM;IAOI,yCAAA;EvE8vRV;EuErwRM;IAOI,wCAAA;EvEiwRV;EuExwRM;IAOI,wCAAA;EvEowRV;EuE3wRM;IAOI,kCAAA;EvEuwRV;EuE9wRM;IAOI,gCAAA;EvE0wRV;EuEjxRM;IAOI,8BAAA;EvE6wRV;EuEpxRM;IAOI,gCAAA;EvEgxRV;EuEvxRM;IAOI,+BAAA;EvEmxRV;EuE1xRM;IAOI,oCAAA;EvEsxRV;EuE7xRM;IAOI,kCAAA;EvEyxRV;EuEhyRM;IAOI,gCAAA;EvE4xRV;EuEnyRM;IAOI,uCAAA;EvE+xRV;EuEtyRM;IAOI,sCAAA;EvEkyRV;EuEzyRM;IAOI,iCAAA;EvEqyRV;EuE5yRM;IAOI,2BAAA;EvEwyRV;EuE/yRM;IAOI,iCAAA;EvE2yRV;EuElzRM;IAOI,+BAAA;EvE8yRV;EuErzRM;IAOI,6BAAA;EvEizRV;EuExzRM;IAOI,+BAAA;EvEozRV;EuE3zRM;IAOI,8BAAA;EvEuzRV;EuE9zRM;IAOI,oBAAA;EvE0zRV;EuEj0RM;IAOI,mBAAA;EvE6zRV;EuEp0RM;IAOI,mBAAA;EvEg0RV;EuEv0RM;IAOI,mBAAA;EvEm0RV;EuE10RM;IAOI,mBAAA;EvEs0RV;EuE70RM;IAOI,mBAAA;EvEy0RV;EuEh1RM;IAOI,mBAAA;EvE40RV;EuEn1RM;IAOI,mBAAA;EvE+0RV;EuEt1RM;IAOI,oBAAA;EvEk1RV;EuEz1RM;IAOI,2BAAA;EvEq1RV;EuE51RM;IAOI,0BAAA;EvEw1RV;EuE/1RM;IAOI,yBAAA;EvE21RV;EuEl2RM;IAOI,0BAAA;EvE81RV;EuEr2RM;IAOI,yBAAA;EvEi2RV;EuEx2RM;IAOI,uBAAA;EvEo2RV;EuE32RM;IAOI,0BAAA;IAAA,yBAAA;EvEw2RV;EuE/2RM;IAOI,iCAAA;IAAA,gCAAA;EvE42RV;EuEn3RM;IAOI,gCAAA;IAAA,+BAAA;EvEg3RV;EuEv3RM;IAOI,+BAAA;IAAA,8BAAA;EvEo3RV;EuE33RM;IAOI,gCAAA;IAAA,+BAAA;EvEw3RV;EuE/3RM;IAOI,+BAAA;IAAA,8BAAA;EvE43RV;EuEn4RM;IAOI,6BAAA;IAAA,4BAAA;EvEg4RV;EuEv4RM;IAOI,wBAAA;IAAA,2BAAA;EvEo4RV;EuE34RM;IAOI,+BAAA;IAAA,kCAAA;EvEw4RV;EuE/4RM;IAOI,8BAAA;IAAA,iCAAA;EvE44RV;EuEn5RM;IAOI,6BAAA;IAAA,gCAAA;EvEg5RV;EuEv5RM;IAOI,8BAAA;IAAA,iCAAA;EvEo5RV;EuE35RM;IAOI,6BAAA;IAAA,gCAAA;EvEw5RV;EuE/5RM;IAOI,2BAAA;IAAA,8BAAA;EvE45RV;EuEn6RM;IAOI,wBAAA;EvE+5RV;EuEt6RM;IAOI,+BAAA;EvEk6RV;EuEz6RM;IAOI,8BAAA;EvEq6RV;EuE56RM;IAOI,6BAAA;EvEw6RV;EuE/6RM;IAOI,8BAAA;EvE26RV;EuEl7RM;IAOI,6BAAA;EvE86RV;EuEr7RM;IAOI,2BAAA;EvEi7RV;EuEx7RM;IAOI,0BAAA;EvEo7RV;EuE37RM;IAOI,iCAAA;EvEu7RV;EuE97RM;IAOI,gCAAA;EvE07RV;EuEj8RM;IAOI,+BAAA;EvE67RV;EuEp8RM;IAOI,gCAAA;EvEg8RV;EuEv8RM;IAOI,+BAAA;EvEm8RV;EuE18RM;IAOI,6BAAA;EvEs8RV;EuE78RM;IAOI,2BAAA;EvEy8RV;EuEh9RM;IAOI,kCAAA;EvE48RV;EuEn9RM;IAOI,iCAAA;EvE+8RV;EuEt9RM;IAOI,gCAAA;EvEk9RV;EuEz9RM;IAOI,iCAAA;EvEq9RV;EuE59RM;IAOI,gCAAA;EvEw9RV;EuE/9RM;IAOI,8BAAA;EvE29RV;EuEl+RM;IAOI,yBAAA;EvE89RV;EuEr+RM;IAOI,gCAAA;EvEi+RV;EuEx+RM;IAOI,+BAAA;EvEo+RV;EuE3+RM;IAOI,8BAAA;EvEu+RV;EuE9+RM;IAOI,+BAAA;EvE0+RV;EuEj/RM;IAOI,8BAAA;EvE6+RV;EuEp/RM;IAOI,4BAAA;EvEg/RV;EuEv/RM;IAOI,4BAAA;EvEm/RV;EuE1/RM;IAOI,2BAAA;EvEs/RV;EuE7/RM;IAOI,0BAAA;EvEy/RV;EuEhgSM;IAOI,2BAAA;EvE4/RV;EuEngSM;IAOI,0BAAA;EvE+/RV;EuEtgSM;IAOI,kCAAA;IAAA,iCAAA;EvEmgSV;EuE1gSM;IAOI,iCAAA;IAAA,gCAAA;EvEugSV;EuE9gSM;IAOI,gCAAA;IAAA,+BAAA;EvE2gSV;EuElhSM;IAOI,iCAAA;IAAA,gCAAA;EvE+gSV;EuEthSM;IAOI,gCAAA;IAAA,+BAAA;EvEmhSV;EuE1hSM;IAOI,gCAAA;IAAA,mCAAA;EvEuhSV;EuE9hSM;IAOI,+BAAA;IAAA,kCAAA;EvE2hSV;EuEliSM;IAOI,8BAAA;IAAA,iCAAA;EvE+hSV;EuEtiSM;IAOI,+BAAA;IAAA,kCAAA;EvEmiSV;EuE1iSM;IAOI,8BAAA;IAAA,iCAAA;EvEuiSV;EuE9iSM;IAOI,gCAAA;EvE0iSV;EuEjjSM;IAOI,+BAAA;EvE6iSV;EuEpjSM;IAOI,8BAAA;EvEgjSV;EuEvjSM;IAOI,+BAAA;EvEmjSV;EuE1jSM;IAOI,8BAAA;EvEsjSV;EuE7jSM;IAOI,kCAAA;EvEyjSV;EuEhkSM;IAOI,iCAAA;EvE4jSV;EuEnkSM;IAOI,gCAAA;EvE+jSV;EuEtkSM;IAOI,iCAAA;EvEkkSV;EuEzkSM;IAOI,gCAAA;EvEqkSV;EuE5kSM;IAOI,mCAAA;EvEwkSV;EuE/kSM;IAOI,kCAAA;EvE2kSV;EuEllSM;IAOI,iCAAA;EvE8kSV;EuErlSM;IAOI,kCAAA;EvEilSV;EuExlSM;IAOI,iCAAA;EvEolSV;EuE3lSM;IAOI,iCAAA;EvEulSV;EuE9lSM;IAOI,gCAAA;EvE0lSV;EuEjmSM;IAOI,+BAAA;EvE6lSV;EuEpmSM;IAOI,gCAAA;EvEgmSV;EuEvmSM;IAOI,+BAAA;EvEmmSV;EuE1mSM;IAOI,qBAAA;EvEsmSV;EuE7mSM;IAOI,4BAAA;EvEymSV;EuEhnSM;IAOI,2BAAA;EvE4mSV;EuEnnSM;IAOI,0BAAA;EvE+mSV;EuEtnSM;IAOI,2BAAA;EvEknSV;EuEznSM;IAOI,0BAAA;EvEqnSV;EuE5nSM;IAOI,2BAAA;IAAA,0BAAA;EvEynSV;EuEhoSM;IAOI,kCAAA;IAAA,iCAAA;EvE6nSV;EuEpoSM;IAOI,iCAAA;IAAA,gCAAA;EvEioSV;EuExoSM;IAOI,gCAAA;IAAA,+BAAA;EvEqoSV;EuE5oSM;IAOI,iCAAA;IAAA,gCAAA;EvEyoSV;EuEhpSM;IAOI,gCAAA;IAAA,+BAAA;EvE6oSV;EuEppSM;IAOI,yBAAA;IAAA,4BAAA;EvEipSV;EuExpSM;IAOI,gCAAA;IAAA,mCAAA;EvEqpSV;EuE5pSM;IAOI,+BAAA;IAAA,kCAAA;EvEypSV;EuEhqSM;IAOI,8BAAA;IAAA,iCAAA;EvE6pSV;EuEpqSM;IAOI,+BAAA;IAAA,kCAAA;EvEiqSV;EuExqSM;IAOI,8BAAA;IAAA,iCAAA;EvEqqSV;EuE5qSM;IAOI,yBAAA;EvEwqSV;EuE/qSM;IAOI,gCAAA;EvE2qSV;EuElrSM;IAOI,+BAAA;EvE8qSV;EuErrSM;IAOI,8BAAA;EvEirSV;EuExrSM;IAOI,+BAAA;EvEorSV;EuE3rSM;IAOI,8BAAA;EvEurSV;EuE9rSM;IAOI,2BAAA;EvE0rSV;EuEjsSM;IAOI,kCAAA;EvE6rSV;EuEpsSM;IAOI,iCAAA;EvEgsSV;EuEvsSM;IAOI,gCAAA;EvEmsSV;EuE1sSM;IAOI,iCAAA;EvEssSV;EuE7sSM;IAOI,gCAAA;EvEysSV;EuEhtSM;IAOI,4BAAA;EvE4sSV;EuEntSM;IAOI,mCAAA;EvE+sSV;EuEttSM;IAOI,kCAAA;EvEktSV;EuEztSM;IAOI,iCAAA;EvEqtSV;EuE5tSM;IAOI,kCAAA;EvEwtSV;EuE/tSM;IAOI,iCAAA;EvE2tSV;EuEluSM;IAOI,0BAAA;EvE8tSV;EuEruSM;IAOI,iCAAA;EvEiuSV;EuExuSM;IAOI,gCAAA;EvEouSV;EuE3uSM;IAOI,+BAAA;EvEuuSV;EuE9uSM;IAOI,gCAAA;EvE0uSV;EuEjvSM;IAOI,+BAAA;EvE6uSV;EuEpvSM;IAOI,2BAAA;EvEgvSV;EuEvvSM;IAOI,4BAAA;EvEmvSV;EuE1vSM;IAOI,6BAAA;EvEsvSV;AACF;Ac9vSI;EyDAI;IAOI,sBAAA;EvE2vSV;EuElwSM;IAOI,uBAAA;EvE8vSV;EuErwSM;IAOI,sBAAA;EvEiwSV;EuExwSM;IAOI,0BAAA;EvEowSV;EuE3wSM;IAOI,gCAAA;EvEuwSV;EuE9wSM;IAOI,yBAAA;EvE0wSV;EuEjxSM;IAOI,wBAAA;EvE6wSV;EuEpxSM;IAOI,yBAAA;EvEgxSV;EuEvxSM;IAOI,6BAAA;EvEmxSV;EuE1xSM;IAOI,8BAAA;EvEsxSV;EuE7xSM;IAOI,wBAAA;EvEyxSV;EuEhySM;IAOI,+BAAA;EvE4xSV;EuEnySM;IAOI,wBAAA;EvE+xSV;EuEtySM;IAOI,yBAAA;EvEkySV;EuEzySM;IAOI,8BAAA;EvEqySV;EuE5ySM;IAOI,iCAAA;EvEwySV;EuE/ySM;IAOI,sCAAA;EvE2ySV;EuElzSM;IAOI,yCAAA;EvE8ySV;EuErzSM;IAOI,uBAAA;EvEizSV;EuExzSM;IAOI,uBAAA;EvEozSV;EuE3zSM;IAOI,yBAAA;EvEuzSV;EuE9zSM;IAOI,yBAAA;EvE0zSV;EuEj0SM;IAOI,0BAAA;EvE6zSV;EuEp0SM;IAOI,4BAAA;EvEg0SV;EuEv0SM;IAOI,kCAAA;EvEm0SV;EuE10SM;IAOI,iBAAA;EvEs0SV;EuE70SM;IAOI,wBAAA;EvEy0SV;EuEh1SM;IAOI,uBAAA;EvE40SV;EuEn1SM;IAOI,sBAAA;EvE+0SV;EuEt1SM;IAOI,uBAAA;EvEk1SV;EuEz1SM;IAOI,sBAAA;EvEq1SV;EuE51SM;IAOI,sCAAA;EvEw1SV;EuE/1SM;IAOI,oCAAA;EvE21SV;EuEl2SM;IAOI,kCAAA;EvE81SV;EuEr2SM;IAOI,yCAAA;EvEi2SV;EuEx2SM;IAOI,wCAAA;EvEo2SV;EuE32SM;IAOI,wCAAA;EvEu2SV;EuE92SM;IAOI,kCAAA;EvE02SV;EuEj3SM;IAOI,gCAAA;EvE62SV;EuEp3SM;IAOI,8BAAA;EvEg3SV;EuEv3SM;IAOI,gCAAA;EvEm3SV;EuE13SM;IAOI,+BAAA;EvEs3SV;EuE73SM;IAOI,oCAAA;EvEy3SV;EuEh4SM;IAOI,kCAAA;EvE43SV;EuEn4SM;IAOI,gCAAA;EvE+3SV;EuEt4SM;IAOI,uCAAA;EvEk4SV;EuEz4SM;IAOI,sCAAA;EvEq4SV;EuE54SM;IAOI,iCAAA;EvEw4SV;EuE/4SM;IAOI,2BAAA;EvE24SV;EuEl5SM;IAOI,iCAAA;EvE84SV;EuEr5SM;IAOI,+BAAA;EvEi5SV;EuEx5SM;IAOI,6BAAA;EvEo5SV;EuE35SM;IAOI,+BAAA;EvEu5SV;EuE95SM;IAOI,8BAAA;EvE05SV;EuEj6SM;IAOI,oBAAA;EvE65SV;EuEp6SM;IAOI,mBAAA;EvEg6SV;EuEv6SM;IAOI,mBAAA;EvEm6SV;EuE16SM;IAOI,mBAAA;EvEs6SV;EuE76SM;IAOI,mBAAA;EvEy6SV;EuEh7SM;IAOI,mBAAA;EvE46SV;EuEn7SM;IAOI,mBAAA;EvE+6SV;EuEt7SM;IAOI,mBAAA;EvEk7SV;EuEz7SM;IAOI,oBAAA;EvEq7SV;EuE57SM;IAOI,2BAAA;EvEw7SV;EuE/7SM;IAOI,0BAAA;EvE27SV;EuEl8SM;IAOI,yBAAA;EvE87SV;EuEr8SM;IAOI,0BAAA;EvEi8SV;EuEx8SM;IAOI,yBAAA;EvEo8SV;EuE38SM;IAOI,uBAAA;EvEu8SV;EuE98SM;IAOI,0BAAA;IAAA,yBAAA;EvE28SV;EuEl9SM;IAOI,iCAAA;IAAA,gCAAA;EvE+8SV;EuEt9SM;IAOI,gCAAA;IAAA,+BAAA;EvEm9SV;EuE19SM;IAOI,+BAAA;IAAA,8BAAA;EvEu9SV;EuE99SM;IAOI,gCAAA;IAAA,+BAAA;EvE29SV;EuEl+SM;IAOI,+BAAA;IAAA,8BAAA;EvE+9SV;EuEt+SM;IAOI,6BAAA;IAAA,4BAAA;EvEm+SV;EuE1+SM;IAOI,wBAAA;IAAA,2BAAA;EvEu+SV;EuE9+SM;IAOI,+BAAA;IAAA,kCAAA;EvE2+SV;EuEl/SM;IAOI,8BAAA;IAAA,iCAAA;EvE++SV;EuEt/SM;IAOI,6BAAA;IAAA,gCAAA;EvEm/SV;EuE1/SM;IAOI,8BAAA;IAAA,iCAAA;EvEu/SV;EuE9/SM;IAOI,6BAAA;IAAA,gCAAA;EvE2/SV;EuElgTM;IAOI,2BAAA;IAAA,8BAAA;EvE+/SV;EuEtgTM;IAOI,wBAAA;EvEkgTV;EuEzgTM;IAOI,+BAAA;EvEqgTV;EuE5gTM;IAOI,8BAAA;EvEwgTV;EuE/gTM;IAOI,6BAAA;EvE2gTV;EuElhTM;IAOI,8BAAA;EvE8gTV;EuErhTM;IAOI,6BAAA;EvEihTV;EuExhTM;IAOI,2BAAA;EvEohTV;EuE3hTM;IAOI,0BAAA;EvEuhTV;EuE9hTM;IAOI,iCAAA;EvE0hTV;EuEjiTM;IAOI,gCAAA;EvE6hTV;EuEpiTM;IAOI,+BAAA;EvEgiTV;EuEviTM;IAOI,gCAAA;EvEmiTV;EuE1iTM;IAOI,+BAAA;EvEsiTV;EuE7iTM;IAOI,6BAAA;EvEyiTV;EuEhjTM;IAOI,2BAAA;EvE4iTV;EuEnjTM;IAOI,kCAAA;EvE+iTV;EuEtjTM;IAOI,iCAAA;EvEkjTV;EuEzjTM;IAOI,gCAAA;EvEqjTV;EuE5jTM;IAOI,iCAAA;EvEwjTV;EuE/jTM;IAOI,gCAAA;EvE2jTV;EuElkTM;IAOI,8BAAA;EvE8jTV;EuErkTM;IAOI,yBAAA;EvEikTV;EuExkTM;IAOI,gCAAA;EvEokTV;EuE3kTM;IAOI,+BAAA;EvEukTV;EuE9kTM;IAOI,8BAAA;EvE0kTV;EuEjlTM;IAOI,+BAAA;EvE6kTV;EuEplTM;IAOI,8BAAA;EvEglTV;EuEvlTM;IAOI,4BAAA;EvEmlTV;EuE1lTM;IAOI,4BAAA;EvEslTV;EuE7lTM;IAOI,2BAAA;EvEylTV;EuEhmTM;IAOI,0BAAA;EvE4lTV;EuEnmTM;IAOI,2BAAA;EvE+lTV;EuEtmTM;IAOI,0BAAA;EvEkmTV;EuEzmTM;IAOI,kCAAA;IAAA,iCAAA;EvEsmTV;EuE7mTM;IAOI,iCAAA;IAAA,gCAAA;EvE0mTV;EuEjnTM;IAOI,gCAAA;IAAA,+BAAA;EvE8mTV;EuErnTM;IAOI,iCAAA;IAAA,gCAAA;EvEknTV;EuEznTM;IAOI,gCAAA;IAAA,+BAAA;EvEsnTV;EuE7nTM;IAOI,gCAAA;IAAA,mCAAA;EvE0nTV;EuEjoTM;IAOI,+BAAA;IAAA,kCAAA;EvE8nTV;EuEroTM;IAOI,8BAAA;IAAA,iCAAA;EvEkoTV;EuEzoTM;IAOI,+BAAA;IAAA,kCAAA;EvEsoTV;EuE7oTM;IAOI,8BAAA;IAAA,iCAAA;EvE0oTV;EuEjpTM;IAOI,gCAAA;EvE6oTV;EuEppTM;IAOI,+BAAA;EvEgpTV;EuEvpTM;IAOI,8BAAA;EvEmpTV;EuE1pTM;IAOI,+BAAA;EvEspTV;EuE7pTM;IAOI,8BAAA;EvEypTV;EuEhqTM;IAOI,kCAAA;EvE4pTV;EuEnqTM;IAOI,iCAAA;EvE+pTV;EuEtqTM;IAOI,gCAAA;EvEkqTV;EuEzqTM;IAOI,iCAAA;EvEqqTV;EuE5qTM;IAOI,gCAAA;EvEwqTV;EuE/qTM;IAOI,mCAAA;EvE2qTV;EuElrTM;IAOI,kCAAA;EvE8qTV;EuErrTM;IAOI,iCAAA;EvEirTV;EuExrTM;IAOI,kCAAA;EvEorTV;EuE3rTM;IAOI,iCAAA;EvEurTV;EuE9rTM;IAOI,iCAAA;EvE0rTV;EuEjsTM;IAOI,gCAAA;EvE6rTV;EuEpsTM;IAOI,+BAAA;EvEgsTV;EuEvsTM;IAOI,gCAAA;EvEmsTV;EuE1sTM;IAOI,+BAAA;EvEssTV;EuE7sTM;IAOI,qBAAA;EvEysTV;EuEhtTM;IAOI,4BAAA;EvE4sTV;EuEntTM;IAOI,2BAAA;EvE+sTV;EuEttTM;IAOI,0BAAA;EvEktTV;EuEztTM;IAOI,2BAAA;EvEqtTV;EuE5tTM;IAOI,0BAAA;EvEwtTV;EuE/tTM;IAOI,2BAAA;IAAA,0BAAA;EvE4tTV;EuEnuTM;IAOI,kCAAA;IAAA,iCAAA;EvEguTV;EuEvuTM;IAOI,iCAAA;IAAA,gCAAA;EvEouTV;EuE3uTM;IAOI,gCAAA;IAAA,+BAAA;EvEwuTV;EuE/uTM;IAOI,iCAAA;IAAA,gCAAA;EvE4uTV;EuEnvTM;IAOI,gCAAA;IAAA,+BAAA;EvEgvTV;EuEvvTM;IAOI,yBAAA;IAAA,4BAAA;EvEovTV;EuE3vTM;IAOI,gCAAA;IAAA,mCAAA;EvEwvTV;EuE/vTM;IAOI,+BAAA;IAAA,kCAAA;EvE4vTV;EuEnwTM;IAOI,8BAAA;IAAA,iCAAA;EvEgwTV;EuEvwTM;IAOI,+BAAA;IAAA,kCAAA;EvEowTV;EuE3wTM;IAOI,8BAAA;IAAA,iCAAA;EvEwwTV;EuE/wTM;IAOI,yBAAA;EvE2wTV;EuElxTM;IAOI,gCAAA;EvE8wTV;EuErxTM;IAOI,+BAAA;EvEixTV;EuExxTM;IAOI,8BAAA;EvEoxTV;EuE3xTM;IAOI,+BAAA;EvEuxTV;EuE9xTM;IAOI,8BAAA;EvE0xTV;EuEjyTM;IAOI,2BAAA;EvE6xTV;EuEpyTM;IAOI,kCAAA;EvEgyTV;EuEvyTM;IAOI,iCAAA;EvEmyTV;EuE1yTM;IAOI,gCAAA;EvEsyTV;EuE7yTM;IAOI,iCAAA;EvEyyTV;EuEhzTM;IAOI,gCAAA;EvE4yTV;EuEnzTM;IAOI,4BAAA;EvE+yTV;EuEtzTM;IAOI,mCAAA;EvEkzTV;EuEzzTM;IAOI,kCAAA;EvEqzTV;EuE5zTM;IAOI,iCAAA;EvEwzTV;EuE/zTM;IAOI,kCAAA;EvE2zTV;EuEl0TM;IAOI,iCAAA;EvE8zTV;EuEr0TM;IAOI,0BAAA;EvEi0TV;EuEx0TM;IAOI,iCAAA;EvEo0TV;EuE30TM;IAOI,gCAAA;EvEu0TV;EuE90TM;IAOI,+BAAA;EvE00TV;EuEj1TM;IAOI,gCAAA;EvE60TV;EuEp1TM;IAOI,+BAAA;EvEg1TV;EuEv1TM;IAOI,2BAAA;EvEm1TV;EuE11TM;IAOI,4BAAA;EvEs1TV;EuE71TM;IAOI,6BAAA;EvEy1TV;AACF;Acj2TI;EyDAI;IAOI,sBAAA;EvE81TV;EuEr2TM;IAOI,uBAAA;EvEi2TV;EuEx2TM;IAOI,sBAAA;EvEo2TV;EuE32TM;IAOI,0BAAA;EvEu2TV;EuE92TM;IAOI,gCAAA;EvE02TV;EuEj3TM;IAOI,yBAAA;EvE62TV;EuEp3TM;IAOI,wBAAA;EvEg3TV;EuEv3TM;IAOI,yBAAA;EvEm3TV;EuE13TM;IAOI,6BAAA;EvEs3TV;EuE73TM;IAOI,8BAAA;EvEy3TV;EuEh4TM;IAOI,wBAAA;EvE43TV;EuEn4TM;IAOI,+BAAA;EvE+3TV;EuEt4TM;IAOI,wBAAA;EvEk4TV;EuEz4TM;IAOI,yBAAA;EvEq4TV;EuE54TM;IAOI,8BAAA;EvEw4TV;EuE/4TM;IAOI,iCAAA;EvE24TV;EuEl5TM;IAOI,sCAAA;EvE84TV;EuEr5TM;IAOI,yCAAA;EvEi5TV;EuEx5TM;IAOI,uBAAA;EvEo5TV;EuE35TM;IAOI,uBAAA;EvEu5TV;EuE95TM;IAOI,yBAAA;EvE05TV;EuEj6TM;IAOI,yBAAA;EvE65TV;EuEp6TM;IAOI,0BAAA;EvEg6TV;EuEv6TM;IAOI,4BAAA;EvEm6TV;EuE16TM;IAOI,kCAAA;EvEs6TV;EuE76TM;IAOI,iBAAA;EvEy6TV;EuEh7TM;IAOI,wBAAA;EvE46TV;EuEn7TM;IAOI,uBAAA;EvE+6TV;EuEt7TM;IAOI,sBAAA;EvEk7TV;EuEz7TM;IAOI,uBAAA;EvEq7TV;EuE57TM;IAOI,sBAAA;EvEw7TV;EuE/7TM;IAOI,sCAAA;EvE27TV;EuEl8TM;IAOI,oCAAA;EvE87TV;EuEr8TM;IAOI,kCAAA;EvEi8TV;EuEx8TM;IAOI,yCAAA;EvEo8TV;EuE38TM;IAOI,wCAAA;EvEu8TV;EuE98TM;IAOI,wCAAA;EvE08TV;EuEj9TM;IAOI,kCAAA;EvE68TV;EuEp9TM;IAOI,gCAAA;EvEg9TV;EuEv9TM;IAOI,8BAAA;EvEm9TV;EuE19TM;IAOI,gCAAA;EvEs9TV;EuE79TM;IAOI,+BAAA;EvEy9TV;EuEh+TM;IAOI,oCAAA;EvE49TV;EuEn+TM;IAOI,kCAAA;EvE+9TV;EuEt+TM;IAOI,gCAAA;EvEk+TV;EuEz+TM;IAOI,uCAAA;EvEq+TV;EuE5+TM;IAOI,sCAAA;EvEw+TV;EuE/+TM;IAOI,iCAAA;EvE2+TV;EuEl/TM;IAOI,2BAAA;EvE8+TV;EuEr/TM;IAOI,iCAAA;EvEi/TV;EuEx/TM;IAOI,+BAAA;EvEo/TV;EuE3/TM;IAOI,6BAAA;EvEu/TV;EuE9/TM;IAOI,+BAAA;EvE0/TV;EuEjgUM;IAOI,8BAAA;EvE6/TV;EuEpgUM;IAOI,oBAAA;EvEggUV;EuEvgUM;IAOI,mBAAA;EvEmgUV;EuE1gUM;IAOI,mBAAA;EvEsgUV;EuE7gUM;IAOI,mBAAA;EvEygUV;EuEhhUM;IAOI,mBAAA;EvE4gUV;EuEnhUM;IAOI,mBAAA;EvE+gUV;EuEthUM;IAOI,mBAAA;EvEkhUV;EuEzhUM;IAOI,mBAAA;EvEqhUV;EuE5hUM;IAOI,oBAAA;EvEwhUV;EuE/hUM;IAOI,2BAAA;EvE2hUV;EuEliUM;IAOI,0BAAA;EvE8hUV;EuEriUM;IAOI,yBAAA;EvEiiUV;EuExiUM;IAOI,0BAAA;EvEoiUV;EuE3iUM;IAOI,yBAAA;EvEuiUV;EuE9iUM;IAOI,uBAAA;EvE0iUV;EuEjjUM;IAOI,0BAAA;IAAA,yBAAA;EvE8iUV;EuErjUM;IAOI,iCAAA;IAAA,gCAAA;EvEkjUV;EuEzjUM;IAOI,gCAAA;IAAA,+BAAA;EvEsjUV;EuE7jUM;IAOI,+BAAA;IAAA,8BAAA;EvE0jUV;EuEjkUM;IAOI,gCAAA;IAAA,+BAAA;EvE8jUV;EuErkUM;IAOI,+BAAA;IAAA,8BAAA;EvEkkUV;EuEzkUM;IAOI,6BAAA;IAAA,4BAAA;EvEskUV;EuE7kUM;IAOI,wBAAA;IAAA,2BAAA;EvE0kUV;EuEjlUM;IAOI,+BAAA;IAAA,kCAAA;EvE8kUV;EuErlUM;IAOI,8BAAA;IAAA,iCAAA;EvEklUV;EuEzlUM;IAOI,6BAAA;IAAA,gCAAA;EvEslUV;EuE7lUM;IAOI,8BAAA;IAAA,iCAAA;EvE0lUV;EuEjmUM;IAOI,6BAAA;IAAA,gCAAA;EvE8lUV;EuErmUM;IAOI,2BAAA;IAAA,8BAAA;EvEkmUV;EuEzmUM;IAOI,wBAAA;EvEqmUV;EuE5mUM;IAOI,+BAAA;EvEwmUV;EuE/mUM;IAOI,8BAAA;EvE2mUV;EuElnUM;IAOI,6BAAA;EvE8mUV;EuErnUM;IAOI,8BAAA;EvEinUV;EuExnUM;IAOI,6BAAA;EvEonUV;EuE3nUM;IAOI,2BAAA;EvEunUV;EuE9nUM;IAOI,0BAAA;EvE0nUV;EuEjoUM;IAOI,iCAAA;EvE6nUV;EuEpoUM;IAOI,gCAAA;EvEgoUV;EuEvoUM;IAOI,+BAAA;EvEmoUV;EuE1oUM;IAOI,gCAAA;EvEsoUV;EuE7oUM;IAOI,+BAAA;EvEyoUV;EuEhpUM;IAOI,6BAAA;EvE4oUV;EuEnpUM;IAOI,2BAAA;EvE+oUV;EuEtpUM;IAOI,kCAAA;EvEkpUV;EuEzpUM;IAOI,iCAAA;EvEqpUV;EuE5pUM;IAOI,gCAAA;EvEwpUV;EuE/pUM;IAOI,iCAAA;EvE2pUV;EuElqUM;IAOI,gCAAA;EvE8pUV;EuErqUM;IAOI,8BAAA;EvEiqUV;EuExqUM;IAOI,yBAAA;EvEoqUV;EuE3qUM;IAOI,gCAAA;EvEuqUV;EuE9qUM;IAOI,+BAAA;EvE0qUV;EuEjrUM;IAOI,8BAAA;EvE6qUV;EuEprUM;IAOI,+BAAA;EvEgrUV;EuEvrUM;IAOI,8BAAA;EvEmrUV;EuE1rUM;IAOI,4BAAA;EvEsrUV;EuE7rUM;IAOI,4BAAA;EvEyrUV;EuEhsUM;IAOI,2BAAA;EvE4rUV;EuEnsUM;IAOI,0BAAA;EvE+rUV;EuEtsUM;IAOI,2BAAA;EvEksUV;EuEzsUM;IAOI,0BAAA;EvEqsUV;EuE5sUM;IAOI,kCAAA;IAAA,iCAAA;EvEysUV;EuEhtUM;IAOI,iCAAA;IAAA,gCAAA;EvE6sUV;EuEptUM;IAOI,gCAAA;IAAA,+BAAA;EvEitUV;EuExtUM;IAOI,iCAAA;IAAA,gCAAA;EvEqtUV;EuE5tUM;IAOI,gCAAA;IAAA,+BAAA;EvEytUV;EuEhuUM;IAOI,gCAAA;IAAA,mCAAA;EvE6tUV;EuEpuUM;IAOI,+BAAA;IAAA,kCAAA;EvEiuUV;EuExuUM;IAOI,8BAAA;IAAA,iCAAA;EvEquUV;EuE5uUM;IAOI,+BAAA;IAAA,kCAAA;EvEyuUV;EuEhvUM;IAOI,8BAAA;IAAA,iCAAA;EvE6uUV;EuEpvUM;IAOI,gCAAA;EvEgvUV;EuEvvUM;IAOI,+BAAA;EvEmvUV;EuE1vUM;IAOI,8BAAA;EvEsvUV;EuE7vUM;IAOI,+BAAA;EvEyvUV;EuEhwUM;IAOI,8BAAA;EvE4vUV;EuEnwUM;IAOI,kCAAA;EvE+vUV;EuEtwUM;IAOI,iCAAA;EvEkwUV;EuEzwUM;IAOI,gCAAA;EvEqwUV;EuE5wUM;IAOI,iCAAA;EvEwwUV;EuE/wUM;IAOI,gCAAA;EvE2wUV;EuElxUM;IAOI,mCAAA;EvE8wUV;EuErxUM;IAOI,kCAAA;EvEixUV;EuExxUM;IAOI,iCAAA;EvEoxUV;EuE3xUM;IAOI,kCAAA;EvEuxUV;EuE9xUM;IAOI,iCAAA;EvE0xUV;EuEjyUM;IAOI,iCAAA;EvE6xUV;EuEpyUM;IAOI,gCAAA;EvEgyUV;EuEvyUM;IAOI,+BAAA;EvEmyUV;EuE1yUM;IAOI,gCAAA;EvEsyUV;EuE7yUM;IAOI,+BAAA;EvEyyUV;EuEhzUM;IAOI,qBAAA;EvE4yUV;EuEnzUM;IAOI,4BAAA;EvE+yUV;EuEtzUM;IAOI,2BAAA;EvEkzUV;EuEzzUM;IAOI,0BAAA;EvEqzUV;EuE5zUM;IAOI,2BAAA;EvEwzUV;EuE/zUM;IAOI,0BAAA;EvE2zUV;EuEl0UM;IAOI,2BAAA;IAAA,0BAAA;EvE+zUV;EuEt0UM;IAOI,kCAAA;IAAA,iCAAA;EvEm0UV;EuE10UM;IAOI,iCAAA;IAAA,gCAAA;EvEu0UV;EuE90UM;IAOI,gCAAA;IAAA,+BAAA;EvE20UV;EuEl1UM;IAOI,iCAAA;IAAA,gCAAA;EvE+0UV;EuEt1UM;IAOI,gCAAA;IAAA,+BAAA;EvEm1UV;EuE11UM;IAOI,yBAAA;IAAA,4BAAA;EvEu1UV;EuE91UM;IAOI,gCAAA;IAAA,mCAAA;EvE21UV;EuEl2UM;IAOI,+BAAA;IAAA,kCAAA;EvE+1UV;EuEt2UM;IAOI,8BAAA;IAAA,iCAAA;EvEm2UV;EuE12UM;IAOI,+BAAA;IAAA,kCAAA;EvEu2UV;EuE92UM;IAOI,8BAAA;IAAA,iCAAA;EvE22UV;EuEl3UM;IAOI,yBAAA;EvE82UV;EuEr3UM;IAOI,gCAAA;EvEi3UV;EuEx3UM;IAOI,+BAAA;EvEo3UV;EuE33UM;IAOI,8BAAA;EvEu3UV;EuE93UM;IAOI,+BAAA;EvE03UV;EuEj4UM;IAOI,8BAAA;EvE63UV;EuEp4UM;IAOI,2BAAA;EvEg4UV;EuEv4UM;IAOI,kCAAA;EvEm4UV;EuE14UM;IAOI,iCAAA;EvEs4UV;EuE74UM;IAOI,gCAAA;EvEy4UV;EuEh5UM;IAOI,iCAAA;EvE44UV;EuEn5UM;IAOI,gCAAA;EvE+4UV;EuEt5UM;IAOI,4BAAA;EvEk5UV;EuEz5UM;IAOI,mCAAA;EvEq5UV;EuE55UM;IAOI,kCAAA;EvEw5UV;EuE/5UM;IAOI,iCAAA;EvE25UV;EuEl6UM;IAOI,kCAAA;EvE85UV;EuEr6UM;IAOI,iCAAA;EvEi6UV;EuEx6UM;IAOI,0BAAA;EvEo6UV;EuE36UM;IAOI,iCAAA;EvEu6UV;EuE96UM;IAOI,gCAAA;EvE06UV;EuEj7UM;IAOI,+BAAA;EvE66UV;EuEp7UM;IAOI,gCAAA;EvEg7UV;EuEv7UM;IAOI,+BAAA;EvEm7UV;EuE17UM;IAOI,2BAAA;EvEs7UV;EuE77UM;IAOI,4BAAA;EvEy7UV;EuEh8UM;IAOI,6BAAA;EvE47UV;AACF;AwEh/UA;ED4CQ;IAOI,6BAAA;EvEi8UV;EuEx8UM;IAOI,8BAAA;EvEo8UV;EuE38UM;IAOI,4BAAA;EvEu8UV;AACF;AwEx+UA;EDyBQ;IAOI,0BAAA;EvE48UV;EuEn9UM;IAOI,gCAAA;EvE+8UV;EuEt9UM;IAOI,yBAAA;EvEk9UV;EuEz9UM;IAOI,wBAAA;EvEq9UV;EuE59UM;IAOI,yBAAA;EvEw9UV;EuE/9UM;IAOI,6BAAA;EvE29UV;EuEl+UM;IAOI,8BAAA;EvE89UV;EuEr+UM;IAOI,wBAAA;EvEi+UV;EuEx+UM;IAOI,+BAAA;EvEo+UV;EuE3+UM;IAOI,wBAAA;EvEu+UV;AACF;AyExiVQ;EACI,kBAAA;AzE0iVZ;AyExiVQ;EACI,6BAAA;AzE0iVZ;AyEtiVI;EACI,iBAAA;EACA,gBAAA;AzEwiVR;AyEliVgB;EACI,gBAAA;AzEoiVpB;;AyE1hVI;EACI,iBAAA;EACA,oCAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AzE6hVR;AyE3hVQ;EACI,6BAAA;AzE6hVZ;AyE3hVY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,8DnE+yCoB;AN8uSpC;AyEzhVQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,sBnE+DD;EmE9DC,kBAAA;EACA,iBAAA;AzE2hVZ;;A0EhkVI;EAlBA,cpE4LW;EoE3LX,0CAAA;EACA,gBAAA;A1EslVJ;;A0EtkVI;EAlBA,cpE4LW;EoE3LX,2CAAA;EACA,gBAAA;A1E4lVJ;;A0E5kVI;EAlBA,cpE4LW;EoE3LX,0CAAA;EACA,gBAAA;A1EkmVJ;;A0EllVI;EAlBA,cpE4LW;EoE3LX,0CAAA;EACA,gBAAA;A1EwmVJ;;A0ExlVI;EAlBA,cpE4LW;EoE3LX,0CAAA;EACA,gBAAA;A1E8mVJ;;A0E9lVI;EAlBA,cpE4LW;EoE3LX,0CAAA;EACA,gBAAA;A1EonVJ;;A0EpmVI;EAlBA,cpE4LW;EoE3LX,2CAAA;EACA,gBAAA;A1E0nVJ;;A0E1mVI;EAlBA,cpE4LW;EoE3LX,wCAAA;EACA,gBAAA;A1EgoVJ;;A0EvmVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1E8nVJ;;A0E9mVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1EqoVJ;;A0ErnVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1E4oVJ;;A0E5nVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1EmpVJ;;A0EnoVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1E0pVJ;;A0E1oVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1EiqVJ;;A0EjpVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1EwqVJ;;A0ExpVI;EAnBA,cpEoLW;EoEnLX,yBAAA;EACA,6BAAA;EACA,gBAAA;A1E+qVJ;;A2EzrVI;EACI,qDAAA;A3E4rVR;;A2E7rVI;EACI,sDAAA;A3EgsVR;;A2EjsVI;EACI,qDAAA;A3EosVR;;A2ErsVI;EACI,qDAAA;A3EwsVR;;A2EzsVI;EACI,qDAAA;A3E4sVR;;A2E7sVI;EACI,qDAAA;A3EgtVR;;A2EjtVI;EACI,sDAAA;A3EotVR;;A2ErtVI;EACI,mDAAA;A3EwtVR;;A2EptVA;EACI,YAAA;A3EutVJ;;A4E5tVI;EACI,ctEwHG;ANumVX;A4E5tVQ;EACI,sBAAA;A5E8tVZ;;A6EvuVA;EACI,WvEqHO;ANqnVX;A6EvuVI;EACI,gBAAA;A7EyuVR;A6EruVQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;A7EuuVZ;;A6E/tVA;EACI,cvEyGO;ANynVX;;A6E/tVA;EACI,qBvE+FO;ANmoVX;A6EhuVI;EAEI,yBvE2FG;EuE1FH,qBvE2FG;ANsoVX;;A6E1tVA;EACI,gBvEupB0B;EuEtpB1B,cvE4GM;EuE3GN,6BAAA;A7E6tVJ;A6E5tVI;EACI,yDvEkgBkC;EuEjgBlC,qBvEkgBkC;EuEjgBlC,6BAAA;EACA,yBAAA;A7E8tVR;A6E5tVI;EACI,qBvE6fkC;EuE5flC,yBAAA;EACA,gBAAA;A7E8tVR;A6E5tVI;EACI,cvEsEG;EuErEH,oBAAA;A7E8tVR;;A6ErtVA;EACI,sBAAA;EACA,kBAAA;EACA,sBAAA;A7EwtVJ;;A6EnsVI;EAhBA,0CAAA;EACA,cvEqHW;EuEpHX,sCAAA;A7EutVJ;A6ErtVI;EACI,gBAAA;A7EutVR;A6EptVI;EAEI,yCAAA;EACA,cvE2GO;AN0mVf;;A6EhtVI;EAhBA,2CAAA;EACA,cvEqHW;EuEpHX,uCAAA;A7EouVJ;A6EluVI;EACI,gBAAA;A7EouVR;A6EjuVI;EAEI,0CAAA;EACA,cvE2GO;ANunVf;;A6E7tVI;EAhBA,0CAAA;EACA,cvEqHW;EuEpHX,sCAAA;A7EivVJ;A6E/uVI;EACI,gBAAA;A7EivVR;A6E9uVI;EAEI,yCAAA;EACA,cvE2GO;ANooVf;;A6E1uVI;EAhBA,0CAAA;EACA,cvEqHW;EuEpHX,sCAAA;A7E8vVJ;A6E5vVI;EACI,gBAAA;A7E8vVR;A6E3vVI;EAEI,yCAAA;EACA,cvE2GO;ANipVf;;A6EvvVI;EAhBA,0CAAA;EACA,cvEqHW;EuEpHX,sCAAA;A7E2wVJ;A6EzwVI;EACI,gBAAA;A7E2wVR;A6ExwVI;EAEI,yCAAA;EACA,cvE2GO;AN8pVf;;A6EpwVI;EAhBA,0CAAA;EACA,cvEqHW;EuEpHX,sCAAA;A7EwxVJ;A6EtxVI;EACI,gBAAA;A7EwxVR;A6ErxVI;EAEI,yCAAA;EACA,cvE2GO;AN2qVf;;A6EjxVI;EAhBA,2CAAA;EACA,cvEqHW;EuEpHX,uCAAA;A7EqyVJ;A6EnyVI;EACI,gBAAA;A7EqyVR;A6ElyVI;EAEI,0CAAA;EACA,cvE2GO;ANwrVf;;A6E9xVI;EAhBA,wCAAA;EACA,cvEqHW;EuEpHX,oCAAA;A7EkzVJ;A6EhzVI;EACI,gBAAA;A7EkzVR;A6E/yVI;EAEI,uCAAA;EACA,cvE2GO;ANqsVf;;A6EjyVI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;AN0sVf;A+BrzVE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;AN+sVf;A+BpzVE;EAEE,2CAAA;A/BqzVJ;A+BlzVE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANutVf;A+B9yVI;EAKI,2CAAA;A/B4yVR;A+BvyVE;EAEE,czB2EW;EyB1EX,6BAAA;A/BwyVJ;A6ExzVQ;EACI,gBAAA;A7E0zVZ;;A6E7zVI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;ANsuVf;A+Bj1VE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;AN2uVf;A+Bh1VE;EAEE,4CAAA;A/Bi1VJ;A+B90VE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANmvVf;A+B10VI;EAKI,4CAAA;A/Bw0VR;A+Bn0VE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bo0VJ;A6Ep1VQ;EACI,gBAAA;A7Es1VZ;;A6Ez1VI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;ANkwVf;A+B72VE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANuwVf;A+B52VE;EAEE,2CAAA;A/B62VJ;A+B12VE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;AN+wVf;A+Bt2VI;EAKI,2CAAA;A/Bo2VR;A+B/1VE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bg2VJ;A6Eh3VQ;EACI,gBAAA;A7Ek3VZ;;A6Er3VI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;AN8xVf;A+Bz4VE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANmyVf;A+Bx4VE;EAEE,2CAAA;A/By4VJ;A+Bt4VE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;AN2yVf;A+Bl4VI;EAKI,2CAAA;A/Bg4VR;A+B33VE;EAEE,czB2EW;EyB1EX,6BAAA;A/B43VJ;A6E54VQ;EACI,gBAAA;A7E84VZ;;A6Ej5VI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;AN0zVf;A+Br6VE;EACE,cATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;AN+zVf;A+Bp6VE;EAEE,2CAAA;A/Bq6VJ;A+Bl6VE;EAKE,cArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANu0Vf;A+B95VI;EAKI,2CAAA;A/B45VR;A+Bv5VE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bw5VJ;A6Ex6VQ;EACI,gBAAA;A7E06VZ;;A6E76VI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;ANs1Vf;A+Bj8VE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;AN21Vf;A+Bh8VE;EAEE,2CAAA;A/Bi8VJ;A+B97VE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;ANm2Vf;A+B17VI;EAKI,2CAAA;A/Bw7VR;A+Bn7VE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bo7VJ;A6Ep8VQ;EACI,gBAAA;A7Es8VZ;;A6Ez8VI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;ANk3Vf;A+B79VE;EACE,cATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANu3Vf;A+B59VE;EAEE,4CAAA;A/B69VJ;A+B19VE;EAKE,cArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;AN+3Vf;A+Bt9VI;EAKI,4CAAA;A/Bo9VR;A+B/8VE;EAEE,czB2EW;EyB1EX,6BAAA;A/Bg9VJ;A6Eh+VQ;EACI,gBAAA;A7Ek+VZ;;A6Er+VI;E9ClBF,czB8Ga;EyB7Gb,qBzB6Ga;AN84Vf;A+Bz/VE;EACE,WATY;EAUZ,yBzByGW;EyBxGX,qBzBwGW;ANm5Vf;A+Bx/VE;EAEE,yCAAA;A/By/VJ;A+Bt/VE;EAKE,WArBa;EAsBb,yBzB0FW;EyBzFX,qBzByFW;AN25Vf;A+Bl/VI;EAKI,yCAAA;A/Bg/VR;A+B3+VE;EAEE,czB2EW;EyB1EX,6BAAA;A/B4+VJ;A6E5/VQ;EACI,gBAAA;A7E8/VZ;;A8EnmWA;EACI,mBxEmmB0B;ANmgV9B;;A8EnmWA;EACI,aAAA;EACA,oBxE+0CgC;EwE90ChC,aAAA;EACA,eAAA;A9EsmWJ;;A8EnmWA;EACI,eAAA;EACA,cAAA;EACA,cAAA;A9EsmWJ;;A8EnmWA;EACI,YAAA;EACA,YAAA;A9EsmWJ;A8ErmWI;EACI,cAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;A9EumWR;A8EnmWgB;EACI,iBAAA;A9EqmWpB;;A8E5lWA;;EAEI,aAAA;A9E+lWJ;;A8E1lWA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,sBxEsyCgC;EwEryChC,oCxE2CgD;EwE1ChD,gBAAA;A9E6lWJ;A8E3lWI;EACI,yBxEsC0C;EwErC1C,8CAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;A9E6lWR;;A8EzlWA;EACI;IACI,yDAAA;E9E4lWN;E8E1lWE;IACI,8DAAA;E9E4lWN;E8E1lWE;IACI,iEAAA;E9E4lWN;AACF;A8ExlWA;EACI,sBxEmCO;EwElCP,gBxEiwCgC;EwEhwChC,qDxEmjB0B;EwEljB1B,mBxE8gB0B;ECrlB1B,sBAAA;APkqWJ;;A8EvlWA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;A9E0lWJ;;A8EvlWA;EACI,mBAAA;EACA,mBxEigB0B;EwEhgB1B,cxEwBO;ANkkWX;;A+E9rWA;EACI,6CzEsoB0B;EyEroB1B,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBzEmrB0B;EyElrB1B,SAAA;A/EisWJ;A+E/rWI;EACI,oBAAA;A/EisWR;A+E9rWI;EACI,qBAAA;A/EgsWR;;A+E5rWA;EACI,mBAAA;EACA,qBAAA;A/E+rWJ;;A+E5rWA;;;EAGI,oBAAA;EACA,0BAAA;A/E+rWJ;;A+E5rWA;EACI;IAEI,wBAAA;E/E+rWN;E+E7rWE;IAEI,4BAAA;E/E+rWN;AACF;A+EzrWA;EACI;IACI,YzE6B4C;EN8pWlD;AACF;A+EvrWA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EACA,czEmEO;ANsnWX;A+EvrWI;EACI,YAAA;A/EyrWR;A+EtrWI;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A/EwrWR;A+ErrWI;EACI,yBzE+CG;ANwoWX;;AcpsWI;EiEmBA;IACI,YAAA;E/EqrWN;E+ElrWE;IACI,YAAA;E/EorWN;AACF;AgFvwWI;EACI,0DAAA;AhFywWR;;AgFpwWA;EACI,oCAAA;EACA,gCAAA;AhFuwWJ;;AgFlwWA;;EAEI,gBAAA;AhFqwWJ;;AgF9vWI;;EACI,2BAAA;AhFkwWR;;AgF5vWI;EACI,qB1E0FG;E0EzFH,kCAAA;AhF+vWR;AgF7vWI;EACI,yB1EoFG;E0EnFH,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kCAAA;AhF+vWR;;AgFxvWI;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;AhF2vWR;AgFxvWI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,uC1Eu6BgC;E0Et6BhC,UAAA;EACA,SAAA;EACA,c1EiEG;ANyrWX;;AgFpvWI;EACI,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AhFuvWR;;AgFjvWQ;EACI,gBAAA;AhFovWZ;;AiFn0WA;EACI,aAAA;AjFs0WJ;;AiFl0WA;EACI,UAAA;EACA,eAAA;AjFq0WJ;;AiFj0WA;EACI,cAAA;AjFo0WJ;;AiFh0WA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,sB3E6FO;E2E5FP,qBAAA;EACA,uCAAA;AjFm0WJ;AiFj0WI;EACI,eAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AjFm0WR;;AiF7zWQ;EACI,qCAAA;AjFg0WZ;;AiF1zWA;EACI,aAAA;EACA,wBAAA;EAEA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;AjF6zWJ;;AiFzzWA;EACI,W3E4DO;E2E3DP,gBAAA;AjF4zWJ;AiF1zWI;EACI,sBAAA;AjF4zWR;;AkFv3WA;EACI,iDAAA;AlF03WJ;AkFx3WI;EACI,mBAAA;AlF03WR;AkFv3WI;EACI,eAAA;EACA,aAAA;AlFy3WR;AkFr3WQ;EACI,oCAAA;EACA,yBAAA;AlFu3WZ;AkFr3WQ;EACI,2CAAA;AlFu3WZ;;AkF/2WQ;EACI,c5E+FD;E4E9FC,gB5EgqBkB;ANktV9B;;AkF72WA;EACI,mB5E4dwB;E4E3dxB,sB5E0lB0B;E4EzlB1B,gBAAA;AlFg3WJ;AkF92WI;EACI,6BAAA;EACA,c5EkFG;E4EjFH,aAAA;AlFg3WR;AkF72WI;;EAEI,c5E4EG;E4E3EH,sB5EoEG;E4EnEH,qD5EqlBsB;AN0xV9B;;AkFv2WQ;EACI,yB5E6DD;AN6yWX;;AkFr2WA;EACI,mBAAA;AlFw2WJ;;AkFr2WA;EACI;IACI,kCAAA;ElFw2WN;AACF;AmF76WI;EACI,8BAAA;EACA,aAAA;EACA,YAAA;AnF+6WR;;AoFr7WA;EACI,aAAA;ApFw7WJ;;AqFt7WA;EACI,WAAA;ArFy7WJ;;AqFp7WA;EACI,WAAA;ArFu7WJ;;AqFl7WA;EACI,YAAA;ArFq7WJ;;AqFj7WA;EACI,YAAA;ArFo7WJ;;AqFh7WA,yBAAA;AACA;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;ArFm7WJ;AqFj7WI;EACI,WAAA;ArFm7WR;AqFh7WI;EACI,WAAA;ArFk7WR;AqF/6WI;EACI,WAAA;ArFi7WR;AqF96WI;EACI,UAAA;ArFg7WR;AqF76WI;EACI,UAAA;ArF+6WR;;AqF36WA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;ArF86WJ;AqF56WI;EACI,WAAA;EACA,SAAA;EACA,kBAAA;ArF86WR;AqF36WI;EACI,WAAA;ArF66WR;AqF16WI;EACI,WAAA;ArF46WR;AqFz6WI;EACI,UAAA;ArF26WR;AqFx6WI;EACI,UAAA;ArF06WR;;AsF//WA;EACI,6BAAA;EACA,4BAAA;AtFkgXJ;AsFjgXI;EACI,kBAAA;EACA,UAAA;AtFmgXR;;AsF9/WA;EACI,gBhFqrB0B;AN40V9B;;AsF7/WA;EACI,aAAA;AtFggXJ;;AsF5/WA;EACI,kBAAA;AtF+/WJ;;AsF3/WI;EACI,aAAA;AtF8/WR;;AuFvhXA;EACI,gBjF8rB0B;AN41V9B;;AuFrhXI;EACI,iCAAA;AvFwhXR;;AuFhhXI;EACI,mBAAA;AvFmhXR;;AuF5gXQ;EACI,YAAA;EACA,WAAA;AvF+gXZ;;AuF1gXA;EACI,cjF6FO;EiF5FP,iBAAA;EACA,qBAAA;EACA,cAAA;AvF6gXJ;AuF3gXI;EACI,cjFwFG;ANq7WX;;AwFljXA;;;;;;;;;;;;EAYI,cAAA;EACA,0DlFsDgD;EkFrDhD,clF6E8C;ANw+WlD;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwFhjXA;EACI,0BAAA;AxFmjXJ;;AwF9iXA;EACI,gBAAA;AxFijXJ;;AwF9iXA;EACI,gBlFHgD;ANojXpD;;AwF7iXA;EACI,4CAAA;EACA,mBAAA;AxFgjXJ;;AyFpoXA;;;;;;;CAAA;AAQA;EAAyC,wBAAA;AzFwoXzC;;A0F5oXA;EACE,kBAAA;EACA,gBAAA;A1F+oXF;;A0F5oXA;EACE,kBAAA;A1F+oXF;;A2FppXA;EACI,YAAA;EACA,gBAAA;EACA,WAAA;A3FupXJ;;A2FnpXA;EACI,kBrFFgD;EqFGhD,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBrF4CgD;AN0mXpD;;A2FlpXA;EACI,YrFXgD;EqFYhD,qFAAA;EACA,0CAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,SrFgCgD;EqF/BhD,0CAAA;EACA,aAAA;A3FqpXJ;A2FnpXI;EACI,qCAAA;A3FqpXR;;A2FjpXA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;A3FopXJ;;A2FhpXA;EACI,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;A3FmpXJ;A2FjpXI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;A3FmpXR;A2FhpXI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;A3FkpXR;A2F/oXI;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;A3FipXR;A2F9oXI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;A3FgpXR;A2F7oXI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;A3F+oXR;;A2F1oXA;EACI,2BAAA;A3F6oXJ;;A2F1oXA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,yCAAA;EACA,qBAAA;EACA,iBAAA;A3F6oXJ;A2F3oXI;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,cAAA;A3F6oXR;A2F1oXI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;A3F4oXR;;A2FvoXA;EACI,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;A3F0oXJ;A2FxoXI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;A3F0oXR;A2FxoXQ;EACI,WAAA;EACA,YAAA;A3F0oXZ;A2FtoXI;EACI,gBAAA;EACA,SAAA;EACA,YAAA;A3FwoXR;A2FroXI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;A3FuoXR;A2FpoXI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A3FsoXR;;A2FhoXI;EACI,gBAAA;EACA,yBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;A3FmoXR;A2FjoXQ;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kCAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;A3FmoXZ;A2FjoXY;;EAEI,wBAAA;EACA,8BAAA;EACA,oBAAA;EACA,4BAAA;EACA,8BAAA;EACA,yBAAA;EACA,4BAAA;EACA,2BAAA;EACA,gCAAA;EACA,4DAAA;EACA,6BAAA;EACA,kCAAA;EACA,uBAAA;A3FmoXhB;A2FjoXgB;;EACI,gDAAA;EACA,yBAAA;A3FooXpB;A2FloXoB;;EACI,+CAAA;EACA,kDAAA;EACA,yBAAA;A3FqoXxB;A2F/nXY;;EAGI,wEAAA;EACA,yBAAA;EACA,2BAAA;EACA,6DAAA;A3FgoXhB;A2F9nXgB;;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;A3FioXpB;A2F9nXgB;;EACI,gDAAA;EACA,kDAAA;EACA,yBAAA;A3FioXpB;A2F/nXoB;;EACI,yBAAA;EACA,0BAAA;A3FkoXxB;A2F7nXY;EACI,kBAAA;EACA,gBAAA;A3F+nXhB;A2F1nXI;EACI,eAAA;A3F4nXR;A2FznXI;EACI,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;A3F2nXR;;A2FvnXA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,qCAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;A3F0nXJ;A2FxnXI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;A3F0nXR;;A2FtnXA;EACI,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;A3FynXJ;;A2FtnXA;EACI,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;A3FynXJ;A2FtnXQ;EACI,4BAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,6BAAA;A3FwnXZ;A2FtnXY;EAEI,yBAAA;EACA,gDAAA;A3FunXhB;A2FjnXY;EACI,yBAAA;EACA,8CAAA;EACA,2BAAA;A3FmnXhB;;A2F7mXA;EACI,2BAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,0BAAA;A3FgnXJ;A2F9mXI;EACI,gBAAA;A3FgnXR;;A2F3mXI;EACI,gBAAA;A3F8mXR;;A2FxmXQ;EACI,wBAAA;A3F2mXZ;A2FtmXY;EACI,wBAAA;A3FwmXhB;;A2F/lXI;EACI,sBAAA;EACA,kBAAA;A3FkmXR;Acp5XI;E6EgTA;IAIQ,0BAAA;E3FomXV;AACF;A2FhmXQ;EACI,aAAA;A3FkmXZ;A2F/lXQ;EACI,cAAA;A3FimXZ;A2F5lXI;EACI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;A3F8lXR;A2F5lXQ;;EAEI,4BAAA;A3F8lXZ;A2F3lXQ;EACI,wBAAA;A3F6lXZ;A2F1lXQ;EACI,oBAAA;A3F4lXZ;A2FtlXY;;;;;EAKI,wBAAA;A3FwlXhB;A2FrlXY;EACI,0BAAA;A3FulXhB;A2FnlXgB;EACI,kBAAA;EACA,mBAAA;A3FqlXpB;A2FnlXoB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;A3FqlXxB;A2FnlXwB;EAGI,crFzZsB;AN4+XlD;A2FhlXwB;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;A3FklX5B;A2F/kXwB;EACI,WAAA;EACA,YAAA;EACA,gBAAA;A3FilX5B;A2F9kXwB;EACI,aAAA;EACA,kBAAA;A3FglX5B;A2F3kXwB;EACI,kBAAA;EACA,yBAAA;EACA,crFjbsB;EqFkbtB,yBrF7VjB;AN06XX;A2F1kX4B;EACI,eAAA;A3F4kXhC;A2FtkX4B;;EACI,aAAA;A3FykXhC;A2FrkXwB;;EAEI,yBAAA;EACA,uBAAA;EACA,2BAAA;A3FukX5B;A2FrkX4B;;EACI,yBAAA;EACA,UrFneoB;EqFoepB,kBAAA;EACA,YAAA;EACA,mDrF3boB;ANmgYpD;A2FtkXgC;;EACI,mDrF9bgB;ANugYpD;A2FtkXgC;;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;A3FykXpC;A2FvkXoC;;EACI,crF3dU;ANqiYlD;A2FlkXgB;EACI,yBAAA;EACA,uBAAA;EACA,2BAAA;A3FokXpB;A2FjkXgB;EACI,cAAA;EACA,aAAA;EACA,aAAA;EACA,yBrF3gB8B;AN8kYlD;A2F9jX4B;;EAEI,yBAAA;EACA,uBAAA;EACA,2BAAA;A3FgkXhC;A2F9jXgC;;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;A3FikXpC;A2F3jX4B;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;A3F6jXhC;A2FvjXwB;EACI,crF7gBsB;ANskYlD;A2FhjXI;EACI,4BAAA;A3FkjXR;AchjYI;E6EogBI;IACI,qBAAA;E3F+iXV;AACF;A2F3iXI;EACI,wBAAA;A3F6iXR;;AcxjYI;E6EkhBI;IACI,kBrF/gBwC;ENyjYlD;E2FxiXM;IACI,2BAAA;E3F0iXV;AACF;AcpjYI;E6E+gBA;IACI,aAAA;E3FwiXN;AACF;AczjYI;E6EqhBA;IACI,kBAAA;IACA,oBAAA;E3FuiXN;E2FpiXE;IACI,aAAA;IACA,sBAAA;E3FsiXN;E2FliXM;IACI,cAAA;E3FoiXV;E2FhiXE;;IAEI,yBAAA;IACA,eAAA;E3FkiXN;E2F9hXE;IACI,kBAAA;E3FgiXN;AACF;A2F7hXA;;eAAA;AAKI;EACI,uBAAA;A3F6hXR;A2F1hXI;EACI,uBAAA;EACA,kBAAA;A3F4hXR;A2FrhXwB;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;A3FuhX5B;A2FphXwB;EACI,cAAA;EACA,uBAAA;A3FshX5B;A2FjhXgB;EACI,eAAA;A3FmhXpB;A2FjhXoB;EACI,kBAAA;A3FmhXxB;A2F7gXQ;;EAEI,wBAAA;A3F+gXZ;A2F5gXQ;EACI,kBrF3pBwC;ANyqYpD;A2F3gXQ;EACI,WrF/pBwC;AN4qYpD;A2F1gXQ;EACI,yBrF3jBD;ANukYX;;A2FpgXI;EACI,oCAAA;EACA,0CAAA;A3FugXR;A2FpgXI;EACI,qFAAA;EACA,sCAAA;EACA,0CAAA;A3FsgXR;A2F7/W4B;EACI,yBrFxsBkB;EqFysBlB,gBAAA;A3F+/WhC;A2Fz/WwB;EACI,crFlrBsB;AN6qYlD;A2Fh/WgB;EACI,2CAAA;A3Fk/WpB;;A2Fz+WA;EACI,aAAA;A3F4+WJ;;A2Fz+WA;EACI,4BAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;A3F4+WJ;A2F1+WI;EACI,kBAAA;A3F4+WR;;A2Fr+WI;EACI,wCAAA;A3Fw+WR;AczqYI;E6EqsBQ;IACI,cAAA;E3Fu+Wd;E2Fn+WM;IACI,cAAA;IACA,cAAA;E3Fq+WV;E2Fl+WM;IACI,gBAAA;IACA,mBAAA;IACA,kBAAA;IACA,yBAAA;E3Fo+WV;E2Fj+WM;IACI,oBAAA;E3Fm+WV;E2Fh+WM;IACI,6BAAA;IACA,sBAAA;E3Fk+WV;AACF;;A2F59WI;EACI,cAAA;A3F+9WR;;A4F7vYA;EACI,cAAA;A5FgwYJ;A4F9vYI;EACI,cAAA;A5FgwYR;A4F7vYI;EACI,aAAA;A5F+vYR;A4F5vYI;EACI,ctFiHG;EsFhHH,gBtFirBsB;EsFhrBtB,eAAA;EACA,yBAAA;A5F8vYR;A4F3vYI;EACI,WtFkGG;EsFjGH,gBtF0qBsB;EsFzqBtB,eAAA;EACA,yBAAA;A5F6vYR;;A4FzvYA,gCAAA;AACA;EACI,YAAA;A5F4vYJ;;A4FzvYE,oCAAA;AACA;EACE;IACE,YAAA,EAAA,0CAAA;E5F4vYJ;AACF;A4FzvYE,yCAAA;AACA;EACE;IACE,YAAA,EAAA,+CAAA;E5F2vYJ;AACF;A4FxvYE;EACE;IACE,YAAA,EAAA,+CAAA;E5F0vYJ;AACF;A4FxvYA;EACI,YtFKgD;EsFJhD,YtF9CgD;EsF+ChD,WAAA;EACA,6BAAA;EACA,eAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;A5F0vYJ;A4FxvYI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;A5F0vYR;A4FvvYI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,kDAAA;A5FyvYR;A4FtvYI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;A5FwvYR;A4FrvYI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;A5FuvYR;A4FpvYI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;A5FsvYR;A4FjvYI;EACI,aAAA;A5FmvYR;A4FhvYI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;A5FkvYR;;A4FtuYQ;EACI,wBAAA;A5FyuYZ;A4FvuYQ;EACI,yBAAA;A5FyuYZ;;A4F9tYA;EAOI,YtF9FgD;EsF+FhD,QAAA;EACA,eAAA;EACA,iBAAA;A5F2tYJ;A4FztYI;EACI,cAAA;A5F2tYR;A4FxtYI;EACI,cAAA;EACA,eAAA;A5F0tYR;A4FvtYI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;A5FytYR;A4FttYI;EACI,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gCAAA;A5FwtYR;A4FrtYI;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;A5FutYR;A4FltYQ;EACI,0BAAA;A5FotYZ;A4FjtYQ;EACI,cAAA;EACA,qBAAA;A5FmtYZ;A4FjtYY;EACI,0BAAA;A5FmtYhB;A4FzsYI;EACI,QAAA;EACA,cAAA;EACA,eAAA;A5F2sYR;A4FzsYQ;EACI,kBAAA;A5F2sYZ;A4FxsYQ;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A5F0sYZ;;A4F3rYA;EACI;IACI,kBAAA;IACA,SAAA;IACA,MAAA;IACA,2BAAA;E5F8rYN;AACF;A4FzrYQ;EACI,cAAA;A5F2rYZ;A4FxrYQ;EACI,yBAAA;A5F0rYZ;A4FvrYQ;EACI,cAAA;A5FyrYZ;;A4FprYA;EACI,yBtFtN8C;EsFuN9C,mBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,YtFlNgD;EsFmNhD,gCAAA;EACA,aAAA;A5FurYJ;A4FprYQ;EACI,WAAA;A5FsrYZ;A4FnrYQ;EACI,eAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,iBtFhOwC;EsFiOxC,kBAAA;EACA,gBtFlOwC;ANu5YpD;A4FnrYY;EACI,YAAA;EACA,WAAA;EACA,+BAAA;EACA,+BAAA;A5FqrYhB;A4F/qYgB;EACI,ctFtQ8B;EsFuQ9B,6BAAA;A5FirYpB;A4F3qYI;EACI,UAAA;A5F6qYR;A4FxtYA;EA8CK,WAAA;A5F6qYL;A4F5qYI;EACI,YtF5P4C;EsF6P5C,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;A5F8qYR;A4F5qYQ;;EAEI,oBAAA;EACA,+BAAA;EACA,SAAA;A5F8qYZ;A4F3qYQ;EACI,gBAAA;EACA,uBAAA;EACA,aAAA;A5F6qYZ;A4F1qYQ;;EAEI,sBAAA;EACA,UAAA;A5F4qYZ;A4FzqYQ;;EAEI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,WtF9ND;EsF+NC,2CAAA;EACA,gBAAA;A5F2qYZ;A4FvqYQ;EACI,yBAAA;EACA,UAAA;A5FyqYZ;A4FtqYQ;EAEI,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,2BAAA;A5FuqYZ;A4FnqYI;EACI,YAAA;EACA,WtFpPG;EsFqPH,qBAAA;EACA,YtFnT4C;EsFoT5C,iBtFpT4C;EsFqT5C,WAAA;EACA,6BAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;A5FqqYR;A4FlqYI;EACI,aAAA;A5FoqYR;;A4F/pYA,iBAAA;AACA;EACI,iBAAA;A5FkqYJ;;A4F/pYA;EACI,cAAA;A5FkqYJ;A4FhqYI;EACI,6BAAA;EACA,kBAAA;A5FkqYR;A4F/pYI;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A5FiqYR;A4F9pYI;EACI,kBAAA;A5FgqYR;A4F9pYQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WtFpSD;ANo8YX;A4F7pYQ;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,ctFrSD;ANo8YX;A4F7pYY;EACI,gBAAA;A5F+pYhB;A4F5pYY;EACI,cAAA;A5F8pYhB;A4F3pYY;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A5F6pYhB;A4FzpYQ;EACI,iBAAA;EACA,mBAAA;EACA,iBAAA;A5F2pYZ;A4FtpYQ;EACI,iBAAA;A5FwpYZ;;A4FnpYA;EACI,eAAA;EACA,sBAAA;A5FspYJ;;A4FnpYA;EACI,2BAAA;A5FspYJ;A4FppYI;EACI,sBAAA;EACA,iBAAA;A5FspYR;;A4FlpYA;EACI,0BAAA;A5FqpYJ;A4FnpYI;EACI,YAAA;EACA,WAAA;A5FqpYR;;AcpiZI;E8EoZA;IACI,sBAAA;IACA,2BAAA;IACA,gCAAA;E5FopYN;E4FlpYM;IACI,wBAAA;E5FopYV;E4FjpYM;IACI,yBAAA;E5FmpYV;E4F7pYE;IAgBI,wBAAA;E5FgpYN;AACF;A4F7oYA;EAEQ;IACI,gBAAA;E5F8oYV;E4F5oYU;IACI,qBAAA;IACA,sBAAA;E5F8oYd;AACF;A4FroYI;EACI,oCAAA;EACA,gCAAA;A5FuoYR;A4FpoYY;EACI,ctFzYL;AN+gZX;A4FpoYgB;EACI,ctF5YT;EsF6YS,4BAAA;A5FsoYpB;A4FhoYoB;EACI,ctFhf0B;EsFif1B,6BAAA;A5FkoYxB;A4F5nYQ;EACI,ctF5ZD;AN0hZX;A4FvpYI;EA4BI,WAAA;A5F8nYR;A4F3nYQ;;EAEQ,yBAAA;A5F6nYhB;A4F1nYY;;EAEI,yBAAA;EACA,UAAA;A5F4nYhB;A4FznYY;;EAEI,yBAAA;EACA,yBtFtbL;EsFubK,qBtFvbL;ANkjZX;A4FxnYY;EACI,yBtF3bL;EsF4bK,ctF1bL;ANojZX;A4FrnYI;EACI,mBtFvjB0C;EsFwjB1C,+BAAA;A5FunYR;A4FpnYI;EACI,cAAA;A5FsnYR;A4FnnYI;EACI,aAAA;A5FqnYR;;AchnZI;E8EmgBI;IACI,SAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;IACA,eAAA;E5FinYV;E4F/mYU;IACI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,YAAA;IACA,yBAAA;IACA,4BAAA;E5FinYd;E4F9mYU;IACI,WAAA;IACA,WAAA;IACA,yBtFjeL;IsFkeK,cAAA;IACA,kBAAA;IACA,+BAAA;E5FgnYd;E4F5mYc;IACI,kBAAA;E5F8mYlB;E4F5mYkB;IACI,QAAA;IACA,wBAAA;E5F8mYtB;E4F3mYkB;IACI,kBAAA;E5F6mYtB;E4F1mYkB;IACI,WAAA;IACA,QAAA;IACA,yBAAA;E5F4mYtB;AACF;A4FpmYI;EACI,aAAA;A5FsmYR;A4FnmYI;EACI,WAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,uBAAA;A5FqmYR;A4FlmYI;EACI;IACI,kBAAA;E5FomYV;AACF;;A4FhmYA;EAIY;IACI,eAAA;E5FgmYd;E4F7lYM;IACI,WAAA;E5F+lYV;AACF;A4F1lYI;EACI,aAAA;A5F4lYR;;A6F5vZA;EACI,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;A7F+vZJ;A6F7vZI;EACI,kBAAA;EACA,SAAA;A7F+vZR;A6F5vZI;EACI,UAAA;A7F8vZR;;A6F1vZA;EACI;IACI,cAAA;E7F6vZN;E6F3vZM;IACI,cAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;E7F6vZV;E6F3vZM;IACI,cAAA;IACA,gBAAA;E7F6vZV;AACF;A8F3xZA;EACI,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,cxFuHO;EwFtHP,WxFCgD;EwFAhD,6BAAA;A9F6xZJ;A8F1xZQ;EACI,cxFiHD;EwFhHC,mBAAA;EACA,oBAAA;A9F4xZZ;A8F3xZY;EACI,cxFgHL;AN6qZX;A8F3xZY;EACI,cAAA;A9F6xZhB;;A8FvxZA;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;A9F0xZJ;;Ac7uZI;EgFzCA;IACI,kBAAA;IACA,kBAAA;E9F0xZN;AACF;A8FtxZI;EACI,kBAAA;A9FwxZR;A8FpxZQ;EACI,4BAAA;A9FsxZZ;;AcvwZI;EgFRI;IACI,iBAAA;IACA,cAAA;E9FmxZV;AACF;;A+Fz0ZA;EACI,yBzF2C8C;EyF1C9C,yEAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,YzFqCgD;EyFpChD,aAAA;EACA,uBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;A/F40ZJ;A+F10ZI;EACI,yBzFsIE;EyFrIF,kBAAA;EACA,WzFsGG;ANsuZX;A+Fz0ZI;EACI,qEAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,WzF8FG;EyF7FH,kBAAA;EACA,kBAAA;EACA,gBAAA;A/F20ZR;A+Fz0ZQ;EACI,qEAAA;A/F20ZZ;A+Fv0ZI;EACI,aAAA;EACA,kBAAA;A/Fy0ZR;A+Fv0ZQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;A/Fy0ZZ;A+Fv0ZY;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sBzFoEL;EyFnEK,iBAAA;EACA,kBAAA;EACA,4CzFolBc;ANqvY9B;A+Fr0ZQ;EACI,kBAAA;A/Fu0ZZ;A+Fr0ZY;EACI,czFiEL;ANswZX;A+Fj0ZQ;EACI,qBAAA;A/Fm0ZZ;A+Fj0ZY;EACI,yBzFgDL;ANmxZX;A+F/zZQ;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;A/Fi0ZZ;A+F/zZY;EACI,czFyEN;ANwvZV;A+F9zZY;EACI,czFoEN;AN4vZV;A+F7zZY;EACI,czF8DN;ANiwZV;;A+FxzZA;EACI,uCAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;A/F2zZJ;;A+FvzZI;EACI,QAAA;A/F0zZR;A+FvzZI;EACI,cAAA;A/FyzZR;;Acp2ZI;EiFgDA;IACI,cAAA;E/FwzZN;E+FtzZM;IACI,uBAAA;E/FwzZV;AACF;AgGp7ZI;EACI,iB1FgB4C;E0Ff5C,cAAA;EACA,4C1FqoBsB;ANizY9B;AgGn7ZI;EACI,iB1FU4C;E0FT5C,cAAA;AhGq7ZR;AgGl7ZI;EACI,cAAA;EACA,+BAAA;AhGo7ZR;AgGh7ZQ;EACI,8BAAA;AhGk7ZZ;AgG76ZQ;EACI,+BAAA;AhG+6ZZ;;Ac74ZI;EkF1BI;IACI,+BAAA;EhG26ZV;AACF;Acn5ZI;EkFlBA;IACI,iBAAA;EhGw6ZN;EgGt6ZM;IACI,aAAA;EhGw6ZV;EgGr6ZM;;IAEI,kBAAA;EhGu6ZV;EgGp6ZM;IACI,kBAAA;IACA,gB1FhDwC;I0FiDxC,gB1FjDwC;I0FkDxC,iCAAA;EhGs6ZV;EgGn6ZM;IACI,cAAA;IACA,WAAA;IACA,oBAAA;EhGq6ZV;AACF;Ac16ZI;EmFxDI;IACI,c3FwDwC;EN66ZlD;EiGl+ZM;IACI,eAAA;EjGo+ZV;AACF;AiGj+ZI;EACI,yBAAA;AjGm+ZR;;AiG/9ZA;EACI,mB3F6B8C;E2F5B9C,gCAAA;EACA,gB3FqCgD;E2FpChD,2BAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AjGk+ZJ;AiGh+ZI;EACI,SAAA;EACA,UAAA;AjGk+ZR;AiG79ZQ;EACI,kB3FCwC;E2FAxC,kBAAA;EACA,iBAAA;EACA,gCAAA;EACA,c3FCwC;E2FAxC,0D3F2BwC;ANo8ZpD;AiG79ZY;EACI,eAAA;EACA,qBAAA;AjG+9ZhB;AiG59ZY;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,c3FZoC;E2FapC,+BAAA;AjG89ZhB;AiG39ZY;EAEI,c3FzBkC;E2F0BlC,6BAAA;AjG49ZhB;AiGt9ZgB;EACI,c3FhC8B;ANw/ZlD;AiGp9ZgB;EACI,c3FrC8B;AN2/ZlD;AiGr9ZoB;EACI,c3FvC0B;E2FwC1B,8BAAA;AjGu9ZxB;;Act+ZI;EmFwBA;IACI,Y3F9B4C;ENg/ZlD;EiG78ZkB;IACI,eAAA;EjG+8ZtB;EiGz8ZM;IACI,uBAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;EjG28ZV;EiGz8ZU;IACI,6BAAA;IACA,c3FtEkC;ENihahD;EiGn8Zc;IACI,SAAA;IACA,WAAA;EjGq8ZlB;EiGj8ZU;IACI,iBAAA;IACA,aAAA;IACA,kCAAA;EjGm8Zd;EiGh8ZkB;IACI,WAAA;IACA,2CAAA;IACA,kBAAA;EjGk8ZtB;EiG77ZkB;IACI,kBAAA;IACA,iBAAA;IACA,UAAA;IACA,aAAA;EjG+7ZtB;EiGz7Zc;IACI,c3F9G8B;ENyiahD;EiGz7ZkB;IACI,c3FjH0B;I2FkH1B,8BAAA;EjG27ZtB;EiGv7Zc;IACI,cAAA;EjGy7ZlB;EiGt7ZsB;IACI,c3F1HsB;ENkjahD;EiGr7ZsB;IACI,cAAA;EjGu7Z1B;EiG/6ZE;IACI,aAAA;EjGi7ZN;EiG76ZM;IACI,4BAAA;EjG+6ZV;AACF;AiG36ZA;EACI,qBAAA;AjG66ZJ;AiG36ZI;EACI,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,QAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;AjG66ZR;;AcxiaI;EmFuIoB;IACI,WAAA;IACA,UAAA;EjGq6Z1B;AACF;Ac/iaI;EmFoJA;IACI,iBAAA;IACA,gBAAA;IACA,UAAA;EjG85ZN;EiG35ZU;IACI,uBAAA;EjG65Zd;EiGx5ZU;IACI,6BAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;EjG05Zd;EiGv5ZU;IACI,kBAAA;IACA,6BAAA;EjGy5Zd;EiGv5Zc;IAEI,c3FnN8B;EN2mahD;EiGl5ZU;IACI,WAAA;IACA,kBAAA;EjGo5Zd;AACF;AiG94ZI;EACI,iB3FnP4C;E2FoP5C,mBAAA;AjGg5ZR;;AiG14ZI;EACI,wCAAA;AjG64ZR;;AkG1paI;EACI,yBAAA;EACA,6BAAA;EACA,gBAAA;AlG6paR;AkG1paI;EACI,eAAA;EACA,W5Fc4C;E4Fb5C,YAAA;EACA,MAAA;EACA,SAAA;EACA,oBAAA;EACA,yB5FW0C;ANipalD;AkG1paQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AlG4paZ;AkGzpaQ;EACI,6BAAA;EACA,iBAAA;AlG2paZ;AkGzpaY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AlG2pahB;AkGzpagB;EACI,2CAAA;AlG2papB;AkGxpagB;EACI,W5F6ET;E4F5ES,+BAAA;EACA,YAAA;EACA,WAAA;AlG0papB;AkGppaI;EACI,cAAA;EACA,eAAA;EACA,Y5FhC4C;E4FiC5C,yB5F/B0C;E4FgC1C,S5FE4C;E4FD5C,SAAA;EACA,U5FnC4C;E4FoC5C,iBAAA;EACA,+BAAA;EACA,6BAAA;AlGspaR;AkGppaQ;EACI,aAAA;AlGspaZ;AkGnpaQ;EACI,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AlGqpaZ;AkGhpagB;EACI,c5F/C8B;E4FgD9B,kB5F5CgC;E4F6ChC,0D5FdgC;ANgqapD;AkG/oagB;EACI,WAAA;AlGipapB;AkG7oaY;EACI,kBAAA;EACA,c5F3DkC;E4F4DlC,iBAAA;EACA,kBAAA;EACA,eAAA;AlG+oahB;AkG7oagB;EAGI,c5FjE8B;AN8salD;AkGxoagB;EACI,c5FvE8B;E4FwE9B,0CAAA;AlG0oapB;AkGvoagB;EACI,c5F5E8B;ANqtalD;AkGnoaY;EACI,QAAA;AlGqoahB;AkGjoaQ;EACI,kBAAA;EACA,gBAAA;AlGmoaZ;AcnsaI;EoFqEI;IACI,qBAAA;IACA,iBAAA;ElGioaV;EkG/naU;IACI,Y5FhHoC;ENivalD;EkG/nac;IACI,aAAA;ElGioalB;EkG3naU;IACI,mBAAA;ElG6nad;AACF;AkGxnaQ;EACI,yB5F/HsC;ANyvalD;AcrtaI;EoFgGI;IACI,+BAAA;ElGwnaV;EkGrnaM;IACI,wBAAA;ElGunaV;EkGnnaU;IACI,aAAA;ElGqnad;AACF;AkGjnaI;EACI,aAAA;AlGmnaR;AkG/maQ;EACI,yB5F5KsC;AN6xalD;AkG7maoB;EACI,c5F1J0B;ANywalD;AkGzmaoB;EAGI,c5FlK0B;AN2walD;AkGpmaoB;EACI,c5FlK0B;E4FmK1B,0CAAA;AlGsmaxB;AkGnmaoB;EACI,c5FvK0B;AN4walD;AkGxlaoB;EACI,+BAAA;AlG0laxB;AkGplaoB;EAGI,+BAAA;AlGolaxB;AkG5kaQ;EACI,8BAAA;AlG8kaZ;AkG3kaQ;EACI,kBAAA;EACA,MAAA;AlG6kaZ;AkGxkaQ;EACI,4CAAA;AlG0kaZ;;AmG7zaA;EACI,cAAA;EACA,aAAA;AnGg0aJ;;AmG7zaA;EACI,eAAA;EACA,cAAA;AnGg0aJ;;AmG7zaA;EACI,YAAA;EACA,WAAA;AnGg0aJ;;AmG7zaA;EACI,cAAA;EACA,aAAA;AnGg0aJ;;AmG7zaA;EACI,cAAA;EACA,aAAA;AnGg0aJ;;AmG7zaA;EACI,YAAA;EACA,WAAA;AnGg0aJ;;AmG7zaA;EACI,cAAA;EACA,aAAA;AnGg0aJ;;AmG7zaA;EACI,mBAAA;EACA,W7FgFO;E6F/EP,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AnGg0aJ;;AmG7zaA;EACI,kBAAA;AnGg0aJ;AmG9zaI;EACI,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;AnGg0aR;;AoGn3aI;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ApGs3aR;AoGr3aQ;EACI,yB9FiHD;E8FhHC,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,wBAAA;EACA,QAAA;ApGu3aZ;AoGr3aQ;EACI,c9FsGD;E8FrGC,qBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ApGu3aZ;AoGp3aI;EACI,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ApGs3aR;AoGr3aQ;EACI,aAAA;ApGu3aZ;AoGn3aQ;EACI,oBAAA;EACA,aAAA;ApGq3aZ;AoGj3aQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;ApGm3aZ;AoG/2aQ;EACI,yB9FmDD;E8FlDC,mBAAA;ApGi3aZ;;AoG12aQ;EACI,kBAAA;ApG62aZ;;AoGx2aA;EACI,aAAA;ApG22aJ;;AoGv2aI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;ApG02aR;AoGx2aI;EACI,YAAA;EACA,WAAA;ApG02aR;AoGz2aQ;EACI,cAAA;ApG22aZ;AoGz2aQ;EACI,cAAA;ApG22aZ;;AoGl2aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;ANqxaf;AoGn2aY;EACI,kB9FKL;ANg2aX;;AoG12aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;AN6xaf;AoG32aY;EACI,kB9FKL;ANw2aX;;AoGl3aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;ANqyaf;AoGn3aY;EACI,kB9FKL;ANg3aX;;AoG13aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;AN6yaf;AoG33aY;EACI,kB9FKL;ANw3aX;;AoGl4aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;ANqzaf;AoGn4aY;EACI,kB9FKL;ANg4aX;;AoG14aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;AN6zaf;AoG34aY;EACI,kB9FKL;ANw4aX;;AoGl5aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;ANq0af;AoGn5aY;EACI,kB9FKL;ANg5aX;;AoG15aY;EACI,yB9FiFD;E8FhFC,qB9FgFD;AN60af;AoG35aY;EACI,kB9FKL;ANw5aX;;AqG7gbI;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ArGghbR;AqG/gbQ;EACI,sB/F8GD;E+F7GC,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,WAAA;EACA,wBAAA;ArGihbZ;AqG/gbQ;EACI,yB/FuGD;E+FtGC,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,8DAAA;EACA,WAAA;ArGihbZ;AqG9gbI;EACI,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;ArGghbR;AqG/gbQ;EACI,aAAA;ArGihbZ;AqG7gbQ;EACI,oBAAA;EACA,0CAAA;EACA,oBAAA;ArG+gbZ;AqG3gbQ;EACI,sBAAA;ArG6gbZ;AqGzgbQ;EACI,mBAAA;ArG2gbZ;;AqGtgbA;EACI,aAAA;ArGygbJ;;AqGrgbI;EACI,YAAA;ArGwgbR;;AqGhgbY;EACI,yB/F+GD;ANo5af;AqG//aY;EACI,qB/F0GD;ANu5af;AqG//aY;EACI,yB/FuGD;AN05af;;AqG1gbY;EACI,yB/F+GD;AN85af;AqGzgbY;EACI,qB/F0GD;ANi6af;AqGzgbY;EACI,yB/FuGD;ANo6af;;AqGphbY;EACI,yB/F+GD;ANw6af;AqGnhbY;EACI,qB/F0GD;AN26af;AqGnhbY;EACI,yB/FuGD;AN86af;;AqG9hbY;EACI,yB/F+GD;ANk7af;AqG7hbY;EACI,qB/F0GD;ANq7af;AqG7hbY;EACI,yB/FuGD;ANw7af;;AqGxibY;EACI,yB/F+GD;AN47af;AqGvibY;EACI,qB/F0GD;AN+7af;AqGvibY;EACI,yB/FuGD;ANk8af;;AqGljbY;EACI,yB/F+GD;ANs8af;AqGjjbY;EACI,qB/F0GD;ANy8af;AqGjjbY;EACI,yB/FuGD;AN48af;;AqG5jbY;EACI,yB/F+GD;ANg9af;AqG3jbY;EACI,qB/F0GD;ANm9af;AqG3jbY;EACI,yB/FuGD;ANs9af;;AqGtkbY;EACI,yB/F+GD;AN09af;AqGrkbY;EACI,qB/F0GD;AN69af;AqGrkbY;EACI,yB/FuGD;ANg+af;;AsG5pbA;EACI,eAAA;AtG+pbJ;;AsG5pbA;EACI,gBAAA;AtG+pbJ;;AsG5pbA;EACI,gBAAA;AtG+pbJ;;AsG5pbA;EACI,gBAAA;AtG+pbJ;;AsG5pbA;EACI,gBAAA;AtG+pbJ;;AsG1pbA;EACI,0DhGspB0B;ANuga9B;;AsG1pbA;EACI,0DhGsCgD;ANunbpD;;AsGxpbA;;;;EAII,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;AtG2pbJ;;AsGxpbA;EACI,qBAAA;AtG2pbJ;;AsGxpbA;EACI,qBAAA;AtG2pbJ;;AsGvpbA;EACI,qBAAA;AtG0pbJ;;AsGvpbA;EACI,qBAAA;AtG0pbJ;;AsGtpbA;EACI,chG6DO;EgG5DP,+BAAA;AtGypbJ;;AsGppbI;EACI,chGwHO;EgGvHP,8BAAA;AtGupbR;;AsGzpbI;EACI,chGwHO;EgGvHP,+BAAA;AtG4pbR;;AsG9pbI;EACI,chGwHO;EgGvHP,8BAAA;AtGiqbR;;AsGnqbI;EACI,chGwHO;EgGvHP,8BAAA;AtGsqbR;;AsGxqbI;EACI,chGwHO;EgGvHP,8BAAA;AtG2qbR;;AsG7qbI;EACI,chGwHO;EgGvHP,8BAAA;AtGgrbR;;AsGlrbI;EACI,chGwHO;EgGvHP,+BAAA;AtGqrbR;;AsGvrbI;EACI,chGwHO;EgGvHP,4BAAA;AtG0rbR;;AsGtrbA;EACI,YAAA;EACA,WAAA;AtGyrbJ;;AsGtrbA;EACI,YAAA;EACA,WAAA;AtGyrbJ;;AsGtrbA;EACI,YAAA;EACA,WAAA;AtGyrbJ;;AsGtrbA;EACI,YAAA;EACA,WAAA;AtGyrbJ;;AsGtrbA;EACI,YAAA;EACA,WAAA;AtGyrbJ;;AsGtrbA;EACI,YAAA;EACA,WAAA;AtGyrbJ;;AsGprbI;EACI,yBhGWG;AN4qbX;;AsGlrbA;EACI,eAAA;AtGqrbJ;;AuGtybA;EACI,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cjGmHO;ANsrbX;;AwG/ybA;EACI,kBAAA;EACA,gBAAA;AxGkzbJ;AwGhzbI;EACI,eAAA;AxGkzbR;;AwG9ybA,gBAAA;AAEA;EACI,gBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AxGgzbJ;AwG/ybI;EACI,mBAAA;AxGizbR;AwG9ybI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;AxGgzbR;AwG9ybQ;EACI,mBAAA;EACA,WAAA;AxGgzbZ;AwG7ybQ;EACI,eAAA;EACA,kBAAA;AxG+ybZ;AwG3ybI;EACI,+DAAA;EACA,clG4GE;EkG3GF,sBlGulBsB;EkGtlBtB,qBAAA;EACA,iBAAA;EACA,kBAAA;AxG6ybR;AwG1ybQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBlG4oBkB;EkG3oBlB,kBAAA;AxG4ybZ;AwGzybQ;EACI,SAAA;EACA,gBAAA;AxG2ybZ;AwGxybQ;EACI,UAAA;EACA,MAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,qEAAA;EACA,iBAAA;EACA,iBAAA;EACA,uEAAA;AxG0ybZ;AwGtybI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AxGwybR;AwGpybQ;EACI,uBAAA;AxGsybZ;AwGnybQ;EACI,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AxGqybZ;AwGlybQ;EACI,yBlGyBD;EkGxBC,clG4BD;ANwwbX;AwGnybY;EACI,yBAAA;EACA,0BlGqBL;EkGpBK,yBlGoBL;EkGnBK,oBAAA;AxGqybhB;;AwG/xbA,oBAAA;AACA;EACI,kBAAA;AxGkybJ;AwGhybI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AxGkybR;AwG/xbI;EACI,iBAAA;AxGiybR;AwG9xbI;EACI,mBAAA;AxGgybR;;AwG3xbI;EACI,gBAAA;EACA,gFAAA;AxG8xbR;;AwGzxbI;EACI,gCAAA;EACA,iBAAA;AxG4xbR;AwG3xbQ;EACI,YAAA;AxG6xbZ;;AyGx6bA;EACI;;;;;IAKI,aAAA;EzG26bN;EyGz6bE;;;;;IAKI,UAAA;IACA,SAAA;EzG26bN;EyGz6bE;IACI,YAAA;EzG26bN;AACF;A0G97bA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,aAAA;A1Gg8bJ;;A0G77bA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;A1Gg8bJ;;A0G77bA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,wBAAA;EACA,gDAAA;A1Gg8bJ;;A0G77bA;;EAEI,kBAAA;EACA,WAAA;EACA,YAAA;A1Gg8bJ;;A0G77bA;EACI;IACI,uBAAA;E1Gg8bN;E0G97bE;IACI,yBAAA;E1Gg8bN;AACF;A2G3+bI;EACI,sBAAA;EACA,4BAAA;EACA,iBAAA;A3G6+bR;;A2Gt+bQ;EACI,6BAAA;A3Gy+bZ;A2Gv+bY;EACI,YAAA;EACA,WAAA;A3Gy+bhB;;A2Gn+bA;EACI,cAAA;A3Gs+bJ;;A2Gn+bA;EACI,cAAA;A3Gs+bJ;;A2Gj+bA;EACI,UAAA;EAIA,0DAAA;EAEA,4BAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;A3Gg+bJ;A2G79bI;EACI,SAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;A3G+9bR;A2G59bI;EACI,kBAAA;EACA,WrG4DG;EqG3DH,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;A3G89bR;;A2Gx9bI;EACI,wBAAA;A3G29bR;A2Gz9bI;EACI,yBAAA;A3G29bR;;A2Gt9bA;EACI,WAAA;EACA,cAAA;EACA,eAAA;A3Gy9bJ;A2Gv9bI;EACI,sBAAA;EACA,oBAAA;EACA,8BAAA;A3Gy9bR;A2Gt9bI;EACI,kBAAA;EACA,yBAAA;A3Gw9bR;;A2Gp9bA;EACI;IACI,uBAAA;E3Gu9bN;E2Gr9bE;IACI,oBAAA;E3Gu9bN;AACF;A2Gp9bA;EACI;IACI,+BAAA;E3Gs9bN;E2Gp9bE;IACI,iCAAA;E3Gs9bN;AACF;A2Gn9bA;EACI;IACI,UAAA;E3Gq9bN;E2Gn9bE;IACI,UAAA;E3Gq9bN;AACF;A2Gj9bA;EACI,oBAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;A3Gm9bJ;A2Gj9bI;EACI,WAAA;EACA,YAAA;A3Gm9bR;A2G98bI;EACI,YAAA;EACA,WAAA;A3Gg9bR;A2G78bI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;A3G+8bR;A2G58bI;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;A3G88bR;A2G38bI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;A3G68bR;A2Gz8bQ;;EAEI,cAAA;A3G28bZ;;A2Gr8bA;EACI,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;A3Gw8bJ;A2Gt8bI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,4CAAA;EACA,iCAAA;A3Gw8bR;A2Gt8bQ;EACI,mBAAA;EACA,cAAA;A3Gw8bZ;A2Gr8bQ;EACI,kBAAA;A3Gu8bZ;A2Gn8bI;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;A3Gq8bR;A2Gl8bI;EACI,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A3Go8bR;A2Gj8bI;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;A3Gm8bR;A2Gh8bI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;A3Gk8bR;A2G/7bI;EACI,cAAA;EACA,iBAAA;EACA,mBAAA;A3Gi8bR;A2G97bI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;A3Gg8bR;A2G97bQ;EACI,0BAAA;A3Gg8bZ;A2G57bI;EACI,4DAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;A3G87bR;A2G57bQ;EAGI,uEAAA;EACA,uBAAA;A3G47bZ;A2Gx7bI;EACI,WAAA;EACA,gBAAA;A3G07bR;A2Gv7bI;EACI;IACI,cAAA;IACA,aAAA;IACA,iBAAA;E3Gy7bV;E2Gt7bM;IACI,aAAA;E3Gw7bV;AACF;A2Gr7bI;EACI;IACI,eAAA;E3Gu7bV;E2Gp7bM;IACI,eAAA;E3Gs7bV;AACF;;A4G1tcA;EACI,iBAAA;EACA,oBAAA;A5G6tcJ;A4G3tcI;EACI,mBAAA;EACA,gBAAA;A5G6tcR;;A4GvtcI;EACI,yBtG8xBsB;EsG7xBtB,mBAAA;EACA,iBAAA;EACA,gBtGsD4C;EsGrD5C,kBAAA;A5G0tcR;;A4GptcI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;A5GutcR;A4GttcQ;EACI,gBAAA;EACA,oBAAA;A5GwtcZ;A4GrtcI;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,ctGgFG;EsG/EH,kBAAA;EACA,qBAAA;EACA,oBAAA;A5GutcR;A4GrtcI;EACI,kBAAA;EACA,4BAAA;EACA,mBAAA;A5GutcR;A4GttcQ;EAEI,ctG6FF;AN0ncV;;A4GjtcI;EACI,eAAA;EACA,ctG6DG;ANupcX;A4GntcQ;EACI,kBAAA;A5GqtcZ;A4GltcQ;EACI,iBAAA;EACA,qBAAA;EACA,sBAAA;A5GotcZ;;A4G5scA;EACI,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;A5G+scJ;;A6GjycA;EACI,cvGkJM;EuGjJN,8EAAA;EACA,eAAA;EACA,iBAAA;EACA,0DvG6DgD;ANuucpD;;A6GhycA;EACI,gBAAA;EACA,0DvGuDgD;EuGtDhD,iBAAA;A7GmycJ;A6GjycI;EACI,UAAA;EACA,eAAA;EACA,sBAAA;EACA,wBAAA;EACA,oBAAA;EACA,oCAAA;A7GmycR;A6GhycI;EACI,evG+HE;EuG9HF,sBAAA;A7GkycR;A6G/xcI;EACI,evG4HE;EuG3HF,sBAAA;A7GiycR;A6G9xcI;EACI,evGiHE;EuGhHF,sBAAA;A7GgycR;A6G7xcI;EACI,evGqHE;EuGpHF,sBAAA;A7G+xcR;A6G5xcI;EACI,evG8GE;EuG7GF,oBAAA;A7G8xcR;;A6G1xcA;EACI;IACI,uBAAA;E7G6xcN;AACF;A6G1xcA;EAEQ;IACI,avG6FF;IuG5FE,evG4FF;IuG3FE,eAAA;IACA,qBAAA;IACA,oBAAA;IACA,eAAA;E7G2xcV;AACF;A8G51cA;EAEI,sBxGoHO;ANyucX;A8G51cI;EACI,gBxGi1C4B;EwGh1C5B,YAAA;EACA,WAAA;EAEA,qBAAA;EACA,qBAAA;A9G61cR;A8G11cI;EACI,kBAAA;EACA,8BAAA;EACA,wBAAA;A9G41cR;;A8Gt1cA;EACI,cAAA;EACA,eAAA;A9Gy1cJ;A8Gv1cI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBxGsFG;EwGrFH,kBAAA;EACA,qDxGsmBsB;ANmvb9B;A8Gv1cQ;EACI,cxGwFD;ANiwcX;A8Gt1cQ;EACI,6CxG8lBkB;EwG7lBlB,0BAAA;A9Gw1cZ;A8Gr1cQ;EACI,WAAA;EACA,kBAAA;A9Gu1cZ;A8Gp1cQ;EACI,YAAA;A9Gs1cZ;A8Gp1cY;;;EAGI,cAAA;EACA,WAAA;A9Gs1chB;A8Gn1cY;EACI,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;A9Gq1chB;A8Gl1cY;EACI,wBAAA;A9Go1chB;A8Gj1cY;EACI,cxGgDL;EwG/CK,iBAAA;A9Gm1chB;A8Gh1cY;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;A9Gk1chB;A8G90cQ;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;A9Gg1cZ;A8G90cY;;EAEI,kBAAA;EACA,MAAA;A9Gg1chB;A8G70cY;EACI,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A9G+0chB;A8G50cY;EACI,QAAA;EACA,YAAA;EACA,kBAAA;A9G80chB;A8Gz0cI;;EAEI,mBxGJG;EwGKH,0BAAA;A9G20cR;A8Gx0cI;;EAEI,iCAAA;A9G00cR;A8Gv0cI;EAEI,0DAAA;A9Gw0cR;A8Gr0cI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;A9Gu0cR;A8Gr0cQ;EACI,UAAA;EACA,eAAA;A9Gu0cZ;A8Gp0cQ;EACI,UAAA;A9Gs0cZ;A8Gn0cQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,mBxGtCD;EwGuCC,UAAA;EACA,2BAAA;EACA,0BAAA;A9Gq0cZ;A8Gl0cQ;EACI,mBAAA;A9Go0cZ;;A8G9zcI;EACI,cxGnDG;EwGoDH,iBAAA;EACA,cAAA;A9Gi0cR;;A8G7zcA;EACI,yBAAA;A9Gg0cJ;;A8G7zcA;EAEQ;IACQ,WAAA;IACA,WAAA;IACA,mBAAA;IACA,uBAAA;E9G+zcd;E8G5zcM;IACI,cAAA;IACA,SAAA;IACA,eAAA;E9G8zcV;AACF;A8GzzcA;EAEQ;IACI,mBAAA;E9G0zcV;E8GrzcM;IACI,YAAA;E9GuzcV;E8GrzcU;IACI,UAAA;E9Guzcd;E8GnzcM;IACI,WAAA;E9GqzcV;E8GnzcU;IACI,iBAAA;IACA,mBAAA;IACA,kBAAA;E9Gqzcd;AACF;A8GhzcA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,sBxGvHO;EwGwHP,sBxGkZ0B;EwGjZ1B,6CxGwZ0B;EwGvZ1B,WAAA;A9GkzcJ;A8G/ycQ;EACI,mBAAA;A9GizcZ;A8G7ycI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;A9G+ycR;;A+G1idA;EACI,kBAAA;A/G6idJ;A+G3idI;EACI,oBAAA;A/G6idR;A+G1idI;EACI,eAAA;EACA,yCAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;A/G4idR;A+GzidI;EACI,iBAAA;A/G2idR;A+GzidQ;EACI,cAAA;EACA,czGsGD;EyGrGC,mBAAA;EACA,yBAAA;A/G2idZ;A+GxidI;EACI,czGgGG;EyG/FH,gBAAA;EACA,SAAA;EACA,mBAAA;A/G0idR;A+GxidQ;EACI,aAAA;A/G0idZ;;A+GridA;EACI,yBzG4GM;EyG3GN,WzG6EO;AN29cX;A+GtidI;EACI,0CAAA;A/GwidR;A+GtidI;EACI,+BAAA;A/GwidR;;AgHvldA;EACI,yB1GsHO;E0GrHP,kBAAA;EACA,aAAA;EACA,gBAAA;AhH0ldJ;;AiH9ldA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;AjHimdJ;;AiH9ldA;EACI,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mB3GylB0B;E2GxlB1B,sB3G0GO;ECvGP,qBAAA;AP+ldJ;AiH/ldI;EACI,qBAAA;AjHimdR;AiH9ldI;EACI,mBAAA;EACA,gBAAA;AjHgmdR;AiH7ldI;EACI,oE3Gq0C4B;E2Gp0C5B,aAAA;EACA,eAAA;E1GZJ,qBAAA;AP4mdJ;;AiH3ldA;EACI,iBAAA;EACA,kBAAA;AjH8ldJ;AiH5ldI;EACI,eAAA;AjH8ldR;AiH3ldI;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AjH6ldR;;AiHtldI;EACI,gFAAA;EACA,4EAAA;AjHyldR;;AiHpldA;EACI,gBAAA;AjHuldJ;;AiHlldI;EACI,kBAAA;EACA,WAAA;AjHqldR;AiHnldI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AjHqldR;;AkH/pdA,kDAAA;AAGI;EACI,8BAAA;EACA,kBAAA;AlHgqdR;AkH/pdQ;EACI,kBAAA;AlHiqdZ;AkHhqdY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yB5GqIN;E4GpIM,kBAAA;EACA,sBAAA;EACA,UAAA;AlHkqdhB;AkHhqdY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,yB5G8FL;ANokdX;AkH5pdQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AlH8pdZ;;AkHrpdA;EACI,mBAAA;EACA,kBAAA;AlHwpdJ;AkHvpdI;EACI,yB5GwEG;E4GvEH,SAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AlHypdR;AkHvpdI;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AlHypdR;AkHvpdI;EACI,cAAA;EACA,kBAAA;EACA,aAAA;AlHypdR;AkHvpdI;EACI,gBAAA;AlHypdR;AkHxpdQ;EACI,qBAAA;EACA,iBAAA;AlH0pdZ;AkHxpdQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AlH0pdZ;;Ac7qdI;EoG0BI;IACI,WAAA;ElHupdV;EkHrpdM;IACI,iBAAA;ElHupdV;EkHrpdM;IACI,mB5GwDF;I4GvDE,kBAAA;IACA,cAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,QAAA;IACA,WAAA;IACA,sBAAA;IACA,UAAA;ElHupdV;EkHtpdU;IACI,WAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,yB5GYL;I4GXK,UAAA;IACA,QAAA;ElHwpdd;EkHrpdM;IACI,mBAAA;IACA,mBAAA;IACA,UAAA;ElHupdV;EkHppdE;IACI,aAAA;ElHspdN;EkHrpdM;IACI,WAAA;IACA,cAAA;IACA,UAAA;ElHupdV;EkHnpdU;IACI,WAAA;IACA,cAAA;IACA,UAAA;ElHqpdd;EkHlpdc;IACI,YAAA;IACA,gBAAA;ElHopdlB;EkHnpdkB;IACI,YAAA;IACA,gBAAA;ElHqpdtB;EkHjpdU;IACI,UAAA;IACA,YAAA;ElHmpdd;EkHlpdc;IACI,UAAA;IACA,WAAA;ElHopdlB;EkHjpdU;IACI,aAAA;ElHmpdd;EkHjpdU;IACI,kBAAA;IACA,cAAA;IACA,iBAAA;ElHmpdd;AACF;Ac1udI;EoG8FI;IACI,kBAAA;ElH+odV;EkH7odM;IACI,sBAAA;IACA,oBAAA;IACA,yBAAA;ElH+odV;EkH7odM;IACI,aAAA;ElH+odV;AACF;AmH9zdI;EACI,oCAAA;AnHg0dR;;AmH3zdI;EACI,sB7G8GG;ANgtdX;;AmHvzdA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,0D7G4pB0B;E6G3pB1B,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AnH0zdJ;;AmHvzdA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,0D7G+oB0B;E6G9oB1B,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AnH0zdJ;AmHxzdI;EAXJ;IAYQ,iBAAA;EnH2zdN;AACF;;AmHxzdA;;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0D7G6nB0B;E6G5nB1B,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AnH2zdJ;AmHzzdI;EAbJ;;IAcQ,kBAAA;IACA,mBAAA;EnH6zdN;AACF;;AmH1zdA;;EAEI,gBAAA;EACA,mBAAA;EACA,kBAAA;AnH6zdJ;;AmHzzdA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;AnH4zdJ;AmH1zdI;;;EAGI,YAAA;AnH4zdR;AmHzzdI;EACI,YAAA;EACA,sBAAA;EACA,2BAAA;AnH2zdR;AmHxzdI;EACI,aAAA;AnH0zdR;AmHvzdI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iJAAA;EAOA,oBAAA;AnHmzdR;AmHhzdI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AnHkzdR;AmH/ydI;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AnHizdR;AmH9ydI;EACI,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AnHgzdR;AmH7ydI;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AnH+ydR;AmH5ydI;EACI,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uDAAA;AnH8ydR;AmH5ydQ;EACI,cAAA;EACA,2BAAA;EACA,yCAAA;AnH8ydZ;AmH1ydI;EA1FJ;IA2FQ,aAAA;EnH6ydN;EmH3ydM;IACI,kBAAA;EnH6ydV;EmH1ydM;IACI,iBAAA;EnH4ydV;EmHzydM;IACI,kBAAA;IACA,mBAAA;EnH2ydV;EmHxydM;IACI,iBAAA;IACA,mBAAA;EnH0ydV;EmHvydM;IACI,iBAAA;IACA,kBAAA;EnHyydV;AACF;AmHtydI;EArHJ;IAsHQ,aAAA;EnHyydN;EmHvydM;IACI,iBAAA;EnHyydV;AACF;;AmHpydA;EACI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AnHuydJ;AmHrydI;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AnHuydR;AmHrydQ;EACI,eAAA;EACA,cAAA;AnHuydZ;AmHnydI;EACI,oBAAA;EACA,qBAAA;EACA,cAAA;AnHqydR;AmHlydI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AnHoydR;AmHjydI;EACI,cAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AnHmydR;AmHhydI;EACI;IACI,iBAAA;IACA,kBAAA;EnHkydV;EmH/xdM;IACI,kBAAA;IACA,kBAAA;EnHiydV;AACF;;AmH7xdA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AnHgydJ;;AmH7xdA;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,sCAAA;EACA,cAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AnHgydJ;;AmH7xdA;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnHgydJ;;AmH7xdA;EACI;IACI,kCAAA;IACA,UAAA;IACA,gBAAA;EnHgydN;EmH7xdE;IACI,6CAAA;IACA,UAAA;IACA,kBAAA;EnH+xdN;AACF;AmH5xdA;EACI,eAAA;AnH8xdJ;;AmH3xdA;EAEI,mBAAA;EAEA,4BAAA;AnH8xdJ;;AmH3xdA;EAEI,qBAAA;AnH8xdJ;;AmH1xdA;EACI,uDAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AnH6xdJ;AmH3xdI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AnH6xdR;AmH3xdQ;EACI,gBAAA;AnH6xdZ;AmHzxdI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AnH2xdR;AmHzxdQ;;;EAGI,cAAA;EACA,qBAAA;EACA,mBAAA;AnH2xdZ;AmHzxdY;;;EACI,cAAA;EACA,0BAAA;AnH6xdhB;AmHzxdQ;EACI,gBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AnH2xdZ;AmHxxdQ;EACI,+BAAA;AnH0xdZ;AmHvxdQ;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AnHyxdZ;AmHrxdI;EAxDJ;IAyDQ,iBAAA;IACA,cAAA;IACA,kBAAA;EnHwxdN;EmHtxdM;IACI,sBAAA;IACA,YAAA;EnHwxdV;EmHrxdM;;IAEI,uBAAA;IACA,WAAA;EnHuxdV;AACF;;AmHlxdA;EACI,8BAAA;EACA,yCAAA;AnHqxdJ;AmHnxdI;EACI;IACI,6BAAA;IACA,8BAAA;EnHqxdV;AACF;AmHlxdI;EACI,YAAA;EACA,WAAA;AnHoxdR;AmHlxdQ;EAJJ;IAKQ,YAAA;EnHqxdV;AACF;AmHlxdI;EACI,SAAA;AnHoxdR;AmHjxdI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AnHmxdR;AmHjxdQ;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AnHmxdZ;AmHhxdQ;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;AnHkxdZ;AmH/wdQ;EACI;IACI,iBAAA;EnHixdd;EmH9wdU;IACI,kBAAA;EnHgxdd;AACF;AmH5wdI;EACI,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;AnH8wdR;AmH5wdQ;EAEI,yBAAA;AnH6wdZ;AmH1wdQ;EACI,yBAAA;EACA,kBAAA;AnH4wdZ;AmH1wdY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AnH4wdhB;AmHvwdI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;AnHywdR;AmHvwdQ;EAEI,cAAA;AnHwwdZ;AmHrwdQ;EACI,aAAA;AnHuwdZ;AmHpwdQ;EACI,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,QAAA;AnHswdZ;AmHnwdQ;EACI,eAAA;EACA,cAAA;AnHqwdZ;AmHlwdQ;EACI,iBAAA;EACA,gBAAA;EACA,gCAAA;AnHowdZ;AmHjwdQ;EACI,yBAAA;AnHmwdZ;AmH9vdQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AnHgwdZ;AmH9vdY;EACI,cAAA;EACA,kBAAA;AnHgwdhB;AmH3vdI;EACI,YAAA;EACA,2BAAA;EACA,cAAA;AnH6vdR;AmH1vdI;EAEI;;IAEI,4BAAA;EnH2vdV;EmHxvdM;IACI,OAAA;IACA,QAAA;EnH0vdV;AACF;;AmHrvdA;EACI,eAAA;AnHwvdJ;AmHtvdI;EACI,mBAAA;AnHwvdR;AmHrvdI;EACI,cAAA;EACA,cAAA;EACA,0D7GoDsB;E6GnDtB,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AnHuvdR;AmHpvdI;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AnHsvdR;AmHnvdI;EACI,WAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AnHqvdR;AmHnvdQ;EACI,WAAA;EACA,aAAA;EACA,wIAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AnHqvdZ;AmHnvdY;EACI,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AnHqvdhB;AmHjvdQ;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AnHmvdZ;AmHjvdY;EACI,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AnHmvdhB;AmHhvdY;EACI,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AnHkvdhB;AmH9udQ;EACI,+BAAA;AnHgvdZ;AmH7udQ;EACI,+BAAA;AnH+udZ;AmH5udQ;EACI,+BAAA;AnH8udZ;AmH1udI;EACI;IACI,aAAA;EnH4udV;AACF;AmHzudI;EA9FJ;IA+FQ,eAAA;EnH4udN;EmH1udM;IACI,iBAAA;EnH4udV;EmHzudM;IACI,gBAAA;EnH2udV;EmHxudM;IACI,aAAA;EnH0udV;EmHvudM;IACI,uBAAA;EnHyudV;EmHvudU;IACI,kBAAA;EnHyudd;EmHtudU;IACI,kBAAA;EnHwudd;AACF;;AmHludA;EACI,eAAA;AnHqudJ;AmHnudI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CAAA;AnHqudR;AmHnudQ;EACI,kBAAA;EACA,QAAA;AnHqudZ;AmHnudY;;;EAGI,mBAAA;AnHqudhB;AmHjudQ;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,qDAAA;AnHmudZ;AmHjudY;EACI,gBAAA;AnHmudhB;AmH/tdQ;EACI,mBAAA;EACA,sBAAA;AnHiudZ;AmH9tdQ;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AnHgudZ;AmH5tdI;EAtDJ;IAuDQ,eAAA;EnH+tdN;EmH7tdM;IACI,iBAAA;EnH+tdV;AACF;;AmH1tdA;EACI,eAAA;EACA,wBAAA;AnH6tdJ;AmH3tdI;EAJJ;IAKQ,wBAAA;EnH8tdN;AACF;AmH5tdI;EACI,mBAAA;EACA,gBAAA;AnH8tdR;AmH5tdQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;AnH8tdZ;AmH1tdI;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AnH4tdR;AmH1tdQ;EAPJ;IAQQ,kBAAA;EnH6tdV;AACF;AmH1tdI;EACI,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AnH4tdR;AmHztdI;EACI,qBAAA;EACA,0D7GzKsB;E6G0KtB,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AnH2tdR;AmHxtdI;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AnH0tdR;AmHxtdQ;EACI,cAAA;AnH0tdZ;AmHttdI;EACI,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AnHwtdR;AmHrtdI;EACI,YAAA;EACA,kBAAA;AnHutdR;AmHptdI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AnHstdR;AmHptdQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;AnHstdZ;AmHltdI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AnHotdR;AmHltdQ;EANJ;IAOQ,mBAAA;IACA,oBAAA;IACA,uBAAA;IACA,SAAA;EnHqtdV;AACF;AmHltdI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AnHotdR;AmHltdQ;EAPJ;IAQQ,mBAAA;IACA,oBAAA;IACA,uBAAA;IACA,MAAA;EnHqtdV;AACF;AmHltdI;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6DAAA;EACA,2CAAA;AnHotdR;AmHltdQ;EAVJ;IAWQ,YAAA;IACA,iBAAA;IACA,eAAA;IACA,4BAAA;IACA,YAAA;IACA,gBAAA;IACA,gGAAA;IACA,kBAAA;EnHqtdV;AACF;AmHltdY;EADJ;IAEQ,kBAAA;IACA,sFAAA;IACA,cAAA;IACA,4BAAA;EnHqtdd;AACF;AmHjtdY;EADJ;IAEQ,mBAAA;IACA,4DAAA;EnHotdd;AACF;AmHjtdQ;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AnHmtdZ;AmHhtdQ;EACI,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AnHktdZ;AmH7sdQ;EACI,6DAAA;AnH+sdZ;AmH7sdY;EAHJ;IAIQ,UAAA;EnHgtdd;AACF;AmHrtdQ;EACI,qJAAA;AnHutdZ;AmHrtdY;EAHJ;IAIQ,UAAA;EnHwtdd;AACF;AmH7tdQ;EACI,wGAAA;AnH+tdZ;AmH7tdY;EAHJ;IAIQ,UAAA;EnHgudd;AACF;AmHrudQ;EACI,qJAAA;AnHuudZ;AmHrudY;EAHJ;IAIQ,UAAA;EnHwudd;AACF;AmH7udQ;EACI,6DAAA;AnH+udZ;AmH7udY;EAHJ;IAIQ,UAAA;EnHgvdd;AACF;AmH5udI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AnH8udR;AmH3udI;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AnH6udR;AmH1udI;EACI,aAAA;AnH4udR;AmH1udQ;EAHJ;IAIQ,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;IACA,2BAAA;IACA,WAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,cAAA;IACA,iBAAA;IACA,WAAA;IACA,6BAAA;EnH6udV;AACF;AmH1udI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AnH4udR;AmH1udQ;EARJ;IASQ,gBAAA;EnH6udV;AACF;AmH1udI;EACI,aAAA;AnH4udR;AmH1udQ;EAHJ;IAIQ,cAAA;IACA,kBAAA;IACA,MAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;IACA,oBAAA;EnH6udV;EmH3udU;IAEI,WAAA;IACA,kBAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,yBAAA;IACA,kBAAA;EnH4udd;EmHzudU;IACI,QAAA;IACA,mBAAA;IACA,yBAAA;IACA,4BAAA;EnH2udd;EmHxudU;IACI,WAAA;IACA,gBAAA;IACA,yBAAA;IACA,2BAAA;EnH0udd;AACF;AmHtudI;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,yCAAA;AnHwudR;AmHtudQ;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AnHwudZ;AmHrudQ;EACI,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AnHuudZ;AmHpudQ;EACI,kCAAA;EACA,cAAA;AnHsudZ;AmHludI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;AnHoudR;AmHludQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;AnHoudZ;AmHhudI;EAzUJ;IA0UQ,eAAA;EnHmudN;EmHjudM;IACI,mBAAA;EnHmudV;EmHhudM;IACI,iBAAA;EnHkudV;EmH/tdM;IACI,kBAAA;EnHiudV;AACF;;AmH5tdA;EACI,eAAA;AnH+tdJ;AmH7tdI;EACI,gBAAA;EACA,mBAAA;AnH+tdR;AmH5tdI;EACI,cAAA;EACA,cAAA;EACA,0D7GpesB;E6GqetB,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AnH8tdR;AmH3tdI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AnH6tdR;AmH1tdI;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnH4tdR;AmHztdI;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AnH2tdR;AmHztdQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AnH2tdZ;AmHztdY;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;AnH2tdhB;AmHztdgB;EACI,qBAAA;EACA,sBAAA;AnH2tdpB;AmHrtdI;EA/DJ;IAgEQ,eAAA;EnHwtdN;EmHttdM;IACI,iBAAA;EnHwtdV;EmHrtdM;IACI,iBAAA;EnHutdV;EmHptdM;IACI,SAAA;EnHstdV;EmHptdU;IACI,YAAA;EnHstdd;EmHptdc;IACI,gBAAA;IACA,gBAAA;EnHstdlB;AACF;;AmH/sdA;EACI,eAAA;AnHktdJ;AmHhtdI;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,kBAAA;AnHktdR;AmH/sdI;EACI,gBAAA;EACA,mBAAA;AnHitdR;AmH9sdI;EACI,cAAA;EACA,cAAA;EACA,0D7GtkBsB;E6GukBtB,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AnHgtdR;AmH7sdI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AnH+sdR;AmH5sdI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AnH8sdR;AmH3sdI;EACI,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AnH6sdR;AmH1sdI;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,uCAAA;AnH4sdR;AmH1sdQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;AnH4sdZ;AmH1sdY;EACI,oCAAA;EACA,cAAA;AnH4sdhB;AmHxsdQ;EACI,gBAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;AnH0sdZ;AmHvsdQ;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AnHysdZ;AmHtsdQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;AnHwsdZ;AmHrsdQ;EACI,uBAAA;EACA,yBAAA;EACA,yBAAA;AnHusdZ;AmHpsdQ;EACI,uBAAA;EACA,yBAAA;EACA,yBAAA;AnHssdZ;AmHnsdQ;EACI,uBAAA;EACA,yBAAA;EACA,yBAAA;AnHqsdZ;AmHlsdQ;EACI,uBAAA;EACA,yBAAA;EACA,yBAAA;AnHosdZ;AmHjsdQ;EACI,uBAAA;EACA,yBAAA;EACA,yBAAA;AnHmsdZ;AmHhsdQ;EACI,uBAAA;EACA,yBAAA;EACA,yBAAA;AnHksdZ;AmH9rdI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,4DAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AnHgsdR;AmH9rdQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AnHgsdZ;AmH7rdQ;EACI,eAAA;EACA,kBAAA;AnH+rdZ;AmH7rdY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AnH+rdhB;AmH5rdY;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;AnH8rdhB;AmH1rdQ;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AnH4rdZ;AmHxrdI;EACI;IACI,qCAAA;EnH0rdV;AACF;AmHvrdI;EAxLJ;IAyLQ,eAAA;EnH0rdN;EmHxrdM;IACI,kBAAA;IACA,mBAAA;EnH0rdV;EmHvrdM;IACI,iBAAA;EnHyrdV;EmHtrdM;IACI,0BAAA;IACA,SAAA;EnHwrdV;EmHrrdM;IACI,sBAAA;IACA,uBAAA;IACA,gBAAA;EnHurdV;EmHrrdU;IACI,gBAAA;EnHurdd;EmHprdU;IACI,aAAA;EnHsrdd;AACF;;AmHhrdA;EACI,eAAA;AnHmrdJ;;AmHhrdA;EACI,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AnHmrdJ;;AmHhrdA;EACI,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,mBAAA;AnHmrdJ;AmHjrdI;EACI,aAAA;EAKA,gBAAA;AnH+qdR;AmH5qdI;EACI,SAAA;EACA,gBAAA;AnH8qdR;AmH3qdI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AnH6qdR;AmH3qdQ;EACI,iBAAA;AnH6qdZ;AmHzqdI;EACI,aAAA;EACA,iBAAA;EACA,YAAA;AnH2qdR;AmHxqdI;EACI,mBAAA;AnH0qdR;AmHvqdI;EACI,mBAAA;AnHyqdR;AmHtqdI;EACI,mBAAA;AnHwqdR;AmHrqdI;EACI,mBAAA;AnHuqdR;AmHpqdI;EACI,mBAAA;AnHsqdR;AmHnqdI;EACI,mBAAA;EACA,qBAAA;AnHqqdR;AmHlqdI;EACI,mBAAA;EACA,qBAAA;AnHoqdR;AmHjqdI;EACI,mBAAA;EACA,qBAAA;AnHmqdR;AmHhqdI;EACI,mBAAA;EACA,qBAAA;AnHkqdR;AmH/pdI;EACI,mBAAA;EACA,qBAAA;AnHiqdR;;AmH7pdA;EACI,SAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AnHgqdJ;AmH9pdI;EACI,kBAAA;AnHgqdR;AmH7pdI;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AnH+pdR;AmH5pdI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AnH8pdR;AmH3pdI;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;AnH6pdR;AmH1pdI;EACI,cAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;AnH4pdR;AmHzpdI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AnH2pdR;AmHzpdQ;EACI,cAAA;AnH2pdZ;AmHxpdQ;EACI,cAAA;AnH0pdZ;AmHtpdI;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;AnHwpdR;;AmHppdA;EACI,cAAA;AnHupdJ;;AmHppdA;EACI,cAAA;AnHupdJ;;AmHppdA;EACI,cAAA;AnHupdJ;;AmHppdA;EACI,cAAA;AnHupdJ;;AmHppdA;EACI,cAAA;AnHupdJ;;AmHppdA;EACI;IACI,mBAAA;EnHupdN;EmHppdE;IACI,YAAA;EnHspdN;EmHppdM;IACI,YAAA;EnHspdV;EmHnpdM;IACI,YAAA;EnHqpdV;EmHlpdM;IACI,kBAAA;IACA,eAAA;EnHopdV;EmHlpdU;IACI,iBAAA;EnHopdd;EmH/odE;IACI,YAAA;IACA,uBAAA;EnHipdN;EmH/odM;IACI,kBAAA;IACA,gBAAA;EnHipdV;EmH9odM;IACI,kBAAA;EnHgpdV;EmH7odM;IACI,iBAAA;IACA,cAAA;EnH+odV;AACF;AmH3odA;;+EAAA;AAGA;EACI,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AnH6odJ;AmH3odI;EACI,aAAA;EACA,uBAAA;AnH6odR;AmHzodQ;EACI,aAAA;EACA,sBAAA;AnH2odZ;AmHvodY;EADJ;IAEQ,kBAAA;EnH0odd;AACF;AmHtodY;EADJ;IAEQ,kBAAA;EnHyodd;AACF;AmHrodI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AnHuodR;AmHpodI;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AnHsodR;AmHnodI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AnHqodR;AmHlodI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AnHoodR;AmHjodI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;AnHmodR;AmHhodI;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;AnHkodR;AmH/ndI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AnHiodR;AmH9ndI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AnHgodR;AmH7ndI;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;AnH+ndR;AmH7ndQ;EACI,gBAAA;AnH+ndZ;AmH5ndQ;EACI,gBAAA;EACA,kBAAA;AnH8ndZ;AmH1ndI;EACI,cAAA;EACA,qBAAA;AnH4ndR;AmHzndI;EACI,cAAA;EACA,qBAAA;EACA,2BAAA;EACA,qBAAA;AnH2ndR;AmHzndQ;EACI,cAAA;AnH2ndZ;AmHvndI;EACI,cAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;AnHyndR;AmHvndQ;EACI,cAAA;AnHyndZ;AmHrndI;EACI,WAAA;EACA,WAAA;EACA,mGAAA;EAQA,4EAAA;EACA,qBAAA;AnHgndR;AmH7mdI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AnH+mdR;AmH5mdI;EACI,SAAA;EACA,cAAA;EACA,kBAAA;AnH8mdR;AmH3mdI;EACI,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,2BAAA;AnH6mdR;AmH3mdQ;EACI,cAAA;AnH6mdZ;;AmHxmdA;EACI;IACI,sBAAA;EnH2mdN;EmHzmdM;IACI,kBAAA;EnH2mdV;EmHxmdM;IACI,eAAA;EnH0mdV;EmHvmdM;IACI,qBAAA;EnHymdV;EmHtmdM;IACI,sBAAA;IACA,kBAAA;IACA,QAAA;IACA,uBAAA;EnHwmdV;EmHrmdM;IACI,kBAAA;EnHumdV;EmHpmdM;IACI,kBAAA;EnHsmdV;AACF;AmH/ldA;EACI,mBAAA;EACA,oBAAA;EACA,gBAAA;AnHimdJ;;AmH9ldA;EACI,mBAAA;AnHimdJ;AmH/ldI;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AnHimdR;AmH9ldI;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;AnHgmdR;;AmH5ldA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AnH+ldJ;AmH3ldI;EACI,gBAAA;EACA,qBAAA;EACA,uBAAA;AnH6ldR;AmH1ldI;EACI,gCAAA;EACA,6DAAA;AnH4ldR;AmHzldI;EACI,UAAA;AnH2ldR;;AmHvldA;EACI,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AnH0ldJ;;AmHvldA;EACI,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,gBAAA;AnH0ldJ;;AmHvldA;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;AnH0ldJ;AmHxldI;;EAEI,kBAAA;EACA,gBAAA;EACA,mBAAA;AnH0ldR;AmHvldI;EACI,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gCAAA;AnHyldR;AmHtldI;EACI,gCAAA;AnHwldR;AmHrldI;EACI,mBAAA;AnHuldR;AmHpldI;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AnHsldR;;AmHlldA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;AnHqldJ;AmHnldI;EACI,cAAA;EACA,kBAAA;AnHqldR;AmHlldI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AnHoldR;AmHjldI;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;AnHmldR;AmHhldI;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AnHkldR;AmHhldQ;EACI,YAAA;EACA,mBAAA;AnHkldZ;AmH/kdQ;EACI,mBAAA;AnHildZ;;AmH5kdA;EACI;IACI,0BAAA;EnH+kdN;EmH5kdE;IACI,sBAAA;IACA,oBAAA;EnH8kdN;EmH5kdM;IACI,8BAAA;EnH8kdV;AACF;AmHvkdA;EACI,mBAAA;EACA,oBAAA;EACA,gBAAA;AnHykdJ;;AmHtkdA;EACI,6DAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,6CAAA;AnHykdJ;AmHvkdI;EACI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AnHykdR;AmHtkdI;EACI,qCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0BAAA;AnHwkdR;AmHrkdI;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AnHukdR;AmHpkdI;EACI,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AnHskdR;;AmHjkdI;EACI,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,QAAA;EACA,4CAAA;AnHokdR;AmHjkdY;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AnHmkdhB;AmHjkdgB;EACI,kBAAA;AnHmkdpB;AmHhkdgB;EACI,cAAA;EACA,mBAAA;AnHkkdpB;AmH/jdgB;EACI,8BAAA;EACA,yBAAA;EACA,4CAAA;AnHikdpB;;AmH1jdA;EACI,mBAAA;EACA,mBAAA;EACA,yBAAA;AnH6jdJ;AmH3jdI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnH6jdR;AmH3jdQ;EACI,iBAAA;EACA,cAAA;AnH6jdZ;;AmHxjdA;EACI;IACI,WAAA;IACA,sBAAA;EnH2jdN;EmHzjdM;IACI,WAAA;IACA,uBAAA;EnH2jdV;AACF;AmHvjdA;EACI,kCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AnHyjdJ;;AmHtjdA;EACI,qCAAA;EACA,cAAA;AnHyjdJ;;AmHtjdA;EACI,mBAAA;EACA,mBAAA;EACA,yBAAA;AnHyjdJ;AmHvjdI;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;AnHyjdR;AmHtjdI;;EAEI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AnHwjdR;AmHtjdQ;;EACI,qBAAA;EACA,uDAAA;AnHyjdZ;AmHrjdI;EACI,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AnHujdR;AmHrjdQ;EACI,mBAAA;EACA,qBAAA;EACA,2BAAA;AnHujdZ;AmHnjdI;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;AnHqjdR;AmHljdI;EACI,kBAAA;AnHojdR;AmHljdQ;EACI,cAAA;AnHojdZ;AmHhjdI;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AnHkjdR;;AmH9idA;EACI,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AnHijdJ;;AmH9idA;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AnHijdJ;AmH/idI;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;AnHijdR;AmH/idQ;EACI,WAAA;AnHijdZ;AmH9idQ;EACI,gBAAA;AnHgjdZ;AmH7idQ;EACI,gBAAA;AnH+idZ;AmH5idQ;EACI,gBAAA;AnH8idZ;AmH3idQ;EACI,YAAA;AnH6idZ;AmHzidI;EACI,gCAAA;EACA,uCAAA;AnH2idR;AmHzidQ;EACI,mBAAA;AnH2idZ;AmHxidQ;EACI,yBAAA;AnH0idZ;AmHvidQ;EACI,kBAAA;EACA,sBAAA;AnHyidZ;AmHtidQ;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AnHwidZ;AmHridQ;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AnHuidZ;AmHridY;EACI,kBAAA;EACA,cAAA;AnHuidhB;AmHnidQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AnHqidZ;AmHnidY;EACI,mBAAA;EACA,cAAA;AnHqidhB;AmHjidQ;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;AnHmidZ;AmHhidQ;EACI,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AnHkidZ;AmHhidY;EACI,cAAA;EACA,kBAAA;AnHkidhB;AmH/hdY;EACI,mBAAA;EACA,cAAA;AnHiidhB;AmH7hdQ;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;AnH+hdZ;AmH7hdY;EACI,kBAAA;AnH+hdhB;AmH5hdY;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;AnH8hdhB;AmH1hdQ;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AnH4hdZ;AmH1hdY;EACI,kBAAA;AnH4hdhB;AmHzhdY;EACI,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;AnH2hdhB;AmHthdI;EACI,kBAAA;AnHwhdR;AmHthdQ;EACI,iBAAA;AnHwhdZ;;AmHnhdA;EACI,kBAAA;EACA,gBAAA;AnHshdJ;;AoHh9hBI;EACI,yB9GqHG;E8GpHH,kBAAA;ApHm9hBR;AoHj9hBI;EACI,UAAA;EACA,kBAAA;ApHm9hBR;;AoH98hBA;EACI;IACI,2BAAA;IACA,uBAAA;EpHi9hBN;AACF;AqHj+hBC,WAAA;AACA;EACG,Y/GuDgD;E+GtDhD,cAAA;EACA,WAAA;ArHm+hBJ;AqHl+hBI;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;ArHo+hBR;AqHl+hBI;EACI,UAAA;EACA,gBAAA;EACA,oCAAA;EACA,gCAAA;ArHo+hBR;AqHn+hBQ;EACI,0DAAA;ArHq+hBZ;AqHj+hBI;EACI,2BAAA;EACA,yB/GmF0B;E+GlF1B,c/GqGG;AN83hBX;;AqH/9hBA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yB/G2FO;E+G1FP,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ArHk+hBJ;;AqH/9hBA;EACI,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;ArHk+hBJ;AqHh+hBQ;EACI,YAAA;EACA,WAAA;ArHk+hBZ;AqH/9hBI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;EACA,iEAAA;ArHi+hBR;;AqH79hBA;EACI,aAAA;EACA,kBAAA;ArHg+hBJ;AqH99hBQ;EACI,WAAA;EACA,YAAA;ArHg+hBZ;AqH79hBI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;ArH+9hBR;;AqH39hBA;EACI,gBAAA;EACA,eAAA;EACA,aAAA;ArH89hBJ;AqH79hBI;EACI,mBAAA;ArH+9hBR;AqH99hBQ;EACI,aAAA;ArHg+hBZ;AqH79hBY;EACI,cAAA;ArH+9hBhB;AqH19hBI;EACI,mB/GW0B;E+GV1B,c/G6BG;E+G5BH,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;ArH49hBR;AqH39hBQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;ArH69hBZ;AqH39hBQ;EACI,SAAA;EACA,UAAA;ArH69hBZ;AqH39hBQ;EACI,WAAA;EACA,MAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;ArH69hBZ;AqH19hBI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;ArH49hBR;AqHz9hBQ;EACI,uBAAA;EACA,4BAAA;EACA,qBAAA;ArH29hBZ;AqHz9hBQ;EACI,yB/GjCsB;E+GkCtB,c/GbD;ANw+hBX;AqH19hBY;EACI,yBAAA;EACA,YAAA;EACA,UAAA;ArH49hBhB;;AsHnmiBA;EACI,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AtHsmiBJ;AsHpmiBI;EACI,YAAA;AtHsmiBR;;AuHrniBA;EACI,2BAAA;AvHwniBJ;AuHvniBI;EACI,qEAAA;EAEA,gBjH2rBsB;AN67gB9B;AuHtniBI;EACI,cAAA;AvHwniBR;;AuHpniBA;;;EAGI,qEAAA;AvHuniBJ;;AuHpniBA;EACI,gBjH6qB0B;AN08gB9B;;AuHpniBA;EACI,oBAAA;EACA,ejHiE8C;ANsjiBlD;;AuHpniBA;EACI,yBAAA;AvHuniBJ;;AuHlniBI;;EACI,qEAAA;EACA,ajH0FG;EiHzFH,gBjH4pBsB;AN09gB9B;;AuH/miBI;;;EACI,ajHiFG;ANmiiBX;;AuH/miBI;EACI,iBAAA;EACA,ejHuEG;AN2iiBX;AuHhniBI;EACI,ejHoEG;AN8iiBX;;AuHtmiBI;EACI,qBAAA;AvHymiBR;;AuHpmiBI;EACI,wBAAA;EACA,qEAAA;AvHumiBR;;AuHjmiBI;EACI,2BAAA;EACA,gBAAA;AvHomiBR;AuHlmiBI;EACI,2BAAA;EACA,4BAAA;AvHomiBR;AuHlmiBI;EACI,kCAAA;AvHomiBR;;AuH/liBI;EACI,8BAAA;AvHkmiBR;;AuH7liBI;EACI,0DAAA;AvHgmiBR;;AuH3liBI;EACI,0BAAA;AvH8liBR;;AuHzliBI;EACI,ajHrB0C;ANiniBlD;AuH1liBI;EACI,yDAAA;EACA,gBjH0kBsB;ANkhhB9B;;AwHhtiBA;EACI,WAAA;EACA,gBAAA;AxHmtiBJ;;AwH9siBQ;;;EAEE,yBAAA;AxHktiBV;AwH/siBI;EACI,wBAAA;EACA,yBlHyGG;ANwmiBX;;AwH5siBA;EACI,2BAAA;AxH+siBJ;;AwH3siBI;EACI,gBAAA;AxH8siBR;;AwH1siBA;EACI,+BAAA;AxH6siBJ;AwH3siBI;EACI,6BAAA;EACA,gCAAA;EACA,yBAAA;AxH6siBR;;AwHxsiBI;EACI,gBlH6B4C;AN8qiBpD;;AwHvsiBA;EACI,4BAAA;AxH0siBJ;;AwHvsiBA;EACI,uBAAA;AxH0siBJ;;AwHrsiBI;;;;;EAKI,UAAA;AxHwsiBR;;AwHnsiBI;EACI,mBlHuDG;EkHtDH,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBlHD4C;ANusiBpD;;AwHhsiBI;;;;;;;EAOI,qBlHqCG;AN8piBX;AwHhsiBI;;EAEI,mBlHgCG;ANkqiBX;;AwH7riBA;EACI,mBlH0BO;EkHzBP,YAAA;EACA,clH4BO;EkH3BP,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AxHgsiBJ;;AwH7riBA;EACI,oBAAA;EACA,eAAA;AxHgsiBJ;;AwH7riBA;;;EAGI,mBlHOO;ANyriBX;;AwH7riBA;;;EAGI,yBlH4BM;EkH3BN,WlHHO;EkHIP,iBAAA;AxHgsiBJ;;AwH5riBI;EACI,gBlHTG;ANwsiBX;;AwH3riBA;EACI,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;AxH8riBJ;;AwH3riBA;EACI,YAAA;EACA,cAAA;EACA,iBAAA;EACA,WlH3BO;EkH4BP,kBAAA;AxH8riBJ;;AwHzriBQ;EACI,kBAAA;AxH4riBZ;AwHxriBI;EACI,kBAAA;AxH0riBR;AwHvriBI;EACI,WlH3CG;ANouiBX;;AwHpriBI;EACI,WlHjDG;ANwuiBX;;AwHjriBQ;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBlH5DD;EkH6DC,kBAAA;EACA,WAAA;EACA,eAAA;AxHoriBZ;;AclyiBI;E0GoHA;IACI,yBAAA;ExHkriBN;EwHjriBM;;;IAGI,gBAAA;IACA,WAAA;IACA,cAAA;IACA,WAAA;IACA,cAAA;ExHmriBV;EwH5qiBc;IACI,WAAA;ExH8qiBlB;EwHxqiBE;IACI,aAAA;ExH0qiBN;AACF;AwHrqiBI;EzF/FF,uBAAA;E1BsKI,oBALI;EE7QN,sBAAA;APq3iBJ;;AwHrqiBA;;EAEI,WlH3GO;ANmxiBX;;AwHlqiBY;EACI,oCAAA;EACA,uCAAA;EACA,sBlHsZc;AN+whB9B;AwHnqiBY;EACI,qCAAA;EACA,wCAAA;EACA,sBlHiZc;ANoxhB9B;;AwH7piBQ;EACI,mCAAA;AxHgqiBZ;AwH3piBQ;EACI,kCAAA;AxH6piBZ;AwHvpiBY;EACI,oCAAA;AxHypiBhB;AwHrpiBQ;EACI,sBAAA;AxHupiBZ;;AwHlpiBA;EACI,sBAAA;AxHqpiBJ;;AyHt6iBA;EACI,sBnHsHO;EmHrHP,UAAA;AzHy6iBJ;AyHx6iBI;EACE,uBAAA;EACE,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cnHuHG;ANmziBX;AyHz6iBQ;EACE,yBnH8GC;AN6ziBX;AyHz6iBQ;EACE,yBnH+IA;EmH9IA,gBAAA;EACA,eAAA;AzH26iBV;;AyHv6iBE;EACE,2EAAA;AzH06iBJ;;AyHx6iBE;EACE,sBnHgGO;EmH/FP,gCAAA;EACA,cnHqGO;ANs0iBX;AyH16iBI;EACE,aAAA;AzH46iBN;;AyHx6iBI;EACE,cAAA;AzH26iBN;AyHx6iBM;EACI,YAAA;EACF,qCAAA;EACA,wCAAA;EACA,sCAAA;EACA,yCAAA;AzH06iBR;AyHv6iBI;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCnHilBwB;EmHhlBxB,mCnHglBwB;ANy1hB9B;;AyHt6iBE;EACI,uBAAA;AzHy6iBN;;A0H79iBA;EACI,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iCAAA;EACA,4CpHooB0B;EoHnoB1B,4BAAA;EACA,kBAAA;EACA,6BAAA;A1Hg+iBJ;;A0H79iBA;EACI,sBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qEAAA;EACA,2BAAA;A1Hg+iBJ;;A2Hh/iBA;EACI,UAAA;A3Hm/iBJ;;A2Hh/iBA;EACI,oCAAA;EACA,8BAAA;A3Hm/iBJ;A2H9+iBQ;;EAEI,yBrHuIF;ANy2iBV;A2H9+iBY;;EACI,qBrHoIN;AN62iBV;A2H7+iBY;EACI,wBAAA;A3H++iBhB;A2H3+iBQ;EACI,qCAAA;EACA,oBAAA;EACA,crHwHF;EqHvHE,0CAAA;A3H6+iBZ;A2Hp+iBY;;;;;EACI,UAAA;EACA,UAAA;EACA,YAAA;A3H0+iBhB;A2Hx+iBY;;;;;EACI,YAAA;EACA,UAAA;EACA,YAAA;A3H8+iBhB;A2Hz+iBgB;EAGI,mBAAA;EACA,qBrHuuBU;ANkwhB9B;;A2Hl+iBA;EACI,gBrHQgD;AN69iBpD;;A2H39iBoB;EACI,4CrH+jBM;EqH9jBN,yBrHgFd;AN84iBV;A2Ht9iBoB;EACI,yBrHoEd;ANo5iBV;;A2H/8iBA;EACI,yBrHsDM;EqHrDN,YAAA;EACA,WrHsBO;EqHrBP,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;A3Hk9iBJ;A2Hh9iBI;EACI,mBAAA;EACA,0CAAA;EACA,WrHaG;ANq8iBX;;Acn/iBI;E6GsCA;IACI,qBAAA;IACA,iBAAA;E3Hi9iBN;E2H98iBE;IACI,aAAA;E3Hg9iBN;E2H78iBM;IACI,kBAAA;IACA,cAAA;IACA,6BAAA;E3H+8iBV;E2H58iBE;IACI,qBAAA;IACA,qBrHqWC;ENymiBP;AACF;A2H18iBI;EACI,yBrHdG;AN09iBX;;A2Hx8iBA;EACI,iBAAA;A3H28iBJ;A2H18iBI;EACI,kBAAA;EACA,0BAAA;A3H48iBR;;A4HtkjBA;;;EACE,iBAAA;EACA,kBAAA;A5H2kjBF;A4HzkjBE;;;;;EAEE,uBAAA;EACA,kBAAA;EACA,6BAAA;EAEA,SAAA;EACA,UAAA;A5H6kjBJ;A4H1kjBE;;;EACE,WAAA;EACA,WAAA;EACA,iBAnBwB;EAqBxB,UAAA;EACA,wEtHktCgC;AN23gBpC;;A4HzkjBA;EAGE,MAAA;EACA,gBAAA;A5H0kjBF;A4HxkjBE;EAEE,gBAAA;EACA,4BtHwEO;ANigjBX;A4HtkjBE;EACE,QAAA;EACA,yBtH6DO;AN2gjBX;;A4HpkjBA;;;EAGE,SAAA;EACA,mBAAA;A5HukjBF;A4HrkjBE;;;;;EAEE,mBAAA;EACA,yBtHsDO;ANohjBX;A4HvkjBE;;;EACE,WAAA;EACA,sBtH2CO;ANgijBX;;A4HvkjBA;EACE,cAAA;A5H0kjBF;;A4HvkjBA;EACE,0DtH2lB4B;EsH1lB5B,mBtHmmB4B;EsHlmB5B,sBtHgCS;EsH/BT,ctHqCS;EsHpCT,qEAAA;EACA,qBAhF0B;EAiF1B,qBAAA;EACA,kBAAA;A5H0kjBF;;A4HtkjBE;EACE,UAAA;A5HykjBJ;A4HtkjBE;EACE,cAAA;A5HwkjBJ;A4HrkjBE;EACE,qBAAA;A5HukjBJ;A4HpkjBE;EACE,qBAAA;A5HskjBJ;;A4HlkjBA;EACE,kBAAA;EACA,UAAA;A5HqkjBF;;A4HlkjBA;EACE,UAAA;A5HqkjBF;A4HnkjBE;EACE,iBAAA;A5HqkjBJ;A4H9jjBE;EACE,oBAAA;A5HgkjBJ;A4HzjjBE;EACE,iBAxHwB;A5HmrjB5B;A4HzjjBI;EACE,UAAA;EACA,WAAA;A5H2jjBN;A4HvjjBE;EACE,kBAjIwB;A5H0rjB5B;A4HvjjBI;EACE,UAAA;EACA,WAAA;A5HyjjBN;;A4HpjjBA;EACE,kBAAA;EACA,sBtHvCS;EsHwCT,4EAAA;EACA,8BAtJ0B;EAuJ1B,+BAvJ0B;EAwJ1B,gBAAA;EACA,kBAAA;A5HujjBF;A4HrjjBE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;A5HujjBJ;;A4HnjjBA;;;;;;EAME,qBAAA;EACA,aAAA;A5HsjjBF;;A4HnjjBA;;;EAGE,aAAA;EACA,ctH7DS;EsH8DT,iBAAA;EACA,mBtH6f4B;ANyjiB9B;;A4HnjjBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;A5HsjjBF;;A4HnjjBA;EACE,gBAAA;EACA,iBAxLsB;EAyLtB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,iCAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;A5HsjjBF;A4HpjjBE;EACE,UAAA;EACA,2BtH1FO;ANgpjBX;A4HpjjBI;EACE,uEAAA;A5HsjjBN;A4HnjjBI;EAEE,sEAvNkC;EAwNlC,eAAA;A5HojjBN;A4HhjjBE;EACE,WAAA;EACA,0BtHzGO;AN2pjBX;A4HhjjBI;EACE,WAAA;A5HkjjBN;A4H/ijBI;EACE,sEAAA;A5HijjBN;A4H9ijBI;EAEE,qEA1OkC;EA2OlC,eAAA;A5H+ijBN;A4H3ijBE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5H6ijBJ;A4H3ijBI;EACE,QAAA;EACA,yBtHnIK;ANgrjBX;A4H3ijBM;EACE,qEAAA;A5H6ijBR;A4HzijBI;EACE,SAAA;EACA,4BtH5IK;ANurjBX;A4HzijBM;EACE,wEAAA;A5H2ijBR;;A4HrijBA;EACE,WAAA;A5HwijBF;;A4HrijBA;EACE,cAvQmB;EAwQnB,kBAAA;A5HwijBF;A4HtijBE;EACE,qBAAA;EACA,WAAA;EACA,WAAA;A5HwijBJ;;A4HpijBA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;A5HuijBF;A4HrijBE;EACE,qBAAA;A5HuijBJ;A4HpijBE;EACE,qBAAA;A5HsijBJ;A4HpijBI;EACE,qBAAA;EACA,iBAAA;A5HsijBN;A4HpijBM;EACE,WAAA;A5HsijBR;A4HnijBM;;EAEE,wBAAA;EACA,SAAA;A5HqijBR;A4HlijBM;EACE,0BAAA;A5HoijBR;A4HhijBI;EACE,gBAAA;EACA,qBAAA;A5HkijBN;;A4H7hjBA;EACE,YAAA;EACA,0EAAA;EACA,YAAA;A5HgijBF;A4H9hjBE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;A5HgijBJ;A4H7hjBE;EACE,kBAAA;EACA,gBtHlOO;ANiwjBX;A4H7hjBI;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;A5H+hjBN;A4H7hjBM;EACE,gBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;A5H+hjBR;A4H7hjBQ;EACE,YAAA;EACA,iBAAA;EACA,wBAAA;A5H+hjBV;A4H7hjBU;EACE,eAAA;EACA,sBtH3PD;AN0xjBX;A4H5hjBU;EACE,yBtHjOF;EsHkOE,YAAA;EACA,iBAAA;A5H8hjBZ;A4H5hjBY;EACE,yBtHtOJ;ANowjBV;A4H1hjBU;EACE,ctHnQD;AN+xjBX;A4H1hjBY;EACE,eAAA;EACA,6BAAA;A5H4hjBd;;A4HnhjBA;EACE,ctHjRS;EsHkRT,qBAAA;EACA,WAjYsB;EAkYtB,iBAlYsB;EAmYtB,kBAAA;EACA,gBAxYuB;A5H85jBzB;A4HphjBE;EACE,eAAA;A5HshjBJ;A4HphjBI;EACE,qBA/YsB;EAgZtB,sBtHnSK;ANyzjBX;;A4HjhjBA;;EAEE,mBAAA;A5HohjBF;;A4HjhjBA;;;EAGE,ctH1SS;EsH2ST,qBAAA;EACA,WA1ZsB;EA2ZtB,YA3ZsB;EA4ZtB,iBA5ZsB;EA6ZtB,kBAAA;EACA,gBAlauB;A5Hs7jBzB;;A4HhhjBE;EAGE,qBA1awB;EA2axB,yBtHhSM;EsHiSN,WAAA;A5HihjBJ;A4H/gjBI;EACE,qEAAA;A5HihjBN;A4H7gjBE;EACE,ctHjUO;EsHkUP,oBAAA;A5H+gjBJ;A4H7gjBI;EACE,eAAA;EACA,6BAAA;A5H+gjBN;;A4H1gjBA;;EAEE,eAAA;A5H6gjBF;A4H3gjBE;;EACE,qBAncwB;EAocxB,yBtHzTM;EsH0TN,sBAAA;A5H8gjBJ;A4H3gjBE;;EACE,iBAAA;A5H8gjBJ;A4H3gjBE;;EACE,qBA7cwB;EA8cxB,yBtHnUM;EsHoUN,WAAA;A5H8gjBJ;A4H5gjBI;;EACE,qEAAA;A5H+gjBN;A4H5gjBI;;EACE,cAAA;A5H+gjBN;A4H5gjBI;;EACE,YAAA;A5H+gjBN;A4H3gjBE;;;;EAGE,qBAjewB;EAkexB,yBtHvVM;EsHwVN,WAAA;A5H8gjBJ;A4H5gjBI;;;;EACE,qEAAA;A5HihjBN;A4H7gjBE;;EACE,qBA3ewB;EA4exB,qEAAA;EACA,WAAA;A5HghjBJ;A4H9gjBI;;EACE,qEAAA;A5HihjBN;A4H7gjBE;;;;EACE,yCAAA;A5HkhjBJ;A4H9gjBI;;;;EACE,sBtH7YK;EsH8YL,ctHxYK;AN25jBX;A4H/gjBE;;EACE,eAAA;EACA,ctH9YO;ANg6jBX;A4HhhjBI;;EACE,6BAAA;A5HmhjBN;;A4H3gjBI;EACE,yBtHlYI;ANg5jBV;A4H1gjBE;EACE,sBtHraO;ANi7jBX;;A4HxgjBA;EACE,kBAAA;EACA,cAAA;A5H2gjBF;;A4HxgjBA;;;EAGE,6BAAA;EACA,qBA/hB0B;A5H0ikB5B;A4HzgjBE;;;EACE,eAAA;A5H6gjBJ;A4H3gjBI;;;;;;EAEE,qEAAA;A5HihjBN;A4H7gjBE;;;EAEE,yBtHzbO;EsH0bP,YAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBA1iB0B;A5H0jkB9B;;A4H5gjBA;;;EAGE,sBtH3cS;EsH4cT,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBA/jB0B;EAgkB1B,qEAAA;A5H+gjBF;A4H7gjBE;;;EACE,eAAA;A5HihjBJ;A4H9gjBE;;;EACE,aAAA;EACA,kBAAA;A5HkhjBJ;;A4H9gjBA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5HihjBF;A4H/gjBE;;;EACE,8BAtlBwB;EAulBxB,+BAvlBwB;A5H0mkB5B;A4HhhjBE;;;EACE,yBAAA;EAGA,iBAAA;EACA,iCA/lBwB;EAgmBxB,kCAhmBwB;A5HonkB5B;A4HjhjBE;;;EACE,yBtHjfO;ANsgkBX;A4HnhjBI;;;EACE,wEAAA;A5HuhjBN;A4HphjBI;;;EACE,qEAAA;A5HwhjBN;A4HphjBE;;;EACE,kBAAA;EACA,UAAA;A5HwhjBJ;;A4HphjBA;EACE,6BAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;A5HuhjBF;A4HrhjBE;EACE,yBtHxfM;EsHyfN,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A5HuhjBJ;;A4HnhjBA;EACE,gBtH1iBS;EsH2iBT,yEAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;A5HshjBF;;A4HnhjBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;A5HshjBF;A4HphjBE;;;EAGE,WAAA;EACA,iBAAA;A5HshjBJ;A4HlhjBE;EACE;;;IAGE,WAAA;IACA,iBAAA;E5HohjBJ;AACF;A4HjhjBE;;EAEE,mBAAA;A5HmhjBJ;A4HhhjBE;EACE,iCAAA;A5HkhjBJ;A4H/gjBE;EACE,2BtHplBO;ANqmkBX;A4H/gjBI;EACE,uEAAA;A5HihjBN;A4H9gjBI;EAEE,sEAjtBkC;EAktBlC,eAAA;A5H+gjBN;A4H3gjBE;EACE,0BtHlmBO;AN+mkBX;A4H3gjBI;EACE,sEAAA;A5H6gjBN;A4H1gjBI;EAEE,qEA/tBkC;EAguBlC,eAAA;A5H2gjBN;;A4HrgjBA;EACE,wBAAA;A5HwgjBF;;A4HngjBE;EACE,WAAA;A5HsgjBJ;A4HpgjBE;EACE,WAAA;A5HsgjBJ;A4HpgjBI;EACE,WAAA;A5HsgjBN;A4HpgjBM;EACE,iBAAA;A5HsgjBR;A4HngjBM;;EAEE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;A5HqgjBR;;A6H1wkBA;EACI,gBAAA;EACA,qEAAA;A7H6wkBJ;A6H3wkBI;EACI,uBAAA;EACA,aAAA;A7H6wkBR;A6H3wkBI;EACI,wCAAA;EACA,gBAAA;A7H6wkBR;;A6HtwkBI;EACI,6BAAA;A7HywkBR;A6HpwkBY;EACI,cvHoGL;ANkqkBX;A6HrwkBgB;EACI,cvHkGT;ANqqkBX;A6HrwkBgB;EACI,mBvHuHV;ANgpkBV;A6HnwkBgB;EACI,yBAAA;A7HqwkBpB;A6HjwkBgB;EACI,yBAAA;A7HmwkBpB;A6HlwkBoB;EACI,mBvHkHd;ANkpkBV;;A6HzvkBI;EACI,mBvHoEG;EuHnEH,4BvHmEG;ANyrkBX;A6H1vkBY;EACI,yBAAA;A7H4vkBhB;A6H3vkBgB;EACI,yBAAA;EACA,kBAAA;A7H6vkBpB;A6HxvkBgB;EACI,kBAAA;A7H0vkBpB;A6HtvkBY;EACI,mBvHkDL;EuHjDK,cvHoDL;ANoskBX;A6HpvkBgB;EACI,qCAAA;EACA,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;A7HsvkBpB;A6HpvkBgB;EACI,qCAAA;EACA,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;A7HsvkBpB;A6HlvkBgB;EACI,8BAAA;EACA,gCAAA;EACA,kBAAA;A7HovkBpB;A6HnvkBoB;EACI,qCAAA;EACA,0BAAA;A7HqvkBxB;A6H/ukBgB;EACI,0EAAA;EACA,4EAAA;EACA,yBAAA;A7HivkBpB;A6HhvkBoB;EACI,iFAAA;EACA,0BAAA;A7HkvkBxB;A6HhvkBoB;EACI,iFAAA;EACA,0BAAA;A7HkvkBxB;;A6HvukBI;EACI,gBAAA;EACA,6BAAA;A7H0ukBR;A6HzukBQ;EACI,yBvH3BD;ANswkBX;A6HzukBQ;EACI,iBAAA;EACA,eAAA;A7H2ukBZ;A6H1ukBY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBvHrCL;EuHsCK,gCAAA;EACA,2BAAA;A7H4ukBhB;A6H3ukBgB;EACI,yBvHzCT;ANsxkBX;A6HzukBgB;EACI,aAAA;EACA,WAAA;A7H2ukBpB;A6HvukBY;EACI,cvHjDL;AN0xkBX;A6HxukBgB;EACI,cvHnDT;AN6xkBX;A6HtukBgB;EACI,8BAAA;EACA,gCAAA;EACA,sBAAA;A7HwukBpB;A6HvukBoB;EACI,cvHpCd;AN6wkBV;A6HnukBgB;EACI,8BAAA;EACA,gCAAA;EACA,sBAAA;A7HqukBpB;A6HpukBoB;EACI,cvHxCd;AN8wkBV;;A6H3tkBI;EACI,6BAAA;A7H8tkBR;A6H7tkBQ;EACI,yBvHxFD;ANuzkBX;A6H3tkBgB;EACI,YAAA;EACA,mBvH9FT;AN2zkBX;A6H1tkBgB;EACI,SAAA;EACA,YAAA;EACA,mBvHnGT;AN+zkBX;A6HztkBY;EACI,cvHrGL;ANg0kBX;A6HxtkBgB;EACI,cvHjFV;AN2ykBV;A6HztkBoB;EACI,mBvHnFd;AN8ykBV;A6HttkBgB;EACI,cvHlFV;AN0ykBV;A6HvtkBoB;EACI,mBvHpFd;AN6ykBV;;A6H9skBgB;EACI,SAAA;A7HitkBpB;;A6HtskBA;EAGY;IACI,cAAA;IACA,WAAA;E7HuskBd;E6HhskBc;IACI,kBAAA;E7HkskBlB;E6H5rkBM;IACI,mBAAA;E7H8rkBV;E6H7rkBU;IACI,UAAA;E7H+rkBd;E6H7rkBU;IACI,mBAAA;E7H+rkBd;E6H7rkBkB;IACI,YAAA;IACA,UAAA;E7H+rkBtB;E6HvrkBU;IACI,UAAA;IACA,QAAA;IACA,kBAAA;IACA,gBAAA;E7HyrkBd;E6HvrkBU;IACI,cAAA;E7HyrkBd;E6HxrkBc;IACI,gBAAA;E7H0rkBlB;E6HzrkBkB;IACI,WAAA;IACA,kBAAA;IACA,gBAAA;E7H2rkBtB;E6HzrkBkB;IACI,UAAA;IACA,sBAAA;IACA,kBAAA;IACA,gBAAA;E7H2rkBtB;AACF;A8H1/kBA;EACI,sBAAA;A9H4/kBJ;A8H1/kBI;EACI,yBAAA;EACA,kCxH09BgC;EwHz9BhC,sBxHgHG;EwH/GH,aAAA;A9H4/kBR;A8H3/kBQ;EACI,iBAAA;EACA,kBAAA;EACA,cxHkHD;EwHjHC,gBAAA;A9H6/kBZ;A8H3/kBQ;EACI,YAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;A9H6/kBZ;A8H5/kBY;EACI,yDAAA;EACA,2BAAA;A9H8/kBhB;A8Hz/kBI;EACI,cxHgGG;AN25kBX;;A8Hp/kBY;EACI,oEAAA;EACA,sCAAA;A9Hu/kBhB;;A8Hj/kBA;EACI,iBAAA;EACA,gBAAA;A9Ho/kBJ;;A8Hj/kBA;EACI,mEAAA;EACA,6CxHslB0B;EwHrlB1B,sBxHoEO;ANg7kBX;;A8Hh/kBI;EACI,aAAA;EACA,uBAAA;A9Hm/kBR;A8Hl/kBQ;EACI,aAAA;EACA,yBAAA;EACA,sBxH0DD;EwHzDC,cxHgED;EwH/DC,gBAAA;A9Ho/kBZ;A8Hj/kBI;EACI,yBxHkFE;ANi6kBV;A8Hj/kBI;EACI,uBAAA;EACA,cxHwDG;AN27kBX;A8Hl/kBQ;EACI,yBxH4EF;EwH3EE,WxH6CD;ANu8kBX;;A8H9+kBI;EACI,sCxH+4BgC;EwH94BhC,oCAAA;EACA,sBxHoCG;EwHnCH,aAAA;A9Hi/kBR;A8Hh/kBQ;EACI,aAAA;EACA,iBAAA;A9Hk/kBZ;A8Hh/kBQ;EACI,iBAAA;EACA,WAAA;EACA,gBAAA;A9Hk/kBZ;A8Hh/kBQ;EACI,SAAA;EACA,cxH8BD;ANo9kBX;A8Hh/kBQ;EACI,yBxHkDF;EwHjDE,YAAA;EACA,WxHkBD;EwHjBC,kBAAA;EAEA,WAAA;A9Hi/kBZ;A8H/+kBQ;EACI,WxHYD;EwHXC,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;A9Hi/kBZ;A8Hh/kBY;EACI,WxHKL;EwHJK,yBxHkCN;ANg9kBV;A8H9+kBI;EACI,WAAA;A9Hg/kBR;A8H/+kBQ;EACI,eAAA;A9Hi/kBZ;;A+H9mlBA;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;A/HinlBJ;;A+H9mlBA;EACI,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;A/HinlBJ;;A+H9mlBA;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;A/HinlBJ;;A+H9mlBA;EACI,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;A/HinlBJ;;A+H9mlBA;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,mFAAA;EACA,eAAA;EACA,kDAAA;EACA,gBAAA;EACA,0CAAA;EACA,qBAAA;A/HinlBJ;;A+H9mlBA;;EAEI,aAAA;A/HinlBJ;;A+H9mlBA;;EAEI,YAAA;EACA,cAAA;A/HinlBJ;;A+H9mlBA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;A/HinlBJ;;A+H9mlBA;EACI,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A/HinlBJ;;A+H9mlBA;EACI,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;A/HinlBJ;;A+H9mlBA;EACI,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;A/HinlBJ;;A+H9mlBA;EACI,oBAAA;EACA,iBAAA;EACA,yBAAA;A/HinlBJ;;A+H9mlBA;EACI,mBAAA;A/HinlBJ;;A+H9mlBA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A/HinlBJ;;A+H9mlBA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;A/HinlBJ;;A+H9mlBA;EACI,0DAAA;EACA,YAAA;EACA,6BAAA;A/HinlBJ;;A+H9mlBA;EACI,MAAA;EACA,WAAA;A/HinlBJ;;A+H9mlBA;EACI,QAAA;EACA,WAAA;A/HinlBJ;;A+H9mlBA;EACI,OAAA;EACA,YAAA;A/HinlBJ;;A+H9mlBA;EACI,YAAA;EACA,SAAA;EACA,UAAA;A/HinlBJ;;A+H9mlBA;EACI,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A/HinlBJ;;A+H9mlBA,gBAAA;AACA;EACI,WAAA;EACA,OAAA;A/HinlBJ;;A+H9mlBA;EACI,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A/HinlBJ;;A+H9mlBA;EACI,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;A/HinlBJ;;A+H9mlBA;EACI,YAAA;A/HinlBJ;;AgIt0lBA;EACI,kFAAA;EACA,WAAA;EACA,gBAAA;AhIy0lBJ;AgIv0lBI;EACI,gBAAA;EACA,yBAAA;AhIy0lBR;AgIv0lBQ;EACI,gBAAA;EACA,oEAAA;AhIy0lBZ;AgIt0lBI;EACI,sB1HuGG;ANiulBX;AgIt0lBY;EACI,YAAA;EACA,iBAAA;EACA,c1HwGL;ANgulBX;AgIt0lBY;EACI,yB1H6HN;E0H5HM,W1H8FL;AN0ulBX;AgIp0lBI;EACI,sB1HyFG;AN6ulBX;AgIp0lBY;EACI,YAAA;EACA,iBAAA;EACA,c1H0FL;AN4ulBX;AgIp0lBY;EACI,yB1H+GN;E0H9GM,W1HgFL;ANsvlBX;;AgIh0lBA;EACI,gBAAA;EACA,wBAAA;AhIm0lBJ;;AgIh0lBA;EACI,gB1HoBgD;E0HnBhD,0D1HgBgD;E0HfhD,yBAAA;EACA,eAAA;EACA,4BAAA;AhIm0lBJ;;AiIv3lBQ;EACI,UAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;AjI03lBZ;;AkIh4lBA;EACI,SAAA;EACA,UAAA;AlIm4lBJ;AkIj4lBI;EACI,gBAAA;EACA,c5HkJE;E4HjJF,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;EACA,kBAAA;AlIm4lBR;AkIj4lBQ;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AlIm4lBZ;AkIh4lBQ;EACI,WAAA;EACA,6BAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AlIk4lBZ;;AkI73lBA;EACI,qB5HsHM;AN0wlBV;;AkI73lBA;EACI,qB5HqHM;AN2wlBV;;AmIt6lBA;EACI,0D7H8qB0B;E6H7qB1B,kC7H8nB0B;E6H7nB1B,mC7H6nB0B;AN4ykB9B;AmIv6lBI;EACI,qB7HoHG;ANqzlBX;;AmIr6lBA;EACI,yBAAA;EACA,sB7HonB0B;ANozkB9B;;AmIr6lBA;EACI,qEAAA;EACA,+B7H+mB0B;E6H9mB1B,gC7H8mB0B;AN0zkB9B;AmIv6lBI;EACI,wBAAA;EACA,c7HwGG;ANi0lBX;AmIv6lBQ;EACI,yBAAA;AnIy6lBZ;AmIr6lBI;EACI,qB7H6FG;AN00lBX;AmIp6lBY;EACI,yBAAA;AnIs6lBhB;AmIn6lBQ;EACI,kBAAA;EACA,cAAA;AnIq6lBZ;;AmI/5lBI;;;EAGI,e7H8EG;ANo1lBX;AmIh6lBI;EACI,a7H2EG;ANu1lBX;;AmI75lBI;EACI,sB7H8DG;E6H7DH,4EAAA;AnIg6lBR;;AmI35lBA;EACI,gBAAA;AnI85lBJ;;AmI35lBA;EACI,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;AnI85lBJ;;AmIz5lBQ;EACI,mBAAA;EACA,gBAAA;AnI45lBZ;AmIx5lBQ;EACI,mBAAA;EACA,mBAAA;EACA,iBAAA;AnI05lBZ;;AmIp5lBI;EACI,mBAAA;EACA,gBAAA;AnIu5lBR;;AmIl5lBA;EACQ,gCAAA;AnIq5lBR;AmIn5lBI;EACI,kCAAA;EACA,2CAAA;EACA,YAAA;AnIq5lBR;AmIn5lBQ;EACI,2BAAA;EACA,oCAAA;AnIq5lBZ;AmIp5lBY;EACI,2BAAA;AnIs5lBhB;AmIn5lBY;EACI,wBAAA;AnIq5lBhB;AmIl5lBY;EACI,8BAAA;AnIo5lBhB;AmIh5lBS;EACI,kCAAA;AnIk5lBb;AmI94lBI;EACI,gCAAA;AnIg5lBR;;AmIz4lBI;EACI,2BAAA;EACA,gCAAA;AnI44lBR;AmI14lBI;EACI,gCAAA;AnI44lBR;AmI14lBQ;EACI,gCAAA;AnI44lBZ;AmIz4lBQ;EACI,yBAAA;AnI24lBZ;AmI14lBY;EACI,0EAAA;EACA,oCAAA;AnI44lBhB;AmIr4lBY;EACI,qB7HjCL;ANw6lBX;AmIn4lBY;EACI,c7HtCL;AN26lBX;AmIp4lBgB;EACI,kCAAA;EACA,yBAAA;AnIs4lBpB;;AoI5imBI;EACI,yBAAA;EACA,iCAAA;ApI+imBR;AoI7imBQ;EACI,yBAAA;ApI+imBZ;;AoI1imBA;EACI,2EAAA;EACA,2BAAA;ApI6imBJ;;AoI1imBA;EACI,wBAAA;ApI6imBJ;;AoI3imBA;EACI,yBAAA;ApI8imBJ;;AoI5imBA;EACI,yBAAA;ApI+imBJ;;AoI5imBA;EACI,iCAAA;EACA,wDAAA;EACA,uBAAA;EACA,iCAAA;EACA,wBAAA;ApI+imBJ;;AoI5imBA;EACI,8EAAA;EACA,iCAAA;ApI+imBJ;;AoI5imBA;EACI,yBAAA;ApI+imBJ;;AoI7imBA;EACI,oDAAA;EACA,yBAAA;ApIgjmBJ;AoI9imBI;EACI,c9HqGE;AN28lBV;AoI5imBQ;EACI,yCAAA;EACA,c9H+FF;AN+8lBV;;AoIximBA;EACI,oDAAA;EACA,yBAAA;ApI2imBJ;AoI1imBI;EACI,6BAAA;EACA,YAAA;ApI4imBR;AoI3imBQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ApI6imBZ;;AoIximBA;EACI,2BAAA;EACA,iCAAA;EACA,2EAAA;ApI2imBJ;;AoIpimBY;EACI,yBAAA;ApIuimBhB;AoInimBI;EACI,iBAAA;ApIqimBR;AoInimBI;EACI,wBAAA;EACA,c9H0BG;E8HzBH,wCAAA;ApIqimBR;AoInimBQ;EACI,sBAAA;EACA,oCAAA;ApIqimBZ;AoIlimBQ;EACI,yBAAA;ApIoimBZ;;AoI3hmBQ;EACI,wBAAA;EACA,c9HMD;E8HLC,6BAAA;ApI8hmBZ;AoI7hmBY;EACI,c9HIL;E8HHK,yB9HJL;ANmimBX;AoI7hmBY;EACI,yB9HPL;ANsimBX;AoI9hmBgB;EACI,yBAAA;ApIgimBpB;AoI5hmBgB;EACI,wCAAA;ApI8hmBpB;AoIrhmBgB;EACI,wBAAA;ApIuhmBpB;AoIrhmBe;EACK,0CAAA;ApIuhmBpB;AoIthmBoB;EACI,0CAAA;ApIwhmBxB;AoIthmBoB;EACI,c9H1Bb;E8H2Ba,6BAAA;ApIwhmBxB;AoIphmBe;EACK,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ApIshmBpB;;AoIzgmBoB;EAEI,yBAAA;ApI2gmBxB;;AqIzrmBI;EACI,mBAAA;ArI4rmBR;AqI1rmBI;EACI,qB/HwxBsB;E+HvxBtB,mBAAA;ArI4rmBR;AqIzrmBI;EACI,kBAAA;EACA,eAAA;ArI2rmBR;AqI1rmBQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;ArI4rmBZ;AqI1rmBQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;ArI4rmBZ;AqIzrmBgB;EACI,UAAA;ArI2rmBpB;AqIvrmBgB;EACI,UAAA;ArIyrmBpB;AcxpmBI;EuH3BI;IACI,qBAAA;IACA,iBAAA;ErIsrmBV;AACF;;AsItumBA;EACI,gBhIqHO;EgIpHP,6ChIqoB0B;EgIpoB1B,qEAAA;AtIyumBJ;AsItumBQ;EACI,0BAAA;AtIwumBZ;AsItumBQ;EACI,yBhI4GD;AN4nmBX;AsIpumBQ;EAEI,sBhIsGD;AN+nmBX;;AsIhumBA;EACI,eAAA;AtImumBJ;;AsI/tmBI;EAkBI,8BAAA;EACA,qBhIuGE;AN0mmBV;AsI/smBI;EAGI,6BAAA;AtI+smBR;;AsI1smBI;;;;EAII,gBhI2DG;EgI1DH,chIkEG;AN2omBX;;AsIxsmBI;EACI,YAAA;AtI2smBR;AsIzsmBI;;;EAGI,chIoDG;EgInDH,ahImDG;ANwpmBX;;AsIvsmBA;EACI,yBhI0CO;ANgqmBX;;AsIvsmBA;;;;;;;EAOI,chIsCO;EgIrCP,ahIqCO;ANqqmBX;;AsItsmBI;EAOI,chIyBG;AN0qmBX;AsIjsmBI;EAYI,mBhIMG;EgILH,qBhIKG;ANmrmBX;;AsIprmBA;EACI,2BAAA;AtIurmBJ;;AsIprmBA;;EAEI,6BAAA;EACA,chICO;ANsrmBX;;AsIprmBA;EACI,6CAAA;AtIurmBJ;;AsIprmBA;EACI,chITO;ANgsmBX;;AuI5zmBA;EACE,0BAAA;EACA,gBjIoHS;EiInHT,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;AvI+zmBF;AuI5zmBQ;EACI,aAAA;AvI8zmBZ;AuI3zmBE;EACI,kBAAA;EACA,cAAA;EACA,aAAA;AvI6zmBN;AuI1zmBM;EACI,aAAA;AvI4zmBV;AuInwmBA;EACE;IACE,UAAA;IAKA,2BAAA;EvI0zmBF;EuIxzmBA;IACE,UAAA;IAKA,0BAAA;EvI0zmBF;EuIxzmBA;IACE,UAAA;IAKA,4BAAA;EvI0zmBF;AACF;AuIpxmBA;EACE;IACE,UAAA;IAKA,2BAAA;EvI0zmBF;EuIxzmBA;IACE,UAAA;IAKA,0BAAA;EvI0zmBF;AACF;AuI1wmBA;EACE;IAKE,mBAAA;EvI0zmBF;EuIxzmBA;IAKE,qBAAA;EvI0zmBF;EuIxzmBA;IAKE,mBAAA;EvI0zmBF;AACF;AuIxzmBA;EACE,sBAAA;AvI0zmBF;;AuIvzmBA;EACE,eAAA;AvI0zmBF;;AuIxzmBA;EACE,eAAA;AvI2zmBF;;AuIzzmBA;EACE,aAAA;AvI4zmBF;;AuI1zmBA;EACE,mBAAA;AvI6zmBF;;AuI3zmBA;EACE,YAAA;AvI8zmBF;;AuI5zmBA;EACE,kBAAA;EACA,aAAA;AvI+zmBF;;AuI7zmBA;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AvIg0mBF;;AuI9zmBA;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AvIi0mBF;;AuI/zmBA;EACE,aAAA;AvIk0mBF;;AuIh0mBA;EACE,UAAA;AvIm0mBF;;AuIj0mBA;EACE,mBAAA;EACA,gBAAA;EACA,kDAAA;AvIo0mBF;;AuIl0mBA;EACE,UAAA;AvIq0mBF;;AuIn0mBA;EAKE,+BAAA;AvIs0mBF;;AuIp0mBA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AvIu0mBF;;AuIr0mBA;EACE,0BAAA;AvIw0mBF;;AuIt0mBA;EACE,UAAA;AvIy0mBF;;AuIv0mBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AvI00mBF;;AuIx0mBA;EACE,kBAAA;EACA,eAAA;AvI20mBF;;AuIz0mBA;EACE,mBAAA;AvI40mBF;;AuI10mBA;EACE,0CAAA;EACA,0CAAA;AvI60mBF;;AuI30mBA;EACE,gBAAA;EACA,uBAAA;AvI80mBF;;AuI50mBA;EACE,6BAAA;AvI+0mBF;;AuI70mBA;EACE,0CAAA;EACA,gBAAA;EACA,kBAAA;AvIg1mBF;;AuI90mBA;EAKE,4BAAA;EAEA,iBAAA;AvIi1mBF;;AuI/0mBA;EACE,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBjI3OS;AN6jnBX;;AuIh1mBA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AvIm1mBF;;AuIj1mBA;EAKE,6DAAA;AvIo1mBF;;AuIl1mBA;EACE,UAAA;EAKA,sDAAA;AvIq1mBF;;AuIn1mBA;EACE,oBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;AvIs1mBF;;AuIp1mBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AvIu1mBF;;AuIr1mBA;EACE,UAAA;EAKA,2BAAA;AvIw1mBF;;AuIt1mBA;EACE,UAAA;EAKA,gCAAA;AvIy1mBF;;AuIv1mBA;EAKE,iCAAA;AvI01mBF;;AuIx1mBA;EACE,UAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AvI21mBF;;AuIz1mBA;EACE,gBAAA;EACA,kDAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EAKA,mCAAA;AvI41mBF;;AuI11mBA;EACE,cAAA;AvI61mBF;;AuI31mBA;EACE,UAAA;EACA,oBAAA;AvI81mBF;;AuI51mBA;EACE,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EAKA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;EACA,oBAAA;EACA,YAAA;AvI+1mBF;;AuI71mBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;AvIg2mBF;;AuI11mBQ;EACI,2CAAA;EACA,WjItXD;EiIuXC,kBAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;AvI61mBZ;AuIv1mBY;EACI,UAAA;AvIy1mBhB;;AwIx1nBA;;EAEE,aAAA;EACA,mBlIoHS;EkInHT,kBAAA;AxI21nBF;;AwIx1nBA;EACE,cAAA;EACA,kBAAA;EACA,WlI4GS;EkI3GT,eAAA;EACA,iBAAA;EACA,mBlIuIQ;EkItIR,kBAAA;EACA,kBAAA;AxI21nBF;;AwIx1nBA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;AxI21nBF;AwIz1nBE;EACE,aAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;AxI21nBJ;AwIx1nBE;EACE,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;AxI01nBJ;;AyI93nBA;EACI,YAAA;EACA,mBnI4HO;EmI3HP,yBAAA;EACA,0DnI+DgD;EmI9DhD,mBnImrB0B;EmIlrB1B,gBAAA;AzIi4nBJ;;AyIj1nBA;EAAM,kBAAA;AzIq1nBN;;AyIp1nBA;EAA+D,yBAAA;UAAA,iBAAA;AzIw1nB/D;;AyIr1nBA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AzIw1nBF;;AyIp1nBA;EACE,kBA/Ce;EAgDf,yBnIyDS;EmIxDT,0DnIymB4B;EmIxmB5B,mBnIinB4B;EmIhnB5B,2CAvDe;EAwDf,gBAlDgB;EAmDhB,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,cnI0CS;EmIzCT,YAAA;AzIu1nBF;;AyIl1nBA;EACE,kBAzDiB;EA0DjB,yBA3DmB;EA4DnB,YAzDkB;EA0DlB,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AzIq1nBF;AyIn1nBE;EACE,SAAA;AzIq1nBJ;AyIl1nBE;EACE,SAAA;AzIo1nBJ;;AyI/0nBA;EACE,WA1EuB;EA2EvB,kBAAA;AzIk1nBF;AyI/0nBE;EAA4B,YAAA;AzIk1nB9B;AyI/0nBE;EAA4B,SAAA;AzIk1nB9B;AyI/0nBE;EACE,sBAlFsB;EAmFtB,yBAAA;EACA,oBAlFiB;EAmFjB,sBApFY;EAqFZ,qBA7GW;EA8GX,eApFa;EAqFb,2CA9GS;EA+GT,WAAA;AzIi1nBJ;AyI/0nBI;EACE,cAAA;EACA,gCAAA;EACA,sBAxFwB;EAyFxB,uBAxFuB;EAyFvB,gBAAA;AzIi1nBN;AyI90nBI;EACE,gBAAA;AzIg1nBN;AyI90nBM;EACE,gBAAA;EACA,eAAA;AzIg1nBR;AyI/0nBQ;EACE,oBAhGe;AzIi7nBzB;AyI90nBQ;EACE,kBAnGkB;EAoGlB,qBAAA;EACA,YApGkB;EAqGlB,WApGiB;EAqGjB,WAAA;AzIg1nBV;AyI70nBQ;EACE,eAxGmB;EAyGnB,kBAAA;EACA,WAAA;AzI+0nBV;;AyIv0nBA;EAEE,0DAAA;AzI00nBF;AyIx0nBE;EACE;IAAO,sBAAA;EzI20nBT;AACF;;A0Iz/nBA;;;;;;CAAA;ACAA;EACE,sBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,mBAAA;EACA,kBAAA;A3I+/nBF;A2I7/nBA,gGAAA;AACA,2FAAA;AACA;;;;;;;CAAA;AASA;EACE,oBAAA;A3I8/nBF;;A2I3/nBC;EACC,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EAEA,qBAAA;EACA,wBAAA;EACA,UAAA;EAEA,kBAAA;EACA,iBAAA;EAEA,gEAAA;EACA,oBAAA;EACA,oBAAA;EAEA,8CAAA;EACA,gBAAA;EACA,sBAAA;EAEA,gEAAA;EACA,yBAAA;EAGA,0DAAA;EACA,eAAA;EAEA,6CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,uDAAA;A3Iq/nBF;;A2Il/nBA;EAAqB,gBAAA;A3Is/nBrB,E2It/nByC,QAAA;AACzC;EAAsB,gBAAA;A3Iw/nBtB,E2Ix/nB0C,QAAA;AAC1C;EAAsB,gBAAA;A3I0/nBtB,E2I1/nB0C,QAAA;AAC1C;EAAsB,gBAAA;A3I4/nBtB,E2I5/nB0C,QAAA;AAC1C;EAAsB,gBAAA;A3I8/nBtB,E2I9/nB0C,QAAA;AAC1C;EAAsB,gBAAA;A3IggoBtB,E2IhgoB0C,QAAA;AAC1C;EAAsB,gBAAA;A3IkgoBtB,E2IlgoB0C,QAAA;AAC1C;EAAsB,gBAAA;A3IogoBtB,E2IpgoB0C,QAAA;AAC1C;EAAqB,gBAAA;A3IsgoBrB,E2ItgoByC,QAAA;AACzC;EAAoB,gBAAA;A3IwgoBpB,E2IxgoBwC,QAAA;AACxC;EAAqB,gBAAA;A3I0goBrB,E2I1goByC,QAAA;AACzC;EAAqB,gBAAA;A3I4goBrB,E2I5goByC,QAAA;AACzC;EAAkC,gBAAA;A3I8goBlC,E2I9goBsD,QAAA;AACtD;EAAyB,gBAAA;A3IghoBzB,E2IhhoB6C,QAAA;AAC7C;EAA4B,gBAAA;A3IkhoB5B,E2IlhoBgD,QAAA;AAChD;EAA0B,gBAAA;A3IohoB1B,E2IphoB8C,QAAA;AAC9C;EAAqB,gBAAA;A3IshoBrB,E2IthoByC,QAAA;AACzC;EAAwB,gBAAA;A3IwhoBxB,E2IxhoB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I0hoBpB,E2I1hoBwC,QAAA;AACxC;EAAsB,gBAAA;A3I4hoBtB,E2I5hoB0C,QAAA;AAC1C;EAAwB,gBAAA;A3I8hoBxB,E2I9hoB4C,QAAA;AAC5C;EAA+B,gBAAA;A3IgioB/B,E2IhioBmD,QAAA;AACnD;EAA6B,gBAAA;A3IkioB7B,E2IlioBiD,QAAA;AACjD;EAAmC,gBAAA;A3IoioBnC,E2IpioBuD,QAAA;AACvD;EAA6B,gBAAA;A3IsioB7B,E2ItioBiD,QAAA;AACjD;EAA2B,gBAAA;A3IwioB3B,E2IxioB+C,QAAA;AAC/C;EAA4B,gBAAA;A3I0ioB5B,E2I1ioBgD,QAAA;AAChD;EAAiC,gBAAA;A3I4ioBjC,E2I5ioBqD,QAAA;AACrD;EAAyB,gBAAA;A3I8ioBzB,E2I9ioB6C,QAAA;AAC7C;EAAiC,gBAAA;A3IgjoBjC,E2IhjoBqD,QAAA;AACrD;EAAkC,gBAAA;A3IkjoBlC,E2IljoBsD,QAAA;AACtD;EAA0B,gBAAA;A3IojoB1B,E2IpjoB8C,QAAA;AAC9C;EAAoB,gBAAA;A3IsjoBpB,E2ItjoBwC,QAAA;AACxC;EAAqB,gBAAA;A3IwjoBrB,E2IxjoByC,QAAA;AACzC;EAAwB,gBAAA;A3I0joBxB,E2I1joB4C,QAAA;AAC5C;EAAuB,gBAAA;A3I4joBvB,E2I5joB2C,QAAA;AAC3C;EAAwB,gBAAA;A3I8joBxB,E2I9joB4C,QAAA;AAC5C;EAAqB,gBAAA;A3IgkoBrB,E2IhkoByC,QAAA;AACzC;EAA0B,gBAAA;A3IkkoB1B,E2IlkoB8C,QAAA;AAC9C;EAAkC,gBAAA;A3IokoBlC,E2IpkoBsD,QAAA;AACtD;EAAsB,gBAAA;A3IskoBtB,E2ItkoB0C,QAAA;AAC1C;EAAgC,gBAAA;A3IwkoBhC,E2IxkoBoD,QAAA;AACpD;EAAgC,gBAAA;A3I0koBhC,E2I1koBoD,QAAA;AACpD;EAAiC,gBAAA;A3I4koBjC,E2I5koBqD,QAAA;AACrD;EAA8B,gBAAA;A3I8koB9B,E2I9koBkD,QAAA;AAClD;EAAyB,gBAAA;A3IgloBzB,E2IhloB6C,QAAA;AAC7C;EAAyB,gBAAA;A3IkloBzB,E2IlloB6C,QAAA;AAC7C;EAA4B,gBAAA;A3IoloB5B,E2IploBgD,QAAA;AAChD;EAA0B,gBAAA;A3IsloB1B,E2ItloB8C,QAAA;AAC9C;EAAuB,gBAAA;A3IwloBvB,E2IxloB2C,QAAA;AAC3C;EAAoB,gBAAA;A3I0loBpB,E2I1loBwC,QAAA;AACxC;EAAmB,gBAAA;A3I4loBnB,E2I5loBuC,QAAA;AACvC;EAA0B,gBAAA;A3I8loB1B,E2I9loB8C,QAAA;AAC9C;EAAsB,gBAAA;A3IgmoBtB,E2IhmoB0C,QAAA;AAC1C;EAAwB,gBAAA;A3IkmoBxB,E2IlmoB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IomoBpB,E2IpmoBwC,QAAA;AACxC;EAAmB,gBAAA;A3IsmoBnB,E2ItmoBuC,QAAA;AACvC;EAA0B,gBAAA;A3IwmoB1B,E2IxmoB8C,QAAA;AAC9C;EAAsB,gBAAA;A3I0moBtB,E2I1moB0C,QAAA;AAC1C;EAAsB,gBAAA;A3I4moBtB,E2I5moB0C,QAAA;AAC1C;EAA0B,gBAAA;A3I8moB1B,E2I9moB8C,QAAA;AAC9C;EAAgC,gBAAA;A3IgnoBhC,E2IhnoBoD,QAAA;AACpD;EAAgC,gBAAA;A3IknoBhC,E2IlnoBoD,QAAA;AACpD;EAAiC,gBAAA;A3IonoBjC,E2IpnoBqD,QAAA;AACrD;EAA8B,gBAAA;A3IsnoB9B,E2ItnoBkD,QAAA;AAClD;EAA+B,gBAAA;A3IwnoB/B,E2IxnoBmD,QAAA;AACnD;EAA8B,gBAAA;A3I0noB9B,E2I1noBkD,QAAA;AAClD;EAA+B,gBAAA;A3I4noB/B,E2I5noBmD,QAAA;AACnD;EAAyB,gBAAA;A3I8noBzB,E2I9noB6C,QAAA;AAC7C;EAA+B,gBAAA;A3IgooB/B,E2IhooBmD,QAAA;AACnD;EAA6B,gBAAA;A3IkooB7B,E2IlooBiD,QAAA;AACjD;EAA2B,gBAAA;A3IoooB3B,E2IpooB+C,QAAA;AAC/C;EAAyB,gBAAA;A3IsooBzB,E2ItooB6C,QAAA;AAC7C;EAA2B,gBAAA;A3IwooB3B,E2IxooB+C,QAAA;AAC/C;EAAoC,gBAAA;A3I0ooBpC,E2I1ooBwD,QAAA;AACxD;EAA0B,gBAAA;A3I4ooB1B,E2I5ooB8C,QAAA;AAC9C;EAA8B,gBAAA;A3I8ooB9B,E2I9ooBkD,QAAA;AAClD;EAA6B,gBAAA;A3IgpoB7B,E2IhpoBiD,QAAA;AACjD;EAA4B,gBAAA;A3IkpoB5B,E2IlpoBgD,QAAA;AAChD;EAA6B,gBAAA;A3IopoB7B,E2IppoBiD,QAAA;AACjD;EAAuB,gBAAA;A3IspoBvB,E2ItpoB2C,QAAA;AAC3C;EAA2B,gBAAA;A3IwpoB3B,E2IxpoB+C,QAAA;AAC/C;EAAuB,gBAAA;A3I0poBvB,E2I1poB2C,QAAA;AAC3C;EAA+B,gBAAA;A3I4poB/B,E2I5poBmD,QAAA;AACnD;EAA8B,gBAAA;A3I8poB9B,E2I9poBkD,QAAA;AAClD;EAA2B,gBAAA;A3IgqoB3B,E2IhqoB+C,QAAA;AAC/C;EAA8B,gBAAA;A3IkqoB9B,E2IlqoBkD,QAAA;AAClD;EAA8B,gBAAA;A3IoqoB9B,E2IpqoBkD,QAAA;AAClD;EAA4B,gBAAA;A3IsqoB5B,E2ItqoBgD,QAAA;AAChD;EAAgC,gBAAA;A3IwqoBhC,E2IxqoBoD,QAAA;AACpD;EAA8B,gBAAA;A3I0qoB9B,E2I1qoBkD,QAAA;AAClD;EAA8B,gBAAA;A3I4qoB9B,E2I5qoBkD,QAAA;AAClD;EAA8B,gBAAA;A3I8qoB9B,E2I9qoBkD,QAAA;AAClD;EAA2B,gBAAA;A3IgroB3B,E2IhroB+C,QAAA;AAC/C;EAAuB,gBAAA;A3IkroBvB,E2IlroB2C,QAAA;AAC3C;EAA0C,gBAAA;A3IoroB1C,E2IproB8D,QAAA;AAC9D;EAAuB,gBAAA;A3IsroBvB,E2ItroB2C,QAAA;AAC3C;EAAiB,gBAAA;A3IwroBjB,E2IxroBqC,QAAA;AACrC;EAAuB,gBAAA;A3I0roBvB,E2I1roB2C,QAAA;AAC3C;EAAmB,gBAAA;A3I4roBnB,E2I5roBuC,QAAA;AACvC;EAAyB,gBAAA;A3I8roBzB,E2I9roB6C,QAAA;AAC7C;EAAwB,gBAAA;A3IgsoBxB,E2IhsoB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IksoBpB,E2IlsoBwC,QAAA;AACxC;EAA4B,gBAAA;A3IosoB5B,E2IpsoBgD,QAAA;AAChD;EAAuB,gBAAA;A3IssoBvB,E2ItsoB2C,QAAA;AAC3C;EAAwB,gBAAA;A3IwsoBxB,E2IxsoB4C,QAAA;AAC5C;EAAuB,gBAAA;A3I0soBvB,E2I1soB2C,QAAA;AAC3C;EAAsB,gBAAA;A3I4soBtB,E2I5soB0C,QAAA;AAC1C;EAAwB,gBAAA;A3I8soBxB,E2I9soB4C,QAAA;AAC5C;EAAkB,gBAAA;A3IgtoBlB,E2IhtoBsC,QAAA;AACtC;EAA4B,gBAAA;A3IktoB5B,E2IltoBgD,QAAA;AAChD;EAAmB,gBAAA;A3IotoBnB,E2IptoBuC,QAAA;AACvC;EAAkB,gBAAA;A3IstoBlB,E2IttoBsC,QAAA;AACtC;EAAmB,gBAAA;A3IwtoBnB,E2IxtoBuC,QAAA;AACvC;EAA4B,gBAAA;A3I0toB5B,E2I1toBgD,QAAA;AAChD;EAA8B,gBAAA;A3I4toB9B,E2I5toBkD,QAAA;AAClD;EAAyB,gBAAA;A3I8toBzB,E2I9toB6C,QAAA;AAC7C;EAAmB,gBAAA;A3IguoBnB,E2IhuoBuC,QAAA;AACvC;EAA2B,gBAAA;A3IkuoB3B,E2IluoB+C,QAAA;AAC/C;EAA4B,gBAAA;A3IouoB5B,E2IpuoBgD,QAAA;AAChD;EAAyB,gBAAA;A3IsuoBzB,E2ItuoB6C,QAAA;AAC7C;EAAkB,gBAAA;A3IwuoBlB,E2IxuoBsC,QAAA;AACtC;EAA0B,gBAAA;A3I0uoB1B,E2I1uoB8C,QAAA;AAC9C;EAAsB,gBAAA;A3I4uoBtB,E2I5uoB0C,QAAA;AAC1C;EAA0B,gBAAA;A3I8uoB1B,E2I9uoB8C,QAAA;AAC9C;EAAyB,gBAAA;A3IgvoBzB,E2IhvoB6C,QAAA;AAC7C;EAAmB,gBAAA;A3IkvoBnB,E2IlvoBuC,QAAA;AACvC;EAAmB,gBAAA;A3IovoBnB,E2IpvoBuC,QAAA;AACvC;EAA0B,gBAAA;A3IsvoB1B,E2ItvoB8C,QAAA;AAC9C;EAA2B,gBAAA;A3IwvoB3B,E2IxvoB+C,QAAA;AAC/C;EAA6B,gBAAA;A3I0voB7B,E2I1voBiD,QAAA;AACjD;EAAsB,gBAAA;A3I4voBtB,E2I5voB0C,QAAA;AAC1C;EAA0B,gBAAA;A3I8voB1B,E2I9voB8C,QAAA;AAC9C;EAA0B,gBAAA;A3IgwoB1B,E2IhwoB8C,QAAA;AAC9C;EAAsB,gBAAA;A3IkwoBtB,E2IlwoB0C,QAAA;AAC1C;EAA0B,gBAAA;A3IowoB1B,E2IpwoB8C,QAAA;AAC9C;EAAmB,gBAAA;A3IswoBnB,E2ItwoBuC,QAAA;AACvC;EAAuB,gBAAA;A3IwwoBvB,E2IxwoB2C,QAAA;AAC3C;EAAyB,gBAAA;A3I0woBzB,E2I1woB6C,QAAA;AAC7C;EAAmB,gBAAA;A3I4woBnB,E2I5woBuC,QAAA;AACvC;EAAuB,gBAAA;A3I8woBvB,E2I9woB2C,QAAA;AAC3C;EAA2B,gBAAA;A3IgxoB3B,E2IhxoB+C,QAAA;AAC/C;EAAwB,gBAAA;A3IkxoBxB,E2IlxoB4C,QAAA;AAC5C;EAA0B,gBAAA;A3IoxoB1B,E2IpxoB8C,QAAA;AAC9C;EAAmB,gBAAA;A3IsxoBnB,E2ItxoBuC,QAAA;AACvC;EAA4B,gBAAA;A3IwxoB5B,E2IxxoBgD,QAAA;AAChD;EAAuB,gBAAA;A3I0xoBvB,E2I1xoB2C,QAAA;AAC3C;EAAoB,gBAAA;A3I4xoBpB,E2I5xoBwC,QAAA;AACxC;EAAsB,gBAAA;A3I8xoBtB,E2I9xoB0C,QAAA;AAC1C;EAAyB,gBAAA;A3IgyoBzB,E2IhyoB6C,QAAA;AAC7C;EAA4B,gBAAA;A3IkyoB5B,E2IlyoBgD,QAAA;AAChD;EAA2B,gBAAA;A3IoyoB3B,E2IpyoB+C,QAAA;AAC/C;EAAgC,gBAAA;A3IsyoBhC,E2ItyoBoD,QAAA;AACpD;EAA2B,gBAAA;A3IwyoB3B,E2IxyoB+C,QAAA;AAC/C;EAA0B,gBAAA;A3I0yoB1B,E2I1yoB8C,QAAA;AAC9C;EAAyB,gBAAA;A3I4yoBzB,E2I5yoB6C,QAAA;AAC7C;EAA2B,gBAAA;A3I8yoB3B,E2I9yoB+C,QAAA;AAC/C;EAAyB,gBAAA;A3IgzoBzB,E2IhzoB6C,QAAA;AAC7C;EAA8B,gBAAA;A3IkzoB9B,E2IlzoBkD,QAAA;AAClD;EAA2B,gBAAA;A3IozoB3B,E2IpzoB+C,QAAA;AAC/C;EAAkB,gBAAA;A3IszoBlB,E2ItzoBsC,QAAA;AACtC;EAA4B,gBAAA;A3IwzoB5B,E2IxzoBgD,QAAA;AAChD;EAAwB,gBAAA;A3I0zoBxB,E2I1zoB4C,QAAA;AAC5C;EAAqB,gBAAA;A3I4zoBrB,E2I5zoByC,QAAA;AACzC;EAA+B,gBAAA;A3I8zoB/B,E2I9zoBmD,QAAA;AACnD;EAA8B,gBAAA;A3Ig0oB9B,E2Ih0oBkD,QAAA;AAClD;EAA6B,gBAAA;A3Ik0oB7B,E2Il0oBiD,QAAA;AACjD;EAA+B,gBAAA;A3Io0oB/B,E2Ip0oBmD,QAAA;AACnD;EAA8B,gBAAA;A3Is0oB9B,E2It0oBkD,QAAA;AAClD;EAAyB,gBAAA;A3Iw0oBzB,E2Ix0oB6C,QAAA;AAC7C;EAA2B,gBAAA;A3I00oB3B,E2I10oB+C,QAAA;AAC/C;EAA0B,gBAAA;A3I40oB1B,E2I50oB8C,QAAA;AAC9C;EAAwB,gBAAA;A3I80oBxB,E2I90oB4C,QAAA;AAC5C;EAAkB,gBAAA;A3Ig1oBlB,E2Ih1oBsC,QAAA;AACtC;EAAuB,gBAAA;A3Ik1oBvB,E2Il1oB2C,QAAA;AAC3C;EAAuB,gBAAA;A3Io1oBvB,E2Ip1oB2C,QAAA;AAC3C;EAAsB,gBAAA;A3Is1oBtB,E2It1oB0C,QAAA;AAC1C;EAAyB,gBAAA;A3Iw1oBzB,E2Ix1oB6C,QAAA;AAC7C;EAAkB,gBAAA;A3I01oBlB,E2I11oBsC,QAAA;AACtC;EAAyB,gBAAA;A3I41oBzB,E2I51oB6C,QAAA;AAC7C;EAA6B,gBAAA;A3I81oB7B,E2I91oBiD,QAAA;AACjD;EAAyB,gBAAA;A3Ig2oBzB,E2Ih2oB6C,QAAA;AAC7C;EAA2B,gBAAA;A3Ik2oB3B,E2Il2oB+C,QAAA;AAC/C;EAA6B,gBAAA;A3Io2oB7B,E2Ip2oBiD,QAAA;AACjD;EAAuB,gBAAA;A3Is2oBvB,E2It2oB2C,QAAA;AAC3C;EAAsB,gBAAA;A3Iw2oBtB,E2Ix2oB0C,QAAA;AAC1C;EAA4B,gBAAA;A3I02oB5B,E2I12oBgD,QAAA;AAChD;EAA0B,gBAAA;A3I42oB1B,E2I52oB8C,QAAA;AAC9C;EAA2B,gBAAA;A3I82oB3B,E2I92oB+C,QAAA;AAC/C;EAAqB,gBAAA;A3Ig3oBrB,E2Ih3oByC,QAAA;AACzC;EAAqB,gBAAA;A3Ik3oBrB,E2Il3oByC,QAAA;AACzC;EAAsB,gBAAA;A3Io3oBtB,E2Ip3oB0C,QAAA;AAC1C;EAAsB,gBAAA;A3Is3oBtB,E2It3oB0C,QAAA;AAC1C;EAA2B,gBAAA;A3Iw3oB3B,E2Ix3oB+C,QAAA;AAC/C;EAAwB,gBAAA;A3I03oBxB,E2I13oB4C,QAAA;AAC5C;EAAuB,gBAAA;A3I43oBvB,E2I53oB2C,QAAA;AAC3C;EAAkB,gBAAA;A3I83oBlB,E2I93oBsC,QAAA;AACtC;EAAuB,gBAAA;A3Ig4oBvB,E2Ih4oB2C,QAAA;AAC3C;EAA0B,gBAAA;A3Ik4oB1B,E2Il4oB8C,QAAA;AAC9C;EAAmB,gBAAA;A3Io4oBnB,E2Ip4oBuC,QAAA;AACvC;EAAmB,gBAAA;A3Is4oBnB,E2It4oBuC,QAAA;AACvC;EAAsB,gBAAA;A3Iw4oBtB,E2Ix4oB0C,QAAA;AAC1C;EAA4B,gBAAA;A3I04oB5B,E2I14oBgD,QAAA;AAChD;EAAwB,gBAAA;A3I44oBxB,E2I54oB4C,QAAA;AAC5C;EAAyB,gBAAA;A3I84oBzB,E2I94oB6C,QAAA;AAC7C;EAA+B,gBAAA;A3Ig5oB/B,E2Ih5oBmD,QAAA;AACnD;EAA2B,gBAAA;A3Ik5oB3B,E2Il5oB+C,QAAA;AAC/C;EAAyB,gBAAA;A3Io5oBzB,E2Ip5oB6C,QAAA;AAC7C;EAA4B,gBAAA;A3Is5oB5B,E2It5oBgD,QAAA;AAChD;EAAwB,gBAAA;A3Iw5oBxB,E2Ix5oB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I05oBpB,E2I15oBwC,QAAA;AACxC;EAA+B,gBAAA;A3I45oB/B,E2I55oBmD,QAAA;AACnD;EAAwB,gBAAA;A3I85oBxB,E2I95oB4C,QAAA;AAC5C;EAAmB,gBAAA;A3Ig6oBnB,E2Ih6oBuC,QAAA;AACvC;EAA2B,gBAAA;A3Ik6oB3B,E2Il6oB+C,QAAA;AAC/C;EAA2B,gBAAA;A3Io6oB3B,E2Ip6oB+C,QAAA;AAC/C;EAAoB,gBAAA;A3Is6oBpB,E2It6oBwC,QAAA;AACxC;EAA2B,gBAAA;A3Iw6oB3B,E2Ix6oB+C,QAAA;AAC/C;EAAqB,gBAAA;A3I06oBrB,E2I16oByC,QAAA;AACzC;EAAsB,gBAAA;A3I46oBtB,E2I56oB0C,QAAA;AAC1C;EAA4B,gBAAA;A3I86oB5B,E2I96oBgD,QAAA;AAChD;EAA4B,gBAAA;A3Ig7oB5B,E2Ih7oBgD,QAAA;AAChD;EAA8B,gBAAA;A3Ik7oB9B,E2Il7oBkD,QAAA;AAClD;EAA8B,gBAAA;A3Io7oB9B,E2Ip7oBkD,QAAA;AAClD;EAAwB,gBAAA;A3Is7oBxB,E2It7oB4C,QAAA;AAC5C;EAA0B,gBAAA;A3Iw7oB1B,E2Ix7oB8C,QAAA;AAC9C;EAAyB,gBAAA;A3I07oBzB,E2I17oB6C,QAAA;AAC7C;EAAyB,gBAAA;A3I47oBzB,E2I57oB6C,QAAA;AAC7C;EAA0B,gBAAA;A3I87oB1B,E2I97oB8C,QAAA;AAC9C;EAAwB,gBAAA;A3Ig8oBxB,E2Ih8oB4C,QAAA;AAC5C;EAA0B,gBAAA;A3Ik8oB1B,E2Il8oB8C,QAAA;AAC9C;EAAwB,gBAAA;A3Io8oBxB,E2Ip8oB4C,QAAA;AAC5C;EAAoB,gBAAA;A3Is8oBpB,E2It8oBwC,QAAA;AACxC;EAAgC,gBAAA;A3Iw8oBhC,E2Ix8oBoD,QAAA;AACpD;EAA0B,gBAAA;A3I08oB1B,E2I18oB8C,QAAA;AAC9C;EAA6B,gBAAA;A3I48oB7B,E2I58oBiD,QAAA;AACjD;EAA0B,gBAAA;A3I88oB1B,E2I98oB8C,QAAA;AAC9C;EAA8B,gBAAA;A3Ig9oB9B,E2Ih9oBkD,QAAA;AAClD;EAAoC,gBAAA;A3Ik9oBpC,E2Il9oBwD,QAAA;AACxD;EAAkC,gBAAA;A3Io9oBlC,E2Ip9oBsD,QAAA;AACtD;EAA6B,gBAAA;A3Is9oB7B,E2It9oBiD,QAAA;AACjD;EAA4B,gBAAA;A3Iw9oB5B,E2Ix9oBgD,QAAA;AAChD;EAAgC,gBAAA;A3I09oBhC,E2I19oBoD,QAAA;AACpD;EAAyB,gBAAA;A3I49oBzB,E2I59oB6C,QAAA;AAC7C;EAA0B,gBAAA;A3I89oB1B,E2I99oB8C,QAAA;AAC9C;EAAyB,gBAAA;A3Ig+oBzB,E2Ih+oB6C,QAAA;AAC7C;EAAyB,gBAAA;A3Ik+oBzB,E2Il+oB6C,QAAA;AAC7C;EAA6B,gBAAA;A3Io+oB7B,E2Ip+oBiD,QAAA;AACjD;EAA8B,gBAAA;A3Is+oB9B,E2It+oBkD,QAAA;AAClD;EAAkC,gBAAA;A3Iw+oBlC,E2Ix+oBsD,QAAA;AACtD;EAA8B,gBAAA;A3I0+oB9B,E2I1+oBkD,QAAA;AAClD;EAAiC,gBAAA;A3I4+oBjC,E2I5+oBqD,QAAA;AACrD;EAAyB,gBAAA;A3I8+oBzB,E2I9+oB6C,QAAA;AAC7C;EAA6B,gBAAA;A3Ig/oB7B,E2Ih/oBiD,QAAA;AACjD;EAA6B,gBAAA;A3Ik/oB7B,E2Il/oBiD,QAAA;AACjD;EAAyB,gBAAA;A3Io/oBzB,E2Ip/oB6C,QAAA;AAC7C;EAAyB,gBAAA;A3Is/oBzB,E2It/oB6C,QAAA;AAC7C;EAAwB,gBAAA;A3Iw/oBxB,E2Ix/oB4C,QAAA;AAC5C;EAA0B,gBAAA;A3I0/oB1B,E2I1/oB8C,QAAA;AAC9C;EAA2B,gBAAA;A3I4/oB3B,E2I5/oB+C,QAAA;AAC/C;EAAgC,gBAAA;A3I8/oBhC,E2I9/oBoD,QAAA;AACpD;EAAkC,gBAAA;A3IggpBlC,E2IhgpBsD,QAAA;AACtD;EAA4B,gBAAA;A3IkgpB5B,E2IlgpBgD,QAAA;AAChD;EAA0B,gBAAA;A3IogpB1B,E2IpgpB8C,QAAA;AAC9C;EAA6B,gBAAA;A3IsgpB7B,E2ItgpBiD,QAAA;AACjD;EAAiC,gBAAA;A3IwgpBjC,E2IxgpBqD,QAAA;AACrD;EAAiC,gBAAA;A3I0gpBjC,E2I1gpBqD,QAAA;AACrD;EAA6B,gBAAA;A3I4gpB7B,E2I5gpBiD,QAAA;AACjD;EAA6B,gBAAA;A3I8gpB7B,E2I9gpBiD,QAAA;AACjD;EAAwB,gBAAA;A3IghpBxB,E2IhhpB4C,QAAA;AAC5C;EAA0B,gBAAA;A3IkhpB1B,E2IlhpB8C,QAAA;AAC9C;EAA2B,gBAAA;A3IohpB3B,E2IphpB+C,QAAA;AAC/C;EAA2B,gBAAA;A3IshpB3B,E2IthpB+C,QAAA;AAC/C;EAAyB,gBAAA;A3IwhpBzB,E2IxhpB6C,QAAA;AAC7C;EAAyB,gBAAA;A3I0hpBzB,E2I1hpB6C,QAAA;AAC7C;EAAoB,gBAAA;A3I4hpBpB,E2I5hpBwC,QAAA;AACxC;EAAqB,gBAAA;A3I8hpBrB,E2I9hpByC,QAAA;AACzC;EAAmB,gBAAA;A3IgipBnB,E2IhipBuC,QAAA;AACvC;EAAmB,gBAAA;A3IkipBnB,E2IlipBuC,QAAA;AACvC;EAAqB,gBAAA;A3IoipBrB,E2IpipByC,QAAA;AACzC;EAAkB,gBAAA;A3IsipBlB,E2ItipBsC,QAAA;AACtC;EAAoB,gBAAA;A3IwipBpB,E2IxipBwC,QAAA;AACxC;EAAsB,gBAAA;A3I0ipBtB,E2I1ipB0C,QAAA;AAC1C;EAAgC,gBAAA;A3I4ipBhC,E2I5ipBoD,QAAA;AACpD;EAAsC,gBAAA;A3I8ipBtC,E2I9ipB0D,QAAA;AAC1D;EAAgC,gBAAA;A3IgjpBhC,E2IhjpBoD,QAAA;AACpD;EAA+B,gBAAA;A3IkjpB/B,E2IljpBmD,QAAA;AACnD;EAAmC,gBAAA;A3IojpBnC,E2IpjpBuD,QAAA;AACvD;EAA+B,gBAAA;A3IsjpB/B,E2ItjpBmD,QAAA;AACnD;EAAsC,gBAAA;A3IwjpBtC,E2IxjpB0D,QAAA;AAC1D;EAAgC,gBAAA;A3I0jpBhC,E2I1jpBoD,QAAA;AACpD;EAAgC,gBAAA;A3I4jpBhC,E2I5jpBoD,QAAA;AACpD;EAA+B,gBAAA;A3I8jpB/B,E2I9jpBmD,QAAA;AACnD;EAAgC,gBAAA;A3IgkpBhC,E2IhkpBoD,QAAA;AACpD;EAA+B,gBAAA;A3IkkpB/B,E2IlkpBmD,QAAA;AACnD;EAAkC,gBAAA;A3IokpBlC,E2IpkpBsD,QAAA;AACtD;EAAkC,gBAAA;A3IskpBlC,E2ItkpBsD,QAAA;AACtD;EAAgC,gBAAA;A3IwkpBhC,E2IxkpBoD,QAAA;AACpD;EAA+B,gBAAA;A3I0kpB/B,E2I1kpBmD,QAAA;AACnD;EAAmC,gBAAA;A3I4kpBnC,E2I5kpBuD,QAAA;AACvD;EAA+B,gBAAA;A3I8kpB/B,E2I9kpBmD,QAAA;AACnD;EAAiC,gBAAA;A3IglpBjC,E2IhlpBqD,QAAA;AACrD;EAAgC,gBAAA;A3IklpBhC,E2IllpBoD,QAAA;AACpD;EAAiC,gBAAA;A3IolpBjC,E2IplpBqD,QAAA;AACrD;EAAgC,gBAAA;A3IslpBhC,E2ItlpBoD,QAAA;AACpD;EAAiC,gBAAA;A3IwlpBjC,E2IxlpBqD,QAAA;AACrD;EAAiC,gBAAA;A3I0lpBjC,E2I1lpBqD,QAAA;AACrD;EAA0B,gBAAA;A3I4lpB1B,E2I5lpB8C,QAAA;AAC9C;EAA4B,gBAAA;A3I8lpB5B,E2I9lpBgD,QAAA;AAChD;EAAiC,gBAAA;A3IgmpBjC,E2IhmpBqD,QAAA;AACrD;EAA4B,gBAAA;A3IkmpB5B,E2IlmpBgD,QAAA;AAChD;EAA2B,gBAAA;A3IompB3B,E2IpmpB+C,QAAA;AAC/C;EAA+B,gBAAA;A3IsmpB/B,E2ItmpBmD,QAAA;AACnD;EAA2B,gBAAA;A3IwmpB3B,E2IxmpB+C,QAAA;AAC/C;EAAkC,gBAAA;A3I0mpBlC,E2I1mpBsD,QAAA;AACtD;EAA4B,gBAAA;A3I4mpB5B,E2I5mpBgD,QAAA;AAChD;EAA4B,gBAAA;A3I8mpB5B,E2I9mpBgD,QAAA;AAChD;EAA+B,gBAAA;A3IgnpB/B,E2IhnpBmD,QAAA;AACnD;EAA2B,gBAAA;A3IknpB3B,E2IlnpB+C,QAAA;AAC/C;EAA4B,gBAAA;A3IonpB5B,E2IpnpBgD,QAAA;AAChD;EAA2B,gBAAA;A3IsnpB3B,E2ItnpB+C,QAAA;AAC/C;EAA8B,gBAAA;A3IwnpB9B,E2IxnpBkD,QAAA;AAClD;EAA8B,gBAAA;A3I0npB9B,E2I1npBkD,QAAA;AAClD;EAA4B,gBAAA;A3I4npB5B,E2I5npBgD,QAAA;AAChD;EAA2B,gBAAA;A3I8npB3B,E2I9npB+C,QAAA;AAC/C;EAA+B,gBAAA;A3IgopB/B,E2IhopBmD,QAAA;AACnD;EAA2B,gBAAA;A3IkopB3B,E2IlopB+C,QAAA;AAC/C;EAA6B,gBAAA;A3IoopB7B,E2IpopBiD,QAAA;AACjD;EAA4B,gBAAA;A3IsopB5B,E2ItopBgD,QAAA;AAChD;EAA6B,gBAAA;A3IwopB7B,E2IxopBiD,QAAA;AACjD;EAA4B,gBAAA;A3I0opB5B,E2I1opBgD,QAAA;AAChD;EAA6B,gBAAA;A3I4opB7B,E2I5opBiD,QAAA;AACjD;EAA6B,gBAAA;A3I8opB7B,E2I9opBiD,QAAA;AACjD;EAAsB,gBAAA;A3IgppBtB,E2IhppB0C,QAAA;AAC1C;EAA2B,gBAAA;A3IkppB3B,E2IlppB+C,QAAA;AAC/C;EAAuB,gBAAA;A3IoppBvB,E2IpppB2C,QAAA;AAC3C;EAAgC,gBAAA;A3IsppBhC,E2ItppBoD,QAAA;AACpD;EAA2B,gBAAA;A3IwppB3B,E2IxppB+C,QAAA;AAC/C;EAAsB,gBAAA;A3I0ppBtB,E2I1ppB0C,QAAA;AAC1C;EAAgC,gBAAA;A3I4ppBhC,E2I5ppBoD,QAAA;AACpD;EAA2B,gBAAA;A3I8ppB3B,E2I9ppB+C,QAAA;AAC/C;EAA8B,gBAAA;A3IgqpB9B,E2IhqpBkD,QAAA;AAClD;EAA6B,gBAAA;A3IkqpB7B,E2IlqpBiD,QAAA;AACjD;EAA6B,gBAAA;A3IoqpB7B,E2IpqpBiD,QAAA;AACjD;EAAyB,gBAAA;A3IsqpBzB,E2ItqpB6C,QAAA;AAC7C;EAAuB,gBAAA;A3IwqpBvB,E2IxqpB2C,QAAA;AAC3C;EAA6B,gBAAA;A3I0qpB7B,E2I1qpBiD,QAAA;AACjD;EAAuB,gBAAA;A3I4qpBvB,E2I5qpB2C,QAAA;AAC3C;EAA0B,gBAAA;A3I8qpB1B,E2I9qpB8C,QAAA;AAC9C;EAAuB,gBAAA;A3IgrpBvB,E2IhrpB2C,QAAA;AAC3C;EAA6B,gBAAA;A3IkrpB7B,E2IlrpBiD,QAAA;AACjD;EAAmB,gBAAA;A3IorpBnB,E2IprpBuC,QAAA;AACvC;EAAwB,gBAAA;A3IsrpBxB,E2ItrpB4C,QAAA;AAC5C;EAA+B,gBAAA;A3IwrpB/B,E2IxrpBmD,QAAA;AACnD;EAAoC,gBAAA;A3I0rpBpC,E2I1rpBwD,QAAA;AACxD;EAAgC,gBAAA;A3I4rpBhC,E2I5rpBoD,QAAA;AACpD;EAA+B,gBAAA;A3I8rpB/B,E2I9rpBmD,QAAA;AACnD;EAAgC,gBAAA;A3IgspBhC,E2IhspBoD,QAAA;AACpD;EAAiC,gBAAA;A3IkspBjC,E2IlspBqD,QAAA;AACrD;EAA6B,gBAAA;A3IospB7B,E2IpspBiD,QAAA;AACjD;EAAkC,gBAAA;A3IsspBlC,E2ItspBsD,QAAA;AACtD;EAA8B,gBAAA;A3IwspB9B,E2IxspBkD,QAAA;AAClD;EAAsC,gBAAA;A3I0spBtC,E2I1spB0D,QAAA;AAC1D;EAAkC,gBAAA;A3I4spBlC,E2I5spBsD,QAAA;AACtD;EAAuB,gBAAA;A3I8spBvB,E2I9spB2C,QAAA;AAC3C;EAAmC,gBAAA;A3IgtpBnC,E2IhtpBuD,QAAA;AACvD;EAAoC,gBAAA;A3IktpBpC,E2IltpBwD,QAAA;AACxD;EAAuB,gBAAA;A3IotpBvB,E2IptpB2C,QAAA;AAC3C;EAA4B,gBAAA;A3IstpB5B,E2IttpBgD,QAAA;AAChD;EAAwB,gBAAA;A3IwtpBxB,E2IxtpB4C,QAAA;AAC5C;EAAyB,gBAAA;A3I0tpBzB,E2I1tpB6C,QAAA;AAC7C;EAAmB,gBAAA;A3I4tpBnB,E2I5tpBuC,QAAA;AACvC;EAAwB,gBAAA;A3I8tpBxB,E2I9tpB4C,QAAA;AAC5C;EAA2B,gBAAA;A3IgupB3B,E2IhupB+C,QAAA;AAC/C;EAA2B,gBAAA;A3IkupB3B,E2IlupB+C,QAAA;AAC/C;EAAuB,gBAAA;A3IoupBvB,E2IpupB2C,QAAA;AAC3C;EAAqB,gBAAA;A3IsupBrB,E2ItupByC,QAAA;AACzC;EAAgC,gBAAA;A3IwupBhC,E2IxupBoD,QAAA;AACpD;EAA0B,gBAAA;A3I0upB1B,E2I1upB8C,QAAA;AAC9C;EAAgC,gBAAA;A3I4upBhC,E2I5upBoD,QAAA;AACpD;EAA4B,gBAAA;A3I8upB5B,E2I9upBgD,QAAA;AAChD;EAAsB,gBAAA;A3IgvpBtB,E2IhvpB0C,QAAA;AAC1C;EAA0B,gBAAA;A3IkvpB1B,E2IlvpB8C,QAAA;AAC9C;EAAsB,gBAAA;A3IovpBtB,E2IpvpB0C,QAAA;AAC1C;EAAsB,gBAAA;A3IsvpBtB,E2ItvpB0C,QAAA;AAC1C;EAAwB,gBAAA;A3IwvpBxB,E2IxvpB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I0vpBpB,E2I1vpBwC,QAAA;AACxC;EAAwB,gBAAA;A3I4vpBxB,E2I5vpB4C,QAAA;AAC5C;EAAwB,gBAAA;A3I8vpBxB,E2I9vpB4C,QAAA;AAC5C;EAAuB,gBAAA;A3IgwpBvB,E2IhwpB2C,QAAA;AAC3C;EAAuB,gBAAA;A3IkwpBvB,E2IlwpB2C,QAAA;AAC3C;EAAyB,gBAAA;A3IowpBzB,E2IpwpB6C,QAAA;AAC7C;EAAuB,gBAAA;A3IswpBvB,E2ItwpB2C,QAAA;AAC3C;EAAwB,gBAAA;A3IwwpBxB,E2IxwpB4C,QAAA;AAC5C;EAAyB,gBAAA;A3I0wpBzB,E2I1wpB6C,QAAA;AAC7C;EAAwB,gBAAA;A3I4wpBxB,E2I5wpB4C,QAAA;AAC5C;EAAkB,gBAAA;A3I8wpBlB,E2I9wpBsC,QAAA;AACtC;EAAqC,gBAAA;A3IgxpBrC,E2IhxpByD,QAAA;AACzD;EAAmC,gBAAA;A3IkxpBnC,E2IlxpBuD,QAAA;AACvD;EAAoC,gBAAA;A3IoxpBpC,E2IpxpBwD,QAAA;AACxD;EAAuB,gBAAA;A3IsxpBvB,E2ItxpB2C,QAAA;AAC3C;EAAyB,gBAAA;A3IwxpBzB,E2IxxpB6C,QAAA;AAC7C;EAA8B,gBAAA;A3I0xpB9B,E2I1xpBkD,QAAA;AAClD;EAA0B,gBAAA;A3I4xpB1B,E2I5xpB8C,QAAA;AAC9C;EAAyB,gBAAA;A3I8xpBzB,E2I9xpB6C,QAAA;AAC7C;EAA2B,gBAAA;A3IgypB3B,E2IhypB+C,QAAA;AAC/C;EAAuB,gBAAA;A3IkypBvB,E2IlypB2C,QAAA;AAC3C;EAAoB,gBAAA;A3IoypBpB,E2IpypBwC,QAAA;AACxC;EAAsB,gBAAA;A3IsypBtB,E2ItypB0C,QAAA;AAC1C;EAAuB,gBAAA;A3IwypBvB,E2IxypB2C,QAAA;AAC3C;EAAkB,gBAAA;A3I0ypBlB,E2I1ypBsC,QAAA;AACtC;EAAuB,gBAAA;A3I4ypBvB,E2I5ypB2C,QAAA;AAC3C;EAAmB,gBAAA;A3I8ypBnB,E2I9ypBuC,QAAA;AACvC;EAAyB,gBAAA;A3IgzpBzB,E2IhzpB6C,QAAA;AAC7C;EAAyB,gBAAA;A3IkzpBzB,E2IlzpB6C,QAAA;AAC7C;EAAoB,gBAAA;A3IozpBpB,E2IpzpBwC,QAAA;AACxC;EAAoB,gBAAA;A3IszpBpB,E2ItzpBwC,QAAA;AACxC;EAAoB,gBAAA;A3IwzpBpB,E2IxzpBwC,QAAA;AACxC;EAA2B,gBAAA;A3I0zpB3B,E2I1zpB+C,QAAA;AAC/C;EAA2B,gBAAA;A3I4zpB3B,E2I5zpB+C,QAAA;AAC/C;EAA6B,gBAAA;A3I8zpB7B,E2I9zpBiD,QAAA;AACjD;EAAgC,gBAAA;A3Ig0pBhC,E2Ih0pBoD,QAAA;AACpD;EAA6B,gBAAA;A3Ik0pB7B,E2Il0pBiD,QAAA;AACjD;EAAoC,gBAAA;A3Io0pBpC,E2Ip0pBwD,QAAA;AACxD;EAAgC,gBAAA;A3Is0pBhC,E2It0pBoD,QAAA;AACpD;EAA4B,gBAAA;A3Iw0pB5B,E2Ix0pBgD,QAAA;AAChD;EAAmC,gBAAA;A3I00pBnC,E2I10pBuD,QAAA;AACvD;EAA6B,gBAAA;A3I40pB7B,E2I50pBiD,QAAA;AACjD;EAA4B,gBAAA;A3I80pB5B,E2I90pBgD,QAAA;AAChD;EAA4B,gBAAA;A3Ig1pB5B,E2Ih1pBgD,QAAA;AAChD;EAA6B,gBAAA;A3Ik1pB7B,E2Il1pBiD,QAAA;AACjD;EAA4B,gBAAA;A3Io1pB5B,E2Ip1pBgD,QAAA;AAChD;EAAgC,gBAAA;A3Is1pBhC,E2It1pBoD,QAAA;AACpD;EAA+B,gBAAA;A3Iw1pB/B,E2Ix1pBmD,QAAA;AACnD;EAA4B,gBAAA;A3I01pB5B,E2I11pBgD,QAAA;AAChD;EAA8B,gBAAA;A3I41pB9B,E2I51pBkD,QAAA;AAClD;EAA4B,gBAAA;A3I81pB5B,E2I91pBgD,QAAA;AAChD;EAA6B,gBAAA;A3Ig2pB7B,E2Ih2pBiD,QAAA;AACjD;EAA8B,gBAAA;A3Ik2pB9B,E2Il2pBkD,QAAA;AAClD;EAA4B,gBAAA;A3Io2pB5B,E2Ip2pBgD,QAAA;AAChD;EAA6B,gBAAA;A3Is2pB7B,E2It2pBiD,QAAA;AACjD;EAAkC,gBAAA;A3Iw2pBlC,E2Ix2pBsD,QAAA;AACtD;EAA8B,gBAAA;A3I02pB9B,E2I12pBkD,QAAA;AAClD;EAAuB,gBAAA;A3I42pBvB,E2I52pB2C,QAAA;AAC3C;EAAwB,gBAAA;A3I82pBxB,E2I92pB4C,QAAA;AAC5C;EAA2B,gBAAA;A3Ig3pB3B,E2Ih3pB+C,QAAA;AAC/C;EAA0B,gBAAA;A3Ik3pB1B,E2Il3pB8C,QAAA;AAC9C;EAAmB,gBAAA;A3Io3pBnB,E2Ip3pBuC,QAAA;AACvC;EAA2B,gBAAA;A3Is3pB3B,E2It3pB+C,QAAA;AAC/C;EAAuB,gBAAA;A3Iw3pBvB,E2Ix3pB2C,QAAA;AAC3C;EAAiC,gBAAA;A3I03pBjC,E2I13pBqD,QAAA;AACrD;EAAkC,gBAAA;A3I43pBlC,E2I53pBsD,QAAA;AACtD;EAAmC,gBAAA;A3I83pBnC,E2I93pBuD,QAAA;AACvD;EAAsB,gBAAA;A3Ig4pBtB,E2Ih4pB0C,QAAA;AAC1C;EAAmB,gBAAA;A3Ik4pBnB,E2Il4pBuC,QAAA;AACvC;EAAyB,gBAAA;A3Io4pBzB,E2Ip4pB6C,QAAA;AAC7C;EAAgC,gBAAA;A3Is4pBhC,E2It4pBoD,QAAA;AACpD;EAA4B,gBAAA;A3Iw4pB5B,E2Ix4pBgD,QAAA;AAChD;EAAiC,gBAAA;A3I04pBjC,E2I14pBqD,QAAA;AACrD;EAA0B,gBAAA;A3I44pB1B,E2I54pB8C,QAAA;AAC9C;EAA2B,gBAAA;A3I84pB3B,E2I94pB+C,QAAA;AAC/C;EAAqB,gBAAA;A3Ig5pBrB,E2Ih5pByC,QAAA;AACzC;EAA2B,gBAAA;A3Ik5pB3B,E2Il5pB+C,QAAA;AAC/C;EAAgC,gBAAA;A3Io5pBhC,E2Ip5pBoD,QAAA;AACpD;EAAgC,gBAAA;A3Is5pBhC,E2It5pBoD,QAAA;AACpD;EAAwB,gBAAA;A3Iw5pBxB,E2Ix5pB4C,QAAA;AAC5C;EAAkB,gBAAA;A3I05pBlB,E2I15pBsC,QAAA;AACtC;EAAyB,gBAAA;A3I45pBzB,E2I55pB6C,QAAA;AAC7C;EAAqC,gBAAA;A3I85pBrC,E2I95pByD,QAAA;AACzD;EAAiC,gBAAA;A3Ig6pBjC,E2Ih6pBqD,QAAA;AACrD;EAAuB,gBAAA;A3Ik6pBvB,E2Il6pB2C,QAAA;AAC3C;EAAyB,gBAAA;A3Io6pBzB,E2Ip6pB6C,QAAA;AAC7C;EAA4B,gBAAA;A3Is6pB5B,E2It6pBgD,QAAA;AAChD;EAAwB,gBAAA;A3Iw6pBxB,E2Ix6pB4C,QAAA;AAC5C;EAAuB,gBAAA;A3I06pBvB,E2I16pB2C,QAAA;AAC3C;EAAuB,gBAAA;A3I46pBvB,E2I56pB2C,QAAA;AAC3C;EAAuB,gBAAA;A3I86pBvB,E2I96pB2C,QAAA;AAC3C;EAAyB,gBAAA;A3Ig7pBzB,E2Ih7pB6C,QAAA;AAC7C;EAA6B,gBAAA;A3Ik7pB7B,E2Il7pBiD,QAAA;AACjD;EAAgC,gBAAA;A3Io7pBhC,E2Ip7pBoD,QAAA;AACpD;EAA6B,gBAAA;A3Is7pB7B,E2It7pBiD,QAAA;AACjD;EAAyB,gBAAA;A3Iw7pBzB,E2Ix7pB6C,QAAA;AAC7C;EAAmC,gBAAA;A3I07pBnC,E2I17pBuD,QAAA;AACvD;EAA4B,gBAAA;A3I47pB5B,E2I57pBgD,QAAA;AAChD;EAAgC,gBAAA;A3I87pBhC,E2I97pBoD,QAAA;AACpD;EAA4B,gBAAA;A3Ig8pB5B,E2Ih8pBgD,QAAA;AAChD;EAA4B,gBAAA;A3Ik8pB5B,E2Il8pBgD,QAAA;AAChD;EAAmC,gBAAA;A3Io8pBnC,E2Ip8pBuD,QAAA;AACvD;EAA+B,gBAAA;A3Is8pB/B,E2It8pBmD,QAAA;AACnD;EAAyB,gBAAA;A3Iw8pBzB,E2Ix8pB6C,QAAA;AAC7C;EAA4B,gBAAA;A3I08pB5B,E2I18pBgD,QAAA;AAChD;EAAiC,gBAAA;A3I48pBjC,E2I58pBqD,QAAA;AACrD;EAA6B,gBAAA;A3I88pB7B,E2I98pBiD,QAAA;AACjD;EAAkC,gBAAA;A3Ig9pBlC,E2Ih9pBsD,QAAA;AACtD;EAA4B,gBAAA;A3Ik9pB5B,E2Il9pBgD,QAAA;AAChD;EAA+B,gBAAA;A3Io9pB/B,E2Ip9pBmD,QAAA;AACnD;EAA2B,gBAAA;A3Is9pB3B,E2It9pB+C,QAAA;AAC/C;EAA6B,gBAAA;A3Iw9pB7B,E2Ix9pBiD,QAAA;AACjD;EAAyB,gBAAA;A3I09pBzB,E2I19pB6C,QAAA;AAC7C;EAA2B,gBAAA;A3I49pB3B,E2I59pB+C,QAAA;AAC/C;EAA4B,gBAAA;A3I89pB5B,E2I99pBgD,QAAA;AAChD;EAAwB,gBAAA;A3Ig+pBxB,E2Ih+pB4C,QAAA;AAC5C;EAAgC,gBAAA;A3Ik+pBhC,E2Il+pBoD,QAAA;AACpD;EAA4B,gBAAA;A3Io+pB5B,E2Ip+pBgD,QAAA;AAChD;EAA4B,gBAAA;A3Is+pB5B,E2It+pBgD,QAAA;AAChD;EAA8B,gBAAA;A3Iw+pB9B,E2Ix+pBkD,QAAA;AAClD;EAA6B,gBAAA;A3I0+pB7B,E2I1+pBiD,QAAA;AACjD;EAA8B,gBAAA;A3I4+pB9B,E2I5+pBkD,QAAA;AAClD;EAAyB,gBAAA;A3I8+pBzB,E2I9+pB6C,QAAA;AAC7C;EAA6B,gBAAA;A3Ig/pB7B,E2Ih/pBiD,QAAA;AACjD;EAAyB,gBAAA;A3Ik/pBzB,E2Il/pB6C,QAAA;AAC7C;EAA8B,gBAAA;A3Io/pB9B,E2Ip/pBkD,QAAA;AAClD;EAA0B,gBAAA;A3Is/pB1B,E2It/pB8C,QAAA;AAC9C;EAAmB,gBAAA;A3Iw/pBnB,E2Ix/pBuC,QAAA;AACvC;EAAmC,gBAAA;A3I0/pBnC,E2I1/pBuD,QAAA;AACvD;EAA+B,gBAAA;A3I4/pB/B,E2I5/pBmD,QAAA;AACnD;EAAmB,gBAAA;A3I8/pBnB,E2I9/pBuC,QAAA;AACvC;EAA2B,gBAAA;A3IggqB3B,E2IhgqB+C,QAAA;AAC/C;EAAqB,gBAAA;A3IkgqBrB,E2IlgqByC,QAAA;AACzC;EAAmB,gBAAA;A3IogqBnB,E2IpgqBuC,QAAA;AACvC;EAA2B,gBAAA;A3IsgqB3B,E2ItgqB+C,QAAA;AAC/C;EAAoB,gBAAA;A3IwgqBpB,E2IxgqBwC,QAAA;AACxC;EAAyB,gBAAA;A3I0gqBzB,E2I1gqB6C,QAAA;AAC7C;EAAqB,gBAAA;A3I4gqBrB,E2I5gqByC,QAAA;AACzC;EAAyB,gBAAA;A3I8gqBzB,E2I9gqB6C,QAAA;AAC7C;EAAqB,gBAAA;A3IghqBrB,E2IhhqByC,QAAA;AACzC;EAAqB,gBAAA;A3IkhqBrB,E2IlhqByC,QAAA;AACzC;EAAwB,gBAAA;A3IohqBxB,E2IphqB4C,QAAA;AAC5C;EAA2B,gBAAA;A3IshqB3B,E2IthqB+C,QAAA;AAC/C;EAAoB,gBAAA;A3IwhqBpB,E2IxhqBwC,QAAA;AACxC;EAA2B,gBAAA;A3I0hqB3B,E2I1hqB+C,QAAA;AAC/C;EAA8B,gBAAA;A3I4hqB9B,E2I5hqBkD,QAAA;AAClD;EAAiC,gBAAA;A3I8hqBjC,E2I9hqBqD,QAAA;AACrD;EAA2B,gBAAA;A3IgiqB3B,E2IhiqB+C,QAAA;AAC/C;EAA0B,gBAAA;A3IkiqB1B,E2IliqB8C,QAAA;AAC9C;EAA0B,gBAAA;A3IoiqB1B,E2IpiqB8C,QAAA;AAC9C;EAA6B,gBAAA;A3IsiqB7B,E2ItiqBiD,QAAA;AACjD;EAA2B,gBAAA;A3IwiqB3B,E2IxiqB+C,QAAA;AAC/C;EAA6B,gBAAA;A3I0iqB7B,E2I1iqBiD,QAAA;AACjD;EAA0B,gBAAA;A3I4iqB1B,E2I5iqB8C,QAAA;AAC9C;EAA8B,gBAAA;A3I8iqB9B,E2I9iqBkD,QAAA;AAClD;EAA2B,gBAAA;A3IgjqB3B,E2IhjqB+C,QAAA;AAC/C;EAA2B,gBAAA;A3IkjqB3B,E2IljqB+C,QAAA;AAC/C;EAA4B,gBAAA;A3IojqB5B,E2IpjqBgD,QAAA;AAChD;EAAqB,gBAAA;A3IsjqBrB,E2ItjqByC,QAAA;AACzC;EAAmB,gBAAA;A3IwjqBnB,E2IxjqBuC,QAAA;AACvC;EAAgC,gBAAA;A3I0jqBhC,E2I1jqBoD,QAAA;AACpD;EAA4B,gBAAA;A3I4jqB5B,E2I5jqBgD,QAAA;AAChD;EAAuB,gBAAA;A3I8jqBvB,E2I9jqB2C,QAAA;AAC3C;EAAsC,gBAAA;A3IgkqBtC,E2IhkqB0D,QAAA;AAC1D;EAA4B,gBAAA;A3IkkqB5B,E2IlkqBgD,QAAA;AAChD;EAAsB,gBAAA;A3IokqBtB,E2IpkqB0C,QAAA;AAC1C;EAAoB,gBAAA;A3IskqBpB,E2ItkqBwC,QAAA;AACxC;EAA6B,gBAAA;A3IwkqB7B,E2IxkqBiD,QAAA;AACjD;EAAmB,gBAAA;A3I0kqBnB,E2I1kqBuC,QAAA;AACvC;EAAmB,gBAAA;A3I4kqBnB,E2I5kqBuC,QAAA;AACvC;EAAyB,gBAAA;A3I8kqBzB,E2I9kqB6C,QAAA;AAC7C;EAAqB,gBAAA;A3IglqBrB,E2IhlqByC,QAAA;AACzC;EAAsC,gBAAA;A3IklqBtC,E2IllqB0D,QAAA;AAC1D;EAAgC,gBAAA;A3IolqBhC,E2IplqBoD,QAAA;AACpD;EAA4B,gBAAA;A3IslqB5B,E2ItlqBgD,QAAA;AAChD;EAAwB,gBAAA;A3IwlqBxB,E2IxlqB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I0lqBpB,E2I1lqBwC,QAAA;AACxC;EAAoB,gBAAA;A3I4lqBpB,E2I5lqBwC,QAAA;AACxC;EAAmB,gBAAA;A3I8lqBnB,E2I9lqBuC,QAAA;AACvC;EAA+B,gBAAA;A3IgmqB/B,E2IhmqBmD,QAAA;AACnD;EAA2B,gBAAA;A3IkmqB3B,E2IlmqB+C,QAAA;AAC/C;EAAkC,gBAAA;A3IomqBlC,E2IpmqBsD,QAAA;AACtD;EAA8B,gBAAA;A3IsmqB9B,E2ItmqBkD,QAAA;AAClD;EAA0B,gBAAA;A3IwmqB1B,E2IxmqB8C,QAAA;AAC9C;EAAqB,gBAAA;A3I0mqBrB,E2I1mqByC,QAAA;AACzC;EAA6B,gBAAA;A3I4mqB7B,E2I5mqBiD,QAAA;AACjD;EAAwB,gBAAA;A3I8mqBxB,E2I9mqB4C,QAAA;AAC5C;EAAmB,gBAAA;A3IgnqBnB,E2IhnqBuC,QAAA;AACvC;EAAoB,gBAAA;A3IknqBpB,E2IlnqBwC,QAAA;AACxC;EAAmC,gBAAA;A3IonqBnC,E2IpnqBuD,QAAA;AACvD;EAA+B,gBAAA;A3IsnqB/B,E2ItnqBmD,QAAA;AACnD;EAAmB,gBAAA;A3IwnqBnB,E2IxnqBuC,QAAA;AACvC;EAAmC,gBAAA;A3I0nqBnC,E2I1nqBuD,QAAA;AACvD;EAAkB,gBAAA;A3I4nqBlB,E2I5nqBsC,QAAA;AACtC;EAA6B,gBAAA;A3I8nqB7B,E2I9nqBiD,QAAA;AACjD;EAAyB,gBAAA;A3IgoqBzB,E2IhoqB6C,QAAA;AAC7C;EAAwB,gBAAA;A3IkoqBxB,E2IloqB4C,QAAA;AAC5C;EAA4B,gBAAA;A3IooqB5B,E2IpoqBgD,QAAA;AAChD;EAAyB,gBAAA;A3IsoqBzB,E2ItoqB6C,QAAA;AAC7C;EAAyB,gBAAA;A3IwoqBzB,E2IxoqB6C,QAAA;AAC7C;EAAoB,gBAAA;A3I0oqBpB,E2I1oqBwC,QAAA;AACxC;EAAwB,gBAAA;A3I4oqBxB,E2I5oqB4C,QAAA;AAC5C;EAA0B,gBAAA;A3I8oqB1B,E2I9oqB8C,QAAA;AAC9C;EAAsB,gBAAA;A3IgpqBtB,E2IhpqB0C,QAAA;AAC1C;EAAuB,gBAAA;A3IkpqBvB,E2IlpqB2C,QAAA;AAC3C;EAAmB,gBAAA;A3IopqBnB,E2IppqBuC,QAAA;AACvC;EAAsC,gBAAA;A3IspqBtC,E2ItpqB0D,QAAA;AAC1D;EAAoC,gBAAA;A3IwpqBpC,E2IxpqBwD,QAAA;AACxD;EAAqC,gBAAA;A3I0pqBrC,E2I1pqByD,QAAA;AACzD;EAA6C,gBAAA;A3I4pqB7C,E2I5pqBiE,QAAA;AACjE;EAA2C,gBAAA;A3I8pqB3C,E2I9pqB+D,QAAA;AAC/D;EAA4C,gBAAA;A3IgqqB5C,E2IhqqBgE,QAAA;AAChE;EAAwB,gBAAA;A3IkqqBxB,E2IlqqB4C,QAAA;AAC5C;EAAwB,gBAAA;A3IoqqBxB,E2IpqqB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IsqqBpB,E2ItqqBwC,QAAA;AACxC;EAAsB,gBAAA;A3IwqqBtB,E2IxqqB0C,QAAA;AAC1C;EAA8B,gBAAA;A3I0qqB9B,E2I1qqBkD,QAAA;AAClD;EAA0B,gBAAA;A3I4qqB1B,E2I5qqB8C,QAAA;AAC9C;EAA2B,gBAAA;A3I8qqB3B,E2I9qqB+C,QAAA;AAC/C;EAA0B,gBAAA;A3IgrqB1B,E2IhrqB8C,QAAA;AAC9C;EAA6B,gBAAA;A3IkrqB7B,E2IlrqBiD,QAAA;AACjD;EAAyB,gBAAA;A3IorqBzB,E2IprqB6C,QAAA;AAC7C;EAAyB,gBAAA;A3IsrqBzB,E2ItrqB6C,QAAA;AAC7C;EAA0B,gBAAA;A3IwrqB1B,E2IxrqB8C,QAAA;AAC9C;EAAyB,gBAAA;A3I0rqBzB,E2I1rqB6C,QAAA;AAC7C;EAA6B,gBAAA;A3I4rqB7B,E2I5rqBiD,QAAA;AACjD;EAAyB,gBAAA;A3I8rqBzB,E2I9rqB6C,QAAA;AAC7C;EAAqC,gBAAA;A3IgsqBrC,E2IhsqByD,QAAA;AACzD;EAAkC,gBAAA;A3IksqBlC,E2IlsqBsD,QAAA;AACtD;EAA2B,gBAAA;A3IosqB3B,E2IpsqB+C,QAAA;AAC/C;EAA0B,gBAAA;A3IssqB1B,E2ItsqB8C,QAAA;AAC9C;EAA2B,gBAAA;A3IwsqB3B,E2IxsqB+C,QAAA;AAC/C;EAA0B,gBAAA;A3I0sqB1B,E2I1sqB8C,QAAA;AAC9C;EAA0B,gBAAA;A3I4sqB1B,E2I5sqB8C,QAAA;AAC9C;EAA2B,gBAAA;A3I8sqB3B,E2I9sqB+C,QAAA;AAC/C;EAAsB,gBAAA;A3IgtqBtB,E2IhtqB0C,QAAA;AAC1C;EAAoB,gBAAA;A3IktqBpB,E2IltqBwC,QAAA;AACxC;EAAqB,gBAAA;A3IotqBrB,E2IptqByC,QAAA;AACzC;EAAqB,gBAAA;A3IstqBrB,E2IttqByC,QAAA;AACzC;EAA4B,gBAAA;A3IwtqB5B,E2IxtqBgD,QAAA;AAChD;EAA0B,gBAAA;A3I0tqB1B,E2I1tqB8C,QAAA;AAC9C;EAA4B,gBAAA;A3I4tqB5B,E2I5tqBgD,QAAA;AAChD;EAAwB,gBAAA;A3I8tqBxB,E2I9tqB4C,QAAA;AAC5C;EAA2B,gBAAA;A3IguqB3B,E2IhuqB+C,QAAA;AAC/C;EAAuB,gBAAA;A3IkuqBvB,E2IluqB2C,QAAA;AAC3C;EAAsB,gBAAA;A3IouqBtB,E2IpuqB0C,QAAA;AAC1C;EAAqB,gBAAA;A3IsuqBrB,E2ItuqByC,QAAA;AACzC;EAAyB,gBAAA;A3IwuqBzB,E2IxuqB6C,QAAA;AAC7C;EAA0B,gBAAA;A3I0uqB1B,E2I1uqB8C,QAAA;AAC9C;EAAoB,gBAAA;A3I4uqBpB,E2I5uqBwC,QAAA;AACxC;EAA+B,gBAAA;A3I8uqB/B,E2I9uqBmD,QAAA;AACnD;EAA2B,gBAAA;A3IgvqB3B,E2IhvqB+C,QAAA;AAC/C;EAA2B,gBAAA;A3IkvqB3B,E2IlvqB+C,QAAA;AAC/C;EAA4B,gBAAA;A3IovqB5B,E2IpvqBgD,QAAA;AAChD;EAA4B,gBAAA;A3IsvqB5B,E2ItvqBgD,QAAA;AAChD;EAAuB,gBAAA;A3IwvqBvB,E2IxvqB2C,QAAA;AAC3C;EAA6B,gBAAA;A3I0vqB7B,E2I1vqBiD,QAAA;AACjD;EAAkC,gBAAA;A3I4vqBlC,E2I5vqBsD,QAAA;AACtD;EAA6B,gBAAA;A3I8vqB7B,E2I9vqBiD,QAAA;AACjD;EAAkB,gBAAA;A3IgwqBlB,E2IhwqBsC,QAAA;AACtC;EAAwB,gBAAA;A3IkwqBxB,E2IlwqB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IowqBpB,E2IpwqBwC,QAAA;AACxC;EAAmB,gBAAA;A3IswqBnB,E2ItwqBuC,QAAA;AACvC;EAA2B,gBAAA;A3IwwqB3B,E2IxwqB+C,QAAA;AAC/C;EAAqB,gBAAA;A3I0wqBrB,E2I1wqByC,QAAA;AACzC;EAAuB,gBAAA;A3I4wqBvB,E2I5wqB2C,QAAA;AAC3C;EAAgC,gBAAA;A3I8wqBhC,E2I9wqBoD,QAAA;AACpD;EAA0B,gBAAA;A3IgxqB1B,E2IhxqB8C,QAAA;AAC9C;EAAyB,gBAAA;A3IkxqBzB,E2IlxqB6C,QAAA;AAC7C;EAA2B,gBAAA;A3IoxqB3B,E2IpxqB+C,QAAA;AAC/C;EAAqB,gBAAA;A3IsxqBrB,E2ItxqByC,QAAA;AACzC;EAAmC,gBAAA;A3IwxqBnC,E2IxxqBuD,QAAA;AACvD;EAAiC,gBAAA;A3I0xqBjC,E2I1xqBqD,QAAA;AACrD;EAA8B,gBAAA;A3I4xqB9B,E2I5xqBkD,QAAA;AAClD;EAA0B,gBAAA;A3I8xqB1B,E2I9xqB8C,QAAA;AAC9C;EAA2C,gBAAA;A3IgyqB3C,E2IhyqB+D,QAAA;AAC/D;EAAwB,gBAAA;A3IkyqBxB,E2IlyqB4C,QAAA;AAC5C;EAA4B,gBAAA;A3IoyqB5B,E2IpyqBgD,QAAA;AAChD;EAAwB,gBAAA;A3IsyqBxB,E2ItyqB4C,QAAA;AAC5C;EAAuB,gBAAA;A3IwyqBvB,E2IxyqB2C,QAAA;AAC3C;EAA2B,gBAAA;A3I0yqB3B,E2I1yqB+C,QAAA;AAC/C;EAAmB,gBAAA;A3I4yqBnB,E2I5yqBuC,QAAA;AACvC;EAAuB,gBAAA;A3I8yqBvB,E2I9yqB2C,QAAA;AAC3C;EAA0B,gBAAA;A3IgzqB1B,E2IhzqB8C,QAAA;AAC9C;EAAqB,gBAAA;A3IkzqBrB,E2IlzqByC,QAAA;AACzC;EAAmB,gBAAA;A3IozqBnB,E2IpzqBuC,QAAA;AACvC;EAA2B,gBAAA;A3IszqB3B,E2ItzqB+C,QAAA;AAC/C;EAAuB,gBAAA;A3IwzqBvB,E2IxzqB2C,QAAA;AAC3C;EAA0B,gBAAA;A3I0zqB1B,E2I1zqB8C,QAAA;AAC9C;EAAsB,gBAAA;A3I4zqBtB,E2I5zqB0C,QAAA;AAC1C;EAAiC,gBAAA;A3I8zqBjC,E2I9zqBqD,QAAA;AACrD;EAA6B,gBAAA;A3Ig0qB7B,E2Ih0qBiD,QAAA;AACjD;EAA+B,gBAAA;A3Ik0qB/B,E2Il0qBmD,QAAA;AACnD;EAA6B,gBAAA;A3Io0qB7B,E2Ip0qBiD,QAAA;AACjD;EAAuB,gBAAA;A3Is0qBvB,E2It0qB2C,QAAA;AAC3C;EAA0B,gBAAA;A3Iw0qB1B,E2Ix0qB8C,QAAA;AAC9C;EAAuB,gBAAA;A3I00qBvB,E2I10qB2C,QAAA;AAC3C;EAA4B,gBAAA;A3I40qB5B,E2I50qBgD,QAAA;AAChD;EAAyB,gBAAA;A3I80qBzB,E2I90qB6C,QAAA;AAC7C;EAAmB,gBAAA;A3Ig1qBnB,E2Ih1qBuC,QAAA;AACvC;EAA0B,gBAAA;A3Ik1qB1B,E2Il1qB8C,QAAA;AAC9C;EAAsB,gBAAA;A3Io1qBtB,E2Ip1qB0C,QAAA;AAC1C;EAA6B,gBAAA;A3Is1qB7B,E2It1qBiD,QAAA;AACjD;EAA8B,gBAAA;A3Iw1qB9B,E2Ix1qBkD,QAAA;AAClD;EAA8B,gBAAA;A3I01qB9B,E2I11qBkD,QAAA;AAClD;EAA+B,gBAAA;A3I41qB/B,E2I51qBmD,QAAA;AACnD;EAA8B,gBAAA;A3I81qB9B,E2I91qBkD,QAAA;AAClD;EAAkC,gBAAA;A3Ig2qBlC,E2Ih2qBsD,QAAA;AACtD;EAAgC,gBAAA;A3Ik2qBhC,E2Il2qBoD,QAAA;AACpD;EAA+B,gBAAA;A3Io2qB/B,E2Ip2qBmD,QAAA;AACnD;EAAyB,gBAAA;A3Is2qBzB,E2It2qB6C,QAAA;AAC7C;EAA0B,gBAAA;A3Iw2qB1B,E2Ix2qB8C,QAAA;AAC9C;EAAsB,gBAAA;A3I02qBtB,E2I12qB0C,QAAA;AAC1C;EAAkB,gBAAA;A3I42qBlB,E2I52qBsC,QAAA;AACtC;EAAmB,gBAAA;A3I82qBnB,E2I92qBuC,QAAA;AACvC;EAA0B,gBAAA;A3Ig3qB1B,E2Ih3qB8C,QAAA;AAC9C;EAA4B,gBAAA;A3Ik3qB5B,E2Il3qBgD,QAAA;AAChD;EAAoB,gBAAA;A3Io3qBpB,E2Ip3qBwC,QAAA;AACxC;EAA2B,gBAAA;A3Is3qB3B,E2It3qB+C,QAAA;AAC/C;EAAkC,gBAAA;A3Iw3qBlC,E2Ix3qBsD,QAAA;AACtD;EAA6B,gBAAA;A3I03qB7B,E2I13qBiD,QAAA;AACjD;EAAsB,gBAAA;A3I43qBtB,E2I53qB0C,QAAA;AAC1C;EAAuB,gBAAA;A3I83qBvB,E2I93qB2C,QAAA;AAC3C;EAAqB,gBAAA;A3Ig4qBrB,E2Ih4qByC,QAAA;AACzC;EAA4B,gBAAA;A3Ik4qB5B,E2Il4qBgD,QAAA;AAChD;EAAwB,gBAAA;A3Io4qBxB,E2Ip4qB4C,QAAA;AAC5C;EAAsB,gBAAA;A3Is4qBtB,E2It4qB0C,QAAA;AAC1C;EAA6B,gBAAA;A3Iw4qB7B,E2Ix4qBiD,QAAA;AACjD;EAAkB,gBAAA;A3I04qBlB,E2I14qBsC,QAAA;AACtC;EAAsB,gBAAA;A3I44qBtB,E2I54qB0C,QAAA;AAC1C;EAAoB,gBAAA;A3I84qBpB,E2I94qBwC,QAAA;AACxC;EAA+B,gBAAA;A3Ig5qB/B,E2Ih5qBmD,QAAA;AACnD;EAAyB,gBAAA;A3Ik5qBzB,E2Il5qB6C,QAAA;AAC7C;EAA2B,gBAAA;A3Io5qB3B,E2Ip5qB+C,QAAA;AAC/C;EAAyB,gBAAA;A3Is5qBzB,E2It5qB6C,QAAA;AAC7C;EAAgC,gBAAA;A3Iw5qBhC,E2Ix5qBoD,QAAA;AACpD;EAA2B,gBAAA;A3I05qB3B,E2I15qB+C,QAAA;AAC/C;EAAoB,gBAAA;A3I45qBpB,E2I55qBwC,QAAA;AACxC;EAA0B,gBAAA;A3I85qB1B,E2I95qB8C,QAAA;AAC9C;EAA+B,gBAAA;A3Ig6qB/B,E2Ih6qBmD,QAAA;AACnD;EAAiC,gBAAA;A3Ik6qBjC,E2Il6qBqD,QAAA;AACrD;EAA6B,gBAAA;A3Io6qB7B,E2Ip6qBiD,QAAA;AACjD;EAA6B,gBAAA;A3Is6qB7B,E2It6qBiD,QAAA;AACjD;EAAoB,gBAAA;A3Iw6qBpB,E2Ix6qBwC,QAAA;AACxC;EAA+B,gBAAA;A3I06qB/B,E2I16qBmD,QAAA;AACnD;EAAyB,gBAAA;A3I46qBzB,E2I56qB6C,QAAA;AAC7C;EAA2B,gBAAA;A3I86qB3B,E2I96qB+C,QAAA;AAC/C;EAA0B,gBAAA;A3Ig7qB1B,E2Ih7qB8C,QAAA;AAC9C;EAA6B,gBAAA;A3Ik7qB7B,E2Il7qBiD,QAAA;AACjD;EAA+B,gBAAA;A3Io7qB/B,E2Ip7qBmD,QAAA;AACnD;EAA2B,gBAAA;A3Is7qB3B,E2It7qB+C,QAAA;AAC/C;EAAuB,gBAAA;A3Iw7qBvB,E2Ix7qB2C,QAAA;AAC3C;EAAiC,gBAAA;A3I07qBjC,E2I17qBqD,QAAA;AACrD;EAAsB,gBAAA;A3I47qBtB,E2I57qB0C,QAAA;AAC1C;EAA2B,gBAAA;A3I87qB3B,E2I97qB+C,QAAA;AAC/C;EAAmB,gBAAA;A3Ig8qBnB,E2Ih8qBuC,QAAA;AACvC;EAAsB,gBAAA;A3Ik8qBtB,E2Il8qB0C,QAAA;AAC1C;EAA4B,gBAAA;A3Io8qB5B,E2Ip8qBgD,QAAA;AAChD;EAAwB,gBAAA;A3Is8qBxB,E2It8qB4C,QAAA;AAC5C;EAAwB,gBAAA;A3Iw8qBxB,E2Ix8qB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I08qBpB,E2I18qBwC,QAAA;AACxC;EAAuB,gBAAA;A3I48qBvB,E2I58qB2C,QAAA;AAC3C;EAAyB,gBAAA;A3I88qBzB,E2I98qB6C,QAAA;AAC7C;EAA+B,gBAAA;A3Ig9qB/B,E2Ih9qBmD,QAAA;AACnD;EAAoB,gBAAA;A3Ik9qBpB,E2Il9qBwC,QAAA;AACxC;EAAkB,gBAAA;A3Io9qBlB,E2Ip9qBsC,QAAA;AACtC;EAAwB,gBAAA;A3Is9qBxB,E2It9qB4C,QAAA;AAC5C;EAAmB,gBAAA;A3Iw9qBnB,E2Ix9qBuC,QAAA;AACvC;EAAwB,gBAAA;A3I09qBxB,E2I19qB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I49qBpB,E2I59qBwC,QAAA;AACxC;EAAuB,gBAAA;A3I89qBvB,E2I99qB2C,QAAA;AAC3C;EAAwB,gBAAA;A3Ig+qBxB,E2Ih+qB4C,QAAA;AAC5C;EAAoB,gBAAA;A3Ik+qBpB,E2Il+qBwC,QAAA;AACxC;EAA2B,gBAAA;A3Io+qB3B,E2Ip+qB+C,QAAA;AAC/C;EAA6B,gBAAA;A3Is+qB7B,E2It+qBiD,QAAA;AACjD;EAAsB,gBAAA;A3Iw+qBtB,E2Ix+qB0C,QAAA;AAC1C;EAAwB,gBAAA;A3I0+qBxB,E2I1+qB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I4+qBpB,E2I5+qBwC,QAAA;AACxC;EAA4B,gBAAA;A3I8+qB5B,E2I9+qBgD,QAAA;AAChD;EAAsB,gBAAA;A3Ig/qBtB,E2Ih/qB0C,QAAA;AAC1C;EAAsB,gBAAA;A3Ik/qBtB,E2Il/qB0C,QAAA;AAC1C;EAAyB,gBAAA;A3Io/qBzB,E2Ip/qB6C,QAAA;AAC7C;EAAsB,gBAAA;A3Is/qBtB,E2It/qB0C,QAAA;AAC1C;EAA6B,gBAAA;A3Iw/qB7B,E2Ix/qBiD,QAAA;AACjD;EAAyB,gBAAA;A3I0/qBzB,E2I1/qB6C,QAAA;AAC7C;EAAyB,gBAAA;A3I4/qBzB,E2I5/qB6C,QAAA;AAC7C;EAAwB,gBAAA;A3I8/qBxB,E2I9/qB4C,QAAA;AAC5C;EAAwB,gBAAA;A3IggrBxB,E2IhgrB4C,QAAA;AAC5C;EAAqB,gBAAA;A3IkgrBrB,E2IlgrByC,QAAA;AACzC;EAA6B,gBAAA;A3IogrB7B,E2IpgrBiD,QAAA;AACjD;EAA+B,gBAAA;A3IsgrB/B,E2ItgrBmD,QAAA;AACnD;EAAyB,gBAAA;A3IwgrBzB,E2IxgrB6C,QAAA;AAC7C;EAA2B,gBAAA;A3I0grB3B,E2I1grB+C,QAAA;AAC/C;EAAoB,gBAAA;A3I4grBpB,E2I5grBwC,QAAA;AACxC;EAAqB,gBAAA;A3I8grBrB,E2I9grByC,QAAA;AACzC;EAAkB,gBAAA;A3IghrBlB,E2IhhrBsC,QAAA;AACtC;EAAuB,gBAAA;A3IkhrBvB,E2IlhrB2C,QAAA;AAC3C;EAAyB,gBAAA;A3IohrBzB,E2IphrB6C,QAAA;AAC7C;EAAwB,gBAAA;A3IshrBxB,E2IthrB4C,QAAA;AAC5C;EAA0B,gBAAA;A3IwhrB1B,E2IxhrB8C,QAAA;AAC9C;EAA0B,gBAAA;A3I0hrB1B,E2I1hrB8C,QAAA;AAC9C;EAA0B,gBAAA;A3I4hrB1B,E2I5hrB8C,QAAA;AAC9C;EAA2B,gBAAA;A3I8hrB3B,E2I9hrB+C,QAAA;AAC/C;EAAoB,gBAAA;A3IgirBpB,E2IhirBwC,QAAA;AACxC;EAAsB,gBAAA;A3IkirBtB,E2IlirB0C,QAAA;AAC1C;EAA4B,gBAAA;A3IoirB5B,E2IpirBgD,QAAA;AAChD;EAA8B,gBAAA;A3IsirB9B,E2ItirBkD,QAAA;AAClD;EAAwB,gBAAA;A3IwirBxB,E2IxirB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I0irBpB,E2I1irBwC,QAAA;AACxC;EAA0B,gBAAA;A3I4irB1B,E2I5irB8C,QAAA;AAC9C;EAAmB,gBAAA;A3I8irBnB,E2I9irBuC,QAAA;AACvC;EAAmB,gBAAA;A3IgjrBnB,E2IhjrBuC,QAAA;AACvC;EAA0B,gBAAA;A3IkjrB1B,E2IljrB8C,QAAA;AAC9C;EAA0B,gBAAA;A3IojrB1B,E2IpjrB8C,QAAA;AAC9C;EAAmB,gBAAA;A3IsjrBnB,E2ItjrBuC,QAAA;AACvC;EAAqB,gBAAA;A3IwjrBrB,E2IxjrByC,QAAA;AACzC;EAAsB,gBAAA;A3I0jrBtB,E2I1jrB0C,QAAA;AAC1C;EAAyB,gBAAA;A3I4jrBzB,E2I5jrB6C,QAAA;AAC7C;EAAuB,gBAAA;A3I8jrBvB,E2I9jrB2C,QAAA;AAC3C;EAA2B,gBAAA;A3IgkrB3B,E2IhkrB+C,QAAA;AAC/C;EAAoB,gBAAA;A3IkkrBpB,E2IlkrBwC,QAAA;AACxC;EAAoB,gBAAA;A3IokrBpB,E2IpkrBwC,QAAA;AACxC;EAAkC,gBAAA;A3IskrBlC,E2ItkrBsD,QAAA;AACtD;EAAiC,gBAAA;A3IwkrBjC,E2IxkrBqD,QAAA;AACrD;EAAgC,gBAAA;A3I0krBhC,E2I1krBoD,QAAA;AACpD;EAAgC,gBAAA;A3I4krBhC,E2I5krBoD,QAAA;AACpD;EAAqC,gBAAA;A3I8krBrC,E2I9krByD,QAAA;AACzD;EAAiC,gBAAA;A3IglrBjC,E2IhlrBqD,QAAA;AACrD;EAAgC,gBAAA;A3IklrBhC,E2IllrBoD,QAAA;AACpD;EAAgC,gBAAA;A3IolrBhC,E2IplrBoD,QAAA;AACpD;EAAiC,gBAAA;A3IslrBjC,E2ItlrBqD,QAAA;AACrD;EAA2B,gBAAA;A3IwlrB3B,E2IxlrB+C,QAAA;AAC/C;EAAuB,gBAAA;A3I0lrBvB,E2I1lrB2C,QAAA;AAC3C;EAA2B,gBAAA;A3I4lrB3B,E2I5lrB+C,QAAA;AAC/C;EAA0B,gBAAA;A3I8lrB1B,E2I9lrB8C,QAAA;AAC9C;EAAoB,gBAAA;A3IgmrBpB,E2IhmrBwC,QAAA;AACxC;EAAsB,gBAAA;A3IkmrBtB,E2IlmrB0C,QAAA;AAC1C;EAAwB,gBAAA;A3IomrBxB,E2IpmrB4C,QAAA;AAC5C;EAAmB,gBAAA;A3IsmrBnB,E2ItmrBuC,QAAA;AACvC;EAA2B,gBAAA;A3IwmrB3B,E2IxmrB+C,QAAA;AAC/C;EAA8B,gBAAA;A3I0mrB9B,E2I1mrBkD,QAAA;AAClD;EAA+B,gBAAA;A3I4mrB/B,E2I5mrBmD,QAAA;AACnD;EAAsB,gBAAA;A3I8mrBtB,E2I9mrB0C,QAAA;AAC1C;EAA4B,gBAAA;A3IgnrB5B,E2IhnrBgD,QAAA;AAChD;EAAwB,gBAAA;A3IknrBxB,E2IlnrB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IonrBpB,E2IpnrBwC,QAAA;AACxC;EAA0B,gBAAA;A3IsnrB1B,E2ItnrB8C,QAAA;AAC9C;EAAsB,gBAAA;A3IwnrBtB,E2IxnrB0C,QAAA;AAC1C;EAA2B,gBAAA;A3I0nrB3B,E2I1nrB+C,QAAA;AAC/C;EAA+B,gBAAA;A3I4nrB/B,E2I5nrBmD,QAAA;AACnD;EAAmB,gBAAA;A3I8nrBnB,E2I9nrBuC,QAAA;AACvC;EAAsB,gBAAA;A3IgorBtB,E2IhorB0C,QAAA;AAC1C;EAAyB,gBAAA;A3IkorBzB,E2IlorB6C,QAAA;AAC7C;EAAqB,gBAAA;A3IoorBrB,E2IporByC,QAAA;AACzC;EAAyB,gBAAA;A3IsorBzB,E2ItorB6C,QAAA;AAC7C;EAA+B,gBAAA;A3IworB/B,E2IxorBmD,QAAA;AACnD;EAA2C,gBAAA;A3I0orB3C,E2I1orB+D,QAAA;AAC/D;EAAoB,gBAAA;A3I4orBpB,E2I5orBwC,QAAA;AACxC;EAAuB,gBAAA;A3I8orBvB,E2I9orB2C,QAAA;AAC3C;EAAyB,gBAAA;A3IgprBzB,E2IhprB6C,QAAA;AAC7C;EAAsB,gBAAA;A3IkprBtB,E2IlprB0C,QAAA;AAC1C;EAA4B,gBAAA;A3IoprB5B,E2IpprBgD,QAAA;AAChD;EAAkB,gBAAA;A3IsprBlB,E2ItprBsC,QAAA;AACtC;EAA6B,gBAAA;A3IwprB7B,E2IxprBiD,QAAA;AACjD;EAAoB,gBAAA;A3I0prBpB,E2I1prBwC,QAAA;AACxC;EAAsB,gBAAA;A3I4prBtB,E2I5prB0C,QAAA;AAC1C;EAAyB,gBAAA;A3I8prBzB,E2I9prB6C,QAAA;AAC7C;EAAwB,gBAAA;A3IgqrBxB,E2IhqrB4C,QAAA;AAC5C;EAAyB,gBAAA;A3IkqrBzB,E2IlqrB6C,QAAA;AAC7C;EAAkB,gBAAA;A3IoqrBlB,E2IpqrBsC,QAAA;AACtC;EAA2B,gBAAA;A3IsqrB3B,E2ItqrB+C,QAAA;AAC/C;EAA4B,gBAAA;A3IwqrB5B,E2IxqrBgD,QAAA;AAChD;EAAsB,gBAAA;A3I0qrBtB,E2I1qrB0C,QAAA;AAC1C;EAAuB,gBAAA;A3I4qrBvB,E2I5qrB2C,QAAA;AAC3C;EAAsB,gBAAA;A3I8qrBtB,E2I9qrB0C,QAAA;AAC1C;EAAoB,gBAAA;A3IgrrBpB,E2IhrrBwC,QAAA;AACxC;EAAuB,gBAAA;A3IkrrBvB,E2IlrrB2C,QAAA;AAC3C;EAAqB,gBAAA;A3IorrBrB,E2IprrByC,QAAA;AACzC;EAAyB,gBAAA;A3IsrrBzB,E2ItrrB6C,QAAA;AAC7C;EAA2B,gBAAA;A3IwrrB3B,E2IxrrB+C,QAAA;AAC/C;EAA0B,gBAAA;A3I0rrB1B,E2I1rrB8C,QAAA;AAC9C;EAAqB,gBAAA;A3I4rrBrB,E2I5rrByC,QAAA;AACzC;EAAqB,gBAAA;A3I8rrBrB,E2I9rrByC,QAAA;AACzC;EAAyB,gBAAA;A3IgsrBzB,E2IhsrB6C,QAAA;AAC7C;EAAgC,gBAAA;A3IksrBhC,E2IlsrBoD,QAAA;AACpD;EAAiC,gBAAA;A3IosrBjC,E2IpsrBqD,QAAA;AACrD;EAA6B,gBAAA;A3IssrB7B,E2ItsrBiD,QAAA;AACjD;EAAqB,gBAAA;A3IwsrBrB,E2IxsrByC,QAAA;AACzC;EAAsB,gBAAA;A3I0srBtB,E2I1srB0C,QAAA;AAC1C;EAA0B,gBAAA;A3I4srB1B,E2I5srB8C,QAAA;AAC9C;EAAwB,gBAAA;A3I8srBxB,E2I9srB4C,QAAA;AAC5C;EAA2B,gBAAA;A3IgtrB3B,E2IhtrB+C,QAAA;AAC/C;EAAiC,gBAAA;A3IktrBjC,E2IltrBqD,QAAA;AACrD;EAA8B,gBAAA;A3IotrB9B,E2IptrBkD,QAAA;AAClD;EAA2B,gBAAA;A3IstrB3B,E2IttrB+C,QAAA;AAC/C;EAAqB,gBAAA;A3IwtrBrB,E2IxtrByC,QAAA;AACzC;EAAmB,gBAAA;A3I0trBnB,E2I1trBuC,QAAA;AACvC;EAAmB,gBAAA;A3I4trBnB,E2I5trBuC,QAAA;AACvC;EAA8B,gBAAA;A3I8trB9B,E2I9trBkD,QAAA;AAClD;EAAgC,gBAAA;A3IgurBhC,E2IhurBoD,QAAA;AACpD;EAA+B,gBAAA;A3IkurB/B,E2IlurBmD,QAAA;AACnD;EAAqB,gBAAA;A3IourBrB,E2IpurByC,QAAA;AACzC;EAAqB,gBAAA;A3IsurBrB,E2IturByC,QAAA;AACzC;EAAsB,gBAAA;A3IwurBtB,E2IxurB0C,QAAA;AAC1C;EAA0B,gBAAA;A3I0urB1B,E2I1urB8C,QAAA;AAC9C;EAAsB,gBAAA;A3I4urBtB,E2I5urB0C,QAAA;AAC1C;EAAmB,gBAAA;A3I8urBnB,E2I9urBuC,QAAA;AACvC;EAAoB,gBAAA;A3IgvrBpB,E2IhvrBwC,QAAA;AACxC;EAAuB,gBAAA;A3IkvrBvB,E2IlvrB2C,QAAA;AAC3C;EAA0B,gBAAA;A3IovrB1B,E2IpvrB8C,QAAA;AAC9C;EAAwB,gBAAA;A3IsvrBxB,E2ItvrB4C,QAAA;AAC5C;EAA2B,gBAAA;A3IwvrB3B,E2IxvrB+C,QAAA;AAC/C;EAAyB,gBAAA;A3I0vrBzB,E2I1vrB6C,QAAA;AAC7C;EAA2B,gBAAA;A3I4vrB3B,E2I5vrB+C,QAAA;AAC/C;EAAyB,gBAAA;A3I8vrBzB,E2I9vrB6C,QAAA;AAC7C;EAAqB,gBAAA;A3IgwrBrB,E2IhwrByC,QAAA;AACzC;EAAsB,gBAAA;A3IkwrBtB,E2IlwrB0C,QAAA;AAC1C;EAA4B,gBAAA;A3IowrB5B,E2IpwrBgD,QAAA;AAChD;EAAuB,gBAAA;A3IswrBvB,E2ItwrB2C,QAAA;AAC3C;EAAsB,gBAAA;A3IwwrBtB,E2IxwrB0C,QAAA;AAC1C;EAA+B,gBAAA;A3I0wrB/B,E2I1wrBmD,QAAA;AACnD;EAAkC,gBAAA;A3I4wrBlC,E2I5wrBsD,QAAA;AACtD;EAA2B,gBAAA;A3I8wrB3B,E2I9wrB+C,QAAA;AAC/C;EAAwB,gBAAA;A3IgxrBxB,E2IhxrB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IkxrBpB,E2IlxrBwC,QAAA;AACxC;EAAwB,gBAAA;A3IoxrBxB,E2IpxrB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IsxrBpB,E2ItxrBwC,QAAA;AACxC;EAA4B,gBAAA;A3IwxrB5B,E2IxxrBgD,QAAA;AAChD;EAAwB,gBAAA;A3I0xrBxB,E2I1xrB4C,QAAA;AAC5C;EAAyB,gBAAA;A3I4xrBzB,E2I5xrB6C,QAAA;AAC7C;EAA0B,gBAAA;A3I8xrB1B,E2I9xrB8C,QAAA;AAC9C;EAAoC,gBAAA;A3IgyrBpC,E2IhyrBwD,QAAA;AACxD;EAAgC,gBAAA;A3IkyrBhC,E2IlyrBoD,QAAA;AACpD;EAA6B,gBAAA;A3IoyrB7B,E2IpyrBiD,QAAA;AACjD;EAAyB,gBAAA;A3IsyrBzB,E2ItyrB6C,QAAA;AAC7C;EAAoB,gBAAA;A3IwyrBpB,E2IxyrBwC,QAAA;AACxC;EAA2B,gBAAA;A3I0yrB3B,E2I1yrB+C,QAAA;AAC/C;EAA6B,gBAAA;A3I4yrB7B,E2I5yrBiD,QAAA;AACjD;EAA8B,gBAAA;A3I8yrB9B,E2I9yrBkD,QAAA;AAClD;EAAyB,gBAAA;A3IgzrBzB,E2IhzrB6C,QAAA;AAC7C;EAA4B,gBAAA;A3IkzrB5B,E2IlzrBgD,QAAA;AAChD;EAAwB,gBAAA;A3IozrBxB,E2IpzrB4C,QAAA;AAC5C;EAA+B,gBAAA;A3IszrB/B,E2ItzrBmD,QAAA;AACnD;EAA6B,gBAAA;A3IwzrB7B,E2IxzrBiD,QAAA;AACjD;EAAmB,gBAAA;A3I0zrBnB,E2I1zrBuC,QAAA;AACvC;EAAsB,gBAAA;A3I4zrBtB,E2I5zrB0C,QAAA;AAC1C;EAAwB,gBAAA;A3I8zrBxB,E2I9zrB4C,QAAA;AAC5C;EAAoB,gBAAA;A3Ig0rBpB,E2Ih0rBwC,QAAA;AACxC;EAAqB,gBAAA;A3Ik0rBrB,E2Il0rByC,QAAA;AACzC;EAAmB,gBAAA;A3Io0rBnB,E2Ip0rBuC,QAAA;AACvC;EAAoB,gBAAA;A3Is0rBpB,E2It0rBwC,QAAA;AACxC;EAA0B,gBAAA;A3Iw0rB1B,E2Ix0rB8C,QAAA;AAC9C;EAA2B,gBAAA;A3I00rB3B,E2I10rB+C,QAAA;AAC/C;EAAqB,gBAAA;A3I40rBrB,E2I50rByC,QAAA;AACzC;EAAqB,gBAAA;A3I80rBrB,E2I90rByC,QAAA;AACzC;EAA4B,gBAAA;A3Ig1rB5B,E2Ih1rBgD,QAAA;AAChD;EAAmB,gBAAA;A3Ik1rBnB,E2Il1rBuC,QAAA;AACvC;EAAgC,gBAAA;A3Io1rBhC,E2Ip1rBoD,QAAA;AACpD;EAAmC,gBAAA;A3Is1rBnC,E2It1rBuD,QAAA;AACvD;EAA4B,gBAAA;A3Iw1rB5B,E2Ix1rBgD,QAAA;AAChD;EAA2B,gBAAA;A3I01rB3B,E2I11rB+C,QAAA;AAC/C;EAA0B,gBAAA;A3I41rB1B,E2I51rB8C,QAAA;AAC9C;EAA8B,gBAAA;A3I81rB9B,E2I91rBkD,QAAA;AAClD;EAAwB,gBAAA;A3Ig2rBxB,E2Ih2rB4C,QAAA;AAC5C;EAAwB,gBAAA;A3Ik2rBxB,E2Il2rB4C,QAAA;AAC5C;EAAoB,gBAAA;A3Io2rBpB,E2Ip2rBwC,QAAA;AACxC;EAAwB,gBAAA;A3Is2rBxB,E2It2rB4C,QAAA;AAC5C;EAAwB,gBAAA;A3Iw2rBxB,E2Ix2rB4C,QAAA;AAC5C;EAAsB,gBAAA;A3I02rBtB,E2I12rB0C,QAAA;AAC1C;EAAyB,gBAAA;A3I42rBzB,E2I52rB6C,QAAA;AAC7C;EAAqB,gBAAA;A3I82rBrB,E2I92rByC,QAAA;AACzC;EAA2B,gBAAA;A3Ig3rB3B,E2Ih3rB+C,QAAA;AAC/C;EAAuB,gBAAA;A3Ik3rBvB,E2Il3rB2C,QAAA;AAC3C;EAAkB,gBAAA;A3Io3rBlB,E2Ip3rBsC,QAAA;AACtC;EAAqB,gBAAA;A3Is3rBrB,E2It3rByC,QAAA;AACzC;EAAuB,gBAAA;A3Iw3rBvB,E2Ix3rB2C,QAAA;AAC3C;EAAyB,gBAAA;A3I03rBzB,E2I13rB6C,QAAA;AAC7C;EAAqB,gBAAA;A3I43rBrB,E2I53rByC,QAAA;AACzC;EAAsB,gBAAA;A3I83rBtB,E2I93rB0C,QAAA;AAC1C;EAAqB,gBAAA;A3Ig4rBrB,E2Ih4rByC,QAAA;AACzC;EAA+B,gBAAA;A3Ik4rB/B,E2Il4rBmD,QAAA;AACnD;EAAyB,gBAAA;A3Io4rBzB,E2Ip4rB6C,QAAA;AAC7C;EAAmB,gBAAA;A3Is4rBnB,E2It4rBuC,QAAA;AACvC;EAAsB,gBAAA;A3Iw4rBtB,E2Ix4rB0C,QAAA;AAC1C;EAAoB,gBAAA;A3I04rBpB,E2I14rBwC,QAAA;AACxC;EAAqB,gBAAA;A3I44rBrB,E2I54rByC,QAAA;AACzC;EAAsB,gBAAA;A3I84rBtB,E2I94rB0C,QAAA;AAC1C;EAA8B,gBAAA;A3Ig5rB9B,E2Ih5rBkD,QAAA;AAClD;EAAsB,gBAAA;A3Ik5rBtB,E2Il5rB0C,QAAA;AAC1C;EAAkB,gBAAA;A3Io5rBlB,E2Ip5rBsC,QAAA;AACtC;EAAmB,gBAAA;A3Is5rBnB,E2It5rBuC,QAAA;AACvC;EAAmB,gBAAA;A3Iw5rBnB,E2Ix5rBuC,QAAA;AACvC;EAAmB,gBAAA;A3I05rBnB,E2I15rBuC,QAAA;AACvC;EAAyB,gBAAA;A3I45rBzB,E2I55rB6C,QAAA;AAC7C;EAA2B,gBAAA;A3I85rB3B,E2I95rB+C,QAAA;AAC/C;EAAuB,gBAAA;A3Ig6rBvB,E2Ih6rB2C,QAAA;AAC3C;EAAwB,gBAAA;A3Ik6rBxB,E2Il6rB4C,QAAA;AAC5C;EAAgC,gBAAA;A3Io6rBhC,E2Ip6rBoD,QAAA;AACpD;EAA+B,gBAAA;A3Is6rB/B,E2It6rBmD,QAAA;AACnD;EAAgC,gBAAA;A3Iw6rBhC,E2Ix6rBoD,QAAA;AACpD;EAA+B,gBAAA;A3I06rB/B,E2I16rBmD,QAAA;AACnD;EAAkC,gBAAA;A3I46rBlC,E2I56rBsD,QAAA;AACtD;EAAwC,gBAAA;A3I86rBxC,E2I96rB4D,QAAA;AAC5D;EAA0B,gBAAA;A3Ig7rB1B,E2Ih7rB8C,QAAA;AAC9C;EAA0B,gBAAA;A3Ik7rB1B,E2Il7rB8C,QAAA;AAC9C;EAAwB,gBAAA;A3Io7rBxB,E2Ip7rB4C,QAAA;AAC5C;EAAkC,gBAAA;A3Is7rBlC,E2It7rBsD,QAAA;AACtD;EAAmB,gBAAA;A3Iw7rBnB,E2Ix7rBuC,QAAA;AACvC;EAAuB,gBAAA;A3I07rBvB,E2I17rB2C,QAAA;AAC3C;EAAuB,gBAAA;A3I47rBvB,E2I57rB2C,QAAA;AAC3C;EAAiB,gBAAA;A3I87rBjB,E2I97rBqC,QAAA;AACrC;EAA0B,gBAAA;A3Ig8rB1B,E2Ih8rB8C,QAAA;AAC9C;EAA0B,gBAAA;A3Ik8rB1B,E2Il8rB8C,QAAA;AAC9C;EAAwB,gBAAA;A3Io8rBxB,E2Ip8rB4C,QAAA;AAC5C;EAAgC,gBAAA;A3Is8rBhC,E2It8rBoD,QAAA;AACpD;EAA+B,gBAAA;A3Iw8rB/B,E2Ix8rBmD,QAAA;AACnD;EAA2B,gBAAA;A3I08rB3B,E2I18rB+C,QAAA;AAC/C;EAAqB,gBAAA;A3I48rBrB,E2I58rByC,QAAA;AACzC;EAA2B,gBAAA;A3I88rB3B,E2I98rB+C,QAAA;AAC/C;EAA2B,gBAAA;A3Ig9rB3B,E2Ih9rB+C,QAAA;AAC/C;EAAoB,gBAAA;A3Ik9rBpB,E2Il9rBwC,QAAA;AACxC;EAAyB,gBAAA;A3Io9rBzB,E2Ip9rB6C,QAAA;AAC7C;EAAwB,gBAAA;A3Is9rBxB,E2It9rB4C,QAAA;AAC5C;EAAiC,gBAAA;A3Iw9rBjC,E2Ix9rBqD,QAAA;AACrD;EAA+B,gBAAA;A3I09rB/B,E2I19rBmD,QAAA;AACnD;EAAsB,gBAAA;A3I49rBtB,E2I59rB0C,QAAA;AAC1C;EAA+B,gBAAA;A3I89rB/B,E2I99rBmD,QAAA;AACnD;EAAwB,gBAAA;A3Ig+rBxB,E2Ih+rB4C,QAAA;AAC5C;EAA8B,gBAAA;A3Ik+rB9B,E2Il+rBkD,QAAA;AAClD;EAAwB,gBAAA;A3Io+rBxB,E2Ip+rB4C,QAAA;AAC5C;EAAoB,gBAAA;A3Is+rBpB,E2It+rBwC,QAAA;AACxC;EAAoB,gBAAA;A3Iw+rBpB,E2Ix+rBwC,QAAA;AACxC;EAAuB,gBAAA;A3I0+rBvB,E2I1+rB2C,QAAA;AAC3C;EAAqB,gBAAA;A3I4+rBrB,E2I5+rByC,QAAA;AACzC;EAAqB,gBAAA;A3I8+rBrB,E2I9+rByC,QAAA;AACzC;EAAyB,gBAAA;A3Ig/rBzB,E2Ih/rB6C,QAAA;AAC7C;EAA4B,gBAAA;A3Ik/rB5B,E2Il/rBgD,QAAA;AAChD;EAAoB,gBAAA;A3Io/rBpB,E2Ip/rBwC,QAAA;AACxC;EAAyB,gBAAA;A3Is/rBzB,E2It/rB6C,QAAA;AAC7C;EAA4B,gBAAA;A3Iw/rB5B,E2Ix/rBgD,QAAA;AAChD;EAAqB,gBAAA;A3I0/rBrB,E2I1/rByC,QAAA;AACzC;EAA6B,gBAAA;A3I4/rB7B,E2I5/rBiD,QAAA;AACjD;EAAuB,gBAAA;A3I8/rBvB,E2I9/rB2C,QAAA;AAC3C;EAA0B,gBAAA;A3IggsB1B,E2IhgsB8C,QAAA;AAC9C;EAAsB,gBAAA;A3IkgsBtB,E2IlgsB0C,QAAA;AAC1C;EAAuB,gBAAA;A3IogsBvB,E2IpgsB2C,QAAA;AAC3C;EAAuB,gBAAA;A3IsgsBvB,E2ItgsB2C,QAAA;AAC3C;EAAwB,gBAAA;A3IwgsBxB,E2IxgsB4C,QAAA;AAC5C;EAAyB,gBAAA;A3I0gsBzB,E2I1gsB6C,QAAA;AAC7C;EAAyB,gBAAA;A3I4gsBzB,E2I5gsB6C,QAAA;AAC7C;EAAqB,gBAAA;A3I8gsBrB,E2I9gsByC,QAAA;AACzC;EAAyB,gBAAA;A3IghsBzB,E2IhhsB6C,QAAA;AAC7C;EAAqB,gBAAA;A3IkhsBrB,E2IlhsByC,QAAA;AACzC;EAAyB,gBAAA;A3IohsBzB,E2IphsB6C,QAAA;AAC7C;EAAyB,gBAAA;A3IshsBzB,E2IthsB6C,QAAA;AAC7C;EAAyB,gBAAA;A3IwhsBzB,E2IxhsB6C,QAAA;AAC7C;EAA0B,gBAAA;A3I0hsB1B,E2I1hsB8C,QAAA;AAC9C;EAA+B,gBAAA;A3I4hsB/B,E2I5hsBmD,QAAA;AACnD;EAA4B,gBAAA;A3I8hsB5B,E2I9hsBgD,QAAA;AAChD;EAAyB,gBAAA;A3IgisBzB,E2IhisB6C,QAAA;AAC7C;EAAwB,gBAAA;A3IkisBxB,E2IlisB4C,QAAA;AAC5C;EAA0B,gBAAA;A3IoisB1B,E2IpisB8C,QAAA;AAC9C;EAAyB,gBAAA;A3IsisBzB,E2ItisB6C,QAAA;AAC7C;EAAmB,gBAAA;A3IwisBnB,E2IxisBuC,QAAA;AACvC;EAAwB,gBAAA;A3I0isBxB,E2I1isB4C,QAAA;AAC5C;EAA2B,gBAAA;A3I4isB3B,E2I5isB+C,QAAA;AAC/C;EAAuB,gBAAA;A3I8isBvB,E2I9isB2C,QAAA;AAC3C;EAAgC,gBAAA;A3IgjsBhC,E2IhjsBoD,QAAA;AACpD;EAA4B,gBAAA;A3IkjsB5B,E2IljsBgD,QAAA;AAChD;EAAoB,gBAAA;A3IojsBpB,E2IpjsBwC,QAAA;AACxC;EAAoC,gBAAA;A3IsjsBpC,E2ItjsBwD,QAAA;AACxD;EAAoC,gBAAA;A3IwjsBpC,E2IxjsBwD,QAAA;AACxD;EAAiC,gBAAA;A3I0jsBjC,E2I1jsBqD,QAAA;AACrD;EAAyC,gBAAA;A3I4jsBzC,E2I5jsB6D,QAAA;AAC7D;EAA2C,gBAAA;A3I8jsB3C,E2I9jsB+D,QAAA;AAC/D;EAAwC,gBAAA;A3IgksBxC,E2IhksB4D,QAAA;AAC5D;EAA0B,gBAAA;A3IkksB1B,E2IlksB8C,QAAA;AAC9C;EAAoB,gBAAA;A3IoksBpB,E2IpksBwC,QAAA;AACxC;EAA4B,gBAAA;A3IsksB5B,E2ItksBgD,QAAA;AAChD;EAAqB,gBAAA;A3IwksBrB,E2IxksByC,QAAA;AACzC;EAAiB,gBAAA;A3I0ksBjB,E2I1ksBqC,QAAA;AACrC;EAAkC,gBAAA;A3I4ksBlC,E2I5ksBsD,QAAA;AACtD;EAAwB,gBAAA;A3I8ksBxB,E2I9ksB4C,QAAA;AAC5C;EAAyB,gBAAA;A3IglsBzB,E2IhlsB6C,QAAA;AAC7C;EAA0B,gBAAA;A3IklsB1B,E2IllsB8C,QAAA;AAC9C;EAA0B,gBAAA;A3IolsB1B,E2IplsB8C,QAAA;AAC9C;EAAyB,gBAAA;A3IslsBzB,E2ItlsB6C,QAAA;AAC7C;EAAwB,gBAAA;A3IwlsBxB,E2IxlsB4C,QAAA;AAC5C;EAAqB,gBAAA;A3I0lsBrB,E2I1lsByC,QAAA;AACzC;EAAwB,gBAAA;A3I4lsBxB,E2I5lsB4C,QAAA;AAC5C;EAAoB,gBAAA;A3I8lsBpB,E2I9lsBwC,QAAA;AACxC;EAAmB,gBAAA;A3IgmsBnB,E2IhmsBuC,QAAA;AACvC;EAAqB,gBAAA;A3IkmsBrB,E2IlmsByC,QAAA;AACzC;EAAwB,gBAAA;A3IomsBxB,E2IpmsB4C,QAAA;AAC5C;EAAoB,gBAAA;A3IsmsBpB,E2ItmsBwC,QAAA;AACxC;EAA+B,gBAAA;A3IwmsB/B,E2IxmsBmD,QAAA;AACnD;EAA0B,gBAAA;A3I0msB1B,E2I1msB8C,QAAA;AAC9C;EAAoB,gBAAA;A3I4msBpB,E2I5msBwC,QAAA;AACxC;EAA2B,gBAAA;A3I8msB3B,E2I9msB+C,QAAA;AAC/C;EAAuB,gBAAA;A3IgnsBvB,E2IhnsB2C,QAAA;AAC3C;EAA8B,gBAAA;A3IknsB9B,E2IlnsBkD,QAAA;AAClD;EAA0B,gBAAA;A3IonsB1B,E2IpnsB8C,QAAA;AAC9C;EAAqB,gBAAA;A3IsnsBrB,E2ItnsByC,QAAA;AACzC;EAAqB,gBAAA;A3IwnsBrB,E2IxnsByC,QAAA;AACzC;EAAuB,gBAAA;A3I0nsBvB,E2I1nsB2C,QAAA;AAC3C;EAA2B,gBAAA;A3I4nsB3B,E2I5nsB+C,QAAA;AAC/C;EAA6B,gBAAA;A3I8nsB7B,E2I9nsBiD,QAAA;AACjD;EAAyB,gBAAA;A3IgosBzB,E2IhosB6C,QAAA;AAC7C;EAA0B,gBAAA;A3IkosB1B,E2IlosB8C,QAAA;AAC9C;EAAyB,gBAAA;A3IoosBzB,E2IposB6C,QAAA;AAC7C;EAAmB,gBAAA;A3IsosBnB,E2ItosBuC,QAAA;AACvC;EAAwB,gBAAA;A3IwosBxB,E2IxosB4C,QAAA;AAC5C;EAAuB,gBAAA;A3I0osBvB,E2I1osB2C,QAAA;AAC3C;EAAmB,gBAAA;A3I4osBnB,E2I5osBuC,QAAA;AACvC;EAA0B,gBAAA;A3I8osB1B,E2I9osB8C,QAAA;AAC9C;EAA8B,gBAAA;A3IgpsB9B,E2IhpsBkD,QAAA;AAClD;EAA6B,gBAAA;A3IkpsB7B,E2IlpsBiD,QAAA;AACjD;EAA6B,gBAAA;A3IopsB7B,E2IppsBiD,QAAA;AACjD;EAAqB,gBAAA;A3IspsBrB,E2ItpsByC,QAAA;AACzC;EAAuB,gBAAA;A3IwpsBvB,E2IxpsB2C,QAAA;AAC3C;EAAwB,gBAAA;A3I0psBxB,E2I1psB4C,QAAA;AAC5C;EAAqB,gBAAA;A3I4psBrB,E2I5psByC,QAAA;AACzC;EAAqB,gBAAA;A3I8psBrB,E2I9psByC,QAAA;AACzC;EAAyB,gBAAA;A3IgqsBzB,E2IhqsB6C,QAAA;AAC7C;EAAkB,gBAAA;A3IkqsBlB,E2IlqsBsC,QAAA;AACtC;EAAuB,gBAAA;A3IoqsBvB,E2IpqsB2C,QAAA;AAC3C;EAA0B,gBAAA;A3IsqsB1B,E2ItqsB8C,QAAA;AAC9C;EAAsB,gBAAA;A3IwqsBtB,E2IxqsB0C,QAAA;ACvpC1C;EACE,8BAAA;EACA,sHAAA;A5Ii0uBF;A4I7zuBA;;EAEE,qBAAA;EACA,uCAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;A5I+zuBF;;A4I5zuBA;EAAyB,gBAAA;A5Ig0uBzB;;A4I/zuBA;EAAoB,gBAAA;A5Im0uBpB;;A4Il0uBA;EAA2B,gBAAA;A5Is0uB3B;;A4Ir0uBA;EAA2B,gBAAA;A5Iy0uB3B;;A4Ix0uBA;EAAwB,gBAAA;A5I40uBxB;;A4I30uBA;EAA2B,gBAAA;A5I+0uB3B;;A4I90uBA;EAA0B,gBAAA;A5Ik1uB1B;;A4Ij1uBA;EAAwB,gBAAA;A5Iq1uBxB;;A4Ip1uBA;EAAkB,gBAAA;A5Iw1uBlB;;A4Iv1uBA;EAA4B,gBAAA;A5I21uB5B;;A4I11uBA;EAAkB,gBAAA;A5I81uBlB;;A4I71uBA;EAA2B,gBAAA;A5Ii2uB3B;;A4Ih2uBA;EAAsB,gBAAA;A5Io2uBtB;;A4In2uBA;EAA+B,gBAAA;A5Iu2uB/B;;A4It2uBA;EAA+B,gBAAA;A5I02uB/B;;A4Iz2uBA;EAAgC,gBAAA;A5I62uBhC;;A4I52uBA;EAA6B,gBAAA;A5Ig3uB7B;;A4I/2uBA;EAA6B,gBAAA;A5Im3uB7B;;A4Il3uBA;EAA6B,gBAAA;A5Is3uB7B;;A4Ir3uBA;EAA8B,gBAAA;A5Iy3uB9B;;A4Ix3uBA;EAA2B,gBAAA;A5I43uB3B;;A4I33uBA;EAA8B,gBAAA;A5I+3uB9B;;A4I93uBA;EAAqC,gBAAA;A5Ik4uBrC;;A4Ij4uBA;EAAqC,gBAAA;A5Iq4uBrC;;A4Ip4uBA;EAAgC,gBAAA;A5Iw4uBhC;;A4Iv4uBA;EAA0C,gBAAA;A5I24uB1C;;A4I14uBA;EAAqC,gBAAA;A5I84uBrC;;A4I74uBA;EAA0C,gBAAA;A5Ii5uB1C;;A4Ih5uBA;EAAqC,gBAAA;A5Io5uBrC;;A4In5uBA;EAA8B,gBAAA;A5Iu5uB9B;;A4It5uBA;EAA2C,gBAAA;A5I05uB3C;;A4Iz5uBA;EAAsC,gBAAA;A5I65uBtC;;A4I55uBA;EAA2C,gBAAA;A5Ig6uB3C;;A4I/5uBA;EAAsC,gBAAA;A5Im6uBtC;;A4Il6uBA;EAA+B,gBAAA;A5Is6uB/B;;A4Ir6uBA;EAA+B,gBAAA;A5Iy6uB/B;;A4Ix6uBA;EAAqC,gBAAA;A5I46uBrC;;A4I36uBA;EAAgC,gBAAA;A5I+6uBhC;;A4I96uBA;EAA4B,gBAAA;A5Ik7uB5B;;A4Ij7uBA;EAAyB,gBAAA;A5Iq7uBzB;;A4Ip7uBA;EAAqC,gBAAA;A5Iw7uBrC;;A4Iv7uBA;EAAgC,gBAAA;A5I27uBhC;;A4I17uBA;EAA+B,gBAAA;A5I87uB/B;;A4I77uBA;EAA+B,gBAAA;A5Ii8uB/B;;A4Ih8uBA;EAAqC,gBAAA;A5Io8uBrC;;A4In8uBA;EAAgC,gBAAA;A5Iu8uBhC;;A4It8uBA;EAAyB,gBAAA;A5I08uBzB;;A4Iz8uBA;EAA2B,gBAAA;A5I68uB3B;;A4I58uBA;EAAgC,gBAAA;A5Ig9uBhC;;A4I/8uBA;EAAiC,gBAAA;A5Im9uBjC;;A4Il9uBA;EAAsC,gBAAA;A5Is9uBtC;;A4Ir9uBA;EAAiC,gBAAA;A5Iy9uBjC;;A4Ix9uBA;EAAgC,gBAAA;A5I49uBhC;;A4I39uBA;EAAsC,gBAAA;A5I+9uBtC;;A4I99uBA;EAAiC,gBAAA;A5Ik+uBjC;;A4Ij+uBA;EAA0B,gBAAA;A5Iq+uB1B;;A4Ip+uBA;EAAmC,gBAAA;A5Iw+uBnC;;A4Iv+uBA;EAA8B,gBAAA;A5I2+uB9B;;A4I1+uBA;EAAwC,gBAAA;A5I8+uBxC;;A4I7+uBA;EAAmC,gBAAA;A5Ii/uBnC;;A4Ih/uBA;EAAwC,gBAAA;A5Io/uBxC;;A4In/uBA;EAAmC,gBAAA;A5Iu/uBnC;;A4It/uBA;EAA4B,gBAAA;A5I0/uB5B;;A4Iz/uBA;EAAyC,gBAAA;A5I6/uBzC;;A4I5/uBA;EAAoC,gBAAA;A5IggvBpC;;A4I//uBA;EAAyC,gBAAA;A5ImgvBzC;;A4IlgvBA;EAAoC,gBAAA;A5IsgvBpC;;A4IrgvBA;EAA6B,gBAAA;A5IygvB7B;;A4IxgvBA;EAA6B,gBAAA;A5I4gvB7B;;A4I3gvBA;EAAmC,gBAAA;A5I+gvBnC;;A4I9gvBA;EAA8B,gBAAA;A5IkhvB9B;;A4IjhvBA;EAAuB,gBAAA;A5IqhvBvB;;A4IphvBA;EAAoC,gBAAA;A5IwhvBpC;;A4IvhvBA;EAAkC,gBAAA;A5I2hvBlC;;A4I1hvBA;EAA8B,gBAAA;A5I8hvB9B;;A4I7hvBA;EAA4B,gBAAA;A5IiivB5B;;A4IhivBA;EAAgC,gBAAA;A5IoivBhC;;A4InivBA;EAA0B,gBAAA;A5IuivB1B;;A4ItivBA;EAAgC,gBAAA;A5I0ivBhC;;A4IzivBA;EAA2B,gBAAA;A5I6ivB3B;;A4I5ivBA;EAAuB,gBAAA;A5IgjvBvB;;A4I/ivBA;EAAiB,gBAAA;A5ImjvBjB;;A4IljvBA;EAAyB,gBAAA;A5IsjvBzB;;A4IrjvBA;EAAoB,gBAAA;A5IyjvBpB;;A4IxjvBA;EAAmB,gBAAA;A5I4jvBnB;;A4I3jvBA;EAA6B,gBAAA;A5I+jvB7B;;A4I9jvBA;EAAqC,gBAAA;A5IkkvBrC;;A4IjkvBA;EAAgC,gBAAA;A5IqkvBhC;;A4IpkvBA;EAAwB,gBAAA;A5IwkvBxB;;A4IvkvBA;EAA4B,gBAAA;A5I2kvB5B;;A4I1kvBA;EAAuB,gBAAA;A5I8kvBvB;;A4I7kvBA;EAA4B,gBAAA;A5IilvB5B;;A4IhlvBA;EAAuB,gBAAA;A5IolvBvB;;A4InlvBA;EAA4B,gBAAA;A5IulvB5B;;A4ItlvBA;EAAuB,gBAAA;A5I0lvBvB;;A4IzlvBA;EAA4B,gBAAA;A5I6lvB5B;;A4I5lvBA;EAAuB,gBAAA;A5IgmvBvB;;A4I/lvBA;EAA4B,gBAAA;A5ImmvB5B;;A4IlmvBA;EAAuB,gBAAA;A5IsmvBvB;;A4IrmvBA;EAA4B,gBAAA;A5IymvB5B;;A4IxmvBA;EAAuB,gBAAA;A5I4mvBvB;;A4I3mvBA;EAA4B,gBAAA;A5I+mvB5B;;A4I9mvBA;EAAuB,gBAAA;A5IknvBvB;;A4IjnvBA;EAA4B,gBAAA;A5IqnvB5B;;A4IpnvBA;EAAuB,gBAAA;A5IwnvBvB;;A4IvnvBA;EAA4B,gBAAA;A5I2nvB5B;;A4I1nvBA;EAAuB,gBAAA;A5I8nvBvB;;A4I7nvBA;EAA4B,gBAAA;A5IiovB5B;;A4IhovBA;EAAuB,gBAAA;A5IoovBvB;;A4InovBA;EAA4B,gBAAA;A5IuovB5B;;A4ItovBA;EAAuB,gBAAA;A5I0ovBvB;;A4IzovBA;EAA6B,gBAAA;A5I6ovB7B;;A4I5ovBA;EAAwB,gBAAA;A5IgpvBxB;;A4I/ovBA;EAA4B,gBAAA;A5ImpvB5B;;A4IlpvBA;EAAuB,gBAAA;A5IspvBvB;;A4IrpvBA;EAAuB,gBAAA;A5IypvBvB;;A4IxpvBA;EAA4B,gBAAA;A5I4pvB5B;;A4I3pvBA;EAAuB,gBAAA;A5I+pvBvB;;A4I9pvBA;EAAyB,gBAAA;A5IkqvBzB;;A4IjqvBA;EAAoB,gBAAA;A5IqqvBpB;;A4IpqvBA;EAAkB,gBAAA;A5IwqvBlB;;A4IvqvBA;EAA6B,gBAAA;A5I2qvB7B;;A4I1qvBA;EAAkC,gBAAA;A5I8qvBlC;;A4I7qvBA;EAA6B,gBAAA;A5IirvB7B;;A4IhrvBA;EAA8B,gBAAA;A5IorvB9B;;A4InrvBA;EAAwB,gBAAA;A5IurvBxB;;A4ItrvBA;EAA0B,gBAAA;A5I0rvB1B;;A4IzrvBA;EAAqB,gBAAA;A5I6rvBrB;;A4I5rvBA;EAA2B,gBAAA;A5IgsvB3B;;A4I/rvBA;EAAsB,gBAAA;A5ImsvBtB;;A4IlsvBA;EAA2B,gBAAA;A5IssvB3B;;A4IrsvBA;EAAsB,gBAAA;A5IysvBtB;;A4IxsvBA;EAA+B,gBAAA;A5I4svB/B;;A4I3svBA;EAA2B,gBAAA;A5I+svB3B;;A4I9svBA;EAA2B,gBAAA;A5IktvB3B;;A4IjtvBA;EAAsB,gBAAA;A5IqtvBtB;;A4IptvBA;EAAwB,gBAAA;A5IwtvBxB;;A4IvtvBA;EAAmB,gBAAA;A5I2tvBnB;;A4I1tvBA;EAAqB,gBAAA;A5I8tvBrB;;A4I7tvBA;EAAsB,gBAAA;A5IiuvBtB;;A4IhuvBA;EAAsB,gBAAA;A5IouvBtB;;A4InuvBA;EAA8B,gBAAA;A5IuuvB9B;;A4ItuvBA;EAAyB,gBAAA;A5I0uvBzB;;A4IzuvBA;EAA8B,gBAAA;A5I6uvB9B;;A4I5uvBA;EAA+B,gBAAA;A5IgvvB/B;;A4I/uvBA;EAAwB,gBAAA;A5ImvvBxB;;A4IlvvBA;EAAwB,gBAAA;A5IsvvBxB;;A4IrvvBA;EAAmB,gBAAA;A5IyvvBnB;;A4IxvvBA;EAAkC,gBAAA;A5I4vvBlC;;A4I3vvBA;EAA6B,gBAAA;A5I+vvB7B;;A4I9vvBA;EAAiC,gBAAA;A5IkwvBjC;;A4IjwvBA;EAA4B,gBAAA;A5IqwvB5B;;A4IpwvBA;EAA4B,gBAAA;A5IwwvB5B;;A4IvwvBA;EAAkC,gBAAA;A5I2wvBlC;;A4I1wvBA;EAA6B,gBAAA;A5I8wvB7B;;A4I7wvBA;EAAiC,gBAAA;A5IixvBjC;;A4IhxvBA;EAA4B,gBAAA;A5IoxvB5B;;A4InxvBA;EAAiC,gBAAA;A5IuxvBjC;;A4ItxvBA;EAA4B,gBAAA;A5I0xvB5B;;A4IzxvBA;EAA8B,gBAAA;A5I6xvB9B;;A4I5xvBA;EAAyB,gBAAA;A5IgyvBzB;;A4I/xvBA;EAAuB,gBAAA;A5ImyvBvB;;A4IlyvBA;EAA6B,gBAAA;A5IsyvB7B;;A4IryvBA;EAAwB,gBAAA;A5IyyvBxB;;A4IxyvBA;EAAwB,gBAAA;A5I4yvBxB;;A4I3yvBA;EAA6B,gBAAA;A5I+yvB7B;;A4I9yvBA;EAA+B,gBAAA;A5IkzvB/B;;A4IjzvBA;EAAwB,gBAAA;A5IqzvBxB;;A4IpzvBA;EAAyB,gBAAA;A5IwzvBzB;;A4IvzvBA;EAA4B,gBAAA;A5I2zvB5B;;A4I1zvBA;EAA4B,gBAAA;A5I8zvB5B;;A4I7zvBA;EAA2B,gBAAA;A5Ii0vB3B;;A4Ih0vBA;EAA0B,gBAAA;A5Io0vB1B;;A4In0vBA;EAA4B,gBAAA;A5Iu0vB5B;;A4It0vBA;EAA2B,gBAAA;A5I00vB3B;;A4Iz0vBA;EAA2B,gBAAA;A5I60vB3B;;A4I50vBA;EAA2B,gBAAA;A5Ig1vB3B;;A4I/0vBA;EAAyB,gBAAA;A5Im1vBzB;;A4Il1vBA;EAA2B,gBAAA;A5Is1vB3B;;A4Ir1vBA;EAAqB,gBAAA;A5Iy1vBrB;;A4Ix1vBA;EAAmC,gBAAA;A5I41vBnC;;A4I31vBA;EAA2B,gBAAA;A5I+1vB3B;;A4I91vBA;EAAkC,gBAAA;A5Ik2vBlC;;A4Ij2vBA;EAAmC,gBAAA;A5Iq2vBnC;;A4Ip2vBA;EAA6B,gBAAA;A5Iw2vB7B;;A4Iv2vBA;EAAqC,gBAAA;A5I22vBrC;;A4I12vBA;EAAsC,gBAAA;A5I82vBtC;;A4I72vBA;EAAgC,gBAAA;A5Ii3vBhC;;A4Ih3vBA;EAAgC,gBAAA;A5Io3vBhC;;A4In3vBA;EAAiC,gBAAA;A5Iu3vBjC;;A4It3vBA;EAAmC,gBAAA;A5I03vBnC;;A4Iz3vBA;EAAoC,gBAAA;A5I63vBpC;;A4I53vBA;EAA8B,gBAAA;A5Ig4vB9B;;A4I/3vBA;EAA6B,gBAAA;A5Im4vB7B;;A4Il4vBA;EAA8B,gBAAA;A5Is4vB9B;;A4Ir4vBA;EAAgC,gBAAA;A5Iy4vBhC;;A4Ix4vBA;EAAiC,gBAAA;A5I44vBjC;;A4I34vBA;EAA2B,gBAAA;A5I+4vB3B;;A4I94vBA;EAAuB,gBAAA;A5Ik5vBvB;;A4Ij5vBA;EAAkB,gBAAA;A5Iq5vBlB;;A4Ip5vBA;EAAqB,gBAAA;A5Iw5vBrB;;A4Iv5vBA;EAAqB,gBAAA;A5I25vBrB;;A4I15vBA;EAA6B,gBAAA;A5I85vB7B;;A4I75vBA;EAAwB,gBAAA;A5Ii6vBxB;;A4Ih6vBA;EAAuC,gBAAA;A5Io6vBvC;;A4In6vBA;EAAkC,gBAAA;A5Iu6vBlC;;A4It6vBA;EAAsC,gBAAA;A5I06vBtC;;A4Iz6vBA;EAAiC,gBAAA;A5I66vBjC;;A4I56vBA;EAAmC,gBAAA;A5Ig7vBnC;;A4I/6vBA;EAA8B,gBAAA;A5Im7vB9B;;A4Il7vBA;EAAkC,gBAAA;A5Is7vBlC;;A4Ir7vBA;EAA6B,gBAAA;A5Iy7vB7B;;A4Ix7vBA;EAA4B,gBAAA;A5I47vB5B;;A4I37vBA;EAAwB,gBAAA;A5I+7vBxB;;A4I97vBA;EAAyB,gBAAA;A5Ik8vBzB;;A4Ij8vBA;EAAoB,gBAAA;A5Iq8vBpB;;A4Ip8vBA;EAA0B,gBAAA;A5Iw8vB1B;;A4Iv8vBA;EAAqB,gBAAA;A5I28vBrB;;A4I18vBA;EAAuB,gBAAA;A5I88vBvB;;A4I78vBA;EAAkB,gBAAA;A5Ii9vBlB;;A4Ih9vBA;EAAuB,gBAAA;A5Io9vBvB;;A4In9vBA;EAAuB,gBAAA;A5Iu9vBvB;;A4It9vBA;EAA8B,gBAAA;A5I09vB9B;;A4Iz9vBA;EAAyB,gBAAA;A5I69vBzB;;A4I59vBA;EAAkC,gBAAA;A5Ig+vBlC;;A4I/9vBA;EAA6B,gBAAA;A5Im+vB7B;;A4Il+vBA;EAAiC,gBAAA;A5Is+vBjC;;A4Ir+vBA;EAA4B,gBAAA;A5Iy+vB5B;;A4Ix+vBA;EAAgC,gBAAA;A5I4+vBhC;;A4I3+vBA;EAA2B,gBAAA;A5I++vB3B;;A4I9+vBA;EAAkC,gBAAA;A5Ik/vBlC;;A4Ij/vBA;EAA6B,gBAAA;A5Iq/vB7B;;A4Ip/vBA;EAA4B,gBAAA;A5Iw/vB5B;;A4Iv/vBA;EAAkC,gBAAA;A5I2/vBlC;;A4I1/vBA;EAA6B,gBAAA;A5I8/vB7B;;A4I7/vBA;EAAkC,gBAAA;A5IigwBlC;;A4IhgwBA;EAA6B,gBAAA;A5IogwB7B;;A4IngwBA;EAAiC,gBAAA;A5IugwBjC;;A4ItgwBA;EAA4B,gBAAA;A5I0gwB5B;;A4IzgwBA;EAAkC,gBAAA;A5I6gwBlC;;A4I5gwBA;EAA6B,gBAAA;A5IghwB7B;;A4I/gwBA;EAAiC,gBAAA;A5ImhwBjC;;A4IlhwBA;EAA4B,gBAAA;A5IshwB5B;;A4IrhwBA;EAA8B,gBAAA;A5IyhwB9B;;A4IxhwBA;EAAyB,gBAAA;A5I4hwBzB;;A4I3hwBA;EAAuB,gBAAA;A5I+hwBvB;;A4I9hwBA;EAAmC,gBAAA;A5IkiwBnC;;A4IjiwBA;EAA8B,gBAAA;A5IqiwB9B;;A4IpiwBA;EAAkC,gBAAA;A5IwiwBlC;;A4IviwBA;EAA6B,gBAAA;A5I2iwB7B;;A4I1iwBA;EAAiC,gBAAA;A5I8iwBjC;;A4I7iwBA;EAA4B,gBAAA;A5IijwB5B;;A4IhjwBA;EAAmC,gBAAA;A5IojwBnC;;A4InjwBA;EAA8B,gBAAA;A5IujwB9B;;A4ItjwBA;EAA6B,gBAAA;A5I0jwB7B;;A4IzjwBA;EAAmC,gBAAA;A5I6jwBnC;;A4I5jwBA;EAA8B,gBAAA;A5IgkwB9B;;A4I/jwBA;EAAmC,gBAAA;A5ImkwBnC;;A4IlkwBA;EAA8B,gBAAA;A5IskwB9B;;A4IrkwBA;EAAkC,gBAAA;A5IykwBlC;;A4IxkwBA;EAA6B,gBAAA;A5I4kwB7B;;A4I3kwBA;EAAmC,gBAAA;A5I+kwBnC;;A4I9kwBA;EAA8B,gBAAA;A5IklwB9B;;A4IjlwBA;EAAkC,gBAAA;A5IqlwBlC;;A4IplwBA;EAA6B,gBAAA;A5IwlwB7B;;A4IvlwBA;EAA+B,gBAAA;A5I2lwB/B;;A4I1lwBA;EAA0B,gBAAA;A5I8lwB1B;;A4I7lwBA;EAAwB,gBAAA;A5IimwBxB;;A4IhmwBA;EAAmC,gBAAA;A5IomwBnC;;A4InmwBA;EAA8B,gBAAA;A5IumwB9B;;A4ItmwBA;EAA6B,gBAAA;A5I0mwB7B;;A4IzmwBA;EAAmC,gBAAA;A5I6mwBnC;;A4I5mwBA;EAA8B,gBAAA;A5IgnwB9B;;A4I/mwBA;EAAkC,gBAAA;A5ImnwBlC;;A4IlnwBA;EAA6B,gBAAA;A5IsnwB7B;;A4IrnwBA;EAAwB,gBAAA;A5IynwBxB;;A4IxnwBA;EAA8B,gBAAA;A5I4nwB9B;;A4I3nwBA;EAA8B,gBAAA;A5I+nwB9B;;A4I9nwBA;EAA6B,gBAAA;A5IkowB7B;;A4IjowBA;EAAwB,gBAAA;A5IqowBxB;;A4IpowBA;EAA0B,gBAAA;A5IwowB1B;;A4IvowBA;EAAgC,gBAAA;A5I2owBhC;;A4I1owBA;EAA2B,gBAAA;A5I8owB3B;;A4I7owBA;EAAgC,gBAAA;A5IipwBhC;;A4IhpwBA;EAAoC,gBAAA;A5IopwBpC;;A4InpwBA;EAA+B,gBAAA;A5IupwB/B;;A4ItpwBA;EAA2B,gBAAA;A5I0pwB3B;;A4IzpwBA;EAAqB,gBAAA;A5I6pwBrB;;A4I5pwBA;EAAsB,gBAAA;A5IgqwBtB;;A4I/pwBA;EAA4B,gBAAA;A5ImqwB5B;;A4IlqwBA;EAAuB,gBAAA;A5IsqwBvB;;A4IrqwBA;EAA6B,gBAAA;A5IyqwB7B;;A4IxqwBA;EAA2B,gBAAA;A5I4qwB3B;;A4I3qwBA;EAAyB,gBAAA;A5I+qwBzB;;A4I9qwBA;EAAwB,gBAAA;A5IkrwBxB;;A4IjrwBA;EAAwB,gBAAA;A5IqrwBxB;;A4IprwBA;EAA8B,gBAAA;A5IwrwB9B;;A4IvrwBA;EAAqC,gBAAA;A5I2rwBrC;;A4I1rwBA;EAAgC,gBAAA;A5I8rwBhC;;A4I7rwBA;EAAyB,gBAAA;A5IiswBzB;;A4IhswBA;EAA8B,gBAAA;A5IoswB9B;;A4InswBA;EAAqC,gBAAA;A5IuswBrC;;A4ItswBA;EAAgC,gBAAA;A5I0swBhC;;A4IzswBA;EAAyB,gBAAA;A5I6swBzB;;A4I5swBA;EAA+B,gBAAA;A5IgtwB/B;;A4I/swBA;EAAsC,gBAAA;A5ImtwBtC;;A4IltwBA;EAAiC,gBAAA;A5IstwBjC;;A4IrtwBA;EAA0B,gBAAA;A5IytwB1B;;A4IxtwBA;EAA4B,gBAAA;A5I4twB5B;;A4I3twBA;EAAmC,gBAAA;A5I+twBnC;;A4I9twBA;EAA8B,gBAAA;A5IkuwB9B;;A4IjuwBA;EAAuB,gBAAA;A5IquwBvB;;A4IpuwBA;EAA8B,gBAAA;A5IwuwB9B;;A4IvuwBA;EAAyB,gBAAA;A5I2uwBzB;;A4I1uwBA;EAA6B,gBAAA;A5I8uwB7B;;A4I7uwBA;EAAwB,gBAAA;A5IivwBxB;;A4IhvwBA;EAAwB,gBAAA;A5IovwBxB;;A4InvwBA;EAA6B,gBAAA;A5IuvwB7B;;A4ItvwBA;EAAwB,gBAAA;A5I0vwBxB;;A4IzvwBA;EAA0B,gBAAA;A5I6vwB1B;;A4I5vwBA;EAAqB,gBAAA;A5IgwwBrB;;A4I/vwBA;EAAmB,gBAAA;A5ImwwBnB;;A4IlwwBA;EAAoB,gBAAA;A5IswwBpB;;A4IrwwBA;EAAoB,gBAAA;A5IywwBpB;;A4IxwwBA;EAAoB,gBAAA;A5I4wwBpB;;A4I3wwBA;EAAyB,gBAAA;A5I+wwBzB;;A4I9wwBA;EAAmB,gBAAA;A5IkxwBnB;;A4IjxwBA;EAAmB,gBAAA;A5IqxwBnB;;A4IpxwBA;EAA6B,gBAAA;A5IwxwB7B;;A4IvxwBA;EAAwB,gBAAA;A5I2xwBxB;;A4I1xwBA;EAAwB,gBAAA;A5I8xwBxB;;A4I7xwBA;EAAkC,gBAAA;A5IiywBlC;;A4IhywBA;EAA6B,gBAAA;A5IoywB7B;;A4InywBA;EAA6B,gBAAA;A5IuywB7B;;A4ItywBA;EAAmC,gBAAA;A5I0ywBnC;;A4IzywBA;EAA8B,gBAAA;A5I6ywB9B;;A4I5ywBA;EAAkC,gBAAA;A5IgzwBlC;;A4I/ywBA;EAA6B,gBAAA;A5ImzwB7B;;A4IlzwBA;EAAwB,gBAAA;A5IszwBxB;;A4IrzwBA;EAA8B,gBAAA;A5IyzwB9B;;A4IxzwBA;EAAyB,gBAAA;A5I4zwBzB;;A4I3zwBA;EAAmC,gBAAA;A5I+zwBnC;;A4I9zwBA;EAA8B,gBAAA;A5Ik0wB9B;;A4Ij0wBA;EAA8B,gBAAA;A5Iq0wB9B;;A4Ip0wBA;EAAoC,gBAAA;A5Iw0wBpC;;A4Iv0wBA;EAA+B,gBAAA;A5I20wB/B;;A4I10wBA;EAAmC,gBAAA;A5I80wBnC;;A4I70wBA;EAA8B,gBAAA;A5Ii1wB9B;;A4Ih1wBA;EAAyB,gBAAA;A5Io1wBzB;;A4In1wBA;EAAoC,gBAAA;A5Iu1wBpC;;A4It1wBA;EAA+B,gBAAA;A5I01wB/B;;A4Iz1wBA;EAA+B,gBAAA;A5I61wB/B;;A4I51wBA;EAAqC,gBAAA;A5Ig2wBrC;;A4I/1wBA;EAAgC,gBAAA;A5Im2wBhC;;A4Il2wBA;EAAoC,gBAAA;A5Is2wBpC;;A4Ir2wBA;EAA+B,gBAAA;A5Iy2wB/B;;A4Ix2wBA;EAA0B,gBAAA;A5I42wB1B;;A4I32wBA;EAA6B,gBAAA;A5I+2wB7B;;A4I92wBA;EAAwB,gBAAA;A5Ik3wBxB;;A4Ij3wBA;EAAmB,gBAAA;A5Iq3wBnB;;A4Ip3wBA;EAAwB,gBAAA;A5Iw3wBxB;;A4Iv3wBA;EAAgC,gBAAA;A5I23wBhC;;A4I13wBA;EAA2B,gBAAA;A5I83wB3B;;A4I73wBA;EAAgC,gBAAA;A5Ii4wBhC;;A4Ih4wBA;EAA2B,gBAAA;A5Io4wB3B;;A4In4wBA;EAAoB,gBAAA;A5Iu4wBpB;;A4It4wBA;EAAyB,gBAAA;A5I04wBzB;;A4Iz4wBA;EAA4B,gBAAA;A5I64wB5B;;A4I54wBA;EAA4B,gBAAA;A5Ig5wB5B;;A4I/4wBA;EAAqB,gBAAA;A5Im5wBrB;;A4Il5wBA;EAAmC,gBAAA;A5Is5wBnC;;A4Ir5wBA;EAA+B,gBAAA;A5Iy5wB/B;;A4Ix5wBA;EAAiC,gBAAA;A5I45wBjC;;A4I35wBA;EAA+B,gBAAA;A5I+5wB/B;;A4I95wBA;EAAgC,gBAAA;A5Ik6wBhC;;A4Ij6wBA;EAA6B,gBAAA;A5Iq6wB7B;;A4Ip6wBA;EAAmC,gBAAA;A5Iw6wBnC;;A4Iv6wBA;EAAmC,gBAAA;A5I26wBnC;;A4I16wBA;EAAoC,gBAAA;A5I86wBpC;;A4I76wBA;EAAiC,gBAAA;A5Ii7wBjC;;A4Ih7wBA;EAA+B,gBAAA;A5Io7wB/B;;A4In7wBA;EAAkC,gBAAA;A5Iu7wBlC;;A4It7wBA;EAAkC,gBAAA;A5I07wBlC;;A4Iz7wBA;EAAmC,gBAAA;A5I67wBnC;;A4I57wBA;EAAgC,gBAAA;A5Ig8wBhC;;A4I/7wBA;EAA2B,gBAAA;A5Im8wB3B;;A4Il8wBA;EAA6B,gBAAA;A5Is8wB7B;;A4Ir8wBA;EAA2B,gBAAA;A5Iy8wB3B;;A4Ix8wBA;EAA4B,gBAAA;A5I48wB5B;;A4I38wBA;EAAyB,gBAAA;A5I+8wBzB;;A4I98wBA;EAA0B,gBAAA;A5Ik9wB1B;;A4Ij9wBA;EAA0B,gBAAA;A5Iq9wB1B;;A4Ip9wBA;EAA4B,gBAAA;A5Iw9wB5B;;A4Iv9wBA;EAAqB,gBAAA;A5I29wBrB;;A4I19wBA;EAA8B,gBAAA;A5I89wB9B;;A4I79wBA;EAA6B,gBAAA;A5Ii+wB7B;;A4Ih+wBA;EAA8B,gBAAA;A5Io+wB9B;;A4In+wBA;EAA6B,gBAAA;A5Iu+wB7B;;A4It+wBA;EAA0B,gBAAA;A5I0+wB1B;;A4Iz+wBA;EAAwB,gBAAA;A5I6+wBxB;;A4I5+wBA;EAAyB,gBAAA;A5Ig/wBzB;;A4I/+wBA;EAA4B,gBAAA;A5Im/wB5B;;A4Il/wBA;EAAoB,gBAAA;A5Is/wBpB;;A4Ir/wBA;EAAoC,gBAAA;A5Iy/wBpC;;A4Ix/wBA;EAA+B,gBAAA;A5I4/wB/B;;A4I3/wBA;EAAkC,gBAAA;A5I+/wBlC;;A4I9/wBA;EAA6B,gBAAA;A5IkgxB7B;;A4IjgxBA;EAA+B,gBAAA;A5IqgxB/B;;A4IpgxBA;EAA0B,gBAAA;A5IwgxB1B;;A4IvgxBA;EAAkC,gBAAA;A5I2gxBlC;;A4I1gxBA;EAA6B,gBAAA;A5I8gxB7B;;A4I7gxBA;EAAiC,gBAAA;A5IihxBjC;;A4IhhxBA;EAA4B,gBAAA;A5IohxB5B;;A4InhxBA;EAAyB,gBAAA;A5IuhxBzB;;A4IthxBA;EAA6B,gBAAA;A5I0hxB7B;;A4IzhxBA;EAAwB,gBAAA;A5I6hxBxB;;A4I5hxBA;EAA8B,gBAAA;A5IgixB9B;;A4I/hxBA;EAAyB,gBAAA;A5ImixBzB;;A4IlixBA;EAA8B,gBAAA;A5IsixB9B;;A4IrixBA;EAAyB,gBAAA;A5IyixBzB;;A4IxixBA;EAA2B,gBAAA;A5I4ixB3B;;A4I3ixBA;EAA8B,gBAAA;A5I+ixB9B;;A4I9ixBA;EAAyB,gBAAA;A5IkjxBzB;;A4IjjxBA;EAA+B,gBAAA;A5IqjxB/B;;A4IpjxBA;EAAmC,gBAAA;A5IwjxBnC;;A4IvjxBA;EAAwC,gBAAA;A5I2jxBxC;;A4I1jxBA;EAAmC,gBAAA;A5I8jxBnC;;A4I7jxBA;EAA8B,gBAAA;A5IikxB9B;;A4IhkxBA;EAA+B,gBAAA;A5IokxB/B;;A4InkxBA;EAA0B,gBAAA;A5IukxB1B;;A4ItkxBA;EAA8B,gBAAA;A5I0kxB9B;;A4IzkxBA;EAAyB,gBAAA;A5I6kxBzB;;A4I5kxBA;EAA8B,gBAAA;A5IglxB9B;;A4I/kxBA;EAAyB,gBAAA;A5ImlxBzB;;A4IllxBA;EAA8B,gBAAA;A5IslxB9B;;A4IrlxBA;EAAoC,gBAAA;A5IylxBpC;;A4IxlxBA;EAA+B,gBAAA;A5I4lxB/B;;A4I3lxBA;EAAyB,gBAAA;A5I+lxBzB;;A4I9lxBA;EAA+B,gBAAA;A5IkmxB/B;;A4IjmxBA;EAA0B,gBAAA;A5IqmxB1B;;A4IpmxBA;EAA+B,gBAAA;A5IwmxB/B;;A4IvmxBA;EAA0B,gBAAA;A5I2mxB1B;;A4I1mxBA;EAA8B,gBAAA;A5I8mxB9B;;A4I7mxBA;EAAyB,gBAAA;A5IinxBzB;;A4IhnxBA;EAA6B,gBAAA;A5IonxB7B;;A4InnxBA;EAAwB,gBAAA;A5IunxBxB;;A4ItnxBA;EAAgC,gBAAA;A5I0nxBhC;;A4IznxBA;EAA2B,gBAAA;A5I6nxB3B;;A4I5nxBA;EAAoB,gBAAA;A5IgoxBpB;;A4I/nxBA;EAA0B,gBAAA;A5ImoxB1B;;A4IloxBA;EAAqB,gBAAA;A5IsoxBrB;;A4IroxBA;EAA0B,gBAAA;A5IyoxB1B;;A4IxoxBA;EAAqB,gBAAA;A5I4oxBrB;;A4I3oxBA;EAAyB,gBAAA;A5I+oxBzB;;A4I9oxBA;EAA0B,gBAAA;A5IkpxB1B;;A4IjpxBA;EAAmB,gBAAA;A5IqpxBnB;;A4IppxBA;EAA8B,gBAAA;A5IwpxB9B;;A4IvpxBA;EAAmC,gBAAA;A5I2pxBnC;;A4I1pxBA;EAA8B,gBAAA;A5I8pxB9B;;A4I7pxBA;EAAyB,gBAAA;A5IiqxBzB;;A4IhqxBA;EAA0B,gBAAA;A5IoqxB1B;;A4InqxBA;EAAsB,gBAAA;A5IuqxBtB;;A4ItqxBA;EAAsB,gBAAA;A5I0qxBtB;;A4IzqxBA;EAA2B,gBAAA;A5I6qxB3B;;A4I5qxBA;EAAsB,gBAAA;A5IgrxBtB;;A4I/qxBA;EAA2B,gBAAA;A5ImrxB3B;;A4IlrxBA;EAAmB,gBAAA;A5IsrxBnB;;A4IrrxBA;EAAyB,gBAAA;A5IyrxBzB;;A4IxrxBA;EAAuB,gBAAA;A5I4rxBvB;;A4I3rxBA;EAAkB,gBAAA;A5I+rxBlB;;A4I9rxBA;EAAsC,gBAAA;A5IksxBtC;;A4IjsxBA;EAAiC,gBAAA;A5IqsxBjC;;A4IpsxBA;EAAuC,gBAAA;A5IwsxBvC;;A4IvsxBA;EAAkC,gBAAA;A5I2sxBlC;;A4I1sxBA;EAA+B,gBAAA;A5I8sxB/B;;A4I7sxBA;EAA0B,gBAAA;A5IitxB1B;;A4IhtxBA;EAAmB,gBAAA;A5IotxBnB;;A4IntxBA;EAAuB,gBAAA;A5IutxBvB;;A4IttxBA;EAAwB,gBAAA;A5I0txBxB;;A4IztxBA;EAAkB,gBAAA;A5I6txBlB;;A4I5txBA;EAA0B,gBAAA;A5IguxB1B;;A4I/txBA;EAA0B,gBAAA;A5ImuxB1B;;A4IluxBA;EAAqB,gBAAA;A5IsuxBrB;;A4IruxBA;EAAiC,gBAAA;A5IyuxBjC;;A4IxuxBA;EAA+B,gBAAA;A5I4uxB/B;;A4I3uxBA;EAA0B,gBAAA;A5I+uxB1B;;A4I9uxBA;EAAiC,gBAAA;A5IkvxBjC;;A4IjvxBA;EAA+B,gBAAA;A5IqvxB/B;;A4IpvxBA;EAA0B,gBAAA;A5IwvxB1B;;A4IvvxBA;EAAmB,gBAAA;A5I2vxBnB;;A4I1vxBA;EAA6B,gBAAA;A5I8vxB7B;;A4I7vxBA;EAAwB,gBAAA;A5IiwxBxB;;A4IhwxBA;EAA6B,gBAAA;A5IowxB7B;;A4InwxBA;EAAwB,gBAAA;A5IuwxBxB;;A4ItwxBA;EAA2B,gBAAA;A5I0wxB3B;;A4IzwxBA;EAA2B,gBAAA;A5I6wxB3B;;A4I5wxBA;EAAsB,gBAAA;A5IgxxBtB;;A4I/wxBA;EAA0B,gBAAA;A5ImxxB1B;;A4IlxxBA;EAAqB,gBAAA;A5IsxxBrB;;A4IrxxBA;EAA0B,gBAAA;A5IyxxB1B;;A4IxxxBA;EAAqB,gBAAA;A5I4xxBrB;;A4I3xxBA;EAA0B,gBAAA;A5I+xxB1B;;A4I9xxBA;EAAqB,gBAAA;A5IkyxBrB;;A4IjyxBA;EAA0B,gBAAA;A5IqyxB1B;;A4IpyxBA;EAAqB,gBAAA;A5IwyxBrB;;A4IvyxBA;EAA0B,gBAAA;A5I2yxB1B;;A4I1yxBA;EAAqB,gBAAA;A5I8yxBrB;;A4I7yxBA;EAA0B,gBAAA;A5IizxB1B;;A4IhzxBA;EAAqB,gBAAA;A5IozxBrB;;A4InzxBA;EAAwB,gBAAA;A5IuzxBxB;;A4ItzxBA;EAAmB,gBAAA;A5I0zxBnB;;A4IzzxBA;EAAsB,gBAAA;A5I6zxBtB;;A4I5zxBA;EAA2B,gBAAA;A5Ig0xB3B;;A4I/zxBA;EAAsB,gBAAA;A5Im0xBtB;;A4Il0xBA;EAAoC,gBAAA;A5Is0xBpC;;A4Ir0xBA;EAAkC,gBAAA;A5Iy0xBlC;;A4Ix0xBA;EAA+B,gBAAA;A5I40xB/B;;A4I30xBA;EAA0B,gBAAA;A5I+0xB1B;;A4I90xBA;EAA6B,gBAAA;A5Ik1xB7B;;A4Ij1xBA;EAAwB,gBAAA;A5Iq1xBxB;;A4Ip1xBA;EAAkB,gBAAA;A5Iw1xBlB;;A4Iv1xBA;EAAuB,gBAAA;A5I21xBvB;;A4I11xBA;EAA2B,gBAAA;A5I81xB3B;;A4I71xBA;EAA2B,gBAAA;A5Ii2xB3B;;A4Ih2xBA;EAAsB,gBAAA;A5Io2xBtB;;A4In2xBA;EAAsB,gBAAA;A5Iu2xBtB;;A4It2xBA;EAAyB,gBAAA;A5I02xBzB;;A4Iz2xBA;EAAoB,gBAAA;A5I62xBpB;;A4I52xBA;EAAuB,gBAAA;A5Ig3xBvB;;A4I/2xBA;EAAwB,gBAAA;A5Im3xBxB;;A4Il3xBA;EAAkB,gBAAA;A5Is3xBlB;;A4Ir3xBA;EAAyB,gBAAA;A5Iy3xBzB;;A4Ix3xBA;EAAoB,gBAAA;A5I43xBpB;;A4I33xBA;EAA+B,gBAAA;A5I+3xB/B;;A4I93xBA;EAA0B,gBAAA;A5Ik4xB1B;;A4Ij4xBA;EAA+B,gBAAA;A5Iq4xB/B;;A4Ip4xBA;EAA0B,gBAAA;A5Iw4xB1B;;A4Iv4xBA;EAAwC,gBAAA;A5I24xBxC;;A4I14xBA;EAAmC,gBAAA;A5I84xBnC;;A4I74xBA;EAA+B,gBAAA;A5Ii5xB/B;;A4Ih5xBA;EAA0B,gBAAA;A5Io5xB1B;;A4In5xBA;EAAoC,gBAAA;A5Iu5xBpC;;A4It5xBA;EAA+B,gBAAA;A5I05xB/B;;A4Iz5xBA;EAAkC,gBAAA;A5I65xBlC;;A4I55xBA;EAA6B,gBAAA;A5Ig6xB7B;;A4I/5xBA;EAAiC,gBAAA;A5Im6xBjC;;A4Il6xBA;EAA4B,gBAAA;A5Is6xB5B;;A4Ir6xBA;EAA+B,gBAAA;A5Iy6xB/B;;A4Ix6xBA;EAA2C,gBAAA;A5I46xB3C;;A4I36xBA;EAAsC,gBAAA;A5I+6xBtC;;A4I96xBA;EAA0B,gBAAA;A5Ik7xB1B;;A4Ij7xBA;EAAoC,gBAAA;A5Iq7xBpC;;A4Ip7xBA;EAA+B,gBAAA;A5Iw7xB/B;;A4Iv7xBA;EAA8B,gBAAA;A5I27xB9B;;A4I17xBA;EAAyB,gBAAA;A5I87xBzB;;A4I77xBA;EAA4B,gBAAA;A5Ii8xB5B;;A4Ih8xBA;EAAiC,gBAAA;A5Io8xBjC;;A4In8xBA;EAA4B,gBAAA;A5Iu8xB5B;;A4It8xBA;EAAuB,gBAAA;A5I08xBvB;;A4Iz8xBA;EAA0B,gBAAA;A5I68xB1B;;A4I58xBA;EAAqB,gBAAA;A5Ig9xBrB;;A4I/8xBA;EAAsC,gBAAA;A5Im9xBtC;;A4Il9xBA;EAAiC,gBAAA;A5Is9xBjC;;A4Ir9xBA;EAAuC,gBAAA;A5Iy9xBvC;;A4Ix9xBA;EAAkC,gBAAA;A5I49xBlC;;A4I39xBA;EAAuC,gBAAA;A5I+9xBvC;;A4I99xBA;EAAkC,gBAAA;A5Ik+xBlC;;A4Ij+xBA;EAAsC,gBAAA;A5Iq+xBtC;;A4Ip+xBA;EAAiC,gBAAA;A5Iw+xBjC;;A4Iv+xBA;EAAwC,gBAAA;A5I2+xBxC;;A4I1+xBA;EAAmC,gBAAA;A5I8+xBnC;;A4I7+xBA;EAA0B,gBAAA;A5Ii/xB1B;;A4Ih/xBA;EAAsB,gBAAA;A5Io/xBtB;;A4In/xBA;EAAuB,gBAAA;A5Iu/xBvB;;A4It/xBA;EAA6B,gBAAA;A5I0/xB7B;;A4Iz/xBA;EAAwB,gBAAA;A5I6/xBxB;;A4I5/xBA;EAAkB,gBAAA;A5IggyBlB;;A4I//xBA;EAAyB,gBAAA;A5ImgyBzB;;A4IlgyBA;EAAyB,gBAAA;A5IsgyBzB;;A4IrgyBA;EAAuB,gBAAA;A5IygyBvB;;A4IxgyBA;EAAmC,gBAAA;A5I4gyBnC;;A4I3gyBA;EAA8B,gBAAA;A5I+gyB9B;;A4I9gyBA;EAAiC,gBAAA;A5IkhyBjC;;A4IjhyBA;EAA4B,gBAAA;A5IqhyB5B;;A4IphyBA;EAAkC,gBAAA;A5IwhyBlC;;A4IvhyBA;EAA6B,gBAAA;A5I2hyB7B;;A4I1hyBA;EAA+B,gBAAA;A5I8hyB/B;;A4I7hyBA;EAA0B,gBAAA;A5IiiyB1B;;A4IhiyBA;EAA8B,gBAAA;A5IoiyB9B;;A4IniyBA;EAAyB,gBAAA;A5IuiyBzB;;A4ItiyBA;EAA8B,gBAAA;A5I0iyB9B;;A4IziyBA;EAAyB,gBAAA;A5I6iyBzB;;A4I5iyBA;EAA6B,gBAAA;A5IgjyB7B;;A4I/iyBA;EAAwB,gBAAA;A5ImjyBxB;;A4IljyBA;EAA6B,gBAAA;A5IsjyB7B;;A4IrjyBA;EAAwB,gBAAA;A5IyjyBxB;;A4IxjyBA;EAA2C,gBAAA;A5I4jyB3C;;A4I3jyBA;EAAsC,gBAAA;A5I+jyBtC;;A4I9jyBA;EAAyC,gBAAA;A5IkkyBzC;;A4IjkyBA;EAAoC,gBAAA;A5IqkyBpC;;A4IpkyBA;EAA0C,gBAAA;A5IwkyB1C;;A4IvkyBA;EAAqC,gBAAA;A5I2kyBrC;;A4I1kyBA;EAAuC,gBAAA;A5I8kyBvC;;A4I7kyBA;EAAkC,gBAAA;A5IilyBlC;;A4IhlyBA;EAAsC,gBAAA;A5IolyBtC;;A4InlyBA;EAAiC,gBAAA;A5IulyBjC;;A4ItlyBA;EAAsC,gBAAA;A5I0lyBtC;;A4IzlyBA;EAAiC,gBAAA;A5I6lyBjC;;A4I5lyBA;EAAqC,gBAAA;A5IgmyBrC;;A4I/lyBA;EAAgC,gBAAA;A5ImmyBhC;;A4IlmyBA;EAAqC,gBAAA;A5IsmyBrC;;A4IrmyBA;EAAgC,gBAAA;A5IymyBhC;;A4IxmyBA;EAAsC,gBAAA;A5I4myBtC;;A4I3myBA;EAAiC,gBAAA;A5I+myBjC;;A4I9myBA;EAAsC,gBAAA;A5IknyBtC;;A4IjnyBA;EAAiC,gBAAA;A5IqnyBjC;;A4IpnyBA;EAAgC,gBAAA;A5IwnyBhC;;A4IvnyBA;EAAqC,gBAAA;A5I2nyBrC;;A4I1nyBA;EAAgC,gBAAA;A5I8nyBhC;;A4I7nyBA;EAAsC,gBAAA;A5IioyBtC;;A4IhoyBA;EAAiC,gBAAA;A5IooyBjC;;A4InoyBA;EAAqC,gBAAA;A5IuoyBrC;;A4ItoyBA;EAAgC,gBAAA;A5I0oyBhC;;A4IzoyBA;EAAsC,gBAAA;A5I6oyBtC;;A4I5oyBA;EAAiC,gBAAA;A5IgpyBjC;;A4I/oyBA;EAAwC,gBAAA;A5ImpyBxC;;A4IlpyBA;EAAmC,gBAAA;A5IspyBnC;;A4IrpyBA;EAAsC,gBAAA;A5IypyBtC;;A4IxpyBA;EAAiC,gBAAA;A5I4pyBjC;;A4I3pyBA;EAAsC,gBAAA;A5I+pyBtC;;A4I9pyBA;EAAiC,gBAAA;A5IkqyBjC;;A4IjqyBA;EAAuC,gBAAA;A5IqqyBvC;;A4IpqyBA;EAAkC,gBAAA;A5IwqyBlC;;A4IvqyBA;EAAqC,gBAAA;A5I2qyBrC;;A4I1qyBA;EAAgC,gBAAA;A5I8qyBhC;;A4I7qyBA;EAAqC,gBAAA;A5IiryBrC;;A4IhryBA;EAAgC,gBAAA;A5IoryBhC;;A4InryBA;EAAqC,gBAAA;A5IuryBrC;;A4ItryBA;EAAgC,gBAAA;A5I0ryBhC;;A4IzryBA;EAAoC,gBAAA;A5I6ryBpC;;A4I5ryBA;EAA+B,gBAAA;A5IgsyB/B;;A4I/ryBA;EAAyC,gBAAA;A5ImsyBzC;;A4IlsyBA;EAAoC,gBAAA;A5IssyBpC;;A4IrsyBA;EAAsC,gBAAA;A5IysyBtC;;A4IxsyBA;EAAiC,gBAAA;A5I4syBjC;;A4I3syBA;EAAuC,gBAAA;A5I+syBvC;;A4I9syBA;EAAkC,gBAAA;A5IktyBlC;;A4IjtyBA;EAA4C,gBAAA;A5IqtyB5C;;A4IptyBA;EAAuC,gBAAA;A5IwtyBvC;;A4IvtyBA;EAAqC,gBAAA;A5I2tyBrC;;A4I1tyBA;EAAgC,gBAAA;A5I8tyBhC;;A4I7tyBA;EAAqC,gBAAA;A5IiuyBrC;;A4IhuyBA;EAAgC,gBAAA;A5IouyBhC;;A4InuyBA;EAAkC,gBAAA;A5IuuyBlC;;A4ItuyBA;EAA6B,gBAAA;A5I0uyB7B;;A4IzuyBA;EAAoC,gBAAA;A5I6uyBpC;;A4I5uyBA;EAA+B,gBAAA;A5IgvyB/B;;A4I/uyBA;EAA2B,gBAAA;A5ImvyB3B;;A4IlvyBA;EAA8B,gBAAA;A5IsvyB9B;;A4IrvyBA;EAAyB,gBAAA;A5IyvyBzB;;A4IxvyBA;EAA8B,gBAAA;A5I4vyB9B;;A4I3vyBA;EAAyB,gBAAA;A5I+vyBzB;;A4I9vyBA;EAAwB,gBAAA;A5IkwyBxB;;A4IjwyBA;EAA6B,gBAAA;A5IqwyB7B;;A4IpwyBA;EAAwB,gBAAA;A5IwwyBxB;;A4IvwyBA;EAA8B,gBAAA;A5I2wyB9B;;A4I1wyBA;EAAyB,gBAAA;A5I8wyBzB;;A4I7wyBA;EAA6B,gBAAA;A5IixyB7B;;A4IhxyBA;EAAwB,gBAAA;A5IoxyBxB;;A4InxyBA;EAA8B,gBAAA;A5IuxyB9B;;A4ItxyBA;EAAyB,gBAAA;A5I0xyBzB;;A4IzxyBA;EAAgC,gBAAA;A5I6xyBhC;;A4I5xyBA;EAA2B,gBAAA;A5IgyyB3B;;A4I/xyBA;EAA8B,gBAAA;A5ImyyB9B;;A4IlyyBA;EAAyB,gBAAA;A5IsyyBzB;;A4IryyBA;EAA8B,gBAAA;A5IyyyB9B;;A4IxyyBA;EAAyB,gBAAA;A5I4yyBzB;;A4I3yyBA;EAA+B,gBAAA;A5I+yyB/B;;A4I9yyBA;EAA0B,gBAAA;A5IkzyB1B;;A4IjzyBA;EAA6B,gBAAA;A5IqzyB7B;;A4IpzyBA;EAAwB,gBAAA;A5IwzyBxB;;A4IvzyBA;EAA6B,gBAAA;A5I2zyB7B;;A4I1zyBA;EAAwB,gBAAA;A5I8zyBxB;;A4I7zyBA;EAA6B,gBAAA;A5Ii0yB7B;;A4Ih0yBA;EAAwB,gBAAA;A5Io0yBxB;;A4In0yBA;EAA4B,gBAAA;A5Iu0yB5B;;A4It0yBA;EAAuB,gBAAA;A5I00yBvB;;A4Iz0yBA;EAAiC,gBAAA;A5I60yBjC;;A4I50yBA;EAA4B,gBAAA;A5Ig1yB5B;;A4I/0yBA;EAA8B,gBAAA;A5Im1yB9B;;A4Il1yBA;EAAyB,gBAAA;A5Is1yBzB;;A4Ir1yBA;EAA+B,gBAAA;A5Iy1yB/B;;A4Ix1yBA;EAA0B,gBAAA;A5I41yB1B;;A4I31yBA;EAAoC,gBAAA;A5I+1yBpC;;A4I91yBA;EAA+B,gBAAA;A5Ik2yB/B;;A4Ij2yBA;EAA6B,gBAAA;A5Iq2yB7B;;A4Ip2yBA;EAAwB,gBAAA;A5Iw2yBxB;;A4Iv2yBA;EAA6B,gBAAA;A5I22yB7B;;A4I12yBA;EAAwB,gBAAA;A5I82yBxB;;A4I72yBA;EAA0B,gBAAA;A5Ii3yB1B;;A4Ih3yBA;EAAqB,gBAAA;A5Io3yBrB;;A4In3yBA;EAA4B,gBAAA;A5Iu3yB5B;;A4It3yBA;EAAuB,gBAAA;A5I03yBvB;;A4Iz3yBA;EAAmB,gBAAA;A5I63yBnB;;A4I53yBA;EAAwB,gBAAA;A5Ig4yBxB;;A4I/3yBA;EAAoB,gBAAA;A5Im4yBpB;;A4Il4yBA;EAAmB,gBAAA;A5Is4yBnB;;A4Ir4yBA;EAAiC,gBAAA;A5Iy4yBjC;;A4Ix4yBA;EAA4B,gBAAA;A5I44yB5B;;A4I34yBA;EAA0B,gBAAA;A5I+4yB1B;;A4I94yBA;EAA2B,gBAAA;A5Ik5yB3B;;A4Ij5yBA;EAAiC,gBAAA;A5Iq5yBjC;;A4Ip5yBA;EAA4B,gBAAA;A5Iw5yB5B;;A4Iv5yBA;EAAqB,gBAAA;A5I25yBrB;;A4I15yBA;EAAwB,gBAAA;A5I85yBxB;;A4I75yBA;EAAmB,gBAAA;A5Ii6yBnB;;A4Ih6yBA;EAAsB,gBAAA;A5Io6yBtB;;A4In6yBA;EAAsB,gBAAA;A5Iu6yBtB;;A4It6yBA;EAAsB,gBAAA;A5I06yBtB;;A4Iz6yBA;EAA2B,gBAAA;A5I66yB3B;;A4I56yBA;EAA0B,gBAAA;A5Ig7yB1B;;A4I/6yBA;EAA2B,gBAAA;A5Im7yB3B;;A4Il7yBA;EAA0B,gBAAA;A5Is7yB1B;;A4Ir7yBA;EAAkC,gBAAA;A5Iy7yBlC;;A4Ix7yBA;EAA6B,gBAAA;A5I47yB7B;;A4I37yBA;EAAuB,gBAAA;A5I+7yBvB;;A4I97yBA;EAAqB,gBAAA;A5Ik8yBrB;;A4Ij8yBA;EAA2B,gBAAA;A5Iq8yB3B;;A4Ip8yBA;EAAsB,gBAAA;A5Iw8yBtB;;A4Iv8yBA;EAAoB,gBAAA;A5I28yBpB;;A4I18yBA;EAA2B,gBAAA;A5I88yB3B;;A4I78yBA;EAAsB,gBAAA;A5Ii9yBtB;;A4Ih9yBA;EAAoB,gBAAA;A5Io9yBpB;;A4In9yBA;EAA8B,gBAAA;A5Iu9yB9B;;A4It9yBA;EAAyB,gBAAA;A5I09yBzB;;A4Iz9yBA;EAA0B,gBAAA;A5I69yB1B;;A4I59yBA;EAAqB,gBAAA;A5Ig+yBrB;;A4I/9yBA;EAAwB,gBAAA;A5Im+yBxB;;A4Il+yBA;EAAkC,gBAAA;A5Is+yBlC;;A4Ir+yBA;EAAwB,gBAAA;A5Iy+yBxB;;A4Ix+yBA;EAAmB,gBAAA;A5I4+yBnB;;A4I3+yBA;EAAkB,gBAAA;A5I++yBlB;;A4I9+yBA;EAA2B,gBAAA;A5Ik/yB3B;;A4Ij/yBA;EAAsB,gBAAA;A5Iq/yBtB;;A4Ip/yBA;EAAuB,gBAAA;A5Iw/yBvB;;A4Iv/yBA;EAAkB,gBAAA;A5I2/yBlB;;A4I1/yBA;EAAwB,gBAAA;A5I8/yBxB;;A4I7/yBA;EAAmB,gBAAA;A5IigzBnB;;A4IhgzBA;EAAqB,gBAAA;A5IogzBrB;;A4IngzBA;EAAoB,gBAAA;A5IugzBpB;;A4ItgzBA;EAAqB,gBAAA;A5I0gzBrB;;A4IzgzBA;EAAqB,gBAAA;A5I6gzBrB;;A4I5gzBA;EAAyB,gBAAA;A5IghzBzB;;A4I/gzBA;EAAuB,gBAAA;A5ImhzBvB;;A4IlhzBA;EAA4B,gBAAA;A5IshzB5B;;A4IrhzBA;EAAuB,gBAAA;A5IyhzBvB;;A4IxhzBA;EAAgC,gBAAA;A5I4hzBhC;;A4I3hzBA;EAA2B,gBAAA;A5I+hzB3B;;A4I9hzBA;EAAuB,gBAAA;A5IkizBvB;;A4IjizBA;EAAgC,gBAAA;A5IqizBhC;;A4IpizBA;EAA2B,gBAAA;A5IwizB3B;;A4IvizBA;EAAuB,gBAAA;A5I2izBvB;;A4I1izBA;EAAwB,gBAAA;A5I8izBxB;;A4I7izBA;EAAmB,gBAAA;A5IijzBnB;;A4IhjzBA;EAA8B,gBAAA;A5IojzB9B;;A4InjzBA;EAA4B,gBAAA;A5IujzB5B;;A4ItjzBA;EAAqB,gBAAA;A5I0jzBrB;;A4IzjzBA;EAA8B,gBAAA;A5I6jzB9B;;A4I5jzBA;EAAoC,gBAAA;A5IgkzBpC;;A4I/jzBA;EAA+B,gBAAA;A5ImkzB/B;;A4IlkzBA;EAAyB,gBAAA;A5IskzBzB;;A4IrkzBA;EAAoC,gBAAA;A5IykzBpC;;A4IxkzBA;EAA+B,gBAAA;A5I4kzB/B;;A4I3kzBA;EAAkC,gBAAA;A5I+kzBlC;;A4I9kzBA;EAA6B,gBAAA;A5IklzB7B;;A4IjlzBA;EAA2B,gBAAA;A5IqlzB3B;;A4IplzBA;EAAsB,gBAAA;A5IwlzBtB;;A4IvlzBA;EAAmB,gBAAA;A5I2lzBnB;;A4I1lzBA;EAAuB,gBAAA;A5I8lzBvB;;A4I7lzBA;EAA+B,gBAAA;A5IimzB/B;;A4IhmzBA;EAA0B,gBAAA;A5IomzB1B;;A4InmzBA;EAA4B,gBAAA;A5IumzB5B;;A4ItmzBA;EAAuB,gBAAA;A5I0mzBvB;;A4IzmzBA;EAA6B,gBAAA;A5I6mzB7B;;A4I5mzBA;EAAwB,gBAAA;A5IgnzBxB;;A4I/mzBA;EAAkB,gBAAA;A5ImnzBlB;;A4IlnzBA;EAAyB,gBAAA;A5IsnzBzB;;A4IrnzBA;EAAsB,gBAAA;A5IynzBtB;;A4IxnzBA;EAAyB,gBAAA;A5I4nzBzB;;A4I3nzBA;EAAyB,gBAAA;A5I+nzBzB;;A4I9nzBA;EAAoB,gBAAA;A5IkozBpB;;A4IjozBA;EAA4B,gBAAA;A5IqozB5B;;A4IpozBA;EAA4B,gBAAA;A5IwozB5B;;A4IvozBA;EAAuB,gBAAA;A5I2ozBvB;;A4I1ozBA;EAA2B,gBAAA;A5I8ozB3B;;A4I7ozBA;EAA2B,gBAAA;A5IipzB3B;;A4IhpzBA;EAAsB,gBAAA;A5IopzBtB;;A4InpzBA;EAA+B,gBAAA;A5IupzB/B;;A4ItpzBA;EAA8B,gBAAA;A5I0pzB9B;;A4IzpzBA;EAA4B,gBAAA;A5I6pzB5B;;A4I5pzBA;EAAwB,gBAAA;A5IgqzBxB;;A4I/pzBA;EAA8B,gBAAA;A5ImqzB9B;;A4IlqzBA;EAAyB,gBAAA;A5IsqzBzB;;A4IrqzBA;EAAyB,gBAAA;A5IyqzBzB;;A4IxqzBA;EAAoB,gBAAA;A5I4qzBpB;;A4I3qzBA;EAAiB,gBAAA;A5I+qzBjB;;A4I9qzBA;EAAwB,gBAAA;A5IkrzBxB;;A4IjrzBA;EAAwB,gBAAA;A5IqrzBxB;;A4IprzBA;EAAyB,gBAAA;A5IwrzBzB;;A4IvrzBA;EAAoB,gBAAA;A5I2rzBpB;;A4I1rzBA;EAAqB,gBAAA;A5I8rzBrB;;A4I7rzBA;EAAyB,gBAAA;A5IiszBzB;;A4IhszBA;EAAoB,gBAAA;A5IoszBpB;;A4InszBA;EAA2B,gBAAA;A5IuszB3B;;A4ItszBA;EAAsB,gBAAA;A5I0szBtB;;A4IzszBA;EAA+B,gBAAA;A5I6szB/B;;A4I5szBA;EAA0B,gBAAA;A5IgtzB1B;;A4I/szBA;EAA+B,gBAAA;A5ImtzB/B;;A4IltzBA;EAA0B,gBAAA;A5IstzB1B;;A4IrtzBA;EAAmB,gBAAA;A5IytzBnB;;A4IxtzBA;EAAgC,gBAAA;A5I4tzBhC;;A4I3tzBA;EAA2B,gBAAA;A5I+tzB3B;;A4I9tzBA;EAAwB,gBAAA;A5IkuzBxB;;A4IjuzBA;EAAwB,gBAAA;A5IquzBxB;;A4IpuzBA;EAA4B,gBAAA;A5IwuzB5B;;A4IvuzBA;EAAiC,gBAAA;A5I2uzBjC;;A4I1uzBA;EAA+B,gBAAA;A5I8uzB/B;;A4I7uzBA;EAAoC,gBAAA;A5IivzBpC;;A4IhvzBA;EAA+B,gBAAA;A5IovzB/B;;A4InvzBA;EAA4B,gBAAA;A5IuvzB5B;;A4ItvzBA;EAA2B,gBAAA;A5I0vzB3B;;A4IzvzBA;EAA8B,gBAAA;A5I6vzB9B;;A4I5vzBA;EAA4B,gBAAA;A5IgwzB5B;;A4I/vzBA;EAA2B,gBAAA;A5ImwzB3B;;A4IlwzBA;EAA+B,gBAAA;A5IswzB/B;;A4IrwzBA;EAA2B,gBAAA;A5IywzB3B;;A4IxwzBA;EAAwB,gBAAA;A5I4wzBxB;;A4I3wzBA;EAAsB,gBAAA;A5I+wzBtB;;A4I9wzBA;EAAuB,gBAAA;A5IkxzBvB;;A4IjxzBA;EAAuB,gBAAA;A5IqxzBvB;;A4IpxzBA;EAA2B,gBAAA;A5IwxzB3B;;A4IvxzBA;EAA4B,gBAAA;A5I2xzB5B;;A4I1xzBA;EAAsB,gBAAA;A5I8xzBtB;;A4I7xzBA;EAA0B,gBAAA;A5IiyzB1B;;A4IhyzBA;EAAqB,gBAAA;A5IoyzBrB;;A4InyzBA;EAAuB,gBAAA;A5IuyzBvB;;A4ItyzBA;EAAkB,gBAAA;A5I0yzBlB;;A4IzyzBA;EAA4B,gBAAA;A5I6yzB5B;;A4I5yzBA;EAAuB,gBAAA;A5IgzzBvB;;A4I/yzBA;EAAqB,gBAAA;A5ImzzBrB;;A4IlzzBA;EAAwB,gBAAA;A5IszzBxB;;A4IrzzBA;EAAmB,gBAAA;A5IyzzBnB;;A4IxzzBA;EAA0B,gBAAA;A5I4zzB1B;;A4I3zzBA;EAAqB,gBAAA;A5I+zzBrB;;A4I9zzBA;EAA6B,gBAAA;A5Ik0zB7B;;A4Ij0zBA;EAA4B,gBAAA;A5Iq0zB5B;;A4Ip0zBA;EAA0B,gBAAA;A5Iw0zB1B;;A4Iv0zBA;EAA0B,gBAAA;A5I20zB1B;;A4I10zBA;EAAqB,gBAAA;A5I80zBrB;;A4I70zBA;EAA2C,gBAAA;A5Ii1zB3C;;A4Ih1zBA;EAAmC,gBAAA;A5Io1zBnC;;A4In1zBA;EAAqC,gBAAA;A5Iu1zBrC;;A4It1zBA;EAA6B,gBAAA;A5I01zB7B;;A4Iz1zBA;EAA2B,gBAAA;A5I61zB3B;;A4I51zBA;EAA0C,gBAAA;A5Ig2zB1C;;A4I/1zBA;EAAkC,gBAAA;A5Im2zBlC;;A4Il2zBA;EAAyC,gBAAA;A5Is2zBzC;;A4Ir2zBA;EAAiC,gBAAA;A5Iy2zBjC;;A4Ix2zBA;EAAmC,gBAAA;A5I42zBnC;;A4I32zBA;EAAyB,gBAAA;A5I+2zBzB;;A4I92zBA;EAA6B,gBAAA;A5Ik3zB7B;;A4Ij3zBA;EAA6B,gBAAA;A5Iq3zB7B;;A4Ip3zBA;EAAiC,gBAAA;A5Iw3zBjC;;A4Iv3zBA;EAA4B,gBAAA;A5I23zB5B;;A4I13zBA;EAAwB,gBAAA;A5I83zBxB;;A4I73zBA;EAAoC,gBAAA;A5Ii4zBpC;;A4Ih4zBA;EAA+B,gBAAA;A5Io4zB/B;;A4In4zBA;EAA6B,gBAAA;A5Iu4zB7B;;A4It4zBA;EAAwB,gBAAA;A5I04zBxB;;A4Iz4zBA;EAAyB,gBAAA;A5I64zBzB;;A4I54zBA;EAAmB,gBAAA;A5Ig5zBnB;;A4I/4zBA;EAAuB,gBAAA;A5Im5zBvB;;A4Il5zBA;EAAyB,gBAAA;A5Is5zBzB;;A4Ir5zBA;EAA0B,gBAAA;A5Iy5zB1B;;A4Ix5zBA;EAAsB,gBAAA;A5I45zBtB;;A4I35zBA;EAAyB,gBAAA;A5I+5zBzB;;A4I95zBA;EAAwB,gBAAA;A5Ik6zBxB;;A4Ij6zBA;EAAsB,gBAAA;A5Iq6zBtB;;A4Ip6zBA;EAAmB,gBAAA;A5Iw6zBnB;;A4Iv6zBA;EAAwB,gBAAA;A5I26zBxB;;A4I16zBA;EAAmB,gBAAA;A5I86zBnB;;A4I76zBA;EAAsB,gBAAA;A5Ii7zBtB;;A4Ih7zBA;EAAuB,gBAAA;A5Io7zBvB;;A4In7zBA;EAAuB,gBAAA;A5Iu7zBvB;;A4It7zBA;EAAkB,gBAAA;A5I07zBlB;;A4Iz7zBA;EAA4B,gBAAA;A5I67zB5B;;A4I57zBA;EAAuB,gBAAA;A5Ig8zBvB;;A4I/7zBA;EAAmB,gBAAA;A5Im8zBnB;;A4Il8zBA;EAA6B,gBAAA;A5Is8zB7B;;A4Ir8zBA;EAAwB,gBAAA;A5Iy8zBxB;;A4Ix8zBA;EAA4B,gBAAA;A5I48zB5B;;A4I38zBA;EAAuB,gBAAA;A5I+8zBvB;;A4I98zBA;EAA+B,gBAAA;A5Ik9zB/B;;A4Ij9zBA;EAAoC,gBAAA;A5Iq9zBpC;;A4Ip9zBA;EAA+B,gBAAA;A5Iw9zB/B;;A4Iv9zBA;EAA0B,gBAAA;A5I29zB1B;;A4I19zBA;EAAwB,gBAAA;A5I89zBxB;;A4I79zBA;EAAsB,gBAAA;A5Ii+zBtB;;A4Ih+zBA;EAAuB,gBAAA;A5Io+zBvB;;A4In+zBA;EAA4B,gBAAA;A5Iu+zB5B;;A4It+zBA;EAAuB,gBAAA;A5I0+zBvB;;A4Iz+zBA;EAAkB,gBAAA;A5I6+zBlB;;A4I5+zBA;EAA8B,gBAAA;A5Ig/zB9B;;A4I/+zBA;EAAuB,gBAAA;A5Im/zBvB;;A4Il/zBA;EAAuB,gBAAA;A5Is/zBvB;;A4Ir/zBA;EAAwB,gBAAA;A5Iy/zBxB;;A4Ix/zBA;EAA8B,gBAAA;A5I4/zB9B;;A4I3/zBA;EAAyB,gBAAA;A5I+/zBzB;;A4I9/zBA;EAAmB,gBAAA;A5Ikg0BnB;;A4Ijg0BA;EAAyB,gBAAA;A5Iqg0BzB;;A4Ipg0BA;EAAoB,gBAAA;A5Iwg0BpB;;A4Ivg0BA;EAA0B,gBAAA;A5I2g0B1B;;A4I1g0BA;EAAqB,gBAAA;A5I8g0BrB;;A4I7g0BA;EAA0B,gBAAA;A5Iih0B1B;;A4Ihh0BA;EAAqB,gBAAA;A5Ioh0BrB;;A4Inh0BA;EAAgC,gBAAA;A5Iuh0BhC;;A4Ith0BA;EAA8B,gBAAA;A5I0h0B9B;;A4Izh0BA;EAAyB,gBAAA;A5I6h0BzB;;A4I5h0BA;EAAgC,gBAAA;A5Igi0BhC;;A4I/h0BA;EAA2B,gBAAA;A5Imi0B3B;;A4Ili0BA;EAAwB,gBAAA;A5Isi0BxB;;A4Iri0BA;EAA8B,gBAAA;A5Iyi0B9B;;A4Ixi0BA;EAAyB,gBAAA;A5I4i0BzB;;A4I3i0BA;EAA6B,gBAAA;A5I+i0B7B;;A4I9i0BA;EAAwB,gBAAA;A5Ikj0BxB;;A4Ijj0BA;EAAuB,gBAAA;A5Iqj0BvB;;A4Ipj0BA;EAAkB,gBAAA;A5Iwj0BlB;;A4Ivj0BA;EAA2B,gBAAA;A5I2j0B3B;;A4I1j0BA;EAA2B,gBAAA;A5I8j0B3B;;A4I7j0BA;EAAsB,gBAAA;A5Iik0BtB;;A4Ihk0BA;EAAqB,gBAAA;A5Iok0BrB;;A4Ink0BA;EAAqB,gBAAA;A5Iuk0BrB;;A4Itk0BA;EAA2B,gBAAA;A5I0k0B3B;;A4Izk0BA;EAA2B,gBAAA;A5I6k0B3B;;A4I5k0BA;EAAsB,gBAAA;A5Igl0BtB;;A4I/k0BA;EAAuB,gBAAA;A5Iml0BvB;;A4Ill0BA;EAAwB,gBAAA;A5Isl0BxB;;A4Irl0BA;EAAwB,gBAAA;A5Iyl0BxB;;A4Ixl0BA;EAA+B,gBAAA;A5I4l0B/B;;A4I3l0BA;EAA0B,gBAAA;A5I+l0B1B;;A4I9l0BA;EAAqC,gBAAA;A5Ikm0BrC;;A4Ijm0BA;EAAgC,gBAAA;A5Iqm0BhC;;A4Ipm0BA;EAA+B,gBAAA;A5Iwm0B/B;;A4Ivm0BA;EAA0B,gBAAA;A5I2m0B1B;;A4I1m0BA;EAA8B,gBAAA;A5I8m0B9B;;A4I7m0BA;EAAyB,gBAAA;A5Iin0BzB;;A4Ihn0BA;EAAkC,gBAAA;A5Ion0BlC;;A4Inn0BA;EAA6B,gBAAA;A5Iun0B7B;;A4Itn0BA;EAA6B,gBAAA;A5I0n0B7B;;A4Izn0BA;EAAwB,gBAAA;A5I6n0BxB;;A4I5n0BA;EAAgC,gBAAA;A5Igo0BhC;;A4I/n0BA;EAA2B,gBAAA;A5Imo0B3B;;A4Ilo0BA;EAAyB,gBAAA;A5Iso0BzB;;A4Iro0BA;EAAoB,gBAAA;A5Iyo0BpB;;A4Ixo0BA;EAAyB,gBAAA;A5I4o0BzB;;A4I3o0BA;EAAoB,gBAAA;A5I+o0BpB;;A4I9o0BA;EAAuB,gBAAA;A5Ikp0BvB;;A4Ijp0BA;EAAkB,gBAAA;A5Iqp0BlB;;A4Ipp0BA;EAA0B,gBAAA;A5Iwp0B1B;;A4Ivp0BA;EAA4B,gBAAA;A5I2p0B5B;;A4I1p0BA;EAAqB,gBAAA;A5I8p0BrB;;A4I7p0BA;EAA4B,gBAAA;A5Iiq0B5B;;A4Ihq0BA;EAA4B,gBAAA;A5Ioq0B5B;;A4Inq0BA;EAAuB,gBAAA;A5Iuq0BvB;;A4Itq0BA;EAA0B,gBAAA;A5I0q0B1B;;A4Izq0BA;EAAqB,gBAAA;A5I6q0BrB;;A4I5q0BA;EAAsB,gBAAA;A5Igr0BtB;;A4I/q0BA;EAAgC,gBAAA;A5Imr0BhC;;A4Ilr0BA;EAA2B,gBAAA;A5Isr0B3B;;A4Irr0BA;EAAkC,gBAAA;A5Iyr0BlC;;A4Ixr0BA;EAAgC,gBAAA;A5I4r0BhC;;A4I3r0BA;EAA2B,gBAAA;A5I+r0B3B;;A4I9r0BA;EAA4B,gBAAA;A5Iks0B5B;;A4Ijs0BA;EAA+B,gBAAA;A5Iqs0B/B;;A4Ips0BA;EAA0B,gBAAA;A5Iws0B1B;;A4Ivs0BA;EAA0B,gBAAA;A5I2s0B1B;;A4I1s0BA;EAAgC,gBAAA;A5I8s0BhC;;A4I7s0BA;EAA+B,gBAAA;A5Iit0B/B;;A4Iht0BA;EAA0B,gBAAA;A5Iot0B1B;;A4Int0BA;EAA4B,gBAAA;A5Iut0B5B;;A4Itt0BA;EAA4B,gBAAA;A5I0t0B5B;;A4Izt0BA;EAAuB,gBAAA;A5I6t0BvB;;A4I5t0BA;EAAqB,gBAAA;A5Igu0BrB;;A4I/t0BA;EAAyB,gBAAA;A5Imu0BzB;;A4Ilu0BA;EAAmC,gBAAA;A5Isu0BnC;;A4Iru0BA;EAA8B,gBAAA;A5Iyu0B9B;;A4Ixu0BA;EAAiC,gBAAA;A5I4u0BjC;;A4I3u0BA;EAA4B,gBAAA;A5I+u0B5B;;A4I9u0BA;EAAoB,gBAAA;A5Ikv0BpB;;A4Ijv0BA;EAA6B,gBAAA;A5Iqv0B7B;;A4Ipv0BA;EAAwB,gBAAA;A5Iwv0BxB;;A4Ivv0BA;EAA6B,gBAAA;A5I2v0B7B;;A4I1v0BA;EAAwB,gBAAA;A5I8v0BxB;;A4I7v0BA;EAAuB,gBAAA;A5Iiw0BvB;;A4Ihw0BA;EAAkB,gBAAA;A5Iow0BlB;;A4Inw0BA;EAAuB,gBAAA;A5Iuw0BvB;;A4Itw0BA;EAAkB,gBAAA;A5I0w0BlB;;A4Izw0BA;EAA4B,gBAAA;A5I6w0B5B;;A4I5w0BA;EAAuB,gBAAA;A5Igx0BvB;;A4I/w0BA;EAA+B,gBAAA;A5Imx0B/B;;A4Ilx0BA;EAA0B,gBAAA;A5Isx0B1B;;A4Irx0BA;EAAwB,gBAAA;A5Iyx0BxB;;A4Ixx0BA;EAAmB,gBAAA;A5I4x0BnB;;A4I3x0BA;EAAwB,gBAAA;A5I+x0BxB;;A4I9x0BA;EAAmB,gBAAA;A5Iky0BnB;;A4Ijy0BA;EAAiC,gBAAA;A5Iqy0BjC;;A4Ipy0BA;EAA+B,gBAAA;A5Iwy0B/B;;A4Ivy0BA;EAA0B,gBAAA;A5I2y0B1B;;A4I1y0BA;EAAiC,gBAAA;A5I8y0BjC;;A4I7y0BA;EAA+B,gBAAA;A5Iiz0B/B;;A4Ihz0BA;EAA0B,gBAAA;A5Ioz0B1B;;A4Inz0BA;EAAmB,gBAAA;A5Iuz0BnB;;A4Itz0BA;EAAoB,gBAAA;A5I0z0BpB;;A4Izz0BA;EAA2B,gBAAA;A5I6z0B3B;;A4I5z0BA;EAAsB,gBAAA;A5Ig00BtB;;A4I/z0BA;EAA0B,gBAAA;A5Im00B1B;;A4Il00BA;EAAqB,gBAAA;A5Is00BrB;;A4Ir00BA;EAAmC,gBAAA;A5Iy00BnC;;A4Ix00BA;EAA8B,gBAAA;A5I400B9B;;A4I300BA;EAAoC,gBAAA;A5I+00BpC;;A4I900BA;EAA+B,gBAAA;A5Ik10B/B;;A4Ij10BA;EAAoC,gBAAA;A5Iq10BpC;;A4Ip10BA;EAA+B,gBAAA;A5Iw10B/B;;A4Iv10BA;EAAmC,gBAAA;A5I210BnC;;A4I110BA;EAA8B,gBAAA;A5I810B9B;;A4I710BA;EAAuB,gBAAA;A5Ii20BvB;;A4Ih20BA;EAAsB,gBAAA;A5Io20BtB;;A4In20BA;EAA6B,gBAAA;A5Iu20B7B;;A4It20BA;EAAsB,gBAAA;A5I020BtB;;A4Iz20BA;EAA0B,gBAAA;A5I620B1B;;A4I520BA;EAA0B,gBAAA;A5Ig30B1B;;A4I/20BA;EAA0B,gBAAA;A5Im30B1B;;A4Il30BA;EAA0B,gBAAA;A5Is30B1B;;A4Ir30BA;EAA0B,gBAAA;A5Iy30B1B;;A4Ix30BA;EAA8B,gBAAA;A5I430B9B;;A4I330BA;EAAyB,gBAAA;A5I+30BzB;;A4I930BA;EAAiC,gBAAA;A5Ik40BjC;;A4Ij40BA;EAA4B,gBAAA;A5Iq40B5B;;A4Ip40BA;EAA0B,gBAAA;A5Iw40B1B;;A4Iv40BA;EAAqB,gBAAA;A5I240BrB;;A4I140BA;EAA2B,gBAAA;A5I840B3B;;A4I740BA;EAAsB,gBAAA;A5Ii50BtB;;A4Ih50BA;EAA6B,gBAAA;A5Io50B7B;;A4In50BA;EAAwB,gBAAA;A5Iu50BxB;;A4It50BA;EAAyB,gBAAA;A5I050BzB;;A4Iz50BA;EAAoB,gBAAA;A5I650BpB;;A4I550BA;EAAuB,gBAAA;A5Ig60BvB;;A4I/50BA;EAAkB,gBAAA;A5Im60BlB;;A4Il60BA;EAAqB,gBAAA;A5Is60BrB;;A4Ir60BA;EAAwB,gBAAA;A5Iy60BxB;;A4Ix60BA;EAAmB,gBAAA;A5I460BnB;;A4I360BA;EAAyB,gBAAA;A5I+60BzB;;A4I960BA;EAAoB,gBAAA;A5Ik70BpB;;A4Ij70BA;EAAuB,gBAAA;A5Iq70BvB;;A4Ip70BA;EAA0B,gBAAA;A5Iw70B1B;;A4Iv70BA;EAAqB,gBAAA;A5I270BrB;;A4I170BA;EAA4B,gBAAA;A5I870B5B;;A4I770BA;EAAqB,gBAAA;A5Ii80BrB;;A4Ih80BA;EAAyB,gBAAA;A5Io80BzB;;A4In80BA;EAAoB,gBAAA;A5Iu80BpB;;A4It80BA;EAA2B,gBAAA;A5I080B3B;;A4Iz80BA;EAAiC,gBAAA;A5I680BjC;;A4I580BA;EAAgC,gBAAA;A5Ig90BhC;;A4I/80BA;EAAsC,gBAAA;A5Im90BtC;;A4Il90BA;EAAgC,gBAAA;A5Is90BhC;;A4Ir90BA;EAA+B,gBAAA;A5Iy90B/B;;A4Ix90BA;EAA4B,gBAAA;A5I490B5B;;A4I390BA;EAA0B,gBAAA;A5I+90B1B;;A4I990BA;EAA+B,gBAAA;A5Ik+0B/B;;A4Ij+0BA;EAA0B,gBAAA;A5Iq+0B1B;;A4Ip+0BA;EAA2B,gBAAA;A5Iw+0B3B;;A4Iv+0BA;EAA0B,gBAAA;A5I2+0B1B;;A4I1+0BA;EAA4B,gBAAA;A5I8+0B5B;;A4I7+0BA;EAAgC,gBAAA;A5Ii/0BhC;;A4Ih/0BA;EAA2B,gBAAA;A5Io/0B3B;;A4In/0BA;EAAuB,gBAAA;A5Iu/0BvB;;A4It/0BA;EAAqB,gBAAA;A5I0/0BrB;;A4Iz/0BA;EAAyB,gBAAA;A5I6/0BzB;;A4I5/0BA;EAAoB,gBAAA;A5Igg1BpB;;A4I//0BA;EAA0B,gBAAA;A5Img1B1B;;A4Ilg1BA;EAAmB,gBAAA;A5Isg1BnB;;A4Irg1BA;EAAsB,gBAAA;A5Iyg1BtB;;A4Ixg1BA;EAA8B,gBAAA;A5I4g1B9B;;A4I3g1BA;EAAyB,gBAAA;A5I+g1BzB;;A4I9g1BA;EAA4B,gBAAA;A5Ikh1B5B;;A4Ijh1BA;EAAkC,gBAAA;A5Iqh1BlC;;A4Iph1BA;EAA6B,gBAAA;A5Iwh1B7B;;A4Ivh1BA;EAAuB,gBAAA;A5I2h1BvB;;A4I1h1BA;EAAuB,gBAAA;A5I8h1BvB;;A4I7h1BA;EAAkB,gBAAA;A5Iii1BlB;;A4Ihi1BA;EAAqC,gBAAA;A5Ioi1BrC;;A4Ini1BA;EAAgC,gBAAA;A5Iui1BhC;;A4Iti1BA;EAAwC,gBAAA;A5I0i1BxC;;A4Izi1BA;EAAmC,gBAAA;A5I6i1BnC;;A4I5i1BA;EAAiC,gBAAA;A5Igj1BjC;;A4I/i1BA;EAA4B,gBAAA;A5Imj1B5B;;A4Ilj1BA;EAAgC,gBAAA;A5Isj1BhC;;A4Irj1BA;EAA2B,gBAAA;A5Iyj1B3B;;A4Ixj1BA;EAAmC,gBAAA;A5I4j1BnC;;A4I3j1BA;EAA8B,gBAAA;A5I+j1B9B;;A4I9j1BA;EAA4B,gBAAA;A5Ikk1B5B;;A4Ijk1BA;EAAuB,gBAAA;A5Iqk1BvB;;A4Ipk1BA;EAAoC,gBAAA;A5Iwk1BpC;;A4Ivk1BA;EAA+B,gBAAA;A5I2k1B/B;;A4I1k1BA;EAAuC,gBAAA;A5I8k1BvC;;A4I7k1BA;EAAkC,gBAAA;A5Iil1BlC;;A4Ihl1BA;EAAgC,gBAAA;A5Iol1BhC;;A4Inl1BA;EAA2B,gBAAA;A5Iul1B3B;;A4Itl1BA;EAAkC,gBAAA;A5I0l1BlC;;A4Izl1BA;EAA6B,gBAAA;A5I6l1B7B;;A4I5l1BA;EAAqC,gBAAA;A5Igm1BrC;;A4I/l1BA;EAAgC,gBAAA;A5Imm1BhC;;A4Ilm1BA;EAA8B,gBAAA;A5Ism1B9B;;A4Irm1BA;EAAyB,gBAAA;A5Iym1BzB;;A4Ixm1BA;EAAoB,gBAAA;A5I4m1BpB;;A4I3m1BA;EAAgC,gBAAA;A5I+m1BhC;;A4I9m1BA;EAA2B,gBAAA;A5Ikn1B3B;;A4Ijn1BA;EAAgC,gBAAA;A5Iqn1BhC;;A4Ipn1BA;EAA2B,gBAAA;A5Iwn1B3B;;A4Ivn1BA;EAAoB,gBAAA;A5I2n1BpB;;A4I1n1BA;EAAsB,gBAAA;A5I8n1BtB;;A4I7n1BA;EAAyB,gBAAA;A5Iio1BzB;;A4Iho1BA;EAAmB,gBAAA;A5Ioo1BnB;;A4Ino1BA;EAAoB,gBAAA;A5Iuo1BpB;;A4Ito1BA;EAAoB,gBAAA;A5I0o1BpB;;A4Izo1BA;EAAkC,gBAAA;A5I6o1BlC;;A4I5o1BA;EAA8B,gBAAA;A5Igp1B9B;;A4I/o1BA;EAAgC,gBAAA;A5Imp1BhC;;A4Ilp1BA;EAA4B,gBAAA;A5Isp1B5B;;A4Irp1BA;EAA4B,gBAAA;A5Iyp1B5B;;A4Ixp1BA;EAAwB,gBAAA;A5I4p1BxB;;A4I3p1BA;EAAoC,gBAAA;A5I+p1BpC;;A4I9p1BA;EAAgC,gBAAA;A5Ikq1BhC;;A4Ijq1BA;EAAkC,gBAAA;A5Iqq1BlC;;A4Ipq1BA;EAA8B,gBAAA;A5Iwq1B9B;;A4Ivq1BA;EAA0B,gBAAA;A5I2q1B1B;;A4I1q1BA;EAAsB,gBAAA;A5I8q1BtB;;A4I7q1BA;EAAwB,gBAAA;A5Iir1BxB;;A4Ihr1BA;EAA2B,gBAAA;A5Ior1B3B;;A4Inr1BA;EAAsB,gBAAA;A5Iur1BtB;;A4Itr1BA;EAA0B,gBAAA;A5I0r1B1B;;A4Izr1BA;EAA2B,gBAAA;A5I6r1B3B;;A4I5r1BA;EAAyB,gBAAA;A5Igs1BzB;;A4I/r1BA;EAA0B,gBAAA;A5Ims1B1B;;A4Ils1BA;EAA0B,gBAAA;A5Iss1B1B;;A4Irs1BA;EAAqB,gBAAA;A5Iys1BrB;;A4Ixs1BA;EAAoB,gBAAA;A5I4s1BpB;;A4I3s1BA;EAAwB,gBAAA;A5I+s1BxB;;A4I9s1BA;EAAwB,gBAAA;A5Ikt1BxB;;A4Ijt1BA;EAAmB,gBAAA;A5Iqt1BnB;;A4Ipt1BA;EAAoB,gBAAA;A5Iwt1BpB;;A4Ivt1BA;EAA4B,gBAAA;A5I2t1B5B;;A4I1t1BA;EAAuB,gBAAA;A5I8t1BvB;;A4I7t1BA;EAA0B,gBAAA;A5Iiu1B1B;;A4Ihu1BA;EAAqB,gBAAA;A5Iou1BrB;;A4Inu1BA;EAA4B,gBAAA;A5Iuu1B5B;;A4Itu1BA;EAAuB,gBAAA;A5I0u1BvB;;A4Izu1BA;EAA+B,gBAAA;A5I6u1B/B;;A4I5u1BA;EAA0B,gBAAA;A5Igv1B1B;;A4I/u1BA;EAAwB,gBAAA;A5Imv1BxB;;A4Ilv1BA;EAAmB,gBAAA;A5Isv1BnB;;A4Irv1BA;EAA8B,gBAAA;A5Iyv1B9B;;A4Ixv1BA;EAAyB,gBAAA;A5I4v1BzB;;A4I3v1BA;EAA6B,gBAAA;A5I+v1B7B;;A4I9v1BA;EAAwB,gBAAA;A5Ikw1BxB;;A4Ijw1BA;EAAuB,gBAAA;A5Iqw1BvB;;A4Ipw1BA;EAA6B,gBAAA;A5Iww1B7B;;A4Ivw1BA;EAAwB,gBAAA;A5I2w1BxB;;A4I1w1BA;EAAgC,gBAAA;A5I8w1BhC;;A4I7w1BA;EAA2B,gBAAA;A5Iix1B3B;;A4Ihx1BA;EAA8B,gBAAA;A5Iox1B9B;;A4Inx1BA;EAAyB,gBAAA;A5Iux1BzB;;A4Itx1BA;EAA8B,gBAAA;A5I0x1B9B;;A4Izx1BA;EAAyB,gBAAA;A5I6x1BzB;;A4I5x1BA;EAAuB,gBAAA;A5Igy1BvB;;A4I/x1BA;EAAkB,gBAAA;A5Imy1BlB;;A4Ily1BA;EAAyB,gBAAA;A5Isy1BzB;;A4Iry1BA;EAA2B,gBAAA;A5Iyy1B3B;;A4Ixy1BA;EAAsB,gBAAA;A5I4y1BtB;;A4I3y1BA;EAA0B,gBAAA;A5I+y1B1B;;A4I9y1BA;EAAqB,gBAAA;A5Ikz1BrB;;A4Ijz1BA;EAAkC,gBAAA;A5Iqz1BlC;;A4Ipz1BA;EAAgC,gBAAA;A5Iwz1BhC;;A4Ivz1BA;EAAoB,gBAAA;A5I2z1BpB;;A4I1z1BA;EAA0B,gBAAA;A5I8z1B1B;;A4I7z1BA;EAAoC,gBAAA;A5Ii01BpC;;A4Ih01BA;EAA+B,gBAAA;A5Io01B/B;;A4In01BA;EAAqB,gBAAA;A5Iu01BrB;;A4It01BA;EAAuB,gBAAA;A5I001BvB;;A4Iz01BA;EAAkB,gBAAA;A5I601BlB;;A4I501BA;EAAwB,gBAAA;A5Ig11BxB;;A4I/01BA;EAAmB,gBAAA;A5Im11BnB;;A4Il11BA;EAAuB,gBAAA;A5Is11BvB;;A4Ir11BA;EAA6B,gBAAA;A5Iy11B7B;;A4Ix11BA;EAAqC,gBAAA;A5I411BrC;;A4I311BA;EAAgC,gBAAA;A5I+11BhC;;A4I911BA;EAAqC,gBAAA;A5Ik21BrC;;A4Ij21BA;EAAgC,gBAAA;A5Iq21BhC;;A4Ip21BA;EAAmC,gBAAA;A5Iw21BnC;;A4Iv21BA;EAA8B,gBAAA;A5I221B9B;;A4I121BA;EAAsC,gBAAA;A5I821BtC;;A4I721BA;EAAiC,gBAAA;A5Ii31BjC;;A4Ih31BA;EAAkC,gBAAA;A5Io31BlC;;A4In31BA;EAA6B,gBAAA;A5Iu31B7B;;A4It31BA;EAA+B,gBAAA;A5I031B/B;;A4Iz31BA;EAA0B,gBAAA;A5I631B1B;;A4I531BA;EAAwB,gBAAA;A5Ig41BxB;;A4I/31BA;EAA4B,gBAAA;A5Im41B5B;;A4Il41BA;EAAuB,gBAAA;A5Is41BvB;;A4Ir41BA;EAA0B,gBAAA;A5Iy41B1B;;A4Ix41BA;EAA+B,gBAAA;A5I441B/B;;A4I341BA;EAAgC,gBAAA;A5I+41BhC;;A4I941BA;EAAwB,gBAAA;A5Ik51BxB;;A4Ij51BA;EAA6B,gBAAA;A5Iq51B7B;;A4Ip51BA;EAAyB,gBAAA;A5Iw51BzB;;A4Iv51BA;EAA8B,gBAAA;A5I251B9B;;A4I151BA;EAAyB,gBAAA;A5I851BzB;;A4I751BA;EAAuB,gBAAA;A5Ii61BvB;;A4Ih61BA;EAA+B,gBAAA;A5Io61B/B;;A4In61BA;EAA+B,gBAAA;A5Iu61B/B;;A4It61BA;EAA8B,gBAAA;A5I061B9B;;A4Iz61BA;EAA+B,gBAAA;A5I661B/B;;A4I561BA;EAA8B,gBAAA;A5Ig71B9B;;A4I/61BA;EAA0B,gBAAA;A5Im71B1B;;A4Il71BA;EAAkC,gBAAA;A5Is71BlC;;A4Ir71BA;EAAyB,gBAAA;A5Iy71BzB;;A4Ix71BA;EAAyB,gBAAA;A5I471BzB;;A4I371BA;EAAwB,gBAAA;A5I+71BxB;;A4I971BA;EAA0B,gBAAA;A5Ik81B1B;;A4Ij81BA;EAAyB,gBAAA;A5Iq81BzB;;A4Ip81BA;EAAsB,gBAAA;A5Iw81BtB;;A4Iv81BA;EAAuB,gBAAA;A5I281BvB;;A4I181BA;EAAoB,gBAAA;A5I881BpB;;A4I781BA;EAAsB,gBAAA;A5Ii91BtB;;A4Ih91BA;EAAyB,gBAAA;A5Io91BzB;;A4In91BA;EAAoB,gBAAA;A5Iu91BpB;;A4It91BA;EAA0B,gBAAA;A5I091B1B;;A4Iz91BA;EAAqB,gBAAA;A5I691BrB;;A4I591BA;EAAwB,gBAAA;A5Ig+1BxB;;A4I/91BA;EAAmB,gBAAA;A5Im+1BnB;;A4Il+1BA;EAA4B,gBAAA;A5Is+1B5B;;A4Ir+1BA;EAA4B,gBAAA;A5Iy+1B5B;;A4Ix+1BA;EAAuB,gBAAA;A5I4+1BvB;;A4I3+1BA;EAA0B,gBAAA;A5I++1B1B;;A4I9+1BA;EAAqB,gBAAA;A5Ik/1BrB;;A4Ij/1BA;EAA6B,gBAAA;A5Iq/1B7B;;A4Ip/1BA;EAA4B,gBAAA;A5Iw/1B5B;;A4Iv/1BA;EAAoB,gBAAA;A5I2/1BpB;;A4I1/1BA;EAAsB,gBAAA;A5I8/1BtB;;A4I7/1BA;EAAsB,gBAAA;A5Iig2BtB;;A4Ihg2BA;EAAiB,gBAAA;A5Iog2BjB;;A4Ing2BA;EAAqB,gBAAA;A5Iug2BrB;;A4Itg2BA;EAAsB,gBAAA;A5I0g2BtB;;A4Izg2BA;EAAwB,gBAAA;A5I6g2BxB;;A4I5g2BA;EAAsB,gBAAA;A5Igh2BtB;;A4I/g2BA;EAAsB,gBAAA;A5Imh2BtB;;A4Ilh2BA;EAAsB,gBAAA;A5Ish2BtB;;A4Irh2BA;EAA0B,gBAAA;A5Iyh2B1B;;A4Ixh2BA;EAAiC,gBAAA;A5I4h2BjC;;A4I3h2BA;EAA6B,gBAAA;A5I+h2B7B;;A4I9h2BA;EAAmB,gBAAA;A5Iki2BnB;;A4Iji2BA;EAA6B,gBAAA;A5Iqi2B7B;;A4Ipi2BA;EAAwB,gBAAA;A5Iwi2BxB;;A4Ivi2BA;EAA6B,gBAAA;A5I2i2B7B;;A4I1i2BA;EAAwB,gBAAA;A5I8i2BxB;;A4I7i2BA;EAA4B,gBAAA;A5Iij2B5B;;A4Ihj2BA;EAAuB,gBAAA;A5Ioj2BvB;;A4Inj2BA;EAAoB,gBAAA;A5Iuj2BpB;;A4Itj2BA;EAA0B,gBAAA;A5I0j2B1B;;A4Izj2BA;EAAqB,gBAAA;A5I6j2BrB;;A4I5j2BA;EAAuB,gBAAA;A5Igk2BvB;;A4I/j2BA;EAAkB,gBAAA;A5Imk2BlB;;A4Ilk2BA;EAAqB,gBAAA;A5Isk2BrB;;A4Irk2BA;EAAyB,gBAAA;A5Iyk2BzB;;A4Ixk2BA;EAAwB,gBAAA;A5I4k2BxB;;A4I3k2BA;EAA2B,gBAAA;A5I+k2B3B;;A4I9k2BA;EAAyB,gBAAA;A5Ikl2BzB;;A4Ijl2BA;EAAoB,gBAAA;A5Iql2BpB;;A4Ipl2BA;EAAwB,gBAAA;A5Iwl2BxB;;A4Ivl2BA;EAA+B,gBAAA;A5I2l2B/B;;A4I1l2BA;EAA0B,gBAAA;A5I8l2B1B;;A4I7l2BA;EAA+B,gBAAA;A5Iim2B/B;;A4Ihm2BA;EAA0B,gBAAA;A5Iom2B1B;;A4Inm2BA;EAA8B,gBAAA;A5Ium2B9B;;A4Itm2BA;EAAyB,gBAAA;A5I0m2BzB;;A4Izm2BA;EAA6B,gBAAA;A5I6m2B7B;;A4I5m2BA;EAAwB,gBAAA;A5Ign2BxB;;A4I/m2BA;EAAiB,gBAAA;A5Imn2BjB;;A4Iln2BA;EAA0B,gBAAA;A5Isn2B1B;;A4Irn2BA;EAAqB,gBAAA;A5Iyn2BrB;;A4Ixn2BA;EAAsB,gBAAA;A5I4n2BtB;;A4I3n2BA;EAAoB,gBAAA;A5I+n2BpB;;A4I9n2BA;EAAoB,gBAAA;A5Iko2BpB;;A4Ijo2BA;EAAuB,gBAAA;A5Iqo2BvB;;A4Ipo2BA;EAAqB,gBAAA;A5Iwo2BrB;;A4Ivo2BA;EAAqB,gBAAA;A5I2o2BrB;;A4I1o2BA;EAAuB,gBAAA;A5I8o2BvB;;A4I7o2BA;EAAmB,gBAAA;A5Iip2BnB;;A4Ihp2BA;EAAmB,gBAAA;A5Iop2BnB;;A4Inp2BA;EAA0B,gBAAA;A5Iup2B1B;;A4Itp2BA;EAA6B,gBAAA;A5I0p2B7B;;A4Izp2BA;EAAqB,gBAAA;A5I6p2BrB;;A4I5p2BA;EAAqB,gBAAA;A5Igq2BrB;;A4I/p2BA;EAA4B,gBAAA;A5Imq2B5B;;A4Ilq2BA;EAAuB,gBAAA;A5Isq2BvB;;A4Irq2BA;EAA6B,gBAAA;A5Iyq2B7B;;A4Ixq2BA;EAAwB,gBAAA;A5I4q2BxB;;A4I3q2BA;EAA6B,gBAAA;A5I+q2B7B;;A4I9q2BA;EAAwB,gBAAA;A5Ikr2BxB;;A4Ijr2BA;EAA4B,gBAAA;A5Iqr2B5B;;A4Ipr2BA;EAAuB,gBAAA;A5Iwr2BvB;;A4Ivr2BA;EAAgB,gBAAA;A5I2r2BhB;;A4I1r2BA;EAAsB,gBAAA;A5I8r2BtB;;A4I7r2BA;EAAsB,gBAAA;A5Iis2BtB;;A4Ihs2BA;EAAuB,gBAAA;A5Ios2BvB;;A4Ins2BA;EAAmB,gBAAA;A5Ius2BnB;;A4Its2BA;EAAoB,gBAAA;A5I0s2BpB;;A4Izs2BA;EAA8B,gBAAA;A5I6s2B9B;;A4I5s2BA;EAAyB,gBAAA;A5Igt2BzB;;A4I/s2BA;EAAwB,gBAAA;A5Imt2BxB;;A4Ilt2BA;EAAuB,gBAAA;A5Ist2BvB;;A4Irt2BA;EAAmB,gBAAA;A5Iyt2BnB;;A4Ixt2BA;EAA+B,gBAAA;A5I4t2B/B;;A4I3t2BA;EAA8B,gBAAA;A5I+t2B9B;;A4I9t2BA;EAA4B,gBAAA;A5Iku2B5B;;A4Iju2BA;EAAgC,gBAAA;A5Iqu2BhC;;A4Ipu2BA;EAA6B,gBAAA;A5Iwu2B7B;;A4Ivu2BA;EAA2B,gBAAA;A5I2u2B3B;;A4I1u2BA;EAAsB,gBAAA;A5I8u2BtB;;A4I7u2BA;EAA6B,gBAAA;A5Iiv2B7B;;A4Ihv2BA;EAAoC,gBAAA;A5Iov2BpC;;A4Inv2BA;EAA+B,gBAAA;A5Iuv2B/B;;A4Itv2BA;EAA4B,gBAAA;A5I0v2B5B;;A4Izv2BA;EAAuB,gBAAA;A5I6v2BvB;;A4I5v2BA;EAA+B,gBAAA;A5Igw2B/B;;A4I/v2BA;EAA4B,gBAAA;A5Imw2B5B;;A4Ilw2BA;EAA0B,gBAAA;A5Isw2B1B;;A4Irw2BA;EAA2B,gBAAA;A5Iyw2B3B;;A4Ixw2BA;EAAyB,gBAAA;A5I4w2BzB;;A4I3w2BA;EAAsB,gBAAA;A5I+w2BtB;;A4I9w2BA;EAAuB,gBAAA;A5Ikx2BvB;;A4Ijx2BA;EAAwB,gBAAA;A5Iqx2BxB;;A4Ipx2BA;EAA8B,gBAAA;A5Iwx2B9B;;A4Ivx2BA;EAAyB,gBAAA;A5I2x2BzB;;A4I1x2BA;EAA2B,gBAAA;A5I8x2B3B;;A4I7x2BA;EAAsB,gBAAA;A5Iiy2BtB;;A4Ihy2BA;EAAsB,gBAAA;A5Ioy2BtB;;A4Iny2BA;EAA0B,gBAAA;A5Iuy2B1B;;A4Ity2BA;EAAsB,gBAAA;A5I0y2BtB;;A4Izy2BA;EAAqB,gBAAA;A5I6y2BrB;;A4I5y2BA;EAAwB,gBAAA;A5Igz2BxB;;A4I/y2BA;EAAyB,gBAAA;A5Imz2BzB;;A4Ilz2BA;EAAoB,gBAAA;A5Isz2BpB;;A4Irz2BA;EAA2B,gBAAA;A5Iyz2B3B;;A4Ixz2BA;EAAsB,gBAAA;A5I4z2BtB;;A4I3z2BA;EAAoB,gBAAA;A5I+z2BpB;;A4I9z2BA;EAAuB,gBAAA;A5Ik02BvB;;A4Ij02BA;EAAwB,gBAAA;A5Iq02BxB;;A4Ip02BA;EAAmB,gBAAA;A5Iw02BnB;;A4Iv02BA;EAAmB,gBAAA;A5I202BnB","sourcesContent":["@charset \"UTF-8\";\n/*\nTemplate Name: Shreyu - Responsive Bootstrap 5 Admin Dashboard\nAuthor: CoderThemes\nVersion: 2.0.0\nWebsite: https://coderthemes.com/\nContact: support@coderthemes.com\nFile: Custom Bootstrap Css File\n*/\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n@import url(\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600&display=swap\");\n:root {\n  --bs-blue: #5369f8;\n  --bs-indigo: #564ab1;\n  --bs-purple: #6f42c1;\n  --bs-pink: #e83e8c;\n  --bs-red: #ff5c75;\n  --bs-orange: #f77e53;\n  --bs-yellow: #ffbe0b;\n  --bs-green: #43d39e;\n  --bs-teal: #1ce1ac;\n  --bs-cyan: #25c2e3;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f8f9fa;\n  --bs-gray-200: #f6f6f7;\n  --bs-gray-300: #e2e7f1;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #4B4B5A;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #5369f8;\n  --bs-secondary: #6c757d;\n  --bs-success: #43d39e;\n  --bs-info: #25c2e3;\n  --bs-warning: #ffbe0b;\n  --bs-danger: #ff5c75;\n  --bs-light: #f8f9fa;\n  --bs-dark: #343a40;\n  --bs-primary-rgb: 83, 105, 248;\n  --bs-secondary-rgb: 108, 117, 125;\n  --bs-success-rgb: 67, 211, 158;\n  --bs-info-rgb: 37, 194, 227;\n  --bs-warning-rgb: 255, 190, 11;\n  --bs-danger-rgb: 255, 92, 117;\n  --bs-light-rgb: 248, 249, 250;\n  --bs-dark-rgb: 52, 58, 64;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-body-color-rgb: 75, 75, 90;\n  --bs-body-bg-rgb: 243, 244, 247;\n  --bs-font-sans-serif: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: Noto Sans, Noto Sans Fallback, sans-serif;\n  --bs-body-font-size: 0.875rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #4B4B5A;\n  --bs-body-bg: #f3f4f7;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1.5rem 0;\n  color: rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);\n  background-color: currentColor;\n  border: 0;\n  opacity: 1;\n}\n\nhr:not([size]) {\n  height: 1px;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  line-height: 1.1;\n}\n\nh1, .h1 {\n  font-size: calc(1.35rem + 1.2vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.25rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.3125rem + 0.75vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.875rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.5rem;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.125rem;\n}\n\nh5, .h5 {\n  font-size: 0.9375rem;\n}\n\nh6, .h6 {\n  font-size: 0.9rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-bs-original-title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.75rem;\n}\n\nmark, .mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #5369f8;\n  text-decoration: none;\n}\na:hover {\n  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);\n  text-decoration: none;\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n  direction: ltr /* rtl:ignore */;\n  unicode-bidi: bidi-override;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 87.5%;\n  color: #212529;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n  font-weight: 700;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.85rem;\n  padding-bottom: 0.85rem;\n  color: #6c757d;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend {\n  line-height: inherit;\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.09375rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n.display-1 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n.display-2 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n.display-3 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n.display-4 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n.display-5 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n.display-6 {\n  font-weight: 300;\n  line-height: 1.1;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 6px;\n}\n\n.initialism {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1.5rem;\n  font-size: 1.09375rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1.5rem;\n  margin-bottom: 1.5rem;\n  font-size: 0.75rem;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #f3f4f7;\n  border: 1px solid #e2e7f1;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.75rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.75rem;\n  color: #6c757d;\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  width: 100%;\n  padding-right: var(--bs-gutter-x, 12px);\n  padding-left: var(--bs-gutter-x, 12px);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n.row {\n  --bs-gutter-x: 24px;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.375rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.375rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.75rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.75rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 2.25rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 2.25rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 4.5rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 4.5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.375rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.375rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 4.5rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 4.5rem;\n  }\n}\n.table {\n  --bs-table-bg: transparent;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: #4B4B5A;\n  --bs-table-striped-bg: #f8f9fa;\n  --bs-table-active-color: #4B4B5A;\n  --bs-table-active-bg: #f8f9fa;\n  --bs-table-hover-color: #4B4B5A;\n  --bs-table-hover-bg: #f8f9fa;\n  width: 100%;\n  margin-bottom: 1.5rem;\n  color: #4B4B5A;\n  vertical-align: top;\n  border-color: #e2e7f1;\n}\n.table > :not(caption) > * > * {\n  padding: 0.85rem 0.85rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n.table > :not(:first-child) {\n  border-top: 2px solid #e2e7f1;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-active {\n  --bs-table-accent-bg: var(--bs-table-active-bg);\n  color: var(--bs-table-active-color);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n\n.table-primary {\n  --bs-table-bg: rgb(86.5098039216%, 88.2352941176%, 99.4509803922%);\n  --bs-table-striped-bg: #343a40;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #343a40;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #343a40;\n  --bs-table-hover-color: #fff;\n  color: #343a40;\n  border-color: rgb(79.8980392157%, 81.6862745098%, 92.0156862745%);\n}\n\n.table-secondary {\n  --bs-table-bg: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n  --bs-table-striped-bg: #343a40;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #343a40;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #343a40;\n  --bs-table-hover-color: #fff;\n  color: #343a40;\n  border-color: rgb(81.662745098%, 82.5333333333%, 83.3333333333%);\n}\n\n.table-success {\n  --bs-table-bg: rgb(85.2549019608%, 96.5490196078%, 92.3921568627%);\n  --bs-table-striped-bg: #343a40;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #343a40;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #343a40;\n  --bs-table-hover-color: #fff;\n  color: #343a40;\n  border-color: rgb(78.768627451%, 89.168627451%, 85.662745098%);\n}\n\n.table-info {\n  --bs-table-bg: rgb(82.9019607843%, 95.2156862745%, 97.8039215686%);\n  --bs-table-striped-bg: #343a40;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #343a40;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #343a40;\n  --bs-table-hover-color: #fff;\n  color: #343a40;\n  border-color: rgb(76.6509803922%, 87.968627451%, 90.5333333333%);\n}\n\n.table-warning {\n  --bs-table-bg: rgb(100%, 94.9019607843%, 80.862745098%);\n  --bs-table-striped-bg: #343a40;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #343a40;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #343a40;\n  --bs-table-hover-color: #fff;\n  color: #343a40;\n  border-color: rgb(92.0392156863%, 87.6862745098%, 75.2862745098%);\n}\n\n.table-danger {\n  --bs-table-bg: rgb(100%, 87.2156862745%, 89.1764705882%);\n  --bs-table-striped-bg: #343a40;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #343a40;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #343a40;\n  --bs-table-hover-color: #fff;\n  color: #343a40;\n  border-color: rgb(92.0392156863%, 80.768627451%, 82.768627451%);\n}\n\n.table-light {\n  --bs-table-bg: #f8f9fa;\n  --bs-table-striped-bg: #343a40;\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: #343a40;\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: #343a40;\n  --bs-table-hover-color: #fff;\n  color: #343a40;\n  border-color: rgb(89.568627451%, 90.1568627451%, 90.7450980392%);\n}\n\n.table-dark {\n  --bs-table-bg: #343a40;\n  --bs-table-striped-bg: white;\n  --bs-table-striped-color: #343a40;\n  --bs-table-active-bg: white;\n  --bs-table-active-color: #343a40;\n  --bs-table-hover-bg: white;\n  --bs-table-hover-color: #343a40;\n  color: #fff;\n  border-color: rgb(28.3529411765%, 30.4705882353%, 32.5882352941%);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.45rem + 1px);\n  padding-bottom: calc(0.45rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.09375rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.28rem + 1px);\n  padding-bottom: calc(0.28rem + 1px);\n  font-size: 0.7875rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #6c757d;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #4B4B5A;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  appearance: none;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: #4B4B5A;\n  background-color: #fff;\n  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n  outline: 0;\n  box-shadow: none;\n}\n.form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n.form-control::placeholder {\n  color: #adb5bd;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #fff;\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.45rem 0.9rem;\n  margin: -0.45rem -0.9rem;\n  margin-inline-end: 0.9rem;\n  color: #4B4B5A;\n  background-color: #f6f6f7;\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: rgb(91.6470588235%, 91.6470588235%, 92.0196078431%);\n}\n.form-control::-webkit-file-upload-button {\n  padding: 0.45rem 0.9rem;\n  margin: -0.45rem -0.9rem;\n  margin-inline-end: 0.9rem;\n  color: #4B4B5A;\n  background-color: #f6f6f7;\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::-webkit-file-upload-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: rgb(91.6470588235%, 91.6470588235%, 92.0196078431%);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #4B4B5A;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.56rem + 2px);\n  padding: 0.28rem 0.8rem;\n  font-size: 0.7875rem;\n  border-radius: 0.2rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.28rem 0.8rem;\n  margin: -0.28rem -0.8rem;\n  margin-inline-end: 0.8rem;\n}\n.form-control-sm::-webkit-file-upload-button {\n  padding: 0.28rem 0.8rem;\n  margin: -0.28rem -0.8rem;\n  margin-inline-end: 0.8rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.3rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n.form-control-lg::-webkit-file-upload-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.9rem + 2px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.56rem + 2px);\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: auto;\n  padding: 0.45rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n.form-control-color::-webkit-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: 0.45rem 2.7rem 0.45rem 0.9rem;\n  -moz-padding-start: calc(0.9rem - 3px);\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #4B4B5A;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.9rem center;\n  background-size: 14px 10px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select {\n  appearance: none;\n}\n.form-select:focus {\n  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n  outline: 0;\n  box-shadow: none;\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.9rem;\n  background-image: none;\n}\n.form-select:disabled {\n  color: #6c757d;\n  background-color: #f6f6f7;\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #4B4B5A;\n}\n\n.form-select-sm {\n  padding-top: 0.28rem;\n  padding-bottom: 0.28rem;\n  padding-left: 0.8rem;\n  font-size: 0.7875rem;\n  border-radius: 0.2rem;\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.3rem;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.3125rem;\n  padding-left: 1.5rem;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5rem;\n}\n\n.form-check-input {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0.25rem;\n  vertical-align: top;\n  background-color: #fff;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  appearance: none;\n  color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n  outline: 0;\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);\n}\n.form-check-input:checked {\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.form-check-input:checked[type=checkbox] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #5369f8;\n  border-color: #5369f8;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%2869.3889648883%, 73.137254902%, 76.8855449156%%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n.form-range {\n  width: 100%;\n  height: 1rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #f3f4f7, none;\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #f3f4f7, none;\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #5369f8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb {\n  appearance: none;\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(79.7647058824%, 82.3529411765%, 99.1764705882%);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #e2e7f1;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #5369f8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb {\n  appearance: none;\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(79.7647058824%, 82.3529411765%, 99.1764705882%);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #e2e7f1;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-select {\n  height: calc(3.5rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  padding: 1rem 0.9rem;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control {\n  padding: 1rem 0.9rem;\n}\n.form-floating > .form-control::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus {\n  z-index: 3;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 3;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #4B4B5A;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #f6f6f7;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.28rem 0.8rem;\n  font-size: 0.7875rem;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3.6rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #43d39e;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.8rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(67, 211, 158, 0.9);\n  border-radius: 0.2rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #43d39e;\n  padding-right: calc(1.5em + 0.9rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2343d39e' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.225rem) center;\n  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #43d39e;\n  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.9rem);\n  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: #43d39e;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  padding-right: 4.95rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2343d39e' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-position: right 0.9rem center, center right 2.7rem;\n  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: #43d39e;\n  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.25);\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: #43d39e;\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: #43d39e;\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #43d39e;\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,\n.was-validated .input-group .form-select:valid,\n.input-group .form-select.is-valid {\n  z-index: 1;\n}\n.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,\n.was-validated .input-group .form-select:valid:focus,\n.input-group .form-select.is-valid:focus {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.75rem;\n  color: #ff5c75;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.4rem 0.8rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #fff;\n  background-color: rgba(255, 92, 117, 0.9);\n  border-radius: 0.2rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #ff5c75;\n  padding-right: calc(1.5em + 0.9rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23ff5c75'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ff5c75' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.225rem) center;\n  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #ff5c75;\n  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.9rem);\n  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: #ff5c75;\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  padding-right: 4.95rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23ff5c75'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ff5c75' stroke='none'/%3e%3c/svg%3e\");\n  background-position: right 0.9rem center, center right 2.7rem;\n  background-size: 14px 10px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: #ff5c75;\n  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.25);\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: #ff5c75;\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: #ff5c75;\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #ff5c75;\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,\n.was-validated .input-group .form-select:invalid,\n.input-group .form-select.is-invalid {\n  z-index: 2;\n}\n.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,\n.was-validated .input-group .form-select:invalid:focus,\n.input-group .form-select.is-invalid:focus {\n  z-index: 3;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #4B4B5A;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #4B4B5A;\n}\n.btn-check:focus + .btn, .btn:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  pointer-events: none;\n  opacity: 0.65;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(27.6666666667%, 35%, 82.6666666667%);\n  border-color: rgb(26.0392156863%, 32.9411764706%, 77.8039215686%);\n}\n.btn-check:focus + .btn-primary, .btn-primary:focus {\n  color: #fff;\n  background-color: rgb(27.6666666667%, 35%, 82.6666666667%);\n  border-color: rgb(26.0392156863%, 32.9411764706%, 77.8039215686%);\n  box-shadow: 0 0 0 0 rgba(42.6666666667%, 50%, 97.6666666667%, 0.5);\n}\n.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(26.0392156863%, 32.9411764706%, 77.8039215686%);\n  border-color: rgb(24.4117647059%, 30.8823529412%, 72.9411764706%);\n}\n.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(42.6666666667%, 50%, 97.6666666667%, 0.5);\n}\n.btn-primary:disabled, .btn-primary.disabled {\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(36%, 39%, 41.6666666667%);\n  border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n}\n.btn-check:focus + .btn-secondary, .btn-secondary:focus {\n  color: #fff;\n  background-color: rgb(36%, 39%, 41.6666666667%);\n  border-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);\n}\n.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(33.8823529412%, 36.7058823529%, 39.2156862745%);\n  border-color: rgb(31.7647058824%, 34.4117647059%, 36.7647058824%);\n}\n.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(51%, 54%, 56.6666666667%, 0.5);\n}\n.btn-secondary:disabled, .btn-secondary.disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #43d39e;\n  border-color: #43d39e;\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: rgb(22.3333333333%, 70.3333333333%, 52.6666666667%);\n  border-color: rgb(21.0196078431%, 66.1960784314%, 49.568627451%);\n}\n.btn-check:focus + .btn-success, .btn-success:focus {\n  color: #fff;\n  background-color: rgb(22.3333333333%, 70.3333333333%, 52.6666666667%);\n  border-color: rgb(21.0196078431%, 66.1960784314%, 49.568627451%);\n  box-shadow: 0 0 0 0 rgba(37.3333333333%, 85.3333333333%, 67.6666666667%, 0.5);\n}\n.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(21.0196078431%, 66.1960784314%, 49.568627451%);\n  border-color: rgb(19.7058823529%, 62.0588235294%, 46.4705882353%);\n}\n.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(37.3333333333%, 85.3333333333%, 67.6666666667%, 0.5);\n}\n.btn-success:disabled, .btn-success.disabled {\n  color: #fff;\n  background-color: #43d39e;\n  border-color: #43d39e;\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #25c2e3;\n  border-color: #25c2e3;\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: rgb(12.3333333333%, 64.6666666667%, 75.6666666667%);\n  border-color: rgb(11.6078431373%, 60.862745098%, 71.2156862745%);\n}\n.btn-check:focus + .btn-info, .btn-info:focus {\n  color: #fff;\n  background-color: rgb(12.3333333333%, 64.6666666667%, 75.6666666667%);\n  border-color: rgb(11.6078431373%, 60.862745098%, 71.2156862745%);\n  box-shadow: 0 0 0 0 rgba(27.3333333333%, 79.6666666667%, 90.6666666667%, 0.5);\n}\n.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(11.6078431373%, 60.862745098%, 71.2156862745%);\n  border-color: rgb(10.8823529412%, 57.0588235294%, 66.7647058824%);\n}\n.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(27.3333333333%, 79.6666666667%, 90.6666666667%, 0.5);\n}\n.btn-info:disabled, .btn-info.disabled {\n  color: #fff;\n  background-color: #25c2e3;\n  border-color: #25c2e3;\n}\n\n.btn-warning {\n  color: #343a40;\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.btn-warning:hover {\n  color: #343a40;\n  background-color: rgb(100%, 78.3333333333%, 18.6666666667%);\n  border-color: rgb(100%, 77.0588235294%, 13.8823529412%);\n}\n.btn-check:focus + .btn-warning, .btn-warning:focus {\n  color: #343a40;\n  background-color: rgb(100%, 78.3333333333%, 18.6666666667%);\n  border-color: rgb(100%, 77.0588235294%, 13.8823529412%);\n  box-shadow: 0 0 0 0 rgba(88.0588235294%, 66.7450980392%, 7.431372549%, 0.5);\n}\n.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {\n  color: #343a40;\n  background-color: rgb(100%, 79.6078431373%, 23.4509803922%);\n  border-color: rgb(100%, 77.0588235294%, 13.8823529412%);\n}\n.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(88.0588235294%, 66.7450980392%, 7.431372549%, 0.5);\n}\n.btn-warning:disabled, .btn-warning.disabled {\n  color: #343a40;\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #ff5c75;\n  border-color: #ff5c75;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(85%, 30.6666666667%, 39%);\n  border-color: rgb(80%, 28.862745098%, 36.7058823529%);\n}\n.btn-check:focus + .btn-danger, .btn-danger:focus {\n  color: #fff;\n  background-color: rgb(85%, 30.6666666667%, 39%);\n  border-color: rgb(80%, 28.862745098%, 36.7058823529%);\n  box-shadow: 0 0 0 0 rgba(100%, 45.6666666667%, 54%, 0.5);\n}\n.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(80%, 28.862745098%, 36.7058823529%);\n  border-color: rgb(75%, 27.0588235294%, 34.4117647059%);\n}\n.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(100%, 45.6666666667%, 54%, 0.5);\n}\n.btn-danger:disabled, .btn-danger.disabled {\n  color: #fff;\n  background-color: #ff5c75;\n  border-color: #ff5c75;\n}\n\n.btn-light {\n  color: #343a40;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.btn-light:hover {\n  color: #343a40;\n  background-color: rgb(97.6666666667%, 98%, 98.3333333333%);\n  border-color: rgb(97.5294117647%, 97.8823529412%, 98.2352941176%);\n}\n.btn-check:focus + .btn-light, .btn-light:focus {\n  color: #343a40;\n  background-color: rgb(97.6666666667%, 98%, 98.3333333333%);\n  border-color: rgb(97.5294117647%, 97.8823529412%, 98.2352941176%);\n  box-shadow: 0 0 0 0 rgba(85.7254901961%, 86.4117647059%, 87.0980392157%, 0.5);\n}\n.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {\n  color: #343a40;\n  background-color: rgb(97.8039215686%, 98.1176470588%, 98.431372549%);\n  border-color: rgb(97.5294117647%, 97.8823529412%, 98.2352941176%);\n}\n.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(85.7254901961%, 86.4117647059%, 87.0980392157%, 0.5);\n}\n.btn-light:disabled, .btn-light.disabled {\n  color: #343a40;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(17.3333333333%, 19.3333333333%, 21.3333333333%);\n  border-color: rgb(16.3137254902%, 18.1960784314%, 20.0784313725%);\n}\n.btn-check:focus + .btn-dark, .btn-dark:focus {\n  color: #fff;\n  background-color: rgb(17.3333333333%, 19.3333333333%, 21.3333333333%);\n  border-color: rgb(16.3137254902%, 18.1960784314%, 20.0784313725%);\n  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);\n}\n.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(16.3137254902%, 18.1960784314%, 20.0784313725%);\n  border-color: rgb(15.2941176471%, 17.0588235294%, 18.8235294118%);\n}\n.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(32.3333333333%, 34.3333333333%, 36.3333333333%, 0.5);\n}\n.btn-dark:disabled, .btn-dark.disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-outline-primary {\n  color: #5369f8;\n  border-color: #5369f8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);\n}\n.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);\n}\n.btn-outline-primary:disabled, .btn-outline-primary.disabled {\n  color: #5369f8;\n  background-color: transparent;\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n\n.btn-outline-success {\n  color: #43d39e;\n  border-color: #43d39e;\n}\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #43d39e;\n  border-color: #43d39e;\n}\n.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {\n  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);\n}\n.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {\n  color: #fff;\n  background-color: #43d39e;\n  border-color: #43d39e;\n}\n.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);\n}\n.btn-outline-success:disabled, .btn-outline-success.disabled {\n  color: #43d39e;\n  background-color: transparent;\n}\n\n.btn-outline-info {\n  color: #25c2e3;\n  border-color: #25c2e3;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #25c2e3;\n  border-color: #25c2e3;\n}\n.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {\n  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);\n}\n.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {\n  color: #fff;\n  background-color: #25c2e3;\n  border-color: #25c2e3;\n}\n.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);\n}\n.btn-outline-info:disabled, .btn-outline-info.disabled {\n  color: #25c2e3;\n  background-color: transparent;\n}\n\n.btn-outline-warning {\n  color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.btn-outline-warning:hover {\n  color: #343a40;\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {\n  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);\n}\n.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {\n  color: #343a40;\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);\n}\n.btn-outline-warning:disabled, .btn-outline-warning.disabled {\n  color: #ffbe0b;\n  background-color: transparent;\n}\n\n.btn-outline-danger {\n  color: #ff5c75;\n  border-color: #ff5c75;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #ff5c75;\n  border-color: #ff5c75;\n}\n.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {\n  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);\n}\n.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {\n  color: #fff;\n  background-color: #ff5c75;\n  border-color: #ff5c75;\n}\n.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);\n}\n.btn-outline-danger:disabled, .btn-outline-danger.disabled {\n  color: #ff5c75;\n  background-color: transparent;\n}\n\n.btn-outline-light {\n  color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.btn-outline-light:hover {\n  color: #343a40;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {\n  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);\n}\n.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {\n  color: #343a40;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);\n}\n.btn-outline-light:disabled, .btn-outline-light.disabled {\n  color: #f8f9fa;\n  background-color: transparent;\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark:disabled, .btn-outline-dark.disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #5369f8;\n  text-decoration: none;\n}\n.btn-link:hover {\n  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);\n  text-decoration: none;\n}\n.btn-link:focus {\n  text-decoration: none;\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #6c757d;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.09375rem;\n  border-radius: 0.25rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.28rem 0.8rem;\n  font-size: 0.7875rem;\n  border-radius: 0.25rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-menu {\n  position: absolute;\n  z-index: 1000;\n  display: none;\n  min-width: 10rem;\n  padding: 0.25rem 0;\n  margin: 0;\n  font-size: 0.875rem;\n  color: #4B4B5A;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n  border-radius: 0.25rem;\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: 0.125rem;\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.75rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e2e7f1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 1.2rem;\n  clear: both;\n  font-weight: 400;\n  color: #4B4B5A;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: rgb(26.4705882353%, 26.4705882353%, 31.7647058824%);\n  background-color: #f8f9fa;\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #343a40;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.25rem 1.2rem;\n  margin-bottom: 0;\n  font-size: 0.7875rem;\n  color: inherit;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.375rem 1.2rem;\n  color: #4B4B5A;\n}\n\n.dropdown-menu-dark {\n  color: #e2e7f1;\n  background-color: #343a40;\n  border-color: rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n}\n.dropdown-menu-dark .dropdown-item {\n  color: #e2e7f1;\n}\n.dropdown-menu-dark .dropdown-item:hover, .dropdown-menu-dark .dropdown-item:focus {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n.dropdown-menu-dark .dropdown-item.active, .dropdown-menu-dark .dropdown-item:active {\n  color: #343a40;\n  background-color: #f8f9fa;\n}\n.dropdown-menu-dark .dropdown-item.disabled, .dropdown-menu-dark .dropdown-item:disabled {\n  color: #adb5bd;\n}\n.dropdown-menu-dark .dropdown-divider {\n  border-color: #e2e7f1;\n}\n.dropdown-menu-dark .dropdown-item-text {\n  color: #e2e7f1;\n}\n.dropdown-menu-dark .dropdown-header {\n  color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.675rem;\n  padding-left: 0.675rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.6rem;\n  padding-left: 0.6rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n  color: #5369f8;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);\n}\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 0px solid #e2e7f1;\n}\n.nav-tabs .nav-link {\n  margin-bottom: -0px;\n  background: none;\n  border: 0px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: #f6f6f7 #f6f6f7 #e2e7f1;\n  isolation: isolate;\n}\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #4B4B5A;\n  background-color: #fff;\n  border-color: #e2e7f1 #e2e7f1 #fff;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -0px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: 0.25rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #5369f8;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 0.75rem;\n  padding-right: 1.5rem;\n  padding-bottom: 0.75rem;\n  padding-left: 1.5rem;\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: 0.3359375rem;\n  padding-bottom: 0.3359375rem;\n  margin-right: 1rem;\n  font-size: 1.09375rem;\n  white-space: nowrap;\n}\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.09375rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  transition: box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 0;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    transition: none;\n    transform: none;\n  }\n  .navbar-expand-sm .offcanvas-top,\n  .navbar-expand-sm .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .navbar-expand-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    transition: none;\n    transform: none;\n  }\n  .navbar-expand-md .offcanvas-top,\n  .navbar-expand-md .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .navbar-expand-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    transition: none;\n    transform: none;\n  }\n  .navbar-expand-lg .offcanvas-top,\n  .navbar-expand-lg .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .navbar-expand-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    transition: none;\n    transform: none;\n  }\n  .navbar-expand-xl .offcanvas-top,\n  .navbar-expand-xl .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .navbar-expand-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: inherit;\n    bottom: 0;\n    z-index: 1000;\n    flex-grow: 1;\n    visibility: visible !important;\n    background-color: transparent;\n    border-right: 0;\n    border-left: 0;\n    transition: none;\n    transform: none;\n  }\n  .navbar-expand-xxl .offcanvas-top,\n  .navbar-expand-xxl .offcanvas-bottom {\n    height: auto;\n    border-top: 0;\n    border-bottom: 0;\n  }\n  .navbar-expand-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: inherit;\n  bottom: 0;\n  z-index: 1000;\n  flex-grow: 1;\n  visibility: visible !important;\n  background-color: transparent;\n  border-right: 0;\n  border-left: 0;\n  transition: none;\n  transform: none;\n}\n.navbar-expand .offcanvas-top,\n.navbar-expand .offcanvas-bottom {\n  height: auto;\n  border-top: 0;\n  border-bottom: 0;\n}\n.navbar-expand .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-light .navbar-brand {\n  color: #5369f8;\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: #5369f8;\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .nav-link.active {\n  color: #5369f8;\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.55);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-text a,\n.navbar-light .navbar-text a:hover,\n.navbar-light .navbar-text a:focus {\n  color: #5369f8;\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.55);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-text a,\n.navbar-dark .navbar-text a:hover,\n.navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid #e2e7f1;\n  border-radius: 0.25rem;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1.25rem 1.25rem;\n}\n\n.card-title {\n  margin-bottom: 0.75rem;\n}\n\n.card-subtitle {\n  margin-top: -0.375rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: 1.25rem;\n}\n\n.card-header {\n  padding: 1rem 1.25rem;\n  margin-bottom: 0;\n  background-color: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);\n  border-bottom: 1px solid #e2e7f1;\n}\n.card-header:first-child {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 1rem 1.25rem;\n  background-color: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);\n  border-top: 1px solid #e2e7f1;\n}\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.625rem;\n  margin-bottom: -1rem;\n  margin-left: -0.625rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.625rem;\n  margin-left: -0.625rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-group > .card {\n  margin-bottom: 12px;\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 1.25rem;\n  font-size: 0.875rem;\n  color: #4B4B5A;\n  text-align: left;\n  background-color: #f3f4f7;\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: rgb(29.2941176471%, 37.0588235294%, 87.5294117647%);\n  background-color: rgb(93.2549019608%, 94.1176470588%, 99.7254901961%);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2829.2941176471%, 37.0588235294%, 87.5294117647%%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  transform: rotate(-180deg);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-left: auto;\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%234B4B5A'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-size: 1.25rem;\n  transition: transform 0.2s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n  outline: 0;\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  background-color: #f3f4f7;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.accordion-body {\n  padding: 1rem 1.25rem;\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button {\n  border-radius: 0;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 1.005rem 0;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: transparent;\n  border-radius: 0.25rem;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #adb5bd;\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: #343a40;\n  background-color: #fff;\n  border: 1px solid #e2e7f1;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: #343a40;\n  background-color: #f6f6f7;\n  border-color: #e2e7f1;\n}\n.page-link:focus {\n  z-index: 3;\n  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);\n  background-color: #f6f6f7;\n  outline: 0;\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.page-item.disabled .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n  border-color: #e2e7f1;\n}\n\n.page-link {\n  padding: 0.5rem 0.75rem;\n}\n\n.page-item:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.09375rem;\n}\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.7875rem;\n}\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.25em 0.4em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 3.75rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 0.9375rem 1.25rem;\n}\n\n.alert-primary {\n  color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);\n  background-color: rgb(86.5098039216%, 88.2352941176%, 99.4509803922%);\n  border-color: rgb(81.1137254902%, 83.5294117647%, 99.231372549%);\n}\n.alert-primary .alert-link {\n  color: rgb(15.6235294118%, 19.7647058824%, 46.6823529412%);\n}\n\n.alert-secondary {\n  color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);\n  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n  border-color: rgb(83.8588235294%, 84.8470588235%, 85.7254901961%);\n}\n.alert-secondary .alert-link {\n  color: rgb(20.3294117647%, 22.0235294118%, 23.5294117647%);\n}\n\n.alert-success {\n  color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);\n  background-color: rgb(85.2549019608%, 96.5490196078%, 92.3921568627%);\n  border-color: rgb(79.3568627451%, 95.168627451%, 89.3490196078%);\n}\n.alert-success .alert-link {\n  color: rgb(12.6117647059%, 39.7176470588%, 29.7411764706%);\n}\n\n.alert-info {\n  color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);\n  background-color: rgb(82.9019607843%, 95.2156862745%, 97.8039215686%);\n  border-color: rgb(76.062745098%, 93.3019607843%, 96.9254901961%);\n}\n.alert-info .alert-link {\n  color: rgb(6.9647058824%, 36.5176470588%, 42.7294117647%);\n}\n\n.alert-warning {\n  color: rgb(60%, 44.7058823529%, 2.5882352941%);\n  background-color: rgb(100%, 94.9019607843%, 80.862745098%);\n  border-color: rgb(100%, 92.862745098%, 73.2078431373%);\n}\n.alert-warning .alert-link {\n  color: rgb(48%, 35.7647058824%, 2.0705882353%);\n}\n\n.alert-danger {\n  color: rgb(60%, 21.6470588235%, 27.5294117647%);\n  background-color: rgb(100%, 87.2156862745%, 89.1764705882%);\n  border-color: rgb(100%, 82.1019607843%, 84.8470588235%);\n}\n.alert-danger .alert-link {\n  color: rgb(48%, 17.3176470588%, 22.0235294118%);\n}\n\n.alert-light {\n  color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);\n  background-color: rgb(99.4509803922%, 99.5294117647%, 99.6078431373%);\n  border-color: rgb(99.231372549%, 99.3411764706%, 99.4509803922%);\n}\n.alert-light .alert-link {\n  color: rgb(46.6823529412%, 46.8705882353%, 47.0588235294%);\n}\n\n.alert-dark {\n  color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);\n  background-color: rgb(84.0784313725%, 84.5490196078%, 85.0196078431%);\n  border-color: rgb(77.7098039216%, 78.368627451%, 79.0274509804%);\n}\n.alert-dark .alert-link {\n  color: rgb(9.7882352941%, 10.9176470588%, 12.0470588235%);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 0.75rem;\n  }\n}\n.progress {\n  display: flex;\n  height: 0.75rem;\n  overflow: hidden;\n  font-size: 0.65625rem;\n  background-color: rgb(96.0460556316%, 96.7277701778%, 98.0911992704%);\n  border-radius: 0.25rem;\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #5369f8;\n  transition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 0.75rem 0.75rem;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.25rem;\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > li::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #4B4B5A;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #4B4B5A;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n.list-group-item-action:active {\n  color: #4B4B5A;\n  background-color: #f6f6f7;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  color: #212529;\n  background-color: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 1px;\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);\n  background-color: rgb(86.5098039216%, 88.2352941176%, 99.4509803922%);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);\n  background-color: rgb(77.8588235294%, 79.4117647059%, 89.5058823529%);\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);\n  border-color: rgb(19.5294117647%, 24.7058823529%, 58.3529411765%);\n}\n\n.list-group-item-secondary {\n  color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);\n  background-color: rgb(88.4705882353%, 89.1764705882%, 89.8039215686%);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);\n  background-color: rgb(79.6235294118%, 80.2588235294%, 80.8235294118%);\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);\n  border-color: rgb(25.4117647059%, 27.5294117647%, 29.4117647059%);\n}\n\n.list-group-item-success {\n  color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);\n  background-color: rgb(85.2549019608%, 96.5490196078%, 92.3921568627%);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);\n  background-color: rgb(76.7294117647%, 86.8941176471%, 83.1529411765%);\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);\n  border-color: rgb(15.7647058824%, 49.6470588235%, 37.1764705882%);\n}\n\n.list-group-item-info {\n  color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);\n  background-color: rgb(82.9019607843%, 95.2156862745%, 97.8039215686%);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);\n  background-color: rgb(74.6117647059%, 85.6941176471%, 88.0235294118%);\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);\n  border-color: rgb(8.7058823529%, 45.6470588235%, 53.4117647059%);\n}\n\n.list-group-item-warning {\n  color: rgb(60%, 44.7058823529%, 2.5882352941%);\n  background-color: rgb(100%, 94.9019607843%, 80.862745098%);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: rgb(60%, 44.7058823529%, 2.5882352941%);\n  background-color: rgb(90%, 85.4117647059%, 72.7764705882%);\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(60%, 44.7058823529%, 2.5882352941%);\n  border-color: rgb(60%, 44.7058823529%, 2.5882352941%);\n}\n\n.list-group-item-danger {\n  color: rgb(60%, 21.6470588235%, 27.5294117647%);\n  background-color: rgb(100%, 87.2156862745%, 89.1764705882%);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: rgb(60%, 21.6470588235%, 27.5294117647%);\n  background-color: rgb(90%, 78.4941176471%, 80.2588235294%);\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(60%, 21.6470588235%, 27.5294117647%);\n  border-color: rgb(60%, 21.6470588235%, 27.5294117647%);\n}\n\n.list-group-item-light {\n  color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);\n  background-color: rgb(99.4509803922%, 99.5294117647%, 99.6078431373%);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);\n  background-color: rgb(89.5058823529%, 89.5764705882%, 89.6470588235%);\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);\n  border-color: rgb(58.3529411765%, 58.5882352941%, 58.8235294118%);\n}\n\n.list-group-item-dark {\n  color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);\n  background-color: rgb(84.0784313725%, 84.5490196078%, 85.0196078431%);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);\n  background-color: rgb(75.6705882353%, 76.0941176471%, 76.5176470588%);\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);\n  border-color: rgb(12.2352941176%, 13.6470588235%, 15.0588235294%);\n}\n\n.btn-close {\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: #000;\n  background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.25rem;\n  opacity: 0.5;\n}\n.btn-close:hover {\n  color: #000;\n  text-decoration: none;\n  opacity: 0.75;\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.25);\n  opacity: 1;\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.25;\n}\n\n.btn-close-white {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n  width: 350px;\n  max-width: 100%;\n  font-size: 0.875rem;\n  pointer-events: auto;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  border-radius: 0.25rem;\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: 12px;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.25rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.toast-header .btn-close {\n  margin-right: -0.375rem;\n  margin-left: 0.75rem;\n}\n\n.toast-body {\n  padding: 0.75rem;\n  word-wrap: break-word;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1055;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.fade .modal-dialog {\n  transform: translate(0, -50px);\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid transparent;\n  border-radius: 0.2rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  width: 100vw;\n  height: 100vh;\n  background-color: #212529;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 0 solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);\n  border-top-left-radius: 0.2rem;\n  border-top-right-radius: 0.2rem;\n}\n.modal-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  border-top: 0 solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);\n  border-bottom-right-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1080;\n  display: block;\n  margin: 0;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 0.9;\n}\n.tooltip .tooltip-arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.4rem 0.8rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.2rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0 /* rtl:ignore */;\n  z-index: 1070;\n  display: block;\n  max-width: 276px;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.7875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #e2e7f1;\n  border-radius: 0.25rem;\n}\n.popover .popover-arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-0.5rem - 1px);\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #e2e7f1;\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #e2e7f1;\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-0.5rem - 1px);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #e2e7f1;\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #f8f9fa;\n}\n\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #e2e7f1;\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.7rem 0.8rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e2e7f1;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.7rem 0.8rem;\n  color: #4B4B5A;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: 0.75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    animation-duration: 1.5s;\n  }\n}\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: 1045;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  visibility: hidden;\n  background-color: #fff;\n  background-clip: padding-box;\n  outline: 0;\n  transition: transform 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #212529;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n}\n.offcanvas-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin-top: -0.5rem;\n  margin-right: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: 1rem 1rem;\n  overflow-y: auto;\n}\n\n.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: 400px;\n  border-right: 0 solid transparent;\n  transform: translateX(-100%);\n}\n\n.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: 400px;\n  border-left: 0 solid transparent;\n  transform: translateX(100%);\n}\n\n.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-bottom: 0 solid transparent;\n  transform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-top: 0 solid transparent;\n  transform: translateY(100%);\n}\n\n.offcanvas.show {\n  transform: none;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentColor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.link-primary {\n  color: #5369f8;\n}\n.link-primary:hover, .link-primary:focus {\n  color: rgb(27.6666666667%, 35%, 82.6666666667%);\n}\n\n.link-secondary {\n  color: #6c757d;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: rgb(36%, 39%, 41.6666666667%);\n}\n\n.link-success {\n  color: #43d39e;\n}\n.link-success:hover, .link-success:focus {\n  color: rgb(22.3333333333%, 70.3333333333%, 52.6666666667%);\n}\n\n.link-info {\n  color: #25c2e3;\n}\n.link-info:hover, .link-info:focus {\n  color: rgb(12.3333333333%, 64.6666666667%, 75.6666666667%);\n}\n\n.link-warning {\n  color: #ffbe0b;\n}\n.link-warning:hover, .link-warning:focus {\n  color: rgb(100%, 78.3333333333%, 18.6666666667%);\n}\n\n.link-danger {\n  color: #ff5c75;\n}\n.link-danger:hover, .link-danger:focus {\n  color: rgb(85%, 30.6666666667%, 39%);\n}\n\n.link-light {\n  color: #f8f9fa;\n}\n.link-light:hover, .link-light:focus {\n  color: rgb(97.6666666667%, 98%, 98.3333333333%);\n}\n\n.link-dark {\n  color: #343a40;\n}\n.link-dark:hover, .link-dark:focus {\n  color: rgb(17.3333333333%, 19.3333333333%, 21.3333333333%);\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentColor;\n  opacity: 1;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #5369f8 !important;\n}\n\n.border-secondary {\n  border-color: #6c757d !important;\n}\n\n.border-success {\n  border-color: #43d39e !important;\n}\n\n.border-info {\n  border-color: #25c2e3 !important;\n}\n\n.border-warning {\n  border-color: #ffbe0b !important;\n}\n\n.border-danger {\n  border-color: #ff5c75 !important;\n}\n\n.border-light {\n  border-color: #f8f9fa !important;\n}\n\n.border-dark {\n  border-color: #343a40 !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.375rem !important;\n}\n\n.gap-2 {\n  gap: 0.75rem !important;\n}\n\n.gap-3 {\n  gap: 1.5rem !important;\n}\n\n.gap-4 {\n  gap: 2.25rem !important;\n}\n\n.gap-5 {\n  gap: 4.5rem !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.375rem !important;\n}\n\n.m-2 {\n  margin: 0.75rem !important;\n}\n\n.m-3 {\n  margin: 1.5rem !important;\n}\n\n.m-4 {\n  margin: 2.25rem !important;\n}\n\n.m-5 {\n  margin: 4.5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.375rem !important;\n  margin-left: 0.375rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-3 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-4 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-5 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.375rem !important;\n  margin-bottom: 0.375rem !important;\n}\n\n.my-2 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-3 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-4 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-5 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.375rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-3 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-4 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-5 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.375rem !important;\n}\n\n.me-2 {\n  margin-right: 0.75rem !important;\n}\n\n.me-3 {\n  margin-right: 1.5rem !important;\n}\n\n.me-4 {\n  margin-right: 2.25rem !important;\n}\n\n.me-5 {\n  margin-right: 4.5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.375rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.375rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-3 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-4 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-5 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.375rem !important;\n}\n\n.m-n2 {\n  margin: -0.75rem !important;\n}\n\n.m-n3 {\n  margin: -1.5rem !important;\n}\n\n.m-n4 {\n  margin: -2.25rem !important;\n}\n\n.m-n5 {\n  margin: -4.5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.375rem !important;\n  margin-left: -0.375rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n3 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n4 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n5 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.375rem !important;\n  margin-bottom: -0.375rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n3 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n4 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n5 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.375rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n3 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n4 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n5 {\n  margin-top: -4.5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.375rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n3 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n4 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n5 {\n  margin-right: -4.5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.375rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.375rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n3 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n4 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n5 {\n  margin-left: -4.5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.375rem !important;\n}\n\n.p-2 {\n  padding: 0.75rem !important;\n}\n\n.p-3 {\n  padding: 1.5rem !important;\n}\n\n.p-4 {\n  padding: 2.25rem !important;\n}\n\n.p-5 {\n  padding: 4.5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.375rem !important;\n  padding-left: 0.375rem !important;\n}\n\n.px-2 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-3 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-4 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-5 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.375rem !important;\n  padding-bottom: 0.375rem !important;\n}\n\n.py-2 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-3 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-4 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-5 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.375rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-3 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-4 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-5 {\n  padding-top: 4.5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.375rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-3 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-4 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-5 {\n  padding-right: 4.5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.375rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 4.5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.375rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-3 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-4 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-5 {\n  padding-left: 4.5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.3125rem + 0.75vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.125rem !important;\n}\n\n.fs-5 {\n  font-size: 0.9375rem !important;\n}\n\n.fs-6 {\n  font-size: 0.9rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.5 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 1.5 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: #6c757d !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: 0.2rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-end {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: 0.25rem !important;\n  border-top-left-radius: 0.25rem !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-sm-5 {\n    gap: 4.5rem !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.375rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.75rem !important;\n  }\n  .m-sm-3 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-4 {\n    margin: 2.25rem !important;\n  }\n  .m-sm-5 {\n    margin: 4.5rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-sm-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.375rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.75rem !important;\n  }\n  .p-sm-3 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-4 {\n    padding: 2.25rem !important;\n  }\n  .p-sm-5 {\n    padding: 4.5rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 4.5rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-md-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-md-5 {\n    gap: 4.5rem !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.375rem !important;\n  }\n  .m-md-2 {\n    margin: 0.75rem !important;\n  }\n  .m-md-3 {\n    margin: 1.5rem !important;\n  }\n  .m-md-4 {\n    margin: 2.25rem !important;\n  }\n  .m-md-5 {\n    margin: 4.5rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-md-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-md-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-md-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-md-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.375rem !important;\n  }\n  .p-md-2 {\n    padding: 0.75rem !important;\n  }\n  .p-md-3 {\n    padding: 1.5rem !important;\n  }\n  .p-md-4 {\n    padding: 2.25rem !important;\n  }\n  .p-md-5 {\n    padding: 4.5rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-md-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-md-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 4.5rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-lg-5 {\n    gap: 4.5rem !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.375rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.75rem !important;\n  }\n  .m-lg-3 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-4 {\n    margin: 2.25rem !important;\n  }\n  .m-lg-5 {\n    margin: 4.5rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-lg-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.375rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.75rem !important;\n  }\n  .p-lg-3 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-4 {\n    padding: 2.25rem !important;\n  }\n  .p-lg-5 {\n    padding: 4.5rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 4.5rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-xl-5 {\n    gap: 4.5rem !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.375rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.75rem !important;\n  }\n  .m-xl-3 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-4 {\n    margin: 2.25rem !important;\n  }\n  .m-xl-5 {\n    margin: 4.5rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-xl-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.375rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.75rem !important;\n  }\n  .p-xl-3 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-4 {\n    padding: 2.25rem !important;\n  }\n  .p-xl-5 {\n    padding: 4.5rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 4.5rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.375rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.75rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 2.25rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 4.5rem !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.375rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.75rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-4 {\n    margin: 2.25rem !important;\n  }\n  .m-xxl-5 {\n    margin: 4.5rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.375rem !important;\n    margin-left: 0.375rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.375rem !important;\n    margin-bottom: 0.375rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.375rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.375rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.375rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.375rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.375rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.75rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -2.25rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -4.5rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.375rem !important;\n    margin-left: -0.375rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.375rem !important;\n    margin-bottom: -0.375rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.375rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -4.5rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.375rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.375rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.375rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -4.5rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.375rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.75rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-4 {\n    padding: 2.25rem !important;\n  }\n  .p-xxl-5 {\n    padding: 4.5rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.375rem !important;\n    padding-left: 0.375rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.375rem !important;\n    padding-bottom: 0.375rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.375rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 4.5rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.375rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.375rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 4.5rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.375rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 4.5rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.25rem !important;\n  }\n  .fs-2 {\n    font-size: 1.875rem !important;\n  }\n  .fs-3 {\n    font-size: 1.5rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n.custom-accordionwitharrow .card + .card {\n  margin-top: 0.5rem;\n}\n.custom-accordionwitharrow .card .card-header {\n  background-color: transparent;\n}\n.custom-accordionwitharrow .accordion-arrow {\n  font-size: 1.2rem;\n  margin-top: -5px;\n}\n.custom-accordionwitharrow a.collapsed i.accordion-arrow:before {\n  content: \"\\e831\";\n}\n\n.custom-accordion .card {\n  overflow: visible;\n  border-color: transparent !important;\n  border-left: 2px dashed #e2e7f1 !important;\n  box-shadow: none;\n  padding-left: 24px;\n  margin-left: 10px;\n}\n.custom-accordion .card .card-header {\n  border-radius: 7px !important;\n}\n.custom-accordion .card .card-header:before {\n  content: \"\";\n  position: absolute;\n  left: 5px;\n  top: 22px;\n  width: 25px;\n  height: 2px;\n  background: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);\n}\n.custom-accordion .card .icon {\n  position: absolute;\n  left: -18px;\n  top: -2px;\n  background-color: #fff;\n  border-radius: 50%;\n  margin-right: 1px;\n}\n\n.badge-soft-primary {\n  color: #5369f8;\n  background-color: rgba(83, 105, 248, 0.18);\n  box-shadow: none;\n}\n\n.badge-soft-secondary {\n  color: #6c757d;\n  background-color: rgba(108, 117, 125, 0.18);\n  box-shadow: none;\n}\n\n.badge-soft-success {\n  color: #43d39e;\n  background-color: rgba(67, 211, 158, 0.18);\n  box-shadow: none;\n}\n\n.badge-soft-info {\n  color: #25c2e3;\n  background-color: rgba(37, 194, 227, 0.18);\n  box-shadow: none;\n}\n\n.badge-soft-warning {\n  color: #ffbe0b;\n  background-color: rgba(255, 190, 11, 0.18);\n  box-shadow: none;\n}\n\n.badge-soft-danger {\n  color: #ff5c75;\n  background-color: rgba(255, 92, 117, 0.18);\n  box-shadow: none;\n}\n\n.badge-soft-light {\n  color: #f8f9fa;\n  background-color: rgba(248, 249, 250, 0.18);\n  box-shadow: none;\n}\n\n.badge-soft-dark {\n  color: #343a40;\n  background-color: rgba(52, 58, 64, 0.18);\n  box-shadow: none;\n}\n\n.badge-outline-primary {\n  color: #5369f8;\n  border: 1px solid #5369f8;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-outline-secondary {\n  color: #6c757d;\n  border: 1px solid #6c757d;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-outline-success {\n  color: #43d39e;\n  border: 1px solid #43d39e;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-outline-info {\n  color: #25c2e3;\n  border: 1px solid #25c2e3;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-outline-warning {\n  color: #ffbe0b;\n  border: 1px solid #ffbe0b;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-outline-danger {\n  color: #ff5c75;\n  border: 1px solid #ff5c75;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-outline-light {\n  color: #f8f9fa;\n  border: 1px solid #f8f9fa;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.badge-outline-dark {\n  color: #343a40;\n  border: 1px solid #343a40;\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.bg-soft-primary {\n  background-color: rgba(83, 105, 248, 0.25) !important;\n}\n\n.bg-soft-secondary {\n  background-color: rgba(108, 117, 125, 0.25) !important;\n}\n\n.bg-soft-success {\n  background-color: rgba(67, 211, 158, 0.25) !important;\n}\n\n.bg-soft-info {\n  background-color: rgba(37, 194, 227, 0.25) !important;\n}\n\n.bg-soft-warning {\n  background-color: rgba(255, 190, 11, 0.25) !important;\n}\n\n.bg-soft-danger {\n  background-color: rgba(255, 92, 117, 0.25) !important;\n}\n\n.bg-soft-light {\n  background-color: rgba(248, 249, 250, 0.25) !important;\n}\n\n.bg-soft-dark {\n  background-color: rgba(52, 58, 64, 0.25) !important;\n}\n\n.bg-ghost {\n  opacity: 0.4;\n}\n\n.breadcrumb-item > a {\n  color: #4B4B5A;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  font-family: \"unicons\";\n}\n\n.btn {\n  color: #fff;\n}\n.btn:focus {\n  box-shadow: none;\n}\n.btn .icon svg {\n  width: 1rem;\n  height: 1rem;\n  margin-left: 0.1rem;\n  margin-top: -2px;\n}\n\n.btn-light, .btn-white {\n  color: #212529;\n}\n\n.btn-white {\n  border-color: #e2e7f1;\n}\n.btn-white:hover, .btn-white:focus {\n  background-color: #e2e7f1;\n  border-color: #ced4da;\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #5369f8;\n  background-color: transparent;\n}\n.btn-link:hover {\n  color: rgb(3.9029466535%, 16.1693504217%, 95.9009749151%);\n  text-decoration: none;\n  background-color: transparent;\n  border-color: transparent;\n}\n.btn-link:focus {\n  text-decoration: none;\n  border-color: transparent;\n  box-shadow: none;\n}\n.btn-link:disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n\n.btn-xs {\n  padding: 0.2rem 0.6rem;\n  font-size: 0.75rem;\n  border-radius: 0.15rem;\n}\n\n.btn-soft-primary {\n  background-color: rgba(83, 105, 248, 0.15);\n  color: #5369f8;\n  border-color: rgba(83, 105, 248, 0.15);\n}\n.btn-soft-primary:focus {\n  box-shadow: none;\n}\n.btn-soft-primary:hover, .btn-soft-primary:focus {\n  background-color: rgba(83, 105, 248, 0.2);\n  color: #5369f8;\n}\n\n.btn-soft-secondary {\n  background-color: rgba(108, 117, 125, 0.15);\n  color: #6c757d;\n  border-color: rgba(108, 117, 125, 0.15);\n}\n.btn-soft-secondary:focus {\n  box-shadow: none;\n}\n.btn-soft-secondary:hover, .btn-soft-secondary:focus {\n  background-color: rgba(108, 117, 125, 0.2);\n  color: #6c757d;\n}\n\n.btn-soft-success {\n  background-color: rgba(67, 211, 158, 0.15);\n  color: #43d39e;\n  border-color: rgba(67, 211, 158, 0.15);\n}\n.btn-soft-success:focus {\n  box-shadow: none;\n}\n.btn-soft-success:hover, .btn-soft-success:focus {\n  background-color: rgba(67, 211, 158, 0.2);\n  color: #43d39e;\n}\n\n.btn-soft-info {\n  background-color: rgba(37, 194, 227, 0.15);\n  color: #25c2e3;\n  border-color: rgba(37, 194, 227, 0.15);\n}\n.btn-soft-info:focus {\n  box-shadow: none;\n}\n.btn-soft-info:hover, .btn-soft-info:focus {\n  background-color: rgba(37, 194, 227, 0.2);\n  color: #25c2e3;\n}\n\n.btn-soft-warning {\n  background-color: rgba(255, 190, 11, 0.15);\n  color: #ffbe0b;\n  border-color: rgba(255, 190, 11, 0.15);\n}\n.btn-soft-warning:focus {\n  box-shadow: none;\n}\n.btn-soft-warning:hover, .btn-soft-warning:focus {\n  background-color: rgba(255, 190, 11, 0.2);\n  color: #ffbe0b;\n}\n\n.btn-soft-danger {\n  background-color: rgba(255, 92, 117, 0.15);\n  color: #ff5c75;\n  border-color: rgba(255, 92, 117, 0.15);\n}\n.btn-soft-danger:focus {\n  box-shadow: none;\n}\n.btn-soft-danger:hover, .btn-soft-danger:focus {\n  background-color: rgba(255, 92, 117, 0.2);\n  color: #ff5c75;\n}\n\n.btn-soft-light {\n  background-color: rgba(248, 249, 250, 0.15);\n  color: #f8f9fa;\n  border-color: rgba(248, 249, 250, 0.15);\n}\n.btn-soft-light:focus {\n  box-shadow: none;\n}\n.btn-soft-light:hover, .btn-soft-light:focus {\n  background-color: rgba(248, 249, 250, 0.2);\n  color: #f8f9fa;\n}\n\n.btn-soft-dark {\n  background-color: rgba(52, 58, 64, 0.15);\n  color: #343a40;\n  border-color: rgba(52, 58, 64, 0.15);\n}\n.btn-soft-dark:focus {\n  box-shadow: none;\n}\n.btn-soft-dark:hover, .btn-soft-dark:focus {\n  background-color: rgba(52, 58, 64, 0.2);\n  color: #343a40;\n}\n\n.btn-outline-primary {\n  color: #5369f8;\n  border-color: #5369f8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);\n}\n.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(83, 105, 248, 0.5);\n}\n.btn-outline-primary:disabled, .btn-outline-primary.disabled {\n  color: #5369f8;\n  background-color: transparent;\n}\n.btn-outline-primary:focus {\n  box-shadow: none;\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n.btn-outline-secondary:focus {\n  box-shadow: none;\n}\n\n.btn-outline-success {\n  color: #43d39e;\n  border-color: #43d39e;\n}\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #43d39e;\n  border-color: #43d39e;\n}\n.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {\n  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);\n}\n.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {\n  color: #fff;\n  background-color: #43d39e;\n  border-color: #43d39e;\n}\n.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(67, 211, 158, 0.5);\n}\n.btn-outline-success:disabled, .btn-outline-success.disabled {\n  color: #43d39e;\n  background-color: transparent;\n}\n.btn-outline-success:focus {\n  box-shadow: none;\n}\n\n.btn-outline-info {\n  color: #25c2e3;\n  border-color: #25c2e3;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #25c2e3;\n  border-color: #25c2e3;\n}\n.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {\n  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);\n}\n.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {\n  color: #fff;\n  background-color: #25c2e3;\n  border-color: #25c2e3;\n}\n.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(37, 194, 227, 0.5);\n}\n.btn-outline-info:disabled, .btn-outline-info.disabled {\n  color: #25c2e3;\n  background-color: transparent;\n}\n.btn-outline-info:focus {\n  box-shadow: none;\n}\n\n.btn-outline-warning {\n  color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.btn-outline-warning:hover {\n  color: #343a40;\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {\n  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);\n}\n.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {\n  color: #343a40;\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(255, 190, 11, 0.5);\n}\n.btn-outline-warning:disabled, .btn-outline-warning.disabled {\n  color: #ffbe0b;\n  background-color: transparent;\n}\n.btn-outline-warning:focus {\n  box-shadow: none;\n}\n\n.btn-outline-danger {\n  color: #ff5c75;\n  border-color: #ff5c75;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #ff5c75;\n  border-color: #ff5c75;\n}\n.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {\n  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);\n}\n.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {\n  color: #fff;\n  background-color: #ff5c75;\n  border-color: #ff5c75;\n}\n.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(255, 92, 117, 0.5);\n}\n.btn-outline-danger:disabled, .btn-outline-danger.disabled {\n  color: #ff5c75;\n  background-color: transparent;\n}\n.btn-outline-danger:focus {\n  box-shadow: none;\n}\n\n.btn-outline-light {\n  color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.btn-outline-light:hover {\n  color: #343a40;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {\n  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);\n}\n.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {\n  color: #343a40;\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);\n}\n.btn-outline-light:disabled, .btn-outline-light.disabled {\n  color: #f8f9fa;\n  background-color: transparent;\n}\n.btn-outline-light:focus {\n  box-shadow: none;\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark:disabled, .btn-outline-dark.disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n.btn-outline-dark:focus {\n  box-shadow: none;\n}\n\n.card {\n  margin-bottom: 24px;\n}\n\n.card-link + .card-link {\n  /*rtl:ignore*/\n  margin-left: 1.25rem;\n  /*rtl:ignore*/\n  margin-right: 0;\n}\n\n.card-drop {\n  font-size: 20px;\n  line-height: 0;\n  color: inherit;\n}\n\n.card-widgets {\n  float: right;\n  height: 16px;\n}\n.card-widgets > a {\n  color: inherit;\n  font-size: 18px;\n  display: inline-block;\n  line-height: 1;\n}\n.card-widgets > a.collapsed i:before {\n  content: \"\\f0415\";\n}\n\n.card-title,\n.card-header {\n  margin-top: 0;\n}\n\n.card-disabled {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-radius: 0.25rem;\n  background: rgba(255, 255, 255, 0.8);\n  cursor: progress;\n}\n.card-disabled .card-portlets-loader {\n  background-color: #3e4852;\n  animation: rotatebox 1.2s infinite ease-in-out;\n  height: 30px;\n  width: 30px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  border-radius: 3px;\n  margin-left: -12px;\n  margin-top: -12px;\n}\n\n@keyframes rotatebox {\n  0% {\n    transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n  }\n  50% {\n    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n  }\n  100% {\n    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n  }\n}\n.card-box {\n  background-color: #fff;\n  padding: 1.25rem;\n  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075);\n  margin-bottom: 24px;\n  border-radius: 0.25rem;\n}\n\n.header-title {\n  font-size: 15px;\n  margin: 0 0 7px 0;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.sub-header {\n  font-size: 0.875rem;\n  margin-bottom: 24px;\n  color: #6c757d;\n}\n\n.dropdown-menu {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  animation-name: DropDownSlide;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  font-size: 0.875rem;\n  top: 100%;\n}\n.dropdown-menu.show {\n  top: 100% !important;\n}\n.dropdown-menu i {\n  display: inline-block;\n}\n\n.dropdown-menu-end {\n  right: 0 !important;\n  left: auto !important;\n}\n\n.dropdown-menu[data-popper-placement^=right],\n.dropdown-menu[data-popper-placement^=top],\n.dropdown-menu[data-popper-placement^=left] {\n  top: auto !important;\n  animation: none !important;\n}\n\n@keyframes DropDownSlide {\n  100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n  0% {\n    -webkit-transform: translateY(-10px);\n    transform: translateY(-10px);\n  }\n}\n@media (min-width: 600px) {\n  .dropdown-lg {\n    width: 320px;\n  }\n}\n.dropdown-icon-item {\n  display: block;\n  border-radius: 3px;\n  line-height: 34px;\n  text-align: center;\n  padding: 15px 0 9px;\n  display: block;\n  border: 1px solid transparent;\n  color: #4B4B5A;\n}\n.dropdown-icon-item img {\n  height: 24px;\n}\n.dropdown-icon-item span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dropdown-icon-item:hover {\n  background-color: #f8f9fa;\n}\n\n@media (min-width: 992px) {\n  .dropdown-mega-menu-xl {\n    width: 40rem;\n  }\n  .dropdown-mega-menu-lg {\n    width: 26rem;\n  }\n}\n.form-control::placeholder {\n  color: rgb(63.0941176471%, 66.0117647059%, 68.9294117647%);\n}\n\n.form-control-light {\n  background-color: #f3f7f9 !important;\n  border-color: #f3f7f9 !important;\n}\n\ninput.form-control[type=color],\ninput.form-control[type=range] {\n  min-height: 39px;\n}\n\n.custom-select.is-invalid:focus, .form-control.is-invalid:focus, .custom-select:invalid:focus, .form-control:invalid:focus,\n.custom-select.is-valid:focus, .form-control.is-valid:focus, .custom-select:valid:focus, .form-control:valid:focus {\n  box-shadow: none !important;\n}\n\n.comment-area-box .form-control {\n  border-color: #e2e7f1;\n  border-radius: 0.25rem 0.25rem 0 0;\n}\n.comment-area-box .comment-area-btn {\n  background-color: #f8f9fa;\n  padding: 10px;\n  border: 1px solid #e2e7f1;\n  border-top: none;\n  border-radius: 0 0 0.25rem 0.25rem;\n}\n\n.search-bar .form-control {\n  padding-left: 40px;\n  padding-right: 20px;\n  border-radius: 30px;\n}\n.search-bar span {\n  position: absolute;\n  z-index: 10;\n  font-size: 16px;\n  line-height: calc(1.5em + 0.9rem + 2px);\n  left: 13px;\n  top: -2px;\n  color: #6c757d;\n}\n\n.password-eye:before {\n  font-family: feather !important;\n  content: \"\\e86a\";\n  font-style: normal;\n  font-weight: 400;\n  font-variant: normal;\n  vertical-align: middle;\n  line-height: 1.2;\n  font-size: 16px;\n}\n\n.show-password .password-eye:before {\n  content: \"\\e86e\";\n}\n\n.modal-title {\n  margin-top: 0;\n}\n\n.modal-full-width {\n  width: 95%;\n  max-width: none;\n}\n\n.modal-top {\n  margin: 0 auto;\n}\n\n.modal-right {\n  position: absolute;\n  right: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  height: 100%;\n  margin: 0;\n  background-color: #fff;\n  align-content: center;\n  transform: translate(25%, 0) !important;\n}\n.modal-right button.close {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1;\n}\n\n.modal.show .modal-right {\n  transform: translate(0, 0) !important;\n}\n\n.modal-bottom {\n  display: flex;\n  flex-flow: column nowrap;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  height: 100%;\n  margin: 0 auto;\n  align-content: center;\n}\n\n.modal-colored-header {\n  color: #fff;\n  border-radius: 0;\n}\n.modal-colored-header .close {\n  color: #fff !important;\n}\n\n.nav-tabs {\n  border-bottom: 2px solid rgba(108, 117, 125, 0.2);\n}\n.nav-tabs .nav-item {\n  margin-bottom: -2px;\n}\n.nav-tabs .nav-link {\n  cursor: pointer;\n  outline: none;\n}\n.nav-tabs li a {\n  border-color: transparent !important;\n  padding: 0.625rem 1.25rem;\n}\n.nav-tabs li a.active {\n  border-bottom: 2px solid #5369f8 !important;\n}\n\n.nav-tabs > li > a, .nav-pills > li > a {\n  color: #4B4B5A;\n  font-weight: 700;\n}\n\n.nav-pills {\n  background: #f3f4f7;\n  border-radius: 0.25rem;\n  padding: 6px 2px;\n}\n.nav-pills .nav-link {\n  background-color: transparent;\n  color: #4B4B5A;\n  outline: none;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #4B4B5A;\n  background-color: #fff;\n  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075);\n}\n\n.navtab-bg li > a {\n  background-color: #e2e7f1;\n}\n\n.tab-content {\n  padding: 20px 0 0 0;\n}\n\n@media only screen and (max-width: 991px) {\n  .hederSection {\n    justify-content: center !important;\n  }\n}\n.pagination-rounded .page-link {\n  border-radius: 30px !important;\n  margin: 0 3px;\n  border: none;\n}\n\n.popover-header {\n  margin-top: 0;\n}\n\n.progress-sm {\n  height: 5px;\n}\n\n.progress-md {\n  height: 8px;\n}\n\n.progress-lg {\n  height: 12px;\n}\n\n.progress-xl {\n  height: 15px;\n}\n\n/* Progressbar Vertical */\n.progress-vertical {\n  min-height: 250px;\n  height: 250px;\n  width: 10px;\n  position: relative;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n}\n.progress-vertical .progress-bar {\n  width: 100%;\n}\n.progress-vertical.progress-xl {\n  width: 15px;\n}\n.progress-vertical.progress-lg {\n  width: 12px;\n}\n.progress-vertical.progress-md {\n  width: 8px;\n}\n.progress-vertical.progress-sm {\n  width: 5px;\n}\n\n.progress-vertical-bottom {\n  min-height: 250px;\n  height: 250px;\n  position: relative;\n  width: 10px;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n}\n.progress-vertical-bottom .progress-bar {\n  width: 100%;\n  bottom: 0;\n  position: absolute;\n}\n.progress-vertical-bottom.progress-xl {\n  width: 15px;\n}\n.progress-vertical-bottom.progress-lg {\n  width: 12px;\n}\n.progress-vertical-bottom.progress-md {\n  width: 8px;\n}\n.progress-vertical-bottom.progress-sm {\n  width: 5px;\n}\n\nbody {\n  padding-right: 0px !important;\n  padding-left: 0px !important;\n}\nbody.loading {\n  visibility: hidden;\n  opacity: 0;\n}\n\nlabel {\n  font-weight: 700;\n}\n\nbutton:focus {\n  outline: none;\n}\n\n.row > * {\n  position: relative;\n}\n\na:focus {\n  outline: none;\n}\n\nth {\n  font-weight: 700;\n}\n\n.table-centered td, .table-centered th {\n  vertical-align: middle !important;\n}\n\n.table-nowrap th, .table-nowrap td {\n  white-space: nowrap;\n}\n\n.table .table-user img {\n  height: 30px;\n  width: 30px;\n}\n\n.action-icon {\n  color: #6c757d;\n  font-size: 1.2rem;\n  display: inline-block;\n  padding: 0 3px;\n}\n.action-icon:hover {\n  color: #4B4B5A;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 10px 0;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  color: #343a40;\n}\n\n.fs-11 {\n  font-size: 11px !important;\n}\n\n.fs-12 {\n  font-size: 12px !important;\n}\n\n.fs-13 {\n  font-size: 13px !important;\n}\n\n.fs-14 {\n  font-size: 14px !important;\n}\n\n.fs-15 {\n  font-size: 15px !important;\n}\n\n.fs-16 {\n  font-size: 16px !important;\n}\n\n.fs-17 {\n  font-size: 17px !important;\n}\n\n.fs-18 {\n  font-size: 18px !important;\n}\n\n.fs-19 {\n  font-size: 19px !important;\n}\n\n.fs-20 {\n  font-size: 20px !important;\n}\n\n.fs-22 {\n  font-size: 22px !important;\n}\n\n.fs-24 {\n  font-size: 24px !important;\n}\n\n.fw-medium {\n  font-weight: 500;\n}\n\n.fw-semibold {\n  font-weight: 600;\n}\n\n.text-unline-dashed {\n  border-bottom: #ced4da 1px dashed !important;\n  padding-bottom: 1px;\n}\n\n/*\nTemplate Name: Shreyu - Responsive Bootstrap 5 Admin Dashboard\nAuthor: CoderThemes\nVersion: 2.0.0\nWebsite: https://coderthemes.com/\nContact: support@coderthemes.com\nFile: Main Css File\n*/\niframe#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n#wrapper {\n  height: 100%;\n  overflow: hidden;\n  width: 100%;\n}\n\n.content-page {\n  margin-left: 250px;\n  overflow: hidden;\n  padding: 0 15px 65px 15px;\n  min-height: 80vh;\n  margin-top: 70px;\n}\n\n.left-side-menu {\n  width: 250px;\n  background: linear-gradient(180deg, #020b18 0%, #031024 45%, #051329 100%) !important;\n  border-right: 1px solid #0a1f3d !important;\n  bottom: 0;\n  padding: 0 0 30px 0;\n  position: fixed;\n  transition: all 0.1s ease-out;\n  top: 70px;\n  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);\n  z-index: 1000;\n}\n.left-side-menu .simplebar-scrollbar:before {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.sidebar-inner-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.sidebar-mobile-brand {\n  padding: 12px 14px;\n  background: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 8px;\n}\n.sidebar-mobile-brand .sidebar-brand-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none !important;\n}\n.sidebar-mobile-brand .sidebar-brand-mascot {\n  height: 44px;\n  width: auto;\n  object-fit: contain;\n}\n.sidebar-mobile-brand .sidebar-brand-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.15;\n}\n.sidebar-mobile-brand .sidebar-brand-title {\n  font-weight: 800;\n  font-size: 17px;\n  color: #0b3558;\n}\n.sidebar-mobile-brand .sidebar-brand-subtitle {\n  font-weight: 700;\n  font-size: 10px;\n  color: #0284c7;\n}\n\n.sidebar-portal-badge-wrap {\n  padding: 16px 14px 8px 14px;\n}\n\n.sidebar-portal-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(14, 38, 77, 0.75);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  border-radius: 9999px;\n  padding: 4px 12px;\n}\n.sidebar-portal-badge .sidebar-badge-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background-color: #22c55e;\n  box-shadow: 0 0 8px #22c55e;\n  flex-shrink: 0;\n}\n.sidebar-portal-badge .sidebar-badge-text {\n  color: #60a5fa;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.sidebar-entity-card {\n  margin: 4px 14px 16px 14px;\n  padding: 10px 12px;\n  background: #081a36;\n  border: 1px solid rgba(59, 130, 246, 0.22);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.sidebar-entity-card .sidebar-entity-icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: #0d2850;\n  border: 1px solid rgba(59, 130, 246, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #60a5fa;\n  flex-shrink: 0;\n}\n.sidebar-entity-card .sidebar-entity-icon svg {\n  width: 18px;\n  height: 18px;\n}\n.sidebar-entity-card .sidebar-entity-info {\n  overflow: hidden;\n  flex: 1;\n  min-width: 0;\n}\n.sidebar-entity-card .sidebar-entity-name {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 13px;\n  line-height: 1.25;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-transform: uppercase;\n  letter-spacing: 0.2px;\n}\n.sidebar-entity-card .sidebar-entity-code {\n  color: #64748b;\n  font-size: 10.5px;\n  font-weight: 500;\n  margin-top: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#sidebar-menu > ul.side-menu {\n  list-style: none;\n  padding: 0 12px 24px 12px;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item {\n  position: relative;\n  list-style: none;\n  border: none !important;\n  background: transparent !important;\n  margin: 0;\n  padding: 0;\n  border-radius: 12px;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item > a,\n#sidebar-menu > ul.side-menu > li.side-nav-item > .side-sub-nav-link {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  padding: 8px 12px !important;\n  border-radius: 12px !important;\n  color: #94a3b8 !important;\n  font-size: 13.5px !important;\n  font-weight: 500 !important;\n  text-decoration: none !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  position: relative !important;\n  background: transparent !important;\n  border: none !important;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item > a:hover,\n#sidebar-menu > ul.side-menu > li.side-nav-item > .side-sub-nav-link:hover {\n  background: rgba(255, 255, 255, 0.06) !important;\n  color: #ffffff !important;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item > a:hover .menu-icon-box,\n#sidebar-menu > ul.side-menu > li.side-nav-item > .side-sub-nav-link:hover .menu-icon-box {\n  background: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.18) !important;\n  color: #ffffff !important;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active,\n#sidebar-menu > ul.side-menu > li.side-nav-item > a.active {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;\n  color: #ffffff !important;\n  font-weight: 600 !important;\n  box-shadow: 0 4px 18px -2px rgba(37, 99, 235, 0.5) !important;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a .active-indicator-pill, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active .active-indicator-pill,\n#sidebar-menu > ul.side-menu > li.side-nav-item > a.active .active-indicator-pill {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4.5px;\n  height: 24px;\n  background: #ffffff;\n  border-radius: 0 4px 4px 0;\n  z-index: 2;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a .menu-icon-box, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active .menu-icon-box,\n#sidebar-menu > ul.side-menu > li.side-nav-item > a.active .menu-icon-box {\n  background: rgba(255, 255, 255, 0.22) !important;\n  border-color: rgba(255, 255, 255, 0.35) !important;\n  color: #ffffff !important;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item.item-active > a .menu-icon-box svg, #sidebar-menu > ul.side-menu > li.side-nav-item.menuitem-active > a.active .menu-icon-box svg,\n#sidebar-menu > ul.side-menu > li.side-nav-item > a.active .menu-icon-box svg {\n  color: #ffffff !important;\n  stroke: #ffffff !important;\n}\n#sidebar-menu > ul.side-menu > li.side-nav-item ul {\n  padding-left: 20px;\n  list-style: none;\n}\n#sidebar-menu .badge {\n  margin-top: 2px;\n}\n#sidebar-menu .menu-title {\n  padding: 14px 14px 6px;\n  letter-spacing: 0.08em;\n  pointer-events: none;\n  cursor: default;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  color: #475569;\n  font-weight: 700;\n}\n\n.menu-icon-box {\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  flex-shrink: 0;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #94a3b8;\n  transition: all 0.2s ease;\n}\n.menu-icon-box svg {\n  width: 17px;\n  height: 17px;\n  stroke-width: 2;\n  fill: none !important;\n}\n\n.menu-item-text {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 13.5px;\n  font-weight: inherit;\n}\n\n.nav-second-level {\n  padding: 4px 0 6px 36px;\n  list-style: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.nav-second-level li a {\n  padding: 6px 10px !important;\n  color: #94a3b8 !important;\n  display: block;\n  position: relative;\n  transition: all 0.2s;\n  font-size: 13px !important;\n  border-radius: 8px !important;\n}\n.nav-second-level li a:focus, .nav-second-level li a:hover {\n  color: #ffffff !important;\n  background: rgba(255, 255, 255, 0.05) !important;\n}\n.nav-second-level li.active > a, .nav-second-level li.menuitem-active > a {\n  color: #60a5fa !important;\n  background: rgba(37, 99, 235, 0.15) !important;\n  font-weight: 600 !important;\n}\n\n.menu-arrow {\n  transition: transform 0.15s;\n  display: inline-block;\n  font-family: \"unicons\";\n  text-rendering: auto;\n  font-size: 1rem;\n  transform: translate(0, 0);\n}\n.menu-arrow::before {\n  content: \"\\e82f\";\n}\n\n[dir=rtl] .menu-arrow::before {\n  content: \"\\e82e\";\n}\n\nli > a[aria-expanded=true] > span.menu-arrow {\n  transform: rotate(90deg);\n}\nli.menuitem-active > a:not(.collapsed) > span.menu-arrow {\n  transform: rotate(90deg);\n}\n\nbody[data-sidebar-size=condensed] .logo-box {\n  width: 70px !important;\n  text-align: center;\n}\n@media (max-width: 991.98px) {\n  body[data-sidebar-size=condensed] .logo-box {\n    padding-left: 0 !important;\n  }\n}\nbody[data-sidebar-size=condensed] .logo span.logo-lg {\n  display: none;\n}\nbody[data-sidebar-size=condensed] .logo span.logo-sm {\n  display: block;\n}\nbody[data-sidebar-size=condensed] .left-side-menu {\n  position: absolute;\n  padding-top: 0;\n  width: 70px !important;\n  z-index: 5;\n}\nbody[data-sidebar-size=condensed] .left-side-menu .simplebar-mask,\nbody[data-sidebar-size=condensed] .left-side-menu .simplebar-content-wrapper {\n  overflow: visible !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu .simplebar-scrollbar {\n  display: none !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu .simplebar-offset {\n  bottom: 0 !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .menu-title,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .menu-arrow,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .label,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .badge,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .collapse.in {\n  display: none !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu .nav.collapse {\n  height: inherit !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li {\n  position: relative;\n  white-space: nowrap;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a {\n  padding: 15px 20px;\n  min-height: 54px;\n  transition: none;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a:hover, body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a:active, body[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a:focus {\n  color: #5369f8;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a i {\n  font-size: 1.3rem;\n  margin-right: 20px;\n  margin-left: 5px;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a svg {\n  width: 18px;\n  height: 18px;\n  margin-left: 6px;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li > a span {\n  display: none;\n  padding-left: 25px;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > a {\n  position: relative;\n  width: calc(190px + 70px);\n  color: #5369f8;\n  background-color: #f8f9fa;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > a span {\n  display: inline;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover a.open :after,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover a.active :after {\n  display: none;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing {\n  display: block !important;\n  height: auto !important;\n  transition: none !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul {\n  display: block !important;\n  left: 70px;\n  position: absolute;\n  width: 190px;\n  box-shadow: 3px 5px 10px 0 rgba(154, 161, 171, 0.2);\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul ul,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul ul {\n  box-shadow: 3px 5px 10px 0 rgba(154, 161, 171, 0.2);\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul a,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul a {\n  box-shadow: none;\n  padding: 8px 20px;\n  position: relative;\n  width: 190px;\n  z-index: 6;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapse > ul a:hover,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul > li:hover > .collapsing > ul a:hover {\n  color: #5369f8;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul .collapsing {\n  display: block !important;\n  height: auto !important;\n  transition: none !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul {\n  padding: 5px 0;\n  z-index: 9999;\n  display: none;\n  background-color: #ffffff;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapse,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapsing {\n  display: block !important;\n  height: auto !important;\n  transition: none !important;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapse > ul,\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li:hover > .collapsing > ul {\n  display: block;\n  left: 190px;\n  margin-top: -36px;\n  position: absolute;\n  width: 190px;\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li > a span.pull-right {\n  position: absolute;\n  right: 20px;\n  top: 12px;\n  transform: rotate(270deg);\n}\nbody[data-sidebar-size=condensed] .left-side-menu #sidebar-menu > ul ul li.active a {\n  color: #5369f8;\n}\nbody[data-sidebar-size=condensed] .content-page {\n  margin-left: 70px !important;\n}\n@media (min-width: 992px) {\n  body[data-sidebar-size=condensed] .footer {\n    left: 70px !important;\n  }\n}\nbody[data-sidebar-size=condensed] .user-box {\n  display: none !important;\n}\n\n@media (min-width: 768px) {\n  body[data-sidebar-size=condensed]:not([data-layout=compact]) {\n    min-height: 1750px;\n  }\n  body.authentication-bg {\n    min-height: auto !important;\n  }\n}\n@media (max-width: 575.98px) {\n  .pro-user-name {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  body {\n    overflow-x: hidden;\n    padding-bottom: 80px;\n  }\n  .left-side-menu {\n    display: none;\n    z-index: 10 !important;\n  }\n  .sidebar-enable .left-side-menu {\n    display: block;\n  }\n  .content-page,\n  body[data-sidebar-size=condensed] .content-page {\n    margin-left: 0 !important;\n    padding: 0 10px;\n  }\n  .footer {\n    left: 0 !important;\n  }\n}\n/* =============\n  Small Menu\n============= */\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .logo-box {\n  width: 160px !important;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu {\n  width: 160px !important;\n  text-align: center;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul > li > a > i {\n  display: block;\n  font-size: 18px;\n  line-height: 24px;\n  width: 100%;\n  margin: 0;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul > li > a svg {\n  display: block;\n  margin: 0 auto 5px auto;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul ul {\n  padding-left: 0;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu #sidebar-menu > ul ul a {\n  padding: 10px 20px;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu .menu-arrow,\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu .badge {\n  display: none !important;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu + .content-page {\n  margin-left: 160px;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu + .content-page .footer {\n  left: 160px;\n}\nbody[data-sidebar-size=compact]:not([data-sidebar-size=condensed]) .left-side-menu .menu-title {\n  background-color: #f8f9fa;\n}\n\nbody[data-sidebar-color=dark] .logo-box {\n  background-color: #ffffff !important;\n  border-right: 1px solid #e2e8f0 !important;\n}\nbody[data-sidebar-color=dark] .left-side-menu {\n  background: linear-gradient(180deg, #020b18 0%, #031024 45%, #051329 100%) !important;\n  border-right-color: #0a1f3d !important;\n  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);\n}\nbody[data-sidebar-color=dark][data-sidebar-size=condensed] #wrapper .left-side-menu #sidebar-menu > ul > li:hover > a {\n  background-color: #323742;\n  box-shadow: none;\n}\nbody[data-sidebar-color=dark][data-sidebar-size=condensed] #wrapper .left-side-menu #sidebar-menu .menuitem-active .active {\n  color: #5369f8;\n}\nbody[data-sidebar-color=dark][data-sidebar-size=compact] #wrapper .left-side-menu .menu-title {\n  background-color: rgba(255, 255, 255, 0.03);\n}\n\n.user-box {\n  display: none;\n}\n\n.user-pro-dropdown {\n  padding: 15px 5px !important;\n  width: 90%;\n  margin-left: 5%;\n  margin-top: 10px;\n}\n.user-pro-dropdown .dropdown-item {\n  border-radius: 3px;\n}\n\nbody[data-layout-mode=detached] .logo-box {\n  background-color: transparent !important;\n}\n@media (min-width: 992px) {\n  body[data-layout-mode=detached] .navbar-custom .container-fluid, body[data-layout-mode=detached] .navbar-custom .container-sm, body[data-layout-mode=detached] .navbar-custom .container-md, body[data-layout-mode=detached] .navbar-custom .container-lg, body[data-layout-mode=detached] .navbar-custom .container-xl, body[data-layout-mode=detached] .navbar-custom .container-xxl {\n    max-width: 95%;\n  }\n  body[data-layout-mode=detached] #wrapper {\n    max-width: 95%;\n    margin: 0 auto;\n  }\n  body[data-layout-mode=detached] .left-side-menu {\n    margin-top: 30px;\n    margin-bottom: 30px;\n    border-radius: 5px;\n    border: 1px solid #e2e7f1;\n  }\n  body[data-layout-mode=detached] .content-page {\n    padding-bottom: 30px;\n  }\n  body[data-layout-mode=detached] .logo-box {\n    background-color: transparent;\n    background-image: none;\n  }\n}\n\nbody[data-sidebar-showuser=true] .user-box {\n  display: block;\n}\n\n.logo {\n  display: block;\n}\n.logo span.logo-lg {\n  display: block;\n}\n.logo span.logo-sm {\n  display: none;\n}\n.logo .logo-lg-text-dark {\n  color: #343a40;\n  font-weight: 700;\n  font-size: 22px;\n  text-transform: uppercase;\n}\n.logo .logo-lg-text-light {\n  color: #fff;\n  font-weight: 700;\n  font-size: 22px;\n  text-transform: uppercase;\n}\n\n/* Default height for the logo */\n.logo Img {\n  height: 80px;\n}\n\n/* Media query for smaller screens */\n@media screen and (max-width: 768px) {\n  .logo Img {\n    height: 60px; /* Adjust the height for smaller screens */\n  }\n}\n/* Media query for even smaller screens */\n@media screen and (max-width: 576px) {\n  .logo Img {\n    height: 40px; /* Adjust the height for even smaller screens */\n  }\n}\n@media screen and (max-width: 376px) {\n  .logo Img {\n    height: 35px; /* Adjust the height for even smaller screens */\n  }\n}\n.logo-box {\n  height: 70px;\n  width: 250px;\n  float: left;\n  transition: all 0.1s ease-out;\n  padding: 0 14px;\n  background: #ffffff !important;\n  border-right: 1px solid #e2e8f0;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  z-index: 1002;\n}\n.logo-box .sidebar-brand-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none !important;\n  width: 100%;\n  overflow: hidden;\n}\n.logo-box .sidebar-brand-mascot {\n  height: 50px;\n  width: auto;\n  max-width: 50px;\n  object-fit: contain;\n  flex-shrink: 0;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));\n}\n.logo-box .sidebar-brand-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 1.15;\n  overflow: hidden;\n}\n.logo-box .sidebar-brand-title {\n  font-weight: 800;\n  font-size: 18px;\n  color: #0b3558;\n  letter-spacing: -0.2px;\n  white-space: nowrap;\n}\n.logo-box .sidebar-brand-subtitle {\n  font-weight: 700;\n  font-size: 10.5px;\n  color: #0284c7;\n  letter-spacing: 0px;\n  white-space: nowrap;\n}\n.logo-box .sidebar-brand-icon-only {\n  display: none;\n}\n.logo-box .sidebar-brand-combo-img {\n  height: 58px;\n  width: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\nbody[data-sidebar-size=condensed] .logo-box .sidebar-brand-combo {\n  display: none !important;\n}\nbody[data-sidebar-size=condensed] .logo-box .sidebar-brand-icon-only {\n  display: block !important;\n}\n\n.topbar-district-contact {\n  height: 70px;\n  gap: 8px;\n  padding: 0 12px;\n  line-height: 1.15;\n}\n.topbar-district-contact__icon {\n  color: #60a5fa;\n}\n.topbar-district-contact__icon-link {\n  color: inherit;\n  cursor: pointer;\n}\n.topbar-district-contact__text {\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.topbar-district-contact__designation {\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  color: rgba(255, 255, 255, 0.55);\n}\n.topbar-district-contact__detail {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #ffffff;\n  text-decoration: none;\n}\n.topbar-district-contact__detail:hover {\n  text-decoration: underline;\n}\n.topbar-district-contact__detail a {\n  color: inherit;\n  text-decoration: none;\n}\n.topbar-district-contact__detail a:hover {\n  text-decoration: underline;\n}\n.topbar-district-contact--mobile {\n  gap: 6px;\n  padding: 0 8px;\n  max-width: 50vw;\n}\n.topbar-district-contact--mobile .topbar-district-contact__designation {\n  font-size: 0.55rem;\n}\n.topbar-district-contact--mobile .topbar-district-contact__detail {\n  font-size: 0.72rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media (max-width: 991.98px) {\n  .topbar-district-contact--mobile {\n    position: absolute;\n    left: 50%;\n    top: 0;\n    transform: translateX(-50%);\n  }\n}\nbody[data-topbar-color=light] .topbar-district-contact__icon {\n  color: #f77707;\n}\nbody[data-topbar-color=light] .topbar-district-contact__designation {\n  color: rgba(0, 0, 0, 0.5);\n}\nbody[data-topbar-color=light] .topbar-district-contact__detail {\n  color: #1e293b;\n}\n\n.navbar-custom {\n  background-color: #323742;\n  padding: 0 10px 0 0;\n  position: fixed;\n  left: 0;\n  right: 0;\n  height: 70px;\n  border-bottom: 1px solid #323742;\n  z-index: 1001;\n}\n.navbar-custom .topnav-menu > li {\n  float: left;\n}\n.navbar-custom .topnav-menu .nav-link {\n  padding: 0 12px;\n  color: rgba(255, 255, 255, 0.6);\n  min-width: 32px;\n  display: block;\n  line-height: 70px;\n  text-align: center;\n  max-height: 70px;\n}\n.navbar-custom .topnav-menu .nav-link svg {\n  height: 20px;\n  width: 20px;\n  color: rgba(255, 255, 255, 0.6);\n  fill: rgba(255, 255, 255, 0.12);\n}\n.navbar-custom .topnav-menu .nav-link:hover svg, .navbar-custom .topnav-menu .nav-link:focus svg, .navbar-custom .topnav-menu .nav-link:active svg {\n  color: #5369f8;\n  fill: rgba(83, 105, 248, 0.1);\n}\n.navbar-custom .container-fluid, .navbar-custom .container-sm, .navbar-custom .container-md, .navbar-custom .container-lg, .navbar-custom .container-xl, .navbar-custom .container-xxl {\n  padding: 0;\n}\n.navbar-custom {\n  /* Search */\n}\n.navbar-custom .app-search {\n  height: 70px;\n  display: grid;\n  width: 180px;\n  margin-right: 20px;\n  align-items: center;\n}\n.navbar-custom .app-search .react-select__placeholder,\n.navbar-custom .app-search input::placeholder {\n  font-size: 0.8125rem;\n  color: rgba(255, 255, 255, 0.3);\n  margin: 0;\n}\n.navbar-custom .app-search .react-select__menu {\n  overflow: hidden;\n  width: 320px !important;\n  margin-top: 0;\n}\n.navbar-custom .app-search .react-select__input,\n.navbar-custom .app-search .react-select__value-container {\n  color: #fff !important;\n  padding: 0;\n}\n.navbar-custom .app-search .form-control,\n.navbar-custom .app-search .react-select__control {\n  border: none;\n  height: 38px;\n  padding-left: 20px;\n  padding-right: 0;\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.07);\n  box-shadow: none;\n}\n.navbar-custom .app-search .input-group-text {\n  margin-left: 0 !important;\n  z-index: 4;\n}\n.navbar-custom .app-search .btn {\n  border-color: transparent;\n  color: rgba(255, 255, 255, 0.3);\n  border-radius: 0 30px 30px 0;\n  box-shadow: none !important;\n}\n.navbar-custom .button-menu-mobile {\n  border: none;\n  color: #fff;\n  display: inline-block;\n  height: 70px;\n  line-height: 70px;\n  width: 60px;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n.navbar-custom .button-menu-mobile.disable-btn {\n  display: none;\n}\n\n/* Notification */\n.noti-scroll {\n  max-height: 230px;\n}\n\n.notification-list {\n  margin-left: 0;\n}\n.notification-list .noti-title {\n  background-color: transparent;\n  padding: 15px 20px;\n}\n.notification-list .noti-icon-badge {\n  display: inline-block;\n  position: absolute;\n  top: 14px;\n  right: 8px;\n}\n.notification-list .notify-item {\n  padding: 12px 20px;\n}\n.notification-list .notify-item .notify-icon {\n  float: left;\n  height: 36px;\n  width: 36px;\n  line-height: 36px;\n  text-align: center;\n  margin-right: 10px;\n  border-radius: 50%;\n  color: #fff;\n}\n.notification-list .notify-item .notify-details {\n  margin-bottom: 5px;\n  overflow: hidden;\n  margin-left: 45px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #343a40;\n}\n.notification-list .notify-item .notify-details b {\n  font-weight: 500;\n}\n.notification-list .notify-item .notify-details small, .notification-list .notify-item .notify-details .small {\n  display: block;\n}\n.notification-list .notify-item .notify-details span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n}\n.notification-list .notify-item .user-msg {\n  margin-left: 45px;\n  white-space: normal;\n  line-height: 16px;\n}\n.notification-list .profile-dropdown .notify-item {\n  padding: 7px 20px;\n}\n\n.noti-icon {\n  font-size: 21px;\n  vertical-align: middle;\n}\n\n.profile-dropdown {\n  min-width: 170px !important;\n}\n.profile-dropdown i {\n  vertical-align: middle;\n  margin-right: 5px;\n}\n\n.nav-user {\n  padding: 0 12px !important;\n}\n.nav-user img {\n  height: 32px;\n  width: 32px;\n}\n\n@media (max-width: 991.98px) {\n  .logo-box {\n    width: 70px !important;\n    padding-right: 0 !important;\n    border-bottom: 1px solid #e2e7f1;\n  }\n  .logo-box .logo-lg {\n    display: none !important;\n  }\n  .logo-box .logo-sm {\n    display: block !important;\n  }\n  .logo-box {\n    display: none !important;\n  }\n}\n@media (max-width: 600px) {\n  .navbar-custom .dropdown {\n    position: static;\n  }\n  .navbar-custom .dropdown .dropdown-menu {\n    left: 10px !important;\n    right: 10px !important;\n  }\n}\nbody[data-topbar-color=light] .navbar-custom {\n  background-color: #ffffff !important;\n  border-bottom: 1px solid #e2e7f1;\n}\nbody[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link {\n  color: #343a40;\n}\nbody[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link svg {\n  color: #343a40;\n  fill: rgba(52, 58, 64, 0.12);\n}\nbody[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link:hover svg, body[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link:focus svg, body[data-topbar-color=light] .navbar-custom .topnav-menu .nav-link:active svg {\n  color: #5369f8;\n  fill: rgba(83, 105, 248, 0.1);\n}\nbody[data-topbar-color=light] .navbar-custom .button-menu-mobile {\n  color: #343a40;\n}\nbody[data-topbar-color=light] .navbar-custom {\n  /* Search */\n}\nbody[data-topbar-color=light] .navbar-custom .app-search .react-select__placeholder,\nbody[data-topbar-color=light] .navbar-custom .app-search input::placeholder {\n  color: #adb5bd !important;\n}\nbody[data-topbar-color=light] .navbar-custom .app-search .react-select__input,\nbody[data-topbar-color=light] .navbar-custom .app-search .react-select__value-container {\n  color: #343a40 !important;\n  padding: 0;\n}\nbody[data-topbar-color=light] .navbar-custom .app-search .form-control,\nbody[data-topbar-color=light] .navbar-custom .app-search .react-select__control {\n  color: #343a40 !important;\n  background-color: #f6f6f7;\n  border-color: #f6f6f7;\n}\nbody[data-topbar-color=light] .navbar-custom .app-search .btn {\n  background-color: #f6f6f7;\n  color: #ced4da;\n}\nbody[data-topbar-color=light] .logo-box {\n  background: #ffffff;\n  border-right: 1px solid #e2e7f1;\n}\nbody[data-topbar-color=light] .logo-dark {\n  display: block;\n}\nbody[data-topbar-color=light] .logo-light {\n  display: none;\n}\n\n@media (max-width: 991.98px) {\n  body[data-layout-mode=horizontal] .navbar-toggle {\n    border: 0;\n    position: relative;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n  }\n  body[data-layout-mode=horizontal] .navbar-toggle .lines {\n    width: 25px;\n    display: block;\n    position: relative;\n    height: 16px;\n    transition: all 0.5s ease;\n    margin-top: calc(54px * 0.5);\n  }\n  body[data-layout-mode=horizontal] .navbar-toggle span {\n    height: 2px;\n    width: 100%;\n    background-color: #4B4B5A;\n    display: block;\n    margin-bottom: 5px;\n    transition: transform 0.5s ease;\n  }\n  body[data-layout-mode=horizontal] .navbar-toggle.open span {\n    position: absolute;\n  }\n  body[data-layout-mode=horizontal] .navbar-toggle.open span:first-child {\n    top: 7px;\n    transform: rotate(45deg);\n  }\n  body[data-layout-mode=horizontal] .navbar-toggle.open span:nth-child(2) {\n    visibility: hidden;\n  }\n  body[data-layout-mode=horizontal] .navbar-toggle.open span:last-child {\n    width: 100%;\n    top: 7px;\n    transform: rotate(-45deg);\n  }\n}\nbody[data-layout-mode=horizontal] .button-menu-mobile {\n  display: none;\n}\nbody[data-layout-mode=horizontal] .logo-box {\n  width: auto;\n  padding-right: 50px;\n  background-color: transparent;\n  padding-left: 0;\n  border: none !important;\n}\n@media (max-width: 1366px) {\n  body[data-layout-mode=horizontal] .logo-box {\n    padding-left: 20px;\n  }\n}\n\n@media (max-width: 360px) {\n  .navbar-custom .topnav-menu .nav-link {\n    padding: 0 12px;\n  }\n  .navbar-custom .button-menu-mobile {\n    width: 45px;\n  }\n}\nbody[data-layout-mode=two-column] .logo-box {\n  display: none;\n}\n\n.page-title-box {\n  align-items: center;\n  justify-content: space-between;\n  display: flex;\n  margin: 0 -27px 0;\n  padding: 20px 27px;\n}\n.page-title-box .page-title {\n  font-size: 1.05rem;\n  margin: 0;\n}\n.page-title-box .breadcrumb {\n  padding: 0;\n}\n\n@media (max-width: 639px) {\n  .page-title-box {\n    display: block;\n  }\n  .page-title-box .page-title {\n    display: block;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  .page-title-box .page-title-right {\n    display: block;\n    padding-top: 5px;\n  }\n}\n.footer {\n  bottom: 0;\n  padding: 19px 15px 20px;\n  position: absolute;\n  right: 0;\n  color: #6c757d;\n  left: 250px;\n  border-top: 1px solid #e2e7f1;\n}\n.footer .footer-links a {\n  color: #6c757d;\n  margin-left: 1.5rem;\n  transition: all 0.4s;\n}\n.footer .footer-links a:hover {\n  color: #212529;\n}\n.footer .footer-links a:first-of-type {\n  margin-left: 0;\n}\n\n.footer-alt {\n  left: 0 !important;\n  text-align: center;\n  background-color: transparent;\n}\n\n@media (max-width: 575.98px) {\n  .footer {\n    left: 0 !important;\n    text-align: center;\n  }\n}\nbody[data-layout-mode=horizontal] .footer {\n  left: 0 !important;\n}\nbody[data-layout-mode=horizontal][data-layout-width=boxed] .footer {\n  max-width: 1300px !important;\n}\n\n@media (min-width: 992px) {\n  body[data-layout-mode=detached] .footer {\n    position: inherit;\n    margin: 0 10px;\n  }\n}\n\n.right-bar {\n  background-color: #ffffff;\n  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n  display: block;\n  position: fixed;\n  transition: all 200ms ease-out;\n  width: 260px;\n  z-index: 9999;\n  float: right !important;\n  right: -270px;\n  top: 0;\n  bottom: 0;\n}\n.right-bar .rightbar-title {\n  background-color: #5369f8;\n  padding: 27px 25px;\n  color: #fff;\n}\n.right-bar .right-bar-toggle {\n  background-color: rgb(26.6680189317%, 29.7450980392%, 32.8221771467%);\n  height: 24px;\n  width: 24px;\n  line-height: 27px;\n  color: #fff;\n  text-align: center;\n  border-radius: 50%;\n  margin-top: -4px;\n}\n.right-bar .right-bar-toggle:hover {\n  background-color: rgb(29.3576741041%, 32.7450980392%, 36.1325219743%);\n}\n.right-bar .user-box {\n  padding: 25px;\n  text-align: center;\n}\n.right-bar .user-box .user-img {\n  position: relative;\n  height: 64px;\n  width: 64px;\n  margin: 0 auto 15px auto;\n}\n.right-bar .user-box .user-img .user-edit {\n  position: absolute;\n  right: -5px;\n  bottom: 0px;\n  height: 24px;\n  width: 24px;\n  background-color: #fff;\n  line-height: 24px;\n  border-radius: 50%;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n}\n.right-bar .user-box h5, .right-bar .user-box .h5 {\n  margin-bottom: 2px;\n}\n.right-bar .user-box h5 a, .right-bar .user-box .h5 a {\n  color: #343a40;\n}\n.right-bar .notification-item .media {\n  padding: 0.75rem 1rem;\n}\n.right-bar .notification-item .media:hover {\n  background-color: #f8f9fa;\n}\n.right-bar .notification-item .user-status {\n  position: absolute;\n  right: 0px;\n  bottom: -4px;\n  font-size: 10px;\n}\n.right-bar .notification-item .user-status.online {\n  color: #43d39e;\n}\n.right-bar .notification-item .user-status.away {\n  color: #ffbe0b;\n}\n.right-bar .notification-item .user-status.busy {\n  color: #ff5c75;\n}\n\n.rightbar-overlay {\n  background-color: rgba(52, 58, 64, 0.2);\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: none;\n  z-index: 9998;\n  transition: all 0.2s ease-out;\n}\n\n.right-bar-enabled .right-bar {\n  right: 0;\n}\n.right-bar-enabled .rightbar-overlay {\n  display: block;\n}\n\n@media (max-width: 575.98px) {\n  .right-bar {\n    overflow: auto;\n  }\n  .right-bar .slimscroll-menu {\n    height: auto !important;\n  }\n}\nbody[data-layout-width=boxed] #wrapper {\n  max-width: 1300px;\n  margin: 0 auto;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n}\nbody[data-layout-width=boxed] .navbar-custom {\n  max-width: 1300px;\n  margin: 0 auto;\n}\nbody[data-layout-width=boxed] .footer {\n  margin: 0 auto;\n  max-width: calc(1300px - 250px);\n}\nbody[data-layout-width=boxed][data-sidebar-size=condensed] .footer {\n  max-width: calc(1300px - 70px);\n}\nbody[data-layout-width=boxed][data-sidebar-size=compact] .footer {\n  max-width: calc(1300px - 160px);\n}\n\n@media (min-width: 768px) {\n  body[data-layout-width=boxed][data-sidebar-size=condensed] .content-page {\n    min-height: calc(1750px - 70px);\n  }\n}\n@media (min-width: 1200px) {\n  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) {\n    padding-bottom: 0;\n  }\n  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) #wrapper {\n    display: flex;\n  }\n  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .navbar-custom,\n  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .topnav {\n    position: absolute;\n  }\n  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .left-side-menu {\n    position: relative;\n    min-width: 250px;\n    max-width: 250px;\n    padding: 20px 0 calc(70px + 20px);\n  }\n  body[data-layout-menu-position=scrollable]:not([data-sidebar-size=condensed]):not([data-sidebar-size=compact]):not([data-layout-mode=two-column]) .content-page {\n    margin-left: 0;\n    width: 100%;\n    padding-bottom: 60px;\n  }\n}\n@media (min-width: 1200px) {\n  body[data-layout-mode=horizontal] .container-fluid, body[data-layout-mode=horizontal] .container-sm, body[data-layout-mode=horizontal] .container-md, body[data-layout-mode=horizontal] .container-lg, body[data-layout-mode=horizontal] .container-xl, body[data-layout-mode=horizontal] .container-xxl {\n    max-width: 90%;\n  }\n  body[data-layout-mode=horizontal] .navbar-custom {\n    padding: 0 24px;\n  }\n}\nbody[data-layout-mode=horizontal] .content-page {\n  margin-left: 0 !important;\n}\n\n.topnav {\n  background: #ffffff;\n  border-bottom: 1px solid #e2e7f1;\n  margin-top: 70px;\n  padding: 0 calc(24px * 0.5);\n  position: fixed;\n  left: 0;\n  right: 0;\n  z-index: 100;\n}\n.topnav .topnav-menu {\n  margin: 0;\n  padding: 0;\n}\n.topnav .navbar-nav .nav-link {\n  font-size: 0.95rem;\n  position: relative;\n  line-height: 22px;\n  padding: calc(33px * 0.5) 1.1rem;\n  color: #6e7488;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n}\n.topnav .navbar-nav .nav-link i {\n  font-size: 15px;\n  display: inline-block;\n}\n.topnav .navbar-nav .nav-link svg {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  margin: -4px 5px 0 0;\n  color: #6e7488;\n  fill: rgba(110, 116, 136, 0.12);\n}\n.topnav .navbar-nav .nav-link:focus, .topnav .navbar-nav .nav-link:hover {\n  color: #5369f8;\n  background-color: transparent;\n}\n.topnav .navbar-nav .nav-item .dropdown.active > a.dropdown-toggle {\n  color: #5369f8;\n}\n.topnav .navbar-nav .nav-item.active > a {\n  color: #5369f8;\n}\n.topnav .navbar-nav .nav-item.active > a svg {\n  color: #5369f8;\n  fill: rgba(83, 105, 248, 0.12);\n}\n\n@media (min-width: 992px) {\n  .topnav {\n    height: 55px;\n  }\n  .topnav .navbar-nav .nav-item:first-of-type .nav-link {\n    padding-left: 0;\n  }\n  .topnav .dropdown-item {\n    padding: 0.5rem 1.25rem;\n    min-width: 180px;\n    margin: 0 0.3rem;\n    width: auto;\n  }\n  .topnav .dropdown-item.active {\n    background-color: transparent;\n    color: #5369f8;\n  }\n  .topnav .dropdown.mega-dropdown .mega-dropdown-menu {\n    left: 0px;\n    right: auto;\n  }\n  .topnav .dropdown .dropdown-menu {\n    padding: 0.3rem 0;\n    margin-top: 0;\n    border-radius: 0 0 0.25rem 0.25rem;\n  }\n  .topnav .dropdown .dropdown-menu .arrow-down::after {\n    right: 20px;\n    transform: rotate(-135deg) translateY(-50%);\n    position: absolute;\n  }\n  .topnav .dropdown .dropdown-menu .dropdown .dropdown-menu {\n    position: absolute;\n    top: 0 !important;\n    left: 100%;\n    display: none;\n  }\n  .topnav .dropdown:hover > .nav-link {\n    color: #5369f8;\n  }\n  .topnav .dropdown:hover > .nav-link svg {\n    color: #5369f8;\n    fill: rgba(83, 105, 248, 0.12);\n  }\n  .topnav .dropdown:hover > .dropdown-menu {\n    display: block;\n  }\n  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-item {\n    color: #5369f8;\n  }\n  .topnav .dropdown:hover > .dropdown-menu > .dropdown:hover > .dropdown-menu {\n    display: block;\n  }\n  .navbar-toggle {\n    display: none;\n  }\n  body[data-layout-mode=horizontal] .content-page {\n    padding: 55px 12px 65px 12px;\n  }\n}\n.arrow-down {\n  display: inline-block;\n}\n.arrow-down:after {\n  border-color: initial;\n  border-style: solid;\n  border-width: 0 0 1px 1px;\n  content: \"\";\n  height: 0.4em;\n  display: inline-block;\n  right: 5px;\n  top: 50%;\n  margin-left: 10px;\n  transform: rotate(-45deg) translateY(-50%);\n  transform-origin: top;\n  transition: all 0.3s ease-out;\n  width: 0.4em;\n}\n\n@media (max-width: 1199.98px) {\n  .topnav-menu .navbar-nav li:last-of-type .dropdown .dropdown-menu {\n    right: 100%;\n    left: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .topnav {\n    max-height: 360px;\n    overflow-y: auto;\n    padding: 0;\n  }\n  .topnav .navbar-nav .nav-link {\n    padding: 0.75rem 1.1rem;\n  }\n  .topnav .dropdown .dropdown-menu {\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    padding-left: 15px;\n  }\n  .topnav .dropdown .dropdown-item {\n    position: relative;\n    background-color: transparent;\n  }\n  .topnav .dropdown .dropdown-item.active, .topnav .dropdown .dropdown-item:active {\n    color: #5369f8;\n  }\n  .topnav .arrow-down::after {\n    right: 15px;\n    position: absolute;\n  }\n}\nbody[data-layout-mode=horizontal][data-layout-width=boxed] .topnav {\n  max-width: 1300px;\n  margin: 70px auto 0;\n}\n\nbody[data-layout-mode=horizontal] .logo-box {\n  background-color: transparent !important;\n}\n\nbody[data-layout-mode=two-column] .left-side-menu {\n  width: calc(70px + 220px);\n  background-color: transparent;\n  box-shadow: none;\n}\nbody[data-layout-mode=two-column] .sidebar-icon-menu {\n  position: fixed;\n  width: 70px;\n  z-index: 500;\n  top: 0;\n  bottom: 0;\n  padding-bottom: 20px;\n  background-color: #5369f8;\n}\nbody[data-layout-mode=two-column] .sidebar-icon-menu .logo {\n  display: block;\n  width: 70px;\n  height: 70px;\n  line-height: 70px;\n  text-align: center;\n}\nbody[data-layout-mode=two-column] .sidebar-icon-menu .nav {\n  background-color: transparent;\n  margin: 24px auto;\n}\nbody[data-layout-mode=two-column] .sidebar-icon-menu .nav .nav-link {\n  text-align: center;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  margin: 12px auto;\n  padding: 0px;\n  border-radius: 4px;\n}\nbody[data-layout-mode=two-column] .sidebar-icon-menu .nav .nav-link.active {\n  background-color: rgba(255, 255, 255, 0.12);\n}\nbody[data-layout-mode=two-column] .sidebar-icon-menu .nav .nav-link svg {\n  color: #fff;\n  fill: rgba(255, 255, 255, 0.12);\n  height: 22px;\n  width: 22px;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu {\n  display: block;\n  position: fixed;\n  width: 220px;\n  background-color: #ffffff;\n  top: 70px;\n  bottom: 0;\n  left: 70px;\n  padding: 30px 5px;\n  border-right: 1px solid #e2e7f1;\n  transition: all 0.1s ease-out;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .sidebar-menu-body {\n  padding: 20px;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .menu-title {\n  color: #adb5bd !important;\n  margin: 0;\n  padding: 10px 20px;\n  letter-spacing: 0.05em;\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  font-weight: 600;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .nav > .nav-item > .nav-link {\n  color: #4b4b5a;\n  font-size: 0.95rem;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .nav > .nav-item .menu-arrow {\n  right: 10px;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link {\n  position: relative;\n  color: #4b4b5a;\n  padding: 6px 15px;\n  border-radius: 3px;\n  margin: 3px 5px;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column] .sidebar-main-menu .nav .nav-link.active {\n  color: #5369f8;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .nav .menuitem-active > a.nav-link {\n  color: #5369f8;\n  background-color: rgba(83, 105, 248, 0.07);\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .nav .menuitem-active a.active {\n  color: #5369f8;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu #sidebar-menu .menu-arrow {\n  top: 7px;\n}\nbody[data-layout-mode=two-column] .sidebar-main-menu .nav-second-level {\n  padding-left: 15px;\n  list-style: none;\n}\n@media (min-width: 992px) {\n  body[data-layout-mode=two-column] .navbar-custom {\n    left: 70px !important;\n    padding-left: 0px;\n  }\n  body[data-layout-mode=two-column] .navbar-custom .logo-box {\n    width: 220px;\n  }\n  body[data-layout-mode=two-column] .navbar-custom .logo-box .logo-sm {\n    display: none;\n  }\n  body[data-layout-mode=two-column][data-sidebar-size=condensed] .logo-box {\n    width: 0 !important;\n  }\n}\nbody[data-layout-mode=two-column][data-sidebar-color=light] .logo-box {\n  background-color: #ffffff;\n}\n@media (min-width: 992px) {\n  body[data-layout-mode=two-column] .content-page {\n    margin-left: calc(70px + 220px);\n  }\n  body[data-layout-mode=two-column] .footer {\n    left: calc(70px + 220px);\n  }\n  body[data-layout-mode=two-column][data-sidebar-size=condensed] .sidebar-main-menu {\n    display: none;\n  }\n}\nbody[data-layout-mode=two-column] .twocolumn-menu-item {\n  display: none;\n}\nbody[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu {\n  background-color: #323742;\n}\nbody[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav > .nav-item > .nav-link {\n  color: #9097a7;\n}\nbody[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .nav-link.active {\n  color: #c8cddc;\n}\nbody[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .menuitem-active > a.nav-link {\n  color: #5369f8;\n  background-color: rgba(83, 105, 248, 0.07);\n}\nbody[data-layout-mode=two-column][data-sidebar-color=dark] .sidebar-main-menu .nav .menuitem-active a.active {\n  color: #5369f8;\n}\nbody[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav > .nav-item > .nav-link, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav > .nav-item > .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\nbody[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column][data-sidebar-color=brand] .sidebar-main-menu .nav .nav-link.active, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav .nav-link:hover, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav .nav-link:focus, body[data-layout-mode=two-column][data-sidebar-color=gradient] .sidebar-main-menu .nav .nav-link.active {\n  color: rgba(255, 255, 255, 0.9);\n}\nbody[data-layout-mode=two-column][data-layout-width=boxed] .navbar-custom {\n  max-width: calc(1300px - 70px);\n}\nbody[data-layout-mode=two-column][data-layout-width=boxed] .sidebar-main-menu {\n  position: absolute;\n  top: 0;\n}\nbody[data-layout-mode=two-column][data-layout-width=boxed]:not([data-sidebar-size=condensed]) .footer {\n  max-width: calc(1300px - calc(70px + 220px));\n}\n\n.avatar-xs {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.avatar-sm {\n  height: 2.25rem;\n  width: 2.25rem;\n}\n\n.avatar {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 3.5rem;\n  width: 3.5rem;\n}\n\n.avatar-lg {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-xl {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xxl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  color: #fff;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n.avatar-group {\n  padding-left: 12px;\n}\n.avatar-group .avatar-group-item {\n  margin: 0 0 10px -12px;\n  display: inline-block;\n  border: 2px solid #fff;\n  border-radius: 50%;\n}\n\n.checkbox label {\n  display: inline-block;\n  padding-left: 8px;\n  position: relative;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.checkbox label::before {\n  background-color: #e2e7f1;\n  border-radius: 3px;\n  border: 2px solid #e2e7f1;\n  content: \"\";\n  display: inline-block;\n  height: 18px;\n  left: 0;\n  margin-left: -18px;\n  position: absolute;\n  transition: 0.3s ease-in-out;\n  width: 18px;\n  outline: none !important;\n  top: 2px;\n}\n.checkbox label::after {\n  color: #4B4B5A;\n  display: inline-block;\n  font-size: 11px;\n  height: 18px;\n  left: 0;\n  margin-left: -18px;\n  padding-left: 3px;\n  padding-top: 2px;\n  position: absolute;\n  top: 0;\n  width: 18px;\n}\n.checkbox input[type=checkbox] {\n  cursor: pointer;\n  opacity: 0;\n  z-index: 1;\n  outline: none !important;\n}\n.checkbox input[type=checkbox]:disabled + label {\n  opacity: 0.65;\n}\n.checkbox input[type=checkbox]:focus + label::before {\n  outline-offset: -2px;\n  outline: none;\n}\n.checkbox input[type=checkbox]:checked + label::after {\n  content: \"\";\n  position: absolute;\n  top: 6px;\n  left: 7px;\n  display: table;\n  width: 4px;\n  height: 8px;\n  border: 2px solid #4B4B5A;\n  border-top-width: 0;\n  border-left-width: 0;\n  transform: rotate(45deg);\n}\n.checkbox input[type=checkbox]:disabled + label::before {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n}\n\n.checkbox.checkbox-circle label::before {\n  border-radius: 50%;\n}\n\n.checkbox.checkbox-inline {\n  margin-top: 0;\n}\n\n.checkbox.checkbox-single input {\n  height: 18px;\n  width: 18px;\n  position: absolute;\n}\n.checkbox.checkbox-single label {\n  height: 18px;\n  width: 18px;\n}\n.checkbox.checkbox-single label:before {\n  margin-left: 0;\n}\n.checkbox.checkbox-single label:after {\n  margin-left: 0;\n}\n\n.checkbox-primary input[type=checkbox]:checked + label::before {\n  background-color: #5369f8;\n  border-color: #5369f8;\n}\n.checkbox-primary input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.checkbox-secondary input[type=checkbox]:checked + label::before {\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.checkbox-secondary input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.checkbox-success input[type=checkbox]:checked + label::before {\n  background-color: #43d39e;\n  border-color: #43d39e;\n}\n.checkbox-success input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.checkbox-info input[type=checkbox]:checked + label::before {\n  background-color: #25c2e3;\n  border-color: #25c2e3;\n}\n.checkbox-info input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.checkbox-warning input[type=checkbox]:checked + label::before {\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n.checkbox-warning input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.checkbox-danger input[type=checkbox]:checked + label::before {\n  background-color: #ff5c75;\n  border-color: #ff5c75;\n}\n.checkbox-danger input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.checkbox-light input[type=checkbox]:checked + label::before {\n  background-color: #f8f9fa;\n  border-color: #f8f9fa;\n}\n.checkbox-light input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.checkbox-dark input[type=checkbox]:checked + label::before {\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.checkbox-dark input[type=checkbox]:checked + label::after {\n  border-color: #fff;\n}\n\n.radio label {\n  display: inline-block;\n  padding-left: 8px;\n  position: relative;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n.radio label::before {\n  background-color: #fff;\n  border-radius: 50%;\n  border: 2px solid #6c757d;\n  content: \"\";\n  display: inline-block;\n  height: 18px;\n  left: 0;\n  margin-left: -18px;\n  position: absolute;\n  transition: border 0.5s ease-in-out;\n  width: 18px;\n  outline: none !important;\n}\n.radio label::after {\n  background-color: #4B4B5A;\n  border-radius: 50%;\n  content: \" \";\n  display: inline-block;\n  height: 10px;\n  left: 6px;\n  margin-left: -20px;\n  position: absolute;\n  top: 4px;\n  transform: scale(0, 0);\n  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n  width: 10px;\n}\n.radio input[type=radio] {\n  cursor: pointer;\n  opacity: 0;\n  z-index: 1;\n  outline: none !important;\n}\n.radio input[type=radio]:disabled + label {\n  opacity: 0.65;\n}\n.radio input[type=radio]:focus + label::before {\n  outline-offset: -2px;\n  outline: 5px auto -webkit-focus-ring-color;\n  outline: thin dotted;\n}\n.radio input[type=radio]:checked + label::after {\n  transform: scale(1, 1);\n}\n.radio input[type=radio]:disabled + label::before {\n  cursor: not-allowed;\n}\n\n.radio.radio-inline {\n  margin-top: 0;\n}\n\n.radio.radio-single label {\n  height: 17px;\n}\n\n.radio-primary input[type=radio] + label::after {\n  background-color: #5369f8;\n}\n.radio-primary input[type=radio]:checked + label::before {\n  border-color: #5369f8;\n}\n.radio-primary input[type=radio]:checked + label::after {\n  background-color: #5369f8;\n}\n\n.radio-secondary input[type=radio] + label::after {\n  background-color: #6c757d;\n}\n.radio-secondary input[type=radio]:checked + label::before {\n  border-color: #6c757d;\n}\n.radio-secondary input[type=radio]:checked + label::after {\n  background-color: #6c757d;\n}\n\n.radio-success input[type=radio] + label::after {\n  background-color: #43d39e;\n}\n.radio-success input[type=radio]:checked + label::before {\n  border-color: #43d39e;\n}\n.radio-success input[type=radio]:checked + label::after {\n  background-color: #43d39e;\n}\n\n.radio-info input[type=radio] + label::after {\n  background-color: #25c2e3;\n}\n.radio-info input[type=radio]:checked + label::before {\n  border-color: #25c2e3;\n}\n.radio-info input[type=radio]:checked + label::after {\n  background-color: #25c2e3;\n}\n\n.radio-warning input[type=radio] + label::after {\n  background-color: #ffbe0b;\n}\n.radio-warning input[type=radio]:checked + label::before {\n  border-color: #ffbe0b;\n}\n.radio-warning input[type=radio]:checked + label::after {\n  background-color: #ffbe0b;\n}\n\n.radio-danger input[type=radio] + label::after {\n  background-color: #ff5c75;\n}\n.radio-danger input[type=radio]:checked + label::before {\n  border-color: #ff5c75;\n}\n.radio-danger input[type=radio]:checked + label::after {\n  background-color: #ff5c75;\n}\n\n.radio-light input[type=radio] + label::after {\n  background-color: #f8f9fa;\n}\n.radio-light input[type=radio]:checked + label::before {\n  border-color: #f8f9fa;\n}\n.radio-light input[type=radio]:checked + label::after {\n  background-color: #f8f9fa;\n}\n\n.radio-dark input[type=radio] + label::after {\n  background-color: #343a40;\n}\n.radio-dark input[type=radio]:checked + label::before {\n  border-color: #343a40;\n}\n.radio-dark input[type=radio]:checked + label::after {\n  background-color: #343a40;\n}\n\n.width-xs {\n  min-width: 80px;\n}\n\n.width-sm {\n  min-width: 100px;\n}\n\n.width-md {\n  min-width: 120px;\n}\n\n.width-lg {\n  min-width: 140px;\n}\n\n.width-xl {\n  min-width: 160px;\n}\n\n.font-family-primary {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n}\n\n.font-family-secondary {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n}\n\n.sp-line-1,\n.sp-line-2,\n.sp-line-3,\n.sp-line-4 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n.sp-line-1 {\n  -webkit-line-clamp: 1;\n}\n\n.sp-line-2 {\n  -webkit-line-clamp: 2;\n}\n\n.sp-line-3 {\n  -webkit-line-clamp: 3;\n}\n\n.sp-line-4 {\n  -webkit-line-clamp: 4;\n}\n\n.icon-dual {\n  color: #6c757d;\n  fill: rgba(108, 117, 125, 0.12);\n}\n\n.icon-dual-primary {\n  color: #5369f8;\n  fill: rgba(83, 105, 248, 0.16);\n}\n\n.icon-dual-secondary {\n  color: #6c757d;\n  fill: rgba(108, 117, 125, 0.16);\n}\n\n.icon-dual-success {\n  color: #43d39e;\n  fill: rgba(67, 211, 158, 0.16);\n}\n\n.icon-dual-info {\n  color: #25c2e3;\n  fill: rgba(37, 194, 227, 0.16);\n}\n\n.icon-dual-warning {\n  color: #ffbe0b;\n  fill: rgba(255, 190, 11, 0.16);\n}\n\n.icon-dual-danger {\n  color: #ff5c75;\n  fill: rgba(255, 92, 117, 0.16);\n}\n\n.icon-dual-light {\n  color: #f8f9fa;\n  fill: rgba(248, 249, 250, 0.16);\n}\n\n.icon-dual-dark {\n  color: #343a40;\n  fill: rgba(52, 58, 64, 0.16);\n}\n\n.icon-xs {\n  height: 16px;\n  width: 16px;\n}\n\n.icon-sm {\n  height: 24px;\n  width: 24px;\n}\n\n.icon-md {\n  height: 32px;\n  width: 32px;\n}\n\n.icon-lg {\n  height: 40px;\n  width: 40px;\n}\n\n.icon-xl {\n  height: 48px;\n  width: 48px;\n}\n\n.icon-xxl {\n  height: 60px;\n  width: 60px;\n}\n\n.item-hovered:hover {\n  background-color: #f8f9fa;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.social-list-item {\n  height: 2rem;\n  width: 2rem;\n  line-height: calc(2rem - 2px);\n  display: block;\n  border: 2px solid #adb5bd;\n  border-radius: 50%;\n  color: #adb5bd;\n}\n\n.widget-flat {\n  position: relative;\n  overflow: hidden;\n}\n.widget-flat i.widget-icon {\n  font-size: 36px;\n}\n\n/* Chat widget */\n.conversation-list {\n  list-style: none;\n  height: 332px;\n  padding: 0 7px;\n  outline: none;\n}\n.conversation-list li {\n  margin-bottom: 24px;\n}\n.conversation-list .chat-avatar {\n  float: left;\n  text-align: center;\n  width: 38px;\n}\n.conversation-list .chat-avatar img {\n  border-radius: 100%;\n  width: 100%;\n}\n.conversation-list .chat-avatar i {\n  font-size: 12px;\n  font-style: normal;\n}\n.conversation-list .ctext-wrap {\n  background: rgb(94.0462263118%, 94.8077555044%, 99.7576952569%);\n  color: #5369f8;\n  border-radius: 0.25rem;\n  display: inline-block;\n  padding: 4px 12px;\n  position: relative;\n}\n.conversation-list .ctext-wrap i {\n  display: block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  position: relative;\n}\n.conversation-list .ctext-wrap p {\n  margin: 0;\n  padding-top: 3px;\n}\n.conversation-list .ctext-wrap:after {\n  right: 98%;\n  top: 0;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-top-color: rgb(94.0462263118%, 94.8077555044%, 99.7576952569%);\n  border-width: 6px;\n  margin-left: -1px;\n  border-right-color: rgb(94.0462263118%, 94.8077555044%, 99.7576952569%);\n}\n.conversation-list .conversation-text {\n  float: left;\n  font-size: 12px;\n  margin-left: 12px;\n  width: 70%;\n}\n.conversation-list .odd .chat-avatar {\n  float: right !important;\n}\n.conversation-list .odd .conversation-text {\n  float: right !important;\n  margin-right: 12px;\n  text-align: right;\n  width: 70% !important;\n}\n.conversation-list .odd .ctext-wrap {\n  background-color: #e2e7f1;\n  color: #4B4B5A;\n}\n.conversation-list .odd .ctext-wrap:after {\n  border-color: transparent;\n  border-left-color: #e2e7f1;\n  border-top-color: #e2e7f1;\n  left: 99% !important;\n}\n\n/* profile / users */\n.profile-widget {\n  position: relative;\n}\n.profile-widget .card-action {\n  position: absolute;\n  right: 7px;\n  top: 12px;\n  z-index: 100;\n}\n.profile-widget .card-img-top {\n  max-height: 220px;\n}\n.profile-widget .profile-info {\n  margin-top: -2.7rem;\n}\n\n.calendar-widget .flatpickr-calendar {\n  box-shadow: none;\n  border: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%) !important;\n}\n\n.activity-widget .activity-list {\n  border-bottom: 1px solid #f6f6f7;\n  padding: 12px 0px;\n}\n.activity-widget .activity-list:last-child {\n  border: none;\n}\n\n@media print {\n  .left-side-menu,\n  .right-bar,\n  .page-title-box,\n  .navbar-custom,\n  .footer {\n    display: none;\n  }\n  .card-body,\n  .content-page,\n  .right-bar,\n  .content,\n  body {\n    padding: 0;\n    margin: 0;\n  }\n  .card {\n    border: none;\n  }\n}\n#preloader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.85);\n  z-index: 9999;\n}\n\n#status {\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -20px 0 0 -20px;\n}\n\n.spinner {\n  margin: 0 auto;\n  font-size: 10px;\n  position: relative;\n  text-indent: -9999em;\n  border-top: 5px solid #e2e7f1;\n  border-right: 5px solid #e2e7f1;\n  border-bottom: 5px solid #e2e7f1;\n  border-left: 5px solid #5369f8;\n  transform: translateZ(0);\n  animation: SpinnerAnimation 1.1s infinite linear;\n}\n\n.spinner,\n.spinner:after {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n}\n\n@keyframes SpinnerAnimation {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\nbody.authentication-bg {\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding-bottom: 0;\n}\n\n.authentication-form .form-group .input-group-text {\n  background-color: transparent;\n}\n.authentication-form .form-group .input-group-text svg {\n  height: 20px;\n  width: 20px;\n}\n\n.icon-fb {\n  color: #3c5a98;\n}\n\n.icon-google {\n  color: #e94134;\n}\n\n.auth-page-sidebar {\n  padding: 0;\n  background-image: url(\"../../../images/Templates-banner.svg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n  position: relative;\n}\n.auth-page-sidebar .overlay {\n  flex: 1;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.auth-page-sidebar .auth-user-testimonial {\n  text-align: center;\n  color: #fff;\n  position: absolute;\n  margin: 0 auto;\n  padding: 0 1.75rem;\n  bottom: 3rem;\n  left: 0;\n  right: 0;\n}\n\n.auth-logo .logo-light {\n  display: none !important;\n}\n.auth-logo .logo-dark {\n  display: block !important;\n}\n\n.logout-checkmark {\n  width: 90px;\n  margin: 0 auto;\n  padding: 20px 0;\n}\n.logout-checkmark .path {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 0;\n  animation: dash 2s ease-in-out;\n}\n.logout-checkmark .spin {\n  animation: spin 2s;\n  transform-origin: 50% 50%;\n}\n\n@keyframes dash {\n  0% {\n    stroke-dashoffset: 1000;\n  }\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n@keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes text {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.mashaal-brand {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 12px;\n  text-decoration: none;\n  margin-bottom: 20px;\n}\n.mashaal-brand__mascot {\n  width: 56px;\n  height: auto;\n}\n.mashaal-brand__combo {\n  height: 68px;\n  width: auto;\n}\n.mashaal-brand__text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n  text-align: left;\n}\n.mashaal-brand__title {\n  font-weight: 800;\n  font-size: 1.25rem;\n  color: #101828;\n}\n.mashaal-brand__subtitle {\n  font-weight: 700;\n  font-size: 0.8rem;\n  color: #101828;\n}\n.mashaal-brand--on-dark .mashaal-brand__title,\n.mashaal-brand--on-dark .mashaal-brand__subtitle {\n  color: #ffffff;\n}\n\n.school-login-page {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  background: #ffffff;\n}\n.school-login-page__back {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 10;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #101828;\n  font-weight: 600;\n  font-size: 0.85rem;\n  text-decoration: none;\n  padding: 8px 14px;\n  border-radius: 999px;\n  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.12);\n  transition: background 0.15s ease;\n}\n.school-login-page__back:hover {\n  background: #ffffff;\n  color: #14335e;\n}\n.school-login-page__back i {\n  font-size: 0.95rem;\n}\n.school-login-page__photo {\n  display: none;\n  background-size: cover;\n  background-position: center;\n  opacity: 0.55;\n}\n.school-login-page__form-wrap {\n  flex: 1 1 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 24px;\n}\n.school-login-page__form {\n  width: 100%;\n  max-width: 380px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n.school-login-page__title {\n  font-weight: 700;\n  font-size: 1.5rem;\n  color: #101828;\n  margin-bottom: 6px;\n}\n.school-login-page__subtitle {\n  color: #667085;\n  font-size: 0.9rem;\n  margin-bottom: 24px;\n}\n.school-login-page__forgot {\n  color: #dc2626;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-decoration: none;\n}\n.school-login-page__forgot:hover {\n  text-decoration: underline;\n}\n.school-login-page__submit {\n  background: linear-gradient(90deg, #b91c3c 0%, #1e3a8a 100%);\n  border: none;\n  font-weight: 700;\n  padding: 10px 0;\n  border-radius: 8px;\n}\n.school-login-page__submit:hover, .school-login-page__submit:focus, .school-login-page__submit:active {\n  background: linear-gradient(90deg, #a01834 0%, #17307a 100%) !important;\n  border: none !important;\n}\n.school-login-page .school-login-form {\n  width: 100%;\n  text-align: left;\n}\n@media (min-width: 768px) {\n  .school-login-page__photo {\n    display: block;\n    flex: 1 1 50%;\n    min-height: 100vh;\n  }\n  .school-login-page__form-wrap {\n    flex: 1 1 50%;\n  }\n}\n@media (min-width: 992px) {\n  .school-login-page__photo {\n    flex-basis: 55%;\n  }\n  .school-login-page__form-wrap {\n    flex-basis: 45%;\n  }\n}\n\n.button-list {\n  margin-left: -8px;\n  margin-bottom: -12px;\n}\n.button-list .btn {\n  margin-bottom: 12px;\n  margin-left: 8px;\n}\n\n.grid-structure .grid-container {\n  background-color: #f8f9fa;\n  margin-bottom: 10px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 10px 20px;\n}\n\n.icons-list-demo div.col-sm-6 {\n  cursor: pointer;\n  line-height: 45px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: block;\n  overflow: hidden;\n}\n.icons-list-demo div.col-sm-6 p {\n  margin-bottom: 0;\n  line-height: inherit;\n}\n.icons-list-demo i {\n  text-align: center;\n  vertical-align: middle;\n  font-size: 22px;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  margin-right: 12px;\n  color: #6c757d;\n  border-radius: 3px;\n  display: inline-block;\n  transition: all 0.2s;\n}\n.icons-list-demo .col-md-4 {\n  border-radius: 3px;\n  background-clip: padding-box;\n  margin-bottom: 10px;\n}\n.icons-list-demo .col-md-4:hover, .icons-list-demo .col-md-4:hover i {\n  color: #5369f8;\n}\n\n.icons-list .icon-item {\n  padding: 15px 0;\n  color: #6c757d;\n}\n.icons-list .icon-item svg {\n  margin-right: 10px;\n}\n.icons-list .icon-item span {\n  line-height: 30px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: 0.5rem;\n  overflow: auto;\n}\n\n.text-error {\n  color: #5369f8;\n  text-shadow: rgba(83, 105, 248, 0.3) 5px 1px, rgba(83, 105, 248, 0.2) 10px 3px;\n  font-size: 84px;\n  line-height: 90px;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n}\n\n.error-text-box {\n  font-size: 10rem;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  min-height: 200px;\n}\n.error-text-box .text {\n  fill: none;\n  stroke-width: 6;\n  stroke-linejoin: round;\n  stroke-dasharray: 30 100;\n  stroke-dashoffset: 0;\n  animation: stroke 9s infinite linear;\n}\n.error-text-box .text:nth-child(5n+1) {\n  stroke: #ff5c75;\n  animation-delay: -1.2s;\n}\n.error-text-box .text:nth-child(5n+2) {\n  stroke: #ffbe0b;\n  animation-delay: -2.4s;\n}\n.error-text-box .text:nth-child(5n+3) {\n  stroke: #5369f8;\n  animation-delay: -3.6s;\n}\n.error-text-box .text:nth-child(5n+4) {\n  stroke: #25c2e3;\n  animation-delay: -4.8s;\n}\n.error-text-box .text:nth-child(5n+5) {\n  stroke: #43d39e;\n  animation-delay: -6s;\n}\n\n@keyframes stroke {\n  100% {\n    stroke-dashoffset: -400;\n  }\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .error-text-box .text {\n    fill: #ff5c75;\n    stroke: #ff5c75;\n    stroke-width: 6;\n    stroke-dasharray: 0 0;\n    stroke-dashoffset: 0;\n    animation: none;\n  }\n}\n.email-container {\n  background-color: #fff;\n}\n.email-container .inbox-leftbar {\n  padding: 1.25rem;\n  width: 250px;\n  float: left;\n  padding-bottom: 184px;\n  margin-bottom: -184px;\n}\n.email-container .inbox-rightbar {\n  margin-left: 250px;\n  border-left: 5px solid #f3f4f7;\n  padding: 0 0 1.5rem 25px;\n}\n\n.message-list {\n  display: block;\n  padding-left: 0;\n}\n.message-list li {\n  position: relative;\n  display: block;\n  height: 48px;\n  line-height: 48px;\n  cursor: default;\n  transition-duration: 0.3s;\n  background: #fff;\n  margin-bottom: 1px;\n  box-shadow: 0 0.05rem 0.01rem rgba(75, 75, 90, 0.075);\n}\n.message-list li a {\n  color: #4B4B5A;\n}\n.message-list li:hover {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  transition-duration: 0.05s;\n}\n.message-list li .col-mail {\n  float: left;\n  position: relative;\n}\n.message-list li .col-mail-1 {\n  width: 320px;\n}\n.message-list li .col-mail-1 .star-toggle,\n.message-list li .col-mail-1 .checkbox-wrapper-mail,\n.message-list li .col-mail-1 .dot {\n  display: block;\n  float: left;\n}\n.message-list li .col-mail-1 .dot {\n  border: 4px solid transparent;\n  border-radius: 100px;\n  margin: 22px 26px 0;\n  height: 0;\n  width: 0;\n  line-height: 0;\n  font-size: 0;\n}\n.message-list li .col-mail-1 .checkbox-wrapper-mail {\n  margin: 15px 10px 0 20px;\n}\n.message-list li .col-mail-1 .star-toggle {\n  color: #adb5bd;\n  margin-left: 10px;\n}\n.message-list li .col-mail-1 .title {\n  position: absolute;\n  top: 0;\n  left: 100px;\n  right: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  margin-bottom: 0;\n  line-height: 50px;\n}\n.message-list li .col-mail-2 {\n  position: absolute;\n  top: 0;\n  left: 320px;\n  right: 0;\n  bottom: 0;\n}\n.message-list li .col-mail-2 .subject,\n.message-list li .col-mail-2 .date {\n  position: absolute;\n  top: 0;\n}\n.message-list li .col-mail-2 .subject {\n  left: 0;\n  right: 110px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.message-list li .col-mail-2 .date {\n  right: 0;\n  width: 100px;\n  padding-left: 10px;\n}\n.message-list li.active,\n.message-list li.mail-selected {\n  background: #f8f9fa;\n  transition-duration: 0.05s;\n}\n.message-list li.active,\n.message-list li.active:hover {\n  box-shadow: inset 3px 0 0 #25c2e3;\n}\n.message-list li.unread a {\n  color: rgb(15.9093982421%, 17.7450980392%, 19.5807978364%);\n}\n.message-list .checkbox-wrapper-mail {\n  cursor: pointer;\n  height: 20px;\n  width: 20px;\n  position: relative;\n  display: inline-block;\n  box-shadow: inset 0 0 0 2px #ced4da;\n  border-radius: 3px;\n}\n.message-list .checkbox-wrapper-mail input {\n  opacity: 0;\n  cursor: pointer;\n}\n.message-list .checkbox-wrapper-mail input:checked ~ label {\n  opacity: 1;\n}\n.message-list .checkbox-wrapper-mail label {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  right: 3px;\n  bottom: 3px;\n  cursor: pointer;\n  background: #6c757d;\n  opacity: 0;\n  margin-bottom: 0 !important;\n  transition-duration: 0.05s;\n}\n.message-list .checkbox-wrapper-mail label:active {\n  background: #87949b;\n}\n\n.mail-list a {\n  color: #4B4B5A;\n  padding: 7px 10px;\n  display: block;\n}\n\n.reply-box {\n  border: 2px solid #f8f9fa;\n}\n\n@media (max-width: 648px) {\n  .email-container .inbox-leftbar {\n    width: 100%;\n    float: none;\n    margin-bottom: 21px;\n    padding-bottom: 1.25rem;\n  }\n  .email-container .inbox-rightbar {\n    margin-left: 0;\n    border: 0;\n    padding-left: 0;\n  }\n}\n@media (max-width: 520px) {\n  .inbox-rightbar > .btn-group {\n    margin-bottom: 10px;\n  }\n  .message-list li .col-mail-1 {\n    width: 150px;\n  }\n  .message-list li .col-mail-1 .title {\n    left: 80px;\n  }\n  .message-list li .col-mail-2 {\n    left: 160px;\n  }\n  .message-list li .col-mail-2 .date {\n    text-align: right;\n    padding-right: 10px;\n    padding-left: 20px;\n  }\n}\n.chatbox {\n  position: fixed;\n  right: 35px;\n  bottom: 10px;\n  width: 300px;\n  background-color: #fff;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  z-index: 99;\n}\n.chatbox .chat-input .form-control {\n  padding-right: 60px;\n}\n.chatbox .chat-link {\n  position: absolute;\n  right: 4px;\n  top: 10px;\n}\n\n.card-pricing {\n  position: relative;\n}\n.card-pricing .card-pricing-plan-name {\n  padding-bottom: 20px;\n}\n.card-pricing .card-pricing-icon {\n  font-size: 22px;\n  background-color: rgba(83, 105, 248, 0.1);\n  height: 60px;\n  display: inline-block;\n  width: 60px;\n  line-height: 62px;\n  border-radius: 50%;\n}\n.card-pricing .card-pricing-price {\n  padding: 30px 0 0;\n}\n.card-pricing .card-pricing-price span {\n  font-size: 40%;\n  color: #6c757d;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n.card-pricing .card-pricing-features {\n  color: #6c757d;\n  list-style: none;\n  margin: 0;\n  padding: 20px 0 0 0;\n}\n.card-pricing .card-pricing-features li {\n  padding: 10px;\n}\n\n.card-pricing-recommended {\n  background-color: #5369f8;\n  color: #fff;\n}\n.card-pricing-recommended .card-pricing-icon {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.card-pricing-recommended .card-pricing-features, .card-pricing-recommended .card-pricing-price span {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.post-user-comment-box {\n  background-color: #f8f9fa;\n  margin: 0 -0.75rem;\n  padding: 1rem;\n  margin-top: 20px;\n}\n\n.board {\n  display: block;\n  white-space: nowrap;\n  overflow-x: auto;\n}\n\n.tasks {\n  display: inline-block;\n  width: 22rem;\n  padding: 0 1rem 1rem 1rem;\n  vertical-align: top;\n  margin-bottom: 24px;\n  background-color: #fff;\n  border-radius: 0.2rem;\n}\n.tasks.tasks:not(:last-child) {\n  margin-right: 1.25rem;\n}\n.tasks .card {\n  white-space: normal;\n  margin-top: 1rem;\n}\n.tasks .task-header {\n  background-color: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);\n  padding: 1rem;\n  margin: 0 -1rem;\n  border-radius: 0.2rem;\n}\n\n.task-list-items {\n  min-height: 100px;\n  position: relative;\n}\n.task-list-items .card {\n  cursor: pointer;\n}\n.task-list-items:before {\n  content: \"No Tasks\";\n  position: absolute;\n  line-height: 110px;\n  width: 100%;\n  text-align: center;\n  font-weight: 600;\n}\n\n.task-modal-content .form-control-light {\n  background-color: rgb(99.1176470588%, 99.1176470588%, 99.2156862745%) !important;\n  border-color: rgb(99.1176470588%, 99.1176470588%, 99.2156862745%) !important;\n}\n\n.gantt-task-details {\n  min-width: 220px;\n}\n\n.task-search .search-input {\n  padding-left: 32px;\n  z-index: 10;\n}\n.task-search .icon-search {\n  z-index: 11;\n  position: absolute;\n  left: 10px;\n  top: 10px;\n}\n\n/************** Horizontal timeline **************/\n.left-timeline .events {\n  border-left: 3px solid #e2e7f1;\n  padding-left: 35px;\n}\n.left-timeline .events .event-list {\n  position: relative;\n}\n.left-timeline .events .event-list::before {\n  content: \"\";\n  position: absolute;\n  left: -45px;\n  top: 6px;\n  height: 18px;\n  width: 18px;\n  background-color: #5369f8;\n  border-radius: 50%;\n  border: 5px solid #fff;\n  z-index: 9;\n}\n.left-timeline .events .event-list::after {\n  content: \"\";\n  position: absolute;\n  left: -38px;\n  top: 14px;\n  height: 3px;\n  width: 30px;\n  background-color: #e2e7f1;\n}\n.left-timeline .album img {\n  height: 36px;\n  width: auto;\n  border-radius: 4px;\n}\n\n.timeline {\n  margin-bottom: 50px;\n  position: relative;\n}\n.timeline:before {\n  background-color: #e2e7f1;\n  bottom: 0;\n  content: \"\";\n  left: 50%;\n  position: absolute;\n  top: 30px;\n  width: 2px;\n  z-index: 0;\n}\n.timeline .time-show {\n  margin-bottom: 30px;\n  margin-top: 30px;\n  position: relative;\n  text-align: center;\n}\n.timeline .timeline-box {\n  display: block;\n  position: relative;\n  padding: 20px;\n}\n.timeline .timeline-album {\n  margin-top: 12px;\n}\n.timeline .timeline-album a {\n  display: inline-block;\n  margin-right: 5px;\n}\n.timeline .timeline-album img {\n  height: 36px;\n  width: auto;\n  border-radius: 3px;\n}\n\n@media (min-width: 768px) {\n  .timeline .time-show {\n    right: 69px;\n  }\n  .timeline .timeline-box {\n    margin-left: 15px;\n  }\n  .timeline .timeline-icon {\n    background: #5369f8;\n    border-radius: 50%;\n    display: block;\n    height: 20px;\n    left: -24px;\n    margin-top: -10px;\n    position: absolute;\n    text-align: center;\n    top: 15%;\n    width: 20px;\n    border: 5px solid #fff;\n    z-index: 9;\n  }\n  .timeline .timeline-icon:before {\n    content: \"\";\n    position: absolute;\n    height: 3px;\n    width: 19px;\n    background-color: #e2e7f1;\n    left: 15px;\n    top: 3px;\n  }\n  .timeline .timeline-desk {\n    display: table-cell;\n    vertical-align: top;\n    width: 50%;\n  }\n  .timeline-item {\n    display: flex;\n  }\n  .timeline-item:before {\n    content: \"\";\n    display: block;\n    width: 50%;\n  }\n  .timeline-item.timeline-item-left:after {\n    content: \"\";\n    display: block;\n    width: 50%;\n  }\n  .timeline-item.timeline-item-left .timeline-desk .album {\n    float: right;\n    margin-top: 20px;\n  }\n  .timeline-item.timeline-item-left .timeline-desk .album a {\n    float: right;\n    margin-left: 5px;\n  }\n  .timeline-item.timeline-item-left .timeline-icon {\n    left: auto;\n    right: -26px;\n  }\n  .timeline-item.timeline-item-left .timeline-icon:before {\n    left: auto;\n    right: 15px;\n  }\n  .timeline-item.timeline-item-left:before {\n    display: none;\n  }\n  .timeline-item.timeline-item-left .timeline-box {\n    margin-right: 15px;\n    margin-left: 0;\n    text-align: right;\n  }\n}\n@media (max-width: 575.98px) {\n  .timeline .time-show {\n    position: relative;\n  }\n  .timeline .event-date {\n    float: left !important;\n    margin-right: 1.5rem;\n    margin-left: 0 !important;\n  }\n  .timeline .timeline-icon {\n    display: none;\n  }\n}\nsection.bg-body {\n  background-color: #ffffff !important;\n}\n\n.navbar.nav-sticky {\n  background-color: #fff;\n}\n\n.section-eyebrow {\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 1.5px;\n  color: #f0611b;\n  margin: 0 auto 10px;\n  text-transform: uppercase;\n}\n\n.section-title {\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-weight: 800;\n  font-size: 2.4rem;\n  color: #101828;\n  margin: 0 auto 12px;\n  line-height: 1.2;\n}\n@media (max-width: 576px) {\n  .section-title {\n    font-size: 1.6rem;\n  }\n}\n\n.section-subtitle,\n.section-description {\n  display: block;\n  width: 100%;\n  max-width: 720px;\n  text-align: center;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-weight: 400;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: #475467;\n  margin: 0 auto 40px;\n}\n@media (max-width: 576px) {\n  .section-subtitle,\n  .section-description {\n    font-size: 0.88rem;\n    margin-bottom: 28px;\n  }\n}\n\n.visionaries-header,\n.sports-categories-header {\n  max-width: 720px;\n  margin: 0 auto 40px;\n  text-align: center;\n}\n\n.hero-banner {\n  position: relative;\n  overflow: hidden;\n  height: 420px;\n}\n.hero-banner .carousel,\n.hero-banner .carousel-inner,\n.hero-banner .carousel-item {\n  height: 100%;\n}\n.hero-banner__slide {\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n}\n.hero-banner__slide-img {\n  display: none;\n}\n.hero-banner__overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background: linear-gradient(100deg, rgba(80, 15, 15, 0.88) 0%, rgba(90, 20, 20, 0.7) 30%, rgba(20, 51, 94, 0.35) 60%, rgba(20, 51, 94, 0.1) 100%);\n  pointer-events: none;\n}\n.hero-banner__content {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  color: #ffffff;\n  padding: 24px 20px;\n  max-width: 640px;\n}\n.hero-banner__title {\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 1.5rem;\n  line-height: 1.25;\n  margin-bottom: 10px;\n}\n.hero-banner__copy {\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.5;\n  margin-bottom: 10px;\n}\n.hero-banner__stats {\n  font-weight: 700;\n  font-size: 0.78rem;\n  color: #ffd399;\n  margin-bottom: 16px;\n}\n.hero-banner__cta {\n  display: inline-flex;\n  align-self: flex-start;\n  align-items: center;\n  gap: 8px;\n  background: #ffffff;\n  color: #14335e;\n  font-weight: 700;\n  font-size: 0.8rem;\n  text-decoration: none;\n  padding: 10px 18px;\n  border-radius: 10px;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.hero-banner__cta:hover {\n  color: #14335e;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n}\n@media (min-width: 768px) {\n  .hero-banner {\n    height: 480px;\n  }\n  .hero-banner__content {\n    padding: 40px 48px;\n  }\n  .hero-banner__title {\n    font-size: 2.2rem;\n  }\n  .hero-banner__copy {\n    font-size: 0.95rem;\n    margin-bottom: 14px;\n  }\n  .hero-banner__stats {\n    font-size: 0.9rem;\n    margin-bottom: 22px;\n  }\n  .hero-banner__cta {\n    font-size: 0.9rem;\n    padding: 12px 22px;\n  }\n}\n@media (min-width: 1200px) {\n  .hero-banner {\n    height: 560px;\n  }\n  .hero-banner__title {\n    font-size: 2.6rem;\n  }\n}\n\n.notice-marquee {\n  display: flex;\n  align-items: stretch;\n  background: #fff4ea;\n  border-bottom: 1px solid #f3d9bd;\n}\n.notice-marquee__label {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #14335e;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 0.85rem;\n  letter-spacing: 0.3px;\n  padding: 10px 18px;\n}\n.notice-marquee__label i {\n  font-size: 1rem;\n  color: #ff8a3d;\n}\n.notice-marquee__link {\n  display: inline-flex;\n  text-decoration: none;\n  color: inherit;\n}\n.notice-marquee__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: 40px;\n  color: #7a2e10;\n  font-weight: 600;\n  font-size: 0.85rem;\n  white-space: nowrap;\n}\n.notice-marquee__badge {\n  flex-shrink: 0;\n  background: #f0611b;\n  color: #ffffff;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  padding: 2px 7px;\n  border-radius: 4px;\n}\n@media (max-width: 576px) {\n  .notice-marquee__label {\n    padding: 8px 12px;\n    font-size: 0.78rem;\n  }\n  .notice-marquee__item {\n    font-size: 0.78rem;\n    margin-right: 28px;\n  }\n}\n\n.circles {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.circles li {\n  position: absolute;\n  display: block;\n  list-style: none;\n  width: 20px;\n  height: 20px;\n  background: rgba(181, 182, 199, 0.1);\n  animation: animate 25s linear infinite;\n  bottom: -150px;\n}\n\n.circles li:nth-child(1) {\n  left: 25%;\n  width: 80px;\n  height: 80px;\n  animation-delay: 0s;\n}\n\n.circles li:nth-child(2) {\n  left: 10%;\n  width: 20px;\n  height: 20px;\n  animation-delay: 2s;\n  animation-duration: 12s;\n}\n\n.circles li:nth-child(3) {\n  left: 70%;\n  width: 20px;\n  height: 20px;\n  animation-delay: 4s;\n}\n\n.circles li:nth-child(4) {\n  left: 40%;\n  width: 60px;\n  height: 60px;\n  animation-delay: 0s;\n  animation-duration: 18s;\n}\n\n.circles li:nth-child(5) {\n  left: 65%;\n  width: 20px;\n  height: 20px;\n  animation-delay: 0s;\n}\n\n.circles li:nth-child(6) {\n  left: 75%;\n  width: 110px;\n  height: 110px;\n  animation-delay: 3s;\n}\n\n.circles li:nth-child(7) {\n  left: 35%;\n  width: 150px;\n  height: 150px;\n  animation-delay: 7s;\n}\n\n.circles li:nth-child(8) {\n  left: 50%;\n  width: 25px;\n  height: 25px;\n  animation-delay: 15s;\n  animation-duration: 45s;\n}\n\n.circles li:nth-child(9) {\n  left: 20%;\n  width: 15px;\n  height: 15px;\n  animation-delay: 2s;\n  animation-duration: 35s;\n}\n\n.circles li:nth-child(10) {\n  left: 85%;\n  width: 150px;\n  height: 150px;\n  animation-delay: 0s;\n  animation-duration: 11s;\n}\n\n@keyframes animate {\n  0% {\n    transform: translateY(0) rotate(0);\n    opacity: 1;\n    border-radius: 0;\n  }\n  100% {\n    transform: translateY(-1000px) rotate(720deg);\n    opacity: 0;\n    border-radius: 50%;\n  }\n}\n.fs-44 {\n  font-size: 44px;\n}\n\n.animate {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n  -webkit-transition: 0.3s ease-in-out;\n  transition: 0.3s ease-in-out;\n}\n\n.animate:hover {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n\n.gov-topbar {\n  background: linear-gradient(to right, #9e3b32, #14335e);\n  padding: 6px 0;\n  font-size: 0.85rem;\n  color: #ffffff;\n}\n.gov-topbar .gov-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 400;\n}\n.gov-topbar .gov-topbar-left .gov-hindi {\n  font-weight: 600;\n}\n.gov-topbar .gov-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.gov-topbar .gov-topbar-right a,\n.gov-topbar .gov-topbar-right .gov-lang,\n.gov-topbar .gov-topbar-right .gov-accessibility-btn {\n  color: #ffffff;\n  text-decoration: none;\n  white-space: nowrap;\n}\n.gov-topbar .gov-topbar-right a:hover,\n.gov-topbar .gov-topbar-right .gov-lang:hover,\n.gov-topbar .gov-topbar-right .gov-accessibility-btn:hover {\n  color: #f0f0f0;\n  text-decoration: underline;\n}\n.gov-topbar .gov-topbar-right .gov-accessibility-btn {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: inherit;\n  cursor: pointer;\n}\n.gov-topbar .gov-topbar-right .gov-divider {\n  color: rgba(255, 255, 255, 0.6);\n}\n.gov-topbar .gov-topbar-right .gov-lang {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n}\n@media (max-width: 576px) {\n  .gov-topbar {\n    font-size: 0.7rem;\n    padding: 5px 0;\n    text-align: center;\n  }\n  .gov-topbar > .container-fluid, .gov-topbar > .container-sm, .gov-topbar > .container-md, .gov-topbar > .container-lg, .gov-topbar > .container-xl, .gov-topbar > .container-xxl {\n    flex-direction: column;\n    row-gap: 4px;\n  }\n  .gov-topbar .gov-topbar-left,\n  .gov-topbar .gov-topbar-right {\n    justify-content: center;\n    width: 100%;\n  }\n}\n\n.main-navbar {\n  background: #ffffff !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n@media (max-width: 576px) {\n  .main-navbar > .container-fluid, .main-navbar > .container-sm, .main-navbar > .container-md, .main-navbar > .container-lg, .main-navbar > .container-xl, .main-navbar > .container-xxl {\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n}\n.main-navbar .navbar-brand-logo {\n  height: 68px;\n  width: auto;\n}\n@media (max-width: 576px) {\n  .main-navbar .navbar-brand-logo {\n    height: 50px;\n  }\n}\n.main-navbar .navbar-brand-mashaal {\n  gap: 12px;\n}\n.main-navbar .navbar-brand-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n}\n.main-navbar .navbar-brand-text__title {\n  font-weight: 800;\n  font-size: 1.5rem;\n  color: #101828;\n}\n.main-navbar .navbar-brand-text__subtitle {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: #101828;\n}\n@media (max-width: 576px) {\n  .main-navbar .navbar-brand-text__title {\n    font-size: 1.1rem;\n  }\n  .main-navbar .navbar-brand-text__subtitle {\n    font-size: 0.72rem;\n  }\n}\n.main-navbar .main-nav-link {\n  color: #1a1a1a !important;\n  font-weight: 600;\n  font-size: 0.95rem;\n  letter-spacing: 0.2px;\n  padding: 0.5rem 0.9rem !important;\n  text-transform: uppercase;\n}\n.main-navbar .main-nav-link:hover, .main-navbar .main-nav-link:focus {\n  color: #14335e !important;\n}\n.main-navbar .main-nav-link.active {\n  color: #14335e !important;\n  position: relative;\n}\n.main-navbar .main-nav-link.active::after {\n  content: \"\";\n  position: absolute;\n  left: 0.9rem;\n  right: 0.9rem;\n  bottom: 0.15rem;\n  height: 2px;\n  background: #f0611b;\n  border-radius: 1px;\n}\n.main-navbar .main-nav-dropdown-toggle {\n  color: #1a1a1a;\n  font-weight: 600;\n  font-size: 0.95rem;\n  background: none;\n  border: none;\n  padding: 0.5rem 0.9rem;\n  display: inline-flex;\n  align-items: center;\n  text-transform: uppercase;\n}\n.main-navbar .main-nav-dropdown-toggle:hover, .main-navbar .main-nav-dropdown-toggle:focus {\n  color: #14335e;\n}\n.main-navbar .main-nav-dropdown-toggle::after {\n  display: none;\n}\n.main-navbar .main-nav-dropdown-toggle--download {\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  padding: 0.4rem 0.9rem;\n  gap: 8px;\n}\n.main-navbar .main-nav-dropdown-toggle__icon {\n  font-size: 1rem;\n  color: #f0611b;\n}\n.main-navbar .main-nav-dropdown-toggle__caret {\n  font-size: 1.1rem;\n  margin-left: 2px;\n  transition: transform 0.15s ease;\n}\n.main-navbar .main-nav-dropdown-toggle.show .main-navbar .main-nav-dropdown-toggle__caret {\n  transform: rotate(180deg);\n}\n.main-navbar .dropdown-menu .dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n}\n.main-navbar .dropdown-menu .dropdown-item i {\n  color: #14335e;\n  font-size: 0.95rem;\n}\n.main-navbar .navbar-toggler {\n  border: none;\n  box-shadow: none !important;\n  color: #14335e;\n}\n@media (max-width: 991.98px) {\n  .main-navbar .main-nav-link,\n  .main-navbar .main-nav-dropdown-toggle {\n    padding: 0.6rem 0 !important;\n  }\n  .main-navbar .main-nav-link.active::after {\n    left: 0;\n    right: 0;\n  }\n}\n\n.visionaries-section {\n  padding: 60px 0;\n}\n.visionaries-section .visionaries-header {\n  margin-bottom: 40px;\n}\n.visionaries-section .visionaries-eyebrow {\n  display: block;\n  color: #14335e;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 1px;\n  margin-bottom: 8px;\n}\n.visionaries-section .visionaries-title {\n  font-weight: 800;\n  font-size: 2rem;\n  color: #101828;\n  margin-bottom: 0;\n}\n.visionaries-section .visionary-card {\n  width: 100%;\n  max-width: 320px;\n  margin: 0 auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #ffffff;\n}\n.visionaries-section .visionary-card__photo {\n  width: 100%;\n  height: 260px;\n  background-image: linear-gradient(to bottom, #ffffff 0%, #ffffff 45%, var(--visionary-band-color) 45%, var(--visionary-band-color) 100%);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n.visionaries-section .visionary-card__photo img {\n  max-width: 78%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  display: block;\n}\n.visionaries-section .visionary-card__info {\n  padding: 18px 16px 22px;\n  text-align: center;\n  background: #ffffff;\n}\n.visionaries-section .visionary-card__info h3, .visionaries-section .visionary-card__info .h3 {\n  font-weight: 700;\n  font-size: 1.05rem;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  color: #e8720c;\n  margin-bottom: 6px;\n}\n.visionaries-section .visionary-card__info p {\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  text-transform: uppercase;\n  color: #1f2937;\n  margin-bottom: 0;\n}\n.visionaries-section .visionary-card--peach {\n  --visionary-band-color: #fbe3cf;\n}\n.visionaries-section .visionary-card--blue {\n  --visionary-band-color: #dbeafe;\n}\n.visionaries-section .visionary-card--pink {\n  --visionary-band-color: #f6def0;\n}\n@media (max-width: 991.98px) {\n  .visionaries-section .visionary-card__photo {\n    height: 230px;\n  }\n}\n@media (max-width: 576px) {\n  .visionaries-section {\n    padding: 40px 0;\n  }\n  .visionaries-section .visionaries-title {\n    font-size: 1.5rem;\n  }\n  .visionaries-section .visionary-card {\n    max-width: 280px;\n  }\n  .visionaries-section .visionary-card__photo {\n    height: 210px;\n  }\n  .visionaries-section .visionary-card__info {\n    padding: 14px 14px 18px;\n  }\n  .visionaries-section .visionary-card__info h3, .visionaries-section .visionary-card__info .h3 {\n    font-size: 0.95rem;\n  }\n  .visionaries-section .visionary-card__info p {\n    font-size: 0.75rem;\n  }\n}\n\n.battery-videos-section {\n  padding: 60px 0;\n}\n.battery-videos-section .battery-video-card {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16/9;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #000;\n  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.08);\n}\n.battery-videos-section .battery-video-card__player {\n  position: absolute;\n  inset: 0;\n}\n.battery-videos-section .battery-video-card__player video,\n.battery-videos-section .battery-video-card__player iframe,\n.battery-videos-section .battery-video-card__player > div {\n  border-radius: 12px;\n}\n.battery-videos-section .battery-video-card__play {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(20, 51, 90, 0.85);\n  color: #ffffff;\n  font-size: 1.4rem;\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n.battery-videos-section .battery-video-card__play i {\n  margin-left: 3px;\n}\n.battery-videos-section .battery-video-card:hover .battery-video-card__play {\n  background: #e8720c;\n  transform: scale(1.08);\n}\n.battery-videos-section .battery-video-card__label {\n  margin: 10px 0 0;\n  text-align: center;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n@media (max-width: 576px) {\n  .battery-videos-section {\n    padding: 40px 0;\n  }\n  .battery-videos-section .visionaries-title {\n    font-size: 1.5rem;\n  }\n}\n\n.mashaal-scheme-section {\n  padding: 40px 0;\n  scroll-margin-top: 140px;\n}\n@media (max-width: 576px) {\n  .mashaal-scheme-section {\n    scroll-margin-top: 100px;\n  }\n}\n.mashaal-scheme-section .mashaal-scheme-image {\n  border-radius: 20px;\n  overflow: hidden;\n}\n.mashaal-scheme-section .mashaal-scheme-image img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n.mashaal-scheme-section .mashaal-scheme-panel {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  background: #0e1f45;\n  padding: 36px 24px;\n}\n@media (min-width: 768px) {\n  .mashaal-scheme-section .mashaal-scheme-panel {\n    padding: 48px 56px;\n  }\n}\n.mashaal-scheme-section .mashaal-scheme-intro {\n  max-width: 780px;\n  margin: 0 auto 34px;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n.mashaal-scheme-section .mashaal-scheme-tag {\n  display: inline-block;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-weight: 700;\n  font-size: 0.85rem;\n  letter-spacing: 2px;\n  color: #ffffff;\n  margin-bottom: 12px;\n}\n.mashaal-scheme-section .mashaal-scheme-heading {\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 2.2rem;\n  line-height: 1.15;\n  margin-bottom: 14px;\n}\n.mashaal-scheme-section .mashaal-scheme-heading span {\n  color: #ff8a3d;\n}\n.mashaal-scheme-section .mashaal-scheme-copy {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 0.95rem;\n  line-height: 1.65;\n  margin-bottom: 0;\n}\n.mashaal-scheme-section .mashaal-scheme-components {\n  min-width: 0;\n  text-align: center;\n}\n.mashaal-scheme-section .mashaal-pathway-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 1.15rem;\n  margin-bottom: 30px;\n}\n.mashaal-scheme-section .mashaal-pathway-title span {\n  display: block;\n  width: 40px;\n  height: 1px;\n  background: rgba(255, 138, 61, 0.6);\n}\n.mashaal-scheme-section .mashaal-pathway {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 30px;\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway {\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: center;\n    gap: 90px;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__chain {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__chain {\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: center;\n    gap: 0;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__link {\n  position: relative;\n  text-align: center;\n  width: 100%;\n  max-width: 260px;\n  padding: 20px 18px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #1c3b7a 0%, #16305f 100%);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link {\n    width: 176px;\n    min-height: 240px;\n    max-width: none;\n    padding: 24px 20px 20px 34px;\n    border: none;\n    border-radius: 0;\n    clip-path: polygon(0 0, calc(100% - 26px) 0, 100% 50%, calc(100% - 26px) 100%, 0 100%, 26px 50%);\n    margin-left: -26px;\n  }\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link--first {\n    padding-left: 20px;\n    clip-path: polygon(0 0, calc(100% - 26px) 0, 100% 50%, calc(100% - 26px) 100%, 0 100%);\n    margin-left: 0;\n    border-radius: 16px 0 0 16px;\n  }\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link--last {\n    padding-right: 20px;\n    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 26px 50%);\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__link h4, .mashaal-scheme-section .mashaal-pathway__link .h4 {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 0.85rem;\n  margin: 3px 0 12px;\n}\n.mashaal-scheme-section .mashaal-pathway__link p {\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 0.72rem;\n  line-height: 1.4;\n  margin-bottom: 0;\n}\n.mashaal-scheme-section .mashaal-pathway__link--1 {\n  background: linear-gradient(180deg, #2563eb 0%, #14335e 100%);\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link--1 {\n    z-index: 4;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__link--2 {\n  background: linear-gradient(180deg, rgb(34.4117647059%, 38.6274509804%, 71.7647058824%) 0%, rgb(24.9019607843%, 21.3725490196%, 28.8235294118%) 100%);\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link--2 {\n    z-index: 3;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__link--3 {\n  background: linear-gradient(180deg, rgb(54.3137254902%, 38.431372549%, 51.3725490196%) 0%, #6b3a35 100%);\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link--3 {\n    z-index: 2;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__link--4 {\n  background: linear-gradient(180deg, rgb(74.2156862745%, 38.2352941176%, 30.9803921569%) 0%, rgb(59.0196078431%, 24.1176470588%, 12.7450980392%) 100%);\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link--4 {\n    z-index: 1;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__link--5 {\n  background: linear-gradient(180deg, #f0611b 0%, #c2410c 100%);\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__link--5 {\n    z-index: 0;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  color: #ffffff;\n  font-size: 1.25rem;\n  margin: 0 auto 12px;\n}\n.mashaal-scheme-section .mashaal-pathway__index {\n  display: block;\n  color: #ff8a3d;\n  font-weight: 800;\n  font-size: 0.68rem;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n.mashaal-scheme-section .mashaal-pathway__arrow {\n  display: none;\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    right: -13px;\n    transform: translateY(-50%);\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    background: #ff8a3d;\n    color: #0a1a3d;\n    font-size: 0.9rem;\n    z-index: 10;\n    box-shadow: 0 0 0 4px #0e1f45;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__branches {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  width: 100%;\n  max-width: 280px;\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__branches {\n    max-width: 240px;\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__branch-trunk {\n  display: none;\n}\n@media (min-width: 992px) {\n  .mashaal-scheme-section .mashaal-pathway__branch-trunk {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: -90px;\n    width: 90px;\n    height: 100%;\n    pointer-events: none;\n  }\n  .mashaal-scheme-section .mashaal-pathway__branch-trunk::before, .mashaal-scheme-section .mashaal-pathway__branch-trunk::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    width: 55px;\n    height: 55px;\n    border: 3px solid #f0611b;\n    border-right: none;\n  }\n  .mashaal-scheme-section .mashaal-pathway__branch-trunk::before {\n    top: 50%;\n    border-bottom: none;\n    border-radius: 14px 0 0 0;\n    transform: translateY(-100%);\n  }\n  .mashaal-scheme-section .mashaal-pathway__branch-trunk::after {\n    bottom: 50%;\n    border-top: none;\n    border-radius: 0 0 0 14px;\n    transform: translateY(100%);\n  }\n}\n.mashaal-scheme-section .mashaal-pathway__branch-card {\n  position: relative;\n  text-align: center;\n  padding: 18px 16px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 138, 61, 0.4);\n}\n.mashaal-scheme-section .mashaal-pathway__branch-card h4, .mashaal-scheme-section .mashaal-pathway__branch-card .h4 {\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 0.9rem;\n  margin: 4px 0 10px;\n}\n.mashaal-scheme-section .mashaal-pathway__branch-card p {\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 0.76rem;\n  line-height: 1.5;\n  margin-bottom: 0;\n}\n.mashaal-scheme-section .mashaal-pathway__branch-card .mashaal-pathway__icon {\n  background: rgba(240, 97, 27, 0.2);\n  color: #ff8a3d;\n}\n.mashaal-scheme-section .mashaal-pathway-footer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  color: rgba(255, 255, 255, 0.55);\n  font-weight: 600;\n  font-size: 0.78rem;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  margin: 10px 0 0;\n}\n.mashaal-scheme-section .mashaal-pathway-footer span {\n  display: block;\n  width: 40px;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.25);\n}\n@media (max-width: 576px) {\n  .mashaal-scheme-section {\n    padding: 30px 0;\n  }\n  .mashaal-scheme-section .mashaal-scheme-panel {\n    border-radius: 14px;\n  }\n  .mashaal-scheme-section .mashaal-scheme-heading {\n    font-size: 1.8rem;\n  }\n  .mashaal-scheme-section .mashaal-scheme-copy {\n    font-size: 0.88rem;\n  }\n}\n\n.associations-section {\n  padding: 60px 0;\n}\n.associations-section .associations-header {\n  max-width: 720px;\n  margin: 0 auto 44px;\n}\n.associations-section .associations-eyebrow {\n  display: block;\n  color: #f0611b;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n}\n.associations-section .associations-title {\n  font-weight: 800;\n  font-size: 2.4rem;\n  color: #101828;\n  margin-bottom: 14px;\n}\n.associations-section .associations-subtitle {\n  color: #667085;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin-bottom: 0;\n}\n.associations-section .associations-grid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 48px;\n}\n.associations-section .associations-grid__item {\n  flex: 0 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 90px;\n}\n.associations-section .associations-grid__item img {\n  max-height: 90px;\n  max-width: 200px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  filter: grayscale(15%);\n  transition: filter 0.2s ease, transform 0.2s ease;\n}\n.associations-section .associations-grid__item img:hover {\n  filter: grayscale(0%);\n  transform: scale(1.04);\n}\n@media (max-width: 576px) {\n  .associations-section {\n    padding: 40px 0;\n  }\n  .associations-section .associations-title {\n    font-size: 1.6rem;\n  }\n  .associations-section .associations-subtitle {\n    font-size: 0.9rem;\n  }\n  .associations-section .associations-grid {\n    gap: 28px;\n  }\n  .associations-section .associations-grid__item {\n    height: 60px;\n  }\n  .associations-section .associations-grid__item img {\n    max-height: 60px;\n    max-width: 140px;\n  }\n}\n\n.our-journey-section {\n  padding: 60px 0;\n}\n.our-journey-section .our-journey-panel {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 20px;\n  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.06);\n  padding: 40px 36px;\n}\n.our-journey-section .our-journey-header {\n  max-width: 640px;\n  margin: 0 auto 32px;\n}\n.our-journey-section .our-journey-eyebrow {\n  display: block;\n  color: #f0611b;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n}\n.our-journey-section .our-journey-title {\n  font-weight: 800;\n  font-size: 2.4rem;\n  color: #101828;\n  margin-bottom: 10px;\n}\n.our-journey-section .our-journey-subtitle {\n  color: #667085;\n  font-size: 0.95rem;\n  margin-bottom: 0;\n}\n.our-journey-section .our-journey-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n  margin-bottom: 18px;\n}\n.our-journey-section .journey-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: 14px;\n  padding: 20px 22px;\n  background: var(--journey-tint);\n  border: 1px solid var(--journey-border);\n}\n.our-journey-section .journey-card__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n  color: var(--journey-accent);\n  font-size: 1.2rem;\n  margin-bottom: 14px;\n}\n.our-journey-section .journey-card__icon--footer {\n  background: rgba(255, 255, 255, 0.7);\n  color: #6d28d9;\n}\n.our-journey-section .journey-card__value {\n  font-weight: 800;\n  font-size: 1.6rem;\n  color: var(--journey-accent);\n  line-height: 1.2;\n}\n.our-journey-section .journey-card__label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #344054;\n  margin-top: 4px;\n}\n.our-journey-section .journey-card::after {\n  content: \"\";\n  position: absolute;\n  left: 22px;\n  bottom: 14px;\n  width: 26px;\n  height: 3px;\n  border-radius: 2px;\n  background: var(--journey-accent);\n}\n.our-journey-section .journey-card--blue {\n  --journey-tint: #eff6ff;\n  --journey-border: #dbeafe;\n  --journey-accent: #2563eb;\n}\n.our-journey-section .journey-card--green {\n  --journey-tint: #ecfdf5;\n  --journey-border: #d1fae5;\n  --journey-accent: #059669;\n}\n.our-journey-section .journey-card--purple {\n  --journey-tint: #f5f3ff;\n  --journey-border: #ede9fe;\n  --journey-accent: #7c3aed;\n}\n.our-journey-section .journey-card--amber {\n  --journey-tint: #fffbeb;\n  --journey-border: #fef3c7;\n  --journey-accent: #d97706;\n}\n.our-journey-section .journey-card--red {\n  --journey-tint: #fef2f2;\n  --journey-border: #fee2e2;\n  --journey-accent: #dc2626;\n}\n.our-journey-section .journey-card--teal {\n  --journey-tint: #f0fdfa;\n  --journey-border: #ccfbf1;\n  --journey-accent: #0d9488;\n}\n.our-journey-section .our-journey-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n  background: linear-gradient(90deg, #f5f3ff 0%, #ede9fe 100%);\n  border: 1px solid #ede9fe;\n  border-radius: 14px;\n  padding: 22px 26px;\n}\n.our-journey-section .our-journey-footer__stat {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex: 1 1 200px;\n}\n.our-journey-section .our-journey-footer__message {\n  flex: 1 1 260px;\n  text-align: center;\n}\n.our-journey-section .our-journey-footer__message h4, .our-journey-section .our-journey-footer__message .h4 {\n  font-weight: 700;\n  font-size: 1rem;\n  color: #101828;\n  margin-bottom: 4px;\n}\n.our-journey-section .our-journey-footer__message p {\n  font-size: 0.85rem;\n  color: #667085;\n  margin-bottom: 0;\n}\n.our-journey-section .our-journey-footer__trend {\n  flex: 0 0 auto;\n  font-size: 2rem;\n  color: #7c3aed;\n  opacity: 0.6;\n}\n@media (max-width: 991.98px) {\n  .our-journey-section .our-journey-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 576px) {\n  .our-journey-section {\n    padding: 40px 0;\n  }\n  .our-journey-section .our-journey-panel {\n    padding: 26px 18px;\n    border-radius: 16px;\n  }\n  .our-journey-section .our-journey-title {\n    font-size: 1.5rem;\n  }\n  .our-journey-section .our-journey-grid {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n  .our-journey-section .our-journey-footer {\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n  }\n  .our-journey-section .our-journey-footer__message {\n    text-align: left;\n  }\n  .our-journey-section .our-journey-footer__trend {\n    display: none;\n  }\n}\n\n.sports-categories-section {\n  padding: 50px 0;\n}\n\n.sports-categories {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  gap: 14px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n}\n\n.sports-group {\n  flex: 1 1 0;\n  min-width: 150px;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.08);\n  background: #ffffff;\n}\n.sports-group--athletics {\n  flex: 2.3 2.3 0;\n  min-width: 400px;\n}\n.sports-group--cycling {\n  flex: 1 1 0;\n  min-width: 200px;\n}\n.sports-group__header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  color: #ffffff;\n  font-weight: 800;\n  font-size: 0.85rem;\n  letter-spacing: 0.5px;\n  white-space: nowrap;\n}\n.sports-group__header i {\n  font-size: 1.1rem;\n}\n.sports-group__events {\n  display: flex;\n  flex-wrap: nowrap;\n  height: 100%;\n}\n.sports-group--athletics .sports-group__header {\n  background: #14335e;\n}\n.sports-group--cycling .sports-group__header {\n  background: #14532d;\n}\n.sports-group--kabaddi .sports-group__header {\n  background: #c2410c;\n}\n.sports-group--football .sports-group__header {\n  background: #166534;\n}\n.sports-group--volleyball .sports-group__header {\n  background: #5b21b6;\n}\n.sports-group--athletics .sports-event {\n  background: #eaf1fb;\n  border-color: #d3e2f5;\n}\n.sports-group--cycling .sports-event {\n  background: #eaf6ee;\n  border-color: #d3ecdc;\n}\n.sports-group--kabaddi .sports-event {\n  background: #fdeee3;\n  border-color: #fad9c1;\n}\n.sports-group--football .sports-event {\n  background: #eaf6ee;\n  border-color: #d3ecdc;\n}\n.sports-group--volleyball .sports-event {\n  background: #f1eafb;\n  border-color: #ded0f5;\n}\n\n.sports-event {\n  flex: 1 1 0;\n  min-width: 78px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 12px 6px 14px;\n  border-right: 1px solid;\n}\n.sports-event:last-child {\n  border-right: none;\n}\n.sports-event__label {\n  font-weight: 700;\n  font-size: 0.72rem;\n  color: #101828;\n  min-height: 32px;\n}\n.sports-event__age {\n  display: block;\n  font-weight: 600;\n  font-size: 0.66rem;\n  color: #475467;\n}\n.sports-event__icon {\n  font-size: 1.8rem;\n  color: inherit;\n  margin: 10px 0;\n  line-height: 1;\n}\n.sports-event__divider {\n  display: block;\n  width: 70%;\n  border-top: 1px dashed #98a2b3;\n  margin-bottom: 8px;\n}\n.sports-event__gender-icons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  font-size: 1.1rem;\n  margin-bottom: 4px;\n}\n.sports-event__gender-icons .icofont-male {\n  color: #1d4ed8;\n}\n.sports-event__gender-icons .icofont-female {\n  color: #db2777;\n}\n.sports-event__gender-label {\n  font-weight: 600;\n  font-size: 0.75rem;\n  color: #344054;\n}\n\n.sports-group--athletics .sports-event__icon {\n  color: #14335e;\n}\n\n.sports-group--cycling .sports-event__icon {\n  color: #14532d;\n}\n\n.sports-group--kabaddi .sports-event__icon {\n  color: #c2410c;\n}\n\n.sports-group--football .sports-event__icon {\n  color: #166534;\n}\n\n.sports-group--volleyball .sports-event__icon {\n  color: #5b21b6;\n}\n\n@media (min-width: 992px) {\n  .sports-categories {\n    overflow-x: visible;\n  }\n  .sports-group {\n    min-width: 0;\n  }\n  .sports-group--athletics {\n    min-width: 0;\n  }\n  .sports-group--cycling {\n    min-width: 0;\n  }\n  .sports-group__header {\n    padding: 14px 12px;\n    font-size: 1rem;\n  }\n  .sports-group__header i {\n    font-size: 1.3rem;\n  }\n  .sports-event {\n    min-width: 0;\n    padding: 16px 10px 18px;\n  }\n  .sports-event__label {\n    font-size: 0.85rem;\n    min-height: 40px;\n  }\n  .sports-event__age {\n    font-size: 0.78rem;\n  }\n  .sports-event__icon {\n    font-size: 2.6rem;\n    margin: 14px 0;\n  }\n}\n/* ==========================================================================\n   Mashaal Modern Responsive Footer\n   ========================================================================== */\n.mashaal-footer {\n  background-color: #0b1325;\n  padding: 48px 0 24px 0;\n  color: #cbd5e1;\n  position: relative;\n  z-index: 10;\n}\n.mashaal-footer__widgets {\n  row-gap: 24px;\n  align-items: flex-start;\n}\n.mashaal-footer__col--brand {\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 992px) {\n  .mashaal-footer__col--links {\n    padding-left: 2rem;\n  }\n}\n@media (min-width: 992px) {\n  .mashaal-footer__col--helpdesk {\n    padding-left: 1rem;\n  }\n}\n.mashaal-footer__brand-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n.mashaal-footer__mascot {\n  height: 84px;\n  width: auto;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n.mashaal-footer__brand-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.mashaal-footer__brand-title {\n  color: #ffffff;\n  font-size: 1.32rem;\n  font-weight: 800;\n  line-height: 1.15;\n  margin: 0 0 3px 0;\n  letter-spacing: -0.2px;\n}\n.mashaal-footer__brand-subtitle {\n  color: #ffffff;\n  font-size: 0.86rem;\n  font-weight: 600;\n  line-height: 1.2;\n  margin: 0;\n  opacity: 0.95;\n}\n.mashaal-footer__brand-desc {\n  color: #94a3b8;\n  font-size: 0.85rem;\n  line-height: 1.55;\n  margin: 0;\n  max-width: 320px;\n}\n.mashaal-footer__title {\n  color: #ffffff;\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0 0 16px 0;\n  letter-spacing: 0.2px;\n}\n.mashaal-footer__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.mashaal-footer__item {\n  margin-bottom: 8px;\n  font-size: 0.85rem;\n  line-height: 1.45;\n}\n.mashaal-footer__item:last-child {\n  margin-bottom: 0;\n}\n.mashaal-footer__item--info {\n  margin-top: 10px;\n  margin-bottom: 2px;\n}\n.mashaal-footer__text {\n  color: #94a3b8;\n  display: inline-block;\n}\n.mashaal-footer__link {\n  color: #94a3b8;\n  text-decoration: none;\n  transition: color 0.2s ease;\n  display: inline-block;\n}\n.mashaal-footer__link:hover {\n  color: #ff8a3d;\n}\n.mashaal-footer__helpdesk-link {\n  color: #ffffff;\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  transition: color 0.2s ease;\n}\n.mashaal-footer__helpdesk-link:hover {\n  color: #ff8a3d;\n}\n.mashaal-footer__divider {\n  height: 1px;\n  width: 100%;\n  background: linear-gradient(90deg, #1e40af 0%, #2563eb 20%, #3b82f6 50%, #2563eb 80%, #1e40af 100%);\n  box-shadow: 0 0 10px rgba(37, 99, 235, 0.6), 0 0 3px rgba(59, 130, 246, 0.9);\n  margin: 36px 0 20px 0;\n}\n.mashaal-footer__bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.82rem;\n  color: #94a3b8;\n}\n.mashaal-footer__copyright {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 0.82rem;\n}\n.mashaal-footer__privacy {\n  color: #94a3b8;\n  font-size: 0.82rem;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n.mashaal-footer__privacy:hover {\n  color: #ffffff;\n}\n\n@media (max-width: 767.98px) {\n  .mashaal-footer {\n    padding: 36px 0 24px 0;\n  }\n  .mashaal-footer__col--brand {\n    margin-bottom: 8px;\n  }\n  .mashaal-footer__brand-desc {\n    max-width: 100%;\n  }\n  .mashaal-footer__divider {\n    margin: 28px 0 18px 0;\n  }\n  .mashaal-footer__bottom {\n    flex-direction: column;\n    text-align: center;\n    gap: 6px;\n    justify-content: center;\n  }\n  .mashaal-footer__copyright {\n    text-align: center;\n  }\n  .mashaal-footer__privacy {\n    text-align: center;\n  }\n}\n.crc-list-page {\n  background: #f2f4f7;\n  padding: 32px 0 60px;\n  min-height: 60vh;\n}\n\n.crc-list-header {\n  margin-bottom: 20px;\n}\n.crc-list-header h5, .crc-list-header .h5 {\n  font-weight: 700;\n  font-size: 1.15rem;\n  color: #101828;\n  margin-bottom: 2px;\n}\n.crc-list-header p {\n  color: #667085;\n  font-size: 0.9rem;\n  margin-bottom: 0;\n}\n\n.crc-list-filters {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);\n  padding: 16px;\n  margin-bottom: 20px;\n  align-items: center;\n}\n.crc-list-filters .crc-list-select__control {\n  min-height: 38px;\n  border-color: #ced4da;\n  border-radius: 0.375rem;\n}\n.crc-list-filters .crc-list-select__control--is-focused {\n  border-color: #86b7fe !important;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;\n}\n.crc-list-filters .crc-list-select__menu {\n  z-index: 5;\n}\n\n.crc-list-error {\n  background: #fef3f2;\n  color: #b42318;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 0.85rem;\n  margin-bottom: 16px;\n}\n\n.crc-list-table-wrap {\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);\n  overflow-x: auto;\n}\n\n.crc-list-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.88rem;\n}\n.crc-list-table th,\n.crc-list-table td {\n  padding: 12px 16px;\n  text-align: left;\n  white-space: nowrap;\n}\n.crc-list-table thead th {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #667085;\n  border-bottom: 1px solid #eaecf0;\n}\n.crc-list-table tbody tr {\n  border-bottom: 1px solid #f2f4f7;\n}\n.crc-list-table tbody tr:last-child {\n  border-bottom: none;\n}\n.crc-list-table__empty {\n  text-align: center;\n  color: #667085;\n  padding: 32px 16px;\n  white-space: normal;\n}\n\n.crc-list-pagination {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 16px;\n}\n.crc-list-pagination__meta {\n  color: #667085;\n  font-size: 0.85rem;\n}\n.crc-list-pagination__controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.crc-list-pagination__page {\n  color: #101828;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n.crc-list-pagination button {\n  border: 1px solid #d0d5dd;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 6px 14px;\n  font-size: 0.85rem;\n  color: #101828;\n}\n.crc-list-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.crc-list-pagination button:not(:disabled):hover {\n  background: #f2f4f7;\n}\n\n@media (max-width: 768px) {\n  .crc-list-filters {\n    grid-template-columns: 1fr;\n  }\n  .crc-list-pagination {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .crc-list-pagination__controls {\n    justify-content: space-between;\n  }\n}\n.coordinator-trainer-page {\n  background: #f4f6fa;\n  padding: 30px 0 60px;\n  min-height: 75vh;\n}\n\n.coordinator-trainer-hero {\n  background: linear-gradient(135deg, #0f2b4c 0%, #173f6e 100%);\n  border-radius: 16px;\n  padding: 24px 28px;\n  color: #ffffff;\n  box-shadow: 0 8px 24px rgba(15, 43, 76, 0.16);\n}\n.coordinator-trainer-hero .badge-official {\n  background: #f0611b;\n  color: #ffffff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 4px 10px;\n  border-radius: 20px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n.coordinator-trainer-hero .badge-ref-date {\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 20px;\n  backdrop-filter: blur(4px);\n}\n.coordinator-trainer-hero .coordinator-trainer-title {\n  font-size: 1.55rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 6px;\n  letter-spacing: -0.01em;\n}\n.coordinator-trainer-hero .coordinator-trainer-subtitle {\n  font-size: 0.92rem;\n  color: rgba(255, 255, 255, 0.82);\n  margin-bottom: 0;\n  max-width: 600px;\n}\n\n.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills {\n  background: #ffffff;\n  padding: 6px;\n  border-radius: 12px;\n  border: 1px solid #eaecf0;\n  display: inline-flex;\n  gap: 6px;\n  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.04);\n}\n.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn {\n  border-radius: 8px;\n  padding: 10px 22px;\n  font-weight: 700;\n  font-size: 0.92rem;\n  color: #475467;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n}\n.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn i {\n  font-size: 1.15rem;\n}\n.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn:hover {\n  color: #14335e;\n  background: #f8fafc;\n}\n.coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn.active {\n  background: #14335e !important;\n  color: #ffffff !important;\n  box-shadow: 0 3px 8px rgba(20, 51, 94, 0.25);\n}\n\n.coordinator-content-card {\n  background: #ffffff;\n  border-radius: 16px;\n  border: 1px solid #eaecf0;\n}\n.coordinator-content-card .empty-state-icon-circle {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: #f0f4fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.coordinator-content-card .empty-state-icon-circle i {\n  font-size: 2.2rem;\n  color: #14335e;\n}\n\n@media (max-width: 575.98px) {\n  .coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills {\n    width: 100%;\n    flex-direction: column;\n  }\n  .coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills .nav-item .coordinator-tab-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n.tab-count-badge {\n  background: rgba(20, 51, 94, 0.12);\n  color: #14335e;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 12px;\n}\n\n.coordinator-tab-btn.active .tab-count-badge {\n  background: rgba(255, 255, 255, 0.25);\n  color: #ffffff;\n}\n\n.coordinator-search-card {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #eaecf0;\n}\n.coordinator-search-card .search-label {\n  font-size: 0.84rem;\n  margin-bottom: 6px;\n  color: #344054;\n}\n.coordinator-search-card .search-select,\n.coordinator-search-card .search-input-control {\n  border-radius: 8px;\n  border: 1px solid #d0d5dd;\n  font-size: 0.88rem;\n  height: 40px;\n}\n.coordinator-search-card .search-select:focus,\n.coordinator-search-card .search-input-control:focus {\n  border-color: #14335e;\n  box-shadow: 0 0 0 3px rgba(20, 51, 94, 0.12) !important;\n}\n.coordinator-search-card .btn-coordinator-search {\n  background: #14335e;\n  border-color: #14335e;\n  height: 40px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n}\n.coordinator-search-card .btn-coordinator-search:hover {\n  background: #0f2747;\n  border-color: #0f2747;\n  transform: translateY(-1px);\n}\n.coordinator-search-card .btn-coordinator-reset {\n  height: 40px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n}\n.coordinator-search-card .results-count-text {\n  font-size: 0.86rem;\n}\n.coordinator-search-card .results-count-text strong {\n  color: #101828;\n}\n.coordinator-search-card .active-filter-indicator {\n  font-size: 0.84rem;\n  color: #14335e;\n  background: #eff4fb;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid #d6e4f7;\n}\n\n.coordinator-table-card {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #eaecf0;\n  overflow: hidden;\n}\n\n.coordinator-main-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.88rem;\n  margin-bottom: 0;\n}\n.coordinator-main-table thead th {\n  background: #f8fafc;\n  color: #344054;\n  font-weight: 700;\n  font-size: 0.76rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 13px 16px;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.coordinator-main-table thead th.th-sr-no {\n  width: 70px;\n}\n.coordinator-main-table thead th.th-districts {\n  min-width: 200px;\n}\n.coordinator-main-table thead th.th-person {\n  min-width: 200px;\n}\n.coordinator-main-table thead th.th-mobile {\n  min-width: 170px;\n}\n.coordinator-main-table thead th.th-action {\n  width: 110px;\n}\n.coordinator-main-table tbody tr.coordinator-row {\n  border-bottom: 1px solid #f2f4f7;\n  transition: background-color 0.15s ease;\n}\n.coordinator-main-table tbody tr.coordinator-row:last-child {\n  border-bottom: none;\n}\n.coordinator-main-table tbody tr.coordinator-row:hover {\n  background-color: #f8faff;\n}\n.coordinator-main-table tbody tr.coordinator-row td {\n  padding: 13px 16px;\n  vertical-align: middle;\n}\n.coordinator-main-table tbody tr.coordinator-row .sr-no-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #f0f4fa;\n  color: #14335e;\n  font-weight: 700;\n  font-size: 0.8rem;\n}\n.coordinator-main-table tbody tr.coordinator-row .district-tag {\n  display: inline-flex;\n  align-items: center;\n  background: #f0fdf4;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n.coordinator-main-table tbody tr.coordinator-row .district-tag i {\n  font-size: 0.85rem;\n  color: #22c55e;\n}\n.coordinator-main-table tbody tr.coordinator-row .person-avatar-circle {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #eff6ff;\n  color: #1d4ed8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n.coordinator-main-table tbody tr.coordinator-row .person-avatar-circle--trainer {\n  background: #fef3c7;\n  color: #b45309;\n}\n.coordinator-main-table tbody tr.coordinator-row .person-name {\n  font-weight: 700;\n  color: #101828;\n  font-size: 0.9rem;\n}\n.coordinator-main-table tbody tr.coordinator-row .mobile-link {\n  display: inline-flex;\n  align-items: center;\n  color: #14335e;\n  font-weight: 600;\n  font-size: 0.88rem;\n  text-decoration: none;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.15s ease;\n}\n.coordinator-main-table tbody tr.coordinator-row .mobile-link i {\n  color: #f0611b;\n  font-size: 0.95rem;\n}\n.coordinator-main-table tbody tr.coordinator-row .mobile-link:hover {\n  background: #f0f4fa;\n  color: #f0611b;\n}\n.coordinator-main-table tbody tr.coordinator-row .btn-call-now {\n  background: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n  font-weight: 700;\n  font-size: 0.8rem;\n  padding: 4px 12px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n}\n.coordinator-main-table tbody tr.coordinator-row .btn-call-now i {\n  font-size: 0.85rem;\n}\n.coordinator-main-table tbody tr.coordinator-row .btn-call-now:hover {\n  background: #16a34a;\n  color: #ffffff;\n  border-color: #16a34a;\n  transform: translateY(-1px);\n}\n.coordinator-main-table tbody tr.coordinator-row .btn-whatsapp-now {\n  background: #25d366;\n  color: #ffffff;\n  border: 1px solid #22c55e;\n  font-weight: 700;\n  font-size: 0.8rem;\n  padding: 4px 10px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.coordinator-main-table tbody tr.coordinator-row .btn-whatsapp-now i {\n  font-size: 0.95rem;\n}\n.coordinator-main-table tbody tr.coordinator-row .btn-whatsapp-now:hover {\n  background: #1da851;\n  color: #ffffff;\n  border-color: #1da851;\n  transform: translateY(-1px);\n}\n.coordinator-main-table .table-no-results {\n  padding: 40px 20px;\n}\n.coordinator-main-table .table-no-results .empty-icon {\n  font-size: 2.8rem;\n}\n\n.coordinator-footer-note {\n  font-size: 0.85rem;\n  line-height: 1.5;\n}\n\n.file-search .search-input {\n  background-color: #f8f9fa;\n  padding-left: 40px;\n}\n.file-search .icon-search {\n  z-index: 9;\n  position: absolute;\n}\n\n@media (max-width: 768px) {\n  .recent-data {\n    margin-left: 0px !important;\n    padding: 0px !important;\n  }\n}\n/* Search */\n.chat-search {\n  height: 70px;\n  display: table;\n  width: 100%;\n}\n.chat-search .chat-search-box {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.chat-search .form-control {\n  padding: 0;\n  box-shadow: none;\n  background-color: #f1f3fa !important;\n  border-color: #f1f3fa !important;\n}\n.chat-search .form-control::placeholder {\n  color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%);\n}\n.chat-search .btn {\n  box-shadow: none !important;\n  background-color: #f1f3fa;\n  color: #6c757d;\n}\n\n.user-status {\n  position: absolute;\n  height: 11px;\n  width: 11px;\n  background-color: #ced4da;\n  border: 2.5px solid #fff;\n  border-radius: 50%;\n  bottom: 0;\n  left: 35px;\n}\n\n.video-call {\n  background-image: url(\"../../../images/users/chat.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 450px;\n  position: relative;\n}\n.video-call .video-call-head img {\n  height: 4rem;\n  width: 4rem;\n}\n.video-call .video-call-action {\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  right: 0;\n  padding: 60px 0 16px;\n  background: linear-gradient(to top, #000 0, rgba(0, 0, 0, 0) 90%);\n}\n\n.voice-call {\n  height: 450px;\n  position: relative;\n}\n.voice-call .voice-call-head img {\n  width: 6rem;\n  height: 6rem;\n}\n.voice-call .voice-call-action {\n  position: absolute;\n  bottom: 0px;\n  left: 0;\n  right: 0;\n}\n\n.conversation-list {\n  list-style: none;\n  padding: 0 15px;\n  outline: none;\n}\n.conversation-list li {\n  margin-bottom: 20px;\n}\n.conversation-list li .conversation-actions {\n  display: none;\n}\n.conversation-list li:hover .conversation-actions {\n  display: block;\n}\n.conversation-list .ctext-wrap {\n  background: #f1f3fa;\n  color: #6c757d;\n  border-radius: 3px;\n  display: inline-block;\n  padding: 7px 12px;\n  position: relative;\n}\n.conversation-list .ctext-wrap i {\n  display: block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: bold;\n  position: relative;\n}\n.conversation-list .ctext-wrap p {\n  margin: 0;\n  padding: 0;\n}\n.conversation-list .ctext-wrap:after {\n  left: -11px;\n  top: 0;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-width: 6px;\n  margin-right: -1px;\n}\n.conversation-list .conversation-text {\n  float: left;\n  font-size: 13px;\n  margin-left: 12px;\n  width: 80%;\n}\n.conversation-list .odd .conversation-text {\n  float: right !important;\n  text-align: right !important;\n  width: 70% !important;\n}\n.conversation-list .odd .ctext-wrap {\n  background-color: #fef5e4;\n  color: #4B4B5A;\n}\n.conversation-list .odd .ctext-wrap:after {\n  border-color: transparent;\n  right: -10px;\n  left: auto;\n}\n\n.dash-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n.dash-stats-grid .dash-stat-tile .card {\n  height: 100%;\n}\n\n.apex-charts {\n  min-height: 10px !important;\n}\n.apex-charts text {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif !important;\n  font-weight: 700;\n}\n.apex-charts .apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.apexcharts-tooltip-title,\n.apexcharts-tooltip-text,\n.apexcharts-legend-text {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif !important;\n}\n\n.apexcharts-legend-series {\n  font-weight: 700;\n}\n\n.apexcharts-gridline {\n  pointer-events: none;\n  stroke: #f9f9fd;\n}\n\n.apexcharts-legend-text {\n  color: #6c757d !important;\n}\n\n.apexcharts-yaxis text,\n.apexcharts-xaxis text {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif !important;\n  fill: #6c757d;\n  font-weight: 700;\n}\n\n.apexcharts-point-annotations text,\n.apexcharts-xaxis-annotations text,\n.apexcharts-yaxis-annotations text {\n  fill: #6c757d;\n}\n\n.apexcharts-radar-series polygon {\n  fill: transparent;\n  stroke: #e2e7f1;\n}\n.apexcharts-radar-series line {\n  stroke: #e2e7f1;\n}\n\n.apexcharts-plot-series .apexcharts-datalabel {\n  fill: #fff !important;\n}\n\n.apexcharts-datalabels-group text {\n  fill: #6c757d !important;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif !important;\n}\n\n.scatter-images-chart .apexcharts-legend {\n  overflow: hidden !important;\n  min-height: 17px;\n}\n.scatter-images-chart .apexcharts-legend-marker {\n  background: none !important;\n  margin-right: 7px !important;\n}\n.scatter-images-chart .apexcharts-legend-series {\n  align-items: flex-start !important;\n}\n\n.apexcharts-pie-series path {\n  stroke: transparent !important;\n}\n\n.apexcharts-track path {\n  stroke: rgb(95.3716370269%, 96.169630643%, 97.7656178751%);\n}\n\n.apexcharts-xaxis line {\n  stroke: #ced4da !important;\n}\n\n.apex-charts .apexcharts-title-text {\n  fill: #343a40;\n}\n.apex-charts .apexcharts-subtitle-text {\n  fill: rgb(61.0588235294%, 63.8823529412%, 66.7058823529%);\n  font-weight: 400;\n}\n\n.calendar {\n  float: left;\n  margin-bottom: 0;\n}\n\n.fc-view-container .table-bordered th,\n.fc-view-container .table-bordered td, .fc-view-harness .table-bordered th,\n.fc-view-harness .table-bordered td {\n  border: 1px solid #e2e7f1;\n}\n.fc-view-container .fc-popover, .fc-view-harness .fc-popover {\n  z-index: 1000 !important;\n  background-color: #f8f9fa;\n}\n\n.fc-view {\n  margin-top: 30px !important;\n}\n\n.none-border .modal-footer {\n  border-top: none;\n}\n\n.fc-toolbar {\n  margin: 10px 0 5px 0 !important;\n}\n.fc-toolbar h2, .fc-toolbar .h2 {\n  font-size: 1.25rem !important;\n  line-height: 1.875rem !important;\n  text-transform: uppercase;\n}\n\n.fc-day-grid-event .fc-time {\n  font-weight: 500;\n}\n\nth.fc-day-header, th.fc-col-header-cell {\n  padding: 0.5rem 0 !important;\n}\n\n.fc-day {\n  background: transparent;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover,\n.fc-toolbar .ui-state-hover {\n  z-index: 0;\n}\n\n.fc th.fc-widget-header {\n  background: #e2e7f1;\n  font-size: 13px;\n  line-height: 20px;\n  padding: 10px 0;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n  border-color: #e2e7f1;\n}\n.fc-unthemed td.fc-today,\n.fc-unthemed .fc-divider {\n  background: #e2e7f1;\n}\n\n.fc-button {\n  background: #e2e7f1;\n  border: none;\n  color: #4B4B5A;\n  text-transform: capitalize;\n  box-shadow: none;\n  border-radius: 3px;\n  margin: 0 3px;\n  padding: 6px 12px;\n  height: auto;\n}\n\n.fc-text-arrow {\n  font-family: inherit;\n  font-size: 1rem;\n}\n\n.fc-state-hover,\n.fc-state-highlight,\n.fc-cell-overlay {\n  background: #e2e7f1;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n  background-color: #5369f8;\n  color: #fff;\n  text-shadow: none;\n}\n\n.fc-unthemed .fc-today {\n  background: #fff;\n}\n\n.fc-event {\n  border-radius: 2px !important;\n  border: none !important;\n  cursor: move;\n  font-size: 0.8125rem !important;\n  margin: 5px 7px;\n  padding: 5px 5px !important;\n  text-align: center;\n}\n\n.external-event {\n  cursor: move;\n  margin: 10px 0;\n  padding: 8px 10px;\n  color: #fff;\n  border-radius: 4px;\n}\n\n.fc-basic-view td.fc-week-number span {\n  padding-right: 8px;\n}\n.fc-basic-view td.fc-day-number {\n  padding-right: 8px;\n}\n.fc-basic-view .fc-content {\n  color: #fff;\n}\n\n.fc-time-grid-event .fc-content {\n  color: #fff;\n}\n\n.fc-content-skeleton .fc-day-top .fc-day-number {\n  float: right;\n  height: 20px;\n  width: 20px;\n  text-align: center;\n  line-height: 20px;\n  background-color: #f8f9fa;\n  border-radius: 50%;\n  margin: 5px;\n  font-size: 11px;\n}\n\n@media (max-width: 767.98px) {\n  .fc-toolbar {\n    display: block !important;\n  }\n  .fc-toolbar .fc-left,\n  .fc-toolbar .fc-right,\n  .fc-toolbar .fc-center {\n    text-align: left;\n    float: none;\n    display: block;\n    clear: both;\n    margin: 10px 0;\n  }\n  .fc .fc-toolbar > * > * {\n    float: none;\n  }\n  .fc-today-button {\n    display: none;\n  }\n}\n.fc-toolbar .btn {\n  padding: 0.28rem 0.8rem;\n  font-size: 0.7875rem;\n  border-radius: 0.25rem;\n}\n\n.fc-list-item-title,\n.fc-list-item-time {\n  color: #fff;\n}\n\n[dir=rtl] .fc-toolbar .btn-group .btn:first-child {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n  border-radius: 0.25rem;\n}\n[dir=rtl] .fc-toolbar .btn-group .btn:last-child {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-radius: 0.25rem;\n}\n\n.fc-list-table .fc-list-day th, .fc-list-table .fc-list-day td, .fc-list-table .fc-list-event th, .fc-list-table .fc-list-event td {\n  padding: 0.85rem 0.85rem !important;\n}\n.fc-list-table .fc-list-day th, .fc-list-table .fc-list-day td {\n  background: transparent !important;\n}\n.fc-list-table .fc-list-event:hover td, .fc-list-table .fc-list-event:hover th {\n  background-color: inherit !important;\n}\n.fc-list-table .fc-list-event td, .fc-list-table .fc-list-event th {\n  color: #fff !important;\n}\n\n.fc-daygrid-event {\n  color: #fff !important;\n}\n\n.sp-container {\n  background-color: #fff;\n  z-index: 9;\n}\n.sp-container button {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.71094rem;\n  border-radius: 0.2rem;\n  font-weight: 400;\n  color: #343a40;\n}\n.sp-container button.sp-palette-toggle {\n  background-color: #f8f9fa;\n}\n.sp-container button.sp-choose {\n  background-color: #43d39e;\n  margin-left: 5px;\n  margin-right: 0;\n}\n\n.sp-palette-container {\n  border-right: 1px solid rgb(91.9995440036%, 93.3789329685%, 96.1377108983%);\n}\n\n.sp-input {\n  background-color: #fff;\n  border-color: #ced4da !important;\n  color: #4B4B5A;\n}\n.sp-input:focus {\n  outline: none;\n}\n\n[dir=rtl] .sp-alpha {\n  direction: ltr;\n}\n[dir=rtl] .sp-original-input-container .sp-add-on {\n  border: none;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-top-left-radius: 4px !important;\n  border-bottom-left-radius: 4px !important;\n}\n[dir=rtl] input.spectrum.with-add-on {\n  border: 1px solid #ced4da;\n  border-left: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.sp-original-input-container .sp-add-on {\n  border: none !important;\n}\n\n.jqstooltip {\n  box-sizing: content-box;\n  width: auto !important;\n  height: auto !important;\n  background-color: #fff !important;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  padding: 5px 10px !important;\n  border-radius: 3px;\n  border-color: #fff !important;\n}\n\n.jqsfield {\n  color: #000 !important;\n  font-size: 12px !important;\n  line-height: 18px !important;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif !important;\n  font-weight: 700 !important;\n}\n\n.dataTables_wrapper.container-fluid, .dataTables_wrapper.container-sm, .dataTables_wrapper.container-md, .dataTables_wrapper.container-lg, .dataTables_wrapper.container-xl, .dataTables_wrapper.container-xxl {\n  padding: 0;\n}\n\ntable.dataTable {\n  border-collapse: collapse !important;\n  margin-bottom: 15px !important;\n}\ntable.dataTable tbody > tr.selected,\ntable.dataTable tbody > tr > .selected {\n  background-color: #5369f8;\n}\ntable.dataTable tbody > tr.selected td,\ntable.dataTable tbody > tr > .selected td {\n  border-color: #5369f8;\n}\ntable.dataTable tbody td:focus {\n  outline: none !important;\n}\ntable.dataTable tbody th.focus, table.dataTable tbody td.focus {\n  outline: 2px solid #5369f8 !important;\n  outline-offset: -1px;\n  color: #5369f8;\n  background-color: rgba(83, 105, 248, 0.15);\n}\ntable.dataTable thead .sorting::before,\ntable.dataTable thead .sorting_asc::before,\ntable.dataTable thead .sorting_desc::before,\ntable.dataTable thead .sorting_asc_disabled::before,\ntable.dataTable thead .sorting_desc_disabled::before {\n  right: 1em;\n  left: auto;\n  content: \"↑\";\n}\ntable.dataTable thead .sorting::after,\ntable.dataTable thead .sorting_asc::after,\ntable.dataTable thead .sorting_desc::after,\ntable.dataTable thead .sorting_asc_disabled::after,\ntable.dataTable thead .sorting_desc_disabled::after {\n  right: 0.5em;\n  left: auto;\n  content: \"↓\";\n}\ntable.dataTable thead > tr > th.sorting, table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc {\n  padding-right: 30px;\n  padding-left: 0.85rem;\n}\n\n.dataTables_info {\n  font-weight: 600;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr[role=row] > th:first-child:before {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  background-color: #43d39e;\n}\ntable.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before, table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {\n  background-color: #ff5c75;\n}\n\ndiv.dt-button-info {\n  background-color: #5369f8;\n  border: none;\n  color: #fff;\n  box-shadow: none;\n  border-radius: 3px;\n  text-align: center;\n  z-index: 21;\n}\ndiv.dt-button-info h2, div.dt-button-info .h2 {\n  border-bottom: none;\n  background-color: rgba(255, 255, 255, 0.2);\n  color: #fff;\n}\n\n@media (max-width: 575.98px) {\n  li.paginate_button.previous, li.paginate_button.next {\n    display: inline-block;\n    font-size: 1.5rem;\n  }\n  li.paginate_button {\n    display: none;\n  }\n  .dataTables_paginate ul {\n    text-align: center;\n    display: block;\n    margin: 1.5rem 0 0 !important;\n  }\n  div.dt-buttons {\n    display: inline-table;\n    margin-bottom: 1.5rem;\n  }\n}\n.activate-select .sorting_1 {\n  background-color: #f8f9fa;\n}\n\n.dataTables_filter {\n  text-align: right;\n}\n.dataTables_filter input {\n  margin-left: 0.5em;\n  margin-right: 0 !important;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -8px;\n  position: absolute;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  content: \"\";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n  border-bottom-color: rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #6c757d;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  top: 0px;\n  border-bottom-color: #fff;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  border-bottom: none;\n  border-top-color: #6c757d;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  bottom: 0px;\n  border-top-color: #fff;\n}\n\n.react-datepicker-wrapper {\n  display: block;\n}\n\n.react-datepicker {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-size: 0.875rem;\n  background-color: #fff;\n  color: #6c757d;\n  border: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time {\n  border-radius: 0.3rem;\n}\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n.react-datepicker-popper[data-placement^=bottom] {\n  padding-top: 10px;\n}\n.react-datepicker-popper[data-placement^=top] {\n  padding-bottom: 10px;\n}\n.react-datepicker-popper[data-placement^=right] {\n  padding-left: 8px;\n}\n.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n.react-datepicker-popper[data-placement^=left] {\n  padding-right: 8px;\n}\n.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #fff;\n  border-bottom: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  padding-top: 8px;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #6c757d;\n  font-weight: bold;\n  font-size: 0.875rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 2rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  width: 0;\n  padding: 0;\n  border: 0.45rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #6c757d;\n}\n.react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);\n  cursor: default;\n}\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #6c757d;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 80px;\n}\n.react-datepicker__navigation--next:hover {\n  border-left-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);\n  cursor: default;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #6c757d;\n}\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #6c757d;\n}\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__month .react-datepicker__month-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: 85px;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {\n  -moz-appearance: textfield;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n  width: 100px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -72px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: #fff;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 100px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + 2rem * 0.5);\n  overflow-y: scroll;\n  padding-right: 0px;\n  padding-left: 0px;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  outline: none !important;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #fff;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #5369f8;\n  color: white;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #5369f8;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #6c757d;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #6c757d;\n  display: inline-block;\n  width: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #fff;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #6c757d;\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range {\n  border-radius: 0.3rem;\n  background-color: #5369f8;\n  color: #fff;\n}\n.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover {\n  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);\n}\n.react-datepicker__month--disabled {\n  color: #6c757d;\n  pointer-events: none;\n}\n.react-datepicker__month--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text {\n  cursor: pointer;\n}\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover {\n  border-radius: 0.3rem;\n  background-color: #5369f8;\n  color: #fff !important;\n}\n.react-datepicker__day--today,\n.react-datepicker__month-text--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #5369f8;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover {\n  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);\n}\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1 {\n  color: magenta;\n}\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2 {\n  color: green;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #5369f8;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover {\n  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);\n}\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: rgb(51.7668967028%, 57.9362471245%, 98.0370248658%);\n  color: #fff;\n}\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover {\n  background-color: rgb(22.9400810604%, 32.7965823201%, 96.8638405083%);\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range) {\n  background-color: rgba(83, 105, 248, 0.5);\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range) {\n  background-color: #fff;\n  color: #6c757d;\n}\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled {\n  cursor: default;\n  color: #6c757d;\n}\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover {\n  background-color: #5369f8;\n}\n.react-datepicker__month-text:hover {\n  background-color: #fff;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: block;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #6c757d;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.45rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #fff;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #6c757d;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n}\n.react-datepicker__close-icon::after {\n  background-color: #5369f8;\n  border-radius: 50%;\n  bottom: 0;\n  box-sizing: border-box;\n  color: #fff;\n  content: \"×\";\n  cursor: pointer;\n  font-size: 12px;\n  height: 16px;\n  width: 16px;\n  line-height: 1;\n  margin: -8px auto 0;\n  padding: 2px;\n  position: absolute;\n  right: 0px;\n  text-align: center;\n}\n\n.react-datepicker__today-button {\n  background: #fff;\n  border-top: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.575rem;\n}\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.81rem solid transparent;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #6c757d;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);\n  cursor: default;\n}\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #6c757d;\n}\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: rgb(33.0825549104%, 35.8394344862%, 38.2899941092%);\n}\n.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(52.453084238%, 55.8764621729%, 58.9194647816%);\n  cursor: default;\n}\n\n.react-datepicker__day:focus {\n  outline: none !important;\n}\n\n.calendar-widget > div {\n  width: 100%;\n}\n.calendar-widget .react-datepicker {\n  width: 100%;\n}\n.calendar-widget .react-datepicker .react-datepicker__month-container {\n  width: 100%;\n}\n.calendar-widget .react-datepicker .react-datepicker__month-container .react-datepicker__current-month {\n  font-size: 1.1rem;\n}\n.calendar-widget .react-datepicker .react-datepicker__month-container .react-datepicker__day-names,\n.calendar-widget .react-datepicker .react-datepicker__month-container .react-datepicker__week {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  height: 52px;\n}\n\n.sw-main {\n  box-shadow: none;\n  border: 1px solid rgb(85.9297765618%, 88.3556771546%, 93.2074783402%);\n}\n.sw-main .sw-toolbar {\n  background: transparent;\n  padding: 10px;\n}\n.sw-main .step-content {\n  background-color: transparent !important;\n  text-align: left;\n}\n\n.sw-theme-default .step-content {\n  background-color: transparent;\n}\n.sw-theme-default > ul.step-anchor > li > a {\n  color: #6c757d;\n}\n.sw-theme-default > ul.step-anchor > li > a:hover {\n  color: #6c757d;\n}\n.sw-theme-default > ul.step-anchor > li > a:after {\n  background: #5369f8;\n}\n.sw-theme-default > ul.step-anchor > li.active > a {\n  color: #5369f8 !important;\n}\n.sw-theme-default > ul.step-anchor > li.done > a {\n  color: #6c757d !important;\n}\n.sw-theme-default > ul.step-anchor > li.done > a:after {\n  background: #43d39e;\n}\n\n.sw-theme-arrows > ul.step-anchor {\n  background: #e2e7f1;\n  border-bottom-color: #e2e7f1;\n}\n.sw-theme-arrows > ul.step-anchor > li a {\n  padding: 10px 0 10px 45px;\n}\n.sw-theme-arrows > ul.step-anchor > li a:hover {\n  padding: 10px 0 10px 45px;\n  isolation: inherit;\n}\n.sw-theme-arrows > ul.step-anchor > li:first-child a {\n  padding-left: 15px;\n}\n.sw-theme-arrows > ul.step-anchor > li > a, .sw-theme-arrows > ul.step-anchor > li > a:hover {\n  background: #e2e7f1;\n  color: #6c757d;\n}\n.sw-theme-arrows > ul.step-anchor > li > a::after {\n  border-left-color: #e2e7f1 !important;\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  border-top: 50px solid transparent;\n  border-bottom: 50px solid transparent;\n  border-left: 30px solid transparent;\n  border-right: 0;\n  position: absolute;\n  top: 50%;\n  margin-top: -50px;\n  left: 100%;\n  z-index: 2;\n}\n.sw-theme-arrows > ul.step-anchor > li > a::before {\n  border-left-color: #e2e7f1 !important;\n  content: \" \";\n  display: block;\n  width: 0;\n  height: 0;\n  border-top: 50px solid transparent;\n  border-bottom: 50px solid transparent;\n  border-left: 30px solid transparent;\n  border-right: 0;\n  position: absolute;\n  top: 50%;\n  margin-top: -50px;\n  margin-left: 1px;\n  left: 100%;\n  z-index: 1;\n}\n.sw-theme-arrows > ul.step-anchor > li.active > a {\n  background: #5369f8 !important;\n  border-color: #5369f8 !important;\n  isolation: inherit;\n}\n.sw-theme-arrows > ul.step-anchor > li.active > a:after {\n  border-left-color: #5369f8 !important;\n  border-right: 0 !important;\n}\n.sw-theme-arrows > ul.step-anchor > li.done > a {\n  background: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;\n  border-color: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;\n  color: #5369f8 !important;\n}\n.sw-theme-arrows > ul.step-anchor > li.done > a:after {\n  border-left-color: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;\n  border-right: 0 !important;\n}\n.sw-theme-arrows > ul.step-anchor > li.done > a::before {\n  border-left-color: rgb(78.6719246358%, 81.3999342754%, 99.1319969329%) !important;\n  border-right: 0 !important;\n}\n\n.sw-theme-circles > ul.step-anchor {\n  margin-top: 30px;\n  background-color: transparent;\n}\n.sw-theme-circles > ul.step-anchor:before {\n  background-color: #e2e7f1;\n}\n.sw-theme-circles > ul.step-anchor > li {\n  margin-left: 40px;\n  margin-right: 0;\n}\n.sw-theme-circles > ul.step-anchor > li > a {\n  font-size: 14px;\n  width: 40px;\n  height: 40px;\n  padding: 12px 0;\n  background-color: #e2e7f1;\n  border-color: #f6f6f7 !important;\n  box-shadow: none !important;\n}\n.sw-theme-circles > ul.step-anchor > li > a:hover {\n  background-color: #e2e7f1;\n}\n.sw-theme-circles > ul.step-anchor > li > a small, .sw-theme-circles > ul.step-anchor > li > a .small {\n  bottom: -20px;\n  width: 100%;\n}\n.sw-theme-circles > ul.step-anchor > li > a, .sw-theme-circles > ul.step-anchor > li > a:hover {\n  color: #6c757d;\n}\n.sw-theme-circles > ul.step-anchor > li > a small, .sw-theme-circles > ul.step-anchor > li > a .small, .sw-theme-circles > ul.step-anchor > li > a:hover small {\n  color: #6c757d;\n}\n.sw-theme-circles > ul.step-anchor > li.active > a {\n  background: #5369f8 !important;\n  border-color: #5369f8 !important;\n  color: #fff !important;\n}\n.sw-theme-circles > ul.step-anchor > li.active > a > small, .sw-theme-circles > ul.step-anchor > li.active > a > .small {\n  color: #5369f8;\n}\n.sw-theme-circles > ul.step-anchor > li.done > a {\n  background: #43d39e !important;\n  border-color: #43d39e !important;\n  color: #fff !important;\n}\n.sw-theme-circles > ul.step-anchor > li.done > a > small, .sw-theme-circles > ul.step-anchor > li.done > a > .small {\n  color: #43d39e;\n}\n\n.sw-theme-dots > ul.step-anchor {\n  background-color: transparent;\n}\n.sw-theme-dots > ul.step-anchor:before {\n  background-color: #e2e7f1;\n}\n.sw-theme-dots > ul.step-anchor > li > a:before {\n  bottom: -6px;\n  background: #e2e7f1;\n}\n.sw-theme-dots > ul.step-anchor > li > a:after {\n  left: 44%;\n  bottom: -8px;\n  background: #ced4da;\n}\n.sw-theme-dots > ul.step-anchor > li > a, .sw-theme-dots > ul.step-anchor > li > a:hover, .sw-theme-dots > ul.step-anchor > li > a:focus {\n  color: #6c757d;\n}\n.sw-theme-dots > ul.step-anchor > li.active > a {\n  color: #5369f8;\n}\n.sw-theme-dots > ul.step-anchor > li.active > a:after {\n  background: #5369f8;\n}\n.sw-theme-dots > ul.step-anchor > li.done > a {\n  color: #43d39e;\n}\n.sw-theme-dots > ul.step-anchor > li.done > a:after {\n  background: #43d39e;\n}\n\n[dir=rtl] .sw-theme-dots > ul.step-anchor > li > a:after {\n  left: 40%;\n}\n\n@media (max-width: 768px) {\n  .sw-main > ul.step-anchor > li {\n    display: block;\n    width: 100%;\n  }\n  .sw-theme-arrows > ul.step-anchor > li a {\n    padding: 10px 15px;\n  }\n  .sw-theme-circles > ul.step-anchor {\n    margin-bottom: 10px;\n  }\n  .sw-theme-circles > ul.step-anchor::before {\n    width: 0px;\n  }\n  .sw-theme-circles > ul.step-anchor > li {\n    margin-bottom: 10px;\n  }\n  .sw-theme-circles > ul.step-anchor > li > a > small, .sw-theme-circles > ul.step-anchor > li > a > .small {\n    bottom: 14px;\n    left: 76px;\n  }\n  .sw-theme-dots > ul.step-anchor::before {\n    left: 10px;\n    right: 0;\n    margin-right: 10px;\n    margin-left: 0px;\n  }\n  .sw-theme-dots > ul.step-anchor > li {\n    margin: 0 20px;\n  }\n  .sw-theme-dots > ul.step-anchor > li > a {\n    text-align: left;\n  }\n  .sw-theme-dots > ul.step-anchor > li > a::before {\n    left: -23px;\n    margin-right: 10px;\n    margin-left: 0px;\n  }\n  .sw-theme-dots > ul.step-anchor > li > a::after {\n    top: -36px;\n    left: -35px !important;\n    margin-right: 10px;\n    margin-left: 0px;\n  }\n}\n.select2-container {\n  width: 100% !important;\n}\n.select2-container .select2-selection--single {\n  border: 1px solid #ced4da;\n  height: calc(1.5em + 0.9rem + 2px);\n  background-color: #fff;\n  outline: none;\n}\n.select2-container .select2-selection--single .select2-selection__rendered {\n  line-height: 36px;\n  padding-left: 12px;\n  color: #4B4B5A;\n  text-align: left;\n}\n.select2-container .select2-selection--single .select2-selection__arrow {\n  height: 34px;\n  width: 34px;\n  right: 3px;\n  left: auto;\n}\n.select2-container .select2-selection--single .select2-selection__arrow b {\n  border-color: #adb5bd transparent transparent transparent;\n  border-width: 6px 6px 0 6px;\n}\n.select2-container input::placeholder {\n  color: #adb5bd;\n}\n\n.select2-container--open .select2-selection--single .select2-selection__arrow b {\n  border-color: transparent transparent #adb5bd transparent !important;\n  border-width: 0 6px 6px 6px !important;\n}\n\n.select2-results__option {\n  padding: 6px 12px;\n  text-align: left;\n}\n\n.select2-dropdown {\n  border: 0 solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  background-color: #fff;\n}\n\n.select2-container--default .select2-search--dropdown {\n  padding: 10px;\n  background-color: white;\n}\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  outline: none;\n  border: 1px solid #ced4da;\n  background-color: #fff;\n  color: #4B4B5A;\n  text-align: left;\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n  background-color: #5369f8;\n}\n.select2-container--default .select2-results__option[aria-selected=true] {\n  background-color: white;\n  color: #343a40;\n}\n.select2-container--default .select2-results__option[aria-selected=true]:hover {\n  background-color: #5369f8;\n  color: #fff;\n}\n\n.select2-container .select2-selection--multiple {\n  min-height: calc(1.5em + 0.9rem + 2px);\n  border: 1px solid #ced4da !important;\n  background-color: #fff;\n  display: flex;\n}\n.select2-container .select2-selection--multiple .select2-selection__choice__display {\n  /*rtl:ignore*/\n  padding-left: 0px;\n}\n.select2-container .select2-selection--multiple .select2-selection__rendered {\n  padding: 1px 10px;\n  float: left;\n  margin-bottom: 0;\n}\n.select2-container .select2-selection--multiple .select2-search__field {\n  border: 0;\n  color: #4B4B5A;\n}\n.select2-container .select2-selection--multiple .select2-selection__choice {\n  background-color: #5369f8;\n  border: none;\n  color: #fff;\n  border-radius: 3px;\n  float: left;\n}\n.select2-container .select2-selection--multiple .select2-selection__choice__remove {\n  color: #fff;\n  margin-right: 2px;\n  /*rtl:ignore*/\n  margin-left: 0px;\n  /*rtl:ignore*/\n  border-right: none;\n}\n.select2-container .select2-selection--multiple .select2-selection__choice__remove:hover {\n  color: #fff;\n  background-color: #5369f8;\n}\n.select2-container .select2-search--inline {\n  float: left;\n}\n.select2-container .select2-search--inline .select2-search__field {\n  margin-top: 7px;\n}\n\n[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%;\n  outline: none;\n  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto;\n  /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%;\n  /* Not required for horizontal scroll to trigger */\n  max-height: 100%;\n  /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: \" \";\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 5px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: \"\";\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}\n\n.ms-container {\n  background: transparent url(\"../../../images/plugin/multiple-arrow.png\") no-repeat 50% 50%;\n  width: auto;\n  max-width: 370px;\n}\n.ms-container .ms-list {\n  box-shadow: none;\n  border: 1px solid #ced4da;\n}\n.ms-container .ms-list.ms-focus {\n  box-shadow: none;\n  border: 1px solid rgb(69.3889648883%, 73.137254902%, 76.8855449156%);\n}\n.ms-container .ms-selectable {\n  background-color: #fff;\n}\n.ms-container .ms-selectable li.ms-elem-selectable {\n  border: none;\n  padding: 5px 10px;\n  color: #6c757d;\n}\n.ms-container .ms-selectable li.ms-hover {\n  background-color: #5369f8;\n  color: #fff;\n}\n.ms-container .ms-selection {\n  background-color: #fff;\n}\n.ms-container .ms-selection li.ms-elem-selection {\n  border: none;\n  padding: 5px 10px;\n  color: #6c757d;\n}\n.ms-container .ms-selection li.ms-hover {\n  background-color: #5369f8;\n  color: #fff;\n}\n\n.ms-selectable {\n  box-shadow: none;\n  outline: none !important;\n}\n\n.ms-optgroup-label {\n  font-weight: 500;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  color: #343a40 !important;\n  font-size: 13px;\n  padding-left: 5px !important;\n}\n\n.bootstrap-touchspin .btn .input-group-text {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  color: inherit;\n}\n\n.parsley-errors-list {\n  margin: 0;\n  padding: 0;\n}\n.parsley-errors-list > li {\n  list-style: none;\n  color: #ff5c75;\n  margin-top: 10px;\n  padding: 4px 7px 4px 28px;\n  position: relative;\n  display: inline-block;\n  background-color: rgba(255, 92, 117, 0.2);\n  border-radius: 7px;\n}\n.parsley-errors-list > li:before {\n  content: \"\\ebee\";\n  font-family: \"unicons\";\n  position: absolute;\n  left: 8px;\n  top: 4px;\n}\n.parsley-errors-list > li:after {\n  content: \"\";\n  border: 8px solid transparent;\n  border-bottom-color: rgba(255, 92, 117, 0.2);\n  position: absolute;\n  left: 14px;\n  top: -16px;\n}\n\n.parsley-error {\n  border-color: #ff5c75;\n}\n\n.parsley-success {\n  border-color: #43d39e;\n}\n\n.ql-container {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  border-bottom-left-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.ql-container.ql-snow {\n  border-color: #ced4da;\n}\n\n.ql-bubble {\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.ql-toolbar {\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif !important;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.ql-toolbar span {\n  outline: none !important;\n  color: #4B4B5A;\n}\n.ql-toolbar span:hover {\n  color: #5369f8 !important;\n}\n.ql-toolbar.ql-snow {\n  border-color: #ced4da;\n}\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: transparent;\n}\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 15px;\n  margin-left: 0;\n}\n\n.ql-snow .ql-stroke,\n.ql-snow .ql-script,\n.ql-snow .ql-strike svg {\n  stroke: #4B4B5A;\n}\n.ql-snow .ql-fill {\n  fill: #4B4B5A;\n}\n\n.ql-snow .ql-picker-options {\n  background-color: #fff;\n  border-color: rgb(93.7549019608%, 94.6470588235%, 95.5392156863%) !important;\n}\n\n.ql-editor {\n  text-align: left;\n}\n\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  position: absolute;\n  margin-top: -9px;\n  right: 0;\n  left: auto;\n  top: 50%;\n  width: 18px;\n}\n\n.ql-editor ol li:not(.ql-direction-rtl), .ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n  padding-right: 0;\n}\n.ql-editor li:not(.ql-direction-rtl):before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n\n.ql-editor ol, .ql-editor ul {\n  padding-left: 1.5em;\n  padding-right: 0;\n}\n\n.rdw-editor-wrapper {\n  border-color: #ced4da !important;\n}\n.rdw-editor-wrapper .rdw-editor-toolbar {\n  background: transparent !important;\n  border-bottom: 1px solid #ced4da !important;\n  border: none;\n}\n.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper {\n  background: #fff !important;\n  border-color: transparent !important;\n}\n.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown.rdw-option-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper:hover, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper.rdw-option-active {\n  box-shadow: none !important;\n}\n.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown img, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper img {\n  fill: #343a40 !important;\n}\n.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-block-dropdown .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontsize-dropdown .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-fontfamily-dropdown .rdw-dropdownoption-active, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper .rdw-dropdownoption-highlighted, .rdw-editor-wrapper .rdw-editor-toolbar .rdw-dropdown-optionwrapper .rdw-dropdownoption-active {\n  background: #f8f9fa !important;\n}\n.rdw-editor-wrapper .rdw-editor-toolbar .rdw-option-wrapper {\n  background: transparent !important;\n}\n.rdw-editor-wrapper .rdw-editor-main {\n  border-color: #ced4da !important;\n}\n\n.EasyMDEContainer .CodeMirror {\n  background: #fff !important;\n  border-color: #ced4da !important;\n}\n.EasyMDEContainer .editor-toolbar {\n  border-color: #ced4da !important;\n}\n.EasyMDEContainer .editor-toolbar i.separator {\n  border-color: #ced4da !important;\n}\n.EasyMDEContainer .editor-toolbar button {\n  color: #343a40 !important;\n}\n.EasyMDEContainer .editor-toolbar button:hover {\n  background: rgb(88.8549019608%, 90.7764705882%, 94.6196078431%) !important;\n  border-color: transparent !important;\n}\n.EasyMDEContainer .CodeMirror-lines .CodeMirror-cursors .CodeMirror-cursor {\n  border-color: #343a40;\n}\n.EasyMDEContainer .CodeMirror-lines .CodeMirror-code .CodeMirror-line {\n  color: #343a40;\n}\n.EasyMDEContainer .CodeMirror-lines .CodeMirror-code .CodeMirror-line .cm-null {\n  background: transparent !important;\n  color: #4B4B5A !important;\n}\n\n.react-select > div {\n  border: 1px solid #ced4da;\n  background-color: #fff !important;\n}\n.react-select > div:hover {\n  border: 1px solid #ced4da;\n}\n\n.react-select__control--is-focused {\n  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%) !important;\n  box-shadow: none !important;\n}\n\n.react-select__indicator-separator {\n  display: none !important;\n}\n\n.react-select__input-container {\n  margin-left: 0 !important;\n}\n\n.react-select__dropdown-indicator {\n  color: #6c757d !important;\n}\n\n.react-select__menu {\n  background-color: #fff !important;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n  border: none !important;\n  border-radius: 0.25rem !important;\n  z-index: 1000 !important;\n}\n\n.react-select__menu-list {\n  border: 0 solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%) !important;\n  border-radius: 0.25rem !important;\n}\n\n.react-select__single-value {\n  color: #6c757d !important;\n}\n\n.react-select__multi-value {\n  background-color: rgba(83, 105, 248, 0.2) !important;\n  color: #5369f8 !important;\n}\n.react-select__multi-value .react-select__multi-value__label {\n  color: #5369f8;\n}\n.react-select__multi-value .react-select__multi-value__remove:hover {\n  background-color: rgba(83, 105, 248, 0.2);\n  color: #5369f8;\n}\n\n.rbt-token {\n  background-color: rgba(83, 105, 248, 0.2) !important;\n  color: #5369f8 !important;\n}\n.rbt-token .rbt-token-remove-button {\n  background-color: transparent;\n  border: none;\n}\n.rbt-token .rbt-token-remove-button .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.rbt-input-multi.focus {\n  box-shadow: none !important;\n  background-color: #fff !important;\n  border-color: rgb(69.3889648883%, 73.137254902%, 76.8855449156%) !important;\n}\n\n.react-select-container .react-select__value-container--has-value .react-select__single-value {\n  color: #4B4B5A !important;\n}\n.react-select-container .react-select__menu-list {\n  max-height: 252px;\n}\n.react-select-container .react-select__option {\n  padding: 0.375rem 1.2rem;\n  color: #4B4B5A;\n  background-color: transparent !important;\n}\n.react-select-container .react-select__option:hover {\n  color: #fff !important;\n  background-color: #5369f8 !important;\n}\n.react-select-container .react-select__option--is-selected {\n  color: #343a40 !important;\n}\n\n.app-search .react-select__menu-list .react-select__option {\n  padding: 0.375rem 1.2rem;\n  color: #4B4B5A;\n  background-color: transparent;\n}\n.app-search .react-select__menu-list .react-select__option:hover {\n  color: #343a40;\n  background-color: #f8f9fa;\n}\n.app-search .react-select__menu-list .react-select__option--is-selected {\n  background-color: #f8f9fa;\n}\n.app-search .react-select__menu-list .react-select__option--is-selected .dropdown-item {\n  color: #343a40 !important;\n}\n.app-search .react-select__menu-list .react-select__option--is-disabled:hover {\n  background-color: transparent !important;\n}\n.app-search .react-select__value-container--has-value .react-select__single-value i, .app-search .react-select__value-container--has-value .react-select__single-value img, .app-search .react-select__value-container--has-value .react-select__single-value .user-subinfo {\n  display: none !important;\n}\n.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item .drop-username {\n  color: rgba(255, 255, 255, 0.6) !important;\n}\n.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item:hover {\n  color: #4B4B5A;\n  background-color: transparent;\n}\n.app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item, .app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item .drop-username {\n  width: 110px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\nbody[data-topbar-color=light] .app-search .react-select__value-container--has-value .react-select__single-value .dropdown-item, body[data-topbar-color=light] .app-search .react-select__value-container--has-value .react-select__single-value .drop-username {\n  color: #343a40 !important;\n}\n\n.react-table th, .react-table td {\n  white-space: nowrap;\n}\n.react-table th {\n  padding-left: 0.85rem;\n  padding-right: 30px;\n}\n.react-table .sortable {\n  position: relative;\n  cursor: pointer;\n}\n.react-table .sortable:before {\n  position: absolute;\n  right: 1rem;\n  left: auto;\n  content: \"↑\";\n  font-family: \"Material Design Icons\";\n  font-size: 1rem;\n  top: 12px;\n  opacity: 0.3;\n}\n.react-table .sortable:after {\n  position: absolute;\n  right: 0.5em;\n  left: auto;\n  content: \"↓\";\n  font-family: \"Material Design Icons\";\n  top: 12px;\n  opacity: 0.3;\n  font-size: 1rem;\n}\n.react-table .sortable.sorting_asc:before {\n  opacity: 1;\n}\n.react-table .sortable.sorting_desc:after {\n  opacity: 1;\n}\n@media (max-width: 991.98px) {\n  .react-table li.paginate_button.previous, .react-table li.paginate_button.next {\n    display: inline-block;\n    font-size: 1.5rem;\n  }\n}\n\n.flatpickr-calendar {\n  background: #fff;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border: 1px solid rgb(93.7549019608%, 94.6470588235%, 95.5392156863%);\n}\n.flatpickr-calendar.arrowTop:before {\n  border-bottom-color: white;\n}\n.flatpickr-calendar.arrowTop:after {\n  border-bottom-color: #fff;\n}\n.flatpickr-calendar.arrowBottom:before, .flatpickr-calendar.arrowBottom:after {\n  border-top-color: #fff;\n}\n\n.flatpickr-current-month {\n  font-size: 110%;\n}\n\n.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {\n  background: #5369f8 !important;\n  border-color: #5369f8;\n}\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n  box-shadow: -10px 0 0 #5369f8;\n}\n\n.flatpickr-time input:hover,\n.flatpickr-time .flatpickr-am-pm:hover,\n.flatpickr-time input:focus,\n.flatpickr-time .flatpickr-am-pm:focus {\n  background: #fff;\n  color: #343a40;\n}\n\n.flatpickr-months .flatpickr-month {\n  height: 36px;\n}\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month,\n.flatpickr-months .flatpickr-month {\n  color: #adb5bd;\n  fill: #adb5bd;\n}\n\n.flatpickr-weekdays {\n  background-color: #f8f9fa;\n}\n\nspan.flatpickr-weekday,\n.flatpickr-day,\n.flatpickr-current-month input.cur-year[disabled],\n.flatpickr-current-month input.cur-year[disabled]:hover,\n.flatpickr-time input,\n.flatpickr-time .flatpickr-time-separator,\n.flatpickr-time .flatpickr-am-pm {\n  color: #4B4B5A;\n  fill: #4B4B5A;\n}\n\n.flatpickr-day.disabled, .flatpickr-day.disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {\n  color: #6c757d;\n}\n.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {\n  background: #f8f9fa;\n  border-color: #f8f9fa;\n}\n\n.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {\n  border-top: 1px solid white;\n}\n\n.numInputWrapper:hover,\n.flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n  background-color: transparent;\n  color: #343a40;\n}\n\n.flatpickr-day.inRange {\n  box-shadow: -5px 0 0 #f8f9fa, 5px 0 0 #f8f9fa;\n}\n\n.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {\n  color: #6c757d;\n}\n\n.dropzone {\n  border: 2px dashed #ced4da;\n  background: #fff;\n  border-radius: 6px;\n  cursor: pointer;\n  min-height: 150px;\n  padding: 20px;\n  min-height: 150px;\n}\n.dropzone > div:focus {\n  outline: none;\n}\n.dropzone .dz-message {\n  text-align: center;\n  margin: 2rem 0;\n  outline: none;\n}\n.dropzone.dz-started .dz-message {\n  display: none;\n}\n\n@-webkit-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px);\n  }\n}\n@-moz-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px);\n  }\n}\n@keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px);\n  }\n}\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n}\n@-moz-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n}\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n@-moz-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.dropzone, .dropzone * {\n  box-sizing: border-box;\n}\n\n.dropzone.dz-clickable {\n  cursor: pointer;\n}\n\n.dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {\n  cursor: pointer;\n}\n\n.dropzone.dz-started .dz-message {\n  display: none;\n}\n\n.dropzone.dz-drag-hover {\n  border-style: solid;\n}\n\n.dropzone.dz-drag-hover .dz-message {\n  opacity: 0.5;\n}\n\n.dropzone .dz-message {\n  text-align: center;\n  margin: 2em 0;\n}\n\n.dropzone .dz-message .dz-button {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n}\n\n.dropzone .dz-preview {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  margin: 16px;\n  min-height: 100px;\n}\n\n.dropzone .dz-preview:hover {\n  z-index: 1000;\n}\n\n.dropzone .dz-preview:hover .dz-details {\n  opacity: 1;\n}\n\n.dropzone .dz-preview.dz-file-preview .dz-image {\n  border-radius: 20px;\n  background: #999;\n  background: linear-gradient(to bottom, #eee, #ddd);\n}\n\n.dropzone .dz-preview.dz-file-preview .dz-details {\n  opacity: 1;\n}\n\n.dropzone .dz-preview.dz-image-preview .dz-details {\n  -webkit-transition: opacity 0.2s linear;\n  -moz-transition: opacity 0.2s linear;\n  -ms-transition: opacity 0.2s linear;\n  -o-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n\n.dropzone .dz-preview .dz-remove {\n  font-size: 14px;\n  text-align: center;\n  display: block;\n  cursor: pointer;\n  border: none;\n}\n\n.dropzone .dz-preview .dz-remove:hover {\n  text-decoration: underline;\n}\n\n.dropzone .dz-preview:hover .dz-details {\n  opacity: 1;\n}\n\n.dropzone .dz-preview .dz-details {\n  z-index: 20;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  font-size: 13px;\n  min-width: 100%;\n  max-width: 100%;\n  padding: 2em 1em;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.9);\n  line-height: 150%;\n}\n\n.dropzone .dz-preview .dz-details .dz-size {\n  margin-bottom: 1em;\n  font-size: 16px;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename {\n  white-space: nowrap;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename:hover span {\n  border: 1px solid rgba(200, 200, 200, 0.8);\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {\n  border: 1px solid transparent;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {\n  background-color: rgba(255, 255, 255, 0.4);\n  padding: 0 0.4em;\n  border-radius: 3px;\n}\n\n.dropzone .dz-preview:hover .dz-image img {\n  -webkit-transform: scale(1.05, 1.05);\n  -moz-transform: scale(1.05, 1.05);\n  -ms-transform: scale(1.05, 1.05);\n  -o-transform: scale(1.05, 1.05);\n  transform: scale(1.05, 1.05);\n  -webkit-filter: blur(8px);\n  filter: blur(8px);\n}\n\n.dropzone .dz-preview .dz-image {\n  border-radius: 20px;\n  overflow: hidden;\n  width: 120px;\n  height: 120px;\n  position: relative;\n  display: block;\n  z-index: 10;\n  background-color: #f8f9fa;\n}\n\n.dropzone .dz-preview .dz-image img {\n  display: block;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n\n.dropzone .dz-preview.dz-success .dz-success-mark {\n  -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.dropzone .dz-preview.dz-error .dz-error-mark {\n  opacity: 1;\n  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {\n  pointer-events: none;\n  opacity: 0;\n  z-index: 500;\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 50%;\n  margin-left: -27px;\n  margin-top: -27px;\n}\n\n.dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {\n  display: block;\n  width: 54px;\n  height: 54px;\n}\n\n.dropzone .dz-preview.dz-processing .dz-progress {\n  opacity: 1;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n\n.dropzone .dz-preview.dz-complete .dz-progress {\n  opacity: 0;\n  -webkit-transition: opacity 0.4s ease-in;\n  -moz-transition: opacity 0.4s ease-in;\n  -ms-transition: opacity 0.4s ease-in;\n  -o-transition: opacity 0.4s ease-in;\n  transition: opacity 0.4s ease-in;\n}\n\n.dropzone .dz-preview:not(.dz-processing) .dz-progress {\n  -webkit-animation: pulse 6s ease infinite;\n  -moz-animation: pulse 6s ease infinite;\n  -ms-animation: pulse 6s ease infinite;\n  -o-animation: pulse 6s ease infinite;\n  animation: pulse 6s ease infinite;\n}\n\n.dropzone .dz-preview .dz-progress {\n  opacity: 1;\n  z-index: 1000;\n  pointer-events: none;\n  position: absolute;\n  height: 16px;\n  left: 50%;\n  top: 50%;\n  margin-top: -8px;\n  width: 80px;\n  margin-left: -40px;\n  background: rgba(255, 255, 255, 0.9);\n  -webkit-transform: scale(1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.dropzone .dz-preview .dz-progress .dz-upload {\n  background: #333;\n  background: linear-gradient(to bottom, #666, #444);\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 0;\n  -webkit-transition: width 300ms ease-in-out;\n  -moz-transition: width 300ms ease-in-out;\n  -ms-transition: width 300ms ease-in-out;\n  -o-transition: width 300ms ease-in-out;\n  transition: width 300ms ease-in-out;\n}\n\n.dropzone .dz-preview.dz-error .dz-error-message {\n  display: block;\n}\n\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.dropzone .dz-preview .dz-error-message {\n  pointer-events: none;\n  z-index: 1000;\n  position: absolute;\n  display: block;\n  display: none;\n  opacity: 0;\n  -webkit-transition: opacity 0.3s ease;\n  -moz-transition: opacity 0.3s ease;\n  -ms-transition: opacity 0.3s ease;\n  -o-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n  border-radius: 8px;\n  font-size: 13px;\n  top: 130px;\n  left: -10px;\n  width: 140px;\n  background: #be2626;\n  background: linear-gradient(to bottom, #be2626, #a92222);\n  padding: 0.5em 1.2em;\n  color: white;\n}\n\n.dropzone .dz-preview .dz-error-message:after {\n  content: \"\";\n  position: absolute;\n  top: -6px;\n  left: 64px;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #be2626;\n}\n\n.dz-preview .dz-remove .btn {\n  background-color: rgba(173, 181, 189, 0.85);\n  color: #fff;\n  border-radius: 50%;\n  font-size: 10px;\n  padding: 0;\n  height: 24px;\n  width: 24px;\n  line-height: 22px;\n  position: absolute;\n  top: -7px;\n  right: -5px;\n  z-index: 999;\n  opacity: 0;\n  transition: 0.2s ease-in-out;\n}\n.dz-preview:hover .dz-remove .btn {\n  opacity: 1;\n}\n\n.gmaps,\n.gmaps-panaroma {\n  height: 300px;\n  background: #f8f9fa;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  line-height: 40px;\n  background: #5369f8;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.gmaps-overlay_arrow.above {\n  bottom: -15px;\n  border-left: 16px solid transparent;\n  border-right: 16px solid transparent;\n  border-top: 16px solid #5369f8;\n}\n.gmaps-overlay_arrow.below {\n  top: -15px;\n  border-left: 16px solid transparent;\n  border-right: 16px solid transparent;\n  border-bottom: 16px solid #5369f8;\n}\n\n.jvectormap-label {\n  border: none;\n  background: #343a40;\n  color: color-yiq(#343a40);\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-size: 0.875rem;\n  padding: 5px 8px;\n}\n\nsvg {\n  touch-action: none;\n}\n\nimage, text, .jvm-zoomin, .jvm-zoomout {\n  user-select: none;\n}\n\n.jvm-container {\n  touch-action: none;\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n\n.jvm-tooltip {\n  border-radius: 3px;\n  background-color: #343a40;\n  font-family: \"Noto Sans\", \"Noto Sans Fallback\", sans-serif;\n  font-size: 0.875rem;\n  box-shadow: 1px 2px 12px rgba(0, 0, 0, 0.2);\n  padding: 5px 8px;\n  white-space: nowrap;\n  position: absolute;\n  display: none;\n  color: #f8f9fa;\n  border: none;\n}\n\n.jvm-zoom-btn {\n  border-radius: 3px;\n  background-color: #292929;\n  padding: 3px;\n  box-sizing: border-box;\n  position: absolute;\n  line-height: 10px;\n  cursor: pointer;\n  color: #FFF;\n  height: 15px;\n  width: 15px;\n  left: 10px;\n}\n.jvm-zoom-btn.jvm-zoomout {\n  top: 30px;\n}\n.jvm-zoom-btn.jvm-zoomin {\n  top: 10px;\n}\n\n.jvm-series-container {\n  right: 15px;\n  position: absolute;\n}\n.jvm-series-container.jvm-series-h {\n  bottom: 15px;\n}\n.jvm-series-container.jvm-series-v {\n  top: 15px;\n}\n.jvm-series-container .jvm-legend {\n  background-color: #FFF;\n  border: 1px solid #e5e7eb;\n  margin-left: 0.75rem;\n  border-radius: 0.25rem;\n  border-color: #e5e7eb;\n  padding: 0.6rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  float: left;\n}\n.jvm-series-container .jvm-legend .jvm-legend-title {\n  line-height: 1;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 0.5rem;\n  margin-bottom: 0.575rem;\n  text-align: left;\n}\n.jvm-series-container .jvm-legend .jvm-legend-inner {\n  overflow: hidden;\n}\n.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick {\n  overflow: hidden;\n  min-width: 40px;\n}\n.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick:not(:first-child) {\n  margin-top: 0.575rem;\n}\n.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick .jvm-legend-tick-sample {\n  border-radius: 4px;\n  margin-right: 0.65rem;\n  height: 16px;\n  width: 16px;\n  float: left;\n}\n.jvm-series-container .jvm-legend .jvm-legend-inner .jvm-legend-tick .jvm-legend-tick-text {\n  font-size: 12px;\n  text-align: center;\n  float: left;\n}\n\n.jvm-line[animation=true] {\n  -webkit-animation: jvm-line-animation 10s linear forwards infinite;\n  animation: jvm-line-animation 10s linear forwards infinite;\n}\n@keyframes jvm-line-animation {\n  from {\n    stroke-dashoffset: 250;\n  }\n}\n\n/*\nTemplate Name: Shreyu - Responsive 5 Admin Dashboard\nAuthor: CoderThemes\nVersion: 2.0.0\nEmail: support@coderthemes.com\nFile: Icons Css File\n*/\n@font-face {\n  font-family: \"unicons\";\n  src: url(\"../../../../fonts/unicons.eot?2256574\");\n  src: url(\"../../../../fonts/unicons.eot?2256574#iefix\") format(\"embedded-opentype\"), url(\"../../../../fonts/unicons.woff2?2256574\") format(\"woff2\"), url(\"../../../../fonts/unicons.woff?2256574\") format(\"woff\"), url(\"../../../../fonts/unicons.ttf?2256574\") format(\"truetype\"), url(\"../../../../fonts/unicons.svg?2256574#unicons\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\n/*\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  @font-face {\n    font-family: 'unicons';\n    src: url('../fonts/unicons.svg?2256574#unicons') format('svg');\n  }\n}\n*/\n.uil {\n  line-height: inherit;\n}\n\n[class^=uil-]:before, [class*=\" uil-\"]:before {\n  font-family: \"unicons\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  text-align: center;\n  /* opacity: .8; */\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1em;\n  vertical-align: middle;\n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  /* you can be more comfortable with increased icons size */\n  font-size: 120%;\n  /* Font smoothing. That was taken from TWBS */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n\n.uil-0-plus:before {\n  content: \"\\e800\";\n} /* '' */\n.uil-10-plus:before {\n  content: \"\\e801\";\n} /* '' */\n.uil-12-plus:before {\n  content: \"\\e802\";\n} /* '' */\n.uil-13-plus:before {\n  content: \"\\e803\";\n} /* '' */\n.uil-16-plus:before {\n  content: \"\\e804\";\n} /* '' */\n.uil-17-plus:before {\n  content: \"\\e805\";\n} /* '' */\n.uil-18-plus:before {\n  content: \"\\e806\";\n} /* '' */\n.uil-21-plus:before {\n  content: \"\\e807\";\n} /* '' */\n.uil-3-plus:before {\n  content: \"\\e808\";\n} /* '' */\n.uil-500px:before {\n  content: \"\\e809\";\n} /* '' */\n.uil-6-plus:before {\n  content: \"\\e80a\";\n} /* '' */\n.uil-abacus:before {\n  content: \"\\e80b\";\n} /* '' */\n.uil-accessible-icon-alt:before {\n  content: \"\\e80c\";\n} /* '' */\n.uil-adjust-alt:before {\n  content: \"\\e80d\";\n} /* '' */\n.uil-adjust-circle:before {\n  content: \"\\e80e\";\n} /* '' */\n.uil-adjust-half:before {\n  content: \"\\e80f\";\n} /* '' */\n.uil-adjust:before {\n  content: \"\\e810\";\n} /* '' */\n.uil-adobe-alt:before {\n  content: \"\\e811\";\n} /* '' */\n.uil-adobe:before {\n  content: \"\\e812\";\n} /* '' */\n.uil-airplay:before {\n  content: \"\\e813\";\n} /* '' */\n.uil-align-alt:before {\n  content: \"\\e814\";\n} /* '' */\n.uil-align-center-alt:before {\n  content: \"\\e815\";\n} /* '' */\n.uil-align-center-h:before {\n  content: \"\\e816\";\n} /* '' */\n.uil-align-center-justify:before {\n  content: \"\\e817\";\n} /* '' */\n.uil-align-center-v:before {\n  content: \"\\e818\";\n} /* '' */\n.uil-align-center:before {\n  content: \"\\e819\";\n} /* '' */\n.uil-align-justify:before {\n  content: \"\\e81a\";\n} /* '' */\n.uil-align-left-justify:before {\n  content: \"\\e81b\";\n} /* '' */\n.uil-align-left:before {\n  content: \"\\e81c\";\n} /* '' */\n.uil-align-letter-right:before {\n  content: \"\\e81d\";\n} /* '' */\n.uil-align-right-justify:before {\n  content: \"\\e81e\";\n} /* '' */\n.uil-align-right:before {\n  content: \"\\e81f\";\n} /* '' */\n.uil-align:before {\n  content: \"\\e820\";\n} /* '' */\n.uil-amazon:before {\n  content: \"\\e821\";\n} /* '' */\n.uil-ambulance:before {\n  content: \"\\e822\";\n} /* '' */\n.uil-analysis:before {\n  content: \"\\e823\";\n} /* '' */\n.uil-analytics:before {\n  content: \"\\e824\";\n} /* '' */\n.uil-anchor:before {\n  content: \"\\e825\";\n} /* '' */\n.uil-android-alt:before {\n  content: \"\\e826\";\n} /* '' */\n.uil-android-phone-slash:before {\n  content: \"\\e827\";\n} /* '' */\n.uil-android:before {\n  content: \"\\e828\";\n} /* '' */\n.uil-angle-double-down:before {\n  content: \"\\e829\";\n} /* '' */\n.uil-angle-double-left:before {\n  content: \"\\e82a\";\n} /* '' */\n.uil-angle-double-right:before {\n  content: \"\\e82b\";\n} /* '' */\n.uil-angle-double-up:before {\n  content: \"\\e82c\";\n} /* '' */\n.uil-angle-down:before {\n  content: \"\\e82d\";\n} /* '' */\n.uil-angle-left:before {\n  content: \"\\e82e\";\n} /* '' */\n.uil-angle-right-b:before {\n  content: \"\\e82f\";\n} /* '' */\n.uil-angle-right:before {\n  content: \"\\e830\";\n} /* '' */\n.uil-angle-up:before {\n  content: \"\\e831\";\n} /* '' */\n.uil-angry:before {\n  content: \"\\e832\";\n} /* '' */\n.uil-ankh:before {\n  content: \"\\e833\";\n} /* '' */\n.uil-annoyed-alt:before {\n  content: \"\\e834\";\n} /* '' */\n.uil-annoyed:before {\n  content: \"\\e835\";\n} /* '' */\n.uil-apple-alt:before {\n  content: \"\\e836\";\n} /* '' */\n.uil-apple:before {\n  content: \"\\e837\";\n} /* '' */\n.uil-apps:before {\n  content: \"\\e838\";\n} /* '' */\n.uil-archive-alt:before {\n  content: \"\\e839\";\n} /* '' */\n.uil-archive:before {\n  content: \"\\e83a\";\n} /* '' */\n.uil-archway:before {\n  content: \"\\e83b\";\n} /* '' */\n.uil-arrow-break:before {\n  content: \"\\e83c\";\n} /* '' */\n.uil-arrow-circle-down:before {\n  content: \"\\e83d\";\n} /* '' */\n.uil-arrow-circle-left:before {\n  content: \"\\e83e\";\n} /* '' */\n.uil-arrow-circle-right:before {\n  content: \"\\e83f\";\n} /* '' */\n.uil-arrow-circle-up:before {\n  content: \"\\e840\";\n} /* '' */\n.uil-arrow-compress-h:before {\n  content: \"\\e841\";\n} /* '' */\n.uil-arrow-down-left:before {\n  content: \"\\e842\";\n} /* '' */\n.uil-arrow-down-right:before {\n  content: \"\\e843\";\n} /* '' */\n.uil-arrow-down:before {\n  content: \"\\e844\";\n} /* '' */\n.uil-arrow-from-right:before {\n  content: \"\\e845\";\n} /* '' */\n.uil-arrow-from-top:before {\n  content: \"\\e846\";\n} /* '' */\n.uil-arrow-growth:before {\n  content: \"\\e847\";\n} /* '' */\n.uil-arrow-left:before {\n  content: \"\\e848\";\n} /* '' */\n.uil-arrow-random:before {\n  content: \"\\e849\";\n} /* '' */\n.uil-arrow-resize-diagonal:before {\n  content: \"\\e84a\";\n} /* '' */\n.uil-arrow-right:before {\n  content: \"\\e84b\";\n} /* '' */\n.uil-arrow-to-bottom:before {\n  content: \"\\e84c\";\n} /* '' */\n.uil-arrow-to-right:before {\n  content: \"\\e84d\";\n} /* '' */\n.uil-arrow-up-left:before {\n  content: \"\\e84e\";\n} /* '' */\n.uil-arrow-up-right:before {\n  content: \"\\e84f\";\n} /* '' */\n.uil-arrow-up:before {\n  content: \"\\e850\";\n} /* '' */\n.uil-arrows-h-alt:before {\n  content: \"\\e851\";\n} /* '' */\n.uil-arrows-h:before {\n  content: \"\\e852\";\n} /* '' */\n.uil-arrows-left-down:before {\n  content: \"\\e853\";\n} /* '' */\n.uil-arrows-maximize:before {\n  content: \"\\e854\";\n} /* '' */\n.uil-arrows-merge:before {\n  content: \"\\e855\";\n} /* '' */\n.uil-arrows-resize-h:before {\n  content: \"\\e856\";\n} /* '' */\n.uil-arrows-resize-v:before {\n  content: \"\\e857\";\n} /* '' */\n.uil-arrows-resize:before {\n  content: \"\\e858\";\n} /* '' */\n.uil-arrows-right-down:before {\n  content: \"\\e859\";\n} /* '' */\n.uil-arrows-shrink-h:before {\n  content: \"\\e85a\";\n} /* '' */\n.uil-arrows-shrink-v:before {\n  content: \"\\e85b\";\n} /* '' */\n.uil-arrows-up-right:before {\n  content: \"\\e85c\";\n} /* '' */\n.uil-arrows-v-alt:before {\n  content: \"\\e85d\";\n} /* '' */\n.uil-arrows-v:before {\n  content: \"\\e85e\";\n} /* '' */\n.uil-assistive-listening-systems:before {\n  content: \"\\e85f\";\n} /* '' */\n.uil-asterisk:before {\n  content: \"\\e860\";\n} /* '' */\n.uil-at:before {\n  content: \"\\e861\";\n} /* '' */\n.uil-atm-card:before {\n  content: \"\\e862\";\n} /* '' */\n.uil-atom:before {\n  content: \"\\e863\";\n} /* '' */\n.uil-auto-flash:before {\n  content: \"\\e864\";\n} /* '' */\n.uil-award-alt:before {\n  content: \"\\e865\";\n} /* '' */\n.uil-award:before {\n  content: \"\\e866\";\n} /* '' */\n.uil-baby-carriage:before {\n  content: \"\\e867\";\n} /* '' */\n.uil-backpack:before {\n  content: \"\\e868\";\n} /* '' */\n.uil-backspace:before {\n  content: \"\\e869\";\n} /* '' */\n.uil-backward:before {\n  content: \"\\e86a\";\n} /* '' */\n.uil-bag-alt:before {\n  content: \"\\e86b\";\n} /* '' */\n.uil-bag-slash:before {\n  content: \"\\e86c\";\n} /* '' */\n.uil-bag:before {\n  content: \"\\e86d\";\n} /* '' */\n.uil-balance-scale:before {\n  content: \"\\e86e\";\n} /* '' */\n.uil-ball:before {\n  content: \"\\e86f\";\n} /* '' */\n.uil-ban:before {\n  content: \"\\e870\";\n} /* '' */\n.uil-bars:before {\n  content: \"\\e871\";\n} /* '' */\n.uil-baseball-ball:before {\n  content: \"\\e872\";\n} /* '' */\n.uil-basketball-hoop:before {\n  content: \"\\e873\";\n} /* '' */\n.uil-basketball:before {\n  content: \"\\e874\";\n} /* '' */\n.uil-bath:before {\n  content: \"\\e875\";\n} /* '' */\n.uil-battery-bolt:before {\n  content: \"\\e876\";\n} /* '' */\n.uil-battery-empty:before {\n  content: \"\\e877\";\n} /* '' */\n.uil-bed-double:before {\n  content: \"\\e878\";\n} /* '' */\n.uil-bed:before {\n  content: \"\\e879\";\n} /* '' */\n.uil-behance-alt:before {\n  content: \"\\e87a\";\n} /* '' */\n.uil-behance:before {\n  content: \"\\e87b\";\n} /* '' */\n.uil-bell-school:before {\n  content: \"\\e87c\";\n} /* '' */\n.uil-bell-slash:before {\n  content: \"\\e87d\";\n} /* '' */\n.uil-bell:before {\n  content: \"\\e87e\";\n} /* '' */\n.uil-bill:before {\n  content: \"\\e87f\";\n} /* '' */\n.uil-bitcoin-alt:before {\n  content: \"\\e880\";\n} /* '' */\n.uil-bitcoin-bold:before {\n  content: \"\\e881\";\n} /* '' */\n.uil-bitcoin-circle:before {\n  content: \"\\e882\";\n} /* '' */\n.uil-bitcoin:before {\n  content: \"\\e883\";\n} /* '' */\n.uil-black-berry:before {\n  content: \"\\e884\";\n} /* '' */\n.uil-blogger-alt:before {\n  content: \"\\e885\";\n} /* '' */\n.uil-blogger:before {\n  content: \"\\e886\";\n} /* '' */\n.uil-bluetooth-b:before {\n  content: \"\\e887\";\n} /* '' */\n.uil-bold:before {\n  content: \"\\e888\";\n} /* '' */\n.uil-bolt-alt:before {\n  content: \"\\e889\";\n} /* '' */\n.uil-bolt-slash:before {\n  content: \"\\e88a\";\n} /* '' */\n.uil-bolt:before {\n  content: \"\\e88b\";\n} /* '' */\n.uil-book-alt:before {\n  content: \"\\e88c\";\n} /* '' */\n.uil-book-medical:before {\n  content: \"\\e88d\";\n} /* '' */\n.uil-book-open:before {\n  content: \"\\e88e\";\n} /* '' */\n.uil-book-reader:before {\n  content: \"\\e88f\";\n} /* '' */\n.uil-book:before {\n  content: \"\\e890\";\n} /* '' */\n.uil-bookmark-full:before {\n  content: \"\\e891\";\n} /* '' */\n.uil-bookmark:before {\n  content: \"\\e892\";\n} /* '' */\n.uil-books:before {\n  content: \"\\e893\";\n} /* '' */\n.uil-boombox:before {\n  content: \"\\e894\";\n} /* '' */\n.uil-border-alt:before {\n  content: \"\\e895\";\n} /* '' */\n.uil-border-bottom:before {\n  content: \"\\e896\";\n} /* '' */\n.uil-border-clear:before {\n  content: \"\\e897\";\n} /* '' */\n.uil-border-horizontal:before {\n  content: \"\\e898\";\n} /* '' */\n.uil-border-inner:before {\n  content: \"\\e899\";\n} /* '' */\n.uil-border-left:before {\n  content: \"\\e89a\";\n} /* '' */\n.uil-border-out:before {\n  content: \"\\e89b\";\n} /* '' */\n.uil-border-right:before {\n  content: \"\\e89c\";\n} /* '' */\n.uil-border-top:before {\n  content: \"\\e89d\";\n} /* '' */\n.uil-border-vertical:before {\n  content: \"\\e89e\";\n} /* '' */\n.uil-bowling-ball:before {\n  content: \"\\e89f\";\n} /* '' */\n.uil-box:before {\n  content: \"\\e8a0\";\n} /* '' */\n.uil-briefcase-alt:before {\n  content: \"\\e8a1\";\n} /* '' */\n.uil-briefcase:before {\n  content: \"\\e8a2\";\n} /* '' */\n.uil-bright:before {\n  content: \"\\e8a3\";\n} /* '' */\n.uil-brightness-empty:before {\n  content: \"\\e8a4\";\n} /* '' */\n.uil-brightness-half:before {\n  content: \"\\e8a5\";\n} /* '' */\n.uil-brightness-low:before {\n  content: \"\\e8a6\";\n} /* '' */\n.uil-brightness-minus:before {\n  content: \"\\e8a7\";\n} /* '' */\n.uil-brightness-plus:before {\n  content: \"\\e8a8\";\n} /* '' */\n.uil-brightness:before {\n  content: \"\\e8a9\";\n} /* '' */\n.uil-bring-bottom:before {\n  content: \"\\e8aa\";\n} /* '' */\n.uil-bring-front:before {\n  content: \"\\e8ab\";\n} /* '' */\n.uil-brush-alt:before {\n  content: \"\\e8ac\";\n} /* '' */\n.uil-bug:before {\n  content: \"\\e8ad\";\n} /* '' */\n.uil-building:before {\n  content: \"\\e8ae\";\n} /* '' */\n.uil-bullseye:before {\n  content: \"\\e8af\";\n} /* '' */\n.uil-bus-alt:before {\n  content: \"\\e8b0\";\n} /* '' */\n.uil-bus-school:before {\n  content: \"\\e8b1\";\n} /* '' */\n.uil-bus:before {\n  content: \"\\e8b2\";\n} /* '' */\n.uil-calcualtor:before {\n  content: \"\\e8b3\";\n} /* '' */\n.uil-calculator-alt:before {\n  content: \"\\e8b4\";\n} /* '' */\n.uil-calculator:before {\n  content: \"\\e8b5\";\n} /* '' */\n.uil-calendar-alt:before {\n  content: \"\\e8b6\";\n} /* '' */\n.uil-calendar-slash:before {\n  content: \"\\e8b7\";\n} /* '' */\n.uil-calender:before {\n  content: \"\\e8b8\";\n} /* '' */\n.uil-calling:before {\n  content: \"\\e8b9\";\n} /* '' */\n.uil-camera-change:before {\n  content: \"\\e8ba\";\n} /* '' */\n.uil-camera-plus:before {\n  content: \"\\e8bb\";\n} /* '' */\n.uil-camera-slash:before {\n  content: \"\\e8bc\";\n} /* '' */\n.uil-camera:before {\n  content: \"\\e8bd\";\n} /* '' */\n.uil-cancel:before {\n  content: \"\\e8be\";\n} /* '' */\n.uil-capsule:before {\n  content: \"\\e8bf\";\n} /* '' */\n.uil-capture:before {\n  content: \"\\e8c0\";\n} /* '' */\n.uil-car-sideview:before {\n  content: \"\\e8c1\";\n} /* '' */\n.uil-car-slash:before {\n  content: \"\\e8c2\";\n} /* '' */\n.uil-car-wash:before {\n  content: \"\\e8c3\";\n} /* '' */\n.uil-car:before {\n  content: \"\\e8c4\";\n} /* '' */\n.uil-card-atm:before {\n  content: \"\\e8c5\";\n} /* '' */\n.uil-caret-right:before {\n  content: \"\\e8c6\";\n} /* '' */\n.uil-cart:before {\n  content: \"\\e8c7\";\n} /* '' */\n.uil-cell:before {\n  content: \"\\e8c8\";\n} /* '' */\n.uil-celsius:before {\n  content: \"\\e8c9\";\n} /* '' */\n.uil-chart-bar-alt:before {\n  content: \"\\e8ca\";\n} /* '' */\n.uil-chart-bar:before {\n  content: \"\\e8cb\";\n} /* '' */\n.uil-chart-down:before {\n  content: \"\\e8cc\";\n} /* '' */\n.uil-chart-growth-alt:before {\n  content: \"\\e8cd\";\n} /* '' */\n.uil-chart-growth:before {\n  content: \"\\e8ce\";\n} /* '' */\n.uil-chart-line:before {\n  content: \"\\e8cf\";\n} /* '' */\n.uil-chart-pie-alt:before {\n  content: \"\\e8d0\";\n} /* '' */\n.uil-chart-pie:before {\n  content: \"\\e8d1\";\n} /* '' */\n.uil-chart:before {\n  content: \"\\e8d2\";\n} /* '' */\n.uil-chat-bubble-user:before {\n  content: \"\\e8d3\";\n} /* '' */\n.uil-chat-info:before {\n  content: \"\\e8d4\";\n} /* '' */\n.uil-chat:before {\n  content: \"\\e8d5\";\n} /* '' */\n.uil-check-circle:before {\n  content: \"\\e8d6\";\n} /* '' */\n.uil-check-square:before {\n  content: \"\\e8d7\";\n} /* '' */\n.uil-check:before {\n  content: \"\\e8d8\";\n} /* '' */\n.uil-circle-layer:before {\n  content: \"\\e8d9\";\n} /* '' */\n.uil-circle:before {\n  content: \"\\e8da\";\n} /* '' */\n.uil-circuit:before {\n  content: \"\\e8db\";\n} /* '' */\n.uil-clapper-board:before {\n  content: \"\\e8dc\";\n} /* '' */\n.uil-clipboard-alt:before {\n  content: \"\\e8dd\";\n} /* '' */\n.uil-clipboard-blank:before {\n  content: \"\\e8de\";\n} /* '' */\n.uil-clipboard-notes:before {\n  content: \"\\e8df\";\n} /* '' */\n.uil-clipboard:before {\n  content: \"\\e8e0\";\n} /* '' */\n.uil-clock-eight:before {\n  content: \"\\e8e1\";\n} /* '' */\n.uil-clock-five:before {\n  content: \"\\e8e2\";\n} /* '' */\n.uil-clock-nine:before {\n  content: \"\\e8e3\";\n} /* '' */\n.uil-clock-seven:before {\n  content: \"\\e8e4\";\n} /* '' */\n.uil-clock-ten:before {\n  content: \"\\e8e5\";\n} /* '' */\n.uil-clock-three:before {\n  content: \"\\e8e6\";\n} /* '' */\n.uil-clock-two:before {\n  content: \"\\e8e7\";\n} /* '' */\n.uil-clock:before {\n  content: \"\\e8e8\";\n} /* '' */\n.uil-closed-captioning:before {\n  content: \"\\e8e9\";\n} /* '' */\n.uil-cloud-block:before {\n  content: \"\\e8ea\";\n} /* '' */\n.uil-cloud-bookmark:before {\n  content: \"\\e8eb\";\n} /* '' */\n.uil-cloud-check:before {\n  content: \"\\e8ec\";\n} /* '' */\n.uil-cloud-computing:before {\n  content: \"\\e8ed\";\n} /* '' */\n.uil-cloud-data-connection:before {\n  content: \"\\e8ee\";\n} /* '' */\n.uil-cloud-database-tree:before {\n  content: \"\\e8ef\";\n} /* '' */\n.uil-cloud-download:before {\n  content: \"\\e8f0\";\n} /* '' */\n.uil-cloud-drizzle:before {\n  content: \"\\e8f1\";\n} /* '' */\n.uil-cloud-exclamation:before {\n  content: \"\\e8f2\";\n} /* '' */\n.uil-cloud-hail:before {\n  content: \"\\e8f3\";\n} /* '' */\n.uil-cloud-heart:before {\n  content: \"\\e8f4\";\n} /* '' */\n.uil-cloud-info:before {\n  content: \"\\e8f5\";\n} /* '' */\n.uil-cloud-lock:before {\n  content: \"\\e8f6\";\n} /* '' */\n.uil-cloud-meatball:before {\n  content: \"\\e8f7\";\n} /* '' */\n.uil-cloud-moon-hail:before {\n  content: \"\\e8f8\";\n} /* '' */\n.uil-cloud-moon-meatball:before {\n  content: \"\\e8f9\";\n} /* '' */\n.uil-cloud-moon-rain:before {\n  content: \"\\e8fa\";\n} /* '' */\n.uil-cloud-moon-showers:before {\n  content: \"\\e8fb\";\n} /* '' */\n.uil-cloud-moon:before {\n  content: \"\\e8fc\";\n} /* '' */\n.uil-cloud-question:before {\n  content: \"\\e8fd\";\n} /* '' */\n.uil-cloud-rain-sun:before {\n  content: \"\\e8fe\";\n} /* '' */\n.uil-cloud-rain:before {\n  content: \"\\e8ff\";\n} /* '' */\n.uil-cloud-redo:before {\n  content: \"\\e900\";\n} /* '' */\n.uil-cloud-set:before {\n  content: \"\\e901\";\n} /* '' */\n.uil-cloud-share:before {\n  content: \"\\e902\";\n} /* '' */\n.uil-cloud-shield:before {\n  content: \"\\e903\";\n} /* '' */\n.uil-cloud-showers-alt:before {\n  content: \"\\e904\";\n} /* '' */\n.uil-cloud-showers-heavy:before {\n  content: \"\\e905\";\n} /* '' */\n.uil-cloud-showers:before {\n  content: \"\\e906\";\n} /* '' */\n.uil-cloud-slash:before {\n  content: \"\\e907\";\n} /* '' */\n.uil-cloud-sun-hail:before {\n  content: \"\\e908\";\n} /* '' */\n.uil-cloud-sun-meatball:before {\n  content: \"\\e909\";\n} /* '' */\n.uil-cloud-sun-rain-alt:before {\n  content: \"\\e90a\";\n} /* '' */\n.uil-cloud-sun-rain:before {\n  content: \"\\e90b\";\n} /* '' */\n.uil-cloud-sun-tear:before {\n  content: \"\\e90c\";\n} /* '' */\n.uil-cloud-sun:before {\n  content: \"\\e90d\";\n} /* '' */\n.uil-cloud-times:before {\n  content: \"\\e90e\";\n} /* '' */\n.uil-cloud-unlock:before {\n  content: \"\\e90f\";\n} /* '' */\n.uil-cloud-upload:before {\n  content: \"\\e910\";\n} /* '' */\n.uil-cloud-wifi:before {\n  content: \"\\e911\";\n} /* '' */\n.uil-cloud-wind:before {\n  content: \"\\e912\";\n} /* '' */\n.uil-cloud:before {\n  content: \"\\e913\";\n} /* '' */\n.uil-clouds:before {\n  content: \"\\e914\";\n} /* '' */\n.uil-club:before {\n  content: \"\\e915\";\n} /* '' */\n.uil-code:before {\n  content: \"\\e916\";\n} /* '' */\n.uil-coffee:before {\n  content: \"\\e917\";\n} /* '' */\n.uil-cog:before {\n  content: \"\\e918\";\n} /* '' */\n.uil-coins:before {\n  content: \"\\e919\";\n} /* '' */\n.uil-columns:before {\n  content: \"\\e91a\";\n} /* '' */\n.uil-comment-alt-block:before {\n  content: \"\\e91b\";\n} /* '' */\n.uil-comment-alt-chart-lines:before {\n  content: \"\\e91c\";\n} /* '' */\n.uil-comment-alt-check:before {\n  content: \"\\e91d\";\n} /* '' */\n.uil-comment-alt-dots:before {\n  content: \"\\e91e\";\n} /* '' */\n.uil-comment-alt-download:before {\n  content: \"\\e91f\";\n} /* '' */\n.uil-comment-alt-edit:before {\n  content: \"\\e920\";\n} /* '' */\n.uil-comment-alt-exclamation:before {\n  content: \"\\e921\";\n} /* '' */\n.uil-comment-alt-heart:before {\n  content: \"\\e922\";\n} /* '' */\n.uil-comment-alt-image:before {\n  content: \"\\e923\";\n} /* '' */\n.uil-comment-alt-info:before {\n  content: \"\\e924\";\n} /* '' */\n.uil-comment-alt-lines:before {\n  content: \"\\e925\";\n} /* '' */\n.uil-comment-alt-lock:before {\n  content: \"\\e926\";\n} /* '' */\n.uil-comment-alt-medical:before {\n  content: \"\\e927\";\n} /* '' */\n.uil-comment-alt-message:before {\n  content: \"\\e928\";\n} /* '' */\n.uil-comment-alt-notes:before {\n  content: \"\\e929\";\n} /* '' */\n.uil-comment-alt-plus:before {\n  content: \"\\e92a\";\n} /* '' */\n.uil-comment-alt-question:before {\n  content: \"\\e92b\";\n} /* '' */\n.uil-comment-alt-redo:before {\n  content: \"\\e92c\";\n} /* '' */\n.uil-comment-alt-search:before {\n  content: \"\\e92d\";\n} /* '' */\n.uil-comment-alt-share:before {\n  content: \"\\e92e\";\n} /* '' */\n.uil-comment-alt-shield:before {\n  content: \"\\e92f\";\n} /* '' */\n.uil-comment-alt-slash:before {\n  content: \"\\e930\";\n} /* '' */\n.uil-comment-alt-upload:before {\n  content: \"\\e931\";\n} /* '' */\n.uil-comment-alt-verify:before {\n  content: \"\\e932\";\n} /* '' */\n.uil-comment-alt:before {\n  content: \"\\e933\";\n} /* '' */\n.uil-comment-block:before {\n  content: \"\\e934\";\n} /* '' */\n.uil-comment-chart-line:before {\n  content: \"\\e935\";\n} /* '' */\n.uil-comment-check:before {\n  content: \"\\e936\";\n} /* '' */\n.uil-comment-dots:before {\n  content: \"\\e937\";\n} /* '' */\n.uil-comment-download:before {\n  content: \"\\e938\";\n} /* '' */\n.uil-comment-edit:before {\n  content: \"\\e939\";\n} /* '' */\n.uil-comment-exclamation:before {\n  content: \"\\e93a\";\n} /* '' */\n.uil-comment-heart:before {\n  content: \"\\e93b\";\n} /* '' */\n.uil-comment-image:before {\n  content: \"\\e93c\";\n} /* '' */\n.uil-comment-info-alt:before {\n  content: \"\\e93d\";\n} /* '' */\n.uil-comment-info:before {\n  content: \"\\e93e\";\n} /* '' */\n.uil-comment-lines:before {\n  content: \"\\e93f\";\n} /* '' */\n.uil-comment-lock:before {\n  content: \"\\e940\";\n} /* '' */\n.uil-comment-medical:before {\n  content: \"\\e941\";\n} /* '' */\n.uil-comment-message:before {\n  content: \"\\e942\";\n} /* '' */\n.uil-comment-notes:before {\n  content: \"\\e943\";\n} /* '' */\n.uil-comment-plus:before {\n  content: \"\\e944\";\n} /* '' */\n.uil-comment-question:before {\n  content: \"\\e945\";\n} /* '' */\n.uil-comment-redo:before {\n  content: \"\\e946\";\n} /* '' */\n.uil-comment-search:before {\n  content: \"\\e947\";\n} /* '' */\n.uil-comment-share:before {\n  content: \"\\e948\";\n} /* '' */\n.uil-comment-shield:before {\n  content: \"\\e949\";\n} /* '' */\n.uil-comment-slash:before {\n  content: \"\\e94a\";\n} /* '' */\n.uil-comment-upload:before {\n  content: \"\\e94b\";\n} /* '' */\n.uil-comment-verify:before {\n  content: \"\\e94c\";\n} /* '' */\n.uil-comment:before {\n  content: \"\\e94d\";\n} /* '' */\n.uil-comments-alt:before {\n  content: \"\\e94e\";\n} /* '' */\n.uil-comments:before {\n  content: \"\\e94f\";\n} /* '' */\n.uil-commnet-alt-slash:before {\n  content: \"\\e950\";\n} /* '' */\n.uil-compact-disc:before {\n  content: \"\\e951\";\n} /* '' */\n.uil-compass:before {\n  content: \"\\e952\";\n} /* '' */\n.uil-compress-alt-left:before {\n  content: \"\\e953\";\n} /* '' */\n.uil-compress-alt:before {\n  content: \"\\e954\";\n} /* '' */\n.uil-compress-arrows:before {\n  content: \"\\e955\";\n} /* '' */\n.uil-compress-lines:before {\n  content: \"\\e956\";\n} /* '' */\n.uil-compress-point:before {\n  content: \"\\e957\";\n} /* '' */\n.uil-compress-v:before {\n  content: \"\\e958\";\n} /* '' */\n.uil-compress:before {\n  content: \"\\e959\";\n} /* '' */\n.uil-computer-mouse:before {\n  content: \"\\e95a\";\n} /* '' */\n.uil-confused:before {\n  content: \"\\e95b\";\n} /* '' */\n.uil-constructor:before {\n  content: \"\\e95c\";\n} /* '' */\n.uil-copy-alt:before {\n  content: \"\\e95d\";\n} /* '' */\n.uil-copy-landscape:before {\n  content: \"\\e95e\";\n} /* '' */\n.uil-copy:before {\n  content: \"\\e95f\";\n} /* '' */\n.uil-copyright:before {\n  content: \"\\e960\";\n} /* '' */\n.uil-corner-down-left:before {\n  content: \"\\e961\";\n} /* '' */\n.uil-corner-down-right-alt:before {\n  content: \"\\e962\";\n} /* '' */\n.uil-corner-down-right:before {\n  content: \"\\e963\";\n} /* '' */\n.uil-corner-left-down:before {\n  content: \"\\e964\";\n} /* '' */\n.uil-corner-right-down:before {\n  content: \"\\e965\";\n} /* '' */\n.uil-corner-up-left-alt:before {\n  content: \"\\e966\";\n} /* '' */\n.uil-corner-up-left:before {\n  content: \"\\e967\";\n} /* '' */\n.uil-corner-up-right-alt:before {\n  content: \"\\e968\";\n} /* '' */\n.uil-corner-up-right:before {\n  content: \"\\e969\";\n} /* '' */\n.uil-creative-commons-pd-alt:before {\n  content: \"\\e96a\";\n} /* '' */\n.uil-creative-commons-pd:before {\n  content: \"\\e96b\";\n} /* '' */\n.uil-crockery:before {\n  content: \"\\e96c\";\n} /* '' */\n.uil-crop-alt-rotate-left:before {\n  content: \"\\e96d\";\n} /* '' */\n.uil-crop-alt-rotate-right:before {\n  content: \"\\e96e\";\n} /* '' */\n.uil-crop-alt:before {\n  content: \"\\e96f\";\n} /* '' */\n.uil-crosshair-alt:before {\n  content: \"\\e970\";\n} /* '' */\n.uil-crosshair:before {\n  content: \"\\e971\";\n} /* '' */\n.uil-crosshairs:before {\n  content: \"\\e972\";\n} /* '' */\n.uil-cube:before {\n  content: \"\\e973\";\n} /* '' */\n.uil-dashboard:before {\n  content: \"\\e974\";\n} /* '' */\n.uil-data-sharing:before {\n  content: \"\\e975\";\n} /* '' */\n.uil-database-alt:before {\n  content: \"\\e976\";\n} /* '' */\n.uil-database:before {\n  content: \"\\e977\";\n} /* '' */\n.uil-desert:before {\n  content: \"\\e978\";\n} /* '' */\n.uil-desktop-alt-slash:before {\n  content: \"\\e979\";\n} /* '' */\n.uil-desktop-alt:before {\n  content: \"\\e97a\";\n} /* '' */\n.uil-desktop-cloud-alt:before {\n  content: \"\\e97b\";\n} /* '' */\n.uil-desktop-slash:before {\n  content: \"\\e97c\";\n} /* '' */\n.uil-desktop:before {\n  content: \"\\e97d\";\n} /* '' */\n.uil-dialpad-alt:before {\n  content: \"\\e97e\";\n} /* '' */\n.uil-dialpad:before {\n  content: \"\\e97f\";\n} /* '' */\n.uil-diamond:before {\n  content: \"\\e980\";\n} /* '' */\n.uil-diary-alt:before {\n  content: \"\\e981\";\n} /* '' */\n.uil-diary:before {\n  content: \"\\e982\";\n} /* '' */\n.uil-dice-five:before {\n  content: \"\\e983\";\n} /* '' */\n.uil-dice-four:before {\n  content: \"\\e984\";\n} /* '' */\n.uil-dice-one:before {\n  content: \"\\e985\";\n} /* '' */\n.uil-dice-six:before {\n  content: \"\\e986\";\n} /* '' */\n.uil-dice-three:before {\n  content: \"\\e987\";\n} /* '' */\n.uil-dice-two:before {\n  content: \"\\e988\";\n} /* '' */\n.uil-direction:before {\n  content: \"\\e989\";\n} /* '' */\n.uil-directions:before {\n  content: \"\\e98a\";\n} /* '' */\n.uil-dizzy-meh:before {\n  content: \"\\e98b\";\n} /* '' */\n.uil-dna:before {\n  content: \"\\e98c\";\n} /* '' */\n.uil-document-layout-center:before {\n  content: \"\\e98d\";\n} /* '' */\n.uil-document-layout-left:before {\n  content: \"\\e98e\";\n} /* '' */\n.uil-document-layout-right:before {\n  content: \"\\e98f\";\n} /* '' */\n.uil-document:before {\n  content: \"\\e990\";\n} /* '' */\n.uil-dollar-alt:before {\n  content: \"\\e991\";\n} /* '' */\n.uil-dollar-sign-alt:before {\n  content: \"\\e992\";\n} /* '' */\n.uil-dollar-sign:before {\n  content: \"\\e993\";\n} /* '' */\n.uil-down-arrow:before {\n  content: \"\\e994\";\n} /* '' */\n.uil-download-alt:before {\n  content: \"\\e995\";\n} /* '' */\n.uil-dribbble:before {\n  content: \"\\e996\";\n} /* '' */\n.uil-drill:before {\n  content: \"\\e997\";\n} /* '' */\n.uil-dropbox:before {\n  content: \"\\e998\";\n} /* '' */\n.uil-dumbbell:before {\n  content: \"\\e999\";\n} /* '' */\n.uil-ear:before {\n  content: \"\\e99a\";\n} /* '' */\n.uil-edit-alt:before {\n  content: \"\\e99b\";\n} /* '' */\n.uil-edit:before {\n  content: \"\\e99c\";\n} /* '' */\n.uil-ellipsis-h:before {\n  content: \"\\e99d\";\n} /* '' */\n.uil-ellipsis-v:before {\n  content: \"\\e99e\";\n} /* '' */\n.uil-emoji:before {\n  content: \"\\e99f\";\n} /* '' */\n.uil-enter:before {\n  content: \"\\e9a0\";\n} /* '' */\n.uil-entry:before {\n  content: \"\\e9a1\";\n} /* '' */\n.uil-envelope-add:before {\n  content: \"\\e9a2\";\n} /* '' */\n.uil-envelope-alt:before {\n  content: \"\\e9a3\";\n} /* '' */\n.uil-envelope-block:before {\n  content: \"\\e9a4\";\n} /* '' */\n.uil-envelope-bookmark:before {\n  content: \"\\e9a5\";\n} /* '' */\n.uil-envelope-check:before {\n  content: \"\\e9a6\";\n} /* '' */\n.uil-envelope-download-alt:before {\n  content: \"\\e9a7\";\n} /* '' */\n.uil-envelope-download:before {\n  content: \"\\e9a8\";\n} /* '' */\n.uil-envelope-edit:before {\n  content: \"\\e9a9\";\n} /* '' */\n.uil-envelope-exclamation:before {\n  content: \"\\e9aa\";\n} /* '' */\n.uil-envelope-heart:before {\n  content: \"\\e9ab\";\n} /* '' */\n.uil-envelope-info:before {\n  content: \"\\e9ac\";\n} /* '' */\n.uil-envelope-lock:before {\n  content: \"\\e9ad\";\n} /* '' */\n.uil-envelope-minus:before {\n  content: \"\\e9ae\";\n} /* '' */\n.uil-envelope-open:before {\n  content: \"\\e9af\";\n} /* '' */\n.uil-envelope-question:before {\n  content: \"\\e9b0\";\n} /* '' */\n.uil-envelope-receive:before {\n  content: \"\\e9b1\";\n} /* '' */\n.uil-envelope-redo:before {\n  content: \"\\e9b2\";\n} /* '' */\n.uil-envelope-search:before {\n  content: \"\\e9b3\";\n} /* '' */\n.uil-envelope-send:before {\n  content: \"\\e9b4\";\n} /* '' */\n.uil-envelope-share:before {\n  content: \"\\e9b5\";\n} /* '' */\n.uil-envelope-shield:before {\n  content: \"\\e9b6\";\n} /* '' */\n.uil-envelope-star:before {\n  content: \"\\e9b7\";\n} /* '' */\n.uil-envelope-times:before {\n  content: \"\\e9b8\";\n} /* '' */\n.uil-envelope-upload-alt:before {\n  content: \"\\e9b9\";\n} /* '' */\n.uil-envelope-upload:before {\n  content: \"\\e9ba\";\n} /* '' */\n.uil-envelope:before {\n  content: \"\\e9bb\";\n} /* '' */\n.uil-envelopes:before {\n  content: \"\\e9bc\";\n} /* '' */\n.uil-equal-circle:before {\n  content: \"\\e9bd\";\n} /* '' */\n.uil-euro-circle:before {\n  content: \"\\e9be\";\n} /* '' */\n.uil-euro:before {\n  content: \"\\e9bf\";\n} /* '' */\n.uil-exchange-alt:before {\n  content: \"\\e9c0\";\n} /* '' */\n.uil-exchange:before {\n  content: \"\\e9c1\";\n} /* '' */\n.uil-exclamation-circle:before {\n  content: \"\\e9c2\";\n} /* '' */\n.uil-exclamation-octagon:before {\n  content: \"\\e9c3\";\n} /* '' */\n.uil-exclamation-triangle:before {\n  content: \"\\e9c4\";\n} /* '' */\n.uil-exclude:before {\n  content: \"\\e9c5\";\n} /* '' */\n.uil-exit:before {\n  content: \"\\e9c6\";\n} /* '' */\n.uil-expand-alt:before {\n  content: \"\\e9c7\";\n} /* '' */\n.uil-expand-arrows-alt:before {\n  content: \"\\e9c8\";\n} /* '' */\n.uil-expand-arrows:before {\n  content: \"\\e9c9\";\n} /* '' */\n.uil-expand-from-corner:before {\n  content: \"\\e9ca\";\n} /* '' */\n.uil-expand-left:before {\n  content: \"\\e9cb\";\n} /* '' */\n.uil-expand-right:before {\n  content: \"\\e9cc\";\n} /* '' */\n.uil-export:before {\n  content: \"\\e9cd\";\n} /* '' */\n.uil-exposure-alt:before {\n  content: \"\\e9ce\";\n} /* '' */\n.uil-exposure-increase:before {\n  content: \"\\e9cf\";\n} /* '' */\n.uil-external-link-alt:before {\n  content: \"\\e9d0\";\n} /* '' */\n.uil-eye-slash:before {\n  content: \"\\e9d1\";\n} /* '' */\n.uil-eye:before {\n  content: \"\\e9d2\";\n} /* '' */\n.uil-facebook-f:before {\n  content: \"\\e9d3\";\n} /* '' */\n.uil-facebook-messenger-alt:before {\n  content: \"\\e9d4\";\n} /* '' */\n.uil-facebook-messenger:before {\n  content: \"\\e9d5\";\n} /* '' */\n.uil-facebook:before {\n  content: \"\\e9d6\";\n} /* '' */\n.uil-fahrenheit:before {\n  content: \"\\e9d7\";\n} /* '' */\n.uil-fast-mail-alt:before {\n  content: \"\\e9d8\";\n} /* '' */\n.uil-fast-mail:before {\n  content: \"\\e9d9\";\n} /* '' */\n.uil-favorite:before {\n  content: \"\\e9da\";\n} /* '' */\n.uil-feedback:before {\n  content: \"\\e9db\";\n} /* '' */\n.uil-file-alt:before {\n  content: \"\\e9dc\";\n} /* '' */\n.uil-file-blank:before {\n  content: \"\\e9dd\";\n} /* '' */\n.uil-file-block-alt:before {\n  content: \"\\e9de\";\n} /* '' */\n.uil-file-bookmark-alt:before {\n  content: \"\\e9df\";\n} /* '' */\n.uil-file-check-alt:before {\n  content: \"\\e9e0\";\n} /* '' */\n.uil-file-check:before {\n  content: \"\\e9e1\";\n} /* '' */\n.uil-file-contract-dollar:before {\n  content: \"\\e9e2\";\n} /* '' */\n.uil-file-copy-alt:before {\n  content: \"\\e9e3\";\n} /* '' */\n.uil-file-download-alt:before {\n  content: \"\\e9e4\";\n} /* '' */\n.uil-file-download:before {\n  content: \"\\e9e5\";\n} /* '' */\n.uil-file-edit-alt:before {\n  content: \"\\e9e6\";\n} /* '' */\n.uil-file-exclamation-alt:before {\n  content: \"\\e9e7\";\n} /* '' */\n.uil-file-exclamation:before {\n  content: \"\\e9e8\";\n} /* '' */\n.uil-file-heart:before {\n  content: \"\\e9e9\";\n} /* '' */\n.uil-file-info-alt:before {\n  content: \"\\e9ea\";\n} /* '' */\n.uil-file-landscape-alt:before {\n  content: \"\\e9eb\";\n} /* '' */\n.uil-file-landscape:before {\n  content: \"\\e9ec\";\n} /* '' */\n.uil-file-lanscape-slash:before {\n  content: \"\\e9ed\";\n} /* '' */\n.uil-file-lock-alt:before {\n  content: \"\\e9ee\";\n} /* '' */\n.uil-file-medical-alt:before {\n  content: \"\\e9ef\";\n} /* '' */\n.uil-file-medical:before {\n  content: \"\\e9f0\";\n} /* '' */\n.uil-file-minus-alt:before {\n  content: \"\\e9f1\";\n} /* '' */\n.uil-file-minus:before {\n  content: \"\\e9f2\";\n} /* '' */\n.uil-file-network:before {\n  content: \"\\e9f3\";\n} /* '' */\n.uil-file-plus-alt:before {\n  content: \"\\e9f4\";\n} /* '' */\n.uil-file-plus:before {\n  content: \"\\e9f5\";\n} /* '' */\n.uil-file-question-alt:before {\n  content: \"\\e9f6\";\n} /* '' */\n.uil-file-question:before {\n  content: \"\\e9f7\";\n} /* '' */\n.uil-file-redo-alt:before {\n  content: \"\\e9f8\";\n} /* '' */\n.uil-file-search-alt:before {\n  content: \"\\e9f9\";\n} /* '' */\n.uil-file-share-alt:before {\n  content: \"\\e9fa\";\n} /* '' */\n.uil-file-shield-alt:before {\n  content: \"\\e9fb\";\n} /* '' */\n.uil-file-slash:before {\n  content: \"\\e9fc\";\n} /* '' */\n.uil-file-times-alt:before {\n  content: \"\\e9fd\";\n} /* '' */\n.uil-file-times:before {\n  content: \"\\e9fe\";\n} /* '' */\n.uil-file-upload-alt:before {\n  content: \"\\e9ff\";\n} /* '' */\n.uil-file-upload:before {\n  content: \"\\ea00\";\n} /* '' */\n.uil-file:before {\n  content: \"\\ea01\";\n} /* '' */\n.uil-files-landscapes-alt:before {\n  content: \"\\ea02\";\n} /* '' */\n.uil-files-landscapes:before {\n  content: \"\\ea03\";\n} /* '' */\n.uil-film:before {\n  content: \"\\ea04\";\n} /* '' */\n.uil-filter-slash:before {\n  content: \"\\ea05\";\n} /* '' */\n.uil-filter:before {\n  content: \"\\ea06\";\n} /* '' */\n.uil-fire:before {\n  content: \"\\ea07\";\n} /* '' */\n.uil-flask-potion:before {\n  content: \"\\ea08\";\n} /* '' */\n.uil-flask:before {\n  content: \"\\ea09\";\n} /* '' */\n.uil-flip-h-alt:before {\n  content: \"\\ea0a\";\n} /* '' */\n.uil-flip-h:before {\n  content: \"\\ea0b\";\n} /* '' */\n.uil-flip-v-alt:before {\n  content: \"\\ea0c\";\n} /* '' */\n.uil-flip-v:before {\n  content: \"\\ea0d\";\n} /* '' */\n.uil-flower:before {\n  content: \"\\ea0e\";\n} /* '' */\n.uil-focus-add:before {\n  content: \"\\ea0f\";\n} /* '' */\n.uil-focus-target:before {\n  content: \"\\ea10\";\n} /* '' */\n.uil-focus:before {\n  content: \"\\ea11\";\n} /* '' */\n.uil-folder-check:before {\n  content: \"\\ea12\";\n} /* '' */\n.uil-folder-download:before {\n  content: \"\\ea13\";\n} /* '' */\n.uil-folder-exclamation:before {\n  content: \"\\ea14\";\n} /* '' */\n.uil-folder-heart:before {\n  content: \"\\ea15\";\n} /* '' */\n.uil-folder-info:before {\n  content: \"\\ea16\";\n} /* '' */\n.uil-folder-lock:before {\n  content: \"\\ea17\";\n} /* '' */\n.uil-folder-medical:before {\n  content: \"\\ea18\";\n} /* '' */\n.uil-folder-minus:before {\n  content: \"\\ea19\";\n} /* '' */\n.uil-folder-network:before {\n  content: \"\\ea1a\";\n} /* '' */\n.uil-folder-plus:before {\n  content: \"\\ea1b\";\n} /* '' */\n.uil-folder-question:before {\n  content: \"\\ea1c\";\n} /* '' */\n.uil-folder-slash:before {\n  content: \"\\ea1d\";\n} /* '' */\n.uil-folder-times:before {\n  content: \"\\ea1e\";\n} /* '' */\n.uil-folder-upload:before {\n  content: \"\\ea1f\";\n} /* '' */\n.uil-folder:before {\n  content: \"\\ea20\";\n} /* '' */\n.uil-food:before {\n  content: \"\\ea21\";\n} /* '' */\n.uil-football-american:before {\n  content: \"\\ea22\";\n} /* '' */\n.uil-football-ball:before {\n  content: \"\\ea23\";\n} /* '' */\n.uil-football:before {\n  content: \"\\ea24\";\n} /* '' */\n.uil-forecastcloud-moon-tear:before {\n  content: \"\\ea25\";\n} /* '' */\n.uil-forwaded-call:before {\n  content: \"\\ea26\";\n} /* '' */\n.uil-forward:before {\n  content: \"\\ea27\";\n} /* '' */\n.uil-frown:before {\n  content: \"\\ea28\";\n} /* '' */\n.uil-game-structure:before {\n  content: \"\\ea29\";\n} /* '' */\n.uil-game:before {\n  content: \"\\ea2a\";\n} /* '' */\n.uil-gift:before {\n  content: \"\\ea2b\";\n} /* '' */\n.uil-github-alt:before {\n  content: \"\\ea2c\";\n} /* '' */\n.uil-github:before {\n  content: \"\\ea2d\";\n} /* '' */\n.uil-glass-martini-alt-slash:before {\n  content: \"\\ea2e\";\n} /* '' */\n.uil-glass-martini-alt:before {\n  content: \"\\ea2f\";\n} /* '' */\n.uil-glass-martini:before {\n  content: \"\\ea30\";\n} /* '' */\n.uil-glass-tea:before {\n  content: \"\\ea31\";\n} /* '' */\n.uil-glass:before {\n  content: \"\\ea32\";\n} /* '' */\n.uil-globe:before {\n  content: \"\\ea33\";\n} /* '' */\n.uil-gold:before {\n  content: \"\\ea34\";\n} /* '' */\n.uil-google-drive-alt:before {\n  content: \"\\ea35\";\n} /* '' */\n.uil-google-drive:before {\n  content: \"\\ea36\";\n} /* '' */\n.uil-google-hangouts-alt:before {\n  content: \"\\ea37\";\n} /* '' */\n.uil-google-hangouts:before {\n  content: \"\\ea38\";\n} /* '' */\n.uil-google-play:before {\n  content: \"\\ea39\";\n} /* '' */\n.uil-google:before {\n  content: \"\\ea3a\";\n} /* '' */\n.uil-graduation-hat:before {\n  content: \"\\ea3b\";\n} /* '' */\n.uil-graph-bar:before {\n  content: \"\\ea3c\";\n} /* '' */\n.uil-grid:before {\n  content: \"\\ea3d\";\n} /* '' */\n.uil-grids:before {\n  content: \"\\ea3e\";\n} /* '' */\n.uil-grin-tongue-wink-alt:before {\n  content: \"\\ea3f\";\n} /* '' */\n.uil-grin-tongue-wink:before {\n  content: \"\\ea40\";\n} /* '' */\n.uil-grin:before {\n  content: \"\\ea41\";\n} /* '' */\n.uil-grip-horizontal-line:before {\n  content: \"\\ea42\";\n} /* '' */\n.uil-hdd:before {\n  content: \"\\ea43\";\n} /* '' */\n.uil-headphones-alt:before {\n  content: \"\\ea44\";\n} /* '' */\n.uil-headphones:before {\n  content: \"\\ea45\";\n} /* '' */\n.uil-heart-alt:before {\n  content: \"\\ea46\";\n} /* '' */\n.uil-heart-medical:before {\n  content: \"\\ea47\";\n} /* '' */\n.uil-heart-rate:before {\n  content: \"\\ea48\";\n} /* '' */\n.uil-heart-sign:before {\n  content: \"\\ea49\";\n} /* '' */\n.uil-heart:before {\n  content: \"\\ea4a\";\n} /* '' */\n.uil-heartbeat:before {\n  content: \"\\ea4b\";\n} /* '' */\n.uil-history-alt:before {\n  content: \"\\ea4c\";\n} /* '' */\n.uil-history:before {\n  content: \"\\ea4d\";\n} /* '' */\n.uil-home-alt:before {\n  content: \"\\ea4e\";\n} /* '' */\n.uil-home:before {\n  content: \"\\ea4f\";\n} /* '' */\n.uil-horizontal-align-center:before {\n  content: \"\\ea50\";\n} /* '' */\n.uil-horizontal-align-left:before {\n  content: \"\\ea51\";\n} /* '' */\n.uil-horizontal-align-right:before {\n  content: \"\\ea52\";\n} /* '' */\n.uil-horizontal-distribution-center:before {\n  content: \"\\ea53\";\n} /* '' */\n.uil-horizontal-distribution-left:before {\n  content: \"\\ea54\";\n} /* '' */\n.uil-horizontal-distribution-right:before {\n  content: \"\\ea55\";\n} /* '' */\n.uil-hourglass:before {\n  content: \"\\ea56\";\n} /* '' */\n.uil-html3-alt:before {\n  content: \"\\ea57\";\n} /* '' */\n.uil-html3:before {\n  content: \"\\ea58\";\n} /* '' */\n.uil-hunting:before {\n  content: \"\\ea59\";\n} /* '' */\n.uil-image-alt-slash:before {\n  content: \"\\ea5a\";\n} /* '' */\n.uil-image-block:before {\n  content: \"\\ea5b\";\n} /* '' */\n.uil-image-broken:before {\n  content: \"\\ea5c\";\n} /* '' */\n.uil-image-check:before {\n  content: \"\\ea5d\";\n} /* '' */\n.uil-image-download:before {\n  content: \"\\ea5e\";\n} /* '' */\n.uil-image-edit:before {\n  content: \"\\ea5f\";\n} /* '' */\n.uil-image-lock:before {\n  content: \"\\ea60\";\n} /* '' */\n.uil-image-minus:before {\n  content: \"\\ea61\";\n} /* '' */\n.uil-image-plus:before {\n  content: \"\\ea62\";\n} /* '' */\n.uil-image-question:before {\n  content: \"\\ea63\";\n} /* '' */\n.uil-image-redo:before {\n  content: \"\\ea64\";\n} /* '' */\n.uil-image-resize-landscape:before {\n  content: \"\\ea65\";\n} /* '' */\n.uil-image-resize-square:before {\n  content: \"\\ea66\";\n} /* '' */\n.uil-image-search:before {\n  content: \"\\ea67\";\n} /* '' */\n.uil-image-share:before {\n  content: \"\\ea68\";\n} /* '' */\n.uil-image-shield:before {\n  content: \"\\ea69\";\n} /* '' */\n.uil-image-slash:before {\n  content: \"\\ea6a\";\n} /* '' */\n.uil-image-times:before {\n  content: \"\\ea6b\";\n} /* '' */\n.uil-image-upload:before {\n  content: \"\\ea6c\";\n} /* '' */\n.uil-image-v:before {\n  content: \"\\ea6d\";\n} /* '' */\n.uil-image:before {\n  content: \"\\ea6e\";\n} /* '' */\n.uil-images:before {\n  content: \"\\ea6f\";\n} /* '' */\n.uil-import:before {\n  content: \"\\ea70\";\n} /* '' */\n.uil-incoming-call:before {\n  content: \"\\ea71\";\n} /* '' */\n.uil-info-circle:before {\n  content: \"\\ea72\";\n} /* '' */\n.uil-instagram-alt:before {\n  content: \"\\ea73\";\n} /* '' */\n.uil-instagram:before {\n  content: \"\\ea74\";\n} /* '' */\n.uil-intercom-alt:before {\n  content: \"\\ea75\";\n} /* '' */\n.uil-intercom:before {\n  content: \"\\ea76\";\n} /* '' */\n.uil-invoice:before {\n  content: \"\\ea77\";\n} /* '' */\n.uil-italic:before {\n  content: \"\\ea78\";\n} /* '' */\n.uil-jackhammer:before {\n  content: \"\\ea79\";\n} /* '' */\n.uil-java-script:before {\n  content: \"\\ea7a\";\n} /* '' */\n.uil-kayak:before {\n  content: \"\\ea7b\";\n} /* '' */\n.uil-key-skeleton-alt:before {\n  content: \"\\ea7c\";\n} /* '' */\n.uil-key-skeleton:before {\n  content: \"\\ea7d\";\n} /* '' */\n.uil-keyboard-alt:before {\n  content: \"\\ea7e\";\n} /* '' */\n.uil-keyboard-hide:before {\n  content: \"\\ea7f\";\n} /* '' */\n.uil-keyboard-show:before {\n  content: \"\\ea80\";\n} /* '' */\n.uil-keyboard:before {\n  content: \"\\ea81\";\n} /* '' */\n.uil-keyhole-circle:before {\n  content: \"\\ea82\";\n} /* '' */\n.uil-keyhole-square-full:before {\n  content: \"\\ea83\";\n} /* '' */\n.uil-keyhole-square:before {\n  content: \"\\ea84\";\n} /* '' */\n.uil-kid:before {\n  content: \"\\ea85\";\n} /* '' */\n.uil-label-alt:before {\n  content: \"\\ea86\";\n} /* '' */\n.uil-label:before {\n  content: \"\\ea87\";\n} /* '' */\n.uil-lamp:before {\n  content: \"\\ea88\";\n} /* '' */\n.uil-laptop-cloud:before {\n  content: \"\\ea89\";\n} /* '' */\n.uil-laptop:before {\n  content: \"\\ea8a\";\n} /* '' */\n.uil-laughing:before {\n  content: \"\\ea8b\";\n} /* '' */\n.uil-layer-group-slash:before {\n  content: \"\\ea8c\";\n} /* '' */\n.uil-layer-group:before {\n  content: \"\\ea8d\";\n} /* '' */\n.uil-layers-alt:before {\n  content: \"\\ea8e\";\n} /* '' */\n.uil-layers-slash:before {\n  content: \"\\ea8f\";\n} /* '' */\n.uil-layers:before {\n  content: \"\\ea90\";\n} /* '' */\n.uil-left-arrow-from-left:before {\n  content: \"\\ea91\";\n} /* '' */\n.uil-left-arrow-to-left:before {\n  content: \"\\ea92\";\n} /* '' */\n.uil-left-indent-alt:before {\n  content: \"\\ea93\";\n} /* '' */\n.uil-left-indent:before {\n  content: \"\\ea94\";\n} /* '' */\n.uil-left-to-right-text-direction:before {\n  content: \"\\ea95\";\n} /* '' */\n.uil-life-ring:before {\n  content: \"\\ea96\";\n} /* '' */\n.uil-lightbulb-alt:before {\n  content: \"\\ea97\";\n} /* '' */\n.uil-lightbulb:before {\n  content: \"\\ea98\";\n} /* '' */\n.uil-line-alt:before {\n  content: \"\\ea99\";\n} /* '' */\n.uil-line-spacing:before {\n  content: \"\\ea9a\";\n} /* '' */\n.uil-line:before {\n  content: \"\\ea9b\";\n} /* '' */\n.uil-link-alt:before {\n  content: \"\\ea9c\";\n} /* '' */\n.uil-link-broken:before {\n  content: \"\\ea9d\";\n} /* '' */\n.uil-link-h:before {\n  content: \"\\ea9e\";\n} /* '' */\n.uil-link:before {\n  content: \"\\ea9f\";\n} /* '' */\n.uil-linkedin-alt:before {\n  content: \"\\eaa0\";\n} /* '' */\n.uil-linkedin:before {\n  content: \"\\eaa1\";\n} /* '' */\n.uil-list-ui-alt:before {\n  content: \"\\eaa2\";\n} /* '' */\n.uil-list-ul:before {\n  content: \"\\eaa3\";\n} /* '' */\n.uil-location-arrow-alt:before {\n  content: \"\\eaa4\";\n} /* '' */\n.uil-location-arrow:before {\n  content: \"\\eaa5\";\n} /* '' */\n.uil-location-pin-alt:before {\n  content: \"\\eaa6\";\n} /* '' */\n.uil-location-point:before {\n  content: \"\\eaa7\";\n} /* '' */\n.uil-location:before {\n  content: \"\\eaa8\";\n} /* '' */\n.uil-lock-access:before {\n  content: \"\\eaa9\";\n} /* '' */\n.uil-lock-alt:before {\n  content: \"\\eaaa\";\n} /* '' */\n.uil-lock-open-alt:before {\n  content: \"\\eaab\";\n} /* '' */\n.uil-lock-slash:before {\n  content: \"\\eaac\";\n} /* '' */\n.uil-lock:before {\n  content: \"\\eaad\";\n} /* '' */\n.uil-mailbox-alt:before {\n  content: \"\\eaae\";\n} /* '' */\n.uil-mailbox:before {\n  content: \"\\eaaf\";\n} /* '' */\n.uil-map-marker-alt:before {\n  content: \"\\eab0\";\n} /* '' */\n.uil-map-marker-edit:before {\n  content: \"\\eab1\";\n} /* '' */\n.uil-map-marker-info:before {\n  content: \"\\eab2\";\n} /* '' */\n.uil-map-marker-minus:before {\n  content: \"\\eab3\";\n} /* '' */\n.uil-map-marker-plus:before {\n  content: \"\\eab4\";\n} /* '' */\n.uil-map-marker-question:before {\n  content: \"\\eab5\";\n} /* '' */\n.uil-map-marker-shield:before {\n  content: \"\\eab6\";\n} /* '' */\n.uil-map-marker-slash:before {\n  content: \"\\eab7\";\n} /* '' */\n.uil-map-marker:before {\n  content: \"\\eab8\";\n} /* '' */\n.uil-map-pin-alt:before {\n  content: \"\\eab9\";\n} /* '' */\n.uil-map-pin:before {\n  content: \"\\eaba\";\n} /* '' */\n.uil-map:before {\n  content: \"\\eabb\";\n} /* '' */\n.uil-mars:before {\n  content: \"\\eabc\";\n} /* '' */\n.uil-master-card:before {\n  content: \"\\eabd\";\n} /* '' */\n.uil-maximize-left:before {\n  content: \"\\eabe\";\n} /* '' */\n.uil-medal:before {\n  content: \"\\eabf\";\n} /* '' */\n.uil-medical-drip:before {\n  content: \"\\eac0\";\n} /* '' */\n.uil-medical-square-full:before {\n  content: \"\\eac1\";\n} /* '' */\n.uil-medical-square:before {\n  content: \"\\eac2\";\n} /* '' */\n.uil-medical:before {\n  content: \"\\eac3\";\n} /* '' */\n.uil-medium-m:before {\n  content: \"\\eac4\";\n} /* '' */\n.uil-medkit:before {\n  content: \"\\eac5\";\n} /* '' */\n.uil-meeting-board:before {\n  content: \"\\eac6\";\n} /* '' */\n.uil-megaphone:before {\n  content: \"\\eac7\";\n} /* '' */\n.uil-meh-alt:before {\n  content: \"\\eac8\";\n} /* '' */\n.uil-meh-closed-eye:before {\n  content: \"\\eac9\";\n} /* '' */\n.uil-meh:before {\n  content: \"\\eaca\";\n} /* '' */\n.uil-message:before {\n  content: \"\\eacb\";\n} /* '' */\n.uil-metro:before {\n  content: \"\\eacc\";\n} /* '' */\n.uil-microphone-slash:before {\n  content: \"\\eacd\";\n} /* '' */\n.uil-microphone:before {\n  content: \"\\eace\";\n} /* '' */\n.uil-minus-circle:before {\n  content: \"\\eacf\";\n} /* '' */\n.uil-minus-path:before {\n  content: \"\\ead0\";\n} /* '' */\n.uil-minus-square-full:before {\n  content: \"\\ead1\";\n} /* '' */\n.uil-minus-square:before {\n  content: \"\\ead2\";\n} /* '' */\n.uil-minus:before {\n  content: \"\\ead3\";\n} /* '' */\n.uil-missed-call:before {\n  content: \"\\ead4\";\n} /* '' */\n.uil-mobey-bill-slash:before {\n  content: \"\\ead5\";\n} /* '' */\n.uil-mobile-android-alt:before {\n  content: \"\\ead6\";\n} /* '' */\n.uil-mobile-android:before {\n  content: \"\\ead7\";\n} /* '' */\n.uil-mobile-vibrate:before {\n  content: \"\\ead8\";\n} /* '' */\n.uil-modem:before {\n  content: \"\\ead9\";\n} /* '' */\n.uil-money-bill-stack:before {\n  content: \"\\eada\";\n} /* '' */\n.uil-money-bill:before {\n  content: \"\\eadb\";\n} /* '' */\n.uil-money-insert:before {\n  content: \"\\eadc\";\n} /* '' */\n.uil-money-stack:before {\n  content: \"\\eadd\";\n} /* '' */\n.uil-money-withdraw:before {\n  content: \"\\eade\";\n} /* '' */\n.uil-money-withdrawal:before {\n  content: \"\\eadf\";\n} /* '' */\n.uil-moneybag-alt:before {\n  content: \"\\eae0\";\n} /* '' */\n.uil-moneybag:before {\n  content: \"\\eae1\";\n} /* '' */\n.uil-monitor-heart-rate:before {\n  content: \"\\eae2\";\n} /* '' */\n.uil-monitor:before {\n  content: \"\\eae3\";\n} /* '' */\n.uil-moon-eclipse:before {\n  content: \"\\eae4\";\n} /* '' */\n.uil-moon:before {\n  content: \"\\eae5\";\n} /* '' */\n.uil-moonset:before {\n  content: \"\\eae6\";\n} /* '' */\n.uil-mountains-sun:before {\n  content: \"\\eae7\";\n} /* '' */\n.uil-mountains:before {\n  content: \"\\eae8\";\n} /* '' */\n.uil-mouse-alt:before {\n  content: \"\\eae9\";\n} /* '' */\n.uil-mouse:before {\n  content: \"\\eaea\";\n} /* '' */\n.uil-multiply:before {\n  content: \"\\eaeb\";\n} /* '' */\n.uil-music-note:before {\n  content: \"\\eaec\";\n} /* '' */\n.uil-music-tune-slash:before {\n  content: \"\\eaed\";\n} /* '' */\n.uil-music:before {\n  content: \"\\eaee\";\n} /* '' */\n.uil-n-a:before {\n  content: \"\\eaef\";\n} /* '' */\n.uil-navigator:before {\n  content: \"\\eaf0\";\n} /* '' */\n.uil-nerd:before {\n  content: \"\\eaf1\";\n} /* '' */\n.uil-newspaper:before {\n  content: \"\\eaf2\";\n} /* '' */\n.uil-ninja:before {\n  content: \"\\eaf3\";\n} /* '' */\n.uil-no-entry:before {\n  content: \"\\eaf4\";\n} /* '' */\n.uil-notebooks:before {\n  content: \"\\eaf5\";\n} /* '' */\n.uil-notes:before {\n  content: \"\\eaf6\";\n} /* '' */\n.uil-object-group:before {\n  content: \"\\eaf7\";\n} /* '' */\n.uil-object-ungroup:before {\n  content: \"\\eaf8\";\n} /* '' */\n.uil-octagon:before {\n  content: \"\\eaf9\";\n} /* '' */\n.uil-opera-alt:before {\n  content: \"\\eafa\";\n} /* '' */\n.uil-opera:before {\n  content: \"\\eafb\";\n} /* '' */\n.uil-outgoing-call:before {\n  content: \"\\eafc\";\n} /* '' */\n.uil-package:before {\n  content: \"\\eafd\";\n} /* '' */\n.uil-padlock:before {\n  content: \"\\eafe\";\n} /* '' */\n.uil-paint-tool:before {\n  content: \"\\eaff\";\n} /* '' */\n.uil-palette:before {\n  content: \"\\eb00\";\n} /* '' */\n.uil-panorama-h-alt:before {\n  content: \"\\eb01\";\n} /* '' */\n.uil-panorama-h:before {\n  content: \"\\eb02\";\n} /* '' */\n.uil-panorama-v:before {\n  content: \"\\eb03\";\n} /* '' */\n.uil-paperclip:before {\n  content: \"\\eb04\";\n} /* '' */\n.uil-paragraph:before {\n  content: \"\\eb05\";\n} /* '' */\n.uil-parcel:before {\n  content: \"\\eb06\";\n} /* '' */\n.uil-parking-square:before {\n  content: \"\\eb07\";\n} /* '' */\n.uil-pathfinder-unite:before {\n  content: \"\\eb08\";\n} /* '' */\n.uil-pathfinder:before {\n  content: \"\\eb09\";\n} /* '' */\n.uil-pause-circle:before {\n  content: \"\\eb0a\";\n} /* '' */\n.uil-pause:before {\n  content: \"\\eb0b\";\n} /* '' */\n.uil-paypal:before {\n  content: \"\\eb0c\";\n} /* '' */\n.uil-pen:before {\n  content: \"\\eb0d\";\n} /* '' */\n.uil-pentagon:before {\n  content: \"\\eb0e\";\n} /* '' */\n.uil-percentage:before {\n  content: \"\\eb0f\";\n} /* '' */\n.uil-phone-alt:before {\n  content: \"\\eb10\";\n} /* '' */\n.uil-phone-pause:before {\n  content: \"\\eb11\";\n} /* '' */\n.uil-phone-slash:before {\n  content: \"\\eb12\";\n} /* '' */\n.uil-phone-times:before {\n  content: \"\\eb13\";\n} /* '' */\n.uil-phone-volume:before {\n  content: \"\\eb14\";\n} /* '' */\n.uil-phone:before {\n  content: \"\\eb15\";\n} /* '' */\n.uil-picture:before {\n  content: \"\\eb16\";\n} /* '' */\n.uil-plane-arrival:before {\n  content: \"\\eb17\";\n} /* '' */\n.uil-plane-departure:before {\n  content: \"\\eb18\";\n} /* '' */\n.uil-plane-fly:before {\n  content: \"\\eb19\";\n} /* '' */\n.uil-plane:before {\n  content: \"\\eb1a\";\n} /* '' */\n.uil-play-circle:before {\n  content: \"\\eb1b\";\n} /* '' */\n.uil-play:before {\n  content: \"\\eb1c\";\n} /* '' */\n.uil-plug:before {\n  content: \"\\eb1d\";\n} /* '' */\n.uil-plus-circle:before {\n  content: \"\\eb1e\";\n} /* '' */\n.uil-plus-square:before {\n  content: \"\\eb1f\";\n} /* '' */\n.uil-plus:before {\n  content: \"\\eb20\";\n} /* '' */\n.uil-podium:before {\n  content: \"\\eb21\";\n} /* '' */\n.uil-polygon:before {\n  content: \"\\eb22\";\n} /* '' */\n.uil-post-stamp:before {\n  content: \"\\eb23\";\n} /* '' */\n.uil-postcard:before {\n  content: \"\\eb24\";\n} /* '' */\n.uil-pound-circle:before {\n  content: \"\\eb25\";\n} /* '' */\n.uil-pound:before {\n  content: \"\\eb26\";\n} /* '' */\n.uil-power:before {\n  content: \"\\eb27\";\n} /* '' */\n.uil-prescription-bottle:before {\n  content: \"\\eb28\";\n} /* '' */\n.uil-presentation-check:before {\n  content: \"\\eb29\";\n} /* '' */\n.uil-presentation-edit:before {\n  content: \"\\eb2a\";\n} /* '' */\n.uil-presentation-line:before {\n  content: \"\\eb2b\";\n} /* '' */\n.uil-presentation-lines-alt:before {\n  content: \"\\eb2c\";\n} /* '' */\n.uil-presentation-minus:before {\n  content: \"\\eb2d\";\n} /* '' */\n.uil-presentation-play:before {\n  content: \"\\eb2e\";\n} /* '' */\n.uil-presentation-plus:before {\n  content: \"\\eb2f\";\n} /* '' */\n.uil-presentation-times:before {\n  content: \"\\eb30\";\n} /* '' */\n.uil-presentation:before {\n  content: \"\\eb31\";\n} /* '' */\n.uil-previous:before {\n  content: \"\\eb32\";\n} /* '' */\n.uil-pricetag-alt:before {\n  content: \"\\eb33\";\n} /* '' */\n.uil-print-slash:before {\n  content: \"\\eb34\";\n} /* '' */\n.uil-print:before {\n  content: \"\\eb35\";\n} /* '' */\n.uil-process:before {\n  content: \"\\eb36\";\n} /* '' */\n.uil-processor:before {\n  content: \"\\eb37\";\n} /* '' */\n.uil-pump:before {\n  content: \"\\eb38\";\n} /* '' */\n.uil-puzzle-piece:before {\n  content: \"\\eb39\";\n} /* '' */\n.uil-question-circle:before {\n  content: \"\\eb3a\";\n} /* '' */\n.uil-raddit-alien-alt:before {\n  content: \"\\eb3b\";\n} /* '' */\n.uil-rainbow:before {\n  content: \"\\eb3c\";\n} /* '' */\n.uil-raindrops-alt:before {\n  content: \"\\eb3d\";\n} /* '' */\n.uil-raindrops:before {\n  content: \"\\eb3e\";\n} /* '' */\n.uil-react:before {\n  content: \"\\eb3f\";\n} /* '' */\n.uil-receipt-alt:before {\n  content: \"\\eb40\";\n} /* '' */\n.uil-receipt:before {\n  content: \"\\eb41\";\n} /* '' */\n.uil-record-audio:before {\n  content: \"\\eb42\";\n} /* '' */\n.uil-reddit-alien-alt:before {\n  content: \"\\eb43\";\n} /* '' */\n.uil-redo:before {\n  content: \"\\eb44\";\n} /* '' */\n.uil-refresh:before {\n  content: \"\\eb45\";\n} /* '' */\n.uil-registered:before {\n  content: \"\\eb46\";\n} /* '' */\n.uil-repeat:before {\n  content: \"\\eb47\";\n} /* '' */\n.uil-restaurant:before {\n  content: \"\\eb48\";\n} /* '' */\n.uil-right-indent-alt:before {\n  content: \"\\eb49\";\n} /* '' */\n.uil-right-to-left-text-direction:before {\n  content: \"\\eb4a\";\n} /* '' */\n.uil-robot:before {\n  content: \"\\eb4b\";\n} /* '' */\n.uil-rope-way:before {\n  content: \"\\eb4c\";\n} /* '' */\n.uil-rotate-360:before {\n  content: \"\\eb4d\";\n} /* '' */\n.uil-rss-alt:before {\n  content: \"\\eb4e\";\n} /* '' */\n.uil-rss-interface:before {\n  content: \"\\eb4f\";\n} /* '' */\n.uil-rss:before {\n  content: \"\\eb50\";\n} /* '' */\n.uil-ruler-combined:before {\n  content: \"\\eb51\";\n} /* '' */\n.uil-ruler:before {\n  content: \"\\eb52\";\n} /* '' */\n.uil-sad-cry:before {\n  content: \"\\eb53\";\n} /* '' */\n.uil-sad-crying:before {\n  content: \"\\eb54\";\n} /* '' */\n.uil-sad-dizzy:before {\n  content: \"\\eb55\";\n} /* '' */\n.uil-sad-squint:before {\n  content: \"\\eb56\";\n} /* '' */\n.uil-sad:before {\n  content: \"\\eb57\";\n} /* '' */\n.uil-scaling-left:before {\n  content: \"\\eb58\";\n} /* '' */\n.uil-scaling-right:before {\n  content: \"\\eb59\";\n} /* '' */\n.uil-scenery:before {\n  content: \"\\eb5a\";\n} /* '' */\n.uil-schedule:before {\n  content: \"\\eb5b\";\n} /* '' */\n.uil-science:before {\n  content: \"\\eb5c\";\n} /* '' */\n.uil-screw:before {\n  content: \"\\eb5d\";\n} /* '' */\n.uil-scroll-h:before {\n  content: \"\\eb5e\";\n} /* '' */\n.uil-scroll:before {\n  content: \"\\eb5f\";\n} /* '' */\n.uil-search-alt:before {\n  content: \"\\eb60\";\n} /* '' */\n.uil-search-minus:before {\n  content: \"\\eb61\";\n} /* '' */\n.uil-search-plus:before {\n  content: \"\\eb62\";\n} /* '' */\n.uil-search:before {\n  content: \"\\eb63\";\n} /* '' */\n.uil-selfie:before {\n  content: \"\\eb64\";\n} /* '' */\n.uil-server-alt:before {\n  content: \"\\eb65\";\n} /* '' */\n.uil-server-connection:before {\n  content: \"\\eb66\";\n} /* '' */\n.uil-server-network-alt:before {\n  content: \"\\eb67\";\n} /* '' */\n.uil-server-network:before {\n  content: \"\\eb68\";\n} /* '' */\n.uil-server:before {\n  content: \"\\eb69\";\n} /* '' */\n.uil-servers:before {\n  content: \"\\eb6a\";\n} /* '' */\n.uil-servicemark:before {\n  content: \"\\eb6b\";\n} /* '' */\n.uil-share-alt:before {\n  content: \"\\eb6c\";\n} /* '' */\n.uil-shield-check:before {\n  content: \"\\eb6d\";\n} /* '' */\n.uil-shield-exclamation:before {\n  content: \"\\eb6e\";\n} /* '' */\n.uil-shield-question:before {\n  content: \"\\eb6f\";\n} /* '' */\n.uil-shield-slash:before {\n  content: \"\\eb70\";\n} /* '' */\n.uil-shield:before {\n  content: \"\\eb71\";\n} /* '' */\n.uil-ship:before {\n  content: \"\\eb72\";\n} /* '' */\n.uil-shop:before {\n  content: \"\\eb73\";\n} /* '' */\n.uil-shopping-basket:before {\n  content: \"\\eb74\";\n} /* '' */\n.uil-shopping-cart-alt:before {\n  content: \"\\eb75\";\n} /* '' */\n.uil-shopping-trolley:before {\n  content: \"\\eb76\";\n} /* '' */\n.uil-shovel:before {\n  content: \"\\eb77\";\n} /* '' */\n.uil-shrink:before {\n  content: \"\\eb78\";\n} /* '' */\n.uil-shuffle:before {\n  content: \"\\eb79\";\n} /* '' */\n.uil-shutter-alt:before {\n  content: \"\\eb7a\";\n} /* '' */\n.uil-shutter:before {\n  content: \"\\eb7b\";\n} /* '' */\n.uil-sick:before {\n  content: \"\\eb7c\";\n} /* '' */\n.uil-sigma:before {\n  content: \"\\eb7d\";\n} /* '' */\n.uil-sign-alt:before {\n  content: \"\\eb7e\";\n} /* '' */\n.uil-sign-in-alt:before {\n  content: \"\\eb7f\";\n} /* '' */\n.uil-sign-left:before {\n  content: \"\\eb80\";\n} /* '' */\n.uil-sign-out-alt:before {\n  content: \"\\eb81\";\n} /* '' */\n.uil-sign-right:before {\n  content: \"\\eb82\";\n} /* '' */\n.uil-signal-alt-3:before {\n  content: \"\\eb83\";\n} /* '' */\n.uil-signal-alt:before {\n  content: \"\\eb84\";\n} /* '' */\n.uil-signal:before {\n  content: \"\\eb85\";\n} /* '' */\n.uil-silence:before {\n  content: \"\\eb86\";\n} /* '' */\n.uil-silent-squint:before {\n  content: \"\\eb87\";\n} /* '' */\n.uil-sim-card:before {\n  content: \"\\eb88\";\n} /* '' */\n.uil-sitemap:before {\n  content: \"\\eb89\";\n} /* '' */\n.uil-skip-forward-alt:before {\n  content: \"\\eb8a\";\n} /* '' */\n.uil-skip-forward-circle:before {\n  content: \"\\eb8b\";\n} /* '' */\n.uil-skip-forward:before {\n  content: \"\\eb8c\";\n} /* '' */\n.uil-skype-alt:before {\n  content: \"\\eb8d\";\n} /* '' */\n.uil-skype:before {\n  content: \"\\eb8e\";\n} /* '' */\n.uil-slack-alt:before {\n  content: \"\\eb8f\";\n} /* '' */\n.uil-slack:before {\n  content: \"\\eb90\";\n} /* '' */\n.uil-sliders-v-alt:before {\n  content: \"\\eb91\";\n} /* '' */\n.uil-sliders-v:before {\n  content: \"\\eb92\";\n} /* '' */\n.uil-smile-beam:before {\n  content: \"\\eb93\";\n} /* '' */\n.uil-smile-dizzy:before {\n  content: \"\\eb94\";\n} /* '' */\n.uil-smile-squint-wink-alt:before {\n  content: \"\\eb95\";\n} /* '' */\n.uil-smile-squint-wink:before {\n  content: \"\\eb96\";\n} /* '' */\n.uil-smile-wink-alt:before {\n  content: \"\\eb97\";\n} /* '' */\n.uil-smile-wink:before {\n  content: \"\\eb98\";\n} /* '' */\n.uil-smile:before {\n  content: \"\\eb99\";\n} /* '' */\n.uil-snapchat-alt:before {\n  content: \"\\eb9a\";\n} /* '' */\n.uil-snapchat-ghost:before {\n  content: \"\\eb9b\";\n} /* '' */\n.uil-snapchat-square:before {\n  content: \"\\eb9c\";\n} /* '' */\n.uil-snow-flake:before {\n  content: \"\\eb9d\";\n} /* '' */\n.uil-snowflake-alt:before {\n  content: \"\\eb9e\";\n} /* '' */\n.uil-snowflake:before {\n  content: \"\\eb9f\";\n} /* '' */\n.uil-sort-amount-down:before {\n  content: \"\\eba0\";\n} /* '' */\n.uil-sort-amount-up:before {\n  content: \"\\eba1\";\n} /* '' */\n.uil-sort:before {\n  content: \"\\eba2\";\n} /* '' */\n.uil-sorting:before {\n  content: \"\\eba3\";\n} /* '' */\n.uil-space-key:before {\n  content: \"\\eba4\";\n} /* '' */\n.uil-spade:before {\n  content: \"\\eba5\";\n} /* '' */\n.uil-sperms:before {\n  content: \"\\eba6\";\n} /* '' */\n.uil-spin:before {\n  content: \"\\eba7\";\n} /* '' */\n.uil-sport:before {\n  content: \"\\eba8\";\n} /* '' */\n.uil-square-full:before {\n  content: \"\\eba9\";\n} /* '' */\n.uil-square-shape:before {\n  content: \"\\ebaa\";\n} /* '' */\n.uil-square:before {\n  content: \"\\ebab\";\n} /* '' */\n.uil-squint:before {\n  content: \"\\ebac\";\n} /* '' */\n.uil-star-half-alt:before {\n  content: \"\\ebad\";\n} /* '' */\n.uil-star:before {\n  content: \"\\ebae\";\n} /* '' */\n.uil-step-backward-alt:before {\n  content: \"\\ebaf\";\n} /* '' */\n.uil-step-backward-circle:before {\n  content: \"\\ebb0\";\n} /* '' */\n.uil-step-backward:before {\n  content: \"\\ebb1\";\n} /* '' */\n.uil-step-forward:before {\n  content: \"\\ebb2\";\n} /* '' */\n.uil-stop-circle:before {\n  content: \"\\ebb3\";\n} /* '' */\n.uil-stopwatch-slash:before {\n  content: \"\\ebb4\";\n} /* '' */\n.uil-stopwatch:before {\n  content: \"\\ebb5\";\n} /* '' */\n.uil-store-alt:before {\n  content: \"\\ebb6\";\n} /* '' */\n.uil-store:before {\n  content: \"\\ebb7\";\n} /* '' */\n.uil-streering:before {\n  content: \"\\ebb8\";\n} /* '' */\n.uil-stretcher:before {\n  content: \"\\ebb9\";\n} /* '' */\n.uil-subject:before {\n  content: \"\\ebba\";\n} /* '' */\n.uil-subway-alt:before {\n  content: \"\\ebbb\";\n} /* '' */\n.uil-subway:before {\n  content: \"\\ebbc\";\n} /* '' */\n.uil-suitcase-alt:before {\n  content: \"\\ebbd\";\n} /* '' */\n.uil-suitcase:before {\n  content: \"\\ebbe\";\n} /* '' */\n.uil-sun:before {\n  content: \"\\ebbf\";\n} /* '' */\n.uil-sunset:before {\n  content: \"\\ebc0\";\n} /* '' */\n.uil-surprise:before {\n  content: \"\\ebc1\";\n} /* '' */\n.uil-swatchbook:before {\n  content: \"\\ebc2\";\n} /* '' */\n.uil-swiggy:before {\n  content: \"\\ebc3\";\n} /* '' */\n.uil-swimmer:before {\n  content: \"\\ebc4\";\n} /* '' */\n.uil-symbol:before {\n  content: \"\\ebc5\";\n} /* '' */\n.uil-sync-exclamation:before {\n  content: \"\\ebc6\";\n} /* '' */\n.uil-sync-slash:before {\n  content: \"\\ebc7\";\n} /* '' */\n.uil-sync:before {\n  content: \"\\ebc8\";\n} /* '' */\n.uil-syringe:before {\n  content: \"\\ebc9\";\n} /* '' */\n.uil-table:before {\n  content: \"\\ebca\";\n} /* '' */\n.uil-tablet:before {\n  content: \"\\ebcb\";\n} /* '' */\n.uil-tablets:before {\n  content: \"\\ebcc\";\n} /* '' */\n.uil-tachometer-fast:before {\n  content: \"\\ebcd\";\n} /* '' */\n.uil-tag-alt:before {\n  content: \"\\ebce\";\n} /* '' */\n.uil-tag:before {\n  content: \"\\ebcf\";\n} /* '' */\n.uil-tape:before {\n  content: \"\\ebd0\";\n} /* '' */\n.uil-taxi:before {\n  content: \"\\ebd1\";\n} /* '' */\n.uil-tear:before {\n  content: \"\\ebd2\";\n} /* '' */\n.uil-technology:before {\n  content: \"\\ebd3\";\n} /* '' */\n.uil-telegram-alt:before {\n  content: \"\\ebd4\";\n} /* '' */\n.uil-telegram:before {\n  content: \"\\ebd5\";\n} /* '' */\n.uil-telescope:before {\n  content: \"\\ebd6\";\n} /* '' */\n.uil-temperature-empty:before {\n  content: \"\\ebd7\";\n} /* '' */\n.uil-temperature-half:before {\n  content: \"\\ebd8\";\n} /* '' */\n.uil-temperature-minus:before {\n  content: \"\\ebd9\";\n} /* '' */\n.uil-temperature-plus:before {\n  content: \"\\ebda\";\n} /* '' */\n.uil-temperature-quarter:before {\n  content: \"\\ebdb\";\n} /* '' */\n.uil-temperature-three-quarter:before {\n  content: \"\\ebdc\";\n} /* '' */\n.uil-temperature:before {\n  content: \"\\ebdd\";\n} /* '' */\n.uil-text-fields:before {\n  content: \"\\ebde\";\n} /* '' */\n.uil-text-size:before {\n  content: \"\\ebdf\";\n} /* '' */\n.uil-text-strike-through:before {\n  content: \"\\ebe0\";\n} /* '' */\n.uil-text:before {\n  content: \"\\ebe1\";\n} /* '' */\n.uil-th-large:before {\n  content: \"\\ebe2\";\n} /* '' */\n.uil-th-slash:before {\n  content: \"\\ebe3\";\n} /* '' */\n.uil-th:before {\n  content: \"\\ebe4\";\n} /* '' */\n.uil-thermometer:before {\n  content: \"\\ebe5\";\n} /* '' */\n.uil-thumbs-down:before {\n  content: \"\\ebe6\";\n} /* '' */\n.uil-thumbs-up:before {\n  content: \"\\ebe7\";\n} /* '' */\n.uil-thunderstorm-moon:before {\n  content: \"\\ebe8\";\n} /* '' */\n.uil-thunderstorm-sun:before {\n  content: \"\\ebe9\";\n} /* '' */\n.uil-thunderstorm:before {\n  content: \"\\ebea\";\n} /* '' */\n.uil-ticket:before {\n  content: \"\\ebeb\";\n} /* '' */\n.uil-times-circle:before {\n  content: \"\\ebec\";\n} /* '' */\n.uil-times-square:before {\n  content: \"\\ebed\";\n} /* '' */\n.uil-times:before {\n  content: \"\\ebee\";\n} /* '' */\n.uil-toggle-off:before {\n  content: \"\\ebef\";\n} /* '' */\n.uil-toggle-on:before {\n  content: \"\\ebf0\";\n} /* '' */\n.uil-top-arrow-from-top:before {\n  content: \"\\ebf1\";\n} /* '' */\n.uil-top-arrow-to-top:before {\n  content: \"\\ebf2\";\n} /* '' */\n.uil-tornado:before {\n  content: \"\\ebf3\";\n} /* '' */\n.uil-trademark-circle:before {\n  content: \"\\ebf4\";\n} /* '' */\n.uil-trademark:before {\n  content: \"\\ebf5\";\n} /* '' */\n.uil-traffic-barrier:before {\n  content: \"\\ebf6\";\n} /* '' */\n.uil-trash-alt:before {\n  content: \"\\ebf7\";\n} /* '' */\n.uil-trash:before {\n  content: \"\\ebf8\";\n} /* '' */\n.uil-trees:before {\n  content: \"\\ebf9\";\n} /* '' */\n.uil-triangle:before {\n  content: \"\\ebfa\";\n} /* '' */\n.uil-trophy:before {\n  content: \"\\ebfb\";\n} /* '' */\n.uil-trowel:before {\n  content: \"\\ebfc\";\n} /* '' */\n.uil-truck-case:before {\n  content: \"\\ebfd\";\n} /* '' */\n.uil-truck-loading:before {\n  content: \"\\ebfe\";\n} /* '' */\n.uil-truck:before {\n  content: \"\\ebff\";\n} /* '' */\n.uil-tumblr-alt:before {\n  content: \"\\ec00\";\n} /* '' */\n.uil-tumblr-square:before {\n  content: \"\\ec01\";\n} /* '' */\n.uil-tumblr:before {\n  content: \"\\ec02\";\n} /* '' */\n.uil-tv-retro-slash:before {\n  content: \"\\ec03\";\n} /* '' */\n.uil-tv-retro:before {\n  content: \"\\ec04\";\n} /* '' */\n.uil-twitter-alt:before {\n  content: \"\\ec05\";\n} /* '' */\n.uil-twitter:before {\n  content: \"\\ec06\";\n} /* '' */\n.uil-umbrella:before {\n  content: \"\\ec07\";\n} /* '' */\n.uil-unamused:before {\n  content: \"\\ec08\";\n} /* '' */\n.uil-underline:before {\n  content: \"\\ec09\";\n} /* '' */\n.uil-university:before {\n  content: \"\\ec0a\";\n} /* '' */\n.uil-unlock-alt:before {\n  content: \"\\ec0b\";\n} /* '' */\n.uil-unlock:before {\n  content: \"\\ec0c\";\n} /* '' */\n.uil-upload-alt:before {\n  content: \"\\ec0d\";\n} /* '' */\n.uil-upload:before {\n  content: \"\\ec0e\";\n} /* '' */\n.uil-usd-circle:before {\n  content: \"\\ec0f\";\n} /* '' */\n.uil-usd-square:before {\n  content: \"\\ec10\";\n} /* '' */\n.uil-user-check:before {\n  content: \"\\ec11\";\n} /* '' */\n.uil-user-circle:before {\n  content: \"\\ec12\";\n} /* '' */\n.uil-user-exclamation:before {\n  content: \"\\ec13\";\n} /* '' */\n.uil-user-hard-hat:before {\n  content: \"\\ec14\";\n} /* '' */\n.uil-user-minus:before {\n  content: \"\\ec15\";\n} /* '' */\n.uil-user-plus:before {\n  content: \"\\ec16\";\n} /* '' */\n.uil-user-square:before {\n  content: \"\\ec17\";\n} /* '' */\n.uil-user-times:before {\n  content: \"\\ec18\";\n} /* '' */\n.uil-user:before {\n  content: \"\\ec19\";\n} /* '' */\n.uil-users-alt:before {\n  content: \"\\ec1a\";\n} /* '' */\n.uil-utensils-alt:before {\n  content: \"\\ec1b\";\n} /* '' */\n.uil-utensils:before {\n  content: \"\\ec1c\";\n} /* '' */\n.uil-vector-square-alt:before {\n  content: \"\\ec1d\";\n} /* '' */\n.uil-vector-square:before {\n  content: \"\\ec1e\";\n} /* '' */\n.uil-venus:before {\n  content: \"\\ec1f\";\n} /* '' */\n.uil-vertical-align-bottom:before {\n  content: \"\\ec20\";\n} /* '' */\n.uil-vertical-align-center:before {\n  content: \"\\ec21\";\n} /* '' */\n.uil-vertical-align-top:before {\n  content: \"\\ec22\";\n} /* '' */\n.uil-vertical-distribute-bottom:before {\n  content: \"\\ec23\";\n} /* '' */\n.uil-vertical-distribution-center:before {\n  content: \"\\ec24\";\n} /* '' */\n.uil-vertical-distribution-top:before {\n  content: \"\\ec25\";\n} /* '' */\n.uil-video-slash:before {\n  content: \"\\ec26\";\n} /* '' */\n.uil-video:before {\n  content: \"\\ec27\";\n} /* '' */\n.uil-visual-studio:before {\n  content: \"\\ec28\";\n} /* '' */\n.uil-vk-alt:before {\n  content: \"\\ec29\";\n} /* '' */\n.uil-vk:before {\n  content: \"\\ec2a\";\n} /* '' */\n.uil-voicemail-rectangle:before {\n  content: \"\\ec2b\";\n} /* '' */\n.uil-voicemail:before {\n  content: \"\\ec2c\";\n} /* '' */\n.uil-volleyball:before {\n  content: \"\\ec2d\";\n} /* '' */\n.uil-volume-down:before {\n  content: \"\\ec2e\";\n} /* '' */\n.uil-volume-mute:before {\n  content: \"\\ec2f\";\n} /* '' */\n.uil-volume-off:before {\n  content: \"\\ec30\";\n} /* '' */\n.uil-volume-up:before {\n  content: \"\\ec31\";\n} /* '' */\n.uil-volume:before {\n  content: \"\\ec32\";\n} /* '' */\n.uil-vuejs-alt:before {\n  content: \"\\ec33\";\n} /* '' */\n.uil-vuejs:before {\n  content: \"\\ec34\";\n} /* '' */\n.uil-wall:before {\n  content: \"\\ec35\";\n} /* '' */\n.uil-wallet:before {\n  content: \"\\ec36\";\n} /* '' */\n.uil-watch-alt:before {\n  content: \"\\ec37\";\n} /* '' */\n.uil-watch:before {\n  content: \"\\ec38\";\n} /* '' */\n.uil-water-drop-slash:before {\n  content: \"\\ec39\";\n} /* '' */\n.uil-water-glass:before {\n  content: \"\\ec3a\";\n} /* '' */\n.uil-water:before {\n  content: \"\\ec3b\";\n} /* '' */\n.uil-web-grid-alt:before {\n  content: \"\\ec3c\";\n} /* '' */\n.uil-web-grid:before {\n  content: \"\\ec3d\";\n} /* '' */\n.uil-web-section-alt:before {\n  content: \"\\ec3e\";\n} /* '' */\n.uil-web-section:before {\n  content: \"\\ec3f\";\n} /* '' */\n.uil-webcam:before {\n  content: \"\\ec40\";\n} /* '' */\n.uil-weight:before {\n  content: \"\\ec41\";\n} /* '' */\n.uil-whatsapp:before {\n  content: \"\\ec42\";\n} /* '' */\n.uil-wheel-barrow:before {\n  content: \"\\ec43\";\n} /* '' */\n.uil-wheelchair-alt:before {\n  content: \"\\ec44\";\n} /* '' */\n.uil-wheelchair:before {\n  content: \"\\ec45\";\n} /* '' */\n.uil-wifi-router:before {\n  content: \"\\ec46\";\n} /* '' */\n.uil-wifi-slash:before {\n  content: \"\\ec47\";\n} /* '' */\n.uil-wifi:before {\n  content: \"\\ec48\";\n} /* '' */\n.uil-wind-moon:before {\n  content: \"\\ec49\";\n} /* '' */\n.uil-wind-sun:before {\n  content: \"\\ec4a\";\n} /* '' */\n.uil-wind:before {\n  content: \"\\ec4b\";\n} /* '' */\n.uil-window-grid:before {\n  content: \"\\ec4c\";\n} /* '' */\n.uil-window-maximize:before {\n  content: \"\\ec4d\";\n} /* '' */\n.uil-window-restore:before {\n  content: \"\\ec4e\";\n} /* '' */\n.uil-window-section:before {\n  content: \"\\ec4f\";\n} /* '' */\n.uil-window:before {\n  content: \"\\ec50\";\n} /* '' */\n.uil-windsock:before {\n  content: \"\\ec51\";\n} /* '' */\n.uil-wrap-text:before {\n  content: \"\\ec52\";\n} /* '' */\n.uil-wrench:before {\n  content: \"\\ec53\";\n} /* '' */\n.uil-yellow:before {\n  content: \"\\ec54\";\n} /* '' */\n.uil-yen-circle:before {\n  content: \"\\ec55\";\n} /* '' */\n.uil-yen:before {\n  content: \"\\ec56\";\n} /* '' */\n.uil-yin-yang:before {\n  content: \"\\ec57\";\n} /* '' */\n.uil-youtube-alt:before {\n  content: \"\\ec58\";\n} /* '' */\n.uil-youtube:before {\n  content: \"\\ec59\";\n} /* '' */\n@font-face {\n  font-family: \"bootstrap-icons\";\n  src: url(\"../../../../fonts/bootstrap-icons.woff2?856008caa5eb66df68595e734e59580d\") format(\"woff2\"), url(\"../../../../fonts/bootstrap-icons.woff?856008caa5eb66df68595e734e59580d\") format(\"woff\");\n}\n[class^=bi-]::before,\n[class*=\" bi-\"]::before {\n  display: inline-block;\n  font-family: bootstrap-icons !important;\n  font-style: normal;\n  font-weight: normal !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -0.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.bi-alarm-fill::before {\n  content: \"\\f101\";\n}\n\n.bi-alarm::before {\n  content: \"\\f102\";\n}\n\n.bi-align-bottom::before {\n  content: \"\\f103\";\n}\n\n.bi-align-center::before {\n  content: \"\\f104\";\n}\n\n.bi-align-end::before {\n  content: \"\\f105\";\n}\n\n.bi-align-middle::before {\n  content: \"\\f106\";\n}\n\n.bi-align-start::before {\n  content: \"\\f107\";\n}\n\n.bi-align-top::before {\n  content: \"\\f108\";\n}\n\n.bi-alt::before {\n  content: \"\\f109\";\n}\n\n.bi-app-indicator::before {\n  content: \"\\f10a\";\n}\n\n.bi-app::before {\n  content: \"\\f10b\";\n}\n\n.bi-archive-fill::before {\n  content: \"\\f10c\";\n}\n\n.bi-archive::before {\n  content: \"\\f10d\";\n}\n\n.bi-arrow-90deg-down::before {\n  content: \"\\f10e\";\n}\n\n.bi-arrow-90deg-left::before {\n  content: \"\\f10f\";\n}\n\n.bi-arrow-90deg-right::before {\n  content: \"\\f110\";\n}\n\n.bi-arrow-90deg-up::before {\n  content: \"\\f111\";\n}\n\n.bi-arrow-bar-down::before {\n  content: \"\\f112\";\n}\n\n.bi-arrow-bar-left::before {\n  content: \"\\f113\";\n}\n\n.bi-arrow-bar-right::before {\n  content: \"\\f114\";\n}\n\n.bi-arrow-bar-up::before {\n  content: \"\\f115\";\n}\n\n.bi-arrow-clockwise::before {\n  content: \"\\f116\";\n}\n\n.bi-arrow-counterclockwise::before {\n  content: \"\\f117\";\n}\n\n.bi-arrow-down-circle-fill::before {\n  content: \"\\f118\";\n}\n\n.bi-arrow-down-circle::before {\n  content: \"\\f119\";\n}\n\n.bi-arrow-down-left-circle-fill::before {\n  content: \"\\f11a\";\n}\n\n.bi-arrow-down-left-circle::before {\n  content: \"\\f11b\";\n}\n\n.bi-arrow-down-left-square-fill::before {\n  content: \"\\f11c\";\n}\n\n.bi-arrow-down-left-square::before {\n  content: \"\\f11d\";\n}\n\n.bi-arrow-down-left::before {\n  content: \"\\f11e\";\n}\n\n.bi-arrow-down-right-circle-fill::before {\n  content: \"\\f11f\";\n}\n\n.bi-arrow-down-right-circle::before {\n  content: \"\\f120\";\n}\n\n.bi-arrow-down-right-square-fill::before {\n  content: \"\\f121\";\n}\n\n.bi-arrow-down-right-square::before {\n  content: \"\\f122\";\n}\n\n.bi-arrow-down-right::before {\n  content: \"\\f123\";\n}\n\n.bi-arrow-down-short::before {\n  content: \"\\f124\";\n}\n\n.bi-arrow-down-square-fill::before {\n  content: \"\\f125\";\n}\n\n.bi-arrow-down-square::before {\n  content: \"\\f126\";\n}\n\n.bi-arrow-down-up::before {\n  content: \"\\f127\";\n}\n\n.bi-arrow-down::before {\n  content: \"\\f128\";\n}\n\n.bi-arrow-left-circle-fill::before {\n  content: \"\\f129\";\n}\n\n.bi-arrow-left-circle::before {\n  content: \"\\f12a\";\n}\n\n.bi-arrow-left-right::before {\n  content: \"\\f12b\";\n}\n\n.bi-arrow-left-short::before {\n  content: \"\\f12c\";\n}\n\n.bi-arrow-left-square-fill::before {\n  content: \"\\f12d\";\n}\n\n.bi-arrow-left-square::before {\n  content: \"\\f12e\";\n}\n\n.bi-arrow-left::before {\n  content: \"\\f12f\";\n}\n\n.bi-arrow-repeat::before {\n  content: \"\\f130\";\n}\n\n.bi-arrow-return-left::before {\n  content: \"\\f131\";\n}\n\n.bi-arrow-return-right::before {\n  content: \"\\f132\";\n}\n\n.bi-arrow-right-circle-fill::before {\n  content: \"\\f133\";\n}\n\n.bi-arrow-right-circle::before {\n  content: \"\\f134\";\n}\n\n.bi-arrow-right-short::before {\n  content: \"\\f135\";\n}\n\n.bi-arrow-right-square-fill::before {\n  content: \"\\f136\";\n}\n\n.bi-arrow-right-square::before {\n  content: \"\\f137\";\n}\n\n.bi-arrow-right::before {\n  content: \"\\f138\";\n}\n\n.bi-arrow-up-circle-fill::before {\n  content: \"\\f139\";\n}\n\n.bi-arrow-up-circle::before {\n  content: \"\\f13a\";\n}\n\n.bi-arrow-up-left-circle-fill::before {\n  content: \"\\f13b\";\n}\n\n.bi-arrow-up-left-circle::before {\n  content: \"\\f13c\";\n}\n\n.bi-arrow-up-left-square-fill::before {\n  content: \"\\f13d\";\n}\n\n.bi-arrow-up-left-square::before {\n  content: \"\\f13e\";\n}\n\n.bi-arrow-up-left::before {\n  content: \"\\f13f\";\n}\n\n.bi-arrow-up-right-circle-fill::before {\n  content: \"\\f140\";\n}\n\n.bi-arrow-up-right-circle::before {\n  content: \"\\f141\";\n}\n\n.bi-arrow-up-right-square-fill::before {\n  content: \"\\f142\";\n}\n\n.bi-arrow-up-right-square::before {\n  content: \"\\f143\";\n}\n\n.bi-arrow-up-right::before {\n  content: \"\\f144\";\n}\n\n.bi-arrow-up-short::before {\n  content: \"\\f145\";\n}\n\n.bi-arrow-up-square-fill::before {\n  content: \"\\f146\";\n}\n\n.bi-arrow-up-square::before {\n  content: \"\\f147\";\n}\n\n.bi-arrow-up::before {\n  content: \"\\f148\";\n}\n\n.bi-arrows-angle-contract::before {\n  content: \"\\f149\";\n}\n\n.bi-arrows-angle-expand::before {\n  content: \"\\f14a\";\n}\n\n.bi-arrows-collapse::before {\n  content: \"\\f14b\";\n}\n\n.bi-arrows-expand::before {\n  content: \"\\f14c\";\n}\n\n.bi-arrows-fullscreen::before {\n  content: \"\\f14d\";\n}\n\n.bi-arrows-move::before {\n  content: \"\\f14e\";\n}\n\n.bi-aspect-ratio-fill::before {\n  content: \"\\f14f\";\n}\n\n.bi-aspect-ratio::before {\n  content: \"\\f150\";\n}\n\n.bi-asterisk::before {\n  content: \"\\f151\";\n}\n\n.bi-at::before {\n  content: \"\\f152\";\n}\n\n.bi-award-fill::before {\n  content: \"\\f153\";\n}\n\n.bi-award::before {\n  content: \"\\f154\";\n}\n\n.bi-back::before {\n  content: \"\\f155\";\n}\n\n.bi-backspace-fill::before {\n  content: \"\\f156\";\n}\n\n.bi-backspace-reverse-fill::before {\n  content: \"\\f157\";\n}\n\n.bi-backspace-reverse::before {\n  content: \"\\f158\";\n}\n\n.bi-backspace::before {\n  content: \"\\f159\";\n}\n\n.bi-badge-3d-fill::before {\n  content: \"\\f15a\";\n}\n\n.bi-badge-3d::before {\n  content: \"\\f15b\";\n}\n\n.bi-badge-4k-fill::before {\n  content: \"\\f15c\";\n}\n\n.bi-badge-4k::before {\n  content: \"\\f15d\";\n}\n\n.bi-badge-8k-fill::before {\n  content: \"\\f15e\";\n}\n\n.bi-badge-8k::before {\n  content: \"\\f15f\";\n}\n\n.bi-badge-ad-fill::before {\n  content: \"\\f160\";\n}\n\n.bi-badge-ad::before {\n  content: \"\\f161\";\n}\n\n.bi-badge-ar-fill::before {\n  content: \"\\f162\";\n}\n\n.bi-badge-ar::before {\n  content: \"\\f163\";\n}\n\n.bi-badge-cc-fill::before {\n  content: \"\\f164\";\n}\n\n.bi-badge-cc::before {\n  content: \"\\f165\";\n}\n\n.bi-badge-hd-fill::before {\n  content: \"\\f166\";\n}\n\n.bi-badge-hd::before {\n  content: \"\\f167\";\n}\n\n.bi-badge-tm-fill::before {\n  content: \"\\f168\";\n}\n\n.bi-badge-tm::before {\n  content: \"\\f169\";\n}\n\n.bi-badge-vo-fill::before {\n  content: \"\\f16a\";\n}\n\n.bi-badge-vo::before {\n  content: \"\\f16b\";\n}\n\n.bi-badge-vr-fill::before {\n  content: \"\\f16c\";\n}\n\n.bi-badge-vr::before {\n  content: \"\\f16d\";\n}\n\n.bi-badge-wc-fill::before {\n  content: \"\\f16e\";\n}\n\n.bi-badge-wc::before {\n  content: \"\\f16f\";\n}\n\n.bi-bag-check-fill::before {\n  content: \"\\f170\";\n}\n\n.bi-bag-check::before {\n  content: \"\\f171\";\n}\n\n.bi-bag-dash-fill::before {\n  content: \"\\f172\";\n}\n\n.bi-bag-dash::before {\n  content: \"\\f173\";\n}\n\n.bi-bag-fill::before {\n  content: \"\\f174\";\n}\n\n.bi-bag-plus-fill::before {\n  content: \"\\f175\";\n}\n\n.bi-bag-plus::before {\n  content: \"\\f176\";\n}\n\n.bi-bag-x-fill::before {\n  content: \"\\f177\";\n}\n\n.bi-bag-x::before {\n  content: \"\\f178\";\n}\n\n.bi-bag::before {\n  content: \"\\f179\";\n}\n\n.bi-bar-chart-fill::before {\n  content: \"\\f17a\";\n}\n\n.bi-bar-chart-line-fill::before {\n  content: \"\\f17b\";\n}\n\n.bi-bar-chart-line::before {\n  content: \"\\f17c\";\n}\n\n.bi-bar-chart-steps::before {\n  content: \"\\f17d\";\n}\n\n.bi-bar-chart::before {\n  content: \"\\f17e\";\n}\n\n.bi-basket-fill::before {\n  content: \"\\f17f\";\n}\n\n.bi-basket::before {\n  content: \"\\f180\";\n}\n\n.bi-basket2-fill::before {\n  content: \"\\f181\";\n}\n\n.bi-basket2::before {\n  content: \"\\f182\";\n}\n\n.bi-basket3-fill::before {\n  content: \"\\f183\";\n}\n\n.bi-basket3::before {\n  content: \"\\f184\";\n}\n\n.bi-battery-charging::before {\n  content: \"\\f185\";\n}\n\n.bi-battery-full::before {\n  content: \"\\f186\";\n}\n\n.bi-battery-half::before {\n  content: \"\\f187\";\n}\n\n.bi-battery::before {\n  content: \"\\f188\";\n}\n\n.bi-bell-fill::before {\n  content: \"\\f189\";\n}\n\n.bi-bell::before {\n  content: \"\\f18a\";\n}\n\n.bi-bezier::before {\n  content: \"\\f18b\";\n}\n\n.bi-bezier2::before {\n  content: \"\\f18c\";\n}\n\n.bi-bicycle::before {\n  content: \"\\f18d\";\n}\n\n.bi-binoculars-fill::before {\n  content: \"\\f18e\";\n}\n\n.bi-binoculars::before {\n  content: \"\\f18f\";\n}\n\n.bi-blockquote-left::before {\n  content: \"\\f190\";\n}\n\n.bi-blockquote-right::before {\n  content: \"\\f191\";\n}\n\n.bi-book-fill::before {\n  content: \"\\f192\";\n}\n\n.bi-book-half::before {\n  content: \"\\f193\";\n}\n\n.bi-book::before {\n  content: \"\\f194\";\n}\n\n.bi-bookmark-check-fill::before {\n  content: \"\\f195\";\n}\n\n.bi-bookmark-check::before {\n  content: \"\\f196\";\n}\n\n.bi-bookmark-dash-fill::before {\n  content: \"\\f197\";\n}\n\n.bi-bookmark-dash::before {\n  content: \"\\f198\";\n}\n\n.bi-bookmark-fill::before {\n  content: \"\\f199\";\n}\n\n.bi-bookmark-heart-fill::before {\n  content: \"\\f19a\";\n}\n\n.bi-bookmark-heart::before {\n  content: \"\\f19b\";\n}\n\n.bi-bookmark-plus-fill::before {\n  content: \"\\f19c\";\n}\n\n.bi-bookmark-plus::before {\n  content: \"\\f19d\";\n}\n\n.bi-bookmark-star-fill::before {\n  content: \"\\f19e\";\n}\n\n.bi-bookmark-star::before {\n  content: \"\\f19f\";\n}\n\n.bi-bookmark-x-fill::before {\n  content: \"\\f1a0\";\n}\n\n.bi-bookmark-x::before {\n  content: \"\\f1a1\";\n}\n\n.bi-bookmark::before {\n  content: \"\\f1a2\";\n}\n\n.bi-bookmarks-fill::before {\n  content: \"\\f1a3\";\n}\n\n.bi-bookmarks::before {\n  content: \"\\f1a4\";\n}\n\n.bi-bookshelf::before {\n  content: \"\\f1a5\";\n}\n\n.bi-bootstrap-fill::before {\n  content: \"\\f1a6\";\n}\n\n.bi-bootstrap-reboot::before {\n  content: \"\\f1a7\";\n}\n\n.bi-bootstrap::before {\n  content: \"\\f1a8\";\n}\n\n.bi-border-all::before {\n  content: \"\\f1a9\";\n}\n\n.bi-border-bottom::before {\n  content: \"\\f1aa\";\n}\n\n.bi-border-center::before {\n  content: \"\\f1ab\";\n}\n\n.bi-border-inner::before {\n  content: \"\\f1ac\";\n}\n\n.bi-border-left::before {\n  content: \"\\f1ad\";\n}\n\n.bi-border-middle::before {\n  content: \"\\f1ae\";\n}\n\n.bi-border-outer::before {\n  content: \"\\f1af\";\n}\n\n.bi-border-right::before {\n  content: \"\\f1b0\";\n}\n\n.bi-border-style::before {\n  content: \"\\f1b1\";\n}\n\n.bi-border-top::before {\n  content: \"\\f1b2\";\n}\n\n.bi-border-width::before {\n  content: \"\\f1b3\";\n}\n\n.bi-border::before {\n  content: \"\\f1b4\";\n}\n\n.bi-bounding-box-circles::before {\n  content: \"\\f1b5\";\n}\n\n.bi-bounding-box::before {\n  content: \"\\f1b6\";\n}\n\n.bi-box-arrow-down-left::before {\n  content: \"\\f1b7\";\n}\n\n.bi-box-arrow-down-right::before {\n  content: \"\\f1b8\";\n}\n\n.bi-box-arrow-down::before {\n  content: \"\\f1b9\";\n}\n\n.bi-box-arrow-in-down-left::before {\n  content: \"\\f1ba\";\n}\n\n.bi-box-arrow-in-down-right::before {\n  content: \"\\f1bb\";\n}\n\n.bi-box-arrow-in-down::before {\n  content: \"\\f1bc\";\n}\n\n.bi-box-arrow-in-left::before {\n  content: \"\\f1bd\";\n}\n\n.bi-box-arrow-in-right::before {\n  content: \"\\f1be\";\n}\n\n.bi-box-arrow-in-up-left::before {\n  content: \"\\f1bf\";\n}\n\n.bi-box-arrow-in-up-right::before {\n  content: \"\\f1c0\";\n}\n\n.bi-box-arrow-in-up::before {\n  content: \"\\f1c1\";\n}\n\n.bi-box-arrow-left::before {\n  content: \"\\f1c2\";\n}\n\n.bi-box-arrow-right::before {\n  content: \"\\f1c3\";\n}\n\n.bi-box-arrow-up-left::before {\n  content: \"\\f1c4\";\n}\n\n.bi-box-arrow-up-right::before {\n  content: \"\\f1c5\";\n}\n\n.bi-box-arrow-up::before {\n  content: \"\\f1c6\";\n}\n\n.bi-box-seam::before {\n  content: \"\\f1c7\";\n}\n\n.bi-box::before {\n  content: \"\\f1c8\";\n}\n\n.bi-braces::before {\n  content: \"\\f1c9\";\n}\n\n.bi-bricks::before {\n  content: \"\\f1ca\";\n}\n\n.bi-briefcase-fill::before {\n  content: \"\\f1cb\";\n}\n\n.bi-briefcase::before {\n  content: \"\\f1cc\";\n}\n\n.bi-brightness-alt-high-fill::before {\n  content: \"\\f1cd\";\n}\n\n.bi-brightness-alt-high::before {\n  content: \"\\f1ce\";\n}\n\n.bi-brightness-alt-low-fill::before {\n  content: \"\\f1cf\";\n}\n\n.bi-brightness-alt-low::before {\n  content: \"\\f1d0\";\n}\n\n.bi-brightness-high-fill::before {\n  content: \"\\f1d1\";\n}\n\n.bi-brightness-high::before {\n  content: \"\\f1d2\";\n}\n\n.bi-brightness-low-fill::before {\n  content: \"\\f1d3\";\n}\n\n.bi-brightness-low::before {\n  content: \"\\f1d4\";\n}\n\n.bi-broadcast-pin::before {\n  content: \"\\f1d5\";\n}\n\n.bi-broadcast::before {\n  content: \"\\f1d6\";\n}\n\n.bi-brush-fill::before {\n  content: \"\\f1d7\";\n}\n\n.bi-brush::before {\n  content: \"\\f1d8\";\n}\n\n.bi-bucket-fill::before {\n  content: \"\\f1d9\";\n}\n\n.bi-bucket::before {\n  content: \"\\f1da\";\n}\n\n.bi-bug-fill::before {\n  content: \"\\f1db\";\n}\n\n.bi-bug::before {\n  content: \"\\f1dc\";\n}\n\n.bi-building::before {\n  content: \"\\f1dd\";\n}\n\n.bi-bullseye::before {\n  content: \"\\f1de\";\n}\n\n.bi-calculator-fill::before {\n  content: \"\\f1df\";\n}\n\n.bi-calculator::before {\n  content: \"\\f1e0\";\n}\n\n.bi-calendar-check-fill::before {\n  content: \"\\f1e1\";\n}\n\n.bi-calendar-check::before {\n  content: \"\\f1e2\";\n}\n\n.bi-calendar-date-fill::before {\n  content: \"\\f1e3\";\n}\n\n.bi-calendar-date::before {\n  content: \"\\f1e4\";\n}\n\n.bi-calendar-day-fill::before {\n  content: \"\\f1e5\";\n}\n\n.bi-calendar-day::before {\n  content: \"\\f1e6\";\n}\n\n.bi-calendar-event-fill::before {\n  content: \"\\f1e7\";\n}\n\n.bi-calendar-event::before {\n  content: \"\\f1e8\";\n}\n\n.bi-calendar-fill::before {\n  content: \"\\f1e9\";\n}\n\n.bi-calendar-minus-fill::before {\n  content: \"\\f1ea\";\n}\n\n.bi-calendar-minus::before {\n  content: \"\\f1eb\";\n}\n\n.bi-calendar-month-fill::before {\n  content: \"\\f1ec\";\n}\n\n.bi-calendar-month::before {\n  content: \"\\f1ed\";\n}\n\n.bi-calendar-plus-fill::before {\n  content: \"\\f1ee\";\n}\n\n.bi-calendar-plus::before {\n  content: \"\\f1ef\";\n}\n\n.bi-calendar-range-fill::before {\n  content: \"\\f1f0\";\n}\n\n.bi-calendar-range::before {\n  content: \"\\f1f1\";\n}\n\n.bi-calendar-week-fill::before {\n  content: \"\\f1f2\";\n}\n\n.bi-calendar-week::before {\n  content: \"\\f1f3\";\n}\n\n.bi-calendar-x-fill::before {\n  content: \"\\f1f4\";\n}\n\n.bi-calendar-x::before {\n  content: \"\\f1f5\";\n}\n\n.bi-calendar::before {\n  content: \"\\f1f6\";\n}\n\n.bi-calendar2-check-fill::before {\n  content: \"\\f1f7\";\n}\n\n.bi-calendar2-check::before {\n  content: \"\\f1f8\";\n}\n\n.bi-calendar2-date-fill::before {\n  content: \"\\f1f9\";\n}\n\n.bi-calendar2-date::before {\n  content: \"\\f1fa\";\n}\n\n.bi-calendar2-day-fill::before {\n  content: \"\\f1fb\";\n}\n\n.bi-calendar2-day::before {\n  content: \"\\f1fc\";\n}\n\n.bi-calendar2-event-fill::before {\n  content: \"\\f1fd\";\n}\n\n.bi-calendar2-event::before {\n  content: \"\\f1fe\";\n}\n\n.bi-calendar2-fill::before {\n  content: \"\\f1ff\";\n}\n\n.bi-calendar2-minus-fill::before {\n  content: \"\\f200\";\n}\n\n.bi-calendar2-minus::before {\n  content: \"\\f201\";\n}\n\n.bi-calendar2-month-fill::before {\n  content: \"\\f202\";\n}\n\n.bi-calendar2-month::before {\n  content: \"\\f203\";\n}\n\n.bi-calendar2-plus-fill::before {\n  content: \"\\f204\";\n}\n\n.bi-calendar2-plus::before {\n  content: \"\\f205\";\n}\n\n.bi-calendar2-range-fill::before {\n  content: \"\\f206\";\n}\n\n.bi-calendar2-range::before {\n  content: \"\\f207\";\n}\n\n.bi-calendar2-week-fill::before {\n  content: \"\\f208\";\n}\n\n.bi-calendar2-week::before {\n  content: \"\\f209\";\n}\n\n.bi-calendar2-x-fill::before {\n  content: \"\\f20a\";\n}\n\n.bi-calendar2-x::before {\n  content: \"\\f20b\";\n}\n\n.bi-calendar2::before {\n  content: \"\\f20c\";\n}\n\n.bi-calendar3-event-fill::before {\n  content: \"\\f20d\";\n}\n\n.bi-calendar3-event::before {\n  content: \"\\f20e\";\n}\n\n.bi-calendar3-fill::before {\n  content: \"\\f20f\";\n}\n\n.bi-calendar3-range-fill::before {\n  content: \"\\f210\";\n}\n\n.bi-calendar3-range::before {\n  content: \"\\f211\";\n}\n\n.bi-calendar3-week-fill::before {\n  content: \"\\f212\";\n}\n\n.bi-calendar3-week::before {\n  content: \"\\f213\";\n}\n\n.bi-calendar3::before {\n  content: \"\\f214\";\n}\n\n.bi-calendar4-event::before {\n  content: \"\\f215\";\n}\n\n.bi-calendar4-range::before {\n  content: \"\\f216\";\n}\n\n.bi-calendar4-week::before {\n  content: \"\\f217\";\n}\n\n.bi-calendar4::before {\n  content: \"\\f218\";\n}\n\n.bi-camera-fill::before {\n  content: \"\\f219\";\n}\n\n.bi-camera-reels-fill::before {\n  content: \"\\f21a\";\n}\n\n.bi-camera-reels::before {\n  content: \"\\f21b\";\n}\n\n.bi-camera-video-fill::before {\n  content: \"\\f21c\";\n}\n\n.bi-camera-video-off-fill::before {\n  content: \"\\f21d\";\n}\n\n.bi-camera-video-off::before {\n  content: \"\\f21e\";\n}\n\n.bi-camera-video::before {\n  content: \"\\f21f\";\n}\n\n.bi-camera::before {\n  content: \"\\f220\";\n}\n\n.bi-camera2::before {\n  content: \"\\f221\";\n}\n\n.bi-capslock-fill::before {\n  content: \"\\f222\";\n}\n\n.bi-capslock::before {\n  content: \"\\f223\";\n}\n\n.bi-card-checklist::before {\n  content: \"\\f224\";\n}\n\n.bi-card-heading::before {\n  content: \"\\f225\";\n}\n\n.bi-card-image::before {\n  content: \"\\f226\";\n}\n\n.bi-card-list::before {\n  content: \"\\f227\";\n}\n\n.bi-card-text::before {\n  content: \"\\f228\";\n}\n\n.bi-caret-down-fill::before {\n  content: \"\\f229\";\n}\n\n.bi-caret-down-square-fill::before {\n  content: \"\\f22a\";\n}\n\n.bi-caret-down-square::before {\n  content: \"\\f22b\";\n}\n\n.bi-caret-down::before {\n  content: \"\\f22c\";\n}\n\n.bi-caret-left-fill::before {\n  content: \"\\f22d\";\n}\n\n.bi-caret-left-square-fill::before {\n  content: \"\\f22e\";\n}\n\n.bi-caret-left-square::before {\n  content: \"\\f22f\";\n}\n\n.bi-caret-left::before {\n  content: \"\\f230\";\n}\n\n.bi-caret-right-fill::before {\n  content: \"\\f231\";\n}\n\n.bi-caret-right-square-fill::before {\n  content: \"\\f232\";\n}\n\n.bi-caret-right-square::before {\n  content: \"\\f233\";\n}\n\n.bi-caret-right::before {\n  content: \"\\f234\";\n}\n\n.bi-caret-up-fill::before {\n  content: \"\\f235\";\n}\n\n.bi-caret-up-square-fill::before {\n  content: \"\\f236\";\n}\n\n.bi-caret-up-square::before {\n  content: \"\\f237\";\n}\n\n.bi-caret-up::before {\n  content: \"\\f238\";\n}\n\n.bi-cart-check-fill::before {\n  content: \"\\f239\";\n}\n\n.bi-cart-check::before {\n  content: \"\\f23a\";\n}\n\n.bi-cart-dash-fill::before {\n  content: \"\\f23b\";\n}\n\n.bi-cart-dash::before {\n  content: \"\\f23c\";\n}\n\n.bi-cart-fill::before {\n  content: \"\\f23d\";\n}\n\n.bi-cart-plus-fill::before {\n  content: \"\\f23e\";\n}\n\n.bi-cart-plus::before {\n  content: \"\\f23f\";\n}\n\n.bi-cart-x-fill::before {\n  content: \"\\f240\";\n}\n\n.bi-cart-x::before {\n  content: \"\\f241\";\n}\n\n.bi-cart::before {\n  content: \"\\f242\";\n}\n\n.bi-cart2::before {\n  content: \"\\f243\";\n}\n\n.bi-cart3::before {\n  content: \"\\f244\";\n}\n\n.bi-cart4::before {\n  content: \"\\f245\";\n}\n\n.bi-cash-stack::before {\n  content: \"\\f246\";\n}\n\n.bi-cash::before {\n  content: \"\\f247\";\n}\n\n.bi-cast::before {\n  content: \"\\f248\";\n}\n\n.bi-chat-dots-fill::before {\n  content: \"\\f249\";\n}\n\n.bi-chat-dots::before {\n  content: \"\\f24a\";\n}\n\n.bi-chat-fill::before {\n  content: \"\\f24b\";\n}\n\n.bi-chat-left-dots-fill::before {\n  content: \"\\f24c\";\n}\n\n.bi-chat-left-dots::before {\n  content: \"\\f24d\";\n}\n\n.bi-chat-left-fill::before {\n  content: \"\\f24e\";\n}\n\n.bi-chat-left-quote-fill::before {\n  content: \"\\f24f\";\n}\n\n.bi-chat-left-quote::before {\n  content: \"\\f250\";\n}\n\n.bi-chat-left-text-fill::before {\n  content: \"\\f251\";\n}\n\n.bi-chat-left-text::before {\n  content: \"\\f252\";\n}\n\n.bi-chat-left::before {\n  content: \"\\f253\";\n}\n\n.bi-chat-quote-fill::before {\n  content: \"\\f254\";\n}\n\n.bi-chat-quote::before {\n  content: \"\\f255\";\n}\n\n.bi-chat-right-dots-fill::before {\n  content: \"\\f256\";\n}\n\n.bi-chat-right-dots::before {\n  content: \"\\f257\";\n}\n\n.bi-chat-right-fill::before {\n  content: \"\\f258\";\n}\n\n.bi-chat-right-quote-fill::before {\n  content: \"\\f259\";\n}\n\n.bi-chat-right-quote::before {\n  content: \"\\f25a\";\n}\n\n.bi-chat-right-text-fill::before {\n  content: \"\\f25b\";\n}\n\n.bi-chat-right-text::before {\n  content: \"\\f25c\";\n}\n\n.bi-chat-right::before {\n  content: \"\\f25d\";\n}\n\n.bi-chat-square-dots-fill::before {\n  content: \"\\f25e\";\n}\n\n.bi-chat-square-dots::before {\n  content: \"\\f25f\";\n}\n\n.bi-chat-square-fill::before {\n  content: \"\\f260\";\n}\n\n.bi-chat-square-quote-fill::before {\n  content: \"\\f261\";\n}\n\n.bi-chat-square-quote::before {\n  content: \"\\f262\";\n}\n\n.bi-chat-square-text-fill::before {\n  content: \"\\f263\";\n}\n\n.bi-chat-square-text::before {\n  content: \"\\f264\";\n}\n\n.bi-chat-square::before {\n  content: \"\\f265\";\n}\n\n.bi-chat-text-fill::before {\n  content: \"\\f266\";\n}\n\n.bi-chat-text::before {\n  content: \"\\f267\";\n}\n\n.bi-chat::before {\n  content: \"\\f268\";\n}\n\n.bi-check-all::before {\n  content: \"\\f269\";\n}\n\n.bi-check-circle-fill::before {\n  content: \"\\f26a\";\n}\n\n.bi-check-circle::before {\n  content: \"\\f26b\";\n}\n\n.bi-check-square-fill::before {\n  content: \"\\f26c\";\n}\n\n.bi-check-square::before {\n  content: \"\\f26d\";\n}\n\n.bi-check::before {\n  content: \"\\f26e\";\n}\n\n.bi-check2-all::before {\n  content: \"\\f26f\";\n}\n\n.bi-check2-circle::before {\n  content: \"\\f270\";\n}\n\n.bi-check2-square::before {\n  content: \"\\f271\";\n}\n\n.bi-check2::before {\n  content: \"\\f272\";\n}\n\n.bi-chevron-bar-contract::before {\n  content: \"\\f273\";\n}\n\n.bi-chevron-bar-down::before {\n  content: \"\\f274\";\n}\n\n.bi-chevron-bar-expand::before {\n  content: \"\\f275\";\n}\n\n.bi-chevron-bar-left::before {\n  content: \"\\f276\";\n}\n\n.bi-chevron-bar-right::before {\n  content: \"\\f277\";\n}\n\n.bi-chevron-bar-up::before {\n  content: \"\\f278\";\n}\n\n.bi-chevron-compact-down::before {\n  content: \"\\f279\";\n}\n\n.bi-chevron-compact-left::before {\n  content: \"\\f27a\";\n}\n\n.bi-chevron-compact-right::before {\n  content: \"\\f27b\";\n}\n\n.bi-chevron-compact-up::before {\n  content: \"\\f27c\";\n}\n\n.bi-chevron-contract::before {\n  content: \"\\f27d\";\n}\n\n.bi-chevron-double-down::before {\n  content: \"\\f27e\";\n}\n\n.bi-chevron-double-left::before {\n  content: \"\\f27f\";\n}\n\n.bi-chevron-double-right::before {\n  content: \"\\f280\";\n}\n\n.bi-chevron-double-up::before {\n  content: \"\\f281\";\n}\n\n.bi-chevron-down::before {\n  content: \"\\f282\";\n}\n\n.bi-chevron-expand::before {\n  content: \"\\f283\";\n}\n\n.bi-chevron-left::before {\n  content: \"\\f284\";\n}\n\n.bi-chevron-right::before {\n  content: \"\\f285\";\n}\n\n.bi-chevron-up::before {\n  content: \"\\f286\";\n}\n\n.bi-circle-fill::before {\n  content: \"\\f287\";\n}\n\n.bi-circle-half::before {\n  content: \"\\f288\";\n}\n\n.bi-circle-square::before {\n  content: \"\\f289\";\n}\n\n.bi-circle::before {\n  content: \"\\f28a\";\n}\n\n.bi-clipboard-check::before {\n  content: \"\\f28b\";\n}\n\n.bi-clipboard-data::before {\n  content: \"\\f28c\";\n}\n\n.bi-clipboard-minus::before {\n  content: \"\\f28d\";\n}\n\n.bi-clipboard-plus::before {\n  content: \"\\f28e\";\n}\n\n.bi-clipboard-x::before {\n  content: \"\\f28f\";\n}\n\n.bi-clipboard::before {\n  content: \"\\f290\";\n}\n\n.bi-clock-fill::before {\n  content: \"\\f291\";\n}\n\n.bi-clock-history::before {\n  content: \"\\f292\";\n}\n\n.bi-clock::before {\n  content: \"\\f293\";\n}\n\n.bi-cloud-arrow-down-fill::before {\n  content: \"\\f294\";\n}\n\n.bi-cloud-arrow-down::before {\n  content: \"\\f295\";\n}\n\n.bi-cloud-arrow-up-fill::before {\n  content: \"\\f296\";\n}\n\n.bi-cloud-arrow-up::before {\n  content: \"\\f297\";\n}\n\n.bi-cloud-check-fill::before {\n  content: \"\\f298\";\n}\n\n.bi-cloud-check::before {\n  content: \"\\f299\";\n}\n\n.bi-cloud-download-fill::before {\n  content: \"\\f29a\";\n}\n\n.bi-cloud-download::before {\n  content: \"\\f29b\";\n}\n\n.bi-cloud-drizzle-fill::before {\n  content: \"\\f29c\";\n}\n\n.bi-cloud-drizzle::before {\n  content: \"\\f29d\";\n}\n\n.bi-cloud-fill::before {\n  content: \"\\f29e\";\n}\n\n.bi-cloud-fog-fill::before {\n  content: \"\\f29f\";\n}\n\n.bi-cloud-fog::before {\n  content: \"\\f2a0\";\n}\n\n.bi-cloud-fog2-fill::before {\n  content: \"\\f2a1\";\n}\n\n.bi-cloud-fog2::before {\n  content: \"\\f2a2\";\n}\n\n.bi-cloud-hail-fill::before {\n  content: \"\\f2a3\";\n}\n\n.bi-cloud-hail::before {\n  content: \"\\f2a4\";\n}\n\n.bi-cloud-haze-1::before {\n  content: \"\\f2a5\";\n}\n\n.bi-cloud-haze-fill::before {\n  content: \"\\f2a6\";\n}\n\n.bi-cloud-haze::before {\n  content: \"\\f2a7\";\n}\n\n.bi-cloud-haze2-fill::before {\n  content: \"\\f2a8\";\n}\n\n.bi-cloud-lightning-fill::before {\n  content: \"\\f2a9\";\n}\n\n.bi-cloud-lightning-rain-fill::before {\n  content: \"\\f2aa\";\n}\n\n.bi-cloud-lightning-rain::before {\n  content: \"\\f2ab\";\n}\n\n.bi-cloud-lightning::before {\n  content: \"\\f2ac\";\n}\n\n.bi-cloud-minus-fill::before {\n  content: \"\\f2ad\";\n}\n\n.bi-cloud-minus::before {\n  content: \"\\f2ae\";\n}\n\n.bi-cloud-moon-fill::before {\n  content: \"\\f2af\";\n}\n\n.bi-cloud-moon::before {\n  content: \"\\f2b0\";\n}\n\n.bi-cloud-plus-fill::before {\n  content: \"\\f2b1\";\n}\n\n.bi-cloud-plus::before {\n  content: \"\\f2b2\";\n}\n\n.bi-cloud-rain-fill::before {\n  content: \"\\f2b3\";\n}\n\n.bi-cloud-rain-heavy-fill::before {\n  content: \"\\f2b4\";\n}\n\n.bi-cloud-rain-heavy::before {\n  content: \"\\f2b5\";\n}\n\n.bi-cloud-rain::before {\n  content: \"\\f2b6\";\n}\n\n.bi-cloud-slash-fill::before {\n  content: \"\\f2b7\";\n}\n\n.bi-cloud-slash::before {\n  content: \"\\f2b8\";\n}\n\n.bi-cloud-sleet-fill::before {\n  content: \"\\f2b9\";\n}\n\n.bi-cloud-sleet::before {\n  content: \"\\f2ba\";\n}\n\n.bi-cloud-snow-fill::before {\n  content: \"\\f2bb\";\n}\n\n.bi-cloud-snow::before {\n  content: \"\\f2bc\";\n}\n\n.bi-cloud-sun-fill::before {\n  content: \"\\f2bd\";\n}\n\n.bi-cloud-sun::before {\n  content: \"\\f2be\";\n}\n\n.bi-cloud-upload-fill::before {\n  content: \"\\f2bf\";\n}\n\n.bi-cloud-upload::before {\n  content: \"\\f2c0\";\n}\n\n.bi-cloud::before {\n  content: \"\\f2c1\";\n}\n\n.bi-clouds-fill::before {\n  content: \"\\f2c2\";\n}\n\n.bi-clouds::before {\n  content: \"\\f2c3\";\n}\n\n.bi-cloudy-fill::before {\n  content: \"\\f2c4\";\n}\n\n.bi-cloudy::before {\n  content: \"\\f2c5\";\n}\n\n.bi-code-slash::before {\n  content: \"\\f2c6\";\n}\n\n.bi-code-square::before {\n  content: \"\\f2c7\";\n}\n\n.bi-code::before {\n  content: \"\\f2c8\";\n}\n\n.bi-collection-fill::before {\n  content: \"\\f2c9\";\n}\n\n.bi-collection-play-fill::before {\n  content: \"\\f2ca\";\n}\n\n.bi-collection-play::before {\n  content: \"\\f2cb\";\n}\n\n.bi-collection::before {\n  content: \"\\f2cc\";\n}\n\n.bi-columns-gap::before {\n  content: \"\\f2cd\";\n}\n\n.bi-columns::before {\n  content: \"\\f2ce\";\n}\n\n.bi-command::before {\n  content: \"\\f2cf\";\n}\n\n.bi-compass-fill::before {\n  content: \"\\f2d0\";\n}\n\n.bi-compass::before {\n  content: \"\\f2d1\";\n}\n\n.bi-cone-striped::before {\n  content: \"\\f2d2\";\n}\n\n.bi-cone::before {\n  content: \"\\f2d3\";\n}\n\n.bi-controller::before {\n  content: \"\\f2d4\";\n}\n\n.bi-cpu-fill::before {\n  content: \"\\f2d5\";\n}\n\n.bi-cpu::before {\n  content: \"\\f2d6\";\n}\n\n.bi-credit-card-2-back-fill::before {\n  content: \"\\f2d7\";\n}\n\n.bi-credit-card-2-back::before {\n  content: \"\\f2d8\";\n}\n\n.bi-credit-card-2-front-fill::before {\n  content: \"\\f2d9\";\n}\n\n.bi-credit-card-2-front::before {\n  content: \"\\f2da\";\n}\n\n.bi-credit-card-fill::before {\n  content: \"\\f2db\";\n}\n\n.bi-credit-card::before {\n  content: \"\\f2dc\";\n}\n\n.bi-crop::before {\n  content: \"\\f2dd\";\n}\n\n.bi-cup-fill::before {\n  content: \"\\f2de\";\n}\n\n.bi-cup-straw::before {\n  content: \"\\f2df\";\n}\n\n.bi-cup::before {\n  content: \"\\f2e0\";\n}\n\n.bi-cursor-fill::before {\n  content: \"\\f2e1\";\n}\n\n.bi-cursor-text::before {\n  content: \"\\f2e2\";\n}\n\n.bi-cursor::before {\n  content: \"\\f2e3\";\n}\n\n.bi-dash-circle-dotted::before {\n  content: \"\\f2e4\";\n}\n\n.bi-dash-circle-fill::before {\n  content: \"\\f2e5\";\n}\n\n.bi-dash-circle::before {\n  content: \"\\f2e6\";\n}\n\n.bi-dash-square-dotted::before {\n  content: \"\\f2e7\";\n}\n\n.bi-dash-square-fill::before {\n  content: \"\\f2e8\";\n}\n\n.bi-dash-square::before {\n  content: \"\\f2e9\";\n}\n\n.bi-dash::before {\n  content: \"\\f2ea\";\n}\n\n.bi-diagram-2-fill::before {\n  content: \"\\f2eb\";\n}\n\n.bi-diagram-2::before {\n  content: \"\\f2ec\";\n}\n\n.bi-diagram-3-fill::before {\n  content: \"\\f2ed\";\n}\n\n.bi-diagram-3::before {\n  content: \"\\f2ee\";\n}\n\n.bi-diamond-fill::before {\n  content: \"\\f2ef\";\n}\n\n.bi-diamond-half::before {\n  content: \"\\f2f0\";\n}\n\n.bi-diamond::before {\n  content: \"\\f2f1\";\n}\n\n.bi-dice-1-fill::before {\n  content: \"\\f2f2\";\n}\n\n.bi-dice-1::before {\n  content: \"\\f2f3\";\n}\n\n.bi-dice-2-fill::before {\n  content: \"\\f2f4\";\n}\n\n.bi-dice-2::before {\n  content: \"\\f2f5\";\n}\n\n.bi-dice-3-fill::before {\n  content: \"\\f2f6\";\n}\n\n.bi-dice-3::before {\n  content: \"\\f2f7\";\n}\n\n.bi-dice-4-fill::before {\n  content: \"\\f2f8\";\n}\n\n.bi-dice-4::before {\n  content: \"\\f2f9\";\n}\n\n.bi-dice-5-fill::before {\n  content: \"\\f2fa\";\n}\n\n.bi-dice-5::before {\n  content: \"\\f2fb\";\n}\n\n.bi-dice-6-fill::before {\n  content: \"\\f2fc\";\n}\n\n.bi-dice-6::before {\n  content: \"\\f2fd\";\n}\n\n.bi-disc-fill::before {\n  content: \"\\f2fe\";\n}\n\n.bi-disc::before {\n  content: \"\\f2ff\";\n}\n\n.bi-discord::before {\n  content: \"\\f300\";\n}\n\n.bi-display-fill::before {\n  content: \"\\f301\";\n}\n\n.bi-display::before {\n  content: \"\\f302\";\n}\n\n.bi-distribute-horizontal::before {\n  content: \"\\f303\";\n}\n\n.bi-distribute-vertical::before {\n  content: \"\\f304\";\n}\n\n.bi-door-closed-fill::before {\n  content: \"\\f305\";\n}\n\n.bi-door-closed::before {\n  content: \"\\f306\";\n}\n\n.bi-door-open-fill::before {\n  content: \"\\f307\";\n}\n\n.bi-door-open::before {\n  content: \"\\f308\";\n}\n\n.bi-dot::before {\n  content: \"\\f309\";\n}\n\n.bi-download::before {\n  content: \"\\f30a\";\n}\n\n.bi-droplet-fill::before {\n  content: \"\\f30b\";\n}\n\n.bi-droplet-half::before {\n  content: \"\\f30c\";\n}\n\n.bi-droplet::before {\n  content: \"\\f30d\";\n}\n\n.bi-earbuds::before {\n  content: \"\\f30e\";\n}\n\n.bi-easel-fill::before {\n  content: \"\\f30f\";\n}\n\n.bi-easel::before {\n  content: \"\\f310\";\n}\n\n.bi-egg-fill::before {\n  content: \"\\f311\";\n}\n\n.bi-egg-fried::before {\n  content: \"\\f312\";\n}\n\n.bi-egg::before {\n  content: \"\\f313\";\n}\n\n.bi-eject-fill::before {\n  content: \"\\f314\";\n}\n\n.bi-eject::before {\n  content: \"\\f315\";\n}\n\n.bi-emoji-angry-fill::before {\n  content: \"\\f316\";\n}\n\n.bi-emoji-angry::before {\n  content: \"\\f317\";\n}\n\n.bi-emoji-dizzy-fill::before {\n  content: \"\\f318\";\n}\n\n.bi-emoji-dizzy::before {\n  content: \"\\f319\";\n}\n\n.bi-emoji-expressionless-fill::before {\n  content: \"\\f31a\";\n}\n\n.bi-emoji-expressionless::before {\n  content: \"\\f31b\";\n}\n\n.bi-emoji-frown-fill::before {\n  content: \"\\f31c\";\n}\n\n.bi-emoji-frown::before {\n  content: \"\\f31d\";\n}\n\n.bi-emoji-heart-eyes-fill::before {\n  content: \"\\f31e\";\n}\n\n.bi-emoji-heart-eyes::before {\n  content: \"\\f31f\";\n}\n\n.bi-emoji-laughing-fill::before {\n  content: \"\\f320\";\n}\n\n.bi-emoji-laughing::before {\n  content: \"\\f321\";\n}\n\n.bi-emoji-neutral-fill::before {\n  content: \"\\f322\";\n}\n\n.bi-emoji-neutral::before {\n  content: \"\\f323\";\n}\n\n.bi-emoji-smile-fill::before {\n  content: \"\\f324\";\n}\n\n.bi-emoji-smile-upside-down-fill::before {\n  content: \"\\f325\";\n}\n\n.bi-emoji-smile-upside-down::before {\n  content: \"\\f326\";\n}\n\n.bi-emoji-smile::before {\n  content: \"\\f327\";\n}\n\n.bi-emoji-sunglasses-fill::before {\n  content: \"\\f328\";\n}\n\n.bi-emoji-sunglasses::before {\n  content: \"\\f329\";\n}\n\n.bi-emoji-wink-fill::before {\n  content: \"\\f32a\";\n}\n\n.bi-emoji-wink::before {\n  content: \"\\f32b\";\n}\n\n.bi-envelope-fill::before {\n  content: \"\\f32c\";\n}\n\n.bi-envelope-open-fill::before {\n  content: \"\\f32d\";\n}\n\n.bi-envelope-open::before {\n  content: \"\\f32e\";\n}\n\n.bi-envelope::before {\n  content: \"\\f32f\";\n}\n\n.bi-eraser-fill::before {\n  content: \"\\f330\";\n}\n\n.bi-eraser::before {\n  content: \"\\f331\";\n}\n\n.bi-exclamation-circle-fill::before {\n  content: \"\\f332\";\n}\n\n.bi-exclamation-circle::before {\n  content: \"\\f333\";\n}\n\n.bi-exclamation-diamond-fill::before {\n  content: \"\\f334\";\n}\n\n.bi-exclamation-diamond::before {\n  content: \"\\f335\";\n}\n\n.bi-exclamation-octagon-fill::before {\n  content: \"\\f336\";\n}\n\n.bi-exclamation-octagon::before {\n  content: \"\\f337\";\n}\n\n.bi-exclamation-square-fill::before {\n  content: \"\\f338\";\n}\n\n.bi-exclamation-square::before {\n  content: \"\\f339\";\n}\n\n.bi-exclamation-triangle-fill::before {\n  content: \"\\f33a\";\n}\n\n.bi-exclamation-triangle::before {\n  content: \"\\f33b\";\n}\n\n.bi-exclamation::before {\n  content: \"\\f33c\";\n}\n\n.bi-exclude::before {\n  content: \"\\f33d\";\n}\n\n.bi-eye-fill::before {\n  content: \"\\f33e\";\n}\n\n.bi-eye-slash-fill::before {\n  content: \"\\f33f\";\n}\n\n.bi-eye-slash::before {\n  content: \"\\f340\";\n}\n\n.bi-eye::before {\n  content: \"\\f341\";\n}\n\n.bi-eyedropper::before {\n  content: \"\\f342\";\n}\n\n.bi-eyeglasses::before {\n  content: \"\\f343\";\n}\n\n.bi-facebook::before {\n  content: \"\\f344\";\n}\n\n.bi-file-arrow-down-fill::before {\n  content: \"\\f345\";\n}\n\n.bi-file-arrow-down::before {\n  content: \"\\f346\";\n}\n\n.bi-file-arrow-up-fill::before {\n  content: \"\\f347\";\n}\n\n.bi-file-arrow-up::before {\n  content: \"\\f348\";\n}\n\n.bi-file-bar-graph-fill::before {\n  content: \"\\f349\";\n}\n\n.bi-file-bar-graph::before {\n  content: \"\\f34a\";\n}\n\n.bi-file-binary-fill::before {\n  content: \"\\f34b\";\n}\n\n.bi-file-binary::before {\n  content: \"\\f34c\";\n}\n\n.bi-file-break-fill::before {\n  content: \"\\f34d\";\n}\n\n.bi-file-break::before {\n  content: \"\\f34e\";\n}\n\n.bi-file-check-fill::before {\n  content: \"\\f34f\";\n}\n\n.bi-file-check::before {\n  content: \"\\f350\";\n}\n\n.bi-file-code-fill::before {\n  content: \"\\f351\";\n}\n\n.bi-file-code::before {\n  content: \"\\f352\";\n}\n\n.bi-file-diff-fill::before {\n  content: \"\\f353\";\n}\n\n.bi-file-diff::before {\n  content: \"\\f354\";\n}\n\n.bi-file-earmark-arrow-down-fill::before {\n  content: \"\\f355\";\n}\n\n.bi-file-earmark-arrow-down::before {\n  content: \"\\f356\";\n}\n\n.bi-file-earmark-arrow-up-fill::before {\n  content: \"\\f357\";\n}\n\n.bi-file-earmark-arrow-up::before {\n  content: \"\\f358\";\n}\n\n.bi-file-earmark-bar-graph-fill::before {\n  content: \"\\f359\";\n}\n\n.bi-file-earmark-bar-graph::before {\n  content: \"\\f35a\";\n}\n\n.bi-file-earmark-binary-fill::before {\n  content: \"\\f35b\";\n}\n\n.bi-file-earmark-binary::before {\n  content: \"\\f35c\";\n}\n\n.bi-file-earmark-break-fill::before {\n  content: \"\\f35d\";\n}\n\n.bi-file-earmark-break::before {\n  content: \"\\f35e\";\n}\n\n.bi-file-earmark-check-fill::before {\n  content: \"\\f35f\";\n}\n\n.bi-file-earmark-check::before {\n  content: \"\\f360\";\n}\n\n.bi-file-earmark-code-fill::before {\n  content: \"\\f361\";\n}\n\n.bi-file-earmark-code::before {\n  content: \"\\f362\";\n}\n\n.bi-file-earmark-diff-fill::before {\n  content: \"\\f363\";\n}\n\n.bi-file-earmark-diff::before {\n  content: \"\\f364\";\n}\n\n.bi-file-earmark-easel-fill::before {\n  content: \"\\f365\";\n}\n\n.bi-file-earmark-easel::before {\n  content: \"\\f366\";\n}\n\n.bi-file-earmark-excel-fill::before {\n  content: \"\\f367\";\n}\n\n.bi-file-earmark-excel::before {\n  content: \"\\f368\";\n}\n\n.bi-file-earmark-fill::before {\n  content: \"\\f369\";\n}\n\n.bi-file-earmark-font-fill::before {\n  content: \"\\f36a\";\n}\n\n.bi-file-earmark-font::before {\n  content: \"\\f36b\";\n}\n\n.bi-file-earmark-image-fill::before {\n  content: \"\\f36c\";\n}\n\n.bi-file-earmark-image::before {\n  content: \"\\f36d\";\n}\n\n.bi-file-earmark-lock-fill::before {\n  content: \"\\f36e\";\n}\n\n.bi-file-earmark-lock::before {\n  content: \"\\f36f\";\n}\n\n.bi-file-earmark-lock2-fill::before {\n  content: \"\\f370\";\n}\n\n.bi-file-earmark-lock2::before {\n  content: \"\\f371\";\n}\n\n.bi-file-earmark-medical-fill::before {\n  content: \"\\f372\";\n}\n\n.bi-file-earmark-medical::before {\n  content: \"\\f373\";\n}\n\n.bi-file-earmark-minus-fill::before {\n  content: \"\\f374\";\n}\n\n.bi-file-earmark-minus::before {\n  content: \"\\f375\";\n}\n\n.bi-file-earmark-music-fill::before {\n  content: \"\\f376\";\n}\n\n.bi-file-earmark-music::before {\n  content: \"\\f377\";\n}\n\n.bi-file-earmark-person-fill::before {\n  content: \"\\f378\";\n}\n\n.bi-file-earmark-person::before {\n  content: \"\\f379\";\n}\n\n.bi-file-earmark-play-fill::before {\n  content: \"\\f37a\";\n}\n\n.bi-file-earmark-play::before {\n  content: \"\\f37b\";\n}\n\n.bi-file-earmark-plus-fill::before {\n  content: \"\\f37c\";\n}\n\n.bi-file-earmark-plus::before {\n  content: \"\\f37d\";\n}\n\n.bi-file-earmark-post-fill::before {\n  content: \"\\f37e\";\n}\n\n.bi-file-earmark-post::before {\n  content: \"\\f37f\";\n}\n\n.bi-file-earmark-ppt-fill::before {\n  content: \"\\f380\";\n}\n\n.bi-file-earmark-ppt::before {\n  content: \"\\f381\";\n}\n\n.bi-file-earmark-richtext-fill::before {\n  content: \"\\f382\";\n}\n\n.bi-file-earmark-richtext::before {\n  content: \"\\f383\";\n}\n\n.bi-file-earmark-ruled-fill::before {\n  content: \"\\f384\";\n}\n\n.bi-file-earmark-ruled::before {\n  content: \"\\f385\";\n}\n\n.bi-file-earmark-slides-fill::before {\n  content: \"\\f386\";\n}\n\n.bi-file-earmark-slides::before {\n  content: \"\\f387\";\n}\n\n.bi-file-earmark-spreadsheet-fill::before {\n  content: \"\\f388\";\n}\n\n.bi-file-earmark-spreadsheet::before {\n  content: \"\\f389\";\n}\n\n.bi-file-earmark-text-fill::before {\n  content: \"\\f38a\";\n}\n\n.bi-file-earmark-text::before {\n  content: \"\\f38b\";\n}\n\n.bi-file-earmark-word-fill::before {\n  content: \"\\f38c\";\n}\n\n.bi-file-earmark-word::before {\n  content: \"\\f38d\";\n}\n\n.bi-file-earmark-x-fill::before {\n  content: \"\\f38e\";\n}\n\n.bi-file-earmark-x::before {\n  content: \"\\f38f\";\n}\n\n.bi-file-earmark-zip-fill::before {\n  content: \"\\f390\";\n}\n\n.bi-file-earmark-zip::before {\n  content: \"\\f391\";\n}\n\n.bi-file-earmark::before {\n  content: \"\\f392\";\n}\n\n.bi-file-easel-fill::before {\n  content: \"\\f393\";\n}\n\n.bi-file-easel::before {\n  content: \"\\f394\";\n}\n\n.bi-file-excel-fill::before {\n  content: \"\\f395\";\n}\n\n.bi-file-excel::before {\n  content: \"\\f396\";\n}\n\n.bi-file-fill::before {\n  content: \"\\f397\";\n}\n\n.bi-file-font-fill::before {\n  content: \"\\f398\";\n}\n\n.bi-file-font::before {\n  content: \"\\f399\";\n}\n\n.bi-file-image-fill::before {\n  content: \"\\f39a\";\n}\n\n.bi-file-image::before {\n  content: \"\\f39b\";\n}\n\n.bi-file-lock-fill::before {\n  content: \"\\f39c\";\n}\n\n.bi-file-lock::before {\n  content: \"\\f39d\";\n}\n\n.bi-file-lock2-fill::before {\n  content: \"\\f39e\";\n}\n\n.bi-file-lock2::before {\n  content: \"\\f39f\";\n}\n\n.bi-file-medical-fill::before {\n  content: \"\\f3a0\";\n}\n\n.bi-file-medical::before {\n  content: \"\\f3a1\";\n}\n\n.bi-file-minus-fill::before {\n  content: \"\\f3a2\";\n}\n\n.bi-file-minus::before {\n  content: \"\\f3a3\";\n}\n\n.bi-file-music-fill::before {\n  content: \"\\f3a4\";\n}\n\n.bi-file-music::before {\n  content: \"\\f3a5\";\n}\n\n.bi-file-person-fill::before {\n  content: \"\\f3a6\";\n}\n\n.bi-file-person::before {\n  content: \"\\f3a7\";\n}\n\n.bi-file-play-fill::before {\n  content: \"\\f3a8\";\n}\n\n.bi-file-play::before {\n  content: \"\\f3a9\";\n}\n\n.bi-file-plus-fill::before {\n  content: \"\\f3aa\";\n}\n\n.bi-file-plus::before {\n  content: \"\\f3ab\";\n}\n\n.bi-file-post-fill::before {\n  content: \"\\f3ac\";\n}\n\n.bi-file-post::before {\n  content: \"\\f3ad\";\n}\n\n.bi-file-ppt-fill::before {\n  content: \"\\f3ae\";\n}\n\n.bi-file-ppt::before {\n  content: \"\\f3af\";\n}\n\n.bi-file-richtext-fill::before {\n  content: \"\\f3b0\";\n}\n\n.bi-file-richtext::before {\n  content: \"\\f3b1\";\n}\n\n.bi-file-ruled-fill::before {\n  content: \"\\f3b2\";\n}\n\n.bi-file-ruled::before {\n  content: \"\\f3b3\";\n}\n\n.bi-file-slides-fill::before {\n  content: \"\\f3b4\";\n}\n\n.bi-file-slides::before {\n  content: \"\\f3b5\";\n}\n\n.bi-file-spreadsheet-fill::before {\n  content: \"\\f3b6\";\n}\n\n.bi-file-spreadsheet::before {\n  content: \"\\f3b7\";\n}\n\n.bi-file-text-fill::before {\n  content: \"\\f3b8\";\n}\n\n.bi-file-text::before {\n  content: \"\\f3b9\";\n}\n\n.bi-file-word-fill::before {\n  content: \"\\f3ba\";\n}\n\n.bi-file-word::before {\n  content: \"\\f3bb\";\n}\n\n.bi-file-x-fill::before {\n  content: \"\\f3bc\";\n}\n\n.bi-file-x::before {\n  content: \"\\f3bd\";\n}\n\n.bi-file-zip-fill::before {\n  content: \"\\f3be\";\n}\n\n.bi-file-zip::before {\n  content: \"\\f3bf\";\n}\n\n.bi-file::before {\n  content: \"\\f3c0\";\n}\n\n.bi-files-alt::before {\n  content: \"\\f3c1\";\n}\n\n.bi-files::before {\n  content: \"\\f3c2\";\n}\n\n.bi-film::before {\n  content: \"\\f3c3\";\n}\n\n.bi-filter-circle-fill::before {\n  content: \"\\f3c4\";\n}\n\n.bi-filter-circle::before {\n  content: \"\\f3c5\";\n}\n\n.bi-filter-left::before {\n  content: \"\\f3c6\";\n}\n\n.bi-filter-right::before {\n  content: \"\\f3c7\";\n}\n\n.bi-filter-square-fill::before {\n  content: \"\\f3c8\";\n}\n\n.bi-filter-square::before {\n  content: \"\\f3c9\";\n}\n\n.bi-filter::before {\n  content: \"\\f3ca\";\n}\n\n.bi-flag-fill::before {\n  content: \"\\f3cb\";\n}\n\n.bi-flag::before {\n  content: \"\\f3cc\";\n}\n\n.bi-flower1::before {\n  content: \"\\f3cd\";\n}\n\n.bi-flower2::before {\n  content: \"\\f3ce\";\n}\n\n.bi-flower3::before {\n  content: \"\\f3cf\";\n}\n\n.bi-folder-check::before {\n  content: \"\\f3d0\";\n}\n\n.bi-folder-fill::before {\n  content: \"\\f3d1\";\n}\n\n.bi-folder-minus::before {\n  content: \"\\f3d2\";\n}\n\n.bi-folder-plus::before {\n  content: \"\\f3d3\";\n}\n\n.bi-folder-symlink-fill::before {\n  content: \"\\f3d4\";\n}\n\n.bi-folder-symlink::before {\n  content: \"\\f3d5\";\n}\n\n.bi-folder-x::before {\n  content: \"\\f3d6\";\n}\n\n.bi-folder::before {\n  content: \"\\f3d7\";\n}\n\n.bi-folder2-open::before {\n  content: \"\\f3d8\";\n}\n\n.bi-folder2::before {\n  content: \"\\f3d9\";\n}\n\n.bi-fonts::before {\n  content: \"\\f3da\";\n}\n\n.bi-forward-fill::before {\n  content: \"\\f3db\";\n}\n\n.bi-forward::before {\n  content: \"\\f3dc\";\n}\n\n.bi-front::before {\n  content: \"\\f3dd\";\n}\n\n.bi-fullscreen-exit::before {\n  content: \"\\f3de\";\n}\n\n.bi-fullscreen::before {\n  content: \"\\f3df\";\n}\n\n.bi-funnel-fill::before {\n  content: \"\\f3e0\";\n}\n\n.bi-funnel::before {\n  content: \"\\f3e1\";\n}\n\n.bi-gear-fill::before {\n  content: \"\\f3e2\";\n}\n\n.bi-gear-wide-connected::before {\n  content: \"\\f3e3\";\n}\n\n.bi-gear-wide::before {\n  content: \"\\f3e4\";\n}\n\n.bi-gear::before {\n  content: \"\\f3e5\";\n}\n\n.bi-gem::before {\n  content: \"\\f3e6\";\n}\n\n.bi-geo-alt-fill::before {\n  content: \"\\f3e7\";\n}\n\n.bi-geo-alt::before {\n  content: \"\\f3e8\";\n}\n\n.bi-geo-fill::before {\n  content: \"\\f3e9\";\n}\n\n.bi-geo::before {\n  content: \"\\f3ea\";\n}\n\n.bi-gift-fill::before {\n  content: \"\\f3eb\";\n}\n\n.bi-gift::before {\n  content: \"\\f3ec\";\n}\n\n.bi-github::before {\n  content: \"\\f3ed\";\n}\n\n.bi-globe::before {\n  content: \"\\f3ee\";\n}\n\n.bi-globe2::before {\n  content: \"\\f3ef\";\n}\n\n.bi-google::before {\n  content: \"\\f3f0\";\n}\n\n.bi-graph-down::before {\n  content: \"\\f3f1\";\n}\n\n.bi-graph-up::before {\n  content: \"\\f3f2\";\n}\n\n.bi-grid-1x2-fill::before {\n  content: \"\\f3f3\";\n}\n\n.bi-grid-1x2::before {\n  content: \"\\f3f4\";\n}\n\n.bi-grid-3x2-gap-fill::before {\n  content: \"\\f3f5\";\n}\n\n.bi-grid-3x2-gap::before {\n  content: \"\\f3f6\";\n}\n\n.bi-grid-3x2::before {\n  content: \"\\f3f7\";\n}\n\n.bi-grid-3x3-gap-fill::before {\n  content: \"\\f3f8\";\n}\n\n.bi-grid-3x3-gap::before {\n  content: \"\\f3f9\";\n}\n\n.bi-grid-3x3::before {\n  content: \"\\f3fa\";\n}\n\n.bi-grid-fill::before {\n  content: \"\\f3fb\";\n}\n\n.bi-grid::before {\n  content: \"\\f3fc\";\n}\n\n.bi-grip-horizontal::before {\n  content: \"\\f3fd\";\n}\n\n.bi-grip-vertical::before {\n  content: \"\\f3fe\";\n}\n\n.bi-hammer::before {\n  content: \"\\f3ff\";\n}\n\n.bi-hand-index-fill::before {\n  content: \"\\f400\";\n}\n\n.bi-hand-index-thumb-fill::before {\n  content: \"\\f401\";\n}\n\n.bi-hand-index-thumb::before {\n  content: \"\\f402\";\n}\n\n.bi-hand-index::before {\n  content: \"\\f403\";\n}\n\n.bi-hand-thumbs-down-fill::before {\n  content: \"\\f404\";\n}\n\n.bi-hand-thumbs-down::before {\n  content: \"\\f405\";\n}\n\n.bi-hand-thumbs-up-fill::before {\n  content: \"\\f406\";\n}\n\n.bi-hand-thumbs-up::before {\n  content: \"\\f407\";\n}\n\n.bi-handbag-fill::before {\n  content: \"\\f408\";\n}\n\n.bi-handbag::before {\n  content: \"\\f409\";\n}\n\n.bi-hash::before {\n  content: \"\\f40a\";\n}\n\n.bi-hdd-fill::before {\n  content: \"\\f40b\";\n}\n\n.bi-hdd-network-fill::before {\n  content: \"\\f40c\";\n}\n\n.bi-hdd-network::before {\n  content: \"\\f40d\";\n}\n\n.bi-hdd-rack-fill::before {\n  content: \"\\f40e\";\n}\n\n.bi-hdd-rack::before {\n  content: \"\\f40f\";\n}\n\n.bi-hdd-stack-fill::before {\n  content: \"\\f410\";\n}\n\n.bi-hdd-stack::before {\n  content: \"\\f411\";\n}\n\n.bi-hdd::before {\n  content: \"\\f412\";\n}\n\n.bi-headphones::before {\n  content: \"\\f413\";\n}\n\n.bi-headset::before {\n  content: \"\\f414\";\n}\n\n.bi-heart-fill::before {\n  content: \"\\f415\";\n}\n\n.bi-heart-half::before {\n  content: \"\\f416\";\n}\n\n.bi-heart::before {\n  content: \"\\f417\";\n}\n\n.bi-heptagon-fill::before {\n  content: \"\\f418\";\n}\n\n.bi-heptagon-half::before {\n  content: \"\\f419\";\n}\n\n.bi-heptagon::before {\n  content: \"\\f41a\";\n}\n\n.bi-hexagon-fill::before {\n  content: \"\\f41b\";\n}\n\n.bi-hexagon-half::before {\n  content: \"\\f41c\";\n}\n\n.bi-hexagon::before {\n  content: \"\\f41d\";\n}\n\n.bi-hourglass-bottom::before {\n  content: \"\\f41e\";\n}\n\n.bi-hourglass-split::before {\n  content: \"\\f41f\";\n}\n\n.bi-hourglass-top::before {\n  content: \"\\f420\";\n}\n\n.bi-hourglass::before {\n  content: \"\\f421\";\n}\n\n.bi-house-door-fill::before {\n  content: \"\\f422\";\n}\n\n.bi-house-door::before {\n  content: \"\\f423\";\n}\n\n.bi-house-fill::before {\n  content: \"\\f424\";\n}\n\n.bi-house::before {\n  content: \"\\f425\";\n}\n\n.bi-hr::before {\n  content: \"\\f426\";\n}\n\n.bi-hurricane::before {\n  content: \"\\f427\";\n}\n\n.bi-image-alt::before {\n  content: \"\\f428\";\n}\n\n.bi-image-fill::before {\n  content: \"\\f429\";\n}\n\n.bi-image::before {\n  content: \"\\f42a\";\n}\n\n.bi-images::before {\n  content: \"\\f42b\";\n}\n\n.bi-inbox-fill::before {\n  content: \"\\f42c\";\n}\n\n.bi-inbox::before {\n  content: \"\\f42d\";\n}\n\n.bi-inboxes-fill::before {\n  content: \"\\f42e\";\n}\n\n.bi-inboxes::before {\n  content: \"\\f42f\";\n}\n\n.bi-info-circle-fill::before {\n  content: \"\\f430\";\n}\n\n.bi-info-circle::before {\n  content: \"\\f431\";\n}\n\n.bi-info-square-fill::before {\n  content: \"\\f432\";\n}\n\n.bi-info-square::before {\n  content: \"\\f433\";\n}\n\n.bi-info::before {\n  content: \"\\f434\";\n}\n\n.bi-input-cursor-text::before {\n  content: \"\\f435\";\n}\n\n.bi-input-cursor::before {\n  content: \"\\f436\";\n}\n\n.bi-instagram::before {\n  content: \"\\f437\";\n}\n\n.bi-intersect::before {\n  content: \"\\f438\";\n}\n\n.bi-journal-album::before {\n  content: \"\\f439\";\n}\n\n.bi-journal-arrow-down::before {\n  content: \"\\f43a\";\n}\n\n.bi-journal-arrow-up::before {\n  content: \"\\f43b\";\n}\n\n.bi-journal-bookmark-fill::before {\n  content: \"\\f43c\";\n}\n\n.bi-journal-bookmark::before {\n  content: \"\\f43d\";\n}\n\n.bi-journal-check::before {\n  content: \"\\f43e\";\n}\n\n.bi-journal-code::before {\n  content: \"\\f43f\";\n}\n\n.bi-journal-medical::before {\n  content: \"\\f440\";\n}\n\n.bi-journal-minus::before {\n  content: \"\\f441\";\n}\n\n.bi-journal-plus::before {\n  content: \"\\f442\";\n}\n\n.bi-journal-richtext::before {\n  content: \"\\f443\";\n}\n\n.bi-journal-text::before {\n  content: \"\\f444\";\n}\n\n.bi-journal-x::before {\n  content: \"\\f445\";\n}\n\n.bi-journal::before {\n  content: \"\\f446\";\n}\n\n.bi-journals::before {\n  content: \"\\f447\";\n}\n\n.bi-joystick::before {\n  content: \"\\f448\";\n}\n\n.bi-justify-left::before {\n  content: \"\\f449\";\n}\n\n.bi-justify-right::before {\n  content: \"\\f44a\";\n}\n\n.bi-justify::before {\n  content: \"\\f44b\";\n}\n\n.bi-kanban-fill::before {\n  content: \"\\f44c\";\n}\n\n.bi-kanban::before {\n  content: \"\\f44d\";\n}\n\n.bi-key-fill::before {\n  content: \"\\f44e\";\n}\n\n.bi-key::before {\n  content: \"\\f44f\";\n}\n\n.bi-keyboard-fill::before {\n  content: \"\\f450\";\n}\n\n.bi-keyboard::before {\n  content: \"\\f451\";\n}\n\n.bi-ladder::before {\n  content: \"\\f452\";\n}\n\n.bi-lamp-fill::before {\n  content: \"\\f453\";\n}\n\n.bi-lamp::before {\n  content: \"\\f454\";\n}\n\n.bi-laptop-fill::before {\n  content: \"\\f455\";\n}\n\n.bi-laptop::before {\n  content: \"\\f456\";\n}\n\n.bi-layer-backward::before {\n  content: \"\\f457\";\n}\n\n.bi-layer-forward::before {\n  content: \"\\f458\";\n}\n\n.bi-layers-fill::before {\n  content: \"\\f459\";\n}\n\n.bi-layers-half::before {\n  content: \"\\f45a\";\n}\n\n.bi-layers::before {\n  content: \"\\f45b\";\n}\n\n.bi-layout-sidebar-inset-reverse::before {\n  content: \"\\f45c\";\n}\n\n.bi-layout-sidebar-inset::before {\n  content: \"\\f45d\";\n}\n\n.bi-layout-sidebar-reverse::before {\n  content: \"\\f45e\";\n}\n\n.bi-layout-sidebar::before {\n  content: \"\\f45f\";\n}\n\n.bi-layout-split::before {\n  content: \"\\f460\";\n}\n\n.bi-layout-text-sidebar-reverse::before {\n  content: \"\\f461\";\n}\n\n.bi-layout-text-sidebar::before {\n  content: \"\\f462\";\n}\n\n.bi-layout-text-window-reverse::before {\n  content: \"\\f463\";\n}\n\n.bi-layout-text-window::before {\n  content: \"\\f464\";\n}\n\n.bi-layout-three-columns::before {\n  content: \"\\f465\";\n}\n\n.bi-layout-wtf::before {\n  content: \"\\f466\";\n}\n\n.bi-life-preserver::before {\n  content: \"\\f467\";\n}\n\n.bi-lightbulb-fill::before {\n  content: \"\\f468\";\n}\n\n.bi-lightbulb-off-fill::before {\n  content: \"\\f469\";\n}\n\n.bi-lightbulb-off::before {\n  content: \"\\f46a\";\n}\n\n.bi-lightbulb::before {\n  content: \"\\f46b\";\n}\n\n.bi-lightning-charge-fill::before {\n  content: \"\\f46c\";\n}\n\n.bi-lightning-charge::before {\n  content: \"\\f46d\";\n}\n\n.bi-lightning-fill::before {\n  content: \"\\f46e\";\n}\n\n.bi-lightning::before {\n  content: \"\\f46f\";\n}\n\n.bi-link-45deg::before {\n  content: \"\\f470\";\n}\n\n.bi-link::before {\n  content: \"\\f471\";\n}\n\n.bi-linkedin::before {\n  content: \"\\f472\";\n}\n\n.bi-list-check::before {\n  content: \"\\f473\";\n}\n\n.bi-list-nested::before {\n  content: \"\\f474\";\n}\n\n.bi-list-ol::before {\n  content: \"\\f475\";\n}\n\n.bi-list-stars::before {\n  content: \"\\f476\";\n}\n\n.bi-list-task::before {\n  content: \"\\f477\";\n}\n\n.bi-list-ul::before {\n  content: \"\\f478\";\n}\n\n.bi-list::before {\n  content: \"\\f479\";\n}\n\n.bi-lock-fill::before {\n  content: \"\\f47a\";\n}\n\n.bi-lock::before {\n  content: \"\\f47b\";\n}\n\n.bi-mailbox::before {\n  content: \"\\f47c\";\n}\n\n.bi-mailbox2::before {\n  content: \"\\f47d\";\n}\n\n.bi-map-fill::before {\n  content: \"\\f47e\";\n}\n\n.bi-map::before {\n  content: \"\\f47f\";\n}\n\n.bi-markdown-fill::before {\n  content: \"\\f480\";\n}\n\n.bi-markdown::before {\n  content: \"\\f481\";\n}\n\n.bi-mask::before {\n  content: \"\\f482\";\n}\n\n.bi-megaphone-fill::before {\n  content: \"\\f483\";\n}\n\n.bi-megaphone::before {\n  content: \"\\f484\";\n}\n\n.bi-menu-app-fill::before {\n  content: \"\\f485\";\n}\n\n.bi-menu-app::before {\n  content: \"\\f486\";\n}\n\n.bi-menu-button-fill::before {\n  content: \"\\f487\";\n}\n\n.bi-menu-button-wide-fill::before {\n  content: \"\\f488\";\n}\n\n.bi-menu-button-wide::before {\n  content: \"\\f489\";\n}\n\n.bi-menu-button::before {\n  content: \"\\f48a\";\n}\n\n.bi-menu-down::before {\n  content: \"\\f48b\";\n}\n\n.bi-menu-up::before {\n  content: \"\\f48c\";\n}\n\n.bi-mic-fill::before {\n  content: \"\\f48d\";\n}\n\n.bi-mic-mute-fill::before {\n  content: \"\\f48e\";\n}\n\n.bi-mic-mute::before {\n  content: \"\\f48f\";\n}\n\n.bi-mic::before {\n  content: \"\\f490\";\n}\n\n.bi-minecart-loaded::before {\n  content: \"\\f491\";\n}\n\n.bi-minecart::before {\n  content: \"\\f492\";\n}\n\n.bi-moisture::before {\n  content: \"\\f493\";\n}\n\n.bi-moon-fill::before {\n  content: \"\\f494\";\n}\n\n.bi-moon-stars-fill::before {\n  content: \"\\f495\";\n}\n\n.bi-moon-stars::before {\n  content: \"\\f496\";\n}\n\n.bi-moon::before {\n  content: \"\\f497\";\n}\n\n.bi-mouse-fill::before {\n  content: \"\\f498\";\n}\n\n.bi-mouse::before {\n  content: \"\\f499\";\n}\n\n.bi-mouse2-fill::before {\n  content: \"\\f49a\";\n}\n\n.bi-mouse2::before {\n  content: \"\\f49b\";\n}\n\n.bi-mouse3-fill::before {\n  content: \"\\f49c\";\n}\n\n.bi-mouse3::before {\n  content: \"\\f49d\";\n}\n\n.bi-music-note-beamed::before {\n  content: \"\\f49e\";\n}\n\n.bi-music-note-list::before {\n  content: \"\\f49f\";\n}\n\n.bi-music-note::before {\n  content: \"\\f4a0\";\n}\n\n.bi-music-player-fill::before {\n  content: \"\\f4a1\";\n}\n\n.bi-music-player::before {\n  content: \"\\f4a2\";\n}\n\n.bi-newspaper::before {\n  content: \"\\f4a3\";\n}\n\n.bi-node-minus-fill::before {\n  content: \"\\f4a4\";\n}\n\n.bi-node-minus::before {\n  content: \"\\f4a5\";\n}\n\n.bi-node-plus-fill::before {\n  content: \"\\f4a6\";\n}\n\n.bi-node-plus::before {\n  content: \"\\f4a7\";\n}\n\n.bi-nut-fill::before {\n  content: \"\\f4a8\";\n}\n\n.bi-nut::before {\n  content: \"\\f4a9\";\n}\n\n.bi-octagon-fill::before {\n  content: \"\\f4aa\";\n}\n\n.bi-octagon-half::before {\n  content: \"\\f4ab\";\n}\n\n.bi-octagon::before {\n  content: \"\\f4ac\";\n}\n\n.bi-option::before {\n  content: \"\\f4ad\";\n}\n\n.bi-outlet::before {\n  content: \"\\f4ae\";\n}\n\n.bi-paint-bucket::before {\n  content: \"\\f4af\";\n}\n\n.bi-palette-fill::before {\n  content: \"\\f4b0\";\n}\n\n.bi-palette::before {\n  content: \"\\f4b1\";\n}\n\n.bi-palette2::before {\n  content: \"\\f4b2\";\n}\n\n.bi-paperclip::before {\n  content: \"\\f4b3\";\n}\n\n.bi-paragraph::before {\n  content: \"\\f4b4\";\n}\n\n.bi-patch-check-fill::before {\n  content: \"\\f4b5\";\n}\n\n.bi-patch-check::before {\n  content: \"\\f4b6\";\n}\n\n.bi-patch-exclamation-fill::before {\n  content: \"\\f4b7\";\n}\n\n.bi-patch-exclamation::before {\n  content: \"\\f4b8\";\n}\n\n.bi-patch-minus-fill::before {\n  content: \"\\f4b9\";\n}\n\n.bi-patch-minus::before {\n  content: \"\\f4ba\";\n}\n\n.bi-patch-plus-fill::before {\n  content: \"\\f4bb\";\n}\n\n.bi-patch-plus::before {\n  content: \"\\f4bc\";\n}\n\n.bi-patch-question-fill::before {\n  content: \"\\f4bd\";\n}\n\n.bi-patch-question::before {\n  content: \"\\f4be\";\n}\n\n.bi-pause-btn-fill::before {\n  content: \"\\f4bf\";\n}\n\n.bi-pause-btn::before {\n  content: \"\\f4c0\";\n}\n\n.bi-pause-circle-fill::before {\n  content: \"\\f4c1\";\n}\n\n.bi-pause-circle::before {\n  content: \"\\f4c2\";\n}\n\n.bi-pause-fill::before {\n  content: \"\\f4c3\";\n}\n\n.bi-pause::before {\n  content: \"\\f4c4\";\n}\n\n.bi-peace-fill::before {\n  content: \"\\f4c5\";\n}\n\n.bi-peace::before {\n  content: \"\\f4c6\";\n}\n\n.bi-pen-fill::before {\n  content: \"\\f4c7\";\n}\n\n.bi-pen::before {\n  content: \"\\f4c8\";\n}\n\n.bi-pencil-fill::before {\n  content: \"\\f4c9\";\n}\n\n.bi-pencil-square::before {\n  content: \"\\f4ca\";\n}\n\n.bi-pencil::before {\n  content: \"\\f4cb\";\n}\n\n.bi-pentagon-fill::before {\n  content: \"\\f4cc\";\n}\n\n.bi-pentagon-half::before {\n  content: \"\\f4cd\";\n}\n\n.bi-pentagon::before {\n  content: \"\\f4ce\";\n}\n\n.bi-people-fill::before {\n  content: \"\\f4cf\";\n}\n\n.bi-people::before {\n  content: \"\\f4d0\";\n}\n\n.bi-percent::before {\n  content: \"\\f4d1\";\n}\n\n.bi-person-badge-fill::before {\n  content: \"\\f4d2\";\n}\n\n.bi-person-badge::before {\n  content: \"\\f4d3\";\n}\n\n.bi-person-bounding-box::before {\n  content: \"\\f4d4\";\n}\n\n.bi-person-check-fill::before {\n  content: \"\\f4d5\";\n}\n\n.bi-person-check::before {\n  content: \"\\f4d6\";\n}\n\n.bi-person-circle::before {\n  content: \"\\f4d7\";\n}\n\n.bi-person-dash-fill::before {\n  content: \"\\f4d8\";\n}\n\n.bi-person-dash::before {\n  content: \"\\f4d9\";\n}\n\n.bi-person-fill::before {\n  content: \"\\f4da\";\n}\n\n.bi-person-lines-fill::before {\n  content: \"\\f4db\";\n}\n\n.bi-person-plus-fill::before {\n  content: \"\\f4dc\";\n}\n\n.bi-person-plus::before {\n  content: \"\\f4dd\";\n}\n\n.bi-person-square::before {\n  content: \"\\f4de\";\n}\n\n.bi-person-x-fill::before {\n  content: \"\\f4df\";\n}\n\n.bi-person-x::before {\n  content: \"\\f4e0\";\n}\n\n.bi-person::before {\n  content: \"\\f4e1\";\n}\n\n.bi-phone-fill::before {\n  content: \"\\f4e2\";\n}\n\n.bi-phone-landscape-fill::before {\n  content: \"\\f4e3\";\n}\n\n.bi-phone-landscape::before {\n  content: \"\\f4e4\";\n}\n\n.bi-phone-vibrate-fill::before {\n  content: \"\\f4e5\";\n}\n\n.bi-phone-vibrate::before {\n  content: \"\\f4e6\";\n}\n\n.bi-phone::before {\n  content: \"\\f4e7\";\n}\n\n.bi-pie-chart-fill::before {\n  content: \"\\f4e8\";\n}\n\n.bi-pie-chart::before {\n  content: \"\\f4e9\";\n}\n\n.bi-pin-angle-fill::before {\n  content: \"\\f4ea\";\n}\n\n.bi-pin-angle::before {\n  content: \"\\f4eb\";\n}\n\n.bi-pin-fill::before {\n  content: \"\\f4ec\";\n}\n\n.bi-pin::before {\n  content: \"\\f4ed\";\n}\n\n.bi-pip-fill::before {\n  content: \"\\f4ee\";\n}\n\n.bi-pip::before {\n  content: \"\\f4ef\";\n}\n\n.bi-play-btn-fill::before {\n  content: \"\\f4f0\";\n}\n\n.bi-play-btn::before {\n  content: \"\\f4f1\";\n}\n\n.bi-play-circle-fill::before {\n  content: \"\\f4f2\";\n}\n\n.bi-play-circle::before {\n  content: \"\\f4f3\";\n}\n\n.bi-play-fill::before {\n  content: \"\\f4f4\";\n}\n\n.bi-play::before {\n  content: \"\\f4f5\";\n}\n\n.bi-plug-fill::before {\n  content: \"\\f4f6\";\n}\n\n.bi-plug::before {\n  content: \"\\f4f7\";\n}\n\n.bi-plus-circle-dotted::before {\n  content: \"\\f4f8\";\n}\n\n.bi-plus-circle-fill::before {\n  content: \"\\f4f9\";\n}\n\n.bi-plus-circle::before {\n  content: \"\\f4fa\";\n}\n\n.bi-plus-square-dotted::before {\n  content: \"\\f4fb\";\n}\n\n.bi-plus-square-fill::before {\n  content: \"\\f4fc\";\n}\n\n.bi-plus-square::before {\n  content: \"\\f4fd\";\n}\n\n.bi-plus::before {\n  content: \"\\f4fe\";\n}\n\n.bi-power::before {\n  content: \"\\f4ff\";\n}\n\n.bi-printer-fill::before {\n  content: \"\\f500\";\n}\n\n.bi-printer::before {\n  content: \"\\f501\";\n}\n\n.bi-puzzle-fill::before {\n  content: \"\\f502\";\n}\n\n.bi-puzzle::before {\n  content: \"\\f503\";\n}\n\n.bi-question-circle-fill::before {\n  content: \"\\f504\";\n}\n\n.bi-question-circle::before {\n  content: \"\\f505\";\n}\n\n.bi-question-diamond-fill::before {\n  content: \"\\f506\";\n}\n\n.bi-question-diamond::before {\n  content: \"\\f507\";\n}\n\n.bi-question-octagon-fill::before {\n  content: \"\\f508\";\n}\n\n.bi-question-octagon::before {\n  content: \"\\f509\";\n}\n\n.bi-question-square-fill::before {\n  content: \"\\f50a\";\n}\n\n.bi-question-square::before {\n  content: \"\\f50b\";\n}\n\n.bi-question::before {\n  content: \"\\f50c\";\n}\n\n.bi-rainbow::before {\n  content: \"\\f50d\";\n}\n\n.bi-receipt-cutoff::before {\n  content: \"\\f50e\";\n}\n\n.bi-receipt::before {\n  content: \"\\f50f\";\n}\n\n.bi-reception-0::before {\n  content: \"\\f510\";\n}\n\n.bi-reception-1::before {\n  content: \"\\f511\";\n}\n\n.bi-reception-2::before {\n  content: \"\\f512\";\n}\n\n.bi-reception-3::before {\n  content: \"\\f513\";\n}\n\n.bi-reception-4::before {\n  content: \"\\f514\";\n}\n\n.bi-record-btn-fill::before {\n  content: \"\\f515\";\n}\n\n.bi-record-btn::before {\n  content: \"\\f516\";\n}\n\n.bi-record-circle-fill::before {\n  content: \"\\f517\";\n}\n\n.bi-record-circle::before {\n  content: \"\\f518\";\n}\n\n.bi-record-fill::before {\n  content: \"\\f519\";\n}\n\n.bi-record::before {\n  content: \"\\f51a\";\n}\n\n.bi-record2-fill::before {\n  content: \"\\f51b\";\n}\n\n.bi-record2::before {\n  content: \"\\f51c\";\n}\n\n.bi-reply-all-fill::before {\n  content: \"\\f51d\";\n}\n\n.bi-reply-all::before {\n  content: \"\\f51e\";\n}\n\n.bi-reply-fill::before {\n  content: \"\\f51f\";\n}\n\n.bi-reply::before {\n  content: \"\\f520\";\n}\n\n.bi-rss-fill::before {\n  content: \"\\f521\";\n}\n\n.bi-rss::before {\n  content: \"\\f522\";\n}\n\n.bi-rulers::before {\n  content: \"\\f523\";\n}\n\n.bi-save-fill::before {\n  content: \"\\f524\";\n}\n\n.bi-save::before {\n  content: \"\\f525\";\n}\n\n.bi-save2-fill::before {\n  content: \"\\f526\";\n}\n\n.bi-save2::before {\n  content: \"\\f527\";\n}\n\n.bi-scissors::before {\n  content: \"\\f528\";\n}\n\n.bi-screwdriver::before {\n  content: \"\\f529\";\n}\n\n.bi-search::before {\n  content: \"\\f52a\";\n}\n\n.bi-segmented-nav::before {\n  content: \"\\f52b\";\n}\n\n.bi-server::before {\n  content: \"\\f52c\";\n}\n\n.bi-share-fill::before {\n  content: \"\\f52d\";\n}\n\n.bi-share::before {\n  content: \"\\f52e\";\n}\n\n.bi-shield-check::before {\n  content: \"\\f52f\";\n}\n\n.bi-shield-exclamation::before {\n  content: \"\\f530\";\n}\n\n.bi-shield-fill-check::before {\n  content: \"\\f531\";\n}\n\n.bi-shield-fill-exclamation::before {\n  content: \"\\f532\";\n}\n\n.bi-shield-fill-minus::before {\n  content: \"\\f533\";\n}\n\n.bi-shield-fill-plus::before {\n  content: \"\\f534\";\n}\n\n.bi-shield-fill-x::before {\n  content: \"\\f535\";\n}\n\n.bi-shield-fill::before {\n  content: \"\\f536\";\n}\n\n.bi-shield-lock-fill::before {\n  content: \"\\f537\";\n}\n\n.bi-shield-lock::before {\n  content: \"\\f538\";\n}\n\n.bi-shield-minus::before {\n  content: \"\\f539\";\n}\n\n.bi-shield-plus::before {\n  content: \"\\f53a\";\n}\n\n.bi-shield-shaded::before {\n  content: \"\\f53b\";\n}\n\n.bi-shield-slash-fill::before {\n  content: \"\\f53c\";\n}\n\n.bi-shield-slash::before {\n  content: \"\\f53d\";\n}\n\n.bi-shield-x::before {\n  content: \"\\f53e\";\n}\n\n.bi-shield::before {\n  content: \"\\f53f\";\n}\n\n.bi-shift-fill::before {\n  content: \"\\f540\";\n}\n\n.bi-shift::before {\n  content: \"\\f541\";\n}\n\n.bi-shop-window::before {\n  content: \"\\f542\";\n}\n\n.bi-shop::before {\n  content: \"\\f543\";\n}\n\n.bi-shuffle::before {\n  content: \"\\f544\";\n}\n\n.bi-signpost-2-fill::before {\n  content: \"\\f545\";\n}\n\n.bi-signpost-2::before {\n  content: \"\\f546\";\n}\n\n.bi-signpost-fill::before {\n  content: \"\\f547\";\n}\n\n.bi-signpost-split-fill::before {\n  content: \"\\f548\";\n}\n\n.bi-signpost-split::before {\n  content: \"\\f549\";\n}\n\n.bi-signpost::before {\n  content: \"\\f54a\";\n}\n\n.bi-sim-fill::before {\n  content: \"\\f54b\";\n}\n\n.bi-sim::before {\n  content: \"\\f54c\";\n}\n\n.bi-skip-backward-btn-fill::before {\n  content: \"\\f54d\";\n}\n\n.bi-skip-backward-btn::before {\n  content: \"\\f54e\";\n}\n\n.bi-skip-backward-circle-fill::before {\n  content: \"\\f54f\";\n}\n\n.bi-skip-backward-circle::before {\n  content: \"\\f550\";\n}\n\n.bi-skip-backward-fill::before {\n  content: \"\\f551\";\n}\n\n.bi-skip-backward::before {\n  content: \"\\f552\";\n}\n\n.bi-skip-end-btn-fill::before {\n  content: \"\\f553\";\n}\n\n.bi-skip-end-btn::before {\n  content: \"\\f554\";\n}\n\n.bi-skip-end-circle-fill::before {\n  content: \"\\f555\";\n}\n\n.bi-skip-end-circle::before {\n  content: \"\\f556\";\n}\n\n.bi-skip-end-fill::before {\n  content: \"\\f557\";\n}\n\n.bi-skip-end::before {\n  content: \"\\f558\";\n}\n\n.bi-skip-forward-btn-fill::before {\n  content: \"\\f559\";\n}\n\n.bi-skip-forward-btn::before {\n  content: \"\\f55a\";\n}\n\n.bi-skip-forward-circle-fill::before {\n  content: \"\\f55b\";\n}\n\n.bi-skip-forward-circle::before {\n  content: \"\\f55c\";\n}\n\n.bi-skip-forward-fill::before {\n  content: \"\\f55d\";\n}\n\n.bi-skip-forward::before {\n  content: \"\\f55e\";\n}\n\n.bi-skip-start-btn-fill::before {\n  content: \"\\f55f\";\n}\n\n.bi-skip-start-btn::before {\n  content: \"\\f560\";\n}\n\n.bi-skip-start-circle-fill::before {\n  content: \"\\f561\";\n}\n\n.bi-skip-start-circle::before {\n  content: \"\\f562\";\n}\n\n.bi-skip-start-fill::before {\n  content: \"\\f563\";\n}\n\n.bi-skip-start::before {\n  content: \"\\f564\";\n}\n\n.bi-slack::before {\n  content: \"\\f565\";\n}\n\n.bi-slash-circle-fill::before {\n  content: \"\\f566\";\n}\n\n.bi-slash-circle::before {\n  content: \"\\f567\";\n}\n\n.bi-slash-square-fill::before {\n  content: \"\\f568\";\n}\n\n.bi-slash-square::before {\n  content: \"\\f569\";\n}\n\n.bi-slash::before {\n  content: \"\\f56a\";\n}\n\n.bi-sliders::before {\n  content: \"\\f56b\";\n}\n\n.bi-smartwatch::before {\n  content: \"\\f56c\";\n}\n\n.bi-snow::before {\n  content: \"\\f56d\";\n}\n\n.bi-snow2::before {\n  content: \"\\f56e\";\n}\n\n.bi-snow3::before {\n  content: \"\\f56f\";\n}\n\n.bi-sort-alpha-down-alt::before {\n  content: \"\\f570\";\n}\n\n.bi-sort-alpha-down::before {\n  content: \"\\f571\";\n}\n\n.bi-sort-alpha-up-alt::before {\n  content: \"\\f572\";\n}\n\n.bi-sort-alpha-up::before {\n  content: \"\\f573\";\n}\n\n.bi-sort-down-alt::before {\n  content: \"\\f574\";\n}\n\n.bi-sort-down::before {\n  content: \"\\f575\";\n}\n\n.bi-sort-numeric-down-alt::before {\n  content: \"\\f576\";\n}\n\n.bi-sort-numeric-down::before {\n  content: \"\\f577\";\n}\n\n.bi-sort-numeric-up-alt::before {\n  content: \"\\f578\";\n}\n\n.bi-sort-numeric-up::before {\n  content: \"\\f579\";\n}\n\n.bi-sort-up-alt::before {\n  content: \"\\f57a\";\n}\n\n.bi-sort-up::before {\n  content: \"\\f57b\";\n}\n\n.bi-soundwave::before {\n  content: \"\\f57c\";\n}\n\n.bi-speaker-fill::before {\n  content: \"\\f57d\";\n}\n\n.bi-speaker::before {\n  content: \"\\f57e\";\n}\n\n.bi-speedometer::before {\n  content: \"\\f57f\";\n}\n\n.bi-speedometer2::before {\n  content: \"\\f580\";\n}\n\n.bi-spellcheck::before {\n  content: \"\\f581\";\n}\n\n.bi-square-fill::before {\n  content: \"\\f582\";\n}\n\n.bi-square-half::before {\n  content: \"\\f583\";\n}\n\n.bi-square::before {\n  content: \"\\f584\";\n}\n\n.bi-stack::before {\n  content: \"\\f585\";\n}\n\n.bi-star-fill::before {\n  content: \"\\f586\";\n}\n\n.bi-star-half::before {\n  content: \"\\f587\";\n}\n\n.bi-star::before {\n  content: \"\\f588\";\n}\n\n.bi-stars::before {\n  content: \"\\f589\";\n}\n\n.bi-stickies-fill::before {\n  content: \"\\f58a\";\n}\n\n.bi-stickies::before {\n  content: \"\\f58b\";\n}\n\n.bi-sticky-fill::before {\n  content: \"\\f58c\";\n}\n\n.bi-sticky::before {\n  content: \"\\f58d\";\n}\n\n.bi-stop-btn-fill::before {\n  content: \"\\f58e\";\n}\n\n.bi-stop-btn::before {\n  content: \"\\f58f\";\n}\n\n.bi-stop-circle-fill::before {\n  content: \"\\f590\";\n}\n\n.bi-stop-circle::before {\n  content: \"\\f591\";\n}\n\n.bi-stop-fill::before {\n  content: \"\\f592\";\n}\n\n.bi-stop::before {\n  content: \"\\f593\";\n}\n\n.bi-stoplights-fill::before {\n  content: \"\\f594\";\n}\n\n.bi-stoplights::before {\n  content: \"\\f595\";\n}\n\n.bi-stopwatch-fill::before {\n  content: \"\\f596\";\n}\n\n.bi-stopwatch::before {\n  content: \"\\f597\";\n}\n\n.bi-subtract::before {\n  content: \"\\f598\";\n}\n\n.bi-suit-club-fill::before {\n  content: \"\\f599\";\n}\n\n.bi-suit-club::before {\n  content: \"\\f59a\";\n}\n\n.bi-suit-diamond-fill::before {\n  content: \"\\f59b\";\n}\n\n.bi-suit-diamond::before {\n  content: \"\\f59c\";\n}\n\n.bi-suit-heart-fill::before {\n  content: \"\\f59d\";\n}\n\n.bi-suit-heart::before {\n  content: \"\\f59e\";\n}\n\n.bi-suit-spade-fill::before {\n  content: \"\\f59f\";\n}\n\n.bi-suit-spade::before {\n  content: \"\\f5a0\";\n}\n\n.bi-sun-fill::before {\n  content: \"\\f5a1\";\n}\n\n.bi-sun::before {\n  content: \"\\f5a2\";\n}\n\n.bi-sunglasses::before {\n  content: \"\\f5a3\";\n}\n\n.bi-sunrise-fill::before {\n  content: \"\\f5a4\";\n}\n\n.bi-sunrise::before {\n  content: \"\\f5a5\";\n}\n\n.bi-sunset-fill::before {\n  content: \"\\f5a6\";\n}\n\n.bi-sunset::before {\n  content: \"\\f5a7\";\n}\n\n.bi-symmetry-horizontal::before {\n  content: \"\\f5a8\";\n}\n\n.bi-symmetry-vertical::before {\n  content: \"\\f5a9\";\n}\n\n.bi-table::before {\n  content: \"\\f5aa\";\n}\n\n.bi-tablet-fill::before {\n  content: \"\\f5ab\";\n}\n\n.bi-tablet-landscape-fill::before {\n  content: \"\\f5ac\";\n}\n\n.bi-tablet-landscape::before {\n  content: \"\\f5ad\";\n}\n\n.bi-tablet::before {\n  content: \"\\f5ae\";\n}\n\n.bi-tag-fill::before {\n  content: \"\\f5af\";\n}\n\n.bi-tag::before {\n  content: \"\\f5b0\";\n}\n\n.bi-tags-fill::before {\n  content: \"\\f5b1\";\n}\n\n.bi-tags::before {\n  content: \"\\f5b2\";\n}\n\n.bi-telegram::before {\n  content: \"\\f5b3\";\n}\n\n.bi-telephone-fill::before {\n  content: \"\\f5b4\";\n}\n\n.bi-telephone-forward-fill::before {\n  content: \"\\f5b5\";\n}\n\n.bi-telephone-forward::before {\n  content: \"\\f5b6\";\n}\n\n.bi-telephone-inbound-fill::before {\n  content: \"\\f5b7\";\n}\n\n.bi-telephone-inbound::before {\n  content: \"\\f5b8\";\n}\n\n.bi-telephone-minus-fill::before {\n  content: \"\\f5b9\";\n}\n\n.bi-telephone-minus::before {\n  content: \"\\f5ba\";\n}\n\n.bi-telephone-outbound-fill::before {\n  content: \"\\f5bb\";\n}\n\n.bi-telephone-outbound::before {\n  content: \"\\f5bc\";\n}\n\n.bi-telephone-plus-fill::before {\n  content: \"\\f5bd\";\n}\n\n.bi-telephone-plus::before {\n  content: \"\\f5be\";\n}\n\n.bi-telephone-x-fill::before {\n  content: \"\\f5bf\";\n}\n\n.bi-telephone-x::before {\n  content: \"\\f5c0\";\n}\n\n.bi-telephone::before {\n  content: \"\\f5c1\";\n}\n\n.bi-terminal-fill::before {\n  content: \"\\f5c2\";\n}\n\n.bi-terminal::before {\n  content: \"\\f5c3\";\n}\n\n.bi-text-center::before {\n  content: \"\\f5c4\";\n}\n\n.bi-text-indent-left::before {\n  content: \"\\f5c5\";\n}\n\n.bi-text-indent-right::before {\n  content: \"\\f5c6\";\n}\n\n.bi-text-left::before {\n  content: \"\\f5c7\";\n}\n\n.bi-text-paragraph::before {\n  content: \"\\f5c8\";\n}\n\n.bi-text-right::before {\n  content: \"\\f5c9\";\n}\n\n.bi-textarea-resize::before {\n  content: \"\\f5ca\";\n}\n\n.bi-textarea-t::before {\n  content: \"\\f5cb\";\n}\n\n.bi-textarea::before {\n  content: \"\\f5cc\";\n}\n\n.bi-thermometer-half::before {\n  content: \"\\f5cd\";\n}\n\n.bi-thermometer-high::before {\n  content: \"\\f5ce\";\n}\n\n.bi-thermometer-low::before {\n  content: \"\\f5cf\";\n}\n\n.bi-thermometer-snow::before {\n  content: \"\\f5d0\";\n}\n\n.bi-thermometer-sun::before {\n  content: \"\\f5d1\";\n}\n\n.bi-thermometer::before {\n  content: \"\\f5d2\";\n}\n\n.bi-three-dots-vertical::before {\n  content: \"\\f5d3\";\n}\n\n.bi-three-dots::before {\n  content: \"\\f5d4\";\n}\n\n.bi-toggle-off::before {\n  content: \"\\f5d5\";\n}\n\n.bi-toggle-on::before {\n  content: \"\\f5d6\";\n}\n\n.bi-toggle2-off::before {\n  content: \"\\f5d7\";\n}\n\n.bi-toggle2-on::before {\n  content: \"\\f5d8\";\n}\n\n.bi-toggles::before {\n  content: \"\\f5d9\";\n}\n\n.bi-toggles2::before {\n  content: \"\\f5da\";\n}\n\n.bi-tools::before {\n  content: \"\\f5db\";\n}\n\n.bi-tornado::before {\n  content: \"\\f5dc\";\n}\n\n.bi-trash-fill::before {\n  content: \"\\f5dd\";\n}\n\n.bi-trash::before {\n  content: \"\\f5de\";\n}\n\n.bi-trash2-fill::before {\n  content: \"\\f5df\";\n}\n\n.bi-trash2::before {\n  content: \"\\f5e0\";\n}\n\n.bi-tree-fill::before {\n  content: \"\\f5e1\";\n}\n\n.bi-tree::before {\n  content: \"\\f5e2\";\n}\n\n.bi-triangle-fill::before {\n  content: \"\\f5e3\";\n}\n\n.bi-triangle-half::before {\n  content: \"\\f5e4\";\n}\n\n.bi-triangle::before {\n  content: \"\\f5e5\";\n}\n\n.bi-trophy-fill::before {\n  content: \"\\f5e6\";\n}\n\n.bi-trophy::before {\n  content: \"\\f5e7\";\n}\n\n.bi-tropical-storm::before {\n  content: \"\\f5e8\";\n}\n\n.bi-truck-flatbed::before {\n  content: \"\\f5e9\";\n}\n\n.bi-truck::before {\n  content: \"\\f5ea\";\n}\n\n.bi-tsunami::before {\n  content: \"\\f5eb\";\n}\n\n.bi-tv-fill::before {\n  content: \"\\f5ec\";\n}\n\n.bi-tv::before {\n  content: \"\\f5ed\";\n}\n\n.bi-twitch::before {\n  content: \"\\f5ee\";\n}\n\n.bi-twitter::before {\n  content: \"\\f5ef\";\n}\n\n.bi-type-bold::before {\n  content: \"\\f5f0\";\n}\n\n.bi-type-h1::before {\n  content: \"\\f5f1\";\n}\n\n.bi-type-h2::before {\n  content: \"\\f5f2\";\n}\n\n.bi-type-h3::before {\n  content: \"\\f5f3\";\n}\n\n.bi-type-italic::before {\n  content: \"\\f5f4\";\n}\n\n.bi-type-strikethrough::before {\n  content: \"\\f5f5\";\n}\n\n.bi-type-underline::before {\n  content: \"\\f5f6\";\n}\n\n.bi-type::before {\n  content: \"\\f5f7\";\n}\n\n.bi-ui-checks-grid::before {\n  content: \"\\f5f8\";\n}\n\n.bi-ui-checks::before {\n  content: \"\\f5f9\";\n}\n\n.bi-ui-radios-grid::before {\n  content: \"\\f5fa\";\n}\n\n.bi-ui-radios::before {\n  content: \"\\f5fb\";\n}\n\n.bi-umbrella-fill::before {\n  content: \"\\f5fc\";\n}\n\n.bi-umbrella::before {\n  content: \"\\f5fd\";\n}\n\n.bi-union::before {\n  content: \"\\f5fe\";\n}\n\n.bi-unlock-fill::before {\n  content: \"\\f5ff\";\n}\n\n.bi-unlock::before {\n  content: \"\\f600\";\n}\n\n.bi-upc-scan::before {\n  content: \"\\f601\";\n}\n\n.bi-upc::before {\n  content: \"\\f602\";\n}\n\n.bi-upload::before {\n  content: \"\\f603\";\n}\n\n.bi-vector-pen::before {\n  content: \"\\f604\";\n}\n\n.bi-view-list::before {\n  content: \"\\f605\";\n}\n\n.bi-view-stacked::before {\n  content: \"\\f606\";\n}\n\n.bi-vinyl-fill::before {\n  content: \"\\f607\";\n}\n\n.bi-vinyl::before {\n  content: \"\\f608\";\n}\n\n.bi-voicemail::before {\n  content: \"\\f609\";\n}\n\n.bi-volume-down-fill::before {\n  content: \"\\f60a\";\n}\n\n.bi-volume-down::before {\n  content: \"\\f60b\";\n}\n\n.bi-volume-mute-fill::before {\n  content: \"\\f60c\";\n}\n\n.bi-volume-mute::before {\n  content: \"\\f60d\";\n}\n\n.bi-volume-off-fill::before {\n  content: \"\\f60e\";\n}\n\n.bi-volume-off::before {\n  content: \"\\f60f\";\n}\n\n.bi-volume-up-fill::before {\n  content: \"\\f610\";\n}\n\n.bi-volume-up::before {\n  content: \"\\f611\";\n}\n\n.bi-vr::before {\n  content: \"\\f612\";\n}\n\n.bi-wallet-fill::before {\n  content: \"\\f613\";\n}\n\n.bi-wallet::before {\n  content: \"\\f614\";\n}\n\n.bi-wallet2::before {\n  content: \"\\f615\";\n}\n\n.bi-watch::before {\n  content: \"\\f616\";\n}\n\n.bi-water::before {\n  content: \"\\f617\";\n}\n\n.bi-whatsapp::before {\n  content: \"\\f618\";\n}\n\n.bi-wifi-1::before {\n  content: \"\\f619\";\n}\n\n.bi-wifi-2::before {\n  content: \"\\f61a\";\n}\n\n.bi-wifi-off::before {\n  content: \"\\f61b\";\n}\n\n.bi-wifi::before {\n  content: \"\\f61c\";\n}\n\n.bi-wind::before {\n  content: \"\\f61d\";\n}\n\n.bi-window-dock::before {\n  content: \"\\f61e\";\n}\n\n.bi-window-sidebar::before {\n  content: \"\\f61f\";\n}\n\n.bi-window::before {\n  content: \"\\f620\";\n}\n\n.bi-wrench::before {\n  content: \"\\f621\";\n}\n\n.bi-x-circle-fill::before {\n  content: \"\\f622\";\n}\n\n.bi-x-circle::before {\n  content: \"\\f623\";\n}\n\n.bi-x-diamond-fill::before {\n  content: \"\\f624\";\n}\n\n.bi-x-diamond::before {\n  content: \"\\f625\";\n}\n\n.bi-x-octagon-fill::before {\n  content: \"\\f626\";\n}\n\n.bi-x-octagon::before {\n  content: \"\\f627\";\n}\n\n.bi-x-square-fill::before {\n  content: \"\\f628\";\n}\n\n.bi-x-square::before {\n  content: \"\\f629\";\n}\n\n.bi-x::before {\n  content: \"\\f62a\";\n}\n\n.bi-youtube::before {\n  content: \"\\f62b\";\n}\n\n.bi-zoom-in::before {\n  content: \"\\f62c\";\n}\n\n.bi-zoom-out::before {\n  content: \"\\f62d\";\n}\n\n.bi-bank::before {\n  content: \"\\f62e\";\n}\n\n.bi-bank2::before {\n  content: \"\\f62f\";\n}\n\n.bi-bell-slash-fill::before {\n  content: \"\\f630\";\n}\n\n.bi-bell-slash::before {\n  content: \"\\f631\";\n}\n\n.bi-cash-coin::before {\n  content: \"\\f632\";\n}\n\n.bi-check-lg::before {\n  content: \"\\f633\";\n}\n\n.bi-coin::before {\n  content: \"\\f634\";\n}\n\n.bi-currency-bitcoin::before {\n  content: \"\\f635\";\n}\n\n.bi-currency-dollar::before {\n  content: \"\\f636\";\n}\n\n.bi-currency-euro::before {\n  content: \"\\f637\";\n}\n\n.bi-currency-exchange::before {\n  content: \"\\f638\";\n}\n\n.bi-currency-pound::before {\n  content: \"\\f639\";\n}\n\n.bi-currency-yen::before {\n  content: \"\\f63a\";\n}\n\n.bi-dash-lg::before {\n  content: \"\\f63b\";\n}\n\n.bi-exclamation-lg::before {\n  content: \"\\f63c\";\n}\n\n.bi-file-earmark-pdf-fill::before {\n  content: \"\\f63d\";\n}\n\n.bi-file-earmark-pdf::before {\n  content: \"\\f63e\";\n}\n\n.bi-file-pdf-fill::before {\n  content: \"\\f63f\";\n}\n\n.bi-file-pdf::before {\n  content: \"\\f640\";\n}\n\n.bi-gender-ambiguous::before {\n  content: \"\\f641\";\n}\n\n.bi-gender-female::before {\n  content: \"\\f642\";\n}\n\n.bi-gender-male::before {\n  content: \"\\f643\";\n}\n\n.bi-gender-trans::before {\n  content: \"\\f644\";\n}\n\n.bi-headset-vr::before {\n  content: \"\\f645\";\n}\n\n.bi-info-lg::before {\n  content: \"\\f646\";\n}\n\n.bi-mastodon::before {\n  content: \"\\f647\";\n}\n\n.bi-messenger::before {\n  content: \"\\f648\";\n}\n\n.bi-piggy-bank-fill::before {\n  content: \"\\f649\";\n}\n\n.bi-piggy-bank::before {\n  content: \"\\f64a\";\n}\n\n.bi-pin-map-fill::before {\n  content: \"\\f64b\";\n}\n\n.bi-pin-map::before {\n  content: \"\\f64c\";\n}\n\n.bi-plus-lg::before {\n  content: \"\\f64d\";\n}\n\n.bi-question-lg::before {\n  content: \"\\f64e\";\n}\n\n.bi-recycle::before {\n  content: \"\\f64f\";\n}\n\n.bi-reddit::before {\n  content: \"\\f650\";\n}\n\n.bi-safe-fill::before {\n  content: \"\\f651\";\n}\n\n.bi-safe2-fill::before {\n  content: \"\\f652\";\n}\n\n.bi-safe2::before {\n  content: \"\\f653\";\n}\n\n.bi-sd-card-fill::before {\n  content: \"\\f654\";\n}\n\n.bi-sd-card::before {\n  content: \"\\f655\";\n}\n\n.bi-skype::before {\n  content: \"\\f656\";\n}\n\n.bi-slash-lg::before {\n  content: \"\\f657\";\n}\n\n.bi-translate::before {\n  content: \"\\f658\";\n}\n\n.bi-x-lg::before {\n  content: \"\\f659\";\n}\n\n.bi-safe::before {\n  content: \"\\f65a\";\n}","/*\nTemplate Name: Shreyu - Responsive Bootstrap 5 Admin Dashboard\nAuthor: CoderThemes\nVersion: 2.0.0\nWebsite: https://coderthemes.com/\nContact: support@coderthemes.com\nFile: Custom Bootstrap Css File\n*/\n\n//Core files\n@import \"../../../node_modules/bootstrap/scss/functions\";\n@import \"../../../node_modules/bootstrap/scss/variables\";\n@import \"config/variables\";\n@import \"../../../node_modules/bootstrap/scss/bootstrap\";\n\n//Components\n@import \"custom/components/accordions\";\n@import \"custom/components/alerts\";\n@import \"custom/components/badge\";\n@import \"custom/components/backgrounds\";\n@import \"custom/components/breadcrumb\";\n@import \"custom/components/buttons\";\n@import \"custom/components/card\";\n@import \"custom/components/dropdown\";\n@import \"custom/components/forms\";\n@import \"custom/components/modal\";\n@import \"custom/components/nav\";\n@import \"custom/components/pagination\";\n@import \"custom/components/popover\";\n@import \"custom/components/progress\";\n@import \"custom/components/reboot\";\n@import \"custom/components/tables\";\n@import \"custom/components/type\";","/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n// scss-docs-start import-stack\n// Configuration\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"utilities\";\n\n// Layout & components\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"containers\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"accordion\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"alert\";\n@import \"progress\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"offcanvas\";\n@import \"placeholders\";\n\n// Helpers\n@import \"helpers\";\n\n// Utilities\n@import \"utilities/api\";\n// scss-docs-end import-stack\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$variable-prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$variable-prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$variable-prefix}white-rgb: #{to-rgb($white)};\n  --#{$variable-prefix}black-rgb: #{to-rgb($black)};\n  --#{$variable-prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$variable-prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$variable-prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$variable-prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$variable-prefix}gradient: #{$gradient};\n\n  // Root and body\n  // stylelint-disable custom-property-empty-line-before\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$variable-prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$variable-prefix}body-font-family: #{$font-family-base};\n  --#{$variable-prefix}body-font-size: #{$font-size-base};\n  --#{$variable-prefix}body-font-weight: #{$font-weight-base};\n  --#{$variable-prefix}body-line-height: #{$line-height-base};\n  --#{$variable-prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$variable-prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$variable-prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n  // stylelint-enable custom-property-empty-line-before\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    font-size: var(--#{$variable-prefix}root-font-size);\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$variable-prefix}body-font-family);\n  @include font-size(var(--#{$variable-prefix}body-font-size));\n  font-weight: var(--#{$variable-prefix}body-font-weight);\n  line-height: var(--#{$variable-prefix}body-line-height);\n  color: var(--#{$variable-prefix}body-color);\n  text-align: var(--#{$variable-prefix}body-text-align);\n  background-color: var(--#{$variable-prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n// 2. Set correct height and prevent the `size` attribute to make the `hr` look like an input field\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  background-color: currentColor;\n  border: 0;\n  opacity: $hr-opacity;\n}\n\nhr:not([size]) {\n  height: $hr-height; // 2\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-bs-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-bs-original-title] { // 1\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  text-decoration-skip-ink: none; // 4\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n  direction: ltr #{\"/* rtl:ignore */\"};\n  unicode-bidi: bidi-override;\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow in Chrome from inputs built with datalists.\n// See https://stackoverflow.com/a/54997118\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// Inherit font family and line height for file input buttons\n\n::file-selector-button {\n  font: inherit;\n}\n\n// 1. Change font properties to `inherit`\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::-webkit-file-upload-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// Variables\n//\n// custom-variables\n//\n\n\n//Background left-sidebar\n$bg-leftbar:                                      #ffffff;\n$bg-leftbar-dark:                                 #323742;\n\n// Leftbar width\n$leftbar-width:                                     250px;\n$leftbar-width-condensed:                           70px;\n\n// Border-color\n$border-color:                                    #ebeef5;\n$border-dark-color:                               #424e5a;\n\n// Small Leftbar Width\n$leftbar-width-sm:                                  160px;\n\n// Boxed layout width\n$boxed-layout-width:                                1300px;\n\n// Compact sidebar\n$twocolumn-sidebar-width:                           220px;\n$twocolumn-sidebar-iconview-width:                  70px;\n$twocolumn-sidebar-bg:                            #ffffff;\n$twocolumn-sidebar-iconview-bg:                   #5369f8;\n\n// Dark leftbar menu color\n$menu-item-color-dark:                            #9097a7;\n$menu-item-hover-color-dark:                      #c8cddc;\n$menu-item-active-color-dark:                     #ffffff;\n\n//Menu item\n$menu-item:                                       #4b4b5a;\n$menu-item-hover:                                 #5369f8;\n$menu-item-active:                                #5369f8;\n$menu-sub-item-active:                            #5369f8;\n$menu-item-size:                                    0.95rem;\n$menu-sub-item-size:                                0.875rem;\n\n// Horizontal Menu Item\n$hori-menu-item-color:                              #6e7488;\n\n//Rightbar Width\n$rightbar-width:                                    260px;\n$rightbar-bg:                                     #ffffff;\n\n//Topbar Background\n$bg-topbar-light:                                 #ffffff;\n$bg-topbar-dark:                                  #323742;\n\n// Leftbar item shadow (Condensed item)\n$box-shadow-condensed:                              3px 5px 10px 0 rgba(154,161,171,.2); \n\n// Topnav Height (Horizontal)\n$topnav-height:                                     55px;\n\n// Topbar Height\n$topbar-height:                                     70px;\n\n// Horizontal Layout\n$horizontal-layout-width:                           90%;\n\n// Body minimum height\n$body-min-height:                                   1750px;\n\n// Secondary font\n// $font-family-secondary:                             'IBM Plex Sans', sans-serif;\n$font-family-secondary:                             'Noto Sans', 'Noto Sans Fallback', sans-serif;\n\n// Font weight\n$font-weight-medium:                                500;\n$font-weight-semibold:                              600;\n\n// Dropdown Large\n$dropdown-lg-width:                                 320px;\n\n// Logo Display\n$logo-dark-display:                                 none;\n$logo-light-display:                                block;\n\n// Logo Display - Auth Pages\n$logo-auth-dark-display:                            block;\n$logo-auth-light-display:                           none;\n\n// User authentication Background\n$auth-img-bg:                                     url(\"../images/bg-auth.jpg\");\n\n// Apex chart\n$apex-grid-color:                                 #f9f9fd;\n\n// Text-color (h1 to h6)\n$text-color-h:                                    #343a40;\n\n// Card overlay \n$card-overlay-color:                              #3e4852;\n$card-overlay-bg:                                   rgba(#ffffff, 0.8);\n\n// Input light gray\n$input-light-bg:                                  #f3f7f9;\n\n// button\n$btn-soft-bg-opacity:  0.15;\n\n// Chat widget\n$chat-primary-user-bg:            #fef5e4;\n$chat-secondary-user-bg:          #f1f3fa;\n\n// landing section bg\n$section-bg:                     #ffffff;\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff;\n$gray-100: #f8f9fa;\n$gray-200: #f6f6f7;\n$gray-300: #e2e7f1;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #6c757d;\n$gray-700: #4B4B5A;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black:    #000;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #5369f8;\n$indigo:  #564ab1;\n$purple:  #6f42c1;\n$pink:    #e83e8c;\n$red:     #ff5c75;\n$orange:  #f77e53;\n$yellow:  #ffbe0b;\n$green:   #43d39e;\n$teal:    #1ce1ac;\n$cyan:    #25c2e3;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue;\n$secondary:     $gray-600;\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;\n$danger:        $red;\n$light:         $gray-100;\n$dark:          $gray-800;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   1.8;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $gray-800;\n$color-contrast-light:     $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n);\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n);\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                false;\n$enable-rounded:              true;\n$enable-shadows:              false;\n$enable-gradients:            false;\n$enable-transitions:          true;\n$enable-reduced-motion:       true;\n$enable-smooth-scroll:        true;\n$enable-grid-classes:         true;\n$enable-cssgrid:              false;\n$enable-button-pointers:      true;\n$enable-rfs:                  true;\n$enable-validation-icons:     true;\n$enable-negative-margins:     true;\n$enable-deprecation-messages: true;\n$enable-important-utilities:  true;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs-;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1.5rem;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n);\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   #f3f4f7;\n$body-color:                $gray-700;\n$body-text-align:           null;\n\n// Utilities maps\n//\n// Extends the default `$theme-colors` maps to help create our utilities.\n\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\n// scss-docs-start utilities-colors\n$utilities-colors: $theme-colors-rgb;\n// scss-docs-end utilities-colors\n\n// scss-docs-start utilities-text-colors\n$utilities-text: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-color)\n  )\n);\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\");\n// scss-docs-end utilities-text-colors\n\n// scss-docs-start utilities-bg-colors\n$utilities-bg: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-bg)\n  )\n);\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\");\n// scss-docs-end utilities-bg-colors\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary;\n$link-decoration:                         none;\n$link-shade-percentage:                   15%;\n$link-hover-color:                        darken($link-color, $link-shade-percentage);\n$link-hover-decoration:                   none;\n\n$stretched-link-pseudo-element:           after;\n$stretched-link-z-index:                  1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           24px;\n$grid-row-columns:            6;\n\n$gutters: $spacers;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n);\n\n$border-color:                lighten($gray-300,2.5%);\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem;\n$border-radius-sm:            .2rem;\n$border-radius-lg:            .3rem;\n$border-radius-pill:          50rem;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15);\n$box-shadow-sm:               0 .05rem .01rem rgba($gray-700, .075);\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175);\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white;\n$component-active-bg:         $primary;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out;\n$transition-fade:             opacity .15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease;\n$transition-collapse-width:   width .35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n// $font-family-sans-serif:      'IBM Plex Sans', sans-serif;\n$font-family-sans-serif:      'Noto Sans', 'Noto Sans Fallback', sans-serif;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n// stylelint-enable value-keyword-case\n$font-family-base:            $font-family-sans-serif;\n$font-family-code:            var(--#{$variable-prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null;\n$font-size-base:              0.875rem; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .9;\n$font-size-lg:                $font-size-base * 1.25;\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-bold:            700;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n\n$line-height-base:            1.5;\n$line-height-sm:              1.5;\n$line-height-lg:              1.5;\n\n$h1-font-size:                2.25rem;\n$h2-font-size:                1.875rem;\n$h3-font-size:                1.5rem;\n$h4-font-size:                1.125rem;\n$h5-font-size:                0.9375rem;\n$h6-font-size:                0.9rem;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer;\n$headings-font-family:        null;\n$headings-font-style:         null;\n$headings-font-weight:        500;\n$headings-line-height:        1.1;\n$headings-color:              null;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n);\n\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             .75rem;\n\n$sub-sup-font-size:           .75em;\n\n$text-muted:                  $gray-600;\n\n$initialism-font-size:        $small-font-size;\n\n$blockquote-margin-y:         $spacer;\n$blockquote-font-size:        $font-size-base * 1.25;\n$blockquote-footer-color:     $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y:                 $spacer;\n$hr-color:                    lighten($gray-300,2.5%);\n$hr-height:                   $border-width;\n$hr-opacity:                  1;\n\n$legend-margin-bottom:        .5rem;\n$legend-font-size:            1.5rem;\n$legend-font-weight:          null;\n\n$mark-padding:                .2em;\n\n$dt-font-weight:              $font-weight-bold;\n\n$nested-kbd-font-weight:      $font-weight-bold;\n\n$list-inline-padding:         6px;\n\n$mark-bg:                     #fcf8e3;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .85rem;\n$table-cell-padding-x:        .85rem;\n$table-cell-padding-y-sm:     .5rem;\n$table-cell-padding-x-sm:     .5rem;\n\n$table-cell-vertical-align:   top;\n\n$table-color:                 $body-color;\n$table-bg:                    transparent;\n$table-accent-bg:             transparent;\n\n$table-th-font-weight:        null;\n\n$table-striped-color:         $table-color;\n$table-striped-bg-factor:     1;\n$table-striped-bg:            rgba($gray-100, $table-striped-bg-factor);\n\n$table-active-color:          $table-color;\n$table-active-bg-factor:      1;\n$table-active-bg:             rgba($gray-100, $table-active-bg-factor);\n\n$table-hover-color:           $table-color;\n$table-hover-bg-factor:       1;\n$table-hover-bg:              rgba($gray-100, $table-hover-bg-factor);\n\n$table-border-factor:         .1;\n$table-border-width:          $border-width;\n$table-border-color:          $gray-300;\n\n$table-striped-order:         odd;\n\n$table-group-separator-color: $gray-300;\n\n$table-caption-color:         $text-muted;\n\n$table-bg-scale:              -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $gray-100,\n  \"dark\":       $dark,\n);\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .45rem;\n$input-btn-padding-x:         .90rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:         0;\n$input-btn-focus-color-opacity: .25;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity);\n$input-btn-focus-blur:          0;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm:      .28rem;\n$input-btn-padding-x-sm:      .8rem;\n$input-btn-font-size-sm:      $font-size-sm;\n\n$input-btn-padding-y-lg:      .5rem;\n$input-btn-padding-x-lg:      1rem;\n$input-btn-font-size-lg:      $font-size-lg;\n\n$input-btn-border-width:      $border-width;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              0px 2px 6px 0px;\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\n\n$btn-link-color:              $link-color;\n$btn-link-hover-color:        $link-hover-color;\n$btn-link-disabled-color:     $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius;\n$btn-border-radius-sm:        $border-radius;\n$btn-border-radius-lg:        $border-radius;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$btn-hover-bg-shade-amount:       15%;\n$btn-hover-bg-tint-amount:        15%;\n$btn-hover-border-shade-amount:   20%;\n$btn-hover-border-tint-amount:    10%;\n$btn-active-bg-shade-amount:      20%;\n$btn-active-bg-tint-amount:       20%;\n$btn-active-border-shade-amount:  25%;\n$btn-active-border-tint-amount:   10%;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem;\n$form-text-font-size:                   $small-font-size;\n$form-text-font-style:                  null;\n$form-text-font-weight:                 null;\n$form-text-color:                       $text-muted;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem;\n$form-label-font-size:                  null;\n$form-label-font-style:                 null;\n$form-label-font-weight:                null;\n$form-label-color:                      null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n\n$input-bg:                              $white;\n$input-disabled-bg:                     $white;\n$input-disabled-border-color:           null;\n\n$input-color:                           $body-color;\n$input-border-color:                    $gray-400;\n$input-border-width:                    $input-btn-border-width;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075);\n\n$input-border-radius:                   $border-radius;\n$input-border-radius-sm:                $border-radius-sm;\n$input-border-radius-lg:                $border-radius-lg;\n\n$input-focus-bg:                        $input-bg;\n$input-focus-border-color:              darken($input-border-color,10%);\n$input-focus-color:                     $input-color;\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                none;\n\n$input-placeholder-color:               $gray-500;\n$input-plaintext-color:                 $body-color;\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-color-width:                      3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1rem;\n$form-check-min-height:                   $font-size-base * $line-height-base;\n$form-check-padding-start:                $form-check-input-width + .5rem;\n$form-check-margin-bottom:                .125rem;\n$form-check-label-color:                  null;\n$form-check-label-cursor:                 null;\n$form-check-transition:                   null;\n\n$form-check-input-active-filter:          brightness(90%);\n\n$form-check-input-bg:                     $input-bg;\n$form-check-input-border:                 1px solid rgba($black, .25);\n$form-check-input-border-radius:          .25em;\n$form-check-radio-border-radius:          50%;\n$form-check-input-focus-border:           $input-focus-border-color;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow;\n\n$form-check-input-checked-color:          $component-active-color;\n$form-check-input-checked-bg-color:       $component-active-bg;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color:          $component-active-color;\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity:        .5;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\n\n$form-check-inline-margin-end:    1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25);\n$form-switch-width:               2em;\n$form-switch-padding-start:       $form-switch-width + .5em;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius:       $form-switch-width;\n$form-switch-transition:          background-position .15s ease-in-out;\n\n$form-switch-focus-color:         $input-focus-border-color;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color:       $component-active-color;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y;\n$input-group-addon-padding-x:           $input-padding-x;\n$input-group-addon-font-weight:         $input-font-weight;\n$input-group-addon-color:               $input-color;\n$input-group-addon-bg:                  $gray-200;\n$input-group-addon-border-color:        $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y;\n$form-select-padding-x:             $input-padding-x;\n$form-select-font-family:           $input-font-family;\n$form-select-font-size:             $input-font-size;\n$form-select-indicator-padding:     $form-select-padding-x * 3; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight;\n$form-select-line-height:           $input-line-height;\n$form-select-color:                 $input-color;\n$form-select-bg:                    $input-bg;\n$form-select-disabled-color:        $gray-600;\n$form-select-disabled-bg:           $gray-200;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position:           right $form-select-padding-x center;\n$form-select-bg-size:               14px 10px; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width:        $input-border-width;\n$form-select-border-color:        $input-border-color;\n$form-select-border-radius:       $border-radius;\n$form-select-box-shadow:          $box-shadow-inset;\n\n$form-select-focus-border-color:  $input-focus-border-color;\n$form-select-focus-width:         $input-focus-width;\n$form-select-focus-box-shadow:    none;\n\n$form-select-padding-y-sm:        $input-padding-y-sm;\n$form-select-padding-x-sm:        $input-padding-x-sm;\n$form-select-font-size-sm:        $input-font-size-sm;\n$form-select-border-radius-sm:    $input-border-radius-sm;\n\n$form-select-padding-y-lg:        $input-padding-y-lg;\n$form-select-padding-x-lg:        $input-padding-x-lg;\n$form-select-font-size-lg:        $input-font-size-lg;\n$form-select-border-radius-lg:    $input-border-radius-lg;\n\n$form-select-transition:          $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100%;\n$form-range-track-height:         .5rem;\n$form-range-track-cursor:         pointer;\n$form-range-track-bg:             $gray-300;\n$form-range-track-border-radius:  1rem;\n$form-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1);\n\n$form-range-thumb-width:                   1rem;\n$form-range-thumb-height:                  $form-range-thumb-width;\n$form-range-thumb-bg:                      $component-active-bg;\n$form-range-thumb-border:                  0;\n$form-range-thumb-border-radius:           1rem;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg:             $gray-500;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color;\n$form-file-button-bg:             $input-group-addon-bg;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%);\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border);\n$form-floating-line-height:       1.25;\n$form-floating-padding-x:         $input-padding-x;\n$form-floating-padding-y:         1rem;\n$form-floating-input-padding-t:   1.625rem;\n$form-floating-input-padding-b:   .625rem;\n$form-floating-label-opacity:     .65;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $small-font-size;\n$form-feedback-font-style:          $form-text-font-style;\n$form-feedback-valid-color:         $success;\n$form-feedback-invalid-color:       $danger;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-offcanvas-backdrop:         1040;\n$zindex-offcanvas:                  1045;\n$zindex-modal-backdrop:             1050;\n$zindex-modal:                      1055;\n$zindex-popover:                    1070;\n$zindex-tooltip:                    1080;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-font-size:                null;\n$nav-link-font-weight:              null;\n$nav-link-color:                    $link-color;\n$nav-link-hover-color:              $link-hover-color;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n$nav-link-disabled-color:           $gray-600;\n\n$nav-tabs-border-color:             $gray-300;\n$nav-tabs-border-width:             0px;\n$nav-tabs-border-radius:            $border-radius;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color;\n$nav-tabs-link-active-color:        $gray-700;\n$nav-tabs-link-active-bg:           $white;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius:           $border-radius;\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5;\n$navbar-padding-x:                  $spacer;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5;\n$navbar-brand-margin-end:           1rem;\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n$navbar-toggler-focus-width:        $btn-focus-width;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55);\n$navbar-dark-hover-color:           rgba($white, .75);\n$navbar-dark-active-color:          $white;\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color:  rgba($white, .1);\n\n$navbar-light-color:                rgba($black, .55);\n$navbar-light-hover-color:          rgba($black, .7);\n$navbar-light-active-color:         $primary;\n$navbar-light-disabled-color:       rgba($black, .3);\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, .1);\n\n$navbar-light-brand-color:                $navbar-light-active-color;\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem;\n$dropdown-padding-x:                0;\n$dropdown-padding-y:                .25rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    $body-color;\n$dropdown-bg:                       $white;\n$dropdown-border-color:             darken($light, 3%);\n$dropdown-border-radius:            $border-radius;\n$dropdown-border-width:             0;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\n$dropdown-divider-bg:               $gray-300;\n$dropdown-divider-margin-y:         $spacer * .5;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175);\n\n$dropdown-link-color:               $body-color;\n$dropdown-link-hover-color:         $headings-color;\n$dropdown-link-hover-bg:            $gray-100;\n\n$dropdown-link-active-color:        $dark;\n$dropdown-link-active-bg:           $gray-100;\n\n$dropdown-link-disabled-color:      $gray-600;\n\n$dropdown-item-padding-y:           .375rem;\n$dropdown-item-padding-x:           1.2rem;\n\n$dropdown-header-color:             inherit;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300;\n$dropdown-dark-bg:                  $gray-800;\n$dropdown-dark-border-color:        $dropdown-border-color;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\n$dropdown-dark-box-shadow:          null;\n$dropdown-dark-link-color:          $dropdown-dark-color;\n$dropdown-dark-link-hover-color:    $white;\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\n$dropdown-dark-link-active-color:   $dropdown-link-active-color;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg;\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color:        $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .5rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .75rem;\n$pagination-padding-x-lg:           1.5rem;\n\n$pagination-color:                  $dark;\n$pagination-bg:                     $white;\n$pagination-border-width:           $border-width;\n$pagination-border-radius:          $border-radius;\n$pagination-margin-start:           -$pagination-border-width;\n$pagination-border-color:           $gray-300;\n\n$pagination-focus-color:            $link-hover-color;\n$pagination-focus-bg:               $gray-200;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            $dark;\n$pagination-hover-bg:               $gray-200;\n$pagination-hover-border-color:     $gray-300;\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $pagination-active-bg;\n\n$pagination-disabled-color:         $gray-600;\n$pagination-disabled-bg:            $white;\n$pagination-disabled-border-color:  $gray-300;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$pagination-border-radius-sm:       $border-radius-sm;\n$pagination-border-radius-lg:       $border-radius-lg;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5;\n$placeholder-opacity-min:           .2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     1.25rem;\n$card-spacer-x:                     1.25rem;\n$card-title-spacer-y:               $spacer * .5;\n$card-border-width:                 1px;\n$card-border-color:                 $gray-300;\n$card-border-radius:                .25rem;\n$card-box-shadow:                   null;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y:                1rem;\n$card-cap-padding-x:                $card-spacer-x;\n$card-cap-bg:                       lighten($gray-300, 5%);\n$card-cap-color:                    null;\n$card-height:                       null;\n$card-color:                        null;\n$card-bg:                           $white;\n$card-img-overlay-padding:          1.25rem;\n$card-group-margin:                 $grid-gutter-width * .5;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem;\n$accordion-padding-x:                     1.25rem;\n$accordion-color:                         $body-color;\n$accordion-bg:                            $body-bg;\n$accordion-border-width:                  $border-width;\n$accordion-border-color:                  rgba($black, .125);\n$accordion-border-radius:                 $border-radius;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\n\n$accordion-body-padding-y:                $accordion-padding-y;\n$accordion-body-padding-x:                $accordion-padding-x;\n\n$accordion-button-padding-y:              $accordion-padding-y;\n$accordion-button-padding-x:              $accordion-padding-x;\n$accordion-button-color:                  $accordion-color;\n$accordion-button-bg:                     $accordion-bg;\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%);\n$accordion-button-active-color:           shade-color($primary, 10%);\n\n$accordion-button-focus-border-color:     $input-focus-border-color;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow;\n\n$accordion-icon-width:                    1.25rem;\n$accordion-icon-color:                    $accordion-color;\n$accordion-icon-active-color:             $accordion-button-active-color;\n$accordion-icon-transition:               transform .2s ease-in-out;\n$accordion-icon-transform:                rotate(-180deg);\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-base;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     $white;\n$tooltip-bg:                        $black;\n$tooltip-border-radius:             .2rem;\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 .4rem;\n$tooltip-padding-x:                 .8rem;\n$tooltip-margin:                    0;\n\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n$tooltip-arrow-color:               $tooltip-bg;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   $line-height-base;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm;\n$popover-bg:                        $white;\n$popover-max-width:                 276px;\n$popover-border-width:              $border-width;\n$popover-border-color:              $gray-300;\n$popover-border-radius:             $border-radius;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2);\n\n$popover-header-bg:                 $gray-100;\n$popover-header-color:              $headings-color;\n$popover-header-padding-y:          .7rem;\n$popover-header-padding-x:          .8rem;\n\n$popover-body-color:                $body-color;\n$popover-body-padding-y:            $popover-header-padding-y;\n$popover-body-padding-x:            $popover-header-padding-x;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n$popover-arrow-color:               $popover-bg;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05);\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .25rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       null;\n$toast-background-color:            rgba($white, .85);\n$toast-border-width:                1px;\n$toast-border-color:                rgba(0, 0, 0, .1);\n$toast-border-radius:               .25rem;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1);\n$toast-spacing:                     $container-padding-x;\n\n$toast-header-color:                $gray-600;\n$toast-header-background-color:     rgba($white, .85);\n$toast-header-border-color:         rgba(0, 0, 0, .05);\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   75%;\n$badge-font-weight:                 $font-weight-bold;\n$badge-color:                       $white;\n$badge-padding-y:                   .25em;\n$badge-padding-x:                   .4em;\n$badge-border-radius:               $border-radius;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               1rem;\n\n$modal-footer-margin-between:       .5rem;\n\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  $white;\n$modal-content-border-color:        transparent;\n$modal-content-border-width:        0;\n$modal-content-border-radius:       .2rem;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5);\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5);\n\n$modal-backdrop-bg:                 $gray-900;\n$modal-backdrop-opacity:            .5;\n$modal-header-border-color:         $border-color;\n$modal-footer-border-color:         $modal-header-border-color;\n$modal-header-border-width:         $modal-content-border-width;\n$modal-footer-border-width:         $modal-header-border-width;\n$modal-header-padding-y:            $modal-inner-padding;\n$modal-header-padding-x:            $modal-inner-padding;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-sm:                          300px;\n$modal-md:                          500px;\n$modal-lg:                          800px;\n$modal-xl:                          1140px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(1.02);\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               .75rem;\n$alert-padding-x:               1.25rem;\n$alert-margin-bottom:           1rem;\n$alert-border-radius:           $border-radius-lg;\n$alert-link-font-weight:        $font-weight-bold;\n$alert-border-width:            $border-width;\n$alert-bg-scale:                -80%;\n$alert-border-scale:            -72%;\n$alert-color-scale:             40%;\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   .75rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       lighten($gray-300, 5.5%);\n$progress-border-radius:            $border-radius;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1);\n$progress-bar-color:                $white;\n$progress-bar-bg:                   $primary;\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  null;\n$list-group-bg:                     $white;\n$list-group-border-color:           rgba($black, .125);\n$list-group-border-width:           $border-width;\n$list-group-border-radius:          $border-radius;\n\n$list-group-item-padding-y:         .75rem;\n$list-group-item-padding-x:         1.25rem;\n$list-group-item-bg-scale:          -80%;\n$list-group-item-color-scale:       40%;\n\n$list-group-hover-bg:               $gray-100;\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         $gray-600;\n$list-group-disabled-bg:            $list-group-bg;\n\n$list-group-action-color:           $gray-700;\n$list-group-action-hover-color:     $list-group-action-color;\n\n$list-group-action-active-color:    $body-color;\n$list-group-action-active-bg:       $gray-200;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      $body-bg;\n$thumbnail-border-width:            $border-width;\n$thumbnail-border-color:            $gray-300;\n$thumbnail-border-radius:           $border-radius;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075);\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size;\n$figure-caption-color:              $gray-600;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null;\n$breadcrumb-padding-y:              $spacer * .67;\n$breadcrumb-padding-x:              0;\n$breadcrumb-item-padding-x:         .5rem;\n$breadcrumb-margin-bottom:          1rem;\n$breadcrumb-bg:                     transparent;\n$breadcrumb-divider-color:          $gray-500;\n$breadcrumb-active-color:           $gray-600;\n$breadcrumb-divider:                quote(\"/\");\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\n$breadcrumb-border-radius:          $border-radius;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white;\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-opacity:         .5;\n$carousel-indicator-active-bg:       $white;\n$carousel-indicator-active-opacity:  1;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             $white;\n$carousel-caption-padding-y:         1.25rem;\n$carousel-caption-spacer:            1.25rem;\n\n$carousel-control-icon-width:        20px;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black;\n$carousel-dark-caption-color:        $black;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem;\n$spinner-height:          $spinner-width;\n$spinner-vertical-align:  -.125em;\n$spinner-border-width:    .25em;\n$spinner-animation-speed: .75s;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em;\n$btn-close-height:           $btn-close-width;\n$btn-close-padding-x:        .25em;\n$btn-close-padding-y:        $btn-close-padding-x;\n$btn-close-color:            $black;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow;\n$btn-close-opacity:          .5;\n$btn-close-hover-opacity:    .75;\n$btn-close-focus-opacity:    1;\n$btn-close-disabled-opacity: .25;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding;\n$offcanvas-padding-x:               $modal-inner-padding;\n$offcanvas-horizontal-width:        400px;\n$offcanvas-vertical-height:         30vh;\n$offcanvas-transition-duration:     .3s;\n$offcanvas-border-color:            $modal-content-border-color;\n$offcanvas-border-width:            $modal-content-border-width;\n$offcanvas-title-line-height:       $modal-title-line-height;\n$offcanvas-bg-color:                $modal-content-bg;\n$offcanvas-color:                   $modal-content-color;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    87.5%;\n$code-color:                        $pink;\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         $white;\n$kbd-bg:                            $gray-900;\n\n$pre-color:                         $gray-900;","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  width: 100%;\n  padding-right: var(--#{$variable-prefix}gutter-x, #{$gutter});\n  padding-left: var(--#{$variable-prefix}gutter-x, #{$gutter});\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$variable-prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$variable-prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$variable-prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$variable-prefix}gutter-x: #{$gutter};\n  --#{$variable-prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$variable-prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$variable-prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$variable-prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$variable-prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$variable-prefix}table-bg: #{$table-bg};\n  --#{$variable-prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$variable-prefix}table-striped-color: #{$table-striped-color};\n  --#{$variable-prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$variable-prefix}table-active-color: #{$table-active-color};\n  --#{$variable-prefix}table-active-bg: #{$table-active-bg};\n  --#{$variable-prefix}table-hover-color: #{$table-hover-color};\n  --#{$variable-prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  vertical-align: $table-cell-vertical-align;\n  border-color: $table-border-color;\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$variable-prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$variable-prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n\n  // Highlight border color between thead, tbody and tfoot.\n  > :not(:first-child) {\n    border-top: (2 * $table-border-width) solid $table-group-separator-color;\n  }\n}\n\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-striped-bg);\n    color: var(--#{$variable-prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-active-bg);\n  color: var(--#{$variable-prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-hover-bg);\n    color: var(--#{$variable-prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n\n    --#{$variable-prefix}table-bg: #{$background};\n    --#{$variable-prefix}table-striped-bg: #{$striped-bg};\n    --#{$variable-prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$variable-prefix}table-active-bg: #{$active-bg};\n    --#{$variable-prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$variable-prefix}table-hover-bg: #{$hover-bg};\n    --#{$variable-prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: $color;\n    border-color: mix($color, $background, percentage($table-border-factor));\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: auto; // Override fixed browser height\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$variable-prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  // stylelint-disable-next-line property-no-vendor-prefix\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$variable-prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  // stylelint-disable no-duplicate-selectors\n  > .form-control {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // stylelint-enable no-duplicate-selectors\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus {\n    z-index: 3;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 3) {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 4) {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group .form-control,\n  .input-group .form-select {\n    @include form-validation-state-selector($state) {\n      @if $state == \"valid\" {\n        z-index: 1;\n      } @else if $state == \"invalid\" {\n        z-index: 2;\n      }\n      &:focus {\n        z-index: 3;\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  line-height: $btn-line-height;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-border-radius);\n  @include transition($btn-transition);\n\n  &:hover {\n    color: $body-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active {\n    @include box-shadow($btn-active-box-shadow);\n\n    &:focus {\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    pointer-events: none;\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $btn-link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $btn-link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  &:hover {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n    }\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  .show > &.dropdown-toggle {\n    color: $active-color;\n    background-color: $active-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $disabled-color;\n    background-color: $disabled-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $disabled-border;\n  }\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  color: $color;\n  border-color: $color;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  &.dropdown-toggle.show {\n    color: $active-color;\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $color;\n    background-color: transparent;\n  }\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: 0; // Override default margin of ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: $dropdown-spacer;\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: $dropdown-divider-margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $dropdown-divider-bg;\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  &:hover,\n  &:focus {\n    color: $dropdown-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  color: $dropdown-dark-color;\n  background-color: $dropdown-dark-bg;\n  border-color: $dropdown-dark-border-color;\n  @include box-shadow($dropdown-dark-box-shadow);\n\n  .dropdown-item {\n    color: $dropdown-dark-link-color;\n\n    &:hover,\n    &:focus {\n      color: $dropdown-dark-link-hover-color;\n      @include gradient-bg($dropdown-dark-link-hover-bg);\n    }\n\n    &.active,\n    &:active {\n      color: $dropdown-dark-link-active-color;\n      @include gradient-bg($dropdown-dark-link-active-bg);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: $dropdown-dark-link-disabled-color;\n    }\n  }\n\n  .dropdown-divider {\n    border-color: $dropdown-dark-divider-bg;\n  }\n\n  .dropdown-item-text {\n    color: $dropdown-dark-link-color;\n  }\n\n  .dropdown-header {\n    color: $dropdown-dark-header-color;\n  }\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\") !default;\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n// Utilities maps\n//\n// Extends the default `$theme-colors` maps to help create our utilities.\n\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\n// scss-docs-start utilities-colors\n$utilities-colors: $theme-colors-rgb !default;\n// scss-docs-end utilities-colors\n\n// scss-docs-start utilities-text-colors\n$utilities-text: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-color)\n  )\n) !default;\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\") !default;\n// scss-docs-end utilities-text-colors\n\n// scss-docs-start utilities-bg-colors\n$utilities-bg: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-bg)\n  )\n) !default;\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\") !default;\n// scss-docs-end utilities-bg-colors\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n$gutters: $spacers !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-color:                $gray-300 !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem !default;\n$border-radius-sm:            .2rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n$hr-height:                   $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-striped-order:         odd !default;\n\n$table-group-separator-color: currentColor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              $link-color !default;\n$btn-link-hover-color:        $link-hover-color !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $body-bg !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    $link-color !default;\n$nav-link-hover-color:              $link-hover-color !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($dropdown-link-color, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-margin-start:           -$pagination-border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            $link-hover-color !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-border-radius:                $border-radius !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default;\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  rgba($black, .125) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     $accordion-bg !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba($black, .1) !default;\n$toast-border-radius:               $border-radius !default;\n$toast-box-shadow:                  $box-shadow !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba($black, .05) !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         null !default;\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  @include font-size($nav-link-font-size);\n  font-weight: $nav-link-font-weight;\n  color: $nav-link-color;\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: $nav-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background: none;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    &:hover,\n    &:focus {\n      border-color: $nav-tabs-link-hover-border-color;\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    @include gradient-bg($nav-pills-link-active-bg);\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding-top: $navbar-padding-y;\n  padding-right: $navbar-padding-x; // default: null\n  padding-bottom: $navbar-padding-y;\n  padding-left: $navbar-padding-x; // default: null\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-brand-margin-end;\n  @include font-size($navbar-brand-font-size);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n  @include transition($navbar-toggler-transition);\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 $navbar-toggler-focus-width;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$variable-prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas {\n          position: inherit;\n          bottom: 0;\n          z-index: 1000;\n          flex-grow: 1;\n          visibility: visible !important; // stylelint-disable-line declaration-no-important\n          background-color: transparent;\n          border-right: 0;\n          border-left: 0;\n          @include transition(none);\n          transform: none;\n        }\n        .offcanvas-top,\n        .offcanvas-bottom {\n          height: auto;\n          border-top: 0;\n          border-bottom: 0;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n\n    a,\n    a:hover,\n    a:focus  {\n      color: $navbar-light-active-color;\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a,\n    a:hover,\n    a:focus {\n      color: $navbar-dark-active-color;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n  @include box-shadow($card-box-shadow);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-title-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-title-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-bottom: -$card-cap-padding-y;\n  margin-left: -$card-cap-padding-x * .5;\n  border-bottom: 0;\n\n  @if $nav-tabs-link-active-bg != $card-bg {\n    .nav-link.active {\n      background-color: $card-bg;\n      border-bottom-color: $card-bg;\n    }\n  }\n}\n\n.card-header-pills {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-left: -$card-cap-padding-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: $accordion-button-padding-y $accordion-button-padding-x;\n  @include font-size($font-size-base);\n  color: $accordion-button-color;\n  text-align: left; // Reset button style\n  background-color: $accordion-button-bg;\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition($accordion-transition);\n\n  &:not(.collapsed) {\n    color: $accordion-button-active-color;\n    background-color: $accordion-button-active-bg;\n    box-shadow: inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\n\n    &::after {\n      background-image: escape-svg($accordion-button-active-icon);\n      transform: $accordion-icon-transform;\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: $accordion-icon-width;\n    height: $accordion-icon-width;\n    margin-left: auto;\n    content: \"\";\n    background-image: escape-svg($accordion-button-icon);\n    background-repeat: no-repeat;\n    background-size: $accordion-icon-width;\n    @include transition($accordion-icon-transition);\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: $accordion-button-focus-border-color;\n    outline: 0;\n    box-shadow: $accordion-button-focus-box-shadow;\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  background-color: $accordion-bg;\n  border: $accordion-border-width solid $accordion-border-color;\n\n  &:first-of-type {\n    @include border-top-radius($accordion-border-radius);\n\n    .accordion-button {\n      @include border-top-radius($accordion-inner-border-radius);\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius($accordion-border-radius);\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius($accordion-inner-border-radius);\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius($accordion-border-radius);\n    }\n  }\n}\n\n.accordion-body {\n  padding: $accordion-body-padding-y $accordion-body-padding-x;\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      @include border-radius(0);\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding-x;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding-x;\n      color: $breadcrumb-divider-color;\n      content: var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    color: $pagination-focus-color;\n    background-color: $pagination-focus-bg;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    @include gradient-bg($pagination-active-bg);\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n@include pagination-size($pagination-padding-y, $pagination-padding-x, null, $pagination-border-radius);\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n  }\n\n  .page-item {\n    @if $pagination-margin-start == (-$pagination-border-width) {\n      &:first-child {\n        .page-link {\n          @include border-start-radius($border-radius);\n        }\n      }\n\n      &:last-child {\n        .page-link {\n          @include border-end-radius($border-radius);\n        }\n      }\n    } @else {\n      //Add border-radius to all pageLinks in case they have left margin\n      .page-link {\n        @include border-radius($border-radius);\n      }\n    }\n  }\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  color: $badge-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > li::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-start-radius($list-group-border-radius);\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-end-radius($list-group-border-radius);\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  width: $toast-max-width;\n  max-width: 100%;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  pointer-events: auto;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  @include border-radius($toast-border-radius);\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: $toast-spacing;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n\n  .btn-close {\n    margin-right: $toast-padding-x * -.5;\n    margin-left: $toast-padding-x;\n  }\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n  word-wrap: break-word;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  @include overlay-backdrop($zindex-modal-backdrop, $modal-backdrop-bg, $modal-backdrop-opacity);\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .btn-close {\n    padding: ($modal-header-padding-y * .5) ($modal-header-padding-x * .5);\n    margin: ($modal-header-padding-y * -.5) ($modal-header-padding-x * -.5) ($modal-header-padding-y * -.5) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n\n      .modal-footer {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .tooltip-arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    bottom: 0;\n\n    &::before {\n      top: -1px;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-end {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: -1px;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    top: 0;\n\n    &::before {\n      bottom: -1px;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-start {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: -1px;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0 #{\"/* rtl:ignore */\"};\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .popover-arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-end {\n  > .popover-arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-start {\n  > .popover-arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid $popover-border-color;\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: $spinner-animation-speed linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: $spinner-animation-speed linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: $spinner-animation-speed * 2;\n    }\n  }\n}\n",".offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: $zindex-offcanvas;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: $offcanvas-color;\n  visibility: hidden;\n  background-color: $offcanvas-bg-color;\n  background-clip: padding-box;\n  outline: 0;\n  @include box-shadow($offcanvas-box-shadow);\n  @include transition(transform $offcanvas-transition-duration ease-in-out);\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\n\n  .btn-close {\n    padding: ($offcanvas-padding-y * .5) ($offcanvas-padding-x * .5);\n    margin-top: $offcanvas-padding-y * -.5;\n    margin-right: $offcanvas-padding-x * -.5;\n    margin-bottom: $offcanvas-padding-y * -.5;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\n  overflow-y: auto;\n}\n\n.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: $offcanvas-horizontal-width;\n  border-right: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateX(-100%);\n}\n\n.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: $offcanvas-horizontal-width;\n  border-left: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateX(100%);\n}\n\n.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: $offcanvas-vertical-height;\n  max-height: 100%;\n  border-bottom: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: $offcanvas-vertical-height;\n  max-height: 100%;\n  border-top: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateY(100%);\n}\n\n.offcanvas.show {\n  transform: none;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentColor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value;\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$variable-prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$variable-prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentColor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (eg. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$variable-prefix}#{$property-class}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$variable-prefix}#{$property-class}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $value in $is-local-vars {\n                --#{$variable-prefix}#{$local-var}: #{$value};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// \n// accordions.scss\n//\n\n.custom-accordionwitharrow {\n    .card {\n        +.card {\n            margin-top: 0.5rem;\n        }\n        .card-header{\n            background-color: transparent;\n        }\n    }\n\n    .accordion-arrow {\n        font-size: 1.2rem;\n        margin-top: -5px;\n    }\n\n    a {\n        &.collapsed {\n            i.accordion-arrow {\n                &:before {\n                    content: \"\\e831\";\n                }\n            }\n        }\n    }\n}\n\n// Custom Accordion\n\n.custom-accordion {\n    .card {\n        overflow: visible;\n        border-color: transparent !important;\n        border-left: 2px dashed $gray-300 !important;\n        box-shadow: none;\n        padding-left: 24px;\n        margin-left: 10px;\n\n        .card-header {\n            border-radius: 7px !important;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                left: 5px;\n                top: 22px;\n                width: 25px;\n                height: 2px;\n                background: $card-cap-bg;\n            }\n        }\n\n        .icon {\n            position: absolute;\n            left: -18px;\n            top: -2px;\n            background-color: $card-bg;\n            border-radius: 50%;\n            margin-right: 1px;\n        }\n    }\n}","// \n// _badges.scss\n// \n\n// Lighten badge\n@mixin badge-variant-light($bg) {\n    color: $bg;\n    background-color: rgba($bg, 0.18);\n    box-shadow: none;\n}\n\n// Outline badge\n\n@mixin badge-variant-outline($bg) {\n    color: $bg;\n    border: 1px solid $bg;\n    background-color: transparent;\n    box-shadow: none;\n}\n\n// Lighten badge (soft)\n\n@each $color,\n$value in $theme-colors {\n    .badge-soft-#{$color} {\n        @include badge-variant-light($value);\n    }\n}\n\n// Outline badge\n\n@each $color,\n$value in $theme-colors {\n    .badge-outline-#{$color} {\n        @include badge-variant-outline($value);\n    }\n}","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.25) !important;\n    }\n}\n\n.bg-ghost {\n    opacity: 0.4;\n}","\n// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: $gray-700;\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: 'unicons';\n        }\n    }\n}\n  ","// \n// buttons.scss\n//\n\n.btn {\n    color: $white;\n    \n\n    &:focus {\n        box-shadow: none;\n    }\n\n    .icon {\n        svg {\n            width: 1rem;\n            height: 1rem;\n            margin-left: 0.1rem;\n            margin-top: -2px;\n        }\n    }\n}\n\n//\n// light button\n// \n.btn-light,.btn-white {\n    color: $gray-900;\n}\n\n.btn-white {\n    border-color: $gray-300;\n\n    &:hover,\n    &:focus {\n        background-color: $gray-300;\n        border-color: $gray-400;\n    }\n}\n//\n// Link buttons\n//\n// Make a button look and behave like a link\n.btn-link {\n    font-weight: $font-weight-normal;\n    color: $link-color;\n    background-color: transparent;\n    &:hover {\n        color: $link-hover-color;\n        text-decoration: $link-hover-decoration;\n        background-color: transparent;\n        border-color: transparent;\n    }\n    &:focus{\n        text-decoration: $link-hover-decoration;\n        border-color: transparent;\n        box-shadow: none;\n    }\n    &:disabled{\n        color: $btn-link-disabled-color;\n        pointer-events: none;\n    } // No need for an active state here\n} \n\n\n// \n// Button Extra Small Size\n// \n\n.btn-xs {\n    padding: .2rem .6rem;\n    font-size: .75rem;\n    border-radius: .15rem;\n}\n\n// Soft variants\n@mixin btn-variant-soft($bg, $color) {\n    background-color: rgba($bg, $btn-soft-bg-opacity);\n    color: $color;\n    border-color: rgba($color, $btn-soft-bg-opacity);\n\n    &:focus {\n        box-shadow: none;\n    }\n\n    &:hover,\n    &:focus {\n        background-color: fade-in(rgba($bg, $btn-soft-bg-opacity), .05);\n        color: $color;\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .btn-soft-#{$color} {\n        @include btn-variant-soft($value, $value);\n    }\n}\n\n//\n// Alternate buttons\n//\n@each $color,\n$value in $theme-colors {\n    .btn-outline-#{$color} {\n        @include button-outline-variant($value);\n        &:focus {\n            box-shadow: none;\n        }\n    }\n}","// \n// card.scss\n//\n\n.card {\n    margin-bottom: $grid-gutter-width;\n}\n\n.card-link + .card-link{\n    /*rtl:ignore*/\n    margin-left: $card-spacer-x;\n    /*rtl:ignore*/\n    margin-right: 0;\n}\n\n.card-drop {\n    font-size: 20px;\n    line-height: 0;\n    color: inherit;\n}\n\n.card-widgets {\n    float: right;\n    height: 16px;\n    > a {\n        color: inherit;\n        font-size: 18px;\n        display: inline-block;\n        line-height: 1;\n\n        &.collapsed {\n            i {\n                &:before {\n                    content: \"\\F0415\";\n                }\n            }\n        }\n    }\n}\n\n\n// Card title / Card Header\n.card-title,\n.card-header {\n    margin-top: 0;\n}\n\n\n//Card disable loading (Custom Cards)\n.card-disabled {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    border-radius: $card-border-radius;\n    background: $card-overlay-bg;\n    cursor: progress;\n\n    .card-portlets-loader {\n        background-color: $card-overlay-color;\n        animation: rotatebox 1.2s infinite ease-in-out;\n        height: 30px;\n        width: 30px;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        border-radius: 3px;\n        margin-left: - ($grid-gutter-width * 0.5);\n        margin-top: - ($grid-gutter-width * 0.5);\n    }\n}\n\n@keyframes rotatebox {\n    0% {\n        transform: perspective(120px) rotateX(0deg) rotateY(0deg);\n    }\n    50% {\n        transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\n    }\n    100% {\n        transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\n    }\n}\n\n// Custom card box\n.card-box {\n    background-color: $card-bg;\n    padding: $card-spacer-x;\n    box-shadow: $box-shadow-sm;\n    margin-bottom: $grid-gutter-width;\n    @include border-radius($card-border-radius);\n}\n\n.header-title {\n    font-size: 15px;\n    margin: 0 0 7px 0;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.sub-header {\n    font-size: 0.875rem;\n    margin-bottom: $grid-gutter-width;\n    color: $text-muted;\n}","// \n// dropdown.scss\n//\n\n.dropdown-menu {\n    box-shadow: $box-shadow;\n    animation-name: DropDownSlide;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    font-size: $font-size-base;\n    top: 100%;\n    \n    &.show {\n        top: 100%!important;\n    }\n\n    i {\n        display: inline-block;\n    }\n}\n\n.dropdown-menu-end {\n    right: 0!important;\n    left: auto!important;\n}\n\n.dropdown-menu[data-popper-placement^=right],\n.dropdown-menu[data-popper-placement^=top],\n.dropdown-menu[data-popper-placement^=left]{\n    top: auto !important;\n    animation: none !important;\n}\n\n@keyframes DropDownSlide {\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0)\n    }\n    0% {\n        -webkit-transform: translateY(-10px);\n        transform: translateY(-10px)\n    }\n}\n\n\n// Dropdown Large (Custom)\n\n@media (min-width: 600px) {\n    .dropdown-lg {\n        width: $dropdown-lg-width;\n    }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n    display: block;\n    border-radius: 3px;\n    line-height: 34px;\n    text-align: center;\n    padding: 15px 0 9px;\n    display: block;\n    border: 1px solid transparent;\n    color: $dropdown-link-color;\n\n    img {\n        height: 24px;\n    }\n\n    span {\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &:hover {\n        background-color: $dropdown-link-hover-bg;\n    }\n}\n\n// Dropdown size\n@include media-breakpoint-up(lg) {\n    .dropdown-mega-menu-xl{\n        width: 40rem;\n    }\n    \n    .dropdown-mega-menu-lg{\n        width: 26rem;\n    }\n}","//\n// forms.scss\n//\n\n.form-control {\n    &::placeholder {\n        color: shade-color($gray-500, 7%);\n    }\n}\n\n// Form-control light\n.form-control-light {\n    background-color: $input-light-bg !important;\n    border-color: $input-light-bg !important;\n}\n\n\n// Form elements (Color and Range)\ninput.form-control[type=\"color\"],\ninput.form-control[type=\"range\"] {\n    min-height: 39px;\n}\n\n\n// Custom select\n.custom-select.is-invalid, .form-control.is-invalid,.custom-select:invalid, .form-control:invalid,\n.custom-select.is-valid, .form-control.is-valid, .custom-select:valid,.form-control:valid {\n    &:focus {\n        box-shadow: none !important;\n    }\n}\n\n// Comment box\n.comment-area-box {\n    .form-control {\n        border-color: $gray-300;\n        border-radius: $input-border-radius $input-border-radius 0 0;\n    }\n    .comment-area-btn {\n        background-color: $gray-100;\n        padding: 10px;\n        border: 1px solid $gray-300;\n        border-top: none;\n        border-radius: 0 0 $input-border-radius $input-border-radius;\n    }\n}\n\n// Search box \n.search-bar {\n\n    .form-control {\n        padding-left: 40px;\n        padding-right: 20px;\n        border-radius: 30px;\n    }\n\n    span {\n        position: absolute;\n        z-index: 10;\n        font-size: 16px;\n        line-height: $input-height;\n        left: 13px;\n        top: -2px;\n        color: $text-muted;\n    }\n}\n\n// Show Password\n.password-eye {\n    &:before {\n        font-family: feather!important;\n        content: \"\\e86a\";\n        font-style: normal;\n        font-weight: 400;\n        font-variant: normal;\n        vertical-align: middle;\n        line-height: 1.2;\n        font-size: 16px;\n    }\n}\n\n.show-password {\n    .password-eye {\n        &:before {\n            content: \"\\e86e\";\n        }\n    }  \n}\n","// \n// modal.scss\n//\n\n// Title text within header\n.modal-title {\n    margin-top: 0;\n}\n\n// Modal full width\n.modal-full-width {\n    width: 95%;\n    max-width: none;\n}\n\n// Modal Positions\n.modal-top {\n    margin: 0 auto;\n}\n\n// Right Modal\n.modal-right {\n    position: absolute;\n    right: 0;\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: center;\n    height: 100%;\n    margin: 0;\n    background-color: $modal-content-bg;\n    align-content: center;\n    transform: translate(25%,0) !important;\n\n    button.close {\n        position: fixed;\n        top: 20px;\n        right: 20px;\n        z-index: 1;\n    }\n}\n\n.modal {\n    &.show {\n        .modal-right {\n            transform: translate(0,0) !important;\n        }\n    }\n}\n\n// Bottom modal\n.modal-bottom {\n    display: flex;\n    flex-flow: column nowrap;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    height: 100%;\n    margin: 0 auto;\n    align-content: center;\n}\n\n// Colored modal header\n.modal-colored-header {\n    color: $white;\n    border-radius: 0;\n\n    .close {\n        color: $white !important;\n    }\n}","// \n// nav.scss\n//\n\n\n// Bootstrap override - turn nav tab with broder\n\n.nav-tabs {\n    border-bottom: 2px solid rgba($gray-600, 0.2);\n\n    .nav-item {\n        margin-bottom: -2px;\n    }\n\n    .nav-link {\n        cursor: pointer;\n        outline: none;\n    }\n\n    li {\n        a {\n            border-color: transparent !important;\n            padding: 0.625rem 1.25rem;\n        }\n        a.active {\n            border-bottom: 2px solid $primary !important;\n        }\n    }\n}\n\n// pills\n.nav-tabs,.nav-pills {\n    > li {\n        > a {\n            color: $gray-700;\n            font-weight: $font-weight-bold;\n        }\n    }\n}\n\n.nav-pills {\n    background: $body-bg;\n    border-radius: $border-radius;\n    padding: 6px 2px;\n\n    .nav-link {\n        background-color: transparent;\n        color: $body-color;\n        outline: none;\n    }\n\n    .nav-link.active,\n    .show>.nav-link {\n        color: $body-color;\n        background-color: $card-bg;\n        box-shadow: $box-shadow-sm;\n    }\n}\n\n\n//Navtab custom\n.navtab-bg {\n    li {\n        >a {\n            background-color: $gray-300;\n        }\n    }\n}\n\n.tab-content {\n    padding: 20px 0 0 0;\n}  \n\n@media only screen and (max-width: 991px) {\n    .hederSection {\n        justify-content: center !important;\n    }\n}","// \n// pagination.scss\n//\n\n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px;\n        border: none;\n    }\n}","// \n// popover.scss\n//\n\n.popover-header {\n    margin-top: 0;\n}","// \n// progress.scss\n//\n\n// Custom height\n\n// Progress height small\n.progress-sm {\n    height: 5px;\n}\n\n\n// Progress height medium\n.progress-md {\n    height: 8px;\n}\n\n\n// Progress height large\n.progress-lg {\n    height: 12px;\n}\n\n// Progress height extra large\n.progress-xl {\n    height: 15px;\n}\n\n\n/* Progressbar Vertical */\n.progress-vertical {\n    min-height: 250px;\n    height: 250px;\n    width: 10px;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-md {\n        width: 8px;\n    }\n\n    &.progress-sm {\n        width: 5px;\n    }\n}\n\n.progress-vertical-bottom {\n    min-height: 250px;\n    height: 250px;\n    position: relative;\n    width: 10px;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n        bottom: 0;\n        position: absolute;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-md {\n        width: 8px;\n    }\n\n    &.progress-sm {\n        width: 5px;\n    }\n}","//\n// reboot.scss\n//\nbody {\n    padding-right: 0px !important;\n    padding-left: 0px !important;\n    &.loading {\n        visibility: hidden;\n        opacity: 0;\n    }\n}\n\n// Forms\nlabel {\n    font-weight: $font-weight-bold;\n}\n\n\nbutton:focus {\n    outline: none;\n}\n\n\n.row >* {\n    position: relative;\n}\n\na{\n    &:focus{\n        outline: none;\n    }\n}","// \n// tables.scss\n//\n\nth {\n    font-weight: $font-weight-bold;\n}\n\n//Table centered (Custom)\n.table-centered {\n    td,th {\n        vertical-align: middle !important;\n    }\n}\n\n\n// Table \n\n.table-nowrap {\n    th,td {\n        white-space: nowrap;\n    }\n}\n\n// Custom table components (Custom)\n.table {\n    .table-user {\n        img {\n            height: 30px;\n            width: 30px;\n        }\n    }\n}\n\n.action-icon {\n    color: $gray-600;\n    font-size: 1.2rem;\n    display: inline-block;\n    padding: 0 3px;\n\n    &:hover {\n        color: $gray-700;\n    }\n}\n","// \n// type.scss\n//\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 10px 0;\n    font-family: $font-family-secondary;\n    color: $text-color-h;\n}\n\n\n// Font sizes (Custom)\n.fs-11 {\n    font-size: 11px !important;\n}\n\n.fs-12 {\n    font-size: 12px !important;\n}\n\n.fs-13 {\n    font-size: 13px !important;\n}\n\n.fs-14 {\n    font-size: 14px !important;\n}\n\n.fs-15 {\n    font-size: 15px !important;\n}\n\n.fs-16 {\n    font-size: 16px !important;\n}\n\n.fs-17 {\n    font-size: 17px !important;\n}\n\n.fs-18 {\n    font-size: 18px !important;\n}\n\n.fs-19 {\n    font-size: 19px !important;\n}\n\n.fs-20 {\n    font-size: 20px !important;\n}\n\n.fs-22 {\n    font-size: 22px !important;\n}\n\n.fs-24 {\n    font-size: 24px !important;\n}\n\n// Font Weight\n\n.fw-medium {\n    font-weight: $font-weight-medium;\n}\n\n.fw-semibold {\n    font-weight: $font-weight-semibold;\n}\n\n// text utilies\n.text-unline-dashed {\n    border-bottom: $gray-400 1px dashed !important;\n    padding-bottom: 1px;\n}","/*\nTemplate Name: Shreyu - Responsive Bootstrap 5 Admin Dashboard\nAuthor: CoderThemes\nVersion: 2.0.0\nWebsite: https://coderthemes.com/\nContact: support@coderthemes.com\nFile: Main Css File\n*/\niframe#webpack-dev-server-client-overlay{display:none!important}\n\n//Fonts\n@import \"custom/fonts/fonts\";\n\n//Core files\n@import \"../../../node_modules/bootstrap/scss/functions\";\n@import \"../../../node_modules/bootstrap/scss/variables\";\n@import \"config/variables\";\n@import \"../../../node_modules/bootstrap/scss/mixins.scss\";\n\n\n// Structure\n@import \"custom/structure/general\";\n@import \"custom/structure/left-menu\";\n@import \"custom/structure/topbar\";\n@import \"custom/structure/page-head\";\n@import \"custom/structure/footer\";\n@import \"custom/structure/right-sidebar\";\n@import \"custom/structure/layouts\";\n@import \"custom/structure/horizontal-nav\";\n@import \"custom/structure/two-column-menu\";\n\n//Components\n@import \"custom/components/avatar\";\n@import \"custom/components/custom-checkbox\";\n@import \"custom/components/custom-radio\";\n@import \"custom/components/helper\";\n@import \"custom/components/social\";\n@import \"custom/components/widgets\";\n@import \"custom/components/print\";\n@import \"custom/components/preloader\";\n\n//Pages\n@import \"custom/pages/authentication\";\n@import \"custom/pages/components-demo\";\n@import \"custom/pages/error\";\n@import \"custom/pages/email\";\n@import \"custom/pages/pricing\";\n@import \"custom/pages/profile\";\n@import \"custom/pages/task\";\n@import \"custom/pages/timeline\";\n@import \"custom/pages/kanbanboard\";\n@import \"custom/pages/landing\";\n@import \"custom/pages/file-manager.scss\";\n@import \"custom/pages/chat\";\n@import \"custom/pages/dashboard\";\n\n\n// Plugins\n@import \"custom/plugins/apexcharts\";\n@import \"custom/plugins/calendar\";\n@import \"custom/plugins/colorpicker\";\n@import \"custom/plugins/sparkline-chart\";\n@import \"custom/plugins/datatable\";\n@import \"custom/plugins/datepicker\"; // react-datepicker style\n@import \"custom/plugins/form-wizard\";\n@import \"custom/plugins/select2\";\n@import \"custom/plugins/simplebar\";\n@import \"custom/plugins/multiple-select\";\n@import \"custom/plugins/bootstrap-touchspin\";\n@import \"custom/plugins/parsley\";\n@import \"custom/plugins/quilljs-editor\";\n@import \"custom/plugins/react-select\"; // react-select style\n@import 'custom/plugins/react-table'; // react table style\n@import \"custom/plugins/flatpickr\";\n@import \"custom/plugins/dropzone\";\n@import \"custom/plugins/google-maps\";\n@import \"custom/plugins/vector-maps\";","// \n// general.scss\n//\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\nbody {\n  overflow-x: hidden;\n}","// \n// menu.scss\n//\n\n// Wrapper\n#wrapper {\n    height: 100%;\n    overflow: hidden;\n    width: 100%;\n}\n\n//Content Page\n.content-page {\n    margin-left: $leftbar-width;\n    overflow: hidden;\n    padding: 0 15px 65px 15px;\n    min-height: 80vh;\n    margin-top: $topbar-height;\n}\n\n// Sidemenu\n.left-side-menu {\n    width: $leftbar-width;\n    background: linear-gradient(180deg, #020b18 0%, #031024 45%, #051329 100%) !important;\n    border-right: 1px solid #0a1f3d !important;\n    bottom: 0;\n    padding: 0 0 30px 0;\n    position: fixed;\n    transition: all .1s ease-out;\n    top: $topbar-height;\n    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);\n    z-index: 1000;\n\n    .simplebar-scrollbar:before {\n        background: rgba(255, 255, 255, 0.15);\n    }\n}\n\n.sidebar-inner-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n// Mobile Top Brand Header (inside offcanvas drawer on mobile)\n.sidebar-mobile-brand {\n    padding: 12px 14px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    margin-bottom: 8px;\n\n    .sidebar-brand-link {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        text-decoration: none !important;\n    }\n\n    .sidebar-brand-mascot {\n        height: 44px;\n        width: auto;\n        object-fit: contain;\n    }\n\n    .sidebar-brand-text {\n        display: flex;\n        flex-direction: column;\n        line-height: 1.15;\n    }\n\n    .sidebar-brand-title {\n        font-weight: 800;\n        font-size: 17px;\n        color: #0b3558;\n    }\n\n    .sidebar-brand-subtitle {\n        font-weight: 700;\n        font-size: 10px;\n        color: #0284c7;\n    }\n}\n\n// Portal Status Pill Badge\n.sidebar-portal-badge-wrap {\n    padding: 16px 14px 8px 14px;\n}\n\n.sidebar-portal-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(14, 38, 77, 0.75);\n    border: 1px solid rgba(59, 130, 246, 0.3);\n    border-radius: 9999px;\n    padding: 4px 12px;\n\n    .sidebar-badge-dot {\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        background-color: #22c55e;\n        box-shadow: 0 0 8px #22c55e;\n        flex-shrink: 0;\n    }\n\n    .sidebar-badge-text {\n        color: #60a5fa;\n        font-size: 10.5px;\n        font-weight: 700;\n        letter-spacing: 0.6px;\n        text-transform: uppercase;\n        white-space: nowrap;\n    }\n}\n\n// Entity Info Card\n.sidebar-entity-card {\n    margin: 4px 14px 16px 14px;\n    padding: 10px 12px;\n    background: #081a36;\n    border: 1px solid rgba(59, 130, 246, 0.22);\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .sidebar-entity-icon {\n        width: 38px;\n        height: 38px;\n        border-radius: 10px;\n        background: #0d2850;\n        border: 1px solid rgba(59, 130, 246, 0.35);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #60a5fa;\n        flex-shrink: 0;\n\n        svg {\n            width: 18px;\n            height: 18px;\n        }\n    }\n\n    .sidebar-entity-info {\n        overflow: hidden;\n        flex: 1;\n        min-width: 0;\n    }\n\n    .sidebar-entity-name {\n        color: #ffffff;\n        font-weight: 700;\n        font-size: 13px;\n        line-height: 1.25;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-transform: uppercase;\n        letter-spacing: 0.2px;\n    }\n\n    .sidebar-entity-code {\n        color: #64748b;\n        font-size: 10.5px;\n        font-weight: 500;\n        margin-top: 3px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n}\n\n// Sidebar Navigation Menu\n#sidebar-menu {\n    > ul.side-menu {\n        list-style: none;\n        padding: 0 12px 24px 12px;\n        margin: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 5px;\n\n        > li.side-nav-item {\n            position: relative;\n            list-style: none;\n            border: none !important;\n            background: transparent !important;\n            margin: 0;\n            padding: 0;\n            border-radius: 12px;\n\n            > a,\n            > .side-sub-nav-link {\n                display: flex !important;\n                align-items: center !important;\n                gap: 12px !important;\n                padding: 8px 12px !important;\n                border-radius: 12px !important;\n                color: #94a3b8 !important;\n                font-size: 13.5px !important;\n                font-weight: 500 !important;\n                text-decoration: none !important;\n                transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n                position: relative !important;\n                background: transparent !important;\n                border: none !important;\n\n                &:hover {\n                    background: rgba(255, 255, 255, 0.06) !important;\n                    color: #ffffff !important;\n\n                    .menu-icon-box {\n                        background: rgba(255, 255, 255, 0.1) !important;\n                        border-color: rgba(255, 255, 255, 0.18) !important;\n                        color: #ffffff !important;\n                    }\n                }\n            }\n\n            // Active item styling\n            &.item-active > a,\n            &.menuitem-active > a.active,\n            > a.active {\n                background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;\n                color: #ffffff !important;\n                font-weight: 600 !important;\n                box-shadow: 0 4px 18px -2px rgba(37, 99, 235, 0.5) !important;\n\n                .active-indicator-pill {\n                    position: absolute;\n                    left: 0;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    width: 4.5px;\n                    height: 24px;\n                    background: #ffffff;\n                    border-radius: 0 4px 4px 0;\n                    z-index: 2;\n                }\n\n                .menu-icon-box {\n                    background: rgba(255, 255, 255, 0.22) !important;\n                    border-color: rgba(255, 255, 255, 0.35) !important;\n                    color: #ffffff !important;\n\n                    svg {\n                        color: #ffffff !important;\n                        stroke: #ffffff !important;\n                    }\n                }\n            }\n\n            ul {\n                padding-left: 20px;\n                list-style: none;\n            }\n        }\n    }\n\n    .badge {\n        margin-top: 2px;\n    }\n\n    .menu-title {\n        padding: 14px 14px 6px;\n        letter-spacing: .08em;\n        pointer-events: none;\n        cursor: default;\n        font-size: 0.65rem;\n        text-transform: uppercase;\n        color: #475569;\n        font-weight: 700;\n    }\n}\n\n.menu-icon-box {\n    width: 36px;\n    height: 36px;\n    border-radius: 9px;\n    flex-shrink: 0;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #94a3b8;\n    transition: all 0.2s ease;\n\n    svg {\n        width: 17px;\n        height: 17px;\n        stroke-width: 2;\n        fill: none !important;\n    }\n}\n\n.menu-item-text {\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 13.5px;\n    font-weight: inherit;\n}\n\n.nav-second-level {\n    padding: 4px 0 6px 36px;\n    list-style: none;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    li {\n        a {\n            padding: 6px 10px !important;\n            color: #94a3b8 !important;\n            display: block;\n            position: relative;\n            transition: all 0.2s;\n            font-size: 13px !important;\n            border-radius: 8px !important;\n\n            &:focus,\n            &:hover {\n                color: #ffffff !important;\n                background: rgba(255, 255, 255, 0.05) !important;\n            }\n        }\n\n        &.active,\n        &.menuitem-active {\n            > a {\n                color: #60a5fa !important;\n                background: rgba(37, 99, 235, 0.15) !important;\n                font-weight: 600 !important;\n            }\n        }\n    }\n}\n\n.menu-arrow {\n    transition: transform .15s;\n    display: inline-block;\n    font-family: 'unicons';\n    text-rendering: auto;\n    font-size: 1rem;\n    transform: translate(0, 0);\n\n    &::before {\n        content: \"\\e82f\";\n    }\n}\n\n[dir=\"rtl\"] .menu-arrow {\n    &::before {\n        content: \"\\e82e\";\n    }\n}\n\nli {\n    > a[aria-expanded=\"true\"] {\n        > span.menu-arrow {\n            transform: rotate(90deg);\n        }\n    }\n    &.menuitem-active {\n        > a:not(.collapsed) {\n            > span.menu-arrow {\n                transform: rotate(90deg);\n            }\n        }\n    }\n}\n\n// Enlarge menu\nbody[data-sidebar-size=\"condensed\"] {\n\n    .logo-box {\n        width: $leftbar-width-condensed !important;\n        text-align: center;\n        @include media-breakpoint-down(lg) {\n            padding-left: 0 !important;\n        }\n    }\n\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n\n        span.logo-sm {\n            display: block;\n        }\n    }\n\n    // Side menu\n    .left-side-menu {\n        position: absolute;\n        padding-top: 0;\n        width: $leftbar-width-condensed !important;\n        z-index: 5;\n\n        .simplebar-mask,\n        .simplebar-content-wrapper {\n            overflow: visible !important;\n        }\n\n        .simplebar-scrollbar {\n            display: none !important;\n        }\n\n        .simplebar-offset {\n            bottom: 0 !important;\n        }\n\n        // Sidebar Menu\n        #sidebar-menu {\n\n            .menu-title,\n            .menu-arrow,\n            .label,\n            .badge,\n            .collapse.in {\n                display: none !important;\n            }\n\n            .nav.collapse {\n                height: inherit !important;\n            }\n\n            >ul {\n                >li {\n                    position: relative;\n                    white-space: nowrap;\n\n                    >a {\n                        padding: 15px 20px;\n                        min-height: 54px;\n                        transition: none;\n\n                        &:hover,\n                        &:active,\n                        &:focus {\n                            color: $menu-item-hover;\n                        }\n\n                        i {\n                            font-size: 1.3rem;\n                            margin-right: 20px;\n                            margin-left: 5px;\n                        }\n\n                        svg {\n                            width: 18px;\n                            height: 18px;\n                            margin-left: 6px;\n                        }\n\n                        span {\n                            display: none;\n                            padding-left: 25px;\n                        }\n                    }\n\n                    &:hover {\n                        >a {\n                            position: relative;\n                            width: calc(190px + #{$leftbar-width-condensed});\n                            color: $menu-item-active;\n                            background-color: $gray-100;\n                            // box-shadow: inset $box-shadow-condensed;\n\n                            span {\n                                display: inline;\n                            }\n                        }\n\n                        a.open,\n                        a.active {\n                            :after {\n                                display: none;\n                            }\n                        }\n\n                        > .collapse,\n                        > .collapsing {\n                            display: block !important;\n                            height: auto !important;\n                            transition: none !important;\n\n                            > ul {\n                                display: block !important;\n                                left: $leftbar-width-condensed;\n                                position: absolute;\n                                width: 190px;\n                                box-shadow: $box-shadow-condensed;\n    \n                                ul {\n                                    box-shadow: $box-shadow-condensed;\n                                }\n    \n                                a {\n                                    box-shadow: none;\n                                    padding: 8px 20px;\n                                    position: relative;\n                                    width: 190px;\n                                    z-index: 6;\n    \n                                    &:hover {\n                                        color: $menu-item-hover;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .collapsing {\n                    display: block !important;\n                    height: auto !important;\n                    transition: none !important;\n                }\n\n                ul {\n                    padding: 5px 0;\n                    z-index: 9999;\n                    display: none;\n                    background-color: $bg-leftbar;\n\n                    li {\n                        &:hover {\n\n                            > .collapse,\n                            > .collapsing {\n                                display: block !important;\n                                height: auto !important;\n                                transition: none !important;\n\n                                >ul {\n                                    display: block;\n                                    left: 190px;\n                                    margin-top: -36px;\n                                    position: absolute;\n                                    width: 190px;\n                                }\n                            }\n                        }\n\n                        >a {\n                            span.pull-right {\n                                position: absolute;\n                                right: 20px;\n                                top: 12px;\n                                transform: rotate(270deg);\n                            }\n                        }\n                    }\n\n                    li.active {\n                        a {\n                            color: $menu-item-active;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    // Content Page\n    .content-page {\n        margin-left: $leftbar-width-condensed !important;\n    }\n\n    @include media-breakpoint-up(lg) {\n\n        //Footer\n        .footer {\n            left: $leftbar-width-condensed !important;\n        }\n    }\n\n    //User box\n    .user-box {\n        display: none !important;\n    }\n}\n\n// Body min-height set\n@include media-breakpoint-up(md) {\n    body {\n        &[data-sidebar-size=\"condensed\"]:not([data-layout=\"compact\"]) {\n            min-height: $body-min-height;\n        }\n        &.authentication-bg {\n            min-height: auto !important;\n        }\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .pro-user-name {\n        display: none;\n    }\n}\n\n@include media-breakpoint-down(lg) {\n    body {\n        overflow-x: hidden;\n        padding-bottom: 80px;\n    }\n\n    .left-side-menu {\n        display: none;\n        z-index: 10 !important;\n    }\n\n    .sidebar-enable {\n        .left-side-menu {\n            display: block;\n        }\n    }\n\n    .content-page,\n    body[data-sidebar-size=\"condensed\"] .content-page {\n        margin-left: 0 !important;\n        padding: 0 10px;\n    }\n\n    //Footer\n    .footer {\n        left: 0 !important;\n    }\n}\n\n/* =============\n  Small Menu\n============= */\n\nbody[data-sidebar-size=\"compact\"]:not([data-sidebar-size=\"condensed\"]){\n    .logo-box {\n        width: $leftbar-width-sm !important;\n    }\n\n    .left-side-menu {\n        width: $leftbar-width-sm !important;\n        text-align: center;\n\n        #sidebar-menu {\n            >ul {\n\n                >li {\n                    >a {\n                        >i {\n                            display: block;\n                            font-size: 18px;\n                            line-height: 24px;\n                            width: 100%;\n                            margin: 0;\n                        }\n\n                        svg {\n                            display: block;\n                            margin: 0 auto 5px auto;\n                        }\n                    }\n                }\n\n                ul {\n                    padding-left: 0;\n\n                    a {\n                        padding: 10px 20px;\n                    }\n                }\n            }\n        }\n\n        .menu-arrow,\n        .badge {\n            display: none !important;\n        }\n\n        &+.content-page {\n            margin-left: $leftbar-width-sm;\n        }\n\n        +.content-page .footer {\n            left: $leftbar-width-sm;\n        }\n\n        .menu-title {\n            background-color: $gray-100;\n        }\n    }\n}\n\n\n// Leftbar-dark\nbody[data-sidebar-color=\"dark\"] {\n    .logo-box {\n        background-color: #ffffff !important;\n        border-right: 1px solid #e2e8f0 !important;\n    }\n\n    .left-side-menu {\n        background: linear-gradient(180deg, #020b18 0%, #031024 45%, #051329 100%) !important;\n        border-right-color: #0a1f3d !important;\n        box-shadow: 4px 0 24px rgba(0, 0, 0, 0.25);\n    }\n\n    &[data-sidebar-size=\"condensed\"] {\n        #wrapper {\n            .left-side-menu {\n                #sidebar-menu {\n                    >ul {\n                        >li {\n                            &:hover>a {\n                                background-color: $bg-leftbar-dark;\n                                box-shadow: none;\n                            }\n                        }\n                    }\n\n                    .menuitem-active {\n                        .active {\n                            color: $menu-item-active;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    &[data-sidebar-size=\"compact\"] {\n        #wrapper {\n            .left-side-menu {\n                .menu-title {\n                    background-color: rgba($white, 0.03);\n                }\n            }\n        }\n    }\n}\n\n\n// Leftbar with user\n.user-box {\n    display: none;\n}\n\n.user-pro-dropdown {\n    padding: 15px 5px !important;\n    width: 90%;\n    margin-left: 5%;\n    margin-top: 10px;\n\n    .dropdown-item {\n        border-radius: 3px;\n    }\n}\n\n// Detached Left sidebar\n\nbody[data-layout-mode=\"detached\"] {\n    .logo-box{\n        background-color: transparent !important;\n    }\n    @include media-breakpoint-up(lg) {\n        .navbar-custom {\n            .container-fluid {\n                max-width: 95%;\n            }\n        }\n\n        #wrapper {\n            max-width: 95%;\n            margin: 0 auto;\n        }\n\n        .left-side-menu {\n            margin-top: 30px;\n            margin-bottom: 30px;\n            border-radius: 5px;\n            border: 1px solid $gray-300;\n        }\n\n        .content-page {\n            padding-bottom: 30px;\n        }\n\n        .logo-box {\n            background-color: transparent;\n            background-image: none;\n        }\n    }\n}\n\n// Sidebar with User\nbody[data-sidebar-showuser=\"true\"] {\n    .user-box {\n        display: block;\n    }\n}","// \n// topbar.scss\n//\n\n// Logo\n.logo {\n    display: block;\n\n    span.logo-lg {\n        display: block;\n    }\n\n    span.logo-sm {\n        display: none;\n    }\n\n    .logo-lg-text-dark {\n        color: $dark;\n        font-weight: $font-weight-bold;\n        font-size: 22px;\n        text-transform: uppercase;\n    }\n\n    .logo-lg-text-light {\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: 22px;\n        text-transform: uppercase;\n    }\n}\n\n/* Default height for the logo */\n.logo Img {\n    height: 80px;\n  }\n  \n  /* Media query for smaller screens */\n  @media screen and (max-width: 768px) {\n    .logo Img {\n      height: 60px; /* Adjust the height for smaller screens */\n    }\n  }\n  \n  /* Media query for even smaller screens */\n  @media screen and (max-width: 576px) {\n    .logo Img{\n      height: 40px; /* Adjust the height for even smaller screens */\n    }\n   \n  }\n  @media screen and (max-width: 376px) {\n    .logo Img{\n      height: 35px; /* Adjust the height for even smaller screens */\n    }\n}\n.logo-box {\n    height: $topbar-height;\n    width: $leftbar-width;\n    float: left;\n    transition: all .1s ease-out;\n    padding: 0 14px;\n    background: #ffffff !important;\n    border-right: 1px solid #e2e8f0;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    z-index: 1002;\n\n    .sidebar-brand-link {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        text-decoration: none !important;\n        width: 100%;\n        overflow: hidden;\n    }\n\n    .sidebar-brand-mascot {\n        height: 50px;\n        width: auto;\n        max-width: 50px;\n        object-fit: contain;\n        flex-shrink: 0;\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));\n    }\n\n    .sidebar-brand-text {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        line-height: 1.15;\n        overflow: hidden;\n    }\n\n    .sidebar-brand-title {\n        font-weight: 800;\n        font-size: 18px;\n        color: #0b3558;\n        letter-spacing: -0.2px;\n        white-space: nowrap;\n    }\n\n    .sidebar-brand-subtitle {\n        font-weight: 700;\n        font-size: 10.5px;\n        color: #0284c7;\n        letter-spacing: 0px;\n        white-space: nowrap;\n    }\n\n    // Bare icon for medium widths - hidden by default (full combo graphic\n    // shown instead), see the media-breakpoint-down(xl) rule below.\n    .sidebar-brand-icon-only {\n        display: none;\n    }\n\n    .sidebar-brand-combo-img {\n        height: 58px;\n        width: auto;\n        object-fit: contain;\n        flex-shrink: 0;\n    }\n}\n\n// Vertical.tsx auto-switches the sidebar to condensed via JS between\n// 768-1028px (window resize handler, not a plain CSS breakpoint) - drop to\n// the bare icon there since the combo image's baked-in text has no room to\n// stay legible at that width. Above 1028px (not condensed) the combo stays\n// visible all the way up - it does not need to hide again below some fixed\n// breakpoint like 1200px, that range showed the combo just fine.\nbody[data-sidebar-size=\"condensed\"] {\n    .logo-box {\n        .sidebar-brand-combo {\n            display: none !important;\n        }\n        .sidebar-brand-icon-only {\n            display: block !important;\n        }\n    }\n}\n\n// District Coordinator contact - shown directly (name/designation/number),\n// not tucked behind a click, since it's meant to be glanceable from any page.\n// Collapses to icon-only below xl (not enough room for the text block\n// alongside search/profile), and disappears entirely below lg alongside the\n// rest of the topbar's optional content (see media-breakpoint-down(lg)\n// further down, which already hides .logo-box the same way).\n.topbar-district-contact {\n    // The multi-line text block can't use the surrounding .nav-link icons'\n    // line-height:$topbar-height centering trick (that only works for a\n    // single line) - give this its own full topbar height instead, so\n    // align-items:center (from the d-flex/align-items-center utility\n    // classes on this element) has a real height to center the icon+text\n    // against, rather than just its own content height at the top of the li.\n    height: $topbar-height;\n    gap: 8px;\n    padding: 0 12px;\n    line-height: 1.15;\n\n    &__icon {\n        color: #60a5fa;\n    }\n\n    &__icon-link {\n        color: inherit;\n        cursor: pointer;\n    }\n\n    &__text {\n        display: flex;\n        flex-direction: column;\n        white-space: nowrap;\n        overflow: hidden;\n    }\n\n    &__designation {\n        font-size: 0.65rem;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.02em;\n        color: rgba(255, 255, 255, 0.55);\n    }\n\n    &__detail {\n        font-size: 0.8rem;\n        font-weight: 600;\n        color: #ffffff;\n        text-decoration: none;\n\n        // __detail is a <span> wrapping an inline <a> in the desktop\n        // variant, but the <a> itself in the compact mobile variant - cover\n        // both rather than assuming which element carries the class.\n        &:hover {\n            text-decoration: underline;\n        }\n\n        a {\n            color: inherit;\n            text-decoration: none;\n\n            &:hover {\n                text-decoration: underline;\n            }\n        }\n    }\n\n    // Compact mobile variant (icon + phone number only) - see Topbar.tsx.\n    // Below lg the brand/search both disappear, leaving a blank gap between\n    // the hamburger button and profile picture; this fills it instead of\n    // also hiding, absolutely centered since the hamburger/profile on either\n    // side are floated, not flex siblings this could center itself against.\n    &--mobile {\n        gap: 6px;\n        padding: 0 8px;\n        max-width: 50vw;\n\n        .topbar-district-contact__designation {\n            font-size: 0.55rem;\n        }\n\n        .topbar-district-contact__detail {\n            font-size: 0.72rem;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n        }\n    }\n}\n\n// Reverted: this used to collapse the desktop variant's text block to\n// icon-only between lg and xl (leaving just __icon-link, dial-only via its\n// tel: href/title tooltip). Per instruction, the designation+name+number\n// text now stays visible at every width from lg up instead.\n// @include media-breakpoint-down(xl) {\n//     .topbar-district-contact:not(.topbar-district-contact--mobile) .topbar-district-contact__text {\n//         display: none;\n//     }\n// }\n\n@media (max-width: 991.98px) {\n    .topbar-district-contact--mobile {\n        position: absolute;\n        left: 50%;\n        top: 0;\n        transform: translateX(-50%);\n    }\n}\n\nbody[data-topbar-color=\"light\"] {\n    .topbar-district-contact {\n        &__icon {\n            color: #f77707;\n        }\n\n        &__designation {\n            color: rgba(0, 0, 0, 0.5);\n        }\n\n        &__detail {\n            color: #1e293b;\n        }\n    }\n}\n\n.navbar-custom {\n    background-color: $bg-topbar-dark;\n    padding: 0 10px 0 0;\n    position: fixed;\n    left: 0;\n    right: 0;\n    height: $topbar-height;\n    border-bottom: 1px solid $bg-topbar-dark;\n    z-index: 1001;\n\n    .topnav-menu {\n        >li {\n            float: left;\n        }\n\n        .nav-link {\n            padding: 0 12px;\n            color: rgba($white, 0.6);\n            min-width: 32px;\n            display: block;\n            line-height: $topbar-height;\n            text-align: center;\n            max-height: $topbar-height;\n\n            svg {\n                height: 20px;\n                width: 20px;\n                color: rgba($white,  0.6);\n                fill: rgba($white, 0.12);\n            }\n\n            &:hover,\n            &:focus,\n            &:active {\n                svg {\n                    color: $menu-item-active;\n                    fill: rgba($menu-item-active, 0.10);\n                }\n            }\n        }\n    }\n\n    .container-fluid {\n        padding: 0;\n    }\n\n     /* Search */\n    .app-search {\n        height: $topbar-height;\n        display: grid;\n        width: 180px;\n        margin-right: 20px;\n        align-items: center;\n\n        .react-select__placeholder,\n        input::placeholder {\n            font-size: 0.8125rem;\n            color: rgba($white, 0.3);\n            margin: 0;\n        }\n        \n        .react-select__menu {\n            overflow: hidden;\n            width: 320px !important;\n            margin-top: 0;\n        }\n\n        .react-select__input,\n        .react-select__value-container {\n            color: $white !important;\n            padding: 0;\n        }\n\n        .form-control,\n        .react-select__control {\n            border: none;\n            height: 38px;\n            padding-left: 20px;\n            padding-right: 0;\n            color: $white;\n            background-color: rgba($white, 0.07);\n            box-shadow: none;\n            // border-radius: 30px 30px 30px 30px;\n        }\n\n        .input-group-text {\n            margin-left: 0 !important;\n            z-index: 4;\n        }\n\n        .btn {\n            // background-color: rgba($white, 0.07);\n            border-color: transparent;\n            color: rgba($white, 0.3);\n            border-radius: 0 30px 30px 0;\n            box-shadow: none !important;\n        }\n    }\n\n    .button-menu-mobile {\n        border: none;\n        color: $white;\n        display: inline-block;\n        height: $topbar-height;\n        line-height: $topbar-height;\n        width: 60px;\n        background-color: transparent;\n        border: none;\n        padding: 0;\n        cursor: pointer;\n    }\n\n    .button-menu-mobile.disable-btn {\n        display: none;\n    }\n}\n\n\n/* Notification */\n.noti-scroll {\n    max-height: 230px;\n}\n\n.notification-list {\n    margin-left: 0;\n\n    .noti-title {\n        background-color: transparent;\n        padding: 15px 20px;\n    }\n\n    .noti-icon-badge {\n        display: inline-block;\n        position: absolute;\n        top: 14px;\n        right: 8px;\n    }\n\n    .notify-item {\n        padding: 12px 20px;\n\n        .notify-icon {\n            float: left;\n            height: 36px;\n            width: 36px;\n            line-height: 36px;\n            text-align: center;\n            margin-right: 10px;\n            border-radius: 50%;\n            color: $white;\n        }\n\n        .notify-details {\n            margin-bottom: 5px;\n            overflow: hidden;\n            margin-left: 45px;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            color: $gray-800;\n\n            b {\n                font-weight: 500;\n            }\n\n            small {\n                display: block;\n            }\n\n            span {\n                display: block;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                font-size: 13px;\n            }\n        }\n\n        .user-msg {\n            margin-left: 45px;\n            white-space: normal;\n            line-height: 16px;\n        }\n    }\n\n    .profile-dropdown {\n        .notify-item {\n            padding: 7px 20px;\n        }\n    }\n}\n\n.noti-icon {\n    font-size: 21px;\n    vertical-align: middle;\n}\n\n.profile-dropdown {\n    min-width: 170px !important;\n\n    i {\n        vertical-align: middle;\n        margin-right: 5px;\n    }\n}\n\n.nav-user {\n    padding: 0 12px !important;\n\n    img {\n        height: 32px;\n        width: 32px;\n    }\n}\n\n@include media-breakpoint-down(lg) {\n    .logo-box {\n        width: $leftbar-width-condensed !important;\n        padding-right: 0 !important;\n        border-bottom: 1px solid $gray-300;\n\n        .logo-lg {\n            display: none !important;\n        }\n\n        .logo-sm {\n            display: block !important;\n        }\n\n        // Below lg, LeftSidebar's own mobile drawer brand (.sidebar-mobile-brand,\n        // d-lg-none) replaces this topbar one entirely - matching that cutover\n        // instead of squeezing the combo/icon into an even narrower box.\n        display: none !important;\n    }\n}\n\n@media (max-width: 600px) {\n    .navbar-custom {\n        .dropdown {\n            position: static;\n\n            .dropdown-menu {\n                left: 10px !important;\n                right: 10px !important;\n            }\n        }\n    }\n}\n\n\n// Light Topbar\n\nbody[data-topbar-color=\"light\"] {\n    .navbar-custom {\n        background-color: $bg-topbar-light !important;\n        border-bottom: 1px solid $gray-300;\n\n        .topnav-menu {\n            .nav-link {\n                color: $dark;\n\n                svg {\n                    color: $dark;\n                    fill: rgba($dark, 0.12);\n                }\n\n                &:hover,\n                &:focus,\n                &:active {\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n            }\n        }   \n\n        .button-menu-mobile {\n            color: $dark;\n        }\n\n        /* Search */\n        .app-search {\n            \n        .react-select__placeholder,\n            input::placeholder {\n                color: $gray-500 !important;\n            }\n\n            .react-select__input,\n            .react-select__value-container {\n                color: $dark !important;\n                padding: 0;\n            }\n\n            .form-control,\n            .react-select__control {\n                color: $dark !important;\n                background-color: $gray-200;\n                border-color: $gray-200;\n            }\n\n            .btn {\n                background-color: $gray-200;\n                color: $gray-400;\n            }\n        }\n    }\n\n    .logo-box {\n        background: $bg-leftbar;\n        border-right: 1px solid $gray-300;\n    }\n\n    .logo-dark {\n        display: block;\n    }\n\n    .logo-light {\n        display: none;\n    }\n}\n\n@include media-breakpoint-down(lg) {\n    body[data-layout-mode=\"horizontal\"] {\n\n        // Navbar Button - Horizontal\n        .navbar-toggle {\n            border: 0;\n            position: relative;\n            padding: 0;\n            margin: 0;\n            cursor: pointer;\n\n            .lines {\n                width: 25px;\n                display: block;\n                position: relative;\n                height: 16px;\n                transition: all .5s ease;\n                margin-top: calc(#{$topbar-height - 16px} * 0.5);\n            }\n\n            span {\n                height: 2px;\n                width: 100%;\n                background-color: $gray-700;\n                display: block;\n                margin-bottom: 5px;\n                transition: transform .5s ease;\n            }\n\n            &.open {\n                span {\n                    position: absolute;\n\n                    &:first-child {\n                        top: 7px;\n                        transform: rotate(45deg);\n                    }\n\n                    &:nth-child(2) {\n                        visibility: hidden;\n                    }\n\n                    &:last-child {\n                        width: 100%;\n                        top: 7px;\n                        transform: rotate(-45deg);\n                    }\n                }\n            }\n        }\n    }\n}\n\nbody[data-layout-mode=\"horizontal\"] {\n    .button-menu-mobile {\n        display: none;\n    }\n\n    .logo-box {\n        width: auto;\n        padding-right: 50px;\n        background-color: transparent;\n        padding-left: 0;\n        border: none !important;\n    }\n\n    @media  (max-width: 1366px) {\n        .logo-box {\n            padding-left: 20px;\n        }\n    }\n}\n\n@media (max-width: 360px) {\n    .navbar-custom {\n        .topnav-menu {\n            \n            .nav-link {\n                padding: 0 12px;\n            }\n        }\n        .button-menu-mobile {\n            width: 45px;\n        }\n    }\n}\n\nbody[data-layout-mode=\"two-column\"] { \n    .logo-box {\n        display: none;\n    }\n}","// \n// page-title.scss\n//\n\n.page-title-box {\n    align-items: center;\n    justify-content: space-between;\n    display: flex;\n    margin: 0 -27px 0;\n    padding: 20px 27px;\n\n    .page-title {\n        font-size: 1.05rem;\n        margin: 0;\n    }\n\n    .breadcrumb {\n        padding: 0;\n    }\n}\n\n@media (max-width: 639px) {\n    .page-title-box {\n        display: block;\n\n        .page-title {\n            display: block;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n        }\n        .page-title-right {\n            display: block;\n            padding-top: 5px;\n        }\n    }\n}","// \n// footer.scss\n//\n\n.footer {\n    bottom: 0;\n    padding: 19px 15px 20px;\n    position: absolute;\n    right: 0;\n    color: $text-muted;\n    left: $leftbar-width;\n    border-top: 1px solid $card-border-color;\n\n    .footer-links {\n        a {\n            color: $text-muted;\n            margin-left: 1.5rem;\n            transition: all .4s;\n            &:hover {\n                color: $gray-900;\n            }\n            &:first-of-type {\n                margin-left: 0;\n            }\n        }\n    }\n}\n\n.footer-alt {\n    left: 0 !important;\n    text-align: center;\n    background-color: transparent;\n}\n\n@include media-breakpoint-down(sm) {\n    .footer {\n        left: 0 !important;\n        text-align: center;\n    }\n}\n\nbody[data-layout-mode=\"horizontal\"] {\n    .footer {\n        left: 0 !important;\n    }\n\n    &[data-layout-width=\"boxed\"] {\n        .footer {\n            max-width: $boxed-layout-width !important;\n        }\n    }\n}\n\nbody[data-layout-mode=\"detached\"] {\n    @include media-breakpoint-up(lg) {\n        .footer {\n            position: inherit;\n            margin: 0 10px;\n        }\n    }\n}","//\n// right-sidebar.scss\n//\n\n.right-bar {\n    background-color: $rightbar-bg;\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n    display: block;\n    position: fixed;\n    transition: all 200ms ease-out;\n    width: $rightbar-width;\n    z-index: 9999;\n    float: right !important;\n    right: -($rightbar-width + 10px);\n    top: 0;\n    bottom: 0;\n\n    .rightbar-title {\n        background-color: $primary;\n        padding: 27px 25px;\n        color: $white;\n    }\n\n    .right-bar-toggle {\n        background-color: lighten($dark, 7%);\n        height: 24px;\n        width: 24px;\n        line-height: 27px;\n        color: $white;\n        text-align: center;\n        border-radius: 50%;\n        margin-top: -4px;\n\n        &:hover {\n            background-color: lighten($dark, 10%);\n        }\n    }\n\n    .user-box {\n        padding: 25px;\n        text-align: center;\n\n        .user-img {\n            position: relative;\n            height: 64px;\n            width: 64px;\n            margin: 0 auto 15px auto;\n\n            .user-edit {\n                position: absolute;\n                right: -5px;\n                bottom: 0px;\n                height: 24px;\n                width: 24px;\n                background-color: $white;\n                line-height: 24px;\n                border-radius: 50%;\n                box-shadow: $box-shadow-lg;\n            }\n        }\n\n        h5 {\n            margin-bottom: 2px;\n\n            a {\n                color: $dark;\n            }\n        }\n    }\n\n    .notification-item {\n        .media {\n            padding: 0.75rem 1rem;\n\n            &:hover {\n                background-color: $dropdown-link-hover-bg;\n            }\n        }\n\n        .user-status {\n            position: absolute;\n            right: 0px;\n            bottom: -4px;\n            font-size: 10px;\n\n            &.online {\n                color: $success;\n            }\n\n            &.away {\n                color: $warning;\n            }\n\n            &.busy {\n                color: $danger;\n            }\n        }\n    }\n}\n\n// Rightbar overlay\n.rightbar-overlay {\n    background-color: rgba($dark, 0.2);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 9998;\n    transition: all .2s ease-out;\n}\n\n.right-bar-enabled {\n    .right-bar {\n        right: 0;\n    }\n\n    .rightbar-overlay {\n        display: block;\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .right-bar {\n        overflow: auto;\n\n        .slimscroll-menu {\n            height: auto !important;\n        }\n    }\n}","//\n// layouts.scss\n//\n\nbody[data-layout-width=\"boxed\"] {\n    #wrapper {\n        max-width: $boxed-layout-width;\n        margin: 0 auto;\n        box-shadow: $box-shadow-lg;\n    }\n\n    .navbar-custom {\n        max-width: $boxed-layout-width;\n        margin: 0 auto;\n    }\n\n    .footer {\n        margin: 0 auto;\n        max-width: calc(#{$boxed-layout-width} - #{$leftbar-width});\n    }\n\n    &[data-sidebar-size=\"condensed\"] {\n        .footer {\n            max-width: calc(#{$boxed-layout-width} - #{$leftbar-width-condensed});\n        }\n    }\n\n    &[data-sidebar-size=\"compact\"] {\n        .footer {\n            max-width: calc(#{$boxed-layout-width} - #{$leftbar-width-sm});\n        }\n    }\n}\n\n// Body min-height set\n@include media-breakpoint-up(md) {\n    body[data-layout-width=\"boxed\"][data-sidebar-size=\"condensed\"] {\n        .content-page {\n            min-height: calc(#{$body-min-height} - #{$leftbar-width-condensed});\n        }\n    }\n}\n\n// Scrollable Layout\n@include media-breakpoint-up(xl) {\n    body[data-layout-menu-position=\"scrollable\"]:not([data-sidebar-size=\"condensed\"]):not([data-sidebar-size=\"compact\"]):not([data-layout-mode=\"two-column\"]) {\n        padding-bottom: 0;\n\n        #wrapper {\n            display: flex;\n        }\n\n        .navbar-custom,\n        .topnav {\n            position: absolute;\n        }\n\n        .left-side-menu {\n            position: relative;\n            min-width: $leftbar-width;\n            max-width: $leftbar-width;\n            padding: 20px 0 calc(#{$topbar-height} + 20px);\n        }\n\n        .content-page {\n            margin-left: 0;\n            width: 100%;\n            padding-bottom: 60px;\n        }\n    }\n}","// \n// _horizontal.scss\n//\n\n// Container width\nbody[data-layout-mode=\"horizontal\"] {\n    @include media-breakpoint-up(xl) {\n        .container-fluid {\n            max-width: $horizontal-layout-width;\n        }\n\n        .navbar-custom {\n            padding: 0 $grid-gutter-width;\n        }\n    }\n\n    .content-page {\n        margin-left: 0 !important;\n    }\n}\n\n.topnav {\n    background: $bg-topbar-light;\n    border-bottom: 1px solid $gray-300;\n    margin-top: $topbar-height;\n    padding: 0 calc(#{$grid-gutter-width} * 0.5);\n    position: fixed;\n    left: 0;\n    right: 0;\n    z-index: 100;\n\n    .topnav-menu {\n        margin: 0;\n        padding: 0;\n    }\n\n    .navbar-nav {\n\n        .nav-link {\n            font-size: $menu-item-size;\n            position: relative;\n            line-height: 22px;\n            padding: calc(#{$topnav-height - 22px} * 0.5) 1.1rem;\n            color: $hori-menu-item-color;\n            font-family: $font-family-secondary;\n\n            i {\n                font-size: 15px;\n                display: inline-block;\n            }\n\n            svg {\n                display: inline-block;\n                width: 16px;\n                height: 16px;\n                margin: -4px 5px 0 0;\n                color: $hori-menu-item-color;\n                fill: rgba($hori-menu-item-color, 0.12);\n            }\n\n            &:focus,\n            &:hover {\n                color: $menu-item-hover;\n                background-color: transparent;\n            }\n        }\n\n        .nav-item {\n            .dropdown.active {\n                > a.dropdown-toggle {\n                    color: $menu-item-active;\n                }\n            }\n            &.active {\n                > a {\n                    color: $menu-item-active;\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.12);\n                    }\n                } \n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(lg) {\n    .topnav {\n        height: $topnav-height;\n\n        .navbar-nav {\n            .nav-item {\n                &:first-of-type {\n                    .nav-link {\n                        padding-left: 0;\n                    }\n                }\n            }\n        }\n\n        .dropdown-item {\n            padding: .5rem 1.25rem;\n            min-width: 180px;\n            margin: 0 .3rem;\n            width: auto;\n\n            &.active {\n                background-color: transparent;\n                color: $menu-item-active;\n            }\n        }\n\n        .dropdown {\n            &.mega-dropdown {\n\n                // position: static;\n                .mega-dropdown-menu {\n                    left: 0px;\n                    right: auto;\n                }\n            }\n\n            .dropdown-menu {\n                padding: 0.3rem 0;\n                margin-top: 0;\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\n\n                .arrow-down {\n                    &::after {\n                        right: 20px;\n                        transform: rotate(-135deg) translateY(-50%);\n                        position: absolute;\n                    }\n                }\n\n                .dropdown {\n                    .dropdown-menu {\n                        position: absolute;\n                        top: 0 !important;\n                        left: 100%;\n                        display: none;\n                    }\n                }\n            }\n\n            &:hover {\n                >.nav-link {\n                    color: $menu-item-hover;\n\n                    svg {\n                        color: $menu-item-hover;\n                        fill: rgba($menu-item-hover, 0.12);\n                    }\n                }\n\n                >.dropdown-menu {\n                    display: block;\n\n                    >.dropdown:hover {\n                        >.dropdown-item {\n                            color: $menu-item-active;\n                        }\n\n                        >.dropdown-menu {\n                            display: block;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .navbar-toggle {\n        display: none;\n    }\n\n    body[data-layout-mode=\"horizontal\"] {\n        .content-page {\n            padding: $topnav-height 12px 65px 12px;\n        }\n    }\n}\n\n.arrow-down {\n    display: inline-block;\n\n    &:after {\n        border-color: initial;\n        border-style: solid;\n        border-width: 0 0 1px 1px;\n        content: \"\";\n        height: .4em;\n        display: inline-block;\n        right: 5px;\n        top: 50%;\n        margin-left: 10px;\n        transform: rotate(-45deg) translateY(-50%);\n        transform-origin: top;\n        transition: all .3s ease-out;\n        width: .4em;\n    }\n}\n\n\n\n@include media-breakpoint-down(xl) {\n    .topnav-menu {\n        .navbar-nav {\n            li {\n                &:last-of-type {\n                    .dropdown {\n                        .dropdown-menu {\n                            right: 100%;\n                            left: auto;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(lg) {\n\n    .topnav {\n        max-height: 360px;\n        overflow-y: auto;\n        padding: 0;\n\n        .navbar-nav {\n            .nav-link {\n                padding: 0.75rem 1.1rem;\n            }\n        }\n\n        .dropdown {\n            .dropdown-menu {\n                background-color: transparent;\n                border: none;\n                box-shadow: none;\n                padding-left: 15px;\n            }\n\n            .dropdown-item {\n                position: relative;\n                background-color: transparent;\n\n                &.active,\n                &:active {\n                    color: $menu-item-active;\n                }\n            }\n        }\n\n        .arrow-down {\n            &::after {\n                right: 15px;\n                position: absolute;\n            }\n        }\n    }\n}\n\nbody[data-layout-mode=\"horizontal\"][data-layout-width=\"boxed\"] {\n    .topnav {\n        max-width: $boxed-layout-width;\n        margin: $topbar-height auto 0;\n    }\n}\n\n// dark-mode\nbody[data-layout-mode=horizontal] {\n    .logo-box {\n        background-color: transparent !important;\n    }\n}\n\n","// \n// two-column-menu.scss\n//\nbody[data-layout-mode=\"two-column\"] {\n    .left-side-menu {\n        width: calc(#{$twocolumn-sidebar-iconview-width} + #{$twocolumn-sidebar-width});\n        background-color: transparent;\n        box-shadow: none;\n    }\n\n    .sidebar-icon-menu {\n        position: fixed;\n        width: $twocolumn-sidebar-iconview-width;\n        z-index: 500;\n        top: 0;\n        bottom: 0;\n        padding-bottom: 20px;\n        background-color: $twocolumn-sidebar-iconview-bg;\n\n        .logo {\n            display: block;\n            width: 70px;\n            height: 70px;\n            line-height: 70px;\n            text-align: center;\n        }\n\n        .nav {\n            background-color: transparent;\n            margin: 24px auto;\n\n            .nav-link {\n                text-align: center;\n                width: 40px;\n                height: 40px;\n                line-height: 40px;\n                margin: 12px auto;\n                padding: 0px;\n                border-radius: 4px;\n\n                &.active {\n                    background-color: rgba($white, 0.12);\n                }\n\n                svg {\n                    color: $white;\n                    fill: rgba($white, 0.12);\n                    height: 22px;\n                    width: 22px;\n                }\n            }\n        }\n    }\n\n    .sidebar-main-menu {\n        display: block;\n        position: fixed;\n        width: $twocolumn-sidebar-width;\n        background-color: $twocolumn-sidebar-bg;\n        top: $topbar-height;\n        bottom: 0;\n        left: $twocolumn-sidebar-iconview-width;\n        padding: 30px 5px;\n        border-right: 1px solid $gray-300;\n        transition: all .1s ease-out;\n\n        .sidebar-menu-body {\n            padding: 20px;\n        }\n\n        .menu-title {\n            color: $gray-500 !important;\n            margin: 0;\n            padding: 10px 20px;\n            letter-spacing: .05em;\n            font-size: .7rem;\n            text-transform: uppercase;\n            font-weight: 600;\n        }\n\n        .nav {\n            >.nav-item {\n                >.nav-link {\n                    color: $menu-item;\n                    font-size: $menu-item-size;\n                    font-family: $font-family-secondary;\n                }\n\n                .menu-arrow {\n                    right: 10px;\n                }\n            }\n\n            .nav-link {\n                position: relative;\n                color: $menu-item;\n                padding: 6px 15px;\n                border-radius: 3px;\n                margin: 3px 5px;\n\n                &:hover,\n                &:focus,\n                &.active {\n                    color: $menu-item-active;\n                }\n            }\n\n            .menuitem-active {\n                > a.nav-link {\n                    color: $menu-item-active;\n                    background-color: rgba($menu-item-active, 0.07);\n                }\n\n                a.active {\n                    color: $menu-item-active;\n                }\n            }\n        }\n\n        #sidebar-menu {\n            .menu-arrow {\n                top: 7px;\n            }\n        }\n\n        .nav-second-level{\n            padding-left: 15px;\n            list-style: none;\n        }\n    }\n\n    @include media-breakpoint-up(lg) {\n        .navbar-custom {\n            left: $twocolumn-sidebar-iconview-width !important;\n            padding-left: 0px;\n\n            .logo-box {\n                width: $twocolumn-sidebar-width;\n\n                .logo-sm {\n                    display: none;\n                }\n            }\n        }\n\n        &[data-sidebar-size=\"condensed\"] {\n            .logo-box {\n                width: 0 !important;\n            }\n        }\n    }\n\n    &[data-sidebar-color=\"light\"]{\n        .logo-box {\n            background-color: $twocolumn-sidebar-bg;\n        }\n    }\n\n    @include media-breakpoint-up(lg) {\n        .content-page {\n            margin-left: calc(#{$twocolumn-sidebar-iconview-width} + #{$twocolumn-sidebar-width});\n        }\n\n        .footer {\n            left: calc(#{$twocolumn-sidebar-iconview-width} + #{$twocolumn-sidebar-width});\n        }\n\n        &[data-sidebar-size=\"condensed\"] {\n            .sidebar-main-menu {\n                display: none;\n            }\n        }\n    }\n\n    .twocolumn-menu-item {\n        display: none;\n    }\n\n    &[data-sidebar-color=\"dark\"] {\n        .sidebar-main-menu {\n            background-color: $bg-leftbar-dark;\n    \n            .nav {\n                >.nav-item {\n                    >.nav-link {\n                        color: $menu-item-color-dark;\n                    }\n                }\n    \n                .nav-link {\n    \n                    &:hover,\n                    &:focus,\n                    &.active {\n                        color: $menu-item-hover-color-dark;\n                    }\n                }\n    \n                .menuitem-active {\n                    > a.nav-link {\n                        color: $menu-item-active;\n                        background-color: rgba($menu-item-active, 0.07);\n                    }\n    \n                    a.active {\n                        color: $menu-item-active;\n                    }\n                }\n            }\n        }\n    }\n\n    &[data-sidebar-color=\"brand\"],\n    &[data-sidebar-color=\"gradient\"] {\n        .sidebar-main-menu {\n    \n            .nav {\n                >.nav-item {\n                    >.nav-link {\n                        color: rgba($white, 0.7);\n                    }\n                }\n    \n                .nav-link {\n    \n                    &:hover,\n                    &:focus,\n                    &.active {\n                        color: rgba($white, 0.9);\n                    }\n                }\n            }\n        }\n    }\n\n    &[data-layout-width=\"boxed\"] {\n        .navbar-custom {\n            max-width: calc(#{$boxed-layout-width} - #{$twocolumn-sidebar-iconview-width});\n        }\n\n        .sidebar-main-menu {\n            position: absolute;\n            top: 0;\n        }\n    }\n\n    &[data-layout-width=\"boxed\"]:not([data-sidebar-size=\"condensed\"]) {\n        .footer {\n            max-width: calc(#{$boxed-layout-width} - #{calc(#{$twocolumn-sidebar-iconview-width} + #{$twocolumn-sidebar-width})});\n        }\n    }\n}","//\n// avatar.scss (avatar thumbnail sizes)\n//\n\n// avatar height\n.avatar-xs {\n    height: 1.5rem;\n    width: 1.5rem;\n}\n\n.avatar-sm {\n    height: 2.25rem;\n    width: 2.25rem;\n}\n\n.avatar {\n    height: 3rem;\n    width: 3rem;\n}\n\n.avatar-md {\n    height: 3.5rem;\n    width: 3.5rem;\n}\n\n.avatar-lg {\n    height: 4.5rem;\n    width: 4.5rem;\n}\n\n.avatar-xl {\n    height: 6rem;\n    width: 6rem;\n}\n\n.avatar-xxl {\n    height: 7.5rem;\n    width: 7.5rem;\n}\n\n.avatar-title {\n    align-items: center;\n    color: $white;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    width: 100%;\n}\n\n.avatar-group {\n    padding-left: 12px;\n\n    .avatar-group-item {\n        margin: 0 0 10px -12px;\n        display: inline-block;\n        border: 2px solid $white;\n        border-radius: 50%;\n    }\n}","// \n// Custom-checkbox.scss\n//\n\n.checkbox {\n    label {\n        display: inline-block;\n        padding-left: 8px;\n        position: relative;\n        font-weight: 500;\n        margin-bottom: 0;\n        &::before {\n            background-color: $gray-300;\n            border-radius: 3px;\n            border: 2px solid $gray-300;\n            content: \"\";\n            display: inline-block;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            position: absolute;\n            transition: 0.3s ease-in-out;\n            width: 18px;\n            outline: none !important;\n            top: 2px;\n        }\n        &::after {\n            color: $gray-700;\n            display: inline-block;\n            font-size: 11px;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            padding-left: 3px;\n            padding-top: 2px;\n            position: absolute;\n            top: 0;\n            width: 18px;\n        }\n    }\n    input[type=\"checkbox\"] {\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n        outline: none !important;\n        &:disabled+label {\n            opacity: 0.65;\n        }\n    }\n    input[type=\"checkbox\"]:focus+label {\n        &::before {\n            outline-offset: -2px;\n            outline: none;\n        }\n    }\n    input[type=\"checkbox\"]:checked+label {\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 6px;\n            left: 7px;\n            display: table;\n            width: 4px;\n            height: 8px;\n            border: 2px solid $gray-700;\n            border-top-width: 0;\n            border-left-width: 0;\n            transform: rotate(45deg);\n        }\n    }\n    input[type=\"checkbox\"]:disabled+label {\n        &::before {\n            background-color: $light;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.checkbox.checkbox-circle {\n    label {\n        &::before {\n            border-radius: 50%;\n        }\n    }\n}\n\n.checkbox.checkbox-inline {\n    margin-top: 0;\n}\n\n.checkbox.checkbox-single {\n    input {\n        height: 18px;\n        width: 18px;\n        position: absolute;\n    }\n    label {\n        height: 18px;\n        width: 18px;\n        &:before {\n            margin-left: 0;\n        }\n        &:after {\n            margin-left: 0;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .checkbox-#{$color} {\n        input[type=\"checkbox\"]:checked+label {\n            &::before {\n                background-color: $value;\n                border-color: $value;\n            }\n            &::after {\n                border-color: $white;\n            }\n        }\n    }\n}","// \n// custom-radio.scss\n//\n\n.radio {\n    label {\n        display: inline-block;\n        padding-left: 8px;\n        position: relative;\n        font-weight: 500;\n        margin-bottom: 0;\n        &::before {\n            background-color: $white;\n            border-radius: 50%;\n            border: 2px solid $gray-600;\n            content: \"\";\n            display: inline-block;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            position: absolute;\n            transition: border 0.5s ease-in-out;\n            width: 18px;\n            outline: none !important;\n        }\n        &::after {\n            background-color: $gray-700;\n            border-radius: 50%;\n            content: \" \";\n            display: inline-block;\n            height: 10px;\n            left: 6px;\n            margin-left: -20px;\n            position: absolute;\n            top: 4px;\n            transform: scale(0, 0);\n            transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            width: 10px;\n        }\n    }\n    input[type=\"radio\"] {\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n        outline: none !important;\n        &:disabled+label {\n            opacity: 0.65;\n        }\n    }\n    input[type=\"radio\"]:focus+label {\n        &::before {\n            outline-offset: -2px;\n            outline: 5px auto -webkit-focus-ring-color;\n            outline: thin dotted;\n        }\n    }\n    input[type=\"radio\"]:checked+label {\n        &::after {\n            transform: scale(1, 1);\n        }\n    }\n    input[type=\"radio\"]:disabled+label {\n        &::before {\n            cursor: not-allowed;\n        }\n    }\n}\n\n.radio.radio-inline {\n    margin-top: 0;\n}\n\n.radio.radio-single {\n    label {\n        height: 17px;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .radio-#{$color} {\n        input[type=\"radio\"]+label {\n            &::after {\n                background-color: $value;\n            }\n        }\n        input[type=\"radio\"]:checked+label {\n            &::before {\n                border-color: $value;\n            }\n            &::after {\n                background-color: $value;\n            }\n        }\n    }\n}","//\n// helper.scss\n//\n\n// Minimum width\n\n.width-xs {\n    min-width: 80px;\n}\n\n.width-sm {\n    min-width: 100px;\n}\n\n.width-md {\n    min-width: 120px;\n}\n\n.width-lg {\n    min-width: 140px;\n}\n\n.width-xl {\n    min-width: 160px;\n}\n\n\n// Font Family\n.font-family-primary {\n    font-family: $font-family-base;\n}\n\n.font-family-secondary {\n    font-family: $font-family-secondary;\n}\n\n// Text specify lines (Only chrome browser support)\n\n.sp-line-1,\n.sp-line-2,\n.sp-line-3,\n.sp-line-4 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n}\n\n.sp-line-1 {\n    -webkit-line-clamp: 1;\n}\n\n.sp-line-2 {\n    -webkit-line-clamp: 2;\n}\n\n\n.sp-line-3 {\n    -webkit-line-clamp: 3;\n}\n\n.sp-line-4 {\n    -webkit-line-clamp: 4;\n}\n\n// Icons\n.icon-dual {\n    color: $text-muted;\n    fill: rgba($text-muted, 0.12);\n}\n\n@each $color,\n$value in $theme-colors {\n    .icon-dual-#{$color} {\n        color: $value;\n        fill: rgba($value, 0.16);\n    }\n}\n\n.icon-xs {\n    height: 16px;\n    width: 16px;\n}\n\n.icon-sm {\n    height: 24px;\n    width: 24px;\n}\n\n.icon-md {\n    height: 32px;\n    width: 32px;\n}\n\n.icon-lg {\n    height: 40px;\n    width: 40px;\n}\n\n.icon-xl {\n    height: 48px;\n    width: 48px;\n}\n\n.icon-xxl {\n    height: 60px;\n    width: 60px;\n}\n\n// Hover item\n.item-hovered {\n    &:hover {\n        background-color: $dropdown-link-hover-bg;\n    }\n}\n\n// cursor\n.cursor-pointer {\n    cursor: pointer;\n}","\n// \n// social.scss\n//\n\n.social-list-item {\n    height: 2rem;\n    width: 2rem;\n    line-height: calc(2rem - 2px);\n    display: block;\n    border: 2px solid $gray-500;\n    border-radius: 50%;\n    color: $gray-500;\n}  ","// \n// widgets.scss\n//\n\n\n// Simple tile box\n.widget-flat {\n    position: relative;\n    overflow: hidden;\n\n    i.widget-icon {\n        font-size: 36px;\n    }\n}\n\n/* Chat widget */\n\n.conversation-list {\n    list-style: none;\n    height: 332px;\n    padding: 0 7px;\n    outline: none;\n    li {\n        margin-bottom: 24px;\n    }\n\n    .chat-avatar {\n        float: left;\n        text-align: center;\n        width: 38px;\n\n        img {\n            border-radius: 100%;\n            width: 100%;\n        }\n\n        i {\n            font-size: 12px;\n            font-style: normal;\n        }\n    }\n\n    .ctext-wrap {\n        background: lighten($primary, 32%);\n        color: $primary;\n        border-radius: $border-radius;\n        display: inline-block;\n        padding: 4px 12px;\n        position: relative;\n        // min-width: 160px;\n\n        i {\n            display: block;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: $font-weight-bold;\n            position: relative;\n        }\n\n        p {\n            margin: 0;\n            padding-top: 3px;\n        }\n\n        &:after {\n            right: 98%;\n            top: 0;\n            border: solid transparent;\n            content: \" \";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-top-color: lighten($primary, 32%);\n            border-width: 6px;\n            margin-left: -1px;\n            border-right-color: lighten($primary, 32%);\n        }\n    }\n\n    .conversation-text {\n        float: left;\n        font-size: 12px;\n        margin-left: 12px;\n        width: 70%;\n    }\n\n    .odd {\n        .chat-avatar {\n            float: right !important;\n        }\n\n        .conversation-text {\n            float: right !important;\n            margin-right: 12px;\n            text-align: right;\n            width: 70% !important;\n        }\n\n        .ctext-wrap {\n            background-color: $gray-300;\n            color: $gray-700;\n            &:after {\n                border-color: transparent;\n                border-left-color: $gray-300;\n                border-top-color: $gray-300;\n                left: 99% !important;\n            }\n        }\n    }\n}\n\n/* profile / users */\n.profile-widget {\n    position: relative;\n\n    .card-action {\n        position: absolute;\n        right: 7px;\n        top: 12px;\n        z-index: 100;\n    }\n\n    .card-img-top {\n        max-height: 220px;\n    }\n\n    .profile-info {\n        margin-top: -2.7rem;\n    }\n}\n\n.calendar-widget {\n    .flatpickr-calendar {\n        box-shadow: none;\n        border: $border-width solid $border-color !important;\n    }\n}\n\n.activity-widget{\n    .activity-list{\n        border-bottom: 1px solid $gray-200;\n        padding: 12px 0px;\n        &:last-child{\n            border: none;\n        }\n    }\n}\n","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .left-side-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-custom,\n    .footer {\n        display: none;\n    }\n    .card-body,\n    .content-page,\n    .right-bar,\n    .content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n    .card {\n        border: none;\n    }\n}","// \n// preloader.scss\n//\n\n#preloader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba($card-bg, 0.85);\n    z-index: 9999;\n}\n\n#status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -20px 0 0 -20px;\n}\n\n.spinner {\n    margin: 0 auto;\n    font-size: 10px;\n    position: relative;\n    text-indent: -9999em;\n    border-top: 5px solid $gray-300;\n    border-right: 5px solid $gray-300;\n    border-bottom: 5px solid $gray-300;\n    border-left: 5px solid $primary;\n    transform: translateZ(0);\n    animation: SpinnerAnimation 1.1s infinite linear;\n}\n\n.spinner,\n.spinner:after {\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n}\n\n@keyframes SpinnerAnimation {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}","//\n// authentication.scss\n//\n\n// authentication pages background\nbody {\n    &.authentication-bg {\n        background-size: cover;\n        background-repeat: no-repeat;\n        padding-bottom: 0;\n    }\n}\n\n\n.authentication-form {\n    .form-group {\n        .input-group-text {\n            background-color: transparent;\n\n            svg {\n                height: 20px;\n                width: 20px;\n            }\n        }\n    }\n}\n\n.icon-fb {\n    color: #3c5a98;\n}\n\n.icon-google {\n    color: #e94134;\n}\n\n\n\n.auth-page-sidebar {\n    padding: 0;\n    // background-image: url('../../../images/auth-bg.jpg');\n    // background-image: url('../../../images/sports-login-image-cms.png');\n    // background-image: url('../../../images/admin-control-panel-vector.jpg');\n    background-image: url('../../../images/Templates-banner.svg');\n\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 100%;\n    position: relative;\n   \n\n    .overlay {\n        flex: 1;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background-color: rgba($black,.4);\n    }\n\n    .auth-user-testimonial {\n        text-align: center;\n        color: $white;\n        position: absolute;\n        margin: 0 auto;\n        padding: 0 1.75rem;\n        bottom: 3rem;\n        left: 0;\n        right: 0;\n    }\n}\n\n// auth-logo\n.auth-logo {\n    .logo-light {\n        display: $logo-auth-light-display !important;\n    }\n    .logo-dark {\n        display: $logo-auth-dark-display !important;\n    }\n}\n\n// logout\n.logout-checkmark {\n    width: 90px;\n    margin: 0 auto;\n    padding: 20px 0;\n\n    .path {\n        stroke-dasharray: 1000;\n        stroke-dashoffset: 0;\n        animation: dash 2s ease-in-out;\n    }\n\n    .spin {\n        animation: spin 2s;\n        transform-origin: 50% 50%;\n    }\n}\n\n@keyframes dash {\n    0% {\n        stroke-dashoffset: 1000;\n    }\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n@keyframes spin {\n    0% {\n        -webkit-transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n    }\n}\n\n@keyframes text {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n// Shared Mashaal brand lockup (logo + wordmark), used across auth pages\n.mashaal-brand {\n    display: inline-flex;\n    align-items: flex-start;\n    gap: 12px;\n    text-decoration: none;\n    margin-bottom: 20px;\n\n    &__mascot {\n        width: 56px;\n        height: auto;\n    }\n\n    // Single combined mascot+title+subtitle graphic (replaces the\n    // __mascot + __text/__title/__subtitle pieces above)\n    &__combo {\n        height: 68px;\n        width: auto;\n    }\n\n    &__text {\n        display: flex;\n        flex-direction: column;\n        line-height: 1.2;\n        text-align: left;\n    }\n\n    &__title {\n        font-weight: 800;\n        font-size: 1.25rem;\n        color: #101828;\n    }\n\n    &__subtitle {\n        font-weight: 700;\n        font-size: 0.8rem;\n        color: #101828;\n    }\n\n    &--on-dark {\n        .mashaal-brand__title,\n        .mashaal-brand__subtitle {\n            color: #ffffff;\n        }\n    }\n}\n\n// School login page\n.school-login-page {\n    position: relative;\n    min-height: 100vh;\n    display: flex;\n    background: #ffffff;\n\n    &__back {\n        position: absolute;\n        top: 20px;\n        left: 20px;\n        z-index: 10;\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        background: rgba(255, 255, 255, 0.9);\n        color: #101828;\n        font-weight: 600;\n        font-size: 0.85rem;\n        text-decoration: none;\n        padding: 8px 14px;\n        border-radius: 999px;\n        box-shadow: 0 2px 8px rgba(16, 24, 40, 0.12);\n        transition: background 0.15s ease;\n\n        &:hover {\n            background: #ffffff;\n            color: #14335e;\n        }\n\n        i {\n            font-size: 0.95rem;\n        }\n    }\n\n    &__photo {\n        display: none;\n        background-size: cover;\n        background-position: center;\n        opacity: 0.55;\n    }\n\n    &__form-wrap {\n        flex: 1 1 100%;\n        min-height: 100vh;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 32px 24px;\n    }\n\n    &__form {\n        width: 100%;\n        max-width: 380px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    &__title {\n        font-weight: 700;\n        font-size: 1.5rem;\n        color: #101828;\n        margin-bottom: 6px;\n    }\n\n    &__subtitle {\n        color: #667085;\n        font-size: 0.9rem;\n        margin-bottom: 24px;\n    }\n\n    &__forgot {\n        color: #dc2626;\n        font-size: 0.85rem;\n        font-weight: 600;\n        text-decoration: none;\n\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n\n    &__submit {\n        background: linear-gradient(90deg, #b91c3c 0%, #1e3a8a 100%);\n        border: none;\n        font-weight: 700;\n        padding: 10px 0;\n        border-radius: 8px;\n\n        &:hover,\n        &:focus,\n        &:active {\n            background: linear-gradient(90deg, #a01834 0%, #17307a 100%) !important;\n            border: none !important;\n        }\n    }\n\n    .school-login-form {\n        width: 100%;\n        text-align: left;\n    }\n\n    @media (min-width: 768px) {\n        &__photo {\n            display: block;\n            flex: 1 1 50%;\n            min-height: 100vh;\n        }\n\n        &__form-wrap {\n            flex: 1 1 50%;\n        }\n    }\n\n    @media (min-width: 992px) {\n        &__photo {\n            flex-basis: 55%;\n        }\n\n        &__form-wrap {\n            flex-basis: 45%;\n        }\n    }\n}","// \n// components-demo.scss\n//\n\n// Demo Only\n.button-list {\n    margin-left: -8px;\n    margin-bottom: -12px;\n    \n    .btn {\n        margin-bottom: 12px;\n        margin-left: 8px;\n    }\n}\n\n// Grid\n.grid-structure {\n    .grid-container {\n        background-color: $table-striped-bg;\n        margin-bottom: 10px;\n        font-size: 0.8rem;\n        font-weight: $font-weight-semibold;\n        padding: 10px 20px;\n    }\n}\n\n// Icon demo ( Demo only )\n.icons-list-demo {\n    div.col-sm-6 {\n        cursor: pointer;\n        line-height: 45px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        display: block;\n        overflow: hidden;\n        p {\n            margin-bottom: 0;\n            line-height: inherit;\n        }\n    }\n    i {\n        text-align: center;\n        vertical-align: middle;\n        font-size: 22px;\n        width: 50px;\n        height: 50px;\n        line-height: 50px;\n        margin-right: 12px;\n        color: $text-muted;\n        border-radius: 3px;\n        display: inline-block;\n        transition: all 0.2s;\n    }\n    .col-md-4 {\n        border-radius: 3px;\n        background-clip: padding-box;\n        margin-bottom: 10px;\n        &:hover,\n        &:hover i {\n            color: $primary;\n        }\n    }\n}\n\n.icons-list  {\n    .icon-item{\n        padding: 15px 0;\n        color: $gray-600;\n        svg{\n            margin-right: 10px;\n        }\n        \n        span{\n            line-height: 30px;\n            display: inline-block;\n            vertical-align: middle;\n        }\n    }\n}\n\n\n// Scrollspy\n\n.scrollspy-example {\n    position: relative;\n    height: 200px;\n    margin-top: .5rem;\n    overflow: auto;\n}","// \n// error.scss\n//\n\n// Error text with shadow\n.text-error {\n    color: $primary;\n    text-shadow: rgba($primary,0.3) 5px 1px, rgba($primary,0.2) 10px 3px;\n    font-size: 84px;\n    line-height: 90px;\n    font-family: $font-family-secondary;\n}\n\n// Animation text\n.error-text-box {\n    font-size: 10rem;\n    font-family: $font-family-secondary;\n    min-height: 200px;\n\n    .text {\n        fill: none;\n        stroke-width: 6;\n        stroke-linejoin: round;\n        stroke-dasharray: 30 100;\n        stroke-dashoffset: 0;\n        animation: stroke 9s infinite linear;\n    }\n    \n    .text:nth-child(5n + 1) {\n        stroke: $danger;\n        animation-delay: -1.2s;\n    }\n    \n    .text:nth-child(5n + 2) {\n        stroke: $warning;\n        animation-delay: -2.4s;\n    }\n    \n    .text:nth-child(5n + 3) {\n        stroke: $primary;\n        animation-delay: -3.6s;\n    }\n    \n    .text:nth-child(5n + 4) {\n        stroke: $info;\n        animation-delay: -4.8s;\n    }\n    \n    .text:nth-child(5n + 5) {\n        stroke: $success;\n        animation-delay: -6s;\n    }\n}\n\n@keyframes stroke {\n    100% {\n        stroke-dashoffset: -400;\n    }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .error-text-box {\n        .text {\n            fill: $danger;\n            stroke: $danger;\n            stroke-width: 6;\n            stroke-dasharray: 0 0;\n            stroke-dashoffset: 0;\n            animation: none;\n        }\n    }\n}","// \n// email.scss\n//\n\n.email-container {\n    // margin-bottom: $grid-gutter-width;\n    background-color: $card-bg;\n    .inbox-leftbar {\n        padding: $card-spacer-x;\n        width: 250px;\n        float: left;\n        // padding: 0 20px 20px 10px;\n        padding-bottom: 184px;\n        margin-bottom: -184px;\n    }\n\n    .inbox-rightbar {\n        margin-left: 250px;\n        border-left: 5px solid $body-bg;\n        padding: 0 0 1.5rem 25px;\n    }\n}\n\n\n\n.message-list {\n    display: block;\n    padding-left: 0;\n\n    li {\n        position: relative;\n        display: block;\n        height: 48px;\n        line-height: 48px;\n        cursor: default;\n        transition-duration: .3s;\n        background: $card-bg;\n        margin-bottom: 1px;\n        box-shadow: $box-shadow-sm;\n\n        a {\n            color: $gray-700;\n        }\n\n        &:hover {\n            box-shadow: $box-shadow;\n            transition-duration: .05s;\n        }\n\n        .col-mail {\n            float: left;\n            position: relative;\n        }\n\n        .col-mail-1 {\n            width: 320px;\n\n            .star-toggle,\n            .checkbox-wrapper-mail,\n            .dot {\n                display: block;\n                float: left;\n            }\n\n            .dot {\n                border: 4px solid transparent;\n                border-radius: 100px;\n                margin: 22px 26px 0;\n                height: 0;\n                width: 0;\n                line-height: 0;\n                font-size: 0;\n            }\n\n            .checkbox-wrapper-mail {\n                margin: 15px 10px 0 20px;\n            }\n\n            .star-toggle {\n                color: $gray-500;\n                margin-left: 10px;\n            }\n\n            .title {\n                position: absolute;\n                top: 0;\n                left: 100px;\n                right: 0;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n                margin-bottom: 0;\n                line-height: 50px;\n            }\n        }\n\n        .col-mail-2 {\n            position: absolute;\n            top: 0;\n            left: 320px;\n            right: 0;\n            bottom: 0;\n\n            .subject,\n            .date {\n                position: absolute;\n                top: 0;\n            }\n\n            .subject {\n                left: 0;\n                right: 110px;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n            }\n\n            .date {\n                right: 0;\n                width: 100px;\n                padding-left: 10px;\n            }\n        }\n    }\n\n    li.active,\n    li.mail-selected {\n        background: $gray-100;\n        transition-duration: .05s;\n    }\n\n    li.active,\n    li.active:hover {\n        box-shadow: inset 3px 0 0 $cyan;\n    }\n\n    li.unread a {\n        // font-weight: $font-weight-semibold;\n        color: darken($dark, 5%);\n    }\n\n    .checkbox-wrapper-mail {\n        cursor: pointer;\n        height: 20px;\n        width: 20px;\n        position: relative;\n        display: inline-block;\n        box-shadow: inset 0 0 0 2px $gray-400;\n        border-radius: 3px;\n\n        input {\n            opacity: 0;\n            cursor: pointer;\n        }\n\n        input:checked~label {\n            opacity: 1;\n        }\n\n        label {\n            position: absolute;\n            top: 3px;\n            left: 3px;\n            right: 3px;\n            bottom: 3px;\n            cursor: pointer;\n            background: $gray-600;\n            opacity: 0;\n            margin-bottom: 0 !important;\n            transition-duration: .05s;\n        }\n\n        label:active {\n            background: #87949b;\n        }\n    }\n}\n\n.mail-list {\n    a {\n        color: $gray-700;\n        padding: 7px 10px;\n        display: block;\n    }\n}\n\n.reply-box {\n    border: 2px solid $light;\n}\n\n@media (max-width: 648px) {\n    .email-container {\n        .inbox-leftbar {\n                width: 100%;\n                float: none;\n                margin-bottom: 21px;\n                padding-bottom: 1.25rem;\n        }\n\n        .inbox-rightbar {\n            margin-left: 0;\n            border: 0;\n            padding-left: 0;\n        }\n    }\n\n}\n\n@media (max-width: 520px) {\n    .inbox-rightbar {\n        >.btn-group {\n            margin-bottom: 10px;\n        }\n    }\n\n    .message-list li {\n        .col-mail-1 {\n            width: 150px;\n\n            .title {\n                left: 80px;\n            }\n        }\n\n        .col-mail-2 {\n            left: 160px;\n\n            .date {\n                text-align: right;\n                padding-right: 10px;\n                padding-left: 20px;\n            }\n        }\n    }\n}\n\n.chatbox {\n    position: fixed;\n    right: 35px;\n    bottom: 10px;\n    width: 300px;\n    background-color: $card-bg;\n    border-radius: $border-radius;\n    box-shadow: $box-shadow;\n    z-index: 99;\n\n    .chat-input {\n        .form-control {\n            padding-right: 60px;\n        }\n    }\n\n    .chat-link {\n        position: absolute;\n        right: 4px;\n        top: 10px\n    }\n}\n","// \n// pricing.scss\n//\n\n.card-pricing {\n    position: relative;\n    \n    .card-pricing-plan-name {\n        padding-bottom: 20px;\n    }\n\n    .card-pricing-icon {\n        font-size: 22px;\n        background-color: rgba($primary,0.1);\n        height: 60px;\n        display: inline-block;\n        width: 60px;\n        line-height: 62px;\n        border-radius: 50%;\n    }\n\n    .card-pricing-price {\n        padding: 30px 0 0;\n\n        span {\n            font-size: 40%;\n            color: $text-muted;\n            letter-spacing: 2px;\n            text-transform: uppercase;\n        }\n    }\n    .card-pricing-features {\n        color: $text-muted;\n        list-style: none;\n        margin: 0;\n        padding: 20px 0 0 0;\n\n        li {\n            padding: 10px;\n        }\n    }\n}\n\n.card-pricing-recommended {\n    background-color: $primary;\n    color: $white;\n\n    .card-pricing-icon {\n        background-color: rgba($white,0.1);\n    }\n    .card-pricing-features,.card-pricing-price span {\n        color: rgba($white,0.7);\n    }\n}","// \n// profile.scss\n//\n\n.post-user-comment-box {\n    background-color: $gray-100;\n    margin: 0 -.75rem;\n    padding: 1rem;\n    margin-top: 20px;\n}","// \n// tasks.scss\n//\n\n.board {\n    display: block;\n    white-space: nowrap;\n    overflow-x: auto;\n}\n\n.tasks {\n    display: inline-block;\n    width: 22rem;\n    padding: 0 1rem 1rem 1rem;\n    vertical-align: top;\n    margin-bottom: $grid-gutter-width;\n    background-color: $card-bg;\n    @include border-radius($border-radius-sm);\n\n    &.tasks:not(:last-child) {\n        margin-right: 1.25rem;\n    }\n\n    .card {\n        white-space: normal;\n        margin-top: 1rem;\n    }\n\n    .task-header {\n        background-color: $card-cap-bg;\n        padding: 1rem;\n        margin: 0 -1rem;\n        @include border-radius($border-radius-sm);\n    }\n}\n\n.task-list-items {\n    min-height: 100px;\n    position: relative;\n\n    .card {\n        cursor: pointer;\n    }\n\n    &:before {\n        content: \"No Tasks\";\n        position: absolute;\n        line-height: 110px;\n        width: 100%;\n        text-align: center;\n        font-weight: 600;\n    }\n}\n\n\n// Task add modal\n.task-modal-content {\n    .form-control-light {\n        background-color: lighten($gray-200, 2.5%) !important;\n        border-color: lighten($gray-200, 2.5%) !important;\n    }\n}\n\n// task - gantt\n.gantt-task-details {\n    min-width: 220px;\n}\n\n// task search\n.task-search {\n    .search-input {\n        padding-left: 32px;\n        z-index: 10;\n    }\n    .icon-search {\n        z-index: 11;\n        position: absolute;\n        left: 10px;\n        top: 10px;\n    }\n}\n","// \n// timeline.scss\n//\n\n/************** Horizontal timeline **************/ \n\n.left-timeline{\n    .events{\n        border-left: 3px solid $gray-300;\n        padding-left: 35px;\n        .event-list{\n            position: relative;\n            &::before{\n                content: \"\";\n                position: absolute;\n                left: -45px;\n                top: 6px;\n                height: 18px;\n                width: 18px;\n                background-color: $primary;\n                border-radius: 50%;\n                border: 5px solid $card-bg;\n                z-index: 9;\n            }\n            &::after{\n                content: \"\";\n                position: absolute;\n                left: -38px;\n                top: 14px;\n                height: 3px;\n                width: 30px;\n                background-color: $gray-300;\n            }\n        }\n    }\n\n    .album {\n        img {\n            height: 36px;\n            width: auto;\n            border-radius: 4px;\n        }\n    }\n}\n\n\n// timeline center\n\n\n.timeline {\n    margin-bottom: 50px;\n    position: relative;\n    &:before {\n        background-color: $gray-300;\n        bottom: 0;\n        content: \"\";\n        left: 50%;\n        position: absolute;\n        top: 30px;\n        width: 2px;\n        z-index: 0;\n    }\n    .time-show {\n        margin-bottom: 30px;\n        margin-top: 30px;\n        position: relative;\n        text-align: center;\n    }\n    .timeline-box {\n        display: block;\n        position: relative;\n        padding: 20px;\n    }\n    .timeline-album {\n        margin-top: 12px;\n        a {\n            display: inline-block;\n            margin-right: 5px;\n        }\n        img {\n            height: 36px;\n            width: auto;\n            border-radius: 3px;\n        }\n    }\n}\n\n@include media-breakpoint-up(md) {\n    .timeline {\n        .time-show {\n            right: 69px;\n        }\n        .timeline-box {\n            margin-left: 15px;\n        }\n        .timeline-icon {\n            background: $primary;\n            border-radius: 50%;\n            display: block;\n            height: 20px;\n            left: -24px;\n            margin-top: -10px;\n            position: absolute;\n            text-align: center;\n            top: 15%;\n            width: 20px;\n            border: 5px solid $card-bg;\n            z-index: 9;\n            &:before {\n                content: \"\";\n                position: absolute;\n                height: 3px;\n                width: 19px;\n                background-color: $gray-300;\n                left: 15px;\n                top: 3px;\n            }\n        }\n        .timeline-desk {\n            display: table-cell;\n            vertical-align: top;\n            width: 50%;\n        }\n    }\n    .timeline-item {\n        display: flex;\n        &:before {\n            content: \"\";\n            display: block;\n            width: 50%;\n        }\n\n        &.timeline-item-left {\n            &:after {\n                content: \"\";\n                display: block;\n                width: 50%;\n            }\n            .timeline-desk {\n                .album {\n                    float: right;\n                    margin-top: 20px;\n                    a {\n                        float: right;\n                        margin-left: 5px;\n                    }\n                }\n            }\n            .timeline-icon {\n                left: auto;\n                right: -26px;\n                &:before{\n                    left: auto;\n                    right: 15px;\n                }\n            }\n            &:before {\n                display: none;\n            }\n            .timeline-box {\n                margin-right: 15px;\n                margin-left: 0;\n                text-align: right;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .timeline {\n        .time-show {\n            position: relative;\n        }\n        .event-date{\n            float: left !important;\n            margin-right: 1.5rem;\n            margin-left: 0 !important;\n        }\n        .timeline-icon {\n            display: none;\n        }\n        \n    }\n}","// \n// landing.scss\n// \n\nsection {\n    &.bg-body {\n        background-color: $section-bg !important;\n    }\n}\n\n.navbar {\n    &.nav-sticky {\n        background-color: $card-bg;\n    }\n}\n\n// Shared section heading (eyebrow + title + subtitle), used by every\n// landing section so labels like \"OUR ASSOCIATIONS\" / \"WATCH & LEARN\" / \"SPORTS DISCIPLINE\"\n// always render with the same font, size, weight and color.\n.section-eyebrow {\n    display: block;\n    width: 100%;\n    text-align: center;\n    font-family: $font-family-base;\n    font-weight: 700;\n    font-size: 0.95rem;\n    letter-spacing: 1.5px;\n    color: #f0611b;\n    margin: 0 auto 10px;\n    text-transform: uppercase;\n}\n\n.section-title {\n    display: block;\n    width: 100%;\n    text-align: center;\n    font-family: $font-family-base;\n    font-weight: 800;\n    font-size: 2.4rem;\n    color: #101828;\n    margin: 0 auto 12px;\n    line-height: 1.2;\n\n    @media (max-width: 576px) {\n        font-size: 1.6rem;\n    }\n}\n\n.section-subtitle,\n.section-description {\n    display: block;\n    width: 100%;\n    max-width: 720px;\n    text-align: center;\n    font-family: $font-family-base;\n    font-weight: 400;\n    font-size: 0.95rem;\n    line-height: 1.6;\n    color: #475467;\n    margin: 0 auto 40px;\n\n    @media (max-width: 576px) {\n        font-size: 0.88rem;\n        margin-bottom: 28px;\n    }\n}\n\n.visionaries-header,\n.sports-categories-header {\n    max-width: 720px;\n    margin: 0 auto 40px;\n    text-align: center;\n}\n\n// Hero banner (Discover the Champions of Tomorrow)\n.hero-banner {\n    position: relative;\n    overflow: hidden;\n    height: 420px;\n\n    .carousel,\n    .carousel-inner,\n    .carousel-item {\n        height: 100%;\n    }\n\n    &__slide {\n        height: 100%;\n        background-size: cover;\n        background-position: center;\n    }\n\n    &__slide-img {\n        display: none;\n    }\n\n    &__overlay {\n        position: absolute;\n        inset: 0;\n        z-index: 1;\n        background: linear-gradient(\n            100deg,\n            rgba(80, 15, 15, 0.88) 0%,\n            rgba(90, 20, 20, 0.7) 30%,\n            rgba(20, 51, 94, 0.35) 60%,\n            rgba(20, 51, 94, 0.1) 100%\n        );\n        pointer-events: none;\n    }\n\n    &__content {\n        position: absolute;\n        inset: 0;\n        z-index: 2;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        color: #ffffff;\n        padding: 24px 20px;\n        max-width: 640px;\n    }\n\n    &__title {\n        color: #ffffff;\n        font-weight: 800;\n        font-size: 1.5rem;\n        line-height: 1.25;\n        margin-bottom: 10px;\n    }\n\n    &__copy {\n        font-size: 0.8rem;\n        color: rgba(255, 255, 255, 0.9);\n        line-height: 1.5;\n        margin-bottom: 10px;\n    }\n\n    &__stats {\n        font-weight: 700;\n        font-size: 0.78rem;\n        color: #ffd399;\n        margin-bottom: 16px;\n    }\n\n    &__cta {\n        display: inline-flex;\n        align-self: flex-start;\n        align-items: center;\n        gap: 8px;\n        background: #ffffff;\n        color: #14335e;\n        font-weight: 700;\n        font-size: 0.8rem;\n        text-decoration: none;\n        padding: 10px 18px;\n        border-radius: 10px;\n        transition: transform 0.15s ease, box-shadow 0.15s ease;\n\n        &:hover {\n            color: #14335e;\n            transform: translateY(-2px);\n            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n        }\n    }\n\n    @media (min-width: 768px) {\n        height: 480px;\n\n        &__content {\n            padding: 40px 48px;\n        }\n\n        &__title {\n            font-size: 2.2rem;\n        }\n\n        &__copy {\n            font-size: 0.95rem;\n            margin-bottom: 14px;\n        }\n\n        &__stats {\n            font-size: 0.9rem;\n            margin-bottom: 22px;\n        }\n\n        &__cta {\n            font-size: 0.9rem;\n            padding: 12px 22px;\n        }\n    }\n\n    @media (min-width: 1200px) {\n        height: 560px;\n\n        &__title {\n            font-size: 2.6rem;\n        }\n    }\n}\n\n// Notice marquee bar\n.notice-marquee {\n    display: flex;\n    align-items: stretch;\n    background: #fff4ea;\n    border-bottom: 1px solid #f3d9bd;\n\n    &__label {\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        background: #14335e;\n        color: #ffffff;\n        font-weight: 700;\n        font-size: 0.85rem;\n        letter-spacing: 0.3px;\n        padding: 10px 18px;\n\n        i {\n            font-size: 1rem;\n            color: #ff8a3d;\n        }\n    }\n\n    &__link {\n        display: inline-flex;\n        text-decoration: none;\n        color: inherit;\n    }\n\n    &__item {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        margin-right: 40px;\n        color: #7a2e10;\n        font-weight: 600;\n        font-size: 0.85rem;\n        white-space: nowrap;\n    }\n\n    &__badge {\n        flex-shrink: 0;\n        background: #f0611b;\n        color: #ffffff;\n        font-size: 0.62rem;\n        font-weight: 700;\n        letter-spacing: 0.3px;\n        text-transform: uppercase;\n        padding: 2px 7px;\n        border-radius: 4px;\n    }\n\n    @media (max-width: 576px) {\n        &__label {\n            padding: 8px 12px;\n            font-size: 0.78rem;\n        }\n\n        &__item {\n            font-size: 0.78rem;\n            margin-right: 28px;\n        }\n    }\n}\n\n.circles {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden\n}\n\n.circles li {\n    position: absolute;\n    display: block;\n    list-style: none;\n    width: 20px;\n    height: 20px;\n    background: rgba(181, 182, 199, .1);\n    animation: animate 25s linear infinite;\n    bottom: -150px\n}\n\n.circles li:nth-child(1) {\n    left: 25%;\n    width: 80px;\n    height: 80px;\n    animation-delay: 0s\n}\n\n.circles li:nth-child(2) {\n    left: 10%;\n    width: 20px;\n    height: 20px;\n    animation-delay: 2s;\n    animation-duration: 12s\n}\n\n.circles li:nth-child(3) {\n    left: 70%;\n    width: 20px;\n    height: 20px;\n    animation-delay: 4s\n}\n\n.circles li:nth-child(4) {\n    left: 40%;\n    width: 60px;\n    height: 60px;\n    animation-delay: 0s;\n    animation-duration: 18s\n}\n\n.circles li:nth-child(5) {\n    left: 65%;\n    width: 20px;\n    height: 20px;\n    animation-delay: 0s\n}\n\n.circles li:nth-child(6) {\n    left: 75%;\n    width: 110px;\n    height: 110px;\n    animation-delay: 3s\n}\n\n.circles li:nth-child(7) {\n    left: 35%;\n    width: 150px;\n    height: 150px;\n    animation-delay: 7s\n}\n\n.circles li:nth-child(8) {\n    left: 50%;\n    width: 25px;\n    height: 25px;\n    animation-delay: 15s;\n    animation-duration: 45s\n}\n\n.circles li:nth-child(9) {\n    left: 20%;\n    width: 15px;\n    height: 15px;\n    animation-delay: 2s;\n    animation-duration: 35s\n}\n\n.circles li:nth-child(10) {\n    left: 85%;\n    width: 150px;\n    height: 150px;\n    animation-delay: 0s;\n    animation-duration: 11s\n}\n\n@keyframes animate {\n    0% {\n        transform: translateY(0) rotate(0);\n        opacity: 1;\n        border-radius: 0\n    }\n\n    100% {\n        transform: translateY(-1000px) rotate(720deg);\n        opacity: 0;\n        border-radius: 50%\n    }\n}\n\n.fs-44 {\n    font-size: 44px\n}\n\n.animate {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n    -webkit-transition: .3s ease-in-out;\n    transition: .3s ease-in-out\n}\n\n.animate:hover {\n    -webkit-transform: scale(1.1);\n    transform: scale(1.1)\n}\n\n// Government top strip\n.gov-topbar {\n    background: linear-gradient(to right, #9e3b32, #14335e);\n    padding: 6px 0;\n    font-size: 0.85rem;\n    color: #ffffff;\n\n    .gov-topbar-left {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-weight: 400;\n\n        .gov-hindi {\n            font-weight: 600;\n        }\n    }\n\n    .gov-topbar-right {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n\n        a,\n        .gov-lang,\n        .gov-accessibility-btn {\n            color: #ffffff;\n            text-decoration: none;\n            white-space: nowrap;\n\n            &:hover {\n                color: #f0f0f0;\n                text-decoration: underline;\n            }\n        }\n\n        .gov-accessibility-btn {\n            background: none;\n            border: none;\n            padding: 0;\n            font-size: inherit;\n            cursor: pointer;\n        }\n\n        .gov-divider {\n            color: rgba(255, 255, 255, 0.6);\n        }\n\n        .gov-lang {\n            display: inline-flex;\n            align-items: center;\n            gap: 4px;\n            cursor: pointer;\n        }\n    }\n\n    @media (max-width: 576px) {\n        font-size: 0.7rem;\n        padding: 5px 0;\n        text-align: center;\n\n        > .container-fluid {\n            flex-direction: column;\n            row-gap: 4px;\n        }\n\n        .gov-topbar-left,\n        .gov-topbar-right {\n            justify-content: center;\n            width: 100%;\n        }\n    }\n}\n\n// Main white menu bar\n.main-navbar {\n    background: #ffffff !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n\n    @media (max-width: 576px) {\n        > .container-fluid {\n            padding-left: 10px !important;\n            padding-right: 10px !important;\n        }\n    }\n\n    .navbar-brand-logo {\n        height: 68px;\n        width: auto;\n\n        @media (max-width: 576px) {\n            height: 50px;\n        }\n    }\n\n    .navbar-brand-mashaal {\n        gap: 12px;\n    }\n\n    .navbar-brand-text {\n        display: flex;\n        flex-direction: column;\n        line-height: 1.2;\n\n        &__title {\n            font-weight: 800;\n            font-size: 1.5rem;\n            color: #101828;\n        }\n\n        &__subtitle {\n            font-weight: 700;\n            font-size: 0.95rem;\n            color: #101828;\n        }\n\n        @media (max-width: 576px) {\n            &__title {\n                font-size: 1.1rem;\n            }\n\n            &__subtitle {\n                font-size: 0.72rem;\n            }\n        }\n    }\n\n    .main-nav-link {\n        color: #1a1a1a !important;\n        font-weight: 600;\n        font-size: 0.95rem;\n        letter-spacing: 0.2px;\n        padding: 0.5rem 0.9rem !important;\n        text-transform: uppercase;\n\n        &:hover,\n        &:focus {\n            color: #14335e !important;\n        }\n\n        &.active {\n            color: #14335e !important;\n            position: relative;\n\n            &::after {\n                content: \"\";\n                position: absolute;\n                left: 0.9rem;\n                right: 0.9rem;\n                bottom: 0.15rem;\n                height: 2px;\n                background: #f0611b;\n                border-radius: 1px;\n            }\n        }\n    }\n\n    .main-nav-dropdown-toggle {\n        color: #1a1a1a;\n        font-weight: 600;\n        font-size: 0.95rem;\n        background: none;\n        border: none;\n        padding: 0.5rem 0.9rem;\n        display: inline-flex;\n        align-items: center;\n        text-transform: uppercase;\n\n        &:hover,\n        &:focus {\n            color: #14335e;\n        }\n\n        &::after {\n            display: none;\n        }\n\n        &--download {\n            border: 1px solid #d0d5dd;\n            border-radius: 8px;\n            padding: 0.4rem 0.9rem;\n            gap: 8px;\n        }\n\n        &__icon {\n            font-size: 1rem;\n            color: #f0611b;\n        }\n\n        &__caret {\n            font-size: 1.1rem;\n            margin-left: 2px;\n            transition: transform 0.15s ease;\n        }\n\n        &.show &__caret {\n            transform: rotate(180deg);\n        }\n    }\n\n    .dropdown-menu {\n        .dropdown-item {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            font-size: 0.9rem;\n\n            i {\n                color: #14335e;\n                font-size: 0.95rem;\n            }\n        }\n    }\n\n    .navbar-toggler {\n        border: none;\n        box-shadow: none !important;\n        color: #14335e;\n    }\n\n    @media (max-width: 991.98px) {\n\n        .main-nav-link,\n        .main-nav-dropdown-toggle {\n            padding: 0.6rem 0 !important;\n        }\n\n        .main-nav-link.active::after {\n            left: 0;\n            right: 0;\n        }\n    }\n}\n\n// Our Visionaries section\n.visionaries-section {\n    padding: 60px 0;\n\n    .visionaries-header {\n        margin-bottom: 40px;\n    }\n\n    .visionaries-eyebrow {\n        display: block;\n        color: #14335e;\n        font-family: $font-family-base;\n        font-weight: 700;\n        font-size: 0.95rem;\n        letter-spacing: 1px;\n        margin-bottom: 8px;\n    }\n\n    .visionaries-title {\n        font-weight: 800;\n        font-size: 2rem;\n        color: #101828;\n        margin-bottom: 0;\n    }\n\n    .visionary-card {\n        width: 100%;\n        max-width: 320px;\n        margin: 0 auto;\n        border: 1px solid #e5e7eb;\n        border-radius: 14px;\n        overflow: hidden;\n        background: #ffffff;\n\n        &__photo {\n            width: 100%;\n            height: 260px;\n            background-image: linear-gradient(to bottom, #ffffff 0%, #ffffff 45%, var(--visionary-band-color) 45%, var(--visionary-band-color) 100%);\n            display: flex;\n            align-items: flex-end;\n            justify-content: center;\n\n            img {\n                max-width: 78%;\n                max-height: 100%;\n                width: auto;\n                height: auto;\n                object-fit: contain;\n                display: block;\n            }\n        }\n\n        &__info {\n            padding: 18px 16px 22px;\n            text-align: center;\n            background: #ffffff;\n\n            h3 {\n                font-weight: 700;\n                font-size: 1.05rem;\n                letter-spacing: 0.3px;\n                text-transform: uppercase;\n                color: #e8720c;\n                margin-bottom: 6px;\n            }\n\n            p {\n                font-size: 0.82rem;\n                font-weight: 600;\n                letter-spacing: 0.2px;\n                text-transform: uppercase;\n                color: #1f2937;\n                margin-bottom: 0;\n            }\n        }\n\n        &--peach {\n            --visionary-band-color: #fbe3cf;\n        }\n\n        &--blue {\n            --visionary-band-color: #dbeafe;\n        }\n\n        &--pink {\n            --visionary-band-color: #f6def0;\n        }\n    }\n\n    @media (max-width: 991.98px) {\n        .visionary-card__photo {\n            height: 230px;\n        }\n    }\n\n    @media (max-width: 576px) {\n        padding: 40px 0;\n\n        .visionaries-title {\n            font-size: 1.5rem;\n        }\n\n        .visionary-card {\n            max-width: 280px;\n        }\n\n        .visionary-card__photo {\n            height: 210px;\n        }\n\n        .visionary-card__info {\n            padding: 14px 14px 18px;\n\n            h3 {\n                font-size: 0.95rem;\n            }\n\n            p {\n                font-size: 0.75rem;\n            }\n        }\n    }\n}\n\n// Battery Test Videos section\n.battery-videos-section {\n    padding: 60px 0;\n\n    .battery-video-card {\n        position: relative;\n        width: 100%;\n        aspect-ratio: 16 / 9;\n        border-radius: 12px;\n        overflow: hidden;\n        background: #000;\n        box-shadow: 0 4px 14px rgba(16, 24, 40, 0.08);\n\n        &__player {\n            position: absolute;\n            inset: 0;\n\n            video,\n            iframe,\n            > div {\n                border-radius: 12px;\n            }\n        }\n\n        &__play {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            width: 56px;\n            height: 56px;\n            border-radius: 50%;\n            background: rgba(20, 51, 90, 0.85);\n            color: #ffffff;\n            font-size: 1.4rem;\n            transition: transform 0.2s ease, background 0.2s ease;\n\n            i {\n                margin-left: 3px;\n            }\n        }\n\n        &:hover .battery-video-card__play {\n            background: #e8720c;\n            transform: scale(1.08);\n        }\n\n        &__label {\n            margin: 10px 0 0;\n            text-align: center;\n            font-size: 0.85rem;\n            font-weight: 600;\n            color: #1f2937;\n        }\n    }\n\n    @media (max-width: 576px) {\n        padding: 40px 0;\n\n        .visionaries-title {\n            font-size: 1.5rem;\n        }\n    }\n}\n\n// Mashaal 2026 scheme / talent pathway\n.mashaal-scheme-section {\n    padding: 40px 0;\n    scroll-margin-top: 140px;\n\n    @media (max-width: 576px) {\n        scroll-margin-top: 100px;\n    }\n\n    .mashaal-scheme-image {\n        border-radius: 20px;\n        overflow: hidden;\n\n        img {\n            display: block;\n            width: 100%;\n            height: auto;\n        }\n    }\n\n    .mashaal-scheme-panel {\n        position: relative;\n        border-radius: 20px;\n        overflow: hidden;\n        background: #0e1f45;\n        padding: 36px 24px;\n\n        @media (min-width: 768px) {\n            padding: 48px 56px;\n        }\n    }\n\n    .mashaal-scheme-intro {\n        max-width: 780px;\n        margin: 0 auto 34px;\n        color: #ffffff;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .mashaal-scheme-tag {\n        display: inline-block;\n        font-family: $font-family-base;\n        font-weight: 700;\n        font-size: 0.85rem;\n        letter-spacing: 2px;\n        color: #ffffff;\n        margin-bottom: 12px;\n    }\n\n    .mashaal-scheme-heading {\n        color: #ffffff;\n        font-weight: 800;\n        font-size: 2.2rem;\n        line-height: 1.15;\n        margin-bottom: 14px;\n\n        span {\n            color: #ff8a3d;\n        }\n    }\n\n    .mashaal-scheme-copy {\n        color: rgba(255, 255, 255, 0.82);\n        font-size: 0.95rem;\n        line-height: 1.65;\n        margin-bottom: 0;\n    }\n\n    .mashaal-scheme-components {\n        min-width: 0;\n        text-align: center;\n    }\n\n    .mashaal-pathway-title {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 16px;\n        color: #ffffff;\n        font-weight: 700;\n        font-size: 1.15rem;\n        margin-bottom: 30px;\n\n        span {\n            display: block;\n            width: 40px;\n            height: 1px;\n            background: rgba(255, 138, 61, 0.6);\n        }\n    }\n\n    .mashaal-pathway {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 30px;\n\n        @media (min-width: 992px) {\n            flex-direction: row;\n            align-items: stretch;\n            justify-content: center;\n            gap: 90px;\n        }\n    }\n\n    .mashaal-pathway__chain {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 16px;\n        width: 100%;\n\n        @media (min-width: 992px) {\n            flex-direction: row;\n            align-items: stretch;\n            justify-content: center;\n            gap: 0;\n        }\n    }\n\n    .mashaal-pathway__link {\n        position: relative;\n        text-align: center;\n        width: 100%;\n        max-width: 260px;\n        padding: 20px 18px;\n        border-radius: 14px;\n        background: linear-gradient(180deg, #1c3b7a 0%, #16305f 100%);\n        border: 1px solid rgba(255, 255, 255, 0.15);\n\n        @media (min-width: 992px) {\n            width: 176px;\n            min-height: 240px;\n            max-width: none;\n            padding: 24px 20px 20px 34px;\n            border: none;\n            border-radius: 0;\n            clip-path: polygon(0 0, calc(100% - 26px) 0, 100% 50%, calc(100% - 26px) 100%, 0 100%, 26px 50%);\n            margin-left: -26px;\n        }\n\n        &--first {\n            @media (min-width: 992px) {\n                padding-left: 20px;\n                clip-path: polygon(0 0, calc(100% - 26px) 0, 100% 50%, calc(100% - 26px) 100%, 0 100%);\n                margin-left: 0;\n                border-radius: 16px 0 0 16px;\n            }\n        }\n\n        &--last {\n            @media (min-width: 992px) {\n                padding-right: 20px;\n                clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 26px 50%);\n            }\n        }\n\n        h4 {\n            color: #ffffff;\n            font-weight: 700;\n            font-size: 0.85rem;\n            margin: 3px 0 12px;\n        }\n\n        p {\n            color: rgba(255, 255, 255, 0.75);\n            font-size: 0.72rem;\n            line-height: 1.4;\n            margin-bottom: 0;\n        }\n    }\n\n    @for $i from 1 through 5 {\n        .mashaal-pathway__link--#{$i} {\n            background: linear-gradient(180deg, mix(#2563eb, #f0611b, (5 - $i) * 25%) 0%, mix(#14335e, #c2410c, (5 - $i) * 25%) 100%);\n\n            @media (min-width: 992px) {\n                z-index: #{5 - $i};\n            }\n        }\n    }\n\n    .mashaal-pathway__icon {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 44px;\n        height: 44px;\n        border-radius: 50%;\n        background: rgba(255, 255, 255, 0.12);\n        color: #ffffff;\n        font-size: 1.25rem;\n        margin: 0 auto 12px;\n    }\n\n    .mashaal-pathway__index {\n        display: block;\n        color: #ff8a3d;\n        font-weight: 800;\n        font-size: 0.68rem;\n        letter-spacing: 0.8px;\n        text-transform: uppercase;\n        margin-bottom: 4px;\n    }\n\n    .mashaal-pathway__arrow {\n        display: none;\n\n        @media (min-width: 992px) {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            top: 50%;\n            right: -13px;\n            transform: translateY(-50%);\n            width: 26px;\n            height: 26px;\n            border-radius: 50%;\n            background: #ff8a3d;\n            color: #0a1a3d;\n            font-size: 0.9rem;\n            z-index: 10;\n            box-shadow: 0 0 0 4px #0e1f45;\n        }\n    }\n\n    .mashaal-pathway__branches {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 18px;\n        width: 100%;\n        max-width: 280px;\n\n        @media (min-width: 992px) {\n            max-width: 240px;\n        }\n    }\n\n    .mashaal-pathway__branch-trunk {\n        display: none;\n\n        @media (min-width: 992px) {\n            display: block;\n            position: absolute;\n            top: 0;\n            left: -90px;\n            width: 90px;\n            height: 100%;\n            pointer-events: none;\n\n            &::before,\n            &::after {\n                content: \"\";\n                position: absolute;\n                left: 0;\n                width: 55px;\n                height: 55px;\n                border: 3px solid #f0611b;\n                border-right: none;\n            }\n\n            &::before {\n                top: 50%;\n                border-bottom: none;\n                border-radius: 14px 0 0 0;\n                transform: translateY(-100%);\n            }\n\n            &::after {\n                bottom: 50%;\n                border-top: none;\n                border-radius: 0 0 0 14px;\n                transform: translateY(100%);\n            }\n        }\n    }\n\n    .mashaal-pathway__branch-card {\n        position: relative;\n        text-align: center;\n        padding: 18px 16px;\n        border-radius: 14px;\n        background: rgba(255, 255, 255, 0.06);\n        border: 1px solid rgba(255, 138, 61, 0.4);\n\n        h4 {\n            color: #ffffff;\n            font-weight: 700;\n            font-size: 0.9rem;\n            margin: 4px 0 10px;\n        }\n\n        p {\n            color: rgba(255, 255, 255, 0.75);\n            font-size: 0.76rem;\n            line-height: 1.5;\n            margin-bottom: 0;\n        }\n\n        .mashaal-pathway__icon {\n            background: rgba(240, 97, 27, 0.2);\n            color: #ff8a3d;\n        }\n    }\n\n    .mashaal-pathway-footer {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 16px;\n        color: rgba(255, 255, 255, 0.55);\n        font-weight: 600;\n        font-size: 0.78rem;\n        letter-spacing: 1.5px;\n        text-transform: uppercase;\n        margin: 10px 0 0;\n\n        span {\n            display: block;\n            width: 40px;\n            height: 1px;\n            background: rgba(255, 255, 255, 0.25);\n        }\n    }\n\n    @media (max-width: 576px) {\n        padding: 30px 0;\n\n        .mashaal-scheme-panel {\n            border-radius: 14px;\n        }\n\n        .mashaal-scheme-heading {\n            font-size: 1.8rem;\n        }\n\n        .mashaal-scheme-copy {\n            font-size: 0.88rem;\n        }\n    }\n}\n\n// Our Associations section\n.associations-section {\n    padding: 60px 0;\n\n    .associations-header {\n        max-width: 720px;\n        margin: 0 auto 44px;\n    }\n\n    .associations-eyebrow {\n        display: block;\n        color: #f0611b;\n        font-family: $font-family-base;\n        font-weight: 700;\n        font-size: 0.95rem;\n        letter-spacing: 1px;\n        margin-bottom: 10px;\n    }\n\n    .associations-title {\n        font-weight: 800;\n        font-size: 2.4rem;\n        color: #101828;\n        margin-bottom: 14px;\n    }\n\n    .associations-subtitle {\n        color: #667085;\n        font-size: 1rem;\n        line-height: 1.6;\n        margin-bottom: 0;\n    }\n\n    .associations-grid {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: center;\n        gap: 48px;\n\n        &__item {\n            flex: 0 1 auto;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            height: 90px;\n\n            img {\n                max-height: 90px;\n                max-width: 200px;\n                width: auto;\n                height: auto;\n                object-fit: contain;\n                filter: grayscale(15%);\n                transition: filter 0.2s ease, transform 0.2s ease;\n\n                &:hover {\n                    filter: grayscale(0%);\n                    transform: scale(1.04);\n                }\n            }\n        }\n    }\n\n    @media (max-width: 576px) {\n        padding: 40px 0;\n\n        .associations-title {\n            font-size: 1.6rem;\n        }\n\n        .associations-subtitle {\n            font-size: 0.9rem;\n        }\n\n        .associations-grid {\n            gap: 28px;\n\n            &__item {\n                height: 60px;\n\n                img {\n                    max-height: 60px;\n                    max-width: 140px;\n                }\n            }\n        }\n    }\n}\n\n// Our Journey (key milestones) section\n.our-journey-section {\n    padding: 60px 0;\n\n    .our-journey-panel {\n        background: #ffffff;\n        border: 1px solid #e5e7eb;\n        border-radius: 20px;\n        box-shadow: 0 12px 32px rgba(16, 24, 40, 0.06);\n        padding: 40px 36px;\n    }\n\n    .our-journey-header {\n        max-width: 640px;\n        margin: 0 auto 32px;\n    }\n\n    .our-journey-eyebrow {\n        display: block;\n        color: #f0611b;\n        font-family: $font-family-base;\n        font-weight: 700;\n        font-size: 0.95rem;\n        letter-spacing: 1px;\n        margin-bottom: 10px;\n    }\n\n    .our-journey-title {\n        font-weight: 800;\n        font-size: 2.4rem;\n        color: #101828;\n        margin-bottom: 10px;\n    }\n\n    .our-journey-subtitle {\n        color: #667085;\n        font-size: 0.95rem;\n        margin-bottom: 0;\n    }\n\n    .our-journey-grid {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 18px;\n        margin-bottom: 18px;\n    }\n\n    .journey-card {\n        position: relative;\n        overflow: hidden;\n        border-radius: 14px;\n        padding: 20px 22px;\n        background: var(--journey-tint);\n        border: 1px solid var(--journey-border);\n\n        &__icon {\n            width: 44px;\n            height: 44px;\n            border-radius: 12px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background: #ffffff;\n            color: var(--journey-accent);\n            font-size: 1.2rem;\n            margin-bottom: 14px;\n\n            &--footer {\n                background: rgba(255, 255, 255, 0.7);\n                color: #6d28d9;\n            }\n        }\n\n        &__value {\n            font-weight: 800;\n            font-size: 1.6rem;\n            color: var(--journey-accent);\n            line-height: 1.2;\n        }\n\n        &__label {\n            font-size: 0.85rem;\n            font-weight: 600;\n            color: #344054;\n            margin-top: 4px;\n        }\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            left: 22px;\n            bottom: 14px;\n            width: 26px;\n            height: 3px;\n            border-radius: 2px;\n            background: var(--journey-accent);\n        }\n\n        &--blue {\n            --journey-tint: #eff6ff;\n            --journey-border: #dbeafe;\n            --journey-accent: #2563eb;\n        }\n\n        &--green {\n            --journey-tint: #ecfdf5;\n            --journey-border: #d1fae5;\n            --journey-accent: #059669;\n        }\n\n        &--purple {\n            --journey-tint: #f5f3ff;\n            --journey-border: #ede9fe;\n            --journey-accent: #7c3aed;\n        }\n\n        &--amber {\n            --journey-tint: #fffbeb;\n            --journey-border: #fef3c7;\n            --journey-accent: #d97706;\n        }\n\n        &--red {\n            --journey-tint: #fef2f2;\n            --journey-border: #fee2e2;\n            --journey-accent: #dc2626;\n        }\n\n        &--teal {\n            --journey-tint: #f0fdfa;\n            --journey-border: #ccfbf1;\n            --journey-accent: #0d9488;\n        }\n    }\n\n    .our-journey-footer {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 20px;\n        flex-wrap: wrap;\n        background: linear-gradient(90deg, #f5f3ff 0%, #ede9fe 100%);\n        border: 1px solid #ede9fe;\n        border-radius: 14px;\n        padding: 22px 26px;\n\n        &__stat {\n            display: flex;\n            align-items: center;\n            gap: 14px;\n            flex: 1 1 200px;\n        }\n\n        &__message {\n            flex: 1 1 260px;\n            text-align: center;\n\n            h4 {\n                font-weight: 700;\n                font-size: 1rem;\n                color: #101828;\n                margin-bottom: 4px;\n            }\n\n            p {\n                font-size: 0.85rem;\n                color: #667085;\n                margin-bottom: 0;\n            }\n        }\n\n        &__trend {\n            flex: 0 0 auto;\n            font-size: 2rem;\n            color: #7c3aed;\n            opacity: 0.6;\n        }\n    }\n\n    @media (max-width: 991.98px) {\n        .our-journey-grid {\n            grid-template-columns: repeat(2, 1fr);\n        }\n    }\n\n    @media (max-width: 576px) {\n        padding: 40px 0;\n\n        .our-journey-panel {\n            padding: 26px 18px;\n            border-radius: 16px;\n        }\n\n        .our-journey-title {\n            font-size: 1.5rem;\n        }\n\n        .our-journey-grid {\n            grid-template-columns: 1fr;\n            gap: 14px;\n        }\n\n        .our-journey-footer {\n            flex-direction: column;\n            align-items: flex-start;\n            text-align: left;\n\n            &__message {\n                text-align: left;\n            }\n\n            &__trend {\n                display: none;\n            }\n        }\n    }\n}\n\n// Sports & age categories\n.sports-categories-section {\n    padding: 50px 0;\n}\n\n.sports-categories {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    gap: 14px;\n    overflow-x: auto;\n    padding-bottom: 4px;\n}\n\n.sports-group {\n    flex: 1 1 0;\n    min-width: 150px;\n    border-radius: 14px;\n    overflow: hidden;\n    box-shadow: 0 6px 18px rgba(16, 24, 40, 0.08);\n    background: #ffffff;\n\n    &--athletics {\n        flex: 2.3 2.3 0;\n        // 5 events x 78px min-width each (.sports-event) = 390px; the group's\n        // own overflow:hidden was silently clipping the 5th event (100m\n        // Sprint) whenever this was narrower than that, instead of letting it\n        // scroll or wrap.\n        min-width: 400px;\n    }\n\n    &--cycling {\n        flex: 1 1 0;\n        min-width: 200px;\n    }\n\n    &__header {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        padding: 12px;\n        color: #ffffff;\n        font-weight: 800;\n        font-size: 0.85rem;\n        letter-spacing: 0.5px;\n        white-space: nowrap;\n\n        i {\n            font-size: 1.1rem;\n        }\n    }\n\n    &__events {\n        display: flex;\n        flex-wrap: nowrap;\n        height: 100%;\n    }\n\n    &--athletics .sports-group__header {\n        background: #14335e;\n    }\n\n    &--cycling .sports-group__header {\n        background: #14532d;\n    }\n\n    &--kabaddi .sports-group__header {\n        background: #c2410c;\n    }\n\n    &--football .sports-group__header {\n        background: #166534;\n    }\n\n    &--volleyball .sports-group__header {\n        background: #5b21b6;\n    }\n\n    &--athletics .sports-event {\n        background: #eaf1fb;\n        border-color: #d3e2f5;\n    }\n\n    &--cycling .sports-event {\n        background: #eaf6ee;\n        border-color: #d3ecdc;\n    }\n\n    &--kabaddi .sports-event {\n        background: #fdeee3;\n        border-color: #fad9c1;\n    }\n\n    &--football .sports-event {\n        background: #eaf6ee;\n        border-color: #d3ecdc;\n    }\n\n    &--volleyball .sports-event {\n        background: #f1eafb;\n        border-color: #ded0f5;\n    }\n}\n\n.sports-event {\n    flex: 1 1 0;\n    min-width: 78px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 12px 6px 14px;\n    border-right: 1px solid;\n\n    &:last-child {\n        border-right: none;\n    }\n\n    &__label {\n        font-weight: 700;\n        font-size: 0.72rem;\n        color: #101828;\n        min-height: 32px;\n    }\n\n    &__age {\n        display: block;\n        font-weight: 600;\n        font-size: 0.66rem;\n        color: #475467;\n    }\n\n    &__icon {\n        font-size: 1.8rem;\n        color: inherit;\n        margin: 10px 0;\n        line-height: 1;\n    }\n\n    &__divider {\n        display: block;\n        width: 70%;\n        border-top: 1px dashed #98a2b3;\n        margin-bottom: 8px;\n    }\n\n    &__gender-icons {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 4px;\n        font-size: 1.1rem;\n        margin-bottom: 4px;\n\n        .icofont-male {\n            color: #1d4ed8;\n        }\n\n        .icofont-female {\n            color: #db2777;\n        }\n    }\n\n    &__gender-label {\n        font-weight: 600;\n        font-size: 0.75rem;\n        color: #344054;\n    }\n}\n\n.sports-group--athletics .sports-event__icon {\n    color: #14335e;\n}\n\n.sports-group--cycling .sports-event__icon {\n    color: #14532d;\n}\n\n.sports-group--kabaddi .sports-event__icon {\n    color: #c2410c;\n}\n\n.sports-group--football .sports-event__icon {\n    color: #166534;\n}\n\n.sports-group--volleyball .sports-event__icon {\n    color: #5b21b6;\n}\n\n@media (min-width: 992px) {\n    .sports-categories {\n        overflow-x: visible;\n    }\n\n    .sports-group {\n        min-width: 0;\n\n        &--athletics {\n            min-width: 0;\n        }\n\n        &--cycling {\n            min-width: 0;\n        }\n\n        &__header {\n            padding: 14px 12px;\n            font-size: 1rem;\n\n            i {\n                font-size: 1.3rem;\n            }\n        }\n    }\n\n    .sports-event {\n        min-width: 0;\n        padding: 16px 10px 18px;\n\n        &__label {\n            font-size: 0.85rem;\n            min-height: 40px;\n        }\n\n        &__age {\n            font-size: 0.78rem;\n        }\n\n        &__icon {\n            font-size: 2.6rem;\n            margin: 14px 0;\n        }\n    }\n}\n\n/* ==========================================================================\n   Mashaal Modern Responsive Footer\n   ========================================================================== */\n.mashaal-footer {\n    background-color: #0b1325;\n    padding: 48px 0 24px 0;\n    color: #cbd5e1;\n    position: relative;\n    z-index: 10;\n\n    &__widgets {\n        row-gap: 24px;\n        align-items: flex-start;\n    }\n\n    &__col {\n        &--brand {\n            display: flex;\n            flex-direction: column;\n        }\n\n        &--links {\n            @media (min-width: 992px) {\n                padding-left: 2rem;\n            }\n        }\n\n        &--helpdesk {\n            @media (min-width: 992px) {\n                padding-left: 1rem;\n            }\n        }\n    }\n\n    &__brand-header {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        margin-bottom: 12px;\n    }\n\n    &__mascot {\n        height: 84px;\n        width: auto;\n        object-fit: contain;\n        flex-shrink: 0;\n    }\n\n    &__brand-text {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n    }\n\n    &__brand-title {\n        color: #ffffff;\n        font-size: 1.32rem;\n        font-weight: 800;\n        line-height: 1.15;\n        margin: 0 0 3px 0;\n        letter-spacing: -0.2px;\n    }\n\n    &__brand-subtitle {\n        color: #ffffff;\n        font-size: 0.86rem;\n        font-weight: 600;\n        line-height: 1.2;\n        margin: 0;\n        opacity: 0.95;\n    }\n\n    &__brand-desc {\n        color: #94a3b8;\n        font-size: 0.85rem;\n        line-height: 1.55;\n        margin: 0;\n        max-width: 320px;\n    }\n\n    &__title {\n        color: #ffffff;\n        font-size: 1.1rem;\n        font-weight: 700;\n        margin: 0 0 16px 0;\n        letter-spacing: 0.2px;\n    }\n\n    &__list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n    }\n\n    &__item {\n        margin-bottom: 8px;\n        font-size: 0.85rem;\n        line-height: 1.45;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        &--info {\n            margin-top: 10px;\n            margin-bottom: 2px;\n        }\n    }\n\n    &__text {\n        color: #94a3b8;\n        display: inline-block;\n    }\n\n    &__link {\n        color: #94a3b8;\n        text-decoration: none;\n        transition: color 0.2s ease;\n        display: inline-block;\n\n        &:hover {\n            color: #ff8a3d;\n        }\n    }\n\n    &__helpdesk-link {\n        color: #ffffff;\n        font-weight: 700;\n        text-decoration: underline;\n        text-underline-offset: 3px;\n        transition: color 0.2s ease;\n\n        &:hover {\n            color: #ff8a3d;\n        }\n    }\n\n    &__divider {\n        height: 1px;\n        width: 100%;\n        background: linear-gradient(\n            90deg,\n            #1e40af 0%,\n            #2563eb 20%,\n            #3b82f6 50%,\n            #2563eb 80%,\n            #1e40af 100%\n        );\n        box-shadow: 0 0 10px rgba(37, 99, 235, 0.6), 0 0 3px rgba(59, 130, 246, 0.9);\n        margin: 36px 0 20px 0;\n    }\n\n    &__bottom {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 0.82rem;\n        color: #94a3b8;\n    }\n\n    &__copyright {\n        margin: 0;\n        color: #94a3b8;\n        font-size: 0.82rem;\n    }\n\n    &__privacy {\n        color: #94a3b8;\n        font-size: 0.82rem;\n        text-decoration: underline;\n        text-underline-offset: 3px;\n        cursor: pointer;\n        transition: color 0.2s ease;\n\n        &:hover {\n            color: #ffffff;\n        }\n    }\n}\n\n@media (max-width: 767.98px) {\n    .mashaal-footer {\n        padding: 36px 0 24px 0;\n\n        &__col--brand {\n            margin-bottom: 8px;\n        }\n\n        &__brand-desc {\n            max-width: 100%;\n        }\n\n        &__divider {\n            margin: 28px 0 18px 0;\n        }\n\n        &__bottom {\n            flex-direction: column;\n            text-align: center;\n            gap: 6px;\n            justify-content: center;\n        }\n\n        &__copyright {\n            text-align: center;\n        }\n\n        &__privacy {\n            text-align: center;\n        }\n    }\n}\n\n// ============================================\n// CRC List Page Styles\n// ============================================\n.crc-list-page {\n    background: #f2f4f7;\n    padding: 32px 0 60px;\n    min-height: 60vh;\n}\n\n.crc-list-header {\n    margin-bottom: 20px;\n\n    h5 {\n        font-weight: 700;\n        font-size: 1.15rem;\n        color: #101828;\n        margin-bottom: 2px;\n    }\n\n    p {\n        color: #667085;\n        font-size: 0.9rem;\n        margin-bottom: 0;\n    }\n}\n\n.crc-list-filters {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    background: #ffffff;\n    border-radius: 14px;\n    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);\n    padding: 16px;\n    margin-bottom: 20px;\n    align-items: center;\n\n    // Match the Bootstrap Form.Control search box's height/radius/border so\n    // the district/block react-select dropdowns line up with it in the grid.\n    .crc-list-select__control {\n        min-height: 38px;\n        border-color: #ced4da;\n        border-radius: 0.375rem;\n    }\n\n    .crc-list-select__control--is-focused {\n        border-color: #86b7fe !important;\n        box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;\n    }\n\n    .crc-list-select__menu {\n        z-index: 5;\n    }\n}\n\n.crc-list-error {\n    background: #fef3f2;\n    color: #b42318;\n    border-radius: 10px;\n    padding: 10px 16px;\n    font-size: 0.85rem;\n    margin-bottom: 16px;\n}\n\n.crc-list-table-wrap {\n    background: #ffffff;\n    border-radius: 14px;\n    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);\n    overflow-x: auto;\n}\n\n.crc-list-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.88rem;\n\n    th,\n    td {\n        padding: 12px 16px;\n        text-align: left;\n        white-space: nowrap;\n    }\n\n    thead th {\n        font-size: 0.72rem;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        color: #667085;\n        border-bottom: 1px solid #eaecf0;\n    }\n\n    tbody tr {\n        border-bottom: 1px solid #f2f4f7;\n    }\n\n    tbody tr:last-child {\n        border-bottom: none;\n    }\n\n    &__empty {\n        text-align: center;\n        color: #667085;\n        padding: 32px 16px;\n        white-space: normal;\n    }\n}\n\n.crc-list-pagination {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-top: 16px;\n\n    &__meta {\n        color: #667085;\n        font-size: 0.85rem;\n    }\n\n    &__controls {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n    }\n\n    &__page {\n        color: #101828;\n        font-size: 0.85rem;\n        font-weight: 600;\n    }\n\n    button {\n        border: 1px solid #d0d5dd;\n        background: #ffffff;\n        border-radius: 8px;\n        padding: 6px 14px;\n        font-size: 0.85rem;\n        color: #101828;\n\n        &:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n        }\n\n        &:not(:disabled):hover {\n            background: #f2f4f7;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .crc-list-filters {\n        grid-template-columns: 1fr;\n    }\n\n    .crc-list-pagination {\n        flex-direction: column;\n        align-items: stretch;\n\n        &__controls {\n            justify-content: space-between;\n        }\n    }\n}\n\n// ==========================================\n// Coordinator / Trainer Page Styles\n// ==========================================\n.coordinator-trainer-page {\n    background: #f4f6fa;\n    padding: 30px 0 60px;\n    min-height: 75vh;\n}\n\n.coordinator-trainer-hero {\n    background: linear-gradient(135deg, #0f2b4c 0%, #173f6e 100%);\n    border-radius: 16px;\n    padding: 24px 28px;\n    color: #ffffff;\n    box-shadow: 0 8px 24px rgba(15, 43, 76, 0.16);\n\n    .badge-official {\n        background: #f0611b;\n        color: #ffffff;\n        font-size: 0.72rem;\n        font-weight: 700;\n        padding: 4px 10px;\n        border-radius: 20px;\n        letter-spacing: 0.5px;\n        text-transform: uppercase;\n    }\n\n    .badge-ref-date {\n        background: rgba(255, 255, 255, 0.18);\n        color: #ffffff;\n        font-size: 0.72rem;\n        font-weight: 600;\n        padding: 4px 10px;\n        border-radius: 20px;\n        backdrop-filter: blur(4px);\n    }\n\n    .coordinator-trainer-title {\n        font-size: 1.55rem;\n        font-weight: 800;\n        color: #ffffff;\n        margin-bottom: 6px;\n        letter-spacing: -0.01em;\n    }\n\n    .coordinator-trainer-subtitle {\n        font-size: 0.92rem;\n        color: rgba(255, 255, 255, 0.82);\n        margin-bottom: 0;\n        max-width: 600px;\n    }\n}\n\n.coordinator-trainer-tabs-wrap {\n    .coordinator-trainer-nav-pills {\n        background: #ffffff;\n        padding: 6px;\n        border-radius: 12px;\n        border: 1px solid #eaecf0;\n        display: inline-flex;\n        gap: 6px;\n        box-shadow: 0 2px 6px rgba(16, 24, 40, 0.04);\n\n        .nav-item {\n            .coordinator-tab-btn {\n                border-radius: 8px;\n                padding: 10px 22px;\n                font-weight: 700;\n                font-size: 0.92rem;\n                color: #475467;\n                background: transparent;\n                border: none;\n                cursor: pointer;\n                transition: all 0.2s ease;\n                display: flex;\n                align-items: center;\n\n                i {\n                    font-size: 1.15rem;\n                }\n\n                &:hover {\n                    color: #14335e;\n                    background: #f8fafc;\n                }\n\n                &.active {\n                    background: #14335e !important;\n                    color: #ffffff !important;\n                    box-shadow: 0 3px 8px rgba(20, 51, 94, 0.25);\n                }\n            }\n        }\n    }\n}\n\n.coordinator-content-card {\n    background: #ffffff;\n    border-radius: 16px;\n    border: 1px solid #eaecf0;\n\n    .empty-state-icon-circle {\n        width: 72px;\n        height: 72px;\n        border-radius: 50%;\n        background: #f0f4fa;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        i {\n            font-size: 2.2rem;\n            color: #14335e;\n        }\n    }\n}\n\n@media (max-width: 575.98px) {\n    .coordinator-trainer-tabs-wrap .coordinator-trainer-nav-pills {\n        width: 100%;\n        flex-direction: column;\n\n        .nav-item .coordinator-tab-btn {\n            width: 100%;\n            justify-content: center;\n        }\n    }\n}\n\n.tab-count-badge {\n    background: rgba(20, 51, 94, 0.12);\n    color: #14335e;\n    font-size: 0.72rem;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 12px;\n}\n\n.coordinator-tab-btn.active .tab-count-badge {\n    background: rgba(255, 255, 255, 0.25);\n    color: #ffffff;\n}\n\n.coordinator-search-card {\n    background: #ffffff;\n    border-radius: 14px;\n    border: 1px solid #eaecf0;\n\n    .search-label {\n        font-size: 0.84rem;\n        margin-bottom: 6px;\n        color: #344054;\n    }\n\n    .search-select,\n    .search-input-control {\n        border-radius: 8px;\n        border: 1px solid #d0d5dd;\n        font-size: 0.88rem;\n        height: 40px;\n\n        &:focus {\n            border-color: #14335e;\n            box-shadow: 0 0 0 3px rgba(20, 51, 94, 0.12) !important;\n        }\n    }\n\n    .btn-coordinator-search {\n        background: #14335e;\n        border-color: #14335e;\n        height: 40px;\n        border-radius: 8px;\n        font-size: 0.9rem;\n        transition: all 0.2s ease;\n\n        &:hover {\n            background: #0f2747;\n            border-color: #0f2747;\n            transform: translateY(-1px);\n        }\n    }\n\n    .btn-coordinator-reset {\n        height: 40px;\n        border-radius: 8px;\n        font-size: 0.9rem;\n    }\n\n    .results-count-text {\n        font-size: 0.86rem;\n\n        strong {\n            color: #101828;\n        }\n    }\n\n    .active-filter-indicator {\n        font-size: 0.84rem;\n        color: #14335e;\n        background: #eff4fb;\n        padding: 4px 10px;\n        border-radius: 6px;\n        border: 1px solid #d6e4f7;\n    }\n}\n\n.coordinator-table-card {\n    background: #ffffff;\n    border-radius: 14px;\n    border: 1px solid #eaecf0;\n    overflow: hidden;\n}\n\n.coordinator-main-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.88rem;\n    margin-bottom: 0;\n\n    thead th {\n        background: #f8fafc;\n        color: #344054;\n        font-weight: 700;\n        font-size: 0.76rem;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        padding: 13px 16px;\n        border-bottom: 2px solid #e2e8f0;\n        white-space: nowrap;\n        vertical-align: middle;\n\n        &.th-sr-no {\n            width: 70px;\n        }\n\n        &.th-districts {\n            min-width: 200px;\n        }\n\n        &.th-person {\n            min-width: 200px;\n        }\n\n        &.th-mobile {\n            min-width: 170px;\n        }\n\n        &.th-action {\n            width: 110px;\n        }\n    }\n\n    tbody tr.coordinator-row {\n        border-bottom: 1px solid #f2f4f7;\n        transition: background-color 0.15s ease;\n\n        &:last-child {\n            border-bottom: none;\n        }\n\n        &:hover {\n            background-color: #f8faff;\n        }\n\n        td {\n            padding: 13px 16px;\n            vertical-align: middle;\n        }\n\n        .sr-no-pill {\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            width: 28px;\n            height: 28px;\n            border-radius: 50%;\n            background: #f0f4fa;\n            color: #14335e;\n            font-weight: 700;\n            font-size: 0.8rem;\n        }\n\n        .district-tag {\n            display: inline-flex;\n            align-items: center;\n            background: #f0fdf4;\n            color: #166534;\n            border: 1px solid #bbf7d0;\n            padding: 4px 10px;\n            border-radius: 6px;\n            font-size: 0.82rem;\n            font-weight: 600;\n\n            i {\n                font-size: 0.85rem;\n                color: #22c55e;\n            }\n        }\n\n        .person-avatar-circle {\n            width: 32px;\n            height: 32px;\n            border-radius: 50%;\n            background: #eff6ff;\n            color: #1d4ed8;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 1rem;\n            flex-shrink: 0;\n\n            &--trainer {\n                background: #fef3c7;\n                color: #b45309;\n            }\n        }\n\n        .person-name {\n            font-weight: 700;\n            color: #101828;\n            font-size: 0.9rem;\n        }\n\n        .mobile-link {\n            display: inline-flex;\n            align-items: center;\n            color: #14335e;\n            font-weight: 600;\n            font-size: 0.88rem;\n            text-decoration: none;\n            padding: 4px 8px;\n            border-radius: 6px;\n            transition: all 0.15s ease;\n\n            i {\n                color: #f0611b;\n                font-size: 0.95rem;\n            }\n\n            &:hover {\n                background: #f0f4fa;\n                color: #f0611b;\n            }\n        }\n\n        .btn-call-now {\n            background: #f0fdf4;\n            color: #15803d;\n            border: 1px solid #bbf7d0;\n            font-weight: 700;\n            font-size: 0.8rem;\n            padding: 4px 12px;\n            border-radius: 6px;\n            transition: all 0.2s ease;\n            text-decoration: none;\n            display: inline-flex;\n            align-items: center;\n\n            i {\n                font-size: 0.85rem;\n            }\n\n            &:hover {\n                background: #16a34a;\n                color: #ffffff;\n                border-color: #16a34a;\n                transform: translateY(-1px);\n            }\n        }\n\n        .btn-whatsapp-now {\n            background: #25d366;\n            color: #ffffff;\n            border: 1px solid #22c55e;\n            font-weight: 700;\n            font-size: 0.8rem;\n            padding: 4px 10px;\n            border-radius: 6px;\n            transition: all 0.2s ease;\n            text-decoration: none;\n            display: inline-flex;\n            align-items: center;\n            gap: 4px;\n\n            i {\n                font-size: 0.95rem;\n            }\n\n            &:hover {\n                background: #1da851;\n                color: #ffffff;\n                border-color: #1da851;\n                transform: translateY(-1px);\n            }\n        }\n    }\n\n    .table-no-results {\n        padding: 40px 20px;\n\n        .empty-icon {\n            font-size: 2.8rem;\n        }\n    }\n}\n\n.coordinator-footer-note {\n    font-size: 0.85rem;\n    line-height: 1.5;\n}\n\n\n","// \n// file-manager.scss\n// \n\n.file-search {\n    .search-input {\n        background-color: $gray-100;\n        padding-left: 40px;\n    }\n    .icon-search {\n        z-index: 9;\n        position: absolute;\n    }\n}\n\n// responsive\n@media (max-width: 768px) {\n    .recent-data{\n        margin-left: 0px !important;\n        padding: 0px !important;\n    }\n}\n\n","// \n//  chat.scss\n// \n\n /* Search */\n .chat-search {\n    height: $topbar-height;\n    display: table;\n    width: 100%;\n    .chat-search-box {\n        display: table-cell;\n        vertical-align: middle;\n        position: relative;\n    }\n    .form-control {        \n        padding: 0;\n        box-shadow: none;\n        background-color: $chat-secondary-user-bg !important;\n        border-color: $chat-secondary-user-bg !important;\n        &::placeholder {\n            color: darken($gray-500, 10%);\n        }\n    }\n\n    .btn {\n        box-shadow: none !important;\n        background-color: $chat-secondary-user-bg;\n        color: $gray-600;\n    }\n}\n\n.user-status {\n    position: absolute;\n    height: 11px;\n    width: 11px;\n    background-color: $gray-400;\n    border: 2.5px solid $white;\n    border-radius: 50%;\n    bottom: 0;\n    left: 35px;\n}\n\n.video-call{\n    background-image: url(\"../../../images/users/chat.jpg\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 450px;\n    position: relative;    \n    .video-call-head{\n        img{\n            height: 4rem;\n            width: 4rem;\n        }\n    }\n    .video-call-action{\n        position: absolute;\n        bottom: 0px;\n        left: 0;\n        right: 0;\n        padding: 60px 0 16px;\n        background: linear-gradient(to top, $black 0, rgba($black, 0) 90%);\n    }\n}\n\n.voice-call{\n    height: 450px;\n    position: relative;\n    .voice-call-head{\n        img{\n            width: 6rem;\n            height: 6rem;\n        }\n    }\n    .voice-call-action{\n        position: absolute;\n        bottom: 0px;\n        left: 0;\n        right: 0;\n    }\n}\n\n.conversation-list {\n    list-style: none;\n    padding: 0 15px;\n    outline: none;\n    li {\n        margin-bottom: 20px;\n        .conversation-actions {\n            display: none;\n        }\n        &:hover{\n            .conversation-actions {\n                display: block;\n            }\n        }\n                \n    }\n    .ctext-wrap {\n        background: $chat-secondary-user-bg;\n        color: $gray-600;\n        border-radius: 3px;\n        display: inline-block;\n        padding: 7px 12px;\n        position: relative;\n        i {\n            display: block;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: bold;\n            position: relative;\n        }\n        p {\n            margin: 0;\n            padding: 0;\n        }\n        &:after {\n            left: -11px;\n            top: 0;\n            border: solid transparent;\n            content: \" \";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-width: 6px;\n            margin-right: -1px;\n        }\n    }\n    .conversation-text {\n        float: left;\n        font-size: 13px;\n        margin-left: 12px;\n        width: 80%;\n    }\n    .odd {\n        .conversation-text {\n            float: right !important;\n            text-align: right !important;\n            width: 70% !important;\n        }\n        .ctext-wrap {\n            background-color: $chat-primary-user-bg;\n            color: $gray-700;\n            &:after {\n                border-color: transparent;\n                right: -10px;\n                left: auto;\n            }\n        }\n    }\n}","//\n// dashboard.scss\n//\n\n// Cluster/Block/District dashboards' stat-card row (crcDashboard,\n// blockDashboard, districtDashboard - see components/DistrictContactCard.tsx).\n// CSS Grid instead of Bootstrap's 12-column Row/Col: 5 cards (4 stats + the\n// district contact card) don't divide evenly into 12 columns without an\n// asymmetric split (e.g. lg=2 x4 + lg=4), which read as cramped/uneven per\n// dev-plan [29 Sept 2026]. auto-fit + minmax gives every tile the same\n// width, wrapping gracefully at any viewport instead of a fixed column count.\n.dash-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    .dash-stat-tile .card {\n        height: 100%;\n    }\n}\n","//\n// apexcharts.scss\n//\n.apex-charts {\n    min-height: 10px !important;\n    text {\n        font-family: $font-family-base !important;\n        // fill: $text-muted;\n        font-weight: $font-weight-bold;\n    }\n    .apexcharts-canvas {\n        margin: 0 auto;\n    }\n}\n\n.apexcharts-tooltip-title,\n.apexcharts-tooltip-text,\n.apexcharts-legend-text  {\n    font-family: $font-family-base !important;\n}\n\n.apexcharts-legend-series {\n    font-weight: $font-weight-bold;\n}\n\n.apexcharts-gridline {\n    pointer-events: none;\n    stroke: $apex-grid-color;\n}\n\n.apexcharts-legend-text {\n    color: $text-muted !important;\n}\n\n.apexcharts-yaxis,\n.apexcharts-xaxis {\n    text {\n        font-family: $font-family-base !important;\n        fill: $text-muted;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.apexcharts-point-annotations,\n.apexcharts-xaxis-annotations,\n.apexcharts-yaxis-annotations {\n    text {\n        fill: $text-muted;\n    }\n}\n\n.apexcharts-radar-series {\n    polygon {\n        fill: transparent;\n        stroke: $gray-300;\n    }\n    line {\n        stroke: $gray-300;\n    }\n}\n\n// .apexcharts-pie-label, \n// .apexcharts-datalabel, \n// .apexcharts-datalabel-label,\n// .apexcharts-datalabel-value {\n//     fill: $text-muted !important;\n// }\n\n.apexcharts-plot-series {\n    .apexcharts-datalabel{\n        fill: $white !important;\n    }\n}\n\n.apexcharts-datalabels-group {\n    text {\n        fill: $text-muted !important;\n        font-family: $font-family-base !important;\n    }\n}\n\n// Scatter images chart\n.scatter-images-chart {\n    .apexcharts-legend {\n        overflow: hidden !important;\n        min-height: 17px;\n    }\n    .apexcharts-legend-marker {\n        background: none !important;\n        margin-right: 7px !important;\n    }\n    .apexcharts-legend-series {\n        align-items: flex-start !important;\n    }\n}\n\n.apexcharts-pie-series {\n    path {\n        stroke: transparent !important;\n    }\n}\n\n.apexcharts-track {\n    path {\n        stroke: lighten($gray-300,5%);\n    }\n}\n\n.apexcharts-xaxis {\n    line {\n        stroke: $gray-400 !important;\n    }\n}\n\n.apex-charts {\n    .apexcharts-title-text {\n        fill: $text-color-h;\n    }\n    .apexcharts-subtitle-text {\n        fill: shade-color($gray-500, 10%);\n        font-weight: $font-weight-normal;\n    }\n}","// \n// calendar.scss\n//\n\n.calendar {\n    float: left;\n    margin-bottom: 0;\n}\n\n.fc-view-container, .fc-view-harness{\n    .table-bordered {\n        th,\n        td {\n          border: $table-border-width solid $table-border-color;\n        }\n    }\n    .fc-popover {\n        z-index: 1000 !important;\n        background-color: $gray-100;\n    }\n}\n\n\n.fc-view {\n    margin-top: 30px !important;\n}\n\n.none-border {\n    .modal-footer {\n        border-top: none;\n    }\n}\n\n.fc-toolbar {\n    margin: 10px 0 5px 0 !important;\n\n    h2 {\n        font-size: 1.25rem !important;\n        line-height: 1.875rem !important;\n        text-transform: uppercase;\n    }\n}\n\n.fc-day-grid-event {\n    .fc-time {\n        font-weight: $font-weight-medium;\n    }\n}\n\nth.fc-day-header, th.fc-col-header-cell {\n    padding: 0.5rem 0 !important;\n}\n\n.fc-day {\n    background: transparent;\n}\n\n.fc-toolbar {\n\n    .fc-state-active,\n    .ui-state-active,\n    button:focus,\n    button:hover,\n    .ui-state-hover {\n        z-index: 0;\n    }\n}\n\n.fc {\n    th.fc-widget-header {\n        background: $gray-300;\n        font-size: 13px;\n        line-height: 20px;\n        padding: 10px 0;\n        text-transform: uppercase;\n        font-weight: $font-weight-medium;\n    }\n}\n\n.fc-unthemed {\n\n    th,\n    td,\n    thead,\n    tbody,\n    .fc-divider,\n    .fc-row,\n    .fc-popover {\n        border-color: $gray-300;\n    }\n\n    td.fc-today,\n    .fc-divider {\n        background: $gray-300;\n    }\n}\n\n\n.fc-button {\n    background: $gray-300;\n    border: none;\n    color: $gray-700;\n    text-transform: capitalize;\n    box-shadow: none;\n    border-radius: 3px;\n    margin: 0 3px;\n    padding: 6px 12px;\n    height: auto;\n}\n\n.fc-text-arrow {\n    font-family: inherit;\n    font-size: 1rem;\n}\n\n.fc-state-hover,\n.fc-state-highlight,\n.fc-cell-overlay {\n    background: $gray-300;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n    background-color: $primary;\n    color: $white;\n    text-shadow: none;\n}\n\n.fc-unthemed {\n    .fc-today {\n        background: $white;\n    }\n}\n\n.fc-event {\n    border-radius: 2px !important;\n    border: none !important;\n    cursor: move;\n    font-size: 0.8125rem !important;\n    margin: 5px 7px;\n    padding: 5px 5px !important;\n    text-align: center;\n}\n\n.external-event {\n    cursor: move;\n    margin: 10px 0;\n    padding: 8px 10px;\n    color: $white;\n    border-radius: 4px;\n}\n\n.fc-basic-view {\n    td.fc-week-number {\n        span {\n            padding-right: 8px;\n        }\n    }\n\n    td.fc-day-number {\n        padding-right: 8px;\n    }\n\n    .fc-content {\n        color: $white;\n    }\n}\n\n.fc-time-grid-event {\n    .fc-content {\n        color: $white;\n    }\n}\n\n.fc-content-skeleton{\n    .fc-day-top {\n        .fc-day-number {\n            float: right;\n            height: 20px;\n            width: 20px;\n            text-align: center;\n            line-height: 20px;\n            background-color: $gray-100;\n            border-radius: 50%;\n            margin: 5px;\n            font-size: 11px;\n        }\n    }\n}\n\n@include media-breakpoint-down(md) {\n    .fc-toolbar {\n        display: block !important;\n        .fc-left,\n        .fc-right,\n        .fc-center {\n            text-align: left;\n            float: none;\n            display: block;\n            clear: both;\n            margin: 10px 0;\n        }\n    }\n\n    .fc {\n        .fc-toolbar {\n            >* {\n                >* {\n                    float: none;\n                }\n            }\n        }\n    }\n\n    .fc-today-button {\n        display: none;\n    }\n}\n\n// overriding button sizes\n.fc-toolbar {\n    .btn {\n        @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n    }\n}\n\n.fc-list-item-title,\n.fc-list-item-time {\n    color: $white;\n}\n\n[dir=\"rtl\"] .fc-toolbar{\n    .btn-group{\n        .btn{\n            &:first-child{\n                border-top-left-radius: 0 !important;\n                border-bottom-left-radius: 0 !important;\n                border-radius: $btn-border-radius;\n            }\n            &:last-child{\n                border-top-right-radius: 0 !important;\n                border-bottom-right-radius: 0 !important;\n                border-radius: $btn-border-radius;\n            }\n        }\n    }\n}\n\n.fc-list-table {\n    .fc-list-day, .fc-list-event {\n        th, td {\n            padding: $table-cell-padding-y $table-cell-padding-x !important;\n        }\n    }\n\n    .fc-list-day {\n        th, td {\n            background: transparent !important;\n        }\n    }\n\n    .fc-list-event {\n        &:hover{\n            td,th {\n                background-color: inherit !important;\n            }\n        }\n\n        td,th {\n            color: $white !important;\n        }\n    }\n}\n\n.fc-daygrid-event {\n    color: $white !important;\n}","//\n// colorpicker.scss\n//\n.sp-container{\n    background-color: $dropdown-bg;\n    z-index: 9;\n    button{\n      padding: .25rem .5rem;\n        font-size: .71094rem;\n        border-radius: .2rem;\n        font-weight: 400;\n        color: $dark;\n        &.sp-palette-toggle{\n          background-color: $light;\n        }\n        &.sp-choose{\n          background-color: $success;\n          margin-left: 5px;\n          margin-right: 0;\n        }\n    }\n  }\n  .sp-palette-container{\n    border-right: 1px solid $border-color;\n  }\n  .sp-input{\n    background-color: $input-bg;\n    border-color: $input-border-color !important;\n    color: $input-color;\n    &:focus{\n      outline: none;\n    }\n  }\n  [dir=\"rtl\"]{\n    .sp-alpha{\n      direction: ltr;\n    }\n    .sp-original-input-container {\n      .sp-add-on{\n          border: none;\n        border-top-right-radius: 0!important;\n        border-bottom-right-radius: 0!important;\n        border-top-left-radius: 4px!important;\n        border-bottom-left-radius: 4px!important\n      }\n    } \n    input.spectrum.with-add-on{\n      border: 1px solid $input-border-color;\n      border-left: 0;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-top-right-radius: $input-border-radius;\n      border-bottom-right-radius: $input-border-radius;\n    }\n  }\n  .sp-original-input-container .sp-add-on{\n      border: none !important;\n  }\n\n\n\n\n\n\n\n\n\n\n\n\n","//\n// sparkline.scss\n//\n\n.jqstooltip {\n    box-sizing: content-box;\n    width: auto !important;\n    height: auto !important;\n    background-color: $white !important;\n    box-shadow: $box-shadow-lg;\n    padding: 5px 10px !important;\n    border-radius: 3px;\n    border-color: $white !important;\n}\n\n.jqsfield {\n    color: $black !important;\n    font-size: 12px !important;\n    line-height: 18px !important;\n    font-family: $font-family-base !important;\n    font-weight: $font-weight-bold !important;\n}","//\n// datatable.scss\n//\n\n.dataTables_wrapper.container-fluid {\n    padding: 0;\n}\n\ntable.dataTable {\n    border-collapse: collapse !important;\n    margin-bottom: 15px !important;\n\n    tbody {\n        // Multi select table\n\n        > tr.selected, \n        >tr >.selected {\n            background-color: $primary;\n            \n            td {\n                border-color: $primary;\n            }\n        }\n        td {\n            &:focus {\n                outline: none !important;\n            }\n        }\n        // Key Tables\n        th.focus,td.focus{\n            outline: 2px solid $primary !important;\n            outline-offset: -1px;\n            color: $primary;\n            background-color: rgba($primary, 0.15);\n        }\n    }\n    thead {\n        .sorting, \n        .sorting_asc, \n        .sorting_desc, \n        .sorting_asc_disabled, \n        .sorting_desc_disabled {\n            &::before{\n                right: 1em;\n                left: auto;\n                content: \"\\2191\";\n            }\n            &::after{\n                right: 0.5em;\n                left: auto;\n                content: \"\\2193\";\n            }\n        }\n        > tr{\n            > th{\n                &.sorting, \n                &.sorting_asc, \n                &.sorting_desc{\n                    padding-right: 30px;\n                    padding-left: $table-cell-padding-x;\n                }\n            }\n        }\n    }\n}\n\n.dataTables_info {\n    font-weight: $font-weight-semibold;\n}\n\n\n// Responsive data table\ntable.dataTable.dtr-inline.collapsed {\n    > tbody {\n        >tr[role=row] {\n            > td, > th {\n                &:first-child{\n                    &:before{\n                        box-shadow: $box-shadow-lg;\n                        background-color: $success;\n                    }\n                }\n            }\n        }\n        >tr.parent {\n            > td, > th {\n                &:first-child{\n                    &:before{\n                        background-color: $danger;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Data Table copy button\ndiv.dt-button-info {\n    background-color: $primary;\n    border: none;\n    color: $white;\n    box-shadow: none;\n    border-radius: 3px;\n    text-align: center;\n    z-index: 21;\n\n    h2 {\n        border-bottom: none;\n        background-color: rgba($white, 0.2);\n        color: $white;\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    li.paginate_button.previous,li.paginate_button.next {\n        display: inline-block;\n        font-size: 1.5rem;\n    }\n \n    li.paginate_button {\n        display: none;\n    }\n    .dataTables_paginate {\n        ul {\n            text-align: center;\n            display: block;\n            margin: $spacer 0 0 !important;\n        }\n    }\n    div.dt-buttons {\n        display: inline-table;\n        margin-bottom: $spacer;\n    }\n}\n\n.activate-select {\n    .sorting_1 {\n        background-color: $dropdown-link-hover-bg;\n    }\n}\n\n.dataTables_filter{\n    text-align: right;\n    input{\n        margin-left: .5em;\n        margin-right: 0 !important;\n    }\n}\n","//\n// Datepicker\n//\n\n$datepicker__background-color: $dropdown-bg;\n$datepicker__border-color: $dropdown-border-color;\n$datepicker__highlighted-color: $primary;\n$datepicker__muted-color: $gray-600;\n$datepicker__selected-color: $primary;\n$datepicker__text-color: $gray-600;\n$datepicker__header-color: $gray-600;\n$datepicker__navigation-disabled-color: lighten($datepicker__muted-color, 10%);\n\n$datepicker__border-radius: 0.3rem;\n$datepicker__day-margin: 0.166rem;\n$datepicker__font-size: $font-size-base;\n$datepicker__font-family: $font-family-base;\n\n$datepicker__item-size: 2rem;\n$datepicker__margin: 0.4rem;\n$datepicker__navigation-size: 0.45rem;\n$datepicker__triangle-size: 8px;\n\n%triangle-arrow {\n  margin-left: -$datepicker__triangle-size;\n  position: absolute;\n\n  &,\n  &::before {\n    box-sizing: content-box;\n    position: absolute;\n    border: $datepicker__triangle-size solid transparent;\n\n    height: 0;\n    width: 1px;\n  }\n\n  &::before {\n    content: \"\";\n    z-index: -1;\n    border-width: $datepicker__triangle-size;\n\n    left: -$datepicker__triangle-size;\n    border-bottom-color: $datepicker__border-color;\n  }\n}\n\n%triangle-arrow-up {\n  @extend %triangle-arrow;\n\n  top: 0;\n  margin-top: -$datepicker__triangle-size;\n\n  &,\n  &::before {\n    border-top: none;\n    border-bottom-color:  $datepicker__muted-color;\n  }\n\n  &::before {\n    top: 0px;\n    border-bottom-color: $input-bg;\n  }\n}\n\n%triangle-arrow-down {\n  @extend %triangle-arrow;\n\n  bottom: 0;\n  margin-bottom: -$datepicker__triangle-size;\n\n  &,\n  &::before {\n    border-bottom: none;\n    border-top-color: $datepicker__muted-color;\n  }\n\n  &::before {\n    bottom: 0px;\n    border-top-color: $input-bg;\n  }\n}\n\n.react-datepicker-wrapper {\n  display: block;\n}\n\n.react-datepicker {\n  font-family: $datepicker__font-family;\n  font-size: $datepicker__font-size;\n  background-color: $dropdown-bg;\n  color: $datepicker__text-color;\n  border: 1px solid $datepicker__border-color;\n  border-radius: $datepicker__border-radius;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only {\n  .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker__time {\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-box {\n    border-radius: 0.3rem;\n  }\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n\n  &[data-placement^=\"bottom\"] {\n    padding-top: $datepicker__triangle-size + 2px;\n\n    .react-datepicker__triangle {\n      @extend %triangle-arrow-up;\n    }\n  }\n\n  &[data-placement^=\"top\"] {\n    padding-bottom: $datepicker__triangle-size + 2px;\n\n    .react-datepicker__triangle {\n      @extend %triangle-arrow-down;\n    }\n  }\n\n  &[data-placement^=\"right\"] {\n    padding-left: $datepicker__triangle-size;\n\n    .react-datepicker__triangle {\n      left: auto;\n      right: 42px;\n    }\n  }\n\n  &[data-placement^=\"left\"] {\n    padding-right: $datepicker__triangle-size;\n\n    .react-datepicker__triangle {\n      left: 42px;\n      right: auto;\n    }\n  }\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: $datepicker__background-color;\n  border-bottom: 1px solid $datepicker__border-color;\n  border-top-left-radius: $datepicker__border-radius;\n  border-top-right-radius: $datepicker__border-radius;\n  padding-top: 8px;\n  position: relative;\n\n  &--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: $datepicker__header-color;\n  font-weight: bold;\n  font-size: $datepicker__font-size;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  width: 0;\n  padding: 0;\n  border: $datepicker__navigation-size solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n\n  &--previous {\n    left: 10px;\n    border-right-color: $datepicker__muted-color;\n\n    &:hover {\n      border-right-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-right-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  &--next {\n    right: 10px;\n    border-left-color: $datepicker__muted-color;\n\n    &--with-time:not(&--with-today-button) {\n      right: 80px;\n    }\n\n    &:hover {\n      border-left-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-left-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  &--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &-previous {\n      top: 4px;\n      border-top-color: $datepicker__muted-color;\n\n      &:hover {\n        border-top-color: darken($datepicker__muted-color, 10%);\n      }\n    }\n\n    &-upcoming {\n      top: -4px;\n      border-bottom-color: $datepicker__muted-color;\n\n      &:hover {\n        border-bottom-color: darken($datepicker__muted-color, 10%);\n      }\n    }\n  }\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: $datepicker__margin;\n  text-align: center;\n\n  .react-datepicker__month-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n\n  .react-datepicker-time__caption {\n    display: inline-block;\n  }\n\n  .react-datepicker-time__input-container {\n    display: inline-block;\n\n    .react-datepicker-time__input {\n      display: inline-block;\n      margin-left: 10px;\n\n      input {\n        width: 85px;\n      }\n\n      input[type=\"time\"]::-webkit-inner-spin-button,\n      input[type=\"time\"]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n\n      input[type=\"time\"] {\n        -moz-appearance: textfield;\n      }\n    }\n\n    .react-datepicker-time__delimiter {\n      margin-left: 5px;\n      display: inline-block;\n    }\n  }\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid $datepicker__border-color;\n  width: 100px;\n\n  &--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n  }\n\n  .react-datepicker__time {\n    position: relative;\n    background: $input-bg;\n\n    .react-datepicker__time-box {\n      width: 100px;\n      overflow-x: hidden;\n      margin: 0 auto;\n      text-align: center;\n\n      ul.react-datepicker__time-list {\n        list-style: none;\n        margin: 0;\n        height: calc(195px + (#{$datepicker__item-size} * 0.5));\n        overflow-y: scroll;\n        padding-right: 0px;\n        padding-left: 0px;\n        width: 100%;\n        box-sizing: content-box;\n\n        li.react-datepicker__time-list-item {\n          height: 30px;\n          padding: 5px 10px;\n          outline: none !important;\n\n          &:hover {\n            cursor: pointer;\n            background-color: $datepicker__background-color;\n          }\n\n          &--selected {\n            background-color: $datepicker__selected-color;\n            color: white;\n            font-weight: bold;\n\n            &:hover {\n              background-color: $datepicker__selected-color;\n            }\n          }\n\n          &--disabled {\n            color: $datepicker__muted-color;\n\n            &:hover {\n              cursor: default;\n              background-color: transparent;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.react-datepicker__week-number {\n  color: $datepicker__muted-color;\n  display: inline-block;\n  width: $datepicker__item-size;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  margin: $datepicker__day-margin;\n\n  &.react-datepicker__week-number--clickable {\n    cursor: pointer;\n\n    &:hover {\n      border-radius: $datepicker__border-radius;\n      background-color: $datepicker__background-color;\n    }\n  }\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: $datepicker__text-color;\n  display: inline-block;\n  width: $datepicker__item-size;\n  height: $datepicker__item-size;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  margin: $datepicker__day-margin;\n}\n\n.react-datepicker__month {\n  &--selected,\n  &--in-selecting-range,\n  &--in-range {\n    border-radius: $datepicker__border-radius;\n    background-color: $datepicker__selected-color;\n    color: #fff;\n\n    &:hover {\n      background-color: darken($datepicker__selected-color, 5%);\n    }\n  }\n\n  &--disabled {\n    color: $datepicker__muted-color;\n    pointer-events: none;\n\n    &:hover {\n      cursor: default;\n      background-color: transparent;\n    }\n  }\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text {\n  cursor: pointer;\n\n  &:hover {\n    border-radius: $datepicker__border-radius;\n    background-color: $datepicker__highlighted-color;\n    color: #fff !important;\n  }\n\n  &--today {\n    font-weight: bold;\n  }\n\n  &--highlighted {\n    border-radius: $datepicker__border-radius;\n    background-color: $datepicker__highlighted-color;\n    color: #fff;\n\n    &:hover {\n      background-color: darken($datepicker__highlighted-color, 5%);\n    }\n\n    &-custom-1 {\n      color: magenta;\n    }\n\n    &-custom-2 {\n      color: green;\n    }\n  }\n\n  &--selected,\n  &--in-selecting-range,\n  &--in-range {\n    border-radius: $datepicker__border-radius;\n    background-color: $datepicker__selected-color;\n    color: #fff;\n\n    &:hover {\n      background-color: darken($datepicker__selected-color, 5%);\n    }\n  }\n\n  &--keyboard-selected {\n    border-radius: $datepicker__border-radius;\n    background-color: lighten($datepicker__selected-color, 10%);\n    color: #fff;\n\n    &:hover {\n      background-color: darken($datepicker__selected-color, 5%);\n    }\n  }\n\n  &--in-selecting-range:not(&--in-range) {\n    background-color: rgba($datepicker__selected-color, 0.5);\n  }\n\n  &--in-range:not(&--in-selecting-range) {\n    .react-datepicker__month--selecting-range & {\n      background-color: $datepicker__background-color;\n      color: $datepicker__text-color;\n    }\n  }\n\n  &--disabled {\n    cursor: default;\n    color: $datepicker__muted-color;\n\n    &:hover {\n      background-color: transparent;\n    }\n  }\n}\n\n.react-datepicker__month-text {\n  &.react-datepicker__month--selected,\n  &.react-datepicker__month--in-range {\n    &:hover {\n      background-color: $datepicker__selected-color;\n    }\n  }\n\n  &:hover {\n    background-color: $datepicker__background-color;\n  }\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: block;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: $datepicker__border-radius;\n\n  &:hover {\n    cursor: pointer;\n\n    .react-datepicker__year-read-view--down-arrow,\n    .react-datepicker__month-read-view--down-arrow {\n      border-top-color: darken($datepicker__muted-color, 10%);\n    }\n  }\n\n  &--down-arrow {\n    @extend %triangle-arrow-down;\n    border-top-color: $datepicker__muted-color;\n    float: right;\n    margin-left: 20px;\n    top: 8px;\n    position: relative;\n    border-width: $datepicker__navigation-size;\n  }\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: $datepicker__background-color;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: $datepicker__border-radius;\n  border: 1px solid $datepicker__border-color;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n\n  &:first-of-type {\n    border-top-left-radius: $datepicker__border-radius;\n    border-top-right-radius: $datepicker__border-radius;\n  }\n\n  &:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: $datepicker__border-radius;\n    border-bottom-right-radius: $datepicker__border-radius;\n  }\n\n  &:hover {\n    background-color: $datepicker__muted-color;\n\n    .react-datepicker__navigation--years-upcoming {\n      border-bottom-color: darken($datepicker__muted-color, 10%);\n    }\n\n    .react-datepicker__navigation--years-previous {\n      border-top-color: darken($datepicker__muted-color, 10%);\n    }\n  }\n\n  &--selected {\n    position: absolute;\n    left: 15px;\n  }\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n\n  &::after {\n    background-color: $datepicker__selected-color;\n    border-radius: 50%;\n    bottom: 0;\n    box-sizing: border-box;\n    color: #fff;\n    content: \"\\00d7\";\n    cursor: pointer;\n    font-size: 12px;\n    height: 16px;\n    width: 16px;\n    line-height: 1;\n    margin: -8px auto 0;\n    padding: 2px;\n    position: absolute;\n    right: 0px;\n    text-align: center;\n  }\n}\n\n.react-datepicker__today-button {\n  background: $datepicker__background-color;\n  border-top: 1px solid $datepicker__border-color;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  // Resize for small screens\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__day-name,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      width: 2rem;\n      line-height: 2rem;\n    }\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header {\n    font-size: $datepicker__font-size * 1.8;\n  }\n\n  .react-datepicker__navigation {\n    border: 1.8 * $datepicker__navigation-size solid transparent;\n  }\n\n  .react-datepicker__navigation--previous {\n    border-right-color: $datepicker__muted-color;\n\n    &:hover {\n      border-right-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-right-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  .react-datepicker__navigation--next {\n    border-left-color: $datepicker__muted-color;\n\n    &:hover {\n      border-left-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-left-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n}\n\n// remove outline on focus\n.react-datepicker__day:focus {\n  outline: none !important;\n}\n\n// calendar widget\n.calendar-widget {\n  > div {\n    width: 100%;\n  }\n  .react-datepicker {\n    width: 100%;\n    \n    .react-datepicker__month-container {\n      width: 100%;\n\n      .react-datepicker__current-month {\n        font-size: 1.1rem;\n      }\n\n      .react-datepicker__day-names,\n      .react-datepicker__week {\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n        height: 52px;\n      }\n\n    }\n  }\n}\n","//\n// formm-wizard.scss\n//\n\n.sw-main{\n    box-shadow: none;\n    border: 1px solid darken($gray-300, 2%);\n    \n    .sw-toolbar{\n        background: transparent;\n        padding: 10px;\n    }\n    .step-content{\n        background-color: transparent !important;\n        text-align: left;\n    }\n}\n\n// sw-theme-default\n\n.sw-theme-default{\n    .step-content{\n        background-color: transparent;\n    }\n\n    >ul.step-anchor{\n        >li{\n            >a{\n                color: $gray-600;\n                &:hover{\n                    color: $gray-600; \n                }\n                &:after{\n                    background: $primary;\n                }\n            }\n            &.active{\n                >a{\n                    color: $primary !important;\n                }\n            }\n            &.done{\n                >a{\n                    color: $gray-600 !important;\n                    &:after{\n                        background: $success;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// sw-theme-arrows\n\n.sw-theme-arrows{\n    >ul.step-anchor{\n        background: $gray-300;\n        border-bottom-color: $gray-300;\n        >li{\n            a{\n                padding: 10px 0 10px 45px;\n                &:hover{\n                    padding: 10px 0 10px 45px;\n                    isolation: inherit;\n                }\n            }\n\n            &:first-child{\n                a{\n                    padding-left: 15px;\n                }\n            }\n\n            >a, >a:hover{\n                background: $gray-300;\n                color: $gray-600;\n            }\n\n            >a{\n                &::after{\n                    border-left-color: $gray-300 !important;\n                    content: \" \";\n                    display: block;\n                    width: 0;\n                    height: 0;\n                    border-top: 50px solid transparent;\n                    border-bottom: 50px solid transparent;\n                    border-left: 30px solid transparent;\n                    border-right: 0;\n                    position: absolute;\n                    top: 50%;\n                    margin-top: -50px;\n                    left: 100%;\n                    z-index: 2;\n                }\n                &::before{\n                    border-left-color: $gray-300 !important;\n                    content: \" \";\n                    display: block;\n                    width: 0;\n                    height: 0;\n                    border-top: 50px solid transparent;\n                    border-bottom: 50px solid transparent;\n                    border-left: 30px solid transparent;\n                    border-right: 0;\n                    position: absolute;\n                    top: 50%;\n                    margin-top: -50px;\n                    margin-left: 1px;\n                    left: 100%;\n                    z-index: 1;\n                }\n            }\n            &.active{\n                >a{\n                    background: $primary !important;\n                    border-color: $primary !important;\n                    isolation: inherit;\n                    &:after{\n                        border-left-color: $primary !important;\n                        border-right: 0 !important;\n                    }\n                }\n            }\n\n            &.done{\n                >a{\n                    background: lighten($primary, 24%) !important;\n                    border-color: lighten($primary, 24%) !important;\n                    color: $primary !important;\n                    &:after{\n                        border-left-color: lighten($primary, 24%) !important;\n                        border-right: 0 !important;\n                    }\n                    &::before{\n                        border-left-color: lighten($primary, 24%) !important;\n                        border-right: 0 !important;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// sw-theme-circles\n\n.sw-theme-circles{\n    >ul.step-anchor{\n        margin-top: 30px;\n        background-color: transparent;\n        &:before{\n            background-color:$gray-300;\n        }\n        >li{\n            margin-left: 40px;\n            margin-right: 0;\n            >a{\n                font-size: 14px;\n                width: 40px;\n                height: 40px;\n                padding: 12px 0;\n                background-color:$gray-300;\n                border-color: $gray-200 !important;\n                box-shadow: none !important;\n                &:hover{\n                    background-color:$gray-300;\n                    \n                }\n\n                small {\n                    bottom: -20px;\n                    width: 100%;\n                }\n            }\n\n            >a, >a:hover{\n                color: $gray-600;\n                small{\n                    color: $gray-600;\n                }\n            }\n            &.active{\n                >a{\n                    background: $primary !important;\n                    border-color: $primary !important;\n                    color: $white !important;\n                    >small{\n                        color: $primary;\n                    }\n                }\n            }\n\n            &.done{\n                >a{\n                    background: $success !important;\n                    border-color: $success !important;\n                    color: $white !important;\n                    >small{\n                        color: $success;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// sw-theme-dots\n\n.sw-theme-dots{\n    >ul.step-anchor{\n        background-color: transparent;\n        &:before{\n            background-color: $gray-300;\n        }\n        >li{\n            >a{\n                &:before{\n                    bottom: -6px;\n                    background: $gray-300;\n                }\n\n                &:after{\n                    left: 44%;\n                    bottom: -8px;\n                    background: $gray-400;\n                }\n            }\n            >a, >a:hover, >a:focus{\n                color: $gray-600;\n            }\n            &.active{\n                >a{\n                    color: $primary;\n                    &:after{\n                        background: $primary;\n                    }\n                }\n            }\n            &.done{\n                >a{\n                    color: $success;\n                    &:after{\n                        background: $success;\n                    }\n                }\n            }\n        }\n    }\n}\n[dir=\"rtl\"] .sw-theme-dots{\n    >ul.step-anchor{\n        >li{\n            >a{\n                &:after{\n                    left: 40%;\n                }\n            }\n        }\n    }\n}\n\n\n\n// responsive\n\n@media (max-width: 768px){\n    .sw-main{\n        >ul.step-anchor{\n            >li{\n                display: block;\n                width: 100%;\n            }\n        }\n    }\n    .sw-theme-arrows{\n        >ul.step-anchor{            \n            >li{\n                a{\n                    padding: 10px 15px;\n                }\n            }\n        }\n    }\n    .sw-theme-circles{\n        >ul.step-anchor{\n            margin-bottom: 10px;\n            &::before{\n                width: 0px;\n            }\n            >li{\n                margin-bottom: 10px;\n                >a{\n                    >small{\n                        bottom: 14px;\n                        left: 76px;\n                    }\n                }\n            }\n        }\n    }\n    .sw-theme-dots{\n        >ul.step-anchor{\n            &::before{\n                left: 10px;\n                right: 0;\n                margin-right: 10px;\n                margin-left: 0px;\n            }\n            >li{\n                margin: 0 20px;\n                >a{\n                    text-align: left;\n                    &::before{\n                        left: -23px;\n                        margin-right: 10px;\n                        margin-left: 0px;\n                    }\n                    &::after {\n                        top: -36px;\n                        left: -35px !important;\n                        margin-right: 10px;\n                        margin-left: 0px;\n                    }\n                }\n            }\n        }\n    }   \n}","//\n// Select 2\n//\n\n.select2-container {\n    width: 100%!important;\n    \n    .select2-selection--single {\n        border: $input-border-width solid $input-border-color;\n        height: $input-height;\n        background-color: $input-bg;\n        outline: none;\n        .select2-selection__rendered {\n            line-height: 36px;\n            padding-left: 12px;\n            color: $input-color;\n            text-align: left;\n        }\n        .select2-selection__arrow {\n            height: 34px;\n            width: 34px;\n            right: 3px;\n            left: auto;\n            b {\n                border-color: $gray-500 transparent transparent transparent;\n                border-width: 6px 6px 0 6px;\n            }\n        }\n    }\n\n    input::placeholder {\n        color: $input-placeholder-color;\n    }\n}\n\n.select2-container--open {\n    .select2-selection--single {\n        .select2-selection__arrow {\n            b {\n                border-color: transparent transparent $gray-500 transparent !important;\n                border-width: 0 6px 6px 6px !important;\n            }\n        }\n    }\n}\n\n.select2-results__option {\n    padding: 6px 12px;\n    text-align: left;\n}\n\n.select2-dropdown {\n    border: $dropdown-border-width solid $dropdown-border-color;\n    box-shadow: $box-shadow;\n    background-color: $dropdown-bg;\n}\n\n.select2-container--default {\n    .select2-search--dropdown {\n        padding: 10px;\n        background-color: lighten($dropdown-bg,2.5%);\n        .select2-search__field {\n            outline: none;\n            border: 1px solid $input-border-color;\n            background-color: $input-bg;\n            color: $input-color;\n            text-align: left;\n        }\n    }\n    .select2-results__option--highlighted[aria-selected] {\n        background-color: $primary;\n    }\n    .select2-results__option[aria-selected=true] {\n        background-color: lighten($dropdown-bg,2.5%);\n        color: $dropdown-link-active-color;\n        &:hover {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n}\n\n.select2-container {    \n    .select2-selection--multiple {\n        min-height: $input-height;\n        border: $input-border-width solid $input-border-color !important;\n        background-color: $input-bg;\n        display: flex;\n        .select2-selection__choice__display{\n            /*rtl:ignore*/\n            padding-left: 0px;\n        }\n        .select2-selection__rendered {\n            padding: 1px 10px;\n            float: left;\n            margin-bottom: 0;\n        }\n        .select2-search__field {\n            border: 0;\n            color: $input-color;\n        }\n        .select2-selection__choice {\n            background-color: $primary;\n            border: none;\n            color: $white;\n            border-radius: 3px;\n            // padding: 0 7px;\n            float: left;\n        }\n        .select2-selection__choice__remove {\n            color: $white;            \n            margin-right: 2px;\n            /*rtl:ignore*/\n            margin-left: 0px;\n            /*rtl:ignore*/\n            border-right: none;\n            &:hover {\n                color: $white;\n                background-color: $primary;\n            }\n        }\n    }\n    .select2-search--inline {\n        float: left;\n        .select2-search__field {\n            margin-top: 7px;\n        }\n    }\n}","[data-simplebar] {\n    position: relative;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-content: flex-start;\n    align-items: flex-start;\n}\n\n.simplebar-wrapper {\n    overflow: hidden;\n    width: inherit;\n    height: inherit;\n    max-width: inherit;\n    max-height: inherit;\n}\n\n.simplebar-mask {\n    direction: inherit;\n    position: absolute;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    width: auto !important;\n    height: auto !important;\n    z-index: 0;\n}\n\n.simplebar-offset {\n    direction: inherit !important;\n    box-sizing: inherit !important;\n    resize: none !important;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    padding: 0;\n    margin: 0;\n    -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n    direction: inherit;\n    box-sizing: border-box !important;\n    position: relative;\n    display: block;\n    height: 100%;\n    outline: none;\n    /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n    width: auto;\n    visibility: visible;\n    overflow: auto;\n    /* Scroll on this element otherwise element can't have a padding applied properly */\n    max-width: 100%;\n    /* Not required for horizontal scroll to trigger */\n    max-height: 100%;\n    /* Needed for vertical scroll to trigger */\n    scrollbar-width: none;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n    display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n    content: ' ';\n    display: table;\n}\n\n.simplebar-placeholder {\n    max-height: 100%;\n    max-width: 100%;\n    width: 100%;\n    pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n    box-sizing: inherit !important;\n    height: 100%;\n    width: 100%;\n    max-width: 1px;\n    position: relative;\n    float: left;\n    max-height: 1px;\n    overflow: hidden;\n    z-index: -1;\n    padding: 0;\n    margin: 0;\n    pointer-events: none;\n    flex-grow: inherit;\n    flex-shrink: 0;\n    flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n    box-sizing: inherit;\n    display: block;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 1000%;\n    width: 1000%;\n    min-height: 1px;\n    min-width: 1px;\n    overflow: hidden;\n    pointer-events: none;\n    z-index: -1;\n}\n\n.simplebar-track {\n    z-index: 1;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n    pointer-events: none;\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n    pointer-events: all;\n}\n\n.simplebar-scrollbar {\n    position: absolute;\n    right: 2px;\n    width: 5px;\n    min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n    position: absolute;\n    content: '';\n    background: #a2adb7;\n    border-radius: 7px;\n    left: 0;\n    right: 0;\n    opacity: 0;\n    transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n    /* When hovered, remove all transitions from drag handle */\n    opacity: 0.5;\n    transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n    top: 0;\n    width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n    top: 2px;\n    bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n    left: 0;\n    height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n    height: 100%;\n    left: 2px;\n    right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n    right: auto;\n    left: 0;\n    top: 2px;\n    height: 7px;\n    min-height: 0;\n    min-width: 10px;\n    width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n    right: auto;\n    left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n    direction: rtl;\n    position: fixed;\n    opacity: 0;\n    visibility: hidden;\n    height: 500px;\n    width: 500px;\n    overflow-y: hidden;\n    overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n    position: fixed;\n    left: 0;\n    visibility: hidden;\n    overflow-y: scroll;\n    scrollbar-width: none;\n}\n\n.custom-scroll {\n    height: 100%;\n}","//\n// multi-select.scss\n//\n\n.ms-container {\n    background: transparent url('../../../images/plugin/multiple-arrow.png') no-repeat 50% 50%;\n    width: auto;\n    max-width: 370px;\n    \n    .ms-list {\n        box-shadow: none;\n        border: $input-border-width solid $input-border-color;\n\n        &.ms-focus {\n            box-shadow: none;\n            border: $input-border-width solid $input-focus-border-color;\n        }\n    }\n    .ms-selectable {\n        background-color: $input-bg;\n        li {\n            &.ms-elem-selectable {\n                border: none;\n                padding: 5px 10px;\n                color: $gray-600;\n            }\n            &.ms-hover {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n    .ms-selection {\n        background-color: $input-bg;\n        li{\n            &.ms-elem-selection {\n                border: none;\n                padding: 5px 10px;\n                color: $gray-600;\n            }\n            &.ms-hover {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n.ms-selectable {\n    box-shadow: none;\n    outline: none !important;\n}\n\n.ms-optgroup-label {\n    font-weight: $font-weight-medium;\n    font-family: $font-family-secondary;\n    color: $dark !important;\n    font-size: 13px;\n    padding-left: 5px !important;\n}","//\n// bootstrap-touchspin.scss\n//\n \n.bootstrap-touchspin {\n    .btn {\n        .input-group-text {\n            padding: 0;\n            border: none;\n            background-color: transparent;\n            color: inherit;\n        }\n    }\n}","//\n// parsley.scss\n//\n\n.parsley-errors-list {\n    margin: 0;\n    padding: 0;\n\n    >li {\n        list-style: none;\n        color: $danger;\n        margin-top: 10px;\n        padding: 4px 7px 4px 28px;\n        position: relative;\n        display: inline-block;\n        background-color: rgba($danger, 0.2);\n        border-radius: 7px;\n\n        &:before {\n            content: \"\\ebee\";\n            font-family: \"unicons\";\n            position: absolute;\n            left: 8px;\n            top: 4px;\n        }\n\n        &:after {\n            content: \"\";\n            border: 8px solid transparent;\n            border-bottom-color: rgba($danger, 0.2);\n            position: absolute;\n            left: 14px;\n            top: -16px;\n        }\n    }\n}\n\n.parsley-error {\n    border-color: $danger;\n}\n\n.parsley-success {\n    border-color: $success;\n}","//\n// quilljs-editor.scss\n//\n \n.ql-container {\n    font-family: $font-family-base;\n    border-bottom-left-radius: $input-border-radius;\n    border-bottom-right-radius: $input-border-radius;\n\n    &.ql-snow {\n        border-color: $input-border-color;\n    }\n}\n\n.ql-bubble {\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n}\n\n.ql-toolbar {\n    font-family: $font-family-base !important;\n    border-top-left-radius: $input-border-radius;\n    border-top-right-radius: $input-border-radius;\n    span {\n        outline: none !important;\n        color: $dropdown-link-color;\n\n        &:hover {\n            color: $primary !important;\n        }\n    }\n\n    &.ql-snow {\n        border-color: $input-border-color;\n\n        .ql-picker.ql-expanded {\n            .ql-picker-label {\n                border-color: transparent;\n            }\n        }\n        .ql-formats {\n            margin-right: 15px;\n            margin-left: 0;\n        }\n    }\n}\n\n.ql-snow {\n    .ql-stroke,\n    .ql-script,\n    .ql-strike svg {\n        stroke: $dropdown-link-color;\n    }\n    .ql-fill {\n        fill: $dropdown-link-color;\n    }\n}\n\n.ql-snow {\n    .ql-picker-options {\n        background-color: $dropdown-bg;\n        border-color: $dropdown-border-color !important;\n    }\n}\n\n\n.ql-editor {\n    text-align: left;\n}\n\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n    position: absolute;\n    margin-top: -9px;\n    right: 0;\n    left: auto;\n    top: 50%;\n    width: 18px;\n}\n\n.ql-editor {\n    ol, ul {\n        li:not(.ql-direction-rtl) {\n            padding-left: 1.5em;\n            padding-right: 0;\n        }\n    }\n    li:not(.ql-direction-rtl) {\n        &:before {\n            margin-left: -1.5em;\n            margin-right: 0.3em;\n            text-align: right;\n        }\n    }\n}\n\n.ql-editor {\n    ol, ul {\n        padding-left: 1.5em;\n        padding-right: 0;\n    }\n}\n\n// react-draft-wysiwyg\n.rdw-editor-wrapper {\n        border-color: $input-border-color !important;\n\n    .rdw-editor-toolbar {\n        background: transparent !important;\n        border-bottom: 1px solid $input-border-color !important; \n        border: none;\n        \n        .rdw-option-wrapper, .rdw-block-dropdown, .rdw-fontsize-dropdown, .rdw-fontfamily-dropdown, .rdw-dropdown-optionwrapper{\n            background: $input-bg !important;\n            border-color: transparent !important;\n            &:hover, &.rdw-option-active {\n                box-shadow: none !important;\n            }\n\n            img{\n                fill: $dark !important;\n            }\n\n            .rdw-dropdownoption-highlighted, .rdw-dropdownoption-active{\n                background: $dropdown-link-active-bg !important;\n            }\n        }\n\n         .rdw-option-wrapper {\n             background: transparent !important;\n         }\n    }\n\n    .rdw-editor-main{\n        border-color: $input-border-color !important;\n    }\n}\n\n// simplemde editor\n\n.EasyMDEContainer{\n    .CodeMirror {\n        background: $input-bg !important;\n        border-color: $input-border-color !important;\n    }\n    .editor-toolbar{\n        border-color: $input-border-color !important;\n\n        i.separator{    \n            border-color: $input-border-color !important;\n        }\n\n        button {\n            color: $dark !important;\n            &:hover {\n                background: tint-color($gray-300, 2%) !important;\n                border-color: transparent !important;\n            }\n        }\n    }\n\n    .CodeMirror-lines {\n        .CodeMirror-cursors {\n            .CodeMirror-cursor{\n                border-color: $dark;\n            }\n        }\n        .CodeMirror-code{\n            .CodeMirror-line {\n                color: $dark;\n                .cm-null {\n                    background: transparent !important;\n                    color:  $input-color !important;\n                }\n            }\n        }\n    }\n}","//\n// _react-select.scss\n//\n\n.react-select {\n    > div {\n        border: $input-border-width solid $input-border-color;\n        background-color: $input-bg !important;\n\n        &:hover {\n            border: $input-border-width solid $input-border-color;\n        }\n    }\n}\n\n.react-select__control--is-focused {\n    border-color: $input-focus-border-color !important;\n    box-shadow: none !important;\n}\n\n.react-select__indicator-separator {\n    display: none !important;\n}\n.react-select__input-container {\n    margin-left: 0 !important;\n}\n.react-select__dropdown-indicator {\n    color: $gray-600 !important;\n}\n\n.react-select__menu {\n    background-color: $dropdown-bg !important;\n    box-shadow: $box-shadow !important;\n    border: none !important;\n    border-radius: $dropdown-border-radius !important;\n    z-index: $zindex-dropdown !important;\n}\n\n.react-select__menu-list {\n    border: $dropdown-border-width solid $dropdown-border-color !important;\n    border-radius: $dropdown-border-radius !important;\n}\n\n.react-select__single-value {\n    color: $gray-600 !important;\n}\n.react-select__multi-value {\n    background-color: rgba($primary, 0.2) !important;\n    color: $primary !important;\n\n    .react-select__multi-value__label {\n        color: $primary;\n    }\n\n    .react-select__multi-value__remove {\n        &:hover {\n            background-color: rgba($primary, 0.2);\n            color: $primary;\n        }\n    }\n}\n\n// react-bootstrap-typeahead style\n.rbt-token {\n    background-color: rgba($primary, 0.2) !important;\n    color: $primary !important;\n    .rbt-token-remove-button {\n        background-color: transparent;\n        border: none;\n        .sr-only {\n            position: absolute;\n            width: 1px;\n            height: 1px;\n            padding: 0;\n            margin: -1px;\n            overflow: hidden;\n            clip: rect(0, 0, 0, 0);\n            white-space: nowrap;\n            border: 0;\n        }\n    }\n}\n\n.rbt-input-multi.focus {\n    box-shadow: none !important;\n    background-color: $input-focus-bg !important;\n    border-color: $input-focus-border-color !important;\n}\n\n// custom select\n.react-select-container {\n    .react-select__value-container {\n        &--has-value {\n            .react-select__single-value{\n                color: $input-color !important;\n            }   \n        }\n    }\n    .react-select__menu-list {\n        max-height: 252px ;\n    }\n    .react-select__option {\n        padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n        color: $gray-700;\n        background-color: transparent !important;\n\n        &:hover {\n            color: $white !important;\n            background-color: $primary !important;\n        }\n\n        &--is-selected {\n            color: $dark !important;\n        }\n    }\n}\n\n\n// Topbar search\n.app-search {\n    .react-select__menu-list {\n        .react-select__option { \n            padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n            color: $gray-700;\n            background-color: transparent;\n            &:hover {\n                color: $dark;\n                background-color: $dropdown-link-hover-bg;\n            }\n            &--is-selected {            \n                background-color: $dropdown-link-hover-bg;\n                .dropdown-item {\n                    color: $dark !important;\n                }\n            }\n            &--is-disabled {\n                &:hover {\n                    background-color: transparent !important;\n                }\n            }\n        }\n    }\n\n    .react-select__value-container {\n       &--has-value{\n           .react-select__single-value {\n                i, img, .user-subinfo{\n                    display: none !important;\n                }\n               .dropdown-item { \n                    color: rgba($white, 0.6) !important;\n                    .drop-username{\n                        color: rgba($white, 0.6) !important;\n                    }\n                    &:hover {\n                        color: $dropdown-link-color;\n                        background-color: transparent;\n                    }\n               }\n\n               .dropdown-item, .dropdown-item .drop-username {\n                    width: 110px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n               }\n           }\n           \n       }\n    }\n}\n\nbody[data-topbar-color=\"light\"] {\n    .app-search {\n        .react-select__value-container {\n            &--has-value {\n                .react-select__single-value {\n                    .dropdown-item,.drop-username {\n                        \n                        color: $dark !important;\n                    }\n                }\n            }\n        }\n    }\n}","//\n// react-table.scss\n//\n\n.react-table {\n    th, td {\n        white-space: nowrap;\n    }\n    th {\n        padding-left: $table-cell-padding-y;\n        padding-right: 30px;\n    }\n\n    .sortable {\n        position: relative;\n        cursor: pointer;\n        &:before {\n            position: absolute;\n            right: 1rem;\n            left: auto;\n            content: \"\\2191\";\n            font-family: \"Material Design Icons\";\n            font-size: 1rem;\n            top: 12px;\n            opacity: 0.3;\n        }\n        &:after {\n            position: absolute;\n            right: .5em;\n            left: auto;\n            content: \"\\2193\";\n            font-family: \"Material Design Icons\";\n            top: 12px;\n            opacity: 0.3;\n            font-size: 1rem;\n        }\n            &.sorting_asc{\n                &:before {\n                    opacity: 1;\n                }\n            }\n            &.sorting_desc{\n                &:after{\n                    opacity: 1;\n                }\n            }\n        }\n        \n    @include media-breakpoint-down(lg) {\n        li.paginate_button.previous,li.paginate_button.next {\n            display: inline-block;\n            font-size: 1.5rem;\n        }\n    }\n}","//\n// flatpickr.scss\n//\n\n.flatpickr-calendar {\n    background: $dropdown-bg;\n    box-shadow: $box-shadow;\n    border: 1px solid $dropdown-border-color;\n\n    &.arrowTop {\n        &:before {\n            border-bottom-color: lighten($dropdown-bg, 7%);\n        }\n        &:after {\n            border-bottom-color: $dropdown-bg;\n        }\n    }\n    &.arrowBottom {\n        &:before,\n        &:after {\n            border-top-color: $dropdown-bg;\n        }\n    }\n}\n\n.flatpickr-current-month {\n    font-size: 110%;\n}\n\n.flatpickr-day {\n    &.selected,\n    &.startRange,\n    &.endRange,\n    &.selected.inRange,\n    &.startRange.inRange,\n    &.endRange.inRange,\n    &.selected:focus,\n    &.startRange:focus,\n    &.endRange:focus,\n    &.selected:hover,\n    &.startRange:hover,\n    &.endRange:hover,\n    &.selected.prevMonthDay,\n    &.startRange.prevMonthDay,\n    &.endRange.prevMonthDay,\n    &.selected.nextMonthDay,\n    &.startRange.nextMonthDay,\n    &.endRange.nextMonthDay {\n        background: $primary !important;\n        border-color: $primary;\n    }\n    &.selected.startRange+.endRange:not(:nth-child(7n+1)),\n    &.startRange.startRange+.endRange:not(:nth-child(7n+1)),\n    &.endRange.startRange+.endRange:not(:nth-child(7n+1)) {\n        box-shadow: -10px 0 0 $primary;\n    }\n}\n\n.flatpickr-time {\n    input:hover,\n    .flatpickr-am-pm:hover,\n    input:focus,\n    .flatpickr-am-pm:focus {\n        background: $input-bg;\n        color: $dropdown-link-active-color;\n    }\n}\n\n.flatpickr-months {\n    .flatpickr-month {\n        height: 36px;\n    }\n    .flatpickr-prev-month,\n    .flatpickr-next-month,\n    .flatpickr-month {\n        color: $gray-500;\n        fill: $gray-500;\n    }\n}\n\n.flatpickr-weekdays {\n    background-color: $dropdown-link-active-bg;\n}\n\nspan.flatpickr-weekday,\n.flatpickr-day,\n.flatpickr-current-month input.cur-year[disabled], \n.flatpickr-current-month input.cur-year[disabled]:hover,\n.flatpickr-time input,\n.flatpickr-time .flatpickr-time-separator, \n.flatpickr-time .flatpickr-am-pm {\n    color: $dropdown-link-color;\n    fill: $dropdown-link-color;\n}\n\n.flatpickr-day {\n    &.disabled, \n    &.disabled:hover, \n    &.prevMonthDay, \n    &.nextMonthDay, \n    &.notAllowed, \n    &.notAllowed.prevMonthDay, \n    &.notAllowed.nextMonthDay {\n        color: $dropdown-link-disabled-color;\n    }\n    &.inRange, \n    &.prevMonthDay.inRange, \n    &.nextMonthDay.inRange, \n    &.today.inRange, \n    &.prevMonthDay.today.inRange, \n    &.nextMonthDay.today.inRange, \n    &:hover, \n    &.prevMonthDay:hover, \n    &.nextMonthDay:hover, \n    &:focus, \n    &.prevMonthDay:focus, \n    &.nextMonthDay:focus {\n        background: $dropdown-link-hover-bg;\n        border-color: $dropdown-link-hover-bg;\n    }\n}\n\n.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {\n    border-top: 1px solid lighten($dropdown-bg, 7%);\n}\n\n.numInputWrapper:hover,\n.flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n    background-color: transparent;\n    color: $dropdown-link-active-color;\n}\n\n.flatpickr-day.inRange {\n    box-shadow: -5px 0 0 $dropdown-link-hover-bg, 5px 0 0 $dropdown-link-hover-bg;\n}\n\n.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {\n    color: $dropdown-link-disabled-color;\n}","//\n// dropzone.scss\n//\n\n.dropzone {\n  border: 2px dashed $input-border-color;\n  background: $input-bg;\n  border-radius: 6px;\n  cursor: pointer;\n  min-height: 150px;\n  padding: 20px;\n  min-height: 150px;\n  \n    >div {\n        &:focus {\n            outline: none;\n        }\n    }\n  .dz-message {\n      text-align: center;\n      margin: 2rem 0;\n      outline: none;\n  }\n  &.dz-started {\n      .dz-message {\n          display: none;\n      }\n  }\n}\n\n@-webkit-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px);\n  }\n}\n@-moz-keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px);\n  }\n}\n@keyframes passing-through {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30%, 70% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n  100% {\n    opacity: 0;\n    -webkit-transform: translateY(-40px);\n    -moz-transform: translateY(-40px);\n    -ms-transform: translateY(-40px);\n    -o-transform: translateY(-40px);\n    transform: translateY(-40px);\n  }\n}\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n}\n@-moz-keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n}\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(40px);\n    -moz-transform: translateY(40px);\n    -ms-transform: translateY(40px);\n    -o-transform: translateY(40px);\n    transform: translateY(40px);\n  }\n  30% {\n    opacity: 1;\n    -webkit-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -o-transform: translateY(0px);\n    transform: translateY(0px);\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n@-moz-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n@keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n  10% {\n    -webkit-transform: scale(1.1);\n    -moz-transform: scale(1.1);\n    -ms-transform: scale(1.1);\n    -o-transform: scale(1.1);\n    transform: scale(1.1);\n  }\n  20% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.dropzone, .dropzone * {\n  box-sizing: border-box;\n}\n\n.dropzone.dz-clickable {\n  cursor: pointer;\n}\n.dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {\n  cursor: pointer;\n}\n.dropzone.dz-started .dz-message {\n  display: none;\n}\n.dropzone.dz-drag-hover {\n  border-style: solid;\n}\n.dropzone.dz-drag-hover .dz-message {\n  opacity: 0.5;\n}\n.dropzone .dz-message {\n  text-align: center;\n  margin: 2em 0;\n}\n.dropzone .dz-message .dz-button {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n}\n.dropzone .dz-preview {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  margin: 16px;\n  min-height: 100px;\n}\n.dropzone .dz-preview:hover {\n  z-index: 1000;\n}\n.dropzone .dz-preview:hover .dz-details {\n  opacity: 1;\n}\n.dropzone .dz-preview.dz-file-preview .dz-image {\n  border-radius: 20px;\n  background: #999;\n  background: linear-gradient(to bottom, #eee, #ddd);\n}\n.dropzone .dz-preview.dz-file-preview .dz-details {\n  opacity: 1;\n}\n.dropzone .dz-preview.dz-image-preview .dz-details {\n  -webkit-transition: opacity 0.2s linear;\n  -moz-transition: opacity 0.2s linear;\n  -ms-transition: opacity 0.2s linear;\n  -o-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n.dropzone .dz-preview .dz-remove {\n  font-size: 14px;\n  text-align: center;\n  display: block;\n  cursor: pointer;\n  border: none;\n}\n.dropzone .dz-preview .dz-remove:hover {\n  text-decoration: underline;\n}\n.dropzone .dz-preview:hover .dz-details {\n  opacity: 1;\n}\n.dropzone .dz-preview .dz-details {\n  z-index: 20;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  font-size: 13px;\n  min-width: 100%;\n  max-width: 100%;\n  padding: 2em 1em;\n  text-align: center;\n  color: rgba(0, 0, 0, 0.9);\n  line-height: 150%;\n}\n.dropzone .dz-preview .dz-details .dz-size {\n  margin-bottom: 1em;\n  font-size: 16px;\n}\n.dropzone .dz-preview .dz-details .dz-filename {\n  white-space: nowrap;\n}\n.dropzone .dz-preview .dz-details .dz-filename:hover span {\n  border: 1px solid rgba(200, 200, 200, 0.8);\n  background-color: rgba(255, 255, 255, 0.8);\n}\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {\n  border: 1px solid transparent;\n}\n.dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {\n  background-color: rgba(255, 255, 255, 0.4);\n  padding: 0 0.4em;\n  border-radius: 3px;\n}\n.dropzone .dz-preview:hover .dz-image img {\n  -webkit-transform: scale(1.05, 1.05);\n  -moz-transform: scale(1.05, 1.05);\n  -ms-transform: scale(1.05, 1.05);\n  -o-transform: scale(1.05, 1.05);\n  transform: scale(1.05, 1.05);\n  -webkit-filter: blur(8px);\n  filter: blur(8px);\n}\n.dropzone .dz-preview .dz-image {\n  border-radius: 20px;\n  overflow: hidden;\n  width: 120px;\n  height: 120px;\n  position: relative;\n  display: block;\n  z-index: 10;\n  background-color: $gray-100 ;\n}\n.dropzone .dz-preview .dz-image img {\n  display: block;\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n.dropzone .dz-preview.dz-success .dz-success-mark {\n  -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.dropzone .dz-preview.dz-error .dz-error-mark {\n  opacity: 1;\n  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n.dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {\n  pointer-events: none;\n  opacity: 0;\n  z-index: 500;\n  position: absolute;\n  display: block;\n  top: 50%;\n  left: 50%;\n  margin-left: -27px;\n  margin-top: -27px;\n}\n.dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {\n  display: block;\n  width: 54px;\n  height: 54px;\n}\n.dropzone .dz-preview.dz-processing .dz-progress {\n  opacity: 1;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.dropzone .dz-preview.dz-complete .dz-progress {\n  opacity: 0;\n  -webkit-transition: opacity 0.4s ease-in;\n  -moz-transition: opacity 0.4s ease-in;\n  -ms-transition: opacity 0.4s ease-in;\n  -o-transition: opacity 0.4s ease-in;\n  transition: opacity 0.4s ease-in;\n}\n.dropzone .dz-preview:not(.dz-processing) .dz-progress {\n  -webkit-animation: pulse 6s ease infinite;\n  -moz-animation: pulse 6s ease infinite;\n  -ms-animation: pulse 6s ease infinite;\n  -o-animation: pulse 6s ease infinite;\n  animation: pulse 6s ease infinite;\n}\n.dropzone .dz-preview .dz-progress {\n  opacity: 1;\n  z-index: 1000;\n  pointer-events: none;\n  position: absolute;\n  height: 16px;\n  left: 50%;\n  top: 50%;\n  margin-top: -8px;\n  width: 80px;\n  margin-left: -40px;\n  background: rgba(255, 255, 255, 0.9);\n  -webkit-transform: scale(1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n.dropzone .dz-preview .dz-progress .dz-upload {\n  background: #333;\n  background: linear-gradient(to bottom, #666, #444);\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 0;\n  -webkit-transition: width 300ms ease-in-out;\n  -moz-transition: width 300ms ease-in-out;\n  -ms-transition: width 300ms ease-in-out;\n  -o-transition: width 300ms ease-in-out;\n  transition: width 300ms ease-in-out;\n}\n.dropzone .dz-preview.dz-error .dz-error-message {\n  display: block;\n}\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\n  opacity: 1;\n  pointer-events: auto;\n}\n.dropzone .dz-preview .dz-error-message {\n  pointer-events: none;\n  z-index: 1000;\n  position: absolute;\n  display: block;\n  display: none;\n  opacity: 0;\n  -webkit-transition: opacity 0.3s ease;\n  -moz-transition: opacity 0.3s ease;\n  -ms-transition: opacity 0.3s ease;\n  -o-transition: opacity 0.3s ease;\n  transition: opacity 0.3s ease;\n  border-radius: 8px;\n  font-size: 13px;\n  top: 130px;\n  left: -10px;\n  width: 140px;\n  background: #be2626;\n  background: linear-gradient(to bottom, #be2626, #a92222);\n  padding: 0.5em 1.2em;\n  color: white;\n}\n.dropzone .dz-preview .dz-error-message:after {\n  content: \"\";\n  position: absolute;\n  top: -6px;\n  left: 64px;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid #be2626;\n}\n\n\n.dz-preview {\n    .dz-remove {\n        .btn {\n            background-color: rgba($gray-500, 0.85);\n            color: $white;\n            border-radius: 50%;\n            font-size: 10px;\n            padding: 0;\n            height: 24px;\n            width: 24px;\n            line-height: 22px;\n            position: absolute;\n            top: -7px;\n            right: -5px;\n            z-index: 999;\n            opacity: 0;\n            transition: 0.2s ease-in-out;\n        }\n    }\n    \n    &:hover {\n        .dz-remove {\n            .btn {\n                opacity: 1;\n            }\n        }\n    }\n}","//\n// google-maps.scss\n//\n \n.gmaps, \n.gmaps-panaroma {\n  height: 300px;\n  background: $gray-100;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: $white;\n  font-size: 16px;\n  line-height: 40px;\n  background: $primary;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n\n  &.above {\n    bottom: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-top: 16px solid $primary;\n  }\n  \n  &.below {\n    top: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-bottom: 16px solid $primary;\n  }\n}","//\n// vector-maps.scss\n//\n\n.jvectormap-label {\n    border: none;\n    background: $dark;\n    color: color-yiq($dark);\n    font-family: $font-family-secondary;\n    font-size: $font-size-base;\n    padding: 5px 8px;\n}\n\n// react jsvectormap style\n\n// Class prefix\n$classPrefix: jvm-;\n$border-color: #e5e7eb;\n$box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n\n// Tooltip\n$tooltip-shadow: 1px 2px 12px rgba(0, 0, 0, .2);\n$tooltip-font-family: $font-family-base;\n$tooltip-bg-color:  $gray-800;\n$tooltip-color:  $gray-100;\n$tooltip-radius: 3px;\n$tooltip-font-size: $font-size-base;\n$tooltip-padding: 5px 8px;\n\n// Zoom buttons\n$zoom-btns-bg-color: #292929;\n$zoom-btns-radius: 3px;\n$zoom-btns-height: 15px;\n$zoom-btns-padding: 3px;\n$zoom-btns-width: 15px;\n\n// Series\n$series-container-right: 15px;\n\n// Legends\n$legend-background-color: #FFF;\n$legend-radius: 0.25rem;\n$legend-margin-left: .75rem;\n$legend-padding: 0.6rem;\n\n// Legend title\n$legend-title-padding-bottom: 0.5rem;\n$legend-title-margin-bottom: 0.575rem;\n\n// Legend ticks\n$legend-tick-margin-top: .575rem;\n$legend-tick-sample-radius: 4px;\n$legend-tick-sample-height: 16px;\n$legend-tick-sample-width: 16px;\n$legend-tick-text-font-size: 12px;\n$legend-tick-text-margin-top: 3px;\n\n// Global resets\nsvg { touch-action: none }\nimage, text, .#{$classPrefix}zoomin, .#{$classPrefix}zoomout { user-select: none }\n\n// jsVectorMap container\n.#{$classPrefix}container {\n  touch-action: none;\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n\n// Tooltip\n.#{$classPrefix}tooltip {\n  border-radius: $tooltip-radius;\n  background-color: $tooltip-bg-color;\n  font-family: $tooltip-font-family;\n  font-size: $tooltip-font-size;\n  box-shadow: $tooltip-shadow;\n  padding: $tooltip-padding;\n  white-space: nowrap;\n  position: absolute;\n  display: none;\n  color: $tooltip-color;\n  border: none;\n\n}\n\n// Zoom buttons\n.#{$classPrefix}zoom-btn {\n  border-radius: $zoom-btns-radius;\n  background-color: $zoom-btns-bg-color;\n  padding: $zoom-btns-padding;\n  box-sizing: border-box;\n  position: absolute;\n  line-height: 10px;\n  cursor: pointer;\n  color: #FFF;\n  height: 15px;\n  width: 15px;\n  left: 10px;\n\n  &.#{$classPrefix}zoomout {\n    top: 30px\n  }\n\n  &.#{$classPrefix}zoomin {\n    top: 10px\n  }\n}\n\n// Series\n.#{$classPrefix}series-container {\n  right: $series-container-right;\n  position: absolute;\n\n  // horizontal\n  &.#{$classPrefix}series-h { bottom: 15px }\n\n  // Vertical\n  &.#{$classPrefix}series-v { top: 15px }\n\n  // Legends\n  .#{$classPrefix}legend {\n    background-color: $legend-background-color;\n    border: 1px solid $border-color;\n    margin-left: $legend-margin-left;\n    border-radius: $legend-radius;\n    border-color: $border-color;\n    padding: $legend-padding;\n    box-shadow: $box-shadow;\n    float: left;\n\n    .#{$classPrefix}legend-title {\n      line-height: 1;\n      border-bottom: 1px solid $border-color;\n      padding-bottom: $legend-title-padding-bottom;\n      margin-bottom: $legend-title-margin-bottom;\n      text-align: left;\n    }\n\n    .#{$classPrefix}legend-inner {\n      overflow: hidden;\n\n      .#{$classPrefix}legend-tick {\n        overflow: hidden;\n        min-width: 40px;\n        &:not(:first-child) {\n          margin-top: $legend-tick-margin-top;\n        }\n\n        .#{$classPrefix}legend-tick-sample {\n          border-radius: $legend-tick-sample-radius;\n          margin-right: .65rem;\n          height: $legend-tick-sample-height;\n          width: $legend-tick-sample-width;\n          float: left;\n        }\n\n        .#{$classPrefix}legend-tick-text {\n          font-size: $legend-tick-text-font-size;\n          text-align: center;\n          float: left;\n        }\n      }\n    }\n  }\n}\n\n// Line animation\n.jvm-line[animation=\"true\"] {\n  -webkit-animation: jvm-line-animation 10s linear forwards infinite;\n  animation: jvm-line-animation 10s linear forwards infinite;\n\n  @keyframes jvm-line-animation {\n    from { stroke-dashoffset: 250; }\n  }\n}\n","/*\nTemplate Name: Shreyu - Responsive 5 Admin Dashboard\nAuthor: CoderThemes\nVersion: 2.0.0\nEmail: support@coderthemes.com\nFile: Icons Css File\n*/\n\n// Plugins\n@import \"custom/plugins/icons\";\n\n","@font-face {\n  font-family: 'unicons';\n  src: url('../../../../fonts/unicons.eot?2256574');\n  src: url('../../../../fonts/unicons.eot?2256574#iefix') format('embedded-opentype'),\n       url('../../../../fonts/unicons.woff2?2256574') format('woff2'),\n       url('../../../../fonts/unicons.woff?2256574') format('woff'),\n       url('../../../../fonts/unicons.ttf?2256574') format('truetype'),\n       url('../../../../fonts/unicons.svg?2256574#unicons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\n/*\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  @font-face {\n    font-family: 'unicons';\n    src: url('../fonts/unicons.svg?2256574#unicons') format('svg');\n  }\n}\n*/\n \n.uil {\n  line-height: inherit;\n}\n\n [class^=\"uil-\"]:before, [class*=\" uil-\"]:before {\n  font-family: \"unicons\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n \n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  // margin-right: .2em;\n  text-align: center;\n  /* opacity: .8; */\n \n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n \n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1em;\n  vertical-align: middle;\n \n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  // margin-left: .2em;\n \n  /* you can be more comfortable with increased icons size */\n  font-size: 120%;\n \n  /* Font smoothing. That was taken from TWBS */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n \n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n \n.uil-0-plus:before { content: '\\e800'; } /* '' */\n.uil-10-plus:before { content: '\\e801'; } /* '' */\n.uil-12-plus:before { content: '\\e802'; } /* '' */\n.uil-13-plus:before { content: '\\e803'; } /* '' */\n.uil-16-plus:before { content: '\\e804'; } /* '' */\n.uil-17-plus:before { content: '\\e805'; } /* '' */\n.uil-18-plus:before { content: '\\e806'; } /* '' */\n.uil-21-plus:before { content: '\\e807'; } /* '' */\n.uil-3-plus:before { content: '\\e808'; } /* '' */\n.uil-500px:before { content: '\\e809'; } /* '' */\n.uil-6-plus:before { content: '\\e80a'; } /* '' */\n.uil-abacus:before { content: '\\e80b'; } /* '' */\n.uil-accessible-icon-alt:before { content: '\\e80c'; } /* '' */\n.uil-adjust-alt:before { content: '\\e80d'; } /* '' */\n.uil-adjust-circle:before { content: '\\e80e'; } /* '' */\n.uil-adjust-half:before { content: '\\e80f'; } /* '' */\n.uil-adjust:before { content: '\\e810'; } /* '' */\n.uil-adobe-alt:before { content: '\\e811'; } /* '' */\n.uil-adobe:before { content: '\\e812'; } /* '' */\n.uil-airplay:before { content: '\\e813'; } /* '' */\n.uil-align-alt:before { content: '\\e814'; } /* '' */\n.uil-align-center-alt:before { content: '\\e815'; } /* '' */\n.uil-align-center-h:before { content: '\\e816'; } /* '' */\n.uil-align-center-justify:before { content: '\\e817'; } /* '' */\n.uil-align-center-v:before { content: '\\e818'; } /* '' */\n.uil-align-center:before { content: '\\e819'; } /* '' */\n.uil-align-justify:before { content: '\\e81a'; } /* '' */\n.uil-align-left-justify:before { content: '\\e81b'; } /* '' */\n.uil-align-left:before { content: '\\e81c'; } /* '' */\n.uil-align-letter-right:before { content: '\\e81d'; } /* '' */\n.uil-align-right-justify:before { content: '\\e81e'; } /* '' */\n.uil-align-right:before { content: '\\e81f'; } /* '' */\n.uil-align:before { content: '\\e820'; } /* '' */\n.uil-amazon:before { content: '\\e821'; } /* '' */\n.uil-ambulance:before { content: '\\e822'; } /* '' */\n.uil-analysis:before { content: '\\e823'; } /* '' */\n.uil-analytics:before { content: '\\e824'; } /* '' */\n.uil-anchor:before { content: '\\e825'; } /* '' */\n.uil-android-alt:before { content: '\\e826'; } /* '' */\n.uil-android-phone-slash:before { content: '\\e827'; } /* '' */\n.uil-android:before { content: '\\e828'; } /* '' */\n.uil-angle-double-down:before { content: '\\e829'; } /* '' */\n.uil-angle-double-left:before { content: '\\e82a'; } /* '' */\n.uil-angle-double-right:before { content: '\\e82b'; } /* '' */\n.uil-angle-double-up:before { content: '\\e82c'; } /* '' */\n.uil-angle-down:before { content: '\\e82d'; } /* '' */\n.uil-angle-left:before { content: '\\e82e'; } /* '' */\n.uil-angle-right-b:before { content: '\\e82f'; } /* '' */\n.uil-angle-right:before { content: '\\e830'; } /* '' */\n.uil-angle-up:before { content: '\\e831'; } /* '' */\n.uil-angry:before { content: '\\e832'; } /* '' */\n.uil-ankh:before { content: '\\e833'; } /* '' */\n.uil-annoyed-alt:before { content: '\\e834'; } /* '' */\n.uil-annoyed:before { content: '\\e835'; } /* '' */\n.uil-apple-alt:before { content: '\\e836'; } /* '' */\n.uil-apple:before { content: '\\e837'; } /* '' */\n.uil-apps:before { content: '\\e838'; } /* '' */\n.uil-archive-alt:before { content: '\\e839'; } /* '' */\n.uil-archive:before { content: '\\e83a'; } /* '' */\n.uil-archway:before { content: '\\e83b'; } /* '' */\n.uil-arrow-break:before { content: '\\e83c'; } /* '' */\n.uil-arrow-circle-down:before { content: '\\e83d'; } /* '' */\n.uil-arrow-circle-left:before { content: '\\e83e'; } /* '' */\n.uil-arrow-circle-right:before { content: '\\e83f'; } /* '' */\n.uil-arrow-circle-up:before { content: '\\e840'; } /* '' */\n.uil-arrow-compress-h:before { content: '\\e841'; } /* '' */\n.uil-arrow-down-left:before { content: '\\e842'; } /* '' */\n.uil-arrow-down-right:before { content: '\\e843'; } /* '' */\n.uil-arrow-down:before { content: '\\e844'; } /* '' */\n.uil-arrow-from-right:before { content: '\\e845'; } /* '' */\n.uil-arrow-from-top:before { content: '\\e846'; } /* '' */\n.uil-arrow-growth:before { content: '\\e847'; } /* '' */\n.uil-arrow-left:before { content: '\\e848'; } /* '' */\n.uil-arrow-random:before { content: '\\e849'; } /* '' */\n.uil-arrow-resize-diagonal:before { content: '\\e84a'; } /* '' */\n.uil-arrow-right:before { content: '\\e84b'; } /* '' */\n.uil-arrow-to-bottom:before { content: '\\e84c'; } /* '' */\n.uil-arrow-to-right:before { content: '\\e84d'; } /* '' */\n.uil-arrow-up-left:before { content: '\\e84e'; } /* '' */\n.uil-arrow-up-right:before { content: '\\e84f'; } /* '' */\n.uil-arrow-up:before { content: '\\e850'; } /* '' */\n.uil-arrows-h-alt:before { content: '\\e851'; } /* '' */\n.uil-arrows-h:before { content: '\\e852'; } /* '' */\n.uil-arrows-left-down:before { content: '\\e853'; } /* '' */\n.uil-arrows-maximize:before { content: '\\e854'; } /* '' */\n.uil-arrows-merge:before { content: '\\e855'; } /* '' */\n.uil-arrows-resize-h:before { content: '\\e856'; } /* '' */\n.uil-arrows-resize-v:before { content: '\\e857'; } /* '' */\n.uil-arrows-resize:before { content: '\\e858'; } /* '' */\n.uil-arrows-right-down:before { content: '\\e859'; } /* '' */\n.uil-arrows-shrink-h:before { content: '\\e85a'; } /* '' */\n.uil-arrows-shrink-v:before { content: '\\e85b'; } /* '' */\n.uil-arrows-up-right:before { content: '\\e85c'; } /* '' */\n.uil-arrows-v-alt:before { content: '\\e85d'; } /* '' */\n.uil-arrows-v:before { content: '\\e85e'; } /* '' */\n.uil-assistive-listening-systems:before { content: '\\e85f'; } /* '' */\n.uil-asterisk:before { content: '\\e860'; } /* '' */\n.uil-at:before { content: '\\e861'; } /* '' */\n.uil-atm-card:before { content: '\\e862'; } /* '' */\n.uil-atom:before { content: '\\e863'; } /* '' */\n.uil-auto-flash:before { content: '\\e864'; } /* '' */\n.uil-award-alt:before { content: '\\e865'; } /* '' */\n.uil-award:before { content: '\\e866'; } /* '' */\n.uil-baby-carriage:before { content: '\\e867'; } /* '' */\n.uil-backpack:before { content: '\\e868'; } /* '' */\n.uil-backspace:before { content: '\\e869'; } /* '' */\n.uil-backward:before { content: '\\e86a'; } /* '' */\n.uil-bag-alt:before { content: '\\e86b'; } /* '' */\n.uil-bag-slash:before { content: '\\e86c'; } /* '' */\n.uil-bag:before { content: '\\e86d'; } /* '' */\n.uil-balance-scale:before { content: '\\e86e'; } /* '' */\n.uil-ball:before { content: '\\e86f'; } /* '' */\n.uil-ban:before { content: '\\e870'; } /* '' */\n.uil-bars:before { content: '\\e871'; } /* '' */\n.uil-baseball-ball:before { content: '\\e872'; } /* '' */\n.uil-basketball-hoop:before { content: '\\e873'; } /* '' */\n.uil-basketball:before { content: '\\e874'; } /* '' */\n.uil-bath:before { content: '\\e875'; } /* '' */\n.uil-battery-bolt:before { content: '\\e876'; } /* '' */\n.uil-battery-empty:before { content: '\\e877'; } /* '' */\n.uil-bed-double:before { content: '\\e878'; } /* '' */\n.uil-bed:before { content: '\\e879'; } /* '' */\n.uil-behance-alt:before { content: '\\e87a'; } /* '' */\n.uil-behance:before { content: '\\e87b'; } /* '' */\n.uil-bell-school:before { content: '\\e87c'; } /* '' */\n.uil-bell-slash:before { content: '\\e87d'; } /* '' */\n.uil-bell:before { content: '\\e87e'; } /* '' */\n.uil-bill:before { content: '\\e87f'; } /* '' */\n.uil-bitcoin-alt:before { content: '\\e880'; } /* '' */\n.uil-bitcoin-bold:before { content: '\\e881'; } /* '' */\n.uil-bitcoin-circle:before { content: '\\e882'; } /* '' */\n.uil-bitcoin:before { content: '\\e883'; } /* '' */\n.uil-black-berry:before { content: '\\e884'; } /* '' */\n.uil-blogger-alt:before { content: '\\e885'; } /* '' */\n.uil-blogger:before { content: '\\e886'; } /* '' */\n.uil-bluetooth-b:before { content: '\\e887'; } /* '' */\n.uil-bold:before { content: '\\e888'; } /* '' */\n.uil-bolt-alt:before { content: '\\e889'; } /* '' */\n.uil-bolt-slash:before { content: '\\e88a'; } /* '' */\n.uil-bolt:before { content: '\\e88b'; } /* '' */\n.uil-book-alt:before { content: '\\e88c'; } /* '' */\n.uil-book-medical:before { content: '\\e88d'; } /* '' */\n.uil-book-open:before { content: '\\e88e'; } /* '' */\n.uil-book-reader:before { content: '\\e88f'; } /* '' */\n.uil-book:before { content: '\\e890'; } /* '' */\n.uil-bookmark-full:before { content: '\\e891'; } /* '' */\n.uil-bookmark:before { content: '\\e892'; } /* '' */\n.uil-books:before { content: '\\e893'; } /* '' */\n.uil-boombox:before { content: '\\e894'; } /* '' */\n.uil-border-alt:before { content: '\\e895'; } /* '' */\n.uil-border-bottom:before { content: '\\e896'; } /* '' */\n.uil-border-clear:before { content: '\\e897'; } /* '' */\n.uil-border-horizontal:before { content: '\\e898'; } /* '' */\n.uil-border-inner:before { content: '\\e899'; } /* '' */\n.uil-border-left:before { content: '\\e89a'; } /* '' */\n.uil-border-out:before { content: '\\e89b'; } /* '' */\n.uil-border-right:before { content: '\\e89c'; } /* '' */\n.uil-border-top:before { content: '\\e89d'; } /* '' */\n.uil-border-vertical:before { content: '\\e89e'; } /* '' */\n.uil-bowling-ball:before { content: '\\e89f'; } /* '' */\n.uil-box:before { content: '\\e8a0'; } /* '' */\n.uil-briefcase-alt:before { content: '\\e8a1'; } /* '' */\n.uil-briefcase:before { content: '\\e8a2'; } /* '' */\n.uil-bright:before { content: '\\e8a3'; } /* '' */\n.uil-brightness-empty:before { content: '\\e8a4'; } /* '' */\n.uil-brightness-half:before { content: '\\e8a5'; } /* '' */\n.uil-brightness-low:before { content: '\\e8a6'; } /* '' */\n.uil-brightness-minus:before { content: '\\e8a7'; } /* '' */\n.uil-brightness-plus:before { content: '\\e8a8'; } /* '' */\n.uil-brightness:before { content: '\\e8a9'; } /* '' */\n.uil-bring-bottom:before { content: '\\e8aa'; } /* '' */\n.uil-bring-front:before { content: '\\e8ab'; } /* '' */\n.uil-brush-alt:before { content: '\\e8ac'; } /* '' */\n.uil-bug:before { content: '\\e8ad'; } /* '' */\n.uil-building:before { content: '\\e8ae'; } /* '' */\n.uil-bullseye:before { content: '\\e8af'; } /* '' */\n.uil-bus-alt:before { content: '\\e8b0'; } /* '' */\n.uil-bus-school:before { content: '\\e8b1'; } /* '' */\n.uil-bus:before { content: '\\e8b2'; } /* '' */\n.uil-calcualtor:before { content: '\\e8b3'; } /* '' */\n.uil-calculator-alt:before { content: '\\e8b4'; } /* '' */\n.uil-calculator:before { content: '\\e8b5'; } /* '' */\n.uil-calendar-alt:before { content: '\\e8b6'; } /* '' */\n.uil-calendar-slash:before { content: '\\e8b7'; } /* '' */\n.uil-calender:before { content: '\\e8b8'; } /* '' */\n.uil-calling:before { content: '\\e8b9'; } /* '' */\n.uil-camera-change:before { content: '\\e8ba'; } /* '' */\n.uil-camera-plus:before { content: '\\e8bb'; } /* '' */\n.uil-camera-slash:before { content: '\\e8bc'; } /* '' */\n.uil-camera:before { content: '\\e8bd'; } /* '' */\n.uil-cancel:before { content: '\\e8be'; } /* '' */\n.uil-capsule:before { content: '\\e8bf'; } /* '' */\n.uil-capture:before { content: '\\e8c0'; } /* '' */\n.uil-car-sideview:before { content: '\\e8c1'; } /* '' */\n.uil-car-slash:before { content: '\\e8c2'; } /* '' */\n.uil-car-wash:before { content: '\\e8c3'; } /* '' */\n.uil-car:before { content: '\\e8c4'; } /* '' */\n.uil-card-atm:before { content: '\\e8c5'; } /* '' */\n.uil-caret-right:before { content: '\\e8c6'; } /* '' */\n.uil-cart:before { content: '\\e8c7'; } /* '' */\n.uil-cell:before { content: '\\e8c8'; } /* '' */\n.uil-celsius:before { content: '\\e8c9'; } /* '' */\n.uil-chart-bar-alt:before { content: '\\e8ca'; } /* '' */\n.uil-chart-bar:before { content: '\\e8cb'; } /* '' */\n.uil-chart-down:before { content: '\\e8cc'; } /* '' */\n.uil-chart-growth-alt:before { content: '\\e8cd'; } /* '' */\n.uil-chart-growth:before { content: '\\e8ce'; } /* '' */\n.uil-chart-line:before { content: '\\e8cf'; } /* '' */\n.uil-chart-pie-alt:before { content: '\\e8d0'; } /* '' */\n.uil-chart-pie:before { content: '\\e8d1'; } /* '' */\n.uil-chart:before { content: '\\e8d2'; } /* '' */\n.uil-chat-bubble-user:before { content: '\\e8d3'; } /* '' */\n.uil-chat-info:before { content: '\\e8d4'; } /* '' */\n.uil-chat:before { content: '\\e8d5'; } /* '' */\n.uil-check-circle:before { content: '\\e8d6'; } /* '' */\n.uil-check-square:before { content: '\\e8d7'; } /* '' */\n.uil-check:before { content: '\\e8d8'; } /* '' */\n.uil-circle-layer:before { content: '\\e8d9'; } /* '' */\n.uil-circle:before { content: '\\e8da'; } /* '' */\n.uil-circuit:before { content: '\\e8db'; } /* '' */\n.uil-clapper-board:before { content: '\\e8dc'; } /* '' */\n.uil-clipboard-alt:before { content: '\\e8dd'; } /* '' */\n.uil-clipboard-blank:before { content: '\\e8de'; } /* '' */\n.uil-clipboard-notes:before { content: '\\e8df'; } /* '' */\n.uil-clipboard:before { content: '\\e8e0'; } /* '' */\n.uil-clock-eight:before { content: '\\e8e1'; } /* '' */\n.uil-clock-five:before { content: '\\e8e2'; } /* '' */\n.uil-clock-nine:before { content: '\\e8e3'; } /* '' */\n.uil-clock-seven:before { content: '\\e8e4'; } /* '' */\n.uil-clock-ten:before { content: '\\e8e5'; } /* '' */\n.uil-clock-three:before { content: '\\e8e6'; } /* '' */\n.uil-clock-two:before { content: '\\e8e7'; } /* '' */\n.uil-clock:before { content: '\\e8e8'; } /* '' */\n.uil-closed-captioning:before { content: '\\e8e9'; } /* '' */\n.uil-cloud-block:before { content: '\\e8ea'; } /* '' */\n.uil-cloud-bookmark:before { content: '\\e8eb'; } /* '' */\n.uil-cloud-check:before { content: '\\e8ec'; } /* '' */\n.uil-cloud-computing:before { content: '\\e8ed'; } /* '' */\n.uil-cloud-data-connection:before { content: '\\e8ee'; } /* '' */\n.uil-cloud-database-tree:before { content: '\\e8ef'; } /* '' */\n.uil-cloud-download:before { content: '\\e8f0'; } /* '' */\n.uil-cloud-drizzle:before { content: '\\e8f1'; } /* '' */\n.uil-cloud-exclamation:before { content: '\\e8f2'; } /* '' */\n.uil-cloud-hail:before { content: '\\e8f3'; } /* '' */\n.uil-cloud-heart:before { content: '\\e8f4'; } /* '' */\n.uil-cloud-info:before { content: '\\e8f5'; } /* '' */\n.uil-cloud-lock:before { content: '\\e8f6'; } /* '' */\n.uil-cloud-meatball:before { content: '\\e8f7'; } /* '' */\n.uil-cloud-moon-hail:before { content: '\\e8f8'; } /* '' */\n.uil-cloud-moon-meatball:before { content: '\\e8f9'; } /* '' */\n.uil-cloud-moon-rain:before { content: '\\e8fa'; } /* '' */\n.uil-cloud-moon-showers:before { content: '\\e8fb'; } /* '' */\n.uil-cloud-moon:before { content: '\\e8fc'; } /* '' */\n.uil-cloud-question:before { content: '\\e8fd'; } /* '' */\n.uil-cloud-rain-sun:before { content: '\\e8fe'; } /* '' */\n.uil-cloud-rain:before { content: '\\e8ff'; } /* '' */\n.uil-cloud-redo:before { content: '\\e900'; } /* '' */\n.uil-cloud-set:before { content: '\\e901'; } /* '' */\n.uil-cloud-share:before { content: '\\e902'; } /* '' */\n.uil-cloud-shield:before { content: '\\e903'; } /* '' */\n.uil-cloud-showers-alt:before { content: '\\e904'; } /* '' */\n.uil-cloud-showers-heavy:before { content: '\\e905'; } /* '' */\n.uil-cloud-showers:before { content: '\\e906'; } /* '' */\n.uil-cloud-slash:before { content: '\\e907'; } /* '' */\n.uil-cloud-sun-hail:before { content: '\\e908'; } /* '' */\n.uil-cloud-sun-meatball:before { content: '\\e909'; } /* '' */\n.uil-cloud-sun-rain-alt:before { content: '\\e90a'; } /* '' */\n.uil-cloud-sun-rain:before { content: '\\e90b'; } /* '' */\n.uil-cloud-sun-tear:before { content: '\\e90c'; } /* '' */\n.uil-cloud-sun:before { content: '\\e90d'; } /* '' */\n.uil-cloud-times:before { content: '\\e90e'; } /* '' */\n.uil-cloud-unlock:before { content: '\\e90f'; } /* '' */\n.uil-cloud-upload:before { content: '\\e910'; } /* '' */\n.uil-cloud-wifi:before { content: '\\e911'; } /* '' */\n.uil-cloud-wind:before { content: '\\e912'; } /* '' */\n.uil-cloud:before { content: '\\e913'; } /* '' */\n.uil-clouds:before { content: '\\e914'; } /* '' */\n.uil-club:before { content: '\\e915'; } /* '' */\n.uil-code:before { content: '\\e916'; } /* '' */\n.uil-coffee:before { content: '\\e917'; } /* '' */\n.uil-cog:before { content: '\\e918'; } /* '' */\n.uil-coins:before { content: '\\e919'; } /* '' */\n.uil-columns:before { content: '\\e91a'; } /* '' */\n.uil-comment-alt-block:before { content: '\\e91b'; } /* '' */\n.uil-comment-alt-chart-lines:before { content: '\\e91c'; } /* '' */\n.uil-comment-alt-check:before { content: '\\e91d'; } /* '' */\n.uil-comment-alt-dots:before { content: '\\e91e'; } /* '' */\n.uil-comment-alt-download:before { content: '\\e91f'; } /* '' */\n.uil-comment-alt-edit:before { content: '\\e920'; } /* '' */\n.uil-comment-alt-exclamation:before { content: '\\e921'; } /* '' */\n.uil-comment-alt-heart:before { content: '\\e922'; } /* '' */\n.uil-comment-alt-image:before { content: '\\e923'; } /* '' */\n.uil-comment-alt-info:before { content: '\\e924'; } /* '' */\n.uil-comment-alt-lines:before { content: '\\e925'; } /* '' */\n.uil-comment-alt-lock:before { content: '\\e926'; } /* '' */\n.uil-comment-alt-medical:before { content: '\\e927'; } /* '' */\n.uil-comment-alt-message:before { content: '\\e928'; } /* '' */\n.uil-comment-alt-notes:before { content: '\\e929'; } /* '' */\n.uil-comment-alt-plus:before { content: '\\e92a'; } /* '' */\n.uil-comment-alt-question:before { content: '\\e92b'; } /* '' */\n.uil-comment-alt-redo:before { content: '\\e92c'; } /* '' */\n.uil-comment-alt-search:before { content: '\\e92d'; } /* '' */\n.uil-comment-alt-share:before { content: '\\e92e'; } /* '' */\n.uil-comment-alt-shield:before { content: '\\e92f'; } /* '' */\n.uil-comment-alt-slash:before { content: '\\e930'; } /* '' */\n.uil-comment-alt-upload:before { content: '\\e931'; } /* '' */\n.uil-comment-alt-verify:before { content: '\\e932'; } /* '' */\n.uil-comment-alt:before { content: '\\e933'; } /* '' */\n.uil-comment-block:before { content: '\\e934'; } /* '' */\n.uil-comment-chart-line:before { content: '\\e935'; } /* '' */\n.uil-comment-check:before { content: '\\e936'; } /* '' */\n.uil-comment-dots:before { content: '\\e937'; } /* '' */\n.uil-comment-download:before { content: '\\e938'; } /* '' */\n.uil-comment-edit:before { content: '\\e939'; } /* '' */\n.uil-comment-exclamation:before { content: '\\e93a'; } /* '' */\n.uil-comment-heart:before { content: '\\e93b'; } /* '' */\n.uil-comment-image:before { content: '\\e93c'; } /* '' */\n.uil-comment-info-alt:before { content: '\\e93d'; } /* '' */\n.uil-comment-info:before { content: '\\e93e'; } /* '' */\n.uil-comment-lines:before { content: '\\e93f'; } /* '' */\n.uil-comment-lock:before { content: '\\e940'; } /* '' */\n.uil-comment-medical:before { content: '\\e941'; } /* '' */\n.uil-comment-message:before { content: '\\e942'; } /* '' */\n.uil-comment-notes:before { content: '\\e943'; } /* '' */\n.uil-comment-plus:before { content: '\\e944'; } /* '' */\n.uil-comment-question:before { content: '\\e945'; } /* '' */\n.uil-comment-redo:before { content: '\\e946'; } /* '' */\n.uil-comment-search:before { content: '\\e947'; } /* '' */\n.uil-comment-share:before { content: '\\e948'; } /* '' */\n.uil-comment-shield:before { content: '\\e949'; } /* '' */\n.uil-comment-slash:before { content: '\\e94a'; } /* '' */\n.uil-comment-upload:before { content: '\\e94b'; } /* '' */\n.uil-comment-verify:before { content: '\\e94c'; } /* '' */\n.uil-comment:before { content: '\\e94d'; } /* '' */\n.uil-comments-alt:before { content: '\\e94e'; } /* '' */\n.uil-comments:before { content: '\\e94f'; } /* '' */\n.uil-commnet-alt-slash:before { content: '\\e950'; } /* '' */\n.uil-compact-disc:before { content: '\\e951'; } /* '' */\n.uil-compass:before { content: '\\e952'; } /* '' */\n.uil-compress-alt-left:before { content: '\\e953'; } /* '' */\n.uil-compress-alt:before { content: '\\e954'; } /* '' */\n.uil-compress-arrows:before { content: '\\e955'; } /* '' */\n.uil-compress-lines:before { content: '\\e956'; } /* '' */\n.uil-compress-point:before { content: '\\e957'; } /* '' */\n.uil-compress-v:before { content: '\\e958'; } /* '' */\n.uil-compress:before { content: '\\e959'; } /* '' */\n.uil-computer-mouse:before { content: '\\e95a'; } /* '' */\n.uil-confused:before { content: '\\e95b'; } /* '' */\n.uil-constructor:before { content: '\\e95c'; } /* '' */\n.uil-copy-alt:before { content: '\\e95d'; } /* '' */\n.uil-copy-landscape:before { content: '\\e95e'; } /* '' */\n.uil-copy:before { content: '\\e95f'; } /* '' */\n.uil-copyright:before { content: '\\e960'; } /* '' */\n.uil-corner-down-left:before { content: '\\e961'; } /* '' */\n.uil-corner-down-right-alt:before { content: '\\e962'; } /* '' */\n.uil-corner-down-right:before { content: '\\e963'; } /* '' */\n.uil-corner-left-down:before { content: '\\e964'; } /* '' */\n.uil-corner-right-down:before { content: '\\e965'; } /* '' */\n.uil-corner-up-left-alt:before { content: '\\e966'; } /* '' */\n.uil-corner-up-left:before { content: '\\e967'; } /* '' */\n.uil-corner-up-right-alt:before { content: '\\e968'; } /* '' */\n.uil-corner-up-right:before { content: '\\e969'; } /* '' */\n.uil-creative-commons-pd-alt:before { content: '\\e96a'; } /* '' */\n.uil-creative-commons-pd:before { content: '\\e96b'; } /* '' */\n.uil-crockery:before { content: '\\e96c'; } /* '' */\n.uil-crop-alt-rotate-left:before { content: '\\e96d'; } /* '' */\n.uil-crop-alt-rotate-right:before { content: '\\e96e'; } /* '' */\n.uil-crop-alt:before { content: '\\e96f'; } /* '' */\n.uil-crosshair-alt:before { content: '\\e970'; } /* '' */\n.uil-crosshair:before { content: '\\e971'; } /* '' */\n.uil-crosshairs:before { content: '\\e972'; } /* '' */\n.uil-cube:before { content: '\\e973'; } /* '' */\n.uil-dashboard:before { content: '\\e974'; } /* '' */\n.uil-data-sharing:before { content: '\\e975'; } /* '' */\n.uil-database-alt:before { content: '\\e976'; } /* '' */\n.uil-database:before { content: '\\e977'; } /* '' */\n.uil-desert:before { content: '\\e978'; } /* '' */\n.uil-desktop-alt-slash:before { content: '\\e979'; } /* '' */\n.uil-desktop-alt:before { content: '\\e97a'; } /* '' */\n.uil-desktop-cloud-alt:before { content: '\\e97b'; } /* '' */\n.uil-desktop-slash:before { content: '\\e97c'; } /* '' */\n.uil-desktop:before { content: '\\e97d'; } /* '' */\n.uil-dialpad-alt:before { content: '\\e97e'; } /* '' */\n.uil-dialpad:before { content: '\\e97f'; } /* '' */\n.uil-diamond:before { content: '\\e980'; } /* '' */\n.uil-diary-alt:before { content: '\\e981'; } /* '' */\n.uil-diary:before { content: '\\e982'; } /* '' */\n.uil-dice-five:before { content: '\\e983'; } /* '' */\n.uil-dice-four:before { content: '\\e984'; } /* '' */\n.uil-dice-one:before { content: '\\e985'; } /* '' */\n.uil-dice-six:before { content: '\\e986'; } /* '' */\n.uil-dice-three:before { content: '\\e987'; } /* '' */\n.uil-dice-two:before { content: '\\e988'; } /* '' */\n.uil-direction:before { content: '\\e989'; } /* '' */\n.uil-directions:before { content: '\\e98a'; } /* '' */\n.uil-dizzy-meh:before { content: '\\e98b'; } /* '' */\n.uil-dna:before { content: '\\e98c'; } /* '' */\n.uil-document-layout-center:before { content: '\\e98d'; } /* '' */\n.uil-document-layout-left:before { content: '\\e98e'; } /* '' */\n.uil-document-layout-right:before { content: '\\e98f'; } /* '' */\n.uil-document:before { content: '\\e990'; } /* '' */\n.uil-dollar-alt:before { content: '\\e991'; } /* '' */\n.uil-dollar-sign-alt:before { content: '\\e992'; } /* '' */\n.uil-dollar-sign:before { content: '\\e993'; } /* '' */\n.uil-down-arrow:before { content: '\\e994'; } /* '' */\n.uil-download-alt:before { content: '\\e995'; } /* '' */\n.uil-dribbble:before { content: '\\e996'; } /* '' */\n.uil-drill:before { content: '\\e997'; } /* '' */\n.uil-dropbox:before { content: '\\e998'; } /* '' */\n.uil-dumbbell:before { content: '\\e999'; } /* '' */\n.uil-ear:before { content: '\\e99a'; } /* '' */\n.uil-edit-alt:before { content: '\\e99b'; } /* '' */\n.uil-edit:before { content: '\\e99c'; } /* '' */\n.uil-ellipsis-h:before { content: '\\e99d'; } /* '' */\n.uil-ellipsis-v:before { content: '\\e99e'; } /* '' */\n.uil-emoji:before { content: '\\e99f'; } /* '' */\n.uil-enter:before { content: '\\e9a0'; } /* '' */\n.uil-entry:before { content: '\\e9a1'; } /* '' */\n.uil-envelope-add:before { content: '\\e9a2'; } /* '' */\n.uil-envelope-alt:before { content: '\\e9a3'; } /* '' */\n.uil-envelope-block:before { content: '\\e9a4'; } /* '' */\n.uil-envelope-bookmark:before { content: '\\e9a5'; } /* '' */\n.uil-envelope-check:before { content: '\\e9a6'; } /* '' */\n.uil-envelope-download-alt:before { content: '\\e9a7'; } /* '' */\n.uil-envelope-download:before { content: '\\e9a8'; } /* '' */\n.uil-envelope-edit:before { content: '\\e9a9'; } /* '' */\n.uil-envelope-exclamation:before { content: '\\e9aa'; } /* '' */\n.uil-envelope-heart:before { content: '\\e9ab'; } /* '' */\n.uil-envelope-info:before { content: '\\e9ac'; } /* '' */\n.uil-envelope-lock:before { content: '\\e9ad'; } /* '' */\n.uil-envelope-minus:before { content: '\\e9ae'; } /* '' */\n.uil-envelope-open:before { content: '\\e9af'; } /* '' */\n.uil-envelope-question:before { content: '\\e9b0'; } /* '' */\n.uil-envelope-receive:before { content: '\\e9b1'; } /* '' */\n.uil-envelope-redo:before { content: '\\e9b2'; } /* '' */\n.uil-envelope-search:before { content: '\\e9b3'; } /* '' */\n.uil-envelope-send:before { content: '\\e9b4'; } /* '' */\n.uil-envelope-share:before { content: '\\e9b5'; } /* '' */\n.uil-envelope-shield:before { content: '\\e9b6'; } /* '' */\n.uil-envelope-star:before { content: '\\e9b7'; } /* '' */\n.uil-envelope-times:before { content: '\\e9b8'; } /* '' */\n.uil-envelope-upload-alt:before { content: '\\e9b9'; } /* '' */\n.uil-envelope-upload:before { content: '\\e9ba'; } /* '' */\n.uil-envelope:before { content: '\\e9bb'; } /* '' */\n.uil-envelopes:before { content: '\\e9bc'; } /* '' */\n.uil-equal-circle:before { content: '\\e9bd'; } /* '' */\n.uil-euro-circle:before { content: '\\e9be'; } /* '' */\n.uil-euro:before { content: '\\e9bf'; } /* '' */\n.uil-exchange-alt:before { content: '\\e9c0'; } /* '' */\n.uil-exchange:before { content: '\\e9c1'; } /* '' */\n.uil-exclamation-circle:before { content: '\\e9c2'; } /* '' */\n.uil-exclamation-octagon:before { content: '\\e9c3'; } /* '' */\n.uil-exclamation-triangle:before { content: '\\e9c4'; } /* '' */\n.uil-exclude:before { content: '\\e9c5'; } /* '' */\n.uil-exit:before { content: '\\e9c6'; } /* '' */\n.uil-expand-alt:before { content: '\\e9c7'; } /* '' */\n.uil-expand-arrows-alt:before { content: '\\e9c8'; } /* '' */\n.uil-expand-arrows:before { content: '\\e9c9'; } /* '' */\n.uil-expand-from-corner:before { content: '\\e9ca'; } /* '' */\n.uil-expand-left:before { content: '\\e9cb'; } /* '' */\n.uil-expand-right:before { content: '\\e9cc'; } /* '' */\n.uil-export:before { content: '\\e9cd'; } /* '' */\n.uil-exposure-alt:before { content: '\\e9ce'; } /* '' */\n.uil-exposure-increase:before { content: '\\e9cf'; } /* '' */\n.uil-external-link-alt:before { content: '\\e9d0'; } /* '' */\n.uil-eye-slash:before { content: '\\e9d1'; } /* '' */\n.uil-eye:before { content: '\\e9d2'; } /* '' */\n.uil-facebook-f:before { content: '\\e9d3'; } /* '' */\n.uil-facebook-messenger-alt:before { content: '\\e9d4'; } /* '' */\n.uil-facebook-messenger:before { content: '\\e9d5'; } /* '' */\n.uil-facebook:before { content: '\\e9d6'; } /* '' */\n.uil-fahrenheit:before { content: '\\e9d7'; } /* '' */\n.uil-fast-mail-alt:before { content: '\\e9d8'; } /* '' */\n.uil-fast-mail:before { content: '\\e9d9'; } /* '' */\n.uil-favorite:before { content: '\\e9da'; } /* '' */\n.uil-feedback:before { content: '\\e9db'; } /* '' */\n.uil-file-alt:before { content: '\\e9dc'; } /* '' */\n.uil-file-blank:before { content: '\\e9dd'; } /* '' */\n.uil-file-block-alt:before { content: '\\e9de'; } /* '' */\n.uil-file-bookmark-alt:before { content: '\\e9df'; } /* '' */\n.uil-file-check-alt:before { content: '\\e9e0'; } /* '' */\n.uil-file-check:before { content: '\\e9e1'; } /* '' */\n.uil-file-contract-dollar:before { content: '\\e9e2'; } /* '' */\n.uil-file-copy-alt:before { content: '\\e9e3'; } /* '' */\n.uil-file-download-alt:before { content: '\\e9e4'; } /* '' */\n.uil-file-download:before { content: '\\e9e5'; } /* '' */\n.uil-file-edit-alt:before { content: '\\e9e6'; } /* '' */\n.uil-file-exclamation-alt:before { content: '\\e9e7'; } /* '' */\n.uil-file-exclamation:before { content: '\\e9e8'; } /* '' */\n.uil-file-heart:before { content: '\\e9e9'; } /* '' */\n.uil-file-info-alt:before { content: '\\e9ea'; } /* '' */\n.uil-file-landscape-alt:before { content: '\\e9eb'; } /* '' */\n.uil-file-landscape:before { content: '\\e9ec'; } /* '' */\n.uil-file-lanscape-slash:before { content: '\\e9ed'; } /* '' */\n.uil-file-lock-alt:before { content: '\\e9ee'; } /* '' */\n.uil-file-medical-alt:before { content: '\\e9ef'; } /* '' */\n.uil-file-medical:before { content: '\\e9f0'; } /* '' */\n.uil-file-minus-alt:before { content: '\\e9f1'; } /* '' */\n.uil-file-minus:before { content: '\\e9f2'; } /* '' */\n.uil-file-network:before { content: '\\e9f3'; } /* '' */\n.uil-file-plus-alt:before { content: '\\e9f4'; } /* '' */\n.uil-file-plus:before { content: '\\e9f5'; } /* '' */\n.uil-file-question-alt:before { content: '\\e9f6'; } /* '' */\n.uil-file-question:before { content: '\\e9f7'; } /* '' */\n.uil-file-redo-alt:before { content: '\\e9f8'; } /* '' */\n.uil-file-search-alt:before { content: '\\e9f9'; } /* '' */\n.uil-file-share-alt:before { content: '\\e9fa'; } /* '' */\n.uil-file-shield-alt:before { content: '\\e9fb'; } /* '' */\n.uil-file-slash:before { content: '\\e9fc'; } /* '' */\n.uil-file-times-alt:before { content: '\\e9fd'; } /* '' */\n.uil-file-times:before { content: '\\e9fe'; } /* '' */\n.uil-file-upload-alt:before { content: '\\e9ff'; } /* '' */\n.uil-file-upload:before { content: '\\ea00'; } /* '' */\n.uil-file:before { content: '\\ea01'; } /* '' */\n.uil-files-landscapes-alt:before { content: '\\ea02'; } /* '' */\n.uil-files-landscapes:before { content: '\\ea03'; } /* '' */\n.uil-film:before { content: '\\ea04'; } /* '' */\n.uil-filter-slash:before { content: '\\ea05'; } /* '' */\n.uil-filter:before { content: '\\ea06'; } /* '' */\n.uil-fire:before { content: '\\ea07'; } /* '' */\n.uil-flask-potion:before { content: '\\ea08'; } /* '' */\n.uil-flask:before { content: '\\ea09'; } /* '' */\n.uil-flip-h-alt:before { content: '\\ea0a'; } /* '' */\n.uil-flip-h:before { content: '\\ea0b'; } /* '' */\n.uil-flip-v-alt:before { content: '\\ea0c'; } /* '' */\n.uil-flip-v:before { content: '\\ea0d'; } /* '' */\n.uil-flower:before { content: '\\ea0e'; } /* '' */\n.uil-focus-add:before { content: '\\ea0f'; } /* '' */\n.uil-focus-target:before { content: '\\ea10'; } /* '' */\n.uil-focus:before { content: '\\ea11'; } /* '' */\n.uil-folder-check:before { content: '\\ea12'; } /* '' */\n.uil-folder-download:before { content: '\\ea13'; } /* '' */\n.uil-folder-exclamation:before { content: '\\ea14'; } /* '' */\n.uil-folder-heart:before { content: '\\ea15'; } /* '' */\n.uil-folder-info:before { content: '\\ea16'; } /* '' */\n.uil-folder-lock:before { content: '\\ea17'; } /* '' */\n.uil-folder-medical:before { content: '\\ea18'; } /* '' */\n.uil-folder-minus:before { content: '\\ea19'; } /* '' */\n.uil-folder-network:before { content: '\\ea1a'; } /* '' */\n.uil-folder-plus:before { content: '\\ea1b'; } /* '' */\n.uil-folder-question:before { content: '\\ea1c'; } /* '' */\n.uil-folder-slash:before { content: '\\ea1d'; } /* '' */\n.uil-folder-times:before { content: '\\ea1e'; } /* '' */\n.uil-folder-upload:before { content: '\\ea1f'; } /* '' */\n.uil-folder:before { content: '\\ea20'; } /* '' */\n.uil-food:before { content: '\\ea21'; } /* '' */\n.uil-football-american:before { content: '\\ea22'; } /* '' */\n.uil-football-ball:before { content: '\\ea23'; } /* '' */\n.uil-football:before { content: '\\ea24'; } /* '' */\n.uil-forecastcloud-moon-tear:before { content: '\\ea25'; } /* '' */\n.uil-forwaded-call:before { content: '\\ea26'; } /* '' */\n.uil-forward:before { content: '\\ea27'; } /* '' */\n.uil-frown:before { content: '\\ea28'; } /* '' */\n.uil-game-structure:before { content: '\\ea29'; } /* '' */\n.uil-game:before { content: '\\ea2a'; } /* '' */\n.uil-gift:before { content: '\\ea2b'; } /* '' */\n.uil-github-alt:before { content: '\\ea2c'; } /* '' */\n.uil-github:before { content: '\\ea2d'; } /* '' */\n.uil-glass-martini-alt-slash:before { content: '\\ea2e'; } /* '' */\n.uil-glass-martini-alt:before { content: '\\ea2f'; } /* '' */\n.uil-glass-martini:before { content: '\\ea30'; } /* '' */\n.uil-glass-tea:before { content: '\\ea31'; } /* '' */\n.uil-glass:before { content: '\\ea32'; } /* '' */\n.uil-globe:before { content: '\\ea33'; } /* '' */\n.uil-gold:before { content: '\\ea34'; } /* '' */\n.uil-google-drive-alt:before { content: '\\ea35'; } /* '' */\n.uil-google-drive:before { content: '\\ea36'; } /* '' */\n.uil-google-hangouts-alt:before { content: '\\ea37'; } /* '' */\n.uil-google-hangouts:before { content: '\\ea38'; } /* '' */\n.uil-google-play:before { content: '\\ea39'; } /* '' */\n.uil-google:before { content: '\\ea3a'; } /* '' */\n.uil-graduation-hat:before { content: '\\ea3b'; } /* '' */\n.uil-graph-bar:before { content: '\\ea3c'; } /* '' */\n.uil-grid:before { content: '\\ea3d'; } /* '' */\n.uil-grids:before { content: '\\ea3e'; } /* '' */\n.uil-grin-tongue-wink-alt:before { content: '\\ea3f'; } /* '' */\n.uil-grin-tongue-wink:before { content: '\\ea40'; } /* '' */\n.uil-grin:before { content: '\\ea41'; } /* '' */\n.uil-grip-horizontal-line:before { content: '\\ea42'; } /* '' */\n.uil-hdd:before { content: '\\ea43'; } /* '' */\n.uil-headphones-alt:before { content: '\\ea44'; } /* '' */\n.uil-headphones:before { content: '\\ea45'; } /* '' */\n.uil-heart-alt:before { content: '\\ea46'; } /* '' */\n.uil-heart-medical:before { content: '\\ea47'; } /* '' */\n.uil-heart-rate:before { content: '\\ea48'; } /* '' */\n.uil-heart-sign:before { content: '\\ea49'; } /* '' */\n.uil-heart:before { content: '\\ea4a'; } /* '' */\n.uil-heartbeat:before { content: '\\ea4b'; } /* '' */\n.uil-history-alt:before { content: '\\ea4c'; } /* '' */\n.uil-history:before { content: '\\ea4d'; } /* '' */\n.uil-home-alt:before { content: '\\ea4e'; } /* '' */\n.uil-home:before { content: '\\ea4f'; } /* '' */\n.uil-horizontal-align-center:before { content: '\\ea50'; } /* '' */\n.uil-horizontal-align-left:before { content: '\\ea51'; } /* '' */\n.uil-horizontal-align-right:before { content: '\\ea52'; } /* '' */\n.uil-horizontal-distribution-center:before { content: '\\ea53'; } /* '' */\n.uil-horizontal-distribution-left:before { content: '\\ea54'; } /* '' */\n.uil-horizontal-distribution-right:before { content: '\\ea55'; } /* '' */\n.uil-hourglass:before { content: '\\ea56'; } /* '' */\n.uil-html3-alt:before { content: '\\ea57'; } /* '' */\n.uil-html3:before { content: '\\ea58'; } /* '' */\n.uil-hunting:before { content: '\\ea59'; } /* '' */\n.uil-image-alt-slash:before { content: '\\ea5a'; } /* '' */\n.uil-image-block:before { content: '\\ea5b'; } /* '' */\n.uil-image-broken:before { content: '\\ea5c'; } /* '' */\n.uil-image-check:before { content: '\\ea5d'; } /* '' */\n.uil-image-download:before { content: '\\ea5e'; } /* '' */\n.uil-image-edit:before { content: '\\ea5f'; } /* '' */\n.uil-image-lock:before { content: '\\ea60'; } /* '' */\n.uil-image-minus:before { content: '\\ea61'; } /* '' */\n.uil-image-plus:before { content: '\\ea62'; } /* '' */\n.uil-image-question:before { content: '\\ea63'; } /* '' */\n.uil-image-redo:before { content: '\\ea64'; } /* '' */\n.uil-image-resize-landscape:before { content: '\\ea65'; } /* '' */\n.uil-image-resize-square:before { content: '\\ea66'; } /* '' */\n.uil-image-search:before { content: '\\ea67'; } /* '' */\n.uil-image-share:before { content: '\\ea68'; } /* '' */\n.uil-image-shield:before { content: '\\ea69'; } /* '' */\n.uil-image-slash:before { content: '\\ea6a'; } /* '' */\n.uil-image-times:before { content: '\\ea6b'; } /* '' */\n.uil-image-upload:before { content: '\\ea6c'; } /* '' */\n.uil-image-v:before { content: '\\ea6d'; } /* '' */\n.uil-image:before { content: '\\ea6e'; } /* '' */\n.uil-images:before { content: '\\ea6f'; } /* '' */\n.uil-import:before { content: '\\ea70'; } /* '' */\n.uil-incoming-call:before { content: '\\ea71'; } /* '' */\n.uil-info-circle:before { content: '\\ea72'; } /* '' */\n.uil-instagram-alt:before { content: '\\ea73'; } /* '' */\n.uil-instagram:before { content: '\\ea74'; } /* '' */\n.uil-intercom-alt:before { content: '\\ea75'; } /* '' */\n.uil-intercom:before { content: '\\ea76'; } /* '' */\n.uil-invoice:before { content: '\\ea77'; } /* '' */\n.uil-italic:before { content: '\\ea78'; } /* '' */\n.uil-jackhammer:before { content: '\\ea79'; } /* '' */\n.uil-java-script:before { content: '\\ea7a'; } /* '' */\n.uil-kayak:before { content: '\\ea7b'; } /* '' */\n.uil-key-skeleton-alt:before { content: '\\ea7c'; } /* '' */\n.uil-key-skeleton:before { content: '\\ea7d'; } /* '' */\n.uil-keyboard-alt:before { content: '\\ea7e'; } /* '' */\n.uil-keyboard-hide:before { content: '\\ea7f'; } /* '' */\n.uil-keyboard-show:before { content: '\\ea80'; } /* '' */\n.uil-keyboard:before { content: '\\ea81'; } /* '' */\n.uil-keyhole-circle:before { content: '\\ea82'; } /* '' */\n.uil-keyhole-square-full:before { content: '\\ea83'; } /* '' */\n.uil-keyhole-square:before { content: '\\ea84'; } /* '' */\n.uil-kid:before { content: '\\ea85'; } /* '' */\n.uil-label-alt:before { content: '\\ea86'; } /* '' */\n.uil-label:before { content: '\\ea87'; } /* '' */\n.uil-lamp:before { content: '\\ea88'; } /* '' */\n.uil-laptop-cloud:before { content: '\\ea89'; } /* '' */\n.uil-laptop:before { content: '\\ea8a'; } /* '' */\n.uil-laughing:before { content: '\\ea8b'; } /* '' */\n.uil-layer-group-slash:before { content: '\\ea8c'; } /* '' */\n.uil-layer-group:before { content: '\\ea8d'; } /* '' */\n.uil-layers-alt:before { content: '\\ea8e'; } /* '' */\n.uil-layers-slash:before { content: '\\ea8f'; } /* '' */\n.uil-layers:before { content: '\\ea90'; } /* '' */\n.uil-left-arrow-from-left:before { content: '\\ea91'; } /* '' */\n.uil-left-arrow-to-left:before { content: '\\ea92'; } /* '' */\n.uil-left-indent-alt:before { content: '\\ea93'; } /* '' */\n.uil-left-indent:before { content: '\\ea94'; } /* '' */\n.uil-left-to-right-text-direction:before { content: '\\ea95'; } /* '' */\n.uil-life-ring:before { content: '\\ea96'; } /* '' */\n.uil-lightbulb-alt:before { content: '\\ea97'; } /* '' */\n.uil-lightbulb:before { content: '\\ea98'; } /* '' */\n.uil-line-alt:before { content: '\\ea99'; } /* '' */\n.uil-line-spacing:before { content: '\\ea9a'; } /* '' */\n.uil-line:before { content: '\\ea9b'; } /* '' */\n.uil-link-alt:before { content: '\\ea9c'; } /* '' */\n.uil-link-broken:before { content: '\\ea9d'; } /* '' */\n.uil-link-h:before { content: '\\ea9e'; } /* '' */\n.uil-link:before { content: '\\ea9f'; } /* '' */\n.uil-linkedin-alt:before { content: '\\eaa0'; } /* '' */\n.uil-linkedin:before { content: '\\eaa1'; } /* '' */\n.uil-list-ui-alt:before { content: '\\eaa2'; } /* '' */\n.uil-list-ul:before { content: '\\eaa3'; } /* '' */\n.uil-location-arrow-alt:before { content: '\\eaa4'; } /* '' */\n.uil-location-arrow:before { content: '\\eaa5'; } /* '' */\n.uil-location-pin-alt:before { content: '\\eaa6'; } /* '' */\n.uil-location-point:before { content: '\\eaa7'; } /* '' */\n.uil-location:before { content: '\\eaa8'; } /* '' */\n.uil-lock-access:before { content: '\\eaa9'; } /* '' */\n.uil-lock-alt:before { content: '\\eaaa'; } /* '' */\n.uil-lock-open-alt:before { content: '\\eaab'; } /* '' */\n.uil-lock-slash:before { content: '\\eaac'; } /* '' */\n.uil-lock:before { content: '\\eaad'; } /* '' */\n.uil-mailbox-alt:before { content: '\\eaae'; } /* '' */\n.uil-mailbox:before { content: '\\eaaf'; } /* '' */\n.uil-map-marker-alt:before { content: '\\eab0'; } /* '' */\n.uil-map-marker-edit:before { content: '\\eab1'; } /* '' */\n.uil-map-marker-info:before { content: '\\eab2'; } /* '' */\n.uil-map-marker-minus:before { content: '\\eab3'; } /* '' */\n.uil-map-marker-plus:before { content: '\\eab4'; } /* '' */\n.uil-map-marker-question:before { content: '\\eab5'; } /* '' */\n.uil-map-marker-shield:before { content: '\\eab6'; } /* '' */\n.uil-map-marker-slash:before { content: '\\eab7'; } /* '' */\n.uil-map-marker:before { content: '\\eab8'; } /* '' */\n.uil-map-pin-alt:before { content: '\\eab9'; } /* '' */\n.uil-map-pin:before { content: '\\eaba'; } /* '' */\n.uil-map:before { content: '\\eabb'; } /* '' */\n.uil-mars:before { content: '\\eabc'; } /* '' */\n.uil-master-card:before { content: '\\eabd'; } /* '' */\n.uil-maximize-left:before { content: '\\eabe'; } /* '' */\n.uil-medal:before { content: '\\eabf'; } /* '' */\n.uil-medical-drip:before { content: '\\eac0'; } /* '' */\n.uil-medical-square-full:before { content: '\\eac1'; } /* '' */\n.uil-medical-square:before { content: '\\eac2'; } /* '' */\n.uil-medical:before { content: '\\eac3'; } /* '' */\n.uil-medium-m:before { content: '\\eac4'; } /* '' */\n.uil-medkit:before { content: '\\eac5'; } /* '' */\n.uil-meeting-board:before { content: '\\eac6'; } /* '' */\n.uil-megaphone:before { content: '\\eac7'; } /* '' */\n.uil-meh-alt:before { content: '\\eac8'; } /* '' */\n.uil-meh-closed-eye:before { content: '\\eac9'; } /* '' */\n.uil-meh:before { content: '\\eaca'; } /* '' */\n.uil-message:before { content: '\\eacb'; } /* '' */\n.uil-metro:before { content: '\\eacc'; } /* '' */\n.uil-microphone-slash:before { content: '\\eacd'; } /* '' */\n.uil-microphone:before { content: '\\eace'; } /* '' */\n.uil-minus-circle:before { content: '\\eacf'; } /* '' */\n.uil-minus-path:before { content: '\\ead0'; } /* '' */\n.uil-minus-square-full:before { content: '\\ead1'; } /* '' */\n.uil-minus-square:before { content: '\\ead2'; } /* '' */\n.uil-minus:before { content: '\\ead3'; } /* '' */\n.uil-missed-call:before { content: '\\ead4'; } /* '' */\n.uil-mobey-bill-slash:before { content: '\\ead5'; } /* '' */\n.uil-mobile-android-alt:before { content: '\\ead6'; } /* '' */\n.uil-mobile-android:before { content: '\\ead7'; } /* '' */\n.uil-mobile-vibrate:before { content: '\\ead8'; } /* '' */\n.uil-modem:before { content: '\\ead9'; } /* '' */\n.uil-money-bill-stack:before { content: '\\eada'; } /* '' */\n.uil-money-bill:before { content: '\\eadb'; } /* '' */\n.uil-money-insert:before { content: '\\eadc'; } /* '' */\n.uil-money-stack:before { content: '\\eadd'; } /* '' */\n.uil-money-withdraw:before { content: '\\eade'; } /* '' */\n.uil-money-withdrawal:before { content: '\\eadf'; } /* '' */\n.uil-moneybag-alt:before { content: '\\eae0'; } /* '' */\n.uil-moneybag:before { content: '\\eae1'; } /* '' */\n.uil-monitor-heart-rate:before { content: '\\eae2'; } /* '' */\n.uil-monitor:before { content: '\\eae3'; } /* '' */\n.uil-moon-eclipse:before { content: '\\eae4'; } /* '' */\n.uil-moon:before { content: '\\eae5'; } /* '' */\n.uil-moonset:before { content: '\\eae6'; } /* '' */\n.uil-mountains-sun:before { content: '\\eae7'; } /* '' */\n.uil-mountains:before { content: '\\eae8'; } /* '' */\n.uil-mouse-alt:before { content: '\\eae9'; } /* '' */\n.uil-mouse:before { content: '\\eaea'; } /* '' */\n.uil-multiply:before { content: '\\eaeb'; } /* '' */\n.uil-music-note:before { content: '\\eaec'; } /* '' */\n.uil-music-tune-slash:before { content: '\\eaed'; } /* '' */\n.uil-music:before { content: '\\eaee'; } /* '' */\n.uil-n-a:before { content: '\\eaef'; } /* '' */\n.uil-navigator:before { content: '\\eaf0'; } /* '' */\n.uil-nerd:before { content: '\\eaf1'; } /* '' */\n.uil-newspaper:before { content: '\\eaf2'; } /* '' */\n.uil-ninja:before { content: '\\eaf3'; } /* '' */\n.uil-no-entry:before { content: '\\eaf4'; } /* '' */\n.uil-notebooks:before { content: '\\eaf5'; } /* '' */\n.uil-notes:before { content: '\\eaf6'; } /* '' */\n.uil-object-group:before { content: '\\eaf7'; } /* '' */\n.uil-object-ungroup:before { content: '\\eaf8'; } /* '' */\n.uil-octagon:before { content: '\\eaf9'; } /* '' */\n.uil-opera-alt:before { content: '\\eafa'; } /* '' */\n.uil-opera:before { content: '\\eafb'; } /* '' */\n.uil-outgoing-call:before { content: '\\eafc'; } /* '' */\n.uil-package:before { content: '\\eafd'; } /* '' */\n.uil-padlock:before { content: '\\eafe'; } /* '' */\n.uil-paint-tool:before { content: '\\eaff'; } /* '' */\n.uil-palette:before { content: '\\eb00'; } /* '' */\n.uil-panorama-h-alt:before { content: '\\eb01'; } /* '' */\n.uil-panorama-h:before { content: '\\eb02'; } /* '' */\n.uil-panorama-v:before { content: '\\eb03'; } /* '' */\n.uil-paperclip:before { content: '\\eb04'; } /* '' */\n.uil-paragraph:before { content: '\\eb05'; } /* '' */\n.uil-parcel:before { content: '\\eb06'; } /* '' */\n.uil-parking-square:before { content: '\\eb07'; } /* '' */\n.uil-pathfinder-unite:before { content: '\\eb08'; } /* '' */\n.uil-pathfinder:before { content: '\\eb09'; } /* '' */\n.uil-pause-circle:before { content: '\\eb0a'; } /* '' */\n.uil-pause:before { content: '\\eb0b'; } /* '' */\n.uil-paypal:before { content: '\\eb0c'; } /* '' */\n.uil-pen:before { content: '\\eb0d'; } /* '' */\n.uil-pentagon:before { content: '\\eb0e'; } /* '' */\n.uil-percentage:before { content: '\\eb0f'; } /* '' */\n.uil-phone-alt:before { content: '\\eb10'; } /* '' */\n.uil-phone-pause:before { content: '\\eb11'; } /* '' */\n.uil-phone-slash:before { content: '\\eb12'; } /* '' */\n.uil-phone-times:before { content: '\\eb13'; } /* '' */\n.uil-phone-volume:before { content: '\\eb14'; } /* '' */\n.uil-phone:before { content: '\\eb15'; } /* '' */\n.uil-picture:before { content: '\\eb16'; } /* '' */\n.uil-plane-arrival:before { content: '\\eb17'; } /* '' */\n.uil-plane-departure:before { content: '\\eb18'; } /* '' */\n.uil-plane-fly:before { content: '\\eb19'; } /* '' */\n.uil-plane:before { content: '\\eb1a'; } /* '' */\n.uil-play-circle:before { content: '\\eb1b'; } /* '' */\n.uil-play:before { content: '\\eb1c'; } /* '' */\n.uil-plug:before { content: '\\eb1d'; } /* '' */\n.uil-plus-circle:before { content: '\\eb1e'; } /* '' */\n.uil-plus-square:before { content: '\\eb1f'; } /* '' */\n.uil-plus:before { content: '\\eb20'; } /* '' */\n.uil-podium:before { content: '\\eb21'; } /* '' */\n.uil-polygon:before { content: '\\eb22'; } /* '' */\n.uil-post-stamp:before { content: '\\eb23'; } /* '' */\n.uil-postcard:before { content: '\\eb24'; } /* '' */\n.uil-pound-circle:before { content: '\\eb25'; } /* '' */\n.uil-pound:before { content: '\\eb26'; } /* '' */\n.uil-power:before { content: '\\eb27'; } /* '' */\n.uil-prescription-bottle:before { content: '\\eb28'; } /* '' */\n.uil-presentation-check:before { content: '\\eb29'; } /* '' */\n.uil-presentation-edit:before { content: '\\eb2a'; } /* '' */\n.uil-presentation-line:before { content: '\\eb2b'; } /* '' */\n.uil-presentation-lines-alt:before { content: '\\eb2c'; } /* '' */\n.uil-presentation-minus:before { content: '\\eb2d'; } /* '' */\n.uil-presentation-play:before { content: '\\eb2e'; } /* '' */\n.uil-presentation-plus:before { content: '\\eb2f'; } /* '' */\n.uil-presentation-times:before { content: '\\eb30'; } /* '' */\n.uil-presentation:before { content: '\\eb31'; } /* '' */\n.uil-previous:before { content: '\\eb32'; } /* '' */\n.uil-pricetag-alt:before { content: '\\eb33'; } /* '' */\n.uil-print-slash:before { content: '\\eb34'; } /* '' */\n.uil-print:before { content: '\\eb35'; } /* '' */\n.uil-process:before { content: '\\eb36'; } /* '' */\n.uil-processor:before { content: '\\eb37'; } /* '' */\n.uil-pump:before { content: '\\eb38'; } /* '' */\n.uil-puzzle-piece:before { content: '\\eb39'; } /* '' */\n.uil-question-circle:before { content: '\\eb3a'; } /* '' */\n.uil-raddit-alien-alt:before { content: '\\eb3b'; } /* '' */\n.uil-rainbow:before { content: '\\eb3c'; } /* '' */\n.uil-raindrops-alt:before { content: '\\eb3d'; } /* '' */\n.uil-raindrops:before { content: '\\eb3e'; } /* '' */\n.uil-react:before { content: '\\eb3f'; } /* '' */\n.uil-receipt-alt:before { content: '\\eb40'; } /* '' */\n.uil-receipt:before { content: '\\eb41'; } /* '' */\n.uil-record-audio:before { content: '\\eb42'; } /* '' */\n.uil-reddit-alien-alt:before { content: '\\eb43'; } /* '' */\n.uil-redo:before { content: '\\eb44'; } /* '' */\n.uil-refresh:before { content: '\\eb45'; } /* '' */\n.uil-registered:before { content: '\\eb46'; } /* '' */\n.uil-repeat:before { content: '\\eb47'; } /* '' */\n.uil-restaurant:before { content: '\\eb48'; } /* '' */\n.uil-right-indent-alt:before { content: '\\eb49'; } /* '' */\n.uil-right-to-left-text-direction:before { content: '\\eb4a'; } /* '' */\n.uil-robot:before { content: '\\eb4b'; } /* '' */\n.uil-rope-way:before { content: '\\eb4c'; } /* '' */\n.uil-rotate-360:before { content: '\\eb4d'; } /* '' */\n.uil-rss-alt:before { content: '\\eb4e'; } /* '' */\n.uil-rss-interface:before { content: '\\eb4f'; } /* '' */\n.uil-rss:before { content: '\\eb50'; } /* '' */\n.uil-ruler-combined:before { content: '\\eb51'; } /* '' */\n.uil-ruler:before { content: '\\eb52'; } /* '' */\n.uil-sad-cry:before { content: '\\eb53'; } /* '' */\n.uil-sad-crying:before { content: '\\eb54'; } /* '' */\n.uil-sad-dizzy:before { content: '\\eb55'; } /* '' */\n.uil-sad-squint:before { content: '\\eb56'; } /* '' */\n.uil-sad:before { content: '\\eb57'; } /* '' */\n.uil-scaling-left:before { content: '\\eb58'; } /* '' */\n.uil-scaling-right:before { content: '\\eb59'; } /* '' */\n.uil-scenery:before { content: '\\eb5a'; } /* '' */\n.uil-schedule:before { content: '\\eb5b'; } /* '' */\n.uil-science:before { content: '\\eb5c'; } /* '' */\n.uil-screw:before { content: '\\eb5d'; } /* '' */\n.uil-scroll-h:before { content: '\\eb5e'; } /* '' */\n.uil-scroll:before { content: '\\eb5f'; } /* '' */\n.uil-search-alt:before { content: '\\eb60'; } /* '' */\n.uil-search-minus:before { content: '\\eb61'; } /* '' */\n.uil-search-plus:before { content: '\\eb62'; } /* '' */\n.uil-search:before { content: '\\eb63'; } /* '' */\n.uil-selfie:before { content: '\\eb64'; } /* '' */\n.uil-server-alt:before { content: '\\eb65'; } /* '' */\n.uil-server-connection:before { content: '\\eb66'; } /* '' */\n.uil-server-network-alt:before { content: '\\eb67'; } /* '' */\n.uil-server-network:before { content: '\\eb68'; } /* '' */\n.uil-server:before { content: '\\eb69'; } /* '' */\n.uil-servers:before { content: '\\eb6a'; } /* '' */\n.uil-servicemark:before { content: '\\eb6b'; } /* '' */\n.uil-share-alt:before { content: '\\eb6c'; } /* '' */\n.uil-shield-check:before { content: '\\eb6d'; } /* '' */\n.uil-shield-exclamation:before { content: '\\eb6e'; } /* '' */\n.uil-shield-question:before { content: '\\eb6f'; } /* '' */\n.uil-shield-slash:before { content: '\\eb70'; } /* '' */\n.uil-shield:before { content: '\\eb71'; } /* '' */\n.uil-ship:before { content: '\\eb72'; } /* '' */\n.uil-shop:before { content: '\\eb73'; } /* '' */\n.uil-shopping-basket:before { content: '\\eb74'; } /* '' */\n.uil-shopping-cart-alt:before { content: '\\eb75'; } /* '' */\n.uil-shopping-trolley:before { content: '\\eb76'; } /* '' */\n.uil-shovel:before { content: '\\eb77'; } /* '' */\n.uil-shrink:before { content: '\\eb78'; } /* '' */\n.uil-shuffle:before { content: '\\eb79'; } /* '' */\n.uil-shutter-alt:before { content: '\\eb7a'; } /* '' */\n.uil-shutter:before { content: '\\eb7b'; } /* '' */\n.uil-sick:before { content: '\\eb7c'; } /* '' */\n.uil-sigma:before { content: '\\eb7d'; } /* '' */\n.uil-sign-alt:before { content: '\\eb7e'; } /* '' */\n.uil-sign-in-alt:before { content: '\\eb7f'; } /* '' */\n.uil-sign-left:before { content: '\\eb80'; } /* '' */\n.uil-sign-out-alt:before { content: '\\eb81'; } /* '' */\n.uil-sign-right:before { content: '\\eb82'; } /* '' */\n.uil-signal-alt-3:before { content: '\\eb83'; } /* '' */\n.uil-signal-alt:before { content: '\\eb84'; } /* '' */\n.uil-signal:before { content: '\\eb85'; } /* '' */\n.uil-silence:before { content: '\\eb86'; } /* '' */\n.uil-silent-squint:before { content: '\\eb87'; } /* '' */\n.uil-sim-card:before { content: '\\eb88'; } /* '' */\n.uil-sitemap:before { content: '\\eb89'; } /* '' */\n.uil-skip-forward-alt:before { content: '\\eb8a'; } /* '' */\n.uil-skip-forward-circle:before { content: '\\eb8b'; } /* '' */\n.uil-skip-forward:before { content: '\\eb8c'; } /* '' */\n.uil-skype-alt:before { content: '\\eb8d'; } /* '' */\n.uil-skype:before { content: '\\eb8e'; } /* '' */\n.uil-slack-alt:before { content: '\\eb8f'; } /* '' */\n.uil-slack:before { content: '\\eb90'; } /* '' */\n.uil-sliders-v-alt:before { content: '\\eb91'; } /* '' */\n.uil-sliders-v:before { content: '\\eb92'; } /* '' */\n.uil-smile-beam:before { content: '\\eb93'; } /* '' */\n.uil-smile-dizzy:before { content: '\\eb94'; } /* '' */\n.uil-smile-squint-wink-alt:before { content: '\\eb95'; } /* '' */\n.uil-smile-squint-wink:before { content: '\\eb96'; } /* '' */\n.uil-smile-wink-alt:before { content: '\\eb97'; } /* '' */\n.uil-smile-wink:before { content: '\\eb98'; } /* '' */\n.uil-smile:before { content: '\\eb99'; } /* '' */\n.uil-snapchat-alt:before { content: '\\eb9a'; } /* '' */\n.uil-snapchat-ghost:before { content: '\\eb9b'; } /* '' */\n.uil-snapchat-square:before { content: '\\eb9c'; } /* '' */\n.uil-snow-flake:before { content: '\\eb9d'; } /* '' */\n.uil-snowflake-alt:before { content: '\\eb9e'; } /* '' */\n.uil-snowflake:before { content: '\\eb9f'; } /* '' */\n.uil-sort-amount-down:before { content: '\\eba0'; } /* '' */\n.uil-sort-amount-up:before { content: '\\eba1'; } /* '' */\n.uil-sort:before { content: '\\eba2'; } /* '' */\n.uil-sorting:before { content: '\\eba3'; } /* '' */\n.uil-space-key:before { content: '\\eba4'; } /* '' */\n.uil-spade:before { content: '\\eba5'; } /* '' */\n.uil-sperms:before { content: '\\eba6'; } /* '' */\n.uil-spin:before { content: '\\eba7'; } /* '' */\n.uil-sport:before { content: '\\eba8'; } /* '' */\n.uil-square-full:before { content: '\\eba9'; } /* '' */\n.uil-square-shape:before { content: '\\ebaa'; } /* '' */\n.uil-square:before { content: '\\ebab'; } /* '' */\n.uil-squint:before { content: '\\ebac'; } /* '' */\n.uil-star-half-alt:before { content: '\\ebad'; } /* '' */\n.uil-star:before { content: '\\ebae'; } /* '' */\n.uil-step-backward-alt:before { content: '\\ebaf'; } /* '' */\n.uil-step-backward-circle:before { content: '\\ebb0'; } /* '' */\n.uil-step-backward:before { content: '\\ebb1'; } /* '' */\n.uil-step-forward:before { content: '\\ebb2'; } /* '' */\n.uil-stop-circle:before { content: '\\ebb3'; } /* '' */\n.uil-stopwatch-slash:before { content: '\\ebb4'; } /* '' */\n.uil-stopwatch:before { content: '\\ebb5'; } /* '' */\n.uil-store-alt:before { content: '\\ebb6'; } /* '' */\n.uil-store:before { content: '\\ebb7'; } /* '' */\n.uil-streering:before { content: '\\ebb8'; } /* '' */\n.uil-stretcher:before { content: '\\ebb9'; } /* '' */\n.uil-subject:before { content: '\\ebba'; } /* '' */\n.uil-subway-alt:before { content: '\\ebbb'; } /* '' */\n.uil-subway:before { content: '\\ebbc'; } /* '' */\n.uil-suitcase-alt:before { content: '\\ebbd'; } /* '' */\n.uil-suitcase:before { content: '\\ebbe'; } /* '' */\n.uil-sun:before { content: '\\ebbf'; } /* '' */\n.uil-sunset:before { content: '\\ebc0'; } /* '' */\n.uil-surprise:before { content: '\\ebc1'; } /* '' */\n.uil-swatchbook:before { content: '\\ebc2'; } /* '' */\n.uil-swiggy:before { content: '\\ebc3'; } /* '' */\n.uil-swimmer:before { content: '\\ebc4'; } /* '' */\n.uil-symbol:before { content: '\\ebc5'; } /* '' */\n.uil-sync-exclamation:before { content: '\\ebc6'; } /* '' */\n.uil-sync-slash:before { content: '\\ebc7'; } /* '' */\n.uil-sync:before { content: '\\ebc8'; } /* '' */\n.uil-syringe:before { content: '\\ebc9'; } /* '' */\n.uil-table:before { content: '\\ebca'; } /* '' */\n.uil-tablet:before { content: '\\ebcb'; } /* '' */\n.uil-tablets:before { content: '\\ebcc'; } /* '' */\n.uil-tachometer-fast:before { content: '\\ebcd'; } /* '' */\n.uil-tag-alt:before { content: '\\ebce'; } /* '' */\n.uil-tag:before { content: '\\ebcf'; } /* '' */\n.uil-tape:before { content: '\\ebd0'; } /* '' */\n.uil-taxi:before { content: '\\ebd1'; } /* '' */\n.uil-tear:before { content: '\\ebd2'; } /* '' */\n.uil-technology:before { content: '\\ebd3'; } /* '' */\n.uil-telegram-alt:before { content: '\\ebd4'; } /* '' */\n.uil-telegram:before { content: '\\ebd5'; } /* '' */\n.uil-telescope:before { content: '\\ebd6'; } /* '' */\n.uil-temperature-empty:before { content: '\\ebd7'; } /* '' */\n.uil-temperature-half:before { content: '\\ebd8'; } /* '' */\n.uil-temperature-minus:before { content: '\\ebd9'; } /* '' */\n.uil-temperature-plus:before { content: '\\ebda'; } /* '' */\n.uil-temperature-quarter:before { content: '\\ebdb'; } /* '' */\n.uil-temperature-three-quarter:before { content: '\\ebdc'; } /* '' */\n.uil-temperature:before { content: '\\ebdd'; } /* '' */\n.uil-text-fields:before { content: '\\ebde'; } /* '' */\n.uil-text-size:before { content: '\\ebdf'; } /* '' */\n.uil-text-strike-through:before { content: '\\ebe0'; } /* '' */\n.uil-text:before { content: '\\ebe1'; } /* '' */\n.uil-th-large:before { content: '\\ebe2'; } /* '' */\n.uil-th-slash:before { content: '\\ebe3'; } /* '' */\n.uil-th:before { content: '\\ebe4'; } /* '' */\n.uil-thermometer:before { content: '\\ebe5'; } /* '' */\n.uil-thumbs-down:before { content: '\\ebe6'; } /* '' */\n.uil-thumbs-up:before { content: '\\ebe7'; } /* '' */\n.uil-thunderstorm-moon:before { content: '\\ebe8'; } /* '' */\n.uil-thunderstorm-sun:before { content: '\\ebe9'; } /* '' */\n.uil-thunderstorm:before { content: '\\ebea'; } /* '' */\n.uil-ticket:before { content: '\\ebeb'; } /* '' */\n.uil-times-circle:before { content: '\\ebec'; } /* '' */\n.uil-times-square:before { content: '\\ebed'; } /* '' */\n.uil-times:before { content: '\\ebee'; } /* '' */\n.uil-toggle-off:before { content: '\\ebef'; } /* '' */\n.uil-toggle-on:before { content: '\\ebf0'; } /* '' */\n.uil-top-arrow-from-top:before { content: '\\ebf1'; } /* '' */\n.uil-top-arrow-to-top:before { content: '\\ebf2'; } /* '' */\n.uil-tornado:before { content: '\\ebf3'; } /* '' */\n.uil-trademark-circle:before { content: '\\ebf4'; } /* '' */\n.uil-trademark:before { content: '\\ebf5'; } /* '' */\n.uil-traffic-barrier:before { content: '\\ebf6'; } /* '' */\n.uil-trash-alt:before { content: '\\ebf7'; } /* '' */\n.uil-trash:before { content: '\\ebf8'; } /* '' */\n.uil-trees:before { content: '\\ebf9'; } /* '' */\n.uil-triangle:before { content: '\\ebfa'; } /* '' */\n.uil-trophy:before { content: '\\ebfb'; } /* '' */\n.uil-trowel:before { content: '\\ebfc'; } /* '' */\n.uil-truck-case:before { content: '\\ebfd'; } /* '' */\n.uil-truck-loading:before { content: '\\ebfe'; } /* '' */\n.uil-truck:before { content: '\\ebff'; } /* '' */\n.uil-tumblr-alt:before { content: '\\ec00'; } /* '' */\n.uil-tumblr-square:before { content: '\\ec01'; } /* '' */\n.uil-tumblr:before { content: '\\ec02'; } /* '' */\n.uil-tv-retro-slash:before { content: '\\ec03'; } /* '' */\n.uil-tv-retro:before { content: '\\ec04'; } /* '' */\n.uil-twitter-alt:before { content: '\\ec05'; } /* '' */\n.uil-twitter:before { content: '\\ec06'; } /* '' */\n.uil-umbrella:before { content: '\\ec07'; } /* '' */\n.uil-unamused:before { content: '\\ec08'; } /* '' */\n.uil-underline:before { content: '\\ec09'; } /* '' */\n.uil-university:before { content: '\\ec0a'; } /* '' */\n.uil-unlock-alt:before { content: '\\ec0b'; } /* '' */\n.uil-unlock:before { content: '\\ec0c'; } /* '' */\n.uil-upload-alt:before { content: '\\ec0d'; } /* '' */\n.uil-upload:before { content: '\\ec0e'; } /* '' */\n.uil-usd-circle:before { content: '\\ec0f'; } /* '' */\n.uil-usd-square:before { content: '\\ec10'; } /* '' */\n.uil-user-check:before { content: '\\ec11'; } /* '' */\n.uil-user-circle:before { content: '\\ec12'; } /* '' */\n.uil-user-exclamation:before { content: '\\ec13'; } /* '' */\n.uil-user-hard-hat:before { content: '\\ec14'; } /* '' */\n.uil-user-minus:before { content: '\\ec15'; } /* '' */\n.uil-user-plus:before { content: '\\ec16'; } /* '' */\n.uil-user-square:before { content: '\\ec17'; } /* '' */\n.uil-user-times:before { content: '\\ec18'; } /* '' */\n.uil-user:before { content: '\\ec19'; } /* '' */\n.uil-users-alt:before { content: '\\ec1a'; } /* '' */\n.uil-utensils-alt:before { content: '\\ec1b'; } /* '' */\n.uil-utensils:before { content: '\\ec1c'; } /* '' */\n.uil-vector-square-alt:before { content: '\\ec1d'; } /* '' */\n.uil-vector-square:before { content: '\\ec1e'; } /* '' */\n.uil-venus:before { content: '\\ec1f'; } /* '' */\n.uil-vertical-align-bottom:before { content: '\\ec20'; } /* '' */\n.uil-vertical-align-center:before { content: '\\ec21'; } /* '' */\n.uil-vertical-align-top:before { content: '\\ec22'; } /* '' */\n.uil-vertical-distribute-bottom:before { content: '\\ec23'; } /* '' */\n.uil-vertical-distribution-center:before { content: '\\ec24'; } /* '' */\n.uil-vertical-distribution-top:before { content: '\\ec25'; } /* '' */\n.uil-video-slash:before { content: '\\ec26'; } /* '' */\n.uil-video:before { content: '\\ec27'; } /* '' */\n.uil-visual-studio:before { content: '\\ec28'; } /* '' */\n.uil-vk-alt:before { content: '\\ec29'; } /* '' */\n.uil-vk:before { content: '\\ec2a'; } /* '' */\n.uil-voicemail-rectangle:before { content: '\\ec2b'; } /* '' */\n.uil-voicemail:before { content: '\\ec2c'; } /* '' */\n.uil-volleyball:before { content: '\\ec2d'; } /* '' */\n.uil-volume-down:before { content: '\\ec2e'; } /* '' */\n.uil-volume-mute:before { content: '\\ec2f'; } /* '' */\n.uil-volume-off:before { content: '\\ec30'; } /* '' */\n.uil-volume-up:before { content: '\\ec31'; } /* '' */\n.uil-volume:before { content: '\\ec32'; } /* '' */\n.uil-vuejs-alt:before { content: '\\ec33'; } /* '' */\n.uil-vuejs:before { content: '\\ec34'; } /* '' */\n.uil-wall:before { content: '\\ec35'; } /* '' */\n.uil-wallet:before { content: '\\ec36'; } /* '' */\n.uil-watch-alt:before { content: '\\ec37'; } /* '' */\n.uil-watch:before { content: '\\ec38'; } /* '' */\n.uil-water-drop-slash:before { content: '\\ec39'; } /* '' */\n.uil-water-glass:before { content: '\\ec3a'; } /* '' */\n.uil-water:before { content: '\\ec3b'; } /* '' */\n.uil-web-grid-alt:before { content: '\\ec3c'; } /* '' */\n.uil-web-grid:before { content: '\\ec3d'; } /* '' */\n.uil-web-section-alt:before { content: '\\ec3e'; } /* '' */\n.uil-web-section:before { content: '\\ec3f'; } /* '' */\n.uil-webcam:before { content: '\\ec40'; } /* '' */\n.uil-weight:before { content: '\\ec41'; } /* '' */\n.uil-whatsapp:before { content: '\\ec42'; } /* '' */\n.uil-wheel-barrow:before { content: '\\ec43'; } /* '' */\n.uil-wheelchair-alt:before { content: '\\ec44'; } /* '' */\n.uil-wheelchair:before { content: '\\ec45'; } /* '' */\n.uil-wifi-router:before { content: '\\ec46'; } /* '' */\n.uil-wifi-slash:before { content: '\\ec47'; } /* '' */\n.uil-wifi:before { content: '\\ec48'; } /* '' */\n.uil-wind-moon:before { content: '\\ec49'; } /* '' */\n.uil-wind-sun:before { content: '\\ec4a'; } /* '' */\n.uil-wind:before { content: '\\ec4b'; } /* '' */\n.uil-window-grid:before { content: '\\ec4c'; } /* '' */\n.uil-window-maximize:before { content: '\\ec4d'; } /* '' */\n.uil-window-restore:before { content: '\\ec4e'; } /* '' */\n.uil-window-section:before { content: '\\ec4f'; } /* '' */\n.uil-window:before { content: '\\ec50'; } /* '' */\n.uil-windsock:before { content: '\\ec51'; } /* '' */\n.uil-wrap-text:before { content: '\\ec52'; } /* '' */\n.uil-wrench:before { content: '\\ec53'; } /* '' */\n.uil-yellow:before { content: '\\ec54'; } /* '' */\n.uil-yen-circle:before { content: '\\ec55'; } /* '' */\n.uil-yen:before { content: '\\ec56'; } /* '' */\n.uil-yin-yang:before { content: '\\ec57'; } /* '' */\n.uil-youtube-alt:before { content: '\\ec58'; } /* '' */\n.uil-youtube:before { content: '\\ec59'; } /* '' */\n","@font-face {\n  font-family: \"bootstrap-icons\";\n  src: url(\"../../../../fonts/bootstrap-icons.woff2?856008caa5eb66df68595e734e59580d\") format(\"woff2\"),\n        url(\"../../../../fonts/bootstrap-icons.woff?856008caa5eb66df68595e734e59580d\") format(\"woff\");\n}\n\n[class^=\"bi-\"]::before,\n[class*=\" bi-\"]::before {\n  display: inline-block;\n  font-family: bootstrap-icons !important;\n  font-style: normal;\n  font-weight: normal !important;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  vertical-align: -.125em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.bi-alarm-fill::before { content: \"\\f101\"; }\n.bi-alarm::before { content: \"\\f102\"; }\n.bi-align-bottom::before { content: \"\\f103\"; }\n.bi-align-center::before { content: \"\\f104\"; }\n.bi-align-end::before { content: \"\\f105\"; }\n.bi-align-middle::before { content: \"\\f106\"; }\n.bi-align-start::before { content: \"\\f107\"; }\n.bi-align-top::before { content: \"\\f108\"; }\n.bi-alt::before { content: \"\\f109\"; }\n.bi-app-indicator::before { content: \"\\f10a\"; }\n.bi-app::before { content: \"\\f10b\"; }\n.bi-archive-fill::before { content: \"\\f10c\"; }\n.bi-archive::before { content: \"\\f10d\"; }\n.bi-arrow-90deg-down::before { content: \"\\f10e\"; }\n.bi-arrow-90deg-left::before { content: \"\\f10f\"; }\n.bi-arrow-90deg-right::before { content: \"\\f110\"; }\n.bi-arrow-90deg-up::before { content: \"\\f111\"; }\n.bi-arrow-bar-down::before { content: \"\\f112\"; }\n.bi-arrow-bar-left::before { content: \"\\f113\"; }\n.bi-arrow-bar-right::before { content: \"\\f114\"; }\n.bi-arrow-bar-up::before { content: \"\\f115\"; }\n.bi-arrow-clockwise::before { content: \"\\f116\"; }\n.bi-arrow-counterclockwise::before { content: \"\\f117\"; }\n.bi-arrow-down-circle-fill::before { content: \"\\f118\"; }\n.bi-arrow-down-circle::before { content: \"\\f119\"; }\n.bi-arrow-down-left-circle-fill::before { content: \"\\f11a\"; }\n.bi-arrow-down-left-circle::before { content: \"\\f11b\"; }\n.bi-arrow-down-left-square-fill::before { content: \"\\f11c\"; }\n.bi-arrow-down-left-square::before { content: \"\\f11d\"; }\n.bi-arrow-down-left::before { content: \"\\f11e\"; }\n.bi-arrow-down-right-circle-fill::before { content: \"\\f11f\"; }\n.bi-arrow-down-right-circle::before { content: \"\\f120\"; }\n.bi-arrow-down-right-square-fill::before { content: \"\\f121\"; }\n.bi-arrow-down-right-square::before { content: \"\\f122\"; }\n.bi-arrow-down-right::before { content: \"\\f123\"; }\n.bi-arrow-down-short::before { content: \"\\f124\"; }\n.bi-arrow-down-square-fill::before { content: \"\\f125\"; }\n.bi-arrow-down-square::before { content: \"\\f126\"; }\n.bi-arrow-down-up::before { content: \"\\f127\"; }\n.bi-arrow-down::before { content: \"\\f128\"; }\n.bi-arrow-left-circle-fill::before { content: \"\\f129\"; }\n.bi-arrow-left-circle::before { content: \"\\f12a\"; }\n.bi-arrow-left-right::before { content: \"\\f12b\"; }\n.bi-arrow-left-short::before { content: \"\\f12c\"; }\n.bi-arrow-left-square-fill::before { content: \"\\f12d\"; }\n.bi-arrow-left-square::before { content: \"\\f12e\"; }\n.bi-arrow-left::before { content: \"\\f12f\"; }\n.bi-arrow-repeat::before { content: \"\\f130\"; }\n.bi-arrow-return-left::before { content: \"\\f131\"; }\n.bi-arrow-return-right::before { content: \"\\f132\"; }\n.bi-arrow-right-circle-fill::before { content: \"\\f133\"; }\n.bi-arrow-right-circle::before { content: \"\\f134\"; }\n.bi-arrow-right-short::before { content: \"\\f135\"; }\n.bi-arrow-right-square-fill::before { content: \"\\f136\"; }\n.bi-arrow-right-square::before { content: \"\\f137\"; }\n.bi-arrow-right::before { content: \"\\f138\"; }\n.bi-arrow-up-circle-fill::before { content: \"\\f139\"; }\n.bi-arrow-up-circle::before { content: \"\\f13a\"; }\n.bi-arrow-up-left-circle-fill::before { content: \"\\f13b\"; }\n.bi-arrow-up-left-circle::before { content: \"\\f13c\"; }\n.bi-arrow-up-left-square-fill::before { content: \"\\f13d\"; }\n.bi-arrow-up-left-square::before { content: \"\\f13e\"; }\n.bi-arrow-up-left::before { content: \"\\f13f\"; }\n.bi-arrow-up-right-circle-fill::before { content: \"\\f140\"; }\n.bi-arrow-up-right-circle::before { content: \"\\f141\"; }\n.bi-arrow-up-right-square-fill::before { content: \"\\f142\"; }\n.bi-arrow-up-right-square::before { content: \"\\f143\"; }\n.bi-arrow-up-right::before { content: \"\\f144\"; }\n.bi-arrow-up-short::before { content: \"\\f145\"; }\n.bi-arrow-up-square-fill::before { content: \"\\f146\"; }\n.bi-arrow-up-square::before { content: \"\\f147\"; }\n.bi-arrow-up::before { content: \"\\f148\"; }\n.bi-arrows-angle-contract::before { content: \"\\f149\"; }\n.bi-arrows-angle-expand::before { content: \"\\f14a\"; }\n.bi-arrows-collapse::before { content: \"\\f14b\"; }\n.bi-arrows-expand::before { content: \"\\f14c\"; }\n.bi-arrows-fullscreen::before { content: \"\\f14d\"; }\n.bi-arrows-move::before { content: \"\\f14e\"; }\n.bi-aspect-ratio-fill::before { content: \"\\f14f\"; }\n.bi-aspect-ratio::before { content: \"\\f150\"; }\n.bi-asterisk::before { content: \"\\f151\"; }\n.bi-at::before { content: \"\\f152\"; }\n.bi-award-fill::before { content: \"\\f153\"; }\n.bi-award::before { content: \"\\f154\"; }\n.bi-back::before { content: \"\\f155\"; }\n.bi-backspace-fill::before { content: \"\\f156\"; }\n.bi-backspace-reverse-fill::before { content: \"\\f157\"; }\n.bi-backspace-reverse::before { content: \"\\f158\"; }\n.bi-backspace::before { content: \"\\f159\"; }\n.bi-badge-3d-fill::before { content: \"\\f15a\"; }\n.bi-badge-3d::before { content: \"\\f15b\"; }\n.bi-badge-4k-fill::before { content: \"\\f15c\"; }\n.bi-badge-4k::before { content: \"\\f15d\"; }\n.bi-badge-8k-fill::before { content: \"\\f15e\"; }\n.bi-badge-8k::before { content: \"\\f15f\"; }\n.bi-badge-ad-fill::before { content: \"\\f160\"; }\n.bi-badge-ad::before { content: \"\\f161\"; }\n.bi-badge-ar-fill::before { content: \"\\f162\"; }\n.bi-badge-ar::before { content: \"\\f163\"; }\n.bi-badge-cc-fill::before { content: \"\\f164\"; }\n.bi-badge-cc::before { content: \"\\f165\"; }\n.bi-badge-hd-fill::before { content: \"\\f166\"; }\n.bi-badge-hd::before { content: \"\\f167\"; }\n.bi-badge-tm-fill::before { content: \"\\f168\"; }\n.bi-badge-tm::before { content: \"\\f169\"; }\n.bi-badge-vo-fill::before { content: \"\\f16a\"; }\n.bi-badge-vo::before { content: \"\\f16b\"; }\n.bi-badge-vr-fill::before { content: \"\\f16c\"; }\n.bi-badge-vr::before { content: \"\\f16d\"; }\n.bi-badge-wc-fill::before { content: \"\\f16e\"; }\n.bi-badge-wc::before { content: \"\\f16f\"; }\n.bi-bag-check-fill::before { content: \"\\f170\"; }\n.bi-bag-check::before { content: \"\\f171\"; }\n.bi-bag-dash-fill::before { content: \"\\f172\"; }\n.bi-bag-dash::before { content: \"\\f173\"; }\n.bi-bag-fill::before { content: \"\\f174\"; }\n.bi-bag-plus-fill::before { content: \"\\f175\"; }\n.bi-bag-plus::before { content: \"\\f176\"; }\n.bi-bag-x-fill::before { content: \"\\f177\"; }\n.bi-bag-x::before { content: \"\\f178\"; }\n.bi-bag::before { content: \"\\f179\"; }\n.bi-bar-chart-fill::before { content: \"\\f17a\"; }\n.bi-bar-chart-line-fill::before { content: \"\\f17b\"; }\n.bi-bar-chart-line::before { content: \"\\f17c\"; }\n.bi-bar-chart-steps::before { content: \"\\f17d\"; }\n.bi-bar-chart::before { content: \"\\f17e\"; }\n.bi-basket-fill::before { content: \"\\f17f\"; }\n.bi-basket::before { content: \"\\f180\"; }\n.bi-basket2-fill::before { content: \"\\f181\"; }\n.bi-basket2::before { content: \"\\f182\"; }\n.bi-basket3-fill::before { content: \"\\f183\"; }\n.bi-basket3::before { content: \"\\f184\"; }\n.bi-battery-charging::before { content: \"\\f185\"; }\n.bi-battery-full::before { content: \"\\f186\"; }\n.bi-battery-half::before { content: \"\\f187\"; }\n.bi-battery::before { content: \"\\f188\"; }\n.bi-bell-fill::before { content: \"\\f189\"; }\n.bi-bell::before { content: \"\\f18a\"; }\n.bi-bezier::before { content: \"\\f18b\"; }\n.bi-bezier2::before { content: \"\\f18c\"; }\n.bi-bicycle::before { content: \"\\f18d\"; }\n.bi-binoculars-fill::before { content: \"\\f18e\"; }\n.bi-binoculars::before { content: \"\\f18f\"; }\n.bi-blockquote-left::before { content: \"\\f190\"; }\n.bi-blockquote-right::before { content: \"\\f191\"; }\n.bi-book-fill::before { content: \"\\f192\"; }\n.bi-book-half::before { content: \"\\f193\"; }\n.bi-book::before { content: \"\\f194\"; }\n.bi-bookmark-check-fill::before { content: \"\\f195\"; }\n.bi-bookmark-check::before { content: \"\\f196\"; }\n.bi-bookmark-dash-fill::before { content: \"\\f197\"; }\n.bi-bookmark-dash::before { content: \"\\f198\"; }\n.bi-bookmark-fill::before { content: \"\\f199\"; }\n.bi-bookmark-heart-fill::before { content: \"\\f19a\"; }\n.bi-bookmark-heart::before { content: \"\\f19b\"; }\n.bi-bookmark-plus-fill::before { content: \"\\f19c\"; }\n.bi-bookmark-plus::before { content: \"\\f19d\"; }\n.bi-bookmark-star-fill::before { content: \"\\f19e\"; }\n.bi-bookmark-star::before { content: \"\\f19f\"; }\n.bi-bookmark-x-fill::before { content: \"\\f1a0\"; }\n.bi-bookmark-x::before { content: \"\\f1a1\"; }\n.bi-bookmark::before { content: \"\\f1a2\"; }\n.bi-bookmarks-fill::before { content: \"\\f1a3\"; }\n.bi-bookmarks::before { content: \"\\f1a4\"; }\n.bi-bookshelf::before { content: \"\\f1a5\"; }\n.bi-bootstrap-fill::before { content: \"\\f1a6\"; }\n.bi-bootstrap-reboot::before { content: \"\\f1a7\"; }\n.bi-bootstrap::before { content: \"\\f1a8\"; }\n.bi-border-all::before { content: \"\\f1a9\"; }\n.bi-border-bottom::before { content: \"\\f1aa\"; }\n.bi-border-center::before { content: \"\\f1ab\"; }\n.bi-border-inner::before { content: \"\\f1ac\"; }\n.bi-border-left::before { content: \"\\f1ad\"; }\n.bi-border-middle::before { content: \"\\f1ae\"; }\n.bi-border-outer::before { content: \"\\f1af\"; }\n.bi-border-right::before { content: \"\\f1b0\"; }\n.bi-border-style::before { content: \"\\f1b1\"; }\n.bi-border-top::before { content: \"\\f1b2\"; }\n.bi-border-width::before { content: \"\\f1b3\"; }\n.bi-border::before { content: \"\\f1b4\"; }\n.bi-bounding-box-circles::before { content: \"\\f1b5\"; }\n.bi-bounding-box::before { content: \"\\f1b6\"; }\n.bi-box-arrow-down-left::before { content: \"\\f1b7\"; }\n.bi-box-arrow-down-right::before { content: \"\\f1b8\"; }\n.bi-box-arrow-down::before { content: \"\\f1b9\"; }\n.bi-box-arrow-in-down-left::before { content: \"\\f1ba\"; }\n.bi-box-arrow-in-down-right::before { content: \"\\f1bb\"; }\n.bi-box-arrow-in-down::before { content: \"\\f1bc\"; }\n.bi-box-arrow-in-left::before { content: \"\\f1bd\"; }\n.bi-box-arrow-in-right::before { content: \"\\f1be\"; }\n.bi-box-arrow-in-up-left::before { content: \"\\f1bf\"; }\n.bi-box-arrow-in-up-right::before { content: \"\\f1c0\"; }\n.bi-box-arrow-in-up::before { content: \"\\f1c1\"; }\n.bi-box-arrow-left::before { content: \"\\f1c2\"; }\n.bi-box-arrow-right::before { content: \"\\f1c3\"; }\n.bi-box-arrow-up-left::before { content: \"\\f1c4\"; }\n.bi-box-arrow-up-right::before { content: \"\\f1c5\"; }\n.bi-box-arrow-up::before { content: \"\\f1c6\"; }\n.bi-box-seam::before { content: \"\\f1c7\"; }\n.bi-box::before { content: \"\\f1c8\"; }\n.bi-braces::before { content: \"\\f1c9\"; }\n.bi-bricks::before { content: \"\\f1ca\"; }\n.bi-briefcase-fill::before { content: \"\\f1cb\"; }\n.bi-briefcase::before { content: \"\\f1cc\"; }\n.bi-brightness-alt-high-fill::before { content: \"\\f1cd\"; }\n.bi-brightness-alt-high::before { content: \"\\f1ce\"; }\n.bi-brightness-alt-low-fill::before { content: \"\\f1cf\"; }\n.bi-brightness-alt-low::before { content: \"\\f1d0\"; }\n.bi-brightness-high-fill::before { content: \"\\f1d1\"; }\n.bi-brightness-high::before { content: \"\\f1d2\"; }\n.bi-brightness-low-fill::before { content: \"\\f1d3\"; }\n.bi-brightness-low::before { content: \"\\f1d4\"; }\n.bi-broadcast-pin::before { content: \"\\f1d5\"; }\n.bi-broadcast::before { content: \"\\f1d6\"; }\n.bi-brush-fill::before { content: \"\\f1d7\"; }\n.bi-brush::before { content: \"\\f1d8\"; }\n.bi-bucket-fill::before { content: \"\\f1d9\"; }\n.bi-bucket::before { content: \"\\f1da\"; }\n.bi-bug-fill::before { content: \"\\f1db\"; }\n.bi-bug::before { content: \"\\f1dc\"; }\n.bi-building::before { content: \"\\f1dd\"; }\n.bi-bullseye::before { content: \"\\f1de\"; }\n.bi-calculator-fill::before { content: \"\\f1df\"; }\n.bi-calculator::before { content: \"\\f1e0\"; }\n.bi-calendar-check-fill::before { content: \"\\f1e1\"; }\n.bi-calendar-check::before { content: \"\\f1e2\"; }\n.bi-calendar-date-fill::before { content: \"\\f1e3\"; }\n.bi-calendar-date::before { content: \"\\f1e4\"; }\n.bi-calendar-day-fill::before { content: \"\\f1e5\"; }\n.bi-calendar-day::before { content: \"\\f1e6\"; }\n.bi-calendar-event-fill::before { content: \"\\f1e7\"; }\n.bi-calendar-event::before { content: \"\\f1e8\"; }\n.bi-calendar-fill::before { content: \"\\f1e9\"; }\n.bi-calendar-minus-fill::before { content: \"\\f1ea\"; }\n.bi-calendar-minus::before { content: \"\\f1eb\"; }\n.bi-calendar-month-fill::before { content: \"\\f1ec\"; }\n.bi-calendar-month::before { content: \"\\f1ed\"; }\n.bi-calendar-plus-fill::before { content: \"\\f1ee\"; }\n.bi-calendar-plus::before { content: \"\\f1ef\"; }\n.bi-calendar-range-fill::before { content: \"\\f1f0\"; }\n.bi-calendar-range::before { content: \"\\f1f1\"; }\n.bi-calendar-week-fill::before { content: \"\\f1f2\"; }\n.bi-calendar-week::before { content: \"\\f1f3\"; }\n.bi-calendar-x-fill::before { content: \"\\f1f4\"; }\n.bi-calendar-x::before { content: \"\\f1f5\"; }\n.bi-calendar::before { content: \"\\f1f6\"; }\n.bi-calendar2-check-fill::before { content: \"\\f1f7\"; }\n.bi-calendar2-check::before { content: \"\\f1f8\"; }\n.bi-calendar2-date-fill::before { content: \"\\f1f9\"; }\n.bi-calendar2-date::before { content: \"\\f1fa\"; }\n.bi-calendar2-day-fill::before { content: \"\\f1fb\"; }\n.bi-calendar2-day::before { content: \"\\f1fc\"; }\n.bi-calendar2-event-fill::before { content: \"\\f1fd\"; }\n.bi-calendar2-event::before { content: \"\\f1fe\"; }\n.bi-calendar2-fill::before { content: \"\\f1ff\"; }\n.bi-calendar2-minus-fill::before { content: \"\\f200\"; }\n.bi-calendar2-minus::before { content: \"\\f201\"; }\n.bi-calendar2-month-fill::before { content: \"\\f202\"; }\n.bi-calendar2-month::before { content: \"\\f203\"; }\n.bi-calendar2-plus-fill::before { content: \"\\f204\"; }\n.bi-calendar2-plus::before { content: \"\\f205\"; }\n.bi-calendar2-range-fill::before { content: \"\\f206\"; }\n.bi-calendar2-range::before { content: \"\\f207\"; }\n.bi-calendar2-week-fill::before { content: \"\\f208\"; }\n.bi-calendar2-week::before { content: \"\\f209\"; }\n.bi-calendar2-x-fill::before { content: \"\\f20a\"; }\n.bi-calendar2-x::before { content: \"\\f20b\"; }\n.bi-calendar2::before { content: \"\\f20c\"; }\n.bi-calendar3-event-fill::before { content: \"\\f20d\"; }\n.bi-calendar3-event::before { content: \"\\f20e\"; }\n.bi-calendar3-fill::before { content: \"\\f20f\"; }\n.bi-calendar3-range-fill::before { content: \"\\f210\"; }\n.bi-calendar3-range::before { content: \"\\f211\"; }\n.bi-calendar3-week-fill::before { content: \"\\f212\"; }\n.bi-calendar3-week::before { content: \"\\f213\"; }\n.bi-calendar3::before { content: \"\\f214\"; }\n.bi-calendar4-event::before { content: \"\\f215\"; }\n.bi-calendar4-range::before { content: \"\\f216\"; }\n.bi-calendar4-week::before { content: \"\\f217\"; }\n.bi-calendar4::before { content: \"\\f218\"; }\n.bi-camera-fill::before { content: \"\\f219\"; }\n.bi-camera-reels-fill::before { content: \"\\f21a\"; }\n.bi-camera-reels::before { content: \"\\f21b\"; }\n.bi-camera-video-fill::before { content: \"\\f21c\"; }\n.bi-camera-video-off-fill::before { content: \"\\f21d\"; }\n.bi-camera-video-off::before { content: \"\\f21e\"; }\n.bi-camera-video::before { content: \"\\f21f\"; }\n.bi-camera::before { content: \"\\f220\"; }\n.bi-camera2::before { content: \"\\f221\"; }\n.bi-capslock-fill::before { content: \"\\f222\"; }\n.bi-capslock::before { content: \"\\f223\"; }\n.bi-card-checklist::before { content: \"\\f224\"; }\n.bi-card-heading::before { content: \"\\f225\"; }\n.bi-card-image::before { content: \"\\f226\"; }\n.bi-card-list::before { content: \"\\f227\"; }\n.bi-card-text::before { content: \"\\f228\"; }\n.bi-caret-down-fill::before { content: \"\\f229\"; }\n.bi-caret-down-square-fill::before { content: \"\\f22a\"; }\n.bi-caret-down-square::before { content: \"\\f22b\"; }\n.bi-caret-down::before { content: \"\\f22c\"; }\n.bi-caret-left-fill::before { content: \"\\f22d\"; }\n.bi-caret-left-square-fill::before { content: \"\\f22e\"; }\n.bi-caret-left-square::before { content: \"\\f22f\"; }\n.bi-caret-left::before { content: \"\\f230\"; }\n.bi-caret-right-fill::before { content: \"\\f231\"; }\n.bi-caret-right-square-fill::before { content: \"\\f232\"; }\n.bi-caret-right-square::before { content: \"\\f233\"; }\n.bi-caret-right::before { content: \"\\f234\"; }\n.bi-caret-up-fill::before { content: \"\\f235\"; }\n.bi-caret-up-square-fill::before { content: \"\\f236\"; }\n.bi-caret-up-square::before { content: \"\\f237\"; }\n.bi-caret-up::before { content: \"\\f238\"; }\n.bi-cart-check-fill::before { content: \"\\f239\"; }\n.bi-cart-check::before { content: \"\\f23a\"; }\n.bi-cart-dash-fill::before { content: \"\\f23b\"; }\n.bi-cart-dash::before { content: \"\\f23c\"; }\n.bi-cart-fill::before { content: \"\\f23d\"; }\n.bi-cart-plus-fill::before { content: \"\\f23e\"; }\n.bi-cart-plus::before { content: \"\\f23f\"; }\n.bi-cart-x-fill::before { content: \"\\f240\"; }\n.bi-cart-x::before { content: \"\\f241\"; }\n.bi-cart::before { content: \"\\f242\"; }\n.bi-cart2::before { content: \"\\f243\"; }\n.bi-cart3::before { content: \"\\f244\"; }\n.bi-cart4::before { content: \"\\f245\"; }\n.bi-cash-stack::before { content: \"\\f246\"; }\n.bi-cash::before { content: \"\\f247\"; }\n.bi-cast::before { content: \"\\f248\"; }\n.bi-chat-dots-fill::before { content: \"\\f249\"; }\n.bi-chat-dots::before { content: \"\\f24a\"; }\n.bi-chat-fill::before { content: \"\\f24b\"; }\n.bi-chat-left-dots-fill::before { content: \"\\f24c\"; }\n.bi-chat-left-dots::before { content: \"\\f24d\"; }\n.bi-chat-left-fill::before { content: \"\\f24e\"; }\n.bi-chat-left-quote-fill::before { content: \"\\f24f\"; }\n.bi-chat-left-quote::before { content: \"\\f250\"; }\n.bi-chat-left-text-fill::before { content: \"\\f251\"; }\n.bi-chat-left-text::before { content: \"\\f252\"; }\n.bi-chat-left::before { content: \"\\f253\"; }\n.bi-chat-quote-fill::before { content: \"\\f254\"; }\n.bi-chat-quote::before { content: \"\\f255\"; }\n.bi-chat-right-dots-fill::before { content: \"\\f256\"; }\n.bi-chat-right-dots::before { content: \"\\f257\"; }\n.bi-chat-right-fill::before { content: \"\\f258\"; }\n.bi-chat-right-quote-fill::before { content: \"\\f259\"; }\n.bi-chat-right-quote::before { content: \"\\f25a\"; }\n.bi-chat-right-text-fill::before { content: \"\\f25b\"; }\n.bi-chat-right-text::before { content: \"\\f25c\"; }\n.bi-chat-right::before { content: \"\\f25d\"; }\n.bi-chat-square-dots-fill::before { content: \"\\f25e\"; }\n.bi-chat-square-dots::before { content: \"\\f25f\"; }\n.bi-chat-square-fill::before { content: \"\\f260\"; }\n.bi-chat-square-quote-fill::before { content: \"\\f261\"; }\n.bi-chat-square-quote::before { content: \"\\f262\"; }\n.bi-chat-square-text-fill::before { content: \"\\f263\"; }\n.bi-chat-square-text::before { content: \"\\f264\"; }\n.bi-chat-square::before { content: \"\\f265\"; }\n.bi-chat-text-fill::before { content: \"\\f266\"; }\n.bi-chat-text::before { content: \"\\f267\"; }\n.bi-chat::before { content: \"\\f268\"; }\n.bi-check-all::before { content: \"\\f269\"; }\n.bi-check-circle-fill::before { content: \"\\f26a\"; }\n.bi-check-circle::before { content: \"\\f26b\"; }\n.bi-check-square-fill::before { content: \"\\f26c\"; }\n.bi-check-square::before { content: \"\\f26d\"; }\n.bi-check::before { content: \"\\f26e\"; }\n.bi-check2-all::before { content: \"\\f26f\"; }\n.bi-check2-circle::before { content: \"\\f270\"; }\n.bi-check2-square::before { content: \"\\f271\"; }\n.bi-check2::before { content: \"\\f272\"; }\n.bi-chevron-bar-contract::before { content: \"\\f273\"; }\n.bi-chevron-bar-down::before { content: \"\\f274\"; }\n.bi-chevron-bar-expand::before { content: \"\\f275\"; }\n.bi-chevron-bar-left::before { content: \"\\f276\"; }\n.bi-chevron-bar-right::before { content: \"\\f277\"; }\n.bi-chevron-bar-up::before { content: \"\\f278\"; }\n.bi-chevron-compact-down::before { content: \"\\f279\"; }\n.bi-chevron-compact-left::before { content: \"\\f27a\"; }\n.bi-chevron-compact-right::before { content: \"\\f27b\"; }\n.bi-chevron-compact-up::before { content: \"\\f27c\"; }\n.bi-chevron-contract::before { content: \"\\f27d\"; }\n.bi-chevron-double-down::before { content: \"\\f27e\"; }\n.bi-chevron-double-left::before { content: \"\\f27f\"; }\n.bi-chevron-double-right::before { content: \"\\f280\"; }\n.bi-chevron-double-up::before { content: \"\\f281\"; }\n.bi-chevron-down::before { content: \"\\f282\"; }\n.bi-chevron-expand::before { content: \"\\f283\"; }\n.bi-chevron-left::before { content: \"\\f284\"; }\n.bi-chevron-right::before { content: \"\\f285\"; }\n.bi-chevron-up::before { content: \"\\f286\"; }\n.bi-circle-fill::before { content: \"\\f287\"; }\n.bi-circle-half::before { content: \"\\f288\"; }\n.bi-circle-square::before { content: \"\\f289\"; }\n.bi-circle::before { content: \"\\f28a\"; }\n.bi-clipboard-check::before { content: \"\\f28b\"; }\n.bi-clipboard-data::before { content: \"\\f28c\"; }\n.bi-clipboard-minus::before { content: \"\\f28d\"; }\n.bi-clipboard-plus::before { content: \"\\f28e\"; }\n.bi-clipboard-x::before { content: \"\\f28f\"; }\n.bi-clipboard::before { content: \"\\f290\"; }\n.bi-clock-fill::before { content: \"\\f291\"; }\n.bi-clock-history::before { content: \"\\f292\"; }\n.bi-clock::before { content: \"\\f293\"; }\n.bi-cloud-arrow-down-fill::before { content: \"\\f294\"; }\n.bi-cloud-arrow-down::before { content: \"\\f295\"; }\n.bi-cloud-arrow-up-fill::before { content: \"\\f296\"; }\n.bi-cloud-arrow-up::before { content: \"\\f297\"; }\n.bi-cloud-check-fill::before { content: \"\\f298\"; }\n.bi-cloud-check::before { content: \"\\f299\"; }\n.bi-cloud-download-fill::before { content: \"\\f29a\"; }\n.bi-cloud-download::before { content: \"\\f29b\"; }\n.bi-cloud-drizzle-fill::before { content: \"\\f29c\"; }\n.bi-cloud-drizzle::before { content: \"\\f29d\"; }\n.bi-cloud-fill::before { content: \"\\f29e\"; }\n.bi-cloud-fog-fill::before { content: \"\\f29f\"; }\n.bi-cloud-fog::before { content: \"\\f2a0\"; }\n.bi-cloud-fog2-fill::before { content: \"\\f2a1\"; }\n.bi-cloud-fog2::before { content: \"\\f2a2\"; }\n.bi-cloud-hail-fill::before { content: \"\\f2a3\"; }\n.bi-cloud-hail::before { content: \"\\f2a4\"; }\n.bi-cloud-haze-1::before { content: \"\\f2a5\"; }\n.bi-cloud-haze-fill::before { content: \"\\f2a6\"; }\n.bi-cloud-haze::before { content: \"\\f2a7\"; }\n.bi-cloud-haze2-fill::before { content: \"\\f2a8\"; }\n.bi-cloud-lightning-fill::before { content: \"\\f2a9\"; }\n.bi-cloud-lightning-rain-fill::before { content: \"\\f2aa\"; }\n.bi-cloud-lightning-rain::before { content: \"\\f2ab\"; }\n.bi-cloud-lightning::before { content: \"\\f2ac\"; }\n.bi-cloud-minus-fill::before { content: \"\\f2ad\"; }\n.bi-cloud-minus::before { content: \"\\f2ae\"; }\n.bi-cloud-moon-fill::before { content: \"\\f2af\"; }\n.bi-cloud-moon::before { content: \"\\f2b0\"; }\n.bi-cloud-plus-fill::before { content: \"\\f2b1\"; }\n.bi-cloud-plus::before { content: \"\\f2b2\"; }\n.bi-cloud-rain-fill::before { content: \"\\f2b3\"; }\n.bi-cloud-rain-heavy-fill::before { content: \"\\f2b4\"; }\n.bi-cloud-rain-heavy::before { content: \"\\f2b5\"; }\n.bi-cloud-rain::before { content: \"\\f2b6\"; }\n.bi-cloud-slash-fill::before { content: \"\\f2b7\"; }\n.bi-cloud-slash::before { content: \"\\f2b8\"; }\n.bi-cloud-sleet-fill::before { content: \"\\f2b9\"; }\n.bi-cloud-sleet::before { content: \"\\f2ba\"; }\n.bi-cloud-snow-fill::before { content: \"\\f2bb\"; }\n.bi-cloud-snow::before { content: \"\\f2bc\"; }\n.bi-cloud-sun-fill::before { content: \"\\f2bd\"; }\n.bi-cloud-sun::before { content: \"\\f2be\"; }\n.bi-cloud-upload-fill::before { content: \"\\f2bf\"; }\n.bi-cloud-upload::before { content: \"\\f2c0\"; }\n.bi-cloud::before { content: \"\\f2c1\"; }\n.bi-clouds-fill::before { content: \"\\f2c2\"; }\n.bi-clouds::before { content: \"\\f2c3\"; }\n.bi-cloudy-fill::before { content: \"\\f2c4\"; }\n.bi-cloudy::before { content: \"\\f2c5\"; }\n.bi-code-slash::before { content: \"\\f2c6\"; }\n.bi-code-square::before { content: \"\\f2c7\"; }\n.bi-code::before { content: \"\\f2c8\"; }\n.bi-collection-fill::before { content: \"\\f2c9\"; }\n.bi-collection-play-fill::before { content: \"\\f2ca\"; }\n.bi-collection-play::before { content: \"\\f2cb\"; }\n.bi-collection::before { content: \"\\f2cc\"; }\n.bi-columns-gap::before { content: \"\\f2cd\"; }\n.bi-columns::before { content: \"\\f2ce\"; }\n.bi-command::before { content: \"\\f2cf\"; }\n.bi-compass-fill::before { content: \"\\f2d0\"; }\n.bi-compass::before { content: \"\\f2d1\"; }\n.bi-cone-striped::before { content: \"\\f2d2\"; }\n.bi-cone::before { content: \"\\f2d3\"; }\n.bi-controller::before { content: \"\\f2d4\"; }\n.bi-cpu-fill::before { content: \"\\f2d5\"; }\n.bi-cpu::before { content: \"\\f2d6\"; }\n.bi-credit-card-2-back-fill::before { content: \"\\f2d7\"; }\n.bi-credit-card-2-back::before { content: \"\\f2d8\"; }\n.bi-credit-card-2-front-fill::before { content: \"\\f2d9\"; }\n.bi-credit-card-2-front::before { content: \"\\f2da\"; }\n.bi-credit-card-fill::before { content: \"\\f2db\"; }\n.bi-credit-card::before { content: \"\\f2dc\"; }\n.bi-crop::before { content: \"\\f2dd\"; }\n.bi-cup-fill::before { content: \"\\f2de\"; }\n.bi-cup-straw::before { content: \"\\f2df\"; }\n.bi-cup::before { content: \"\\f2e0\"; }\n.bi-cursor-fill::before { content: \"\\f2e1\"; }\n.bi-cursor-text::before { content: \"\\f2e2\"; }\n.bi-cursor::before { content: \"\\f2e3\"; }\n.bi-dash-circle-dotted::before { content: \"\\f2e4\"; }\n.bi-dash-circle-fill::before { content: \"\\f2e5\"; }\n.bi-dash-circle::before { content: \"\\f2e6\"; }\n.bi-dash-square-dotted::before { content: \"\\f2e7\"; }\n.bi-dash-square-fill::before { content: \"\\f2e8\"; }\n.bi-dash-square::before { content: \"\\f2e9\"; }\n.bi-dash::before { content: \"\\f2ea\"; }\n.bi-diagram-2-fill::before { content: \"\\f2eb\"; }\n.bi-diagram-2::before { content: \"\\f2ec\"; }\n.bi-diagram-3-fill::before { content: \"\\f2ed\"; }\n.bi-diagram-3::before { content: \"\\f2ee\"; }\n.bi-diamond-fill::before { content: \"\\f2ef\"; }\n.bi-diamond-half::before { content: \"\\f2f0\"; }\n.bi-diamond::before { content: \"\\f2f1\"; }\n.bi-dice-1-fill::before { content: \"\\f2f2\"; }\n.bi-dice-1::before { content: \"\\f2f3\"; }\n.bi-dice-2-fill::before { content: \"\\f2f4\"; }\n.bi-dice-2::before { content: \"\\f2f5\"; }\n.bi-dice-3-fill::before { content: \"\\f2f6\"; }\n.bi-dice-3::before { content: \"\\f2f7\"; }\n.bi-dice-4-fill::before { content: \"\\f2f8\"; }\n.bi-dice-4::before { content: \"\\f2f9\"; }\n.bi-dice-5-fill::before { content: \"\\f2fa\"; }\n.bi-dice-5::before { content: \"\\f2fb\"; }\n.bi-dice-6-fill::before { content: \"\\f2fc\"; }\n.bi-dice-6::before { content: \"\\f2fd\"; }\n.bi-disc-fill::before { content: \"\\f2fe\"; }\n.bi-disc::before { content: \"\\f2ff\"; }\n.bi-discord::before { content: \"\\f300\"; }\n.bi-display-fill::before { content: \"\\f301\"; }\n.bi-display::before { content: \"\\f302\"; }\n.bi-distribute-horizontal::before { content: \"\\f303\"; }\n.bi-distribute-vertical::before { content: \"\\f304\"; }\n.bi-door-closed-fill::before { content: \"\\f305\"; }\n.bi-door-closed::before { content: \"\\f306\"; }\n.bi-door-open-fill::before { content: \"\\f307\"; }\n.bi-door-open::before { content: \"\\f308\"; }\n.bi-dot::before { content: \"\\f309\"; }\n.bi-download::before { content: \"\\f30a\"; }\n.bi-droplet-fill::before { content: \"\\f30b\"; }\n.bi-droplet-half::before { content: \"\\f30c\"; }\n.bi-droplet::before { content: \"\\f30d\"; }\n.bi-earbuds::before { content: \"\\f30e\"; }\n.bi-easel-fill::before { content: \"\\f30f\"; }\n.bi-easel::before { content: \"\\f310\"; }\n.bi-egg-fill::before { content: \"\\f311\"; }\n.bi-egg-fried::before { content: \"\\f312\"; }\n.bi-egg::before { content: \"\\f313\"; }\n.bi-eject-fill::before { content: \"\\f314\"; }\n.bi-eject::before { content: \"\\f315\"; }\n.bi-emoji-angry-fill::before { content: \"\\f316\"; }\n.bi-emoji-angry::before { content: \"\\f317\"; }\n.bi-emoji-dizzy-fill::before { content: \"\\f318\"; }\n.bi-emoji-dizzy::before { content: \"\\f319\"; }\n.bi-emoji-expressionless-fill::before { content: \"\\f31a\"; }\n.bi-emoji-expressionless::before { content: \"\\f31b\"; }\n.bi-emoji-frown-fill::before { content: \"\\f31c\"; }\n.bi-emoji-frown::before { content: \"\\f31d\"; }\n.bi-emoji-heart-eyes-fill::before { content: \"\\f31e\"; }\n.bi-emoji-heart-eyes::before { content: \"\\f31f\"; }\n.bi-emoji-laughing-fill::before { content: \"\\f320\"; }\n.bi-emoji-laughing::before { content: \"\\f321\"; }\n.bi-emoji-neutral-fill::before { content: \"\\f322\"; }\n.bi-emoji-neutral::before { content: \"\\f323\"; }\n.bi-emoji-smile-fill::before { content: \"\\f324\"; }\n.bi-emoji-smile-upside-down-fill::before { content: \"\\f325\"; }\n.bi-emoji-smile-upside-down::before { content: \"\\f326\"; }\n.bi-emoji-smile::before { content: \"\\f327\"; }\n.bi-emoji-sunglasses-fill::before { content: \"\\f328\"; }\n.bi-emoji-sunglasses::before { content: \"\\f329\"; }\n.bi-emoji-wink-fill::before { content: \"\\f32a\"; }\n.bi-emoji-wink::before { content: \"\\f32b\"; }\n.bi-envelope-fill::before { content: \"\\f32c\"; }\n.bi-envelope-open-fill::before { content: \"\\f32d\"; }\n.bi-envelope-open::before { content: \"\\f32e\"; }\n.bi-envelope::before { content: \"\\f32f\"; }\n.bi-eraser-fill::before { content: \"\\f330\"; }\n.bi-eraser::before { content: \"\\f331\"; }\n.bi-exclamation-circle-fill::before { content: \"\\f332\"; }\n.bi-exclamation-circle::before { content: \"\\f333\"; }\n.bi-exclamation-diamond-fill::before { content: \"\\f334\"; }\n.bi-exclamation-diamond::before { content: \"\\f335\"; }\n.bi-exclamation-octagon-fill::before { content: \"\\f336\"; }\n.bi-exclamation-octagon::before { content: \"\\f337\"; }\n.bi-exclamation-square-fill::before { content: \"\\f338\"; }\n.bi-exclamation-square::before { content: \"\\f339\"; }\n.bi-exclamation-triangle-fill::before { content: \"\\f33a\"; }\n.bi-exclamation-triangle::before { content: \"\\f33b\"; }\n.bi-exclamation::before { content: \"\\f33c\"; }\n.bi-exclude::before { content: \"\\f33d\"; }\n.bi-eye-fill::before { content: \"\\f33e\"; }\n.bi-eye-slash-fill::before { content: \"\\f33f\"; }\n.bi-eye-slash::before { content: \"\\f340\"; }\n.bi-eye::before { content: \"\\f341\"; }\n.bi-eyedropper::before { content: \"\\f342\"; }\n.bi-eyeglasses::before { content: \"\\f343\"; }\n.bi-facebook::before { content: \"\\f344\"; }\n.bi-file-arrow-down-fill::before { content: \"\\f345\"; }\n.bi-file-arrow-down::before { content: \"\\f346\"; }\n.bi-file-arrow-up-fill::before { content: \"\\f347\"; }\n.bi-file-arrow-up::before { content: \"\\f348\"; }\n.bi-file-bar-graph-fill::before { content: \"\\f349\"; }\n.bi-file-bar-graph::before { content: \"\\f34a\"; }\n.bi-file-binary-fill::before { content: \"\\f34b\"; }\n.bi-file-binary::before { content: \"\\f34c\"; }\n.bi-file-break-fill::before { content: \"\\f34d\"; }\n.bi-file-break::before { content: \"\\f34e\"; }\n.bi-file-check-fill::before { content: \"\\f34f\"; }\n.bi-file-check::before { content: \"\\f350\"; }\n.bi-file-code-fill::before { content: \"\\f351\"; }\n.bi-file-code::before { content: \"\\f352\"; }\n.bi-file-diff-fill::before { content: \"\\f353\"; }\n.bi-file-diff::before { content: \"\\f354\"; }\n.bi-file-earmark-arrow-down-fill::before { content: \"\\f355\"; }\n.bi-file-earmark-arrow-down::before { content: \"\\f356\"; }\n.bi-file-earmark-arrow-up-fill::before { content: \"\\f357\"; }\n.bi-file-earmark-arrow-up::before { content: \"\\f358\"; }\n.bi-file-earmark-bar-graph-fill::before { content: \"\\f359\"; }\n.bi-file-earmark-bar-graph::before { content: \"\\f35a\"; }\n.bi-file-earmark-binary-fill::before { content: \"\\f35b\"; }\n.bi-file-earmark-binary::before { content: \"\\f35c\"; }\n.bi-file-earmark-break-fill::before { content: \"\\f35d\"; }\n.bi-file-earmark-break::before { content: \"\\f35e\"; }\n.bi-file-earmark-check-fill::before { content: \"\\f35f\"; }\n.bi-file-earmark-check::before { content: \"\\f360\"; }\n.bi-file-earmark-code-fill::before { content: \"\\f361\"; }\n.bi-file-earmark-code::before { content: \"\\f362\"; }\n.bi-file-earmark-diff-fill::before { content: \"\\f363\"; }\n.bi-file-earmark-diff::before { content: \"\\f364\"; }\n.bi-file-earmark-easel-fill::before { content: \"\\f365\"; }\n.bi-file-earmark-easel::before { content: \"\\f366\"; }\n.bi-file-earmark-excel-fill::before { content: \"\\f367\"; }\n.bi-file-earmark-excel::before { content: \"\\f368\"; }\n.bi-file-earmark-fill::before { content: \"\\f369\"; }\n.bi-file-earmark-font-fill::before { content: \"\\f36a\"; }\n.bi-file-earmark-font::before { content: \"\\f36b\"; }\n.bi-file-earmark-image-fill::before { content: \"\\f36c\"; }\n.bi-file-earmark-image::before { content: \"\\f36d\"; }\n.bi-file-earmark-lock-fill::before { content: \"\\f36e\"; }\n.bi-file-earmark-lock::before { content: \"\\f36f\"; }\n.bi-file-earmark-lock2-fill::before { content: \"\\f370\"; }\n.bi-file-earmark-lock2::before { content: \"\\f371\"; }\n.bi-file-earmark-medical-fill::before { content: \"\\f372\"; }\n.bi-file-earmark-medical::before { content: \"\\f373\"; }\n.bi-file-earmark-minus-fill::before { content: \"\\f374\"; }\n.bi-file-earmark-minus::before { content: \"\\f375\"; }\n.bi-file-earmark-music-fill::before { content: \"\\f376\"; }\n.bi-file-earmark-music::before { content: \"\\f377\"; }\n.bi-file-earmark-person-fill::before { content: \"\\f378\"; }\n.bi-file-earmark-person::before { content: \"\\f379\"; }\n.bi-file-earmark-play-fill::before { content: \"\\f37a\"; }\n.bi-file-earmark-play::before { content: \"\\f37b\"; }\n.bi-file-earmark-plus-fill::before { content: \"\\f37c\"; }\n.bi-file-earmark-plus::before { content: \"\\f37d\"; }\n.bi-file-earmark-post-fill::before { content: \"\\f37e\"; }\n.bi-file-earmark-post::before { content: \"\\f37f\"; }\n.bi-file-earmark-ppt-fill::before { content: \"\\f380\"; }\n.bi-file-earmark-ppt::before { content: \"\\f381\"; }\n.bi-file-earmark-richtext-fill::before { content: \"\\f382\"; }\n.bi-file-earmark-richtext::before { content: \"\\f383\"; }\n.bi-file-earmark-ruled-fill::before { content: \"\\f384\"; }\n.bi-file-earmark-ruled::before { content: \"\\f385\"; }\n.bi-file-earmark-slides-fill::before { content: \"\\f386\"; }\n.bi-file-earmark-slides::before { content: \"\\f387\"; }\n.bi-file-earmark-spreadsheet-fill::before { content: \"\\f388\"; }\n.bi-file-earmark-spreadsheet::before { content: \"\\f389\"; }\n.bi-file-earmark-text-fill::before { content: \"\\f38a\"; }\n.bi-file-earmark-text::before { content: \"\\f38b\"; }\n.bi-file-earmark-word-fill::before { content: \"\\f38c\"; }\n.bi-file-earmark-word::before { content: \"\\f38d\"; }\n.bi-file-earmark-x-fill::before { content: \"\\f38e\"; }\n.bi-file-earmark-x::before { content: \"\\f38f\"; }\n.bi-file-earmark-zip-fill::before { content: \"\\f390\"; }\n.bi-file-earmark-zip::before { content: \"\\f391\"; }\n.bi-file-earmark::before { content: \"\\f392\"; }\n.bi-file-easel-fill::before { content: \"\\f393\"; }\n.bi-file-easel::before { content: \"\\f394\"; }\n.bi-file-excel-fill::before { content: \"\\f395\"; }\n.bi-file-excel::before { content: \"\\f396\"; }\n.bi-file-fill::before { content: \"\\f397\"; }\n.bi-file-font-fill::before { content: \"\\f398\"; }\n.bi-file-font::before { content: \"\\f399\"; }\n.bi-file-image-fill::before { content: \"\\f39a\"; }\n.bi-file-image::before { content: \"\\f39b\"; }\n.bi-file-lock-fill::before { content: \"\\f39c\"; }\n.bi-file-lock::before { content: \"\\f39d\"; }\n.bi-file-lock2-fill::before { content: \"\\f39e\"; }\n.bi-file-lock2::before { content: \"\\f39f\"; }\n.bi-file-medical-fill::before { content: \"\\f3a0\"; }\n.bi-file-medical::before { content: \"\\f3a1\"; }\n.bi-file-minus-fill::before { content: \"\\f3a2\"; }\n.bi-file-minus::before { content: \"\\f3a3\"; }\n.bi-file-music-fill::before { content: \"\\f3a4\"; }\n.bi-file-music::before { content: \"\\f3a5\"; }\n.bi-file-person-fill::before { content: \"\\f3a6\"; }\n.bi-file-person::before { content: \"\\f3a7\"; }\n.bi-file-play-fill::before { content: \"\\f3a8\"; }\n.bi-file-play::before { content: \"\\f3a9\"; }\n.bi-file-plus-fill::before { content: \"\\f3aa\"; }\n.bi-file-plus::before { content: \"\\f3ab\"; }\n.bi-file-post-fill::before { content: \"\\f3ac\"; }\n.bi-file-post::before { content: \"\\f3ad\"; }\n.bi-file-ppt-fill::before { content: \"\\f3ae\"; }\n.bi-file-ppt::before { content: \"\\f3af\"; }\n.bi-file-richtext-fill::before { content: \"\\f3b0\"; }\n.bi-file-richtext::before { content: \"\\f3b1\"; }\n.bi-file-ruled-fill::before { content: \"\\f3b2\"; }\n.bi-file-ruled::before { content: \"\\f3b3\"; }\n.bi-file-slides-fill::before { content: \"\\f3b4\"; }\n.bi-file-slides::before { content: \"\\f3b5\"; }\n.bi-file-spreadsheet-fill::before { content: \"\\f3b6\"; }\n.bi-file-spreadsheet::before { content: \"\\f3b7\"; }\n.bi-file-text-fill::before { content: \"\\f3b8\"; }\n.bi-file-text::before { content: \"\\f3b9\"; }\n.bi-file-word-fill::before { content: \"\\f3ba\"; }\n.bi-file-word::before { content: \"\\f3bb\"; }\n.bi-file-x-fill::before { content: \"\\f3bc\"; }\n.bi-file-x::before { content: \"\\f3bd\"; }\n.bi-file-zip-fill::before { content: \"\\f3be\"; }\n.bi-file-zip::before { content: \"\\f3bf\"; }\n.bi-file::before { content: \"\\f3c0\"; }\n.bi-files-alt::before { content: \"\\f3c1\"; }\n.bi-files::before { content: \"\\f3c2\"; }\n.bi-film::before { content: \"\\f3c3\"; }\n.bi-filter-circle-fill::before { content: \"\\f3c4\"; }\n.bi-filter-circle::before { content: \"\\f3c5\"; }\n.bi-filter-left::before { content: \"\\f3c6\"; }\n.bi-filter-right::before { content: \"\\f3c7\"; }\n.bi-filter-square-fill::before { content: \"\\f3c8\"; }\n.bi-filter-square::before { content: \"\\f3c9\"; }\n.bi-filter::before { content: \"\\f3ca\"; }\n.bi-flag-fill::before { content: \"\\f3cb\"; }\n.bi-flag::before { content: \"\\f3cc\"; }\n.bi-flower1::before { content: \"\\f3cd\"; }\n.bi-flower2::before { content: \"\\f3ce\"; }\n.bi-flower3::before { content: \"\\f3cf\"; }\n.bi-folder-check::before { content: \"\\f3d0\"; }\n.bi-folder-fill::before { content: \"\\f3d1\"; }\n.bi-folder-minus::before { content: \"\\f3d2\"; }\n.bi-folder-plus::before { content: \"\\f3d3\"; }\n.bi-folder-symlink-fill::before { content: \"\\f3d4\"; }\n.bi-folder-symlink::before { content: \"\\f3d5\"; }\n.bi-folder-x::before { content: \"\\f3d6\"; }\n.bi-folder::before { content: \"\\f3d7\"; }\n.bi-folder2-open::before { content: \"\\f3d8\"; }\n.bi-folder2::before { content: \"\\f3d9\"; }\n.bi-fonts::before { content: \"\\f3da\"; }\n.bi-forward-fill::before { content: \"\\f3db\"; }\n.bi-forward::before { content: \"\\f3dc\"; }\n.bi-front::before { content: \"\\f3dd\"; }\n.bi-fullscreen-exit::before { content: \"\\f3de\"; }\n.bi-fullscreen::before { content: \"\\f3df\"; }\n.bi-funnel-fill::before { content: \"\\f3e0\"; }\n.bi-funnel::before { content: \"\\f3e1\"; }\n.bi-gear-fill::before { content: \"\\f3e2\"; }\n.bi-gear-wide-connected::before { content: \"\\f3e3\"; }\n.bi-gear-wide::before { content: \"\\f3e4\"; }\n.bi-gear::before { content: \"\\f3e5\"; }\n.bi-gem::before { content: \"\\f3e6\"; }\n.bi-geo-alt-fill::before { content: \"\\f3e7\"; }\n.bi-geo-alt::before { content: \"\\f3e8\"; }\n.bi-geo-fill::before { content: \"\\f3e9\"; }\n.bi-geo::before { content: \"\\f3ea\"; }\n.bi-gift-fill::before { content: \"\\f3eb\"; }\n.bi-gift::before { content: \"\\f3ec\"; }\n.bi-github::before { content: \"\\f3ed\"; }\n.bi-globe::before { content: \"\\f3ee\"; }\n.bi-globe2::before { content: \"\\f3ef\"; }\n.bi-google::before { content: \"\\f3f0\"; }\n.bi-graph-down::before { content: \"\\f3f1\"; }\n.bi-graph-up::before { content: \"\\f3f2\"; }\n.bi-grid-1x2-fill::before { content: \"\\f3f3\"; }\n.bi-grid-1x2::before { content: \"\\f3f4\"; }\n.bi-grid-3x2-gap-fill::before { content: \"\\f3f5\"; }\n.bi-grid-3x2-gap::before { content: \"\\f3f6\"; }\n.bi-grid-3x2::before { content: \"\\f3f7\"; }\n.bi-grid-3x3-gap-fill::before { content: \"\\f3f8\"; }\n.bi-grid-3x3-gap::before { content: \"\\f3f9\"; }\n.bi-grid-3x3::before { content: \"\\f3fa\"; }\n.bi-grid-fill::before { content: \"\\f3fb\"; }\n.bi-grid::before { content: \"\\f3fc\"; }\n.bi-grip-horizontal::before { content: \"\\f3fd\"; }\n.bi-grip-vertical::before { content: \"\\f3fe\"; }\n.bi-hammer::before { content: \"\\f3ff\"; }\n.bi-hand-index-fill::before { content: \"\\f400\"; }\n.bi-hand-index-thumb-fill::before { content: \"\\f401\"; }\n.bi-hand-index-thumb::before { content: \"\\f402\"; }\n.bi-hand-index::before { content: \"\\f403\"; }\n.bi-hand-thumbs-down-fill::before { content: \"\\f404\"; }\n.bi-hand-thumbs-down::before { content: \"\\f405\"; }\n.bi-hand-thumbs-up-fill::before { content: \"\\f406\"; }\n.bi-hand-thumbs-up::before { content: \"\\f407\"; }\n.bi-handbag-fill::before { content: \"\\f408\"; }\n.bi-handbag::before { content: \"\\f409\"; }\n.bi-hash::before { content: \"\\f40a\"; }\n.bi-hdd-fill::before { content: \"\\f40b\"; }\n.bi-hdd-network-fill::before { content: \"\\f40c\"; }\n.bi-hdd-network::before { content: \"\\f40d\"; }\n.bi-hdd-rack-fill::before { content: \"\\f40e\"; }\n.bi-hdd-rack::before { content: \"\\f40f\"; }\n.bi-hdd-stack-fill::before { content: \"\\f410\"; }\n.bi-hdd-stack::before { content: \"\\f411\"; }\n.bi-hdd::before { content: \"\\f412\"; }\n.bi-headphones::before { content: \"\\f413\"; }\n.bi-headset::before { content: \"\\f414\"; }\n.bi-heart-fill::before { content: \"\\f415\"; }\n.bi-heart-half::before { content: \"\\f416\"; }\n.bi-heart::before { content: \"\\f417\"; }\n.bi-heptagon-fill::before { content: \"\\f418\"; }\n.bi-heptagon-half::before { content: \"\\f419\"; }\n.bi-heptagon::before { content: \"\\f41a\"; }\n.bi-hexagon-fill::before { content: \"\\f41b\"; }\n.bi-hexagon-half::before { content: \"\\f41c\"; }\n.bi-hexagon::before { content: \"\\f41d\"; }\n.bi-hourglass-bottom::before { content: \"\\f41e\"; }\n.bi-hourglass-split::before { content: \"\\f41f\"; }\n.bi-hourglass-top::before { content: \"\\f420\"; }\n.bi-hourglass::before { content: \"\\f421\"; }\n.bi-house-door-fill::before { content: \"\\f422\"; }\n.bi-house-door::before { content: \"\\f423\"; }\n.bi-house-fill::before { content: \"\\f424\"; }\n.bi-house::before { content: \"\\f425\"; }\n.bi-hr::before { content: \"\\f426\"; }\n.bi-hurricane::before { content: \"\\f427\"; }\n.bi-image-alt::before { content: \"\\f428\"; }\n.bi-image-fill::before { content: \"\\f429\"; }\n.bi-image::before { content: \"\\f42a\"; }\n.bi-images::before { content: \"\\f42b\"; }\n.bi-inbox-fill::before { content: \"\\f42c\"; }\n.bi-inbox::before { content: \"\\f42d\"; }\n.bi-inboxes-fill::before { content: \"\\f42e\"; }\n.bi-inboxes::before { content: \"\\f42f\"; }\n.bi-info-circle-fill::before { content: \"\\f430\"; }\n.bi-info-circle::before { content: \"\\f431\"; }\n.bi-info-square-fill::before { content: \"\\f432\"; }\n.bi-info-square::before { content: \"\\f433\"; }\n.bi-info::before { content: \"\\f434\"; }\n.bi-input-cursor-text::before { content: \"\\f435\"; }\n.bi-input-cursor::before { content: \"\\f436\"; }\n.bi-instagram::before { content: \"\\f437\"; }\n.bi-intersect::before { content: \"\\f438\"; }\n.bi-journal-album::before { content: \"\\f439\"; }\n.bi-journal-arrow-down::before { content: \"\\f43a\"; }\n.bi-journal-arrow-up::before { content: \"\\f43b\"; }\n.bi-journal-bookmark-fill::before { content: \"\\f43c\"; }\n.bi-journal-bookmark::before { content: \"\\f43d\"; }\n.bi-journal-check::before { content: \"\\f43e\"; }\n.bi-journal-code::before { content: \"\\f43f\"; }\n.bi-journal-medical::before { content: \"\\f440\"; }\n.bi-journal-minus::before { content: \"\\f441\"; }\n.bi-journal-plus::before { content: \"\\f442\"; }\n.bi-journal-richtext::before { content: \"\\f443\"; }\n.bi-journal-text::before { content: \"\\f444\"; }\n.bi-journal-x::before { content: \"\\f445\"; }\n.bi-journal::before { content: \"\\f446\"; }\n.bi-journals::before { content: \"\\f447\"; }\n.bi-joystick::before { content: \"\\f448\"; }\n.bi-justify-left::before { content: \"\\f449\"; }\n.bi-justify-right::before { content: \"\\f44a\"; }\n.bi-justify::before { content: \"\\f44b\"; }\n.bi-kanban-fill::before { content: \"\\f44c\"; }\n.bi-kanban::before { content: \"\\f44d\"; }\n.bi-key-fill::before { content: \"\\f44e\"; }\n.bi-key::before { content: \"\\f44f\"; }\n.bi-keyboard-fill::before { content: \"\\f450\"; }\n.bi-keyboard::before { content: \"\\f451\"; }\n.bi-ladder::before { content: \"\\f452\"; }\n.bi-lamp-fill::before { content: \"\\f453\"; }\n.bi-lamp::before { content: \"\\f454\"; }\n.bi-laptop-fill::before { content: \"\\f455\"; }\n.bi-laptop::before { content: \"\\f456\"; }\n.bi-layer-backward::before { content: \"\\f457\"; }\n.bi-layer-forward::before { content: \"\\f458\"; }\n.bi-layers-fill::before { content: \"\\f459\"; }\n.bi-layers-half::before { content: \"\\f45a\"; }\n.bi-layers::before { content: \"\\f45b\"; }\n.bi-layout-sidebar-inset-reverse::before { content: \"\\f45c\"; }\n.bi-layout-sidebar-inset::before { content: \"\\f45d\"; }\n.bi-layout-sidebar-reverse::before { content: \"\\f45e\"; }\n.bi-layout-sidebar::before { content: \"\\f45f\"; }\n.bi-layout-split::before { content: \"\\f460\"; }\n.bi-layout-text-sidebar-reverse::before { content: \"\\f461\"; }\n.bi-layout-text-sidebar::before { content: \"\\f462\"; }\n.bi-layout-text-window-reverse::before { content: \"\\f463\"; }\n.bi-layout-text-window::before { content: \"\\f464\"; }\n.bi-layout-three-columns::before { content: \"\\f465\"; }\n.bi-layout-wtf::before { content: \"\\f466\"; }\n.bi-life-preserver::before { content: \"\\f467\"; }\n.bi-lightbulb-fill::before { content: \"\\f468\"; }\n.bi-lightbulb-off-fill::before { content: \"\\f469\"; }\n.bi-lightbulb-off::before { content: \"\\f46a\"; }\n.bi-lightbulb::before { content: \"\\f46b\"; }\n.bi-lightning-charge-fill::before { content: \"\\f46c\"; }\n.bi-lightning-charge::before { content: \"\\f46d\"; }\n.bi-lightning-fill::before { content: \"\\f46e\"; }\n.bi-lightning::before { content: \"\\f46f\"; }\n.bi-link-45deg::before { content: \"\\f470\"; }\n.bi-link::before { content: \"\\f471\"; }\n.bi-linkedin::before { content: \"\\f472\"; }\n.bi-list-check::before { content: \"\\f473\"; }\n.bi-list-nested::before { content: \"\\f474\"; }\n.bi-list-ol::before { content: \"\\f475\"; }\n.bi-list-stars::before { content: \"\\f476\"; }\n.bi-list-task::before { content: \"\\f477\"; }\n.bi-list-ul::before { content: \"\\f478\"; }\n.bi-list::before { content: \"\\f479\"; }\n.bi-lock-fill::before { content: \"\\f47a\"; }\n.bi-lock::before { content: \"\\f47b\"; }\n.bi-mailbox::before { content: \"\\f47c\"; }\n.bi-mailbox2::before { content: \"\\f47d\"; }\n.bi-map-fill::before { content: \"\\f47e\"; }\n.bi-map::before { content: \"\\f47f\"; }\n.bi-markdown-fill::before { content: \"\\f480\"; }\n.bi-markdown::before { content: \"\\f481\"; }\n.bi-mask::before { content: \"\\f482\"; }\n.bi-megaphone-fill::before { content: \"\\f483\"; }\n.bi-megaphone::before { content: \"\\f484\"; }\n.bi-menu-app-fill::before { content: \"\\f485\"; }\n.bi-menu-app::before { content: \"\\f486\"; }\n.bi-menu-button-fill::before { content: \"\\f487\"; }\n.bi-menu-button-wide-fill::before { content: \"\\f488\"; }\n.bi-menu-button-wide::before { content: \"\\f489\"; }\n.bi-menu-button::before { content: \"\\f48a\"; }\n.bi-menu-down::before { content: \"\\f48b\"; }\n.bi-menu-up::before { content: \"\\f48c\"; }\n.bi-mic-fill::before { content: \"\\f48d\"; }\n.bi-mic-mute-fill::before { content: \"\\f48e\"; }\n.bi-mic-mute::before { content: \"\\f48f\"; }\n.bi-mic::before { content: \"\\f490\"; }\n.bi-minecart-loaded::before { content: \"\\f491\"; }\n.bi-minecart::before { content: \"\\f492\"; }\n.bi-moisture::before { content: \"\\f493\"; }\n.bi-moon-fill::before { content: \"\\f494\"; }\n.bi-moon-stars-fill::before { content: \"\\f495\"; }\n.bi-moon-stars::before { content: \"\\f496\"; }\n.bi-moon::before { content: \"\\f497\"; }\n.bi-mouse-fill::before { content: \"\\f498\"; }\n.bi-mouse::before { content: \"\\f499\"; }\n.bi-mouse2-fill::before { content: \"\\f49a\"; }\n.bi-mouse2::before { content: \"\\f49b\"; }\n.bi-mouse3-fill::before { content: \"\\f49c\"; }\n.bi-mouse3::before { content: \"\\f49d\"; }\n.bi-music-note-beamed::before { content: \"\\f49e\"; }\n.bi-music-note-list::before { content: \"\\f49f\"; }\n.bi-music-note::before { content: \"\\f4a0\"; }\n.bi-music-player-fill::before { content: \"\\f4a1\"; }\n.bi-music-player::before { content: \"\\f4a2\"; }\n.bi-newspaper::before { content: \"\\f4a3\"; }\n.bi-node-minus-fill::before { content: \"\\f4a4\"; }\n.bi-node-minus::before { content: \"\\f4a5\"; }\n.bi-node-plus-fill::before { content: \"\\f4a6\"; }\n.bi-node-plus::before { content: \"\\f4a7\"; }\n.bi-nut-fill::before { content: \"\\f4a8\"; }\n.bi-nut::before { content: \"\\f4a9\"; }\n.bi-octagon-fill::before { content: \"\\f4aa\"; }\n.bi-octagon-half::before { content: \"\\f4ab\"; }\n.bi-octagon::before { content: \"\\f4ac\"; }\n.bi-option::before { content: \"\\f4ad\"; }\n.bi-outlet::before { content: \"\\f4ae\"; }\n.bi-paint-bucket::before { content: \"\\f4af\"; }\n.bi-palette-fill::before { content: \"\\f4b0\"; }\n.bi-palette::before { content: \"\\f4b1\"; }\n.bi-palette2::before { content: \"\\f4b2\"; }\n.bi-paperclip::before { content: \"\\f4b3\"; }\n.bi-paragraph::before { content: \"\\f4b4\"; }\n.bi-patch-check-fill::before { content: \"\\f4b5\"; }\n.bi-patch-check::before { content: \"\\f4b6\"; }\n.bi-patch-exclamation-fill::before { content: \"\\f4b7\"; }\n.bi-patch-exclamation::before { content: \"\\f4b8\"; }\n.bi-patch-minus-fill::before { content: \"\\f4b9\"; }\n.bi-patch-minus::before { content: \"\\f4ba\"; }\n.bi-patch-plus-fill::before { content: \"\\f4bb\"; }\n.bi-patch-plus::before { content: \"\\f4bc\"; }\n.bi-patch-question-fill::before { content: \"\\f4bd\"; }\n.bi-patch-question::before { content: \"\\f4be\"; }\n.bi-pause-btn-fill::before { content: \"\\f4bf\"; }\n.bi-pause-btn::before { content: \"\\f4c0\"; }\n.bi-pause-circle-fill::before { content: \"\\f4c1\"; }\n.bi-pause-circle::before { content: \"\\f4c2\"; }\n.bi-pause-fill::before { content: \"\\f4c3\"; }\n.bi-pause::before { content: \"\\f4c4\"; }\n.bi-peace-fill::before { content: \"\\f4c5\"; }\n.bi-peace::before { content: \"\\f4c6\"; }\n.bi-pen-fill::before { content: \"\\f4c7\"; }\n.bi-pen::before { content: \"\\f4c8\"; }\n.bi-pencil-fill::before { content: \"\\f4c9\"; }\n.bi-pencil-square::before { content: \"\\f4ca\"; }\n.bi-pencil::before { content: \"\\f4cb\"; }\n.bi-pentagon-fill::before { content: \"\\f4cc\"; }\n.bi-pentagon-half::before { content: \"\\f4cd\"; }\n.bi-pentagon::before { content: \"\\f4ce\"; }\n.bi-people-fill::before { content: \"\\f4cf\"; }\n.bi-people::before { content: \"\\f4d0\"; }\n.bi-percent::before { content: \"\\f4d1\"; }\n.bi-person-badge-fill::before { content: \"\\f4d2\"; }\n.bi-person-badge::before { content: \"\\f4d3\"; }\n.bi-person-bounding-box::before { content: \"\\f4d4\"; }\n.bi-person-check-fill::before { content: \"\\f4d5\"; }\n.bi-person-check::before { content: \"\\f4d6\"; }\n.bi-person-circle::before { content: \"\\f4d7\"; }\n.bi-person-dash-fill::before { content: \"\\f4d8\"; }\n.bi-person-dash::before { content: \"\\f4d9\"; }\n.bi-person-fill::before { content: \"\\f4da\"; }\n.bi-person-lines-fill::before { content: \"\\f4db\"; }\n.bi-person-plus-fill::before { content: \"\\f4dc\"; }\n.bi-person-plus::before { content: \"\\f4dd\"; }\n.bi-person-square::before { content: \"\\f4de\"; }\n.bi-person-x-fill::before { content: \"\\f4df\"; }\n.bi-person-x::before { content: \"\\f4e0\"; }\n.bi-person::before { content: \"\\f4e1\"; }\n.bi-phone-fill::before { content: \"\\f4e2\"; }\n.bi-phone-landscape-fill::before { content: \"\\f4e3\"; }\n.bi-phone-landscape::before { content: \"\\f4e4\"; }\n.bi-phone-vibrate-fill::before { content: \"\\f4e5\"; }\n.bi-phone-vibrate::before { content: \"\\f4e6\"; }\n.bi-phone::before { content: \"\\f4e7\"; }\n.bi-pie-chart-fill::before { content: \"\\f4e8\"; }\n.bi-pie-chart::before { content: \"\\f4e9\"; }\n.bi-pin-angle-fill::before { content: \"\\f4ea\"; }\n.bi-pin-angle::before { content: \"\\f4eb\"; }\n.bi-pin-fill::before { content: \"\\f4ec\"; }\n.bi-pin::before { content: \"\\f4ed\"; }\n.bi-pip-fill::before { content: \"\\f4ee\"; }\n.bi-pip::before { content: \"\\f4ef\"; }\n.bi-play-btn-fill::before { content: \"\\f4f0\"; }\n.bi-play-btn::before { content: \"\\f4f1\"; }\n.bi-play-circle-fill::before { content: \"\\f4f2\"; }\n.bi-play-circle::before { content: \"\\f4f3\"; }\n.bi-play-fill::before { content: \"\\f4f4\"; }\n.bi-play::before { content: \"\\f4f5\"; }\n.bi-plug-fill::before { content: \"\\f4f6\"; }\n.bi-plug::before { content: \"\\f4f7\"; }\n.bi-plus-circle-dotted::before { content: \"\\f4f8\"; }\n.bi-plus-circle-fill::before { content: \"\\f4f9\"; }\n.bi-plus-circle::before { content: \"\\f4fa\"; }\n.bi-plus-square-dotted::before { content: \"\\f4fb\"; }\n.bi-plus-square-fill::before { content: \"\\f4fc\"; }\n.bi-plus-square::before { content: \"\\f4fd\"; }\n.bi-plus::before { content: \"\\f4fe\"; }\n.bi-power::before { content: \"\\f4ff\"; }\n.bi-printer-fill::before { content: \"\\f500\"; }\n.bi-printer::before { content: \"\\f501\"; }\n.bi-puzzle-fill::before { content: \"\\f502\"; }\n.bi-puzzle::before { content: \"\\f503\"; }\n.bi-question-circle-fill::before { content: \"\\f504\"; }\n.bi-question-circle::before { content: \"\\f505\"; }\n.bi-question-diamond-fill::before { content: \"\\f506\"; }\n.bi-question-diamond::before { content: \"\\f507\"; }\n.bi-question-octagon-fill::before { content: \"\\f508\"; }\n.bi-question-octagon::before { content: \"\\f509\"; }\n.bi-question-square-fill::before { content: \"\\f50a\"; }\n.bi-question-square::before { content: \"\\f50b\"; }\n.bi-question::before { content: \"\\f50c\"; }\n.bi-rainbow::before { content: \"\\f50d\"; }\n.bi-receipt-cutoff::before { content: \"\\f50e\"; }\n.bi-receipt::before { content: \"\\f50f\"; }\n.bi-reception-0::before { content: \"\\f510\"; }\n.bi-reception-1::before { content: \"\\f511\"; }\n.bi-reception-2::before { content: \"\\f512\"; }\n.bi-reception-3::before { content: \"\\f513\"; }\n.bi-reception-4::before { content: \"\\f514\"; }\n.bi-record-btn-fill::before { content: \"\\f515\"; }\n.bi-record-btn::before { content: \"\\f516\"; }\n.bi-record-circle-fill::before { content: \"\\f517\"; }\n.bi-record-circle::before { content: \"\\f518\"; }\n.bi-record-fill::before { content: \"\\f519\"; }\n.bi-record::before { content: \"\\f51a\"; }\n.bi-record2-fill::before { content: \"\\f51b\"; }\n.bi-record2::before { content: \"\\f51c\"; }\n.bi-reply-all-fill::before { content: \"\\f51d\"; }\n.bi-reply-all::before { content: \"\\f51e\"; }\n.bi-reply-fill::before { content: \"\\f51f\"; }\n.bi-reply::before { content: \"\\f520\"; }\n.bi-rss-fill::before { content: \"\\f521\"; }\n.bi-rss::before { content: \"\\f522\"; }\n.bi-rulers::before { content: \"\\f523\"; }\n.bi-save-fill::before { content: \"\\f524\"; }\n.bi-save::before { content: \"\\f525\"; }\n.bi-save2-fill::before { content: \"\\f526\"; }\n.bi-save2::before { content: \"\\f527\"; }\n.bi-scissors::before { content: \"\\f528\"; }\n.bi-screwdriver::before { content: \"\\f529\"; }\n.bi-search::before { content: \"\\f52a\"; }\n.bi-segmented-nav::before { content: \"\\f52b\"; }\n.bi-server::before { content: \"\\f52c\"; }\n.bi-share-fill::before { content: \"\\f52d\"; }\n.bi-share::before { content: \"\\f52e\"; }\n.bi-shield-check::before { content: \"\\f52f\"; }\n.bi-shield-exclamation::before { content: \"\\f530\"; }\n.bi-shield-fill-check::before { content: \"\\f531\"; }\n.bi-shield-fill-exclamation::before { content: \"\\f532\"; }\n.bi-shield-fill-minus::before { content: \"\\f533\"; }\n.bi-shield-fill-plus::before { content: \"\\f534\"; }\n.bi-shield-fill-x::before { content: \"\\f535\"; }\n.bi-shield-fill::before { content: \"\\f536\"; }\n.bi-shield-lock-fill::before { content: \"\\f537\"; }\n.bi-shield-lock::before { content: \"\\f538\"; }\n.bi-shield-minus::before { content: \"\\f539\"; }\n.bi-shield-plus::before { content: \"\\f53a\"; }\n.bi-shield-shaded::before { content: \"\\f53b\"; }\n.bi-shield-slash-fill::before { content: \"\\f53c\"; }\n.bi-shield-slash::before { content: \"\\f53d\"; }\n.bi-shield-x::before { content: \"\\f53e\"; }\n.bi-shield::before { content: \"\\f53f\"; }\n.bi-shift-fill::before { content: \"\\f540\"; }\n.bi-shift::before { content: \"\\f541\"; }\n.bi-shop-window::before { content: \"\\f542\"; }\n.bi-shop::before { content: \"\\f543\"; }\n.bi-shuffle::before { content: \"\\f544\"; }\n.bi-signpost-2-fill::before { content: \"\\f545\"; }\n.bi-signpost-2::before { content: \"\\f546\"; }\n.bi-signpost-fill::before { content: \"\\f547\"; }\n.bi-signpost-split-fill::before { content: \"\\f548\"; }\n.bi-signpost-split::before { content: \"\\f549\"; }\n.bi-signpost::before { content: \"\\f54a\"; }\n.bi-sim-fill::before { content: \"\\f54b\"; }\n.bi-sim::before { content: \"\\f54c\"; }\n.bi-skip-backward-btn-fill::before { content: \"\\f54d\"; }\n.bi-skip-backward-btn::before { content: \"\\f54e\"; }\n.bi-skip-backward-circle-fill::before { content: \"\\f54f\"; }\n.bi-skip-backward-circle::before { content: \"\\f550\"; }\n.bi-skip-backward-fill::before { content: \"\\f551\"; }\n.bi-skip-backward::before { content: \"\\f552\"; }\n.bi-skip-end-btn-fill::before { content: \"\\f553\"; }\n.bi-skip-end-btn::before { content: \"\\f554\"; }\n.bi-skip-end-circle-fill::before { content: \"\\f555\"; }\n.bi-skip-end-circle::before { content: \"\\f556\"; }\n.bi-skip-end-fill::before { content: \"\\f557\"; }\n.bi-skip-end::before { content: \"\\f558\"; }\n.bi-skip-forward-btn-fill::before { content: \"\\f559\"; }\n.bi-skip-forward-btn::before { content: \"\\f55a\"; }\n.bi-skip-forward-circle-fill::before { content: \"\\f55b\"; }\n.bi-skip-forward-circle::before { content: \"\\f55c\"; }\n.bi-skip-forward-fill::before { content: \"\\f55d\"; }\n.bi-skip-forward::before { content: \"\\f55e\"; }\n.bi-skip-start-btn-fill::before { content: \"\\f55f\"; }\n.bi-skip-start-btn::before { content: \"\\f560\"; }\n.bi-skip-start-circle-fill::before { content: \"\\f561\"; }\n.bi-skip-start-circle::before { content: \"\\f562\"; }\n.bi-skip-start-fill::before { content: \"\\f563\"; }\n.bi-skip-start::before { content: \"\\f564\"; }\n.bi-slack::before { content: \"\\f565\"; }\n.bi-slash-circle-fill::before { content: \"\\f566\"; }\n.bi-slash-circle::before { content: \"\\f567\"; }\n.bi-slash-square-fill::before { content: \"\\f568\"; }\n.bi-slash-square::before { content: \"\\f569\"; }\n.bi-slash::before { content: \"\\f56a\"; }\n.bi-sliders::before { content: \"\\f56b\"; }\n.bi-smartwatch::before { content: \"\\f56c\"; }\n.bi-snow::before { content: \"\\f56d\"; }\n.bi-snow2::before { content: \"\\f56e\"; }\n.bi-snow3::before { content: \"\\f56f\"; }\n.bi-sort-alpha-down-alt::before { content: \"\\f570\"; }\n.bi-sort-alpha-down::before { content: \"\\f571\"; }\n.bi-sort-alpha-up-alt::before { content: \"\\f572\"; }\n.bi-sort-alpha-up::before { content: \"\\f573\"; }\n.bi-sort-down-alt::before { content: \"\\f574\"; }\n.bi-sort-down::before { content: \"\\f575\"; }\n.bi-sort-numeric-down-alt::before { content: \"\\f576\"; }\n.bi-sort-numeric-down::before { content: \"\\f577\"; }\n.bi-sort-numeric-up-alt::before { content: \"\\f578\"; }\n.bi-sort-numeric-up::before { content: \"\\f579\"; }\n.bi-sort-up-alt::before { content: \"\\f57a\"; }\n.bi-sort-up::before { content: \"\\f57b\"; }\n.bi-soundwave::before { content: \"\\f57c\"; }\n.bi-speaker-fill::before { content: \"\\f57d\"; }\n.bi-speaker::before { content: \"\\f57e\"; }\n.bi-speedometer::before { content: \"\\f57f\"; }\n.bi-speedometer2::before { content: \"\\f580\"; }\n.bi-spellcheck::before { content: \"\\f581\"; }\n.bi-square-fill::before { content: \"\\f582\"; }\n.bi-square-half::before { content: \"\\f583\"; }\n.bi-square::before { content: \"\\f584\"; }\n.bi-stack::before { content: \"\\f585\"; }\n.bi-star-fill::before { content: \"\\f586\"; }\n.bi-star-half::before { content: \"\\f587\"; }\n.bi-star::before { content: \"\\f588\"; }\n.bi-stars::before { content: \"\\f589\"; }\n.bi-stickies-fill::before { content: \"\\f58a\"; }\n.bi-stickies::before { content: \"\\f58b\"; }\n.bi-sticky-fill::before { content: \"\\f58c\"; }\n.bi-sticky::before { content: \"\\f58d\"; }\n.bi-stop-btn-fill::before { content: \"\\f58e\"; }\n.bi-stop-btn::before { content: \"\\f58f\"; }\n.bi-stop-circle-fill::before { content: \"\\f590\"; }\n.bi-stop-circle::before { content: \"\\f591\"; }\n.bi-stop-fill::before { content: \"\\f592\"; }\n.bi-stop::before { content: \"\\f593\"; }\n.bi-stoplights-fill::before { content: \"\\f594\"; }\n.bi-stoplights::before { content: \"\\f595\"; }\n.bi-stopwatch-fill::before { content: \"\\f596\"; }\n.bi-stopwatch::before { content: \"\\f597\"; }\n.bi-subtract::before { content: \"\\f598\"; }\n.bi-suit-club-fill::before { content: \"\\f599\"; }\n.bi-suit-club::before { content: \"\\f59a\"; }\n.bi-suit-diamond-fill::before { content: \"\\f59b\"; }\n.bi-suit-diamond::before { content: \"\\f59c\"; }\n.bi-suit-heart-fill::before { content: \"\\f59d\"; }\n.bi-suit-heart::before { content: \"\\f59e\"; }\n.bi-suit-spade-fill::before { content: \"\\f59f\"; }\n.bi-suit-spade::before { content: \"\\f5a0\"; }\n.bi-sun-fill::before { content: \"\\f5a1\"; }\n.bi-sun::before { content: \"\\f5a2\"; }\n.bi-sunglasses::before { content: \"\\f5a3\"; }\n.bi-sunrise-fill::before { content: \"\\f5a4\"; }\n.bi-sunrise::before { content: \"\\f5a5\"; }\n.bi-sunset-fill::before { content: \"\\f5a6\"; }\n.bi-sunset::before { content: \"\\f5a7\"; }\n.bi-symmetry-horizontal::before { content: \"\\f5a8\"; }\n.bi-symmetry-vertical::before { content: \"\\f5a9\"; }\n.bi-table::before { content: \"\\f5aa\"; }\n.bi-tablet-fill::before { content: \"\\f5ab\"; }\n.bi-tablet-landscape-fill::before { content: \"\\f5ac\"; }\n.bi-tablet-landscape::before { content: \"\\f5ad\"; }\n.bi-tablet::before { content: \"\\f5ae\"; }\n.bi-tag-fill::before { content: \"\\f5af\"; }\n.bi-tag::before { content: \"\\f5b0\"; }\n.bi-tags-fill::before { content: \"\\f5b1\"; }\n.bi-tags::before { content: \"\\f5b2\"; }\n.bi-telegram::before { content: \"\\f5b3\"; }\n.bi-telephone-fill::before { content: \"\\f5b4\"; }\n.bi-telephone-forward-fill::before { content: \"\\f5b5\"; }\n.bi-telephone-forward::before { content: \"\\f5b6\"; }\n.bi-telephone-inbound-fill::before { content: \"\\f5b7\"; }\n.bi-telephone-inbound::before { content: \"\\f5b8\"; }\n.bi-telephone-minus-fill::before { content: \"\\f5b9\"; }\n.bi-telephone-minus::before { content: \"\\f5ba\"; }\n.bi-telephone-outbound-fill::before { content: \"\\f5bb\"; }\n.bi-telephone-outbound::before { content: \"\\f5bc\"; }\n.bi-telephone-plus-fill::before { content: \"\\f5bd\"; }\n.bi-telephone-plus::before { content: \"\\f5be\"; }\n.bi-telephone-x-fill::before { content: \"\\f5bf\"; }\n.bi-telephone-x::before { content: \"\\f5c0\"; }\n.bi-telephone::before { content: \"\\f5c1\"; }\n.bi-terminal-fill::before { content: \"\\f5c2\"; }\n.bi-terminal::before { content: \"\\f5c3\"; }\n.bi-text-center::before { content: \"\\f5c4\"; }\n.bi-text-indent-left::before { content: \"\\f5c5\"; }\n.bi-text-indent-right::before { content: \"\\f5c6\"; }\n.bi-text-left::before { content: \"\\f5c7\"; }\n.bi-text-paragraph::before { content: \"\\f5c8\"; }\n.bi-text-right::before { content: \"\\f5c9\"; }\n.bi-textarea-resize::before { content: \"\\f5ca\"; }\n.bi-textarea-t::before { content: \"\\f5cb\"; }\n.bi-textarea::before { content: \"\\f5cc\"; }\n.bi-thermometer-half::before { content: \"\\f5cd\"; }\n.bi-thermometer-high::before { content: \"\\f5ce\"; }\n.bi-thermometer-low::before { content: \"\\f5cf\"; }\n.bi-thermometer-snow::before { content: \"\\f5d0\"; }\n.bi-thermometer-sun::before { content: \"\\f5d1\"; }\n.bi-thermometer::before { content: \"\\f5d2\"; }\n.bi-three-dots-vertical::before { content: \"\\f5d3\"; }\n.bi-three-dots::before { content: \"\\f5d4\"; }\n.bi-toggle-off::before { content: \"\\f5d5\"; }\n.bi-toggle-on::before { content: \"\\f5d6\"; }\n.bi-toggle2-off::before { content: \"\\f5d7\"; }\n.bi-toggle2-on::before { content: \"\\f5d8\"; }\n.bi-toggles::before { content: \"\\f5d9\"; }\n.bi-toggles2::before { content: \"\\f5da\"; }\n.bi-tools::before { content: \"\\f5db\"; }\n.bi-tornado::before { content: \"\\f5dc\"; }\n.bi-trash-fill::before { content: \"\\f5dd\"; }\n.bi-trash::before { content: \"\\f5de\"; }\n.bi-trash2-fill::before { content: \"\\f5df\"; }\n.bi-trash2::before { content: \"\\f5e0\"; }\n.bi-tree-fill::before { content: \"\\f5e1\"; }\n.bi-tree::before { content: \"\\f5e2\"; }\n.bi-triangle-fill::before { content: \"\\f5e3\"; }\n.bi-triangle-half::before { content: \"\\f5e4\"; }\n.bi-triangle::before { content: \"\\f5e5\"; }\n.bi-trophy-fill::before { content: \"\\f5e6\"; }\n.bi-trophy::before { content: \"\\f5e7\"; }\n.bi-tropical-storm::before { content: \"\\f5e8\"; }\n.bi-truck-flatbed::before { content: \"\\f5e9\"; }\n.bi-truck::before { content: \"\\f5ea\"; }\n.bi-tsunami::before { content: \"\\f5eb\"; }\n.bi-tv-fill::before { content: \"\\f5ec\"; }\n.bi-tv::before { content: \"\\f5ed\"; }\n.bi-twitch::before { content: \"\\f5ee\"; }\n.bi-twitter::before { content: \"\\f5ef\"; }\n.bi-type-bold::before { content: \"\\f5f0\"; }\n.bi-type-h1::before { content: \"\\f5f1\"; }\n.bi-type-h2::before { content: \"\\f5f2\"; }\n.bi-type-h3::before { content: \"\\f5f3\"; }\n.bi-type-italic::before { content: \"\\f5f4\"; }\n.bi-type-strikethrough::before { content: \"\\f5f5\"; }\n.bi-type-underline::before { content: \"\\f5f6\"; }\n.bi-type::before { content: \"\\f5f7\"; }\n.bi-ui-checks-grid::before { content: \"\\f5f8\"; }\n.bi-ui-checks::before { content: \"\\f5f9\"; }\n.bi-ui-radios-grid::before { content: \"\\f5fa\"; }\n.bi-ui-radios::before { content: \"\\f5fb\"; }\n.bi-umbrella-fill::before { content: \"\\f5fc\"; }\n.bi-umbrella::before { content: \"\\f5fd\"; }\n.bi-union::before { content: \"\\f5fe\"; }\n.bi-unlock-fill::before { content: \"\\f5ff\"; }\n.bi-unlock::before { content: \"\\f600\"; }\n.bi-upc-scan::before { content: \"\\f601\"; }\n.bi-upc::before { content: \"\\f602\"; }\n.bi-upload::before { content: \"\\f603\"; }\n.bi-vector-pen::before { content: \"\\f604\"; }\n.bi-view-list::before { content: \"\\f605\"; }\n.bi-view-stacked::before { content: \"\\f606\"; }\n.bi-vinyl-fill::before { content: \"\\f607\"; }\n.bi-vinyl::before { content: \"\\f608\"; }\n.bi-voicemail::before { content: \"\\f609\"; }\n.bi-volume-down-fill::before { content: \"\\f60a\"; }\n.bi-volume-down::before { content: \"\\f60b\"; }\n.bi-volume-mute-fill::before { content: \"\\f60c\"; }\n.bi-volume-mute::before { content: \"\\f60d\"; }\n.bi-volume-off-fill::before { content: \"\\f60e\"; }\n.bi-volume-off::before { content: \"\\f60f\"; }\n.bi-volume-up-fill::before { content: \"\\f610\"; }\n.bi-volume-up::before { content: \"\\f611\"; }\n.bi-vr::before { content: \"\\f612\"; }\n.bi-wallet-fill::before { content: \"\\f613\"; }\n.bi-wallet::before { content: \"\\f614\"; }\n.bi-wallet2::before { content: \"\\f615\"; }\n.bi-watch::before { content: \"\\f616\"; }\n.bi-water::before { content: \"\\f617\"; }\n.bi-whatsapp::before { content: \"\\f618\"; }\n.bi-wifi-1::before { content: \"\\f619\"; }\n.bi-wifi-2::before { content: \"\\f61a\"; }\n.bi-wifi-off::before { content: \"\\f61b\"; }\n.bi-wifi::before { content: \"\\f61c\"; }\n.bi-wind::before { content: \"\\f61d\"; }\n.bi-window-dock::before { content: \"\\f61e\"; }\n.bi-window-sidebar::before { content: \"\\f61f\"; }\n.bi-window::before { content: \"\\f620\"; }\n.bi-wrench::before { content: \"\\f621\"; }\n.bi-x-circle-fill::before { content: \"\\f622\"; }\n.bi-x-circle::before { content: \"\\f623\"; }\n.bi-x-diamond-fill::before { content: \"\\f624\"; }\n.bi-x-diamond::before { content: \"\\f625\"; }\n.bi-x-octagon-fill::before { content: \"\\f626\"; }\n.bi-x-octagon::before { content: \"\\f627\"; }\n.bi-x-square-fill::before { content: \"\\f628\"; }\n.bi-x-square::before { content: \"\\f629\"; }\n.bi-x::before { content: \"\\f62a\"; }\n.bi-youtube::before { content: \"\\f62b\"; }\n.bi-zoom-in::before { content: \"\\f62c\"; }\n.bi-zoom-out::before { content: \"\\f62d\"; }\n.bi-bank::before { content: \"\\f62e\"; }\n.bi-bank2::before { content: \"\\f62f\"; }\n.bi-bell-slash-fill::before { content: \"\\f630\"; }\n.bi-bell-slash::before { content: \"\\f631\"; }\n.bi-cash-coin::before { content: \"\\f632\"; }\n.bi-check-lg::before { content: \"\\f633\"; }\n.bi-coin::before { content: \"\\f634\"; }\n.bi-currency-bitcoin::before { content: \"\\f635\"; }\n.bi-currency-dollar::before { content: \"\\f636\"; }\n.bi-currency-euro::before { content: \"\\f637\"; }\n.bi-currency-exchange::before { content: \"\\f638\"; }\n.bi-currency-pound::before { content: \"\\f639\"; }\n.bi-currency-yen::before { content: \"\\f63a\"; }\n.bi-dash-lg::before { content: \"\\f63b\"; }\n.bi-exclamation-lg::before { content: \"\\f63c\"; }\n.bi-file-earmark-pdf-fill::before { content: \"\\f63d\"; }\n.bi-file-earmark-pdf::before { content: \"\\f63e\"; }\n.bi-file-pdf-fill::before { content: \"\\f63f\"; }\n.bi-file-pdf::before { content: \"\\f640\"; }\n.bi-gender-ambiguous::before { content: \"\\f641\"; }\n.bi-gender-female::before { content: \"\\f642\"; }\n.bi-gender-male::before { content: \"\\f643\"; }\n.bi-gender-trans::before { content: \"\\f644\"; }\n.bi-headset-vr::before { content: \"\\f645\"; }\n.bi-info-lg::before { content: \"\\f646\"; }\n.bi-mastodon::before { content: \"\\f647\"; }\n.bi-messenger::before { content: \"\\f648\"; }\n.bi-piggy-bank-fill::before { content: \"\\f649\"; }\n.bi-piggy-bank::before { content: \"\\f64a\"; }\n.bi-pin-map-fill::before { content: \"\\f64b\"; }\n.bi-pin-map::before { content: \"\\f64c\"; }\n.bi-plus-lg::before { content: \"\\f64d\"; }\n.bi-question-lg::before { content: \"\\f64e\"; }\n.bi-recycle::before { content: \"\\f64f\"; }\n.bi-reddit::before { content: \"\\f650\"; }\n.bi-safe-fill::before { content: \"\\f651\"; }\n.bi-safe2-fill::before { content: \"\\f652\"; }\n.bi-safe2::before { content: \"\\f653\"; }\n.bi-sd-card-fill::before { content: \"\\f654\"; }\n.bi-sd-card::before { content: \"\\f655\"; }\n.bi-skype::before { content: \"\\f656\"; }\n.bi-slash-lg::before { content: \"\\f657\"; }\n.bi-translate::before { content: \"\\f658\"; }\n.bi-x-lg::before { content: \"\\f659\"; }\n.bi-safe::before { content: \"\\f65a\"; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
